
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec28f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec28f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("86HTI", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $5e70ef68188e9db2$export$ffb0004e005737fa; }, function (v) { return $5e70ef68188e9db2$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $5e70ef68188e9db2$export$34b9dba7ce09269b; }, function (v) { return $5e70ef68188e9db2$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $5e70ef68188e9db2$export$25062201e9e25d76; }, function (v) { return $5e70ef68188e9db2$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5e70ef68188e9db2$export$ffb0004e005737fa;
var $5e70ef68188e9db2$export$34b9dba7ce09269b;
var $5e70ef68188e9db2$export$25062201e9e25d76;
"use strict";
var $5e70ef68188e9db2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $5e70ef68188e9db2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $5e70ef68188e9db2$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $5e70ef68188e9db2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$5e70ef68188e9db2$export$ffb0004e005737fa = $5e70ef68188e9db2$var$REACT_FRAGMENT_TYPE;
$5e70ef68188e9db2$export$34b9dba7ce09269b = $5e70ef68188e9db2$var$jsxProd;
$5e70ef68188e9db2$export$25062201e9e25d76 = $5e70ef68188e9db2$var$jsxProd;

});

parcelRegister("lTTfJ", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $ff199815cdbd2fab$export$882461b6382ed46c; }, function (v) { return $ff199815cdbd2fab$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $ff199815cdbd2fab$export$757ceba2d55c277e; }, function (v) { return $ff199815cdbd2fab$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $ff199815cdbd2fab$export$83d89fbfd8236492; }, function (v) { return $ff199815cdbd2fab$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $ff199815cdbd2fab$export$882461b6382ed46c;
var $ff199815cdbd2fab$export$757ceba2d55c277e;
var $ff199815cdbd2fab$export$83d89fbfd8236492;
"use strict";

var $bIbAw = parcelRequire("bIbAw");

var $gRqVZ = parcelRequire("gRqVZ");

var $hYKvr = parcelRequire("hYKvr");
function $ff199815cdbd2fab$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $ff199815cdbd2fab$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $ff199815cdbd2fab$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $ff199815cdbd2fab$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $ff199815cdbd2fab$var$assertIsMounted(fiber) {
    if ($ff199815cdbd2fab$var$getNearestMountedFiber(fiber) !== fiber) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(188));
}
function $ff199815cdbd2fab$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $ff199815cdbd2fab$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $ff199815cdbd2fab$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $ff199815cdbd2fab$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $ff199815cdbd2fab$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $ff199815cdbd2fab$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $ff199815cdbd2fab$var$assign = Object.assign, $ff199815cdbd2fab$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $ff199815cdbd2fab$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $ff199815cdbd2fab$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $ff199815cdbd2fab$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $ff199815cdbd2fab$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $ff199815cdbd2fab$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $ff199815cdbd2fab$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $ff199815cdbd2fab$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $ff199815cdbd2fab$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $ff199815cdbd2fab$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $ff199815cdbd2fab$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $ff199815cdbd2fab$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $ff199815cdbd2fab$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $ff199815cdbd2fab$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $ff199815cdbd2fab$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $ff199815cdbd2fab$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $ff199815cdbd2fab$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $ff199815cdbd2fab$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $ff199815cdbd2fab$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$ff199815cdbd2fab$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $ff199815cdbd2fab$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $ff199815cdbd2fab$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $ff199815cdbd2fab$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $ff199815cdbd2fab$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $ff199815cdbd2fab$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $ff199815cdbd2fab$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $ff199815cdbd2fab$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $ff199815cdbd2fab$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $ff199815cdbd2fab$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $ff199815cdbd2fab$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $ff199815cdbd2fab$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $ff199815cdbd2fab$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $ff199815cdbd2fab$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $ff199815cdbd2fab$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $ff199815cdbd2fab$var$getComponentNameFromType(type.type) || "Memo";
        case $ff199815cdbd2fab$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $ff199815cdbd2fab$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $ff199815cdbd2fab$var$isArrayImpl = Array.isArray, $ff199815cdbd2fab$var$ReactSharedInternals = $gRqVZ.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $ff199815cdbd2fab$var$ReactDOMSharedInternals = $hYKvr.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $ff199815cdbd2fab$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $ff199815cdbd2fab$var$valueStack = [], $ff199815cdbd2fab$var$index = -1;
function $ff199815cdbd2fab$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $ff199815cdbd2fab$var$pop(cursor) {
    0 > $ff199815cdbd2fab$var$index || (cursor.current = $ff199815cdbd2fab$var$valueStack[$ff199815cdbd2fab$var$index], $ff199815cdbd2fab$var$valueStack[$ff199815cdbd2fab$var$index] = null, $ff199815cdbd2fab$var$index--);
}
function $ff199815cdbd2fab$var$push(cursor, value) {
    $ff199815cdbd2fab$var$index++;
    $ff199815cdbd2fab$var$valueStack[$ff199815cdbd2fab$var$index] = cursor.current;
    cursor.current = value;
}
var $ff199815cdbd2fab$var$contextStackCursor = $ff199815cdbd2fab$var$createCursor(null), $ff199815cdbd2fab$var$contextFiberStackCursor = $ff199815cdbd2fab$var$createCursor(null), $ff199815cdbd2fab$var$rootInstanceStackCursor = $ff199815cdbd2fab$var$createCursor(null), $ff199815cdbd2fab$var$hostTransitionProviderCursor = $ff199815cdbd2fab$var$createCursor(null);
function $ff199815cdbd2fab$var$pushHostContainer(fiber, nextRootInstance) {
    $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$rootInstanceStackCursor, nextRootInstance);
    $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$contextFiberStackCursor, fiber);
    $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $ff199815cdbd2fab$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $ff199815cdbd2fab$var$getOwnHostContext(nextRootInstance), fiber = $ff199815cdbd2fab$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $ff199815cdbd2fab$var$pop($ff199815cdbd2fab$var$contextStackCursor);
    $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$contextStackCursor, fiber);
}
function $ff199815cdbd2fab$var$popHostContainer() {
    $ff199815cdbd2fab$var$pop($ff199815cdbd2fab$var$contextStackCursor);
    $ff199815cdbd2fab$var$pop($ff199815cdbd2fab$var$contextFiberStackCursor);
    $ff199815cdbd2fab$var$pop($ff199815cdbd2fab$var$rootInstanceStackCursor);
}
function $ff199815cdbd2fab$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$hostTransitionProviderCursor, fiber);
    var context = $ff199815cdbd2fab$var$contextStackCursor.current;
    var JSCompiler_inline_result = $ff199815cdbd2fab$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$contextFiberStackCursor, fiber), $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$contextStackCursor, JSCompiler_inline_result));
}
function $ff199815cdbd2fab$var$popHostContext(fiber) {
    $ff199815cdbd2fab$var$contextFiberStackCursor.current === fiber && ($ff199815cdbd2fab$var$pop($ff199815cdbd2fab$var$contextStackCursor), $ff199815cdbd2fab$var$pop($ff199815cdbd2fab$var$contextFiberStackCursor));
    $ff199815cdbd2fab$var$hostTransitionProviderCursor.current === fiber && ($ff199815cdbd2fab$var$pop($ff199815cdbd2fab$var$hostTransitionProviderCursor), $ff199815cdbd2fab$var$HostTransitionContext._currentValue = $ff199815cdbd2fab$var$sharedNotPendingObject);
}
var $ff199815cdbd2fab$var$hasOwnProperty = Object.prototype.hasOwnProperty, $ff199815cdbd2fab$var$scheduleCallback$3 = $bIbAw.unstable_scheduleCallback, $ff199815cdbd2fab$var$cancelCallback$1 = $bIbAw.unstable_cancelCallback, $ff199815cdbd2fab$var$shouldYield = $bIbAw.unstable_shouldYield, $ff199815cdbd2fab$var$requestPaint = $bIbAw.unstable_requestPaint, $ff199815cdbd2fab$var$now = $bIbAw.unstable_now, $ff199815cdbd2fab$var$getCurrentPriorityLevel = $bIbAw.unstable_getCurrentPriorityLevel, $ff199815cdbd2fab$var$ImmediatePriority = $bIbAw.unstable_ImmediatePriority, $ff199815cdbd2fab$var$UserBlockingPriority = $bIbAw.unstable_UserBlockingPriority, $ff199815cdbd2fab$var$NormalPriority$1 = $bIbAw.unstable_NormalPriority, $ff199815cdbd2fab$var$LowPriority = $bIbAw.unstable_LowPriority, $ff199815cdbd2fab$var$IdlePriority = $bIbAw.unstable_IdlePriority, $ff199815cdbd2fab$var$log$1 = $bIbAw.log, $ff199815cdbd2fab$var$unstable_setDisableYieldValue = $bIbAw.unstable_setDisableYieldValue, $ff199815cdbd2fab$var$rendererID = null, $ff199815cdbd2fab$var$injectedHook = null;
function $ff199815cdbd2fab$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $ff199815cdbd2fab$var$log$1 && $ff199815cdbd2fab$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($ff199815cdbd2fab$var$injectedHook && "function" === typeof $ff199815cdbd2fab$var$injectedHook.setStrictMode) try {
        $ff199815cdbd2fab$var$injectedHook.setStrictMode($ff199815cdbd2fab$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $ff199815cdbd2fab$var$clz32 = Math.clz32 ? Math.clz32 : $ff199815cdbd2fab$var$clz32Fallback, $ff199815cdbd2fab$var$log = Math.log, $ff199815cdbd2fab$var$LN2 = Math.LN2;
function $ff199815cdbd2fab$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($ff199815cdbd2fab$var$log(x) / $ff199815cdbd2fab$var$LN2 | 0) | 0;
}
var $ff199815cdbd2fab$var$nextTransitionLane = 256, $ff199815cdbd2fab$var$nextRetryLane = 4194304;
function $ff199815cdbd2fab$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $ff199815cdbd2fab$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $ff199815cdbd2fab$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $ff199815cdbd2fab$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $ff199815cdbd2fab$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $ff199815cdbd2fab$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $ff199815cdbd2fab$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $ff199815cdbd2fab$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $ff199815cdbd2fab$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $ff199815cdbd2fab$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $ff199815cdbd2fab$var$claimNextTransitionLane() {
    var lane = $ff199815cdbd2fab$var$nextTransitionLane;
    $ff199815cdbd2fab$var$nextTransitionLane <<= 1;
    0 === ($ff199815cdbd2fab$var$nextTransitionLane & 4194048) && ($ff199815cdbd2fab$var$nextTransitionLane = 256);
    return lane;
}
function $ff199815cdbd2fab$var$claimNextRetryLane() {
    var lane = $ff199815cdbd2fab$var$nextRetryLane;
    $ff199815cdbd2fab$var$nextRetryLane <<= 1;
    0 === ($ff199815cdbd2fab$var$nextRetryLane & 62914560) && ($ff199815cdbd2fab$var$nextRetryLane = 4194304);
    return lane;
}
function $ff199815cdbd2fab$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $ff199815cdbd2fab$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $ff199815cdbd2fab$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $ff199815cdbd2fab$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $ff199815cdbd2fab$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $ff199815cdbd2fab$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $ff199815cdbd2fab$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $ff199815cdbd2fab$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $ff199815cdbd2fab$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $ff199815cdbd2fab$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $ff199815cdbd2fab$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $ff199815cdbd2fab$var$resolveUpdatePriority() {
    var updatePriority = $ff199815cdbd2fab$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $ff199815cdbd2fab$var$getEventPriority(updatePriority.type);
}
function $ff199815cdbd2fab$var$runWithPriority(priority, fn) {
    var previousPriority = $ff199815cdbd2fab$var$ReactDOMSharedInternals.p;
    try {
        return $ff199815cdbd2fab$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $ff199815cdbd2fab$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $ff199815cdbd2fab$var$randomKey = Math.random().toString(36).slice(2), $ff199815cdbd2fab$var$internalInstanceKey = "__reactFiber$" + $ff199815cdbd2fab$var$randomKey, $ff199815cdbd2fab$var$internalPropsKey = "__reactProps$" + $ff199815cdbd2fab$var$randomKey, $ff199815cdbd2fab$var$internalContainerInstanceKey = "__reactContainer$" + $ff199815cdbd2fab$var$randomKey, $ff199815cdbd2fab$var$internalEventHandlersKey = "__reactEvents$" + $ff199815cdbd2fab$var$randomKey, $ff199815cdbd2fab$var$internalEventHandlerListenersKey = "__reactListeners$" + $ff199815cdbd2fab$var$randomKey, $ff199815cdbd2fab$var$internalEventHandlesSetKey = "__reactHandles$" + $ff199815cdbd2fab$var$randomKey, $ff199815cdbd2fab$var$internalRootNodeResourcesKey = "__reactResources$" + $ff199815cdbd2fab$var$randomKey, $ff199815cdbd2fab$var$internalHoistableMarker = "__reactMarker$" + $ff199815cdbd2fab$var$randomKey;
function $ff199815cdbd2fab$var$detachDeletedInstance(node) {
    delete node[$ff199815cdbd2fab$var$internalInstanceKey];
    delete node[$ff199815cdbd2fab$var$internalPropsKey];
    delete node[$ff199815cdbd2fab$var$internalEventHandlersKey];
    delete node[$ff199815cdbd2fab$var$internalEventHandlerListenersKey];
    delete node[$ff199815cdbd2fab$var$internalEventHandlesSetKey];
}
function $ff199815cdbd2fab$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$ff199815cdbd2fab$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$ff199815cdbd2fab$var$internalContainerInstanceKey] || parentNode[$ff199815cdbd2fab$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $ff199815cdbd2fab$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$ff199815cdbd2fab$var$internalInstanceKey]) return parentNode;
                targetNode = $ff199815cdbd2fab$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $ff199815cdbd2fab$var$getInstanceFromNode(node) {
    if (node = node[$ff199815cdbd2fab$var$internalInstanceKey] || node[$ff199815cdbd2fab$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $ff199815cdbd2fab$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(33));
}
function $ff199815cdbd2fab$var$getResourcesFromRoot(root) {
    var resources = root[$ff199815cdbd2fab$var$internalRootNodeResourcesKey];
    resources || (resources = root[$ff199815cdbd2fab$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $ff199815cdbd2fab$var$markNodeAsHoistable(node) {
    node[$ff199815cdbd2fab$var$internalHoistableMarker] = !0;
}
var $ff199815cdbd2fab$var$allNativeEvents = new Set(), $ff199815cdbd2fab$var$registrationNameDependencies = {};
function $ff199815cdbd2fab$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $ff199815cdbd2fab$var$registerDirectEvent(registrationName, dependencies);
    $ff199815cdbd2fab$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $ff199815cdbd2fab$var$registerDirectEvent(registrationName, dependencies) {
    $ff199815cdbd2fab$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$ff199815cdbd2fab$var$allNativeEvents.add(dependencies[registrationName]);
}
var $ff199815cdbd2fab$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $ff199815cdbd2fab$var$illegalAttributeNameCache = {}, $ff199815cdbd2fab$var$validatedAttributeNameCache = {};
function $ff199815cdbd2fab$var$isAttributeNameSafe(attributeName) {
    if ($ff199815cdbd2fab$var$hasOwnProperty.call($ff199815cdbd2fab$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($ff199815cdbd2fab$var$hasOwnProperty.call($ff199815cdbd2fab$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($ff199815cdbd2fab$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $ff199815cdbd2fab$var$validatedAttributeNameCache[attributeName] = !0;
    $ff199815cdbd2fab$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $ff199815cdbd2fab$var$setValueForAttribute(node, name, value) {
    if ($ff199815cdbd2fab$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $ff199815cdbd2fab$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $ff199815cdbd2fab$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $ff199815cdbd2fab$var$prefix, $ff199815cdbd2fab$var$suffix;
function $ff199815cdbd2fab$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $ff199815cdbd2fab$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $ff199815cdbd2fab$var$prefix = match && match[1] || "";
        $ff199815cdbd2fab$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $ff199815cdbd2fab$var$prefix + name + $ff199815cdbd2fab$var$suffix;
}
var $ff199815cdbd2fab$var$reentry = !1;
function $ff199815cdbd2fab$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $ff199815cdbd2fab$var$reentry) return "";
    $ff199815cdbd2fab$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $ff199815cdbd2fab$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $ff199815cdbd2fab$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $ff199815cdbd2fab$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $ff199815cdbd2fab$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $ff199815cdbd2fab$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $ff199815cdbd2fab$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $ff199815cdbd2fab$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $ff199815cdbd2fab$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $ff199815cdbd2fab$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $ff199815cdbd2fab$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $ff199815cdbd2fab$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $ff199815cdbd2fab$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $ff199815cdbd2fab$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $ff199815cdbd2fab$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $ff199815cdbd2fab$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $ff199815cdbd2fab$var$trackValueOnNode(node) {
    var valueField = $ff199815cdbd2fab$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $ff199815cdbd2fab$var$track(node) {
    node._valueTracker || (node._valueTracker = $ff199815cdbd2fab$var$trackValueOnNode(node));
}
function $ff199815cdbd2fab$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $ff199815cdbd2fab$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $ff199815cdbd2fab$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $ff199815cdbd2fab$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $ff199815cdbd2fab$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($ff199815cdbd2fab$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $ff199815cdbd2fab$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $ff199815cdbd2fab$var$getToStringValue(value);
        } else element.value !== "" + $ff199815cdbd2fab$var$getToStringValue(value) && (element.value = "" + $ff199815cdbd2fab$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $ff199815cdbd2fab$var$setDefaultValue(element, type, $ff199815cdbd2fab$var$getToStringValue(value)) : null != defaultValue ? $ff199815cdbd2fab$var$setDefaultValue(element, type, $ff199815cdbd2fab$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $ff199815cdbd2fab$var$getToStringValue(name) : element.removeAttribute("name");
}
function $ff199815cdbd2fab$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $ff199815cdbd2fab$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $ff199815cdbd2fab$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $ff199815cdbd2fab$var$setDefaultValue(node, type, value) {
    "number" === type && $ff199815cdbd2fab$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $ff199815cdbd2fab$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $ff199815cdbd2fab$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $ff199815cdbd2fab$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $ff199815cdbd2fab$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $ff199815cdbd2fab$var$getToStringValue(defaultValue) : "";
}
function $ff199815cdbd2fab$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(92));
            if ($ff199815cdbd2fab$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $ff199815cdbd2fab$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $ff199815cdbd2fab$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $ff199815cdbd2fab$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $ff199815cdbd2fab$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $ff199815cdbd2fab$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $ff199815cdbd2fab$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $ff199815cdbd2fab$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $ff199815cdbd2fab$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $ff199815cdbd2fab$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $ff199815cdbd2fab$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $ff199815cdbd2fab$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $ff199815cdbd2fab$var$sanitizeURL(url) {
    return $ff199815cdbd2fab$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $ff199815cdbd2fab$var$currentReplayingEvent = null;
function $ff199815cdbd2fab$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $ff199815cdbd2fab$var$restoreTarget = null, $ff199815cdbd2fab$var$restoreQueue = null;
function $ff199815cdbd2fab$var$restoreStateOfTarget(target) {
    var internalInstance = $ff199815cdbd2fab$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$ff199815cdbd2fab$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $ff199815cdbd2fab$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $ff199815cdbd2fab$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$ff199815cdbd2fab$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(90));
                            $ff199815cdbd2fab$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $ff199815cdbd2fab$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $ff199815cdbd2fab$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $ff199815cdbd2fab$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $ff199815cdbd2fab$var$isInsideEventHandler = !1;
function $ff199815cdbd2fab$var$batchedUpdates$1(fn, a, b) {
    if ($ff199815cdbd2fab$var$isInsideEventHandler) return fn(a, b);
    $ff199815cdbd2fab$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($ff199815cdbd2fab$var$isInsideEventHandler = !1, null !== $ff199815cdbd2fab$var$restoreTarget || null !== $ff199815cdbd2fab$var$restoreQueue) {
            if ($ff199815cdbd2fab$var$flushSyncWork$1(), $ff199815cdbd2fab$var$restoreTarget && (a = $ff199815cdbd2fab$var$restoreTarget, fn = $ff199815cdbd2fab$var$restoreQueue, $ff199815cdbd2fab$var$restoreQueue = $ff199815cdbd2fab$var$restoreTarget = null, $ff199815cdbd2fab$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$ff199815cdbd2fab$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $ff199815cdbd2fab$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$ff199815cdbd2fab$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $ff199815cdbd2fab$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $ff199815cdbd2fab$var$passiveBrowserEventsSupported = !1;
if ($ff199815cdbd2fab$var$canUseDOM) try {
    var $ff199815cdbd2fab$var$options = {};
    Object.defineProperty($ff199815cdbd2fab$var$options, "passive", {
        get: function() {
            $ff199815cdbd2fab$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $ff199815cdbd2fab$var$options, $ff199815cdbd2fab$var$options);
    window.removeEventListener("test", $ff199815cdbd2fab$var$options, $ff199815cdbd2fab$var$options);
} catch (e) {
    $ff199815cdbd2fab$var$passiveBrowserEventsSupported = !1;
}
var $ff199815cdbd2fab$var$root = null, $ff199815cdbd2fab$var$startText = null, $ff199815cdbd2fab$var$fallbackText = null;
function $ff199815cdbd2fab$var$getData() {
    if ($ff199815cdbd2fab$var$fallbackText) return $ff199815cdbd2fab$var$fallbackText;
    var start, startValue = $ff199815cdbd2fab$var$startText, startLength = startValue.length, end, endValue = "value" in $ff199815cdbd2fab$var$root ? $ff199815cdbd2fab$var$root.value : $ff199815cdbd2fab$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $ff199815cdbd2fab$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $ff199815cdbd2fab$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $ff199815cdbd2fab$var$functionThatReturnsTrue() {
    return !0;
}
function $ff199815cdbd2fab$var$functionThatReturnsFalse() {
    return !1;
}
function $ff199815cdbd2fab$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $ff199815cdbd2fab$var$functionThatReturnsTrue : $ff199815cdbd2fab$var$functionThatReturnsFalse;
        this.isPropagationStopped = $ff199815cdbd2fab$var$functionThatReturnsFalse;
        return this;
    }
    $ff199815cdbd2fab$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $ff199815cdbd2fab$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $ff199815cdbd2fab$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $ff199815cdbd2fab$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $ff199815cdbd2fab$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $ff199815cdbd2fab$var$SyntheticEvent = $ff199815cdbd2fab$var$createSyntheticEvent($ff199815cdbd2fab$var$EventInterface), $ff199815cdbd2fab$var$UIEventInterface = $ff199815cdbd2fab$var$assign({}, $ff199815cdbd2fab$var$EventInterface, {
    view: 0,
    detail: 0
}), $ff199815cdbd2fab$var$SyntheticUIEvent = $ff199815cdbd2fab$var$createSyntheticEvent($ff199815cdbd2fab$var$UIEventInterface), $ff199815cdbd2fab$var$lastMovementX, $ff199815cdbd2fab$var$lastMovementY, $ff199815cdbd2fab$var$lastMouseEvent, $ff199815cdbd2fab$var$MouseEventInterface = $ff199815cdbd2fab$var$assign({}, $ff199815cdbd2fab$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $ff199815cdbd2fab$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $ff199815cdbd2fab$var$lastMouseEvent && ($ff199815cdbd2fab$var$lastMouseEvent && "mousemove" === event.type ? ($ff199815cdbd2fab$var$lastMovementX = event.screenX - $ff199815cdbd2fab$var$lastMouseEvent.screenX, $ff199815cdbd2fab$var$lastMovementY = event.screenY - $ff199815cdbd2fab$var$lastMouseEvent.screenY) : $ff199815cdbd2fab$var$lastMovementY = $ff199815cdbd2fab$var$lastMovementX = 0, $ff199815cdbd2fab$var$lastMouseEvent = event);
        return $ff199815cdbd2fab$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $ff199815cdbd2fab$var$lastMovementY;
    }
}), $ff199815cdbd2fab$var$SyntheticMouseEvent = $ff199815cdbd2fab$var$createSyntheticEvent($ff199815cdbd2fab$var$MouseEventInterface), $ff199815cdbd2fab$var$DragEventInterface = $ff199815cdbd2fab$var$assign({}, $ff199815cdbd2fab$var$MouseEventInterface, {
    dataTransfer: 0
}), $ff199815cdbd2fab$var$SyntheticDragEvent = $ff199815cdbd2fab$var$createSyntheticEvent($ff199815cdbd2fab$var$DragEventInterface), $ff199815cdbd2fab$var$FocusEventInterface = $ff199815cdbd2fab$var$assign({}, $ff199815cdbd2fab$var$UIEventInterface, {
    relatedTarget: 0
}), $ff199815cdbd2fab$var$SyntheticFocusEvent = $ff199815cdbd2fab$var$createSyntheticEvent($ff199815cdbd2fab$var$FocusEventInterface), $ff199815cdbd2fab$var$AnimationEventInterface = $ff199815cdbd2fab$var$assign({}, $ff199815cdbd2fab$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $ff199815cdbd2fab$var$SyntheticAnimationEvent = $ff199815cdbd2fab$var$createSyntheticEvent($ff199815cdbd2fab$var$AnimationEventInterface), $ff199815cdbd2fab$var$ClipboardEventInterface = $ff199815cdbd2fab$var$assign({}, $ff199815cdbd2fab$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $ff199815cdbd2fab$var$SyntheticClipboardEvent = $ff199815cdbd2fab$var$createSyntheticEvent($ff199815cdbd2fab$var$ClipboardEventInterface), $ff199815cdbd2fab$var$CompositionEventInterface = $ff199815cdbd2fab$var$assign({}, $ff199815cdbd2fab$var$EventInterface, {
    data: 0
}), $ff199815cdbd2fab$var$SyntheticCompositionEvent = $ff199815cdbd2fab$var$createSyntheticEvent($ff199815cdbd2fab$var$CompositionEventInterface), $ff199815cdbd2fab$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $ff199815cdbd2fab$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $ff199815cdbd2fab$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $ff199815cdbd2fab$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $ff199815cdbd2fab$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $ff199815cdbd2fab$var$getEventModifierState() {
    return $ff199815cdbd2fab$var$modifierStateGetter;
}
var $ff199815cdbd2fab$var$KeyboardEventInterface = $ff199815cdbd2fab$var$assign({}, $ff199815cdbd2fab$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $ff199815cdbd2fab$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $ff199815cdbd2fab$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $ff199815cdbd2fab$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $ff199815cdbd2fab$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $ff199815cdbd2fab$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $ff199815cdbd2fab$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $ff199815cdbd2fab$var$SyntheticKeyboardEvent = $ff199815cdbd2fab$var$createSyntheticEvent($ff199815cdbd2fab$var$KeyboardEventInterface), $ff199815cdbd2fab$var$PointerEventInterface = $ff199815cdbd2fab$var$assign({}, $ff199815cdbd2fab$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $ff199815cdbd2fab$var$SyntheticPointerEvent = $ff199815cdbd2fab$var$createSyntheticEvent($ff199815cdbd2fab$var$PointerEventInterface), $ff199815cdbd2fab$var$TouchEventInterface = $ff199815cdbd2fab$var$assign({}, $ff199815cdbd2fab$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $ff199815cdbd2fab$var$getEventModifierState
}), $ff199815cdbd2fab$var$SyntheticTouchEvent = $ff199815cdbd2fab$var$createSyntheticEvent($ff199815cdbd2fab$var$TouchEventInterface), $ff199815cdbd2fab$var$TransitionEventInterface = $ff199815cdbd2fab$var$assign({}, $ff199815cdbd2fab$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $ff199815cdbd2fab$var$SyntheticTransitionEvent = $ff199815cdbd2fab$var$createSyntheticEvent($ff199815cdbd2fab$var$TransitionEventInterface), $ff199815cdbd2fab$var$WheelEventInterface = $ff199815cdbd2fab$var$assign({}, $ff199815cdbd2fab$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $ff199815cdbd2fab$var$SyntheticWheelEvent = $ff199815cdbd2fab$var$createSyntheticEvent($ff199815cdbd2fab$var$WheelEventInterface), $ff199815cdbd2fab$var$ToggleEventInterface = $ff199815cdbd2fab$var$assign({}, $ff199815cdbd2fab$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $ff199815cdbd2fab$var$SyntheticToggleEvent = $ff199815cdbd2fab$var$createSyntheticEvent($ff199815cdbd2fab$var$ToggleEventInterface), $ff199815cdbd2fab$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $ff199815cdbd2fab$var$canUseCompositionEvent = $ff199815cdbd2fab$var$canUseDOM && "CompositionEvent" in window, $ff199815cdbd2fab$var$documentMode = null;
$ff199815cdbd2fab$var$canUseDOM && "documentMode" in document && ($ff199815cdbd2fab$var$documentMode = document.documentMode);
var $ff199815cdbd2fab$var$canUseTextInputEvent = $ff199815cdbd2fab$var$canUseDOM && "TextEvent" in window && !$ff199815cdbd2fab$var$documentMode, $ff199815cdbd2fab$var$useFallbackCompositionData = $ff199815cdbd2fab$var$canUseDOM && (!$ff199815cdbd2fab$var$canUseCompositionEvent || $ff199815cdbd2fab$var$documentMode && 8 < $ff199815cdbd2fab$var$documentMode && 11 >= $ff199815cdbd2fab$var$documentMode), $ff199815cdbd2fab$var$SPACEBAR_CHAR = String.fromCharCode(32), $ff199815cdbd2fab$var$hasSpaceKeypress = !1;
function $ff199815cdbd2fab$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $ff199815cdbd2fab$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $ff199815cdbd2fab$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $ff199815cdbd2fab$var$isComposing = !1;
function $ff199815cdbd2fab$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $ff199815cdbd2fab$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $ff199815cdbd2fab$var$hasSpaceKeypress = !0;
            return $ff199815cdbd2fab$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $ff199815cdbd2fab$var$SPACEBAR_CHAR && $ff199815cdbd2fab$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $ff199815cdbd2fab$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($ff199815cdbd2fab$var$isComposing) return "compositionend" === domEventName || !$ff199815cdbd2fab$var$canUseCompositionEvent && $ff199815cdbd2fab$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $ff199815cdbd2fab$var$getData(), $ff199815cdbd2fab$var$fallbackText = $ff199815cdbd2fab$var$startText = $ff199815cdbd2fab$var$root = null, $ff199815cdbd2fab$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $ff199815cdbd2fab$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $ff199815cdbd2fab$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $ff199815cdbd2fab$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$ff199815cdbd2fab$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $ff199815cdbd2fab$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $ff199815cdbd2fab$var$restoreTarget ? $ff199815cdbd2fab$var$restoreQueue ? $ff199815cdbd2fab$var$restoreQueue.push(target) : $ff199815cdbd2fab$var$restoreQueue = [
        target
    ] : $ff199815cdbd2fab$var$restoreTarget = target;
    inst = $ff199815cdbd2fab$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $ff199815cdbd2fab$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $ff199815cdbd2fab$var$activeElement$1 = null, $ff199815cdbd2fab$var$activeElementInst$1 = null;
function $ff199815cdbd2fab$var$runEventInBatch(dispatchQueue) {
    $ff199815cdbd2fab$var$processDispatchQueue(dispatchQueue, 0);
}
function $ff199815cdbd2fab$var$getInstIfValueChanged(targetInst) {
    var targetNode = $ff199815cdbd2fab$var$getNodeFromInstance(targetInst);
    if ($ff199815cdbd2fab$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $ff199815cdbd2fab$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $ff199815cdbd2fab$var$isInputEventSupported = !1;
if ($ff199815cdbd2fab$var$canUseDOM) {
    var $ff199815cdbd2fab$var$JSCompiler_inline_result$jscomp$282;
    if ($ff199815cdbd2fab$var$canUseDOM) {
        var $ff199815cdbd2fab$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$ff199815cdbd2fab$var$isSupported$jscomp$inline_417) {
            var $ff199815cdbd2fab$var$element$jscomp$inline_418 = document.createElement("div");
            $ff199815cdbd2fab$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $ff199815cdbd2fab$var$isSupported$jscomp$inline_417 = "function" === typeof $ff199815cdbd2fab$var$element$jscomp$inline_418.oninput;
        }
        $ff199815cdbd2fab$var$JSCompiler_inline_result$jscomp$282 = $ff199815cdbd2fab$var$isSupported$jscomp$inline_417;
    } else $ff199815cdbd2fab$var$JSCompiler_inline_result$jscomp$282 = !1;
    $ff199815cdbd2fab$var$isInputEventSupported = $ff199815cdbd2fab$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $ff199815cdbd2fab$var$stopWatchingForValueChange() {
    $ff199815cdbd2fab$var$activeElement$1 && ($ff199815cdbd2fab$var$activeElement$1.detachEvent("onpropertychange", $ff199815cdbd2fab$var$handlePropertyChange), $ff199815cdbd2fab$var$activeElementInst$1 = $ff199815cdbd2fab$var$activeElement$1 = null);
}
function $ff199815cdbd2fab$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $ff199815cdbd2fab$var$getInstIfValueChanged($ff199815cdbd2fab$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $ff199815cdbd2fab$var$createAndAccumulateChangeEvent(dispatchQueue, $ff199815cdbd2fab$var$activeElementInst$1, nativeEvent, $ff199815cdbd2fab$var$getEventTarget(nativeEvent));
        $ff199815cdbd2fab$var$batchedUpdates$1($ff199815cdbd2fab$var$runEventInBatch, dispatchQueue);
    }
}
function $ff199815cdbd2fab$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($ff199815cdbd2fab$var$stopWatchingForValueChange(), $ff199815cdbd2fab$var$activeElement$1 = target, $ff199815cdbd2fab$var$activeElementInst$1 = targetInst, $ff199815cdbd2fab$var$activeElement$1.attachEvent("onpropertychange", $ff199815cdbd2fab$var$handlePropertyChange)) : "focusout" === domEventName && $ff199815cdbd2fab$var$stopWatchingForValueChange();
}
function $ff199815cdbd2fab$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $ff199815cdbd2fab$var$getInstIfValueChanged($ff199815cdbd2fab$var$activeElementInst$1);
}
function $ff199815cdbd2fab$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $ff199815cdbd2fab$var$getInstIfValueChanged(targetInst);
}
function $ff199815cdbd2fab$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $ff199815cdbd2fab$var$getInstIfValueChanged(targetInst);
}
function $ff199815cdbd2fab$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $ff199815cdbd2fab$var$objectIs = "function" === typeof Object.is ? Object.is : $ff199815cdbd2fab$var$is;
function $ff199815cdbd2fab$var$shallowEqual(objA, objB) {
    if ($ff199815cdbd2fab$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$ff199815cdbd2fab$var$hasOwnProperty.call(objB, currentKey) || !$ff199815cdbd2fab$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $ff199815cdbd2fab$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $ff199815cdbd2fab$var$getNodeForCharacterOffset(root, offset) {
    var node = $ff199815cdbd2fab$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $ff199815cdbd2fab$var$getLeafNode(node);
    }
}
function $ff199815cdbd2fab$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $ff199815cdbd2fab$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $ff199815cdbd2fab$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $ff199815cdbd2fab$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $ff199815cdbd2fab$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $ff199815cdbd2fab$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $ff199815cdbd2fab$var$skipSelectionChangeEvent = $ff199815cdbd2fab$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $ff199815cdbd2fab$var$activeElement = null, $ff199815cdbd2fab$var$activeElementInst = null, $ff199815cdbd2fab$var$lastSelection = null, $ff199815cdbd2fab$var$mouseDown = !1;
function $ff199815cdbd2fab$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $ff199815cdbd2fab$var$mouseDown || null == $ff199815cdbd2fab$var$activeElement || $ff199815cdbd2fab$var$activeElement !== $ff199815cdbd2fab$var$getActiveElement(doc) || (doc = $ff199815cdbd2fab$var$activeElement, "selectionStart" in doc && $ff199815cdbd2fab$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $ff199815cdbd2fab$var$lastSelection && $ff199815cdbd2fab$var$shallowEqual($ff199815cdbd2fab$var$lastSelection, doc) || ($ff199815cdbd2fab$var$lastSelection = doc, doc = $ff199815cdbd2fab$var$accumulateTwoPhaseListeners($ff199815cdbd2fab$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $ff199815cdbd2fab$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $ff199815cdbd2fab$var$activeElement)));
}
function $ff199815cdbd2fab$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $ff199815cdbd2fab$var$vendorPrefixes = {
    animationend: $ff199815cdbd2fab$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $ff199815cdbd2fab$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $ff199815cdbd2fab$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $ff199815cdbd2fab$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $ff199815cdbd2fab$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $ff199815cdbd2fab$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $ff199815cdbd2fab$var$makePrefixMap("Transition", "TransitionEnd")
}, $ff199815cdbd2fab$var$prefixedEventNames = {}, $ff199815cdbd2fab$var$style = {};
$ff199815cdbd2fab$var$canUseDOM && ($ff199815cdbd2fab$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $ff199815cdbd2fab$var$vendorPrefixes.animationend.animation, delete $ff199815cdbd2fab$var$vendorPrefixes.animationiteration.animation, delete $ff199815cdbd2fab$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $ff199815cdbd2fab$var$vendorPrefixes.transitionend.transition);
function $ff199815cdbd2fab$var$getVendorPrefixedEventName(eventName) {
    if ($ff199815cdbd2fab$var$prefixedEventNames[eventName]) return $ff199815cdbd2fab$var$prefixedEventNames[eventName];
    if (!$ff199815cdbd2fab$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $ff199815cdbd2fab$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $ff199815cdbd2fab$var$style) return $ff199815cdbd2fab$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $ff199815cdbd2fab$var$ANIMATION_END = $ff199815cdbd2fab$var$getVendorPrefixedEventName("animationend"), $ff199815cdbd2fab$var$ANIMATION_ITERATION = $ff199815cdbd2fab$var$getVendorPrefixedEventName("animationiteration"), $ff199815cdbd2fab$var$ANIMATION_START = $ff199815cdbd2fab$var$getVendorPrefixedEventName("animationstart"), $ff199815cdbd2fab$var$TRANSITION_RUN = $ff199815cdbd2fab$var$getVendorPrefixedEventName("transitionrun"), $ff199815cdbd2fab$var$TRANSITION_START = $ff199815cdbd2fab$var$getVendorPrefixedEventName("transitionstart"), $ff199815cdbd2fab$var$TRANSITION_CANCEL = $ff199815cdbd2fab$var$getVendorPrefixedEventName("transitioncancel"), $ff199815cdbd2fab$var$TRANSITION_END = $ff199815cdbd2fab$var$getVendorPrefixedEventName("transitionend"), $ff199815cdbd2fab$var$topLevelEventsToReactNames = new Map(), $ff199815cdbd2fab$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$ff199815cdbd2fab$var$simpleEventPluginEvents.push("scrollEnd");
function $ff199815cdbd2fab$var$registerSimpleEvent(domEventName, reactName) {
    $ff199815cdbd2fab$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $ff199815cdbd2fab$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $ff199815cdbd2fab$var$CapturedStacks = new WeakMap();
function $ff199815cdbd2fab$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $ff199815cdbd2fab$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $ff199815cdbd2fab$var$getStackByFiberInDevAndProd(source)
        };
        $ff199815cdbd2fab$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $ff199815cdbd2fab$var$getStackByFiberInDevAndProd(source)
    };
}
var $ff199815cdbd2fab$var$concurrentQueues = [], $ff199815cdbd2fab$var$concurrentQueuesIndex = 0, $ff199815cdbd2fab$var$concurrentlyUpdatedLanes = 0;
function $ff199815cdbd2fab$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $ff199815cdbd2fab$var$concurrentQueuesIndex, i = $ff199815cdbd2fab$var$concurrentlyUpdatedLanes = $ff199815cdbd2fab$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $ff199815cdbd2fab$var$concurrentQueues[i];
        $ff199815cdbd2fab$var$concurrentQueues[i++] = null;
        var queue = $ff199815cdbd2fab$var$concurrentQueues[i];
        $ff199815cdbd2fab$var$concurrentQueues[i++] = null;
        var update = $ff199815cdbd2fab$var$concurrentQueues[i];
        $ff199815cdbd2fab$var$concurrentQueues[i++] = null;
        var lane = $ff199815cdbd2fab$var$concurrentQueues[i];
        $ff199815cdbd2fab$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $ff199815cdbd2fab$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $ff199815cdbd2fab$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $ff199815cdbd2fab$var$concurrentQueues[$ff199815cdbd2fab$var$concurrentQueuesIndex++] = fiber;
    $ff199815cdbd2fab$var$concurrentQueues[$ff199815cdbd2fab$var$concurrentQueuesIndex++] = queue;
    $ff199815cdbd2fab$var$concurrentQueues[$ff199815cdbd2fab$var$concurrentQueuesIndex++] = update;
    $ff199815cdbd2fab$var$concurrentQueues[$ff199815cdbd2fab$var$concurrentQueuesIndex++] = lane;
    $ff199815cdbd2fab$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $ff199815cdbd2fab$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $ff199815cdbd2fab$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $ff199815cdbd2fab$var$getRootForUpdatedFiber(fiber);
}
function $ff199815cdbd2fab$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $ff199815cdbd2fab$var$enqueueUpdate$1(fiber, null, null, lane);
    return $ff199815cdbd2fab$var$getRootForUpdatedFiber(fiber);
}
function $ff199815cdbd2fab$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $ff199815cdbd2fab$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $ff199815cdbd2fab$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $ff199815cdbd2fab$var$nestedUpdateCount) throw $ff199815cdbd2fab$var$nestedUpdateCount = 0, $ff199815cdbd2fab$var$rootWithNestedUpdates = null, Error($ff199815cdbd2fab$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $ff199815cdbd2fab$var$emptyContextObject = {};
function $ff199815cdbd2fab$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $ff199815cdbd2fab$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $ff199815cdbd2fab$var$FiberNode(tag, pendingProps, key, mode);
}
function $ff199815cdbd2fab$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $ff199815cdbd2fab$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $ff199815cdbd2fab$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $ff199815cdbd2fab$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $ff199815cdbd2fab$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $ff199815cdbd2fab$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $ff199815cdbd2fab$var$isHostHoistableType(type, pendingProps, $ff199815cdbd2fab$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $ff199815cdbd2fab$var$REACT_ACTIVITY_TYPE:
            return type = $ff199815cdbd2fab$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $ff199815cdbd2fab$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $ff199815cdbd2fab$var$REACT_FRAGMENT_TYPE:
            return $ff199815cdbd2fab$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $ff199815cdbd2fab$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $ff199815cdbd2fab$var$REACT_PROFILER_TYPE:
            return type = $ff199815cdbd2fab$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $ff199815cdbd2fab$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $ff199815cdbd2fab$var$REACT_SUSPENSE_TYPE:
            return type = $ff199815cdbd2fab$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $ff199815cdbd2fab$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $ff199815cdbd2fab$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $ff199815cdbd2fab$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $ff199815cdbd2fab$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $ff199815cdbd2fab$var$REACT_PROVIDER_TYPE:
                case $ff199815cdbd2fab$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $ff199815cdbd2fab$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $ff199815cdbd2fab$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $ff199815cdbd2fab$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $ff199815cdbd2fab$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($ff199815cdbd2fab$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $ff199815cdbd2fab$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $ff199815cdbd2fab$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $ff199815cdbd2fab$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $ff199815cdbd2fab$var$createFiberFromText(content, mode, lanes) {
    content = $ff199815cdbd2fab$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $ff199815cdbd2fab$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $ff199815cdbd2fab$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $ff199815cdbd2fab$var$forkStack = [], $ff199815cdbd2fab$var$forkStackIndex = 0, $ff199815cdbd2fab$var$treeForkProvider = null, $ff199815cdbd2fab$var$treeForkCount = 0, $ff199815cdbd2fab$var$idStack = [], $ff199815cdbd2fab$var$idStackIndex = 0, $ff199815cdbd2fab$var$treeContextProvider = null, $ff199815cdbd2fab$var$treeContextId = 1, $ff199815cdbd2fab$var$treeContextOverflow = "";
function $ff199815cdbd2fab$var$pushTreeFork(workInProgress, totalChildren) {
    $ff199815cdbd2fab$var$forkStack[$ff199815cdbd2fab$var$forkStackIndex++] = $ff199815cdbd2fab$var$treeForkCount;
    $ff199815cdbd2fab$var$forkStack[$ff199815cdbd2fab$var$forkStackIndex++] = $ff199815cdbd2fab$var$treeForkProvider;
    $ff199815cdbd2fab$var$treeForkProvider = workInProgress;
    $ff199815cdbd2fab$var$treeForkCount = totalChildren;
}
function $ff199815cdbd2fab$var$pushTreeId(workInProgress, totalChildren, index) {
    $ff199815cdbd2fab$var$idStack[$ff199815cdbd2fab$var$idStackIndex++] = $ff199815cdbd2fab$var$treeContextId;
    $ff199815cdbd2fab$var$idStack[$ff199815cdbd2fab$var$idStackIndex++] = $ff199815cdbd2fab$var$treeContextOverflow;
    $ff199815cdbd2fab$var$idStack[$ff199815cdbd2fab$var$idStackIndex++] = $ff199815cdbd2fab$var$treeContextProvider;
    $ff199815cdbd2fab$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $ff199815cdbd2fab$var$treeContextId;
    workInProgress = $ff199815cdbd2fab$var$treeContextOverflow;
    var baseLength = 32 - $ff199815cdbd2fab$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $ff199815cdbd2fab$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $ff199815cdbd2fab$var$treeContextId = 1 << 32 - $ff199815cdbd2fab$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $ff199815cdbd2fab$var$treeContextOverflow = length + workInProgress;
    } else $ff199815cdbd2fab$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $ff199815cdbd2fab$var$treeContextOverflow = workInProgress;
}
function $ff199815cdbd2fab$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($ff199815cdbd2fab$var$pushTreeFork(workInProgress, 1), $ff199815cdbd2fab$var$pushTreeId(workInProgress, 1, 0));
}
function $ff199815cdbd2fab$var$popTreeContext(workInProgress) {
    for(; workInProgress === $ff199815cdbd2fab$var$treeForkProvider;)$ff199815cdbd2fab$var$treeForkProvider = $ff199815cdbd2fab$var$forkStack[--$ff199815cdbd2fab$var$forkStackIndex], $ff199815cdbd2fab$var$forkStack[$ff199815cdbd2fab$var$forkStackIndex] = null, $ff199815cdbd2fab$var$treeForkCount = $ff199815cdbd2fab$var$forkStack[--$ff199815cdbd2fab$var$forkStackIndex], $ff199815cdbd2fab$var$forkStack[$ff199815cdbd2fab$var$forkStackIndex] = null;
    for(; workInProgress === $ff199815cdbd2fab$var$treeContextProvider;)$ff199815cdbd2fab$var$treeContextProvider = $ff199815cdbd2fab$var$idStack[--$ff199815cdbd2fab$var$idStackIndex], $ff199815cdbd2fab$var$idStack[$ff199815cdbd2fab$var$idStackIndex] = null, $ff199815cdbd2fab$var$treeContextOverflow = $ff199815cdbd2fab$var$idStack[--$ff199815cdbd2fab$var$idStackIndex], $ff199815cdbd2fab$var$idStack[$ff199815cdbd2fab$var$idStackIndex] = null, $ff199815cdbd2fab$var$treeContextId = $ff199815cdbd2fab$var$idStack[--$ff199815cdbd2fab$var$idStackIndex], $ff199815cdbd2fab$var$idStack[$ff199815cdbd2fab$var$idStackIndex] = null;
}
var $ff199815cdbd2fab$var$hydrationParentFiber = null, $ff199815cdbd2fab$var$nextHydratableInstance = null, $ff199815cdbd2fab$var$isHydrating = !1, $ff199815cdbd2fab$var$hydrationErrors = null, $ff199815cdbd2fab$var$rootOrSingletonContext = !1, $ff199815cdbd2fab$var$HydrationMismatchException = Error($ff199815cdbd2fab$var$formatProdErrorMessage(519));
function $ff199815cdbd2fab$var$throwOnHydrationMismatch(fiber) {
    var error = Error($ff199815cdbd2fab$var$formatProdErrorMessage(418, ""));
    $ff199815cdbd2fab$var$queueHydrationError($ff199815cdbd2fab$var$createCapturedValueAtFiber(error, fiber));
    throw $ff199815cdbd2fab$var$HydrationMismatchException;
}
function $ff199815cdbd2fab$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$ff199815cdbd2fab$var$internalInstanceKey] = fiber;
    instance[$ff199815cdbd2fab$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("cancel", instance);
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $ff199815cdbd2fab$var$mediaEventTypes.length; type++)$ff199815cdbd2fab$var$listenToNonDelegatedEvent($ff199815cdbd2fab$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("error", instance);
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("invalid", instance);
            $ff199815cdbd2fab$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $ff199815cdbd2fab$var$track(instance);
            break;
        case "select":
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("invalid", instance), $ff199815cdbd2fab$var$initTextarea(instance, props.value, props.defaultValue, props.children), $ff199815cdbd2fab$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $ff199815cdbd2fab$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($ff199815cdbd2fab$var$listenToNonDelegatedEvent("beforetoggle", instance), $ff199815cdbd2fab$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $ff199815cdbd2fab$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $ff199815cdbd2fab$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $ff199815cdbd2fab$var$noop$1), instance = !0) : instance = !1;
    instance || $ff199815cdbd2fab$var$throwOnHydrationMismatch(fiber);
}
function $ff199815cdbd2fab$var$popToNextHostParent(fiber) {
    for($ff199815cdbd2fab$var$hydrationParentFiber = fiber.return; $ff199815cdbd2fab$var$hydrationParentFiber;)switch($ff199815cdbd2fab$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $ff199815cdbd2fab$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $ff199815cdbd2fab$var$rootOrSingletonContext = !0;
            return;
        default:
            $ff199815cdbd2fab$var$hydrationParentFiber = $ff199815cdbd2fab$var$hydrationParentFiber.return;
    }
}
function $ff199815cdbd2fab$var$popHydrationState(fiber) {
    if (fiber !== $ff199815cdbd2fab$var$hydrationParentFiber) return !1;
    if (!$ff199815cdbd2fab$var$isHydrating) return $ff199815cdbd2fab$var$popToNextHostParent(fiber), $ff199815cdbd2fab$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $ff199815cdbd2fab$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $ff199815cdbd2fab$var$nextHydratableInstance && $ff199815cdbd2fab$var$throwOnHydrationMismatch(fiber);
    $ff199815cdbd2fab$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $ff199815cdbd2fab$var$nextHydratableInstance = $ff199815cdbd2fab$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $ff199815cdbd2fab$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $ff199815cdbd2fab$var$nextHydratableInstance, $ff199815cdbd2fab$var$isSingletonScope(fiber.type) ? (fiber = $ff199815cdbd2fab$var$previousHydratableOnEnteringScopedSingleton, $ff199815cdbd2fab$var$previousHydratableOnEnteringScopedSingleton = null, $ff199815cdbd2fab$var$nextHydratableInstance = fiber) : $ff199815cdbd2fab$var$nextHydratableInstance = tag) : $ff199815cdbd2fab$var$nextHydratableInstance = $ff199815cdbd2fab$var$hydrationParentFiber ? $ff199815cdbd2fab$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $ff199815cdbd2fab$var$resetHydrationState() {
    $ff199815cdbd2fab$var$nextHydratableInstance = $ff199815cdbd2fab$var$hydrationParentFiber = null;
    $ff199815cdbd2fab$var$isHydrating = !1;
}
function $ff199815cdbd2fab$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $ff199815cdbd2fab$var$hydrationErrors;
    null !== queuedErrors && (null === $ff199815cdbd2fab$var$workInProgressRootRecoverableErrors ? $ff199815cdbd2fab$var$workInProgressRootRecoverableErrors = queuedErrors : $ff199815cdbd2fab$var$workInProgressRootRecoverableErrors.push.apply($ff199815cdbd2fab$var$workInProgressRootRecoverableErrors, queuedErrors), $ff199815cdbd2fab$var$hydrationErrors = null);
    return queuedErrors;
}
function $ff199815cdbd2fab$var$queueHydrationError(error) {
    null === $ff199815cdbd2fab$var$hydrationErrors ? $ff199815cdbd2fab$var$hydrationErrors = [
        error
    ] : $ff199815cdbd2fab$var$hydrationErrors.push(error);
}
var $ff199815cdbd2fab$var$valueCursor = $ff199815cdbd2fab$var$createCursor(null), $ff199815cdbd2fab$var$currentlyRenderingFiber$1 = null, $ff199815cdbd2fab$var$lastContextDependency = null;
function $ff199815cdbd2fab$var$pushProvider(providerFiber, context, nextValue) {
    $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $ff199815cdbd2fab$var$popProvider(context) {
    context._currentValue = $ff199815cdbd2fab$var$valueCursor.current;
    $ff199815cdbd2fab$var$pop($ff199815cdbd2fab$var$valueCursor);
}
function $ff199815cdbd2fab$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $ff199815cdbd2fab$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $ff199815cdbd2fab$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $ff199815cdbd2fab$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $ff199815cdbd2fab$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $ff199815cdbd2fab$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $ff199815cdbd2fab$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($ff199815cdbd2fab$var$HostTransitionContext) : current = [
                $ff199815cdbd2fab$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $ff199815cdbd2fab$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $ff199815cdbd2fab$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$ff199815cdbd2fab$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $ff199815cdbd2fab$var$prepareToReadContext(workInProgress) {
    $ff199815cdbd2fab$var$currentlyRenderingFiber$1 = workInProgress;
    $ff199815cdbd2fab$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $ff199815cdbd2fab$var$readContext(context) {
    return $ff199815cdbd2fab$var$readContextForConsumer($ff199815cdbd2fab$var$currentlyRenderingFiber$1, context);
}
function $ff199815cdbd2fab$var$readContextDuringReconciliation(consumer, context) {
    null === $ff199815cdbd2fab$var$currentlyRenderingFiber$1 && $ff199815cdbd2fab$var$prepareToReadContext(consumer);
    return $ff199815cdbd2fab$var$readContextForConsumer(consumer, context);
}
function $ff199815cdbd2fab$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $ff199815cdbd2fab$var$lastContextDependency) {
        if (null === consumer) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(308));
        $ff199815cdbd2fab$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $ff199815cdbd2fab$var$lastContextDependency = $ff199815cdbd2fab$var$lastContextDependency.next = context;
    return value;
}
var $ff199815cdbd2fab$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $ff199815cdbd2fab$var$scheduleCallback$2 = $bIbAw.unstable_scheduleCallback, $ff199815cdbd2fab$var$NormalPriority = $bIbAw.unstable_NormalPriority, $ff199815cdbd2fab$var$CacheContext = {
    $$typeof: $ff199815cdbd2fab$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $ff199815cdbd2fab$var$createCache() {
    return {
        controller: new $ff199815cdbd2fab$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $ff199815cdbd2fab$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $ff199815cdbd2fab$var$scheduleCallback$2($ff199815cdbd2fab$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $ff199815cdbd2fab$var$currentEntangledListeners = null, $ff199815cdbd2fab$var$currentEntangledPendingCount = 0, $ff199815cdbd2fab$var$currentEntangledLane = 0, $ff199815cdbd2fab$var$currentEntangledActionThenable = null;
function $ff199815cdbd2fab$var$entangleAsyncAction(transition, thenable) {
    if (null === $ff199815cdbd2fab$var$currentEntangledListeners) {
        var entangledListeners = $ff199815cdbd2fab$var$currentEntangledListeners = [];
        $ff199815cdbd2fab$var$currentEntangledPendingCount = 0;
        $ff199815cdbd2fab$var$currentEntangledLane = $ff199815cdbd2fab$var$requestTransitionLane();
        $ff199815cdbd2fab$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $ff199815cdbd2fab$var$currentEntangledPendingCount++;
    thenable.then($ff199815cdbd2fab$var$pingEngtangledActionScope, $ff199815cdbd2fab$var$pingEngtangledActionScope);
    return thenable;
}
function $ff199815cdbd2fab$var$pingEngtangledActionScope() {
    if (0 === --$ff199815cdbd2fab$var$currentEntangledPendingCount && null !== $ff199815cdbd2fab$var$currentEntangledListeners) {
        null !== $ff199815cdbd2fab$var$currentEntangledActionThenable && ($ff199815cdbd2fab$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $ff199815cdbd2fab$var$currentEntangledListeners;
        $ff199815cdbd2fab$var$currentEntangledListeners = null;
        $ff199815cdbd2fab$var$currentEntangledLane = 0;
        $ff199815cdbd2fab$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $ff199815cdbd2fab$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $ff199815cdbd2fab$var$prevOnStartTransitionFinish = $ff199815cdbd2fab$var$ReactSharedInternals.S;
$ff199815cdbd2fab$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $ff199815cdbd2fab$var$entangleAsyncAction(transition, returnValue);
    null !== $ff199815cdbd2fab$var$prevOnStartTransitionFinish && $ff199815cdbd2fab$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $ff199815cdbd2fab$var$resumedCache = $ff199815cdbd2fab$var$createCursor(null);
function $ff199815cdbd2fab$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $ff199815cdbd2fab$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $ff199815cdbd2fab$var$workInProgressRoot.pooledCache;
}
function $ff199815cdbd2fab$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$resumedCache, $ff199815cdbd2fab$var$resumedCache.current) : $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$resumedCache, prevCachePool.pool);
}
function $ff199815cdbd2fab$var$getSuspendedCache() {
    var cacheFromPool = $ff199815cdbd2fab$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $ff199815cdbd2fab$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $ff199815cdbd2fab$var$SuspenseException = Error($ff199815cdbd2fab$var$formatProdErrorMessage(460)), $ff199815cdbd2fab$var$SuspenseyCommitException = Error($ff199815cdbd2fab$var$formatProdErrorMessage(474)), $ff199815cdbd2fab$var$SuspenseActionException = Error($ff199815cdbd2fab$var$formatProdErrorMessage(542)), $ff199815cdbd2fab$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $ff199815cdbd2fab$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $ff199815cdbd2fab$var$noop$3() {}
function $ff199815cdbd2fab$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($ff199815cdbd2fab$var$noop$3, $ff199815cdbd2fab$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $ff199815cdbd2fab$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($ff199815cdbd2fab$var$noop$3, $ff199815cdbd2fab$var$noop$3);
            else {
                thenableState = $ff199815cdbd2fab$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $ff199815cdbd2fab$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $ff199815cdbd2fab$var$suspendedThenable = thenable;
            throw $ff199815cdbd2fab$var$SuspenseException;
    }
}
var $ff199815cdbd2fab$var$suspendedThenable = null;
function $ff199815cdbd2fab$var$getSuspendedThenable() {
    if (null === $ff199815cdbd2fab$var$suspendedThenable) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(459));
    var thenable = $ff199815cdbd2fab$var$suspendedThenable;
    $ff199815cdbd2fab$var$suspendedThenable = null;
    return thenable;
}
function $ff199815cdbd2fab$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $ff199815cdbd2fab$var$SuspenseException || rejectedReason === $ff199815cdbd2fab$var$SuspenseActionException) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(483));
}
var $ff199815cdbd2fab$var$hasForceUpdate = !1;
function $ff199815cdbd2fab$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $ff199815cdbd2fab$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $ff199815cdbd2fab$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $ff199815cdbd2fab$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($ff199815cdbd2fab$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $ff199815cdbd2fab$var$getRootForUpdatedFiber(fiber);
        $ff199815cdbd2fab$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $ff199815cdbd2fab$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $ff199815cdbd2fab$var$getRootForUpdatedFiber(fiber);
}
function $ff199815cdbd2fab$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $ff199815cdbd2fab$var$markRootEntangled(root, lane);
    }
}
function $ff199815cdbd2fab$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $ff199815cdbd2fab$var$didReadFromEntangledAsyncAction = !1;
function $ff199815cdbd2fab$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($ff199815cdbd2fab$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $ff199815cdbd2fab$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $ff199815cdbd2fab$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $ff199815cdbd2fab$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $ff199815cdbd2fab$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($ff199815cdbd2fab$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $ff199815cdbd2fab$var$currentEntangledLane && ($ff199815cdbd2fab$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $ff199815cdbd2fab$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $ff199815cdbd2fab$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $ff199815cdbd2fab$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $ff199815cdbd2fab$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $ff199815cdbd2fab$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$ff199815cdbd2fab$var$callCallback(callbacks[updateQueue], context);
}
var $ff199815cdbd2fab$var$currentTreeHiddenStackCursor = $ff199815cdbd2fab$var$createCursor(null), $ff199815cdbd2fab$var$prevEntangledRenderLanesCursor = $ff199815cdbd2fab$var$createCursor(0);
function $ff199815cdbd2fab$var$pushHiddenContext(fiber, context) {
    fiber = $ff199815cdbd2fab$var$entangledRenderLanes;
    $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$prevEntangledRenderLanesCursor, fiber);
    $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$currentTreeHiddenStackCursor, context);
    $ff199815cdbd2fab$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $ff199815cdbd2fab$var$reuseHiddenContextOnStack() {
    $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$prevEntangledRenderLanesCursor, $ff199815cdbd2fab$var$entangledRenderLanes);
    $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$currentTreeHiddenStackCursor, $ff199815cdbd2fab$var$currentTreeHiddenStackCursor.current);
}
function $ff199815cdbd2fab$var$popHiddenContext() {
    $ff199815cdbd2fab$var$entangledRenderLanes = $ff199815cdbd2fab$var$prevEntangledRenderLanesCursor.current;
    $ff199815cdbd2fab$var$pop($ff199815cdbd2fab$var$currentTreeHiddenStackCursor);
    $ff199815cdbd2fab$var$pop($ff199815cdbd2fab$var$prevEntangledRenderLanesCursor);
}
var $ff199815cdbd2fab$var$renderLanes = 0, $ff199815cdbd2fab$var$currentlyRenderingFiber = null, $ff199815cdbd2fab$var$currentHook = null, $ff199815cdbd2fab$var$workInProgressHook = null, $ff199815cdbd2fab$var$didScheduleRenderPhaseUpdate = !1, $ff199815cdbd2fab$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $ff199815cdbd2fab$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $ff199815cdbd2fab$var$localIdCounter = 0, $ff199815cdbd2fab$var$thenableIndexCounter$1 = 0, $ff199815cdbd2fab$var$thenableState$1 = null, $ff199815cdbd2fab$var$globalClientIdCounter = 0;
function $ff199815cdbd2fab$var$throwInvalidHookError() {
    throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(321));
}
function $ff199815cdbd2fab$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$ff199815cdbd2fab$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $ff199815cdbd2fab$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $ff199815cdbd2fab$var$renderLanes = nextRenderLanes;
    $ff199815cdbd2fab$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $ff199815cdbd2fab$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $ff199815cdbd2fab$var$HooksDispatcherOnMount : $ff199815cdbd2fab$var$HooksDispatcherOnUpdate;
    $ff199815cdbd2fab$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $ff199815cdbd2fab$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $ff199815cdbd2fab$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $ff199815cdbd2fab$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $ff199815cdbd2fab$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $ff199815cdbd2fab$var$finishRenderingHooks(current) {
    $ff199815cdbd2fab$var$ReactSharedInternals.H = $ff199815cdbd2fab$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $ff199815cdbd2fab$var$currentHook && null !== $ff199815cdbd2fab$var$currentHook.next;
    $ff199815cdbd2fab$var$renderLanes = 0;
    $ff199815cdbd2fab$var$workInProgressHook = $ff199815cdbd2fab$var$currentHook = $ff199815cdbd2fab$var$currentlyRenderingFiber = null;
    $ff199815cdbd2fab$var$didScheduleRenderPhaseUpdate = !1;
    $ff199815cdbd2fab$var$thenableIndexCounter$1 = 0;
    $ff199815cdbd2fab$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(300));
    null === current || $ff199815cdbd2fab$var$didReceiveUpdate || (current = current.dependencies, null !== current && $ff199815cdbd2fab$var$checkIfContextChanged(current) && ($ff199815cdbd2fab$var$didReceiveUpdate = !0));
}
function $ff199815cdbd2fab$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $ff199815cdbd2fab$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $ff199815cdbd2fab$var$didScheduleRenderPhaseUpdateDuringThisPass && ($ff199815cdbd2fab$var$thenableState$1 = null);
        $ff199815cdbd2fab$var$thenableIndexCounter$1 = 0;
        $ff199815cdbd2fab$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $ff199815cdbd2fab$var$workInProgressHook = $ff199815cdbd2fab$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $ff199815cdbd2fab$var$ReactSharedInternals.H = $ff199815cdbd2fab$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($ff199815cdbd2fab$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $ff199815cdbd2fab$var$TransitionAwareHostComponent() {
    var dispatcher = $ff199815cdbd2fab$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $ff199815cdbd2fab$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $ff199815cdbd2fab$var$currentHook ? $ff199815cdbd2fab$var$currentHook.memoizedState : null) !== dispatcher && ($ff199815cdbd2fab$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $ff199815cdbd2fab$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $ff199815cdbd2fab$var$localIdCounter;
    $ff199815cdbd2fab$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $ff199815cdbd2fab$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $ff199815cdbd2fab$var$resetHooksOnUnwind(workInProgress) {
    if ($ff199815cdbd2fab$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $ff199815cdbd2fab$var$didScheduleRenderPhaseUpdate = !1;
    }
    $ff199815cdbd2fab$var$renderLanes = 0;
    $ff199815cdbd2fab$var$workInProgressHook = $ff199815cdbd2fab$var$currentHook = $ff199815cdbd2fab$var$currentlyRenderingFiber = null;
    $ff199815cdbd2fab$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $ff199815cdbd2fab$var$thenableIndexCounter$1 = $ff199815cdbd2fab$var$localIdCounter = 0;
    $ff199815cdbd2fab$var$thenableState$1 = null;
}
function $ff199815cdbd2fab$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $ff199815cdbd2fab$var$workInProgressHook ? $ff199815cdbd2fab$var$currentlyRenderingFiber.memoizedState = $ff199815cdbd2fab$var$workInProgressHook = hook : $ff199815cdbd2fab$var$workInProgressHook = $ff199815cdbd2fab$var$workInProgressHook.next = hook;
    return $ff199815cdbd2fab$var$workInProgressHook;
}
function $ff199815cdbd2fab$var$updateWorkInProgressHook() {
    if (null === $ff199815cdbd2fab$var$currentHook) {
        var nextCurrentHook = $ff199815cdbd2fab$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $ff199815cdbd2fab$var$currentHook.next;
    var nextWorkInProgressHook = null === $ff199815cdbd2fab$var$workInProgressHook ? $ff199815cdbd2fab$var$currentlyRenderingFiber.memoizedState : $ff199815cdbd2fab$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $ff199815cdbd2fab$var$workInProgressHook = nextWorkInProgressHook, $ff199815cdbd2fab$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $ff199815cdbd2fab$var$currentlyRenderingFiber.alternate) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(467));
            throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(310));
        }
        $ff199815cdbd2fab$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $ff199815cdbd2fab$var$currentHook.memoizedState,
            baseState: $ff199815cdbd2fab$var$currentHook.baseState,
            baseQueue: $ff199815cdbd2fab$var$currentHook.baseQueue,
            queue: $ff199815cdbd2fab$var$currentHook.queue,
            next: null
        };
        null === $ff199815cdbd2fab$var$workInProgressHook ? $ff199815cdbd2fab$var$currentlyRenderingFiber.memoizedState = $ff199815cdbd2fab$var$workInProgressHook = nextCurrentHook : $ff199815cdbd2fab$var$workInProgressHook = $ff199815cdbd2fab$var$workInProgressHook.next = nextCurrentHook;
    }
    return $ff199815cdbd2fab$var$workInProgressHook;
}
function $ff199815cdbd2fab$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $ff199815cdbd2fab$var$useThenable(thenable) {
    var index = $ff199815cdbd2fab$var$thenableIndexCounter$1;
    $ff199815cdbd2fab$var$thenableIndexCounter$1 += 1;
    null === $ff199815cdbd2fab$var$thenableState$1 && ($ff199815cdbd2fab$var$thenableState$1 = []);
    thenable = $ff199815cdbd2fab$var$trackUsedThenable($ff199815cdbd2fab$var$thenableState$1, thenable, index);
    index = $ff199815cdbd2fab$var$currentlyRenderingFiber;
    null === (null === $ff199815cdbd2fab$var$workInProgressHook ? index.memoizedState : $ff199815cdbd2fab$var$workInProgressHook.next) && (index = index.alternate, $ff199815cdbd2fab$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $ff199815cdbd2fab$var$HooksDispatcherOnMount : $ff199815cdbd2fab$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $ff199815cdbd2fab$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $ff199815cdbd2fab$var$useThenable(usable);
        if (usable.$$typeof === $ff199815cdbd2fab$var$REACT_CONTEXT_TYPE) return $ff199815cdbd2fab$var$readContext(usable);
    }
    throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(438, String(usable)));
}
function $ff199815cdbd2fab$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $ff199815cdbd2fab$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $ff199815cdbd2fab$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $ff199815cdbd2fab$var$createFunctionComponentUpdateQueue(), $ff199815cdbd2fab$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $ff199815cdbd2fab$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $ff199815cdbd2fab$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $ff199815cdbd2fab$var$updateReducer(reducer) {
    var hook = $ff199815cdbd2fab$var$updateWorkInProgressHook();
    return $ff199815cdbd2fab$var$updateReducerImpl(hook, $ff199815cdbd2fab$var$currentHook, reducer);
}
function $ff199815cdbd2fab$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($ff199815cdbd2fab$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($ff199815cdbd2fab$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $ff199815cdbd2fab$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($ff199815cdbd2fab$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $ff199815cdbd2fab$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $ff199815cdbd2fab$var$currentlyRenderingFiber.lanes |= revertLane, $ff199815cdbd2fab$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $ff199815cdbd2fab$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $ff199815cdbd2fab$var$currentlyRenderingFiber.lanes |= updateLane, $ff199815cdbd2fab$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$ff199815cdbd2fab$var$objectIs(pendingQueue, hook.memoizedState) && ($ff199815cdbd2fab$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $ff199815cdbd2fab$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $ff199815cdbd2fab$var$rerenderReducer(reducer) {
    var hook = $ff199815cdbd2fab$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $ff199815cdbd2fab$var$objectIs(newState, hook.memoizedState) || ($ff199815cdbd2fab$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $ff199815cdbd2fab$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $ff199815cdbd2fab$var$currentlyRenderingFiber, hook = $ff199815cdbd2fab$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $ff199815cdbd2fab$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$ff199815cdbd2fab$var$objectIs(($ff199815cdbd2fab$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $ff199815cdbd2fab$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $ff199815cdbd2fab$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $ff199815cdbd2fab$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $ff199815cdbd2fab$var$workInProgressHook && $ff199815cdbd2fab$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $ff199815cdbd2fab$var$pushSimpleEffect(9, $ff199815cdbd2fab$var$createEffectInstance(), $ff199815cdbd2fab$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $ff199815cdbd2fab$var$workInProgressRoot) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($ff199815cdbd2fab$var$renderLanes & 124) || $ff199815cdbd2fab$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $ff199815cdbd2fab$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $ff199815cdbd2fab$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $ff199815cdbd2fab$var$createFunctionComponentUpdateQueue(), $ff199815cdbd2fab$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $ff199815cdbd2fab$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $ff199815cdbd2fab$var$checkIfSnapshotChanged(inst) && $ff199815cdbd2fab$var$forceStoreRerender(fiber);
}
function $ff199815cdbd2fab$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $ff199815cdbd2fab$var$checkIfSnapshotChanged(inst) && $ff199815cdbd2fab$var$forceStoreRerender(fiber);
    });
}
function $ff199815cdbd2fab$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$ff199815cdbd2fab$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $ff199815cdbd2fab$var$forceStoreRerender(fiber) {
    var root = $ff199815cdbd2fab$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $ff199815cdbd2fab$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $ff199815cdbd2fab$var$mountStateImpl(initialState) {
    var hook = $ff199815cdbd2fab$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($ff199815cdbd2fab$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $ff199815cdbd2fab$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $ff199815cdbd2fab$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $ff199815cdbd2fab$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $ff199815cdbd2fab$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $ff199815cdbd2fab$var$updateReducerImpl(hook, $ff199815cdbd2fab$var$currentHook, "function" === typeof reducer ? reducer : $ff199815cdbd2fab$var$basicStateReducer);
}
function $ff199815cdbd2fab$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($ff199815cdbd2fab$var$isRenderPhaseUpdate(fiber)) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $ff199815cdbd2fab$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $ff199815cdbd2fab$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $ff199815cdbd2fab$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $ff199815cdbd2fab$var$ReactSharedInternals.T, currentTransition = {};
        $ff199815cdbd2fab$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $ff199815cdbd2fab$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $ff199815cdbd2fab$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $ff199815cdbd2fab$var$onActionError(actionQueue, node, error);
        } finally{
            $ff199815cdbd2fab$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $ff199815cdbd2fab$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $ff199815cdbd2fab$var$onActionError(actionQueue, node, error$38);
    }
}
function $ff199815cdbd2fab$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $ff199815cdbd2fab$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $ff199815cdbd2fab$var$onActionError(actionQueue, node, error);
    }) : $ff199815cdbd2fab$var$onActionSuccess(actionQueue, node, returnValue);
}
function $ff199815cdbd2fab$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $ff199815cdbd2fab$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $ff199815cdbd2fab$var$runActionStateAction(actionQueue, nextState)));
}
function $ff199815cdbd2fab$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $ff199815cdbd2fab$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $ff199815cdbd2fab$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $ff199815cdbd2fab$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $ff199815cdbd2fab$var$mountActionState(action, initialStateProp) {
    if ($ff199815cdbd2fab$var$isHydrating) {
        var ssrFormState = $ff199815cdbd2fab$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $ff199815cdbd2fab$var$currentlyRenderingFiber;
                if ($ff199815cdbd2fab$var$isHydrating) {
                    if ($ff199815cdbd2fab$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $ff199815cdbd2fab$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $ff199815cdbd2fab$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $ff199815cdbd2fab$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $ff199815cdbd2fab$var$nextHydratableInstance = $ff199815cdbd2fab$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $ff199815cdbd2fab$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $ff199815cdbd2fab$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $ff199815cdbd2fab$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $ff199815cdbd2fab$var$dispatchSetState.bind(null, $ff199815cdbd2fab$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $ff199815cdbd2fab$var$mountStateImpl(!1);
    inRootOrSingleton = $ff199815cdbd2fab$var$dispatchOptimisticSetState.bind(null, $ff199815cdbd2fab$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $ff199815cdbd2fab$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $ff199815cdbd2fab$var$dispatchActionState.bind(null, $ff199815cdbd2fab$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $ff199815cdbd2fab$var$updateActionState(action) {
    var stateHook = $ff199815cdbd2fab$var$updateWorkInProgressHook();
    return $ff199815cdbd2fab$var$updateActionStateImpl(stateHook, $ff199815cdbd2fab$var$currentHook, action);
}
function $ff199815cdbd2fab$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $ff199815cdbd2fab$var$updateReducerImpl(stateHook, currentStateHook, $ff199815cdbd2fab$var$actionStateReducer)[0];
    stateHook = $ff199815cdbd2fab$var$updateReducer($ff199815cdbd2fab$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $ff199815cdbd2fab$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $ff199815cdbd2fab$var$SuspenseException) throw $ff199815cdbd2fab$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $ff199815cdbd2fab$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($ff199815cdbd2fab$var$currentlyRenderingFiber.flags |= 2048, $ff199815cdbd2fab$var$pushSimpleEffect(9, $ff199815cdbd2fab$var$createEffectInstance(), $ff199815cdbd2fab$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $ff199815cdbd2fab$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $ff199815cdbd2fab$var$rerenderActionState(action) {
    var stateHook = $ff199815cdbd2fab$var$updateWorkInProgressHook(), currentStateHook = $ff199815cdbd2fab$var$currentHook;
    if (null !== currentStateHook) return $ff199815cdbd2fab$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $ff199815cdbd2fab$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $ff199815cdbd2fab$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $ff199815cdbd2fab$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $ff199815cdbd2fab$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $ff199815cdbd2fab$var$createFunctionComponentUpdateQueue(), $ff199815cdbd2fab$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $ff199815cdbd2fab$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $ff199815cdbd2fab$var$updateRef() {
    return $ff199815cdbd2fab$var$updateWorkInProgressHook().memoizedState;
}
function $ff199815cdbd2fab$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $ff199815cdbd2fab$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $ff199815cdbd2fab$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $ff199815cdbd2fab$var$pushSimpleEffect(1 | hookFlags, $ff199815cdbd2fab$var$createEffectInstance(), create, createDeps);
}
function $ff199815cdbd2fab$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $ff199815cdbd2fab$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $ff199815cdbd2fab$var$currentHook && null !== deps && $ff199815cdbd2fab$var$areHookInputsEqual(deps, $ff199815cdbd2fab$var$currentHook.memoizedState.deps) ? hook.memoizedState = $ff199815cdbd2fab$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($ff199815cdbd2fab$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $ff199815cdbd2fab$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $ff199815cdbd2fab$var$mountEffect(create, createDeps) {
    $ff199815cdbd2fab$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $ff199815cdbd2fab$var$updateEffect(create, createDeps) {
    $ff199815cdbd2fab$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $ff199815cdbd2fab$var$updateInsertionEffect(create, deps) {
    return $ff199815cdbd2fab$var$updateEffectImpl(4, 2, create, deps);
}
function $ff199815cdbd2fab$var$updateLayoutEffect(create, deps) {
    return $ff199815cdbd2fab$var$updateEffectImpl(4, 4, create, deps);
}
function $ff199815cdbd2fab$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $ff199815cdbd2fab$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $ff199815cdbd2fab$var$updateEffectImpl(4, 4, $ff199815cdbd2fab$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $ff199815cdbd2fab$var$mountDebugValue() {}
function $ff199815cdbd2fab$var$updateCallback(callback, deps) {
    var hook = $ff199815cdbd2fab$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $ff199815cdbd2fab$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $ff199815cdbd2fab$var$updateMemo(nextCreate, deps) {
    var hook = $ff199815cdbd2fab$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $ff199815cdbd2fab$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($ff199815cdbd2fab$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $ff199815cdbd2fab$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $ff199815cdbd2fab$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $ff199815cdbd2fab$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($ff199815cdbd2fab$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $ff199815cdbd2fab$var$requestDeferredLane();
    $ff199815cdbd2fab$var$currentlyRenderingFiber.lanes |= hook;
    $ff199815cdbd2fab$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $ff199815cdbd2fab$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($ff199815cdbd2fab$var$objectIs(value, prevValue)) return value;
    if (null !== $ff199815cdbd2fab$var$currentTreeHiddenStackCursor.current) return hook = $ff199815cdbd2fab$var$mountDeferredValueImpl(hook, value, initialValue), $ff199815cdbd2fab$var$objectIs(hook, prevValue) || ($ff199815cdbd2fab$var$didReceiveUpdate = !0), hook;
    if (0 === ($ff199815cdbd2fab$var$renderLanes & 42)) return $ff199815cdbd2fab$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $ff199815cdbd2fab$var$requestDeferredLane();
    $ff199815cdbd2fab$var$currentlyRenderingFiber.lanes |= hook;
    $ff199815cdbd2fab$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $ff199815cdbd2fab$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $ff199815cdbd2fab$var$ReactDOMSharedInternals.p;
    $ff199815cdbd2fab$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $ff199815cdbd2fab$var$ReactSharedInternals.T, currentTransition = {};
    $ff199815cdbd2fab$var$ReactSharedInternals.T = currentTransition;
    $ff199815cdbd2fab$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $ff199815cdbd2fab$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $ff199815cdbd2fab$var$chainThenableValue(returnValue, finishedState);
            $ff199815cdbd2fab$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $ff199815cdbd2fab$var$requestUpdateLane(fiber));
        } else $ff199815cdbd2fab$var$dispatchSetStateInternal(fiber, queue, finishedState, $ff199815cdbd2fab$var$requestUpdateLane(fiber));
    } catch (error) {
        $ff199815cdbd2fab$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $ff199815cdbd2fab$var$requestUpdateLane());
    } finally{
        $ff199815cdbd2fab$var$ReactDOMSharedInternals.p = previousPriority, $ff199815cdbd2fab$var$ReactSharedInternals.T = prevTransition;
    }
}
function $ff199815cdbd2fab$var$noop$2() {}
function $ff199815cdbd2fab$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(476));
    var queue = $ff199815cdbd2fab$var$ensureFormComponentIsStateful(formFiber).queue;
    $ff199815cdbd2fab$var$startTransition(formFiber, queue, pendingState, $ff199815cdbd2fab$var$sharedNotPendingObject, null === action ? $ff199815cdbd2fab$var$noop$2 : function() {
        $ff199815cdbd2fab$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $ff199815cdbd2fab$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $ff199815cdbd2fab$var$sharedNotPendingObject,
        baseState: $ff199815cdbd2fab$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $ff199815cdbd2fab$var$basicStateReducer,
            lastRenderedState: $ff199815cdbd2fab$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $ff199815cdbd2fab$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $ff199815cdbd2fab$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $ff199815cdbd2fab$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $ff199815cdbd2fab$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $ff199815cdbd2fab$var$requestUpdateLane());
}
function $ff199815cdbd2fab$var$useHostTransitionStatus() {
    return $ff199815cdbd2fab$var$readContext($ff199815cdbd2fab$var$HostTransitionContext);
}
function $ff199815cdbd2fab$var$updateId() {
    return $ff199815cdbd2fab$var$updateWorkInProgressHook().memoizedState;
}
function $ff199815cdbd2fab$var$updateRefresh() {
    return $ff199815cdbd2fab$var$updateWorkInProgressHook().memoizedState;
}
function $ff199815cdbd2fab$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $ff199815cdbd2fab$var$requestUpdateLane();
                fiber = $ff199815cdbd2fab$var$createUpdate(lane);
                var root$41 = $ff199815cdbd2fab$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($ff199815cdbd2fab$var$scheduleUpdateOnFiber(root$41, provider, lane), $ff199815cdbd2fab$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $ff199815cdbd2fab$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $ff199815cdbd2fab$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $ff199815cdbd2fab$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $ff199815cdbd2fab$var$isRenderPhaseUpdate(fiber) ? $ff199815cdbd2fab$var$enqueueRenderPhaseUpdate(queue, action) : (action = $ff199815cdbd2fab$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($ff199815cdbd2fab$var$scheduleUpdateOnFiber(action, fiber, lane), $ff199815cdbd2fab$var$entangleTransitionUpdate(action, queue, lane)));
}
function $ff199815cdbd2fab$var$dispatchSetState(fiber, queue, action) {
    var lane = $ff199815cdbd2fab$var$requestUpdateLane();
    $ff199815cdbd2fab$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $ff199815cdbd2fab$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($ff199815cdbd2fab$var$isRenderPhaseUpdate(fiber)) $ff199815cdbd2fab$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($ff199815cdbd2fab$var$objectIs(eagerState, currentState)) return $ff199815cdbd2fab$var$enqueueUpdate$1(fiber, queue, update, 0), null === $ff199815cdbd2fab$var$workInProgressRoot && $ff199815cdbd2fab$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $ff199815cdbd2fab$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $ff199815cdbd2fab$var$scheduleUpdateOnFiber(action, fiber, lane), $ff199815cdbd2fab$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $ff199815cdbd2fab$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $ff199815cdbd2fab$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($ff199815cdbd2fab$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $ff199815cdbd2fab$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $ff199815cdbd2fab$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $ff199815cdbd2fab$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $ff199815cdbd2fab$var$currentlyRenderingFiber || null !== alternate && alternate === $ff199815cdbd2fab$var$currentlyRenderingFiber;
}
function $ff199815cdbd2fab$var$enqueueRenderPhaseUpdate(queue, update) {
    $ff199815cdbd2fab$var$didScheduleRenderPhaseUpdateDuringThisPass = $ff199815cdbd2fab$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $ff199815cdbd2fab$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $ff199815cdbd2fab$var$markRootEntangled(root, lane);
    }
}
var $ff199815cdbd2fab$var$ContextOnlyDispatcher = {
    readContext: $ff199815cdbd2fab$var$readContext,
    use: $ff199815cdbd2fab$var$use,
    useCallback: $ff199815cdbd2fab$var$throwInvalidHookError,
    useContext: $ff199815cdbd2fab$var$throwInvalidHookError,
    useEffect: $ff199815cdbd2fab$var$throwInvalidHookError,
    useImperativeHandle: $ff199815cdbd2fab$var$throwInvalidHookError,
    useLayoutEffect: $ff199815cdbd2fab$var$throwInvalidHookError,
    useInsertionEffect: $ff199815cdbd2fab$var$throwInvalidHookError,
    useMemo: $ff199815cdbd2fab$var$throwInvalidHookError,
    useReducer: $ff199815cdbd2fab$var$throwInvalidHookError,
    useRef: $ff199815cdbd2fab$var$throwInvalidHookError,
    useState: $ff199815cdbd2fab$var$throwInvalidHookError,
    useDebugValue: $ff199815cdbd2fab$var$throwInvalidHookError,
    useDeferredValue: $ff199815cdbd2fab$var$throwInvalidHookError,
    useTransition: $ff199815cdbd2fab$var$throwInvalidHookError,
    useSyncExternalStore: $ff199815cdbd2fab$var$throwInvalidHookError,
    useId: $ff199815cdbd2fab$var$throwInvalidHookError,
    useHostTransitionStatus: $ff199815cdbd2fab$var$throwInvalidHookError,
    useFormState: $ff199815cdbd2fab$var$throwInvalidHookError,
    useActionState: $ff199815cdbd2fab$var$throwInvalidHookError,
    useOptimistic: $ff199815cdbd2fab$var$throwInvalidHookError,
    useMemoCache: $ff199815cdbd2fab$var$throwInvalidHookError,
    useCacheRefresh: $ff199815cdbd2fab$var$throwInvalidHookError
}, $ff199815cdbd2fab$var$HooksDispatcherOnMount = {
    readContext: $ff199815cdbd2fab$var$readContext,
    use: $ff199815cdbd2fab$var$use,
    useCallback: function(callback, deps) {
        $ff199815cdbd2fab$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $ff199815cdbd2fab$var$readContext,
    useEffect: $ff199815cdbd2fab$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $ff199815cdbd2fab$var$mountEffectImpl(4194308, 4, $ff199815cdbd2fab$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $ff199815cdbd2fab$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $ff199815cdbd2fab$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $ff199815cdbd2fab$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($ff199815cdbd2fab$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $ff199815cdbd2fab$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $ff199815cdbd2fab$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $ff199815cdbd2fab$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($ff199815cdbd2fab$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $ff199815cdbd2fab$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $ff199815cdbd2fab$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $ff199815cdbd2fab$var$dispatchReducerAction.bind(null, $ff199815cdbd2fab$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $ff199815cdbd2fab$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $ff199815cdbd2fab$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $ff199815cdbd2fab$var$dispatchSetState.bind(null, $ff199815cdbd2fab$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $ff199815cdbd2fab$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $ff199815cdbd2fab$var$mountWorkInProgressHook();
        return $ff199815cdbd2fab$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $ff199815cdbd2fab$var$mountStateImpl(!1);
        stateHook = $ff199815cdbd2fab$var$startTransition.bind(null, $ff199815cdbd2fab$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $ff199815cdbd2fab$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $ff199815cdbd2fab$var$currentlyRenderingFiber, hook = $ff199815cdbd2fab$var$mountWorkInProgressHook();
        if ($ff199815cdbd2fab$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $ff199815cdbd2fab$var$workInProgressRoot) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(349));
            0 !== ($ff199815cdbd2fab$var$workInProgressRootRenderLanes & 124) || $ff199815cdbd2fab$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $ff199815cdbd2fab$var$mountEffect($ff199815cdbd2fab$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $ff199815cdbd2fab$var$pushSimpleEffect(9, $ff199815cdbd2fab$var$createEffectInstance(), $ff199815cdbd2fab$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $ff199815cdbd2fab$var$mountWorkInProgressHook(), identifierPrefix = $ff199815cdbd2fab$var$workInProgressRoot.identifierPrefix;
        if ($ff199815cdbd2fab$var$isHydrating) {
            var JSCompiler_inline_result = $ff199815cdbd2fab$var$treeContextOverflow;
            var idWithLeadingBit = $ff199815cdbd2fab$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $ff199815cdbd2fab$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $ff199815cdbd2fab$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $ff199815cdbd2fab$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $ff199815cdbd2fab$var$useHostTransitionStatus,
    useFormState: $ff199815cdbd2fab$var$mountActionState,
    useActionState: $ff199815cdbd2fab$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $ff199815cdbd2fab$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $ff199815cdbd2fab$var$dispatchOptimisticSetState.bind(null, $ff199815cdbd2fab$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $ff199815cdbd2fab$var$useMemoCache,
    useCacheRefresh: function() {
        return $ff199815cdbd2fab$var$mountWorkInProgressHook().memoizedState = $ff199815cdbd2fab$var$refreshCache.bind(null, $ff199815cdbd2fab$var$currentlyRenderingFiber);
    }
}, $ff199815cdbd2fab$var$HooksDispatcherOnUpdate = {
    readContext: $ff199815cdbd2fab$var$readContext,
    use: $ff199815cdbd2fab$var$use,
    useCallback: $ff199815cdbd2fab$var$updateCallback,
    useContext: $ff199815cdbd2fab$var$readContext,
    useEffect: $ff199815cdbd2fab$var$updateEffect,
    useImperativeHandle: $ff199815cdbd2fab$var$updateImperativeHandle,
    useInsertionEffect: $ff199815cdbd2fab$var$updateInsertionEffect,
    useLayoutEffect: $ff199815cdbd2fab$var$updateLayoutEffect,
    useMemo: $ff199815cdbd2fab$var$updateMemo,
    useReducer: $ff199815cdbd2fab$var$updateReducer,
    useRef: $ff199815cdbd2fab$var$updateRef,
    useState: function() {
        return $ff199815cdbd2fab$var$updateReducer($ff199815cdbd2fab$var$basicStateReducer);
    },
    useDebugValue: $ff199815cdbd2fab$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $ff199815cdbd2fab$var$updateWorkInProgressHook();
        return $ff199815cdbd2fab$var$updateDeferredValueImpl(hook, $ff199815cdbd2fab$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $ff199815cdbd2fab$var$updateReducer($ff199815cdbd2fab$var$basicStateReducer)[0], start = $ff199815cdbd2fab$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $ff199815cdbd2fab$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $ff199815cdbd2fab$var$updateSyncExternalStore,
    useId: $ff199815cdbd2fab$var$updateId,
    useHostTransitionStatus: $ff199815cdbd2fab$var$useHostTransitionStatus,
    useFormState: $ff199815cdbd2fab$var$updateActionState,
    useActionState: $ff199815cdbd2fab$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $ff199815cdbd2fab$var$updateWorkInProgressHook();
        return $ff199815cdbd2fab$var$updateOptimisticImpl(hook, $ff199815cdbd2fab$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $ff199815cdbd2fab$var$useMemoCache,
    useCacheRefresh: $ff199815cdbd2fab$var$updateRefresh
}, $ff199815cdbd2fab$var$HooksDispatcherOnRerender = {
    readContext: $ff199815cdbd2fab$var$readContext,
    use: $ff199815cdbd2fab$var$use,
    useCallback: $ff199815cdbd2fab$var$updateCallback,
    useContext: $ff199815cdbd2fab$var$readContext,
    useEffect: $ff199815cdbd2fab$var$updateEffect,
    useImperativeHandle: $ff199815cdbd2fab$var$updateImperativeHandle,
    useInsertionEffect: $ff199815cdbd2fab$var$updateInsertionEffect,
    useLayoutEffect: $ff199815cdbd2fab$var$updateLayoutEffect,
    useMemo: $ff199815cdbd2fab$var$updateMemo,
    useReducer: $ff199815cdbd2fab$var$rerenderReducer,
    useRef: $ff199815cdbd2fab$var$updateRef,
    useState: function() {
        return $ff199815cdbd2fab$var$rerenderReducer($ff199815cdbd2fab$var$basicStateReducer);
    },
    useDebugValue: $ff199815cdbd2fab$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $ff199815cdbd2fab$var$updateWorkInProgressHook();
        return null === $ff199815cdbd2fab$var$currentHook ? $ff199815cdbd2fab$var$mountDeferredValueImpl(hook, value, initialValue) : $ff199815cdbd2fab$var$updateDeferredValueImpl(hook, $ff199815cdbd2fab$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $ff199815cdbd2fab$var$rerenderReducer($ff199815cdbd2fab$var$basicStateReducer)[0], start = $ff199815cdbd2fab$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $ff199815cdbd2fab$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $ff199815cdbd2fab$var$updateSyncExternalStore,
    useId: $ff199815cdbd2fab$var$updateId,
    useHostTransitionStatus: $ff199815cdbd2fab$var$useHostTransitionStatus,
    useFormState: $ff199815cdbd2fab$var$rerenderActionState,
    useActionState: $ff199815cdbd2fab$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $ff199815cdbd2fab$var$updateWorkInProgressHook();
        if (null !== $ff199815cdbd2fab$var$currentHook) return $ff199815cdbd2fab$var$updateOptimisticImpl(hook, $ff199815cdbd2fab$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $ff199815cdbd2fab$var$useMemoCache,
    useCacheRefresh: $ff199815cdbd2fab$var$updateRefresh
}, $ff199815cdbd2fab$var$thenableState = null, $ff199815cdbd2fab$var$thenableIndexCounter = 0;
function $ff199815cdbd2fab$var$unwrapThenable(thenable) {
    var index = $ff199815cdbd2fab$var$thenableIndexCounter;
    $ff199815cdbd2fab$var$thenableIndexCounter += 1;
    null === $ff199815cdbd2fab$var$thenableState && ($ff199815cdbd2fab$var$thenableState = []);
    return $ff199815cdbd2fab$var$trackUsedThenable($ff199815cdbd2fab$var$thenableState, thenable, index);
}
function $ff199815cdbd2fab$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $ff199815cdbd2fab$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $ff199815cdbd2fab$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $ff199815cdbd2fab$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $ff199815cdbd2fab$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $ff199815cdbd2fab$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $ff199815cdbd2fab$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $ff199815cdbd2fab$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $ff199815cdbd2fab$var$REACT_LAZY_TYPE && $ff199815cdbd2fab$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $ff199815cdbd2fab$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $ff199815cdbd2fab$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $ff199815cdbd2fab$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $ff199815cdbd2fab$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $ff199815cdbd2fab$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $ff199815cdbd2fab$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $ff199815cdbd2fab$var$REACT_ELEMENT_TYPE:
                    return lanes = $ff199815cdbd2fab$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $ff199815cdbd2fab$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $ff199815cdbd2fab$var$REACT_PORTAL_TYPE:
                    return newChild = $ff199815cdbd2fab$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $ff199815cdbd2fab$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($ff199815cdbd2fab$var$isArrayImpl(newChild) || $ff199815cdbd2fab$var$getIteratorFn(newChild)) return newChild = $ff199815cdbd2fab$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $ff199815cdbd2fab$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $ff199815cdbd2fab$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $ff199815cdbd2fab$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $ff199815cdbd2fab$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $ff199815cdbd2fab$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $ff199815cdbd2fab$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $ff199815cdbd2fab$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($ff199815cdbd2fab$var$isArrayImpl(newChild) || $ff199815cdbd2fab$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $ff199815cdbd2fab$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $ff199815cdbd2fab$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $ff199815cdbd2fab$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $ff199815cdbd2fab$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $ff199815cdbd2fab$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $ff199815cdbd2fab$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $ff199815cdbd2fab$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($ff199815cdbd2fab$var$isArrayImpl(newChild) || $ff199815cdbd2fab$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $ff199815cdbd2fab$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $ff199815cdbd2fab$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $ff199815cdbd2fab$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $ff199815cdbd2fab$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $ff199815cdbd2fab$var$isHydrating && $ff199815cdbd2fab$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $ff199815cdbd2fab$var$isHydrating && $ff199815cdbd2fab$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $ff199815cdbd2fab$var$isHydrating && $ff199815cdbd2fab$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $ff199815cdbd2fab$var$isHydrating && $ff199815cdbd2fab$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $ff199815cdbd2fab$var$isHydrating && $ff199815cdbd2fab$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $ff199815cdbd2fab$var$isHydrating && $ff199815cdbd2fab$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $ff199815cdbd2fab$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $ff199815cdbd2fab$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $ff199815cdbd2fab$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $ff199815cdbd2fab$var$REACT_LAZY_TYPE && $ff199815cdbd2fab$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $ff199815cdbd2fab$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $ff199815cdbd2fab$var$REACT_FRAGMENT_TYPE ? (lanes = $ff199815cdbd2fab$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $ff199815cdbd2fab$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $ff199815cdbd2fab$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $ff199815cdbd2fab$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $ff199815cdbd2fab$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $ff199815cdbd2fab$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($ff199815cdbd2fab$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($ff199815cdbd2fab$var$getIteratorFn(newChild)) {
                key = $ff199815cdbd2fab$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $ff199815cdbd2fab$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $ff199815cdbd2fab$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $ff199815cdbd2fab$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $ff199815cdbd2fab$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $ff199815cdbd2fab$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $ff199815cdbd2fab$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $ff199815cdbd2fab$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $ff199815cdbd2fab$var$SuspenseException || x === $ff199815cdbd2fab$var$SuspenseActionException) throw x;
            var fiber = $ff199815cdbd2fab$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $ff199815cdbd2fab$var$reconcileChildFibers = $ff199815cdbd2fab$var$createChildReconciler(!0), $ff199815cdbd2fab$var$mountChildFibers = $ff199815cdbd2fab$var$createChildReconciler(!1), $ff199815cdbd2fab$var$suspenseHandlerStackCursor = $ff199815cdbd2fab$var$createCursor(null), $ff199815cdbd2fab$var$shellBoundary = null;
function $ff199815cdbd2fab$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$suspenseStackCursor, $ff199815cdbd2fab$var$suspenseStackCursor.current & 1);
    $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$suspenseHandlerStackCursor, handler);
    null === $ff199815cdbd2fab$var$shellBoundary && (null === current || null !== $ff199815cdbd2fab$var$currentTreeHiddenStackCursor.current ? $ff199815cdbd2fab$var$shellBoundary = handler : null !== current.memoizedState && ($ff199815cdbd2fab$var$shellBoundary = handler));
}
function $ff199815cdbd2fab$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$suspenseStackCursor, $ff199815cdbd2fab$var$suspenseStackCursor.current), $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$suspenseHandlerStackCursor, fiber), null === $ff199815cdbd2fab$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($ff199815cdbd2fab$var$shellBoundary = fiber);
        }
    } else $ff199815cdbd2fab$var$reuseSuspenseHandlerOnStack(fiber);
}
function $ff199815cdbd2fab$var$reuseSuspenseHandlerOnStack() {
    $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$suspenseStackCursor, $ff199815cdbd2fab$var$suspenseStackCursor.current);
    $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$suspenseHandlerStackCursor, $ff199815cdbd2fab$var$suspenseHandlerStackCursor.current);
}
function $ff199815cdbd2fab$var$popSuspenseHandler(fiber) {
    $ff199815cdbd2fab$var$pop($ff199815cdbd2fab$var$suspenseHandlerStackCursor);
    $ff199815cdbd2fab$var$shellBoundary === fiber && ($ff199815cdbd2fab$var$shellBoundary = null);
    $ff199815cdbd2fab$var$pop($ff199815cdbd2fab$var$suspenseStackCursor);
}
var $ff199815cdbd2fab$var$suspenseStackCursor = $ff199815cdbd2fab$var$createCursor(0);
function $ff199815cdbd2fab$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $ff199815cdbd2fab$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $ff199815cdbd2fab$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $ff199815cdbd2fab$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $ff199815cdbd2fab$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $ff199815cdbd2fab$var$requestUpdateLane(), update = $ff199815cdbd2fab$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $ff199815cdbd2fab$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($ff199815cdbd2fab$var$scheduleUpdateOnFiber(payload, inst, lane), $ff199815cdbd2fab$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $ff199815cdbd2fab$var$requestUpdateLane(), update = $ff199815cdbd2fab$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $ff199815cdbd2fab$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($ff199815cdbd2fab$var$scheduleUpdateOnFiber(payload, inst, lane), $ff199815cdbd2fab$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $ff199815cdbd2fab$var$requestUpdateLane(), update = $ff199815cdbd2fab$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $ff199815cdbd2fab$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($ff199815cdbd2fab$var$scheduleUpdateOnFiber(callback, inst, lane), $ff199815cdbd2fab$var$entangleTransitions(callback, inst, lane));
    }
};
function $ff199815cdbd2fab$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$ff199815cdbd2fab$var$shallowEqual(oldProps, newProps) || !$ff199815cdbd2fab$var$shallowEqual(oldState, newState) : !0;
}
function $ff199815cdbd2fab$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $ff199815cdbd2fab$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $ff199815cdbd2fab$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $ff199815cdbd2fab$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $ff199815cdbd2fab$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $ff199815cdbd2fab$var$defaultOnUncaughtError(error) {
    $ff199815cdbd2fab$var$reportGlobalError(error);
}
function $ff199815cdbd2fab$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $ff199815cdbd2fab$var$defaultOnRecoverableError(error) {
    $ff199815cdbd2fab$var$reportGlobalError(error);
}
function $ff199815cdbd2fab$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $ff199815cdbd2fab$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $ff199815cdbd2fab$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $ff199815cdbd2fab$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $ff199815cdbd2fab$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $ff199815cdbd2fab$var$createClassErrorUpdate(lane) {
    lane = $ff199815cdbd2fab$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $ff199815cdbd2fab$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $ff199815cdbd2fab$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $ff199815cdbd2fab$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $ff199815cdbd2fab$var$legacyErrorBoundariesThatAlreadyFailed ? $ff199815cdbd2fab$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $ff199815cdbd2fab$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $ff199815cdbd2fab$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $ff199815cdbd2fab$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $ff199815cdbd2fab$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $ff199815cdbd2fab$var$shellBoundary ? $ff199815cdbd2fab$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $ff199815cdbd2fab$var$workInProgressRootExitStatus && ($ff199815cdbd2fab$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $ff199815cdbd2fab$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $ff199815cdbd2fab$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $ff199815cdbd2fab$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $ff199815cdbd2fab$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $ff199815cdbd2fab$var$attachPingListener(root, value, rootRenderLanes);
        $ff199815cdbd2fab$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($ff199815cdbd2fab$var$isHydrating) return returnFiber = $ff199815cdbd2fab$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $ff199815cdbd2fab$var$HydrationMismatchException && (root = Error($ff199815cdbd2fab$var$formatProdErrorMessage(422), {
        cause: value
    }), $ff199815cdbd2fab$var$queueHydrationError($ff199815cdbd2fab$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $ff199815cdbd2fab$var$HydrationMismatchException && (returnFiber = Error($ff199815cdbd2fab$var$formatProdErrorMessage(423), {
        cause: value
    }), $ff199815cdbd2fab$var$queueHydrationError($ff199815cdbd2fab$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $ff199815cdbd2fab$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $ff199815cdbd2fab$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $ff199815cdbd2fab$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $ff199815cdbd2fab$var$workInProgressRootExitStatus && ($ff199815cdbd2fab$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($ff199815cdbd2fab$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $ff199815cdbd2fab$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $ff199815cdbd2fab$var$workInProgressRootConcurrentErrors ? $ff199815cdbd2fab$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $ff199815cdbd2fab$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $ff199815cdbd2fab$var$workInProgressRootExitStatus && ($ff199815cdbd2fab$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $ff199815cdbd2fab$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $ff199815cdbd2fab$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $ff199815cdbd2fab$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $ff199815cdbd2fab$var$legacyErrorBoundariesThatAlreadyFailed || !$ff199815cdbd2fab$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $ff199815cdbd2fab$var$createClassErrorUpdate(rootRenderLanes), $ff199815cdbd2fab$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $ff199815cdbd2fab$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $ff199815cdbd2fab$var$SelectiveHydrationException = Error($ff199815cdbd2fab$var$formatProdErrorMessage(461)), $ff199815cdbd2fab$var$didReceiveUpdate = !1;
function $ff199815cdbd2fab$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $ff199815cdbd2fab$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $ff199815cdbd2fab$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $ff199815cdbd2fab$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $ff199815cdbd2fab$var$prepareToReadContext(workInProgress);
    nextProps = $ff199815cdbd2fab$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $ff199815cdbd2fab$var$checkDidRenderIdHook();
    if (null !== current && !$ff199815cdbd2fab$var$didReceiveUpdate) return $ff199815cdbd2fab$var$bailoutHooks(current, workInProgress, renderLanes), $ff199815cdbd2fab$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $ff199815cdbd2fab$var$isHydrating && key && $ff199815cdbd2fab$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $ff199815cdbd2fab$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $ff199815cdbd2fab$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$ff199815cdbd2fab$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $ff199815cdbd2fab$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $ff199815cdbd2fab$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$ff199815cdbd2fab$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $ff199815cdbd2fab$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $ff199815cdbd2fab$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $ff199815cdbd2fab$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $ff199815cdbd2fab$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($ff199815cdbd2fab$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($ff199815cdbd2fab$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $ff199815cdbd2fab$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($ff199815cdbd2fab$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $ff199815cdbd2fab$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $ff199815cdbd2fab$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $ff199815cdbd2fab$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $ff199815cdbd2fab$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $ff199815cdbd2fab$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $ff199815cdbd2fab$var$pushHiddenContext(workInProgress, prevState) : $ff199815cdbd2fab$var$reuseHiddenContextOnStack(), $ff199815cdbd2fab$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $ff199815cdbd2fab$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($ff199815cdbd2fab$var$pushTransition(workInProgress, prevState.cachePool), $ff199815cdbd2fab$var$pushHiddenContext(workInProgress, prevState), $ff199815cdbd2fab$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $ff199815cdbd2fab$var$pushTransition(workInProgress, null), $ff199815cdbd2fab$var$reuseHiddenContextOnStack(), $ff199815cdbd2fab$var$reuseSuspenseHandlerOnStack(workInProgress));
    $ff199815cdbd2fab$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $ff199815cdbd2fab$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $ff199815cdbd2fab$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $ff199815cdbd2fab$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $ff199815cdbd2fab$var$pushTransition(workInProgress, null);
    $ff199815cdbd2fab$var$reuseHiddenContextOnStack();
    $ff199815cdbd2fab$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $ff199815cdbd2fab$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $ff199815cdbd2fab$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $ff199815cdbd2fab$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $ff199815cdbd2fab$var$prepareToReadContext(workInProgress);
    Component = $ff199815cdbd2fab$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $ff199815cdbd2fab$var$checkDidRenderIdHook();
    if (null !== current && !$ff199815cdbd2fab$var$didReceiveUpdate) return $ff199815cdbd2fab$var$bailoutHooks(current, workInProgress, renderLanes), $ff199815cdbd2fab$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $ff199815cdbd2fab$var$isHydrating && nextProps && $ff199815cdbd2fab$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $ff199815cdbd2fab$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $ff199815cdbd2fab$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $ff199815cdbd2fab$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $ff199815cdbd2fab$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $ff199815cdbd2fab$var$finishRenderingHooks(current);
    Component = $ff199815cdbd2fab$var$checkDidRenderIdHook();
    if (null !== current && !$ff199815cdbd2fab$var$didReceiveUpdate) return $ff199815cdbd2fab$var$bailoutHooks(current, workInProgress, renderLanes), $ff199815cdbd2fab$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $ff199815cdbd2fab$var$isHydrating && Component && $ff199815cdbd2fab$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $ff199815cdbd2fab$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $ff199815cdbd2fab$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $ff199815cdbd2fab$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $ff199815cdbd2fab$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $ff199815cdbd2fab$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $ff199815cdbd2fab$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $ff199815cdbd2fab$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $ff199815cdbd2fab$var$readContext(contextType) : $ff199815cdbd2fab$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($ff199815cdbd2fab$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $ff199815cdbd2fab$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $ff199815cdbd2fab$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $ff199815cdbd2fab$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $ff199815cdbd2fab$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $ff199815cdbd2fab$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $ff199815cdbd2fab$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $ff199815cdbd2fab$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $ff199815cdbd2fab$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $ff199815cdbd2fab$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $ff199815cdbd2fab$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $ff199815cdbd2fab$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($ff199815cdbd2fab$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $ff199815cdbd2fab$var$hasForceUpdate || $ff199815cdbd2fab$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $ff199815cdbd2fab$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $ff199815cdbd2fab$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $ff199815cdbd2fab$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $ff199815cdbd2fab$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $ff199815cdbd2fab$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $ff199815cdbd2fab$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $ff199815cdbd2fab$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $ff199815cdbd2fab$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $ff199815cdbd2fab$var$hasForceUpdate || null !== current && null !== current.dependencies && $ff199815cdbd2fab$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($ff199815cdbd2fab$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $ff199815cdbd2fab$var$hasForceUpdate || $ff199815cdbd2fab$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $ff199815cdbd2fab$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $ff199815cdbd2fab$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $ff199815cdbd2fab$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $ff199815cdbd2fab$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $ff199815cdbd2fab$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $ff199815cdbd2fab$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $ff199815cdbd2fab$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $ff199815cdbd2fab$var$resetHydrationState();
    workInProgress.flags |= 256;
    $ff199815cdbd2fab$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $ff199815cdbd2fab$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $ff199815cdbd2fab$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $ff199815cdbd2fab$var$getSuspendedCache()
    };
}
function $ff199815cdbd2fab$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $ff199815cdbd2fab$var$workInProgressDeferredLane);
    return current;
}
function $ff199815cdbd2fab$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($ff199815cdbd2fab$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($ff199815cdbd2fab$var$isHydrating) {
            showFallback ? $ff199815cdbd2fab$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $ff199815cdbd2fab$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($ff199815cdbd2fab$var$isHydrating) {
                var nextInstance = $ff199815cdbd2fab$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $ff199815cdbd2fab$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $ff199815cdbd2fab$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $ff199815cdbd2fab$var$treeContextProvider ? {
                            id: $ff199815cdbd2fab$var$treeContextId,
                            overflow: $ff199815cdbd2fab$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $ff199815cdbd2fab$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $ff199815cdbd2fab$var$hydrationParentFiber = workInProgress, $ff199815cdbd2fab$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $ff199815cdbd2fab$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $ff199815cdbd2fab$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $ff199815cdbd2fab$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $ff199815cdbd2fab$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $ff199815cdbd2fab$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $ff199815cdbd2fab$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $ff199815cdbd2fab$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $ff199815cdbd2fab$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $ff199815cdbd2fab$var$SUSPENDED_MARKER, nextProps;
        $ff199815cdbd2fab$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $ff199815cdbd2fab$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($ff199815cdbd2fab$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $ff199815cdbd2fab$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($ff199815cdbd2fab$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($ff199815cdbd2fab$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $ff199815cdbd2fab$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $ff199815cdbd2fab$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $ff199815cdbd2fab$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $ff199815cdbd2fab$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $ff199815cdbd2fab$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $ff199815cdbd2fab$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($ff199815cdbd2fab$var$pushPrimaryTreeSuspenseHandler(workInProgress), $ff199815cdbd2fab$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($ff199815cdbd2fab$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $ff199815cdbd2fab$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $ff199815cdbd2fab$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($ff199815cdbd2fab$var$didReceiveUpdate || $ff199815cdbd2fab$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $ff199815cdbd2fab$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $ff199815cdbd2fab$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $ff199815cdbd2fab$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $ff199815cdbd2fab$var$enqueueConcurrentRenderForLane(current, nextProps), $ff199815cdbd2fab$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $ff199815cdbd2fab$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $ff199815cdbd2fab$var$renderDidSuspendDelayIfPossible();
            workInProgress = $ff199815cdbd2fab$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $ff199815cdbd2fab$var$nextHydratableInstance = $ff199815cdbd2fab$var$getNextHydratable(nextInstance.nextSibling), $ff199815cdbd2fab$var$hydrationParentFiber = workInProgress, $ff199815cdbd2fab$var$isHydrating = !0, $ff199815cdbd2fab$var$hydrationErrors = null, $ff199815cdbd2fab$var$rootOrSingletonContext = !1, null !== current && ($ff199815cdbd2fab$var$idStack[$ff199815cdbd2fab$var$idStackIndex++] = $ff199815cdbd2fab$var$treeContextId, $ff199815cdbd2fab$var$idStack[$ff199815cdbd2fab$var$idStackIndex++] = $ff199815cdbd2fab$var$treeContextOverflow, $ff199815cdbd2fab$var$idStack[$ff199815cdbd2fab$var$idStackIndex++] = $ff199815cdbd2fab$var$treeContextProvider, $ff199815cdbd2fab$var$treeContextId = current.id, $ff199815cdbd2fab$var$treeContextOverflow = current.overflow, $ff199815cdbd2fab$var$treeContextProvider = workInProgress), workInProgress = $ff199815cdbd2fab$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $ff199815cdbd2fab$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $ff199815cdbd2fab$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $ff199815cdbd2fab$var$createWorkInProgress(digest, showFallback) : (showFallback = $ff199815cdbd2fab$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $ff199815cdbd2fab$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $ff199815cdbd2fab$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $ff199815cdbd2fab$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $ff199815cdbd2fab$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $ff199815cdbd2fab$var$SUSPENDED_MARKER, nextProps;
    $ff199815cdbd2fab$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $ff199815cdbd2fab$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $ff199815cdbd2fab$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $ff199815cdbd2fab$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $ff199815cdbd2fab$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $ff199815cdbd2fab$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $ff199815cdbd2fab$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $ff199815cdbd2fab$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $ff199815cdbd2fab$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $ff199815cdbd2fab$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $ff199815cdbd2fab$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $ff199815cdbd2fab$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $ff199815cdbd2fab$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $ff199815cdbd2fab$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $ff199815cdbd2fab$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $ff199815cdbd2fab$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $ff199815cdbd2fab$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $ff199815cdbd2fab$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $ff199815cdbd2fab$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $ff199815cdbd2fab$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $ff199815cdbd2fab$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $ff199815cdbd2fab$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $ff199815cdbd2fab$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $ff199815cdbd2fab$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($ff199815cdbd2fab$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $ff199815cdbd2fab$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $ff199815cdbd2fab$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $ff199815cdbd2fab$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $ff199815cdbd2fab$var$checkIfContextChanged(current) ? !0 : !1;
}
function $ff199815cdbd2fab$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $ff199815cdbd2fab$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $ff199815cdbd2fab$var$pushProvider(workInProgress, $ff199815cdbd2fab$var$CacheContext, current.memoizedState.cache);
            $ff199815cdbd2fab$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $ff199815cdbd2fab$var$pushHostContext(workInProgress);
            break;
        case 4:
            $ff199815cdbd2fab$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $ff199815cdbd2fab$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $ff199815cdbd2fab$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $ff199815cdbd2fab$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $ff199815cdbd2fab$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $ff199815cdbd2fab$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $ff199815cdbd2fab$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($ff199815cdbd2fab$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $ff199815cdbd2fab$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$suspenseStackCursor, $ff199815cdbd2fab$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $ff199815cdbd2fab$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $ff199815cdbd2fab$var$pushProvider(workInProgress, $ff199815cdbd2fab$var$CacheContext, current.memoizedState.cache);
    }
    return $ff199815cdbd2fab$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $ff199815cdbd2fab$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $ff199815cdbd2fab$var$didReceiveUpdate = !0;
        else {
            if (!$ff199815cdbd2fab$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $ff199815cdbd2fab$var$didReceiveUpdate = !1, $ff199815cdbd2fab$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $ff199815cdbd2fab$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $ff199815cdbd2fab$var$didReceiveUpdate = !1, $ff199815cdbd2fab$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $ff199815cdbd2fab$var$pushTreeId(workInProgress, $ff199815cdbd2fab$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $ff199815cdbd2fab$var$shouldConstruct(lazyComponent) ? (current = $ff199815cdbd2fab$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $ff199815cdbd2fab$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $ff199815cdbd2fab$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $ff199815cdbd2fab$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $ff199815cdbd2fab$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $ff199815cdbd2fab$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $ff199815cdbd2fab$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $ff199815cdbd2fab$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $ff199815cdbd2fab$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $ff199815cdbd2fab$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $ff199815cdbd2fab$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $ff199815cdbd2fab$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $ff199815cdbd2fab$var$cloneUpdateQueue(current, workInProgress);
                $ff199815cdbd2fab$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $ff199815cdbd2fab$var$pushProvider(workInProgress, $ff199815cdbd2fab$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $ff199815cdbd2fab$var$propagateContextChanges(workInProgress, [
                    $ff199815cdbd2fab$var$CacheContext
                ], renderLanes, !0);
                $ff199815cdbd2fab$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $ff199815cdbd2fab$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $ff199815cdbd2fab$var$createCapturedValueAtFiber(Error($ff199815cdbd2fab$var$formatProdErrorMessage(424)), workInProgress);
                        $ff199815cdbd2fab$var$queueHydrationError(init);
                        workInProgress = $ff199815cdbd2fab$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $ff199815cdbd2fab$var$nextHydratableInstance = $ff199815cdbd2fab$var$getNextHydratable(current.firstChild);
                        $ff199815cdbd2fab$var$hydrationParentFiber = workInProgress;
                        $ff199815cdbd2fab$var$isHydrating = !0;
                        $ff199815cdbd2fab$var$hydrationErrors = null;
                        $ff199815cdbd2fab$var$rootOrSingletonContext = !0;
                        renderLanes = $ff199815cdbd2fab$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $ff199815cdbd2fab$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $ff199815cdbd2fab$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $ff199815cdbd2fab$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $ff199815cdbd2fab$var$markRef(current, workInProgress), null === current ? (renderLanes = $ff199815cdbd2fab$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $ff199815cdbd2fab$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $ff199815cdbd2fab$var$getOwnerDocumentFromRootContainer($ff199815cdbd2fab$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$ff199815cdbd2fab$var$internalInstanceKey] = workInProgress, lazyComponent[$ff199815cdbd2fab$var$internalPropsKey] = current, $ff199815cdbd2fab$var$setInitialProperties(lazyComponent, renderLanes, current), $ff199815cdbd2fab$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $ff199815cdbd2fab$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $ff199815cdbd2fab$var$pushHostContext(workInProgress), null === current && $ff199815cdbd2fab$var$isHydrating && (lazyComponent = workInProgress.stateNode = $ff199815cdbd2fab$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $ff199815cdbd2fab$var$rootInstanceStackCursor.current), $ff199815cdbd2fab$var$hydrationParentFiber = workInProgress, $ff199815cdbd2fab$var$rootOrSingletonContext = !0, init = $ff199815cdbd2fab$var$nextHydratableInstance, $ff199815cdbd2fab$var$isSingletonScope(workInProgress.type) ? ($ff199815cdbd2fab$var$previousHydratableOnEnteringScopedSingleton = init, $ff199815cdbd2fab$var$nextHydratableInstance = $ff199815cdbd2fab$var$getNextHydratable(lazyComponent.firstChild)) : $ff199815cdbd2fab$var$nextHydratableInstance = init), $ff199815cdbd2fab$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $ff199815cdbd2fab$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $ff199815cdbd2fab$var$isHydrating) {
                if (init = lazyComponent = $ff199815cdbd2fab$var$nextHydratableInstance) lazyComponent = $ff199815cdbd2fab$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $ff199815cdbd2fab$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $ff199815cdbd2fab$var$hydrationParentFiber = workInProgress, $ff199815cdbd2fab$var$nextHydratableInstance = $ff199815cdbd2fab$var$getNextHydratable(lazyComponent.firstChild), $ff199815cdbd2fab$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $ff199815cdbd2fab$var$throwOnHydrationMismatch(workInProgress);
            }
            $ff199815cdbd2fab$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $ff199815cdbd2fab$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $ff199815cdbd2fab$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $ff199815cdbd2fab$var$renderWithHooks(current, workInProgress, $ff199815cdbd2fab$var$TransitionAwareHostComponent, null, null, renderLanes), $ff199815cdbd2fab$var$HostTransitionContext._currentValue = init);
            $ff199815cdbd2fab$var$markRef(current, workInProgress);
            $ff199815cdbd2fab$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $ff199815cdbd2fab$var$isHydrating) {
                if (current = renderLanes = $ff199815cdbd2fab$var$nextHydratableInstance) renderLanes = $ff199815cdbd2fab$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $ff199815cdbd2fab$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $ff199815cdbd2fab$var$hydrationParentFiber = workInProgress, $ff199815cdbd2fab$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $ff199815cdbd2fab$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $ff199815cdbd2fab$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $ff199815cdbd2fab$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $ff199815cdbd2fab$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $ff199815cdbd2fab$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $ff199815cdbd2fab$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $ff199815cdbd2fab$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $ff199815cdbd2fab$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $ff199815cdbd2fab$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $ff199815cdbd2fab$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $ff199815cdbd2fab$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $ff199815cdbd2fab$var$prepareToReadContext(workInProgress), init = $ff199815cdbd2fab$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $ff199815cdbd2fab$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $ff199815cdbd2fab$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $ff199815cdbd2fab$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $ff199815cdbd2fab$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $ff199815cdbd2fab$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $ff199815cdbd2fab$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $ff199815cdbd2fab$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $ff199815cdbd2fab$var$prepareToReadContext(workInProgress), lazyComponent = $ff199815cdbd2fab$var$readContext($ff199815cdbd2fab$var$CacheContext), null === current ? (init = $ff199815cdbd2fab$var$peekCacheFromPool(), null === init && (init = $ff199815cdbd2fab$var$workInProgressRoot, prevState = $ff199815cdbd2fab$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $ff199815cdbd2fab$var$initializeUpdateQueue(workInProgress), $ff199815cdbd2fab$var$pushProvider(workInProgress, $ff199815cdbd2fab$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($ff199815cdbd2fab$var$cloneUpdateQueue(current, workInProgress), $ff199815cdbd2fab$var$processUpdateQueue(workInProgress, null, null, renderLanes), $ff199815cdbd2fab$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $ff199815cdbd2fab$var$pushProvider(workInProgress, $ff199815cdbd2fab$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $ff199815cdbd2fab$var$pushProvider(workInProgress, $ff199815cdbd2fab$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $ff199815cdbd2fab$var$propagateContextChanges(workInProgress, [
                $ff199815cdbd2fab$var$CacheContext
            ], renderLanes, !0))), $ff199815cdbd2fab$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $ff199815cdbd2fab$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $ff199815cdbd2fab$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$ff199815cdbd2fab$var$preloadResource(resource)) {
        resource = $ff199815cdbd2fab$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($ff199815cdbd2fab$var$workInProgressRootRenderLanes & 4194048) === $ff199815cdbd2fab$var$workInProgressRootRenderLanes ? null !== $ff199815cdbd2fab$var$shellBoundary : ($ff199815cdbd2fab$var$workInProgressRootRenderLanes & 62914560) !== $ff199815cdbd2fab$var$workInProgressRootRenderLanes && 0 === ($ff199815cdbd2fab$var$workInProgressRootRenderLanes & 536870912) || resource !== $ff199815cdbd2fab$var$shellBoundary)) throw $ff199815cdbd2fab$var$suspendedThenable = $ff199815cdbd2fab$var$noopSuspenseyCommitThenable, $ff199815cdbd2fab$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $ff199815cdbd2fab$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $ff199815cdbd2fab$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $ff199815cdbd2fab$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $ff199815cdbd2fab$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$ff199815cdbd2fab$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $ff199815cdbd2fab$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $ff199815cdbd2fab$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $ff199815cdbd2fab$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $ff199815cdbd2fab$var$bubbleProperties(workInProgress), null;
        case 1:
            return $ff199815cdbd2fab$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $ff199815cdbd2fab$var$popProvider($ff199815cdbd2fab$var$CacheContext);
            $ff199815cdbd2fab$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $ff199815cdbd2fab$var$popHydrationState(workInProgress) ? $ff199815cdbd2fab$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $ff199815cdbd2fab$var$upgradeHydrationErrorsToRecoverable());
            $ff199815cdbd2fab$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($ff199815cdbd2fab$var$markUpdate(workInProgress), null !== renderLanes ? ($ff199815cdbd2fab$var$bubbleProperties(workInProgress), $ff199815cdbd2fab$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($ff199815cdbd2fab$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($ff199815cdbd2fab$var$markUpdate(workInProgress), $ff199815cdbd2fab$var$bubbleProperties(workInProgress), $ff199815cdbd2fab$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($ff199815cdbd2fab$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $ff199815cdbd2fab$var$markUpdate(workInProgress), $ff199815cdbd2fab$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $ff199815cdbd2fab$var$popHostContext(workInProgress);
            renderLanes = $ff199815cdbd2fab$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $ff199815cdbd2fab$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(166));
                    $ff199815cdbd2fab$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $ff199815cdbd2fab$var$contextStackCursor.current;
                $ff199815cdbd2fab$var$popHydrationState(workInProgress) ? $ff199815cdbd2fab$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $ff199815cdbd2fab$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $ff199815cdbd2fab$var$markUpdate(workInProgress));
            }
            $ff199815cdbd2fab$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $ff199815cdbd2fab$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $ff199815cdbd2fab$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(166));
                    $ff199815cdbd2fab$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $ff199815cdbd2fab$var$contextStackCursor.current;
                if ($ff199815cdbd2fab$var$popHydrationState(workInProgress)) $ff199815cdbd2fab$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $ff199815cdbd2fab$var$getOwnerDocumentFromRootContainer($ff199815cdbd2fab$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$ff199815cdbd2fab$var$internalInstanceKey] = workInProgress;
                    current[$ff199815cdbd2fab$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($ff199815cdbd2fab$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $ff199815cdbd2fab$var$markUpdate(workInProgress);
                }
            }
            $ff199815cdbd2fab$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $ff199815cdbd2fab$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(166));
                current = $ff199815cdbd2fab$var$rootInstanceStackCursor.current;
                if ($ff199815cdbd2fab$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $ff199815cdbd2fab$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$ff199815cdbd2fab$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $ff199815cdbd2fab$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $ff199815cdbd2fab$var$throwOnHydrationMismatch(workInProgress);
                } else current = $ff199815cdbd2fab$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$ff199815cdbd2fab$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $ff199815cdbd2fab$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $ff199815cdbd2fab$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(317));
                        type[$ff199815cdbd2fab$var$internalInstanceKey] = workInProgress;
                    } else $ff199815cdbd2fab$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $ff199815cdbd2fab$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $ff199815cdbd2fab$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $ff199815cdbd2fab$var$popSuspenseHandler(workInProgress), workInProgress;
                    $ff199815cdbd2fab$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $ff199815cdbd2fab$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $ff199815cdbd2fab$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $ff199815cdbd2fab$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $ff199815cdbd2fab$var$popHostContainer(), null === current && $ff199815cdbd2fab$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $ff199815cdbd2fab$var$bubbleProperties(workInProgress), null;
        case 10:
            return $ff199815cdbd2fab$var$popProvider(workInProgress.type), $ff199815cdbd2fab$var$bubbleProperties(workInProgress), null;
        case 19:
            $ff199815cdbd2fab$var$pop($ff199815cdbd2fab$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $ff199815cdbd2fab$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $ff199815cdbd2fab$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $ff199815cdbd2fab$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $ff199815cdbd2fab$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $ff199815cdbd2fab$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $ff199815cdbd2fab$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$ff199815cdbd2fab$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$suspenseStackCursor, $ff199815cdbd2fab$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $ff199815cdbd2fab$var$now() > $ff199815cdbd2fab$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $ff199815cdbd2fab$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $ff199815cdbd2fab$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $ff199815cdbd2fab$var$scheduleRetryEffect(workInProgress, current), $ff199815cdbd2fab$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$ff199815cdbd2fab$var$isHydrating) return $ff199815cdbd2fab$var$bubbleProperties(workInProgress), null;
                    } else 2 * $ff199815cdbd2fab$var$now() - type.renderingStartTime > $ff199815cdbd2fab$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $ff199815cdbd2fab$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $ff199815cdbd2fab$var$now(), workInProgress.sibling = null, current = $ff199815cdbd2fab$var$suspenseStackCursor.current, $ff199815cdbd2fab$var$push($ff199815cdbd2fab$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $ff199815cdbd2fab$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $ff199815cdbd2fab$var$popSuspenseHandler(workInProgress), $ff199815cdbd2fab$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($ff199815cdbd2fab$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $ff199815cdbd2fab$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $ff199815cdbd2fab$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $ff199815cdbd2fab$var$pop($ff199815cdbd2fab$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $ff199815cdbd2fab$var$popProvider($ff199815cdbd2fab$var$CacheContext), $ff199815cdbd2fab$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $ff199815cdbd2fab$var$unwindWork(current, workInProgress) {
    $ff199815cdbd2fab$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $ff199815cdbd2fab$var$popProvider($ff199815cdbd2fab$var$CacheContext), $ff199815cdbd2fab$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $ff199815cdbd2fab$var$popHostContext(workInProgress), null;
        case 13:
            $ff199815cdbd2fab$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(340));
                $ff199815cdbd2fab$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $ff199815cdbd2fab$var$pop($ff199815cdbd2fab$var$suspenseStackCursor), null;
        case 4:
            return $ff199815cdbd2fab$var$popHostContainer(), null;
        case 10:
            return $ff199815cdbd2fab$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $ff199815cdbd2fab$var$popSuspenseHandler(workInProgress), $ff199815cdbd2fab$var$popHiddenContext(), null !== current && $ff199815cdbd2fab$var$pop($ff199815cdbd2fab$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $ff199815cdbd2fab$var$popProvider($ff199815cdbd2fab$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $ff199815cdbd2fab$var$unwindInterruptedWork(current, interruptedWork) {
    $ff199815cdbd2fab$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $ff199815cdbd2fab$var$popProvider($ff199815cdbd2fab$var$CacheContext);
            $ff199815cdbd2fab$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $ff199815cdbd2fab$var$popHostContext(interruptedWork);
            break;
        case 4:
            $ff199815cdbd2fab$var$popHostContainer();
            break;
        case 13:
            $ff199815cdbd2fab$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $ff199815cdbd2fab$var$pop($ff199815cdbd2fab$var$suspenseStackCursor);
            break;
        case 10:
            $ff199815cdbd2fab$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $ff199815cdbd2fab$var$popSuspenseHandler(interruptedWork);
            $ff199815cdbd2fab$var$popHiddenContext();
            null !== current && $ff199815cdbd2fab$var$pop($ff199815cdbd2fab$var$resumedCache);
            break;
        case 24:
            $ff199815cdbd2fab$var$popProvider($ff199815cdbd2fab$var$CacheContext);
    }
}
function $ff199815cdbd2fab$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $ff199815cdbd2fab$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $ff199815cdbd2fab$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $ff199815cdbd2fab$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $ff199815cdbd2fab$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $ff199815cdbd2fab$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $ff199815cdbd2fab$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $ff199815cdbd2fab$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $ff199815cdbd2fab$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $ff199815cdbd2fab$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $ff199815cdbd2fab$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $ff199815cdbd2fab$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $ff199815cdbd2fab$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $ff199815cdbd2fab$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $ff199815cdbd2fab$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $ff199815cdbd2fab$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $ff199815cdbd2fab$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $ff199815cdbd2fab$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $ff199815cdbd2fab$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $ff199815cdbd2fab$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$ff199815cdbd2fab$var$internalPropsKey] = newProps;
    } catch (error) {
        $ff199815cdbd2fab$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $ff199815cdbd2fab$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $ff199815cdbd2fab$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $ff199815cdbd2fab$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $ff199815cdbd2fab$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $ff199815cdbd2fab$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $ff199815cdbd2fab$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $ff199815cdbd2fab$var$noop$1));
    else if (4 !== tag && (27 === tag && $ff199815cdbd2fab$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($ff199815cdbd2fab$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$ff199815cdbd2fab$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $ff199815cdbd2fab$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $ff199815cdbd2fab$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($ff199815cdbd2fab$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$ff199815cdbd2fab$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $ff199815cdbd2fab$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $ff199815cdbd2fab$var$setInitialProperties(singleton, type, props);
        singleton[$ff199815cdbd2fab$var$internalInstanceKey] = finishedWork;
        singleton[$ff199815cdbd2fab$var$internalPropsKey] = props;
    } catch (error) {
        $ff199815cdbd2fab$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $ff199815cdbd2fab$var$offscreenSubtreeIsHidden = !1, $ff199815cdbd2fab$var$offscreenSubtreeWasHidden = !1, $ff199815cdbd2fab$var$needsFormReset = !1, $ff199815cdbd2fab$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $ff199815cdbd2fab$var$nextEffect = null;
function $ff199815cdbd2fab$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $ff199815cdbd2fab$var$eventsEnabled = $ff199815cdbd2fab$var$_enabled;
    root = $ff199815cdbd2fab$var$getActiveElementDeep(root);
    if ($ff199815cdbd2fab$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $ff199815cdbd2fab$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $ff199815cdbd2fab$var$_enabled = !1;
    for($ff199815cdbd2fab$var$nextEffect = firstChild; null !== $ff199815cdbd2fab$var$nextEffect;)if (firstChild = $ff199815cdbd2fab$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $ff199815cdbd2fab$var$nextEffect = root;
    else for(; null !== $ff199815cdbd2fab$var$nextEffect;){
        firstChild = $ff199815cdbd2fab$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $ff199815cdbd2fab$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $ff199815cdbd2fab$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $ff199815cdbd2fab$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $ff199815cdbd2fab$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $ff199815cdbd2fab$var$nextEffect = root;
            break;
        }
        $ff199815cdbd2fab$var$nextEffect = firstChild.return;
    }
}
function $ff199815cdbd2fab$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $ff199815cdbd2fab$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $ff199815cdbd2fab$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $ff199815cdbd2fab$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $ff199815cdbd2fab$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $ff199815cdbd2fab$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $ff199815cdbd2fab$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $ff199815cdbd2fab$var$commitClassCallbacks(finishedWork);
            flags & 512 && $ff199815cdbd2fab$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $ff199815cdbd2fab$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $ff199815cdbd2fab$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $ff199815cdbd2fab$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $ff199815cdbd2fab$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $ff199815cdbd2fab$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $ff199815cdbd2fab$var$commitHostMount(finishedWork);
            flags & 512 && $ff199815cdbd2fab$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $ff199815cdbd2fab$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $ff199815cdbd2fab$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $ff199815cdbd2fab$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $ff199815cdbd2fab$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $ff199815cdbd2fab$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $ff199815cdbd2fab$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $ff199815cdbd2fab$var$offscreenSubtreeWasHidden;
                prevProps = $ff199815cdbd2fab$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $ff199815cdbd2fab$var$offscreenSubtreeWasHidden;
                $ff199815cdbd2fab$var$offscreenSubtreeIsHidden = flags;
                ($ff199815cdbd2fab$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $ff199815cdbd2fab$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $ff199815cdbd2fab$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $ff199815cdbd2fab$var$offscreenSubtreeIsHidden = prevProps;
                $ff199815cdbd2fab$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $ff199815cdbd2fab$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $ff199815cdbd2fab$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $ff199815cdbd2fab$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $ff199815cdbd2fab$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $ff199815cdbd2fab$var$hostParent = null, $ff199815cdbd2fab$var$hostParentIsContainer = !1;
function $ff199815cdbd2fab$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$ff199815cdbd2fab$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $ff199815cdbd2fab$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($ff199815cdbd2fab$var$injectedHook && "function" === typeof $ff199815cdbd2fab$var$injectedHook.onCommitFiberUnmount) try {
        $ff199815cdbd2fab$var$injectedHook.onCommitFiberUnmount($ff199815cdbd2fab$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $ff199815cdbd2fab$var$offscreenSubtreeWasHidden || $ff199815cdbd2fab$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $ff199815cdbd2fab$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $ff199815cdbd2fab$var$offscreenSubtreeWasHidden || $ff199815cdbd2fab$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $ff199815cdbd2fab$var$hostParent, prevHostParentIsContainer = $ff199815cdbd2fab$var$hostParentIsContainer;
            $ff199815cdbd2fab$var$isSingletonScope(deletedFiber.type) && ($ff199815cdbd2fab$var$hostParent = deletedFiber.stateNode, $ff199815cdbd2fab$var$hostParentIsContainer = !1);
            $ff199815cdbd2fab$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $ff199815cdbd2fab$var$releaseSingletonInstance(deletedFiber.stateNode);
            $ff199815cdbd2fab$var$hostParent = prevHostParent;
            $ff199815cdbd2fab$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $ff199815cdbd2fab$var$offscreenSubtreeWasHidden || $ff199815cdbd2fab$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $ff199815cdbd2fab$var$hostParent;
            prevHostParentIsContainer = $ff199815cdbd2fab$var$hostParentIsContainer;
            $ff199815cdbd2fab$var$hostParent = null;
            $ff199815cdbd2fab$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $ff199815cdbd2fab$var$hostParent = prevHostParent;
            $ff199815cdbd2fab$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $ff199815cdbd2fab$var$hostParent) {
                if ($ff199815cdbd2fab$var$hostParentIsContainer) try {
                    (9 === $ff199815cdbd2fab$var$hostParent.nodeType ? $ff199815cdbd2fab$var$hostParent.body : "HTML" === $ff199815cdbd2fab$var$hostParent.nodeName ? $ff199815cdbd2fab$var$hostParent.ownerDocument.body : $ff199815cdbd2fab$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $ff199815cdbd2fab$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $ff199815cdbd2fab$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $ff199815cdbd2fab$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $ff199815cdbd2fab$var$hostParent && ($ff199815cdbd2fab$var$hostParentIsContainer ? (finishedRoot = $ff199815cdbd2fab$var$hostParent, $ff199815cdbd2fab$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $ff199815cdbd2fab$var$retryIfBlockedOn(finishedRoot)) : $ff199815cdbd2fab$var$clearSuspenseBoundary($ff199815cdbd2fab$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $ff199815cdbd2fab$var$hostParent;
            prevHostParentIsContainer = $ff199815cdbd2fab$var$hostParentIsContainer;
            $ff199815cdbd2fab$var$hostParent = deletedFiber.stateNode.containerInfo;
            $ff199815cdbd2fab$var$hostParentIsContainer = !0;
            $ff199815cdbd2fab$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $ff199815cdbd2fab$var$hostParent = prevHostParent;
            $ff199815cdbd2fab$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $ff199815cdbd2fab$var$offscreenSubtreeWasHidden || $ff199815cdbd2fab$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $ff199815cdbd2fab$var$offscreenSubtreeWasHidden || $ff199815cdbd2fab$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $ff199815cdbd2fab$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $ff199815cdbd2fab$var$offscreenSubtreeWasHidden || ($ff199815cdbd2fab$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $ff199815cdbd2fab$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $ff199815cdbd2fab$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $ff199815cdbd2fab$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $ff199815cdbd2fab$var$offscreenSubtreeWasHidden = (prevHostParent = $ff199815cdbd2fab$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $ff199815cdbd2fab$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $ff199815cdbd2fab$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $ff199815cdbd2fab$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $ff199815cdbd2fab$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $ff199815cdbd2fab$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $ff199815cdbd2fab$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $ff199815cdbd2fab$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $ff199815cdbd2fab$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $ff199815cdbd2fab$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $ff199815cdbd2fab$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $ff199815cdbd2fab$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $ff199815cdbd2fab$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $ff199815cdbd2fab$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($ff199815cdbd2fab$var$isSingletonScope(parent.type)) {
                        $ff199815cdbd2fab$var$hostParent = parent.stateNode;
                        $ff199815cdbd2fab$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $ff199815cdbd2fab$var$hostParent = parent.stateNode;
                    $ff199815cdbd2fab$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $ff199815cdbd2fab$var$hostParent = parent.stateNode.containerInfo;
                    $ff199815cdbd2fab$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $ff199815cdbd2fab$var$hostParent) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(160));
        $ff199815cdbd2fab$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $ff199815cdbd2fab$var$hostParent = null;
        $ff199815cdbd2fab$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$ff199815cdbd2fab$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $ff199815cdbd2fab$var$currentHoistableRoot = null;
function $ff199815cdbd2fab$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $ff199815cdbd2fab$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $ff199815cdbd2fab$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($ff199815cdbd2fab$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $ff199815cdbd2fab$var$commitHookEffectListMount(3, finishedWork), $ff199815cdbd2fab$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $ff199815cdbd2fab$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $ff199815cdbd2fab$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($ff199815cdbd2fab$var$offscreenSubtreeWasHidden || null === current || $ff199815cdbd2fab$var$safelyDetachRef(current, current.return));
            flags & 64 && $ff199815cdbd2fab$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $ff199815cdbd2fab$var$currentHoistableRoot;
            $ff199815cdbd2fab$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $ff199815cdbd2fab$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($ff199815cdbd2fab$var$offscreenSubtreeWasHidden || null === current || $ff199815cdbd2fab$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$ff199815cdbd2fab$var$internalHoistableMarker] || currentResource[$ff199815cdbd2fab$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $ff199815cdbd2fab$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$ff199815cdbd2fab$var$internalInstanceKey] = finishedWork;
                                        $ff199815cdbd2fab$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $ff199815cdbd2fab$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $ff199815cdbd2fab$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $ff199815cdbd2fab$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $ff199815cdbd2fab$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$ff199815cdbd2fab$var$internalInstanceKey] = finishedWork;
                                $ff199815cdbd2fab$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $ff199815cdbd2fab$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $ff199815cdbd2fab$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $ff199815cdbd2fab$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $ff199815cdbd2fab$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $ff199815cdbd2fab$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $ff199815cdbd2fab$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $ff199815cdbd2fab$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($ff199815cdbd2fab$var$offscreenSubtreeWasHidden || null === current || $ff199815cdbd2fab$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $ff199815cdbd2fab$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $ff199815cdbd2fab$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $ff199815cdbd2fab$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($ff199815cdbd2fab$var$offscreenSubtreeWasHidden || null === current || $ff199815cdbd2fab$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $ff199815cdbd2fab$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $ff199815cdbd2fab$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $ff199815cdbd2fab$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($ff199815cdbd2fab$var$needsFormReset = !0);
            break;
        case 6:
            $ff199815cdbd2fab$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $ff199815cdbd2fab$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $ff199815cdbd2fab$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $ff199815cdbd2fab$var$tagCaches = null;
            hoistableRoot = $ff199815cdbd2fab$var$currentHoistableRoot;
            $ff199815cdbd2fab$var$currentHoistableRoot = $ff199815cdbd2fab$var$getHoistableRoot(root.containerInfo);
            $ff199815cdbd2fab$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $ff199815cdbd2fab$var$currentHoistableRoot = hoistableRoot;
            $ff199815cdbd2fab$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $ff199815cdbd2fab$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $ff199815cdbd2fab$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $ff199815cdbd2fab$var$needsFormReset && ($ff199815cdbd2fab$var$needsFormReset = !1, $ff199815cdbd2fab$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $ff199815cdbd2fab$var$currentHoistableRoot;
            $ff199815cdbd2fab$var$currentHoistableRoot = $ff199815cdbd2fab$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $ff199815cdbd2fab$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $ff199815cdbd2fab$var$commitReconciliationEffects(finishedWork);
            $ff199815cdbd2fab$var$currentHoistableRoot = flags;
            break;
        case 12:
            $ff199815cdbd2fab$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $ff199815cdbd2fab$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $ff199815cdbd2fab$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $ff199815cdbd2fab$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($ff199815cdbd2fab$var$globalMostRecentFallbackTime = $ff199815cdbd2fab$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $ff199815cdbd2fab$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $ff199815cdbd2fab$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $ff199815cdbd2fab$var$offscreenSubtreeWasHidden;
            $ff199815cdbd2fab$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $ff199815cdbd2fab$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $ff199815cdbd2fab$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $ff199815cdbd2fab$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $ff199815cdbd2fab$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $ff199815cdbd2fab$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $ff199815cdbd2fab$var$offscreenSubtreeIsHidden || $ff199815cdbd2fab$var$offscreenSubtreeWasHidden || $ff199815cdbd2fab$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $ff199815cdbd2fab$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $ff199815cdbd2fab$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $ff199815cdbd2fab$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $ff199815cdbd2fab$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $ff199815cdbd2fab$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $ff199815cdbd2fab$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $ff199815cdbd2fab$var$recursivelyTraverseMutationEffects(root, finishedWork), $ff199815cdbd2fab$var$commitReconciliationEffects(finishedWork);
    }
}
function $ff199815cdbd2fab$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($ff199815cdbd2fab$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $ff199815cdbd2fab$var$getHostSibling(finishedWork);
                    $ff199815cdbd2fab$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($ff199815cdbd2fab$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $ff199815cdbd2fab$var$getHostSibling(finishedWork);
                    $ff199815cdbd2fab$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $ff199815cdbd2fab$var$getHostSibling(finishedWork);
                    $ff199815cdbd2fab$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $ff199815cdbd2fab$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $ff199815cdbd2fab$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $ff199815cdbd2fab$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $ff199815cdbd2fab$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$ff199815cdbd2fab$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $ff199815cdbd2fab$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $ff199815cdbd2fab$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $ff199815cdbd2fab$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $ff199815cdbd2fab$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $ff199815cdbd2fab$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $ff199815cdbd2fab$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $ff199815cdbd2fab$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $ff199815cdbd2fab$var$safelyDetachRef(finishedWork, finishedWork.return);
                $ff199815cdbd2fab$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $ff199815cdbd2fab$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $ff199815cdbd2fab$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $ff199815cdbd2fab$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $ff199815cdbd2fab$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $ff199815cdbd2fab$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $ff199815cdbd2fab$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $ff199815cdbd2fab$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $ff199815cdbd2fab$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$ff199815cdbd2fab$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $ff199815cdbd2fab$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $ff199815cdbd2fab$var$commitClassCallbacks(finishedWork);
                $ff199815cdbd2fab$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $ff199815cdbd2fab$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $ff199815cdbd2fab$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $ff199815cdbd2fab$var$commitHostMount(finishedWork);
                $ff199815cdbd2fab$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $ff199815cdbd2fab$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $ff199815cdbd2fab$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $ff199815cdbd2fab$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $ff199815cdbd2fab$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $ff199815cdbd2fab$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $ff199815cdbd2fab$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $ff199815cdbd2fab$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $ff199815cdbd2fab$var$releaseCache(previousCache));
}
function $ff199815cdbd2fab$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $ff199815cdbd2fab$var$releaseCache(current));
}
function $ff199815cdbd2fab$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$ff199815cdbd2fab$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $ff199815cdbd2fab$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $ff199815cdbd2fab$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $ff199815cdbd2fab$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $ff199815cdbd2fab$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $ff199815cdbd2fab$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $ff199815cdbd2fab$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $ff199815cdbd2fab$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $ff199815cdbd2fab$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $ff199815cdbd2fab$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $ff199815cdbd2fab$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $ff199815cdbd2fab$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $ff199815cdbd2fab$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $ff199815cdbd2fab$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $ff199815cdbd2fab$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $ff199815cdbd2fab$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $ff199815cdbd2fab$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $ff199815cdbd2fab$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $ff199815cdbd2fab$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $ff199815cdbd2fab$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $ff199815cdbd2fab$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $ff199815cdbd2fab$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $ff199815cdbd2fab$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $ff199815cdbd2fab$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $ff199815cdbd2fab$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $ff199815cdbd2fab$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $ff199815cdbd2fab$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $ff199815cdbd2fab$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $ff199815cdbd2fab$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $ff199815cdbd2fab$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $ff199815cdbd2fab$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $ff199815cdbd2fab$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $ff199815cdbd2fab$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $ff199815cdbd2fab$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $ff199815cdbd2fab$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $ff199815cdbd2fab$var$suspenseyCommitFlag = 8192;
function $ff199815cdbd2fab$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $ff199815cdbd2fab$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$ff199815cdbd2fab$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $ff199815cdbd2fab$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $ff199815cdbd2fab$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $ff199815cdbd2fab$var$suspenseyCommitFlag && null !== fiber.memoizedState && $ff199815cdbd2fab$var$suspendResource($ff199815cdbd2fab$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $ff199815cdbd2fab$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $ff199815cdbd2fab$var$currentHoistableRoot;
            $ff199815cdbd2fab$var$currentHoistableRoot = $ff199815cdbd2fab$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $ff199815cdbd2fab$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $ff199815cdbd2fab$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $ff199815cdbd2fab$var$suspenseyCommitFlag, $ff199815cdbd2fab$var$suspenseyCommitFlag = 16777216, $ff199815cdbd2fab$var$recursivelyAccumulateSuspenseyCommit(fiber), $ff199815cdbd2fab$var$suspenseyCommitFlag = previousHoistableRoot) : $ff199815cdbd2fab$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $ff199815cdbd2fab$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $ff199815cdbd2fab$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $ff199815cdbd2fab$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $ff199815cdbd2fab$var$nextEffect = childToDelete;
            $ff199815cdbd2fab$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $ff199815cdbd2fab$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$ff199815cdbd2fab$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $ff199815cdbd2fab$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $ff199815cdbd2fab$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $ff199815cdbd2fab$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $ff199815cdbd2fab$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $ff199815cdbd2fab$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $ff199815cdbd2fab$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $ff199815cdbd2fab$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $ff199815cdbd2fab$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $ff199815cdbd2fab$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $ff199815cdbd2fab$var$nextEffect = childToDelete;
            $ff199815cdbd2fab$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $ff199815cdbd2fab$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $ff199815cdbd2fab$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $ff199815cdbd2fab$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $ff199815cdbd2fab$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $ff199815cdbd2fab$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $ff199815cdbd2fab$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $ff199815cdbd2fab$var$nextEffect;){
        var fiber = $ff199815cdbd2fab$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $ff199815cdbd2fab$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $ff199815cdbd2fab$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $ff199815cdbd2fab$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $ff199815cdbd2fab$var$nextEffect;){
            cache = $ff199815cdbd2fab$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $ff199815cdbd2fab$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $ff199815cdbd2fab$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $ff199815cdbd2fab$var$nextEffect = sibling;
                break a;
            }
            $ff199815cdbd2fab$var$nextEffect = returnFiber;
        }
    }
}
var $ff199815cdbd2fab$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $ff199815cdbd2fab$var$readContext($ff199815cdbd2fab$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $ff199815cdbd2fab$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $ff199815cdbd2fab$var$executionContext = 0, $ff199815cdbd2fab$var$workInProgressRoot = null, $ff199815cdbd2fab$var$workInProgress = null, $ff199815cdbd2fab$var$workInProgressRootRenderLanes = 0, $ff199815cdbd2fab$var$workInProgressSuspendedReason = 0, $ff199815cdbd2fab$var$workInProgressThrownValue = null, $ff199815cdbd2fab$var$workInProgressRootDidSkipSuspendedSiblings = !1, $ff199815cdbd2fab$var$workInProgressRootIsPrerendering = !1, $ff199815cdbd2fab$var$workInProgressRootDidAttachPingListener = !1, $ff199815cdbd2fab$var$entangledRenderLanes = 0, $ff199815cdbd2fab$var$workInProgressRootExitStatus = 0, $ff199815cdbd2fab$var$workInProgressRootSkippedLanes = 0, $ff199815cdbd2fab$var$workInProgressRootInterleavedUpdatedLanes = 0, $ff199815cdbd2fab$var$workInProgressRootPingedLanes = 0, $ff199815cdbd2fab$var$workInProgressDeferredLane = 0, $ff199815cdbd2fab$var$workInProgressSuspendedRetryLanes = 0, $ff199815cdbd2fab$var$workInProgressRootConcurrentErrors = null, $ff199815cdbd2fab$var$workInProgressRootRecoverableErrors = null, $ff199815cdbd2fab$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $ff199815cdbd2fab$var$globalMostRecentFallbackTime = 0, $ff199815cdbd2fab$var$workInProgressRootRenderTargetTime = Infinity, $ff199815cdbd2fab$var$workInProgressTransitions = null, $ff199815cdbd2fab$var$legacyErrorBoundariesThatAlreadyFailed = null, $ff199815cdbd2fab$var$pendingEffectsStatus = 0, $ff199815cdbd2fab$var$pendingEffectsRoot = null, $ff199815cdbd2fab$var$pendingFinishedWork = null, $ff199815cdbd2fab$var$pendingEffectsLanes = 0, $ff199815cdbd2fab$var$pendingEffectsRemainingLanes = 0, $ff199815cdbd2fab$var$pendingPassiveTransitions = null, $ff199815cdbd2fab$var$pendingRecoverableErrors = null, $ff199815cdbd2fab$var$nestedUpdateCount = 0, $ff199815cdbd2fab$var$rootWithNestedUpdates = null;
function $ff199815cdbd2fab$var$requestUpdateLane() {
    if (0 !== ($ff199815cdbd2fab$var$executionContext & 2) && 0 !== $ff199815cdbd2fab$var$workInProgressRootRenderLanes) return $ff199815cdbd2fab$var$workInProgressRootRenderLanes & -$ff199815cdbd2fab$var$workInProgressRootRenderLanes;
    if (null !== $ff199815cdbd2fab$var$ReactSharedInternals.T) {
        var actionScopeLane = $ff199815cdbd2fab$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $ff199815cdbd2fab$var$requestTransitionLane();
    }
    return $ff199815cdbd2fab$var$resolveUpdatePriority();
}
function $ff199815cdbd2fab$var$requestDeferredLane() {
    0 === $ff199815cdbd2fab$var$workInProgressDeferredLane && ($ff199815cdbd2fab$var$workInProgressDeferredLane = 0 === ($ff199815cdbd2fab$var$workInProgressRootRenderLanes & 536870912) || $ff199815cdbd2fab$var$isHydrating ? $ff199815cdbd2fab$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $ff199815cdbd2fab$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $ff199815cdbd2fab$var$workInProgressDeferredLane;
}
function $ff199815cdbd2fab$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $ff199815cdbd2fab$var$workInProgressRoot && (2 === $ff199815cdbd2fab$var$workInProgressSuspendedReason || 9 === $ff199815cdbd2fab$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $ff199815cdbd2fab$var$prepareFreshStack(root, 0), $ff199815cdbd2fab$var$markRootSuspended(root, $ff199815cdbd2fab$var$workInProgressRootRenderLanes, $ff199815cdbd2fab$var$workInProgressDeferredLane, !1);
    $ff199815cdbd2fab$var$markRootUpdated$1(root, lane);
    if (0 === ($ff199815cdbd2fab$var$executionContext & 2) || root !== $ff199815cdbd2fab$var$workInProgressRoot) root === $ff199815cdbd2fab$var$workInProgressRoot && (0 === ($ff199815cdbd2fab$var$executionContext & 2) && ($ff199815cdbd2fab$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $ff199815cdbd2fab$var$workInProgressRootExitStatus && $ff199815cdbd2fab$var$markRootSuspended(root, $ff199815cdbd2fab$var$workInProgressRootRenderLanes, $ff199815cdbd2fab$var$workInProgressDeferredLane, !1)), $ff199815cdbd2fab$var$ensureRootIsScheduled(root);
}
function $ff199815cdbd2fab$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($ff199815cdbd2fab$var$executionContext & 6)) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $ff199815cdbd2fab$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $ff199815cdbd2fab$var$renderRootConcurrent(root$jscomp$0, lanes) : $ff199815cdbd2fab$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $ff199815cdbd2fab$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $ff199815cdbd2fab$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$ff199815cdbd2fab$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $ff199815cdbd2fab$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $ff199815cdbd2fab$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($ff199815cdbd2fab$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $ff199815cdbd2fab$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($ff199815cdbd2fab$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $ff199815cdbd2fab$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $ff199815cdbd2fab$var$workInProgressRootRecoverableErrors;
                            $ff199815cdbd2fab$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $ff199815cdbd2fab$var$workInProgressRootRecoverableErrors ? $ff199815cdbd2fab$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $ff199815cdbd2fab$var$workInProgressRootRecoverableErrors.push.apply($ff199815cdbd2fab$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $ff199815cdbd2fab$var$prepareFreshStack(root$jscomp$0, 0);
                $ff199815cdbd2fab$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $ff199815cdbd2fab$var$markRootSuspended(shouldTimeSlice, lanes, $ff199815cdbd2fab$var$workInProgressDeferredLane, !$ff199815cdbd2fab$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $ff199815cdbd2fab$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $ff199815cdbd2fab$var$globalMostRecentFallbackTime + 300 - $ff199815cdbd2fab$var$now(), 10 < exitStatus)) {
                    $ff199815cdbd2fab$var$markRootSuspended(shouldTimeSlice, lanes, $ff199815cdbd2fab$var$workInProgressDeferredLane, !$ff199815cdbd2fab$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $ff199815cdbd2fab$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $ff199815cdbd2fab$var$scheduleTimeout($ff199815cdbd2fab$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $ff199815cdbd2fab$var$workInProgressRootRecoverableErrors, $ff199815cdbd2fab$var$workInProgressTransitions, $ff199815cdbd2fab$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $ff199815cdbd2fab$var$workInProgressDeferredLane, $ff199815cdbd2fab$var$workInProgressRootInterleavedUpdatedLanes, $ff199815cdbd2fab$var$workInProgressSuspendedRetryLanes, $ff199815cdbd2fab$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $ff199815cdbd2fab$var$commitRootWhenReady(shouldTimeSlice, forceSync, $ff199815cdbd2fab$var$workInProgressRootRecoverableErrors, $ff199815cdbd2fab$var$workInProgressTransitions, $ff199815cdbd2fab$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $ff199815cdbd2fab$var$workInProgressDeferredLane, $ff199815cdbd2fab$var$workInProgressRootInterleavedUpdatedLanes, $ff199815cdbd2fab$var$workInProgressSuspendedRetryLanes, $ff199815cdbd2fab$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $ff199815cdbd2fab$var$ensureRootIsScheduled(root$jscomp$0);
}
function $ff199815cdbd2fab$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($ff199815cdbd2fab$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $ff199815cdbd2fab$var$noop
        }, $ff199815cdbd2fab$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $ff199815cdbd2fab$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($ff199815cdbd2fab$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $ff199815cdbd2fab$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $ff199815cdbd2fab$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $ff199815cdbd2fab$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$ff199815cdbd2fab$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $ff199815cdbd2fab$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$ff199815cdbd2fab$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$ff199815cdbd2fab$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $ff199815cdbd2fab$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $ff199815cdbd2fab$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $ff199815cdbd2fab$var$flushSyncWork$1() {
    return 0 === ($ff199815cdbd2fab$var$executionContext & 6) ? ($ff199815cdbd2fab$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $ff199815cdbd2fab$var$resetWorkInProgressStack() {
    if (null !== $ff199815cdbd2fab$var$workInProgress) {
        if (0 === $ff199815cdbd2fab$var$workInProgressSuspendedReason) var interruptedWork = $ff199815cdbd2fab$var$workInProgress.return;
        else interruptedWork = $ff199815cdbd2fab$var$workInProgress, $ff199815cdbd2fab$var$lastContextDependency = $ff199815cdbd2fab$var$currentlyRenderingFiber$1 = null, $ff199815cdbd2fab$var$resetHooksOnUnwind(interruptedWork), $ff199815cdbd2fab$var$thenableState = null, $ff199815cdbd2fab$var$thenableIndexCounter = 0, interruptedWork = $ff199815cdbd2fab$var$workInProgress;
        for(; null !== interruptedWork;)$ff199815cdbd2fab$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $ff199815cdbd2fab$var$workInProgress = null;
    }
}
function $ff199815cdbd2fab$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $ff199815cdbd2fab$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $ff199815cdbd2fab$var$resetWorkInProgressStack();
    $ff199815cdbd2fab$var$workInProgressRoot = root;
    $ff199815cdbd2fab$var$workInProgress = timeoutHandle = $ff199815cdbd2fab$var$createWorkInProgress(root.current, null);
    $ff199815cdbd2fab$var$workInProgressRootRenderLanes = lanes;
    $ff199815cdbd2fab$var$workInProgressSuspendedReason = 0;
    $ff199815cdbd2fab$var$workInProgressThrownValue = null;
    $ff199815cdbd2fab$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $ff199815cdbd2fab$var$workInProgressRootIsPrerendering = $ff199815cdbd2fab$var$checkIfRootIsPrerendering(root, lanes);
    $ff199815cdbd2fab$var$workInProgressRootDidAttachPingListener = !1;
    $ff199815cdbd2fab$var$workInProgressSuspendedRetryLanes = $ff199815cdbd2fab$var$workInProgressDeferredLane = $ff199815cdbd2fab$var$workInProgressRootPingedLanes = $ff199815cdbd2fab$var$workInProgressRootInterleavedUpdatedLanes = $ff199815cdbd2fab$var$workInProgressRootSkippedLanes = $ff199815cdbd2fab$var$workInProgressRootExitStatus = 0;
    $ff199815cdbd2fab$var$workInProgressRootRecoverableErrors = $ff199815cdbd2fab$var$workInProgressRootConcurrentErrors = null;
    $ff199815cdbd2fab$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $ff199815cdbd2fab$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $ff199815cdbd2fab$var$entangledRenderLanes = lanes;
    $ff199815cdbd2fab$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $ff199815cdbd2fab$var$handleThrow(root, thrownValue) {
    $ff199815cdbd2fab$var$currentlyRenderingFiber = null;
    $ff199815cdbd2fab$var$ReactSharedInternals.H = $ff199815cdbd2fab$var$ContextOnlyDispatcher;
    thrownValue === $ff199815cdbd2fab$var$SuspenseException || thrownValue === $ff199815cdbd2fab$var$SuspenseActionException ? (thrownValue = $ff199815cdbd2fab$var$getSuspendedThenable(), $ff199815cdbd2fab$var$workInProgressSuspendedReason = 3) : thrownValue === $ff199815cdbd2fab$var$SuspenseyCommitException ? (thrownValue = $ff199815cdbd2fab$var$getSuspendedThenable(), $ff199815cdbd2fab$var$workInProgressSuspendedReason = 4) : $ff199815cdbd2fab$var$workInProgressSuspendedReason = thrownValue === $ff199815cdbd2fab$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $ff199815cdbd2fab$var$workInProgressThrownValue = thrownValue;
    null === $ff199815cdbd2fab$var$workInProgress && ($ff199815cdbd2fab$var$workInProgressRootExitStatus = 1, $ff199815cdbd2fab$var$logUncaughtError(root, $ff199815cdbd2fab$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $ff199815cdbd2fab$var$pushDispatcher() {
    var prevDispatcher = $ff199815cdbd2fab$var$ReactSharedInternals.H;
    $ff199815cdbd2fab$var$ReactSharedInternals.H = $ff199815cdbd2fab$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $ff199815cdbd2fab$var$ContextOnlyDispatcher : prevDispatcher;
}
function $ff199815cdbd2fab$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $ff199815cdbd2fab$var$ReactSharedInternals.A;
    $ff199815cdbd2fab$var$ReactSharedInternals.A = $ff199815cdbd2fab$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $ff199815cdbd2fab$var$renderDidSuspendDelayIfPossible() {
    $ff199815cdbd2fab$var$workInProgressRootExitStatus = 4;
    $ff199815cdbd2fab$var$workInProgressRootDidSkipSuspendedSiblings || ($ff199815cdbd2fab$var$workInProgressRootRenderLanes & 4194048) !== $ff199815cdbd2fab$var$workInProgressRootRenderLanes && null !== $ff199815cdbd2fab$var$suspenseHandlerStackCursor.current || ($ff199815cdbd2fab$var$workInProgressRootIsPrerendering = !0);
    0 === ($ff199815cdbd2fab$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($ff199815cdbd2fab$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $ff199815cdbd2fab$var$workInProgressRoot || $ff199815cdbd2fab$var$markRootSuspended($ff199815cdbd2fab$var$workInProgressRoot, $ff199815cdbd2fab$var$workInProgressRootRenderLanes, $ff199815cdbd2fab$var$workInProgressDeferredLane, !1);
}
function $ff199815cdbd2fab$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $ff199815cdbd2fab$var$executionContext;
    $ff199815cdbd2fab$var$executionContext |= 2;
    var prevDispatcher = $ff199815cdbd2fab$var$pushDispatcher(), prevAsyncDispatcher = $ff199815cdbd2fab$var$pushAsyncDispatcher();
    if ($ff199815cdbd2fab$var$workInProgressRoot !== root || $ff199815cdbd2fab$var$workInProgressRootRenderLanes !== lanes) $ff199815cdbd2fab$var$workInProgressTransitions = null, $ff199815cdbd2fab$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $ff199815cdbd2fab$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $ff199815cdbd2fab$var$workInProgressSuspendedReason && null !== $ff199815cdbd2fab$var$workInProgress) {
            var unitOfWork = $ff199815cdbd2fab$var$workInProgress, thrownValue = $ff199815cdbd2fab$var$workInProgressThrownValue;
            switch($ff199815cdbd2fab$var$workInProgressSuspendedReason){
                case 8:
                    $ff199815cdbd2fab$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $ff199815cdbd2fab$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $ff199815cdbd2fab$var$workInProgressSuspendedReason;
                    $ff199815cdbd2fab$var$workInProgressSuspendedReason = 0;
                    $ff199815cdbd2fab$var$workInProgressThrownValue = null;
                    $ff199815cdbd2fab$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $ff199815cdbd2fab$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $ff199815cdbd2fab$var$workInProgressSuspendedReason, $ff199815cdbd2fab$var$workInProgressSuspendedReason = 0, $ff199815cdbd2fab$var$workInProgressThrownValue = null, $ff199815cdbd2fab$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $ff199815cdbd2fab$var$workLoopSync();
        exitStatus = $ff199815cdbd2fab$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $ff199815cdbd2fab$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $ff199815cdbd2fab$var$lastContextDependency = $ff199815cdbd2fab$var$currentlyRenderingFiber$1 = null;
    $ff199815cdbd2fab$var$executionContext = prevExecutionContext;
    $ff199815cdbd2fab$var$ReactSharedInternals.H = prevDispatcher;
    $ff199815cdbd2fab$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $ff199815cdbd2fab$var$workInProgress && ($ff199815cdbd2fab$var$workInProgressRoot = null, $ff199815cdbd2fab$var$workInProgressRootRenderLanes = 0, $ff199815cdbd2fab$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $ff199815cdbd2fab$var$workLoopSync() {
    for(; null !== $ff199815cdbd2fab$var$workInProgress;)$ff199815cdbd2fab$var$performUnitOfWork($ff199815cdbd2fab$var$workInProgress);
}
function $ff199815cdbd2fab$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $ff199815cdbd2fab$var$executionContext;
    $ff199815cdbd2fab$var$executionContext |= 2;
    var prevDispatcher = $ff199815cdbd2fab$var$pushDispatcher(), prevAsyncDispatcher = $ff199815cdbd2fab$var$pushAsyncDispatcher();
    $ff199815cdbd2fab$var$workInProgressRoot !== root || $ff199815cdbd2fab$var$workInProgressRootRenderLanes !== lanes ? ($ff199815cdbd2fab$var$workInProgressTransitions = null, $ff199815cdbd2fab$var$workInProgressRootRenderTargetTime = $ff199815cdbd2fab$var$now() + 500, $ff199815cdbd2fab$var$prepareFreshStack(root, lanes)) : $ff199815cdbd2fab$var$workInProgressRootIsPrerendering = $ff199815cdbd2fab$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $ff199815cdbd2fab$var$workInProgressSuspendedReason && null !== $ff199815cdbd2fab$var$workInProgress) {
            lanes = $ff199815cdbd2fab$var$workInProgress;
            var thrownValue = $ff199815cdbd2fab$var$workInProgressThrownValue;
            b: switch($ff199815cdbd2fab$var$workInProgressSuspendedReason){
                case 1:
                    $ff199815cdbd2fab$var$workInProgressSuspendedReason = 0;
                    $ff199815cdbd2fab$var$workInProgressThrownValue = null;
                    $ff199815cdbd2fab$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($ff199815cdbd2fab$var$isThenableResolved(thrownValue)) {
                        $ff199815cdbd2fab$var$workInProgressSuspendedReason = 0;
                        $ff199815cdbd2fab$var$workInProgressThrownValue = null;
                        $ff199815cdbd2fab$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $ff199815cdbd2fab$var$workInProgressSuspendedReason && 9 !== $ff199815cdbd2fab$var$workInProgressSuspendedReason || $ff199815cdbd2fab$var$workInProgressRoot !== root || ($ff199815cdbd2fab$var$workInProgressSuspendedReason = 7);
                        $ff199815cdbd2fab$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $ff199815cdbd2fab$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $ff199815cdbd2fab$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $ff199815cdbd2fab$var$isThenableResolved(thrownValue) ? ($ff199815cdbd2fab$var$workInProgressSuspendedReason = 0, $ff199815cdbd2fab$var$workInProgressThrownValue = null, $ff199815cdbd2fab$var$replaySuspendedUnitOfWork(lanes)) : ($ff199815cdbd2fab$var$workInProgressSuspendedReason = 0, $ff199815cdbd2fab$var$workInProgressThrownValue = null, $ff199815cdbd2fab$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($ff199815cdbd2fab$var$workInProgress.tag){
                        case 26:
                            resource = $ff199815cdbd2fab$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $ff199815cdbd2fab$var$workInProgress;
                            if (resource ? $ff199815cdbd2fab$var$preloadResource(resource) : 1) {
                                $ff199815cdbd2fab$var$workInProgressSuspendedReason = 0;
                                $ff199815cdbd2fab$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $ff199815cdbd2fab$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($ff199815cdbd2fab$var$workInProgress = returnFiber, $ff199815cdbd2fab$var$completeUnitOfWork(returnFiber)) : $ff199815cdbd2fab$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $ff199815cdbd2fab$var$workInProgressSuspendedReason = 0;
                    $ff199815cdbd2fab$var$workInProgressThrownValue = null;
                    $ff199815cdbd2fab$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $ff199815cdbd2fab$var$workInProgressSuspendedReason = 0;
                    $ff199815cdbd2fab$var$workInProgressThrownValue = null;
                    $ff199815cdbd2fab$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $ff199815cdbd2fab$var$resetWorkInProgressStack();
                    $ff199815cdbd2fab$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(462));
            }
        }
        $ff199815cdbd2fab$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $ff199815cdbd2fab$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $ff199815cdbd2fab$var$lastContextDependency = $ff199815cdbd2fab$var$currentlyRenderingFiber$1 = null;
    $ff199815cdbd2fab$var$ReactSharedInternals.H = prevDispatcher;
    $ff199815cdbd2fab$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $ff199815cdbd2fab$var$executionContext = prevExecutionContext;
    if (null !== $ff199815cdbd2fab$var$workInProgress) return 0;
    $ff199815cdbd2fab$var$workInProgressRoot = null;
    $ff199815cdbd2fab$var$workInProgressRootRenderLanes = 0;
    $ff199815cdbd2fab$var$finishQueueingConcurrentUpdates();
    return $ff199815cdbd2fab$var$workInProgressRootExitStatus;
}
function $ff199815cdbd2fab$var$workLoopConcurrentByScheduler() {
    for(; null !== $ff199815cdbd2fab$var$workInProgress && !$ff199815cdbd2fab$var$shouldYield();)$ff199815cdbd2fab$var$performUnitOfWork($ff199815cdbd2fab$var$workInProgress);
}
function $ff199815cdbd2fab$var$performUnitOfWork(unitOfWork) {
    var next = $ff199815cdbd2fab$var$beginWork(unitOfWork.alternate, unitOfWork, $ff199815cdbd2fab$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $ff199815cdbd2fab$var$completeUnitOfWork(unitOfWork) : $ff199815cdbd2fab$var$workInProgress = next;
}
function $ff199815cdbd2fab$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $ff199815cdbd2fab$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $ff199815cdbd2fab$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $ff199815cdbd2fab$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $ff199815cdbd2fab$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $ff199815cdbd2fab$var$resetHooksOnUnwind(next);
        default:
            $ff199815cdbd2fab$var$unwindInterruptedWork(current, next), next = $ff199815cdbd2fab$var$workInProgress = $ff199815cdbd2fab$var$resetWorkInProgress(next, $ff199815cdbd2fab$var$entangledRenderLanes), next = $ff199815cdbd2fab$var$beginWork(current, next, $ff199815cdbd2fab$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $ff199815cdbd2fab$var$completeUnitOfWork(unitOfWork) : $ff199815cdbd2fab$var$workInProgress = next;
}
function $ff199815cdbd2fab$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $ff199815cdbd2fab$var$lastContextDependency = $ff199815cdbd2fab$var$currentlyRenderingFiber$1 = null;
    $ff199815cdbd2fab$var$resetHooksOnUnwind(unitOfWork);
    $ff199815cdbd2fab$var$thenableState = null;
    $ff199815cdbd2fab$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($ff199815cdbd2fab$var$throwException(root, returnFiber, unitOfWork, thrownValue, $ff199815cdbd2fab$var$workInProgressRootRenderLanes)) {
            $ff199815cdbd2fab$var$workInProgressRootExitStatus = 1;
            $ff199815cdbd2fab$var$logUncaughtError(root, $ff199815cdbd2fab$var$createCapturedValueAtFiber(thrownValue, root.current));
            $ff199815cdbd2fab$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $ff199815cdbd2fab$var$workInProgress = returnFiber, error;
        $ff199815cdbd2fab$var$workInProgressRootExitStatus = 1;
        $ff199815cdbd2fab$var$logUncaughtError(root, $ff199815cdbd2fab$var$createCapturedValueAtFiber(thrownValue, root.current));
        $ff199815cdbd2fab$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($ff199815cdbd2fab$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($ff199815cdbd2fab$var$workInProgressRootIsPrerendering || 0 !== ($ff199815cdbd2fab$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($ff199815cdbd2fab$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $ff199815cdbd2fab$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $ff199815cdbd2fab$var$unwindUnitOfWork(unitOfWork, root);
    } else $ff199815cdbd2fab$var$completeUnitOfWork(unitOfWork);
}
function $ff199815cdbd2fab$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $ff199815cdbd2fab$var$unwindUnitOfWork(completedWork, $ff199815cdbd2fab$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $ff199815cdbd2fab$var$completeWork(completedWork.alternate, completedWork, $ff199815cdbd2fab$var$entangledRenderLanes);
        if (null !== next) {
            $ff199815cdbd2fab$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $ff199815cdbd2fab$var$workInProgress = completedWork;
            return;
        }
        $ff199815cdbd2fab$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $ff199815cdbd2fab$var$workInProgressRootExitStatus && ($ff199815cdbd2fab$var$workInProgressRootExitStatus = 5);
}
function $ff199815cdbd2fab$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $ff199815cdbd2fab$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $ff199815cdbd2fab$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $ff199815cdbd2fab$var$workInProgress = unitOfWork;
            return;
        }
        $ff199815cdbd2fab$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $ff199815cdbd2fab$var$workInProgressRootExitStatus = 6;
    $ff199815cdbd2fab$var$workInProgress = null;
}
function $ff199815cdbd2fab$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $ff199815cdbd2fab$var$flushPendingEffects();
    while (0 !== $ff199815cdbd2fab$var$pendingEffectsStatus);
    if (0 !== ($ff199815cdbd2fab$var$executionContext & 6)) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $ff199815cdbd2fab$var$concurrentlyUpdatedLanes;
        $ff199815cdbd2fab$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $ff199815cdbd2fab$var$workInProgressRoot && ($ff199815cdbd2fab$var$workInProgress = $ff199815cdbd2fab$var$workInProgressRoot = null, $ff199815cdbd2fab$var$workInProgressRootRenderLanes = 0);
        $ff199815cdbd2fab$var$pendingFinishedWork = finishedWork;
        $ff199815cdbd2fab$var$pendingEffectsRoot = root;
        $ff199815cdbd2fab$var$pendingEffectsLanes = lanes;
        $ff199815cdbd2fab$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $ff199815cdbd2fab$var$pendingPassiveTransitions = transitions;
        $ff199815cdbd2fab$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $ff199815cdbd2fab$var$scheduleCallback$1($ff199815cdbd2fab$var$NormalPriority$1, function() {
            $ff199815cdbd2fab$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $ff199815cdbd2fab$var$ReactSharedInternals.T;
            $ff199815cdbd2fab$var$ReactSharedInternals.T = null;
            transitions = $ff199815cdbd2fab$var$ReactDOMSharedInternals.p;
            $ff199815cdbd2fab$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $ff199815cdbd2fab$var$executionContext;
            $ff199815cdbd2fab$var$executionContext |= 4;
            try {
                $ff199815cdbd2fab$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $ff199815cdbd2fab$var$executionContext = spawnedLane, $ff199815cdbd2fab$var$ReactDOMSharedInternals.p = transitions, $ff199815cdbd2fab$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $ff199815cdbd2fab$var$pendingEffectsStatus = 1;
        $ff199815cdbd2fab$var$flushMutationEffects();
        $ff199815cdbd2fab$var$flushLayoutEffects();
        $ff199815cdbd2fab$var$flushSpawnedWork();
    }
}
function $ff199815cdbd2fab$var$flushMutationEffects() {
    if (1 === $ff199815cdbd2fab$var$pendingEffectsStatus) {
        $ff199815cdbd2fab$var$pendingEffectsStatus = 0;
        var root = $ff199815cdbd2fab$var$pendingEffectsRoot, finishedWork = $ff199815cdbd2fab$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $ff199815cdbd2fab$var$ReactSharedInternals.T;
            $ff199815cdbd2fab$var$ReactSharedInternals.T = null;
            var previousPriority = $ff199815cdbd2fab$var$ReactDOMSharedInternals.p;
            $ff199815cdbd2fab$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $ff199815cdbd2fab$var$executionContext;
            $ff199815cdbd2fab$var$executionContext |= 4;
            try {
                $ff199815cdbd2fab$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $ff199815cdbd2fab$var$selectionInformation, curFocusedElem = $ff199815cdbd2fab$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $ff199815cdbd2fab$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $ff199815cdbd2fab$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $ff199815cdbd2fab$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $ff199815cdbd2fab$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $ff199815cdbd2fab$var$_enabled = !!$ff199815cdbd2fab$var$eventsEnabled;
                $ff199815cdbd2fab$var$selectionInformation = $ff199815cdbd2fab$var$eventsEnabled = null;
            } finally{
                $ff199815cdbd2fab$var$executionContext = prevExecutionContext, $ff199815cdbd2fab$var$ReactDOMSharedInternals.p = previousPriority, $ff199815cdbd2fab$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $ff199815cdbd2fab$var$pendingEffectsStatus = 2;
    }
}
function $ff199815cdbd2fab$var$flushLayoutEffects() {
    if (2 === $ff199815cdbd2fab$var$pendingEffectsStatus) {
        $ff199815cdbd2fab$var$pendingEffectsStatus = 0;
        var root = $ff199815cdbd2fab$var$pendingEffectsRoot, finishedWork = $ff199815cdbd2fab$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $ff199815cdbd2fab$var$ReactSharedInternals.T;
            $ff199815cdbd2fab$var$ReactSharedInternals.T = null;
            var previousPriority = $ff199815cdbd2fab$var$ReactDOMSharedInternals.p;
            $ff199815cdbd2fab$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $ff199815cdbd2fab$var$executionContext;
            $ff199815cdbd2fab$var$executionContext |= 4;
            try {
                $ff199815cdbd2fab$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $ff199815cdbd2fab$var$executionContext = prevExecutionContext, $ff199815cdbd2fab$var$ReactDOMSharedInternals.p = previousPriority, $ff199815cdbd2fab$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $ff199815cdbd2fab$var$pendingEffectsStatus = 3;
    }
}
function $ff199815cdbd2fab$var$flushSpawnedWork() {
    if (4 === $ff199815cdbd2fab$var$pendingEffectsStatus || 3 === $ff199815cdbd2fab$var$pendingEffectsStatus) {
        $ff199815cdbd2fab$var$pendingEffectsStatus = 0;
        $ff199815cdbd2fab$var$requestPaint();
        var root = $ff199815cdbd2fab$var$pendingEffectsRoot, finishedWork = $ff199815cdbd2fab$var$pendingFinishedWork, lanes = $ff199815cdbd2fab$var$pendingEffectsLanes, recoverableErrors = $ff199815cdbd2fab$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $ff199815cdbd2fab$var$pendingEffectsStatus = 5 : ($ff199815cdbd2fab$var$pendingEffectsStatus = 0, $ff199815cdbd2fab$var$pendingFinishedWork = $ff199815cdbd2fab$var$pendingEffectsRoot = null, $ff199815cdbd2fab$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($ff199815cdbd2fab$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $ff199815cdbd2fab$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($ff199815cdbd2fab$var$injectedHook && "function" === typeof $ff199815cdbd2fab$var$injectedHook.onCommitFiberRoot) try {
            $ff199815cdbd2fab$var$injectedHook.onCommitFiberRoot($ff199815cdbd2fab$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $ff199815cdbd2fab$var$ReactSharedInternals.T;
            remainingLanes = $ff199815cdbd2fab$var$ReactDOMSharedInternals.p;
            $ff199815cdbd2fab$var$ReactDOMSharedInternals.p = 2;
            $ff199815cdbd2fab$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $ff199815cdbd2fab$var$ReactSharedInternals.T = finishedWork, $ff199815cdbd2fab$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($ff199815cdbd2fab$var$pendingEffectsLanes & 3) && $ff199815cdbd2fab$var$flushPendingEffects();
        $ff199815cdbd2fab$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $ff199815cdbd2fab$var$rootWithNestedUpdates ? $ff199815cdbd2fab$var$nestedUpdateCount++ : ($ff199815cdbd2fab$var$nestedUpdateCount = 0, $ff199815cdbd2fab$var$rootWithNestedUpdates = root) : $ff199815cdbd2fab$var$nestedUpdateCount = 0;
        $ff199815cdbd2fab$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $ff199815cdbd2fab$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $ff199815cdbd2fab$var$releaseCache(remainingLanes)));
}
function $ff199815cdbd2fab$var$flushPendingEffects(wasDelayedCommit) {
    $ff199815cdbd2fab$var$flushMutationEffects();
    $ff199815cdbd2fab$var$flushLayoutEffects();
    $ff199815cdbd2fab$var$flushSpawnedWork();
    return $ff199815cdbd2fab$var$flushPassiveEffects(wasDelayedCommit);
}
function $ff199815cdbd2fab$var$flushPassiveEffects() {
    if (5 !== $ff199815cdbd2fab$var$pendingEffectsStatus) return !1;
    var root = $ff199815cdbd2fab$var$pendingEffectsRoot, remainingLanes = $ff199815cdbd2fab$var$pendingEffectsRemainingLanes;
    $ff199815cdbd2fab$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $ff199815cdbd2fab$var$lanesToEventPriority($ff199815cdbd2fab$var$pendingEffectsLanes), prevTransition = $ff199815cdbd2fab$var$ReactSharedInternals.T, previousPriority = $ff199815cdbd2fab$var$ReactDOMSharedInternals.p;
    try {
        $ff199815cdbd2fab$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $ff199815cdbd2fab$var$ReactSharedInternals.T = null;
        renderPriority = $ff199815cdbd2fab$var$pendingPassiveTransitions;
        $ff199815cdbd2fab$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $ff199815cdbd2fab$var$pendingEffectsRoot, lanes = $ff199815cdbd2fab$var$pendingEffectsLanes;
        $ff199815cdbd2fab$var$pendingEffectsStatus = 0;
        $ff199815cdbd2fab$var$pendingFinishedWork = $ff199815cdbd2fab$var$pendingEffectsRoot = null;
        $ff199815cdbd2fab$var$pendingEffectsLanes = 0;
        if (0 !== ($ff199815cdbd2fab$var$executionContext & 6)) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(331));
        var prevExecutionContext = $ff199815cdbd2fab$var$executionContext;
        $ff199815cdbd2fab$var$executionContext |= 4;
        $ff199815cdbd2fab$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $ff199815cdbd2fab$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $ff199815cdbd2fab$var$executionContext = prevExecutionContext;
        $ff199815cdbd2fab$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($ff199815cdbd2fab$var$injectedHook && "function" === typeof $ff199815cdbd2fab$var$injectedHook.onPostCommitFiberRoot) try {
            $ff199815cdbd2fab$var$injectedHook.onPostCommitFiberRoot($ff199815cdbd2fab$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $ff199815cdbd2fab$var$ReactDOMSharedInternals.p = previousPriority, $ff199815cdbd2fab$var$ReactSharedInternals.T = prevTransition, $ff199815cdbd2fab$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $ff199815cdbd2fab$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $ff199815cdbd2fab$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $ff199815cdbd2fab$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $ff199815cdbd2fab$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($ff199815cdbd2fab$var$markRootUpdated$1(rootFiber, 2), $ff199815cdbd2fab$var$ensureRootIsScheduled(rootFiber));
}
function $ff199815cdbd2fab$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $ff199815cdbd2fab$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $ff199815cdbd2fab$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $ff199815cdbd2fab$var$legacyErrorBoundariesThatAlreadyFailed || !$ff199815cdbd2fab$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $ff199815cdbd2fab$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $ff199815cdbd2fab$var$createClassErrorUpdate(2);
                instance = $ff199815cdbd2fab$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($ff199815cdbd2fab$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $ff199815cdbd2fab$var$markRootUpdated$1(instance, 2), $ff199815cdbd2fab$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $ff199815cdbd2fab$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $ff199815cdbd2fab$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($ff199815cdbd2fab$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $ff199815cdbd2fab$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $ff199815cdbd2fab$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $ff199815cdbd2fab$var$workInProgressRoot === root && ($ff199815cdbd2fab$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $ff199815cdbd2fab$var$workInProgressRootExitStatus || 3 === $ff199815cdbd2fab$var$workInProgressRootExitStatus && ($ff199815cdbd2fab$var$workInProgressRootRenderLanes & 62914560) === $ff199815cdbd2fab$var$workInProgressRootRenderLanes && 300 > $ff199815cdbd2fab$var$now() - $ff199815cdbd2fab$var$globalMostRecentFallbackTime ? 0 === ($ff199815cdbd2fab$var$executionContext & 2) && $ff199815cdbd2fab$var$prepareFreshStack(root, 0) : $ff199815cdbd2fab$var$workInProgressRootPingedLanes |= pingedLanes, $ff199815cdbd2fab$var$workInProgressSuspendedRetryLanes === $ff199815cdbd2fab$var$workInProgressRootRenderLanes && ($ff199815cdbd2fab$var$workInProgressSuspendedRetryLanes = 0));
    $ff199815cdbd2fab$var$ensureRootIsScheduled(root);
}
function $ff199815cdbd2fab$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $ff199815cdbd2fab$var$claimNextRetryLane());
    boundaryFiber = $ff199815cdbd2fab$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($ff199815cdbd2fab$var$markRootUpdated$1(boundaryFiber, retryLane), $ff199815cdbd2fab$var$ensureRootIsScheduled(boundaryFiber));
}
function $ff199815cdbd2fab$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $ff199815cdbd2fab$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $ff199815cdbd2fab$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $ff199815cdbd2fab$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $ff199815cdbd2fab$var$scheduleCallback$1(priorityLevel, callback) {
    return $ff199815cdbd2fab$var$scheduleCallback$3(priorityLevel, callback);
}
var $ff199815cdbd2fab$var$firstScheduledRoot = null, $ff199815cdbd2fab$var$lastScheduledRoot = null, $ff199815cdbd2fab$var$didScheduleMicrotask = !1, $ff199815cdbd2fab$var$mightHavePendingSyncWork = !1, $ff199815cdbd2fab$var$isFlushingWork = !1, $ff199815cdbd2fab$var$currentEventTransitionLane = 0;
function $ff199815cdbd2fab$var$ensureRootIsScheduled(root) {
    root !== $ff199815cdbd2fab$var$lastScheduledRoot && null === root.next && (null === $ff199815cdbd2fab$var$lastScheduledRoot ? $ff199815cdbd2fab$var$firstScheduledRoot = $ff199815cdbd2fab$var$lastScheduledRoot = root : $ff199815cdbd2fab$var$lastScheduledRoot = $ff199815cdbd2fab$var$lastScheduledRoot.next = root);
    $ff199815cdbd2fab$var$mightHavePendingSyncWork = !0;
    $ff199815cdbd2fab$var$didScheduleMicrotask || ($ff199815cdbd2fab$var$didScheduleMicrotask = !0, $ff199815cdbd2fab$var$scheduleImmediateRootScheduleTask());
}
function $ff199815cdbd2fab$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$ff199815cdbd2fab$var$isFlushingWork && $ff199815cdbd2fab$var$mightHavePendingSyncWork) {
        $ff199815cdbd2fab$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $ff199815cdbd2fab$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $ff199815cdbd2fab$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $ff199815cdbd2fab$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $ff199815cdbd2fab$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $ff199815cdbd2fab$var$getNextLanes(root$174, root$174 === $ff199815cdbd2fab$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $ff199815cdbd2fab$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $ff199815cdbd2fab$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $ff199815cdbd2fab$var$isFlushingWork = !1;
    }
}
function $ff199815cdbd2fab$var$processRootScheduleInImmediateTask() {
    $ff199815cdbd2fab$var$processRootScheduleInMicrotask();
}
function $ff199815cdbd2fab$var$processRootScheduleInMicrotask() {
    $ff199815cdbd2fab$var$mightHavePendingSyncWork = $ff199815cdbd2fab$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $ff199815cdbd2fab$var$currentEventTransitionLane && ($ff199815cdbd2fab$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $ff199815cdbd2fab$var$currentEventTransitionLane), $ff199815cdbd2fab$var$currentEventTransitionLane = 0);
    for(var currentTime = $ff199815cdbd2fab$var$now(), prev = null, root = $ff199815cdbd2fab$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $ff199815cdbd2fab$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $ff199815cdbd2fab$var$firstScheduledRoot = next : prev.next = next, null === next && ($ff199815cdbd2fab$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $ff199815cdbd2fab$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $ff199815cdbd2fab$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $ff199815cdbd2fab$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $ff199815cdbd2fab$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $ff199815cdbd2fab$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $ff199815cdbd2fab$var$workInProgressRoot;
    suspendedLanes = $ff199815cdbd2fab$var$workInProgressRootRenderLanes;
    suspendedLanes = $ff199815cdbd2fab$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $ff199815cdbd2fab$var$workInProgressSuspendedReason || 9 === $ff199815cdbd2fab$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $ff199815cdbd2fab$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $ff199815cdbd2fab$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $ff199815cdbd2fab$var$cancelCallback$1(pingedLanes);
        switch($ff199815cdbd2fab$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $ff199815cdbd2fab$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $ff199815cdbd2fab$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $ff199815cdbd2fab$var$IdlePriority;
                break;
            default:
                suspendedLanes = $ff199815cdbd2fab$var$NormalPriority$1;
        }
        pingedLanes = $ff199815cdbd2fab$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $ff199815cdbd2fab$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $ff199815cdbd2fab$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $ff199815cdbd2fab$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $ff199815cdbd2fab$var$pendingEffectsStatus && 5 !== $ff199815cdbd2fab$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($ff199815cdbd2fab$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $ff199815cdbd2fab$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $ff199815cdbd2fab$var$getNextLanes(root, root === $ff199815cdbd2fab$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $ff199815cdbd2fab$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $ff199815cdbd2fab$var$scheduleTaskForRootDuringMicrotask(root, $ff199815cdbd2fab$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $ff199815cdbd2fab$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $ff199815cdbd2fab$var$performSyncWorkOnRoot(root, lanes) {
    if ($ff199815cdbd2fab$var$flushPendingEffects()) return null;
    $ff199815cdbd2fab$var$performWorkOnRoot(root, lanes, !0);
}
function $ff199815cdbd2fab$var$scheduleImmediateRootScheduleTask() {
    $ff199815cdbd2fab$var$scheduleMicrotask(function() {
        0 !== ($ff199815cdbd2fab$var$executionContext & 6) ? $ff199815cdbd2fab$var$scheduleCallback$3($ff199815cdbd2fab$var$ImmediatePriority, $ff199815cdbd2fab$var$processRootScheduleInImmediateTask) : $ff199815cdbd2fab$var$processRootScheduleInMicrotask();
    });
}
function $ff199815cdbd2fab$var$requestTransitionLane() {
    0 === $ff199815cdbd2fab$var$currentEventTransitionLane && ($ff199815cdbd2fab$var$currentEventTransitionLane = $ff199815cdbd2fab$var$claimNextTransitionLane());
    return $ff199815cdbd2fab$var$currentEventTransitionLane;
}
function $ff199815cdbd2fab$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $ff199815cdbd2fab$var$sanitizeURL("" + actionProp);
}
function $ff199815cdbd2fab$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $ff199815cdbd2fab$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $ff199815cdbd2fab$var$coerceFormActionProp((nativeEventTarget[$ff199815cdbd2fab$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$ff199815cdbd2fab$var$internalPropsKey] || null) ? $ff199815cdbd2fab$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $ff199815cdbd2fab$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $ff199815cdbd2fab$var$currentEventTransitionLane) {
                                var formData = submitter ? $ff199815cdbd2fab$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $ff199815cdbd2fab$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $ff199815cdbd2fab$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $ff199815cdbd2fab$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $ff199815cdbd2fab$var$i$jscomp$inline_1528 = 0; $ff199815cdbd2fab$var$i$jscomp$inline_1528 < $ff199815cdbd2fab$var$simpleEventPluginEvents.length; $ff199815cdbd2fab$var$i$jscomp$inline_1528++){
    var $ff199815cdbd2fab$var$eventName$jscomp$inline_1529 = $ff199815cdbd2fab$var$simpleEventPluginEvents[$ff199815cdbd2fab$var$i$jscomp$inline_1528], $ff199815cdbd2fab$var$domEventName$jscomp$inline_1530 = $ff199815cdbd2fab$var$eventName$jscomp$inline_1529.toLowerCase(), $ff199815cdbd2fab$var$capitalizedEvent$jscomp$inline_1531 = $ff199815cdbd2fab$var$eventName$jscomp$inline_1529[0].toUpperCase() + $ff199815cdbd2fab$var$eventName$jscomp$inline_1529.slice(1);
    $ff199815cdbd2fab$var$registerSimpleEvent($ff199815cdbd2fab$var$domEventName$jscomp$inline_1530, "on" + $ff199815cdbd2fab$var$capitalizedEvent$jscomp$inline_1531);
}
$ff199815cdbd2fab$var$registerSimpleEvent($ff199815cdbd2fab$var$ANIMATION_END, "onAnimationEnd");
$ff199815cdbd2fab$var$registerSimpleEvent($ff199815cdbd2fab$var$ANIMATION_ITERATION, "onAnimationIteration");
$ff199815cdbd2fab$var$registerSimpleEvent($ff199815cdbd2fab$var$ANIMATION_START, "onAnimationStart");
$ff199815cdbd2fab$var$registerSimpleEvent("dblclick", "onDoubleClick");
$ff199815cdbd2fab$var$registerSimpleEvent("focusin", "onFocus");
$ff199815cdbd2fab$var$registerSimpleEvent("focusout", "onBlur");
$ff199815cdbd2fab$var$registerSimpleEvent($ff199815cdbd2fab$var$TRANSITION_RUN, "onTransitionRun");
$ff199815cdbd2fab$var$registerSimpleEvent($ff199815cdbd2fab$var$TRANSITION_START, "onTransitionStart");
$ff199815cdbd2fab$var$registerSimpleEvent($ff199815cdbd2fab$var$TRANSITION_CANCEL, "onTransitionCancel");
$ff199815cdbd2fab$var$registerSimpleEvent($ff199815cdbd2fab$var$TRANSITION_END, "onTransitionEnd");
$ff199815cdbd2fab$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$ff199815cdbd2fab$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$ff199815cdbd2fab$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$ff199815cdbd2fab$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$ff199815cdbd2fab$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$ff199815cdbd2fab$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$ff199815cdbd2fab$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$ff199815cdbd2fab$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$ff199815cdbd2fab$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$ff199815cdbd2fab$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $ff199815cdbd2fab$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $ff199815cdbd2fab$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($ff199815cdbd2fab$var$mediaEventTypes));
function $ff199815cdbd2fab$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $ff199815cdbd2fab$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $ff199815cdbd2fab$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $ff199815cdbd2fab$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$ff199815cdbd2fab$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$ff199815cdbd2fab$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($ff199815cdbd2fab$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $ff199815cdbd2fab$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $ff199815cdbd2fab$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $ff199815cdbd2fab$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $ff199815cdbd2fab$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$ff199815cdbd2fab$var$listeningMarker]) {
        rootContainerElement[$ff199815cdbd2fab$var$listeningMarker] = !0;
        $ff199815cdbd2fab$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($ff199815cdbd2fab$var$nonDelegatedEvents.has(domEventName) || $ff199815cdbd2fab$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $ff199815cdbd2fab$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$ff199815cdbd2fab$var$listeningMarker] || (ownerDocument[$ff199815cdbd2fab$var$listeningMarker] = !0, $ff199815cdbd2fab$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $ff199815cdbd2fab$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($ff199815cdbd2fab$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $ff199815cdbd2fab$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $ff199815cdbd2fab$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $ff199815cdbd2fab$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$ff199815cdbd2fab$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $ff199815cdbd2fab$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $ff199815cdbd2fab$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $ff199815cdbd2fab$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $ff199815cdbd2fab$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $ff199815cdbd2fab$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $ff199815cdbd2fab$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $ff199815cdbd2fab$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $ff199815cdbd2fab$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $ff199815cdbd2fab$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $ff199815cdbd2fab$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $ff199815cdbd2fab$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $ff199815cdbd2fab$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $ff199815cdbd2fab$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $ff199815cdbd2fab$var$SyntheticTouchEvent;
                        break;
                    case $ff199815cdbd2fab$var$ANIMATION_END:
                    case $ff199815cdbd2fab$var$ANIMATION_ITERATION:
                    case $ff199815cdbd2fab$var$ANIMATION_START:
                        SyntheticEventCtor = $ff199815cdbd2fab$var$SyntheticAnimationEvent;
                        break;
                    case $ff199815cdbd2fab$var$TRANSITION_END:
                        SyntheticEventCtor = $ff199815cdbd2fab$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $ff199815cdbd2fab$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $ff199815cdbd2fab$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $ff199815cdbd2fab$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $ff199815cdbd2fab$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $ff199815cdbd2fab$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $ff199815cdbd2fab$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($ff199815cdbd2fab$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $ff199815cdbd2fab$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($ff199815cdbd2fab$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$ff199815cdbd2fab$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $ff199815cdbd2fab$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $ff199815cdbd2fab$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $ff199815cdbd2fab$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $ff199815cdbd2fab$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $ff199815cdbd2fab$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $ff199815cdbd2fab$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $ff199815cdbd2fab$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $ff199815cdbd2fab$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $ff199815cdbd2fab$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $ff199815cdbd2fab$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $ff199815cdbd2fab$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $ff199815cdbd2fab$var$getParent(inCapturePhase);
                                reactEventName = $ff199815cdbd2fab$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $ff199815cdbd2fab$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $ff199815cdbd2fab$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $ff199815cdbd2fab$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $ff199815cdbd2fab$var$getTargetInstForChangeEvent;
                else if ($ff199815cdbd2fab$var$isTextInputElement(reactName)) {
                    if ($ff199815cdbd2fab$var$isInputEventSupported) getTargetInstFunc = $ff199815cdbd2fab$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $ff199815cdbd2fab$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $ff199815cdbd2fab$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $ff199815cdbd2fab$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $ff199815cdbd2fab$var$getTargetInstForChangeEvent) : getTargetInstFunc = $ff199815cdbd2fab$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $ff199815cdbd2fab$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $ff199815cdbd2fab$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $ff199815cdbd2fab$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($ff199815cdbd2fab$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $ff199815cdbd2fab$var$activeElement = handleEventFunc, $ff199815cdbd2fab$var$activeElementInst = targetInst, $ff199815cdbd2fab$var$lastSelection = null;
                    break;
                case "focusout":
                    $ff199815cdbd2fab$var$lastSelection = $ff199815cdbd2fab$var$activeElementInst = $ff199815cdbd2fab$var$activeElement = null;
                    break;
                case "mousedown":
                    $ff199815cdbd2fab$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $ff199815cdbd2fab$var$mouseDown = !1;
                    $ff199815cdbd2fab$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($ff199815cdbd2fab$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $ff199815cdbd2fab$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($ff199815cdbd2fab$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $ff199815cdbd2fab$var$isComposing ? $ff199815cdbd2fab$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($ff199815cdbd2fab$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($ff199815cdbd2fab$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $ff199815cdbd2fab$var$isComposing && (fallbackData = $ff199815cdbd2fab$var$getData()) : ($ff199815cdbd2fab$var$root = nativeEventTarget, $ff199815cdbd2fab$var$startText = "value" in $ff199815cdbd2fab$var$root ? $ff199815cdbd2fab$var$root.value : $ff199815cdbd2fab$var$root.textContent, $ff199815cdbd2fab$var$isComposing = !0)), handleEventFunc = $ff199815cdbd2fab$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $ff199815cdbd2fab$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $ff199815cdbd2fab$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $ff199815cdbd2fab$var$canUseTextInputEvent ? $ff199815cdbd2fab$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $ff199815cdbd2fab$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $ff199815cdbd2fab$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $ff199815cdbd2fab$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $ff199815cdbd2fab$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $ff199815cdbd2fab$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $ff199815cdbd2fab$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $ff199815cdbd2fab$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $ff199815cdbd2fab$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($ff199815cdbd2fab$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $ff199815cdbd2fab$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($ff199815cdbd2fab$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $ff199815cdbd2fab$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $ff199815cdbd2fab$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $ff199815cdbd2fab$var$getListener(target, registrationName), null != stateNode && listeners.unshift($ff199815cdbd2fab$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $ff199815cdbd2fab$var$getListener(target, registrationName), null != stateNode && listeners.push($ff199815cdbd2fab$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $ff199815cdbd2fab$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $ff199815cdbd2fab$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $ff199815cdbd2fab$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($ff199815cdbd2fab$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($ff199815cdbd2fab$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $ff199815cdbd2fab$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $ff199815cdbd2fab$var$normalizeMarkupForTextOrAttribute(clientText);
    return $ff199815cdbd2fab$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $ff199815cdbd2fab$var$noop$1() {}
function $ff199815cdbd2fab$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $ff199815cdbd2fab$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $ff199815cdbd2fab$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $ff199815cdbd2fab$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $ff199815cdbd2fab$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $ff199815cdbd2fab$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $ff199815cdbd2fab$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $ff199815cdbd2fab$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $ff199815cdbd2fab$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $ff199815cdbd2fab$var$setProp(domElement, tag, "name", props.name, props, null), $ff199815cdbd2fab$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $ff199815cdbd2fab$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $ff199815cdbd2fab$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($ff199815cdbd2fab$var$setProp(domElement, tag, "encType", props.encType, props, null), $ff199815cdbd2fab$var$setProp(domElement, tag, "method", props.method, props, null), $ff199815cdbd2fab$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $ff199815cdbd2fab$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $ff199815cdbd2fab$var$noop$1);
            break;
        case "onScroll":
            null != value && $ff199815cdbd2fab$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $ff199815cdbd2fab$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $ff199815cdbd2fab$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("toggle", domElement);
            $ff199815cdbd2fab$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $ff199815cdbd2fab$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $ff199815cdbd2fab$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $ff199815cdbd2fab$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $ff199815cdbd2fab$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $ff199815cdbd2fab$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $ff199815cdbd2fab$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $ff199815cdbd2fab$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $ff199815cdbd2fab$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $ff199815cdbd2fab$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $ff199815cdbd2fab$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $ff199815cdbd2fab$var$aliases.get(key) || key, $ff199815cdbd2fab$var$setValueForAttribute(domElement, key, value);
    }
}
function $ff199815cdbd2fab$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $ff199815cdbd2fab$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $ff199815cdbd2fab$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $ff199815cdbd2fab$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $ff199815cdbd2fab$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $ff199815cdbd2fab$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $ff199815cdbd2fab$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$ff199815cdbd2fab$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$ff199815cdbd2fab$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $ff199815cdbd2fab$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $ff199815cdbd2fab$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("error", domElement);
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(137, tag));
                    default:
                        $ff199815cdbd2fab$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $ff199815cdbd2fab$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $ff199815cdbd2fab$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $ff199815cdbd2fab$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $ff199815cdbd2fab$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $ff199815cdbd2fab$var$track(domElement);
            return;
        case "select":
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $ff199815cdbd2fab$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $ff199815cdbd2fab$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $ff199815cdbd2fab$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(91));
                    break;
                default:
                    $ff199815cdbd2fab$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $ff199815cdbd2fab$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $ff199815cdbd2fab$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $ff199815cdbd2fab$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("toggle", domElement);
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("cancel", domElement);
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $ff199815cdbd2fab$var$mediaEventTypes.length; hasSrc++)$ff199815cdbd2fab$var$listenToNonDelegatedEvent($ff199815cdbd2fab$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("error", domElement);
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $ff199815cdbd2fab$var$listenToNonDelegatedEvent("error", domElement), $ff199815cdbd2fab$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(137, tag));
                default:
                    $ff199815cdbd2fab$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($ff199815cdbd2fab$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $ff199815cdbd2fab$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $ff199815cdbd2fab$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $ff199815cdbd2fab$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $ff199815cdbd2fab$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $ff199815cdbd2fab$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $ff199815cdbd2fab$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $ff199815cdbd2fab$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $ff199815cdbd2fab$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $ff199815cdbd2fab$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $ff199815cdbd2fab$var$updateOptions(domElement, !!lastProps, tag, !0) : $ff199815cdbd2fab$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $ff199815cdbd2fab$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $ff199815cdbd2fab$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $ff199815cdbd2fab$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $ff199815cdbd2fab$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $ff199815cdbd2fab$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $ff199815cdbd2fab$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $ff199815cdbd2fab$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($ff199815cdbd2fab$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $ff199815cdbd2fab$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $ff199815cdbd2fab$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $ff199815cdbd2fab$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $ff199815cdbd2fab$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $ff199815cdbd2fab$var$eventsEnabled = null, $ff199815cdbd2fab$var$selectionInformation = null;
function $ff199815cdbd2fab$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $ff199815cdbd2fab$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $ff199815cdbd2fab$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $ff199815cdbd2fab$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $ff199815cdbd2fab$var$currentPopstateTransitionEvent = null;
function $ff199815cdbd2fab$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $ff199815cdbd2fab$var$currentPopstateTransitionEvent) return !1;
        $ff199815cdbd2fab$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $ff199815cdbd2fab$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $ff199815cdbd2fab$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $ff199815cdbd2fab$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $ff199815cdbd2fab$var$localPromise = "function" === typeof Promise ? Promise : void 0, $ff199815cdbd2fab$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $ff199815cdbd2fab$var$localPromise ? function(callback) {
    return $ff199815cdbd2fab$var$localPromise.resolve(null).then(callback).catch($ff199815cdbd2fab$var$handleErrorInNextTick);
} : $ff199815cdbd2fab$var$scheduleTimeout;
function $ff199815cdbd2fab$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $ff199815cdbd2fab$var$isSingletonScope(type) {
    return "head" === type;
}
function $ff199815cdbd2fab$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $ff199815cdbd2fab$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $ff199815cdbd2fab$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $ff199815cdbd2fab$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$ff199815cdbd2fab$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $ff199815cdbd2fab$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $ff199815cdbd2fab$var$retryIfBlockedOn(suspenseInstance);
}
function $ff199815cdbd2fab$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $ff199815cdbd2fab$var$clearContainerSparingly(node);
                $ff199815cdbd2fab$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $ff199815cdbd2fab$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$ff199815cdbd2fab$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $ff199815cdbd2fab$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $ff199815cdbd2fab$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $ff199815cdbd2fab$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $ff199815cdbd2fab$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $ff199815cdbd2fab$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $ff199815cdbd2fab$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $ff199815cdbd2fab$var$previousHydratableOnEnteringScopedSingleton = null;
function $ff199815cdbd2fab$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $ff199815cdbd2fab$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $ff199815cdbd2fab$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(451));
    }
}
function $ff199815cdbd2fab$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $ff199815cdbd2fab$var$detachDeletedInstance(instance);
}
var $ff199815cdbd2fab$var$preloadPropsMap = new Map(), $ff199815cdbd2fab$var$preconnectsSet = new Set();
function $ff199815cdbd2fab$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $ff199815cdbd2fab$var$previousDispatcher = $ff199815cdbd2fab$var$ReactDOMSharedInternals.d;
$ff199815cdbd2fab$var$ReactDOMSharedInternals.d = {
    f: $ff199815cdbd2fab$var$flushSyncWork,
    r: $ff199815cdbd2fab$var$requestFormReset,
    D: $ff199815cdbd2fab$var$prefetchDNS,
    C: $ff199815cdbd2fab$var$preconnect,
    L: $ff199815cdbd2fab$var$preload,
    m: $ff199815cdbd2fab$var$preloadModule,
    X: $ff199815cdbd2fab$var$preinitScript,
    S: $ff199815cdbd2fab$var$preinitStyle,
    M: $ff199815cdbd2fab$var$preinitModuleScript
};
function $ff199815cdbd2fab$var$flushSyncWork() {
    var previousWasRendering = $ff199815cdbd2fab$var$previousDispatcher.f(), wasRendering = $ff199815cdbd2fab$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $ff199815cdbd2fab$var$requestFormReset(form) {
    var formInst = $ff199815cdbd2fab$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $ff199815cdbd2fab$var$requestFormReset$1(formInst) : $ff199815cdbd2fab$var$previousDispatcher.r(form);
}
var $ff199815cdbd2fab$var$globalDocument = "undefined" === typeof document ? null : document;
function $ff199815cdbd2fab$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $ff199815cdbd2fab$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $ff199815cdbd2fab$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $ff199815cdbd2fab$var$preconnectsSet.has(limitedEscapedHref) || ($ff199815cdbd2fab$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $ff199815cdbd2fab$var$setInitialProperties(href, "link", rel), $ff199815cdbd2fab$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $ff199815cdbd2fab$var$prefetchDNS(href) {
    $ff199815cdbd2fab$var$previousDispatcher.D(href);
    $ff199815cdbd2fab$var$preconnectAs("dns-prefetch", href, null);
}
function $ff199815cdbd2fab$var$preconnect(href, crossOrigin) {
    $ff199815cdbd2fab$var$previousDispatcher.C(href, crossOrigin);
    $ff199815cdbd2fab$var$preconnectAs("preconnect", href, crossOrigin);
}
function $ff199815cdbd2fab$var$preload(href, as, options) {
    $ff199815cdbd2fab$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $ff199815cdbd2fab$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $ff199815cdbd2fab$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $ff199815cdbd2fab$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $ff199815cdbd2fab$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $ff199815cdbd2fab$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $ff199815cdbd2fab$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $ff199815cdbd2fab$var$getStyleKey(href);
                break;
            case "script":
                key = $ff199815cdbd2fab$var$getScriptKey(href);
        }
        $ff199815cdbd2fab$var$preloadPropsMap.has(key) || (href = $ff199815cdbd2fab$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $ff199815cdbd2fab$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($ff199815cdbd2fab$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($ff199815cdbd2fab$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $ff199815cdbd2fab$var$setInitialProperties(as, "link", href), $ff199815cdbd2fab$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $ff199815cdbd2fab$var$preloadModule(href, options) {
    $ff199815cdbd2fab$var$previousDispatcher.m(href, options);
    var ownerDocument = $ff199815cdbd2fab$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $ff199815cdbd2fab$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $ff199815cdbd2fab$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $ff199815cdbd2fab$var$getScriptKey(href);
        }
        if (!$ff199815cdbd2fab$var$preloadPropsMap.has(key) && (href = $ff199815cdbd2fab$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $ff199815cdbd2fab$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($ff199815cdbd2fab$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $ff199815cdbd2fab$var$setInitialProperties(as, "link", href);
            $ff199815cdbd2fab$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $ff199815cdbd2fab$var$preinitStyle(href, precedence, options) {
    $ff199815cdbd2fab$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $ff199815cdbd2fab$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $ff199815cdbd2fab$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $ff199815cdbd2fab$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($ff199815cdbd2fab$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $ff199815cdbd2fab$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $ff199815cdbd2fab$var$preloadPropsMap.get(key)) && $ff199815cdbd2fab$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $ff199815cdbd2fab$var$markNodeAsHoistable(link);
                $ff199815cdbd2fab$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $ff199815cdbd2fab$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $ff199815cdbd2fab$var$preinitScript(src, options) {
    $ff199815cdbd2fab$var$previousDispatcher.X(src, options);
    var ownerDocument = $ff199815cdbd2fab$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $ff199815cdbd2fab$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $ff199815cdbd2fab$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($ff199815cdbd2fab$var$getScriptSelectorFromKey(key)), resource || (src = $ff199815cdbd2fab$var$assign({
            src: src,
            async: !0
        }, options), (options = $ff199815cdbd2fab$var$preloadPropsMap.get(key)) && $ff199815cdbd2fab$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $ff199815cdbd2fab$var$markNodeAsHoistable(resource), $ff199815cdbd2fab$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $ff199815cdbd2fab$var$preinitModuleScript(src, options) {
    $ff199815cdbd2fab$var$previousDispatcher.M(src, options);
    var ownerDocument = $ff199815cdbd2fab$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $ff199815cdbd2fab$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $ff199815cdbd2fab$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($ff199815cdbd2fab$var$getScriptSelectorFromKey(key)), resource || (src = $ff199815cdbd2fab$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $ff199815cdbd2fab$var$preloadPropsMap.get(key)) && $ff199815cdbd2fab$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $ff199815cdbd2fab$var$markNodeAsHoistable(resource), $ff199815cdbd2fab$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $ff199815cdbd2fab$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $ff199815cdbd2fab$var$rootInstanceStackCursor.current) ? $ff199815cdbd2fab$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $ff199815cdbd2fab$var$getStyleKey(pendingProps.href), pendingProps = $ff199815cdbd2fab$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $ff199815cdbd2fab$var$getStyleKey(pendingProps.href);
                var styles$244 = $ff199815cdbd2fab$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($ff199815cdbd2fab$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $ff199815cdbd2fab$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $ff199815cdbd2fab$var$preloadPropsMap.set(type, pendingProps), styles$244 || $ff199815cdbd2fab$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $ff199815cdbd2fab$var$getScriptKey(pendingProps), pendingProps = $ff199815cdbd2fab$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(444, type));
    }
}
function $ff199815cdbd2fab$var$getStyleKey(href) {
    return 'href="' + $ff199815cdbd2fab$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $ff199815cdbd2fab$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $ff199815cdbd2fab$var$stylesheetPropsFromRawProps(rawProps) {
    return $ff199815cdbd2fab$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $ff199815cdbd2fab$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $ff199815cdbd2fab$var$setInitialProperties(key, "link", preloadProps), $ff199815cdbd2fab$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $ff199815cdbd2fab$var$getScriptKey(src) {
    return '[src="' + $ff199815cdbd2fab$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $ff199815cdbd2fab$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $ff199815cdbd2fab$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $ff199815cdbd2fab$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $ff199815cdbd2fab$var$markNodeAsHoistable(instance), instance;
            var styleProps = $ff199815cdbd2fab$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $ff199815cdbd2fab$var$markNodeAsHoistable(instance);
            $ff199815cdbd2fab$var$setInitialProperties(instance, "style", styleProps);
            $ff199815cdbd2fab$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $ff199815cdbd2fab$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($ff199815cdbd2fab$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $ff199815cdbd2fab$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $ff199815cdbd2fab$var$stylesheetPropsFromRawProps(props);
            (styleProps = $ff199815cdbd2fab$var$preloadPropsMap.get(styleProps)) && $ff199815cdbd2fab$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $ff199815cdbd2fab$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $ff199815cdbd2fab$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $ff199815cdbd2fab$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $ff199815cdbd2fab$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($ff199815cdbd2fab$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $ff199815cdbd2fab$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $ff199815cdbd2fab$var$preloadPropsMap.get(instance$250)) instance = $ff199815cdbd2fab$var$assign({}, props), $ff199815cdbd2fab$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $ff199815cdbd2fab$var$markNodeAsHoistable(styleProps);
            $ff199815cdbd2fab$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $ff199815cdbd2fab$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $ff199815cdbd2fab$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $ff199815cdbd2fab$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $ff199815cdbd2fab$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $ff199815cdbd2fab$var$tagCaches = null;
function $ff199815cdbd2fab$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $ff199815cdbd2fab$var$tagCaches) {
        var cache = new Map();
        var caches = $ff199815cdbd2fab$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $ff199815cdbd2fab$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$ff199815cdbd2fab$var$internalHoistableMarker] || node[$ff199815cdbd2fab$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $ff199815cdbd2fab$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $ff199815cdbd2fab$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $ff199815cdbd2fab$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $ff199815cdbd2fab$var$suspendedState = null;
function $ff199815cdbd2fab$var$noop() {}
function $ff199815cdbd2fab$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $ff199815cdbd2fab$var$suspendedState) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(475));
    var state = $ff199815cdbd2fab$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $ff199815cdbd2fab$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($ff199815cdbd2fab$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $ff199815cdbd2fab$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $ff199815cdbd2fab$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $ff199815cdbd2fab$var$stylesheetPropsFromRawProps(props);
            (key = $ff199815cdbd2fab$var$preloadPropsMap.get(key)) && $ff199815cdbd2fab$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $ff199815cdbd2fab$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $ff199815cdbd2fab$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $ff199815cdbd2fab$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $ff199815cdbd2fab$var$waitForCommitToBeReady() {
    if (null === $ff199815cdbd2fab$var$suspendedState) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(475));
    var state = $ff199815cdbd2fab$var$suspendedState;
    state.stylesheets && 0 === state.count && $ff199815cdbd2fab$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $ff199815cdbd2fab$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $ff199815cdbd2fab$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $ff199815cdbd2fab$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $ff199815cdbd2fab$var$precedencesByRoot = null;
function $ff199815cdbd2fab$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $ff199815cdbd2fab$var$precedencesByRoot = new Map(), resources.forEach($ff199815cdbd2fab$var$insertStylesheetIntoRoot, state), $ff199815cdbd2fab$var$precedencesByRoot = null, $ff199815cdbd2fab$var$onUnsuspend.call(state));
}
function $ff199815cdbd2fab$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $ff199815cdbd2fab$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $ff199815cdbd2fab$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $ff199815cdbd2fab$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $ff199815cdbd2fab$var$HostTransitionContext = {
    $$typeof: $ff199815cdbd2fab$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $ff199815cdbd2fab$var$sharedNotPendingObject,
    _currentValue2: $ff199815cdbd2fab$var$sharedNotPendingObject,
    _threadCount: 0
};
function $ff199815cdbd2fab$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $ff199815cdbd2fab$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $ff199815cdbd2fab$var$createLaneMap(0);
    this.hiddenUpdates = $ff199815cdbd2fab$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $ff199815cdbd2fab$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $ff199815cdbd2fab$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $ff199815cdbd2fab$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $ff199815cdbd2fab$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $ff199815cdbd2fab$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $ff199815cdbd2fab$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $ff199815cdbd2fab$var$emptyContextObject;
    parentComponent = $ff199815cdbd2fab$var$emptyContextObject;
    return parentComponent;
}
function $ff199815cdbd2fab$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $ff199815cdbd2fab$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $ff199815cdbd2fab$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $ff199815cdbd2fab$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($ff199815cdbd2fab$var$scheduleUpdateOnFiber(element, rootFiber, lane), $ff199815cdbd2fab$var$entangleTransitions(element, rootFiber, lane));
}
function $ff199815cdbd2fab$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $ff199815cdbd2fab$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $ff199815cdbd2fab$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $ff199815cdbd2fab$var$markRetryLaneImpl(fiber, retryLane);
}
function $ff199815cdbd2fab$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $ff199815cdbd2fab$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $ff199815cdbd2fab$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $ff199815cdbd2fab$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $ff199815cdbd2fab$var$_enabled = !0;
function $ff199815cdbd2fab$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $ff199815cdbd2fab$var$ReactSharedInternals.T;
    $ff199815cdbd2fab$var$ReactSharedInternals.T = null;
    var previousPriority = $ff199815cdbd2fab$var$ReactDOMSharedInternals.p;
    try {
        $ff199815cdbd2fab$var$ReactDOMSharedInternals.p = 2, $ff199815cdbd2fab$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $ff199815cdbd2fab$var$ReactDOMSharedInternals.p = previousPriority, $ff199815cdbd2fab$var$ReactSharedInternals.T = prevTransition;
    }
}
function $ff199815cdbd2fab$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $ff199815cdbd2fab$var$ReactSharedInternals.T;
    $ff199815cdbd2fab$var$ReactSharedInternals.T = null;
    var previousPriority = $ff199815cdbd2fab$var$ReactDOMSharedInternals.p;
    try {
        $ff199815cdbd2fab$var$ReactDOMSharedInternals.p = 8, $ff199815cdbd2fab$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $ff199815cdbd2fab$var$ReactDOMSharedInternals.p = previousPriority, $ff199815cdbd2fab$var$ReactSharedInternals.T = prevTransition;
    }
}
function $ff199815cdbd2fab$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($ff199815cdbd2fab$var$_enabled) {
        var blockedOn = $ff199815cdbd2fab$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $ff199815cdbd2fab$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $ff199815cdbd2fab$var$return_targetInst, targetContainer), $ff199815cdbd2fab$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($ff199815cdbd2fab$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($ff199815cdbd2fab$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $ff199815cdbd2fab$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $ff199815cdbd2fab$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $ff199815cdbd2fab$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $ff199815cdbd2fab$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $ff199815cdbd2fab$var$ensureRootIsScheduled(fiber);
                                0 === ($ff199815cdbd2fab$var$executionContext & 6) && ($ff199815cdbd2fab$var$workInProgressRootRenderTargetTime = $ff199815cdbd2fab$var$now() + 500, $ff199815cdbd2fab$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $ff199815cdbd2fab$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $ff199815cdbd2fab$var$scheduleUpdateOnFiber(root, fiber, 2), $ff199815cdbd2fab$var$flushSyncWork$1(), $ff199815cdbd2fab$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $ff199815cdbd2fab$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $ff199815cdbd2fab$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $ff199815cdbd2fab$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $ff199815cdbd2fab$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $ff199815cdbd2fab$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $ff199815cdbd2fab$var$getEventTarget(nativeEvent);
    return $ff199815cdbd2fab$var$findInstanceBlockingTarget(nativeEvent);
}
var $ff199815cdbd2fab$var$return_targetInst = null;
function $ff199815cdbd2fab$var$findInstanceBlockingTarget(targetNode) {
    $ff199815cdbd2fab$var$return_targetInst = null;
    targetNode = $ff199815cdbd2fab$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $ff199815cdbd2fab$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $ff199815cdbd2fab$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $ff199815cdbd2fab$var$return_targetInst = targetNode;
    return null;
}
function $ff199815cdbd2fab$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($ff199815cdbd2fab$var$getCurrentPriorityLevel()){
                case $ff199815cdbd2fab$var$ImmediatePriority:
                    return 2;
                case $ff199815cdbd2fab$var$UserBlockingPriority:
                    return 8;
                case $ff199815cdbd2fab$var$NormalPriority$1:
                case $ff199815cdbd2fab$var$LowPriority:
                    return 32;
                case $ff199815cdbd2fab$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $ff199815cdbd2fab$var$hasScheduledReplayAttempt = !1, $ff199815cdbd2fab$var$queuedFocus = null, $ff199815cdbd2fab$var$queuedDrag = null, $ff199815cdbd2fab$var$queuedMouse = null, $ff199815cdbd2fab$var$queuedPointers = new Map(), $ff199815cdbd2fab$var$queuedPointerCaptures = new Map(), $ff199815cdbd2fab$var$queuedExplicitHydrationTargets = [], $ff199815cdbd2fab$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $ff199815cdbd2fab$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $ff199815cdbd2fab$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $ff199815cdbd2fab$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $ff199815cdbd2fab$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $ff199815cdbd2fab$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $ff199815cdbd2fab$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $ff199815cdbd2fab$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $ff199815cdbd2fab$var$getInstanceFromNode(blockedOn), null !== blockedOn && $ff199815cdbd2fab$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $ff199815cdbd2fab$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $ff199815cdbd2fab$var$queuedFocus = $ff199815cdbd2fab$var$accumulateOrCreateContinuousQueuedReplayableEvent($ff199815cdbd2fab$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $ff199815cdbd2fab$var$queuedDrag = $ff199815cdbd2fab$var$accumulateOrCreateContinuousQueuedReplayableEvent($ff199815cdbd2fab$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $ff199815cdbd2fab$var$queuedMouse = $ff199815cdbd2fab$var$accumulateOrCreateContinuousQueuedReplayableEvent($ff199815cdbd2fab$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $ff199815cdbd2fab$var$queuedPointers.set(pointerId, $ff199815cdbd2fab$var$accumulateOrCreateContinuousQueuedReplayableEvent($ff199815cdbd2fab$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $ff199815cdbd2fab$var$queuedPointerCaptures.set(pointerId, $ff199815cdbd2fab$var$accumulateOrCreateContinuousQueuedReplayableEvent($ff199815cdbd2fab$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $ff199815cdbd2fab$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $ff199815cdbd2fab$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $ff199815cdbd2fab$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $ff199815cdbd2fab$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $ff199815cdbd2fab$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $ff199815cdbd2fab$var$requestUpdateLane();
                            lane = $ff199815cdbd2fab$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $ff199815cdbd2fab$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $ff199815cdbd2fab$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $ff199815cdbd2fab$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $ff199815cdbd2fab$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $ff199815cdbd2fab$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $ff199815cdbd2fab$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $ff199815cdbd2fab$var$currentReplayingEvent = null;
        } else return targetContainers = $ff199815cdbd2fab$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $ff199815cdbd2fab$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $ff199815cdbd2fab$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $ff199815cdbd2fab$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $ff199815cdbd2fab$var$replayUnblockedEvents() {
    $ff199815cdbd2fab$var$hasScheduledReplayAttempt = !1;
    null !== $ff199815cdbd2fab$var$queuedFocus && $ff199815cdbd2fab$var$attemptReplayContinuousQueuedEvent($ff199815cdbd2fab$var$queuedFocus) && ($ff199815cdbd2fab$var$queuedFocus = null);
    null !== $ff199815cdbd2fab$var$queuedDrag && $ff199815cdbd2fab$var$attemptReplayContinuousQueuedEvent($ff199815cdbd2fab$var$queuedDrag) && ($ff199815cdbd2fab$var$queuedDrag = null);
    null !== $ff199815cdbd2fab$var$queuedMouse && $ff199815cdbd2fab$var$attemptReplayContinuousQueuedEvent($ff199815cdbd2fab$var$queuedMouse) && ($ff199815cdbd2fab$var$queuedMouse = null);
    $ff199815cdbd2fab$var$queuedPointers.forEach($ff199815cdbd2fab$var$attemptReplayContinuousQueuedEventInMap);
    $ff199815cdbd2fab$var$queuedPointerCaptures.forEach($ff199815cdbd2fab$var$attemptReplayContinuousQueuedEventInMap);
}
function $ff199815cdbd2fab$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $ff199815cdbd2fab$var$hasScheduledReplayAttempt || ($ff199815cdbd2fab$var$hasScheduledReplayAttempt = !0, $bIbAw.unstable_scheduleCallback($bIbAw.unstable_NormalPriority, $ff199815cdbd2fab$var$replayUnblockedEvents)));
}
var $ff199815cdbd2fab$var$lastScheduledReplayQueue = null;
function $ff199815cdbd2fab$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $ff199815cdbd2fab$var$lastScheduledReplayQueue !== formReplayingQueue && ($ff199815cdbd2fab$var$lastScheduledReplayQueue = formReplayingQueue, $bIbAw.unstable_scheduleCallback($bIbAw.unstable_NormalPriority, function() {
        $ff199815cdbd2fab$var$lastScheduledReplayQueue === formReplayingQueue && ($ff199815cdbd2fab$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $ff199815cdbd2fab$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $ff199815cdbd2fab$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $ff199815cdbd2fab$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $ff199815cdbd2fab$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $ff199815cdbd2fab$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $ff199815cdbd2fab$var$queuedFocus && $ff199815cdbd2fab$var$scheduleCallbackIfUnblocked($ff199815cdbd2fab$var$queuedFocus, unblocked);
    null !== $ff199815cdbd2fab$var$queuedDrag && $ff199815cdbd2fab$var$scheduleCallbackIfUnblocked($ff199815cdbd2fab$var$queuedDrag, unblocked);
    null !== $ff199815cdbd2fab$var$queuedMouse && $ff199815cdbd2fab$var$scheduleCallbackIfUnblocked($ff199815cdbd2fab$var$queuedMouse, unblocked);
    $ff199815cdbd2fab$var$queuedPointers.forEach(unblock);
    $ff199815cdbd2fab$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $ff199815cdbd2fab$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $ff199815cdbd2fab$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $ff199815cdbd2fab$var$queuedExplicitHydrationTargets.length && (i = $ff199815cdbd2fab$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$ff199815cdbd2fab$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $ff199815cdbd2fab$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$ff199815cdbd2fab$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $ff199815cdbd2fab$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$ff199815cdbd2fab$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $ff199815cdbd2fab$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $ff199815cdbd2fab$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $ff199815cdbd2fab$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$ff199815cdbd2fab$var$ReactDOMHydrationRoot.prototype.render = $ff199815cdbd2fab$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(409));
    var current = root.current, lane = $ff199815cdbd2fab$var$requestUpdateLane();
    $ff199815cdbd2fab$var$updateContainerImpl(current, lane, children, root, null, null);
};
$ff199815cdbd2fab$var$ReactDOMHydrationRoot.prototype.unmount = $ff199815cdbd2fab$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $ff199815cdbd2fab$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $ff199815cdbd2fab$var$flushSyncWork$1();
        container[$ff199815cdbd2fab$var$internalContainerInstanceKey] = null;
    }
};
function $ff199815cdbd2fab$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$ff199815cdbd2fab$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $ff199815cdbd2fab$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $ff199815cdbd2fab$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $ff199815cdbd2fab$var$queuedExplicitHydrationTargets[i].priority; i++);
        $ff199815cdbd2fab$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $ff199815cdbd2fab$var$attemptExplicitHydrationTarget(target);
    }
};
var $ff199815cdbd2fab$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $gRqVZ.version;
if ("19.1.0" !== $ff199815cdbd2fab$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(527, $ff199815cdbd2fab$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.0"));
$ff199815cdbd2fab$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $ff199815cdbd2fab$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $ff199815cdbd2fab$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $ff199815cdbd2fab$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $ff199815cdbd2fab$var$ReactSharedInternals,
    reconcilerVersion: "19.1.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $ff199815cdbd2fab$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$ff199815cdbd2fab$var$hook$jscomp$inline_2257.isDisabled && $ff199815cdbd2fab$var$hook$jscomp$inline_2257.supportsFiber) try {
        $ff199815cdbd2fab$var$rendererID = $ff199815cdbd2fab$var$hook$jscomp$inline_2257.inject($ff199815cdbd2fab$var$internals$jscomp$inline_2256), $ff199815cdbd2fab$var$injectedHook = $ff199815cdbd2fab$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$ff199815cdbd2fab$export$882461b6382ed46c = function(container, options) {
    if (!$ff199815cdbd2fab$var$isValidContainer(container)) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $ff199815cdbd2fab$var$defaultOnUncaughtError, onCaughtError = $ff199815cdbd2fab$var$defaultOnCaughtError, onRecoverableError = $ff199815cdbd2fab$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $ff199815cdbd2fab$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$ff199815cdbd2fab$var$internalContainerInstanceKey] = options.current;
    $ff199815cdbd2fab$var$listenToAllSupportedEvents(container);
    return new $ff199815cdbd2fab$var$ReactDOMRoot(options);
};
$ff199815cdbd2fab$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$ff199815cdbd2fab$var$isValidContainer(container)) throw Error($ff199815cdbd2fab$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $ff199815cdbd2fab$var$defaultOnUncaughtError, onCaughtError = $ff199815cdbd2fab$var$defaultOnCaughtError, onRecoverableError = $ff199815cdbd2fab$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $ff199815cdbd2fab$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $ff199815cdbd2fab$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $ff199815cdbd2fab$var$requestUpdateLane();
    isStrictMode = $ff199815cdbd2fab$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $ff199815cdbd2fab$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $ff199815cdbd2fab$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $ff199815cdbd2fab$var$markRootUpdated$1(initialChildren, options);
    $ff199815cdbd2fab$var$ensureRootIsScheduled(initialChildren);
    container[$ff199815cdbd2fab$var$internalContainerInstanceKey] = initialChildren.current;
    $ff199815cdbd2fab$var$listenToAllSupportedEvents(container);
    return new $ff199815cdbd2fab$var$ReactDOMHydrationRoot(initialChildren);
};
$ff199815cdbd2fab$export$83d89fbfd8236492 = "19.1.0";

});
parcelRegister("bIbAw", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gBUuL"));

});
parcelRegister("gBUuL", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $c17beccda67052ae$export$c4744153514ff05d; }, function (v) { return $c17beccda67052ae$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $c17beccda67052ae$export$3e506c1ccc9cc1a7; }, function (v) { return $c17beccda67052ae$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $c17beccda67052ae$export$e26fe2ed2fa76875; }, function (v) { return $c17beccda67052ae$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $c17beccda67052ae$export$502329bbf4b505b1; }, function (v) { return $c17beccda67052ae$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $c17beccda67052ae$export$6e3807111c4874c4; }, function (v) { return $c17beccda67052ae$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $c17beccda67052ae$export$c27134553091fb3a; }, function (v) { return $c17beccda67052ae$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $c17beccda67052ae$export$33ee1acdc04fd2a2; }, function (v) { return $c17beccda67052ae$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $c17beccda67052ae$export$b00a404bbd5edef2; }, function (v) { return $c17beccda67052ae$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $c17beccda67052ae$export$d66a1c1c77bd778b; }, function (v) { return $c17beccda67052ae$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $c17beccda67052ae$export$d3dfb8e4810cb555; }, function (v) { return $c17beccda67052ae$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $c17beccda67052ae$export$72fdf0e06517287b; }, function (v) { return $c17beccda67052ae$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $c17beccda67052ae$export$816d2913ae6b83b1; }, function (v) { return $c17beccda67052ae$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $c17beccda67052ae$export$61bcfe829111a1d0; }, function (v) { return $c17beccda67052ae$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $c17beccda67052ae$export$7ee8c9beb337bc3f; }, function (v) { return $c17beccda67052ae$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $c17beccda67052ae$export$b5836b71941fa3ed; }, function (v) { return $c17beccda67052ae$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $c17beccda67052ae$export$cf845f2c119da08a; }, function (v) { return $c17beccda67052ae$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c17beccda67052ae$export$c4744153514ff05d;
var $c17beccda67052ae$export$3e506c1ccc9cc1a7;
var $c17beccda67052ae$export$e26fe2ed2fa76875;
var $c17beccda67052ae$export$502329bbf4b505b1;
var $c17beccda67052ae$export$6e3807111c4874c4;
var $c17beccda67052ae$export$c27134553091fb3a;
var $c17beccda67052ae$export$33ee1acdc04fd2a2;
var $c17beccda67052ae$export$b00a404bbd5edef2;
var $c17beccda67052ae$export$d66a1c1c77bd778b;
var $c17beccda67052ae$export$d3dfb8e4810cb555;
var $c17beccda67052ae$export$72fdf0e06517287b;
var $c17beccda67052ae$export$816d2913ae6b83b1;
var $c17beccda67052ae$export$61bcfe829111a1d0;
var $c17beccda67052ae$export$7ee8c9beb337bc3f;
var $c17beccda67052ae$export$b5836b71941fa3ed;
var $c17beccda67052ae$export$cf845f2c119da08a;
"use strict";
function $c17beccda67052ae$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $c17beccda67052ae$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $c17beccda67052ae$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $c17beccda67052ae$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $c17beccda67052ae$var$compare(left, last)) rightIndex < length && 0 > $c17beccda67052ae$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $c17beccda67052ae$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $c17beccda67052ae$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$c17beccda67052ae$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $c17beccda67052ae$var$localPerformance = performance;
    $c17beccda67052ae$export$c4744153514ff05d = function() {
        return $c17beccda67052ae$var$localPerformance.now();
    };
} else {
    var $c17beccda67052ae$var$localDate = Date, $c17beccda67052ae$var$initialTime = $c17beccda67052ae$var$localDate.now();
    $c17beccda67052ae$export$c4744153514ff05d = function() {
        return $c17beccda67052ae$var$localDate.now() - $c17beccda67052ae$var$initialTime;
    };
}
var $c17beccda67052ae$var$taskQueue = [], $c17beccda67052ae$var$timerQueue = [], $c17beccda67052ae$var$taskIdCounter = 1, $c17beccda67052ae$var$currentTask = null, $c17beccda67052ae$var$currentPriorityLevel = 3, $c17beccda67052ae$var$isPerformingWork = !1, $c17beccda67052ae$var$isHostCallbackScheduled = !1, $c17beccda67052ae$var$isHostTimeoutScheduled = !1, $c17beccda67052ae$var$needsPaint = !1, $c17beccda67052ae$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $c17beccda67052ae$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $c17beccda67052ae$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $c17beccda67052ae$var$advanceTimers(currentTime) {
    for(var timer = $c17beccda67052ae$var$peek($c17beccda67052ae$var$timerQueue); null !== timer;){
        if (null === timer.callback) $c17beccda67052ae$var$pop($c17beccda67052ae$var$timerQueue);
        else if (timer.startTime <= currentTime) $c17beccda67052ae$var$pop($c17beccda67052ae$var$timerQueue), timer.sortIndex = timer.expirationTime, $c17beccda67052ae$var$push($c17beccda67052ae$var$taskQueue, timer);
        else break;
        timer = $c17beccda67052ae$var$peek($c17beccda67052ae$var$timerQueue);
    }
}
function $c17beccda67052ae$var$handleTimeout(currentTime) {
    $c17beccda67052ae$var$isHostTimeoutScheduled = !1;
    $c17beccda67052ae$var$advanceTimers(currentTime);
    if (!$c17beccda67052ae$var$isHostCallbackScheduled) {
        if (null !== $c17beccda67052ae$var$peek($c17beccda67052ae$var$taskQueue)) $c17beccda67052ae$var$isHostCallbackScheduled = !0, $c17beccda67052ae$var$isMessageLoopRunning || ($c17beccda67052ae$var$isMessageLoopRunning = !0, $c17beccda67052ae$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $c17beccda67052ae$var$peek($c17beccda67052ae$var$timerQueue);
            null !== firstTimer && $c17beccda67052ae$var$requestHostTimeout($c17beccda67052ae$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $c17beccda67052ae$var$isMessageLoopRunning = !1, $c17beccda67052ae$var$taskTimeoutID = -1, $c17beccda67052ae$var$frameInterval = 5, $c17beccda67052ae$var$startTime = -1;
function $c17beccda67052ae$var$shouldYieldToHost() {
    return $c17beccda67052ae$var$needsPaint ? !0 : $c17beccda67052ae$export$c4744153514ff05d() - $c17beccda67052ae$var$startTime < $c17beccda67052ae$var$frameInterval ? !1 : !0;
}
function $c17beccda67052ae$var$performWorkUntilDeadline() {
    $c17beccda67052ae$var$needsPaint = !1;
    if ($c17beccda67052ae$var$isMessageLoopRunning) {
        var currentTime = $c17beccda67052ae$export$c4744153514ff05d();
        $c17beccda67052ae$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $c17beccda67052ae$var$isHostCallbackScheduled = !1;
                $c17beccda67052ae$var$isHostTimeoutScheduled && ($c17beccda67052ae$var$isHostTimeoutScheduled = !1, $c17beccda67052ae$var$localClearTimeout($c17beccda67052ae$var$taskTimeoutID), $c17beccda67052ae$var$taskTimeoutID = -1);
                $c17beccda67052ae$var$isPerformingWork = !0;
                var previousPriorityLevel = $c17beccda67052ae$var$currentPriorityLevel;
                try {
                    b: {
                        $c17beccda67052ae$var$advanceTimers(currentTime);
                        for($c17beccda67052ae$var$currentTask = $c17beccda67052ae$var$peek($c17beccda67052ae$var$taskQueue); null !== $c17beccda67052ae$var$currentTask && !($c17beccda67052ae$var$currentTask.expirationTime > currentTime && $c17beccda67052ae$var$shouldYieldToHost());){
                            var callback = $c17beccda67052ae$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $c17beccda67052ae$var$currentTask.callback = null;
                                $c17beccda67052ae$var$currentPriorityLevel = $c17beccda67052ae$var$currentTask.priorityLevel;
                                var continuationCallback = callback($c17beccda67052ae$var$currentTask.expirationTime <= currentTime);
                                currentTime = $c17beccda67052ae$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $c17beccda67052ae$var$currentTask.callback = continuationCallback;
                                    $c17beccda67052ae$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $c17beccda67052ae$var$currentTask === $c17beccda67052ae$var$peek($c17beccda67052ae$var$taskQueue) && $c17beccda67052ae$var$pop($c17beccda67052ae$var$taskQueue);
                                $c17beccda67052ae$var$advanceTimers(currentTime);
                            } else $c17beccda67052ae$var$pop($c17beccda67052ae$var$taskQueue);
                            $c17beccda67052ae$var$currentTask = $c17beccda67052ae$var$peek($c17beccda67052ae$var$taskQueue);
                        }
                        if (null !== $c17beccda67052ae$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $c17beccda67052ae$var$peek($c17beccda67052ae$var$timerQueue);
                            null !== firstTimer && $c17beccda67052ae$var$requestHostTimeout($c17beccda67052ae$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $c17beccda67052ae$var$currentTask = null, $c17beccda67052ae$var$currentPriorityLevel = previousPriorityLevel, $c17beccda67052ae$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $c17beccda67052ae$var$schedulePerformWorkUntilDeadline() : $c17beccda67052ae$var$isMessageLoopRunning = !1;
        }
    }
}
var $c17beccda67052ae$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $c17beccda67052ae$var$localSetImmediate) $c17beccda67052ae$var$schedulePerformWorkUntilDeadline = function() {
    $c17beccda67052ae$var$localSetImmediate($c17beccda67052ae$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $c17beccda67052ae$var$channel = new MessageChannel(), $c17beccda67052ae$var$port = $c17beccda67052ae$var$channel.port2;
    $c17beccda67052ae$var$channel.port1.onmessage = $c17beccda67052ae$var$performWorkUntilDeadline;
    $c17beccda67052ae$var$schedulePerformWorkUntilDeadline = function() {
        $c17beccda67052ae$var$port.postMessage(null);
    };
} else $c17beccda67052ae$var$schedulePerformWorkUntilDeadline = function() {
    $c17beccda67052ae$var$localSetTimeout($c17beccda67052ae$var$performWorkUntilDeadline, 0);
};
function $c17beccda67052ae$var$requestHostTimeout(callback, ms) {
    $c17beccda67052ae$var$taskTimeoutID = $c17beccda67052ae$var$localSetTimeout(function() {
        callback($c17beccda67052ae$export$c4744153514ff05d());
    }, ms);
}
$c17beccda67052ae$export$3e506c1ccc9cc1a7 = 5;
$c17beccda67052ae$export$e26fe2ed2fa76875 = 1;
$c17beccda67052ae$export$502329bbf4b505b1 = 4;
$c17beccda67052ae$export$6e3807111c4874c4 = 3;
$c17beccda67052ae$export$c27134553091fb3a = null;
$c17beccda67052ae$export$33ee1acdc04fd2a2 = 2;
$c17beccda67052ae$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$c17beccda67052ae$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $c17beccda67052ae$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$c17beccda67052ae$export$d3dfb8e4810cb555 = function() {
    return $c17beccda67052ae$var$currentPriorityLevel;
};
$c17beccda67052ae$export$72fdf0e06517287b = function(eventHandler) {
    switch($c17beccda67052ae$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $c17beccda67052ae$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $c17beccda67052ae$var$currentPriorityLevel;
    $c17beccda67052ae$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $c17beccda67052ae$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$c17beccda67052ae$export$816d2913ae6b83b1 = function() {
    $c17beccda67052ae$var$needsPaint = !0;
};
$c17beccda67052ae$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $c17beccda67052ae$var$currentPriorityLevel;
    $c17beccda67052ae$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $c17beccda67052ae$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$c17beccda67052ae$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $c17beccda67052ae$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $c17beccda67052ae$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $c17beccda67052ae$var$push($c17beccda67052ae$var$timerQueue, priorityLevel), null === $c17beccda67052ae$var$peek($c17beccda67052ae$var$taskQueue) && priorityLevel === $c17beccda67052ae$var$peek($c17beccda67052ae$var$timerQueue) && ($c17beccda67052ae$var$isHostTimeoutScheduled ? ($c17beccda67052ae$var$localClearTimeout($c17beccda67052ae$var$taskTimeoutID), $c17beccda67052ae$var$taskTimeoutID = -1) : $c17beccda67052ae$var$isHostTimeoutScheduled = !0, $c17beccda67052ae$var$requestHostTimeout($c17beccda67052ae$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $c17beccda67052ae$var$push($c17beccda67052ae$var$taskQueue, priorityLevel), $c17beccda67052ae$var$isHostCallbackScheduled || $c17beccda67052ae$var$isPerformingWork || ($c17beccda67052ae$var$isHostCallbackScheduled = !0, $c17beccda67052ae$var$isMessageLoopRunning || ($c17beccda67052ae$var$isMessageLoopRunning = !0, $c17beccda67052ae$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$c17beccda67052ae$export$b5836b71941fa3ed = $c17beccda67052ae$var$shouldYieldToHost;
$c17beccda67052ae$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $c17beccda67052ae$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $c17beccda67052ae$var$currentPriorityLevel;
        $c17beccda67052ae$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $c17beccda67052ae$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("gRqVZ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eT7Qk"));

});
parcelRegister("eT7Qk", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $02cc11b2741a3739$export$dca3b0875bd9a954; }, function (v) { return $02cc11b2741a3739$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $02cc11b2741a3739$export$16fa2f45be04daa8; }, function (v) { return $02cc11b2741a3739$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $02cc11b2741a3739$export$ffb0004e005737fa; }, function (v) { return $02cc11b2741a3739$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $02cc11b2741a3739$export$e2c29f18771995cb; }, function (v) { return $02cc11b2741a3739$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $02cc11b2741a3739$export$221d75b3f55bb0bd; }, function (v) { return $02cc11b2741a3739$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $02cc11b2741a3739$export$5f8d39834fd61797; }, function (v) { return $02cc11b2741a3739$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $02cc11b2741a3739$export$74bf444e3cd11ea5; }, function (v) { return $02cc11b2741a3739$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $02cc11b2741a3739$export$1ced07cd6b1985ce; }, function (v) { return $02cc11b2741a3739$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $02cc11b2741a3739$export$abd8e32b826d7ea7; }, function (v) { return $02cc11b2741a3739$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $02cc11b2741a3739$export$69a3209f1a06c04d; }, function (v) { return $02cc11b2741a3739$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $02cc11b2741a3739$export$e530037191fcd5d7; }, function (v) { return $02cc11b2741a3739$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $02cc11b2741a3739$export$fd42f52fd3ae1109; }, function (v) { return $02cc11b2741a3739$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $02cc11b2741a3739$export$c8a8987d4410bf2d; }, function (v) { return $02cc11b2741a3739$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $02cc11b2741a3739$export$7d1e3a5e95ceca43; }, function (v) { return $02cc11b2741a3739$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $02cc11b2741a3739$export$257a8862b851cb5b; }, function (v) { return $02cc11b2741a3739$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $02cc11b2741a3739$export$a8257692ac88316c; }, function (v) { return $02cc11b2741a3739$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $02cc11b2741a3739$export$488013bae63b21da; }, function (v) { return $02cc11b2741a3739$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $02cc11b2741a3739$export$7c73462e0d25e514; }, function (v) { return $02cc11b2741a3739$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $02cc11b2741a3739$export$7568632d0d33d16d; }, function (v) { return $02cc11b2741a3739$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $02cc11b2741a3739$export$f93f40ac0ca7e3a8; }, function (v) { return $02cc11b2741a3739$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $02cc11b2741a3739$export$1f96ae73734a86cc; }, function (v) { return $02cc11b2741a3739$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $02cc11b2741a3739$export$9a47ced3238df325; }, function (v) { return $02cc11b2741a3739$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $02cc11b2741a3739$export$35808ee640e87ca7; }, function (v) { return $02cc11b2741a3739$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $02cc11b2741a3739$export$fae74005e78b1a27; }, function (v) { return $02cc11b2741a3739$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $02cc11b2741a3739$export$dc8fbce3eb94dc1e; }, function (v) { return $02cc11b2741a3739$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $02cc11b2741a3739$export$6a7bc4e911dc01cf; }, function (v) { return $02cc11b2741a3739$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $02cc11b2741a3739$export$6d9c69b0de29b591; }, function (v) { return $02cc11b2741a3739$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $02cc11b2741a3739$export$f680877a34711e37; }, function (v) { return $02cc11b2741a3739$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $02cc11b2741a3739$export$d5a552a76deda3c2; }, function (v) { return $02cc11b2741a3739$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $02cc11b2741a3739$export$aaabe4eda9ed9969; }, function (v) { return $02cc11b2741a3739$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $02cc11b2741a3739$export$e5c5a5f917a5871c; }, function (v) { return $02cc11b2741a3739$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $02cc11b2741a3739$export$1538c33de8887b59; }, function (v) { return $02cc11b2741a3739$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $02cc11b2741a3739$export$fca7f784ae7a249a; }, function (v) { return $02cc11b2741a3739$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $02cc11b2741a3739$export$13e3392192263954; }, function (v) { return $02cc11b2741a3739$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $02cc11b2741a3739$export$b8f5890fc79d6aca; }, function (v) { return $02cc11b2741a3739$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $02cc11b2741a3739$export$60241385465d0a34; }, function (v) { return $02cc11b2741a3739$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $02cc11b2741a3739$export$306c0aa65ff9ec16; }, function (v) { return $02cc11b2741a3739$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $02cc11b2741a3739$export$7b286972b8d8ccbf; }, function (v) { return $02cc11b2741a3739$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $02cc11b2741a3739$export$83d89fbfd8236492; }, function (v) { return $02cc11b2741a3739$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $02cc11b2741a3739$export$dca3b0875bd9a954;
var $02cc11b2741a3739$export$16fa2f45be04daa8;
var $02cc11b2741a3739$export$ffb0004e005737fa;
var $02cc11b2741a3739$export$e2c29f18771995cb;
var $02cc11b2741a3739$export$221d75b3f55bb0bd;
var $02cc11b2741a3739$export$5f8d39834fd61797;
var $02cc11b2741a3739$export$74bf444e3cd11ea5;
var $02cc11b2741a3739$export$1ced07cd6b1985ce;
var $02cc11b2741a3739$export$abd8e32b826d7ea7;
var $02cc11b2741a3739$export$69a3209f1a06c04d;
var $02cc11b2741a3739$export$e530037191fcd5d7;
var $02cc11b2741a3739$export$fd42f52fd3ae1109;
var $02cc11b2741a3739$export$c8a8987d4410bf2d;
var $02cc11b2741a3739$export$7d1e3a5e95ceca43;
var $02cc11b2741a3739$export$257a8862b851cb5b;
var $02cc11b2741a3739$export$a8257692ac88316c;
var $02cc11b2741a3739$export$488013bae63b21da;
var $02cc11b2741a3739$export$7c73462e0d25e514;
var $02cc11b2741a3739$export$7568632d0d33d16d;
var $02cc11b2741a3739$export$f93f40ac0ca7e3a8;
var $02cc11b2741a3739$export$1f96ae73734a86cc;
var $02cc11b2741a3739$export$9a47ced3238df325;
var $02cc11b2741a3739$export$35808ee640e87ca7;
var $02cc11b2741a3739$export$fae74005e78b1a27;
var $02cc11b2741a3739$export$dc8fbce3eb94dc1e;
var $02cc11b2741a3739$export$6a7bc4e911dc01cf;
var $02cc11b2741a3739$export$6d9c69b0de29b591;
var $02cc11b2741a3739$export$f680877a34711e37;
var $02cc11b2741a3739$export$d5a552a76deda3c2;
var $02cc11b2741a3739$export$aaabe4eda9ed9969;
var $02cc11b2741a3739$export$e5c5a5f917a5871c;
var $02cc11b2741a3739$export$1538c33de8887b59;
var $02cc11b2741a3739$export$fca7f784ae7a249a;
var $02cc11b2741a3739$export$13e3392192263954;
var $02cc11b2741a3739$export$b8f5890fc79d6aca;
var $02cc11b2741a3739$export$60241385465d0a34;
var $02cc11b2741a3739$export$306c0aa65ff9ec16;
var $02cc11b2741a3739$export$7b286972b8d8ccbf;
var $02cc11b2741a3739$export$83d89fbfd8236492;
"use strict";
var $02cc11b2741a3739$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $02cc11b2741a3739$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $02cc11b2741a3739$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $02cc11b2741a3739$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $02cc11b2741a3739$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $02cc11b2741a3739$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $02cc11b2741a3739$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $02cc11b2741a3739$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $02cc11b2741a3739$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $02cc11b2741a3739$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $02cc11b2741a3739$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $02cc11b2741a3739$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $02cc11b2741a3739$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $02cc11b2741a3739$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$02cc11b2741a3739$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $02cc11b2741a3739$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $02cc11b2741a3739$var$assign = Object.assign, $02cc11b2741a3739$var$emptyObject = {};
function $02cc11b2741a3739$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $02cc11b2741a3739$var$emptyObject;
    this.updater = updater || $02cc11b2741a3739$var$ReactNoopUpdateQueue;
}
$02cc11b2741a3739$var$Component.prototype.isReactComponent = {};
$02cc11b2741a3739$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$02cc11b2741a3739$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $02cc11b2741a3739$var$ComponentDummy() {}
$02cc11b2741a3739$var$ComponentDummy.prototype = $02cc11b2741a3739$var$Component.prototype;
function $02cc11b2741a3739$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $02cc11b2741a3739$var$emptyObject;
    this.updater = updater || $02cc11b2741a3739$var$ReactNoopUpdateQueue;
}
var $02cc11b2741a3739$var$pureComponentPrototype = $02cc11b2741a3739$var$PureComponent.prototype = new $02cc11b2741a3739$var$ComponentDummy();
$02cc11b2741a3739$var$pureComponentPrototype.constructor = $02cc11b2741a3739$var$PureComponent;
$02cc11b2741a3739$var$assign($02cc11b2741a3739$var$pureComponentPrototype, $02cc11b2741a3739$var$Component.prototype);
$02cc11b2741a3739$var$pureComponentPrototype.isPureReactComponent = !0;
var $02cc11b2741a3739$var$isArrayImpl = Array.isArray, $02cc11b2741a3739$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $02cc11b2741a3739$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $02cc11b2741a3739$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $02cc11b2741a3739$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $02cc11b2741a3739$var$cloneAndReplaceKey(oldElement, newKey) {
    return $02cc11b2741a3739$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $02cc11b2741a3739$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $02cc11b2741a3739$var$REACT_ELEMENT_TYPE;
}
function $02cc11b2741a3739$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $02cc11b2741a3739$var$userProvidedKeyEscapeRegex = /\/+/g;
function $02cc11b2741a3739$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $02cc11b2741a3739$var$escape("" + element.key) : index.toString(36);
}
function $02cc11b2741a3739$var$noop$1() {}
function $02cc11b2741a3739$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($02cc11b2741a3739$var$noop$1, $02cc11b2741a3739$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $02cc11b2741a3739$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $02cc11b2741a3739$var$REACT_ELEMENT_TYPE:
                case $02cc11b2741a3739$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $02cc11b2741a3739$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $02cc11b2741a3739$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $02cc11b2741a3739$var$getElementKey(children, 0) : nameSoFar, $02cc11b2741a3739$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($02cc11b2741a3739$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $02cc11b2741a3739$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($02cc11b2741a3739$var$isValidElement(callback) && (callback = $02cc11b2741a3739$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($02cc11b2741a3739$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($02cc11b2741a3739$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $02cc11b2741a3739$var$getElementKey(nameSoFar, i), invokeCallback += $02cc11b2741a3739$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $02cc11b2741a3739$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $02cc11b2741a3739$var$getElementKey(nameSoFar, i++), invokeCallback += $02cc11b2741a3739$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $02cc11b2741a3739$var$mapIntoArray($02cc11b2741a3739$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $02cc11b2741a3739$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $02cc11b2741a3739$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $02cc11b2741a3739$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $02cc11b2741a3739$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $02cc11b2741a3739$var$noop() {}
$02cc11b2741a3739$export$dca3b0875bd9a954 = {
    map: $02cc11b2741a3739$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $02cc11b2741a3739$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $02cc11b2741a3739$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $02cc11b2741a3739$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$02cc11b2741a3739$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$02cc11b2741a3739$export$16fa2f45be04daa8 = $02cc11b2741a3739$var$Component;
$02cc11b2741a3739$export$ffb0004e005737fa = $02cc11b2741a3739$var$REACT_FRAGMENT_TYPE;
$02cc11b2741a3739$export$e2c29f18771995cb = $02cc11b2741a3739$var$REACT_PROFILER_TYPE;
$02cc11b2741a3739$export$221d75b3f55bb0bd = $02cc11b2741a3739$var$PureComponent;
$02cc11b2741a3739$export$5f8d39834fd61797 = $02cc11b2741a3739$var$REACT_STRICT_MODE_TYPE;
$02cc11b2741a3739$export$74bf444e3cd11ea5 = $02cc11b2741a3739$var$REACT_SUSPENSE_TYPE;
$02cc11b2741a3739$export$1ced07cd6b1985ce = $02cc11b2741a3739$var$ReactSharedInternals;
$02cc11b2741a3739$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $02cc11b2741a3739$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$02cc11b2741a3739$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$02cc11b2741a3739$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $02cc11b2741a3739$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$02cc11b2741a3739$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $02cc11b2741a3739$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$02cc11b2741a3739$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $02cc11b2741a3739$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $02cc11b2741a3739$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$02cc11b2741a3739$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$02cc11b2741a3739$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $02cc11b2741a3739$var$ReactElement(type, key, void 0, void 0, null, props);
};
$02cc11b2741a3739$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$02cc11b2741a3739$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $02cc11b2741a3739$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$02cc11b2741a3739$export$a8257692ac88316c = $02cc11b2741a3739$var$isValidElement;
$02cc11b2741a3739$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $02cc11b2741a3739$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $02cc11b2741a3739$var$lazyInitializer
    };
};
$02cc11b2741a3739$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $02cc11b2741a3739$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$02cc11b2741a3739$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $02cc11b2741a3739$var$ReactSharedInternals.T, currentTransition = {};
    $02cc11b2741a3739$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $02cc11b2741a3739$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($02cc11b2741a3739$var$noop, $02cc11b2741a3739$var$reportGlobalError);
    } catch (error) {
        $02cc11b2741a3739$var$reportGlobalError(error);
    } finally{
        $02cc11b2741a3739$var$ReactSharedInternals.T = prevTransition;
    }
};
$02cc11b2741a3739$export$f93f40ac0ca7e3a8 = function() {
    return $02cc11b2741a3739$var$ReactSharedInternals.H.useCacheRefresh();
};
$02cc11b2741a3739$export$1f96ae73734a86cc = function(usable) {
    return $02cc11b2741a3739$var$ReactSharedInternals.H.use(usable);
};
$02cc11b2741a3739$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $02cc11b2741a3739$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$02cc11b2741a3739$export$35808ee640e87ca7 = function(callback, deps) {
    return $02cc11b2741a3739$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$02cc11b2741a3739$export$fae74005e78b1a27 = function(Context) {
    return $02cc11b2741a3739$var$ReactSharedInternals.H.useContext(Context);
};
$02cc11b2741a3739$export$dc8fbce3eb94dc1e = function() {};
$02cc11b2741a3739$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $02cc11b2741a3739$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$02cc11b2741a3739$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $02cc11b2741a3739$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$02cc11b2741a3739$export$f680877a34711e37 = function() {
    return $02cc11b2741a3739$var$ReactSharedInternals.H.useId();
};
$02cc11b2741a3739$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $02cc11b2741a3739$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$02cc11b2741a3739$export$aaabe4eda9ed9969 = function(create, deps) {
    return $02cc11b2741a3739$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$02cc11b2741a3739$export$e5c5a5f917a5871c = function(create, deps) {
    return $02cc11b2741a3739$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$02cc11b2741a3739$export$1538c33de8887b59 = function(create, deps) {
    return $02cc11b2741a3739$var$ReactSharedInternals.H.useMemo(create, deps);
};
$02cc11b2741a3739$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $02cc11b2741a3739$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$02cc11b2741a3739$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $02cc11b2741a3739$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$02cc11b2741a3739$export$b8f5890fc79d6aca = function(initialValue) {
    return $02cc11b2741a3739$var$ReactSharedInternals.H.useRef(initialValue);
};
$02cc11b2741a3739$export$60241385465d0a34 = function(initialState) {
    return $02cc11b2741a3739$var$ReactSharedInternals.H.useState(initialState);
};
$02cc11b2741a3739$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $02cc11b2741a3739$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$02cc11b2741a3739$export$7b286972b8d8ccbf = function() {
    return $02cc11b2741a3739$var$ReactSharedInternals.H.useTransition();
};
$02cc11b2741a3739$export$83d89fbfd8236492 = "19.1.0";

});


parcelRegister("hYKvr", function(module, exports) {
'use strict';
function $d16c1d63edd56b07$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d16c1d63edd56b07$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d16c1d63edd56b07$var$checkDCE();

module.exports = (parcelRequire("hEVCW"));

});
parcelRegister("hEVCW", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $cdb2dfa3fbc3251d$export$69ce8ef3fe5cead0; }, function (v) { return $cdb2dfa3fbc3251d$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $cdb2dfa3fbc3251d$export$d39a5bbd09211389; }, function (v) { return $cdb2dfa3fbc3251d$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $cdb2dfa3fbc3251d$export$cd75ccfd720a3cd4; }, function (v) { return $cdb2dfa3fbc3251d$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $cdb2dfa3fbc3251d$export$a0816fa17a9e79be; }, function (v) { return $cdb2dfa3fbc3251d$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $cdb2dfa3fbc3251d$export$7292efcadded39f3; }, function (v) { return $cdb2dfa3fbc3251d$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $cdb2dfa3fbc3251d$export$da407abadb9b8f86; }, function (v) { return $cdb2dfa3fbc3251d$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $cdb2dfa3fbc3251d$export$314cfea32580671c; }, function (v) { return $cdb2dfa3fbc3251d$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $cdb2dfa3fbc3251d$export$513ccb98c53b8039; }, function (v) { return $cdb2dfa3fbc3251d$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $cdb2dfa3fbc3251d$export$dbca993bc2d264a; }, function (v) { return $cdb2dfa3fbc3251d$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $cdb2dfa3fbc3251d$export$4797a8006f0655d0; }, function (v) { return $cdb2dfa3fbc3251d$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $cdb2dfa3fbc3251d$export$c78a37762a8d58e1; }, function (v) { return $cdb2dfa3fbc3251d$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $cdb2dfa3fbc3251d$export$606f11b2eb45ecc6; }, function (v) { return $cdb2dfa3fbc3251d$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $cdb2dfa3fbc3251d$export$f7e8a0bf92324b1e; }, function (v) { return $cdb2dfa3fbc3251d$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $cdb2dfa3fbc3251d$export$83d89fbfd8236492; }, function (v) { return $cdb2dfa3fbc3251d$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cdb2dfa3fbc3251d$export$69ce8ef3fe5cead0;
var $cdb2dfa3fbc3251d$export$d39a5bbd09211389;
var $cdb2dfa3fbc3251d$export$cd75ccfd720a3cd4;
var $cdb2dfa3fbc3251d$export$a0816fa17a9e79be;
var $cdb2dfa3fbc3251d$export$7292efcadded39f3;
var $cdb2dfa3fbc3251d$export$da407abadb9b8f86;
var $cdb2dfa3fbc3251d$export$314cfea32580671c;
var $cdb2dfa3fbc3251d$export$513ccb98c53b8039;
var $cdb2dfa3fbc3251d$export$dbca993bc2d264a;
var $cdb2dfa3fbc3251d$export$4797a8006f0655d0;
var $cdb2dfa3fbc3251d$export$c78a37762a8d58e1;
var $cdb2dfa3fbc3251d$export$606f11b2eb45ecc6;
var $cdb2dfa3fbc3251d$export$f7e8a0bf92324b1e;
var $cdb2dfa3fbc3251d$export$83d89fbfd8236492;
"use strict";

var $gRqVZ = parcelRequire("gRqVZ");
function $cdb2dfa3fbc3251d$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $cdb2dfa3fbc3251d$var$noop() {}
var $cdb2dfa3fbc3251d$var$Internals = {
    d: {
        f: $cdb2dfa3fbc3251d$var$noop,
        r: function() {
            throw Error($cdb2dfa3fbc3251d$var$formatProdErrorMessage(522));
        },
        D: $cdb2dfa3fbc3251d$var$noop,
        C: $cdb2dfa3fbc3251d$var$noop,
        L: $cdb2dfa3fbc3251d$var$noop,
        m: $cdb2dfa3fbc3251d$var$noop,
        X: $cdb2dfa3fbc3251d$var$noop,
        S: $cdb2dfa3fbc3251d$var$noop,
        M: $cdb2dfa3fbc3251d$var$noop
    },
    p: 0,
    findDOMNode: null
}, $cdb2dfa3fbc3251d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $cdb2dfa3fbc3251d$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $cdb2dfa3fbc3251d$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $cdb2dfa3fbc3251d$var$ReactSharedInternals = $gRqVZ.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $cdb2dfa3fbc3251d$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$cdb2dfa3fbc3251d$export$69ce8ef3fe5cead0 = $cdb2dfa3fbc3251d$var$Internals;
$cdb2dfa3fbc3251d$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($cdb2dfa3fbc3251d$var$formatProdErrorMessage(299));
    return $cdb2dfa3fbc3251d$var$createPortal$1(children, container, null, key);
};
$cdb2dfa3fbc3251d$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $cdb2dfa3fbc3251d$var$ReactSharedInternals.T, previousUpdatePriority = $cdb2dfa3fbc3251d$var$Internals.p;
    try {
        if ($cdb2dfa3fbc3251d$var$ReactSharedInternals.T = null, $cdb2dfa3fbc3251d$var$Internals.p = 2, fn) return fn();
    } finally{
        $cdb2dfa3fbc3251d$var$ReactSharedInternals.T = previousTransition, $cdb2dfa3fbc3251d$var$Internals.p = previousUpdatePriority, $cdb2dfa3fbc3251d$var$Internals.d.f();
    }
};
$cdb2dfa3fbc3251d$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $cdb2dfa3fbc3251d$var$Internals.d.C(href, options));
};
$cdb2dfa3fbc3251d$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $cdb2dfa3fbc3251d$var$Internals.d.D(href);
};
$cdb2dfa3fbc3251d$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $cdb2dfa3fbc3251d$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $cdb2dfa3fbc3251d$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $cdb2dfa3fbc3251d$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$cdb2dfa3fbc3251d$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $cdb2dfa3fbc3251d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $cdb2dfa3fbc3251d$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $cdb2dfa3fbc3251d$var$Internals.d.M(href);
    }
};
$cdb2dfa3fbc3251d$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $cdb2dfa3fbc3251d$var$getCrossOriginStringAs(as, options.crossOrigin);
        $cdb2dfa3fbc3251d$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$cdb2dfa3fbc3251d$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $cdb2dfa3fbc3251d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $cdb2dfa3fbc3251d$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $cdb2dfa3fbc3251d$var$Internals.d.m(href);
    }
};
$cdb2dfa3fbc3251d$export$4797a8006f0655d0 = function(form) {
    $cdb2dfa3fbc3251d$var$Internals.d.r(form);
};
$cdb2dfa3fbc3251d$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$cdb2dfa3fbc3251d$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $cdb2dfa3fbc3251d$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$cdb2dfa3fbc3251d$export$f7e8a0bf92324b1e = function() {
    return $cdb2dfa3fbc3251d$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$cdb2dfa3fbc3251d$export$83d89fbfd8236492 = "19.1.0";

});



parcelRegister("lVnei", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $ff60f0c2944f86e7$export$2b8d127b894957b9; }, function (v) { return $ff60f0c2944f86e7$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $ff60f0c2944f86e7$export$cea3a54a6425200c; }, function (v) { return $ff60f0c2944f86e7$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $ff60f0c2944f86e7$export$a7c73072b1a182ae; }, function (v) { return $ff60f0c2944f86e7$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $ff60f0c2944f86e7$export$9f27bc3417b4524d; }, function (v) { return $ff60f0c2944f86e7$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $ff60f0c2944f86e7$export$db77ccec0bb4ccac; }, function (v) { return $ff60f0c2944f86e7$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $ff60f0c2944f86e7$export$8392c0c9d3dcbd35; }, function (v) { return $ff60f0c2944f86e7$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ff60f0c2944f86e7$export$ffb0004e005737fa; }, function (v) { return $ff60f0c2944f86e7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $ff60f0c2944f86e7$export$b624eff549462981; }, function (v) { return $ff60f0c2944f86e7$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $ff60f0c2944f86e7$export$7897aa7841a5380c; }, function (v) { return $ff60f0c2944f86e7$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $ff60f0c2944f86e7$export$602eac185826482c; }, function (v) { return $ff60f0c2944f86e7$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $ff60f0c2944f86e7$export$e2c29f18771995cb; }, function (v) { return $ff60f0c2944f86e7$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ff60f0c2944f86e7$export$5f8d39834fd61797; }, function (v) { return $ff60f0c2944f86e7$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ff60f0c2944f86e7$export$74bf444e3cd11ea5; }, function (v) { return $ff60f0c2944f86e7$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $ff60f0c2944f86e7$export$92387174baf9b227; }, function (v) { return $ff60f0c2944f86e7$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $ff60f0c2944f86e7$export$ec112efeb987d9c6; }, function (v) { return $ff60f0c2944f86e7$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $ff60f0c2944f86e7$export$b706b080d889d2c9; }, function (v) { return $ff60f0c2944f86e7$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $ff60f0c2944f86e7$export$5be5a87408f70ddc; }, function (v) { return $ff60f0c2944f86e7$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $ff60f0c2944f86e7$export$45a5e7f76e0caa8d; }, function (v) { return $ff60f0c2944f86e7$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $ff60f0c2944f86e7$export$455c2e768291efa6; }, function (v) { return $ff60f0c2944f86e7$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $ff60f0c2944f86e7$export$9522e17588c12572; }, function (v) { return $ff60f0c2944f86e7$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $ff60f0c2944f86e7$export$2110ac352bb060b9; }, function (v) { return $ff60f0c2944f86e7$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $ff60f0c2944f86e7$export$56885ab8b9c456ab; }, function (v) { return $ff60f0c2944f86e7$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $ff60f0c2944f86e7$export$d927fcb6adf8f9de; }, function (v) { return $ff60f0c2944f86e7$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $ff60f0c2944f86e7$export$b82d16f27459e05a; }, function (v) { return $ff60f0c2944f86e7$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $ff60f0c2944f86e7$export$522c17b4f5e123e8; }, function (v) { return $ff60f0c2944f86e7$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $ff60f0c2944f86e7$export$1aabd8a0274ecfd6; }, function (v) { return $ff60f0c2944f86e7$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $ff60f0c2944f86e7$export$9b621391a187a31a; }, function (v) { return $ff60f0c2944f86e7$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $ff60f0c2944f86e7$export$f5bbd400c2f4426f; }, function (v) { return $ff60f0c2944f86e7$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ff60f0c2944f86e7$export$2b8d127b894957b9;
var $ff60f0c2944f86e7$export$cea3a54a6425200c;
var $ff60f0c2944f86e7$export$a7c73072b1a182ae;
var $ff60f0c2944f86e7$export$9f27bc3417b4524d;
var $ff60f0c2944f86e7$export$db77ccec0bb4ccac;
var $ff60f0c2944f86e7$export$8392c0c9d3dcbd35;
var $ff60f0c2944f86e7$export$ffb0004e005737fa;
var $ff60f0c2944f86e7$export$b624eff549462981;
var $ff60f0c2944f86e7$export$7897aa7841a5380c;
var $ff60f0c2944f86e7$export$602eac185826482c;
var $ff60f0c2944f86e7$export$e2c29f18771995cb;
var $ff60f0c2944f86e7$export$5f8d39834fd61797;
var $ff60f0c2944f86e7$export$74bf444e3cd11ea5;
var $ff60f0c2944f86e7$export$92387174baf9b227;
var $ff60f0c2944f86e7$export$ec112efeb987d9c6;
var $ff60f0c2944f86e7$export$b706b080d889d2c9;
var $ff60f0c2944f86e7$export$5be5a87408f70ddc;
var $ff60f0c2944f86e7$export$45a5e7f76e0caa8d;
var $ff60f0c2944f86e7$export$455c2e768291efa6;
var $ff60f0c2944f86e7$export$9522e17588c12572;
var $ff60f0c2944f86e7$export$2110ac352bb060b9;
var $ff60f0c2944f86e7$export$56885ab8b9c456ab;
var $ff60f0c2944f86e7$export$d927fcb6adf8f9de;
var $ff60f0c2944f86e7$export$b82d16f27459e05a;
var $ff60f0c2944f86e7$export$522c17b4f5e123e8;
var $ff60f0c2944f86e7$export$1aabd8a0274ecfd6;
var $ff60f0c2944f86e7$export$9b621391a187a31a;
var $ff60f0c2944f86e7$export$f5bbd400c2f4426f;
'use strict';
var $ff60f0c2944f86e7$var$b = "function" === typeof Symbol && Symbol.for, $ff60f0c2944f86e7$var$c = $ff60f0c2944f86e7$var$b ? Symbol.for("react.element") : 60103, $ff60f0c2944f86e7$var$d = $ff60f0c2944f86e7$var$b ? Symbol.for("react.portal") : 60106, $ff60f0c2944f86e7$var$e = $ff60f0c2944f86e7$var$b ? Symbol.for("react.fragment") : 60107, $ff60f0c2944f86e7$var$f = $ff60f0c2944f86e7$var$b ? Symbol.for("react.strict_mode") : 60108, $ff60f0c2944f86e7$var$g = $ff60f0c2944f86e7$var$b ? Symbol.for("react.profiler") : 60114, $ff60f0c2944f86e7$var$h = $ff60f0c2944f86e7$var$b ? Symbol.for("react.provider") : 60109, $ff60f0c2944f86e7$var$k = $ff60f0c2944f86e7$var$b ? Symbol.for("react.context") : 60110, $ff60f0c2944f86e7$var$l = $ff60f0c2944f86e7$var$b ? Symbol.for("react.async_mode") : 60111, $ff60f0c2944f86e7$var$m = $ff60f0c2944f86e7$var$b ? Symbol.for("react.concurrent_mode") : 60111, $ff60f0c2944f86e7$var$n = $ff60f0c2944f86e7$var$b ? Symbol.for("react.forward_ref") : 60112, $ff60f0c2944f86e7$var$p = $ff60f0c2944f86e7$var$b ? Symbol.for("react.suspense") : 60113, $ff60f0c2944f86e7$var$q = $ff60f0c2944f86e7$var$b ? Symbol.for("react.suspense_list") : 60120, $ff60f0c2944f86e7$var$r = $ff60f0c2944f86e7$var$b ? Symbol.for("react.memo") : 60115, $ff60f0c2944f86e7$var$t = $ff60f0c2944f86e7$var$b ? Symbol.for("react.lazy") : 60116, $ff60f0c2944f86e7$var$v = $ff60f0c2944f86e7$var$b ? Symbol.for("react.block") : 60121, $ff60f0c2944f86e7$var$w = $ff60f0c2944f86e7$var$b ? Symbol.for("react.fundamental") : 60117, $ff60f0c2944f86e7$var$x = $ff60f0c2944f86e7$var$b ? Symbol.for("react.responder") : 60118, $ff60f0c2944f86e7$var$y = $ff60f0c2944f86e7$var$b ? Symbol.for("react.scope") : 60119;
function $ff60f0c2944f86e7$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $ff60f0c2944f86e7$var$c:
                switch(a = a.type, a){
                    case $ff60f0c2944f86e7$var$l:
                    case $ff60f0c2944f86e7$var$m:
                    case $ff60f0c2944f86e7$var$e:
                    case $ff60f0c2944f86e7$var$g:
                    case $ff60f0c2944f86e7$var$f:
                    case $ff60f0c2944f86e7$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $ff60f0c2944f86e7$var$k:
                            case $ff60f0c2944f86e7$var$n:
                            case $ff60f0c2944f86e7$var$t:
                            case $ff60f0c2944f86e7$var$r:
                            case $ff60f0c2944f86e7$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $ff60f0c2944f86e7$var$d:
                return u;
        }
    }
}
function $ff60f0c2944f86e7$var$A(a) {
    return $ff60f0c2944f86e7$var$z(a) === $ff60f0c2944f86e7$var$m;
}
$ff60f0c2944f86e7$export$2b8d127b894957b9 = $ff60f0c2944f86e7$var$l;
$ff60f0c2944f86e7$export$cea3a54a6425200c = $ff60f0c2944f86e7$var$m;
$ff60f0c2944f86e7$export$a7c73072b1a182ae = $ff60f0c2944f86e7$var$k;
$ff60f0c2944f86e7$export$9f27bc3417b4524d = $ff60f0c2944f86e7$var$h;
$ff60f0c2944f86e7$export$db77ccec0bb4ccac = $ff60f0c2944f86e7$var$c;
$ff60f0c2944f86e7$export$8392c0c9d3dcbd35 = $ff60f0c2944f86e7$var$n;
$ff60f0c2944f86e7$export$ffb0004e005737fa = $ff60f0c2944f86e7$var$e;
$ff60f0c2944f86e7$export$b624eff549462981 = $ff60f0c2944f86e7$var$t;
$ff60f0c2944f86e7$export$7897aa7841a5380c = $ff60f0c2944f86e7$var$r;
$ff60f0c2944f86e7$export$602eac185826482c = $ff60f0c2944f86e7$var$d;
$ff60f0c2944f86e7$export$e2c29f18771995cb = $ff60f0c2944f86e7$var$g;
$ff60f0c2944f86e7$export$5f8d39834fd61797 = $ff60f0c2944f86e7$var$f;
$ff60f0c2944f86e7$export$74bf444e3cd11ea5 = $ff60f0c2944f86e7$var$p;
$ff60f0c2944f86e7$export$92387174baf9b227 = function(a) {
    return $ff60f0c2944f86e7$var$A(a) || $ff60f0c2944f86e7$var$z(a) === $ff60f0c2944f86e7$var$l;
};
$ff60f0c2944f86e7$export$ec112efeb987d9c6 = $ff60f0c2944f86e7$var$A;
$ff60f0c2944f86e7$export$b706b080d889d2c9 = function(a) {
    return $ff60f0c2944f86e7$var$z(a) === $ff60f0c2944f86e7$var$k;
};
$ff60f0c2944f86e7$export$5be5a87408f70ddc = function(a) {
    return $ff60f0c2944f86e7$var$z(a) === $ff60f0c2944f86e7$var$h;
};
$ff60f0c2944f86e7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ff60f0c2944f86e7$var$c;
};
$ff60f0c2944f86e7$export$455c2e768291efa6 = function(a) {
    return $ff60f0c2944f86e7$var$z(a) === $ff60f0c2944f86e7$var$n;
};
$ff60f0c2944f86e7$export$9522e17588c12572 = function(a) {
    return $ff60f0c2944f86e7$var$z(a) === $ff60f0c2944f86e7$var$e;
};
$ff60f0c2944f86e7$export$2110ac352bb060b9 = function(a) {
    return $ff60f0c2944f86e7$var$z(a) === $ff60f0c2944f86e7$var$t;
};
$ff60f0c2944f86e7$export$56885ab8b9c456ab = function(a) {
    return $ff60f0c2944f86e7$var$z(a) === $ff60f0c2944f86e7$var$r;
};
$ff60f0c2944f86e7$export$d927fcb6adf8f9de = function(a) {
    return $ff60f0c2944f86e7$var$z(a) === $ff60f0c2944f86e7$var$d;
};
$ff60f0c2944f86e7$export$b82d16f27459e05a = function(a) {
    return $ff60f0c2944f86e7$var$z(a) === $ff60f0c2944f86e7$var$g;
};
$ff60f0c2944f86e7$export$522c17b4f5e123e8 = function(a) {
    return $ff60f0c2944f86e7$var$z(a) === $ff60f0c2944f86e7$var$f;
};
$ff60f0c2944f86e7$export$1aabd8a0274ecfd6 = function(a) {
    return $ff60f0c2944f86e7$var$z(a) === $ff60f0c2944f86e7$var$p;
};
$ff60f0c2944f86e7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $ff60f0c2944f86e7$var$e || a === $ff60f0c2944f86e7$var$m || a === $ff60f0c2944f86e7$var$g || a === $ff60f0c2944f86e7$var$f || a === $ff60f0c2944f86e7$var$p || a === $ff60f0c2944f86e7$var$q || "object" === typeof a && null !== a && (a.$$typeof === $ff60f0c2944f86e7$var$t || a.$$typeof === $ff60f0c2944f86e7$var$r || a.$$typeof === $ff60f0c2944f86e7$var$h || a.$$typeof === $ff60f0c2944f86e7$var$k || a.$$typeof === $ff60f0c2944f86e7$var$n || a.$$typeof === $ff60f0c2944f86e7$var$w || a.$$typeof === $ff60f0c2944f86e7$var$x || a.$$typeof === $ff60f0c2944f86e7$var$y || a.$$typeof === $ff60f0c2944f86e7$var$v);
};
$ff60f0c2944f86e7$export$f5bbd400c2f4426f = $ff60f0c2944f86e7$var$z;

});

parcelRegister("jIrNf", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("hNM3I", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f9Yqh.default;
    }
});

var $f9Yqh = parcelRequire("f9Yqh");

});
parcelRegister("f9Yqh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b09690fcee01a686$export$2e2bcd8739ae039; });

var $if2ZQ = parcelRequire("if2ZQ");

var $gRqVZ = parcelRequire("gRqVZ");

var $6tDSK = parcelRequire("6tDSK");

var $01ysi = parcelRequire("01ysi");
'use client';
function $b09690fcee01a686$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $01ysi.jsx)((0, $6tDSK.default), (0, $if2ZQ.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $6tDSK.default).muiName;
    return /*#__PURE__*/ $gRqVZ.memo(/*#__PURE__*/ $gRqVZ.forwardRef(Component));
}

});
parcelRegister("if2ZQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d47bf3c5b645be1b$export$2e2bcd8739ae039; });
function $d47bf3c5b645be1b$export$2e2bcd8739ae039() {
    return $d47bf3c5b645be1b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d47bf3c5b645be1b$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("6tDSK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b74633e12d2eed0$export$2e2bcd8739ae039; });

var $if2ZQ = parcelRequire("if2ZQ");

var $2UY5J = parcelRequire("2UY5J");

var $gRqVZ = parcelRequire("gRqVZ");


var $5RjKS = parcelRequire("5RjKS");

var $kKoGD = parcelRequire("kKoGD");

var $f6KN8 = parcelRequire("f6KN8");

var $eXJcZ = parcelRequire("eXJcZ");

var $4EIqH = parcelRequire("4EIqH");

var $5qGta = parcelRequire("5qGta");

var $01ysi = parcelRequire("01ysi");
'use client';
const $4b74633e12d2eed0$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $4b74633e12d2eed0$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $f6KN8.default)(color)}`,
            `fontSize${(0, $f6KN8.default)(fontSize)}`
        ]
    };
    return (0, $kKoGD.default)(slots, (0, $5qGta.getSvgIconUtilityClass), classes);
};
const $4b74633e12d2eed0$var$SvgIconRoot = (0, $4EIqH.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $f6KN8.default)(ownerState.color)}`],
            styles[`fontSize${(0, $f6KN8.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $4b74633e12d2eed0$var$SvgIcon = /*#__PURE__*/ $gRqVZ.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $eXJcZ.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $2UY5J.default)(props, $4b74633e12d2eed0$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $gRqVZ.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $if2ZQ.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $4b74633e12d2eed0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $01ysi.jsxs)($4b74633e12d2eed0$var$SvgIconRoot, (0, $if2ZQ.default)({
        as: component,
        className: (0, $5RjKS.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $01ysi.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$4b74633e12d2eed0$var$SvgIcon.muiName = 'SvgIcon';
var $4b74633e12d2eed0$export$2e2bcd8739ae039 = $4b74633e12d2eed0$var$SvgIcon;

});
parcelRegister("2UY5J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21ff6ca433c09377$export$2e2bcd8739ae039; });
function $21ff6ca433c09377$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("5RjKS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33edf406b6240896$export$2e2bcd8739ae039; });
function $33edf406b6240896$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $33edf406b6240896$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $33edf406b6240896$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $33edf406b6240896$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $33edf406b6240896$export$2e2bcd8739ae039 = $33edf406b6240896$export$4f5d2d50c9deca37;

});

parcelRegister("kKoGD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1ab40c46c9ee49a$export$2e2bcd8739ae039; });
function $f1ab40c46c9ee49a$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("f6KN8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $affbb659943cabd3$export$2e2bcd8739ae039; });

var $iGncY = parcelRequire("iGncY");
var $affbb659943cabd3$export$2e2bcd8739ae039 = (0, $iGncY.default);

});
parcelRegister("iGncY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d99e26ebad560d48$export$2e2bcd8739ae039; });

var $16hJ5 = parcelRequire("16hJ5");
function $d99e26ebad560d48$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $16hJ5.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("16hJ5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cd41a051bde27da$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $0cd41a051bde27da$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});



parcelRegister("eXJcZ", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $ae49a4d9bfd27ec7$export$2440da353cedad43; });

var $if2ZQ = parcelRequire("if2ZQ");
parcelRequire("gRqVZ");


var $3youE = parcelRequire("3youE");

var $01ysi = parcelRequire("01ysi");
'use client';
function $ae49a4d9bfd27ec7$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $3youE.default), (0, $if2ZQ.default)({}, props));
}
var $ae49a4d9bfd27ec7$export$2e2bcd8739ae039 = $ae49a4d9bfd27ec7$var$DefaultPropsProvider;
function $ae49a4d9bfd27ec7$export$2440da353cedad43(params) {
    return (0, $3youE.useDefaultProps)(params);
}

});
parcelRegister("3youE", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $29678bf52d961106$export$2440da353cedad43; });
$parcel$export(module.exports, "default", function () { return $29678bf52d961106$export$2e2bcd8739ae039; });

var $gRqVZ = parcelRequire("gRqVZ");


var $3NvHU = parcelRequire("3NvHU");

var $01ysi = parcelRequire("01ysi");
'use client';
const $29678bf52d961106$var$PropsContext = /*#__PURE__*/ $gRqVZ.createContext(undefined);
function $29678bf52d961106$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $01ysi.jsx)($29678bf52d961106$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $29678bf52d961106$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $3NvHU.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $3NvHU.default)(config, props);
    return props;
}
function $29678bf52d961106$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $gRqVZ.useContext($29678bf52d961106$var$PropsContext);
    return $29678bf52d961106$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $29678bf52d961106$export$2e2bcd8739ae039 = $29678bf52d961106$var$DefaultPropsProvider;

});
parcelRegister("3NvHU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c3e8b1ba44649df$export$2e2bcd8739ae039; });

var $if2ZQ = parcelRequire("if2ZQ");
function $2c3e8b1ba44649df$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $if2ZQ.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $if2ZQ.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $if2ZQ.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $2c3e8b1ba44649df$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});

parcelRegister("01ysi", function(module, exports) {
'use strict';

module.exports = (parcelRequire("86HTI"));

});



parcelRegister("4EIqH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $363d5ca1f5ec78e3$export$2e2bcd8739ae039; });

var $2IPdQ = parcelRequire("2IPdQ");

var $5B4J7 = parcelRequire("5B4J7");

var $1WdmB = parcelRequire("1WdmB");

var $6NiJf = parcelRequire("6NiJf");

'use client';
const $363d5ca1f5ec78e3$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($2IPdQ)))({
    themeId: (0, $1WdmB.default),
    defaultTheme: $5B4J7.default,
    rootShouldForwardProp: $6NiJf.default
});
var $363d5ca1f5ec78e3$export$2e2bcd8739ae039 = $363d5ca1f5ec78e3$var$styled;

});
parcelRegister("2IPdQ", function(module, exports) {
"use strict";

var $dN8sB = parcelRequire("dN8sB");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1fb76c80d73c840b$var$createStyled;
module.exports.shouldForwardProp = $1fb76c80d73c840b$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $1fb76c80d73c840b$var$_extends2 = $dN8sB((parcelRequire("ag2w3")));

var $1fb76c80d73c840b$var$_objectWithoutPropertiesLoose2 = $dN8sB((parcelRequire("2SaMy")));

var $1fb76c80d73c840b$var$_styledEngine = $1fb76c80d73c840b$var$_interopRequireWildcard((parcelRequire("15iRw")));

var $b6XT3 = parcelRequire("b6XT3");

var $1fb76c80d73c840b$var$_capitalize = $dN8sB((parcelRequire("i8qbw")));

var $1fb76c80d73c840b$var$_getDisplayName = $dN8sB((parcelRequire("271u2")));

var $1fb76c80d73c840b$var$_createTheme = $dN8sB((parcelRequire("leyOo")));

var $1fb76c80d73c840b$var$_styleFunctionSx = $dN8sB((parcelRequire("9ABZG")));
const $1fb76c80d73c840b$var$_excluded = [
    "ownerState"
], $1fb76c80d73c840b$var$_excluded2 = [
    "variants"
], $1fb76c80d73c840b$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $1fb76c80d73c840b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1fb76c80d73c840b$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $1fb76c80d73c840b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $1fb76c80d73c840b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $1fb76c80d73c840b$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $1fb76c80d73c840b$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $1fb76c80d73c840b$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $1fb76c80d73c840b$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $1fb76c80d73c840b$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $1fb76c80d73c840b$var$_createTheme.default)();
const $1fb76c80d73c840b$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $1fb76c80d73c840b$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $1fb76c80d73c840b$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $1fb76c80d73c840b$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $1fb76c80d73c840b$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $1fb76c80d73c840b$var$_objectWithoutPropertiesLoose2.default)(_ref, $1fb76c80d73c840b$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $1fb76c80d73c840b$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$1fb76c80d73c840b$var$processStyleArg(resolvedStyle, (0, $1fb76c80d73c840b$var$_extends2.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $1fb76c80d73c840b$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $1fb76c80d73c840b$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $1fb76c80d73c840b$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $1fb76c80d73c840b$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $1fb76c80d73c840b$var$shallowLayer((0, $1fb76c80d73c840b$var$_styledEngine.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $1fb76c80d73c840b$var$shallowLayer((0, $1fb76c80d73c840b$var$_styledEngine.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $1fb76c80d73c840b$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $1fb76c80d73c840b$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $1fb76c80d73c840b$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $1fb76c80d73c840b$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $1fb76c80d73c840b$var$_styleFunctionSx.default)((0, $1fb76c80d73c840b$var$_extends2.default)({}, props, {
            theme: $1fb76c80d73c840b$var$resolveTheme((0, $1fb76c80d73c840b$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $1fb76c80d73c840b$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $1fb76c80d73c840b$var$defaultOverridesResolver($1fb76c80d73c840b$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $1fb76c80d73c840b$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $1fb76c80d73c840b$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $1fb76c80d73c840b$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($1fb76c80d73c840b$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $1fb76c80d73c840b$var$_styledEngine.default)(tag, (0, $1fb76c80d73c840b$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $b6XT3.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $1fb76c80d73c840b$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $1fb76c80d73c840b$var$processStyleArg(stylesArg, (0, $1fb76c80d73c840b$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $1fb76c80d73c840b$var$resolveTheme((0, $1fb76c80d73c840b$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $1fb76c80d73c840b$var$processStyleArg(slotStyle, (0, $1fb76c80d73c840b$var$_extends2.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $1fb76c80d73c840b$var$resolveTheme((0, $1fb76c80d73c840b$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $1fb76c80d73c840b$var$processStyleArg({
                    variants: themeVariants
                }, (0, $1fb76c80d73c840b$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("dN8sB", function(module, exports) {
function $a0a66a013625ff5e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $a0a66a013625ff5e$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ag2w3", function(module, exports) {
function $777d59a0870fa4d9$var$_extends() {
    return module.exports = $777d59a0870fa4d9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $777d59a0870fa4d9$var$_extends.apply(null, arguments);
}
module.exports = $777d59a0870fa4d9$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2SaMy", function(module, exports) {
function $2178fd0c9f897810$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $2178fd0c9f897810$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("15iRw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0ca4e3b77324dd14$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $0ca4e3b77324dd14$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "internal_serializeStyles", function () { return $0ca4e3b77324dd14$export$13a2d3ef13012b32; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("8DRs0")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("50JbI")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("50JbI")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("8vLaV")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("4dd7z")).default; });
/**
 * @mui/styled-engine v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $jSn0H = parcelRequire("jSn0H");

var $7wOEF = parcelRequire("7wOEF");

var $50JbI = parcelRequire("50JbI");
var $8DRs0 = parcelRequire("8DRs0");

var $8vLaV = parcelRequire("8vLaV");

var $4dd7z = parcelRequire("4dd7z");
'use client';
function $0ca4e3b77324dd14$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $jSn0H.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $0ca4e3b77324dd14$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};
// Emotion only accepts an array, but we want to avoid allocations
const $0ca4e3b77324dd14$var$wrapper = [];
function $0ca4e3b77324dd14$export$13a2d3ef13012b32(styles) {
    $0ca4e3b77324dd14$var$wrapper[0] = styles;
    return (0, $7wOEF.serializeStyles)($0ca4e3b77324dd14$var$wrapper);
}

});
parcelRegister("jSn0H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e784e8d5c93998ff$export$2e2bcd8739ae039; });

var $1RwNx = parcelRequire("1RwNx");
parcelRequire("ag2w3");

parcelRequire("7wOEF");
parcelRequire("lje6s");
parcelRequire("h3Czr");
parcelRequire("gRqVZ");
parcelRequire("2Fkpb");
var $e784e8d5c93998ff$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $e784e8d5c93998ff$export$2e2bcd8739ae039 = (0, $1RwNx.default).bind(null);
$e784e8d5c93998ff$var$tags.forEach(function(tagName) {
    $e784e8d5c93998ff$export$2e2bcd8739ae039[tagName] = $e784e8d5c93998ff$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("1RwNx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15b42eabeac216a1$export$2e2bcd8739ae039; });

var $if2ZQ = parcelRequire("if2ZQ");
parcelRequire("50JbI");
var $8DRs0 = parcelRequire("8DRs0");

var $7wOEF = parcelRequire("7wOEF");

var $lje6s = parcelRequire("lje6s");

var $h3Czr = parcelRequire("h3Czr");

var $gRqVZ = parcelRequire("gRqVZ");

var $2Fkpb = parcelRequire("2Fkpb");
var $15b42eabeac216a1$var$isBrowser = typeof document !== 'undefined';
var $15b42eabeac216a1$var$isDevelopment = false;
var $15b42eabeac216a1$var$testOmitPropsOnStringTag = (0, $2Fkpb.default);
var $15b42eabeac216a1$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $15b42eabeac216a1$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $15b42eabeac216a1$var$testOmitPropsOnStringTag : $15b42eabeac216a1$var$testOmitPropsOnComponent;
};
var $15b42eabeac216a1$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $15b42eabeac216a1$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $h3Czr.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $lje6s.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $h3Czr.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$15b42eabeac216a1$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $gRqVZ.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $15b42eabeac216a1$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $15b42eabeac216a1$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $15b42eabeac216a1$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $8DRs0.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $gRqVZ.useContext((0, $8DRs0.T));
            }
            if (typeof props.className === 'string') className = (0, $h3Czr.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $7wOEF.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $15b42eabeac216a1$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $gRqVZ.createElement($gRqVZ.Fragment, null, /*#__PURE__*/ $gRqVZ.createElement($15b42eabeac216a1$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $gRqVZ.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $15b42eabeac216a1$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $if2ZQ.default)({}, options, nextOptions, {
                shouldForwardProp: $15b42eabeac216a1$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("50JbI", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $3a6001345ca85ef2$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $3a6001345ca85ef2$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $3a6001345ca85ef2$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "jsx", function () { return $3a6001345ca85ef2$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("8DRs0")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("8DRs0")).w; });

var $8DRs0 = parcelRequire("8DRs0");

var $gRqVZ = parcelRequire("gRqVZ");

var $h3Czr = parcelRequire("h3Czr");

var $lje6s = parcelRequire("lje6s");

var $7wOEF = parcelRequire("7wOEF");
parcelRequire("fohPQ");
parcelRequire("ag2w3");
parcelRequire("47Tyn");

parcelRequire("6q1gP");
var $3a6001345ca85ef2$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $8DRs0.h).call(props, 'css')) return $gRqVZ.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $8DRs0.E);
    createElementArgArray[1] = (0, $8DRs0.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $gRqVZ.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($3a6001345ca85ef2$export$c8a8987d4410bf2d || ($3a6001345ca85ef2$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $3a6001345ca85ef2$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $8DRs0.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $7wOEF.serializeStyles)([
        styles
    ], undefined, $gRqVZ.useContext((0, $8DRs0.T)));
    if (!(0, $8DRs0.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $gRqVZ.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $gRqVZ.useRef();
    (0, $lje6s.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $lje6s.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $h3Czr.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $3a6001345ca85ef2$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $7wOEF.serializeStyles)(args);
}
function $3a6001345ca85ef2$export$d25ddfdf17c3ad3e() {
    var insertable = $3a6001345ca85ef2$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $3a6001345ca85ef2$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $3a6001345ca85ef2$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $h3Czr.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $3a6001345ca85ef2$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $lje6s.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $h3Czr.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $8DRs0.i) && res !== undefined) rules += res;
        }
        if (!(0, $8DRs0.i)) return rules;
    });
    if (!(0, $8DRs0.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $gRqVZ.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $3a6001345ca85ef2$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $8DRs0.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $8DRs0.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $7wOEF.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $h3Czr.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $8DRs0.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $3a6001345ca85ef2$var$merge(cache.registered, css, $3a6001345ca85ef2$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $gRqVZ.useContext((0, $8DRs0.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $gRqVZ.createElement($gRqVZ.Fragment, null, /*#__PURE__*/ $gRqVZ.createElement($3a6001345ca85ef2$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("8DRs0", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $64ab6d70417f49ae$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $64ab6d70417f49ae$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $64ab6d70417f49ae$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $64ab6d70417f49ae$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $64ab6d70417f49ae$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $64ab6d70417f49ae$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $64ab6d70417f49ae$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $64ab6d70417f49ae$export$a9c23c6ac3fc3eca; });

var $gRqVZ = parcelRequire("gRqVZ");

var $fohPQ = parcelRequire("fohPQ");

var $if2ZQ = parcelRequire("if2ZQ");

var $47Tyn = parcelRequire("47Tyn");

var $3IqxN = parcelRequire("3IqxN");

var $h3Czr = parcelRequire("h3Czr");

var $7wOEF = parcelRequire("7wOEF");

var $lje6s = parcelRequire("lje6s");
var $64ab6d70417f49ae$export$407448d2b89b1813 = false;
var $64ab6d70417f49ae$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $64ab6d70417f49ae$var$EmotionCacheContext = /* #__PURE__ */ $gRqVZ.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $fohPQ.default)({
    key: 'css'
}) : null);
var $64ab6d70417f49ae$export$e7094788287c5e9b = $64ab6d70417f49ae$var$EmotionCacheContext.Provider;
var $64ab6d70417f49ae$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $gRqVZ.useContext)($64ab6d70417f49ae$var$EmotionCacheContext);
};
var $64ab6d70417f49ae$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $gRqVZ.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $gRqVZ.useContext)($64ab6d70417f49ae$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$64ab6d70417f49ae$export$23f2a1d2818174ef) $64ab6d70417f49ae$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $gRqVZ.useContext)($64ab6d70417f49ae$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $fohPQ.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $gRqVZ.createElement($64ab6d70417f49ae$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $64ab6d70417f49ae$export$971d5caa766a69d7 = /* #__PURE__ */ $gRqVZ.createContext({});
var $64ab6d70417f49ae$export$3b14a55fb2447963 = function useTheme() {
    return $gRqVZ.useContext($64ab6d70417f49ae$export$971d5caa766a69d7);
};
var $64ab6d70417f49ae$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $if2ZQ.default)({}, outerTheme, theme);
};
var $64ab6d70417f49ae$var$createCacheWithTheme = /* #__PURE__ */ (0, $47Tyn.default)(function(outerTheme) {
    return (0, $47Tyn.default)(function(theme) {
        return $64ab6d70417f49ae$var$getTheme(outerTheme, theme);
    });
});
var $64ab6d70417f49ae$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $gRqVZ.useContext($64ab6d70417f49ae$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $64ab6d70417f49ae$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $gRqVZ.createElement($64ab6d70417f49ae$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $64ab6d70417f49ae$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $gRqVZ.forwardRef(function render(props, ref) {
        var theme = $gRqVZ.useContext($64ab6d70417f49ae$export$971d5caa766a69d7);
        return /*#__PURE__*/ $gRqVZ.createElement(Component, (0, $if2ZQ.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $3IqxN.default)(WithTheme, Component);
}
var $64ab6d70417f49ae$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $64ab6d70417f49ae$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $64ab6d70417f49ae$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($64ab6d70417f49ae$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$64ab6d70417f49ae$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $64ab6d70417f49ae$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $h3Czr.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $lje6s.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $h3Czr.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$64ab6d70417f49ae$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $gRqVZ.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $64ab6d70417f49ae$var$Emotion = /* #__PURE__ */ $64ab6d70417f49ae$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$64ab6d70417f49ae$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $h3Czr.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $7wOEF.serializeStyles)(registeredStyles, undefined, $gRqVZ.useContext($64ab6d70417f49ae$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($64ab6d70417f49ae$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $64ab6d70417f49ae$var$typePropName && !$64ab6d70417f49ae$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $gRqVZ.createElement($gRqVZ.Fragment, null, /*#__PURE__*/ $gRqVZ.createElement($64ab6d70417f49ae$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $gRqVZ.createElement(WrappedComponent, newProps));
});
var $64ab6d70417f49ae$export$a9c23c6ac3fc3eca = $64ab6d70417f49ae$var$Emotion;

});
parcelRegister("fohPQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b346ee9f77e6f24c$export$2e2bcd8739ae039; });

var $333TX = parcelRequire("333TX");

var $4ttQF = parcelRequire("4ttQF");

var $47Tyn = parcelRequire("47Tyn");

var $gRouI = parcelRequire("gRouI");
var $b346ee9f77e6f24c$var$isBrowser = typeof document !== 'undefined';
var $b346ee9f77e6f24c$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $4ttQF.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $4ttQF.token)(character)) break;
        (0, $4ttQF.next)();
    }
    return (0, $4ttQF.slice)(begin, (0, $4ttQF.position));
};
var $b346ee9f77e6f24c$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $4ttQF.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $4ttQF.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $b346ee9f77e6f24c$var$identifierWithPointTracking((0, $4ttQF.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $4ttQF.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $4ttQF.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $4ttQF.from)(character);
    }
    while (character = (0, $4ttQF.next)());
    return parsed;
};
var $b346ee9f77e6f24c$var$getRules = function getRules(value, points) {
    return (0, $4ttQF.dealloc)($b346ee9f77e6f24c$var$toRules((0, $4ttQF.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $b346ee9f77e6f24c$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $b346ee9f77e6f24c$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$b346ee9f77e6f24c$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $b346ee9f77e6f24c$var$fixedElements.set(element, true);
    var points = [];
    var rules = $b346ee9f77e6f24c$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $b346ee9f77e6f24c$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $b346ee9f77e6f24c$var$prefix(value, length) {
    switch((0, $4ttQF.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $4ttQF.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $4ttQF.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $4ttQF.WEBKIT) + value + (0, $4ttQF.MOZ) + value + (0, $4ttQF.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $4ttQF.WEBKIT) + value + (0, $4ttQF.MS) + value + value;
        // order
        case 6165:
            return (0, $4ttQF.WEBKIT) + value + (0, $4ttQF.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $4ttQF.WEBKIT) + value + (0, $4ttQF.replace)(value, /(\w+).+(:[^]+)/, (0, $4ttQF.WEBKIT) + 'box-$1$2' + (0, $4ttQF.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $4ttQF.WEBKIT) + value + (0, $4ttQF.MS) + 'flex-item-' + (0, $4ttQF.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $4ttQF.WEBKIT) + value + (0, $4ttQF.MS) + 'flex-line-pack' + (0, $4ttQF.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $4ttQF.WEBKIT) + value + (0, $4ttQF.MS) + (0, $4ttQF.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $4ttQF.WEBKIT) + value + (0, $4ttQF.MS) + (0, $4ttQF.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $4ttQF.WEBKIT) + 'box-' + (0, $4ttQF.replace)(value, '-grow', '') + (0, $4ttQF.WEBKIT) + value + (0, $4ttQF.MS) + (0, $4ttQF.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $4ttQF.WEBKIT) + (0, $4ttQF.replace)(value, /([^-])(transform)/g, '$1' + (0, $4ttQF.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $4ttQF.replace)((0, $4ttQF.replace)((0, $4ttQF.replace)(value, /(zoom-|grab)/, (0, $4ttQF.WEBKIT) + '$1'), /(image-set)/, (0, $4ttQF.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $4ttQF.replace)(value, /(image-set\([^]*)/, (0, $4ttQF.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $4ttQF.replace)((0, $4ttQF.replace)(value, /(.+:)(flex-)?(.*)/, (0, $4ttQF.WEBKIT) + 'box-pack:$3' + (0, $4ttQF.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $4ttQF.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $4ttQF.replace)(value, /(.+)-inline(.+)/, (0, $4ttQF.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $4ttQF.strlen)(value) - 1 - length > 6) switch((0, $4ttQF.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $4ttQF.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $4ttQF.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $4ttQF.WEBKIT) + '$2-$3' + '$1' + (0, $4ttQF.MOZ) + ((0, $4ttQF.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $4ttQF.indexof)(value, 'stretch') ? $b346ee9f77e6f24c$var$prefix((0, $4ttQF.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $4ttQF.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $4ttQF.charat)(value, (0, $4ttQF.strlen)(value) - 3 - (~(0, $4ttQF.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $4ttQF.replace)(value, ':', ':' + (0, $4ttQF.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $4ttQF.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $4ttQF.WEBKIT) + ((0, $4ttQF.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $4ttQF.WEBKIT) + '$2$3' + '$1' + (0, $4ttQF.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $4ttQF.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $4ttQF.WEBKIT) + value + (0, $4ttQF.MS) + (0, $4ttQF.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $4ttQF.WEBKIT) + value + (0, $4ttQF.MS) + (0, $4ttQF.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $4ttQF.WEBKIT) + value + (0, $4ttQF.MS) + (0, $4ttQF.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $4ttQF.WEBKIT) + value + (0, $4ttQF.MS) + value + value;
    }
    return value;
}
var $b346ee9f77e6f24c$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $4ttQF.DECLARATION:
                element["return"] = $b346ee9f77e6f24c$var$prefix(element.value, element.length);
                break;
            case 0, $4ttQF.KEYFRAMES:
                return (0, $4ttQF.serialize)([
                    (0, $4ttQF.copy)(element, {
                        value: (0, $4ttQF.replace)(element.value, '@', '@' + (0, $4ttQF.WEBKIT))
                    })
                ], callback);
            case 0, $4ttQF.RULESET:
                if (element.length) return (0, $4ttQF.combine)(element.props, function(value) {
                    switch((0, $4ttQF.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $4ttQF.serialize)([
                                (0, $4ttQF.copy)(element, {
                                    props: [
                                        (0, $4ttQF.replace)(value, /:(read-\w+)/, ':' + (0, $4ttQF.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $4ttQF.serialize)([
                                (0, $4ttQF.copy)(element, {
                                    props: [
                                        (0, $4ttQF.replace)(value, /:(plac\w+)/, ':' + (0, $4ttQF.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $4ttQF.copy)(element, {
                                    props: [
                                        (0, $4ttQF.replace)(value, /:(plac\w+)/, ':' + (0, $4ttQF.MOZ) + '$1')
                                    ]
                                }),
                                (0, $4ttQF.copy)(element, {
                                    props: [
                                        (0, $4ttQF.replace)(value, /:(plac\w+)/, (0, $4ttQF.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $b346ee9f77e6f24c$var$getServerStylisCache = $b346ee9f77e6f24c$var$isBrowser ? undefined : (0, $47Tyn.default)(function() {
    return (0, $gRouI.default)(function() {
        return {};
    });
});
var $b346ee9f77e6f24c$var$defaultStylisPlugins = [
    $b346ee9f77e6f24c$var$prefixer
];
var $b346ee9f77e6f24c$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($b346ee9f77e6f24c$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $b346ee9f77e6f24c$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($b346ee9f77e6f24c$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $b346ee9f77e6f24c$var$compat,
        $b346ee9f77e6f24c$var$removeLabel
    ];
    if (!$b346ee9f77e6f24c$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $4ttQF.stringify),
            (0, $4ttQF.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $4ttQF.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $4ttQF.serialize)((0, $4ttQF.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $4ttQF.stringify)
        ];
        var _serializer = (0, $4ttQF.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $4ttQF.serialize)((0, $4ttQF.compile)(styles), _serializer);
        };
        var serverStylisCache = $b346ee9f77e6f24c$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $333TX.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("333TX", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $2384adb27be16440$export$9d753cd7ae895cce; });
var $2384adb27be16440$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $2384adb27be16440$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $2384adb27be16440$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $2384adb27be16440$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$2384adb27be16440$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($2384adb27be16440$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $2384adb27be16440$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("4ttQF", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $4509a12fea491e57$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $4509a12fea491e57$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $4509a12fea491e57$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $4509a12fea491e57$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $4509a12fea491e57$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $4509a12fea491e57$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $4509a12fea491e57$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $4509a12fea491e57$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $4509a12fea491e57$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $4509a12fea491e57$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $4509a12fea491e57$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $4509a12fea491e57$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $4509a12fea491e57$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $4509a12fea491e57$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $4509a12fea491e57$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $4509a12fea491e57$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $4509a12fea491e57$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $4509a12fea491e57$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $4509a12fea491e57$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $4509a12fea491e57$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $4509a12fea491e57$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $4509a12fea491e57$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $4509a12fea491e57$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $4509a12fea491e57$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $4509a12fea491e57$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $4509a12fea491e57$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $4509a12fea491e57$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $4509a12fea491e57$export$38bcb760f1d4871c; });
var $4509a12fea491e57$export$71ad59f2e432cfe8 = "-ms-";
var $4509a12fea491e57$export$2c0f367103c8d01c = "-moz-";
var $4509a12fea491e57$export$39dfd62a25e0fe93 = "-webkit-";
var $4509a12fea491e57$export$a29989082612d0d9 = "comm";
var $4509a12fea491e57$export$aa3a2e812ca8570d = "rule";
var $4509a12fea491e57$export$527d108ccf083c2b = "decl";
var $4509a12fea491e57$export$d3d35020fa5b54f0 = "@page";
var $4509a12fea491e57$export$500415a86c544f73 = "@media";
var $4509a12fea491e57$export$a763edbf796b780a = "@import";
var $4509a12fea491e57$export$2790aeb8b4e5c826 = "@charset";
var $4509a12fea491e57$export$1cc683e23b84b133 = "@viewport";
var $4509a12fea491e57$export$9447a5efea57e862 = "@supports";
var $4509a12fea491e57$export$ef011b4e114b1fba = "@document";
var $4509a12fea491e57$export$6aad947bda0f3f46 = "@namespace";
var $4509a12fea491e57$export$b44a8529a35fcb60 = "@keyframes";
var $4509a12fea491e57$export$2c16de31893252e6 = "@font-face";
var $4509a12fea491e57$export$3d846dd52e150c6f = "@counter-style";
var $4509a12fea491e57$export$22314bfbb57653fe = "@font-feature-values";
var $4509a12fea491e57$export$d773506282b3cfe6 = "@layer";
var $4509a12fea491e57$export$2335f513bbd82c6d = Math.abs;
var $4509a12fea491e57$export$6788812c4e6611e6 = String.fromCharCode;
var $4509a12fea491e57$export$e6e34fd1f2686227 = Object.assign;
function $4509a12fea491e57$export$d6af199866bfb566(e, r) {
    return $4509a12fea491e57$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $4509a12fea491e57$export$a9db5e087081082d(e, 0)) << 2 ^ $4509a12fea491e57$export$a9db5e087081082d(e, 1)) << 2 ^ $4509a12fea491e57$export$a9db5e087081082d(e, 2)) << 2 ^ $4509a12fea491e57$export$a9db5e087081082d(e, 3) : 0;
}
function $4509a12fea491e57$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $4509a12fea491e57$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $4509a12fea491e57$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $4509a12fea491e57$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $4509a12fea491e57$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $4509a12fea491e57$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $4509a12fea491e57$export$36776f635604f274(e) {
    return e.length;
}
function $4509a12fea491e57$export$f9084667e487ed46(e) {
    return e.length;
}
function $4509a12fea491e57$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $4509a12fea491e57$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $4509a12fea491e57$export$53f1d5ea8de3d7c = 1;
var $4509a12fea491e57$export$4e0c71f277ca26b3 = 1;
var $4509a12fea491e57$export$f24224f1c91d8156 = 0;
var $4509a12fea491e57$export$5880b8b5730aff45 = 0;
var $4509a12fea491e57$export$c0306caf338ac095 = 0;
var $4509a12fea491e57$export$30a86d91af8ff6e6 = "";
function $4509a12fea491e57$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $4509a12fea491e57$export$53f1d5ea8de3d7c,
        column: $4509a12fea491e57$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $4509a12fea491e57$export$784d13d8ee351f07(e, r) {
    return $4509a12fea491e57$export$e6e34fd1f2686227($4509a12fea491e57$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $4509a12fea491e57$export$eba6f6f03b0a92e7() {
    return $4509a12fea491e57$export$c0306caf338ac095;
}
function $4509a12fea491e57$export$232faf9add678146() {
    $4509a12fea491e57$export$c0306caf338ac095 = $4509a12fea491e57$export$5880b8b5730aff45 > 0 ? $4509a12fea491e57$export$a9db5e087081082d($4509a12fea491e57$export$30a86d91af8ff6e6, --$4509a12fea491e57$export$5880b8b5730aff45) : 0;
    if ($4509a12fea491e57$export$4e0c71f277ca26b3--, $4509a12fea491e57$export$c0306caf338ac095 === 10) $4509a12fea491e57$export$4e0c71f277ca26b3 = 1, $4509a12fea491e57$export$53f1d5ea8de3d7c--;
    return $4509a12fea491e57$export$c0306caf338ac095;
}
function $4509a12fea491e57$export$48cfd1e771a65c4f() {
    $4509a12fea491e57$export$c0306caf338ac095 = $4509a12fea491e57$export$5880b8b5730aff45 < $4509a12fea491e57$export$f24224f1c91d8156 ? $4509a12fea491e57$export$a9db5e087081082d($4509a12fea491e57$export$30a86d91af8ff6e6, $4509a12fea491e57$export$5880b8b5730aff45++) : 0;
    if ($4509a12fea491e57$export$4e0c71f277ca26b3++, $4509a12fea491e57$export$c0306caf338ac095 === 10) $4509a12fea491e57$export$4e0c71f277ca26b3 = 1, $4509a12fea491e57$export$53f1d5ea8de3d7c++;
    return $4509a12fea491e57$export$c0306caf338ac095;
}
function $4509a12fea491e57$export$4d3fb11e950abb9e() {
    return $4509a12fea491e57$export$a9db5e087081082d($4509a12fea491e57$export$30a86d91af8ff6e6, $4509a12fea491e57$export$5880b8b5730aff45);
}
function $4509a12fea491e57$export$e88cb2efb12ae807() {
    return $4509a12fea491e57$export$5880b8b5730aff45;
}
function $4509a12fea491e57$export$58adb3bec8346d0f(e, r) {
    return $4509a12fea491e57$export$2f35ab04d2335697($4509a12fea491e57$export$30a86d91af8ff6e6, e, r);
}
function $4509a12fea491e57$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $4509a12fea491e57$export$2de70f21292aac9e(e) {
    return $4509a12fea491e57$export$53f1d5ea8de3d7c = $4509a12fea491e57$export$4e0c71f277ca26b3 = 1, $4509a12fea491e57$export$f24224f1c91d8156 = $4509a12fea491e57$export$36776f635604f274($4509a12fea491e57$export$30a86d91af8ff6e6 = e), $4509a12fea491e57$export$5880b8b5730aff45 = 0, [];
}
function $4509a12fea491e57$export$45918ac1574455b1(e) {
    return $4509a12fea491e57$export$30a86d91af8ff6e6 = "", e;
}
function $4509a12fea491e57$export$410ac95b9ec204b8(e) {
    return $4509a12fea491e57$export$87c2784dc9fc4ab($4509a12fea491e57$export$58adb3bec8346d0f($4509a12fea491e57$export$5880b8b5730aff45 - 1, $4509a12fea491e57$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $4509a12fea491e57$export$660b2ee2d4fb4eff(e) {
    return $4509a12fea491e57$export$45918ac1574455b1($4509a12fea491e57$export$5f8c09e3ae6f64e1($4509a12fea491e57$export$2de70f21292aac9e(e)));
}
function $4509a12fea491e57$export$7af1228ff777d175(e) {
    while($4509a12fea491e57$export$c0306caf338ac095 = $4509a12fea491e57$export$4d3fb11e950abb9e())if ($4509a12fea491e57$export$c0306caf338ac095 < 33) $4509a12fea491e57$export$48cfd1e771a65c4f();
    else break;
    return $4509a12fea491e57$export$9e1725a4cfeada27(e) > 2 || $4509a12fea491e57$export$9e1725a4cfeada27($4509a12fea491e57$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $4509a12fea491e57$export$5f8c09e3ae6f64e1(e) {
    while($4509a12fea491e57$export$48cfd1e771a65c4f())switch($4509a12fea491e57$export$9e1725a4cfeada27($4509a12fea491e57$export$c0306caf338ac095)){
        case 0:
            $4509a12fea491e57$export$10d8903dec122b9d($4509a12fea491e57$export$c2ab62c7bf24634($4509a12fea491e57$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $4509a12fea491e57$export$10d8903dec122b9d($4509a12fea491e57$export$410ac95b9ec204b8($4509a12fea491e57$export$c0306caf338ac095), e);
            break;
        default:
            $4509a12fea491e57$export$10d8903dec122b9d($4509a12fea491e57$export$6788812c4e6611e6($4509a12fea491e57$export$c0306caf338ac095), e);
    }
    return e;
}
function $4509a12fea491e57$export$955ba06d119e085e(e, r) {
    while(--r && $4509a12fea491e57$export$48cfd1e771a65c4f())if ($4509a12fea491e57$export$c0306caf338ac095 < 48 || $4509a12fea491e57$export$c0306caf338ac095 > 102 || $4509a12fea491e57$export$c0306caf338ac095 > 57 && $4509a12fea491e57$export$c0306caf338ac095 < 65 || $4509a12fea491e57$export$c0306caf338ac095 > 70 && $4509a12fea491e57$export$c0306caf338ac095 < 97) break;
    return $4509a12fea491e57$export$58adb3bec8346d0f(e, $4509a12fea491e57$export$e88cb2efb12ae807() + (r < 6 && $4509a12fea491e57$export$4d3fb11e950abb9e() == 32 && $4509a12fea491e57$export$48cfd1e771a65c4f() == 32));
}
function $4509a12fea491e57$export$c889f2fcc19dbf12(e) {
    while($4509a12fea491e57$export$48cfd1e771a65c4f())switch($4509a12fea491e57$export$c0306caf338ac095){
        case e:
            return $4509a12fea491e57$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $4509a12fea491e57$export$c889f2fcc19dbf12($4509a12fea491e57$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $4509a12fea491e57$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $4509a12fea491e57$export$48cfd1e771a65c4f();
            break;
    }
    return $4509a12fea491e57$export$5880b8b5730aff45;
}
function $4509a12fea491e57$export$4254d4e2b3745c4c(e, r) {
    while($4509a12fea491e57$export$48cfd1e771a65c4f())if (e + $4509a12fea491e57$export$c0306caf338ac095 === 57) break;
    else if (e + $4509a12fea491e57$export$c0306caf338ac095 === 84 && $4509a12fea491e57$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $4509a12fea491e57$export$58adb3bec8346d0f(r, $4509a12fea491e57$export$5880b8b5730aff45 - 1) + "*" + $4509a12fea491e57$export$6788812c4e6611e6(e === 47 ? e : $4509a12fea491e57$export$48cfd1e771a65c4f());
}
function $4509a12fea491e57$export$c2ab62c7bf24634(e) {
    while(!$4509a12fea491e57$export$9e1725a4cfeada27($4509a12fea491e57$export$4d3fb11e950abb9e()))$4509a12fea491e57$export$48cfd1e771a65c4f();
    return $4509a12fea491e57$export$58adb3bec8346d0f(e, $4509a12fea491e57$export$5880b8b5730aff45);
}
function $4509a12fea491e57$export$ef7acd7185315e22(e) {
    return $4509a12fea491e57$export$45918ac1574455b1($4509a12fea491e57$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $4509a12fea491e57$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $4509a12fea491e57$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $4509a12fea491e57$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $4509a12fea491e57$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($4509a12fea491e57$export$f8e21b1e77979a08(j += $4509a12fea491e57$export$77ad94ebf1c2b9ed($4509a12fea491e57$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $4509a12fea491e57$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $4509a12fea491e57$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $4509a12fea491e57$export$955ba06d119e085e($4509a12fea491e57$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($4509a12fea491e57$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $4509a12fea491e57$export$10d8903dec122b9d($4509a12fea491e57$export$4a34f930e789283c($4509a12fea491e57$export$4254d4e2b3745c4c($4509a12fea491e57$export$48cfd1e771a65c4f(), $4509a12fea491e57$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $4509a12fea491e57$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $4509a12fea491e57$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $4509a12fea491e57$export$36776f635604f274(j) - l) $4509a12fea491e57$export$10d8903dec122b9d(p > 32 ? $4509a12fea491e57$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $4509a12fea491e57$export$f8483753829ec8f3($4509a12fea491e57$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $4509a12fea491e57$export$10d8903dec122b9d(y = $4509a12fea491e57$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $4509a12fea491e57$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $4509a12fea491e57$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $4509a12fea491e57$export$98e6a39c04603d36(e, y, y, n && $4509a12fea491e57$export$10d8903dec122b9d($4509a12fea491e57$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $4509a12fea491e57$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $4509a12fea491e57$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $4509a12fea491e57$export$232faf9add678146() == 125) continue;
            }
            switch(j += $4509a12fea491e57$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($4509a12fea491e57$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($4509a12fea491e57$export$4d3fb11e950abb9e() === 45) j += $4509a12fea491e57$export$410ac95b9ec204b8($4509a12fea491e57$export$48cfd1e771a65c4f());
                    v = $4509a12fea491e57$export$4d3fb11e950abb9e(), o = l = $4509a12fea491e57$export$36776f635604f274(g = j += $4509a12fea491e57$export$c2ab62c7bf24634($4509a12fea491e57$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $4509a12fea491e57$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $4509a12fea491e57$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $4509a12fea491e57$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $4509a12fea491e57$export$2f35ab04d2335697(e, v + 1, v = $4509a12fea491e57$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $4509a12fea491e57$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $4509a12fea491e57$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $4509a12fea491e57$export$35059013cd4a06db(e, r, a, s === 0 ? $4509a12fea491e57$export$aa3a2e812ca8570d : i, f, o, l);
}
function $4509a12fea491e57$export$4a34f930e789283c(e, r, a) {
    return $4509a12fea491e57$export$35059013cd4a06db(e, r, a, $4509a12fea491e57$export$a29989082612d0d9, $4509a12fea491e57$export$6788812c4e6611e6($4509a12fea491e57$export$eba6f6f03b0a92e7()), $4509a12fea491e57$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $4509a12fea491e57$export$f8483753829ec8f3(e, r, a, n) {
    return $4509a12fea491e57$export$35059013cd4a06db(e, r, a, $4509a12fea491e57$export$527d108ccf083c2b, $4509a12fea491e57$export$2f35ab04d2335697(e, 0, n), $4509a12fea491e57$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $4509a12fea491e57$export$82e9f45cca5ba907(n, c, s) {
    switch($4509a12fea491e57$export$d6af199866bfb566(n, c)){
        case 5103:
            return $4509a12fea491e57$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $4509a12fea491e57$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $4509a12fea491e57$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $4509a12fea491e57$export$39dfd62a25e0fe93 + n + $4509a12fea491e57$export$2c0f367103c8d01c + n + $4509a12fea491e57$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($4509a12fea491e57$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $4509a12fea491e57$export$39dfd62a25e0fe93 + n + $4509a12fea491e57$export$71ad59f2e432cfe8 + $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $4509a12fea491e57$export$39dfd62a25e0fe93 + n + $4509a12fea491e57$export$71ad59f2e432cfe8 + $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $4509a12fea491e57$export$39dfd62a25e0fe93 + n + $4509a12fea491e57$export$71ad59f2e432cfe8 + $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $4509a12fea491e57$export$39dfd62a25e0fe93 + n + $4509a12fea491e57$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $4509a12fea491e57$export$39dfd62a25e0fe93 + n + $4509a12fea491e57$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $4509a12fea491e57$export$39dfd62a25e0fe93 + n + $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $4509a12fea491e57$export$39dfd62a25e0fe93 + "box-$1$2" + $4509a12fea491e57$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $4509a12fea491e57$export$39dfd62a25e0fe93 + n + $4509a12fea491e57$export$71ad59f2e432cfe8 + "flex-item-" + $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$4509a12fea491e57$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $4509a12fea491e57$export$71ad59f2e432cfe8 + "grid-row-" + $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $4509a12fea491e57$export$39dfd62a25e0fe93 + n + $4509a12fea491e57$export$71ad59f2e432cfe8 + "flex-line-pack" + $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $4509a12fea491e57$export$39dfd62a25e0fe93 + n + $4509a12fea491e57$export$71ad59f2e432cfe8 + $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $4509a12fea491e57$export$39dfd62a25e0fe93 + n + $4509a12fea491e57$export$71ad59f2e432cfe8 + $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $4509a12fea491e57$export$39dfd62a25e0fe93 + "box-" + $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, "-grow", "") + $4509a12fea491e57$export$39dfd62a25e0fe93 + n + $4509a12fea491e57$export$71ad59f2e432cfe8 + $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $4509a12fea491e57$export$39dfd62a25e0fe93 + $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $4509a12fea491e57$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $4509a12fea491e57$export$77ad94ebf1c2b9ed($4509a12fea491e57$export$77ad94ebf1c2b9ed($4509a12fea491e57$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $4509a12fea491e57$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $4509a12fea491e57$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $4509a12fea491e57$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $4509a12fea491e57$export$77ad94ebf1c2b9ed($4509a12fea491e57$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $4509a12fea491e57$export$39dfd62a25e0fe93 + "box-pack:$3" + $4509a12fea491e57$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $4509a12fea491e57$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$4509a12fea491e57$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $4509a12fea491e57$export$71ad59f2e432cfe8 + "grid-column-align" + $4509a12fea491e57$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $4509a12fea491e57$export$71ad59f2e432cfe8 + $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $4509a12fea491e57$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$4509a12fea491e57$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $4509a12fea491e57$export$71ad59f2e432cfe8 + $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $4509a12fea491e57$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$4509a12fea491e57$export$f8e21b1e77979a08(s, "span") ? $4509a12fea491e57$export$4659b591c19bdf3d(s, /\d+/) : +$4509a12fea491e57$export$4659b591c19bdf3d(s, /\d+/) - +$4509a12fea491e57$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $4509a12fea491e57$export$71ad59f2e432cfe8 + $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $4509a12fea491e57$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $4509a12fea491e57$export$71ad59f2e432cfe8 + $4509a12fea491e57$export$77ad94ebf1c2b9ed($4509a12fea491e57$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $4509a12fea491e57$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($4509a12fea491e57$export$36776f635604f274(n) - 1 - c > 6) switch($4509a12fea491e57$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($4509a12fea491e57$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $4509a12fea491e57$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $4509a12fea491e57$export$2c0f367103c8d01c + ($4509a12fea491e57$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$4509a12fea491e57$export$f8e21b1e77979a08(n, "stretch") ? $4509a12fea491e57$export$82e9f45cca5ba907($4509a12fea491e57$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $4509a12fea491e57$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $4509a12fea491e57$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($4509a12fea491e57$export$a9db5e087081082d(n, c + 6) === 121) return $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, ":", ":" + $4509a12fea491e57$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($4509a12fea491e57$export$a9db5e087081082d(n, $4509a12fea491e57$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $4509a12fea491e57$export$39dfd62a25e0fe93 + ($4509a12fea491e57$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $4509a12fea491e57$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $4509a12fea491e57$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, ":", ":" + $4509a12fea491e57$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $4509a12fea491e57$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $4509a12fea491e57$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $4509a12fea491e57$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $4509a12fea491e57$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $4509a12fea491e57$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $4509a12fea491e57$export$a763edbf796b780a:
        case $4509a12fea491e57$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $4509a12fea491e57$export$a29989082612d0d9:
            return "";
        case $4509a12fea491e57$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $4509a12fea491e57$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $4509a12fea491e57$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $4509a12fea491e57$export$36776f635604f274(a = $4509a12fea491e57$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $4509a12fea491e57$export$5a7767152ae0305f(e) {
    var r = $4509a12fea491e57$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $4509a12fea491e57$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $4509a12fea491e57$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $4509a12fea491e57$export$527d108ccf083c2b:
                n.return = $4509a12fea491e57$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $4509a12fea491e57$export$b44a8529a35fcb60:
                return $4509a12fea491e57$export$dfdc1655ccc5b9cb([
                    $4509a12fea491e57$export$784d13d8ee351f07(n, {
                        value: $4509a12fea491e57$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $4509a12fea491e57$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $4509a12fea491e57$export$aa3a2e812ca8570d:
                if (n.length) return $4509a12fea491e57$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($4509a12fea491e57$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $4509a12fea491e57$export$dfdc1655ccc5b9cb([
                                $4509a12fea491e57$export$784d13d8ee351f07(n, {
                                    props: [
                                        $4509a12fea491e57$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $4509a12fea491e57$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $4509a12fea491e57$export$dfdc1655ccc5b9cb([
                                $4509a12fea491e57$export$784d13d8ee351f07(n, {
                                    props: [
                                        $4509a12fea491e57$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $4509a12fea491e57$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $4509a12fea491e57$export$784d13d8ee351f07(n, {
                                    props: [
                                        $4509a12fea491e57$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $4509a12fea491e57$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $4509a12fea491e57$export$784d13d8ee351f07(n, {
                                    props: [
                                        $4509a12fea491e57$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $4509a12fea491e57$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $4509a12fea491e57$export$76a88f7de6507443(e) {
    switch(e.type){
        case $4509a12fea491e57$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $4509a12fea491e57$export$1be1fc439b849fdf($4509a12fea491e57$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($4509a12fea491e57$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $4509a12fea491e57$export$2f35ab04d2335697(r, 1, $4509a12fea491e57$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $4509a12fea491e57$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $4509a12fea491e57$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $4509a12fea491e57$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("47Tyn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3012e89c0d33c9a0$export$2e2bcd8739ae039; });
var $3012e89c0d33c9a0$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("gRouI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c46498a314014487$export$2e2bcd8739ae039; });
function $c46498a314014487$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("3IqxN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b4a124408fb4d02$export$2e2bcd8739ae039; });

var $6q1gP = parcelRequire("6q1gP");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $2b4a124408fb4d02$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6q1gP)))(targetComponent, sourceComponent);
};

});
parcelRegister("6q1gP", function(module, exports) {
'use strict';

var $G7LU6 = parcelRequire("G7LU6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $4ac6280ec989192c$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $4ac6280ec989192c$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $4ac6280ec989192c$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $4ac6280ec989192c$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $4ac6280ec989192c$var$TYPE_STATICS = {};
$4ac6280ec989192c$var$TYPE_STATICS[$G7LU6.ForwardRef] = $4ac6280ec989192c$var$FORWARD_REF_STATICS;
$4ac6280ec989192c$var$TYPE_STATICS[$G7LU6.Memo] = $4ac6280ec989192c$var$MEMO_STATICS;
function $4ac6280ec989192c$var$getStatics(component) {
    // React v16.11 and below
    if ($G7LU6.isMemo(component)) return $4ac6280ec989192c$var$MEMO_STATICS;
     // React v16.12 and above
    return $4ac6280ec989192c$var$TYPE_STATICS[component['$$typeof']] || $4ac6280ec989192c$var$REACT_STATICS;
}
var $4ac6280ec989192c$var$defineProperty = Object.defineProperty;
var $4ac6280ec989192c$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $4ac6280ec989192c$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $4ac6280ec989192c$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $4ac6280ec989192c$var$getPrototypeOf = Object.getPrototypeOf;
var $4ac6280ec989192c$var$objectPrototype = Object.prototype;
function $4ac6280ec989192c$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($4ac6280ec989192c$var$objectPrototype) {
            var inheritedComponent = $4ac6280ec989192c$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $4ac6280ec989192c$var$objectPrototype) $4ac6280ec989192c$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $4ac6280ec989192c$var$getOwnPropertyNames(sourceComponent);
        if ($4ac6280ec989192c$var$getOwnPropertySymbols) keys = keys.concat($4ac6280ec989192c$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $4ac6280ec989192c$var$getStatics(targetComponent);
        var sourceStatics = $4ac6280ec989192c$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$4ac6280ec989192c$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $4ac6280ec989192c$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $4ac6280ec989192c$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $4ac6280ec989192c$var$hoistNonReactStatics;

});
parcelRegister("G7LU6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lVnei"));

});



parcelRegister("h3Czr", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $c6b0a2cf021587b7$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $c6b0a2cf021587b7$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $c6b0a2cf021587b7$export$6f077d94b33a01aa; });
var $c6b0a2cf021587b7$var$isBrowser = typeof document !== 'undefined';
function $c6b0a2cf021587b7$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $c6b0a2cf021587b7$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $c6b0a2cf021587b7$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $c6b0a2cf021587b7$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $c6b0a2cf021587b7$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$c6b0a2cf021587b7$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$c6b0a2cf021587b7$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("7wOEF", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $57b2d095eec11f8d$export$6321afa313b251b5; });

var $e09Lt = parcelRequire("e09Lt");

var $3YHyS = parcelRequire("3YHyS");

var $gRouI = parcelRequire("gRouI");
var $57b2d095eec11f8d$var$isDevelopment = false;
var $57b2d095eec11f8d$var$hyphenateRegex = /[A-Z]|^ms/g;
var $57b2d095eec11f8d$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $57b2d095eec11f8d$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $57b2d095eec11f8d$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $57b2d095eec11f8d$var$processStyleName = /* #__PURE__ */ (0, $gRouI.default)(function(styleName) {
    return $57b2d095eec11f8d$var$isCustomProperty(styleName) ? styleName : styleName.replace($57b2d095eec11f8d$var$hyphenateRegex, '-$&').toLowerCase();
});
var $57b2d095eec11f8d$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($57b2d095eec11f8d$var$animationRegex, function(match, p1, p2) {
                $57b2d095eec11f8d$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $57b2d095eec11f8d$var$cursor
                };
                return p1;
            });
    }
    if ((0, $3YHyS.default)[key] !== 1 && !$57b2d095eec11f8d$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $57b2d095eec11f8d$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $57b2d095eec11f8d$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $57b2d095eec11f8d$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $57b2d095eec11f8d$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $57b2d095eec11f8d$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $57b2d095eec11f8d$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $57b2d095eec11f8d$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $57b2d095eec11f8d$var$cursor;
                var result = interpolation(mergedProps);
                $57b2d095eec11f8d$var$cursor = previousCursor;
                return $57b2d095eec11f8d$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $57b2d095eec11f8d$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $57b2d095eec11f8d$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($57b2d095eec11f8d$var$isProcessableValue(asString)) string += $57b2d095eec11f8d$var$processStyleName(key) + ":" + $57b2d095eec11f8d$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $57b2d095eec11f8d$var$isDevelopment) throw new Error($57b2d095eec11f8d$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($57b2d095eec11f8d$var$isProcessableValue(value[_i])) string += $57b2d095eec11f8d$var$processStyleName(key) + ":" + $57b2d095eec11f8d$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $57b2d095eec11f8d$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $57b2d095eec11f8d$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $57b2d095eec11f8d$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $57b2d095eec11f8d$var$cursor;
function $57b2d095eec11f8d$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $57b2d095eec11f8d$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $57b2d095eec11f8d$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $57b2d095eec11f8d$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $57b2d095eec11f8d$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $57b2d095eec11f8d$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $e09Lt.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $57b2d095eec11f8d$var$cursor
    };
}

});
parcelRegister("e09Lt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a318a3ddf16e13c8$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $a318a3ddf16e13c8$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("3YHyS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e58c41906bd6205$export$2e2bcd8739ae039; });
var $2e58c41906bd6205$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("lje6s", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $f8364fe4fd58903a$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $f8364fe4fd58903a$export$811a713a7276cb9d; });

var $gRqVZ = parcelRequire("gRqVZ");
var $f8364fe4fd58903a$var$isBrowser = typeof document !== 'undefined';
var $f8364fe4fd58903a$var$syncFallback = function syncFallback(create) {
    return create();
};
var $f8364fe4fd58903a$var$useInsertionEffect = $gRqVZ.useInsertionEffect ? $gRqVZ.useInsertionEffect : false;
var $f8364fe4fd58903a$export$db21c7ffa21794e7 = !$f8364fe4fd58903a$var$isBrowser ? $f8364fe4fd58903a$var$syncFallback : $f8364fe4fd58903a$var$useInsertionEffect || $f8364fe4fd58903a$var$syncFallback;
var $f8364fe4fd58903a$export$811a713a7276cb9d = $f8364fe4fd58903a$var$useInsertionEffect || $gRqVZ.useLayoutEffect;

});



parcelRegister("2Fkpb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f0f3d25d773bb0c$export$2e2bcd8739ae039; });

var $gRouI = parcelRequire("gRouI");
// eslint-disable-next-line no-undef
var $1f0f3d25d773bb0c$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $1f0f3d25d773bb0c$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $gRouI.default)(function(prop) {
    return $1f0f3d25d773bb0c$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("8vLaV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6325d000b64e8b74$export$2e2bcd8739ae039; });

var $gRqVZ = parcelRequire("gRqVZ");


var $8DRs0 = parcelRequire("8DRs0");

var $fohPQ = parcelRequire("fohPQ");

var $01ysi = parcelRequire("01ysi");
'use client';
function $6325d000b64e8b74$var$getCache(injectFirst, enableCssLayer) {
    const emotionCache = (0, $fohPQ.default)({
        key: 'css',
        prepend: injectFirst
    });
    if (enableCssLayer) {
        const prevInsert = emotionCache.insert;
        emotionCache.insert = (...args)=>{
            if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
            args[1].styles = `@layer mui {${args[1].styles}}`;
            return prevInsert(...args);
        };
    }
    return emotionCache;
}
const $6325d000b64e8b74$var$cacheMap = new Map();
function $6325d000b64e8b74$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $gRqVZ.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $6325d000b64e8b74$var$cacheMap.has(cacheKey)) return $6325d000b64e8b74$var$cacheMap.get(cacheKey);
        const fresh = $6325d000b64e8b74$var$getCache(injectFirst, enableCssLayer);
        $6325d000b64e8b74$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    if (injectFirst || enableCssLayer) return /*#__PURE__*/ (0, $01ysi.jsx)((0, $8DRs0.C), {
        value: cache,
        children: children
    });
    return children;
}

});

parcelRegister("4dd7z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31128dec16d8f8bb$export$2e2bcd8739ae039; });
parcelRequire("gRqVZ");


var $50JbI = parcelRequire("50JbI");

var $01ysi = parcelRequire("01ysi");
'use client';
function $31128dec16d8f8bb$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $31128dec16d8f8bb$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($31128dec16d8f8bb$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $50JbI.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("b6XT3", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $816eb5906909f144$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $816eb5906909f144$export$2e2bcd8739ae039; });

var $if2ZQ = parcelRequire("if2ZQ");

var $gRqVZ = parcelRequire("gRqVZ");
function $816eb5906909f144$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $816eb5906909f144$var$deepClone(source) {
    if (/*#__PURE__*/ $gRqVZ.isValidElement(source) || !$816eb5906909f144$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $816eb5906909f144$var$deepClone(source[key]);
    });
    return output;
}
function $816eb5906909f144$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $if2ZQ.default)({}, target) : target;
    if ($816eb5906909f144$export$53b83ca8eaab0383(target) && $816eb5906909f144$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $gRqVZ.isValidElement(source[key])) output[key] = source[key];
        else if ($816eb5906909f144$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $816eb5906909f144$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $816eb5906909f144$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $816eb5906909f144$export$53b83ca8eaab0383(source[key]) ? $816eb5906909f144$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("i8qbw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("iGncY")).default; });

var $iGncY = parcelRequire("iGncY");

});

parcelRegister("271u2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("hA3a8")).default; });

var $hA3a8 = parcelRequire("hA3a8");
$parcel$exportWildcard(module.exports, $hA3a8);

});
parcelRegister("hA3a8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $ccc840780d0aec7a$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $ccc840780d0aec7a$export$2e2bcd8739ae039; });

var $21zrz = parcelRequire("21zrz");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $ccc840780d0aec7a$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $ccc840780d0aec7a$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($ccc840780d0aec7a$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $ccc840780d0aec7a$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $ccc840780d0aec7a$export$aad197c7121a6651(Component) || fallback;
}
function $ccc840780d0aec7a$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $ccc840780d0aec7a$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $ccc840780d0aec7a$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $ccc840780d0aec7a$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $21zrz.ForwardRef:
            return $ccc840780d0aec7a$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $21zrz.Memo:
            return $ccc840780d0aec7a$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("21zrz", function(module, exports) {
'use strict';

module.exports = (parcelRequire("65tnd"));

});
parcelRegister("65tnd", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $46e9fea6bf473b07$export$a7c73072b1a182ae; }, function (v) { return $46e9fea6bf473b07$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $46e9fea6bf473b07$export$9f27bc3417b4524d; }, function (v) { return $46e9fea6bf473b07$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $46e9fea6bf473b07$export$db77ccec0bb4ccac; }, function (v) { return $46e9fea6bf473b07$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $46e9fea6bf473b07$export$8392c0c9d3dcbd35; }, function (v) { return $46e9fea6bf473b07$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $46e9fea6bf473b07$export$ffb0004e005737fa; }, function (v) { return $46e9fea6bf473b07$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $46e9fea6bf473b07$export$b624eff549462981; }, function (v) { return $46e9fea6bf473b07$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $46e9fea6bf473b07$export$7897aa7841a5380c; }, function (v) { return $46e9fea6bf473b07$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $46e9fea6bf473b07$export$602eac185826482c; }, function (v) { return $46e9fea6bf473b07$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $46e9fea6bf473b07$export$e2c29f18771995cb; }, function (v) { return $46e9fea6bf473b07$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $46e9fea6bf473b07$export$5f8d39834fd61797; }, function (v) { return $46e9fea6bf473b07$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $46e9fea6bf473b07$export$74bf444e3cd11ea5; }, function (v) { return $46e9fea6bf473b07$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $46e9fea6bf473b07$export$998bcd577473dd93; }, function (v) { return $46e9fea6bf473b07$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $46e9fea6bf473b07$export$b706b080d889d2c9; }, function (v) { return $46e9fea6bf473b07$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $46e9fea6bf473b07$export$5be5a87408f70ddc; }, function (v) { return $46e9fea6bf473b07$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $46e9fea6bf473b07$export$45a5e7f76e0caa8d; }, function (v) { return $46e9fea6bf473b07$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $46e9fea6bf473b07$export$455c2e768291efa6; }, function (v) { return $46e9fea6bf473b07$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $46e9fea6bf473b07$export$9522e17588c12572; }, function (v) { return $46e9fea6bf473b07$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $46e9fea6bf473b07$export$2110ac352bb060b9; }, function (v) { return $46e9fea6bf473b07$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $46e9fea6bf473b07$export$56885ab8b9c456ab; }, function (v) { return $46e9fea6bf473b07$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $46e9fea6bf473b07$export$d927fcb6adf8f9de; }, function (v) { return $46e9fea6bf473b07$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $46e9fea6bf473b07$export$b82d16f27459e05a; }, function (v) { return $46e9fea6bf473b07$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $46e9fea6bf473b07$export$522c17b4f5e123e8; }, function (v) { return $46e9fea6bf473b07$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $46e9fea6bf473b07$export$1aabd8a0274ecfd6; }, function (v) { return $46e9fea6bf473b07$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $46e9fea6bf473b07$export$3d6c20d97e46b957; }, function (v) { return $46e9fea6bf473b07$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $46e9fea6bf473b07$export$9b621391a187a31a; }, function (v) { return $46e9fea6bf473b07$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $46e9fea6bf473b07$export$f5bbd400c2f4426f; }, function (v) { return $46e9fea6bf473b07$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $46e9fea6bf473b07$export$a7c73072b1a182ae;
var $46e9fea6bf473b07$export$9f27bc3417b4524d;
var $46e9fea6bf473b07$export$db77ccec0bb4ccac;
var $46e9fea6bf473b07$export$8392c0c9d3dcbd35;
var $46e9fea6bf473b07$export$ffb0004e005737fa;
var $46e9fea6bf473b07$export$b624eff549462981;
var $46e9fea6bf473b07$export$7897aa7841a5380c;
var $46e9fea6bf473b07$export$602eac185826482c;
var $46e9fea6bf473b07$export$e2c29f18771995cb;
var $46e9fea6bf473b07$export$5f8d39834fd61797;
var $46e9fea6bf473b07$export$74bf444e3cd11ea5;
var $46e9fea6bf473b07$export$998bcd577473dd93;
var $46e9fea6bf473b07$export$b706b080d889d2c9;
var $46e9fea6bf473b07$export$5be5a87408f70ddc;
var $46e9fea6bf473b07$export$45a5e7f76e0caa8d;
var $46e9fea6bf473b07$export$455c2e768291efa6;
var $46e9fea6bf473b07$export$9522e17588c12572;
var $46e9fea6bf473b07$export$2110ac352bb060b9;
var $46e9fea6bf473b07$export$56885ab8b9c456ab;
var $46e9fea6bf473b07$export$d927fcb6adf8f9de;
var $46e9fea6bf473b07$export$b82d16f27459e05a;
var $46e9fea6bf473b07$export$522c17b4f5e123e8;
var $46e9fea6bf473b07$export$1aabd8a0274ecfd6;
var $46e9fea6bf473b07$export$3d6c20d97e46b957;
var $46e9fea6bf473b07$export$9b621391a187a31a;
var $46e9fea6bf473b07$export$f5bbd400c2f4426f;
"use strict";
var $46e9fea6bf473b07$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $46e9fea6bf473b07$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $46e9fea6bf473b07$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $46e9fea6bf473b07$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $46e9fea6bf473b07$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $46e9fea6bf473b07$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $46e9fea6bf473b07$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $46e9fea6bf473b07$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $46e9fea6bf473b07$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $46e9fea6bf473b07$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $46e9fea6bf473b07$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $46e9fea6bf473b07$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $46e9fea6bf473b07$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $46e9fea6bf473b07$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $46e9fea6bf473b07$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $46e9fea6bf473b07$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $46e9fea6bf473b07$var$REACT_FRAGMENT_TYPE:
                    case $46e9fea6bf473b07$var$REACT_PROFILER_TYPE:
                    case $46e9fea6bf473b07$var$REACT_STRICT_MODE_TYPE:
                    case $46e9fea6bf473b07$var$REACT_SUSPENSE_TYPE:
                    case $46e9fea6bf473b07$var$REACT_SUSPENSE_LIST_TYPE:
                    case $46e9fea6bf473b07$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $46e9fea6bf473b07$var$REACT_CONTEXT_TYPE:
                            case $46e9fea6bf473b07$var$REACT_FORWARD_REF_TYPE:
                            case $46e9fea6bf473b07$var$REACT_LAZY_TYPE:
                            case $46e9fea6bf473b07$var$REACT_MEMO_TYPE:
                                return object;
                            case $46e9fea6bf473b07$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $46e9fea6bf473b07$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$46e9fea6bf473b07$export$a7c73072b1a182ae = $46e9fea6bf473b07$var$REACT_CONSUMER_TYPE;
$46e9fea6bf473b07$export$9f27bc3417b4524d = $46e9fea6bf473b07$var$REACT_CONTEXT_TYPE;
$46e9fea6bf473b07$export$db77ccec0bb4ccac = $46e9fea6bf473b07$var$REACT_ELEMENT_TYPE;
$46e9fea6bf473b07$export$8392c0c9d3dcbd35 = $46e9fea6bf473b07$var$REACT_FORWARD_REF_TYPE;
$46e9fea6bf473b07$export$ffb0004e005737fa = $46e9fea6bf473b07$var$REACT_FRAGMENT_TYPE;
$46e9fea6bf473b07$export$b624eff549462981 = $46e9fea6bf473b07$var$REACT_LAZY_TYPE;
$46e9fea6bf473b07$export$7897aa7841a5380c = $46e9fea6bf473b07$var$REACT_MEMO_TYPE;
$46e9fea6bf473b07$export$602eac185826482c = $46e9fea6bf473b07$var$REACT_PORTAL_TYPE;
$46e9fea6bf473b07$export$e2c29f18771995cb = $46e9fea6bf473b07$var$REACT_PROFILER_TYPE;
$46e9fea6bf473b07$export$5f8d39834fd61797 = $46e9fea6bf473b07$var$REACT_STRICT_MODE_TYPE;
$46e9fea6bf473b07$export$74bf444e3cd11ea5 = $46e9fea6bf473b07$var$REACT_SUSPENSE_TYPE;
$46e9fea6bf473b07$export$998bcd577473dd93 = $46e9fea6bf473b07$var$REACT_SUSPENSE_LIST_TYPE;
$46e9fea6bf473b07$export$b706b080d889d2c9 = function(object) {
    return $46e9fea6bf473b07$var$typeOf(object) === $46e9fea6bf473b07$var$REACT_CONSUMER_TYPE;
};
$46e9fea6bf473b07$export$5be5a87408f70ddc = function(object) {
    return $46e9fea6bf473b07$var$typeOf(object) === $46e9fea6bf473b07$var$REACT_CONTEXT_TYPE;
};
$46e9fea6bf473b07$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $46e9fea6bf473b07$var$REACT_ELEMENT_TYPE;
};
$46e9fea6bf473b07$export$455c2e768291efa6 = function(object) {
    return $46e9fea6bf473b07$var$typeOf(object) === $46e9fea6bf473b07$var$REACT_FORWARD_REF_TYPE;
};
$46e9fea6bf473b07$export$9522e17588c12572 = function(object) {
    return $46e9fea6bf473b07$var$typeOf(object) === $46e9fea6bf473b07$var$REACT_FRAGMENT_TYPE;
};
$46e9fea6bf473b07$export$2110ac352bb060b9 = function(object) {
    return $46e9fea6bf473b07$var$typeOf(object) === $46e9fea6bf473b07$var$REACT_LAZY_TYPE;
};
$46e9fea6bf473b07$export$56885ab8b9c456ab = function(object) {
    return $46e9fea6bf473b07$var$typeOf(object) === $46e9fea6bf473b07$var$REACT_MEMO_TYPE;
};
$46e9fea6bf473b07$export$d927fcb6adf8f9de = function(object) {
    return $46e9fea6bf473b07$var$typeOf(object) === $46e9fea6bf473b07$var$REACT_PORTAL_TYPE;
};
$46e9fea6bf473b07$export$b82d16f27459e05a = function(object) {
    return $46e9fea6bf473b07$var$typeOf(object) === $46e9fea6bf473b07$var$REACT_PROFILER_TYPE;
};
$46e9fea6bf473b07$export$522c17b4f5e123e8 = function(object) {
    return $46e9fea6bf473b07$var$typeOf(object) === $46e9fea6bf473b07$var$REACT_STRICT_MODE_TYPE;
};
$46e9fea6bf473b07$export$1aabd8a0274ecfd6 = function(object) {
    return $46e9fea6bf473b07$var$typeOf(object) === $46e9fea6bf473b07$var$REACT_SUSPENSE_TYPE;
};
$46e9fea6bf473b07$export$3d6c20d97e46b957 = function(object) {
    return $46e9fea6bf473b07$var$typeOf(object) === $46e9fea6bf473b07$var$REACT_SUSPENSE_LIST_TYPE;
};
$46e9fea6bf473b07$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $46e9fea6bf473b07$var$REACT_FRAGMENT_TYPE || type === $46e9fea6bf473b07$var$REACT_PROFILER_TYPE || type === $46e9fea6bf473b07$var$REACT_STRICT_MODE_TYPE || type === $46e9fea6bf473b07$var$REACT_SUSPENSE_TYPE || type === $46e9fea6bf473b07$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $46e9fea6bf473b07$var$REACT_LAZY_TYPE || type.$$typeof === $46e9fea6bf473b07$var$REACT_MEMO_TYPE || type.$$typeof === $46e9fea6bf473b07$var$REACT_CONTEXT_TYPE || type.$$typeof === $46e9fea6bf473b07$var$REACT_CONSUMER_TYPE || type.$$typeof === $46e9fea6bf473b07$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $46e9fea6bf473b07$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$46e9fea6bf473b07$export$f5bbd400c2f4426f = $46e9fea6bf473b07$var$typeOf;

});




parcelRegister("leyOo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("bmFJp")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("j56oc")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("afIbA")).default; });

var $bmFJp = parcelRequire("bmFJp");

var $j56oc = parcelRequire("j56oc");

var $afIbA = parcelRequire("afIbA");

});
parcelRegister("bmFJp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84621ec9c9b4e708$export$2e2bcd8739ae039; });

var $if2ZQ = parcelRequire("if2ZQ");

var $2UY5J = parcelRequire("2UY5J");

var $b6XT3 = parcelRequire("b6XT3");

var $j56oc = parcelRequire("j56oc");

var $aJf8u = parcelRequire("aJf8u");

var $43Mxh = parcelRequire("43Mxh");

var $euX6z = parcelRequire("euX6z");

var $bA4Bm = parcelRequire("bA4Bm");

var $afIbA = parcelRequire("afIbA");
const $84621ec9c9b4e708$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $84621ec9c9b4e708$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $2UY5J.default)(options, $84621ec9c9b4e708$var$_excluded);
    const breakpoints = (0, $j56oc.default)(breakpointsInput);
    const spacing = (0, $43Mxh.default)(spacingInput);
    let muiTheme = (0, $b6XT3.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $if2ZQ.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $if2ZQ.default)({}, (0, $aJf8u.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $afIbA.default);
    muiTheme = args.reduce((acc, argument)=>(0, $b6XT3.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $if2ZQ.default)({}, (0, $bA4Bm.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $euX6z.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $84621ec9c9b4e708$export$2e2bcd8739ae039 = $84621ec9c9b4e708$var$createTheme;

});
parcelRegister("j56oc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de4370c2527c9e90$export$2e2bcd8739ae039; });

var $2UY5J = parcelRequire("2UY5J");

var $if2ZQ = parcelRequire("if2ZQ");
const $de4370c2527c9e90$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $de4370c2527c9e90$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $de4370c2527c9e90$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $if2ZQ.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $de4370c2527c9e90$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $2UY5J.default)(breakpoints, $de4370c2527c9e90$var$_excluded);
    const sortedValues = $de4370c2527c9e90$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $if2ZQ.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("aJf8u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cf9d908d10a62a3$export$2e2bcd8739ae039; });
const $7cf9d908d10a62a3$var$shape = {
    borderRadius: 4
};
var $7cf9d908d10a62a3$export$2e2bcd8739ae039 = $7cf9d908d10a62a3$var$shape;

});

parcelRegister("43Mxh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f4d176fd29c0ad4$export$2e2bcd8739ae039; });

var $dtIKp = parcelRequire("dtIKp");
function $2f4d176fd29c0ad4$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $dtIKp.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("dtIKp", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $9d00b1b518bb3307$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $9d00b1b518bb3307$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $9d00b1b518bb3307$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $9d00b1b518bb3307$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $9d00b1b518bb3307$export$6f98e8eaf0be1996; });


var $3EQY1 = parcelRequire("3EQY1");

var $du93j = parcelRequire("du93j");

var $bg0eO = parcelRequire("bg0eO");

var $jwQ9U = parcelRequire("jwQ9U");
const $9d00b1b518bb3307$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $9d00b1b518bb3307$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $9d00b1b518bb3307$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $9d00b1b518bb3307$var$getCssProperties = (0, $jwQ9U.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($9d00b1b518bb3307$var$aliases[prop]) prop = $9d00b1b518bb3307$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $9d00b1b518bb3307$var$properties[a];
    const direction = $9d00b1b518bb3307$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $9d00b1b518bb3307$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $9d00b1b518bb3307$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $9d00b1b518bb3307$var$spacingKeys = [
    ...$9d00b1b518bb3307$export$aab52a0dde05ad8a,
    ...$9d00b1b518bb3307$export$f8397d44f03ab6ad
];
function $9d00b1b518bb3307$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $du93j.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $9d00b1b518bb3307$export$1def6f833384e3d1(theme) {
    return $9d00b1b518bb3307$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $9d00b1b518bb3307$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $9d00b1b518bb3307$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $9d00b1b518bb3307$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $9d00b1b518bb3307$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $9d00b1b518bb3307$var$getCssProperties(prop);
    const styleFromPropValue = $9d00b1b518bb3307$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $3EQY1.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $9d00b1b518bb3307$var$style(props, keys) {
    const transformer = $9d00b1b518bb3307$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$9d00b1b518bb3307$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $bg0eO.default), {});
}
function $9d00b1b518bb3307$export$7ede87f9b603dd3c(props) {
    return $9d00b1b518bb3307$var$style(props, $9d00b1b518bb3307$export$aab52a0dde05ad8a);
}
$9d00b1b518bb3307$export$7ede87f9b603dd3c.propTypes = {};
$9d00b1b518bb3307$export$7ede87f9b603dd3c.filterProps = $9d00b1b518bb3307$export$aab52a0dde05ad8a;
function $9d00b1b518bb3307$export$6f98e8eaf0be1996(props) {
    return $9d00b1b518bb3307$var$style(props, $9d00b1b518bb3307$export$f8397d44f03ab6ad);
}
$9d00b1b518bb3307$export$6f98e8eaf0be1996.propTypes = {};
$9d00b1b518bb3307$export$6f98e8eaf0be1996.filterProps = $9d00b1b518bb3307$export$f8397d44f03ab6ad;
function $9d00b1b518bb3307$var$spacing(props) {
    return $9d00b1b518bb3307$var$style(props, $9d00b1b518bb3307$var$spacingKeys);
}
$9d00b1b518bb3307$var$spacing.propTypes = {};
$9d00b1b518bb3307$var$spacing.filterProps = $9d00b1b518bb3307$var$spacingKeys;
var $9d00b1b518bb3307$export$2e2bcd8739ae039 = $9d00b1b518bb3307$var$spacing;

});
parcelRegister("3EQY1", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $2a9e31b39b1321d8$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $2a9e31b39b1321d8$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $2a9e31b39b1321d8$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $2a9e31b39b1321d8$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $2a9e31b39b1321d8$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $2a9e31b39b1321d8$export$980e6a259d807490; });

var $if2ZQ = parcelRequire("if2ZQ");


var $b6XT3 = parcelRequire("b6XT3");

var $bg0eO = parcelRequire("bg0eO");
const $2a9e31b39b1321d8$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $2a9e31b39b1321d8$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$2a9e31b39b1321d8$export$68c286be0e7e55b7[key]}px)`
};
function $2a9e31b39b1321d8$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $2a9e31b39b1321d8$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $2a9e31b39b1321d8$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $2a9e31b39b1321d8$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $2a9e31b39b1321d8$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $2a9e31b39b1321d8$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $if2ZQ.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $bg0eO.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $2a9e31b39b1321d8$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $2a9e31b39b1321d8$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $2a9e31b39b1321d8$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $2a9e31b39b1321d8$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $b6XT3.default)(prev, next), {});
    return $2a9e31b39b1321d8$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $2a9e31b39b1321d8$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $2a9e31b39b1321d8$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $2a9e31b39b1321d8$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $2a9e31b39b1321d8$export$2e2bcd8739ae039 = $2a9e31b39b1321d8$var$breakpoints;

});
parcelRegister("bg0eO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83215f948f2403e5$export$2e2bcd8739ae039; });

var $b6XT3 = parcelRequire("b6XT3");
function $83215f948f2403e5$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $b6XT3.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $83215f948f2403e5$export$2e2bcd8739ae039 = $83215f948f2403e5$var$merge;

});


parcelRegister("du93j", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $9d1519518b49f369$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $9d1519518b49f369$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $9d1519518b49f369$export$2e2bcd8739ae039; });

var $iGncY = parcelRequire("iGncY");


var $3EQY1 = parcelRequire("3EQY1");
function $9d1519518b49f369$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $9d1519518b49f369$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $9d1519518b49f369$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $9d1519518b49f369$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $9d1519518b49f369$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $9d1519518b49f369$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $9d1519518b49f369$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $iGncY.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $3EQY1.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $9d1519518b49f369$export$2e2bcd8739ae039 = $9d1519518b49f369$var$style;

});

parcelRegister("jwQ9U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e379771f55960bdd$export$2e2bcd8739ae039; });
function $e379771f55960bdd$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("euX6z", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $a8e1b70687fd5b84$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $a8e1b70687fd5b84$export$2e2bcd8739ae039; });

var $iGncY = parcelRequire("iGncY");

var $bg0eO = parcelRequire("bg0eO");

var $du93j = parcelRequire("du93j");

var $3EQY1 = parcelRequire("3EQY1");

var $bA4Bm = parcelRequire("bA4Bm");
function $a8e1b70687fd5b84$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $a8e1b70687fd5b84$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $a8e1b70687fd5b84$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $du93j.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $du93j.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $du93j.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $iGncY.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $3EQY1.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $bA4Bm.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $3EQY1.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $a8e1b70687fd5b84$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $bg0eO.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $3EQY1.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($a8e1b70687fd5b84$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $bg0eO.default)(css, breakpointsValues);
                        }
                    } else css = (0, $bg0eO.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $3EQY1.removeUnusedBreakpoints)(breakpointsKeys, css)
            };
            return (0, $3EQY1.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $a8e1b70687fd5b84$var$styleFunctionSx = $a8e1b70687fd5b84$export$7d53d8bf2911e013();
$a8e1b70687fd5b84$var$styleFunctionSx.filterProps = [
    'sx'
];
var $a8e1b70687fd5b84$export$2e2bcd8739ae039 = $a8e1b70687fd5b84$var$styleFunctionSx;

});
parcelRegister("bA4Bm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86e6a0496061903a$export$2e2bcd8739ae039; });

var $dtIKp = parcelRequire("dtIKp");

var $3aejT = parcelRequire("3aejT");

var $HKwFA = parcelRequire("HKwFA");

var $bElcC = parcelRequire("bElcC");

var $eumTQ = parcelRequire("eumTQ");
const $86e6a0496061903a$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $3aejT.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $3aejT.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $3aejT.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $3aejT.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $3aejT.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $3aejT.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $3aejT.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $bElcC.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $bElcC.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $bElcC.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $dtIKp.padding)
    },
    pt: {
        style: (0, $dtIKp.padding)
    },
    pr: {
        style: (0, $dtIKp.padding)
    },
    pb: {
        style: (0, $dtIKp.padding)
    },
    pl: {
        style: (0, $dtIKp.padding)
    },
    px: {
        style: (0, $dtIKp.padding)
    },
    py: {
        style: (0, $dtIKp.padding)
    },
    padding: {
        style: (0, $dtIKp.padding)
    },
    paddingTop: {
        style: (0, $dtIKp.padding)
    },
    paddingRight: {
        style: (0, $dtIKp.padding)
    },
    paddingBottom: {
        style: (0, $dtIKp.padding)
    },
    paddingLeft: {
        style: (0, $dtIKp.padding)
    },
    paddingX: {
        style: (0, $dtIKp.padding)
    },
    paddingY: {
        style: (0, $dtIKp.padding)
    },
    paddingInline: {
        style: (0, $dtIKp.padding)
    },
    paddingInlineStart: {
        style: (0, $dtIKp.padding)
    },
    paddingInlineEnd: {
        style: (0, $dtIKp.padding)
    },
    paddingBlock: {
        style: (0, $dtIKp.padding)
    },
    paddingBlockStart: {
        style: (0, $dtIKp.padding)
    },
    paddingBlockEnd: {
        style: (0, $dtIKp.padding)
    },
    m: {
        style: (0, $dtIKp.margin)
    },
    mt: {
        style: (0, $dtIKp.margin)
    },
    mr: {
        style: (0, $dtIKp.margin)
    },
    mb: {
        style: (0, $dtIKp.margin)
    },
    ml: {
        style: (0, $dtIKp.margin)
    },
    mx: {
        style: (0, $dtIKp.margin)
    },
    my: {
        style: (0, $dtIKp.margin)
    },
    margin: {
        style: (0, $dtIKp.margin)
    },
    marginTop: {
        style: (0, $dtIKp.margin)
    },
    marginRight: {
        style: (0, $dtIKp.margin)
    },
    marginBottom: {
        style: (0, $dtIKp.margin)
    },
    marginLeft: {
        style: (0, $dtIKp.margin)
    },
    marginX: {
        style: (0, $dtIKp.margin)
    },
    marginY: {
        style: (0, $dtIKp.margin)
    },
    marginInline: {
        style: (0, $dtIKp.margin)
    },
    marginInlineStart: {
        style: (0, $dtIKp.margin)
    },
    marginInlineEnd: {
        style: (0, $dtIKp.margin)
    },
    marginBlock: {
        style: (0, $dtIKp.margin)
    },
    marginBlockStart: {
        style: (0, $dtIKp.margin)
    },
    marginBlockEnd: {
        style: (0, $dtIKp.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $HKwFA.gap)
    },
    rowGap: {
        style: (0, $HKwFA.rowGap)
    },
    columnGap: {
        style: (0, $HKwFA.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $eumTQ.sizingTransform)
    },
    maxWidth: {
        style: (0, $eumTQ.maxWidth)
    },
    minWidth: {
        transform: (0, $eumTQ.sizingTransform)
    },
    height: {
        transform: (0, $eumTQ.sizingTransform)
    },
    maxHeight: {
        transform: (0, $eumTQ.sizingTransform)
    },
    minHeight: {
        transform: (0, $eumTQ.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $86e6a0496061903a$export$2e2bcd8739ae039 = $86e6a0496061903a$var$defaultSxConfig;

});
parcelRegister("3aejT", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $24dd69e5ea3104b5$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $24dd69e5ea3104b5$export$7a57f79000377ca2; });


var $du93j = parcelRequire("du93j");

var $976sh = parcelRequire("976sh");

var $dtIKp = parcelRequire("dtIKp");

var $3EQY1 = parcelRequire("3EQY1");
function $24dd69e5ea3104b5$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $24dd69e5ea3104b5$var$createBorderStyle(prop, transform) {
    return (0, $du93j.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $24dd69e5ea3104b5$export$1edee58a52776cd9 = $24dd69e5ea3104b5$var$createBorderStyle('border', $24dd69e5ea3104b5$export$34e2febe53ae29cc);
const $24dd69e5ea3104b5$export$f9a7b6bd24892946 = $24dd69e5ea3104b5$var$createBorderStyle('borderTop', $24dd69e5ea3104b5$export$34e2febe53ae29cc);
const $24dd69e5ea3104b5$export$5abca33e6be905d2 = $24dd69e5ea3104b5$var$createBorderStyle('borderRight', $24dd69e5ea3104b5$export$34e2febe53ae29cc);
const $24dd69e5ea3104b5$export$e2ce9f12a980a822 = $24dd69e5ea3104b5$var$createBorderStyle('borderBottom', $24dd69e5ea3104b5$export$34e2febe53ae29cc);
const $24dd69e5ea3104b5$export$47658cca1a909427 = $24dd69e5ea3104b5$var$createBorderStyle('borderLeft', $24dd69e5ea3104b5$export$34e2febe53ae29cc);
const $24dd69e5ea3104b5$export$e7fb0694ba2404fc = $24dd69e5ea3104b5$var$createBorderStyle('borderColor');
const $24dd69e5ea3104b5$export$126a92c968acdb85 = $24dd69e5ea3104b5$var$createBorderStyle('borderTopColor');
const $24dd69e5ea3104b5$export$85cc51cb8fbb8c0e = $24dd69e5ea3104b5$var$createBorderStyle('borderRightColor');
const $24dd69e5ea3104b5$export$340b0327727f6d1a = $24dd69e5ea3104b5$var$createBorderStyle('borderBottomColor');
const $24dd69e5ea3104b5$export$60beef91a985b4bf = $24dd69e5ea3104b5$var$createBorderStyle('borderLeftColor');
const $24dd69e5ea3104b5$export$f9258c55612cbed7 = $24dd69e5ea3104b5$var$createBorderStyle('outline', $24dd69e5ea3104b5$export$34e2febe53ae29cc);
const $24dd69e5ea3104b5$export$621fe586efeb64b9 = $24dd69e5ea3104b5$var$createBorderStyle('outlineColor');
const $24dd69e5ea3104b5$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $dtIKp.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $dtIKp.getValue)(transformer, propValue)
            });
        return (0, $3EQY1.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$24dd69e5ea3104b5$export$7a57f79000377ca2.propTypes = {};
$24dd69e5ea3104b5$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $24dd69e5ea3104b5$var$borders = (0, $976sh.default)($24dd69e5ea3104b5$export$1edee58a52776cd9, $24dd69e5ea3104b5$export$f9a7b6bd24892946, $24dd69e5ea3104b5$export$5abca33e6be905d2, $24dd69e5ea3104b5$export$e2ce9f12a980a822, $24dd69e5ea3104b5$export$47658cca1a909427, $24dd69e5ea3104b5$export$e7fb0694ba2404fc, $24dd69e5ea3104b5$export$126a92c968acdb85, $24dd69e5ea3104b5$export$85cc51cb8fbb8c0e, $24dd69e5ea3104b5$export$340b0327727f6d1a, $24dd69e5ea3104b5$export$60beef91a985b4bf, $24dd69e5ea3104b5$export$7a57f79000377ca2, $24dd69e5ea3104b5$export$f9258c55612cbed7, $24dd69e5ea3104b5$export$621fe586efeb64b9);
var $24dd69e5ea3104b5$export$2e2bcd8739ae039 = $24dd69e5ea3104b5$var$borders;

});
parcelRegister("976sh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a29c657c3be1ca1$export$2e2bcd8739ae039; });

var $bg0eO = parcelRequire("bg0eO");
function $6a29c657c3be1ca1$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $bg0eO.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $6a29c657c3be1ca1$export$2e2bcd8739ae039 = $6a29c657c3be1ca1$var$compose;

});


parcelRegister("HKwFA", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $08381b591a394362$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $08381b591a394362$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $08381b591a394362$export$8a833ffa5f5dbeda; });

var $du93j = parcelRequire("du93j");

var $976sh = parcelRequire("976sh");

var $dtIKp = parcelRequire("dtIKp");

var $3EQY1 = parcelRequire("3EQY1");

const $08381b591a394362$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $dtIKp.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $dtIKp.getValue)(transformer, propValue)
            });
        return (0, $3EQY1.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$08381b591a394362$export$5df9adcb0db95e1e.propTypes = {};
$08381b591a394362$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $08381b591a394362$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $dtIKp.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $dtIKp.getValue)(transformer, propValue)
            });
        return (0, $3EQY1.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$08381b591a394362$export$ec60d70ff941a580.propTypes = {};
$08381b591a394362$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $08381b591a394362$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $dtIKp.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $dtIKp.getValue)(transformer, propValue)
            });
        return (0, $3EQY1.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$08381b591a394362$export$8a833ffa5f5dbeda.propTypes = {};
$08381b591a394362$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $08381b591a394362$export$baf44164ca3a34e8 = (0, $du93j.default)({
    prop: 'gridColumn'
});
const $08381b591a394362$export$8f7213a1cd01e832 = (0, $du93j.default)({
    prop: 'gridRow'
});
const $08381b591a394362$export$b0e0abbc49ba668 = (0, $du93j.default)({
    prop: 'gridAutoFlow'
});
const $08381b591a394362$export$bcd8b929d4b4142 = (0, $du93j.default)({
    prop: 'gridAutoColumns'
});
const $08381b591a394362$export$e5039a674e14c828 = (0, $du93j.default)({
    prop: 'gridAutoRows'
});
const $08381b591a394362$export$42bd9088661ffb03 = (0, $du93j.default)({
    prop: 'gridTemplateColumns'
});
const $08381b591a394362$export$920682ae05b999bc = (0, $du93j.default)({
    prop: 'gridTemplateRows'
});
const $08381b591a394362$export$1b88fbdd482fd33a = (0, $du93j.default)({
    prop: 'gridTemplateAreas'
});
const $08381b591a394362$export$bdb486e40d52d26f = (0, $du93j.default)({
    prop: 'gridArea'
});
const $08381b591a394362$var$grid = (0, $976sh.default)($08381b591a394362$export$5df9adcb0db95e1e, $08381b591a394362$export$ec60d70ff941a580, $08381b591a394362$export$8a833ffa5f5dbeda, $08381b591a394362$export$baf44164ca3a34e8, $08381b591a394362$export$8f7213a1cd01e832, $08381b591a394362$export$b0e0abbc49ba668, $08381b591a394362$export$bcd8b929d4b4142, $08381b591a394362$export$e5039a674e14c828, $08381b591a394362$export$42bd9088661ffb03, $08381b591a394362$export$920682ae05b999bc, $08381b591a394362$export$1b88fbdd482fd33a, $08381b591a394362$export$bdb486e40d52d26f);
var $08381b591a394362$export$2e2bcd8739ae039 = $08381b591a394362$var$grid;

});

parcelRegister("bElcC", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $87b3e08a5c7322ea$export$dbaffd4420ea0ac6; });

var $du93j = parcelRequire("du93j");

var $976sh = parcelRequire("976sh");
function $87b3e08a5c7322ea$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $87b3e08a5c7322ea$export$35e9368ef982300f = (0, $du93j.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $87b3e08a5c7322ea$export$dbaffd4420ea0ac6
});
const $87b3e08a5c7322ea$export$2506f56c10355b33 = (0, $du93j.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $87b3e08a5c7322ea$export$dbaffd4420ea0ac6
});
const $87b3e08a5c7322ea$export$8c5a050822fd698c = (0, $du93j.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $87b3e08a5c7322ea$export$dbaffd4420ea0ac6
});
const $87b3e08a5c7322ea$var$palette = (0, $976sh.default)($87b3e08a5c7322ea$export$35e9368ef982300f, $87b3e08a5c7322ea$export$2506f56c10355b33, $87b3e08a5c7322ea$export$8c5a050822fd698c);
var $87b3e08a5c7322ea$export$2e2bcd8739ae039 = $87b3e08a5c7322ea$var$palette;

});

parcelRegister("eumTQ", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $a8c5a172be222e5b$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $a8c5a172be222e5b$export$488fda99655ff65a; });

var $du93j = parcelRequire("du93j");

var $976sh = parcelRequire("976sh");

var $3EQY1 = parcelRequire("3EQY1");
function $a8c5a172be222e5b$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $a8c5a172be222e5b$export$7e3df82ee760448c = (0, $du93j.default)({
    prop: 'width',
    transform: $a8c5a172be222e5b$export$8afece71750ec241
});
const $a8c5a172be222e5b$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $3EQY1.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $a8c5a172be222e5b$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $3EQY1.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$a8c5a172be222e5b$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $a8c5a172be222e5b$export$ee148fbbe8357dd2 = (0, $du93j.default)({
    prop: 'minWidth',
    transform: $a8c5a172be222e5b$export$8afece71750ec241
});
const $a8c5a172be222e5b$export$ac607276a8fe9f0a = (0, $du93j.default)({
    prop: 'height',
    transform: $a8c5a172be222e5b$export$8afece71750ec241
});
const $a8c5a172be222e5b$export$dc0d8bd0b94f8570 = (0, $du93j.default)({
    prop: 'maxHeight',
    transform: $a8c5a172be222e5b$export$8afece71750ec241
});
const $a8c5a172be222e5b$export$a43cf604e12f3b17 = (0, $du93j.default)({
    prop: 'minHeight',
    transform: $a8c5a172be222e5b$export$8afece71750ec241
});
const $a8c5a172be222e5b$export$ffed9f14fb65e276 = (0, $du93j.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $a8c5a172be222e5b$export$8afece71750ec241
});
const $a8c5a172be222e5b$export$905076ed6620e671 = (0, $du93j.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $a8c5a172be222e5b$export$8afece71750ec241
});
const $a8c5a172be222e5b$export$6ccc93f785106a58 = (0, $du93j.default)({
    prop: 'boxSizing'
});
const $a8c5a172be222e5b$var$sizing = (0, $976sh.default)($a8c5a172be222e5b$export$7e3df82ee760448c, $a8c5a172be222e5b$export$488fda99655ff65a, $a8c5a172be222e5b$export$ee148fbbe8357dd2, $a8c5a172be222e5b$export$ac607276a8fe9f0a, $a8c5a172be222e5b$export$dc0d8bd0b94f8570, $a8c5a172be222e5b$export$a43cf604e12f3b17, $a8c5a172be222e5b$export$6ccc93f785106a58);
var $a8c5a172be222e5b$export$2e2bcd8739ae039 = $a8c5a172be222e5b$var$sizing;

});



parcelRegister("afIbA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $776d947ae705c3f3$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $776d947ae705c3f3$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("9ABZG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("euX6z")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("euX6z")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("bnOCc")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("bA4Bm")).default; });

var $euX6z = parcelRequire("euX6z");

var $bnOCc = parcelRequire("bnOCc");

var $bA4Bm = parcelRequire("bA4Bm");

});
parcelRegister("bnOCc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84991ac9aabeb7b1$export$2e2bcd8739ae039; });

var $if2ZQ = parcelRequire("if2ZQ");

var $2UY5J = parcelRequire("2UY5J");

var $b6XT3 = parcelRequire("b6XT3");

var $bA4Bm = parcelRequire("bA4Bm");
const $84991ac9aabeb7b1$var$_excluded = [
    "sx"
];
const $84991ac9aabeb7b1$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $bA4Bm.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $84991ac9aabeb7b1$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $2UY5J.default)(props, $84991ac9aabeb7b1$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $84991ac9aabeb7b1$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $b6XT3.isPlainObject)(result)) return systemProps;
        return (0, $if2ZQ.default)({}, systemProps, result);
    };
    else finalSx = (0, $if2ZQ.default)({}, systemProps, inSx);
    return (0, $if2ZQ.default)({}, otherProps, {
        sx: finalSx
    });
}

});



parcelRegister("5B4J7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41341317a6e8a5a1$export$2e2bcd8739ae039; });

var $1kZhP = parcelRequire("1kZhP");
'use client';
const $41341317a6e8a5a1$var$defaultTheme = (0, $1kZhP.default)();
var $41341317a6e8a5a1$export$2e2bcd8739ae039 = $41341317a6e8a5a1$var$defaultTheme;

});
parcelRegister("1kZhP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f9732eaac35c2e6$export$2e2bcd8739ae039; });

var $if2ZQ = parcelRequire("if2ZQ");

var $2UY5J = parcelRequire("2UY5J");

var $16hJ5 = parcelRequire("16hJ5");

var $b6XT3 = parcelRequire("b6XT3");

var $euX6z = parcelRequire("euX6z");
var $bA4Bm = parcelRequire("bA4Bm");

var $bmFJp = parcelRequire("bmFJp");


var $d5DRE = parcelRequire("d5DRE");

var $jVvbx = parcelRequire("jVvbx");

var $3nYtv = parcelRequire("3nYtv");

var $52XlH = parcelRequire("52XlH");

var $eUwKW = parcelRequire("eUwKW");

var $2RJnv = parcelRequire("2RJnv");
const $0f9732eaac35c2e6$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $0f9732eaac35c2e6$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $2UY5J.default)(options, $0f9732eaac35c2e6$var$_excluded);
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateCssVars === undefined) throw new Error((0, $16hJ5.default)(18));
    const palette = (0, $jVvbx.default)(paletteInput);
    const systemTheme = (0, $bmFJp.default)(options);
    let muiTheme = (0, $b6XT3.default)(systemTheme, {
        mixins: (0, $d5DRE.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $52XlH.default).slice(),
        typography: (0, $3nYtv.default)(palette, typographyInput),
        transitions: (0, $eUwKW.default)(transitionsInput),
        zIndex: (0, $if2ZQ.default)({}, (0, $2RJnv.default))
    });
    muiTheme = (0, $b6XT3.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $b6XT3.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $if2ZQ.default)({}, (0, $bA4Bm.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $euX6z.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $0f9732eaac35c2e6$var$warnedOnce = false;
function $0f9732eaac35c2e6$export$c469355549431d9b(...args) {
    return $0f9732eaac35c2e6$var$createTheme(...args);
}
var $0f9732eaac35c2e6$export$2e2bcd8739ae039 = $0f9732eaac35c2e6$var$createTheme;

});
parcelRegister("d5DRE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $987aaa3565a53cef$export$2e2bcd8739ae039; });

var $if2ZQ = parcelRequire("if2ZQ");
function $987aaa3565a53cef$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $if2ZQ.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("jVvbx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e81b87e230ad317f$export$2e2bcd8739ae039; });

var $if2ZQ = parcelRequire("if2ZQ");

var $2UY5J = parcelRequire("2UY5J");

var $16hJ5 = parcelRequire("16hJ5");

var $b6XT3 = parcelRequire("b6XT3");

var $5olLg = parcelRequire("5olLg");

var $4An4F = parcelRequire("4An4F");

var $5YoP5 = parcelRequire("5YoP5");

var $gtZmB = parcelRequire("gtZmB");

var $7PLXJ = parcelRequire("7PLXJ");

var $byer0 = parcelRequire("byer0");

var $1J2pr = parcelRequire("1J2pr");

var $kORAY = parcelRequire("kORAY");

var $234Uj = parcelRequire("234Uj");
const $e81b87e230ad317f$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $e81b87e230ad317f$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $4An4F.default).white,
        default: (0, $4An4F.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $e81b87e230ad317f$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $4An4F.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $4An4F.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $e81b87e230ad317f$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $5olLg.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $5olLg.darken)(intent.main, tonalOffsetDark);
    }
}
function $e81b87e230ad317f$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $1J2pr.default)[200],
        light: (0, $1J2pr.default)[50],
        dark: (0, $1J2pr.default)[400]
    };
    return {
        main: (0, $1J2pr.default)[700],
        light: (0, $1J2pr.default)[400],
        dark: (0, $1J2pr.default)[800]
    };
}
function $e81b87e230ad317f$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $gtZmB.default)[200],
        light: (0, $gtZmB.default)[50],
        dark: (0, $gtZmB.default)[400]
    };
    return {
        main: (0, $gtZmB.default)[500],
        light: (0, $gtZmB.default)[300],
        dark: (0, $gtZmB.default)[700]
    };
}
function $e81b87e230ad317f$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $7PLXJ.default)[500],
        light: (0, $7PLXJ.default)[300],
        dark: (0, $7PLXJ.default)[700]
    };
    return {
        main: (0, $7PLXJ.default)[700],
        light: (0, $7PLXJ.default)[400],
        dark: (0, $7PLXJ.default)[800]
    };
}
function $e81b87e230ad317f$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $kORAY.default)[400],
        light: (0, $kORAY.default)[300],
        dark: (0, $kORAY.default)[700]
    };
    return {
        main: (0, $kORAY.default)[700],
        light: (0, $kORAY.default)[500],
        dark: (0, $kORAY.default)[900]
    };
}
function $e81b87e230ad317f$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $234Uj.default)[400],
        light: (0, $234Uj.default)[300],
        dark: (0, $234Uj.default)[700]
    };
    return {
        main: (0, $234Uj.default)[800],
        light: (0, $234Uj.default)[500],
        dark: (0, $234Uj.default)[900]
    };
}
function $e81b87e230ad317f$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $byer0.default)[400],
        light: (0, $byer0.default)[300],
        dark: (0, $byer0.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $byer0.default)[500],
        dark: (0, $byer0.default)[900]
    };
}
function $e81b87e230ad317f$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $2UY5J.default)(palette, $e81b87e230ad317f$var$_excluded);
    const primary = palette.primary || $e81b87e230ad317f$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $e81b87e230ad317f$var$getDefaultSecondary(mode);
    const error = palette.error || $e81b87e230ad317f$var$getDefaultError(mode);
    const info = palette.info || $e81b87e230ad317f$var$getDefaultInfo(mode);
    const success = palette.success || $e81b87e230ad317f$var$getDefaultSuccess(mode);
    const warning = palette.warning || $e81b87e230ad317f$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $5olLg.getContrastRatio)(background, $e81b87e230ad317f$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $e81b87e230ad317f$export$55ce6f3a06c59543.text.primary : $e81b87e230ad317f$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $if2ZQ.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $16hJ5.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $16hJ5.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $e81b87e230ad317f$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $e81b87e230ad317f$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $e81b87e230ad317f$export$55ce6f3a06c59543,
        light: $e81b87e230ad317f$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $b6XT3.default)((0, $if2ZQ.default)({
        // A collection of common colors.
        common: (0, $if2ZQ.default)({}, (0, $4An4F.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $5YoP5.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("5olLg", function(module, exports) {
"use strict";

var $dN8sB = parcelRequire("dN8sB");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $3ed012f999b50a06$var$alpha;
module.exports.blend = $3ed012f999b50a06$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $3ed012f999b50a06$var$darken;
module.exports.decomposeColor = $3ed012f999b50a06$var$decomposeColor;
module.exports.emphasize = $3ed012f999b50a06$var$emphasize;
module.exports.getContrastRatio = $3ed012f999b50a06$var$getContrastRatio;
module.exports.getLuminance = $3ed012f999b50a06$var$getLuminance;
module.exports.hexToRgb = $3ed012f999b50a06$var$hexToRgb;
module.exports.hslToRgb = $3ed012f999b50a06$var$hslToRgb;
module.exports.lighten = $3ed012f999b50a06$var$lighten;
module.exports.private_safeAlpha = $3ed012f999b50a06$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $3ed012f999b50a06$var$private_safeDarken;
module.exports.private_safeEmphasize = $3ed012f999b50a06$var$private_safeEmphasize;
module.exports.private_safeLighten = $3ed012f999b50a06$var$private_safeLighten;
module.exports.recomposeColor = $3ed012f999b50a06$var$recomposeColor;
module.exports.rgbToHex = $3ed012f999b50a06$var$rgbToHex;

var $3ed012f999b50a06$var$_formatMuiErrorMessage2 = $dN8sB((parcelRequire("cUBH1")));

var $3ed012f999b50a06$var$_clamp = $dN8sB((parcelRequire("l6aAX")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $3ed012f999b50a06$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $3ed012f999b50a06$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $3ed012f999b50a06$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $3ed012f999b50a06$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $3ed012f999b50a06$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $3ed012f999b50a06$var$decomposeColor($3ed012f999b50a06$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $3ed012f999b50a06$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $3ed012f999b50a06$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $3ed012f999b50a06$var$colorChannel = (color)=>{
    const decomposedColor = $3ed012f999b50a06$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $3ed012f999b50a06$var$colorChannel;
const $3ed012f999b50a06$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $3ed012f999b50a06$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $3ed012f999b50a06$var$private_safeColorChannel;
function $3ed012f999b50a06$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $3ed012f999b50a06$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $3ed012f999b50a06$var$decomposeColor(color);
    return `#${values.map((n, i)=>$3ed012f999b50a06$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $3ed012f999b50a06$var$hslToRgb(color) {
    color = $3ed012f999b50a06$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $3ed012f999b50a06$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $3ed012f999b50a06$var$getLuminance(color) {
    color = $3ed012f999b50a06$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $3ed012f999b50a06$var$decomposeColor($3ed012f999b50a06$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $3ed012f999b50a06$var$getContrastRatio(foreground, background) {
    const lumA = $3ed012f999b50a06$var$getLuminance(foreground);
    const lumB = $3ed012f999b50a06$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $3ed012f999b50a06$var$alpha(color, value) {
    color = $3ed012f999b50a06$var$decomposeColor(color);
    value = $3ed012f999b50a06$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $3ed012f999b50a06$var$recomposeColor(color);
}
function $3ed012f999b50a06$var$private_safeAlpha(color, value, warning) {
    try {
        return $3ed012f999b50a06$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $3ed012f999b50a06$var$darken(color, coefficient) {
    color = $3ed012f999b50a06$var$decomposeColor(color);
    coefficient = $3ed012f999b50a06$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $3ed012f999b50a06$var$recomposeColor(color);
}
function $3ed012f999b50a06$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $3ed012f999b50a06$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $3ed012f999b50a06$var$lighten(color, coefficient) {
    color = $3ed012f999b50a06$var$decomposeColor(color);
    coefficient = $3ed012f999b50a06$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $3ed012f999b50a06$var$recomposeColor(color);
}
function $3ed012f999b50a06$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $3ed012f999b50a06$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $3ed012f999b50a06$var$emphasize(color, coefficient = 0.15) {
    return $3ed012f999b50a06$var$getLuminance(color) > 0.5 ? $3ed012f999b50a06$var$darken(color, coefficient) : $3ed012f999b50a06$var$lighten(color, coefficient);
}
function $3ed012f999b50a06$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $3ed012f999b50a06$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $3ed012f999b50a06$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $3ed012f999b50a06$var$decomposeColor(background);
    const overlayColor = $3ed012f999b50a06$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $3ed012f999b50a06$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("cUBH1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("16hJ5")).default; });

var $16hJ5 = parcelRequire("16hJ5");

});

parcelRegister("l6aAX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("l99Lj")).default; });

var $l99Lj = parcelRequire("l99Lj");

});
parcelRegister("l99Lj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f65202c9290d4a00$export$2e2bcd8739ae039; });
function $f65202c9290d4a00$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $f65202c9290d4a00$export$2e2bcd8739ae039 = $f65202c9290d4a00$var$clamp;

});



parcelRegister("4An4F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $356c6c450cc80f63$export$2e2bcd8739ae039; });
const $356c6c450cc80f63$var$common = {
    black: '#000',
    white: '#fff'
};
var $356c6c450cc80f63$export$2e2bcd8739ae039 = $356c6c450cc80f63$var$common;

});

parcelRegister("5YoP5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4595cfb1b3541750$export$2e2bcd8739ae039; });
const $4595cfb1b3541750$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $4595cfb1b3541750$export$2e2bcd8739ae039 = $4595cfb1b3541750$var$grey;

});

parcelRegister("gtZmB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bffef44b044948bf$export$2e2bcd8739ae039; });
const $bffef44b044948bf$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $bffef44b044948bf$export$2e2bcd8739ae039 = $bffef44b044948bf$var$purple;

});

parcelRegister("7PLXJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b42802e12bf76a1$export$2e2bcd8739ae039; });
const $5b42802e12bf76a1$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $5b42802e12bf76a1$export$2e2bcd8739ae039 = $5b42802e12bf76a1$var$red;

});

parcelRegister("byer0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $868e1115f43217a0$export$2e2bcd8739ae039; });
const $868e1115f43217a0$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $868e1115f43217a0$export$2e2bcd8739ae039 = $868e1115f43217a0$var$orange;

});

parcelRegister("1J2pr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $141bdcd6d98c446e$export$2e2bcd8739ae039; });
const $141bdcd6d98c446e$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $141bdcd6d98c446e$export$2e2bcd8739ae039 = $141bdcd6d98c446e$var$blue;

});

parcelRegister("kORAY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2820d1568300c7c$export$2e2bcd8739ae039; });
const $f2820d1568300c7c$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $f2820d1568300c7c$export$2e2bcd8739ae039 = $f2820d1568300c7c$var$lightBlue;

});

parcelRegister("234Uj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17dfab16d86c3713$export$2e2bcd8739ae039; });
const $17dfab16d86c3713$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $17dfab16d86c3713$export$2e2bcd8739ae039 = $17dfab16d86c3713$var$green;

});


parcelRegister("3nYtv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27726e24b0452bc5$export$2e2bcd8739ae039; });

var $if2ZQ = parcelRequire("if2ZQ");

var $2UY5J = parcelRequire("2UY5J");

var $b6XT3 = parcelRequire("b6XT3");
const $27726e24b0452bc5$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $27726e24b0452bc5$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $27726e24b0452bc5$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $27726e24b0452bc5$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $27726e24b0452bc5$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $27726e24b0452bc5$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $2UY5J.default)(_ref, $27726e24b0452bc5$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $if2ZQ.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $27726e24b0452bc5$var$defaultFontFamily ? {
            letterSpacing: `${$27726e24b0452bc5$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $27726e24b0452bc5$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $27726e24b0452bc5$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $b6XT3.default)((0, $if2ZQ.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("52XlH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3acb2d26b48defcf$export$2e2bcd8739ae039; });
const $3acb2d26b48defcf$var$shadowKeyUmbraOpacity = 0.2;
const $3acb2d26b48defcf$var$shadowKeyPenumbraOpacity = 0.14;
const $3acb2d26b48defcf$var$shadowAmbientShadowOpacity = 0.12;
function $3acb2d26b48defcf$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$3acb2d26b48defcf$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$3acb2d26b48defcf$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$3acb2d26b48defcf$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $3acb2d26b48defcf$var$shadows = [
    'none',
    $3acb2d26b48defcf$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $3acb2d26b48defcf$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $3acb2d26b48defcf$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $3acb2d26b48defcf$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $3acb2d26b48defcf$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $3acb2d26b48defcf$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $3acb2d26b48defcf$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $3acb2d26b48defcf$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $3acb2d26b48defcf$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $3acb2d26b48defcf$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $3acb2d26b48defcf$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $3acb2d26b48defcf$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $3acb2d26b48defcf$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $3acb2d26b48defcf$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $3acb2d26b48defcf$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $3acb2d26b48defcf$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $3acb2d26b48defcf$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $3acb2d26b48defcf$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $3acb2d26b48defcf$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $3acb2d26b48defcf$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $3acb2d26b48defcf$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $3acb2d26b48defcf$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $3acb2d26b48defcf$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $3acb2d26b48defcf$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $3acb2d26b48defcf$export$2e2bcd8739ae039 = $3acb2d26b48defcf$var$shadows;

});

parcelRegister("eUwKW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adafb44f6065b278$export$2e2bcd8739ae039; });

var $2UY5J = parcelRequire("2UY5J");

var $if2ZQ = parcelRequire("if2ZQ");
const $adafb44f6065b278$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $adafb44f6065b278$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $adafb44f6065b278$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $adafb44f6065b278$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $adafb44f6065b278$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $adafb44f6065b278$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $if2ZQ.default)({}, $adafb44f6065b278$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $if2ZQ.default)({}, $adafb44f6065b278$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $2UY5J.default)(options, $adafb44f6065b278$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $adafb44f6065b278$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $adafb44f6065b278$var$formatMs(delay)}`).join(',');
    };
    return (0, $if2ZQ.default)({
        getAutoHeightDuration: $adafb44f6065b278$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("2RJnv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2163bb2bf7643677$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $2163bb2bf7643677$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $2163bb2bf7643677$export$2e2bcd8739ae039 = $2163bb2bf7643677$var$zIndex;

});



parcelRegister("1WdmB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $169592f91db9bf31$export$2e2bcd8739ae039; });
var $169592f91db9bf31$export$2e2bcd8739ae039 = '$$material';

});

parcelRegister("6NiJf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f25d8d4f139b5a8$export$2e2bcd8739ae039; });

var $80ARC = parcelRequire("80ARC");
const $4f25d8d4f139b5a8$var$rootShouldForwardProp = (prop)=>(0, $80ARC.default)(prop) && prop !== 'classes';
var $4f25d8d4f139b5a8$export$2e2bcd8739ae039 = $4f25d8d4f139b5a8$var$rootShouldForwardProp;

});
parcelRegister("80ARC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d4aeb2db681c604$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $5d4aeb2db681c604$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $5d4aeb2db681c604$export$2e2bcd8739ae039 = $5d4aeb2db681c604$var$slotShouldForwardProp;

});



parcelRegister("5qGta", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $3f4052faa857daf6$export$c7c50641356bdfa5; });

var $bJKzs = parcelRequire("bJKzs");

var $dhwoc = parcelRequire("dhwoc");
function $3f4052faa857daf6$export$c7c50641356bdfa5(slot) {
    return (0, $dhwoc.default)('MuiSvgIcon', slot);
}
const $3f4052faa857daf6$var$svgIconClasses = (0, $bJKzs.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $3f4052faa857daf6$export$2e2bcd8739ae039 = $3f4052faa857daf6$var$svgIconClasses;

});
parcelRegister("bJKzs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88b805adbfbbd21b$export$2e2bcd8739ae039; });

var $dhwoc = parcelRequire("dhwoc");
function $88b805adbfbbd21b$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $dhwoc.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("dhwoc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ab5fcbd9d0c71e4$export$2e2bcd8739ae039; });

var $4JlxW = parcelRequire("4JlxW");
const $9ab5fcbd9d0c71e4$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $9ab5fcbd9d0c71e4$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $9ab5fcbd9d0c71e4$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $4JlxW.default).generate(componentName)}-${slot}`;
}
function $9ab5fcbd9d0c71e4$export$34c0130b1f3e8ae3(slot) {
    return $9ab5fcbd9d0c71e4$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("4JlxW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $371c14166ff26038$export$2e2bcd8739ae039; });
const $371c14166ff26038$var$defaultGenerator = (componentName)=>componentName;
const $371c14166ff26038$var$createClassNameGenerator = ()=>{
    let generate = $371c14166ff26038$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $371c14166ff26038$var$defaultGenerator;
        }
    };
};
const $371c14166ff26038$var$ClassNameGenerator = $371c14166ff26038$var$createClassNameGenerator();
var $371c14166ff26038$export$2e2bcd8739ae039 = $371c14166ff26038$var$ClassNameGenerator;

});







parcelRegister("s5PzN", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $dAgMT = parcelRequire("dAgMT");
function $05472387bf8b76c4$var$emptyFunction() {}
function $05472387bf8b76c4$var$emptyFunctionWithReset() {}
$05472387bf8b76c4$var$emptyFunctionWithReset.resetWarningCache = $05472387bf8b76c4$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $dAgMT) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $05472387bf8b76c4$var$emptyFunctionWithReset,
        resetWarningCache: $05472387bf8b76c4$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("dAgMT", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $9e3ba8d2d191acb8$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $9e3ba8d2d191acb8$var$ReactPropTypesSecret;

});


parcelRegister("34DZz", function(module, exports) {
'use strict';

var $jESoY = parcelRequire("jESoY");

var $dyYME = parcelRequire("dyYME");

var $aiXDU = parcelRequire("aiXDU");

var $7di5e = parcelRequire("7di5e");

var $9JyqT = parcelRequire("9JyqT");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $23d0c4690f6e4b3b$var$createInstance(defaultConfig) {
    var context = new $aiXDU(defaultConfig);
    var instance = $dyYME($aiXDU.prototype.request, context);
    // Copy axios.prototype to instance
    $jESoY.extend(instance, $aiXDU.prototype, context);
    // Copy context to instance
    $jESoY.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $23d0c4690f6e4b3b$var$axios = $23d0c4690f6e4b3b$var$createInstance($9JyqT);
// Expose Axios class to allow class inheritance
$23d0c4690f6e4b3b$var$axios.Axios = $aiXDU;
// Factory for creating new instances
$23d0c4690f6e4b3b$var$axios.create = function create(instanceConfig) {
    return $23d0c4690f6e4b3b$var$createInstance($7di5e($23d0c4690f6e4b3b$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$23d0c4690f6e4b3b$var$axios.Cancel = (parcelRequire("7GH3k"));

$23d0c4690f6e4b3b$var$axios.CancelToken = (parcelRequire("epDZS"));

$23d0c4690f6e4b3b$var$axios.isCancel = (parcelRequire("83qWb"));
// Expose all/spread
$23d0c4690f6e4b3b$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$23d0c4690f6e4b3b$var$axios.spread = (parcelRequire("fB11Q"));

// Expose isAxiosError
$23d0c4690f6e4b3b$var$axios.isAxiosError = (parcelRequire("3jjnk"));
module.exports = $23d0c4690f6e4b3b$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $23d0c4690f6e4b3b$var$axios;

});
parcelRegister("jESoY", function(module, exports) {
'use strict';

var $dyYME = parcelRequire("dyYME");
// utils is a library of generic helper functions non-specific to axios
var $e4fbf3d0b709852c$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $e4fbf3d0b709852c$var$isArray(val) {
    return $e4fbf3d0b709852c$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $e4fbf3d0b709852c$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $e4fbf3d0b709852c$var$isBuffer(val) {
    return val !== null && !$e4fbf3d0b709852c$var$isUndefined(val) && val.constructor !== null && !$e4fbf3d0b709852c$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $e4fbf3d0b709852c$var$isArrayBuffer(val) {
    return $e4fbf3d0b709852c$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $e4fbf3d0b709852c$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $e4fbf3d0b709852c$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $e4fbf3d0b709852c$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $e4fbf3d0b709852c$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $e4fbf3d0b709852c$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $e4fbf3d0b709852c$var$isPlainObject(val) {
    if ($e4fbf3d0b709852c$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $e4fbf3d0b709852c$var$isDate(val) {
    return $e4fbf3d0b709852c$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $e4fbf3d0b709852c$var$isFile(val) {
    return $e4fbf3d0b709852c$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $e4fbf3d0b709852c$var$isBlob(val) {
    return $e4fbf3d0b709852c$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $e4fbf3d0b709852c$var$isFunction(val) {
    return $e4fbf3d0b709852c$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $e4fbf3d0b709852c$var$isStream(val) {
    return $e4fbf3d0b709852c$var$isObject(val) && $e4fbf3d0b709852c$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $e4fbf3d0b709852c$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $e4fbf3d0b709852c$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $e4fbf3d0b709852c$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $e4fbf3d0b709852c$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($e4fbf3d0b709852c$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $e4fbf3d0b709852c$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($e4fbf3d0b709852c$var$isPlainObject(result[key]) && $e4fbf3d0b709852c$var$isPlainObject(val)) result[key] = $e4fbf3d0b709852c$var$merge(result[key], val);
        else if ($e4fbf3d0b709852c$var$isPlainObject(val)) result[key] = $e4fbf3d0b709852c$var$merge({}, val);
        else if ($e4fbf3d0b709852c$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$e4fbf3d0b709852c$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $e4fbf3d0b709852c$var$extend(a, b, thisArg) {
    $e4fbf3d0b709852c$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $dyYME(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $e4fbf3d0b709852c$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $e4fbf3d0b709852c$var$isArray,
    isArrayBuffer: $e4fbf3d0b709852c$var$isArrayBuffer,
    isBuffer: $e4fbf3d0b709852c$var$isBuffer,
    isFormData: $e4fbf3d0b709852c$var$isFormData,
    isArrayBufferView: $e4fbf3d0b709852c$var$isArrayBufferView,
    isString: $e4fbf3d0b709852c$var$isString,
    isNumber: $e4fbf3d0b709852c$var$isNumber,
    isObject: $e4fbf3d0b709852c$var$isObject,
    isPlainObject: $e4fbf3d0b709852c$var$isPlainObject,
    isUndefined: $e4fbf3d0b709852c$var$isUndefined,
    isDate: $e4fbf3d0b709852c$var$isDate,
    isFile: $e4fbf3d0b709852c$var$isFile,
    isBlob: $e4fbf3d0b709852c$var$isBlob,
    isFunction: $e4fbf3d0b709852c$var$isFunction,
    isStream: $e4fbf3d0b709852c$var$isStream,
    isURLSearchParams: $e4fbf3d0b709852c$var$isURLSearchParams,
    isStandardBrowserEnv: $e4fbf3d0b709852c$var$isStandardBrowserEnv,
    forEach: $e4fbf3d0b709852c$var$forEach,
    merge: $e4fbf3d0b709852c$var$merge,
    extend: $e4fbf3d0b709852c$var$extend,
    trim: $e4fbf3d0b709852c$var$trim,
    stripBOM: $e4fbf3d0b709852c$var$stripBOM
};

});
parcelRegister("dyYME", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("aiXDU", function(module, exports) {
'use strict';

var $jESoY = parcelRequire("jESoY");

var $l8nWr = parcelRequire("l8nWr");

var $i8qej = parcelRequire("i8qej");

var $4RIrm = parcelRequire("4RIrm");

var $7di5e = parcelRequire("7di5e");

var $jcXlv = parcelRequire("jcXlv");
var $7809d99beee5a1f6$var$validators = $jcXlv.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $7809d99beee5a1f6$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $i8qej(),
        response: new $i8qej()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $7809d99beee5a1f6$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $7di5e(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) $jcXlv.assertOptions(transitional, {
        silentJSONParsing: $7809d99beee5a1f6$var$validators.transitional($7809d99beee5a1f6$var$validators.boolean, '1.0.0'),
        forcedJSONParsing: $7809d99beee5a1f6$var$validators.transitional($7809d99beee5a1f6$var$validators.boolean, '1.0.0'),
        clarifyTimeoutError: $7809d99beee5a1f6$var$validators.transitional($7809d99beee5a1f6$var$validators.boolean, '1.0.0')
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $4RIrm,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $4RIrm(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$7809d99beee5a1f6$var$Axios.prototype.getUri = function getUri(config) {
    config = $7di5e(this.defaults, config);
    return $l8nWr(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$jESoY.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $7809d99beee5a1f6$var$Axios.prototype[method] = function(url, config) {
        return this.request($7di5e(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$jESoY.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $7809d99beee5a1f6$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($7di5e(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $7809d99beee5a1f6$var$Axios;

});
parcelRegister("l8nWr", function(module, exports) {
'use strict';

var $jESoY = parcelRequire("jESoY");
function $f62ceaa187d6d893$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($jESoY.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $jESoY.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($jESoY.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $jESoY.forEach(val, function parseValue(v) {
                if ($jESoY.isDate(v)) v = v.toISOString();
                else if ($jESoY.isObject(v)) v = JSON.stringify(v);
                parts.push($f62ceaa187d6d893$var$encode(key) + '=' + $f62ceaa187d6d893$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("i8qej", function(module, exports) {
'use strict';

var $jESoY = parcelRequire("jESoY");
function $d33d520b405eae0c$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $d33d520b405eae0c$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $d33d520b405eae0c$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $d33d520b405eae0c$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $jESoY.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $d33d520b405eae0c$var$InterceptorManager;

});

parcelRegister("4RIrm", function(module, exports) {
'use strict';

var $jESoY = parcelRequire("jESoY");

var $jKuwG = parcelRequire("jKuwG");

var $83qWb = parcelRequire("83qWb");

var $9JyqT = parcelRequire("9JyqT");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $38ae9592133cc82d$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $38ae9592133cc82d$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $jKuwG.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $jESoY.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $jESoY.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $9JyqT.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $38ae9592133cc82d$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $jKuwG.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$83qWb(reason)) {
            $38ae9592133cc82d$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $jKuwG.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("jKuwG", function(module, exports) {
'use strict';

var $jESoY = parcelRequire("jESoY");

var $9JyqT = parcelRequire("9JyqT");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $9JyqT;
    /*eslint no-param-reassign:0*/ $jESoY.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("9JyqT", function(module, exports) {
'use strict';

var $jESoY = parcelRequire("jESoY");

var $ftPcj = parcelRequire("ftPcj");

var $SWJET = parcelRequire("SWJET");
var $716306adf8168531$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $716306adf8168531$var$setContentTypeIfUnset(headers, value) {
    if (!$jESoY.isUndefined(headers) && $jESoY.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $716306adf8168531$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("1UCSF"));
    return adapter;
}
function $716306adf8168531$var$stringifySafely(rawValue, parser, encoder) {
    if ($jESoY.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $jESoY.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $716306adf8168531$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $716306adf8168531$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $ftPcj(headers, 'Accept');
            $ftPcj(headers, 'Content-Type');
            if ($jESoY.isFormData(data) || $jESoY.isArrayBuffer(data) || $jESoY.isBuffer(data) || $jESoY.isStream(data) || $jESoY.isFile(data) || $jESoY.isBlob(data)) return data;
            if ($jESoY.isArrayBufferView(data)) return data.buffer;
            if ($jESoY.isURLSearchParams(data)) {
                $716306adf8168531$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($jESoY.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
                $716306adf8168531$var$setContentTypeIfUnset(headers, 'application/json');
                return $716306adf8168531$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
            if (strictJSONParsing || forcedJSONParsing && $jESoY.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === 'SyntaxError') throw $SWJET(e, this, 'E_JSON_PARSE');
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$716306adf8168531$var$defaults.headers = {
    common: {
        'Accept': 'application/json, text/plain, */*'
    }
};
$jESoY.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $716306adf8168531$var$defaults.headers[method] = {};
});
$jESoY.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $716306adf8168531$var$defaults.headers[method] = $jESoY.merge($716306adf8168531$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $716306adf8168531$var$defaults;

});
parcelRegister("ftPcj", function(module, exports) {
'use strict';

var $jESoY = parcelRequire("jESoY");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $jESoY.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("SWJET", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});

parcelRegister("1UCSF", function(module, exports) {
'use strict';

var $jESoY = parcelRequire("jESoY");

var $8N5xp = parcelRequire("8N5xp");

var $hhuwr = parcelRequire("hhuwr");

var $l8nWr = parcelRequire("l8nWr");

var $ccZkp = parcelRequire("ccZkp");

var $jYz4m = parcelRequire("jYz4m");

var $3qlWo = parcelRequire("3qlWo");

var $dmwJN = parcelRequire("dmwJN");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if ($jESoY.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $ccZkp(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $l8nWr(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $jYz4m(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $8N5xp(resolve, reject, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($dmwJN('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($dmwJN('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($dmwJN(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($jESoY.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $3qlWo(fullPath)) && config.xsrfCookieName ? $hhuwr.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $jESoY.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$jESoY.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("8N5xp", function(module, exports) {
'use strict';

var $dmwJN = parcelRequire("dmwJN");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($dmwJN('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("dmwJN", function(module, exports) {
'use strict';

var $SWJET = parcelRequire("SWJET");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $SWJET(error, config, code, request, response);
};

});


parcelRegister("hhuwr", function(module, exports) {
'use strict';

var $jESoY = parcelRequire("jESoY");
module.exports = $jESoY.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($jESoY.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($jESoY.isString(path)) cookie.push('path=' + path);
            if ($jESoY.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("ccZkp", function(module, exports) {
'use strict';

var $7uIr0 = parcelRequire("7uIr0");

var $9dhcT = parcelRequire("9dhcT");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$7uIr0(requestedURL)) return $9dhcT(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("7uIr0", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("9dhcT", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("jYz4m", function(module, exports) {
'use strict';

var $jESoY = parcelRequire("jESoY");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $e8aed2f90952bc78$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $jESoY.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $jESoY.trim(line.substr(0, i)).toLowerCase();
        val = $jESoY.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $e8aed2f90952bc78$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("3qlWo", function(module, exports) {
'use strict';

var $jESoY = parcelRequire("jESoY");
module.exports = $jESoY.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $jESoY.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("83qWb", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("7di5e", function(module, exports) {
'use strict';

var $jESoY = parcelRequire("jESoY");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        'url',
        'method',
        'data'
    ];
    var mergeDeepPropertiesKeys = [
        'headers',
        'auth',
        'proxy',
        'params'
    ];
    var defaultToConfig2Keys = [
        'baseURL',
        'transformRequest',
        'transformResponse',
        'paramsSerializer',
        'timeout',
        'timeoutMessage',
        'withCredentials',
        'adapter',
        'responseType',
        'xsrfCookieName',
        'xsrfHeaderName',
        'onUploadProgress',
        'onDownloadProgress',
        'decompress',
        'maxContentLength',
        'maxBodyLength',
        'maxRedirects',
        'transport',
        'httpAgent',
        'httpsAgent',
        'cancelToken',
        'socketPath',
        'responseEncoding'
    ];
    var directMergeKeys = [
        'validateStatus'
    ];
    function getMergedValue(target, source) {
        if ($jESoY.isPlainObject(target) && $jESoY.isPlainObject(source)) return $jESoY.merge(target, source);
        else if ($jESoY.isPlainObject(source)) return $jESoY.merge({}, source);
        else if ($jESoY.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$jESoY.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$jESoY.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $jESoY.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$jESoY.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $jESoY.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $jESoY.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$jESoY.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$jESoY.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $jESoY.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $jESoY.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});

parcelRegister("jcXlv", function(module, exports) {
'use strict';

var $bKrHq = parcelRequire("bKrHq");
var $dfbd2c25b5d75609$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $dfbd2c25b5d75609$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $dfbd2c25b5d75609$var$deprecatedWarnings = {};
var $dfbd2c25b5d75609$var$currentVerArr = $bKrHq.version.split('.');
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function $dfbd2c25b5d75609$var$isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split('.') : $dfbd2c25b5d75609$var$currentVerArr;
    var destVer = version.split('.');
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ $dfbd2c25b5d75609$var$validators.transitional = function transitional(validator, version, message) {
    var isDeprecated = version && $dfbd2c25b5d75609$var$isOlderVersion(version);
    function formatMessage(opt, desc) {
        return '[Axios v' + $bKrHq.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, ' has been removed in ' + version));
        if (isDeprecated && !$dfbd2c25b5d75609$var$deprecatedWarnings[opt]) {
            $dfbd2c25b5d75609$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $dfbd2c25b5d75609$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new TypeError('options must be an object');
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError('option ' + opt + ' must be ' + result);
            continue;
        }
        if (allowUnknown !== true) throw Error('Unknown option ' + opt);
    }
}
module.exports = {
    isOlderVersion: $dfbd2c25b5d75609$var$isOlderVersion,
    assertOptions: $dfbd2c25b5d75609$var$assertOptions,
    validators: $dfbd2c25b5d75609$var$validators
};

});
parcelRegister("bKrHq", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"axios\",\"version\":\"0.21.4\",\"description\":\"Promise based HTTP client for the browser and node.js\",\"main\":\"index.js\",\"scripts\":{\"test\":\"grunt test\",\"start\":\"node ./sandbox/server.js\",\"build\":\"NODE_ENV=production grunt build\",\"preversion\":\"npm test\",\"version\":\"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json\",\"postversion\":\"git push && git push --tags\",\"examples\":\"node ./examples/server.js\",\"coveralls\":\"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js\",\"fix\":\"eslint --fix lib/**/*.js\"},\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/axios/axios.git\"},\"keywords\":[\"xhr\",\"http\",\"ajax\",\"promise\",\"node\"],\"author\":\"Matt Zabriskie\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/axios/axios/issues\"},\"homepage\":\"https://axios-http.com\",\"devDependencies\":{\"coveralls\":\"^3.0.0\",\"es6-promise\":\"^4.2.4\",\"grunt\":\"^1.3.0\",\"grunt-banner\":\"^0.6.0\",\"grunt-cli\":\"^1.2.0\",\"grunt-contrib-clean\":\"^1.1.0\",\"grunt-contrib-watch\":\"^1.0.0\",\"grunt-eslint\":\"^23.0.0\",\"grunt-karma\":\"^4.0.0\",\"grunt-mocha-test\":\"^0.13.3\",\"grunt-ts\":\"^6.0.0-beta.19\",\"grunt-webpack\":\"^4.0.2\",\"istanbul-instrumenter-loader\":\"^1.0.0\",\"jasmine-core\":\"^2.4.1\",\"karma\":\"^6.3.2\",\"karma-chrome-launcher\":\"^3.1.0\",\"karma-firefox-launcher\":\"^2.1.0\",\"karma-jasmine\":\"^1.1.1\",\"karma-jasmine-ajax\":\"^0.1.13\",\"karma-safari-launcher\":\"^1.0.0\",\"karma-sauce-launcher\":\"^4.3.6\",\"karma-sinon\":\"^1.0.5\",\"karma-sourcemap-loader\":\"^0.3.8\",\"karma-webpack\":\"^4.0.2\",\"load-grunt-tasks\":\"^3.5.2\",\"minimist\":\"^1.2.0\",\"mocha\":\"^8.2.1\",\"sinon\":\"^4.5.0\",\"terser-webpack-plugin\":\"^4.2.3\",\"typescript\":\"^4.0.5\",\"url-search-params\":\"^0.10.0\",\"webpack\":\"^4.44.2\",\"webpack-dev-server\":\"^3.11.0\"},\"browser\":{\"./lib/adapters/http.js\":\"./lib/adapters/xhr.js\"},\"jsdelivr\":\"dist/axios.min.js\",\"unpkg\":\"dist/axios.min.js\",\"typings\":\"./index.d.ts\",\"dependencies\":{\"follow-redirects\":\"^1.14.0\"},\"bundlesize\":[{\"path\":\"./dist/axios.min.js\",\"threshold\":\"5kB\"}]}");

});



parcelRegister("7GH3k", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $598dd9fe49e862ff$var$Cancel(message) {
    this.message = message;
}
$598dd9fe49e862ff$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$598dd9fe49e862ff$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $598dd9fe49e862ff$var$Cancel;

});

parcelRegister("epDZS", function(module, exports) {
'use strict';

var $7GH3k = parcelRequire("7GH3k");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $a7e26d126145bb42$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $7GH3k(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $a7e26d126145bb42$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $a7e26d126145bb42$var$CancelToken.source = function source() {
    var cancel;
    var token = new $a7e26d126145bb42$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $a7e26d126145bb42$var$CancelToken;

});

parcelRegister("fB11Q", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("3jjnk", function(module, exports) {
'use strict';
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === 'object' && payload.isAxiosError === true;
};

});


parcelRegister("8wUEv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $k8Bfo = parcelRequire("k8Bfo");

var $gRqVZ = parcelRequire("gRqVZ");

var $635d41de2cbfdc22$var$useMountedState_1 = $k8Bfo.__importDefault((parcelRequire("6HQ2I")));
function $635d41de2cbfdc22$var$useAsyncFn(fn, deps, initialState) {
    if (deps === void 0) deps = [];
    if (initialState === void 0) initialState = {
        loading: false
    };
    var lastCallId = $gRqVZ.useRef(0);
    var isMounted = $635d41de2cbfdc22$var$useMountedState_1.default();
    var _a = $gRqVZ.useState(initialState), state = _a[0], set = _a[1];
    var callback = $gRqVZ.useCallback(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var callId = ++lastCallId.current;
        if (!state.loading) set(function(prevState) {
            return $k8Bfo.__assign($k8Bfo.__assign({}, prevState), {
                loading: true
            });
        });
        return fn.apply(void 0, args).then(function(value) {
            isMounted() && callId === lastCallId.current && set({
                value: value,
                loading: false
            });
            return value;
        }, function(error) {
            isMounted() && callId === lastCallId.current && set({
                error: error,
                loading: false
            });
            return error;
        });
    }, deps);
    return [
        state,
        callback
    ];
}
module.exports.default = $635d41de2cbfdc22$var$useAsyncFn;

});
parcelRegister("k8Bfo", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $ea9172857b8af30b$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $ea9172857b8af30b$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__awaiter", function () { return $ea9172857b8af30b$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $ea9172857b8af30b$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $ea9172857b8af30b$export$19a8beecd37a4c45; });
$parcel$export(module.exports, "__read", function () { return $ea9172857b8af30b$export$8d051b38c9118094; });
$parcel$export(module.exports, "__spreadArray", function () { return $ea9172857b8af30b$export$1216008129fb82ed; });
$parcel$export(module.exports, "__await", function () { return $ea9172857b8af30b$export$10c90e4f7922046c; });
$parcel$export(module.exports, "__asyncGenerator", function () { return $ea9172857b8af30b$export$e427f37a30a4de9b; });
$parcel$export(module.exports, "__asyncValues", function () { return $ea9172857b8af30b$export$e3b29a3d6162315f; });
$parcel$export(module.exports, "__importDefault", function () { return $ea9172857b8af30b$export$da59b14a69baef04; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $ea9172857b8af30b$var$extendStatics = function(d, b) {
    $ea9172857b8af30b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $ea9172857b8af30b$var$extendStatics(d, b);
};
function $ea9172857b8af30b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $ea9172857b8af30b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ea9172857b8af30b$export$18ce0697a983be9b = function() {
    $ea9172857b8af30b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ea9172857b8af30b$export$18ce0697a983be9b.apply(this, arguments);
};
function $ea9172857b8af30b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ea9172857b8af30b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ea9172857b8af30b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ea9172857b8af30b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $ea9172857b8af30b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $ea9172857b8af30b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $ea9172857b8af30b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $ea9172857b8af30b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ea9172857b8af30b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ea9172857b8af30b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $ea9172857b8af30b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $ea9172857b8af30b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $ea9172857b8af30b$export$45d3717a4c69092e(o, m, p);
}
function $ea9172857b8af30b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ea9172857b8af30b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ea9172857b8af30b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ea9172857b8af30b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ea9172857b8af30b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ea9172857b8af30b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $ea9172857b8af30b$export$10c90e4f7922046c(v) {
    return this instanceof $ea9172857b8af30b$export$10c90e4f7922046c ? (this.v = v, this) : new $ea9172857b8af30b$export$10c90e4f7922046c(v);
}
function $ea9172857b8af30b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ea9172857b8af30b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ea9172857b8af30b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ea9172857b8af30b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $ea9172857b8af30b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ea9172857b8af30b$export$19a8beecd37a4c45 === "function" ? $ea9172857b8af30b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ea9172857b8af30b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $ea9172857b8af30b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $ea9172857b8af30b$var$ownKeys = function(o) {
    $ea9172857b8af30b$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $ea9172857b8af30b$var$ownKeys(o);
};
function $ea9172857b8af30b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $ea9172857b8af30b$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $ea9172857b8af30b$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $ea9172857b8af30b$var$__setModuleDefault(result, mod);
    return result;
}
function $ea9172857b8af30b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ea9172857b8af30b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $ea9172857b8af30b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $ea9172857b8af30b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $ea9172857b8af30b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $ea9172857b8af30b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $ea9172857b8af30b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $ea9172857b8af30b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $ea9172857b8af30b$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $ea9172857b8af30b$export$2e2bcd8739ae039 = {
    __extends: $ea9172857b8af30b$export$a8ba968b8961cb8a,
    __assign: $ea9172857b8af30b$export$18ce0697a983be9b,
    __rest: $ea9172857b8af30b$export$3c9a16f847548506,
    __decorate: $ea9172857b8af30b$export$29e00dfd3077644b,
    __param: $ea9172857b8af30b$export$d5ad3fd78186038f,
    __esDecorate: $ea9172857b8af30b$export$3a84e1ae4e97e9b0,
    __runInitializers: $ea9172857b8af30b$export$d831c04e792af3d,
    __propKey: $ea9172857b8af30b$export$6a2a36740a146cb8,
    __setFunctionName: $ea9172857b8af30b$export$d1a06452d3489bc7,
    __metadata: $ea9172857b8af30b$export$f1db080c865becb9,
    __awaiter: $ea9172857b8af30b$export$1050f835b63b671e,
    __generator: $ea9172857b8af30b$export$67ebef60e6f28a6,
    __createBinding: $ea9172857b8af30b$export$45d3717a4c69092e,
    __exportStar: $ea9172857b8af30b$export$f33643c0debef087,
    __values: $ea9172857b8af30b$export$19a8beecd37a4c45,
    __read: $ea9172857b8af30b$export$8d051b38c9118094,
    __spread: $ea9172857b8af30b$export$afc72e2116322959,
    __spreadArrays: $ea9172857b8af30b$export$6388937ca91ccae8,
    __spreadArray: $ea9172857b8af30b$export$1216008129fb82ed,
    __await: $ea9172857b8af30b$export$10c90e4f7922046c,
    __asyncGenerator: $ea9172857b8af30b$export$e427f37a30a4de9b,
    __asyncDelegator: $ea9172857b8af30b$export$bbd80228419bb833,
    __asyncValues: $ea9172857b8af30b$export$e3b29a3d6162315f,
    __makeTemplateObject: $ea9172857b8af30b$export$4fb47efe1390b86f,
    __importStar: $ea9172857b8af30b$export$c21735bcef00d192,
    __importDefault: $ea9172857b8af30b$export$da59b14a69baef04,
    __classPrivateFieldGet: $ea9172857b8af30b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $ea9172857b8af30b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $ea9172857b8af30b$export$81fdc39f203e4e04,
    __addDisposableResource: $ea9172857b8af30b$export$88ac25d8e944e405,
    __disposeResources: $ea9172857b8af30b$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $ea9172857b8af30b$export$889dfb5d17574b0b
};

});

parcelRegister("6HQ2I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gRqVZ = parcelRequire("gRqVZ");
function $4e1f20dea345f4a9$var$useMountedState() {
    var mountedRef = $gRqVZ.useRef(false);
    var get = $gRqVZ.useCallback(function() {
        return mountedRef.current;
    }, []);
    $gRqVZ.useEffect(function() {
        mountedRef.current = true;
        return function() {
            mountedRef.current = false;
        };
    }, []);
    return get;
}
module.exports.default = $4e1f20dea345f4a9$var$useMountedState;

});


parcelRegister("489wz", function(module, exports) {

$parcel$export(module.exports, "useFormikContext", function () { return useFormikContext; });
$parcel$export(module.exports, "Formik", function () { return Formik; });
$parcel$export(module.exports, "Field", function () { return Field; });
$parcel$export(module.exports, "Form", function () { return Form; });

var $iYjpF = parcelRequire("iYjpF");

var $6bB6B = parcelRequire("6bB6B");

var $hvQN0 = parcelRequire("hvQN0");

var $gRqVZ = parcelRequire("gRqVZ");

var $1TUVf = parcelRequire("1TUVf");

var $1wh2w = parcelRequire("1wh2w");

var $8SzAZ = parcelRequire("8SzAZ");

var $a9kWi = parcelRequire("a9kWi");

var $6q1gP = parcelRequire("6q1gP");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $gRqVZ.createContext)(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $gRqVZ.useContext)(FormikContext);
    !!!formik && (0, $1wh2w.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === 'function';
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $gRqVZ.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);
    if (typeof doc === 'undefined') return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $a9kWi.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $8SzAZ.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $a9kWi.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $8SzAZ.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case 'SET_VALUES':
            return _extends({}, state, {
                values: msg.payload
            });
        case 'SET_TOUCHED':
            return _extends({}, state, {
                touched: msg.payload
            });
        case 'SET_ERRORS':
            if ((0, (/*@__PURE__*/$parcel$interopDefault($1TUVf)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case 'SET_STATUS':
            return _extends({}, state, {
                status: msg.payload
            });
        case 'SET_ISSUBMITTING':
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case 'SET_ISVALIDATING':
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case 'SET_FIELD_VALUE':
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_TOUCHED':
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_ERROR':
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case 'RESET_FORM':
            return _extends({}, state, msg.payload);
        case 'SET_FORMIK_STATE':
            return msg.payload(state);
        case 'SUBMIT_ATTEMPT':
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case 'SUBMIT_FAILURE':
            return _extends({}, state, {
                isSubmitting: false
            });
        case 'SUBMIT_SUCCESS':
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $gRqVZ.useRef)(props.initialValues);
    var initialErrors = (0, $gRqVZ.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $gRqVZ.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $gRqVZ.useRef)(props.initialStatus);
    var isMounted = (0, $gRqVZ.useRef)(false);
    var fieldRegistry = (0, $gRqVZ.useRef)({});
    (0, $gRqVZ.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $gRqVZ.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $gRqVZ.useRef)({
        values: (0, $hvQN0.default)(props.initialValues),
        errors: (0, $hvQN0.default)(props.initialErrors) || emptyErrors,
        touched: (0, $hvQN0.default)(props.initialTouched) || emptyTouched,
        status: (0, $hvQN0.default)(props.initialStatus),
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $gRqVZ.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $gRqVZ.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $gRqVZ.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === 'ValidationError') resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $gRqVZ.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $gRqVZ.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $gRqVZ.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $iYjpF.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: 'SET_ISVALIDATING',
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
                dispatch({
                    type: 'SET_ERRORS',
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $gRqVZ.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($1TUVf)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $gRqVZ.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: 'RESET_FORM',
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $gRqVZ.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($1TUVf)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $gRqVZ.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($1TUVf)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: 'SET_ERRORS',
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $gRqVZ.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($1TUVf)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: 'SET_TOUCHED',
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $gRqVZ.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($1TUVf)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: 'SET_STATUS',
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: 'SET_FIELD_ERROR',
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: 'SET_ISVALIDATING',
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: 'SET_ISVALIDATING',
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $gRqVZ.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $gRqVZ.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: 'SET_TOUCHED',
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $gRqVZ.useCallback)(function(errors) {
        dispatch({
            type: 'SET_ERRORS',
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: 'SET_VALUES',
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $gRqVZ.useCallback)(function(field, value) {
        dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        var resolvedValue = isFunction(value) ? value(getIn(state.values, field)) : value;
        dispatch({
            type: 'SET_FIELD_VALUE',
            payload: {
                field: field,
                value: resolvedValue
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, resolvedValue)) : Promise.resolve();
    });
    var executeChange = (0, $gRqVZ.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            field;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: 'SET_FIELD_TOUCHED',
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $gRqVZ.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        field;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $gRqVZ.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: 'SET_FORMIK_STATE',
            payload: stateOrCb
        });
        else dispatch({
            type: 'SET_FORMIK_STATE',
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $gRqVZ.useCallback)(function(status) {
        dispatch({
            type: 'SET_STATUS',
            payload: status
        });
    }, []);
    var setSubmitting = (0, $gRqVZ.useCallback)(function(isSubmitting) {
        dispatch({
            type: 'SET_ISSUBMITTING',
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: 'SUBMIT_ATTEMPT'
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: 'SUBMIT_SUCCESS'
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: 'SUBMIT_FAILURE'
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: 'SUBMIT_FAILURE'
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $gRqVZ.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $gRqVZ.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $gRqVZ.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === 'checkbox') {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === 'radio') {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === 'select' && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $gRqVZ.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($1TUVf)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $gRqVZ.useMemo)(function() {
        return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $gRqVZ.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $gRqVZ.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $gRqVZ.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $gRqVZ.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? 'validateSync' : 'validate'](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $6bB6B.default)(value)) return prepareDataForValidation(value);
            else return value !== '' ? value : undefined;
        });
        else if ((0, $6bB6B.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== '' ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === 'undefined') {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $iYjpF.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $iYjpF.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === 'boolean') return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == 'true' || valueProp == 'false') return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $gRqVZ.useLayoutEffect) : (0, $gRqVZ.useEffect);
function useEventCallback(fn) {
    var ref = (0, $gRqVZ.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $gRqVZ.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $gRqVZ.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $1wh2w.default)(false);
    var fieldHelpers = (0, $gRqVZ.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $gRqVZ.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $gRqVZ.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $gRqVZ.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || 'input';
    if (typeof asElement === 'string') {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $gRqVZ.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $gRqVZ.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $gRqVZ.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : '#';
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $gRqVZ.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = 'Form';
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $gRqVZ.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $gRqVZ.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $gRqVZ.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($6q1gP)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $gRqVZ.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $1wh2w.default)(false);
            return (0, $gRqVZ.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($6q1gP)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === 'function' ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $hvQN0.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($1TUVf)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $gRqVZ.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? (0, $gRqVZ.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $gRqVZ.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $gRqVZ.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $gRqVZ.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $1wh2w.default)(false);
        !!(component && render) && (0, $1wh2w.default)(false);
        !!(is && children && isFunction(children)) && (0, $1wh2w.default)(false);
        !!(component && children && isFunction(children)) && (0, $1wh2w.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $1wh2w.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === 'string') {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $gRqVZ.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $gRqVZ.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || 'input';
        if (typeof asElement === 'string') {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $gRqVZ.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $gRqVZ.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $gRqVZ.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("iYjpF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcfce3a01de86d60$export$2e2bcd8739ae039; });
var $dcfce3a01de86d60$var$isMergeableObject = function isMergeableObject(value) {
    return $dcfce3a01de86d60$var$isNonNullObject(value) && !$dcfce3a01de86d60$var$isSpecial(value);
};
function $dcfce3a01de86d60$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $dcfce3a01de86d60$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $dcfce3a01de86d60$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $dcfce3a01de86d60$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $dcfce3a01de86d60$var$REACT_ELEMENT_TYPE = $dcfce3a01de86d60$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $dcfce3a01de86d60$var$isReactElement(value) {
    return value.$$typeof === $dcfce3a01de86d60$var$REACT_ELEMENT_TYPE;
}
function $dcfce3a01de86d60$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $dcfce3a01de86d60$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $dcfce3a01de86d60$var$deepmerge($dcfce3a01de86d60$var$emptyTarget(value), value, options) : value;
}
function $dcfce3a01de86d60$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $dcfce3a01de86d60$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $dcfce3a01de86d60$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $dcfce3a01de86d60$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $dcfce3a01de86d60$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $dcfce3a01de86d60$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $dcfce3a01de86d60$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $dcfce3a01de86d60$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $dcfce3a01de86d60$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $dcfce3a01de86d60$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $dcfce3a01de86d60$var$mergeObject(target, source, options);
}
$dcfce3a01de86d60$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $dcfce3a01de86d60$var$deepmerge(prev, next, options);
    }, {});
};
var $dcfce3a01de86d60$var$deepmerge_1 = $dcfce3a01de86d60$var$deepmerge;
var $dcfce3a01de86d60$export$2e2bcd8739ae039 = $dcfce3a01de86d60$var$deepmerge_1;

});

parcelRegister("6bB6B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48108d876d34b170$export$2e2bcd8739ae039; });

var $3nHVm = parcelRequire("3nHVm");

var $fhmjs = parcelRequire("fhmjs");

var $e3gLp = parcelRequire("e3gLp");
/** `Object#toString` result references. */ var $48108d876d34b170$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $48108d876d34b170$var$funcProto = Function.prototype, $48108d876d34b170$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $48108d876d34b170$var$funcToString = $48108d876d34b170$var$funcProto.toString;
/** Used to check objects for own properties. */ var $48108d876d34b170$var$hasOwnProperty = $48108d876d34b170$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $48108d876d34b170$var$objectCtorString = $48108d876d34b170$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $48108d876d34b170$var$isPlainObject(value) {
    if (!(0, $e3gLp.default)(value) || (0, $3nHVm.default)(value) != $48108d876d34b170$var$objectTag) return false;
    var proto = (0, $fhmjs.default)(value);
    if (proto === null) return true;
    var Ctor = $48108d876d34b170$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $48108d876d34b170$var$funcToString.call(Ctor) == $48108d876d34b170$var$objectCtorString;
}
var $48108d876d34b170$export$2e2bcd8739ae039 = $48108d876d34b170$var$isPlainObject;

});
parcelRegister("3nHVm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2765977ea0eff44d$export$2e2bcd8739ae039; });

var $ceXwU = parcelRequire("ceXwU");

var $4dCd9 = parcelRequire("4dCd9");

var $lDhg4 = parcelRequire("lDhg4");
/** `Object#toString` result references. */ var $2765977ea0eff44d$var$nullTag = '[object Null]', $2765977ea0eff44d$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $2765977ea0eff44d$var$symToStringTag = (0, $ceXwU.default) ? (0, $ceXwU.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $2765977ea0eff44d$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $2765977ea0eff44d$var$undefinedTag : $2765977ea0eff44d$var$nullTag;
    return $2765977ea0eff44d$var$symToStringTag && $2765977ea0eff44d$var$symToStringTag in Object(value) ? (0, $4dCd9.default)(value) : (0, $lDhg4.default)(value);
}
var $2765977ea0eff44d$export$2e2bcd8739ae039 = $2765977ea0eff44d$var$baseGetTag;

});
parcelRegister("ceXwU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e94f835d7fb996a$export$2e2bcd8739ae039; });

var $71oki = parcelRequire("71oki");
/** Built-in value references. */ var $8e94f835d7fb996a$var$Symbol = (0, $71oki.default).Symbol;
var $8e94f835d7fb996a$export$2e2bcd8739ae039 = $8e94f835d7fb996a$var$Symbol;

});
parcelRegister("71oki", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51cb7f1a704a19f6$export$2e2bcd8739ae039; });

var $qyeYs = parcelRequire("qyeYs");
/** Detect free variable `self`. */ var $51cb7f1a704a19f6$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $51cb7f1a704a19f6$var$root = (0, $qyeYs.default) || $51cb7f1a704a19f6$var$freeSelf || Function('return this')();
var $51cb7f1a704a19f6$export$2e2bcd8739ae039 = $51cb7f1a704a19f6$var$root;

});
parcelRegister("qyeYs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04fcfd46bd99a1b1$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $04fcfd46bd99a1b1$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $04fcfd46bd99a1b1$export$2e2bcd8739ae039 = $04fcfd46bd99a1b1$var$freeGlobal;

});



parcelRegister("4dCd9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31260443dbdddfec$export$2e2bcd8739ae039; });

var $ceXwU = parcelRequire("ceXwU");
/** Used for built-in method references. */ var $31260443dbdddfec$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $31260443dbdddfec$var$hasOwnProperty = $31260443dbdddfec$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $31260443dbdddfec$var$nativeObjectToString = $31260443dbdddfec$var$objectProto.toString;
/** Built-in value references. */ var $31260443dbdddfec$var$symToStringTag = (0, $ceXwU.default) ? (0, $ceXwU.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $31260443dbdddfec$var$getRawTag(value) {
    var isOwn = $31260443dbdddfec$var$hasOwnProperty.call(value, $31260443dbdddfec$var$symToStringTag), tag = value[$31260443dbdddfec$var$symToStringTag];
    try {
        value[$31260443dbdddfec$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $31260443dbdddfec$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$31260443dbdddfec$var$symToStringTag] = tag;
        else delete value[$31260443dbdddfec$var$symToStringTag];
    }
    return result;
}
var $31260443dbdddfec$export$2e2bcd8739ae039 = $31260443dbdddfec$var$getRawTag;

});

parcelRegister("lDhg4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbfaa0a191f282aa$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $fbfaa0a191f282aa$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $fbfaa0a191f282aa$var$nativeObjectToString = $fbfaa0a191f282aa$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $fbfaa0a191f282aa$var$objectToString(value) {
    return $fbfaa0a191f282aa$var$nativeObjectToString.call(value);
}
var $fbfaa0a191f282aa$export$2e2bcd8739ae039 = $fbfaa0a191f282aa$var$objectToString;

});


parcelRegister("fhmjs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1f9c0654dad3f4c$export$2e2bcd8739ae039; });

var $3bHHQ = parcelRequire("3bHHQ");
/** Built-in value references. */ var $b1f9c0654dad3f4c$var$getPrototype = (0, $3bHHQ.default)(Object.getPrototypeOf, Object);
var $b1f9c0654dad3f4c$export$2e2bcd8739ae039 = $b1f9c0654dad3f4c$var$getPrototype;

});
parcelRegister("3bHHQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25244d536bf4b908$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $25244d536bf4b908$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $25244d536bf4b908$export$2e2bcd8739ae039 = $25244d536bf4b908$var$overArg;

});


parcelRegister("e3gLp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3ae5970554f0e27$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $a3ae5970554f0e27$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $a3ae5970554f0e27$export$2e2bcd8739ae039 = $a3ae5970554f0e27$var$isObjectLike;

});


parcelRegister("hvQN0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbfe47d1b622f306$export$2e2bcd8739ae039; });

var $3HFnb = parcelRequire("3HFnb");
/** Used to compose bitmasks for cloning. */ var $cbfe47d1b622f306$var$CLONE_DEEP_FLAG = 1, $cbfe47d1b622f306$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $cbfe47d1b622f306$var$cloneDeep(value) {
    return (0, $3HFnb.default)(value, $cbfe47d1b622f306$var$CLONE_DEEP_FLAG | $cbfe47d1b622f306$var$CLONE_SYMBOLS_FLAG);
}
var $cbfe47d1b622f306$export$2e2bcd8739ae039 = $cbfe47d1b622f306$var$cloneDeep;

});
parcelRegister("3HFnb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b257b0c0d32189a$export$2e2bcd8739ae039; });

var $hQ4rP = parcelRequire("hQ4rP");

var $juhyh = parcelRequire("juhyh");

var $1sJoT = parcelRequire("1sJoT");

var $8aDKX = parcelRequire("8aDKX");

var $hW3bZ = parcelRequire("hW3bZ");

var $dGDoI = parcelRequire("dGDoI");

var $gaHa5 = parcelRequire("gaHa5");

var $kUIwZ = parcelRequire("kUIwZ");

var $aslhb = parcelRequire("aslhb");

var $3ap0R = parcelRequire("3ap0R");

var $eFgoZ = parcelRequire("eFgoZ");

var $j5aX8 = parcelRequire("j5aX8");

var $iUHy8 = parcelRequire("iUHy8");

var $kHTZH = parcelRequire("kHTZH");

var $7m9vs = parcelRequire("7m9vs");

var $kCwEw = parcelRequire("kCwEw");

var $emwkF = parcelRequire("emwkF");

var $85B3r = parcelRequire("85B3r");

var $f8M9J = parcelRequire("f8M9J");

var $9UGdJ = parcelRequire("9UGdJ");

var $jkb5J = parcelRequire("jkb5J");

var $7nPCK = parcelRequire("7nPCK");
/** Used to compose bitmasks for cloning. */ var $2b257b0c0d32189a$var$CLONE_DEEP_FLAG = 1, $2b257b0c0d32189a$var$CLONE_FLAT_FLAG = 2, $2b257b0c0d32189a$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $2b257b0c0d32189a$var$argsTag = '[object Arguments]', $2b257b0c0d32189a$var$arrayTag = '[object Array]', $2b257b0c0d32189a$var$boolTag = '[object Boolean]', $2b257b0c0d32189a$var$dateTag = '[object Date]', $2b257b0c0d32189a$var$errorTag = '[object Error]', $2b257b0c0d32189a$var$funcTag = '[object Function]', $2b257b0c0d32189a$var$genTag = '[object GeneratorFunction]', $2b257b0c0d32189a$var$mapTag = '[object Map]', $2b257b0c0d32189a$var$numberTag = '[object Number]', $2b257b0c0d32189a$var$objectTag = '[object Object]', $2b257b0c0d32189a$var$regexpTag = '[object RegExp]', $2b257b0c0d32189a$var$setTag = '[object Set]', $2b257b0c0d32189a$var$stringTag = '[object String]', $2b257b0c0d32189a$var$symbolTag = '[object Symbol]', $2b257b0c0d32189a$var$weakMapTag = '[object WeakMap]';
var $2b257b0c0d32189a$var$arrayBufferTag = '[object ArrayBuffer]', $2b257b0c0d32189a$var$dataViewTag = '[object DataView]', $2b257b0c0d32189a$var$float32Tag = '[object Float32Array]', $2b257b0c0d32189a$var$float64Tag = '[object Float64Array]', $2b257b0c0d32189a$var$int8Tag = '[object Int8Array]', $2b257b0c0d32189a$var$int16Tag = '[object Int16Array]', $2b257b0c0d32189a$var$int32Tag = '[object Int32Array]', $2b257b0c0d32189a$var$uint8Tag = '[object Uint8Array]', $2b257b0c0d32189a$var$uint8ClampedTag = '[object Uint8ClampedArray]', $2b257b0c0d32189a$var$uint16Tag = '[object Uint16Array]', $2b257b0c0d32189a$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $2b257b0c0d32189a$var$cloneableTags = {};
$2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$argsTag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$arrayTag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$arrayBufferTag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$dataViewTag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$boolTag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$dateTag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$float32Tag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$float64Tag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$int8Tag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$int16Tag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$int32Tag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$mapTag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$numberTag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$objectTag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$regexpTag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$setTag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$stringTag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$symbolTag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$uint8Tag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$uint8ClampedTag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$uint16Tag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$uint32Tag] = true;
$2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$errorTag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$funcTag] = $2b257b0c0d32189a$var$cloneableTags[$2b257b0c0d32189a$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $2b257b0c0d32189a$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $2b257b0c0d32189a$var$CLONE_DEEP_FLAG, isFlat = bitmask & $2b257b0c0d32189a$var$CLONE_FLAT_FLAG, isFull = bitmask & $2b257b0c0d32189a$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $f8M9J.default)(value)) return value;
    var isArr = (0, $kCwEw.default)(value);
    if (isArr) {
        result = (0, $iUHy8.default)(value);
        if (!isDeep) return (0, $gaHa5.default)(value, result);
    } else {
        var tag = (0, $j5aX8.default)(value), isFunc = tag == $2b257b0c0d32189a$var$funcTag || tag == $2b257b0c0d32189a$var$genTag;
        if ((0, $emwkF.default)(value)) return (0, $dGDoI.default)(value, isDeep);
        if (tag == $2b257b0c0d32189a$var$objectTag || tag == $2b257b0c0d32189a$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $7m9vs.default)(value);
            if (!isDeep) return isFlat ? (0, $aslhb.default)(value, (0, $hW3bZ.default)(result, value)) : (0, $kUIwZ.default)(value, (0, $8aDKX.default)(result, value));
        } else {
            if (!$2b257b0c0d32189a$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $kHTZH.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $hQ4rP.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $9UGdJ.default)(value)) value.forEach(function(subValue) {
        result.add($2b257b0c0d32189a$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $85B3r.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $2b257b0c0d32189a$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $eFgoZ.default) : (0, $3ap0R.default) : isFlat ? (0, $7nPCK.default) : (0, $jkb5J.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $juhyh.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $1sJoT.default)(result, key, $2b257b0c0d32189a$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $2b257b0c0d32189a$export$2e2bcd8739ae039 = $2b257b0c0d32189a$var$baseClone;

});
parcelRegister("hQ4rP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfcabe3fb9e9eb43$export$2e2bcd8739ae039; });

var $ksgJc = parcelRequire("ksgJc");

var $3s3py = parcelRequire("3s3py");

var $debnD = parcelRequire("debnD");

var $33W34 = parcelRequire("33W34");

var $l7ZrI = parcelRequire("l7ZrI");

var $3ER2w = parcelRequire("3ER2w");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $cfcabe3fb9e9eb43$var$Stack(entries) {
    var data = this.__data__ = new (0, $ksgJc.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$cfcabe3fb9e9eb43$var$Stack.prototype.clear = (0, $3s3py.default);
$cfcabe3fb9e9eb43$var$Stack.prototype['delete'] = (0, $debnD.default);
$cfcabe3fb9e9eb43$var$Stack.prototype.get = (0, $33W34.default);
$cfcabe3fb9e9eb43$var$Stack.prototype.has = (0, $l7ZrI.default);
$cfcabe3fb9e9eb43$var$Stack.prototype.set = (0, $3ER2w.default);
var $cfcabe3fb9e9eb43$export$2e2bcd8739ae039 = $cfcabe3fb9e9eb43$var$Stack;

});
parcelRegister("ksgJc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee4365fc00b7419c$export$2e2bcd8739ae039; });

var $iB75g = parcelRequire("iB75g");

var $f00O6 = parcelRequire("f00O6");

var $lMOMd = parcelRequire("lMOMd");

var $cXZfY = parcelRequire("cXZfY");

var $8SkbC = parcelRequire("8SkbC");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $ee4365fc00b7419c$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$ee4365fc00b7419c$var$ListCache.prototype.clear = (0, $iB75g.default);
$ee4365fc00b7419c$var$ListCache.prototype['delete'] = (0, $f00O6.default);
$ee4365fc00b7419c$var$ListCache.prototype.get = (0, $lMOMd.default);
$ee4365fc00b7419c$var$ListCache.prototype.has = (0, $cXZfY.default);
$ee4365fc00b7419c$var$ListCache.prototype.set = (0, $8SkbC.default);
var $ee4365fc00b7419c$export$2e2bcd8739ae039 = $ee4365fc00b7419c$var$ListCache;

});
parcelRegister("iB75g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8a12d6f7ecdc652$export$2e2bcd8739ae039; });
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $d8a12d6f7ecdc652$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $d8a12d6f7ecdc652$export$2e2bcd8739ae039 = $d8a12d6f7ecdc652$var$listCacheClear;

});

parcelRegister("f00O6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aeb77b5c38c2eb27$export$2e2bcd8739ae039; });

var $i6w5M = parcelRequire("i6w5M");
/** Used for built-in method references. */ var $aeb77b5c38c2eb27$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $aeb77b5c38c2eb27$var$splice = $aeb77b5c38c2eb27$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $aeb77b5c38c2eb27$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $i6w5M.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $aeb77b5c38c2eb27$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $aeb77b5c38c2eb27$export$2e2bcd8739ae039 = $aeb77b5c38c2eb27$var$listCacheDelete;

});
parcelRegister("i6w5M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2e1ae5dacc4e883$export$2e2bcd8739ae039; });

var $cbK6Z = parcelRequire("cbK6Z");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $d2e1ae5dacc4e883$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $cbK6Z.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $d2e1ae5dacc4e883$export$2e2bcd8739ae039 = $d2e1ae5dacc4e883$var$assocIndexOf;

});
parcelRegister("cbK6Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8dfa47f5b7baae2d$export$2e2bcd8739ae039; });
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $8dfa47f5b7baae2d$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $8dfa47f5b7baae2d$export$2e2bcd8739ae039 = $8dfa47f5b7baae2d$var$eq;

});



parcelRegister("lMOMd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdc577de9d2d45a7$export$2e2bcd8739ae039; });

var $i6w5M = parcelRequire("i6w5M");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fdc577de9d2d45a7$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $i6w5M.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $fdc577de9d2d45a7$export$2e2bcd8739ae039 = $fdc577de9d2d45a7$var$listCacheGet;

});

parcelRegister("cXZfY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $970a830879b16fc3$export$2e2bcd8739ae039; });

var $i6w5M = parcelRequire("i6w5M");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $970a830879b16fc3$var$listCacheHas(key) {
    return (0, $i6w5M.default)(this.__data__, key) > -1;
}
var $970a830879b16fc3$export$2e2bcd8739ae039 = $970a830879b16fc3$var$listCacheHas;

});

parcelRegister("8SkbC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6763067eeebc9645$export$2e2bcd8739ae039; });

var $i6w5M = parcelRequire("i6w5M");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $6763067eeebc9645$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $i6w5M.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $6763067eeebc9645$export$2e2bcd8739ae039 = $6763067eeebc9645$var$listCacheSet;

});


parcelRegister("3s3py", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2836a20645cab0ee$export$2e2bcd8739ae039; });

var $ksgJc = parcelRequire("ksgJc");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $2836a20645cab0ee$var$stackClear() {
    this.__data__ = new (0, $ksgJc.default);
    this.size = 0;
}
var $2836a20645cab0ee$export$2e2bcd8739ae039 = $2836a20645cab0ee$var$stackClear;

});

parcelRegister("debnD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a156903d4ce12fa$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9a156903d4ce12fa$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $9a156903d4ce12fa$export$2e2bcd8739ae039 = $9a156903d4ce12fa$var$stackDelete;

});

parcelRegister("33W34", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23aeae23a867ca95$export$2e2bcd8739ae039; });
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $23aeae23a867ca95$var$stackGet(key) {
    return this.__data__.get(key);
}
var $23aeae23a867ca95$export$2e2bcd8739ae039 = $23aeae23a867ca95$var$stackGet;

});

parcelRegister("l7ZrI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f619ea4e0e33020e$export$2e2bcd8739ae039; });
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f619ea4e0e33020e$var$stackHas(key) {
    return this.__data__.has(key);
}
var $f619ea4e0e33020e$export$2e2bcd8739ae039 = $f619ea4e0e33020e$var$stackHas;

});

parcelRegister("3ER2w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a9e4013cdb78bad$export$2e2bcd8739ae039; });

var $ksgJc = parcelRequire("ksgJc");

var $a0AgJ = parcelRequire("a0AgJ");

var $5znFr = parcelRequire("5znFr");
/** Used as the size to enable large array optimizations. */ var $2a9e4013cdb78bad$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $2a9e4013cdb78bad$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $ksgJc.default)) {
        var pairs = data.__data__;
        if (!(0, $a0AgJ.default) || pairs.length < $2a9e4013cdb78bad$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $5znFr.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $2a9e4013cdb78bad$export$2e2bcd8739ae039 = $2a9e4013cdb78bad$var$stackSet;

});
parcelRegister("a0AgJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $749609b594786ad0$export$2e2bcd8739ae039; });

var $gZ56P = parcelRequire("gZ56P");

var $71oki = parcelRequire("71oki");
/* Built-in method references that are verified to be native. */ var $749609b594786ad0$var$Map = (0, $gZ56P.default)((0, $71oki.default), 'Map');
var $749609b594786ad0$export$2e2bcd8739ae039 = $749609b594786ad0$var$Map;

});
parcelRegister("gZ56P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5d64e695c59f5b0$export$2e2bcd8739ae039; });

var $aL8C2 = parcelRequire("aL8C2");

var $1PtZX = parcelRequire("1PtZX");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $c5d64e695c59f5b0$var$getNative(object, key) {
    var value = (0, $1PtZX.default)(object, key);
    return (0, $aL8C2.default)(value) ? value : undefined;
}
var $c5d64e695c59f5b0$export$2e2bcd8739ae039 = $c5d64e695c59f5b0$var$getNative;

});
parcelRegister("aL8C2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d54f96a25f40804$export$2e2bcd8739ae039; });

var $9xi30 = parcelRequire("9xi30");

var $18hd8 = parcelRequire("18hd8");

var $f8M9J = parcelRequire("f8M9J");

var $1WJ1e = parcelRequire("1WJ1e");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $7d54f96a25f40804$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $7d54f96a25f40804$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $7d54f96a25f40804$var$funcProto = Function.prototype, $7d54f96a25f40804$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $7d54f96a25f40804$var$funcToString = $7d54f96a25f40804$var$funcProto.toString;
/** Used to check objects for own properties. */ var $7d54f96a25f40804$var$hasOwnProperty = $7d54f96a25f40804$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $7d54f96a25f40804$var$reIsNative = RegExp('^' + $7d54f96a25f40804$var$funcToString.call($7d54f96a25f40804$var$hasOwnProperty).replace($7d54f96a25f40804$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $7d54f96a25f40804$var$baseIsNative(value) {
    if (!(0, $f8M9J.default)(value) || (0, $18hd8.default)(value)) return false;
    var pattern = (0, $9xi30.default)(value) ? $7d54f96a25f40804$var$reIsNative : $7d54f96a25f40804$var$reIsHostCtor;
    return pattern.test((0, $1WJ1e.default)(value));
}
var $7d54f96a25f40804$export$2e2bcd8739ae039 = $7d54f96a25f40804$var$baseIsNative;

});
parcelRegister("9xi30", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f1531f6496a8ff2$export$2e2bcd8739ae039; });

var $3nHVm = parcelRequire("3nHVm");

var $f8M9J = parcelRequire("f8M9J");
/** `Object#toString` result references. */ var $6f1531f6496a8ff2$var$asyncTag = '[object AsyncFunction]', $6f1531f6496a8ff2$var$funcTag = '[object Function]', $6f1531f6496a8ff2$var$genTag = '[object GeneratorFunction]', $6f1531f6496a8ff2$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $6f1531f6496a8ff2$var$isFunction(value) {
    if (!(0, $f8M9J.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $3nHVm.default)(value);
    return tag == $6f1531f6496a8ff2$var$funcTag || tag == $6f1531f6496a8ff2$var$genTag || tag == $6f1531f6496a8ff2$var$asyncTag || tag == $6f1531f6496a8ff2$var$proxyTag;
}
var $6f1531f6496a8ff2$export$2e2bcd8739ae039 = $6f1531f6496a8ff2$var$isFunction;

});
parcelRegister("f8M9J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b05cf524c6e5e5f8$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $b05cf524c6e5e5f8$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $b05cf524c6e5e5f8$export$2e2bcd8739ae039 = $b05cf524c6e5e5f8$var$isObject;

});


parcelRegister("18hd8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d33e38255b754de$export$2e2bcd8739ae039; });

var $1cVei = parcelRequire("1cVei");
/** Used to detect methods masquerading as native. */ var $0d33e38255b754de$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $1cVei.default) && (0, $1cVei.default).keys && (0, $1cVei.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $0d33e38255b754de$var$isMasked(func) {
    return !!$0d33e38255b754de$var$maskSrcKey && $0d33e38255b754de$var$maskSrcKey in func;
}
var $0d33e38255b754de$export$2e2bcd8739ae039 = $0d33e38255b754de$var$isMasked;

});
parcelRegister("1cVei", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e134e080448c8ac$export$2e2bcd8739ae039; });

var $71oki = parcelRequire("71oki");
/** Used to detect overreaching core-js shims. */ var $0e134e080448c8ac$var$coreJsData = (0, $71oki.default)['__core-js_shared__'];
var $0e134e080448c8ac$export$2e2bcd8739ae039 = $0e134e080448c8ac$var$coreJsData;

});


parcelRegister("1WJ1e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16ae21033808726e$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $16ae21033808726e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $16ae21033808726e$var$funcToString = $16ae21033808726e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $16ae21033808726e$var$toSource(func) {
    if (func != null) {
        try {
            return $16ae21033808726e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $16ae21033808726e$export$2e2bcd8739ae039 = $16ae21033808726e$var$toSource;

});


parcelRegister("1PtZX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1551d2ea89811db0$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $1551d2ea89811db0$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $1551d2ea89811db0$export$2e2bcd8739ae039 = $1551d2ea89811db0$var$getValue;

});



parcelRegister("5znFr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40e2947b2b189b27$export$2e2bcd8739ae039; });

var $gZw2H = parcelRequire("gZw2H");

var $f4pyS = parcelRequire("f4pyS");

var $9ywU2 = parcelRequire("9ywU2");

var $dZ4I9 = parcelRequire("dZ4I9");

var $4hLjv = parcelRequire("4hLjv");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $40e2947b2b189b27$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$40e2947b2b189b27$var$MapCache.prototype.clear = (0, $gZw2H.default);
$40e2947b2b189b27$var$MapCache.prototype['delete'] = (0, $f4pyS.default);
$40e2947b2b189b27$var$MapCache.prototype.get = (0, $9ywU2.default);
$40e2947b2b189b27$var$MapCache.prototype.has = (0, $dZ4I9.default);
$40e2947b2b189b27$var$MapCache.prototype.set = (0, $4hLjv.default);
var $40e2947b2b189b27$export$2e2bcd8739ae039 = $40e2947b2b189b27$var$MapCache;

});
parcelRegister("gZw2H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5eb32d0ff12b1f6$export$2e2bcd8739ae039; });

var $OdSuc = parcelRequire("OdSuc");

var $ksgJc = parcelRequire("ksgJc");

var $a0AgJ = parcelRequire("a0AgJ");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $c5eb32d0ff12b1f6$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $OdSuc.default),
        'map': new ((0, $a0AgJ.default) || (0, $ksgJc.default)),
        'string': new (0, $OdSuc.default)
    };
}
var $c5eb32d0ff12b1f6$export$2e2bcd8739ae039 = $c5eb32d0ff12b1f6$var$mapCacheClear;

});
parcelRegister("OdSuc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $096f6f786b1bb89a$export$2e2bcd8739ae039; });

var $fjsGl = parcelRequire("fjsGl");

var $aXYc5 = parcelRequire("aXYc5");

var $jSEmx = parcelRequire("jSEmx");

var $aacRc = parcelRequire("aacRc");

var $5vdUF = parcelRequire("5vdUF");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $096f6f786b1bb89a$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$096f6f786b1bb89a$var$Hash.prototype.clear = (0, $fjsGl.default);
$096f6f786b1bb89a$var$Hash.prototype['delete'] = (0, $aXYc5.default);
$096f6f786b1bb89a$var$Hash.prototype.get = (0, $jSEmx.default);
$096f6f786b1bb89a$var$Hash.prototype.has = (0, $aacRc.default);
$096f6f786b1bb89a$var$Hash.prototype.set = (0, $5vdUF.default);
var $096f6f786b1bb89a$export$2e2bcd8739ae039 = $096f6f786b1bb89a$var$Hash;

});
parcelRegister("fjsGl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b25ee1068f80b38a$export$2e2bcd8739ae039; });

var $2OLbf = parcelRequire("2OLbf");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $b25ee1068f80b38a$var$hashClear() {
    this.__data__ = (0, $2OLbf.default) ? (0, $2OLbf.default)(null) : {};
    this.size = 0;
}
var $b25ee1068f80b38a$export$2e2bcd8739ae039 = $b25ee1068f80b38a$var$hashClear;

});
parcelRegister("2OLbf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20d4d958d27a8fa9$export$2e2bcd8739ae039; });

var $gZ56P = parcelRequire("gZ56P");
/* Built-in method references that are verified to be native. */ var $20d4d958d27a8fa9$var$nativeCreate = (0, $gZ56P.default)(Object, 'create');
var $20d4d958d27a8fa9$export$2e2bcd8739ae039 = $20d4d958d27a8fa9$var$nativeCreate;

});


parcelRegister("aXYc5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fbe1b563628ff4b$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7fbe1b563628ff4b$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $7fbe1b563628ff4b$export$2e2bcd8739ae039 = $7fbe1b563628ff4b$var$hashDelete;

});

parcelRegister("jSEmx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7925e9a3e21c799$export$2e2bcd8739ae039; });

var $2OLbf = parcelRequire("2OLbf");
/** Used to stand-in for `undefined` hash values. */ var $e7925e9a3e21c799$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $e7925e9a3e21c799$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e7925e9a3e21c799$var$hasOwnProperty = $e7925e9a3e21c799$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e7925e9a3e21c799$var$hashGet(key) {
    var data = this.__data__;
    if (0, $2OLbf.default) {
        var result = data[key];
        return result === $e7925e9a3e21c799$var$HASH_UNDEFINED ? undefined : result;
    }
    return $e7925e9a3e21c799$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $e7925e9a3e21c799$export$2e2bcd8739ae039 = $e7925e9a3e21c799$var$hashGet;

});

parcelRegister("aacRc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7664cfaefe3e78dc$export$2e2bcd8739ae039; });

var $2OLbf = parcelRequire("2OLbf");
/** Used for built-in method references. */ var $7664cfaefe3e78dc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7664cfaefe3e78dc$var$hasOwnProperty = $7664cfaefe3e78dc$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7664cfaefe3e78dc$var$hashHas(key) {
    var data = this.__data__;
    return (0, $2OLbf.default) ? data[key] !== undefined : $7664cfaefe3e78dc$var$hasOwnProperty.call(data, key);
}
var $7664cfaefe3e78dc$export$2e2bcd8739ae039 = $7664cfaefe3e78dc$var$hashHas;

});

parcelRegister("5vdUF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $401aa3cfdd146709$export$2e2bcd8739ae039; });

var $2OLbf = parcelRequire("2OLbf");
/** Used to stand-in for `undefined` hash values. */ var $401aa3cfdd146709$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $401aa3cfdd146709$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $2OLbf.default) && value === undefined ? $401aa3cfdd146709$var$HASH_UNDEFINED : value;
    return this;
}
var $401aa3cfdd146709$export$2e2bcd8739ae039 = $401aa3cfdd146709$var$hashSet;

});



parcelRegister("f4pyS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af8b0eb46b781a34$export$2e2bcd8739ae039; });

var $fKhGV = parcelRequire("fKhGV");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $af8b0eb46b781a34$var$mapCacheDelete(key) {
    var result = (0, $fKhGV.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $af8b0eb46b781a34$export$2e2bcd8739ae039 = $af8b0eb46b781a34$var$mapCacheDelete;

});
parcelRegister("fKhGV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b768e007d2afba5e$export$2e2bcd8739ae039; });

var $8oW3I = parcelRequire("8oW3I");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $b768e007d2afba5e$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $8oW3I.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $b768e007d2afba5e$export$2e2bcd8739ae039 = $b768e007d2afba5e$var$getMapData;

});
parcelRegister("8oW3I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61dd99e5a79106c4$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $61dd99e5a79106c4$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $61dd99e5a79106c4$export$2e2bcd8739ae039 = $61dd99e5a79106c4$var$isKeyable;

});



parcelRegister("9ywU2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f50cfd879746405$export$2e2bcd8739ae039; });

var $fKhGV = parcelRequire("fKhGV");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6f50cfd879746405$var$mapCacheGet(key) {
    return (0, $fKhGV.default)(this, key).get(key);
}
var $6f50cfd879746405$export$2e2bcd8739ae039 = $6f50cfd879746405$var$mapCacheGet;

});

parcelRegister("dZ4I9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02a0973b5ddfeef8$export$2e2bcd8739ae039; });

var $fKhGV = parcelRequire("fKhGV");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $02a0973b5ddfeef8$var$mapCacheHas(key) {
    return (0, $fKhGV.default)(this, key).has(key);
}
var $02a0973b5ddfeef8$export$2e2bcd8739ae039 = $02a0973b5ddfeef8$var$mapCacheHas;

});

parcelRegister("4hLjv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31ed737a17b592c1$export$2e2bcd8739ae039; });

var $fKhGV = parcelRequire("fKhGV");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $31ed737a17b592c1$var$mapCacheSet(key, value) {
    var data = (0, $fKhGV.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $31ed737a17b592c1$export$2e2bcd8739ae039 = $31ed737a17b592c1$var$mapCacheSet;

});




parcelRegister("juhyh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2fe6f15efe3b544$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $e2fe6f15efe3b544$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $e2fe6f15efe3b544$export$2e2bcd8739ae039 = $e2fe6f15efe3b544$var$arrayEach;

});

parcelRegister("1sJoT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $110b9f8d544f6038$export$2e2bcd8739ae039; });

var $kQYPe = parcelRequire("kQYPe");

var $cbK6Z = parcelRequire("cbK6Z");
/** Used for built-in method references. */ var $110b9f8d544f6038$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $110b9f8d544f6038$var$hasOwnProperty = $110b9f8d544f6038$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $110b9f8d544f6038$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($110b9f8d544f6038$var$hasOwnProperty.call(object, key) && (0, $cbK6Z.default)(objValue, value)) || value === undefined && !(key in object)) (0, $kQYPe.default)(object, key, value);
}
var $110b9f8d544f6038$export$2e2bcd8739ae039 = $110b9f8d544f6038$var$assignValue;

});
parcelRegister("kQYPe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2e7d89acc3a281d$export$2e2bcd8739ae039; });

var $hhHuk = parcelRequire("hhHuk");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $f2e7d89acc3a281d$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $hhHuk.default)) (0, $hhHuk.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $f2e7d89acc3a281d$export$2e2bcd8739ae039 = $f2e7d89acc3a281d$var$baseAssignValue;

});
parcelRegister("hhHuk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c955c20e7ee9d05b$export$2e2bcd8739ae039; });

var $gZ56P = parcelRequire("gZ56P");
var $c955c20e7ee9d05b$var$defineProperty = function() {
    try {
        var func = (0, $gZ56P.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $c955c20e7ee9d05b$export$2e2bcd8739ae039 = $c955c20e7ee9d05b$var$defineProperty;

});



parcelRegister("8aDKX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f2e18b6d5314153$export$2e2bcd8739ae039; });

var $fvoVP = parcelRequire("fvoVP");

var $jkb5J = parcelRequire("jkb5J");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $5f2e18b6d5314153$var$baseAssign(object, source) {
    return object && (0, $fvoVP.default)(source, (0, $jkb5J.default)(source), object);
}
var $5f2e18b6d5314153$export$2e2bcd8739ae039 = $5f2e18b6d5314153$var$baseAssign;

});
parcelRegister("fvoVP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b49d17359480f079$export$2e2bcd8739ae039; });

var $1sJoT = parcelRequire("1sJoT");

var $kQYPe = parcelRequire("kQYPe");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $b49d17359480f079$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $kQYPe.default)(object, key, newValue);
        else (0, $1sJoT.default)(object, key, newValue);
    }
    return object;
}
var $b49d17359480f079$export$2e2bcd8739ae039 = $b49d17359480f079$var$copyObject;

});

parcelRegister("jkb5J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1187d1dfabe881b$export$2e2bcd8739ae039; });

var $fRn6n = parcelRequire("fRn6n");

var $8Stmt = parcelRequire("8Stmt");

var $3BZtz = parcelRequire("3BZtz");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $e1187d1dfabe881b$var$keys(object) {
    return (0, $3BZtz.default)(object) ? (0, $fRn6n.default)(object) : (0, $8Stmt.default)(object);
}
var $e1187d1dfabe881b$export$2e2bcd8739ae039 = $e1187d1dfabe881b$var$keys;

});
parcelRegister("fRn6n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8bdb9cbc8154aba$export$2e2bcd8739ae039; });

var $ad1ze = parcelRequire("ad1ze");

var $iCVed = parcelRequire("iCVed");

var $kCwEw = parcelRequire("kCwEw");

var $emwkF = parcelRequire("emwkF");

var $3H65O = parcelRequire("3H65O");

var $L67KT = parcelRequire("L67KT");
/** Used for built-in method references. */ var $b8bdb9cbc8154aba$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b8bdb9cbc8154aba$var$hasOwnProperty = $b8bdb9cbc8154aba$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $b8bdb9cbc8154aba$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $kCwEw.default)(value), isArg = !isArr && (0, $iCVed.default)(value), isBuff = !isArr && !isArg && (0, $emwkF.default)(value), isType = !isArr && !isArg && !isBuff && (0, $L67KT.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $ad1ze.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $b8bdb9cbc8154aba$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $3H65O.default)(key, length)))) result.push(key);
    return result;
}
var $b8bdb9cbc8154aba$export$2e2bcd8739ae039 = $b8bdb9cbc8154aba$var$arrayLikeKeys;

});
parcelRegister("ad1ze", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76ec557b5cf0d970$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $76ec557b5cf0d970$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $76ec557b5cf0d970$export$2e2bcd8739ae039 = $76ec557b5cf0d970$var$baseTimes;

});

parcelRegister("iCVed", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8f82aecbfb0d7b6$export$2e2bcd8739ae039; });

var $4xO1n = parcelRequire("4xO1n");

var $e3gLp = parcelRequire("e3gLp");
/** Used for built-in method references. */ var $d8f82aecbfb0d7b6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d8f82aecbfb0d7b6$var$hasOwnProperty = $d8f82aecbfb0d7b6$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $d8f82aecbfb0d7b6$var$propertyIsEnumerable = $d8f82aecbfb0d7b6$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $d8f82aecbfb0d7b6$var$isArguments = (0, $4xO1n.default)(function() {
    return arguments;
}()) ? (0, $4xO1n.default) : function(value) {
    return (0, $e3gLp.default)(value) && $d8f82aecbfb0d7b6$var$hasOwnProperty.call(value, 'callee') && !$d8f82aecbfb0d7b6$var$propertyIsEnumerable.call(value, 'callee');
};
var $d8f82aecbfb0d7b6$export$2e2bcd8739ae039 = $d8f82aecbfb0d7b6$var$isArguments;

});
parcelRegister("4xO1n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34f10ba574c6f393$export$2e2bcd8739ae039; });

var $3nHVm = parcelRequire("3nHVm");

var $e3gLp = parcelRequire("e3gLp");
/** `Object#toString` result references. */ var $34f10ba574c6f393$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $34f10ba574c6f393$var$baseIsArguments(value) {
    return (0, $e3gLp.default)(value) && (0, $3nHVm.default)(value) == $34f10ba574c6f393$var$argsTag;
}
var $34f10ba574c6f393$export$2e2bcd8739ae039 = $34f10ba574c6f393$var$baseIsArguments;

});


parcelRegister("kCwEw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f030af63e50421c1$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $f030af63e50421c1$var$isArray = Array.isArray;
var $f030af63e50421c1$export$2e2bcd8739ae039 = $f030af63e50421c1$var$isArray;

});

parcelRegister("emwkF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a74c334736aafdbb$export$2e2bcd8739ae039; });

var $71oki = parcelRequire("71oki");

var $4U59o = parcelRequire("4U59o");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $71oki.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $4U59o.default);
var $a74c334736aafdbb$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("4U59o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3920632a05d7d242$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $3920632a05d7d242$var$stubFalse() {
    return false;
}
var $3920632a05d7d242$export$2e2bcd8739ae039 = $3920632a05d7d242$var$stubFalse;

});


parcelRegister("3H65O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b0a1d2770e64571$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $2b0a1d2770e64571$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $2b0a1d2770e64571$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $2b0a1d2770e64571$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $2b0a1d2770e64571$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $2b0a1d2770e64571$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $2b0a1d2770e64571$export$2e2bcd8739ae039 = $2b0a1d2770e64571$var$isIndex;

});

parcelRegister("L67KT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08d924043d9f81a5$export$2e2bcd8739ae039; });

var $50bgt = parcelRequire("50bgt");

var $hJyWG = parcelRequire("hJyWG");

var $g6fiN = parcelRequire("g6fiN");
/* Node.js helper references. */ var $08d924043d9f81a5$var$nodeIsTypedArray = (0, $g6fiN.default) && (0, $g6fiN.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $08d924043d9f81a5$var$isTypedArray = $08d924043d9f81a5$var$nodeIsTypedArray ? (0, $hJyWG.default)($08d924043d9f81a5$var$nodeIsTypedArray) : (0, $50bgt.default);
var $08d924043d9f81a5$export$2e2bcd8739ae039 = $08d924043d9f81a5$var$isTypedArray;

});
parcelRegister("50bgt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a45b0c92c8a8459$export$2e2bcd8739ae039; });

var $3nHVm = parcelRequire("3nHVm");

var $j3LLn = parcelRequire("j3LLn");

var $e3gLp = parcelRequire("e3gLp");
/** `Object#toString` result references. */ var $3a45b0c92c8a8459$var$argsTag = '[object Arguments]', $3a45b0c92c8a8459$var$arrayTag = '[object Array]', $3a45b0c92c8a8459$var$boolTag = '[object Boolean]', $3a45b0c92c8a8459$var$dateTag = '[object Date]', $3a45b0c92c8a8459$var$errorTag = '[object Error]', $3a45b0c92c8a8459$var$funcTag = '[object Function]', $3a45b0c92c8a8459$var$mapTag = '[object Map]', $3a45b0c92c8a8459$var$numberTag = '[object Number]', $3a45b0c92c8a8459$var$objectTag = '[object Object]', $3a45b0c92c8a8459$var$regexpTag = '[object RegExp]', $3a45b0c92c8a8459$var$setTag = '[object Set]', $3a45b0c92c8a8459$var$stringTag = '[object String]', $3a45b0c92c8a8459$var$weakMapTag = '[object WeakMap]';
var $3a45b0c92c8a8459$var$arrayBufferTag = '[object ArrayBuffer]', $3a45b0c92c8a8459$var$dataViewTag = '[object DataView]', $3a45b0c92c8a8459$var$float32Tag = '[object Float32Array]', $3a45b0c92c8a8459$var$float64Tag = '[object Float64Array]', $3a45b0c92c8a8459$var$int8Tag = '[object Int8Array]', $3a45b0c92c8a8459$var$int16Tag = '[object Int16Array]', $3a45b0c92c8a8459$var$int32Tag = '[object Int32Array]', $3a45b0c92c8a8459$var$uint8Tag = '[object Uint8Array]', $3a45b0c92c8a8459$var$uint8ClampedTag = '[object Uint8ClampedArray]', $3a45b0c92c8a8459$var$uint16Tag = '[object Uint16Array]', $3a45b0c92c8a8459$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $3a45b0c92c8a8459$var$typedArrayTags = {};
$3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$float32Tag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$float64Tag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$int8Tag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$int16Tag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$int32Tag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$uint8Tag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$uint8ClampedTag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$uint16Tag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$uint32Tag] = true;
$3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$argsTag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$arrayTag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$arrayBufferTag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$boolTag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$dataViewTag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$dateTag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$errorTag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$funcTag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$mapTag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$numberTag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$objectTag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$regexpTag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$setTag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$stringTag] = $3a45b0c92c8a8459$var$typedArrayTags[$3a45b0c92c8a8459$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $3a45b0c92c8a8459$var$baseIsTypedArray(value) {
    return (0, $e3gLp.default)(value) && (0, $j3LLn.default)(value.length) && !!$3a45b0c92c8a8459$var$typedArrayTags[(0, $3nHVm.default)(value)];
}
var $3a45b0c92c8a8459$export$2e2bcd8739ae039 = $3a45b0c92c8a8459$var$baseIsTypedArray;

});
parcelRegister("j3LLn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de0358e8cc4b9340$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $de0358e8cc4b9340$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $de0358e8cc4b9340$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $de0358e8cc4b9340$var$MAX_SAFE_INTEGER;
}
var $de0358e8cc4b9340$export$2e2bcd8739ae039 = $de0358e8cc4b9340$var$isLength;

});


parcelRegister("hJyWG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce91bf19e8b1a441$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $ce91bf19e8b1a441$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $ce91bf19e8b1a441$export$2e2bcd8739ae039 = $ce91bf19e8b1a441$var$baseUnary;

});

parcelRegister("g6fiN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb89138d77263bf1$export$2e2bcd8739ae039; });

var $qyeYs = parcelRequire("qyeYs");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $qyeYs.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $bb89138d77263bf1$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("8Stmt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $676a24767b838334$export$2e2bcd8739ae039; });

var $7bmSi = parcelRequire("7bmSi");

var $4h7ov = parcelRequire("4h7ov");
/** Used for built-in method references. */ var $676a24767b838334$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $676a24767b838334$var$hasOwnProperty = $676a24767b838334$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $676a24767b838334$var$baseKeys(object) {
    if (!(0, $7bmSi.default)(object)) return (0, $4h7ov.default)(object);
    var result = [];
    for(var key in Object(object))if ($676a24767b838334$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $676a24767b838334$export$2e2bcd8739ae039 = $676a24767b838334$var$baseKeys;

});
parcelRegister("7bmSi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53ab4df450510d41$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $53ab4df450510d41$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $53ab4df450510d41$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $53ab4df450510d41$var$objectProto;
    return value === proto;
}
var $53ab4df450510d41$export$2e2bcd8739ae039 = $53ab4df450510d41$var$isPrototype;

});

parcelRegister("4h7ov", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31ce7c4c488615dc$export$2e2bcd8739ae039; });

var $3bHHQ = parcelRequire("3bHHQ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $31ce7c4c488615dc$var$nativeKeys = (0, $3bHHQ.default)(Object.keys, Object);
var $31ce7c4c488615dc$export$2e2bcd8739ae039 = $31ce7c4c488615dc$var$nativeKeys;

});


parcelRegister("3BZtz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a1483a60ae16ebe$export$2e2bcd8739ae039; });

var $9xi30 = parcelRequire("9xi30");

var $j3LLn = parcelRequire("j3LLn");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $2a1483a60ae16ebe$var$isArrayLike(value) {
    return value != null && (0, $j3LLn.default)(value.length) && !(0, $9xi30.default)(value);
}
var $2a1483a60ae16ebe$export$2e2bcd8739ae039 = $2a1483a60ae16ebe$var$isArrayLike;

});



parcelRegister("hW3bZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0ea5464f9e46906$export$2e2bcd8739ae039; });

var $fvoVP = parcelRequire("fvoVP");

var $7nPCK = parcelRequire("7nPCK");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $d0ea5464f9e46906$var$baseAssignIn(object, source) {
    return object && (0, $fvoVP.default)(source, (0, $7nPCK.default)(source), object);
}
var $d0ea5464f9e46906$export$2e2bcd8739ae039 = $d0ea5464f9e46906$var$baseAssignIn;

});
parcelRegister("7nPCK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5602b9d624be7fa9$export$2e2bcd8739ae039; });

var $fRn6n = parcelRequire("fRn6n");

var $kw1j3 = parcelRequire("kw1j3");

var $3BZtz = parcelRequire("3BZtz");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $5602b9d624be7fa9$var$keysIn(object) {
    return (0, $3BZtz.default)(object) ? (0, $fRn6n.default)(object, true) : (0, $kw1j3.default)(object);
}
var $5602b9d624be7fa9$export$2e2bcd8739ae039 = $5602b9d624be7fa9$var$keysIn;

});
parcelRegister("kw1j3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eef7cf3410af14aa$export$2e2bcd8739ae039; });

var $f8M9J = parcelRequire("f8M9J");

var $7bmSi = parcelRequire("7bmSi");

var $5ibx4 = parcelRequire("5ibx4");
/** Used for built-in method references. */ var $eef7cf3410af14aa$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $eef7cf3410af14aa$var$hasOwnProperty = $eef7cf3410af14aa$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $eef7cf3410af14aa$var$baseKeysIn(object) {
    if (!(0, $f8M9J.default)(object)) return (0, $5ibx4.default)(object);
    var isProto = (0, $7bmSi.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$eef7cf3410af14aa$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $eef7cf3410af14aa$export$2e2bcd8739ae039 = $eef7cf3410af14aa$var$baseKeysIn;

});
parcelRegister("5ibx4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3da7944ed791b4a1$export$2e2bcd8739ae039; });
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $3da7944ed791b4a1$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $3da7944ed791b4a1$export$2e2bcd8739ae039 = $3da7944ed791b4a1$var$nativeKeysIn;

});




parcelRegister("dGDoI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f6dc22587405af4$export$2e2bcd8739ae039; });

var $71oki = parcelRequire("71oki");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $71oki.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $9f6dc22587405af4$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("gaHa5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc5f0f8411b1ee11$export$2e2bcd8739ae039; });
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $bc5f0f8411b1ee11$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $bc5f0f8411b1ee11$export$2e2bcd8739ae039 = $bc5f0f8411b1ee11$var$copyArray;

});

parcelRegister("kUIwZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f39b949457e57472$export$2e2bcd8739ae039; });

var $fvoVP = parcelRequire("fvoVP");

var $dsYjZ = parcelRequire("dsYjZ");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $f39b949457e57472$var$copySymbols(source, object) {
    return (0, $fvoVP.default)(source, (0, $dsYjZ.default)(source), object);
}
var $f39b949457e57472$export$2e2bcd8739ae039 = $f39b949457e57472$var$copySymbols;

});
parcelRegister("dsYjZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cdcae75255ae7a9$export$2e2bcd8739ae039; });

var $lwu5J = parcelRequire("lwu5J");

var $e9qPQ = parcelRequire("e9qPQ");
/** Used for built-in method references. */ var $9cdcae75255ae7a9$var$objectProto = Object.prototype;
/** Built-in value references. */ var $9cdcae75255ae7a9$var$propertyIsEnumerable = $9cdcae75255ae7a9$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9cdcae75255ae7a9$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $9cdcae75255ae7a9$var$getSymbols = !$9cdcae75255ae7a9$var$nativeGetSymbols ? (0, $e9qPQ.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $lwu5J.default)($9cdcae75255ae7a9$var$nativeGetSymbols(object), function(symbol) {
        return $9cdcae75255ae7a9$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $9cdcae75255ae7a9$export$2e2bcd8739ae039 = $9cdcae75255ae7a9$var$getSymbols;

});
parcelRegister("lwu5J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fab3eda8a3a4e336$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $fab3eda8a3a4e336$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $fab3eda8a3a4e336$export$2e2bcd8739ae039 = $fab3eda8a3a4e336$var$arrayFilter;

});

parcelRegister("e9qPQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4d6b8d80a3109ed$export$2e2bcd8739ae039; });
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $a4d6b8d80a3109ed$var$stubArray() {
    return [];
}
var $a4d6b8d80a3109ed$export$2e2bcd8739ae039 = $a4d6b8d80a3109ed$var$stubArray;

});



parcelRegister("aslhb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79cd05e243d2f3d7$export$2e2bcd8739ae039; });

var $fvoVP = parcelRequire("fvoVP");

var $1UvAg = parcelRequire("1UvAg");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $79cd05e243d2f3d7$var$copySymbolsIn(source, object) {
    return (0, $fvoVP.default)(source, (0, $1UvAg.default)(source), object);
}
var $79cd05e243d2f3d7$export$2e2bcd8739ae039 = $79cd05e243d2f3d7$var$copySymbolsIn;

});
parcelRegister("1UvAg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1643854ab425ed20$export$2e2bcd8739ae039; });

var $bGZZV = parcelRequire("bGZZV");

var $fhmjs = parcelRequire("fhmjs");

var $dsYjZ = parcelRequire("dsYjZ");

var $e9qPQ = parcelRequire("e9qPQ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1643854ab425ed20$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $1643854ab425ed20$var$getSymbolsIn = !$1643854ab425ed20$var$nativeGetSymbols ? (0, $e9qPQ.default) : function(object) {
    var result = [];
    while(object){
        (0, $bGZZV.default)(result, (0, $dsYjZ.default)(object));
        object = (0, $fhmjs.default)(object);
    }
    return result;
};
var $1643854ab425ed20$export$2e2bcd8739ae039 = $1643854ab425ed20$var$getSymbolsIn;

});
parcelRegister("bGZZV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8833b56af949af73$export$2e2bcd8739ae039; });
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $8833b56af949af73$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $8833b56af949af73$export$2e2bcd8739ae039 = $8833b56af949af73$var$arrayPush;

});



parcelRegister("3ap0R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24e5b54ff0eea27a$export$2e2bcd8739ae039; });

var $88w0D = parcelRequire("88w0D");

var $dsYjZ = parcelRequire("dsYjZ");

var $jkb5J = parcelRequire("jkb5J");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $24e5b54ff0eea27a$var$getAllKeys(object) {
    return (0, $88w0D.default)(object, (0, $jkb5J.default), (0, $dsYjZ.default));
}
var $24e5b54ff0eea27a$export$2e2bcd8739ae039 = $24e5b54ff0eea27a$var$getAllKeys;

});
parcelRegister("88w0D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ec7e6719a0a471a$export$2e2bcd8739ae039; });

var $bGZZV = parcelRequire("bGZZV");

var $kCwEw = parcelRequire("kCwEw");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $5ec7e6719a0a471a$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $kCwEw.default)(object) ? result : (0, $bGZZV.default)(result, symbolsFunc(object));
}
var $5ec7e6719a0a471a$export$2e2bcd8739ae039 = $5ec7e6719a0a471a$var$baseGetAllKeys;

});


parcelRegister("eFgoZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aad19e2767eb94c1$export$2e2bcd8739ae039; });

var $88w0D = parcelRequire("88w0D");

var $1UvAg = parcelRequire("1UvAg");

var $7nPCK = parcelRequire("7nPCK");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $aad19e2767eb94c1$var$getAllKeysIn(object) {
    return (0, $88w0D.default)(object, (0, $7nPCK.default), (0, $1UvAg.default));
}
var $aad19e2767eb94c1$export$2e2bcd8739ae039 = $aad19e2767eb94c1$var$getAllKeysIn;

});

parcelRegister("j5aX8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de46faee63e37773$export$2e2bcd8739ae039; });

var $iZVpS = parcelRequire("iZVpS");

var $a0AgJ = parcelRequire("a0AgJ");

var $hD0nc = parcelRequire("hD0nc");

var $36RU5 = parcelRequire("36RU5");

var $jMw0N = parcelRequire("jMw0N");

var $3nHVm = parcelRequire("3nHVm");

var $1WJ1e = parcelRequire("1WJ1e");
/** `Object#toString` result references. */ var $de46faee63e37773$var$mapTag = '[object Map]', $de46faee63e37773$var$objectTag = '[object Object]', $de46faee63e37773$var$promiseTag = '[object Promise]', $de46faee63e37773$var$setTag = '[object Set]', $de46faee63e37773$var$weakMapTag = '[object WeakMap]';
var $de46faee63e37773$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $de46faee63e37773$var$dataViewCtorString = (0, $1WJ1e.default)((0, $iZVpS.default)), $de46faee63e37773$var$mapCtorString = (0, $1WJ1e.default)((0, $a0AgJ.default)), $de46faee63e37773$var$promiseCtorString = (0, $1WJ1e.default)((0, $hD0nc.default)), $de46faee63e37773$var$setCtorString = (0, $1WJ1e.default)((0, $36RU5.default)), $de46faee63e37773$var$weakMapCtorString = (0, $1WJ1e.default)((0, $jMw0N.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $de46faee63e37773$var$getTag = (0, $3nHVm.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $iZVpS.default) && $de46faee63e37773$var$getTag(new (0, $iZVpS.default)(new ArrayBuffer(1))) != $de46faee63e37773$var$dataViewTag || (0, $a0AgJ.default) && $de46faee63e37773$var$getTag(new (0, $a0AgJ.default)) != $de46faee63e37773$var$mapTag || (0, $hD0nc.default) && $de46faee63e37773$var$getTag((0, $hD0nc.default).resolve()) != $de46faee63e37773$var$promiseTag || (0, $36RU5.default) && $de46faee63e37773$var$getTag(new (0, $36RU5.default)) != $de46faee63e37773$var$setTag || (0, $jMw0N.default) && $de46faee63e37773$var$getTag(new (0, $jMw0N.default)) != $de46faee63e37773$var$weakMapTag) $de46faee63e37773$var$getTag = function(value) {
    var result = (0, $3nHVm.default)(value), Ctor = result == $de46faee63e37773$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $1WJ1e.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $de46faee63e37773$var$dataViewCtorString:
            return $de46faee63e37773$var$dataViewTag;
        case $de46faee63e37773$var$mapCtorString:
            return $de46faee63e37773$var$mapTag;
        case $de46faee63e37773$var$promiseCtorString:
            return $de46faee63e37773$var$promiseTag;
        case $de46faee63e37773$var$setCtorString:
            return $de46faee63e37773$var$setTag;
        case $de46faee63e37773$var$weakMapCtorString:
            return $de46faee63e37773$var$weakMapTag;
    }
    return result;
};
var $de46faee63e37773$export$2e2bcd8739ae039 = $de46faee63e37773$var$getTag;

});
parcelRegister("iZVpS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd4a7631c7749b87$export$2e2bcd8739ae039; });

var $gZ56P = parcelRequire("gZ56P");

var $71oki = parcelRequire("71oki");
/* Built-in method references that are verified to be native. */ var $dd4a7631c7749b87$var$DataView = (0, $gZ56P.default)((0, $71oki.default), 'DataView');
var $dd4a7631c7749b87$export$2e2bcd8739ae039 = $dd4a7631c7749b87$var$DataView;

});

parcelRegister("hD0nc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd565e51419a6c84$export$2e2bcd8739ae039; });

var $gZ56P = parcelRequire("gZ56P");

var $71oki = parcelRequire("71oki");
/* Built-in method references that are verified to be native. */ var $cd565e51419a6c84$var$Promise = (0, $gZ56P.default)((0, $71oki.default), 'Promise');
var $cd565e51419a6c84$export$2e2bcd8739ae039 = $cd565e51419a6c84$var$Promise;

});

parcelRegister("36RU5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $243bbec918f9717f$export$2e2bcd8739ae039; });

var $gZ56P = parcelRequire("gZ56P");

var $71oki = parcelRequire("71oki");
/* Built-in method references that are verified to be native. */ var $243bbec918f9717f$var$Set = (0, $gZ56P.default)((0, $71oki.default), 'Set');
var $243bbec918f9717f$export$2e2bcd8739ae039 = $243bbec918f9717f$var$Set;

});

parcelRegister("jMw0N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e66b54e591c2b135$export$2e2bcd8739ae039; });

var $gZ56P = parcelRequire("gZ56P");

var $71oki = parcelRequire("71oki");
/* Built-in method references that are verified to be native. */ var $e66b54e591c2b135$var$WeakMap = (0, $gZ56P.default)((0, $71oki.default), 'WeakMap');
var $e66b54e591c2b135$export$2e2bcd8739ae039 = $e66b54e591c2b135$var$WeakMap;

});


parcelRegister("iUHy8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc4f3cfa30372b28$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $dc4f3cfa30372b28$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dc4f3cfa30372b28$var$hasOwnProperty = $dc4f3cfa30372b28$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $dc4f3cfa30372b28$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $dc4f3cfa30372b28$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $dc4f3cfa30372b28$export$2e2bcd8739ae039 = $dc4f3cfa30372b28$var$initCloneArray;

});

parcelRegister("kHTZH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1334216d635cd35$export$2e2bcd8739ae039; });

var $gBO7L = parcelRequire("gBO7L");

var $aVIKn = parcelRequire("aVIKn");

var $4T2H4 = parcelRequire("4T2H4");

var $kYuyE = parcelRequire("kYuyE");

var $hyzHK = parcelRequire("hyzHK");
/** `Object#toString` result references. */ var $f1334216d635cd35$var$boolTag = '[object Boolean]', $f1334216d635cd35$var$dateTag = '[object Date]', $f1334216d635cd35$var$mapTag = '[object Map]', $f1334216d635cd35$var$numberTag = '[object Number]', $f1334216d635cd35$var$regexpTag = '[object RegExp]', $f1334216d635cd35$var$setTag = '[object Set]', $f1334216d635cd35$var$stringTag = '[object String]', $f1334216d635cd35$var$symbolTag = '[object Symbol]';
var $f1334216d635cd35$var$arrayBufferTag = '[object ArrayBuffer]', $f1334216d635cd35$var$dataViewTag = '[object DataView]', $f1334216d635cd35$var$float32Tag = '[object Float32Array]', $f1334216d635cd35$var$float64Tag = '[object Float64Array]', $f1334216d635cd35$var$int8Tag = '[object Int8Array]', $f1334216d635cd35$var$int16Tag = '[object Int16Array]', $f1334216d635cd35$var$int32Tag = '[object Int32Array]', $f1334216d635cd35$var$uint8Tag = '[object Uint8Array]', $f1334216d635cd35$var$uint8ClampedTag = '[object Uint8ClampedArray]', $f1334216d635cd35$var$uint16Tag = '[object Uint16Array]', $f1334216d635cd35$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $f1334216d635cd35$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $f1334216d635cd35$var$arrayBufferTag:
            return (0, $gBO7L.default)(object);
        case $f1334216d635cd35$var$boolTag:
        case $f1334216d635cd35$var$dateTag:
            return new Ctor(+object);
        case $f1334216d635cd35$var$dataViewTag:
            return (0, $aVIKn.default)(object, isDeep);
        case $f1334216d635cd35$var$float32Tag:
        case $f1334216d635cd35$var$float64Tag:
        case $f1334216d635cd35$var$int8Tag:
        case $f1334216d635cd35$var$int16Tag:
        case $f1334216d635cd35$var$int32Tag:
        case $f1334216d635cd35$var$uint8Tag:
        case $f1334216d635cd35$var$uint8ClampedTag:
        case $f1334216d635cd35$var$uint16Tag:
        case $f1334216d635cd35$var$uint32Tag:
            return (0, $hyzHK.default)(object, isDeep);
        case $f1334216d635cd35$var$mapTag:
            return new Ctor;
        case $f1334216d635cd35$var$numberTag:
        case $f1334216d635cd35$var$stringTag:
            return new Ctor(object);
        case $f1334216d635cd35$var$regexpTag:
            return (0, $4T2H4.default)(object);
        case $f1334216d635cd35$var$setTag:
            return new Ctor;
        case $f1334216d635cd35$var$symbolTag:
            return (0, $kYuyE.default)(object);
    }
}
var $f1334216d635cd35$export$2e2bcd8739ae039 = $f1334216d635cd35$var$initCloneByTag;

});
parcelRegister("gBO7L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c176fbb0761f7626$export$2e2bcd8739ae039; });

var $jzV4C = parcelRequire("jzV4C");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $c176fbb0761f7626$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $jzV4C.default)(result).set(new (0, $jzV4C.default)(arrayBuffer));
    return result;
}
var $c176fbb0761f7626$export$2e2bcd8739ae039 = $c176fbb0761f7626$var$cloneArrayBuffer;

});
parcelRegister("jzV4C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e40d8eca0e78c234$export$2e2bcd8739ae039; });

var $71oki = parcelRequire("71oki");
/** Built-in value references. */ var $e40d8eca0e78c234$var$Uint8Array = (0, $71oki.default).Uint8Array;
var $e40d8eca0e78c234$export$2e2bcd8739ae039 = $e40d8eca0e78c234$var$Uint8Array;

});


parcelRegister("aVIKn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f51f00fc773c67b$export$2e2bcd8739ae039; });

var $gBO7L = parcelRequire("gBO7L");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $7f51f00fc773c67b$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $gBO7L.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $7f51f00fc773c67b$export$2e2bcd8739ae039 = $7f51f00fc773c67b$var$cloneDataView;

});

parcelRegister("4T2H4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38ee635e4bf10f23$export$2e2bcd8739ae039; });
/** Used to match `RegExp` flags from their coerced string values. */ var $38ee635e4bf10f23$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $38ee635e4bf10f23$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $38ee635e4bf10f23$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $38ee635e4bf10f23$export$2e2bcd8739ae039 = $38ee635e4bf10f23$var$cloneRegExp;

});

parcelRegister("kYuyE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4511d6c504c4c37$export$2e2bcd8739ae039; });

var $ceXwU = parcelRequire("ceXwU");
/** Used to convert symbols to primitives and strings. */ var $f4511d6c504c4c37$var$symbolProto = (0, $ceXwU.default) ? (0, $ceXwU.default).prototype : undefined, $f4511d6c504c4c37$var$symbolValueOf = $f4511d6c504c4c37$var$symbolProto ? $f4511d6c504c4c37$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $f4511d6c504c4c37$var$cloneSymbol(symbol) {
    return $f4511d6c504c4c37$var$symbolValueOf ? Object($f4511d6c504c4c37$var$symbolValueOf.call(symbol)) : {};
}
var $f4511d6c504c4c37$export$2e2bcd8739ae039 = $f4511d6c504c4c37$var$cloneSymbol;

});

parcelRegister("hyzHK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc814ed6f6917ea1$export$2e2bcd8739ae039; });

var $gBO7L = parcelRequire("gBO7L");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $cc814ed6f6917ea1$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $gBO7L.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $cc814ed6f6917ea1$export$2e2bcd8739ae039 = $cc814ed6f6917ea1$var$cloneTypedArray;

});


parcelRegister("7m9vs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55b1f644e5e2b238$export$2e2bcd8739ae039; });

var $lNxys = parcelRequire("lNxys");

var $fhmjs = parcelRequire("fhmjs");

var $7bmSi = parcelRequire("7bmSi");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $55b1f644e5e2b238$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $7bmSi.default)(object) ? (0, $lNxys.default)((0, $fhmjs.default)(object)) : {};
}
var $55b1f644e5e2b238$export$2e2bcd8739ae039 = $55b1f644e5e2b238$var$initCloneObject;

});
parcelRegister("lNxys", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fde833de76af9146$export$2e2bcd8739ae039; });

var $f8M9J = parcelRequire("f8M9J");
/** Built-in value references. */ var $fde833de76af9146$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $fde833de76af9146$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $f8M9J.default)(proto)) return {};
        if ($fde833de76af9146$var$objectCreate) return $fde833de76af9146$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $fde833de76af9146$export$2e2bcd8739ae039 = $fde833de76af9146$var$baseCreate;

});


parcelRegister("85B3r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e3b889b4537a3ca$export$2e2bcd8739ae039; });

var $1ryPK = parcelRequire("1ryPK");

var $hJyWG = parcelRequire("hJyWG");

var $g6fiN = parcelRequire("g6fiN");
/* Node.js helper references. */ var $5e3b889b4537a3ca$var$nodeIsMap = (0, $g6fiN.default) && (0, $g6fiN.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $5e3b889b4537a3ca$var$isMap = $5e3b889b4537a3ca$var$nodeIsMap ? (0, $hJyWG.default)($5e3b889b4537a3ca$var$nodeIsMap) : (0, $1ryPK.default);
var $5e3b889b4537a3ca$export$2e2bcd8739ae039 = $5e3b889b4537a3ca$var$isMap;

});
parcelRegister("1ryPK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10d3554f99465825$export$2e2bcd8739ae039; });

var $j5aX8 = parcelRequire("j5aX8");

var $e3gLp = parcelRequire("e3gLp");
/** `Object#toString` result references. */ var $10d3554f99465825$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $10d3554f99465825$var$baseIsMap(value) {
    return (0, $e3gLp.default)(value) && (0, $j5aX8.default)(value) == $10d3554f99465825$var$mapTag;
}
var $10d3554f99465825$export$2e2bcd8739ae039 = $10d3554f99465825$var$baseIsMap;

});


parcelRegister("9UGdJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $737a181d2a0e9f9c$export$2e2bcd8739ae039; });

var $9mktB = parcelRequire("9mktB");

var $hJyWG = parcelRequire("hJyWG");

var $g6fiN = parcelRequire("g6fiN");
/* Node.js helper references. */ var $737a181d2a0e9f9c$var$nodeIsSet = (0, $g6fiN.default) && (0, $g6fiN.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $737a181d2a0e9f9c$var$isSet = $737a181d2a0e9f9c$var$nodeIsSet ? (0, $hJyWG.default)($737a181d2a0e9f9c$var$nodeIsSet) : (0, $9mktB.default);
var $737a181d2a0e9f9c$export$2e2bcd8739ae039 = $737a181d2a0e9f9c$var$isSet;

});
parcelRegister("9mktB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d060d537ffba065$export$2e2bcd8739ae039; });

var $j5aX8 = parcelRequire("j5aX8");

var $e3gLp = parcelRequire("e3gLp");
/** `Object#toString` result references. */ var $6d060d537ffba065$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $6d060d537ffba065$var$baseIsSet(value) {
    return (0, $e3gLp.default)(value) && (0, $j5aX8.default)(value) == $6d060d537ffba065$var$setTag;
}
var $6d060d537ffba065$export$2e2bcd8739ae039 = $6d060d537ffba065$var$baseIsSet;

});




parcelRegister("1TUVf", function(module, exports) {
'use strict';
var $1627151d20f00885$var$isArray = Array.isArray;
var $1627151d20f00885$var$keyList = Object.keys;
var $1627151d20f00885$var$hasProp = Object.prototype.hasOwnProperty;
var $1627151d20f00885$var$hasElementType = typeof Element !== 'undefined';
function $1627151d20f00885$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $1627151d20f00885$var$isArray(a), arrB = $1627151d20f00885$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$1627151d20f00885$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $1627151d20f00885$var$keyList(a);
        length = keys.length;
        if (length !== $1627151d20f00885$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$1627151d20f00885$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($1627151d20f00885$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$1627151d20f00885$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $1627151d20f00885$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("1wh2w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11b5ff595d82e259$export$2e2bcd8739ae039; });
var $11b5ff595d82e259$var$isProduction = true;
function $11b5ff595d82e259$var$warning(condition, message) {
    if (!$11b5ff595d82e259$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $11b5ff595d82e259$export$2e2bcd8739ae039 = $11b5ff595d82e259$var$warning;

});

parcelRegister("8SzAZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $676efa6cc4b5ed59$export$2e2bcd8739ae039; });

var $3HFnb = parcelRequire("3HFnb");
/** Used to compose bitmasks for cloning. */ var $676efa6cc4b5ed59$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $676efa6cc4b5ed59$var$clone(value) {
    return (0, $3HFnb.default)(value, $676efa6cc4b5ed59$var$CLONE_SYMBOLS_FLAG);
}
var $676efa6cc4b5ed59$export$2e2bcd8739ae039 = $676efa6cc4b5ed59$var$clone;

});

parcelRegister("a9kWi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $763afcc1ea1c1eb0$export$2e2bcd8739ae039; });

var $aSA17 = parcelRequire("aSA17");

var $gaHa5 = parcelRequire("gaHa5");

var $kCwEw = parcelRequire("kCwEw");

var $boGwZ = parcelRequire("boGwZ");

var $hQsVf = parcelRequire("hQsVf");

var $ePb8k = parcelRequire("ePb8k");

var $6GU9z = parcelRequire("6GU9z");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $763afcc1ea1c1eb0$var$toPath(value) {
    if ((0, $kCwEw.default)(value)) return (0, $aSA17.default)(value, (0, $ePb8k.default));
    return (0, $boGwZ.default)(value) ? [
        value
    ] : (0, $gaHa5.default)((0, $hQsVf.default)((0, $6GU9z.default)(value)));
}
var $763afcc1ea1c1eb0$export$2e2bcd8739ae039 = $763afcc1ea1c1eb0$var$toPath;

});
parcelRegister("aSA17", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ebae2c5acda97a4$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $7ebae2c5acda97a4$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $7ebae2c5acda97a4$export$2e2bcd8739ae039 = $7ebae2c5acda97a4$var$arrayMap;

});

parcelRegister("boGwZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84c2ed5d4194a3aa$export$2e2bcd8739ae039; });

var $3nHVm = parcelRequire("3nHVm");

var $e3gLp = parcelRequire("e3gLp");
/** `Object#toString` result references. */ var $84c2ed5d4194a3aa$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $84c2ed5d4194a3aa$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $e3gLp.default)(value) && (0, $3nHVm.default)(value) == $84c2ed5d4194a3aa$var$symbolTag;
}
var $84c2ed5d4194a3aa$export$2e2bcd8739ae039 = $84c2ed5d4194a3aa$var$isSymbol;

});

parcelRegister("hQsVf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfddba5bcb217f58$export$2e2bcd8739ae039; });

var $jekg9 = parcelRequire("jekg9");
/** Used to match property names within property paths. */ var $cfddba5bcb217f58$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $cfddba5bcb217f58$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $cfddba5bcb217f58$var$stringToPath = (0, $jekg9.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($cfddba5bcb217f58$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($cfddba5bcb217f58$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $cfddba5bcb217f58$export$2e2bcd8739ae039 = $cfddba5bcb217f58$var$stringToPath;

});
parcelRegister("jekg9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfff0a43fb11866b$export$2e2bcd8739ae039; });

var $6GK1e = parcelRequire("6GK1e");
/** Used as the maximum memoize cache size. */ var $dfff0a43fb11866b$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $dfff0a43fb11866b$var$memoizeCapped(func) {
    var result = (0, $6GK1e.default)(func, function(key) {
        if (cache.size === $dfff0a43fb11866b$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $dfff0a43fb11866b$export$2e2bcd8739ae039 = $dfff0a43fb11866b$var$memoizeCapped;

});
parcelRegister("6GK1e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4dea5cb236ba3592$export$2e2bcd8739ae039; });

var $5znFr = parcelRequire("5znFr");
/** Error message constants. */ var $4dea5cb236ba3592$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $4dea5cb236ba3592$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($4dea5cb236ba3592$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($4dea5cb236ba3592$var$memoize.Cache || (0, $5znFr.default));
    return memoized;
}
// Expose `MapCache`.
$4dea5cb236ba3592$var$memoize.Cache = (0, $5znFr.default);
var $4dea5cb236ba3592$export$2e2bcd8739ae039 = $4dea5cb236ba3592$var$memoize;

});



parcelRegister("ePb8k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acae76f6c396a078$export$2e2bcd8739ae039; });

var $boGwZ = parcelRequire("boGwZ");
/** Used as references for various `Number` constants. */ var $acae76f6c396a078$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $acae76f6c396a078$var$toKey(value) {
    if (typeof value == 'string' || (0, $boGwZ.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$acae76f6c396a078$var$INFINITY ? '-0' : result;
}
var $acae76f6c396a078$export$2e2bcd8739ae039 = $acae76f6c396a078$var$toKey;

});

parcelRegister("6GU9z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4df2393346dd8f9d$export$2e2bcd8739ae039; });

var $cZUxu = parcelRequire("cZUxu");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $4df2393346dd8f9d$var$toString(value) {
    return value == null ? '' : (0, $cZUxu.default)(value);
}
var $4df2393346dd8f9d$export$2e2bcd8739ae039 = $4df2393346dd8f9d$var$toString;

});
parcelRegister("cZUxu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97670a0fbafbad9a$export$2e2bcd8739ae039; });

var $ceXwU = parcelRequire("ceXwU");

var $aSA17 = parcelRequire("aSA17");

var $kCwEw = parcelRequire("kCwEw");

var $boGwZ = parcelRequire("boGwZ");
/** Used as references for various `Number` constants. */ var $97670a0fbafbad9a$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $97670a0fbafbad9a$var$symbolProto = (0, $ceXwU.default) ? (0, $ceXwU.default).prototype : undefined, $97670a0fbafbad9a$var$symbolToString = $97670a0fbafbad9a$var$symbolProto ? $97670a0fbafbad9a$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $97670a0fbafbad9a$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $kCwEw.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $aSA17.default)(value, $97670a0fbafbad9a$var$baseToString) + '';
    if ((0, $boGwZ.default)(value)) return $97670a0fbafbad9a$var$symbolToString ? $97670a0fbafbad9a$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$97670a0fbafbad9a$var$INFINITY ? '-0' : result;
}
var $97670a0fbafbad9a$export$2e2bcd8739ae039 = $97670a0fbafbad9a$var$baseToString;

});




parcelRegister("6KEih", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ea64b73350f42c8$export$2e2bcd8739ae039; });

var $eprdt = parcelRequire("eprdt");

var $9wiPO = parcelRequire("9wiPO");

var $evomV = parcelRequire("evomV");

var $hzItX = parcelRequire("hzItX");

var $h40qL = parcelRequire("h40qL");

var $XxsPs = parcelRequire("XxsPs");

var $3hUd9 = parcelRequire("3hUd9");

var $7qATu = parcelRequire("7qATu");

var $jdVXS = parcelRequire("jdVXS");

var $b90he = parcelRequire("b90he");

var $anVd6 = parcelRequire("anVd6");

var $8Eosr = parcelRequire("8Eosr");

var $6oePL = parcelRequire("6oePL");

var $3yeFB = parcelRequire("3yeFB");

var $20vqL = parcelRequire("20vqL");

var $6iLio = parcelRequire("6iLio");

var $39BXO = parcelRequire("39BXO");

var $17H8C = parcelRequire("17H8C");

var $e88oW = parcelRequire("e88oW");

var $4gNjr = parcelRequire("4gNjr");

var $hRRcn = parcelRequire("hRRcn");

var $fdaoy = parcelRequire("fdaoy");

var $f4S9s = parcelRequire("f4S9s");

var $9jTus = parcelRequire("9jTus");

var $d94C1 = parcelRequire("d94C1");

var $bv0op = parcelRequire("bv0op");

var $7tZ3h = parcelRequire("7tZ3h");

var $43ibR = parcelRequire("43ibR");

var $4Fb6a = parcelRequire("4Fb6a");

var $dOFk4 = parcelRequire("dOFk4");

var $fbzOf = parcelRequire("fbzOf");
(0, $eprdt.default).register({
    'attributors/attribute/direction': (0, $evomV.DirectionAttribute),
    'attributors/class/align': (0, $9wiPO.AlignClass),
    'attributors/class/background': (0, $7qATu.BackgroundClass),
    'attributors/class/color': (0, $jdVXS.ColorClass),
    'attributors/class/direction': (0, $evomV.DirectionClass),
    'attributors/class/font': (0, $b90he.FontClass),
    'attributors/class/size': (0, $anVd6.SizeClass),
    'attributors/style/align': (0, $9wiPO.AlignStyle),
    'attributors/style/background': (0, $7qATu.BackgroundStyle),
    'attributors/style/color': (0, $jdVXS.ColorStyle),
    'attributors/style/direction': (0, $evomV.DirectionStyle),
    'attributors/style/font': (0, $b90he.FontStyle),
    'attributors/style/size': (0, $anVd6.SizeStyle)
}, true);
(0, $eprdt.default).register({
    'formats/align': (0, $9wiPO.AlignClass),
    'formats/direction': (0, $evomV.DirectionClass),
    'formats/indent': (0, $hzItX.default),
    'formats/background': (0, $7qATu.BackgroundStyle),
    'formats/color': (0, $jdVXS.ColorStyle),
    'formats/font': (0, $b90he.FontClass),
    'formats/size': (0, $anVd6.SizeClass),
    'formats/blockquote': (0, $h40qL.default),
    'formats/code-block': (0, $hRRcn.default),
    'formats/header': (0, $XxsPs.default),
    'formats/list': (0, $3hUd9.default),
    'formats/bold': (0, $8Eosr.default),
    'formats/code': (0, $hRRcn.Code),
    'formats/italic': (0, $6oePL.default),
    'formats/link': (0, $3yeFB.default),
    'formats/script': (0, $20vqL.default),
    'formats/strike': (0, $6iLio.default),
    'formats/underline': (0, $39BXO.default),
    'formats/formula': (0, $17H8C.default),
    'formats/image': (0, $e88oW.default),
    'formats/video': (0, $4gNjr.default),
    'modules/syntax': (0, $fdaoy.default),
    'modules/table': (0, $f4S9s.default),
    'modules/toolbar': (0, $9jTus.default),
    'themes/bubble': (0, $dOFk4.default),
    'themes/snow': (0, $fbzOf.default),
    'ui/icons': (0, $d94C1.default),
    'ui/picker': (0, $bv0op.default),
    'ui/icon-picker': (0, $43ibR.default),
    'ui/color-picker': (0, $7tZ3h.default),
    'ui/tooltip': (0, $4Fb6a.default)
}, true);
var $4ea64b73350f42c8$export$2e2bcd8739ae039 = (0, $eprdt.default);

});
parcelRegister("eprdt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7d883157d87821b$export$2e2bcd8739ae039; });

var $5ubWu = parcelRequire("5ubWu");

var $4UH9n = parcelRequire("4UH9n");

var $ekYWe = parcelRequire("ekYWe");

var $hrKTM = parcelRequire("hrKTM");

var $4lEvv = parcelRequire("4lEvv");

var $7ve13 = parcelRequire("7ve13");

var $4Xyhi = parcelRequire("4Xyhi");

var $dzdwt = parcelRequire("dzdwt");

var $fpYVL = parcelRequire("fpYVL");

var $63ASE = parcelRequire("63ASE");

var $8iE1x = parcelRequire("8iE1x");

var $8c4Uv = parcelRequire("8c4Uv");

var $cXlxJ = parcelRequire("cXlxJ");

var $kHwOs = parcelRequire("kHwOs");

var $ezcCP = parcelRequire("ezcCP");

var $lmNv5 = parcelRequire("lmNv5");

var $cC34A = parcelRequire("cC34A");
(0, $5ubWu.default).register({
    'blots/block': (0, $4UH9n.default),
    'blots/block/embed': (0, $4UH9n.BlockEmbed),
    'blots/break': (0, $ekYWe.default),
    'blots/container': (0, $hrKTM.default),
    'blots/cursor': (0, $4lEvv.default),
    'blots/embed': (0, $7ve13.default),
    'blots/inline': (0, $4Xyhi.default),
    'blots/scroll': (0, $dzdwt.default),
    'blots/text': (0, $fpYVL.default),
    'modules/clipboard': (0, $63ASE.default),
    'modules/history': (0, $8iE1x.default),
    'modules/keyboard': (0, $8c4Uv.default),
    'modules/uploader': (0, $cXlxJ.default),
    'modules/input': (0, $ezcCP.default),
    'modules/uiNode': (0, $lmNv5.default)
});
var $a7d883157d87821b$export$2e2bcd8739ae039 = (0, $5ubWu.default);

});
parcelRegister("5ubWu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fe90493bdbac5e1$export$2e2bcd8739ae039; });

var $3izSM = parcelRequire("3izSM");

var $eYvg2 = parcelRequire("eYvg2");

var $kHwOs = parcelRequire("kHwOs");

var $3sXwB = parcelRequire("3sXwB");

var $8AVGf = parcelRequire("8AVGf");

var $4apTj = parcelRequire("4apTj");

var $jzLjA = parcelRequire("jzLjA");

var $cC34A = parcelRequire("cC34A");

var $9iwdq = parcelRequire("9iwdq");

var $kYcHV = parcelRequire("kYcHV");

var $8rmjg = parcelRequire("8rmjg");

var $cEKJW = parcelRequire("cEKJW");

var $6Ef7U = parcelRequire("6Ef7U");
const $3fe90493bdbac5e1$var$debug = (0, $jzLjA.default)('quill');
const $3fe90493bdbac5e1$export$bc58ce2776ecdb6f = new $eYvg2.Registry();
$eYvg2.ParentBlot.uiClass = 'ql-ui';
/**
 * Options for initializing a Quill instance
 */ /**
 * Similar to QuillOptions, but with all properties expanded to their default values,
 * and all selectors resolved to HTMLElements.
 */ class $3fe90493bdbac5e1$export$2e2bcd8739ae039 {
    static DEFAULTS = {
        bounds: null,
        modules: {
            clipboard: true,
            keyboard: true,
            history: true,
            uploader: true
        },
        placeholder: '',
        readOnly: false,
        registry: $3fe90493bdbac5e1$export$bc58ce2776ecdb6f,
        theme: 'default'
    };
    static events = (0, $8AVGf.default).events;
    static sources = (0, $8AVGf.default).sources;
    static version = "2.0.3";
    static imports = {
        delta: (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs))),
        parchment: $eYvg2,
        'core/module': (0, $cC34A.default),
        'core/theme': (0, $8rmjg.default)
    };
    static debug(limit) {
        if (limit === true) limit = 'log';
        (0, $jzLjA.default).level(limit);
    }
    static find(node) {
        let bubble = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return (0, $4apTj.default).get(node) || $3fe90493bdbac5e1$export$bc58ce2776ecdb6f.find(node, bubble);
    }
    static import(name) {
        if (this.imports[name] == null) $3fe90493bdbac5e1$var$debug.error(`Cannot import ${name}. Are you sure it was registered?`);
        return this.imports[name];
    }
    static register() {
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) !== 'string') {
            const target = arguments.length <= 0 ? undefined : arguments[0];
            const overwrite = !!(arguments.length <= 1 ? undefined : arguments[1]);
            const name = 'attrName' in target ? target.attrName : target.blotName;
            if (typeof name === 'string') // Shortcut for formats:
            // register(Blot | Attributor, overwrite)
            this.register(`formats/${name}`, target, overwrite);
            else Object.keys(target).forEach((key)=>{
                this.register(key, target[key], overwrite);
            });
        } else {
            const path = arguments.length <= 0 ? undefined : arguments[0];
            const target = arguments.length <= 1 ? undefined : arguments[1];
            const overwrite = !!(arguments.length <= 2 ? undefined : arguments[2]);
            if (this.imports[path] != null && !overwrite) $3fe90493bdbac5e1$var$debug.warn(`Overwriting ${path} with`, target);
            this.imports[path] = target;
            if ((path.startsWith('blots/') || path.startsWith('formats/')) && target && typeof target !== 'boolean' && target.blotName !== 'abstract') $3fe90493bdbac5e1$export$bc58ce2776ecdb6f.register(target);
            if (typeof target.register === 'function') target.register($3fe90493bdbac5e1$export$bc58ce2776ecdb6f);
        }
    }
    constructor(container){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.options = $3fe90493bdbac5e1$export$72ab7189806b6df5(container, options);
        this.container = this.options.container;
        if (this.container == null) {
            $3fe90493bdbac5e1$var$debug.error('Invalid Quill container', container);
            return;
        }
        if (this.options.debug) $3fe90493bdbac5e1$export$2e2bcd8739ae039.debug(this.options.debug);
        const html = this.container.innerHTML.trim();
        this.container.classList.add('ql-container');
        this.container.innerHTML = '';
        (0, $4apTj.default).set(this.container, this);
        this.root = this.addContainer('ql-editor');
        this.root.classList.add('ql-blank');
        this.emitter = new (0, $8AVGf.default)();
        const scrollBlotName = $eYvg2.ScrollBlot.blotName;
        const ScrollBlot = this.options.registry.query(scrollBlotName);
        if (!ScrollBlot || !('blotName' in ScrollBlot)) throw new Error(`Cannot initialize Quill without "${scrollBlotName}" blot`);
        this.scroll = new ScrollBlot(this.options.registry, this.root, {
            emitter: this.emitter
        });
        this.editor = new (0, $3sXwB.default)(this.scroll);
        this.selection = new (0, $9iwdq.default)(this.scroll, this.emitter);
        this.composition = new (0, $kYcHV.default)(this.scroll, this.emitter);
        this.theme = new this.options.theme(this, this.options); // eslint-disable-line new-cap
        this.keyboard = this.theme.addModule('keyboard');
        this.clipboard = this.theme.addModule('clipboard');
        this.history = this.theme.addModule('history');
        this.uploader = this.theme.addModule('uploader');
        this.theme.addModule('input');
        this.theme.addModule('uiNode');
        this.theme.init();
        this.emitter.on((0, $8AVGf.default).events.EDITOR_CHANGE, (type)=>{
            if (type === (0, $8AVGf.default).events.TEXT_CHANGE) this.root.classList.toggle('ql-blank', this.editor.isBlank());
        });
        this.emitter.on((0, $8AVGf.default).events.SCROLL_UPDATE, (source, mutations)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $3fe90493bdbac5e1$var$modify.call(this, ()=>this.editor.update(null, mutations, selectionInfo), source);
        });
        this.emitter.on((0, $8AVGf.default).events.SCROLL_EMBED_UPDATE, (blot, delta)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $3fe90493bdbac5e1$var$modify.call(this, ()=>{
                const change = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(blot.offset(this)).retain({
                    [blot.statics.blotName]: delta
                });
                return this.editor.update(change, [], selectionInfo);
            }, $3fe90493bdbac5e1$export$2e2bcd8739ae039.sources.USER);
        });
        if (html) {
            const contents = this.clipboard.convert({
                html: `${html}<p><br></p>`,
                text: '\n'
            });
            this.setContents(contents);
        }
        this.history.clear();
        if (this.options.placeholder) this.root.setAttribute('data-placeholder', this.options.placeholder);
        if (this.options.readOnly) this.disable();
        this.allowReadOnlyEdits = false;
    }
    addContainer(container) {
        let refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (typeof container === 'string') {
            const className = container;
            container = document.createElement('div');
            container.classList.add(className);
        }
        this.container.insertBefore(container, refNode);
        return container;
    }
    blur() {
        this.selection.setRange(null);
    }
    deleteText(index, length, source) {
        // @ts-expect-error
        [index, length, , source] = $3fe90493bdbac5e1$export$e336952123c0bccd(index, length, source);
        return $3fe90493bdbac5e1$var$modify.call(this, ()=>{
            return this.editor.deleteText(index, length);
        }, source, index, -1 * length);
    }
    disable() {
        this.enable(false);
    }
    editReadOnly(modifier) {
        this.allowReadOnlyEdits = true;
        const value = modifier();
        this.allowReadOnlyEdits = false;
        return value;
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.scroll.enable(enabled);
        this.container.classList.toggle('ql-disabled', !enabled);
    }
    focus() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.selection.focus();
        if (!options.preventScroll) this.scrollSelectionIntoView();
    }
    format(name, value) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $8AVGf.default).sources.API;
        return $3fe90493bdbac5e1$var$modify.call(this, ()=>{
            const range = this.getSelection(true);
            let change = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))();
            if (range == null) return change;
            if (this.scroll.query(name, $eYvg2.Scope.BLOCK)) change = this.editor.formatLine(range.index, range.length, {
                [name]: value
            });
            else if (range.length === 0) {
                this.selection.format(name, value);
                return change;
            } else change = this.editor.formatText(range.index, range.length, {
                [name]: value
            });
            this.setSelection(range, (0, $8AVGf.default).sources.SILENT);
            return change;
        }, source);
    }
    formatLine(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $3fe90493bdbac5e1$export$e336952123c0bccd(index, length, // @ts-expect-error
        name, value, source);
        return $3fe90493bdbac5e1$var$modify.call(this, ()=>{
            return this.editor.formatLine(index, length, formats);
        }, source, index, 0);
    }
    formatText(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $3fe90493bdbac5e1$export$e336952123c0bccd(// @ts-expect-error
        index, length, name, value, source);
        return $3fe90493bdbac5e1$var$modify.call(this, ()=>{
            return this.editor.formatText(index, length, formats);
        }, source, index, 0);
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let bounds = null;
        if (typeof index === 'number') bounds = this.selection.getBounds(index, length);
        else bounds = this.selection.getBounds(index.index, index.length);
        if (!bounds) return null;
        const containerBounds = this.container.getBoundingClientRect();
        return {
            bottom: bounds.bottom - containerBounds.top,
            height: bounds.height,
            left: bounds.left - containerBounds.left,
            right: bounds.right - containerBounds.left,
            top: bounds.top - containerBounds.top,
            width: bounds.width
        };
    }
    getContents() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
        [index, length] = $3fe90493bdbac5e1$export$e336952123c0bccd(index, length);
        return this.editor.getContents(index, length);
    }
    getFormat() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (typeof index === 'number') return this.editor.getFormat(index, length);
        return this.editor.getFormat(index.index, index.length);
    }
    getIndex(blot) {
        return blot.offset(this.scroll);
    }
    getLength() {
        return this.scroll.length();
    }
    getLeaf(index) {
        return this.scroll.leaf(index);
    }
    getLine(index) {
        return this.scroll.line(index);
    }
    getLines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        if (typeof index !== 'number') return this.scroll.lines(index.index, index.length);
        return this.scroll.lines(index, length);
    }
    getModule(name) {
        return this.theme.modules[name];
    }
    getSelection() {
        let focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (focus) this.focus();
        this.update(); // Make sure we access getRange with editor in consistent state
        return this.selection.getRange()[0];
    }
    getSemanticHTML() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === 'number') length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $3fe90493bdbac5e1$export$e336952123c0bccd(index, length);
        return this.editor.getHTML(index, length);
    }
    getText() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === 'number') length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $3fe90493bdbac5e1$export$e336952123c0bccd(index, length);
        return this.editor.getText(index, length);
    }
    hasFocus() {
        return this.selection.hasFocus();
    }
    insertEmbed(index, embed, value) {
        let source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $3fe90493bdbac5e1$export$2e2bcd8739ae039.sources.API;
        return $3fe90493bdbac5e1$var$modify.call(this, ()=>{
            return this.editor.insertEmbed(index, embed, value);
        }, source, index);
    }
    insertText(index, text, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        // @ts-expect-error
        [index, , formats, source] = $3fe90493bdbac5e1$export$e336952123c0bccd(index, 0, name, value, source);
        return $3fe90493bdbac5e1$var$modify.call(this, ()=>{
            return this.editor.insertText(index, text, formats);
        }, source, index, text.length);
    }
    isEnabled() {
        return this.scroll.isEnabled();
    }
    off() {
        return this.emitter.off(...arguments);
    }
    on() {
        return this.emitter.on(...arguments);
    }
    once() {
        return this.emitter.once(...arguments);
    }
    removeFormat(index, length, source) {
        [index, length, , source] = $3fe90493bdbac5e1$export$e336952123c0bccd(index, length, source);
        return $3fe90493bdbac5e1$var$modify.call(this, ()=>{
            return this.editor.removeFormat(index, length);
        }, source, index);
    }
    scrollRectIntoView(rect) {
        (0, $cEKJW.default)(this.root, rect);
    }
    /**
   * @deprecated Use Quill#scrollSelectionIntoView() instead.
   */ scrollIntoView() {
        console.warn('Quill#scrollIntoView() has been deprecated and will be removed in the near future. Please use Quill#scrollSelectionIntoView() instead.');
        this.scrollSelectionIntoView();
    }
    /**
   * Scroll the current selection into the visible area.
   * If the selection is already visible, no scrolling will occur.
   */ scrollSelectionIntoView() {
        const range = this.selection.lastRange;
        const bounds = range && this.selection.getBounds(range.index, range.length);
        if (bounds) this.scrollRectIntoView(bounds);
    }
    setContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $8AVGf.default).sources.API;
        return $3fe90493bdbac5e1$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))(delta);
            const length = this.getLength();
            // Quill will set empty editor to \n
            const delete1 = this.editor.deleteText(0, length);
            const applied = this.editor.insertContents(0, delta);
            // Remove extra \n from empty editor initialization
            const delete2 = this.editor.deleteText(this.getLength() - 1, 1);
            return delete1.compose(applied).compose(delete2);
        }, source);
    }
    setSelection(index, length, source) {
        if (index == null) // @ts-expect-error https://github.com/microsoft/TypeScript/issues/22609
        this.selection.setRange(null, length || $3fe90493bdbac5e1$export$2e2bcd8739ae039.sources.API);
        else {
            // @ts-expect-error
            [index, length, , source] = $3fe90493bdbac5e1$export$e336952123c0bccd(index, length, source);
            this.selection.setRange(new (0, $9iwdq.Range)(Math.max(0, index), length), source);
            if (source !== (0, $8AVGf.default).sources.SILENT) this.scrollSelectionIntoView();
        }
    }
    setText(text) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $8AVGf.default).sources.API;
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().insert(text);
        return this.setContents(delta, source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $8AVGf.default).sources.USER;
        const change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
        this.selection.update(source);
        // TODO this is usually undefined
        return change;
    }
    updateContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $8AVGf.default).sources.API;
        return $3fe90493bdbac5e1$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))(delta);
            return this.editor.applyDelta(delta);
        }, source, true);
    }
}
function $3fe90493bdbac5e1$var$resolveSelector(selector) {
    return typeof selector === 'string' ? document.querySelector(selector) : selector;
}
function $3fe90493bdbac5e1$var$expandModuleConfig(config) {
    return Object.entries(config ?? {}).reduce((expanded, _ref)=>{
        let [key, value] = _ref;
        return {
            ...expanded,
            [key]: value === true ? {} : value
        };
    }, {});
}
function $3fe90493bdbac5e1$var$omitUndefinedValuesFromOptions(obj) {
    return Object.fromEntries(Object.entries(obj).filter((entry)=>entry[1] !== undefined));
}
function $3fe90493bdbac5e1$export$72ab7189806b6df5(containerOrSelector, options) {
    const container = $3fe90493bdbac5e1$var$resolveSelector(containerOrSelector);
    if (!container) throw new Error('Invalid Quill container');
    const shouldUseDefaultTheme = !options.theme || options.theme === $3fe90493bdbac5e1$export$2e2bcd8739ae039.DEFAULTS.theme;
    const theme = shouldUseDefaultTheme ? (0, $8rmjg.default) : $3fe90493bdbac5e1$export$2e2bcd8739ae039.import(`themes/${options.theme}`);
    if (!theme) throw new Error(`Invalid theme ${options.theme}. Did you register it?`);
    const { modules: quillModuleDefaults, ...quillDefaults } = $3fe90493bdbac5e1$export$2e2bcd8739ae039.DEFAULTS;
    const { modules: themeModuleDefaults, ...themeDefaults } = theme.DEFAULTS;
    let userModuleOptions = $3fe90493bdbac5e1$var$expandModuleConfig(options.modules);
    // Special case toolbar shorthand
    if (userModuleOptions != null && userModuleOptions.toolbar && userModuleOptions.toolbar.constructor !== Object) userModuleOptions = {
        ...userModuleOptions,
        toolbar: {
            container: userModuleOptions.toolbar
        }
    };
    const modules = (0, $3izSM.default)({}, $3fe90493bdbac5e1$var$expandModuleConfig(quillModuleDefaults), $3fe90493bdbac5e1$var$expandModuleConfig(themeModuleDefaults), userModuleOptions);
    const config = {
        ...quillDefaults,
        ...$3fe90493bdbac5e1$var$omitUndefinedValuesFromOptions(themeDefaults),
        ...$3fe90493bdbac5e1$var$omitUndefinedValuesFromOptions(options)
    };
    let registry = options.registry;
    if (registry) {
        if (options.formats) $3fe90493bdbac5e1$var$debug.warn('Ignoring "formats" option because "registry" is specified');
    } else registry = options.formats ? (0, $6Ef7U.default)(options.formats, config.registry, $3fe90493bdbac5e1$var$debug) : config.registry;
    return {
        ...config,
        registry: registry,
        container: container,
        theme: theme,
        modules: Object.entries(modules).reduce((modulesWithDefaults, _ref2)=>{
            let [name, value] = _ref2;
            if (!value) return modulesWithDefaults;
            const moduleClass = $3fe90493bdbac5e1$export$2e2bcd8739ae039.import(`modules/${name}`);
            if (moduleClass == null) {
                $3fe90493bdbac5e1$var$debug.error(`Cannot load ${name} module. Are you sure you registered it?`);
                return modulesWithDefaults;
            }
            return {
                ...modulesWithDefaults,
                // @ts-expect-error
                [name]: (0, $3izSM.default)({}, moduleClass.DEFAULTS || {}, value)
            };
        }, {}),
        bounds: $3fe90493bdbac5e1$var$resolveSelector(config.bounds)
    };
}
// Handle selection preservation and TEXT_CHANGE emission
// common to modification APIs
function $3fe90493bdbac5e1$var$modify(modifier, source, index, shift) {
    if (!this.isEnabled() && source === (0, $8AVGf.default).sources.USER && !this.allowReadOnlyEdits) return new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))();
    let range = index == null ? null : this.getSelection();
    const oldDelta = this.editor.delta;
    const change = modifier();
    if (range != null) {
        if (index === true) index = range.index; // eslint-disable-line prefer-destructuring
        if (shift == null) range = $3fe90493bdbac5e1$var$shiftRange(range, change, source);
        else if (shift !== 0) // @ts-expect-error index should always be number
        range = $3fe90493bdbac5e1$var$shiftRange(range, index, shift, source);
        this.setSelection(range, (0, $8AVGf.default).sources.SILENT);
    }
    if (change.length() > 0) {
        const args = [
            (0, $8AVGf.default).events.TEXT_CHANGE,
            change,
            oldDelta,
            source
        ];
        this.emitter.emit((0, $8AVGf.default).events.EDITOR_CHANGE, ...args);
        if (source !== (0, $8AVGf.default).sources.SILENT) this.emitter.emit(...args);
    }
    return change;
}
function $3fe90493bdbac5e1$export$e336952123c0bccd(index, length, name, value, source) {
    let formats = {};
    // @ts-expect-error
    if (typeof index.index === 'number' && typeof index.length === 'number') {
        // Allow for throwaway end (used by insertText/insertEmbed)
        if (typeof length !== 'number') {
            // @ts-expect-error
            source = value;
            value = name;
            name = length;
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        } else {
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        }
    } else if (typeof length !== 'number') {
        // @ts-expect-error
        source = value;
        value = name;
        name = length;
        length = 0;
    }
    // Handle format being object, two format name/value strings or excluded
    if (typeof name === 'object') {
        // @ts-expect-error Fix me later
        formats = name;
        // @ts-expect-error
        source = value;
    } else if (typeof name === 'string') {
        if (value != null) formats[name] = value;
        else // @ts-expect-error
        source = name;
    }
    // Handle optional source
    source = source || (0, $8AVGf.default).sources.API;
    // @ts-expect-error
    return [
        index,
        length,
        formats,
        source
    ];
}
function $3fe90493bdbac5e1$var$shiftRange(range, index, lengthOrSource, source) {
    const length = typeof lengthOrSource === 'number' ? lengthOrSource : 0;
    if (range == null) return null;
    let start;
    let end;
    // @ts-expect-error -- TODO: add a better type guard around `index`
    if (index && typeof index.transformPosition === 'function') [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>// @ts-expect-error -- TODO: add a better type guard around `index`
        index.transformPosition(pos, source !== (0, $8AVGf.default).sources.USER));
    else [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>{
        // @ts-expect-error -- TODO: add a better type guard around `index`
        if (pos < index || pos === index && source === (0, $8AVGf.default).sources.USER) return pos;
        if (length >= 0) return pos + length;
        // @ts-expect-error -- TODO: add a better type guard around `index`
        return Math.max(index, pos + length);
    });
    return new (0, $9iwdq.Range)(start, end - start);
}

});
parcelRegister("3izSM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $266ee3155ecc0aa5$export$2e2bcd8739ae039; });

var $5RtYP = parcelRequire("5RtYP");

var $a1O1s = parcelRequire("a1O1s");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $266ee3155ecc0aa5$var$merge = (0, $a1O1s.default)(function(object, source, srcIndex) {
    (0, $5RtYP.default)(object, source, srcIndex);
});
var $266ee3155ecc0aa5$export$2e2bcd8739ae039 = $266ee3155ecc0aa5$var$merge;

});
parcelRegister("5RtYP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4449286a0e0c16d5$export$2e2bcd8739ae039; });

var $hQ4rP = parcelRequire("hQ4rP");

var $gtmd9 = parcelRequire("gtmd9");

var $jw1OO = parcelRequire("jw1OO");

var $3D1Ft = parcelRequire("3D1Ft");

var $f8M9J = parcelRequire("f8M9J");

var $7nPCK = parcelRequire("7nPCK");

var $d6xEh = parcelRequire("d6xEh");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $4449286a0e0c16d5$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $jw1OO.default)(source, function(srcValue, key) {
        stack || (stack = new (0, $hQ4rP.default));
        if ((0, $f8M9J.default)(srcValue)) (0, $3D1Ft.default)(object, source, key, srcIndex, $4449286a0e0c16d5$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $d6xEh.default)(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $gtmd9.default)(object, key, newValue);
        }
    }, (0, $7nPCK.default));
}
var $4449286a0e0c16d5$export$2e2bcd8739ae039 = $4449286a0e0c16d5$var$baseMerge;

});
parcelRegister("gtmd9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfe09573be5bfa1b$export$2e2bcd8739ae039; });

var $kQYPe = parcelRequire("kQYPe");

var $cbK6Z = parcelRequire("cbK6Z");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $bfe09573be5bfa1b$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $cbK6Z.default)(object[key], value) || value === undefined && !(key in object)) (0, $kQYPe.default)(object, key, value);
}
var $bfe09573be5bfa1b$export$2e2bcd8739ae039 = $bfe09573be5bfa1b$var$assignMergeValue;

});

parcelRegister("jw1OO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3526a9a868e2538$export$2e2bcd8739ae039; });

var $1znNa = parcelRequire("1znNa");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $e3526a9a868e2538$var$baseFor = (0, $1znNa.default)();
var $e3526a9a868e2538$export$2e2bcd8739ae039 = $e3526a9a868e2538$var$baseFor;

});
parcelRegister("1znNa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $124b83ee0a9ea0b2$export$2e2bcd8739ae039; });
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $124b83ee0a9ea0b2$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $124b83ee0a9ea0b2$export$2e2bcd8739ae039 = $124b83ee0a9ea0b2$var$createBaseFor;

});


parcelRegister("3D1Ft", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a464ed0e7bf58be$export$2e2bcd8739ae039; });

var $gtmd9 = parcelRequire("gtmd9");

var $dGDoI = parcelRequire("dGDoI");

var $hyzHK = parcelRequire("hyzHK");

var $gaHa5 = parcelRequire("gaHa5");

var $7m9vs = parcelRequire("7m9vs");

var $iCVed = parcelRequire("iCVed");

var $kCwEw = parcelRequire("kCwEw");

var $fDUjM = parcelRequire("fDUjM");

var $emwkF = parcelRequire("emwkF");

var $9xi30 = parcelRequire("9xi30");

var $f8M9J = parcelRequire("f8M9J");

var $6bB6B = parcelRequire("6bB6B");

var $L67KT = parcelRequire("L67KT");

var $d6xEh = parcelRequire("d6xEh");

var $f4XgK = parcelRequire("f4XgK");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $2a464ed0e7bf58be$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $d6xEh.default)(object, key), srcValue = (0, $d6xEh.default)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $gtmd9.default)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $kCwEw.default)(srcValue), isBuff = !isArr && (0, $emwkF.default)(srcValue), isTyped = !isArr && !isBuff && (0, $L67KT.default)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $kCwEw.default)(objValue)) newValue = objValue;
            else if ((0, $fDUjM.default)(objValue)) newValue = (0, $gaHa5.default)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $dGDoI.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $hyzHK.default)(srcValue, true);
            } else newValue = [];
        } else if ((0, $6bB6B.default)(srcValue) || (0, $iCVed.default)(srcValue)) {
            newValue = objValue;
            if ((0, $iCVed.default)(objValue)) newValue = (0, $f4XgK.default)(objValue);
            else if (!(0, $f8M9J.default)(objValue) || (0, $9xi30.default)(objValue)) newValue = (0, $7m9vs.default)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    (0, $gtmd9.default)(object, key, newValue);
}
var $2a464ed0e7bf58be$export$2e2bcd8739ae039 = $2a464ed0e7bf58be$var$baseMergeDeep;

});
parcelRegister("fDUjM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6362f196567eac5$export$2e2bcd8739ae039; });

var $3BZtz = parcelRequire("3BZtz");

var $e3gLp = parcelRequire("e3gLp");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $b6362f196567eac5$var$isArrayLikeObject(value) {
    return (0, $e3gLp.default)(value) && (0, $3BZtz.default)(value);
}
var $b6362f196567eac5$export$2e2bcd8739ae039 = $b6362f196567eac5$var$isArrayLikeObject;

});

parcelRegister("d6xEh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98a5efd9ece3e6cb$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $98a5efd9ece3e6cb$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
var $98a5efd9ece3e6cb$export$2e2bcd8739ae039 = $98a5efd9ece3e6cb$var$safeGet;

});

parcelRegister("f4XgK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afa53459c3b81183$export$2e2bcd8739ae039; });

var $fvoVP = parcelRequire("fvoVP");

var $7nPCK = parcelRequire("7nPCK");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $afa53459c3b81183$var$toPlainObject(value) {
    return (0, $fvoVP.default)(value, (0, $7nPCK.default)(value));
}
var $afa53459c3b81183$export$2e2bcd8739ae039 = $afa53459c3b81183$var$toPlainObject;

});



parcelRegister("a1O1s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74d0ccd1ceaa824e$export$2e2bcd8739ae039; });

var $hi0tp = parcelRequire("hi0tp");

var $kJW4R = parcelRequire("kJW4R");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $74d0ccd1ceaa824e$var$createAssigner(assigner) {
    return (0, $hi0tp.default)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && (0, $kJW4R.default)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $74d0ccd1ceaa824e$export$2e2bcd8739ae039 = $74d0ccd1ceaa824e$var$createAssigner;

});
parcelRegister("hi0tp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9647c16c90726b4$export$2e2bcd8739ae039; });

var $aXLjm = parcelRequire("aXLjm");

var $79mOn = parcelRequire("79mOn");

var $aZe4M = parcelRequire("aZe4M");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $c9647c16c90726b4$var$baseRest(func, start) {
    return (0, $aZe4M.default)((0, $79mOn.default)(func, start, (0, $aXLjm.default)), func + '');
}
var $c9647c16c90726b4$export$2e2bcd8739ae039 = $c9647c16c90726b4$var$baseRest;

});
parcelRegister("aXLjm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fb41d17e0611cef$export$2e2bcd8739ae039; });
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $7fb41d17e0611cef$var$identity(value) {
    return value;
}
var $7fb41d17e0611cef$export$2e2bcd8739ae039 = $7fb41d17e0611cef$var$identity;

});

parcelRegister("79mOn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $534b11940afda0a8$export$2e2bcd8739ae039; });

var $av7Vx = parcelRequire("av7Vx");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $534b11940afda0a8$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $534b11940afda0a8$var$overRest(func, start, transform) {
    start = $534b11940afda0a8$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $534b11940afda0a8$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $av7Vx.default)(func, this, otherArgs);
    };
}
var $534b11940afda0a8$export$2e2bcd8739ae039 = $534b11940afda0a8$var$overRest;

});
parcelRegister("av7Vx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a52f2c994100a81$export$2e2bcd8739ae039; });
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $7a52f2c994100a81$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $7a52f2c994100a81$export$2e2bcd8739ae039 = $7a52f2c994100a81$var$apply;

});


parcelRegister("aZe4M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ffa851eda99fe2b$export$2e2bcd8739ae039; });

var $bP6vU = parcelRequire("bP6vU");

var $12bEK = parcelRequire("12bEK");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $7ffa851eda99fe2b$var$setToString = (0, $12bEK.default)((0, $bP6vU.default));
var $7ffa851eda99fe2b$export$2e2bcd8739ae039 = $7ffa851eda99fe2b$var$setToString;

});
parcelRegister("bP6vU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89b9829e311e943b$export$2e2bcd8739ae039; });

var $c6VfN = parcelRequire("c6VfN");

var $hhHuk = parcelRequire("hhHuk");

var $aXLjm = parcelRequire("aXLjm");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $89b9829e311e943b$var$baseSetToString = !(0, $hhHuk.default) ? (0, $aXLjm.default) : function(func, string) {
    return (0, $hhHuk.default)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, $c6VfN.default)(string),
        'writable': true
    });
};
var $89b9829e311e943b$export$2e2bcd8739ae039 = $89b9829e311e943b$var$baseSetToString;

});
parcelRegister("c6VfN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d1274f916e5f3d7$export$2e2bcd8739ae039; });
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $8d1274f916e5f3d7$var$constant(value) {
    return function() {
        return value;
    };
}
var $8d1274f916e5f3d7$export$2e2bcd8739ae039 = $8d1274f916e5f3d7$var$constant;

});


parcelRegister("12bEK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c0f050704c9fe04$export$2e2bcd8739ae039; });
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $0c0f050704c9fe04$var$HOT_COUNT = 800, $0c0f050704c9fe04$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0c0f050704c9fe04$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $0c0f050704c9fe04$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $0c0f050704c9fe04$var$nativeNow(), remaining = $0c0f050704c9fe04$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $0c0f050704c9fe04$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $0c0f050704c9fe04$export$2e2bcd8739ae039 = $0c0f050704c9fe04$var$shortOut;

});



parcelRegister("kJW4R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1950f97edf0f814$export$2e2bcd8739ae039; });

var $cbK6Z = parcelRequire("cbK6Z");

var $3BZtz = parcelRequire("3BZtz");

var $3H65O = parcelRequire("3H65O");

var $f8M9J = parcelRequire("f8M9J");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $f1950f97edf0f814$var$isIterateeCall(value, index, object) {
    if (!(0, $f8M9J.default)(object)) return false;
    var type = typeof index;
    if (type == 'number' ? (0, $3BZtz.default)(object) && (0, $3H65O.default)(index, object.length) : type == 'string' && index in object) return (0, $cbK6Z.default)(object[index], value);
    return false;
}
var $f1950f97edf0f814$export$2e2bcd8739ae039 = $f1950f97edf0f814$var$isIterateeCall;

});



parcelRegister("eYvg2", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $ae6eea6b2cc3a579$export$775b6bb06e53a214; });
$parcel$export(module.exports, "Attributor", function () { return $ae6eea6b2cc3a579$export$217610c4183502d0; });
$parcel$export(module.exports, "Registry", function () { return $ae6eea6b2cc3a579$export$4d9facee29974f3; });
$parcel$export(module.exports, "ClassAttributor", function () { return $ae6eea6b2cc3a579$export$651d45509677cf07; });
$parcel$export(module.exports, "StyleAttributor", function () { return $ae6eea6b2cc3a579$export$7c8099bbfe87b94d; });
$parcel$export(module.exports, "AttributorStore", function () { return $ae6eea6b2cc3a579$export$68ad86ab95e8de42; });
$parcel$export(module.exports, "LeafBlot", function () { return $ae6eea6b2cc3a579$export$7420b9c542181544; });
$parcel$export(module.exports, "ParentBlot", function () { return $ae6eea6b2cc3a579$export$e43113f0aad76fe; });
$parcel$export(module.exports, "InlineBlot", function () { return $ae6eea6b2cc3a579$export$f67a34bc25a7a861; });
$parcel$export(module.exports, "BlockBlot", function () { return $ae6eea6b2cc3a579$export$4f7f03641f7bfc8c; });
$parcel$export(module.exports, "ContainerBlot", function () { return $ae6eea6b2cc3a579$export$c898d510319704c0; });
$parcel$export(module.exports, "EmbedBlot", function () { return $ae6eea6b2cc3a579$export$297a1fa96f55f00f; });
$parcel$export(module.exports, "ScrollBlot", function () { return $ae6eea6b2cc3a579$export$7175329dad7a46f1; });
$parcel$export(module.exports, "TextBlot", function () { return $ae6eea6b2cc3a579$export$10ac0c5716409de6; });
var $ae6eea6b2cc3a579$export$775b6bb06e53a214 = /* @__PURE__ */ ((Scope2)=>(Scope2[Scope2.TYPE = 3] = "TYPE", Scope2[Scope2.LEVEL = 12] = "LEVEL", Scope2[Scope2.ATTRIBUTE = 13] = "ATTRIBUTE", Scope2[Scope2.BLOT = 14] = "BLOT", Scope2[Scope2.INLINE = 7] = "INLINE", Scope2[Scope2.BLOCK = 11] = "BLOCK", Scope2[Scope2.BLOCK_BLOT = 10] = "BLOCK_BLOT", Scope2[Scope2.INLINE_BLOT = 6] = "INLINE_BLOT", Scope2[Scope2.BLOCK_ATTRIBUTE = 9] = "BLOCK_ATTRIBUTE", Scope2[Scope2.INLINE_ATTRIBUTE = 5] = "INLINE_ATTRIBUTE", Scope2[Scope2.ANY = 15] = "ANY", Scope2))($ae6eea6b2cc3a579$export$775b6bb06e53a214 || {});
class $ae6eea6b2cc3a579$export$217610c4183502d0 {
    constructor(attrName, keyName, options = {}){
        this.attrName = attrName, this.keyName = keyName;
        const attributeBit = $ae6eea6b2cc3a579$export$775b6bb06e53a214.TYPE & $ae6eea6b2cc3a579$export$775b6bb06e53a214.ATTRIBUTE;
        this.scope = options.scope != null ? // Ignore type bits, force attribute bit
        options.scope & $ae6eea6b2cc3a579$export$775b6bb06e53a214.LEVEL | attributeBit : $ae6eea6b2cc3a579$export$775b6bb06e53a214.ATTRIBUTE, options.whitelist != null && (this.whitelist = options.whitelist);
    }
    static keys(node) {
        return Array.from(node.attributes).map((item)=>item.name);
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.setAttribute(this.keyName, value), !0) : !1;
    }
    canAdd(_node, value) {
        return this.whitelist == null ? !0 : typeof value == "string" ? this.whitelist.indexOf(value.replace(/["']/g, "")) > -1 : this.whitelist.indexOf(value) > -1;
    }
    remove(node) {
        node.removeAttribute(this.keyName);
    }
    value(node) {
        const value = node.getAttribute(this.keyName);
        return this.canAdd(node, value) && value ? value : "";
    }
}
class $ae6eea6b2cc3a579$var$ParchmentError extends Error {
    constructor(message){
        message = "[Parchment] " + message, super(message), this.message = message, this.name = this.constructor.name;
    }
}
const $ae6eea6b2cc3a579$var$_Registry = class _Registry {
    constructor(){
        this.attributes = {}, this.classes = {}, this.tags = {}, this.types = {};
    }
    static find(node, bubble = !1) {
        if (node == null) return null;
        if (this.blots.has(node)) return this.blots.get(node) || null;
        if (bubble) {
            let parentNode = null;
            try {
                parentNode = node.parentNode;
            } catch  {
                return null;
            }
            return this.find(parentNode, bubble);
        }
        return null;
    }
    create(scroll, input, value) {
        const match2 = this.query(input);
        if (match2 == null) throw new $ae6eea6b2cc3a579$var$ParchmentError(`Unable to create ${input} blot`);
        const blotClass = match2, node = // @ts-expect-error Fix me later
        input instanceof Node || input.nodeType === Node.TEXT_NODE ? input : blotClass.create(value), blot = new blotClass(scroll, node, value);
        return _Registry.blots.set(blot.domNode, blot), blot;
    }
    find(node, bubble = !1) {
        return _Registry.find(node, bubble);
    }
    query(query, scope = $ae6eea6b2cc3a579$export$775b6bb06e53a214.ANY) {
        let match2;
        return typeof query == "string" ? match2 = this.types[query] || this.attributes[query] : query instanceof Text || query.nodeType === Node.TEXT_NODE ? match2 = this.types.text : typeof query == "number" ? query & $ae6eea6b2cc3a579$export$775b6bb06e53a214.LEVEL & $ae6eea6b2cc3a579$export$775b6bb06e53a214.BLOCK ? match2 = this.types.block : query & $ae6eea6b2cc3a579$export$775b6bb06e53a214.LEVEL & $ae6eea6b2cc3a579$export$775b6bb06e53a214.INLINE && (match2 = this.types.inline) : query instanceof Element && ((query.getAttribute("class") || "").split(/\s+/).some((name)=>(match2 = this.classes[name], !!match2)), match2 = match2 || this.tags[query.tagName]), match2 == null ? null : "scope" in match2 && scope & $ae6eea6b2cc3a579$export$775b6bb06e53a214.LEVEL & match2.scope && scope & $ae6eea6b2cc3a579$export$775b6bb06e53a214.TYPE & match2.scope ? match2 : null;
    }
    register(...definitions) {
        return definitions.map((definition)=>{
            const isBlot = "blotName" in definition, isAttr = "attrName" in definition;
            if (!isBlot && !isAttr) throw new $ae6eea6b2cc3a579$var$ParchmentError("Invalid definition");
            if (isBlot && definition.blotName === "abstract") throw new $ae6eea6b2cc3a579$var$ParchmentError("Cannot register abstract class");
            const key = isBlot ? definition.blotName : isAttr ? definition.attrName : void 0;
            return this.types[key] = definition, isAttr ? typeof definition.keyName == "string" && (this.attributes[definition.keyName] = definition) : isBlot && (definition.className && (this.classes[definition.className] = definition), definition.tagName && (Array.isArray(definition.tagName) ? definition.tagName = definition.tagName.map((tagName)=>tagName.toUpperCase()) : definition.tagName = definition.tagName.toUpperCase(), (Array.isArray(definition.tagName) ? definition.tagName : [
                definition.tagName
            ]).forEach((tag)=>{
                (this.tags[tag] == null || definition.className == null) && (this.tags[tag] = definition);
            }))), definition;
        });
    }
};
$ae6eea6b2cc3a579$var$_Registry.blots = /* @__PURE__ */ new WeakMap();
let $ae6eea6b2cc3a579$export$4d9facee29974f3 = $ae6eea6b2cc3a579$var$_Registry;
function $ae6eea6b2cc3a579$var$match(node, prefix) {
    return (node.getAttribute("class") || "").split(/\s+/).filter((name)=>name.indexOf(`${prefix}-`) === 0);
}
class $ae6eea6b2cc3a579$var$ClassAttributor extends $ae6eea6b2cc3a579$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("class") || "").split(/\s+/).map((name)=>name.split("-").slice(0, -1).join("-"));
    }
    add(node, value) {
        return this.canAdd(node, value) ? (this.remove(node), node.classList.add(`${this.keyName}-${value}`), !0) : !1;
    }
    remove(node) {
        $ae6eea6b2cc3a579$var$match(node, this.keyName).forEach((name)=>{
            node.classList.remove(name);
        }), node.classList.length === 0 && node.removeAttribute("class");
    }
    value(node) {
        const value = ($ae6eea6b2cc3a579$var$match(node, this.keyName)[0] || "").slice(this.keyName.length + 1);
        return this.canAdd(node, value) ? value : "";
    }
}
const $ae6eea6b2cc3a579$export$651d45509677cf07 = $ae6eea6b2cc3a579$var$ClassAttributor;
function $ae6eea6b2cc3a579$var$camelize(name) {
    const parts = name.split("-"), rest = parts.slice(1).map((part)=>part[0].toUpperCase() + part.slice(1)).join("");
    return parts[0] + rest;
}
class $ae6eea6b2cc3a579$var$StyleAttributor extends $ae6eea6b2cc3a579$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("style") || "").split(";").map((value)=>value.split(":")[0].trim());
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.style[$ae6eea6b2cc3a579$var$camelize(this.keyName)] = value, !0) : !1;
    }
    remove(node) {
        node.style[$ae6eea6b2cc3a579$var$camelize(this.keyName)] = "", node.getAttribute("style") || node.removeAttribute("style");
    }
    value(node) {
        const value = node.style[$ae6eea6b2cc3a579$var$camelize(this.keyName)];
        return this.canAdd(node, value) ? value : "";
    }
}
const $ae6eea6b2cc3a579$export$7c8099bbfe87b94d = $ae6eea6b2cc3a579$var$StyleAttributor;
class $ae6eea6b2cc3a579$var$AttributorStore {
    constructor(domNode){
        this.attributes = {}, this.domNode = domNode, this.build();
    }
    attribute(attribute, value) {
        value ? attribute.add(this.domNode, value) && (attribute.value(this.domNode) != null ? this.attributes[attribute.attrName] = attribute : delete this.attributes[attribute.attrName]) : (attribute.remove(this.domNode), delete this.attributes[attribute.attrName]);
    }
    build() {
        this.attributes = {};
        const blot = $ae6eea6b2cc3a579$export$4d9facee29974f3.find(this.domNode);
        if (blot == null) return;
        const attributes = $ae6eea6b2cc3a579$export$217610c4183502d0.keys(this.domNode), classes = $ae6eea6b2cc3a579$export$651d45509677cf07.keys(this.domNode), styles = $ae6eea6b2cc3a579$export$7c8099bbfe87b94d.keys(this.domNode);
        attributes.concat(classes).concat(styles).forEach((name)=>{
            const attr = blot.scroll.query(name, $ae6eea6b2cc3a579$export$775b6bb06e53a214.ATTRIBUTE);
            attr instanceof $ae6eea6b2cc3a579$export$217610c4183502d0 && (this.attributes[attr.attrName] = attr);
        });
    }
    copy(target) {
        Object.keys(this.attributes).forEach((key)=>{
            const value = this.attributes[key].value(this.domNode);
            target.format(key, value);
        });
    }
    move(target) {
        this.copy(target), Object.keys(this.attributes).forEach((key)=>{
            this.attributes[key].remove(this.domNode);
        }), this.attributes = {};
    }
    values() {
        return Object.keys(this.attributes).reduce((attributes, name)=>(attributes[name] = this.attributes[name].value(this.domNode), attributes), {});
    }
}
const $ae6eea6b2cc3a579$export$68ad86ab95e8de42 = $ae6eea6b2cc3a579$var$AttributorStore, $ae6eea6b2cc3a579$var$_ShadowBlot = class _ShadowBlot {
    constructor(scroll, domNode){
        this.scroll = scroll, this.domNode = domNode, $ae6eea6b2cc3a579$export$4d9facee29974f3.blots.set(domNode, this), this.prev = null, this.next = null;
    }
    static create(rawValue) {
        if (this.tagName == null) throw new $ae6eea6b2cc3a579$var$ParchmentError("Blot definition missing tagName");
        let node, value;
        return Array.isArray(this.tagName) ? (typeof rawValue == "string" ? (value = rawValue.toUpperCase(), parseInt(value, 10).toString() === value && (value = parseInt(value, 10))) : typeof rawValue == "number" && (value = rawValue), typeof value == "number" ? node = document.createElement(this.tagName[value - 1]) : value && this.tagName.indexOf(value) > -1 ? node = document.createElement(value) : node = document.createElement(this.tagName[0])) : node = document.createElement(this.tagName), this.className && node.classList.add(this.className), node;
    }
    // Hack for accessing inherited static methods
    get statics() {
        return this.constructor;
    }
    attach() {}
    clone() {
        const domNode = this.domNode.cloneNode(!1);
        return this.scroll.create(domNode);
    }
    detach() {
        this.parent != null && this.parent.removeChild(this), $ae6eea6b2cc3a579$export$4d9facee29974f3.blots.delete(this.domNode);
    }
    deleteAt(index, length) {
        this.isolate(index, length).remove();
    }
    formatAt(index, length, name, value) {
        const blot = this.isolate(index, length);
        if (this.scroll.query(name, $ae6eea6b2cc3a579$export$775b6bb06e53a214.BLOT) != null && value) blot.wrap(name, value);
        else if (this.scroll.query(name, $ae6eea6b2cc3a579$export$775b6bb06e53a214.ATTRIBUTE) != null) {
            const parent = this.scroll.create(this.statics.scope);
            blot.wrap(parent), parent.format(name, value);
        }
    }
    insertAt(index, value, def) {
        const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def), ref = this.split(index);
        this.parent.insertBefore(blot, ref || void 0);
    }
    isolate(index, length) {
        const target = this.split(index);
        if (target == null) throw new Error("Attempt to isolate at end");
        return target.split(length), target;
    }
    length() {
        return 1;
    }
    offset(root = this.parent) {
        return this.parent == null || this === root ? 0 : this.parent.children.offset(this) + this.parent.offset(root);
    }
    optimize(_context) {
        this.statics.requiredContainer && !(this.parent instanceof this.statics.requiredContainer) && this.wrap(this.statics.requiredContainer.blotName);
    }
    remove() {
        this.domNode.parentNode != null && this.domNode.parentNode.removeChild(this.domNode), this.detach();
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return this.parent != null && (this.parent.insertBefore(replacement, this.next || void 0), this.remove()), replacement;
    }
    split(index, _force) {
        return index === 0 ? this : this.next;
    }
    update(_mutations, _context) {}
    wrap(name, value) {
        const wrapper = typeof name == "string" ? this.scroll.create(name, value) : name;
        if (this.parent != null && this.parent.insertBefore(wrapper, this.next || void 0), typeof wrapper.appendChild != "function") throw new $ae6eea6b2cc3a579$var$ParchmentError(`Cannot wrap ${name}`);
        return wrapper.appendChild(this), wrapper;
    }
};
$ae6eea6b2cc3a579$var$_ShadowBlot.blotName = "abstract";
let $ae6eea6b2cc3a579$var$ShadowBlot = $ae6eea6b2cc3a579$var$_ShadowBlot;
const $ae6eea6b2cc3a579$var$_LeafBlot = class _LeafBlot extends $ae6eea6b2cc3a579$var$ShadowBlot {
    /**
   * Returns the value represented by domNode if it is this Blot's type
   * No checking that domNode can represent this Blot type is required so
   * applications needing it should check externally before calling.
   */ static value(_domNode) {
        return !0;
    }
    /**
   * Given location represented by node and offset from DOM Selection Range,
   * return index to that location.
   */ index(node, offset) {
        return this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY ? Math.min(offset, 1) : -1;
    }
    /**
   * Given index to location within blot, return node and offset representing
   * that location, consumable by DOM Selection Range
   */ position(index, _inclusive) {
        let offset = Array.from(this.parent.domNode.childNodes).indexOf(this.domNode);
        return index > 0 && (offset += 1), [
            this.parent.domNode,
            offset
        ];
    }
    /**
   * Return value represented by this blot
   * Should not change without interaction from API or
   * user change detectable by update()
   */ value() {
        return {
            [this.statics.blotName]: this.statics.value(this.domNode) || !0
        };
    }
};
$ae6eea6b2cc3a579$var$_LeafBlot.scope = $ae6eea6b2cc3a579$export$775b6bb06e53a214.INLINE_BLOT;
let $ae6eea6b2cc3a579$var$LeafBlot = $ae6eea6b2cc3a579$var$_LeafBlot;
const $ae6eea6b2cc3a579$export$7420b9c542181544 = $ae6eea6b2cc3a579$var$LeafBlot;
class $ae6eea6b2cc3a579$var$LinkedList {
    constructor(){
        this.head = null, this.tail = null, this.length = 0;
    }
    append(...nodes) {
        if (this.insertBefore(nodes[0], null), nodes.length > 1) {
            const rest = nodes.slice(1);
            this.append(...rest);
        }
    }
    at(index) {
        const next = this.iterator();
        let cur = next();
        for(; cur && index > 0;)index -= 1, cur = next();
        return cur;
    }
    contains(node) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            if (cur === node) return !0;
            cur = next();
        }
        return !1;
    }
    indexOf(node) {
        const next = this.iterator();
        let cur = next(), index = 0;
        for(; cur;){
            if (cur === node) return index;
            index += 1, cur = next();
        }
        return -1;
    }
    insertBefore(node, refNode) {
        node != null && (this.remove(node), node.next = refNode, refNode != null ? (node.prev = refNode.prev, refNode.prev != null && (refNode.prev.next = node), refNode.prev = node, refNode === this.head && (this.head = node)) : this.tail != null ? (this.tail.next = node, node.prev = this.tail, this.tail = node) : (node.prev = null, this.head = this.tail = node), this.length += 1);
    }
    offset(target) {
        let index = 0, cur = this.head;
        for(; cur != null;){
            if (cur === target) return index;
            index += cur.length(), cur = cur.next;
        }
        return -1;
    }
    remove(node) {
        this.contains(node) && (node.prev != null && (node.prev.next = node.next), node.next != null && (node.next.prev = node.prev), node === this.head && (this.head = node.next), node === this.tail && (this.tail = node.prev), this.length -= 1);
    }
    iterator(curNode = this.head) {
        return ()=>{
            const ret = curNode;
            return curNode != null && (curNode = curNode.next), ret;
        };
    }
    find(index, inclusive = !1) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            const length = cur.length();
            if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) return [
                cur,
                index
            ];
            index -= length, cur = next();
        }
        return [
            null,
            0
        ];
    }
    forEach(callback) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)callback(cur), cur = next();
    }
    forEachAt(index, length, callback) {
        if (length <= 0) return;
        const [startNode, offset] = this.find(index);
        let curIndex = index - offset;
        const next = this.iterator(startNode);
        let cur = next();
        for(; cur && curIndex < index + length;){
            const curLength = cur.length();
            index > curIndex ? callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index)) : callback(cur, 0, Math.min(curLength, index + length - curIndex)), curIndex += curLength, cur = next();
        }
    }
    map(callback) {
        return this.reduce((memo, cur)=>(memo.push(callback(cur)), memo), []);
    }
    reduce(callback, memo) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)memo = callback(memo, cur), cur = next();
        return memo;
    }
}
function $ae6eea6b2cc3a579$var$makeAttachedBlot(node, scroll) {
    const found = scroll.find(node);
    if (found) return found;
    try {
        return scroll.create(node);
    } catch  {
        const blot = scroll.create($ae6eea6b2cc3a579$export$775b6bb06e53a214.INLINE);
        return Array.from(node.childNodes).forEach((child)=>{
            blot.domNode.appendChild(child);
        }), node.parentNode && node.parentNode.replaceChild(blot.domNode, node), blot.attach(), blot;
    }
}
const $ae6eea6b2cc3a579$var$_ParentBlot = class _ParentBlot extends $ae6eea6b2cc3a579$var$ShadowBlot {
    constructor(scroll, domNode){
        super(scroll, domNode), this.uiNode = null, this.build();
    }
    appendChild(other) {
        this.insertBefore(other);
    }
    attach() {
        super.attach(), this.children.forEach((child)=>{
            child.attach();
        });
    }
    attachUI(node) {
        this.uiNode != null && this.uiNode.remove(), this.uiNode = node, _ParentBlot.uiClass && this.uiNode.classList.add(_ParentBlot.uiClass), this.uiNode.setAttribute("contenteditable", "false"), this.domNode.insertBefore(this.uiNode, this.domNode.firstChild);
    }
    /**
   * Called during construction, should fill its own children LinkedList.
   */ build() {
        this.children = new $ae6eea6b2cc3a579$var$LinkedList(), Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode).reverse().forEach((node)=>{
            try {
                const child = $ae6eea6b2cc3a579$var$makeAttachedBlot(node, this.scroll);
                this.insertBefore(child, this.children.head || void 0);
            } catch (err) {
                if (err instanceof $ae6eea6b2cc3a579$var$ParchmentError) return;
                throw err;
            }
        });
    }
    deleteAt(index, length) {
        if (index === 0 && length === this.length()) return this.remove();
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.deleteAt(offset, childLength);
        });
    }
    descendant(criteria, index = 0) {
        const [child, offset] = this.children.find(index);
        return criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria ? [
            child,
            offset
        ] : child instanceof _ParentBlot ? child.descendant(criteria, offset) : [
            null,
            -1
        ];
    }
    descendants(criteria, index = 0, length = Number.MAX_VALUE) {
        let descendants = [], lengthLeft = length;
        return this.children.forEachAt(index, length, (child, childIndex, childLength)=>{
            (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) && descendants.push(child), child instanceof _ParentBlot && (descendants = descendants.concat(child.descendants(criteria, childIndex, lengthLeft))), lengthLeft -= childLength;
        }), descendants;
    }
    detach() {
        this.children.forEach((child)=>{
            child.detach();
        }), super.detach();
    }
    enforceAllowedChildren() {
        let done = !1;
        this.children.forEach((child)=>{
            done || this.statics.allowedChildren.some((def)=>child instanceof def) || (child.statics.scope === $ae6eea6b2cc3a579$export$775b6bb06e53a214.BLOCK_BLOT ? (child.next != null && this.splitAfter(child), child.prev != null && this.splitAfter(child.prev), child.parent.unwrap(), done = !0) : child instanceof _ParentBlot ? child.unwrap() : child.remove());
        });
    }
    formatAt(index, length, name, value) {
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.formatAt(offset, childLength, name, value);
        });
    }
    insertAt(index, value, def) {
        const [child, offset] = this.children.find(index);
        if (child) child.insertAt(offset, value, def);
        else {
            const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def);
            this.appendChild(blot);
        }
    }
    insertBefore(childBlot, refBlot) {
        childBlot.parent != null && childBlot.parent.children.remove(childBlot);
        let refDomNode = null;
        this.children.insertBefore(childBlot, refBlot || null), childBlot.parent = this, refBlot != null && (refDomNode = refBlot.domNode), (this.domNode.parentNode !== childBlot.domNode || this.domNode.nextSibling !== refDomNode) && this.domNode.insertBefore(childBlot.domNode, refDomNode), childBlot.attach();
    }
    length() {
        return this.children.reduce((memo, child)=>memo + child.length(), 0);
    }
    moveChildren(targetParent, refNode) {
        this.children.forEach((child)=>{
            targetParent.insertBefore(child, refNode);
        });
    }
    optimize(context) {
        if (super.optimize(context), this.enforceAllowedChildren(), this.uiNode != null && this.uiNode !== this.domNode.firstChild && this.domNode.insertBefore(this.uiNode, this.domNode.firstChild), this.children.length === 0) {
            if (this.statics.defaultChild != null) {
                const child = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(child);
            } else this.remove();
        }
    }
    path(index, inclusive = !1) {
        const [child, offset] = this.children.find(index, inclusive), position = [
            [
                this,
                index
            ]
        ];
        return child instanceof _ParentBlot ? position.concat(child.path(offset, inclusive)) : (child != null && position.push([
            child,
            offset
        ]), position);
    }
    removeChild(child) {
        this.children.remove(child);
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return replacement instanceof _ParentBlot && this.moveChildren(replacement), super.replaceWith(replacement);
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.clone();
        return this.parent && this.parent.insertBefore(after, this.next || void 0), this.children.forEachAt(index, this.length(), (child, offset, _length)=>{
            const split = child.split(offset, force);
            split != null && after.appendChild(split);
        }), after;
    }
    splitAfter(child) {
        const after = this.clone();
        for(; child.next != null;)after.appendChild(child.next);
        return this.parent && this.parent.insertBefore(after, this.next || void 0), after;
    }
    unwrap() {
        this.parent && this.moveChildren(this.parent, this.next || void 0), this.remove();
    }
    update(mutations, _context) {
        const addedNodes = [], removedNodes = [];
        mutations.forEach((mutation)=>{
            mutation.target === this.domNode && mutation.type === "childList" && (addedNodes.push(...mutation.addedNodes), removedNodes.push(...mutation.removedNodes));
        }), removedNodes.forEach((node)=>{
            if (node.parentNode != null && // @ts-expect-error Fix me later
            node.tagName !== "IFRAME" && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return;
            const blot = this.scroll.find(node);
            blot != null && (blot.domNode.parentNode == null || blot.domNode.parentNode === this.domNode) && blot.detach();
        }), addedNodes.filter((node)=>node.parentNode === this.domNode && node !== this.uiNode).sort((a, b)=>a === b ? 0 : a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1).forEach((node)=>{
            let refBlot = null;
            node.nextSibling != null && (refBlot = this.scroll.find(node.nextSibling));
            const blot = $ae6eea6b2cc3a579$var$makeAttachedBlot(node, this.scroll);
            (blot.next !== refBlot || blot.next == null) && (blot.parent != null && blot.parent.removeChild(this), this.insertBefore(blot, refBlot || void 0));
        }), this.enforceAllowedChildren();
    }
};
$ae6eea6b2cc3a579$var$_ParentBlot.uiClass = "";
let $ae6eea6b2cc3a579$var$ParentBlot = $ae6eea6b2cc3a579$var$_ParentBlot;
const $ae6eea6b2cc3a579$export$e43113f0aad76fe = $ae6eea6b2cc3a579$var$ParentBlot;
function $ae6eea6b2cc3a579$var$isEqual(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) return !1;
    for(const prop in obj1)if (obj1[prop] !== obj2[prop]) return !1;
    return !0;
}
const $ae6eea6b2cc3a579$var$_InlineBlot = class _InlineBlot extends $ae6eea6b2cc3a579$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_InlineBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $ae6eea6b2cc3a579$export$68ad86ab95e8de42(this.domNode);
    }
    format(name, value) {
        if (name === this.statics.blotName && !value) this.children.forEach((child)=>{
            child instanceof _InlineBlot || (child = child.wrap(_InlineBlot.blotName, !0)), this.attributes.copy(child);
        }), this.unwrap();
        else {
            const format = this.scroll.query(name, $ae6eea6b2cc3a579$export$775b6bb06e53a214.INLINE);
            if (format == null) return;
            format instanceof $ae6eea6b2cc3a579$export$217610c4183502d0 ? this.attributes.attribute(format, value) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value);
        }
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.formats()[name] != null || this.scroll.query(name, $ae6eea6b2cc3a579$export$775b6bb06e53a214.ATTRIBUTE) ? this.isolate(index, length).format(name, value) : super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        const formats = this.formats();
        if (Object.keys(formats).length === 0) return this.unwrap();
        const next = this.next;
        next instanceof _InlineBlot && next.prev === this && $ae6eea6b2cc3a579$var$isEqual(formats, next.formats()) && (next.moveChildren(this), next.remove());
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
    wrap(name, value) {
        const wrapper = super.wrap(name, value);
        return wrapper instanceof _InlineBlot && this.attributes.move(wrapper), wrapper;
    }
};
$ae6eea6b2cc3a579$var$_InlineBlot.allowedChildren = [
    $ae6eea6b2cc3a579$var$_InlineBlot,
    $ae6eea6b2cc3a579$export$7420b9c542181544
], $ae6eea6b2cc3a579$var$_InlineBlot.blotName = "inline", $ae6eea6b2cc3a579$var$_InlineBlot.scope = $ae6eea6b2cc3a579$export$775b6bb06e53a214.INLINE_BLOT, $ae6eea6b2cc3a579$var$_InlineBlot.tagName = "SPAN";
let $ae6eea6b2cc3a579$var$InlineBlot = $ae6eea6b2cc3a579$var$_InlineBlot;
const $ae6eea6b2cc3a579$export$f67a34bc25a7a861 = $ae6eea6b2cc3a579$var$InlineBlot, $ae6eea6b2cc3a579$var$_BlockBlot = class _BlockBlot extends $ae6eea6b2cc3a579$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_BlockBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $ae6eea6b2cc3a579$export$68ad86ab95e8de42(this.domNode);
    }
    format(name, value) {
        const format = this.scroll.query(name, $ae6eea6b2cc3a579$export$775b6bb06e53a214.BLOCK);
        format != null && (format instanceof $ae6eea6b2cc3a579$export$217610c4183502d0 ? this.attributes.attribute(format, value) : name === this.statics.blotName && !value ? this.replaceWith(_BlockBlot.blotName) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value));
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.scroll.query(name, $ae6eea6b2cc3a579$export$775b6bb06e53a214.BLOCK) != null ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        if (def == null || this.scroll.query(value, $ae6eea6b2cc3a579$export$775b6bb06e53a214.INLINE) != null) super.insertAt(index, value, def);
        else {
            const after = this.split(index);
            if (after != null) {
                const blot = this.scroll.create(value, def);
                after.parent.insertBefore(blot, after);
            } else throw new Error("Attempt to insertAt after block boundaries");
        }
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
};
$ae6eea6b2cc3a579$var$_BlockBlot.blotName = "block", $ae6eea6b2cc3a579$var$_BlockBlot.scope = $ae6eea6b2cc3a579$export$775b6bb06e53a214.BLOCK_BLOT, $ae6eea6b2cc3a579$var$_BlockBlot.tagName = "P", $ae6eea6b2cc3a579$var$_BlockBlot.allowedChildren = [
    $ae6eea6b2cc3a579$export$f67a34bc25a7a861,
    $ae6eea6b2cc3a579$var$_BlockBlot,
    $ae6eea6b2cc3a579$export$7420b9c542181544
];
let $ae6eea6b2cc3a579$var$BlockBlot = $ae6eea6b2cc3a579$var$_BlockBlot;
const $ae6eea6b2cc3a579$export$4f7f03641f7bfc8c = $ae6eea6b2cc3a579$var$BlockBlot, $ae6eea6b2cc3a579$var$_ContainerBlot = class _ContainerBlot extends $ae6eea6b2cc3a579$export$e43113f0aad76fe {
    checkMerge() {
        return this.next !== null && this.next.statics.blotName === this.statics.blotName;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length), this.enforceAllowedChildren();
    }
    formatAt(index, length, name, value) {
        super.formatAt(index, length, name, value), this.enforceAllowedChildren();
    }
    insertAt(index, value, def) {
        super.insertAt(index, value, def), this.enforceAllowedChildren();
    }
    optimize(context) {
        super.optimize(context), this.children.length > 0 && this.next != null && this.checkMerge() && (this.next.moveChildren(this), this.next.remove());
    }
};
$ae6eea6b2cc3a579$var$_ContainerBlot.blotName = "container", $ae6eea6b2cc3a579$var$_ContainerBlot.scope = $ae6eea6b2cc3a579$export$775b6bb06e53a214.BLOCK_BLOT;
let $ae6eea6b2cc3a579$var$ContainerBlot = $ae6eea6b2cc3a579$var$_ContainerBlot;
const $ae6eea6b2cc3a579$export$c898d510319704c0 = $ae6eea6b2cc3a579$var$ContainerBlot;
class $ae6eea6b2cc3a579$var$EmbedBlot extends $ae6eea6b2cc3a579$export$7420b9c542181544 {
    static formats(_domNode, _scroll) {}
    format(name, value) {
        super.formatAt(0, this.length(), name, value);
    }
    formatAt(index, length, name, value) {
        index === 0 && length === this.length() ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    formats() {
        return this.statics.formats(this.domNode, this.scroll);
    }
}
const $ae6eea6b2cc3a579$export$297a1fa96f55f00f = $ae6eea6b2cc3a579$var$EmbedBlot, $ae6eea6b2cc3a579$var$OBSERVER_CONFIG = {
    attributes: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
}, $ae6eea6b2cc3a579$var$MAX_OPTIMIZE_ITERATIONS = 100, $ae6eea6b2cc3a579$var$_ScrollBlot = class _ScrollBlot extends $ae6eea6b2cc3a579$export$e43113f0aad76fe {
    constructor(registry, node){
        super(null, node), this.registry = registry, this.scroll = this, this.build(), this.observer = new MutationObserver((mutations)=>{
            this.update(mutations);
        }), this.observer.observe(this.domNode, $ae6eea6b2cc3a579$var$OBSERVER_CONFIG), this.attach();
    }
    create(input, value) {
        return this.registry.create(this, input, value);
    }
    find(node, bubble = !1) {
        const blot = this.registry.find(node, bubble);
        return blot ? blot.scroll === this ? blot : bubble ? this.find(blot.scroll.domNode.parentNode, !0) : null : null;
    }
    query(query, scope = $ae6eea6b2cc3a579$export$775b6bb06e53a214.ANY) {
        return this.registry.query(query, scope);
    }
    register(...definitions) {
        return this.registry.register(...definitions);
    }
    build() {
        this.scroll != null && super.build();
    }
    detach() {
        super.detach(), this.observer.disconnect();
    }
    deleteAt(index, length) {
        this.update(), index === 0 && length === this.length() ? this.children.forEach((child)=>{
            child.remove();
        }) : super.deleteAt(index, length);
    }
    formatAt(index, length, name, value) {
        this.update(), super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        this.update(), super.insertAt(index, value, def);
    }
    optimize(mutations = [], context = {}) {
        super.optimize(context);
        const mutationsMap = context.mutationsMap || /* @__PURE__ */ new WeakMap();
        let records = Array.from(this.observer.takeRecords());
        for(; records.length > 0;)mutations.push(records.pop());
        const mark = (blot, markParent = !0)=>{
            blot == null || blot === this || blot.domNode.parentNode != null && (mutationsMap.has(blot.domNode) || mutationsMap.set(blot.domNode, []), markParent && mark(blot.parent));
        }, optimize = (blot)=>{
            mutationsMap.has(blot.domNode) && (blot instanceof $ae6eea6b2cc3a579$export$e43113f0aad76fe && blot.children.forEach(optimize), mutationsMap.delete(blot.domNode), blot.optimize(context));
        };
        let remaining = mutations;
        for(let i = 0; remaining.length > 0; i += 1){
            if (i >= $ae6eea6b2cc3a579$var$MAX_OPTIMIZE_ITERATIONS) throw new Error("[Parchment] Maximum optimize iterations reached");
            for(remaining.forEach((mutation)=>{
                const blot = this.find(mutation.target, !0);
                blot != null && (blot.domNode === mutation.target && (mutation.type === "childList" ? (mark(this.find(mutation.previousSibling, !1)), Array.from(mutation.addedNodes).forEach((node)=>{
                    const child = this.find(node, !1);
                    mark(child, !1), child instanceof $ae6eea6b2cc3a579$export$e43113f0aad76fe && child.children.forEach((grandChild)=>{
                        mark(grandChild, !1);
                    });
                })) : mutation.type === "attributes" && mark(blot.prev)), mark(blot));
            }), this.children.forEach(optimize), remaining = Array.from(this.observer.takeRecords()), records = remaining.slice(); records.length > 0;)mutations.push(records.pop());
        }
    }
    update(mutations, context = {}) {
        mutations = mutations || this.observer.takeRecords();
        const mutationsMap = /* @__PURE__ */ new WeakMap();
        mutations.map((mutation)=>{
            const blot = this.find(mutation.target, !0);
            return blot == null ? null : mutationsMap.has(blot.domNode) ? (mutationsMap.get(blot.domNode).push(mutation), null) : (mutationsMap.set(blot.domNode, [
                mutation
            ]), blot);
        }).forEach((blot)=>{
            blot != null && blot !== this && mutationsMap.has(blot.domNode) && blot.update(mutationsMap.get(blot.domNode) || [], context);
        }), context.mutationsMap = mutationsMap, mutationsMap.has(this.domNode) && super.update(mutationsMap.get(this.domNode), context), this.optimize(mutations, context);
    }
};
$ae6eea6b2cc3a579$var$_ScrollBlot.blotName = "scroll", $ae6eea6b2cc3a579$var$_ScrollBlot.defaultChild = $ae6eea6b2cc3a579$export$4f7f03641f7bfc8c, $ae6eea6b2cc3a579$var$_ScrollBlot.allowedChildren = [
    $ae6eea6b2cc3a579$export$4f7f03641f7bfc8c,
    $ae6eea6b2cc3a579$export$c898d510319704c0
], $ae6eea6b2cc3a579$var$_ScrollBlot.scope = $ae6eea6b2cc3a579$export$775b6bb06e53a214.BLOCK_BLOT, $ae6eea6b2cc3a579$var$_ScrollBlot.tagName = "DIV";
let $ae6eea6b2cc3a579$var$ScrollBlot = $ae6eea6b2cc3a579$var$_ScrollBlot;
const $ae6eea6b2cc3a579$export$7175329dad7a46f1 = $ae6eea6b2cc3a579$var$ScrollBlot, $ae6eea6b2cc3a579$var$_TextBlot = class _TextBlot extends $ae6eea6b2cc3a579$export$7420b9c542181544 {
    static create(value) {
        return document.createTextNode(value);
    }
    static value(domNode) {
        return domNode.data;
    }
    constructor(scroll, node){
        super(scroll, node), this.text = this.statics.value(this.domNode);
    }
    deleteAt(index, length) {
        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
    }
    index(node, offset) {
        return this.domNode === node ? offset : -1;
    }
    insertAt(index, value, def) {
        def == null ? (this.text = this.text.slice(0, index) + value + this.text.slice(index), this.domNode.data = this.text) : super.insertAt(index, value, def);
    }
    length() {
        return this.text.length;
    }
    optimize(context) {
        super.optimize(context), this.text = this.statics.value(this.domNode), this.text.length === 0 ? this.remove() : this.next instanceof _TextBlot && this.next.prev === this && (this.insertAt(this.length(), this.next.value()), this.next.remove());
    }
    position(index, _inclusive = !1) {
        return [
            this.domNode,
            index
        ];
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.scroll.create(this.domNode.splitText(index));
        return this.parent.insertBefore(after, this.next || void 0), this.text = this.statics.value(this.domNode), after;
    }
    update(mutations, _context) {
        mutations.some((mutation)=>mutation.type === "characterData" && mutation.target === this.domNode) && (this.text = this.statics.value(this.domNode));
    }
    value() {
        return this.text;
    }
};
$ae6eea6b2cc3a579$var$_TextBlot.blotName = "text", $ae6eea6b2cc3a579$var$_TextBlot.scope = $ae6eea6b2cc3a579$export$775b6bb06e53a214.INLINE_BLOT;
let $ae6eea6b2cc3a579$var$TextBlot = $ae6eea6b2cc3a579$var$_TextBlot;
const $ae6eea6b2cc3a579$export$10ac0c5716409de6 = $ae6eea6b2cc3a579$var$TextBlot;

});

parcelRegister("kHwOs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AttributeMap = module.exports.OpIterator = module.exports.Op = void 0;

var $h8gkm = parcelRequire("h8gkm");

var $pATLF = parcelRequire("pATLF");

var $9vtdl = parcelRequire("9vtdl");

var $2ZZoh = parcelRequire("2ZZoh");
module.exports.AttributeMap = $2ZZoh.default;

var $1xkvs = parcelRequire("1xkvs");
module.exports.Op = $1xkvs.default;

var $8IQdg = parcelRequire("8IQdg");
module.exports.OpIterator = $8IQdg.default;
const $f12146bcbe874b33$var$NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
const $f12146bcbe874b33$var$getEmbedTypeAndData = (a, b)=>{
    if (typeof a !== 'object' || a === null) throw new Error(`cannot retain a ${typeof a}`);
    if (typeof b !== 'object' || b === null) throw new Error(`cannot retain a ${typeof b}`);
    const embedType = Object.keys(a)[0];
    if (!embedType || embedType !== Object.keys(b)[0]) throw new Error(`embed types not matched: ${embedType} != ${Object.keys(b)[0]}`);
    return [
        embedType,
        a[embedType],
        b[embedType]
    ];
};
class $f12146bcbe874b33$var$Delta {
    constructor(ops){
        // Assume we are given a well formed ops
        if (Array.isArray(ops)) this.ops = ops;
        else if (ops != null && Array.isArray(ops.ops)) this.ops = ops.ops;
        else this.ops = [];
    }
    static registerEmbed(embedType, handler) {
        this.handlers[embedType] = handler;
    }
    static unregisterEmbed(embedType) {
        delete this.handlers[embedType];
    }
    static getHandler(embedType) {
        const handler = this.handlers[embedType];
        if (!handler) throw new Error(`no handlers for embed type "${embedType}"`);
        return handler;
    }
    insert(arg, attributes) {
        const newOp = {};
        if (typeof arg === 'string' && arg.length === 0) return this;
        newOp.insert = arg;
        if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    delete(length) {
        if (length <= 0) return this;
        return this.push({
            delete: length
        });
    }
    retain(length, attributes) {
        if (typeof length === 'number' && length <= 0) return this;
        const newOp = {
            retain: length
        };
        if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    push(newOp) {
        let index = this.ops.length;
        let lastOp = this.ops[index - 1];
        newOp = $pATLF(newOp);
        if (typeof lastOp === 'object') {
            if (typeof newOp.delete === 'number' && typeof lastOp.delete === 'number') {
                this.ops[index - 1] = {
                    delete: lastOp.delete + newOp.delete
                };
                return this;
            }
            // Since it does not matter if we insert before or after deleting at the same index,
            // always prefer to insert first
            if (typeof lastOp.delete === 'number' && newOp.insert != null) {
                index -= 1;
                lastOp = this.ops[index - 1];
                if (typeof lastOp !== 'object') {
                    this.ops.unshift(newOp);
                    return this;
                }
            }
            if ($9vtdl(newOp.attributes, lastOp.attributes)) {
                if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
                    this.ops[index - 1] = {
                        insert: lastOp.insert + newOp.insert
                    };
                    if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
                    this.ops[index - 1] = {
                        retain: lastOp.retain + newOp.retain
                    };
                    if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                }
            }
        }
        if (index === this.ops.length) this.ops.push(newOp);
        else this.ops.splice(index, 0, newOp);
        return this;
    }
    chop() {
        const lastOp = this.ops[this.ops.length - 1];
        if (lastOp && typeof lastOp.retain === 'number' && !lastOp.attributes) this.ops.pop();
        return this;
    }
    filter(predicate) {
        return this.ops.filter(predicate);
    }
    forEach(predicate) {
        this.ops.forEach(predicate);
    }
    map(predicate) {
        return this.ops.map(predicate);
    }
    partition(predicate) {
        const passed = [];
        const failed = [];
        this.forEach((op)=>{
            const target = predicate(op) ? passed : failed;
            target.push(op);
        });
        return [
            passed,
            failed
        ];
    }
    reduce(predicate, initialValue) {
        return this.ops.reduce(predicate, initialValue);
    }
    changeLength() {
        return this.reduce((length, elem)=>{
            if (elem.insert) return length + $1xkvs.default.length(elem);
            else if (elem.delete) return length - elem.delete;
            return length;
        }, 0);
    }
    length() {
        return this.reduce((length, elem)=>{
            return length + $1xkvs.default.length(elem);
        }, 0);
    }
    slice(start = 0, end = Infinity) {
        const ops = [];
        const iter = new $8IQdg.default(this.ops);
        let index = 0;
        while(index < end && iter.hasNext()){
            let nextOp;
            if (index < start) nextOp = iter.next(start - index);
            else {
                nextOp = iter.next(end - index);
                ops.push(nextOp);
            }
            index += $1xkvs.default.length(nextOp);
        }
        return new $f12146bcbe874b33$var$Delta(ops);
    }
    compose(other) {
        const thisIter = new $8IQdg.default(this.ops);
        const otherIter = new $8IQdg.default(other.ops);
        const ops = [];
        const firstOther = otherIter.peek();
        if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
            let firstLeft = firstOther.retain;
            while(thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft){
                firstLeft -= thisIter.peekLength();
                ops.push(thisIter.next());
            }
            if (firstOther.retain - firstLeft > 0) otherIter.next(firstOther.retain - firstLeft);
        }
        const delta = new $f12146bcbe874b33$var$Delta(ops);
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
            else if (thisIter.peekType() === 'delete') delta.push(thisIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (otherOp.retain) {
                    const newOp = {};
                    if (typeof thisOp.retain === 'number') newOp.retain = typeof otherOp.retain === 'number' ? length : otherOp.retain;
                    else if (typeof otherOp.retain === 'number') {
                        if (thisOp.retain == null) newOp.insert = thisOp.insert;
                        else newOp.retain = thisOp.retain;
                    } else {
                        const action = thisOp.retain == null ? 'insert' : 'retain';
                        const [embedType, thisData, otherData] = $f12146bcbe874b33$var$getEmbedTypeAndData(thisOp[action], otherOp.retain);
                        const handler = $f12146bcbe874b33$var$Delta.getHandler(embedType);
                        newOp[action] = {
                            [embedType]: handler.compose(thisData, otherData, action === 'retain')
                        };
                    }
                    // Preserve null when composing with a retain, otherwise remove it for inserts
                    const attributes = $2ZZoh.default.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
                    if (attributes) newOp.attributes = attributes;
                    delta.push(newOp);
                    // Optimization if rest of other is just retain
                    if (!otherIter.hasNext() && $9vtdl(delta.ops[delta.ops.length - 1], newOp)) {
                        const rest = new $f12146bcbe874b33$var$Delta(thisIter.rest());
                        return delta.concat(rest).chop();
                    }
                // Other op should be delete, we could be an insert or retain
                // Insert + delete cancels out
                } else if (typeof otherOp.delete === 'number' && (typeof thisOp.retain === 'number' || typeof thisOp.retain === 'object' && thisOp.retain !== null)) delta.push(otherOp);
            }
        }
        return delta.chop();
    }
    concat(other) {
        const delta = new $f12146bcbe874b33$var$Delta(this.ops.slice());
        if (other.ops.length > 0) {
            delta.push(other.ops[0]);
            delta.ops = delta.ops.concat(other.ops.slice(1));
        }
        return delta;
    }
    diff(other, cursor) {
        if (this.ops === other.ops) return new $f12146bcbe874b33$var$Delta();
        const strings = [
            this,
            other
        ].map((delta)=>{
            return delta.map((op)=>{
                if (op.insert != null) return typeof op.insert === 'string' ? op.insert : $f12146bcbe874b33$var$NULL_CHARACTER;
                const prep = delta === other ? 'on' : 'with';
                throw new Error('diff() called ' + prep + ' non-document');
            }).join('');
        });
        const retDelta = new $f12146bcbe874b33$var$Delta();
        const diffResult = $h8gkm(strings[0], strings[1], cursor, true);
        const thisIter = new $8IQdg.default(this.ops);
        const otherIter = new $8IQdg.default(other.ops);
        diffResult.forEach((component)=>{
            let length = component[1].length;
            while(length > 0){
                let opLength = 0;
                switch(component[0]){
                    case $h8gkm.INSERT:
                        opLength = Math.min(otherIter.peekLength(), length);
                        retDelta.push(otherIter.next(opLength));
                        break;
                    case $h8gkm.DELETE:
                        opLength = Math.min(length, thisIter.peekLength());
                        thisIter.next(opLength);
                        retDelta.delete(opLength);
                        break;
                    case $h8gkm.EQUAL:
                        opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                        const thisOp = thisIter.next(opLength);
                        const otherOp = otherIter.next(opLength);
                        if ($9vtdl(thisOp.insert, otherOp.insert)) retDelta.retain(opLength, $2ZZoh.default.diff(thisOp.attributes, otherOp.attributes));
                        else retDelta.push(otherOp).delete(opLength);
                        break;
                }
                length -= opLength;
            }
        });
        return retDelta.chop();
    }
    eachLine(predicate, newline = '\n') {
        const iter = new $8IQdg.default(this.ops);
        let line = new $f12146bcbe874b33$var$Delta();
        let i = 0;
        while(iter.hasNext()){
            if (iter.peekType() !== 'insert') return;
            const thisOp = iter.peek();
            const start = $1xkvs.default.length(thisOp) - iter.peekLength();
            const index = typeof thisOp.insert === 'string' ? thisOp.insert.indexOf(newline, start) - start : -1;
            if (index < 0) line.push(iter.next());
            else if (index > 0) line.push(iter.next(index));
            else {
                if (predicate(line, iter.next(1).attributes || {}, i) === false) return;
                i += 1;
                line = new $f12146bcbe874b33$var$Delta();
            }
        }
        if (line.length() > 0) predicate(line, {}, i);
    }
    invert(base) {
        const inverted = new $f12146bcbe874b33$var$Delta();
        this.reduce((baseIndex, op)=>{
            if (op.insert) inverted.delete($1xkvs.default.length(op));
            else if (typeof op.retain === 'number' && op.attributes == null) {
                inverted.retain(op.retain);
                return baseIndex + op.retain;
            } else if (op.delete || typeof op.retain === 'number') {
                const length = op.delete || op.retain;
                const slice = base.slice(baseIndex, baseIndex + length);
                slice.forEach((baseOp)=>{
                    if (op.delete) inverted.push(baseOp);
                    else if (op.retain && op.attributes) inverted.retain($1xkvs.default.length(baseOp), $2ZZoh.default.invert(op.attributes, baseOp.attributes));
                });
                return baseIndex + length;
            } else if (typeof op.retain === 'object' && op.retain !== null) {
                const slice = base.slice(baseIndex, baseIndex + 1);
                const baseOp = new $8IQdg.default(slice.ops).next();
                const [embedType, opData, baseOpData] = $f12146bcbe874b33$var$getEmbedTypeAndData(op.retain, baseOp.insert);
                const handler = $f12146bcbe874b33$var$Delta.getHandler(embedType);
                inverted.retain({
                    [embedType]: handler.invert(opData, baseOpData)
                }, $2ZZoh.default.invert(op.attributes, baseOp.attributes));
                return baseIndex + 1;
            }
            return baseIndex;
        }, 0);
        return inverted.chop();
    }
    transform(arg, priority = false) {
        priority = !!priority;
        if (typeof arg === 'number') return this.transformPosition(arg, priority);
        const other = arg;
        const thisIter = new $8IQdg.default(this.ops);
        const otherIter = new $8IQdg.default(other.ops);
        const delta = new $f12146bcbe874b33$var$Delta();
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) delta.retain($1xkvs.default.length(thisIter.next()));
            else if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (thisOp.delete) continue;
                else if (otherOp.delete) delta.push(otherOp);
                else {
                    const thisData = thisOp.retain;
                    const otherData = otherOp.retain;
                    let transformedData = typeof otherData === 'object' && otherData !== null ? otherData : length;
                    if (typeof thisData === 'object' && thisData !== null && typeof otherData === 'object' && otherData !== null) {
                        const embedType = Object.keys(thisData)[0];
                        if (embedType === Object.keys(otherData)[0]) {
                            const handler = $f12146bcbe874b33$var$Delta.getHandler(embedType);
                            if (handler) transformedData = {
                                [embedType]: handler.transform(thisData[embedType], otherData[embedType], priority)
                            };
                        }
                    }
                    // We retain either their retain or insert
                    delta.retain(transformedData, $2ZZoh.default.transform(thisOp.attributes, otherOp.attributes, priority));
                }
            }
        }
        return delta.chop();
    }
    transformPosition(index, priority = false) {
        priority = !!priority;
        const thisIter = new $8IQdg.default(this.ops);
        let offset = 0;
        while(thisIter.hasNext() && offset <= index){
            const length = thisIter.peekLength();
            const nextType = thisIter.peekType();
            thisIter.next();
            if (nextType === 'delete') {
                index -= Math.min(length, index - offset);
                continue;
            } else if (nextType === 'insert' && (offset < index || !priority)) index += length;
            offset += length;
        }
        return index;
    }
}
$f12146bcbe874b33$var$Delta.Op = $1xkvs.default;
$f12146bcbe874b33$var$Delta.OpIterator = $8IQdg.default;
$f12146bcbe874b33$var$Delta.AttributeMap = $2ZZoh.default;
$f12146bcbe874b33$var$Delta.handlers = {};
module.exports.default = $f12146bcbe874b33$var$Delta;
module.exports = $f12146bcbe874b33$var$Delta;
module.exports.default = $f12146bcbe874b33$var$Delta;

});
parcelRegister("h8gkm", function(module, exports) {
/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */ var $c78fd950e528e75c$var$DIFF_DELETE = -1;
var $c78fd950e528e75c$var$DIFF_INSERT = 1;
var $c78fd950e528e75c$var$DIFF_EQUAL = 0;
/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int|Object} [cursor_pos] Edit position in text1 or object with more info
 * @param {boolean} [cleanup] Apply semantic cleanup before returning.
 * @return {Array} Array of diff tuples.
 */ function $c78fd950e528e75c$var$diff_main(text1, text2, cursor_pos, cleanup, _fix_unicode) {
    // Check for equality
    if (text1 === text2) {
        if (text1) return [
            [
                $c78fd950e528e75c$var$DIFF_EQUAL,
                text1
            ]
        ];
        return [];
    }
    if (cursor_pos != null) {
        var editdiff = $c78fd950e528e75c$var$find_cursor_edit_diff(text1, text2, cursor_pos);
        if (editdiff) return editdiff;
    }
    // Trim off common prefix (speedup).
    var commonlength = $c78fd950e528e75c$var$diff_commonPrefix(text1, text2);
    var commonprefix = text1.substring(0, commonlength);
    text1 = text1.substring(commonlength);
    text2 = text2.substring(commonlength);
    // Trim off common suffix (speedup).
    commonlength = $c78fd950e528e75c$var$diff_commonSuffix(text1, text2);
    var commonsuffix = text1.substring(text1.length - commonlength);
    text1 = text1.substring(0, text1.length - commonlength);
    text2 = text2.substring(0, text2.length - commonlength);
    // Compute the diff on the middle block.
    var diffs = $c78fd950e528e75c$var$diff_compute_(text1, text2);
    // Restore the prefix and suffix.
    if (commonprefix) diffs.unshift([
        $c78fd950e528e75c$var$DIFF_EQUAL,
        commonprefix
    ]);
    if (commonsuffix) diffs.push([
        $c78fd950e528e75c$var$DIFF_EQUAL,
        commonsuffix
    ]);
    $c78fd950e528e75c$var$diff_cleanupMerge(diffs, _fix_unicode);
    if (cleanup) $c78fd950e528e75c$var$diff_cleanupSemantic(diffs);
    return diffs;
}
/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */ function $c78fd950e528e75c$var$diff_compute_(text1, text2) {
    var diffs;
    if (!text1) // Just add some text (speedup).
    return [
        [
            $c78fd950e528e75c$var$DIFF_INSERT,
            text2
        ]
    ];
    if (!text2) // Just delete some text (speedup).
    return [
        [
            $c78fd950e528e75c$var$DIFF_DELETE,
            text1
        ]
    ];
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    var i = longtext.indexOf(shorttext);
    if (i !== -1) {
        // Shorter text is inside the longer text (speedup).
        diffs = [
            [
                $c78fd950e528e75c$var$DIFF_INSERT,
                longtext.substring(0, i)
            ],
            [
                $c78fd950e528e75c$var$DIFF_EQUAL,
                shorttext
            ],
            [
                $c78fd950e528e75c$var$DIFF_INSERT,
                longtext.substring(i + shorttext.length)
            ]
        ];
        // Swap insertions for deletions if diff is reversed.
        if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = $c78fd950e528e75c$var$DIFF_DELETE;
        return diffs;
    }
    if (shorttext.length === 1) // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [
        [
            $c78fd950e528e75c$var$DIFF_DELETE,
            text1
        ],
        [
            $c78fd950e528e75c$var$DIFF_INSERT,
            text2
        ]
    ];
    // Check to see if the problem can be split in two.
    var hm = $c78fd950e528e75c$var$diff_halfMatch_(text1, text2);
    if (hm) {
        // A half-match was found, sort out the return data.
        var text1_a = hm[0];
        var text1_b = hm[1];
        var text2_a = hm[2];
        var text2_b = hm[3];
        var mid_common = hm[4];
        // Send both pairs off for separate processing.
        var diffs_a = $c78fd950e528e75c$var$diff_main(text1_a, text2_a);
        var diffs_b = $c78fd950e528e75c$var$diff_main(text1_b, text2_b);
        // Merge the results.
        return diffs_a.concat([
            [
                $c78fd950e528e75c$var$DIFF_EQUAL,
                mid_common
            ]
        ], diffs_b);
    }
    return $c78fd950e528e75c$var$diff_bisect_(text1, text2);
}
/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */ function $c78fd950e528e75c$var$diff_bisect_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    var max_d = Math.ceil((text1_length + text2_length) / 2);
    var v_offset = max_d;
    var v_length = 2 * max_d;
    var v1 = new Array(v_length);
    var v2 = new Array(v_length);
    // Setting all elements to -1 is faster in Chrome & Firefox than mixing
    // integers and undefined.
    for(var x = 0; x < v_length; x++){
        v1[x] = -1;
        v2[x] = -1;
    }
    v1[v_offset + 1] = 0;
    v2[v_offset + 1] = 0;
    var delta = text1_length - text2_length;
    // If the total number of characters is odd, then the front path will collide
    // with the reverse path.
    var front = delta % 2 !== 0;
    // Offsets for start and end of k loop.
    // Prevents mapping of space beyond the grid.
    var k1start = 0;
    var k1end = 0;
    var k2start = 0;
    var k2end = 0;
    for(var d = 0; d < max_d; d++){
        // Walk the front path one step.
        for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
            var k1_offset = v_offset + k1;
            var x1;
            if (k1 === -d || k1 !== d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
            else x1 = v1[k1_offset - 1] + 1;
            var y1 = x1 - k1;
            while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) === text2.charAt(y1)){
                x1++;
                y1++;
            }
            v1[k1_offset] = x1;
            if (x1 > text1_length) // Ran off the right of the graph.
            k1end += 2;
            else if (y1 > text2_length) // Ran off the bottom of the graph.
            k1start += 2;
            else if (front) {
                var k2_offset = v_offset + delta - k1;
                if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] !== -1) {
                    // Mirror x2 onto top-left coordinate system.
                    var x2 = text1_length - v2[k2_offset];
                    if (x1 >= x2) // Overlap detected.
                    return $c78fd950e528e75c$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
        // Walk the reverse path one step.
        for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
            var k2_offset = v_offset + k2;
            var x2;
            if (k2 === -d || k2 !== d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
            else x2 = v2[k2_offset - 1] + 1;
            var y2 = x2 - k2;
            while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) === text2.charAt(text2_length - y2 - 1)){
                x2++;
                y2++;
            }
            v2[k2_offset] = x2;
            if (x2 > text1_length) // Ran off the left of the graph.
            k2end += 2;
            else if (y2 > text2_length) // Ran off the top of the graph.
            k2start += 2;
            else if (!front) {
                var k1_offset = v_offset + delta - k2;
                if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] !== -1) {
                    var x1 = v1[k1_offset];
                    var y1 = v_offset + x1 - k1_offset;
                    // Mirror x2 onto top-left coordinate system.
                    x2 = text1_length - x2;
                    if (x1 >= x2) // Overlap detected.
                    return $c78fd950e528e75c$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
    }
    // Diff took too long and hit the deadline or
    // number of diffs equals number of characters, no commonality at all.
    return [
        [
            $c78fd950e528e75c$var$DIFF_DELETE,
            text1
        ],
        [
            $c78fd950e528e75c$var$DIFF_INSERT,
            text2
        ]
    ];
}
/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */ function $c78fd950e528e75c$var$diff_bisectSplit_(text1, text2, x, y) {
    var text1a = text1.substring(0, x);
    var text2a = text2.substring(0, y);
    var text1b = text1.substring(x);
    var text2b = text2.substring(y);
    // Compute both diffs serially.
    var diffs = $c78fd950e528e75c$var$diff_main(text1a, text2a);
    var diffsb = $c78fd950e528e75c$var$diff_main(text1b, text2b);
    return diffs.concat(diffsb);
}
/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */ function $c78fd950e528e75c$var$diff_commonPrefix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.charAt(0) !== text2.charAt(0)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerstart = 0;
    while(pointermin < pointermid){
        if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
            pointermin = pointermid;
            pointerstart = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($c78fd950e528e75c$var$is_surrogate_pair_start(text1.charCodeAt(pointermid - 1))) pointermid--;
    return pointermid;
}
/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */ function $c78fd950e528e75c$var$diff_commonOverlap_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    // Eliminate the null case.
    if (text1_length == 0 || text2_length == 0) return 0;
    // Truncate the longer string.
    if (text1_length > text2_length) text1 = text1.substring(text1_length - text2_length);
    else if (text1_length < text2_length) text2 = text2.substring(0, text1_length);
    var text_length = Math.min(text1_length, text2_length);
    // Quick check for the worst case.
    if (text1 == text2) return text_length;
    // Start by looking for a single character match
    // and increase length until no match is found.
    // Performance analysis: http://neil.fraser.name/news/2010/11/04/
    var best = 0;
    var length = 1;
    while(true){
        var pattern = text1.substring(text_length - length);
        var found = text2.indexOf(pattern);
        if (found == -1) return best;
        length += found;
        if (found == 0 || text1.substring(text_length - length) == text2.substring(0, length)) {
            best = length;
            length++;
        }
    }
}
/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */ function $c78fd950e528e75c$var$diff_commonSuffix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.slice(-1) !== text2.slice(-1)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerend = 0;
    while(pointermin < pointermid){
        if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
            pointermin = pointermid;
            pointerend = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($c78fd950e528e75c$var$is_surrogate_pair_end(text1.charCodeAt(text1.length - pointermid))) pointermid--;
    return pointermid;
}
/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */ function $c78fd950e528e75c$var$diff_halfMatch_(text1, text2) {
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
    /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */ function diff_halfMatchI_(longtext, shorttext, i) {
        // Start with a 1/4 length substring at position i as a seed.
        var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
        var j = -1;
        var best_common = "";
        var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
        while((j = shorttext.indexOf(seed, j + 1)) !== -1){
            var prefixLength = $c78fd950e528e75c$var$diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
            var suffixLength = $c78fd950e528e75c$var$diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
            if (best_common.length < suffixLength + prefixLength) {
                best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                best_longtext_a = longtext.substring(0, i - suffixLength);
                best_longtext_b = longtext.substring(i + prefixLength);
                best_shorttext_a = shorttext.substring(0, j - suffixLength);
                best_shorttext_b = shorttext.substring(j + prefixLength);
            }
        }
        if (best_common.length * 2 >= longtext.length) return [
            best_longtext_a,
            best_longtext_b,
            best_shorttext_a,
            best_shorttext_b,
            best_common
        ];
        else return null;
    }
    // First check if the second quarter is the seed for a half-match.
    var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
    // Check again based on the third quarter.
    var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
    var hm;
    if (!hm1 && !hm2) return null;
    else if (!hm2) hm = hm1;
    else if (!hm1) hm = hm2;
    else // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
    // A half-match was found, sort out the return data.
    var text1_a, text1_b, text2_a, text2_b;
    if (text1.length > text2.length) {
        text1_a = hm[0];
        text1_b = hm[1];
        text2_a = hm[2];
        text2_b = hm[3];
    } else {
        text2_a = hm[0];
        text2_b = hm[1];
        text1_a = hm[2];
        text1_b = hm[3];
    }
    var mid_common = hm[4];
    return [
        text1_a,
        text1_b,
        text2_a,
        text2_b,
        mid_common
    ];
}
/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $c78fd950e528e75c$var$diff_cleanupSemantic(diffs) {
    var changes = false;
    var equalities = []; // Stack of indices where equalities are found.
    var equalitiesLength = 0; // Keeping our own length var is faster in JS.
    /** @type {?string} */ var lastequality = null;
    // Always equal to diffs[equalities[equalitiesLength - 1]][1]
    var pointer = 0; // Index of current position.
    // Number of characters that changed prior to the equality.
    var length_insertions1 = 0;
    var length_deletions1 = 0;
    // Number of characters that changed after the equality.
    var length_insertions2 = 0;
    var length_deletions2 = 0;
    while(pointer < diffs.length){
        if (diffs[pointer][0] == $c78fd950e528e75c$var$DIFF_EQUAL) {
            // Equality found.
            equalities[equalitiesLength++] = pointer;
            length_insertions1 = length_insertions2;
            length_deletions1 = length_deletions2;
            length_insertions2 = 0;
            length_deletions2 = 0;
            lastequality = diffs[pointer][1];
        } else {
            // An insertion or deletion.
            if (diffs[pointer][0] == $c78fd950e528e75c$var$DIFF_INSERT) length_insertions2 += diffs[pointer][1].length;
            else length_deletions2 += diffs[pointer][1].length;
            // Eliminate an equality that is smaller or equal to the edits on both
            // sides of it.
            if (lastequality && lastequality.length <= Math.max(length_insertions1, length_deletions1) && lastequality.length <= Math.max(length_insertions2, length_deletions2)) {
                // Duplicate record.
                diffs.splice(equalities[equalitiesLength - 1], 0, [
                    $c78fd950e528e75c$var$DIFF_DELETE,
                    lastequality
                ]);
                // Change second copy to insert.
                diffs[equalities[equalitiesLength - 1] + 1][0] = $c78fd950e528e75c$var$DIFF_INSERT;
                // Throw away the equality we just deleted.
                equalitiesLength--;
                // Throw away the previous equality (it needs to be reevaluated).
                equalitiesLength--;
                pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                length_insertions1 = 0; // Reset the counters.
                length_deletions1 = 0;
                length_insertions2 = 0;
                length_deletions2 = 0;
                lastequality = null;
                changes = true;
            }
        }
        pointer++;
    }
    // Normalize the diff.
    if (changes) $c78fd950e528e75c$var$diff_cleanupMerge(diffs);
    $c78fd950e528e75c$var$diff_cleanupSemanticLossless(diffs);
    // Find any overlaps between deletions and insertions.
    // e.g: <del>abcxxx</del><ins>xxxdef</ins>
    //   -> <del>abc</del>xxx<ins>def</ins>
    // e.g: <del>xxxabc</del><ins>defxxx</ins>
    //   -> <ins>def</ins>xxx<del>abc</del>
    // Only extract an overlap if it is as big as the edit ahead or behind it.
    pointer = 1;
    while(pointer < diffs.length){
        if (diffs[pointer - 1][0] == $c78fd950e528e75c$var$DIFF_DELETE && diffs[pointer][0] == $c78fd950e528e75c$var$DIFF_INSERT) {
            var deletion = diffs[pointer - 1][1];
            var insertion = diffs[pointer][1];
            var overlap_length1 = $c78fd950e528e75c$var$diff_commonOverlap_(deletion, insertion);
            var overlap_length2 = $c78fd950e528e75c$var$diff_commonOverlap_(insertion, deletion);
            if (overlap_length1 >= overlap_length2) {
                if (overlap_length1 >= deletion.length / 2 || overlap_length1 >= insertion.length / 2) {
                    // Overlap found.  Insert an equality and trim the surrounding edits.
                    diffs.splice(pointer, 0, [
                        $c78fd950e528e75c$var$DIFF_EQUAL,
                        insertion.substring(0, overlap_length1)
                    ]);
                    diffs[pointer - 1][1] = deletion.substring(0, deletion.length - overlap_length1);
                    diffs[pointer + 1][1] = insertion.substring(overlap_length1);
                    pointer++;
                }
            } else if (overlap_length2 >= deletion.length / 2 || overlap_length2 >= insertion.length / 2) {
                // Reverse overlap found.
                // Insert an equality and swap and trim the surrounding edits.
                diffs.splice(pointer, 0, [
                    $c78fd950e528e75c$var$DIFF_EQUAL,
                    deletion.substring(0, overlap_length2)
                ]);
                diffs[pointer - 1][0] = $c78fd950e528e75c$var$DIFF_INSERT;
                diffs[pointer - 1][1] = insertion.substring(0, insertion.length - overlap_length2);
                diffs[pointer + 1][0] = $c78fd950e528e75c$var$DIFF_DELETE;
                diffs[pointer + 1][1] = deletion.substring(overlap_length2);
                pointer++;
            }
            pointer++;
        }
        pointer++;
    }
}
var $c78fd950e528e75c$var$nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
var $c78fd950e528e75c$var$whitespaceRegex_ = /\s/;
var $c78fd950e528e75c$var$linebreakRegex_ = /[\r\n]/;
var $c78fd950e528e75c$var$blanklineEndRegex_ = /\n\r?\n$/;
var $c78fd950e528e75c$var$blanklineStartRegex_ = /^\r?\n\r?\n/;
/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $c78fd950e528e75c$var$diff_cleanupSemanticLossless(diffs) {
    /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */ function diff_cleanupSemanticScore_(one, two) {
        if (!one || !two) // Edges are the best.
        return 6;
        // Each port of this function behaves slightly differently due to
        // subtle differences in each language's definition of things like
        // 'whitespace'.  Since this function's purpose is largely cosmetic,
        // the choice has been made to use each language's native features
        // rather than force total conformity.
        var char1 = one.charAt(one.length - 1);
        var char2 = two.charAt(0);
        var nonAlphaNumeric1 = char1.match($c78fd950e528e75c$var$nonAlphaNumericRegex_);
        var nonAlphaNumeric2 = char2.match($c78fd950e528e75c$var$nonAlphaNumericRegex_);
        var whitespace1 = nonAlphaNumeric1 && char1.match($c78fd950e528e75c$var$whitespaceRegex_);
        var whitespace2 = nonAlphaNumeric2 && char2.match($c78fd950e528e75c$var$whitespaceRegex_);
        var lineBreak1 = whitespace1 && char1.match($c78fd950e528e75c$var$linebreakRegex_);
        var lineBreak2 = whitespace2 && char2.match($c78fd950e528e75c$var$linebreakRegex_);
        var blankLine1 = lineBreak1 && one.match($c78fd950e528e75c$var$blanklineEndRegex_);
        var blankLine2 = lineBreak2 && two.match($c78fd950e528e75c$var$blanklineStartRegex_);
        if (blankLine1 || blankLine2) // Five points for blank lines.
        return 5;
        else if (lineBreak1 || lineBreak2) // Four points for line breaks.
        return 4;
        else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) // Three points for end of sentences.
        return 3;
        else if (whitespace1 || whitespace2) // Two points for whitespace.
        return 2;
        else if (nonAlphaNumeric1 || nonAlphaNumeric2) // One point for non-alphanumeric.
        return 1;
        return 0;
    }
    var pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] == $c78fd950e528e75c$var$DIFF_EQUAL && diffs[pointer + 1][0] == $c78fd950e528e75c$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            var equality1 = diffs[pointer - 1][1];
            var edit = diffs[pointer][1];
            var equality2 = diffs[pointer + 1][1];
            // First, shift the edit as far left as possible.
            var commonOffset = $c78fd950e528e75c$var$diff_commonSuffix(equality1, edit);
            if (commonOffset) {
                var commonString = edit.substring(edit.length - commonOffset);
                equality1 = equality1.substring(0, equality1.length - commonOffset);
                edit = commonString + edit.substring(0, edit.length - commonOffset);
                equality2 = commonString + equality2;
            }
            // Second, step character by character right, looking for the best fit.
            var bestEquality1 = equality1;
            var bestEdit = edit;
            var bestEquality2 = equality2;
            var bestScore = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
            while(edit.charAt(0) === equality2.charAt(0)){
                equality1 += edit.charAt(0);
                edit = edit.substring(1) + equality2.charAt(0);
                equality2 = equality2.substring(1);
                var score = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
                // The >= encourages trailing rather than leading whitespace on edits.
                if (score >= bestScore) {
                    bestScore = score;
                    bestEquality1 = equality1;
                    bestEdit = edit;
                    bestEquality2 = equality2;
                }
            }
            if (diffs[pointer - 1][1] != bestEquality1) {
                // We have an improvement, save it back to the diff.
                if (bestEquality1) diffs[pointer - 1][1] = bestEquality1;
                else {
                    diffs.splice(pointer - 1, 1);
                    pointer--;
                }
                diffs[pointer][1] = bestEdit;
                if (bestEquality2) diffs[pointer + 1][1] = bestEquality2;
                else {
                    diffs.splice(pointer + 1, 1);
                    pointer--;
                }
            }
        }
        pointer++;
    }
}
/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 * @param {boolean} fix_unicode Whether to normalize to a unicode-correct diff
 */ function $c78fd950e528e75c$var$diff_cleanupMerge(diffs, fix_unicode) {
    diffs.push([
        $c78fd950e528e75c$var$DIFF_EQUAL,
        ""
    ]); // Add a dummy entry at the end.
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = "";
    var text_insert = "";
    var commonlength;
    while(pointer < diffs.length){
        if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
            diffs.splice(pointer, 1);
            continue;
        }
        switch(diffs[pointer][0]){
            case $c78fd950e528e75c$var$DIFF_INSERT:
                count_insert++;
                text_insert += diffs[pointer][1];
                pointer++;
                break;
            case $c78fd950e528e75c$var$DIFF_DELETE:
                count_delete++;
                text_delete += diffs[pointer][1];
                pointer++;
                break;
            case $c78fd950e528e75c$var$DIFF_EQUAL:
                var previous_equality = pointer - count_insert - count_delete - 1;
                if (fix_unicode) {
                    // prevent splitting of unicode surrogate pairs.  when fix_unicode is true,
                    // we assume that the old and new text in the diff are complete and correct
                    // unicode-encoded JS strings, but the tuple boundaries may fall between
                    // surrogate pairs.  we fix this by shaving off stray surrogates from the end
                    // of the previous equality and the beginning of this equality.  this may create
                    // empty equalities or a common prefix or suffix.  for example, if AB and AC are
                    // emojis, `[[0, 'A'], [-1, 'BA'], [0, 'C']]` would turn into deleting 'ABAC' and
                    // inserting 'AC', and then the common suffix 'AC' will be eliminated.  in this
                    // particular case, both equalities go away, we absorb any previous inequalities,
                    // and we keep scanning for the next equality before rewriting the tuples.
                    if (previous_equality >= 0 && $c78fd950e528e75c$var$ends_with_pair_start(diffs[previous_equality][1])) {
                        var stray = diffs[previous_equality][1].slice(-1);
                        diffs[previous_equality][1] = diffs[previous_equality][1].slice(0, -1);
                        text_delete = stray + text_delete;
                        text_insert = stray + text_insert;
                        if (!diffs[previous_equality][1]) {
                            // emptied out previous equality, so delete it and include previous delete/insert
                            diffs.splice(previous_equality, 1);
                            pointer--;
                            var k = previous_equality - 1;
                            if (diffs[k] && diffs[k][0] === $c78fd950e528e75c$var$DIFF_INSERT) {
                                count_insert++;
                                text_insert = diffs[k][1] + text_insert;
                                k--;
                            }
                            if (diffs[k] && diffs[k][0] === $c78fd950e528e75c$var$DIFF_DELETE) {
                                count_delete++;
                                text_delete = diffs[k][1] + text_delete;
                                k--;
                            }
                            previous_equality = k;
                        }
                    }
                    if ($c78fd950e528e75c$var$starts_with_pair_end(diffs[pointer][1])) {
                        var stray = diffs[pointer][1].charAt(0);
                        diffs[pointer][1] = diffs[pointer][1].slice(1);
                        text_delete += stray;
                        text_insert += stray;
                    }
                }
                if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
                    // for empty equality not at end, wait for next equality
                    diffs.splice(pointer, 1);
                    break;
                }
                if (text_delete.length > 0 || text_insert.length > 0) {
                    // note that diff_commonPrefix and diff_commonSuffix are unicode-aware
                    if (text_delete.length > 0 && text_insert.length > 0) {
                        // Factor out any common prefixes.
                        commonlength = $c78fd950e528e75c$var$diff_commonPrefix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            if (previous_equality >= 0) diffs[previous_equality][1] += text_insert.substring(0, commonlength);
                            else {
                                diffs.splice(0, 0, [
                                    $c78fd950e528e75c$var$DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)
                                ]);
                                pointer++;
                            }
                            text_insert = text_insert.substring(commonlength);
                            text_delete = text_delete.substring(commonlength);
                        }
                        // Factor out any common suffixes.
                        commonlength = $c78fd950e528e75c$var$diff_commonSuffix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                            text_insert = text_insert.substring(0, text_insert.length - commonlength);
                            text_delete = text_delete.substring(0, text_delete.length - commonlength);
                        }
                    }
                    // Delete the offending records and add the merged ones.
                    var n = count_insert + count_delete;
                    if (text_delete.length === 0 && text_insert.length === 0) {
                        diffs.splice(pointer - n, n);
                        pointer = pointer - n;
                    } else if (text_delete.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $c78fd950e528e75c$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 1;
                    } else if (text_insert.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $c78fd950e528e75c$var$DIFF_DELETE,
                            text_delete
                        ]);
                        pointer = pointer - n + 1;
                    } else {
                        diffs.splice(pointer - n, n, [
                            $c78fd950e528e75c$var$DIFF_DELETE,
                            text_delete
                        ], [
                            $c78fd950e528e75c$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 2;
                    }
                }
                if (pointer !== 0 && diffs[pointer - 1][0] === $c78fd950e528e75c$var$DIFF_EQUAL) {
                    // Merge this equality with the previous one.
                    diffs[pointer - 1][1] += diffs[pointer][1];
                    diffs.splice(pointer, 1);
                } else pointer++;
                count_insert = 0;
                count_delete = 0;
                text_delete = "";
                text_insert = "";
                break;
        }
    }
    if (diffs[diffs.length - 1][1] === "") diffs.pop(); // Remove the dummy entry at the end.
    // Second pass: look for single edits surrounded on both sides by equalities
    // which can be shifted sideways to eliminate an equality.
    // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
    var changes = false;
    pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] === $c78fd950e528e75c$var$DIFF_EQUAL && diffs[pointer + 1][0] === $c78fd950e528e75c$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) === diffs[pointer - 1][1]) {
                // Shift the edit over the previous equality.
                diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                diffs.splice(pointer - 1, 1);
                changes = true;
            } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                // Shift the edit over the next equality.
                diffs[pointer - 1][1] += diffs[pointer + 1][1];
                diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                diffs.splice(pointer + 1, 1);
                changes = true;
            }
        }
        pointer++;
    }
    // If shifts were made, the diff needs reordering and another shift sweep.
    if (changes) $c78fd950e528e75c$var$diff_cleanupMerge(diffs, fix_unicode);
}
function $c78fd950e528e75c$var$is_surrogate_pair_start(charCode) {
    return charCode >= 0xd800 && charCode <= 0xdbff;
}
function $c78fd950e528e75c$var$is_surrogate_pair_end(charCode) {
    return charCode >= 0xdc00 && charCode <= 0xdfff;
}
function $c78fd950e528e75c$var$starts_with_pair_end(str) {
    return $c78fd950e528e75c$var$is_surrogate_pair_end(str.charCodeAt(0));
}
function $c78fd950e528e75c$var$ends_with_pair_start(str) {
    return $c78fd950e528e75c$var$is_surrogate_pair_start(str.charCodeAt(str.length - 1));
}
function $c78fd950e528e75c$var$remove_empty_tuples(tuples) {
    var ret = [];
    for(var i = 0; i < tuples.length; i++)if (tuples[i][1].length > 0) ret.push(tuples[i]);
    return ret;
}
function $c78fd950e528e75c$var$make_edit_splice(before, oldMiddle, newMiddle, after) {
    if ($c78fd950e528e75c$var$ends_with_pair_start(before) || $c78fd950e528e75c$var$starts_with_pair_end(after)) return null;
    return $c78fd950e528e75c$var$remove_empty_tuples([
        [
            $c78fd950e528e75c$var$DIFF_EQUAL,
            before
        ],
        [
            $c78fd950e528e75c$var$DIFF_DELETE,
            oldMiddle
        ],
        [
            $c78fd950e528e75c$var$DIFF_INSERT,
            newMiddle
        ],
        [
            $c78fd950e528e75c$var$DIFF_EQUAL,
            after
        ]
    ]);
}
function $c78fd950e528e75c$var$find_cursor_edit_diff(oldText, newText, cursor_pos) {
    // note: this runs after equality check has ruled out exact equality
    var oldRange = typeof cursor_pos === "number" ? {
        index: cursor_pos,
        length: 0
    } : cursor_pos.oldRange;
    var newRange = typeof cursor_pos === "number" ? null : cursor_pos.newRange;
    // take into account the old and new selection to generate the best diff
    // possible for a text edit.  for example, a text change from "xxx" to "xx"
    // could be a delete or forwards-delete of any one of the x's, or the
    // result of selecting two of the x's and typing "x".
    var oldLength = oldText.length;
    var newLength = newText.length;
    if (oldRange.length === 0 && (newRange === null || newRange.length === 0)) {
        // see if we have an insert or delete before or after cursor
        var oldCursor = oldRange.index;
        var oldBefore = oldText.slice(0, oldCursor);
        var oldAfter = oldText.slice(oldCursor);
        var maybeNewCursor = newRange ? newRange.index : null;
        editBefore: {
            // is this an insert or delete right before oldCursor?
            var newCursor = oldCursor + newLength - oldLength;
            if (maybeNewCursor !== null && maybeNewCursor !== newCursor) break editBefore;
            if (newCursor < 0 || newCursor > newLength) break editBefore;
            var newBefore = newText.slice(0, newCursor);
            var newAfter = newText.slice(newCursor);
            if (newAfter !== oldAfter) break editBefore;
            var prefixLength = Math.min(oldCursor, newCursor);
            var oldPrefix = oldBefore.slice(0, prefixLength);
            var newPrefix = newBefore.slice(0, prefixLength);
            if (oldPrefix !== newPrefix) break editBefore;
            var oldMiddle = oldBefore.slice(prefixLength);
            var newMiddle = newBefore.slice(prefixLength);
            return $c78fd950e528e75c$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldAfter);
        }
        editAfter: {
            // is this an insert or delete right after oldCursor?
            if (maybeNewCursor !== null && maybeNewCursor !== oldCursor) break editAfter;
            var cursor = oldCursor;
            var newBefore = newText.slice(0, cursor);
            var newAfter = newText.slice(cursor);
            if (newBefore !== oldBefore) break editAfter;
            var suffixLength = Math.min(oldLength - cursor, newLength - cursor);
            var oldSuffix = oldAfter.slice(oldAfter.length - suffixLength);
            var newSuffix = newAfter.slice(newAfter.length - suffixLength);
            if (oldSuffix !== newSuffix) break editAfter;
            var oldMiddle = oldAfter.slice(0, oldAfter.length - suffixLength);
            var newMiddle = newAfter.slice(0, newAfter.length - suffixLength);
            return $c78fd950e528e75c$var$make_edit_splice(oldBefore, oldMiddle, newMiddle, oldSuffix);
        }
    }
    if (oldRange.length > 0 && newRange && newRange.length === 0) replaceRange: {
        // see if diff could be a splice of the old selection range
        var oldPrefix = oldText.slice(0, oldRange.index);
        var oldSuffix = oldText.slice(oldRange.index + oldRange.length);
        var prefixLength = oldPrefix.length;
        var suffixLength = oldSuffix.length;
        if (newLength < prefixLength + suffixLength) break replaceRange;
        var newPrefix = newText.slice(0, prefixLength);
        var newSuffix = newText.slice(newLength - suffixLength);
        if (oldPrefix !== newPrefix || oldSuffix !== newSuffix) break replaceRange;
        var oldMiddle = oldText.slice(prefixLength, oldLength - suffixLength);
        var newMiddle = newText.slice(prefixLength, newLength - suffixLength);
        return $c78fd950e528e75c$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldSuffix);
    }
    return null;
}
function $c78fd950e528e75c$var$diff(text1, text2, cursor_pos, cleanup) {
    // only pass fix_unicode=true at the top level, not when diff_main is
    // recursively invoked
    return $c78fd950e528e75c$var$diff_main(text1, text2, cursor_pos, cleanup, true);
}
$c78fd950e528e75c$var$diff.INSERT = $c78fd950e528e75c$var$DIFF_INSERT;
$c78fd950e528e75c$var$diff.DELETE = $c78fd950e528e75c$var$DIFF_DELETE;
$c78fd950e528e75c$var$diff.EQUAL = $c78fd950e528e75c$var$DIFF_EQUAL;
module.exports = $c78fd950e528e75c$var$diff;

});

parcelRegister("pATLF", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */ function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
}
/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */ function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
}
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, baseClone, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (!isArr) var props = isFull ? getAllKeys(value) : keys(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */ function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor);
}
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */ function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor);
}
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
}
/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return cloneMap(object, isDeep, cloneFunc);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return cloneSet(object, isDeep, cloneFunc);
        case symbolTag:
            return cloneSymbol(object);
    }
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, true, true);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = cloneDeep;

});

parcelRegister("9vtdl", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("2ZZoh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $pATLF = parcelRequire("pATLF");

var $9vtdl = parcelRequire("9vtdl");
var $22f0e62e1682a2ca$var$AttributeMap;
(function(AttributeMap) {
    function compose(a = {}, b = {}, keepNull = false) {
        if (typeof a !== 'object') a = {};
        if (typeof b !== 'object') b = {};
        let attributes = $pATLF(b);
        if (!keepNull) attributes = Object.keys(attributes).reduce((copy, key)=>{
            if (attributes[key] != null) copy[key] = attributes[key];
            return copy;
        }, {});
        for(const key in a)if (a[key] !== undefined && b[key] === undefined) attributes[key] = a[key];
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.compose = compose;
    function diff(a = {}, b = {}) {
        if (typeof a !== 'object') a = {};
        if (typeof b !== 'object') b = {};
        const attributes = Object.keys(a).concat(Object.keys(b)).reduce((attrs, key)=>{
            if (!$9vtdl(a[key], b[key])) attrs[key] = b[key] === undefined ? null : b[key];
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.diff = diff;
    function invert(attr = {}, base = {}) {
        attr = attr || {};
        const baseInverted = Object.keys(base).reduce((memo, key)=>{
            if (base[key] !== attr[key] && attr[key] !== undefined) memo[key] = base[key];
            return memo;
        }, {});
        return Object.keys(attr).reduce((memo, key)=>{
            if (attr[key] !== base[key] && base[key] === undefined) memo[key] = null;
            return memo;
        }, baseInverted);
    }
    AttributeMap.invert = invert;
    function transform(a, b, priority = false) {
        if (typeof a !== 'object') return b;
        if (typeof b !== 'object') return undefined;
        if (!priority) return b; // b simply overwrites us without priority
        const attributes = Object.keys(b).reduce((attrs, key)=>{
            if (a[key] === undefined) attrs[key] = b[key]; // null is a valid value
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.transform = transform;
})($22f0e62e1682a2ca$var$AttributeMap || ($22f0e62e1682a2ca$var$AttributeMap = {}));
module.exports.default = $22f0e62e1682a2ca$var$AttributeMap;

});

parcelRegister("1xkvs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $11e8c7aab376ef6d$var$Op;
(function(Op) {
    function length(op) {
        if (typeof op.delete === 'number') return op.delete;
        else if (typeof op.retain === 'number') return op.retain;
        else if (typeof op.retain === 'object' && op.retain !== null) return 1;
        else return typeof op.insert === 'string' ? op.insert.length : 1;
    }
    Op.length = length;
})($11e8c7aab376ef6d$var$Op || ($11e8c7aab376ef6d$var$Op = {}));
module.exports.default = $11e8c7aab376ef6d$var$Op;

});

parcelRegister("8IQdg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1xkvs = parcelRequire("1xkvs");
class $659aef2fcd356695$var$Iterator {
    constructor(ops){
        this.ops = ops;
        this.index = 0;
        this.offset = 0;
    }
    hasNext() {
        return this.peekLength() < Infinity;
    }
    next(length) {
        if (!length) length = Infinity;
        const nextOp = this.ops[this.index];
        if (nextOp) {
            const offset = this.offset;
            const opLength = $1xkvs.default.length(nextOp);
            if (length >= opLength - offset) {
                length = opLength - offset;
                this.index += 1;
                this.offset = 0;
            } else this.offset += length;
            if (typeof nextOp.delete === 'number') return {
                delete: length
            };
            else {
                const retOp = {};
                if (nextOp.attributes) retOp.attributes = nextOp.attributes;
                if (typeof nextOp.retain === 'number') retOp.retain = length;
                else if (typeof nextOp.retain === 'object' && nextOp.retain !== null) // offset should === 0, length should === 1
                retOp.retain = nextOp.retain;
                else if (typeof nextOp.insert === 'string') retOp.insert = nextOp.insert.substr(offset, length);
                else // offset should === 0, length should === 1
                retOp.insert = nextOp.insert;
                return retOp;
            }
        } else return {
            retain: Infinity
        };
    }
    peek() {
        return this.ops[this.index];
    }
    peekLength() {
        if (this.ops[this.index]) // Should never return 0 if our index is being managed correctly
        return $1xkvs.default.length(this.ops[this.index]) - this.offset;
        else return Infinity;
    }
    peekType() {
        const op = this.ops[this.index];
        if (op) {
            if (typeof op.delete === 'number') return 'delete';
            else if (typeof op.retain === 'number' || typeof op.retain === 'object' && op.retain !== null) return 'retain';
            else return 'insert';
        }
        return 'retain';
    }
    rest() {
        if (!this.hasNext()) return [];
        else if (this.offset === 0) return this.ops.slice(this.index);
        else {
            const offset = this.offset;
            const index = this.index;
            const next = this.next();
            const rest = this.ops.slice(this.index);
            this.offset = offset;
            this.index = index;
            return [
                next
            ].concat(rest);
        }
    }
}
module.exports.default = $659aef2fcd356695$var$Iterator;

});


parcelRegister("3sXwB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28622902ef8156ba$export$2e2bcd8739ae039; });

var $hvQN0 = parcelRequire("hvQN0");
var $f0tJx = parcelRequire("f0tJx");
var $3izSM = parcelRequire("3izSM");

var $eYvg2 = parcelRequire("eYvg2");

var $kHwOs = parcelRequire("kHwOs");

var $4UH9n = parcelRequire("4UH9n");

var $ekYWe = parcelRequire("ekYWe");

var $4lEvv = parcelRequire("4lEvv");

var $fpYVL = parcelRequire("fpYVL");

var $9iwdq = parcelRequire("9iwdq");
const $28622902ef8156ba$var$ASCII = /^[ -~]*$/;
class $28622902ef8156ba$var$Editor {
    constructor(scroll){
        this.scroll = scroll;
        this.delta = this.getDelta();
    }
    applyDelta(delta) {
        this.scroll.update();
        let scrollLength = this.scroll.length();
        this.scroll.batchStart();
        const normalizedDelta = $28622902ef8156ba$var$normalizeDelta(delta);
        const deleteDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))();
        const normalizedOps = $28622902ef8156ba$var$splitOpLines(normalizedDelta.ops.slice());
        normalizedOps.reduce((index, op)=>{
            const length = (0, $kHwOs.Op).length(op);
            let attributes = op.attributes || {};
            let isImplicitNewlinePrepended = false;
            let isImplicitNewlineAppended = false;
            if (op.insert != null) {
                deleteDelta.retain(length);
                if (typeof op.insert === 'string') {
                    const text = op.insert;
                    isImplicitNewlineAppended = !text.endsWith('\n') && (scrollLength <= index || !!this.scroll.descendant((0, $4UH9n.BlockEmbed), index)[0]);
                    this.scroll.insertAt(index, text);
                    const [line, offset] = this.scroll.line(index);
                    let formats = (0, $3izSM.default)({}, (0, $4UH9n.bubbleFormats)(line));
                    if (line instanceof (0, $4UH9n.default)) {
                        const [leaf] = line.descendant((0, $eYvg2.LeafBlot), offset);
                        if (leaf) formats = (0, $3izSM.default)(formats, (0, $4UH9n.bubbleFormats)(leaf));
                    }
                    attributes = (0, $kHwOs.AttributeMap).diff(formats, attributes) || {};
                } else if (typeof op.insert === 'object') {
                    const key = Object.keys(op.insert)[0]; // There should only be one key
                    if (key == null) return index;
                    const isInlineEmbed = this.scroll.query(key, (0, $eYvg2.Scope).INLINE) != null;
                    if (isInlineEmbed) {
                        if (scrollLength <= index || !!this.scroll.descendant((0, $4UH9n.BlockEmbed), index)[0]) isImplicitNewlineAppended = true;
                    } else if (index > 0) {
                        const [leaf, offset] = this.scroll.descendant((0, $eYvg2.LeafBlot), index - 1);
                        if (leaf instanceof (0, $fpYVL.default)) {
                            const text = leaf.value();
                            if (text[offset] !== '\n') isImplicitNewlinePrepended = true;
                        } else if (leaf instanceof (0, $eYvg2.EmbedBlot) && leaf.statics.scope === (0, $eYvg2.Scope).INLINE_BLOT) isImplicitNewlinePrepended = true;
                    }
                    this.scroll.insertAt(index, key, op.insert[key]);
                    if (isInlineEmbed) {
                        const [leaf] = this.scroll.descendant((0, $eYvg2.LeafBlot), index);
                        if (leaf) {
                            const formats = (0, $3izSM.default)({}, (0, $4UH9n.bubbleFormats)(leaf));
                            attributes = (0, $kHwOs.AttributeMap).diff(formats, attributes) || {};
                        }
                    }
                }
                scrollLength += length;
            } else {
                deleteDelta.push(op);
                if (op.retain !== null && typeof op.retain === 'object') {
                    const key = Object.keys(op.retain)[0];
                    if (key == null) return index;
                    this.scroll.updateEmbedAt(index, key, op.retain[key]);
                }
            }
            Object.keys(attributes).forEach((name)=>{
                this.scroll.formatAt(index, length, name, attributes[name]);
            });
            const prependedLength = isImplicitNewlinePrepended ? 1 : 0;
            const addedLength = isImplicitNewlineAppended ? 1 : 0;
            scrollLength += prependedLength + addedLength;
            deleteDelta.retain(prependedLength);
            deleteDelta.delete(addedLength);
            return index + length + prependedLength + addedLength;
        }, 0);
        deleteDelta.reduce((index, op)=>{
            if (typeof op.delete === 'number') {
                this.scroll.deleteAt(index, op.delete);
                return index;
            }
            return index + (0, $kHwOs.Op).length(op);
        }, 0);
        this.scroll.batchEnd();
        this.scroll.optimize();
        return this.update(normalizedDelta);
    }
    deleteText(index, length) {
        this.scroll.deleteAt(index, length);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(index).delete(length));
    }
    formatLine(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.scroll.update();
        Object.keys(formats).forEach((format)=>{
            this.scroll.lines(index, Math.max(length, 1)).forEach((line)=>{
                line.format(format, formats[format]);
            });
        });
        this.scroll.optimize();
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(index).retain(length, (0, $hvQN0.default)(formats));
        return this.update(delta);
    }
    formatText(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, length, format, formats[format]);
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(index).retain(length, (0, $hvQN0.default)(formats));
        return this.update(delta);
    }
    getContents(index, length) {
        return this.delta.slice(index, index + length);
    }
    getDelta() {
        return this.scroll.lines().reduce((delta, line)=>{
            return delta.concat(line.delta());
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))());
    }
    getFormat(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let lines = [];
        let leaves = [];
        if (length === 0) this.scroll.path(index).forEach((path)=>{
            const [blot] = path;
            if (blot instanceof (0, $4UH9n.default)) lines.push(blot);
            else if (blot instanceof (0, $eYvg2.LeafBlot)) leaves.push(blot);
        });
        else {
            lines = this.scroll.lines(index, length);
            leaves = this.scroll.descendants((0, $eYvg2.LeafBlot), index, length);
        }
        const [lineFormats, leafFormats] = [
            lines,
            leaves
        ].map((blots)=>{
            const blot = blots.shift();
            if (blot == null) return {};
            let formats = (0, $4UH9n.bubbleFormats)(blot);
            while(Object.keys(formats).length > 0){
                const blot = blots.shift();
                if (blot == null) return formats;
                formats = $28622902ef8156ba$var$combineFormats((0, $4UH9n.bubbleFormats)(blot), formats);
            }
            return formats;
        });
        return {
            ...lineFormats,
            ...leafFormats
        };
    }
    getHTML(index, length) {
        const [line, lineOffset] = this.scroll.line(index);
        if (line) {
            const lineLength = line.length();
            const isWithinLine = line.length() >= lineOffset + length;
            if (isWithinLine && !(lineOffset === 0 && length === lineLength)) return $28622902ef8156ba$var$convertHTML(line, lineOffset, length, true);
            return $28622902ef8156ba$var$convertHTML(this.scroll, index, length, true);
        }
        return '';
    }
    getText(index, length) {
        return this.getContents(index, length).filter((op)=>typeof op.insert === 'string').map((op)=>op.insert).join('');
    }
    insertContents(index, contents) {
        const normalizedDelta = $28622902ef8156ba$var$normalizeDelta(contents);
        const change = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(index).concat(normalizedDelta);
        this.scroll.insertContents(index, normalizedDelta);
        return this.update(change);
    }
    insertEmbed(index, embed, value) {
        this.scroll.insertAt(index, embed, value);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(index).insert({
            [embed]: value
        }));
    }
    insertText(index, text) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
        this.scroll.insertAt(index, text);
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, text.length, format, formats[format]);
        });
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(index).insert(text, (0, $hvQN0.default)(formats)));
    }
    isBlank() {
        if (this.scroll.children.length === 0) return true;
        if (this.scroll.children.length > 1) return false;
        const blot = this.scroll.children.head;
        if (blot?.statics.blotName !== (0, $4UH9n.default).blotName) return false;
        const block = blot;
        if (block.children.length > 1) return false;
        return block.children.head instanceof (0, $ekYWe.default);
    }
    removeFormat(index, length) {
        const text = this.getText(index, length);
        const [line, offset] = this.scroll.line(index + length);
        let suffixLength = 0;
        let suffix = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))();
        if (line != null) {
            suffixLength = line.length() - offset;
            suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
        }
        const contents = this.getContents(index, length + suffixLength);
        const diff = contents.diff(new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().insert(text).concat(suffix));
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(index).concat(diff);
        return this.applyDelta(delta);
    }
    update(change) {
        let mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        let selectionInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
        const oldDelta = this.delta;
        if (mutations.length === 1 && mutations[0].type === 'characterData' && // @ts-expect-error Fix me later
        mutations[0].target.data.match($28622902ef8156ba$var$ASCII) && this.scroll.find(mutations[0].target)) {
            // Optimization for character changes
            const textBlot = this.scroll.find(mutations[0].target);
            const formats = (0, $4UH9n.bubbleFormats)(textBlot);
            const index = textBlot.offset(this.scroll);
            // @ts-expect-error Fix me later
            const oldValue = mutations[0].oldValue.replace((0, $4lEvv.default).CONTENTS, '');
            const oldText = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().insert(oldValue);
            // @ts-expect-error
            const newText = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().insert(textBlot.value());
            const relativeSelectionInfo = selectionInfo && {
                oldRange: $28622902ef8156ba$var$shiftRange(selectionInfo.oldRange, -index),
                newRange: $28622902ef8156ba$var$shiftRange(selectionInfo.newRange, -index)
            };
            const diffDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(index).concat(oldText.diff(newText, relativeSelectionInfo));
            change = diffDelta.reduce((delta, op)=>{
                if (op.insert) return delta.insert(op.insert, formats);
                return delta.push(op);
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))());
            this.delta = oldDelta.compose(change);
        } else {
            this.delta = this.getDelta();
            if (!change || !(0, $f0tJx.default)(oldDelta.compose(change), this.delta)) change = oldDelta.diff(this.delta, selectionInfo);
        }
        return change;
    }
}
function $28622902ef8156ba$var$convertListHTML(items, lastIndent, types) {
    if (items.length === 0) {
        const [endTag] = $28622902ef8156ba$var$getListType(types.pop());
        if (lastIndent <= 0) return `</li></${endTag}>`;
        return `</li></${endTag}>${$28622902ef8156ba$var$convertListHTML([], lastIndent - 1, types)}`;
    }
    const [{ child: child, offset: offset, length: length, indent: indent, type: type }, ...rest] = items;
    const [tag, attribute] = $28622902ef8156ba$var$getListType(type);
    if (indent > lastIndent) {
        types.push(type);
        if (indent === lastIndent + 1) return `<${tag}><li${attribute}>${$28622902ef8156ba$var$convertHTML(child, offset, length)}${$28622902ef8156ba$var$convertListHTML(rest, indent, types)}`;
        return `<${tag}><li>${$28622902ef8156ba$var$convertListHTML(items, lastIndent + 1, types)}`;
    }
    const previousType = types[types.length - 1];
    if (indent === lastIndent && type === previousType) return `</li><li${attribute}>${$28622902ef8156ba$var$convertHTML(child, offset, length)}${$28622902ef8156ba$var$convertListHTML(rest, indent, types)}`;
    const [endTag] = $28622902ef8156ba$var$getListType(types.pop());
    return `</li></${endTag}>${$28622902ef8156ba$var$convertListHTML(items, lastIndent - 1, types)}`;
}
function $28622902ef8156ba$var$convertHTML(blot, index, length) {
    let isRoot = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if ('html' in blot && typeof blot.html === 'function') return blot.html(index, length);
    if (blot instanceof (0, $fpYVL.default)) {
        const escapedText = (0, $fpYVL.escapeText)(blot.value().slice(index, index + length));
        return escapedText.replaceAll(' ', '&nbsp;');
    }
    if (blot instanceof (0, $eYvg2.ParentBlot)) {
        // TODO fix API
        if (blot.statics.blotName === 'list-container') {
            const items = [];
            blot.children.forEachAt(index, length, (child, offset, childLength)=>{
                const formats = 'formats' in child && typeof child.formats === 'function' ? child.formats() : {};
                items.push({
                    child: child,
                    offset: offset,
                    length: childLength,
                    indent: formats.indent || 0,
                    type: formats.list
                });
            });
            return $28622902ef8156ba$var$convertListHTML(items, -1, []);
        }
        const parts = [];
        blot.children.forEachAt(index, length, (child, offset, childLength)=>{
            parts.push($28622902ef8156ba$var$convertHTML(child, offset, childLength));
        });
        if (isRoot || blot.statics.blotName === 'list') return parts.join('');
        const { outerHTML: outerHTML, innerHTML: innerHTML } = blot.domNode;
        const [start, end] = outerHTML.split(`>${innerHTML}<`);
        // TODO cleanup
        if (start === '<table') return `<table style="border: 1px solid #000;">${parts.join('')}<${end}`;
        return `${start}>${parts.join('')}<${end}`;
    }
    return blot.domNode instanceof Element ? blot.domNode.outerHTML : '';
}
function $28622902ef8156ba$var$combineFormats(formats, combined) {
    return Object.keys(combined).reduce((merged, name)=>{
        if (formats[name] == null) return merged;
        const combinedValue = combined[name];
        if (combinedValue === formats[name]) merged[name] = combinedValue;
        else if (Array.isArray(combinedValue)) {
            if (combinedValue.indexOf(formats[name]) < 0) merged[name] = combinedValue.concat([
                formats[name]
            ]);
            else // If style already exists, don't add to an array, but don't lose other styles
            merged[name] = combinedValue;
        } else merged[name] = [
            combinedValue,
            formats[name]
        ];
        return merged;
    }, {});
}
function $28622902ef8156ba$var$getListType(type) {
    const tag = type === 'ordered' ? 'ol' : 'ul';
    switch(type){
        case 'checked':
            return [
                tag,
                ' data-list="checked"'
            ];
        case 'unchecked':
            return [
                tag,
                ' data-list="unchecked"'
            ];
        default:
            return [
                tag,
                ''
            ];
    }
}
function $28622902ef8156ba$var$normalizeDelta(delta) {
    return delta.reduce((normalizedDelta, op)=>{
        if (typeof op.insert === 'string') {
            const text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
            return normalizedDelta.insert(text, op.attributes);
        }
        return normalizedDelta.push(op);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))());
}
function $28622902ef8156ba$var$shiftRange(_ref, amount) {
    let { index: index, length: length } = _ref;
    return new (0, $9iwdq.Range)(index + amount, length);
}
function $28622902ef8156ba$var$splitOpLines(ops) {
    const split = [];
    ops.forEach((op)=>{
        if (typeof op.insert === 'string') {
            const lines = op.insert.split('\n');
            lines.forEach((line, index)=>{
                if (index) split.push({
                    insert: '\n',
                    attributes: op.attributes
                });
                if (line) split.push({
                    insert: line,
                    attributes: op.attributes
                });
            });
        } else split.push(op);
    });
    return split;
}
var $28622902ef8156ba$export$2e2bcd8739ae039 = $28622902ef8156ba$var$Editor;

});
parcelRegister("f0tJx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aecdeb8b78d26a5f$export$2e2bcd8739ae039; });

var $l2i3f = parcelRequire("l2i3f");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $aecdeb8b78d26a5f$var$isEqual(value, other) {
    return (0, $l2i3f.default)(value, other);
}
var $aecdeb8b78d26a5f$export$2e2bcd8739ae039 = $aecdeb8b78d26a5f$var$isEqual;

});
parcelRegister("l2i3f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f507c97ea16f4438$export$2e2bcd8739ae039; });

var $e05GU = parcelRequire("e05GU");

var $e3gLp = parcelRequire("e3gLp");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $f507c97ea16f4438$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $e3gLp.default)(value) && !(0, $e3gLp.default)(other)) return value !== value && other !== other;
    return (0, $e05GU.default)(value, other, bitmask, customizer, $f507c97ea16f4438$var$baseIsEqual, stack);
}
var $f507c97ea16f4438$export$2e2bcd8739ae039 = $f507c97ea16f4438$var$baseIsEqual;

});
parcelRegister("e05GU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3157ae2950ec837$export$2e2bcd8739ae039; });

var $hQ4rP = parcelRequire("hQ4rP");

var $4ZGzg = parcelRequire("4ZGzg");

var $9mQf2 = parcelRequire("9mQf2");

var $bLgho = parcelRequire("bLgho");

var $j5aX8 = parcelRequire("j5aX8");

var $kCwEw = parcelRequire("kCwEw");

var $emwkF = parcelRequire("emwkF");

var $L67KT = parcelRequire("L67KT");
/** Used to compose bitmasks for value comparisons. */ var $a3157ae2950ec837$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $a3157ae2950ec837$var$argsTag = '[object Arguments]', $a3157ae2950ec837$var$arrayTag = '[object Array]', $a3157ae2950ec837$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $a3157ae2950ec837$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a3157ae2950ec837$var$hasOwnProperty = $a3157ae2950ec837$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a3157ae2950ec837$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $kCwEw.default)(object), othIsArr = (0, $kCwEw.default)(other), objTag = objIsArr ? $a3157ae2950ec837$var$arrayTag : (0, $j5aX8.default)(object), othTag = othIsArr ? $a3157ae2950ec837$var$arrayTag : (0, $j5aX8.default)(other);
    objTag = objTag == $a3157ae2950ec837$var$argsTag ? $a3157ae2950ec837$var$objectTag : objTag;
    othTag = othTag == $a3157ae2950ec837$var$argsTag ? $a3157ae2950ec837$var$objectTag : othTag;
    var objIsObj = objTag == $a3157ae2950ec837$var$objectTag, othIsObj = othTag == $a3157ae2950ec837$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $emwkF.default)(object)) {
        if (!(0, $emwkF.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $hQ4rP.default));
        return objIsArr || (0, $L67KT.default)(object) ? (0, $4ZGzg.default)(object, other, bitmask, customizer, equalFunc, stack) : (0, $9mQf2.default)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $a3157ae2950ec837$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $a3157ae2950ec837$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $a3157ae2950ec837$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $hQ4rP.default));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $hQ4rP.default));
    return (0, $bLgho.default)(object, other, bitmask, customizer, equalFunc, stack);
}
var $a3157ae2950ec837$export$2e2bcd8739ae039 = $a3157ae2950ec837$var$baseIsEqualDeep;

});
parcelRegister("4ZGzg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a2de10188a82859$export$2e2bcd8739ae039; });

var $lcU89 = parcelRequire("lcU89");

var $d0d5K = parcelRequire("d0d5K");

var $8HJfw = parcelRequire("8HJfw");
/** Used to compose bitmasks for value comparisons. */ var $3a2de10188a82859$var$COMPARE_PARTIAL_FLAG = 1, $3a2de10188a82859$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $3a2de10188a82859$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $3a2de10188a82859$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $3a2de10188a82859$var$COMPARE_UNORDERED_FLAG ? new (0, $lcU89.default) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $d0d5K.default)(other, function(othValue, othIndex) {
                if (!(0, $8HJfw.default)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
var $3a2de10188a82859$export$2e2bcd8739ae039 = $3a2de10188a82859$var$equalArrays;

});
parcelRegister("lcU89", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f706424b7b1b2897$export$2e2bcd8739ae039; });

var $5znFr = parcelRequire("5znFr");

var $fQSE7 = parcelRequire("fQSE7");

var $d94Fo = parcelRequire("d94Fo");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $f706424b7b1b2897$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $5znFr.default);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$f706424b7b1b2897$var$SetCache.prototype.add = $f706424b7b1b2897$var$SetCache.prototype.push = (0, $fQSE7.default);
$f706424b7b1b2897$var$SetCache.prototype.has = (0, $d94Fo.default);
var $f706424b7b1b2897$export$2e2bcd8739ae039 = $f706424b7b1b2897$var$SetCache;

});
parcelRegister("fQSE7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8a619f01a41eba1$export$2e2bcd8739ae039; });
/** Used to stand-in for `undefined` hash values. */ var $b8a619f01a41eba1$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $b8a619f01a41eba1$var$setCacheAdd(value) {
    this.__data__.set(value, $b8a619f01a41eba1$var$HASH_UNDEFINED);
    return this;
}
var $b8a619f01a41eba1$export$2e2bcd8739ae039 = $b8a619f01a41eba1$var$setCacheAdd;

});

parcelRegister("d94Fo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $991fbc4d3745c876$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $991fbc4d3745c876$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $991fbc4d3745c876$export$2e2bcd8739ae039 = $991fbc4d3745c876$var$setCacheHas;

});


parcelRegister("d0d5K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97756e30fa06c8f8$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $97756e30fa06c8f8$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $97756e30fa06c8f8$export$2e2bcd8739ae039 = $97756e30fa06c8f8$var$arraySome;

});

parcelRegister("8HJfw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $656570796dcbf19c$export$2e2bcd8739ae039; });
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $656570796dcbf19c$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $656570796dcbf19c$export$2e2bcd8739ae039 = $656570796dcbf19c$var$cacheHas;

});


parcelRegister("9mQf2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d1eb13b300751fd$export$2e2bcd8739ae039; });

var $ceXwU = parcelRequire("ceXwU");

var $jzV4C = parcelRequire("jzV4C");

var $cbK6Z = parcelRequire("cbK6Z");

var $4ZGzg = parcelRequire("4ZGzg");

var $ap7Hv = parcelRequire("ap7Hv");

var $fz6o9 = parcelRequire("fz6o9");
/** Used to compose bitmasks for value comparisons. */ var $6d1eb13b300751fd$var$COMPARE_PARTIAL_FLAG = 1, $6d1eb13b300751fd$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $6d1eb13b300751fd$var$boolTag = '[object Boolean]', $6d1eb13b300751fd$var$dateTag = '[object Date]', $6d1eb13b300751fd$var$errorTag = '[object Error]', $6d1eb13b300751fd$var$mapTag = '[object Map]', $6d1eb13b300751fd$var$numberTag = '[object Number]', $6d1eb13b300751fd$var$regexpTag = '[object RegExp]', $6d1eb13b300751fd$var$setTag = '[object Set]', $6d1eb13b300751fd$var$stringTag = '[object String]', $6d1eb13b300751fd$var$symbolTag = '[object Symbol]';
var $6d1eb13b300751fd$var$arrayBufferTag = '[object ArrayBuffer]', $6d1eb13b300751fd$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $6d1eb13b300751fd$var$symbolProto = (0, $ceXwU.default) ? (0, $ceXwU.default).prototype : undefined, $6d1eb13b300751fd$var$symbolValueOf = $6d1eb13b300751fd$var$symbolProto ? $6d1eb13b300751fd$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $6d1eb13b300751fd$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $6d1eb13b300751fd$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $6d1eb13b300751fd$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $jzV4C.default)(object), new (0, $jzV4C.default)(other))) return false;
            return true;
        case $6d1eb13b300751fd$var$boolTag:
        case $6d1eb13b300751fd$var$dateTag:
        case $6d1eb13b300751fd$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $cbK6Z.default)(+object, +other);
        case $6d1eb13b300751fd$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $6d1eb13b300751fd$var$regexpTag:
        case $6d1eb13b300751fd$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $6d1eb13b300751fd$var$mapTag:
            var convert = (0, $ap7Hv.default);
        case $6d1eb13b300751fd$var$setTag:
            var isPartial = bitmask & $6d1eb13b300751fd$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $fz6o9.default));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $6d1eb13b300751fd$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $4ZGzg.default)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $6d1eb13b300751fd$var$symbolTag:
            if ($6d1eb13b300751fd$var$symbolValueOf) return $6d1eb13b300751fd$var$symbolValueOf.call(object) == $6d1eb13b300751fd$var$symbolValueOf.call(other);
    }
    return false;
}
var $6d1eb13b300751fd$export$2e2bcd8739ae039 = $6d1eb13b300751fd$var$equalByTag;

});
parcelRegister("ap7Hv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7932365fd039c634$export$2e2bcd8739ae039; });
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $7932365fd039c634$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $7932365fd039c634$export$2e2bcd8739ae039 = $7932365fd039c634$var$mapToArray;

});

parcelRegister("fz6o9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b54f148a84e4de59$export$2e2bcd8739ae039; });
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $b54f148a84e4de59$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $b54f148a84e4de59$export$2e2bcd8739ae039 = $b54f148a84e4de59$var$setToArray;

});


parcelRegister("bLgho", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8900b63efdb98b56$export$2e2bcd8739ae039; });

var $3ap0R = parcelRequire("3ap0R");
/** Used to compose bitmasks for value comparisons. */ var $8900b63efdb98b56$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $8900b63efdb98b56$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8900b63efdb98b56$var$hasOwnProperty = $8900b63efdb98b56$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $8900b63efdb98b56$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $8900b63efdb98b56$var$COMPARE_PARTIAL_FLAG, objProps = (0, $3ap0R.default)(object), objLength = objProps.length, othProps = (0, $3ap0R.default)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $8900b63efdb98b56$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
var $8900b63efdb98b56$export$2e2bcd8739ae039 = $8900b63efdb98b56$var$equalObjects;

});




parcelRegister("4UH9n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $393ddd1d984101d5$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "blockDelta", function () { return $393ddd1d984101d5$export$992ff47219af5a2b; });
$parcel$export(module.exports, "BlockEmbed", function () { return $393ddd1d984101d5$export$48b9f0688962d028; });
$parcel$export(module.exports, "bubbleFormats", function () { return $393ddd1d984101d5$export$e4bb5a6163449612; });

var $eYvg2 = parcelRequire("eYvg2");

var $kHwOs = parcelRequire("kHwOs");

var $ekYWe = parcelRequire("ekYWe");

var $4Xyhi = parcelRequire("4Xyhi");

var $fpYVL = parcelRequire("fpYVL");
const $393ddd1d984101d5$var$NEWLINE_LENGTH = 1;
class $393ddd1d984101d5$export$2e2bcd8739ae039 extends (0, $eYvg2.BlockBlot) {
    cache = {};
    delta() {
        if (this.cache.delta == null) this.cache.delta = $393ddd1d984101d5$export$992ff47219af5a2b(this);
        return this.cache.delta;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length);
        this.cache = {};
    }
    formatAt(index, length, name, value) {
        if (length <= 0) return;
        if (this.scroll.query(name, (0, $eYvg2.Scope).BLOCK)) {
            if (index + length === this.length()) this.format(name, value);
        } else super.formatAt(index, Math.min(length, this.length() - index - 1), name, value);
        this.cache = {};
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            this.cache = {};
            return;
        }
        if (value.length === 0) return;
        const lines = value.split('\n');
        const text = lines.shift();
        if (text.length > 0) {
            if (index < this.length() - 1 || this.children.tail == null) super.insertAt(Math.min(index, this.length() - 1), text);
            else this.children.tail.insertAt(this.children.tail.length(), text);
            this.cache = {};
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let block = this;
        lines.reduce((lineIndex, line)=>{
            // @ts-expect-error Fix me later
            block = block.split(lineIndex, true);
            block.insertAt(0, line);
            return line.length;
        }, index + text.length);
    }
    insertBefore(blot, ref) {
        const { head: head } = this.children;
        super.insertBefore(blot, ref);
        if (head instanceof (0, $ekYWe.default)) head.remove();
        this.cache = {};
    }
    length() {
        if (this.cache.length == null) this.cache.length = super.length() + $393ddd1d984101d5$var$NEWLINE_LENGTH;
        return this.cache.length;
    }
    moveChildren(target, ref) {
        super.moveChildren(target, ref);
        this.cache = {};
    }
    optimize(context) {
        super.optimize(context);
        this.cache = {};
    }
    path(index) {
        return super.path(index, true);
    }
    removeChild(child) {
        super.removeChild(child);
        this.cache = {};
    }
    split(index) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (force && (index === 0 || index >= this.length() - $393ddd1d984101d5$var$NEWLINE_LENGTH)) {
            const clone = this.clone();
            if (index === 0) {
                this.parent.insertBefore(clone, this);
                return this;
            }
            this.parent.insertBefore(clone, this.next);
            return clone;
        }
        const next = super.split(index, force);
        this.cache = {};
        return next;
    }
}
$393ddd1d984101d5$export$2e2bcd8739ae039.blotName = 'block';
$393ddd1d984101d5$export$2e2bcd8739ae039.tagName = 'P';
$393ddd1d984101d5$export$2e2bcd8739ae039.defaultChild = (0, $ekYWe.default);
$393ddd1d984101d5$export$2e2bcd8739ae039.allowedChildren = [
    (0, $ekYWe.default),
    (0, $4Xyhi.default),
    (0, $eYvg2.EmbedBlot),
    (0, $fpYVL.default)
];
class $393ddd1d984101d5$export$48b9f0688962d028 extends (0, $eYvg2.EmbedBlot) {
    attach() {
        super.attach();
        this.attributes = new (0, $eYvg2.AttributorStore)(this.domNode);
    }
    delta() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().insert(this.value(), {
            ...this.formats(),
            ...this.attributes.values()
        });
    }
    format(name, value) {
        const attribute = this.scroll.query(name, (0, $eYvg2.Scope).BLOCK_ATTRIBUTE);
        if (attribute != null) // @ts-expect-error TODO: Scroll#query() should return Attributor when scope is attribute
        this.attributes.attribute(attribute, value);
    }
    formatAt(index, length, name, value) {
        this.format(name, value);
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            return;
        }
        const lines = value.split('\n');
        const text = lines.pop();
        const blocks = lines.map((line)=>{
            const block = this.scroll.create($393ddd1d984101d5$export$2e2bcd8739ae039.blotName);
            block.insertAt(0, line);
            return block;
        });
        const ref = this.split(index);
        blocks.forEach((block)=>{
            this.parent.insertBefore(block, ref);
        });
        if (text) this.parent.insertBefore(this.scroll.create('text', text), ref);
    }
}
$393ddd1d984101d5$export$48b9f0688962d028.scope = (0, $eYvg2.Scope).BLOCK_BLOT;
// It is important for cursor behavior BlockEmbeds use tags that are block level elements
function $393ddd1d984101d5$export$992ff47219af5a2b(blot) {
    let filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return blot.descendants((0, $eYvg2.LeafBlot)).reduce((delta, leaf)=>{
        if (leaf.length() === 0) return delta;
        return delta.insert(leaf.value(), $393ddd1d984101d5$export$e4bb5a6163449612(leaf, {}, filter));
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))()).insert('\n', $393ddd1d984101d5$export$e4bb5a6163449612(blot));
}
function $393ddd1d984101d5$export$e4bb5a6163449612(blot) {
    let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (blot == null) return formats;
    if ('formats' in blot && typeof blot.formats === 'function') {
        formats = {
            ...formats,
            ...blot.formats()
        };
        if (filter) // exclude syntax highlighting from deltas and getFormat()
        delete formats['code-token'];
    }
    if (blot.parent == null || blot.parent.statics.blotName === 'scroll' || blot.parent.statics.scope !== blot.statics.scope) return formats;
    return $393ddd1d984101d5$export$e4bb5a6163449612(blot.parent, formats, filter);
}

});
parcelRegister("ekYWe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a70233fcb8d5608d$export$2e2bcd8739ae039; });

var $eYvg2 = parcelRequire("eYvg2");
class $a70233fcb8d5608d$var$Break extends (0, $eYvg2.EmbedBlot) {
    static value() {
        return undefined;
    }
    optimize() {
        if (this.prev || this.next) this.remove();
    }
    length() {
        return 0;
    }
    value() {
        return '';
    }
}
$a70233fcb8d5608d$var$Break.blotName = 'break';
$a70233fcb8d5608d$var$Break.tagName = 'BR';
var $a70233fcb8d5608d$export$2e2bcd8739ae039 = $a70233fcb8d5608d$var$Break;

});

parcelRegister("4Xyhi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39c742fe980313eb$export$2e2bcd8739ae039; });

var $eYvg2 = parcelRequire("eYvg2");

var $ekYWe = parcelRequire("ekYWe");

var $fpYVL = parcelRequire("fpYVL");
class $39c742fe980313eb$var$Inline extends (0, $eYvg2.InlineBlot) {
    static allowedChildren = [
        $39c742fe980313eb$var$Inline,
        (0, $ekYWe.default),
        (0, $eYvg2.EmbedBlot),
        (0, $fpYVL.default)
    ];
    // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
    static order = [
        'cursor',
        'inline',
        // Must be lower
        'link',
        // Chrome wants <a> to be lower
        'underline',
        'strike',
        'italic',
        'bold',
        'script',
        'code' // Must be higher
    ];
    static compare(self, other) {
        const selfIndex = $39c742fe980313eb$var$Inline.order.indexOf(self);
        const otherIndex = $39c742fe980313eb$var$Inline.order.indexOf(other);
        if (selfIndex >= 0 || otherIndex >= 0) return selfIndex - otherIndex;
        if (self === other) return 0;
        if (self < other) return -1;
        return 1;
    }
    formatAt(index, length, name, value) {
        if ($39c742fe980313eb$var$Inline.compare(this.statics.blotName, name) < 0 && this.scroll.query(name, (0, $eYvg2.Scope).BLOT)) {
            const blot = this.isolate(index, length);
            if (value) blot.wrap(name, value);
        } else super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent instanceof $39c742fe980313eb$var$Inline && $39c742fe980313eb$var$Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
            const parent = this.parent.isolate(this.offset(), this.length());
            // @ts-expect-error TODO: make isolate generic
            this.moveChildren(parent);
            parent.wrap(this);
        }
    }
}
var $39c742fe980313eb$export$2e2bcd8739ae039 = $39c742fe980313eb$var$Inline;

});
parcelRegister("fpYVL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b39874666e004fbd$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "escapeText", function () { return $b39874666e004fbd$export$96e6fc3a139b2555; });

var $eYvg2 = parcelRequire("eYvg2");
class $b39874666e004fbd$export$2e2bcd8739ae039 extends (0, $eYvg2.TextBlot) {
}
// https://lodash.com/docs#escape
const $b39874666e004fbd$var$entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
function $b39874666e004fbd$export$96e6fc3a139b2555(text) {
    return text.replace(/[&<>"']/g, (s)=>$b39874666e004fbd$var$entityMap[s]);
}

});



parcelRegister("4lEvv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32a88b73ef5359d9$export$2e2bcd8739ae039; });

var $eYvg2 = parcelRequire("eYvg2");

var $fpYVL = parcelRequire("fpYVL");
class $32a88b73ef5359d9$var$Cursor extends (0, $eYvg2.EmbedBlot) {
    static blotName = 'cursor';
    static className = 'ql-cursor';
    static tagName = 'span';
    static CONTENTS = '\uFEFF';
    static value() {
        return undefined;
    }
    constructor(scroll, domNode, selection){
        super(scroll, domNode);
        this.selection = selection;
        this.textNode = document.createTextNode($32a88b73ef5359d9$var$Cursor.CONTENTS);
        this.domNode.appendChild(this.textNode);
        this.savedLength = 0;
    }
    detach() {
        // super.detach() will also clear domNode.__blot
        if (this.parent != null) this.parent.removeChild(this);
    }
    format(name, value) {
        if (this.savedLength !== 0) {
            super.format(name, value);
            return;
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let target = this;
        let index = 0;
        while(target != null && target.statics.scope !== (0, $eYvg2.Scope).BLOCK_BLOT){
            index += target.offset(target.parent);
            target = target.parent;
        }
        if (target != null) {
            this.savedLength = $32a88b73ef5359d9$var$Cursor.CONTENTS.length;
            // @ts-expect-error TODO: allow empty context in Parchment
            target.optimize();
            target.formatAt(index, $32a88b73ef5359d9$var$Cursor.CONTENTS.length, name, value);
            this.savedLength = 0;
        }
    }
    index(node, offset) {
        if (node === this.textNode) return 0;
        return super.index(node, offset);
    }
    length() {
        return this.savedLength;
    }
    position() {
        return [
            this.textNode,
            this.textNode.data.length
        ];
    }
    remove() {
        super.remove();
        // @ts-expect-error Fix me later
        this.parent = null;
    }
    restore() {
        if (this.selection.composing || this.parent == null) return null;
        const range = this.selection.getNativeRange();
        // Browser may push down styles/nodes inside the cursor blot.
        // https://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#push-down-values
        while(this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode)// @ts-expect-error Fix me later
        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
        const prevTextBlot = this.prev instanceof (0, $fpYVL.default) ? this.prev : null;
        const prevTextLength = prevTextBlot ? prevTextBlot.length() : 0;
        const nextTextBlot = this.next instanceof (0, $fpYVL.default) ? this.next : null;
        // @ts-expect-error TODO: make TextBlot.text public
        const nextText = nextTextBlot ? nextTextBlot.text : '';
        const { textNode: textNode } = this;
        // take text from inside this blot and reset it
        const newText = textNode.data.split($32a88b73ef5359d9$var$Cursor.CONTENTS).join('');
        textNode.data = $32a88b73ef5359d9$var$Cursor.CONTENTS;
        // proactively merge TextBlots around cursor so that optimization
        // doesn't lose the cursor.  the reason we are here in cursor.restore
        // could be that the user clicked in prevTextBlot or nextTextBlot, or
        // the user typed something.
        let mergedTextBlot;
        if (prevTextBlot) {
            mergedTextBlot = prevTextBlot;
            if (newText || nextTextBlot) {
                prevTextBlot.insertAt(prevTextBlot.length(), newText + nextText);
                if (nextTextBlot) nextTextBlot.remove();
            }
        } else if (nextTextBlot) {
            mergedTextBlot = nextTextBlot;
            nextTextBlot.insertAt(0, newText);
        } else {
            const newTextNode = document.createTextNode(newText);
            mergedTextBlot = this.scroll.create(newTextNode);
            this.parent.insertBefore(mergedTextBlot, this);
        }
        this.remove();
        if (range) {
            // calculate selection to restore
            const remapOffset = (node, offset)=>{
                if (prevTextBlot && node === prevTextBlot.domNode) return offset;
                if (node === textNode) return prevTextLength + offset - 1;
                if (nextTextBlot && node === nextTextBlot.domNode) return prevTextLength + newText.length + offset;
                return null;
            };
            const start = remapOffset(range.start.node, range.start.offset);
            const end = remapOffset(range.end.node, range.end.offset);
            if (start !== null && end !== null) return {
                startNode: mergedTextBlot.domNode,
                startOffset: start,
                endNode: mergedTextBlot.domNode,
                endOffset: end
            };
        }
        return null;
    }
    update(mutations, context) {
        if (mutations.some((mutation)=>{
            return mutation.type === 'characterData' && mutation.target === this.textNode;
        })) {
            const range = this.restore();
            if (range) context.range = range;
        }
    }
    // Avoid .ql-cursor being a descendant of `<a/>`.
    // The reason is Safari pushes down `<a/>` on text insertion.
    // That will cause DOM nodes not sync with the model.
    //
    // For example ({I} is the caret), given the markup:
    //    <a><span class="ql-cursor">\uFEFF{I}</span></a>
    // When typing a char "x", `<a/>` will be pushed down inside the `<span>` first:
    //    <span class="ql-cursor"><a>\uFEFF{I}</a></span>
    // And then "x" will be inserted after `<a/>`:
    //    <span class="ql-cursor"><a>\uFEFF</a>d{I}</span>
    optimize(context) {
        // @ts-expect-error Fix me later
        super.optimize(context);
        let { parent: parent } = this;
        while(parent){
            if (parent.domNode.tagName === 'A') {
                this.savedLength = $32a88b73ef5359d9$var$Cursor.CONTENTS.length;
                // @ts-expect-error TODO: make isolate generic
                parent.isolate(this.offset(parent), this.length()).unwrap();
                this.savedLength = 0;
                break;
            }
            parent = parent.parent;
        }
    }
    value() {
        return '';
    }
}
var $32a88b73ef5359d9$export$2e2bcd8739ae039 = $32a88b73ef5359d9$var$Cursor;

});

parcelRegister("9iwdq", function(module, exports) {

$parcel$export(module.exports, "Range", function () { return $6c4ec8d00dbc6ebd$export$9a58ef0d7ad3278c; });
$parcel$export(module.exports, "default", function () { return $6c4ec8d00dbc6ebd$export$2e2bcd8739ae039; });

var $eYvg2 = parcelRequire("eYvg2");

var $hvQN0 = parcelRequire("hvQN0");
var $f0tJx = parcelRequire("f0tJx");

var $8AVGf = parcelRequire("8AVGf");

var $jzLjA = parcelRequire("jzLjA");
const $6c4ec8d00dbc6ebd$var$debug = (0, $jzLjA.default)('quill:selection');
class $6c4ec8d00dbc6ebd$export$9a58ef0d7ad3278c {
    constructor(index){
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        this.index = index;
        this.length = length;
    }
}
class $6c4ec8d00dbc6ebd$var$Selection {
    constructor(scroll, emitter){
        this.emitter = emitter;
        this.scroll = scroll;
        this.composing = false;
        this.mouseDown = false;
        this.root = this.scroll.domNode;
        // @ts-expect-error
        this.cursor = this.scroll.create('cursor', this);
        // savedRange is last non-null range
        this.savedRange = new $6c4ec8d00dbc6ebd$export$9a58ef0d7ad3278c(0, 0);
        this.lastRange = this.savedRange;
        this.lastNative = null;
        this.handleComposition();
        this.handleDragging();
        this.emitter.listenDOM('selectionchange', document, ()=>{
            if (!this.mouseDown && !this.composing) setTimeout(this.update.bind(this, (0, $8AVGf.default).sources.USER), 1);
        });
        this.emitter.on((0, $8AVGf.default).events.SCROLL_BEFORE_UPDATE, ()=>{
            if (!this.hasFocus()) return;
            const native = this.getNativeRange();
            if (native == null) return;
            if (native.start.node === this.cursor.textNode) return; // cursor.restore() will handle
            this.emitter.once((0, $8AVGf.default).events.SCROLL_UPDATE, (source, mutations)=>{
                try {
                    if (this.root.contains(native.start.node) && this.root.contains(native.end.node)) this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
                    const triggeredByTyping = mutations.some((mutation)=>mutation.type === 'characterData' || mutation.type === 'childList' || mutation.type === 'attributes' && mutation.target === this.root);
                    this.update(triggeredByTyping ? (0, $8AVGf.default).sources.SILENT : source);
                } catch (ignored) {
                // ignore
                }
            });
        });
        this.emitter.on((0, $8AVGf.default).events.SCROLL_OPTIMIZE, (mutations, context)=>{
            if (context.range) {
                const { startNode: startNode, startOffset: startOffset, endNode: endNode, endOffset: endOffset } = context.range;
                this.setNativeRange(startNode, startOffset, endNode, endOffset);
                this.update((0, $8AVGf.default).sources.SILENT);
            }
        });
        this.update((0, $8AVGf.default).sources.SILENT);
    }
    handleComposition() {
        this.emitter.on((0, $8AVGf.default).events.COMPOSITION_BEFORE_START, ()=>{
            this.composing = true;
        });
        this.emitter.on((0, $8AVGf.default).events.COMPOSITION_END, ()=>{
            this.composing = false;
            if (this.cursor.parent) {
                const range = this.cursor.restore();
                if (!range) return;
                setTimeout(()=>{
                    this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                }, 1);
            }
        });
    }
    handleDragging() {
        this.emitter.listenDOM('mousedown', document.body, ()=>{
            this.mouseDown = true;
        });
        this.emitter.listenDOM('mouseup', document.body, ()=>{
            this.mouseDown = false;
            this.update((0, $8AVGf.default).sources.USER);
        });
    }
    focus() {
        if (this.hasFocus()) return;
        this.root.focus({
            preventScroll: true
        });
        this.setRange(this.savedRange);
    }
    format(format, value) {
        this.scroll.update();
        const nativeRange = this.getNativeRange();
        if (nativeRange == null || !nativeRange.native.collapsed || this.scroll.query(format, (0, $eYvg2.Scope).BLOCK)) return;
        if (nativeRange.start.node !== this.cursor.textNode) {
            const blot = this.scroll.find(nativeRange.start.node, false);
            if (blot == null) return;
            // TODO Give blot ability to not split
            if (blot instanceof (0, $eYvg2.LeafBlot)) {
                const after = blot.split(nativeRange.start.offset);
                blot.parent.insertBefore(this.cursor, after);
            } else // @ts-expect-error TODO: nativeRange.start.node doesn't seem to match function signature
            blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
            this.cursor.attach();
        }
        this.cursor.format(format, value);
        this.scroll.optimize();
        this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
        this.update();
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        const scrollLength = this.scroll.length();
        index = Math.min(index, scrollLength - 1);
        length = Math.min(index + length, scrollLength - 1) - index;
        let node;
        let [leaf, offset] = this.scroll.leaf(index);
        if (leaf == null) return null;
        if (length > 0 && offset === leaf.length()) {
            const [next] = this.scroll.leaf(index + 1);
            if (next) {
                const [line] = this.scroll.line(index);
                const [nextLine] = this.scroll.line(index + 1);
                if (line === nextLine) {
                    leaf = next;
                    offset = 0;
                }
            }
        }
        [node, offset] = leaf.position(offset, true);
        const range = document.createRange();
        if (length > 0) {
            range.setStart(node, offset);
            [leaf, offset] = this.scroll.leaf(index + length);
            if (leaf == null) return null;
            [node, offset] = leaf.position(offset, true);
            range.setEnd(node, offset);
            return range.getBoundingClientRect();
        }
        let side = 'left';
        let rect;
        if (node instanceof Text) {
            // Return null if the text node is empty because it is
            // not able to get a useful client rect:
            // https://github.com/w3c/csswg-drafts/issues/2514.
            // Empty text nodes are most likely caused by TextBlot#optimize()
            // not getting called when editor content changes.
            if (!node.data.length) return null;
            if (offset < node.data.length) {
                range.setStart(node, offset);
                range.setEnd(node, offset + 1);
            } else {
                range.setStart(node, offset - 1);
                range.setEnd(node, offset);
                side = 'right';
            }
            rect = range.getBoundingClientRect();
        } else {
            if (!(leaf.domNode instanceof Element)) return null;
            rect = leaf.domNode.getBoundingClientRect();
            if (offset > 0) side = 'right';
        }
        return {
            bottom: rect.top + rect.height,
            height: rect.height,
            left: rect[side],
            right: rect[side],
            top: rect.top,
            width: 0
        };
    }
    getNativeRange() {
        const selection = document.getSelection();
        if (selection == null || selection.rangeCount <= 0) return null;
        const nativeRange = selection.getRangeAt(0);
        if (nativeRange == null) return null;
        const range = this.normalizeNative(nativeRange);
        $6c4ec8d00dbc6ebd$var$debug.info('getNativeRange', range);
        return range;
    }
    getRange() {
        const root = this.scroll.domNode;
        if ('isConnected' in root && !root.isConnected) // document.getSelection() forces layout on Blink, so we trend to
        // not calling it.
        return [
            null,
            null
        ];
        const normalized = this.getNativeRange();
        if (normalized == null) return [
            null,
            null
        ];
        const range = this.normalizedToRange(normalized);
        return [
            range,
            normalized
        ];
    }
    hasFocus() {
        return document.activeElement === this.root || document.activeElement != null && $6c4ec8d00dbc6ebd$var$contains(this.root, document.activeElement);
    }
    normalizedToRange(range) {
        const positions = [
            [
                range.start.node,
                range.start.offset
            ]
        ];
        if (!range.native.collapsed) positions.push([
            range.end.node,
            range.end.offset
        ]);
        const indexes = positions.map((position)=>{
            const [node, offset] = position;
            const blot = this.scroll.find(node, true);
            // @ts-expect-error Fix me later
            const index = blot.offset(this.scroll);
            if (offset === 0) return index;
            if (blot instanceof (0, $eYvg2.LeafBlot)) return index + blot.index(node, offset);
            // @ts-expect-error Fix me later
            return index + blot.length();
        });
        const end = Math.min(Math.max(...indexes), this.scroll.length() - 1);
        const start = Math.min(end, ...indexes);
        return new $6c4ec8d00dbc6ebd$export$9a58ef0d7ad3278c(start, end - start);
    }
    normalizeNative(nativeRange) {
        if (!$6c4ec8d00dbc6ebd$var$contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !$6c4ec8d00dbc6ebd$var$contains(this.root, nativeRange.endContainer)) return null;
        const range = {
            start: {
                node: nativeRange.startContainer,
                offset: nativeRange.startOffset
            },
            end: {
                node: nativeRange.endContainer,
                offset: nativeRange.endOffset
            },
            native: nativeRange
        };
        [
            range.start,
            range.end
        ].forEach((position)=>{
            let { node: node, offset: offset } = position;
            while(!(node instanceof Text) && node.childNodes.length > 0){
                if (node.childNodes.length > offset) {
                    node = node.childNodes[offset];
                    offset = 0;
                } else if (node.childNodes.length === offset) {
                    // @ts-expect-error Fix me later
                    node = node.lastChild;
                    if (node instanceof Text) offset = node.data.length;
                    else if (node.childNodes.length > 0) // Container case
                    offset = node.childNodes.length;
                    else // Embed case
                    offset = node.childNodes.length + 1;
                } else break;
            }
            position.node = node;
            position.offset = offset;
        });
        return range;
    }
    rangeToNative(range) {
        const scrollLength = this.scroll.length();
        const getPosition = (index, inclusive)=>{
            index = Math.min(scrollLength - 1, index);
            const [leaf, leafOffset] = this.scroll.leaf(index);
            return leaf ? leaf.position(leafOffset, inclusive) : [
                null,
                -1
            ];
        };
        return [
            ...getPosition(range.index, false),
            ...getPosition(range.index + range.length, true)
        ];
    }
    setNativeRange(startNode, startOffset) {
        let endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
        let endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
        let force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        $6c4ec8d00dbc6ebd$var$debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
        if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || // @ts-expect-error Fix me later
        endNode.parentNode == null)) return;
        const selection = document.getSelection();
        if (selection == null) return;
        if (startNode != null) {
            if (!this.hasFocus()) this.root.focus({
                preventScroll: true
            });
            const { native: native } = this.getNativeRange() || {};
            if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
                if (startNode instanceof Element && startNode.tagName === 'BR') {
                    // @ts-expect-error Fix me later
                    startOffset = Array.from(startNode.parentNode.childNodes).indexOf(startNode);
                    startNode = startNode.parentNode;
                }
                if (endNode instanceof Element && endNode.tagName === 'BR') {
                    // @ts-expect-error Fix me later
                    endOffset = Array.from(endNode.parentNode.childNodes).indexOf(endNode);
                    endNode = endNode.parentNode;
                }
                const range = document.createRange();
                // @ts-expect-error Fix me later
                range.setStart(startNode, startOffset);
                // @ts-expect-error Fix me later
                range.setEnd(endNode, endOffset);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        } else {
            selection.removeAllRanges();
            this.root.blur();
        }
    }
    setRange(range) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $8AVGf.default).sources.API;
        if (typeof force === 'string') {
            source = force;
            force = false;
        }
        $6c4ec8d00dbc6ebd$var$debug.info('setRange', range);
        if (range != null) {
            const args = this.rangeToNative(range);
            this.setNativeRange(...args, force);
        } else this.setNativeRange(null);
        this.update(source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $8AVGf.default).sources.USER;
        const oldRange = this.lastRange;
        const [lastRange, nativeRange] = this.getRange();
        this.lastRange = lastRange;
        this.lastNative = nativeRange;
        if (this.lastRange != null) this.savedRange = this.lastRange;
        if (!(0, $f0tJx.default)(oldRange, this.lastRange)) {
            if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
                const range = this.cursor.restore();
                if (range) this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
            }
            const args = [
                (0, $8AVGf.default).events.SELECTION_CHANGE,
                (0, $hvQN0.default)(this.lastRange),
                (0, $hvQN0.default)(oldRange),
                source
            ];
            this.emitter.emit((0, $8AVGf.default).events.EDITOR_CHANGE, ...args);
            if (source !== (0, $8AVGf.default).sources.SILENT) this.emitter.emit(...args);
        }
    }
}
function $6c4ec8d00dbc6ebd$var$contains(parent, descendant) {
    try {
        // Firefox inserts inaccessible nodes around video elements
        descendant.parentNode; // eslint-disable-line @typescript-eslint/no-unused-expressions
    } catch (e) {
        return false;
    }
    return parent.contains(descendant);
}
var $6c4ec8d00dbc6ebd$export$2e2bcd8739ae039 = $6c4ec8d00dbc6ebd$var$Selection;

});
parcelRegister("8AVGf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $641e6dab607d6389$export$2e2bcd8739ae039; });

var $2Yi2U = parcelRequire("2Yi2U");

var $4apTj = parcelRequire("4apTj");

var $jzLjA = parcelRequire("jzLjA");
const $641e6dab607d6389$var$debug = (0, $jzLjA.default)('quill:events');
const $641e6dab607d6389$var$EVENTS = [
    'selectionchange',
    'mousedown',
    'mouseup',
    'click'
];
$641e6dab607d6389$var$EVENTS.forEach((eventName)=>{
    document.addEventListener(eventName, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        Array.from(document.querySelectorAll('.ql-container')).forEach((node)=>{
            const quill = (0, $4apTj.default).get(node);
            if (quill && quill.emitter) quill.emitter.handleDOM(...args);
        });
    });
});
class $641e6dab607d6389$var$Emitter extends (0, $2Yi2U.EventEmitter) {
    static events = {
        EDITOR_CHANGE: 'editor-change',
        SCROLL_BEFORE_UPDATE: 'scroll-before-update',
        SCROLL_BLOT_MOUNT: 'scroll-blot-mount',
        SCROLL_BLOT_UNMOUNT: 'scroll-blot-unmount',
        SCROLL_OPTIMIZE: 'scroll-optimize',
        SCROLL_UPDATE: 'scroll-update',
        SCROLL_EMBED_UPDATE: 'scroll-embed-update',
        SELECTION_CHANGE: 'selection-change',
        TEXT_CHANGE: 'text-change',
        COMPOSITION_BEFORE_START: 'composition-before-start',
        COMPOSITION_START: 'composition-start',
        COMPOSITION_BEFORE_END: 'composition-before-end',
        COMPOSITION_END: 'composition-end'
    };
    static sources = {
        API: 'api',
        SILENT: 'silent',
        USER: 'user'
    };
    constructor(){
        super();
        this.domListeners = {};
        this.on('error', $641e6dab607d6389$var$debug.error);
    }
    emit() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $641e6dab607d6389$var$debug.log.call($641e6dab607d6389$var$debug, ...args);
        // @ts-expect-error
        return super.emit(...args);
    }
    handleDOM(event) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        (this.domListeners[event.type] || []).forEach((_ref)=>{
            let { node: node, handler: handler } = _ref;
            if (event.target === node || node.contains(event.target)) handler(event, ...args);
        });
    }
    listenDOM(eventName, node, handler) {
        if (!this.domListeners[eventName]) this.domListeners[eventName] = [];
        this.domListeners[eventName].push({
            node: node,
            handler: handler
        });
    }
}
var $641e6dab607d6389$export$2e2bcd8739ae039 = $641e6dab607d6389$var$Emitter;

});
parcelRegister("2Yi2U", function(module, exports) {
'use strict';
var $229f2eebd014b793$var$has = Object.prototype.hasOwnProperty, $229f2eebd014b793$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $229f2eebd014b793$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $229f2eebd014b793$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $229f2eebd014b793$var$Events().__proto__) $229f2eebd014b793$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $229f2eebd014b793$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $229f2eebd014b793$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $229f2eebd014b793$var$EE(fn, context || emitter, once), evt = $229f2eebd014b793$var$prefix ? $229f2eebd014b793$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $229f2eebd014b793$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $229f2eebd014b793$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $229f2eebd014b793$var$EventEmitter() {
    this._events = new $229f2eebd014b793$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $229f2eebd014b793$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($229f2eebd014b793$var$has.call(events, name)) names.push($229f2eebd014b793$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $229f2eebd014b793$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $229f2eebd014b793$var$prefix ? $229f2eebd014b793$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $229f2eebd014b793$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $229f2eebd014b793$var$prefix ? $229f2eebd014b793$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $229f2eebd014b793$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $229f2eebd014b793$var$prefix ? $229f2eebd014b793$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $229f2eebd014b793$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $229f2eebd014b793$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $229f2eebd014b793$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $229f2eebd014b793$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $229f2eebd014b793$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $229f2eebd014b793$var$prefix ? $229f2eebd014b793$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $229f2eebd014b793$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $229f2eebd014b793$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $229f2eebd014b793$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $229f2eebd014b793$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $229f2eebd014b793$var$prefix ? $229f2eebd014b793$var$prefix + event : event;
        if (this._events[evt]) $229f2eebd014b793$var$clearEvent(this, evt);
    } else {
        this._events = new $229f2eebd014b793$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$229f2eebd014b793$var$EventEmitter.prototype.off = $229f2eebd014b793$var$EventEmitter.prototype.removeListener;
$229f2eebd014b793$var$EventEmitter.prototype.addListener = $229f2eebd014b793$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$229f2eebd014b793$var$EventEmitter.prefixed = $229f2eebd014b793$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$229f2eebd014b793$var$EventEmitter.EventEmitter = $229f2eebd014b793$var$EventEmitter;
module.exports = $229f2eebd014b793$var$EventEmitter;

});

parcelRegister("4apTj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $308c2e0ec0ae0374$export$2e2bcd8739ae039; });
var $308c2e0ec0ae0374$export$2e2bcd8739ae039 = new WeakMap();

});

parcelRegister("jzLjA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e405fcf54423d99f$export$2e2bcd8739ae039; });
const $e405fcf54423d99f$var$levels = [
    'error',
    'warn',
    'log',
    'info'
];
let $e405fcf54423d99f$var$level = 'warn';
function $e405fcf54423d99f$var$debug(method) {
    if ($e405fcf54423d99f$var$level) {
        if ($e405fcf54423d99f$var$levels.indexOf(method) <= $e405fcf54423d99f$var$levels.indexOf($e405fcf54423d99f$var$level)) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            console[method](...args); // eslint-disable-line no-console
        }
    }
}
function $e405fcf54423d99f$var$namespace(ns) {
    return $e405fcf54423d99f$var$levels.reduce((logger, method)=>{
        logger[method] = $e405fcf54423d99f$var$debug.bind(console, method, ns);
        return logger;
    }, {});
}
$e405fcf54423d99f$var$namespace.level = (newLevel)=>{
    $e405fcf54423d99f$var$level = newLevel;
};
$e405fcf54423d99f$var$debug.level = $e405fcf54423d99f$var$namespace.level;
var $e405fcf54423d99f$export$2e2bcd8739ae039 = $e405fcf54423d99f$var$namespace;

});




parcelRegister("cC34A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92eb6ae1e6f0114c$export$2e2bcd8739ae039; });
class $92eb6ae1e6f0114c$var$Module {
    static DEFAULTS = {};
    constructor(quill){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.quill = quill;
        this.options = options;
    }
}
var $92eb6ae1e6f0114c$export$2e2bcd8739ae039 = $92eb6ae1e6f0114c$var$Module;

});

parcelRegister("kYcHV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f44344acbad050cd$export$2e2bcd8739ae039; });

var $7ve13 = parcelRequire("7ve13");

var $8AVGf = parcelRequire("8AVGf");
class $f44344acbad050cd$var$Composition {
    isComposing = false;
    constructor(scroll, emitter){
        this.scroll = scroll;
        this.emitter = emitter;
        this.setupListeners();
    }
    setupListeners() {
        this.scroll.domNode.addEventListener('compositionstart', (event)=>{
            if (!this.isComposing) this.handleCompositionStart(event);
        });
        this.scroll.domNode.addEventListener('compositionend', (event)=>{
            if (this.isComposing) // Webkit makes DOM changes after compositionend, so we use microtask to
            // ensure the order.
            // https://bugs.webkit.org/show_bug.cgi?id=31902
            queueMicrotask(()=>{
                this.handleCompositionEnd(event);
            });
        });
    }
    handleCompositionStart(event) {
        const blot = event.target instanceof Node ? this.scroll.find(event.target, true) : null;
        if (blot && !(blot instanceof (0, $7ve13.default))) {
            this.emitter.emit((0, $8AVGf.default).events.COMPOSITION_BEFORE_START, event);
            this.scroll.batchStart();
            this.emitter.emit((0, $8AVGf.default).events.COMPOSITION_START, event);
            this.isComposing = true;
        }
    }
    handleCompositionEnd(event) {
        this.emitter.emit((0, $8AVGf.default).events.COMPOSITION_BEFORE_END, event);
        this.scroll.batchEnd();
        this.emitter.emit((0, $8AVGf.default).events.COMPOSITION_END, event);
        this.isComposing = false;
    }
}
var $f44344acbad050cd$export$2e2bcd8739ae039 = $f44344acbad050cd$var$Composition;

});
parcelRegister("7ve13", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57664cf12eff2b51$export$2e2bcd8739ae039; });

var $eYvg2 = parcelRequire("eYvg2");

var $fpYVL = parcelRequire("fpYVL");
const $57664cf12eff2b51$var$GUARD_TEXT = '\uFEFF';
class $57664cf12eff2b51$var$Embed extends (0, $eYvg2.EmbedBlot) {
    constructor(scroll, node){
        super(scroll, node);
        this.contentNode = document.createElement('span');
        this.contentNode.setAttribute('contenteditable', 'false');
        Array.from(this.domNode.childNodes).forEach((childNode)=>{
            this.contentNode.appendChild(childNode);
        });
        this.leftGuard = document.createTextNode($57664cf12eff2b51$var$GUARD_TEXT);
        this.rightGuard = document.createTextNode($57664cf12eff2b51$var$GUARD_TEXT);
        this.domNode.appendChild(this.leftGuard);
        this.domNode.appendChild(this.contentNode);
        this.domNode.appendChild(this.rightGuard);
    }
    index(node, offset) {
        if (node === this.leftGuard) return 0;
        if (node === this.rightGuard) return 1;
        return super.index(node, offset);
    }
    restore(node) {
        let range = null;
        let textNode;
        const text = node.data.split($57664cf12eff2b51$var$GUARD_TEXT).join('');
        if (node === this.leftGuard) {
            if (this.prev instanceof (0, $fpYVL.default)) {
                const prevLength = this.prev.length();
                this.prev.insertAt(prevLength, text);
                range = {
                    startNode: this.prev.domNode,
                    startOffset: prevLength + text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        } else if (node === this.rightGuard) {
            if (this.next instanceof (0, $fpYVL.default)) {
                this.next.insertAt(0, text);
                range = {
                    startNode: this.next.domNode,
                    startOffset: text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this.next);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        }
        node.data = $57664cf12eff2b51$var$GUARD_TEXT;
        return range;
    }
    update(mutations, context) {
        mutations.forEach((mutation)=>{
            if (mutation.type === 'characterData' && (mutation.target === this.leftGuard || mutation.target === this.rightGuard)) {
                const range = this.restore(mutation.target);
                if (range) context.range = range;
            }
        });
    }
}
var $57664cf12eff2b51$export$2e2bcd8739ae039 = $57664cf12eff2b51$var$Embed;

});


parcelRegister("8rmjg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $625226964b82f8de$export$2e2bcd8739ae039; });
class $625226964b82f8de$var$Theme {
    static DEFAULTS = {
        modules: {}
    };
    static themes = {
        default: $625226964b82f8de$var$Theme
    };
    modules = {};
    constructor(quill, options){
        this.quill = quill;
        this.options = options;
    }
    init() {
        Object.keys(this.options.modules).forEach((name)=>{
            if (this.modules[name] == null) this.addModule(name);
        });
    }
    addModule(name) {
        // @ts-expect-error
        const ModuleClass = this.quill.constructor.import(`modules/${name}`);
        this.modules[name] = new ModuleClass(this.quill, this.options.modules[name] || {});
        return this.modules[name];
    }
}
var $625226964b82f8de$export$2e2bcd8739ae039 = $625226964b82f8de$var$Theme;

});

parcelRegister("cEKJW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $936d7a124eb3200a$export$2e2bcd8739ae039; });
const $936d7a124eb3200a$var$getParentElement = (element)=>element.parentElement || element.getRootNode().host || null;
const $936d7a124eb3200a$var$getElementRect = (element)=>{
    const rect = element.getBoundingClientRect();
    const scaleX = 'offsetWidth' in element && Math.abs(rect.width) / element.offsetWidth || 1;
    const scaleY = 'offsetHeight' in element && Math.abs(rect.height) / element.offsetHeight || 1;
    return {
        top: rect.top,
        right: rect.left + element.clientWidth * scaleX,
        bottom: rect.top + element.clientHeight * scaleY,
        left: rect.left
    };
};
const $936d7a124eb3200a$var$paddingValueToInt = (value)=>{
    const number = parseInt(value, 10);
    return Number.isNaN(number) ? 0 : number;
};
// Follow the steps described in https://www.w3.org/TR/cssom-view-1/#element-scrolling-members,
// assuming that the scroll option is set to 'nearest'.
const $936d7a124eb3200a$var$getScrollDistance = (targetStart, targetEnd, scrollStart, scrollEnd, scrollPaddingStart, scrollPaddingEnd)=>{
    if (targetStart < scrollStart && targetEnd > scrollEnd) return 0;
    if (targetStart < scrollStart) return -(scrollStart - targetStart + scrollPaddingStart);
    if (targetEnd > scrollEnd) return targetEnd - targetStart > scrollEnd - scrollStart ? targetStart + scrollPaddingStart - scrollStart : targetEnd - scrollEnd + scrollPaddingEnd;
    return 0;
};
const $936d7a124eb3200a$var$scrollRectIntoView = (root, targetRect)=>{
    const document = root.ownerDocument;
    let rect = targetRect;
    let current = root;
    while(current){
        const isDocumentBody = current === document.body;
        const bounding = isDocumentBody ? {
            top: 0,
            right: window.visualViewport?.width ?? document.documentElement.clientWidth,
            bottom: window.visualViewport?.height ?? document.documentElement.clientHeight,
            left: 0
        } : $936d7a124eb3200a$var$getElementRect(current);
        const style = getComputedStyle(current);
        const scrollDistanceX = $936d7a124eb3200a$var$getScrollDistance(rect.left, rect.right, bounding.left, bounding.right, $936d7a124eb3200a$var$paddingValueToInt(style.scrollPaddingLeft), $936d7a124eb3200a$var$paddingValueToInt(style.scrollPaddingRight));
        const scrollDistanceY = $936d7a124eb3200a$var$getScrollDistance(rect.top, rect.bottom, bounding.top, bounding.bottom, $936d7a124eb3200a$var$paddingValueToInt(style.scrollPaddingTop), $936d7a124eb3200a$var$paddingValueToInt(style.scrollPaddingBottom));
        if (scrollDistanceX || scrollDistanceY) {
            if (isDocumentBody) document.defaultView?.scrollBy(scrollDistanceX, scrollDistanceY);
            else {
                const { scrollLeft: scrollLeft, scrollTop: scrollTop } = current;
                if (scrollDistanceY) current.scrollTop += scrollDistanceY;
                if (scrollDistanceX) current.scrollLeft += scrollDistanceX;
                const scrolledLeft = current.scrollLeft - scrollLeft;
                const scrolledTop = current.scrollTop - scrollTop;
                rect = {
                    left: rect.left - scrolledLeft,
                    top: rect.top - scrolledTop,
                    right: rect.right - scrolledLeft,
                    bottom: rect.bottom - scrolledTop
                };
            }
        }
        current = isDocumentBody || style.position === 'fixed' ? null : $936d7a124eb3200a$var$getParentElement(current);
    }
};
var $936d7a124eb3200a$export$2e2bcd8739ae039 = $936d7a124eb3200a$var$scrollRectIntoView;

});

parcelRegister("6Ef7U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d723651adcbcd3c$export$2e2bcd8739ae039; });

var $eYvg2 = parcelRequire("eYvg2");
const $4d723651adcbcd3c$var$MAX_REGISTER_ITERATIONS = 100;
const $4d723651adcbcd3c$var$CORE_FORMATS = [
    'block',
    'break',
    'cursor',
    'inline',
    'scroll',
    'text'
];
const $4d723651adcbcd3c$var$createRegistryWithFormats = (formats, sourceRegistry, debug)=>{
    const registry = new (0, $eYvg2.Registry)();
    $4d723651adcbcd3c$var$CORE_FORMATS.forEach((name)=>{
        const coreBlot = sourceRegistry.query(name);
        if (coreBlot) registry.register(coreBlot);
    });
    formats.forEach((name)=>{
        let format = sourceRegistry.query(name);
        if (!format) debug.error(`Cannot register "${name}" specified in "formats" config. Are you sure it was registered?`);
        let iterations = 0;
        while(format){
            registry.register(format);
            format = 'blotName' in format ? format.requiredContainer ?? null : null;
            iterations += 1;
            if (iterations > $4d723651adcbcd3c$var$MAX_REGISTER_ITERATIONS) {
                debug.error(`Cycle detected in registering blot requiredContainer: "${name}"`);
                break;
            }
        }
    });
    return registry;
};
var $4d723651adcbcd3c$export$2e2bcd8739ae039 = $4d723651adcbcd3c$var$createRegistryWithFormats;

});


parcelRegister("hrKTM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb3956651040aaea$export$2e2bcd8739ae039; });

var $eYvg2 = parcelRequire("eYvg2");
class $cb3956651040aaea$var$Container extends (0, $eYvg2.ContainerBlot) {
}
var $cb3956651040aaea$export$2e2bcd8739ae039 = $cb3956651040aaea$var$Container;

});

parcelRegister("dzdwt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e0908909a26a82c$export$2e2bcd8739ae039; });

var $eYvg2 = parcelRequire("eYvg2");

var $kHwOs = parcelRequire("kHwOs");

var $8AVGf = parcelRequire("8AVGf");

var $4UH9n = parcelRequire("4UH9n");

var $ekYWe = parcelRequire("ekYWe");

var $hrKTM = parcelRequire("hrKTM");
function $9e0908909a26a82c$var$isLine(blot) {
    return blot instanceof (0, $4UH9n.default) || blot instanceof (0, $4UH9n.BlockEmbed);
}
function $9e0908909a26a82c$var$isUpdatable(blot) {
    return typeof blot.updateContent === 'function';
}
class $9e0908909a26a82c$var$Scroll extends (0, $eYvg2.ScrollBlot) {
    static blotName = 'scroll';
    static className = 'ql-editor';
    static tagName = 'DIV';
    static defaultChild = (0, $4UH9n.default);
    static allowedChildren = [
        (0, $4UH9n.default),
        (0, $4UH9n.BlockEmbed),
        (0, $hrKTM.default)
    ];
    constructor(registry, domNode, _ref){
        let { emitter: emitter } = _ref;
        super(registry, domNode);
        this.emitter = emitter;
        this.batch = false;
        this.optimize();
        this.enable();
        this.domNode.addEventListener('dragstart', (e)=>this.handleDragStart(e));
    }
    batchStart() {
        if (!Array.isArray(this.batch)) this.batch = [];
    }
    batchEnd() {
        if (!this.batch) return;
        const mutations = this.batch;
        this.batch = false;
        this.update(mutations);
    }
    emitMount(blot) {
        this.emitter.emit((0, $8AVGf.default).events.SCROLL_BLOT_MOUNT, blot);
    }
    emitUnmount(blot) {
        this.emitter.emit((0, $8AVGf.default).events.SCROLL_BLOT_UNMOUNT, blot);
    }
    emitEmbedUpdate(blot, change) {
        this.emitter.emit((0, $8AVGf.default).events.SCROLL_EMBED_UPDATE, blot, change);
    }
    deleteAt(index, length) {
        const [first, offset] = this.line(index);
        const [last] = this.line(index + length);
        super.deleteAt(index, length);
        if (last != null && first !== last && offset > 0) {
            if (first instanceof (0, $4UH9n.BlockEmbed) || last instanceof (0, $4UH9n.BlockEmbed)) {
                this.optimize();
                return;
            }
            const ref = last.children.head instanceof (0, $ekYWe.default) ? null : last.children.head;
            // @ts-expect-error
            first.moveChildren(last, ref);
            // @ts-expect-error
            first.remove();
        }
        this.optimize();
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.domNode.setAttribute('contenteditable', enabled ? 'true' : 'false');
    }
    formatAt(index, length, format, value) {
        super.formatAt(index, length, format, value);
        this.optimize();
    }
    insertAt(index, value, def) {
        if (index >= this.length()) {
            if (def == null || this.scroll.query(value, (0, $eYvg2.Scope).BLOCK) == null) {
                const blot = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(blot);
                if (def == null && value.endsWith('\n')) blot.insertAt(0, value.slice(0, -1), def);
                else blot.insertAt(0, value, def);
            } else {
                const embed = this.scroll.create(value, def);
                this.appendChild(embed);
            }
        } else super.insertAt(index, value, def);
        this.optimize();
    }
    insertBefore(blot, ref) {
        if (blot.statics.scope === (0, $eYvg2.Scope).INLINE_BLOT) {
            const wrapper = this.scroll.create(this.statics.defaultChild.blotName);
            wrapper.appendChild(blot);
            super.insertBefore(wrapper, ref);
        } else super.insertBefore(blot, ref);
    }
    insertContents(index, delta) {
        const renderBlocks = this.deltaToRenderBlocks(delta.concat(new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().insert('\n')));
        const last = renderBlocks.pop();
        if (last == null) return;
        this.batchStart();
        const first = renderBlocks.shift();
        if (first) {
            const shouldInsertNewlineChar = first.type === 'block' && (first.delta.length() === 0 || !this.descendant((0, $4UH9n.BlockEmbed), index)[0] && index < this.length());
            const delta = first.type === 'block' ? first.delta : new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().insert({
                [first.key]: first.value
            });
            $9e0908909a26a82c$var$insertInlineContents(this, index, delta);
            const newlineCharLength = first.type === 'block' ? 1 : 0;
            const lineEndIndex = index + delta.length() + newlineCharLength;
            if (shouldInsertNewlineChar) this.insertAt(lineEndIndex - 1, '\n');
            const formats = (0, $4UH9n.bubbleFormats)(this.line(index)[0]);
            const attributes = (0, $kHwOs.AttributeMap).diff(formats, first.attributes) || {};
            Object.keys(attributes).forEach((name)=>{
                this.formatAt(lineEndIndex - 1, 1, name, attributes[name]);
            });
            index = lineEndIndex;
        }
        let [refBlot, refBlotOffset] = this.children.find(index);
        if (renderBlocks.length) {
            if (refBlot) {
                refBlot = refBlot.split(refBlotOffset);
                refBlotOffset = 0;
            }
            renderBlocks.forEach((renderBlock)=>{
                if (renderBlock.type === 'block') {
                    const block = this.createBlock(renderBlock.attributes, refBlot || undefined);
                    $9e0908909a26a82c$var$insertInlineContents(block, 0, renderBlock.delta);
                } else {
                    const blockEmbed = this.create(renderBlock.key, renderBlock.value);
                    this.insertBefore(blockEmbed, refBlot || undefined);
                    Object.keys(renderBlock.attributes).forEach((name)=>{
                        blockEmbed.format(name, renderBlock.attributes[name]);
                    });
                }
            });
        }
        if (last.type === 'block' && last.delta.length()) {
            const offset = refBlot ? refBlot.offset(refBlot.scroll) + refBlotOffset : this.length();
            $9e0908909a26a82c$var$insertInlineContents(this, offset, last.delta);
        }
        this.batchEnd();
        this.optimize();
    }
    isEnabled() {
        return this.domNode.getAttribute('contenteditable') === 'true';
    }
    leaf(index) {
        const last = this.path(index).pop();
        if (!last) return [
            null,
            -1
        ];
        const [blot, offset] = last;
        return blot instanceof (0, $eYvg2.LeafBlot) ? [
            blot,
            offset
        ] : [
            null,
            -1
        ];
    }
    line(index) {
        if (index === this.length()) return this.line(index - 1);
        // @ts-expect-error TODO: make descendant() generic
        return this.descendant($9e0908909a26a82c$var$isLine, index);
    }
    lines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        const getLines = (blot, blotIndex, blotLength)=>{
            let lines = [];
            let lengthLeft = blotLength;
            blot.children.forEachAt(blotIndex, blotLength, (child, childIndex, childLength)=>{
                if ($9e0908909a26a82c$var$isLine(child)) lines.push(child);
                else if (child instanceof (0, $eYvg2.ContainerBlot)) lines = lines.concat(getLines(child, childIndex, lengthLeft));
                lengthLeft -= childLength;
            });
            return lines;
        };
        return getLines(this, index, length);
    }
    optimize() {
        let mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.batch) return;
        super.optimize(mutations, context);
        if (mutations.length > 0) this.emitter.emit((0, $8AVGf.default).events.SCROLL_OPTIMIZE, mutations, context);
    }
    path(index) {
        return super.path(index).slice(1); // Exclude self
    }
    remove() {
    // Never remove self
    }
    update(mutations) {
        if (this.batch) {
            if (Array.isArray(mutations)) this.batch = this.batch.concat(mutations);
            return;
        }
        let source = (0, $8AVGf.default).sources.USER;
        if (typeof mutations === 'string') source = mutations;
        if (!Array.isArray(mutations)) mutations = this.observer.takeRecords();
        mutations = mutations.filter((_ref2)=>{
            let { target: target } = _ref2;
            const blot = this.find(target, true);
            return blot && !$9e0908909a26a82c$var$isUpdatable(blot);
        });
        if (mutations.length > 0) this.emitter.emit((0, $8AVGf.default).events.SCROLL_BEFORE_UPDATE, source, mutations);
        super.update(mutations.concat([])); // pass copy
        if (mutations.length > 0) this.emitter.emit((0, $8AVGf.default).events.SCROLL_UPDATE, source, mutations);
    }
    updateEmbedAt(index, key, change) {
        // Currently it only supports top-level embeds (BlockEmbed).
        // We can update `ParentBlot` in parchment to support inline embeds.
        const [blot] = this.descendant((b)=>b instanceof (0, $4UH9n.BlockEmbed), index);
        if (blot && blot.statics.blotName === key && $9e0908909a26a82c$var$isUpdatable(blot)) blot.updateContent(change);
    }
    handleDragStart(event) {
        event.preventDefault();
    }
    deltaToRenderBlocks(delta) {
        const renderBlocks = [];
        let currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))();
        delta.forEach((op)=>{
            const insert = op?.insert;
            if (!insert) return;
            if (typeof insert === 'string') {
                const splitted = insert.split('\n');
                splitted.slice(0, -1).forEach((text)=>{
                    currentBlockDelta.insert(text, op.attributes);
                    renderBlocks.push({
                        type: 'block',
                        delta: currentBlockDelta,
                        attributes: op.attributes ?? {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))();
                });
                const last = splitted[splitted.length - 1];
                if (last) currentBlockDelta.insert(last, op.attributes);
            } else {
                const key = Object.keys(insert)[0];
                if (!key) return;
                if (this.query(key, (0, $eYvg2.Scope).INLINE)) currentBlockDelta.push(op);
                else {
                    if (currentBlockDelta.length()) renderBlocks.push({
                        type: 'block',
                        delta: currentBlockDelta,
                        attributes: {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))();
                    renderBlocks.push({
                        type: 'blockEmbed',
                        key: key,
                        value: insert[key],
                        attributes: op.attributes ?? {}
                    });
                }
            }
        });
        if (currentBlockDelta.length()) renderBlocks.push({
            type: 'block',
            delta: currentBlockDelta,
            attributes: {}
        });
        return renderBlocks;
    }
    createBlock(attributes, refBlot) {
        let blotName;
        const formats = {};
        Object.entries(attributes).forEach((_ref3)=>{
            let [key, value] = _ref3;
            const isBlockBlot = this.query(key, (0, $eYvg2.Scope).BLOCK & (0, $eYvg2.Scope).BLOT) != null;
            if (isBlockBlot) blotName = key;
            else formats[key] = value;
        });
        const block = this.create(blotName || this.statics.defaultChild.blotName, blotName ? attributes[blotName] : undefined);
        this.insertBefore(block, refBlot || undefined);
        const length = block.length();
        Object.entries(formats).forEach((_ref4)=>{
            let [key, value] = _ref4;
            block.formatAt(0, length, key, value);
        });
        return block;
    }
}
function $9e0908909a26a82c$var$insertInlineContents(parent, index, inlineContents) {
    inlineContents.reduce((index, op)=>{
        const length = (0, $kHwOs.Op).length(op);
        let attributes = op.attributes || {};
        if (op.insert != null) {
            if (typeof op.insert === 'string') {
                const text = op.insert;
                parent.insertAt(index, text);
                const [leaf] = parent.descendant((0, $eYvg2.LeafBlot), index);
                const formats = (0, $4UH9n.bubbleFormats)(leaf);
                attributes = (0, $kHwOs.AttributeMap).diff(formats, attributes) || {};
            } else if (typeof op.insert === 'object') {
                const key = Object.keys(op.insert)[0]; // There should only be one key
                if (key == null) return index;
                parent.insertAt(index, key, op.insert[key]);
                const isInlineEmbed = parent.scroll.query(key, (0, $eYvg2.Scope).INLINE) != null;
                if (isInlineEmbed) {
                    const [leaf] = parent.descendant((0, $eYvg2.LeafBlot), index);
                    const formats = (0, $4UH9n.bubbleFormats)(leaf);
                    attributes = (0, $kHwOs.AttributeMap).diff(formats, attributes) || {};
                }
            }
        }
        Object.keys(attributes).forEach((key)=>{
            parent.formatAt(index, length, key, attributes[key]);
        });
        return index + length;
    }, index);
}
var $9e0908909a26a82c$export$2e2bcd8739ae039 = $9e0908909a26a82c$var$Scroll;

});

parcelRegister("63ASE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $468fa191268ee681$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "traverse", function () { return $468fa191268ee681$export$df3f009e3d155b20; });

var $eYvg2 = parcelRequire("eYvg2");

var $kHwOs = parcelRequire("kHwOs");

var $4UH9n = parcelRequire("4UH9n");

var $jzLjA = parcelRequire("jzLjA");

var $cC34A = parcelRequire("cC34A");

var $5ubWu = parcelRequire("5ubWu");

var $9wiPO = parcelRequire("9wiPO");

var $7qATu = parcelRequire("7qATu");

var $hRRcn = parcelRequire("hRRcn");

var $jdVXS = parcelRequire("jdVXS");

var $evomV = parcelRequire("evomV");

var $b90he = parcelRequire("b90he");

var $anVd6 = parcelRequire("anVd6");

var $8c4Uv = parcelRequire("8c4Uv");

var $7VpBT = parcelRequire("7VpBT");
const $468fa191268ee681$var$debug = (0, $jzLjA.default)('quill:clipboard');
const $468fa191268ee681$var$CLIPBOARD_CONFIG = [
    [
        Node.TEXT_NODE,
        $468fa191268ee681$export$9b884371b5570711
    ],
    [
        Node.TEXT_NODE,
        $468fa191268ee681$export$c695b9637111f586
    ],
    [
        'br',
        $468fa191268ee681$var$matchBreak
    ],
    [
        Node.ELEMENT_NODE,
        $468fa191268ee681$export$c695b9637111f586
    ],
    [
        Node.ELEMENT_NODE,
        $468fa191268ee681$export$e9719de873a22c03
    ],
    [
        Node.ELEMENT_NODE,
        $468fa191268ee681$export$7da59a717dc94488
    ],
    [
        Node.ELEMENT_NODE,
        $468fa191268ee681$var$matchStyles
    ],
    [
        'li',
        $468fa191268ee681$var$matchIndent
    ],
    [
        'ol, ul',
        $468fa191268ee681$var$matchList
    ],
    [
        'pre',
        $468fa191268ee681$var$matchCodeBlock
    ],
    [
        'tr',
        $468fa191268ee681$var$matchTable
    ],
    [
        'b',
        $468fa191268ee681$var$createMatchAlias('bold')
    ],
    [
        'i',
        $468fa191268ee681$var$createMatchAlias('italic')
    ],
    [
        'strike',
        $468fa191268ee681$var$createMatchAlias('strike')
    ],
    [
        'style',
        $468fa191268ee681$var$matchIgnore
    ]
];
const $468fa191268ee681$var$ATTRIBUTE_ATTRIBUTORS = [
    (0, $9wiPO.AlignAttribute),
    (0, $evomV.DirectionAttribute)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
const $468fa191268ee681$var$STYLE_ATTRIBUTORS = [
    (0, $9wiPO.AlignStyle),
    (0, $7qATu.BackgroundStyle),
    (0, $jdVXS.ColorStyle),
    (0, $evomV.DirectionStyle),
    (0, $b90he.FontStyle),
    (0, $anVd6.SizeStyle)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
class $468fa191268ee681$export$2e2bcd8739ae039 extends (0, $cC34A.default) {
    static DEFAULTS = {
        matchers: []
    };
    constructor(quill, options){
        super(quill, options);
        this.quill.root.addEventListener('copy', (e)=>this.onCaptureCopy(e, false));
        this.quill.root.addEventListener('cut', (e)=>this.onCaptureCopy(e, true));
        this.quill.root.addEventListener('paste', this.onCapturePaste.bind(this));
        this.matchers = [];
        $468fa191268ee681$var$CLIPBOARD_CONFIG.concat(this.options.matchers ?? []).forEach((_ref)=>{
            let [selector, matcher] = _ref;
            this.addMatcher(selector, matcher);
        });
    }
    addMatcher(selector, matcher) {
        this.matchers.push([
            selector,
            matcher
        ]);
    }
    convert(_ref2) {
        let { html: html, text: text } = _ref2;
        let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (formats[(0, $hRRcn.default).blotName]) return new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().insert(text || '', {
            [(0, $hRRcn.default).blotName]: formats[(0, $hRRcn.default).blotName]
        });
        if (!html) return new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().insert(text || '', formats);
        const delta = this.convertHTML(html);
        // Remove trailing newline
        if ($468fa191268ee681$var$deltaEndsWith(delta, '\n') && (delta.ops[delta.ops.length - 1].attributes == null || formats.table)) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(delta.length() - 1).delete(1));
        return delta;
    }
    normalizeHTML(doc) {
        (0, $7VpBT.default)(doc);
    }
    convertHTML(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        this.normalizeHTML(doc);
        const container = doc.body;
        const nodeMatches = new WeakMap();
        const [elementMatchers, textMatchers] = this.prepareMatching(container, nodeMatches);
        return $468fa191268ee681$export$df3f009e3d155b20(this.quill.scroll, container, elementMatchers, textMatchers, nodeMatches);
    }
    dangerouslyPasteHTML(index, html) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $5ubWu.default).sources.API;
        if (typeof index === 'string') {
            const delta = this.convert({
                html: index,
                text: ''
            });
            // @ts-expect-error
            this.quill.setContents(delta, html);
            this.quill.setSelection(0, (0, $5ubWu.default).sources.SILENT);
        } else {
            const paste = this.convert({
                html: html,
                text: ''
            });
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(index).concat(paste), source);
            this.quill.setSelection(index + paste.length(), (0, $5ubWu.default).sources.SILENT);
        }
    }
    onCaptureCopy(e) {
        let isCut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (e.defaultPrevented) return;
        e.preventDefault();
        const [range] = this.quill.selection.getRange();
        if (range == null) return;
        const { html: html, text: text } = this.onCopy(range, isCut);
        e.clipboardData?.setData('text/plain', text);
        e.clipboardData?.setData('text/html', html);
        if (isCut) (0, $8c4Uv.deleteRange)({
            range: range,
            quill: this.quill
        });
    }
    /*
   * https://www.iana.org/assignments/media-types/text/uri-list
   */ normalizeURIList(urlList) {
        return urlList.split(/\r?\n/)// Ignore all comments
        .filter((url)=>url[0] !== '#').join('\n');
    }
    onCapturePaste(e) {
        if (e.defaultPrevented || !this.quill.isEnabled()) return;
        e.preventDefault();
        const range = this.quill.getSelection(true);
        if (range == null) return;
        const html = e.clipboardData?.getData('text/html');
        let text = e.clipboardData?.getData('text/plain');
        if (!html && !text) {
            const urlList = e.clipboardData?.getData('text/uri-list');
            if (urlList) text = this.normalizeURIList(urlList);
        }
        const files = Array.from(e.clipboardData?.files || []);
        if (!html && files.length > 0) {
            this.quill.uploader.upload(range, files);
            return;
        }
        if (html && files.length > 0) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            if (doc.body.childElementCount === 1 && doc.body.firstElementChild?.tagName === 'IMG') {
                this.quill.uploader.upload(range, files);
                return;
            }
        }
        this.onPaste(range, {
            html: html,
            text: text
        });
    }
    onCopy(range) {
        const text = this.quill.getText(range);
        const html = this.quill.getSemanticHTML(range);
        return {
            html: html,
            text: text
        };
    }
    onPaste(range, _ref3) {
        let { text: text, html: html } = _ref3;
        const formats = this.quill.getFormat(range.index);
        const pastedDelta = this.convert({
            text: text,
            html: html
        }, formats);
        $468fa191268ee681$var$debug.log('onPaste', pastedDelta, {
            text: text,
            html: html
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(range.index).delete(range.length).concat(pastedDelta);
        this.quill.updateContents(delta, (0, $5ubWu.default).sources.USER);
        // range.length contributes to delta.length()
        this.quill.setSelection(delta.length() - range.length, (0, $5ubWu.default).sources.SILENT);
        this.quill.scrollSelectionIntoView();
    }
    prepareMatching(container, nodeMatches) {
        const elementMatchers = [];
        const textMatchers = [];
        this.matchers.forEach((pair)=>{
            const [selector, matcher] = pair;
            switch(selector){
                case Node.TEXT_NODE:
                    textMatchers.push(matcher);
                    break;
                case Node.ELEMENT_NODE:
                    elementMatchers.push(matcher);
                    break;
                default:
                    Array.from(container.querySelectorAll(selector)).forEach((node)=>{
                        if (nodeMatches.has(node)) {
                            const matches = nodeMatches.get(node);
                            matches?.push(matcher);
                        } else nodeMatches.set(node, [
                            matcher
                        ]);
                    });
                    break;
            }
        });
        return [
            elementMatchers,
            textMatchers
        ];
    }
}
function $468fa191268ee681$var$applyFormat(delta, format, value, scroll) {
    if (!scroll.query(format)) return delta;
    return delta.reduce((newDelta, op)=>{
        if (!op.insert) return newDelta;
        if (op.attributes && op.attributes[format]) return newDelta.push(op);
        const formats = value ? {
            [format]: value
        } : {};
        return newDelta.insert(op.insert, {
            ...formats,
            ...op.attributes
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))());
}
function $468fa191268ee681$var$deltaEndsWith(delta, text) {
    let endText = '';
    for(let i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i // eslint-disable-line no-plusplus
    ){
        const op = delta.ops[i];
        if (typeof op.insert !== 'string') break;
        endText = op.insert + endText;
    }
    return endText.slice(-1 * text.length) === text;
}
function $468fa191268ee681$var$isLine(node, scroll) {
    if (!(node instanceof Element)) return false;
    const match = scroll.query(node);
    // @ts-expect-error
    if (match && match.prototype instanceof (0, $eYvg2.EmbedBlot)) return false;
    return [
        'address',
        'article',
        'blockquote',
        'canvas',
        'dd',
        'div',
        'dl',
        'dt',
        'fieldset',
        'figcaption',
        'figure',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'header',
        'iframe',
        'li',
        'main',
        'nav',
        'ol',
        'output',
        'p',
        'pre',
        'section',
        'table',
        'td',
        'tr',
        'ul',
        'video'
    ].includes(node.tagName.toLowerCase());
}
function $468fa191268ee681$var$isBetweenInlineElements(node, scroll) {
    return node.previousElementSibling && node.nextElementSibling && !$468fa191268ee681$var$isLine(node.previousElementSibling, scroll) && !$468fa191268ee681$var$isLine(node.nextElementSibling, scroll);
}
const $468fa191268ee681$var$preNodes = new WeakMap();
function $468fa191268ee681$var$isPre(node) {
    if (node == null) return false;
    if (!$468fa191268ee681$var$preNodes.has(node)) {
        // @ts-expect-error
        if (node.tagName === 'PRE') $468fa191268ee681$var$preNodes.set(node, true);
        else $468fa191268ee681$var$preNodes.set(node, $468fa191268ee681$var$isPre(node.parentNode));
    }
    return $468fa191268ee681$var$preNodes.get(node);
}
function $468fa191268ee681$export$df3f009e3d155b20(scroll, node, elementMatchers, textMatchers, nodeMatches) {
    // Post-order
    if (node.nodeType === node.TEXT_NODE) return textMatchers.reduce((delta, matcher)=>{
        return matcher(node, delta, scroll);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))());
    if (node.nodeType === node.ELEMENT_NODE) return Array.from(node.childNodes || []).reduce((delta, childNode)=>{
        let childrenDelta = $468fa191268ee681$export$df3f009e3d155b20(scroll, childNode, elementMatchers, textMatchers, nodeMatches);
        if (childNode.nodeType === node.ELEMENT_NODE) {
            childrenDelta = elementMatchers.reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
            childrenDelta = (nodeMatches.get(childNode) || []).reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
        }
        return delta.concat(childrenDelta);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))());
    return new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))();
}
function $468fa191268ee681$var$createMatchAlias(format) {
    return (_node, delta, scroll)=>{
        return $468fa191268ee681$var$applyFormat(delta, format, true, scroll);
    };
}
function $468fa191268ee681$export$7da59a717dc94488(node, delta, scroll) {
    const attributes = (0, $eYvg2.Attributor).keys(node);
    const classes = (0, $eYvg2.ClassAttributor).keys(node);
    const styles = (0, $eYvg2.StyleAttributor).keys(node);
    const formats = {};
    attributes.concat(classes).concat(styles).forEach((name)=>{
        let attr = scroll.query(name, (0, $eYvg2.Scope).ATTRIBUTE);
        if (attr != null) {
            formats[attr.attrName] = attr.value(node);
            if (formats[attr.attrName]) return;
        }
        attr = $468fa191268ee681$var$ATTRIBUTE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) formats[attr.attrName] = attr.value(node) || undefined;
        attr = $468fa191268ee681$var$STYLE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) {
            attr = $468fa191268ee681$var$STYLE_ATTRIBUTORS[name];
            formats[attr.attrName] = attr.value(node) || undefined;
        }
    });
    return Object.entries(formats).reduce((newDelta, _ref4)=>{
        let [name, value] = _ref4;
        return $468fa191268ee681$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
}
function $468fa191268ee681$export$e9719de873a22c03(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null) return delta;
    // @ts-expect-error
    if (match.prototype instanceof (0, $eYvg2.EmbedBlot)) {
        const embed = {};
        // @ts-expect-error
        const value = match.value(node);
        if (value != null) {
            // @ts-expect-error
            embed[match.blotName] = value;
            // @ts-expect-error
            return new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().insert(embed, match.formats(node, scroll));
        }
    } else {
        // @ts-expect-error
        if (match.prototype instanceof (0, $eYvg2.BlockBlot) && !$468fa191268ee681$var$deltaEndsWith(delta, '\n')) delta.insert('\n');
        if ('blotName' in match && 'formats' in match && typeof match.formats === 'function') return $468fa191268ee681$var$applyFormat(delta, match.blotName, match.formats(node, scroll), scroll);
    }
    return delta;
}
function $468fa191268ee681$var$matchBreak(node, delta) {
    if (!$468fa191268ee681$var$deltaEndsWith(delta, '\n')) delta.insert('\n');
    return delta;
}
function $468fa191268ee681$var$matchCodeBlock(node, delta, scroll) {
    const match = scroll.query('code-block');
    const language = match && 'formats' in match && typeof match.formats === 'function' ? match.formats(node, scroll) : true;
    return $468fa191268ee681$var$applyFormat(delta, 'code-block', language, scroll);
}
function $468fa191268ee681$var$matchIgnore() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))();
}
function $468fa191268ee681$var$matchIndent(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null || // @ts-expect-error
    match.blotName !== 'list' || !$468fa191268ee681$var$deltaEndsWith(delta, '\n')) return delta;
    let indent = -1;
    let parent = node.parentNode;
    while(parent != null){
        // @ts-expect-error
        if ([
            'OL',
            'UL'
        ].includes(parent.tagName)) indent += 1;
        parent = parent.parentNode;
    }
    if (indent <= 0) return delta;
    return delta.reduce((composed, op)=>{
        if (!op.insert) return composed;
        if (op.attributes && typeof op.attributes.indent === 'number') return composed.push(op);
        return composed.insert(op.insert, {
            indent: indent,
            ...op.attributes || {}
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))());
}
function $468fa191268ee681$var$matchList(node, delta, scroll) {
    const element = node;
    let list = element.tagName === 'OL' ? 'ordered' : 'bullet';
    const checkedAttr = element.getAttribute('data-checked');
    if (checkedAttr) list = checkedAttr === 'true' ? 'checked' : 'unchecked';
    return $468fa191268ee681$var$applyFormat(delta, 'list', list, scroll);
}
function $468fa191268ee681$export$c695b9637111f586(node, delta, scroll) {
    if (!$468fa191268ee681$var$deltaEndsWith(delta, '\n')) {
        if ($468fa191268ee681$var$isLine(node, scroll) && (node.childNodes.length > 0 || node instanceof HTMLParagraphElement)) return delta.insert('\n');
        if (delta.length() > 0 && node.nextSibling) {
            let nextSibling = node.nextSibling;
            while(nextSibling != null){
                if ($468fa191268ee681$var$isLine(nextSibling, scroll)) return delta.insert('\n');
                const match = scroll.query(nextSibling);
                // @ts-expect-error
                if (match && match.prototype instanceof (0, $4UH9n.BlockEmbed)) return delta.insert('\n');
                nextSibling = nextSibling.firstChild;
            }
        }
    }
    return delta;
}
function $468fa191268ee681$var$matchStyles(node, delta, scroll) {
    const formats = {};
    const style = node.style || {};
    if (style.fontStyle === 'italic') formats.italic = true;
    if (style.textDecoration === 'underline') formats.underline = true;
    if (style.textDecoration === 'line-through') formats.strike = true;
    if (style.fontWeight?.startsWith('bold') || // @ts-expect-error Fix me later
    parseInt(style.fontWeight, 10) >= 700) formats.bold = true;
    delta = Object.entries(formats).reduce((newDelta, _ref5)=>{
        let [name, value] = _ref5;
        return $468fa191268ee681$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
    // @ts-expect-error
    if (parseFloat(style.textIndent || 0) > 0) // Could be 0.5in
    return new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().insert('\t').concat(delta);
    return delta;
}
function $468fa191268ee681$var$matchTable(node, delta, scroll) {
    const table = node.parentElement?.tagName === 'TABLE' ? node.parentElement : node.parentElement?.parentElement;
    if (table != null) {
        const rows = Array.from(table.querySelectorAll('tr'));
        const row = rows.indexOf(node) + 1;
        return $468fa191268ee681$var$applyFormat(delta, 'table', row, scroll);
    }
    return delta;
}
function $468fa191268ee681$export$9b884371b5570711(node, delta, scroll) {
    // @ts-expect-error
    let text = node.data;
    // Word represents empty line with <o:p>&nbsp;</o:p>
    if (node.parentElement?.tagName === 'O:P') return delta.insert(text.trim());
    if (!$468fa191268ee681$var$isPre(node)) {
        if (text.trim().length === 0 && text.includes('\n') && !$468fa191268ee681$var$isBetweenInlineElements(node, scroll)) return delta;
        // convert all non-nbsp whitespace into regular space
        text = text.replace(/[^\S\u00a0]/g, ' ');
        // collapse consecutive spaces into one
        text = text.replace(/ {2,}/g, ' ');
        if (node.previousSibling == null && node.parentElement != null && $468fa191268ee681$var$isLine(node.parentElement, scroll) || node.previousSibling instanceof Element && $468fa191268ee681$var$isLine(node.previousSibling, scroll)) // block structure means we don't need leading space
        text = text.replace(/^ /, '');
        if (node.nextSibling == null && node.parentElement != null && $468fa191268ee681$var$isLine(node.parentElement, scroll) || node.nextSibling instanceof Element && $468fa191268ee681$var$isLine(node.nextSibling, scroll)) // block structure means we don't need trailing space
        text = text.replace(/ $/, '');
        // done removing whitespace and can normalize all to regular space
        text = text.replaceAll('\u00a0', ' ');
    }
    return delta.insert(text);
}

});
parcelRegister("9wiPO", function(module, exports) {

$parcel$export(module.exports, "AlignAttribute", function () { return $6ee5b6605a44e3d1$export$2ef0f9fb04a51388; });
$parcel$export(module.exports, "AlignClass", function () { return $6ee5b6605a44e3d1$export$7f3685f5846c07da; });
$parcel$export(module.exports, "AlignStyle", function () { return $6ee5b6605a44e3d1$export$d2060f5d114c9fe8; });

var $eYvg2 = parcelRequire("eYvg2");
const $6ee5b6605a44e3d1$var$config = {
    scope: (0, $eYvg2.Scope).BLOCK,
    whitelist: [
        'right',
        'center',
        'justify'
    ]
};
const $6ee5b6605a44e3d1$export$2ef0f9fb04a51388 = new (0, $eYvg2.Attributor)('align', 'align', $6ee5b6605a44e3d1$var$config);
const $6ee5b6605a44e3d1$export$7f3685f5846c07da = new (0, $eYvg2.ClassAttributor)('align', 'ql-align', $6ee5b6605a44e3d1$var$config);
const $6ee5b6605a44e3d1$export$d2060f5d114c9fe8 = new (0, $eYvg2.StyleAttributor)('align', 'text-align', $6ee5b6605a44e3d1$var$config);

});

parcelRegister("7qATu", function(module, exports) {

$parcel$export(module.exports, "BackgroundClass", function () { return $56879477c83f4d84$export$8aa96c8963152b12; });
$parcel$export(module.exports, "BackgroundStyle", function () { return $56879477c83f4d84$export$dc1cbcab4c682ef; });

var $eYvg2 = parcelRequire("eYvg2");

var $jdVXS = parcelRequire("jdVXS");
const $56879477c83f4d84$export$8aa96c8963152b12 = new (0, $eYvg2.ClassAttributor)('background', 'ql-bg', {
    scope: (0, $eYvg2.Scope).INLINE
});
const $56879477c83f4d84$export$dc1cbcab4c682ef = new (0, $jdVXS.ColorAttributor)('background', 'background-color', {
    scope: (0, $eYvg2.Scope).INLINE
});

});
parcelRegister("jdVXS", function(module, exports) {

$parcel$export(module.exports, "ColorAttributor", function () { return $039c9572d5e8d45f$export$c992e3369f248f6e; });
$parcel$export(module.exports, "ColorClass", function () { return $039c9572d5e8d45f$export$42795dcf0ec6f3c8; });
$parcel$export(module.exports, "ColorStyle", function () { return $039c9572d5e8d45f$export$1415f56796d9a5a9; });

var $eYvg2 = parcelRequire("eYvg2");
class $039c9572d5e8d45f$export$c992e3369f248f6e extends (0, $eYvg2.StyleAttributor) {
    value(domNode) {
        let value = super.value(domNode);
        if (!value.startsWith('rgb(')) return value;
        value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
        const hex = value.split(',').map((component)=>`00${parseInt(component, 10).toString(16)}`.slice(-2)).join('');
        return `#${hex}`;
    }
}
const $039c9572d5e8d45f$export$42795dcf0ec6f3c8 = new (0, $eYvg2.ClassAttributor)('color', 'ql-color', {
    scope: (0, $eYvg2.Scope).INLINE
});
const $039c9572d5e8d45f$export$1415f56796d9a5a9 = new $039c9572d5e8d45f$export$c992e3369f248f6e('color', 'color', {
    scope: (0, $eYvg2.Scope).INLINE
});

});


parcelRegister("hRRcn", function(module, exports) {

$parcel$export(module.exports, "CodeBlockContainer", function () { return $d020a709e3f324de$export$3b131632d3d15165; });
$parcel$export(module.exports, "default", function () { return $d020a709e3f324de$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Code", function () { return $d020a709e3f324de$export$52f0f02147b12c03; });

var $4UH9n = parcelRequire("4UH9n");

var $ekYWe = parcelRequire("ekYWe");

var $4lEvv = parcelRequire("4lEvv");

var $4Xyhi = parcelRequire("4Xyhi");

var $fpYVL = parcelRequire("fpYVL");

var $hrKTM = parcelRequire("hrKTM");

var $5ubWu = parcelRequire("5ubWu");
class $d020a709e3f324de$export$3b131632d3d15165 extends (0, $hrKTM.default) {
    static create(value) {
        const domNode = super.create(value);
        domNode.setAttribute('spellcheck', 'false');
        return domNode;
    }
    code(index, length) {
        return this.children// @ts-expect-error
        .map((child)=>child.length() <= 1 ? '' : child.domNode.innerText).join('\n').slice(index, index + length);
    }
    html(index, length) {
        // `\n`s are needed in order to support empty lines at the beginning and the end.
        // https://html.spec.whatwg.org/multipage/syntax.html#element-restrictions
        return `<pre>\n${(0, $fpYVL.escapeText)(this.code(index, length))}\n</pre>`;
    }
}
class $d020a709e3f324de$export$2e2bcd8739ae039 extends (0, $4UH9n.default) {
    static TAB = '  ';
    static register() {
        (0, $5ubWu.default).register($d020a709e3f324de$export$3b131632d3d15165);
    }
}
class $d020a709e3f324de$export$52f0f02147b12c03 extends (0, $4Xyhi.default) {
}
$d020a709e3f324de$export$52f0f02147b12c03.blotName = 'code';
$d020a709e3f324de$export$52f0f02147b12c03.tagName = 'CODE';
$d020a709e3f324de$export$2e2bcd8739ae039.blotName = 'code-block';
$d020a709e3f324de$export$2e2bcd8739ae039.className = 'ql-code-block';
$d020a709e3f324de$export$2e2bcd8739ae039.tagName = 'DIV';
$d020a709e3f324de$export$3b131632d3d15165.blotName = 'code-block-container';
$d020a709e3f324de$export$3b131632d3d15165.className = 'ql-code-block-container';
$d020a709e3f324de$export$3b131632d3d15165.tagName = 'DIV';
$d020a709e3f324de$export$3b131632d3d15165.allowedChildren = [
    $d020a709e3f324de$export$2e2bcd8739ae039
];
$d020a709e3f324de$export$2e2bcd8739ae039.allowedChildren = [
    (0, $fpYVL.default),
    (0, $ekYWe.default),
    (0, $4lEvv.default)
];
$d020a709e3f324de$export$2e2bcd8739ae039.requiredContainer = $d020a709e3f324de$export$3b131632d3d15165;

});

parcelRegister("evomV", function(module, exports) {

$parcel$export(module.exports, "DirectionAttribute", function () { return $a8f6dd0d29594fc9$export$4158215dafad9efa; });
$parcel$export(module.exports, "DirectionClass", function () { return $a8f6dd0d29594fc9$export$630028b3af294dec; });
$parcel$export(module.exports, "DirectionStyle", function () { return $a8f6dd0d29594fc9$export$175979e518d1dfd1; });

var $eYvg2 = parcelRequire("eYvg2");
const $a8f6dd0d29594fc9$var$config = {
    scope: (0, $eYvg2.Scope).BLOCK,
    whitelist: [
        'rtl'
    ]
};
const $a8f6dd0d29594fc9$export$4158215dafad9efa = new (0, $eYvg2.Attributor)('direction', 'dir', $a8f6dd0d29594fc9$var$config);
const $a8f6dd0d29594fc9$export$630028b3af294dec = new (0, $eYvg2.ClassAttributor)('direction', 'ql-direction', $a8f6dd0d29594fc9$var$config);
const $a8f6dd0d29594fc9$export$175979e518d1dfd1 = new (0, $eYvg2.StyleAttributor)('direction', 'direction', $a8f6dd0d29594fc9$var$config);

});

parcelRegister("b90he", function(module, exports) {

$parcel$export(module.exports, "FontClass", function () { return $81d0bff4a41f16d9$export$78a99ee601572ab; });
$parcel$export(module.exports, "FontStyle", function () { return $81d0bff4a41f16d9$export$23b468d4ca3f8c96; });

var $eYvg2 = parcelRequire("eYvg2");
const $81d0bff4a41f16d9$var$config = {
    scope: (0, $eYvg2.Scope).INLINE,
    whitelist: [
        'serif',
        'monospace'
    ]
};
const $81d0bff4a41f16d9$export$78a99ee601572ab = new (0, $eYvg2.ClassAttributor)('font', 'ql-font', $81d0bff4a41f16d9$var$config);
class $81d0bff4a41f16d9$var$FontStyleAttributor extends (0, $eYvg2.StyleAttributor) {
    value(node) {
        return super.value(node).replace(/["']/g, '');
    }
}
const $81d0bff4a41f16d9$export$23b468d4ca3f8c96 = new $81d0bff4a41f16d9$var$FontStyleAttributor('font', 'font-family', $81d0bff4a41f16d9$var$config);

});

parcelRegister("anVd6", function(module, exports) {

$parcel$export(module.exports, "SizeClass", function () { return $78f86e21f9de8d0a$export$c84684d52bca9684; });
$parcel$export(module.exports, "SizeStyle", function () { return $78f86e21f9de8d0a$export$5443b95a30e89ac5; });

var $eYvg2 = parcelRequire("eYvg2");
const $78f86e21f9de8d0a$export$c84684d52bca9684 = new (0, $eYvg2.ClassAttributor)('size', 'ql-size', {
    scope: (0, $eYvg2.Scope).INLINE,
    whitelist: [
        'small',
        'large',
        'huge'
    ]
});
const $78f86e21f9de8d0a$export$5443b95a30e89ac5 = new (0, $eYvg2.StyleAttributor)('size', 'font-size', {
    scope: (0, $eYvg2.Scope).INLINE,
    whitelist: [
        '10px',
        '18px',
        '32px'
    ]
});

});

parcelRegister("8c4Uv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f7340d684a7b28d$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "deleteRange", function () { return $5f7340d684a7b28d$export$a6c813797f379898; });

var $hvQN0 = parcelRequire("hvQN0");
var $f0tJx = parcelRequire("f0tJx");

var $kHwOs = parcelRequire("kHwOs");

var $eYvg2 = parcelRequire("eYvg2");

var $5ubWu = parcelRequire("5ubWu");

var $jzLjA = parcelRequire("jzLjA");

var $cC34A = parcelRequire("cC34A");
const $5f7340d684a7b28d$var$debug = (0, $jzLjA.default)('quill:keyboard');
const $5f7340d684a7b28d$export$34a157fc58f3dd07 = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
class $5f7340d684a7b28d$export$2e2bcd8739ae039 extends (0, $cC34A.default) {
    static match(evt, binding) {
        if ([
            'altKey',
            'ctrlKey',
            'metaKey',
            'shiftKey'
        ].some((key)=>{
            return !!binding[key] !== evt[key] && binding[key] !== null;
        })) return false;
        return binding.key === evt.key || binding.key === evt.which;
    }
    constructor(quill, options){
        super(quill, options);
        this.bindings = {};
        // @ts-expect-error Fix me later
        Object.keys(this.options.bindings).forEach((name)=>{
            // @ts-expect-error Fix me later
            if (this.options.bindings[name]) // @ts-expect-error Fix me later
            this.addBinding(this.options.bindings[name]);
        });
        this.addBinding({
            key: 'Enter',
            shiftKey: null
        }, this.handleEnter);
        this.addBinding({
            key: 'Enter',
            metaKey: null,
            ctrlKey: null,
            altKey: null
        }, ()=>{});
        if (/Firefox/i.test(navigator.userAgent)) {
            // Need to handle delete and backspace for Firefox in the general case #1171
            this.addBinding({
                key: 'Backspace'
            }, {
                collapsed: true
            }, this.handleBackspace);
            this.addBinding({
                key: 'Delete'
            }, {
                collapsed: true
            }, this.handleDelete);
        } else {
            this.addBinding({
                key: 'Backspace'
            }, {
                collapsed: true,
                prefix: /^.?$/
            }, this.handleBackspace);
            this.addBinding({
                key: 'Delete'
            }, {
                collapsed: true,
                suffix: /^.?$/
            }, this.handleDelete);
        }
        this.addBinding({
            key: 'Backspace'
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: 'Delete'
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: 'Backspace',
            altKey: null,
            ctrlKey: null,
            metaKey: null,
            shiftKey: null
        }, {
            collapsed: true,
            offset: 0
        }, this.handleBackspace);
        this.listen();
    }
    addBinding(keyBinding) {
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const binding = $5f7340d684a7b28d$export$a3295358bff77e(keyBinding);
        if (binding == null) {
            $5f7340d684a7b28d$var$debug.warn('Attempted to add invalid keyboard binding', binding);
            return;
        }
        if (typeof context === 'function') context = {
            handler: context
        };
        if (typeof handler === 'function') handler = {
            handler: handler
        };
        const keys = Array.isArray(binding.key) ? binding.key : [
            binding.key
        ];
        keys.forEach((key)=>{
            const singleBinding = {
                ...binding,
                key: key,
                ...context,
                ...handler
            };
            this.bindings[singleBinding.key] = this.bindings[singleBinding.key] || [];
            this.bindings[singleBinding.key].push(singleBinding);
        });
    }
    listen() {
        this.quill.root.addEventListener('keydown', (evt)=>{
            if (evt.defaultPrevented || evt.isComposing) return;
            // evt.isComposing is false when pressing Enter/Backspace when composing in Safari
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            const isComposing = evt.keyCode === 229 && (evt.key === 'Enter' || evt.key === 'Backspace');
            if (isComposing) return;
            const bindings = (this.bindings[evt.key] || []).concat(this.bindings[evt.which] || []);
            const matches = bindings.filter((binding)=>$5f7340d684a7b28d$export$2e2bcd8739ae039.match(evt, binding));
            if (matches.length === 0) return;
            // @ts-expect-error
            const blot = (0, $5ubWu.default).find(evt.target, true);
            if (blot && blot.scroll !== this.quill.scroll) return;
            const range = this.quill.getSelection();
            if (range == null || !this.quill.hasFocus()) return;
            const [line, offset] = this.quill.getLine(range.index);
            const [leafStart, offsetStart] = this.quill.getLeaf(range.index);
            const [leafEnd, offsetEnd] = range.length === 0 ? [
                leafStart,
                offsetStart
            ] : this.quill.getLeaf(range.index + range.length);
            const prefixText = leafStart instanceof (0, $eYvg2.TextBlot) ? leafStart.value().slice(0, offsetStart) : '';
            const suffixText = leafEnd instanceof (0, $eYvg2.TextBlot) ? leafEnd.value().slice(offsetEnd) : '';
            const curContext = {
                collapsed: range.length === 0,
                // @ts-expect-error Fix me later
                empty: range.length === 0 && line.length() <= 1,
                format: this.quill.getFormat(range),
                line: line,
                offset: offset,
                prefix: prefixText,
                suffix: suffixText,
                event: evt
            };
            const prevented = matches.some((binding)=>{
                if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
                if (binding.empty != null && binding.empty !== curContext.empty) return false;
                if (binding.offset != null && binding.offset !== curContext.offset) return false;
                if (Array.isArray(binding.format)) {
                    // any format is present
                    if (binding.format.every((name)=>curContext.format[name] == null)) return false;
                } else if (typeof binding.format === 'object') {
                    // all formats must match
                    if (!Object.keys(binding.format).every((name)=>{
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === true) return curContext.format[name] != null;
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === false) return curContext.format[name] == null;
                        // @ts-expect-error Fix me later
                        return (0, $f0tJx.default)(binding.format[name], curContext.format[name]);
                    })) return false;
                }
                if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
                if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
                // @ts-expect-error Fix me later
                return binding.handler.call(this, range, curContext, binding) !== true;
            });
            if (prevented) evt.preventDefault();
        });
    }
    handleBackspace(range, context) {
        // Check for astral symbols
        const length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
        if (range.index === 0 || this.quill.getLength() <= 1) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(range.index - length).delete(length);
        if (context.offset === 0) {
            // Always deleting newline here, length always 1
            const [prev] = this.quill.getLine(range.index - 1);
            if (prev) {
                const isPrevLineEmpty = prev.statics.blotName === 'block' && prev.length() <= 1;
                if (!isPrevLineEmpty) {
                    // @ts-expect-error Fix me later
                    const curFormats = line.formats();
                    const prevFormats = this.quill.getFormat(range.index - 1, 1);
                    formats = (0, $kHwOs.AttributeMap).diff(curFormats, prevFormats) || {};
                    if (Object.keys(formats).length > 0) {
                        // line.length() - 1 targets \n in line, another -1 for newline being deleted
                        const formatDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - 2).retain(1, formats);
                        delta = delta.compose(formatDelta);
                    }
                }
            }
        }
        this.quill.updateContents(delta, (0, $5ubWu.default).sources.USER);
        this.quill.focus();
    }
    handleDelete(range, context) {
        // Check for astral symbols
        const length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
        if (range.index >= this.quill.getLength() - length) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(range.index).delete(length);
        // @ts-expect-error Fix me later
        if (context.offset >= line.length() - 1) {
            const [next] = this.quill.getLine(range.index + 1);
            if (next) {
                // @ts-expect-error Fix me later
                const curFormats = line.formats();
                const nextFormats = this.quill.getFormat(range.index, 1);
                formats = (0, $kHwOs.AttributeMap).diff(curFormats, nextFormats) || {};
                if (Object.keys(formats).length > 0) delta = delta.retain(next.length() - 1).retain(1, formats);
            }
        }
        this.quill.updateContents(delta, (0, $5ubWu.default).sources.USER);
        this.quill.focus();
    }
    handleDeleteRange(range) {
        $5f7340d684a7b28d$export$a6c813797f379898({
            range: range,
            quill: this.quill
        });
        this.quill.focus();
    }
    handleEnter(range, context) {
        const lineFormats = Object.keys(context.format).reduce((formats, format)=>{
            if (this.quill.scroll.query(format, (0, $eYvg2.Scope).BLOCK) && !Array.isArray(context.format[format])) formats[format] = context.format[format];
            return formats;
        }, {});
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(range.index).delete(range.length).insert('\n', lineFormats);
        this.quill.updateContents(delta, (0, $5ubWu.default).sources.USER);
        this.quill.setSelection(range.index + 1, (0, $5ubWu.default).sources.SILENT);
        this.quill.focus();
    }
}
const $5f7340d684a7b28d$var$defaultOptions = {
    bindings: {
        bold: $5f7340d684a7b28d$var$makeFormatHandler('bold'),
        italic: $5f7340d684a7b28d$var$makeFormatHandler('italic'),
        underline: $5f7340d684a7b28d$var$makeFormatHandler('underline'),
        indent: {
            // highlight tab or tab at beginning of list, indent or blockquote
            key: 'Tab',
            format: [
                'blockquote',
                'indent',
                'list'
            ],
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format('indent', '+1', (0, $5ubWu.default).sources.USER);
                return false;
            }
        },
        outdent: {
            key: 'Tab',
            shiftKey: true,
            format: [
                'blockquote',
                'indent',
                'list'
            ],
            // highlight tab or tab at beginning of list, indent or blockquote
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format('indent', '-1', (0, $5ubWu.default).sources.USER);
                return false;
            }
        },
        'outdent backspace': {
            key: 'Backspace',
            collapsed: true,
            shiftKey: null,
            metaKey: null,
            ctrlKey: null,
            altKey: null,
            format: [
                'indent',
                'list'
            ],
            offset: 0,
            handler (range, context) {
                if (context.format.indent != null) this.quill.format('indent', '-1', (0, $5ubWu.default).sources.USER);
                else if (context.format.list != null) this.quill.format('list', false, (0, $5ubWu.default).sources.USER);
            }
        },
        'indent code-block': $5f7340d684a7b28d$var$makeCodeBlockHandler(true),
        'outdent code-block': $5f7340d684a7b28d$var$makeCodeBlockHandler(false),
        'remove tab': {
            key: 'Tab',
            shiftKey: true,
            collapsed: true,
            prefix: /\t$/,
            handler (range) {
                this.quill.deleteText(range.index - 1, 1, (0, $5ubWu.default).sources.USER);
            }
        },
        tab: {
            key: 'Tab',
            handler (range, context) {
                if (context.format.table) return true;
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(range.index).delete(range.length).insert('\t');
                this.quill.updateContents(delta, (0, $5ubWu.default).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index + 1, (0, $5ubWu.default).sources.SILENT);
                return false;
            }
        },
        'blockquote empty enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'blockquote'
            ],
            empty: true,
            handler () {
                this.quill.format('blockquote', false, (0, $5ubWu.default).sources.USER);
            }
        },
        'list empty enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'list'
            ],
            empty: true,
            handler (range, context) {
                const formats = {
                    list: false
                };
                if (context.format.indent) formats.indent = false;
                this.quill.formatLine(range.index, range.length, formats, (0, $5ubWu.default).sources.USER);
            }
        },
        'checklist enter': {
            key: 'Enter',
            collapsed: true,
            format: {
                list: 'checked'
            },
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                const formats = {
                    // @ts-expect-error Fix me later
                    ...line.formats(),
                    list: 'checked'
                };
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(range.index).insert('\n', formats)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    list: 'unchecked'
                });
                this.quill.updateContents(delta, (0, $5ubWu.default).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $5ubWu.default).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        'header enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'header'
            ],
            suffix: /^$/,
            handler (range, context) {
                const [line, offset] = this.quill.getLine(range.index);
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(range.index).insert('\n', context.format)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    header: null
                });
                this.quill.updateContents(delta, (0, $5ubWu.default).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $5ubWu.default).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        'table backspace': {
            key: 'Backspace',
            format: [
                'table'
            ],
            collapsed: true,
            offset: 0,
            handler () {}
        },
        'table delete': {
            key: 'Delete',
            format: [
                'table'
            ],
            collapsed: true,
            suffix: /^$/,
            handler () {}
        },
        'table enter': {
            key: 'Enter',
            shiftKey: null,
            format: [
                'table'
            ],
            handler (range) {
                const module = this.quill.getModule('table');
                if (module) {
                    // @ts-expect-error
                    const [table, row, cell, offset] = module.getTable(range);
                    const shift = $5f7340d684a7b28d$var$tableSide(table, row, cell, offset);
                    if (shift == null) return;
                    let index = table.offset();
                    if (shift < 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(index).insert('\n');
                        this.quill.updateContents(delta, (0, $5ubWu.default).sources.USER);
                        this.quill.setSelection(range.index + 1, range.length, (0, $5ubWu.default).sources.SILENT);
                    } else if (shift > 0) {
                        index += table.length();
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(index).insert('\n');
                        this.quill.updateContents(delta, (0, $5ubWu.default).sources.USER);
                        this.quill.setSelection(index, (0, $5ubWu.default).sources.USER);
                    }
                }
            }
        },
        'table tab': {
            key: 'Tab',
            shiftKey: null,
            format: [
                'table'
            ],
            handler (range, context) {
                const { event: event, line: cell } = context;
                const offset = cell.offset(this.quill.scroll);
                if (event.shiftKey) this.quill.setSelection(offset - 1, (0, $5ubWu.default).sources.USER);
                else this.quill.setSelection(offset + cell.length(), (0, $5ubWu.default).sources.USER);
            }
        },
        'list autofill': {
            key: ' ',
            shiftKey: null,
            collapsed: true,
            format: {
                'code-block': false,
                blockquote: false,
                table: false
            },
            prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
            handler (range, context) {
                if (this.quill.scroll.query('list') == null) return true;
                const { length: length } = context.prefix;
                const [line, offset] = this.quill.getLine(range.index);
                if (offset > length) return true;
                let value;
                switch(context.prefix.trim()){
                    case '[]':
                    case '[ ]':
                        value = 'unchecked';
                        break;
                    case '[x]':
                        value = 'checked';
                        break;
                    case '-':
                    case '*':
                        value = 'bullet';
                        break;
                    default:
                        value = 'ordered';
                }
                this.quill.insertText(range.index, ' ', (0, $5ubWu.default).sources.USER);
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(range.index - offset).delete(length + 1)// @ts-expect-error Fix me later
                .retain(line.length() - 2 - offset).retain(1, {
                    list: value
                });
                this.quill.updateContents(delta, (0, $5ubWu.default).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index - length, (0, $5ubWu.default).sources.SILENT);
                return false;
            }
        },
        'code exit': {
            key: 'Enter',
            collapsed: true,
            format: [
                'code-block'
            ],
            prefix: /^$/,
            suffix: /^\s*$/,
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                let numLines = 2;
                let cur = line;
                while(cur != null && cur.length() <= 1 && cur.formats()['code-block']){
                    // @ts-expect-error
                    cur = cur.prev;
                    numLines -= 1;
                    // Requisite prev lines are empty
                    if (numLines <= 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - offset - 2).retain(1, {
                            'code-block': null
                        }).delete(1);
                        this.quill.updateContents(delta, (0, $5ubWu.default).sources.USER);
                        this.quill.setSelection(range.index - 1, (0, $5ubWu.default).sources.SILENT);
                        return false;
                    }
                }
                return true;
            }
        },
        'embed left': $5f7340d684a7b28d$var$makeEmbedArrowHandler('ArrowLeft', false),
        'embed left shift': $5f7340d684a7b28d$var$makeEmbedArrowHandler('ArrowLeft', true),
        'embed right': $5f7340d684a7b28d$var$makeEmbedArrowHandler('ArrowRight', false),
        'embed right shift': $5f7340d684a7b28d$var$makeEmbedArrowHandler('ArrowRight', true),
        'table down': $5f7340d684a7b28d$var$makeTableArrowHandler(false),
        'table up': $5f7340d684a7b28d$var$makeTableArrowHandler(true)
    }
};
$5f7340d684a7b28d$export$2e2bcd8739ae039.DEFAULTS = $5f7340d684a7b28d$var$defaultOptions;
function $5f7340d684a7b28d$var$makeCodeBlockHandler(indent) {
    return {
        key: 'Tab',
        shiftKey: !indent,
        format: {
            'code-block': true
        },
        handler (range, _ref) {
            let { event: event } = _ref;
            const CodeBlock = this.quill.scroll.query('code-block');
            // @ts-expect-error
            const { TAB: TAB } = CodeBlock;
            if (range.length === 0 && !event.shiftKey) {
                this.quill.insertText(range.index, TAB, (0, $5ubWu.default).sources.USER);
                this.quill.setSelection(range.index + TAB.length, (0, $5ubWu.default).sources.SILENT);
                return;
            }
            const lines = range.length === 0 ? this.quill.getLines(range.index, 1) : this.quill.getLines(range);
            let { index: index, length: length } = range;
            lines.forEach((line, i)=>{
                if (indent) {
                    line.insertAt(0, TAB);
                    if (i === 0) index += TAB.length;
                    else length += TAB.length;
                // @ts-expect-error Fix me later
                } else if (line.domNode.textContent.startsWith(TAB)) {
                    line.deleteAt(0, TAB.length);
                    if (i === 0) index -= TAB.length;
                    else length -= TAB.length;
                }
            });
            this.quill.update((0, $5ubWu.default).sources.USER);
            this.quill.setSelection(index, length, (0, $5ubWu.default).sources.SILENT);
        }
    };
}
function $5f7340d684a7b28d$var$makeEmbedArrowHandler(key, shiftKey) {
    const where = key === 'ArrowLeft' ? 'prefix' : 'suffix';
    return {
        key: key,
        shiftKey: shiftKey,
        altKey: null,
        [where]: /^$/,
        handler (range) {
            let { index: index } = range;
            if (key === 'ArrowRight') index += range.length + 1;
            const [leaf] = this.quill.getLeaf(index);
            if (!(leaf instanceof (0, $eYvg2.EmbedBlot))) return true;
            if (key === 'ArrowLeft') {
                if (shiftKey) this.quill.setSelection(range.index - 1, range.length + 1, (0, $5ubWu.default).sources.USER);
                else this.quill.setSelection(range.index - 1, (0, $5ubWu.default).sources.USER);
            } else if (shiftKey) this.quill.setSelection(range.index, range.length + 1, (0, $5ubWu.default).sources.USER);
            else this.quill.setSelection(range.index + range.length + 1, (0, $5ubWu.default).sources.USER);
            return false;
        }
    };
}
function $5f7340d684a7b28d$var$makeFormatHandler(format) {
    return {
        key: format[0],
        shortKey: true,
        handler (range, context) {
            this.quill.format(format, !context.format[format], (0, $5ubWu.default).sources.USER);
        }
    };
}
function $5f7340d684a7b28d$var$makeTableArrowHandler(up) {
    return {
        key: up ? 'ArrowUp' : 'ArrowDown',
        collapsed: true,
        format: [
            'table'
        ],
        handler (range, context) {
            // TODO move to table module
            const key = up ? 'prev' : 'next';
            const cell = context.line;
            const targetRow = cell.parent[key];
            if (targetRow != null) {
                if (targetRow.statics.blotName === 'table-row') {
                    // @ts-expect-error
                    let targetCell = targetRow.children.head;
                    let cur = cell;
                    while(cur.prev != null){
                        // @ts-expect-error
                        cur = cur.prev;
                        targetCell = targetCell.next;
                    }
                    const index = targetCell.offset(this.quill.scroll) + Math.min(context.offset, targetCell.length() - 1);
                    this.quill.setSelection(index, 0, (0, $5ubWu.default).sources.USER);
                }
            } else {
                // @ts-expect-error
                const targetLine = cell.table()[key];
                if (targetLine != null) {
                    if (up) this.quill.setSelection(targetLine.offset(this.quill.scroll) + targetLine.length() - 1, 0, (0, $5ubWu.default).sources.USER);
                    else this.quill.setSelection(targetLine.offset(this.quill.scroll), 0, (0, $5ubWu.default).sources.USER);
                }
            }
            return false;
        }
    };
}
function $5f7340d684a7b28d$export$a3295358bff77e(binding) {
    if (typeof binding === 'string' || typeof binding === 'number') binding = {
        key: binding
    };
    else if (typeof binding === 'object') binding = (0, $hvQN0.default)(binding);
    else return null;
    if (binding.shortKey) {
        binding[$5f7340d684a7b28d$export$34a157fc58f3dd07] = binding.shortKey;
        delete binding.shortKey;
    }
    return binding;
}
// TODO: Move into quill.ts or editor.ts
function $5f7340d684a7b28d$export$a6c813797f379898(_ref2) {
    let { quill: quill, range: range } = _ref2;
    const lines = quill.getLines(range);
    let formats = {};
    if (lines.length > 1) {
        const firstFormats = lines[0].formats();
        const lastFormats = lines[lines.length - 1].formats();
        formats = (0, $kHwOs.AttributeMap).diff(lastFormats, firstFormats) || {};
    }
    quill.deleteText(range, (0, $5ubWu.default).sources.USER);
    if (Object.keys(formats).length > 0) quill.formatLine(range.index, 1, formats, (0, $5ubWu.default).sources.USER);
    quill.setSelection(range.index, (0, $5ubWu.default).sources.SILENT);
}
function $5f7340d684a7b28d$var$tableSide(_table, row, cell, offset) {
    if (row.prev == null && row.next == null) {
        if (cell.prev == null && cell.next == null) return offset === 0 ? -1 : 1;
        return cell.prev == null ? -1 : 1;
    }
    if (row.prev == null) return -1;
    if (row.next == null) return 1;
    return null;
}

});

parcelRegister("7VpBT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c51b8e7d2d45af8$export$2e2bcd8739ae039; });

var $dZBXf = parcelRequire("dZBXf");

var $CeA28 = parcelRequire("CeA28");
const $5c51b8e7d2d45af8$var$NORMALIZERS = [
    (0, $CeA28.default),
    (0, $dZBXf.default)
];
const $5c51b8e7d2d45af8$var$normalizeExternalHTML = (doc)=>{
    if (doc.documentElement) $5c51b8e7d2d45af8$var$NORMALIZERS.forEach((normalize)=>{
        normalize(doc);
    });
};
var $5c51b8e7d2d45af8$export$2e2bcd8739ae039 = $5c51b8e7d2d45af8$var$normalizeExternalHTML;

});
parcelRegister("dZBXf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2fe69e1889064f7$export$2e2bcd8739ae039; });
const $a2fe69e1889064f7$var$normalWeightRegexp = /font-weight:\s*normal/;
const $a2fe69e1889064f7$var$blockTagNames = [
    'P',
    'OL',
    'UL'
];
const $a2fe69e1889064f7$var$isBlockElement = (element)=>{
    return element && $a2fe69e1889064f7$var$blockTagNames.includes(element.tagName);
};
const $a2fe69e1889064f7$var$normalizeEmptyLines = (doc)=>{
    Array.from(doc.querySelectorAll('br')).filter((br)=>$a2fe69e1889064f7$var$isBlockElement(br.previousElementSibling) && $a2fe69e1889064f7$var$isBlockElement(br.nextElementSibling)).forEach((br)=>{
        br.parentNode?.removeChild(br);
    });
};
const $a2fe69e1889064f7$var$normalizeFontWeight = (doc)=>{
    Array.from(doc.querySelectorAll('b[style*="font-weight"]')).filter((node)=>node.getAttribute('style')?.match($a2fe69e1889064f7$var$normalWeightRegexp)).forEach((node)=>{
        const fragment = doc.createDocumentFragment();
        fragment.append(...node.childNodes);
        node.parentNode?.replaceChild(fragment, node);
    });
};
function $a2fe69e1889064f7$export$2e2bcd8739ae039(doc) {
    if (doc.querySelector('[id^="docs-internal-guid-"]')) {
        $a2fe69e1889064f7$var$normalizeFontWeight(doc);
        $a2fe69e1889064f7$var$normalizeEmptyLines(doc);
    }
}

});

parcelRegister("CeA28", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $072edc0b9ac4d8c9$export$2e2bcd8739ae039; });
const $072edc0b9ac4d8c9$var$ignoreRegexp = /\bmso-list:[^;]*ignore/i;
const $072edc0b9ac4d8c9$var$idRegexp = /\bmso-list:[^;]*\bl(\d+)/i;
const $072edc0b9ac4d8c9$var$indentRegexp = /\bmso-list:[^;]*\blevel(\d+)/i;
const $072edc0b9ac4d8c9$var$parseListItem = (element, html)=>{
    const style = element.getAttribute('style');
    const idMatch = style?.match($072edc0b9ac4d8c9$var$idRegexp);
    if (!idMatch) return null;
    const id = Number(idMatch[1]);
    const indentMatch = style?.match($072edc0b9ac4d8c9$var$indentRegexp);
    const indent = indentMatch ? Number(indentMatch[1]) : 1;
    const typeRegexp = new RegExp(`@list l${id}:level${indent}\\s*\\{[^\\}]*mso-level-number-format:\\s*([\\w-]+)`, 'i');
    const typeMatch = html.match(typeRegexp);
    const type = typeMatch && typeMatch[1] === 'bullet' ? 'bullet' : 'ordered';
    return {
        id: id,
        indent: indent,
        type: type,
        element: element
    };
};
// list items are represented as `p` tags with styles like `mso-list: l0 level1` where:
// 1. "0" in "l0" means the list item id;
// 2. "1" in "level1" means the indent level, starting from 1.
const $072edc0b9ac4d8c9$var$normalizeListItem = (doc)=>{
    const msoList = Array.from(doc.querySelectorAll('[style*=mso-list]'));
    const ignored = [];
    const others = [];
    msoList.forEach((node)=>{
        const shouldIgnore = (node.getAttribute('style') || '').match($072edc0b9ac4d8c9$var$ignoreRegexp);
        if (shouldIgnore) ignored.push(node);
        else others.push(node);
    });
    // Each list item contains a marker wrapped with "mso-list: Ignore".
    ignored.forEach((node)=>node.parentNode?.removeChild(node));
    // The list stype is not defined inline with the tag, instead, it's in the
    // style tag so we need to pass the html as a string.
    const html = doc.documentElement.innerHTML;
    const listItems = others.map((element)=>$072edc0b9ac4d8c9$var$parseListItem(element, html)).filter((parsed)=>parsed);
    while(listItems.length){
        const childListItems = [];
        let current = listItems.shift();
        // Group continuous items into the same group (aka "ul")
        while(current){
            childListItems.push(current);
            current = listItems.length && listItems[0]?.element === current.element.nextElementSibling && // Different id means the next item doesn't belong to this group.
            listItems[0].id === current.id ? listItems.shift() : null;
        }
        const ul = document.createElement('ul');
        childListItems.forEach((listItem)=>{
            const li = document.createElement('li');
            li.setAttribute('data-list', listItem.type);
            if (listItem.indent > 1) li.setAttribute('class', `ql-indent-${listItem.indent - 1}`);
            li.innerHTML = listItem.element.innerHTML;
            ul.appendChild(li);
        });
        const element = childListItems[0]?.element;
        const { parentNode: parentNode } = element ?? {};
        if (element) parentNode?.replaceChild(ul, element);
        childListItems.slice(1).forEach((_ref)=>{
            let { element: e } = _ref;
            parentNode?.removeChild(e);
        });
    }
};
function $072edc0b9ac4d8c9$export$2e2bcd8739ae039(doc) {
    if (doc.documentElement.getAttribute('xmlns:w') === 'urn:schemas-microsoft-com:office:word') $072edc0b9ac4d8c9$var$normalizeListItem(doc);
}

});



parcelRegister("8iE1x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60af0d15fde81ff7$export$2e2bcd8739ae039; });

var $eYvg2 = parcelRequire("eYvg2");

var $cC34A = parcelRequire("cC34A");

var $5ubWu = parcelRequire("5ubWu");
class $60af0d15fde81ff7$export$2e2bcd8739ae039 extends (0, $cC34A.default) {
    static DEFAULTS = {
        delay: 1000,
        maxStack: 100,
        userOnly: false
    };
    lastRecorded = 0;
    ignoreChange = false;
    stack = {
        undo: [],
        redo: []
    };
    currentRange = null;
    constructor(quill, options){
        super(quill, options);
        this.quill.on((0, $5ubWu.default).events.EDITOR_CHANGE, (eventName, value, oldValue, source)=>{
            if (eventName === (0, $5ubWu.default).events.SELECTION_CHANGE) {
                if (value && source !== (0, $5ubWu.default).sources.SILENT) this.currentRange = value;
            } else if (eventName === (0, $5ubWu.default).events.TEXT_CHANGE) {
                if (!this.ignoreChange) {
                    if (!this.options.userOnly || source === (0, $5ubWu.default).sources.USER) this.record(value, oldValue);
                    else this.transform(value);
                }
                this.currentRange = $60af0d15fde81ff7$var$transformRange(this.currentRange, value);
            }
        });
        this.quill.keyboard.addBinding({
            key: 'z',
            shortKey: true
        }, this.undo.bind(this));
        this.quill.keyboard.addBinding({
            key: [
                'z',
                'Z'
            ],
            shortKey: true,
            shiftKey: true
        }, this.redo.bind(this));
        if (/Win/i.test(navigator.platform)) this.quill.keyboard.addBinding({
            key: 'y',
            shortKey: true
        }, this.redo.bind(this));
        this.quill.root.addEventListener('beforeinput', (event)=>{
            if (event.inputType === 'historyUndo') {
                this.undo();
                event.preventDefault();
            } else if (event.inputType === 'historyRedo') {
                this.redo();
                event.preventDefault();
            }
        });
    }
    change(source, dest) {
        if (this.stack[source].length === 0) return;
        const item = this.stack[source].pop();
        if (!item) return;
        const base = this.quill.getContents();
        const inverseDelta = item.delta.invert(base);
        this.stack[dest].push({
            delta: inverseDelta,
            range: $60af0d15fde81ff7$var$transformRange(item.range, inverseDelta)
        });
        this.lastRecorded = 0;
        this.ignoreChange = true;
        this.quill.updateContents(item.delta, (0, $5ubWu.default).sources.USER);
        this.ignoreChange = false;
        this.restoreSelection(item);
    }
    clear() {
        this.stack = {
            undo: [],
            redo: []
        };
    }
    cutoff() {
        this.lastRecorded = 0;
    }
    record(changeDelta, oldDelta) {
        if (changeDelta.ops.length === 0) return;
        this.stack.redo = [];
        let undoDelta = changeDelta.invert(oldDelta);
        let undoRange = this.currentRange;
        const timestamp = Date.now();
        if (// @ts-expect-error Fix me later
        this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
            const item = this.stack.undo.pop();
            if (item) {
                undoDelta = undoDelta.compose(item.delta);
                undoRange = item.range;
            }
        } else this.lastRecorded = timestamp;
        if (undoDelta.length() === 0) return;
        this.stack.undo.push({
            delta: undoDelta,
            range: undoRange
        });
        // @ts-expect-error Fix me later
        if (this.stack.undo.length > this.options.maxStack) this.stack.undo.shift();
    }
    redo() {
        this.change('redo', 'undo');
    }
    transform(delta) {
        $60af0d15fde81ff7$var$transformStack(this.stack.undo, delta);
        $60af0d15fde81ff7$var$transformStack(this.stack.redo, delta);
    }
    undo() {
        this.change('undo', 'redo');
    }
    restoreSelection(stackItem) {
        if (stackItem.range) this.quill.setSelection(stackItem.range, (0, $5ubWu.default).sources.USER);
        else {
            const index = $60af0d15fde81ff7$export$64042f78dc41d29e(this.quill.scroll, stackItem.delta);
            this.quill.setSelection(index, (0, $5ubWu.default).sources.USER);
        }
    }
}
function $60af0d15fde81ff7$var$transformStack(stack, delta) {
    let remoteDelta = delta;
    for(let i = stack.length - 1; i >= 0; i -= 1){
        const oldItem = stack[i];
        stack[i] = {
            delta: remoteDelta.transform(oldItem.delta, true),
            range: oldItem.range && $60af0d15fde81ff7$var$transformRange(oldItem.range, remoteDelta)
        };
        remoteDelta = oldItem.delta.transform(remoteDelta);
        if (stack[i].delta.length() === 0) stack.splice(i, 1);
    }
}
function $60af0d15fde81ff7$var$endsWithNewlineChange(scroll, delta) {
    const lastOp = delta.ops[delta.ops.length - 1];
    if (lastOp == null) return false;
    if (lastOp.insert != null) return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
    if (lastOp.attributes != null) return Object.keys(lastOp.attributes).some((attr)=>{
        return scroll.query(attr, (0, $eYvg2.Scope).BLOCK) != null;
    });
    return false;
}
function $60af0d15fde81ff7$export$64042f78dc41d29e(scroll, delta) {
    const deleteLength = delta.reduce((length, op)=>{
        return length + (op.delete || 0);
    }, 0);
    let changeIndex = delta.length() - deleteLength;
    if ($60af0d15fde81ff7$var$endsWithNewlineChange(scroll, delta)) changeIndex -= 1;
    return changeIndex;
}
function $60af0d15fde81ff7$var$transformRange(range, delta) {
    if (!range) return range;
    const start = delta.transformPosition(range.index);
    const end = delta.transformPosition(range.index + range.length);
    return {
        index: start,
        length: end - start
    };
}

});

parcelRegister("cXlxJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96ebb4b884f09547$export$2e2bcd8739ae039; });

var $kHwOs = parcelRequire("kHwOs");

var $8AVGf = parcelRequire("8AVGf");

var $cC34A = parcelRequire("cC34A");
class $96ebb4b884f09547$var$Uploader extends (0, $cC34A.default) {
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener('drop', (e)=>{
            e.preventDefault();
            let native = null;
            if (document.caretRangeFromPoint) native = document.caretRangeFromPoint(e.clientX, e.clientY);
            else if (document.caretPositionFromPoint) {
                // @ts-expect-error
                const position = document.caretPositionFromPoint(e.clientX, e.clientY);
                native = document.createRange();
                native.setStart(position.offsetNode, position.offset);
                native.setEnd(position.offsetNode, position.offset);
            }
            const normalized = native && quill.selection.normalizeNative(native);
            if (normalized) {
                const range = quill.selection.normalizedToRange(normalized);
                if (e.dataTransfer?.files) this.upload(range, e.dataTransfer.files);
            }
        });
    }
    upload(range, files) {
        const uploads = [];
        Array.from(files).forEach((file)=>{
            if (file && this.options.mimetypes?.includes(file.type)) uploads.push(file);
        });
        if (uploads.length > 0) // @ts-expect-error Fix me later
        this.options.handler.call(this, range, uploads);
    }
}
$96ebb4b884f09547$var$Uploader.DEFAULTS = {
    mimetypes: [
        'image/png',
        'image/jpeg'
    ],
    handler (range, files) {
        if (!this.quill.scroll.query('image')) return;
        const promises = files.map((file)=>{
            return new Promise((resolve)=>{
                const reader = new FileReader();
                reader.onload = ()=>{
                    resolve(reader.result);
                };
                reader.readAsDataURL(file);
            });
        });
        Promise.all(promises).then((images)=>{
            const update = images.reduce((delta, image)=>{
                return delta.insert({
                    image: image
                });
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(range.index).delete(range.length));
            this.quill.updateContents(update, (0, $8AVGf.default).sources.USER);
            this.quill.setSelection(range.index + images.length, (0, $8AVGf.default).sources.SILENT);
        });
    }
};
var $96ebb4b884f09547$export$2e2bcd8739ae039 = $96ebb4b884f09547$var$Uploader;

});

parcelRegister("ezcCP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9ae20b19e7fd5b5$export$2e2bcd8739ae039; });

var $kHwOs = parcelRequire("kHwOs");

var $cC34A = parcelRequire("cC34A");

var $5ubWu = parcelRequire("5ubWu");

var $8c4Uv = parcelRequire("8c4Uv");
const $a9ae20b19e7fd5b5$var$INSERT_TYPES = [
    'insertText',
    'insertReplacementText'
];
class $a9ae20b19e7fd5b5$var$Input extends (0, $cC34A.default) {
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener('beforeinput', (event)=>{
            this.handleBeforeInput(event);
        });
        // Gboard with English input on Android triggers `compositionstart` sometimes even
        // users are not going to type anything.
        if (!/Android/i.test(navigator.userAgent)) quill.on((0, $5ubWu.default).events.COMPOSITION_BEFORE_START, ()=>{
            this.handleCompositionStart();
        });
    }
    deleteRange(range) {
        (0, $8c4Uv.deleteRange)({
            range: range,
            quill: this.quill
        });
    }
    replaceText(range) {
        let text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        if (range.length === 0) return false;
        if (text) {
            // Follow the native behavior that inherits the formats of the first character
            const formats = this.quill.getFormat(range.index, 1);
            this.deleteRange(range);
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(range.index).insert(text, formats), (0, $5ubWu.default).sources.USER);
        } else this.deleteRange(range);
        this.quill.setSelection(range.index + text.length, 0, (0, $5ubWu.default).sources.SILENT);
        return true;
    }
    handleBeforeInput(event) {
        if (this.quill.composition.isComposing || event.defaultPrevented || !$a9ae20b19e7fd5b5$var$INSERT_TYPES.includes(event.inputType)) return;
        const staticRange = event.getTargetRanges ? event.getTargetRanges()[0] : null;
        if (!staticRange || staticRange.collapsed === true) return;
        const text = $a9ae20b19e7fd5b5$var$getPlainTextFromInputEvent(event);
        if (text == null) return;
        const normalized = this.quill.selection.normalizeNative(staticRange);
        const range = normalized ? this.quill.selection.normalizedToRange(normalized) : null;
        if (range && this.replaceText(range, text)) event.preventDefault();
    }
    handleCompositionStart() {
        const range = this.quill.getSelection();
        if (range) this.replaceText(range);
    }
}
function $a9ae20b19e7fd5b5$var$getPlainTextFromInputEvent(event) {
    // When `inputType` is "insertText":
    // - `event.data` should be string (Safari uses `event.dataTransfer`).
    // - `event.dataTransfer` should be null.
    // When `inputType` is "insertReplacementText":
    // - `event.data` should be null.
    // - `event.dataTransfer` should contain "text/plain" data.
    if (typeof event.data === 'string') return event.data;
    if (event.dataTransfer?.types.includes('text/plain')) return event.dataTransfer.getData('text/plain');
    return null;
}
var $a9ae20b19e7fd5b5$export$2e2bcd8739ae039 = $a9ae20b19e7fd5b5$var$Input;

});

parcelRegister("lmNv5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8e20cc8b3a03a19$export$2e2bcd8739ae039; });

var $eYvg2 = parcelRequire("eYvg2");

var $cC34A = parcelRequire("cC34A");

var $5ubWu = parcelRequire("5ubWu");
const $f8e20cc8b3a03a19$var$isMac = /Mac/i.test(navigator.platform);
const $f8e20cc8b3a03a19$export$b6cc50769bf06658 = 100;
// A loose check to determine if the shortcut can move the caret before a UI node:
// <ANY_PARENT>[CARET]<div class="ql-ui"></div>[CONTENT]</ANY_PARENT>
const $f8e20cc8b3a03a19$var$canMoveCaretBeforeUINode = (event)=>{
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || // RTL scripts or moving from the end of the previous line
    event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'Home') return true;
    if ($f8e20cc8b3a03a19$var$isMac && event.key === 'a' && event.ctrlKey === true) return true;
    return false;
};
class $f8e20cc8b3a03a19$var$UINode extends (0, $cC34A.default) {
    isListening = false;
    selectionChangeDeadline = 0;
    constructor(quill, options){
        super(quill, options);
        this.handleArrowKeys();
        this.handleNavigationShortcuts();
    }
    handleArrowKeys() {
        this.quill.keyboard.addBinding({
            key: [
                'ArrowLeft',
                'ArrowRight'
            ],
            offset: 0,
            shiftKey: null,
            handler (range, _ref) {
                let { line: line, event: event } = _ref;
                if (!(line instanceof (0, $eYvg2.ParentBlot)) || !line.uiNode) return true;
                const isRTL = getComputedStyle(line.domNode)['direction'] === 'rtl';
                if (isRTL && event.key !== 'ArrowRight' || !isRTL && event.key !== 'ArrowLeft') return true;
                this.quill.setSelection(range.index - 1, range.length + (event.shiftKey ? 1 : 0), (0, $5ubWu.default).sources.USER);
                return false;
            }
        });
    }
    handleNavigationShortcuts() {
        this.quill.root.addEventListener('keydown', (event)=>{
            if (!event.defaultPrevented && $f8e20cc8b3a03a19$var$canMoveCaretBeforeUINode(event)) this.ensureListeningToSelectionChange();
        });
    }
    /**
   * We only listen to the `selectionchange` event when
   * there is an intention of moving the caret to the beginning using shortcuts.
   * This is primarily implemented to prevent infinite loops, as we are changing
   * the selection within the handler of a `selectionchange` event.
   */ ensureListeningToSelectionChange() {
        this.selectionChangeDeadline = Date.now() + $f8e20cc8b3a03a19$export$b6cc50769bf06658;
        if (this.isListening) return;
        this.isListening = true;
        const listener = ()=>{
            this.isListening = false;
            if (Date.now() <= this.selectionChangeDeadline) this.handleSelectionChange();
        };
        document.addEventListener('selectionchange', listener, {
            once: true
        });
    }
    handleSelectionChange() {
        const selection = document.getSelection();
        if (!selection) return;
        const range = selection.getRangeAt(0);
        if (range.collapsed !== true || range.startOffset !== 0) return;
        const line = this.quill.scroll.find(range.startContainer);
        if (!(line instanceof (0, $eYvg2.ParentBlot)) || !line.uiNode) return;
        const newRange = document.createRange();
        newRange.setStartAfter(line.uiNode);
        newRange.setEndAfter(line.uiNode);
        selection.removeAllRanges();
        selection.addRange(newRange);
    }
}
var $f8e20cc8b3a03a19$export$2e2bcd8739ae039 = $f8e20cc8b3a03a19$var$UINode;

});


parcelRegister("hzItX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccb835cfa66ed05c$export$2e2bcd8739ae039; });

var $eYvg2 = parcelRequire("eYvg2");
class $ccb835cfa66ed05c$var$IndentAttributor extends (0, $eYvg2.ClassAttributor) {
    add(node, value) {
        let normalizedValue = 0;
        if (value === '+1' || value === '-1') {
            const indent = this.value(node) || 0;
            normalizedValue = value === '+1' ? indent + 1 : indent - 1;
        } else if (typeof value === 'number') normalizedValue = value;
        if (normalizedValue === 0) {
            this.remove(node);
            return true;
        }
        return super.add(node, normalizedValue.toString());
    }
    canAdd(node, value) {
        return super.canAdd(node, value) || super.canAdd(node, parseInt(value, 10));
    }
    value(node) {
        return parseInt(super.value(node), 10) || undefined; // Don't return NaN
    }
}
const $ccb835cfa66ed05c$var$IndentClass = new $ccb835cfa66ed05c$var$IndentAttributor('indent', 'ql-indent', {
    scope: (0, $eYvg2.Scope).BLOCK,
    // @ts-expect-error
    whitelist: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ]
});
var $ccb835cfa66ed05c$export$2e2bcd8739ae039 = $ccb835cfa66ed05c$var$IndentClass;

});

parcelRegister("h40qL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6c324efed663855$export$2e2bcd8739ae039; });

var $4UH9n = parcelRequire("4UH9n");
class $c6c324efed663855$var$Blockquote extends (0, $4UH9n.default) {
    static blotName = 'blockquote';
    static tagName = 'blockquote';
}
var $c6c324efed663855$export$2e2bcd8739ae039 = $c6c324efed663855$var$Blockquote;

});

parcelRegister("XxsPs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b2f780d719f08cf$export$2e2bcd8739ae039; });

var $4UH9n = parcelRequire("4UH9n");
class $0b2f780d719f08cf$var$Header extends (0, $4UH9n.default) {
    static blotName = 'header';
    static tagName = [
        'H1',
        'H2',
        'H3',
        'H4',
        'H5',
        'H6'
    ];
    static formats(domNode) {
        return this.tagName.indexOf(domNode.tagName) + 1;
    }
}
var $0b2f780d719f08cf$export$2e2bcd8739ae039 = $0b2f780d719f08cf$var$Header;

});

parcelRegister("3hUd9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $264e8ffd665730b0$export$2e2bcd8739ae039; });

var $4UH9n = parcelRequire("4UH9n");

var $hrKTM = parcelRequire("hrKTM");

var $5ubWu = parcelRequire("5ubWu");
class $264e8ffd665730b0$export$122a2a667e12876b extends (0, $hrKTM.default) {
}
$264e8ffd665730b0$export$122a2a667e12876b.blotName = 'list-container';
$264e8ffd665730b0$export$122a2a667e12876b.tagName = 'OL';
class $264e8ffd665730b0$export$2e2bcd8739ae039 extends (0, $4UH9n.default) {
    static create(value) {
        const node = super.create();
        node.setAttribute('data-list', value);
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute('data-list') || undefined;
    }
    static register() {
        (0, $5ubWu.default).register($264e8ffd665730b0$export$122a2a667e12876b);
    }
    constructor(scroll, domNode){
        super(scroll, domNode);
        const ui = domNode.ownerDocument.createElement('span');
        const listEventHandler = (e)=>{
            if (!scroll.isEnabled()) return;
            const format = this.statics.formats(domNode, scroll);
            if (format === 'checked') {
                this.format('list', 'unchecked');
                e.preventDefault();
            } else if (format === 'unchecked') {
                this.format('list', 'checked');
                e.preventDefault();
            }
        };
        ui.addEventListener('mousedown', listEventHandler);
        ui.addEventListener('touchstart', listEventHandler);
        this.attachUI(ui);
    }
    format(name, value) {
        if (name === this.statics.blotName && value) this.domNode.setAttribute('data-list', value);
        else super.format(name, value);
    }
}
$264e8ffd665730b0$export$2e2bcd8739ae039.blotName = 'list';
$264e8ffd665730b0$export$2e2bcd8739ae039.tagName = 'LI';
$264e8ffd665730b0$export$122a2a667e12876b.allowedChildren = [
    $264e8ffd665730b0$export$2e2bcd8739ae039
];
$264e8ffd665730b0$export$2e2bcd8739ae039.requiredContainer = $264e8ffd665730b0$export$122a2a667e12876b;

});

parcelRegister("8Eosr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64c507ed7c577034$export$2e2bcd8739ae039; });

var $4Xyhi = parcelRequire("4Xyhi");
class $64c507ed7c577034$var$Bold extends (0, $4Xyhi.default) {
    static blotName = 'bold';
    static tagName = [
        'STRONG',
        'B'
    ];
    static create() {
        return super.create();
    }
    static formats() {
        return true;
    }
    optimize(context) {
        super.optimize(context);
        if (this.domNode.tagName !== this.statics.tagName[0]) this.replaceWith(this.statics.blotName);
    }
}
var $64c507ed7c577034$export$2e2bcd8739ae039 = $64c507ed7c577034$var$Bold;

});

parcelRegister("6oePL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a707da631daea39$export$2e2bcd8739ae039; });

var $8Eosr = parcelRequire("8Eosr");
class $4a707da631daea39$var$Italic extends (0, $8Eosr.default) {
    static blotName = 'italic';
    static tagName = [
        'EM',
        'I'
    ];
}
var $4a707da631daea39$export$2e2bcd8739ae039 = $4a707da631daea39$var$Italic;

});

parcelRegister("3yeFB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $295fed3acc4a0bc9$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "sanitize", function () { return $295fed3acc4a0bc9$export$83d2e9e3e4ee39ed; });

var $4Xyhi = parcelRequire("4Xyhi");
class $295fed3acc4a0bc9$export$2e2bcd8739ae039 extends (0, $4Xyhi.default) {
    static blotName = 'link';
    static tagName = 'A';
    static SANITIZED_URL = 'about:blank';
    static PROTOCOL_WHITELIST = [
        'http',
        'https',
        'mailto',
        'tel',
        'sms'
    ];
    static create(value) {
        const node = super.create(value);
        node.setAttribute('href', this.sanitize(value));
        node.setAttribute('rel', 'noopener noreferrer');
        node.setAttribute('target', '_blank');
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute('href');
    }
    static sanitize(url) {
        return $295fed3acc4a0bc9$export$83d2e9e3e4ee39ed(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
    }
    format(name, value) {
        if (name !== this.statics.blotName || !value) super.format(name, value);
        else // @ts-expect-error
        this.domNode.setAttribute('href', this.constructor.sanitize(value));
    }
}
function $295fed3acc4a0bc9$export$83d2e9e3e4ee39ed(url, protocols) {
    const anchor = document.createElement('a');
    anchor.href = url;
    const protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
    return protocols.indexOf(protocol) > -1;
}

});

parcelRegister("20vqL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1763f6570e4d0a83$export$2e2bcd8739ae039; });

var $4Xyhi = parcelRequire("4Xyhi");
class $1763f6570e4d0a83$var$Script extends (0, $4Xyhi.default) {
    static blotName = 'script';
    static tagName = [
        'SUB',
        'SUP'
    ];
    static create(value) {
        if (value === 'super') return document.createElement('sup');
        if (value === 'sub') return document.createElement('sub');
        return super.create(value);
    }
    static formats(domNode) {
        if (domNode.tagName === 'SUB') return 'sub';
        if (domNode.tagName === 'SUP') return 'super';
        return undefined;
    }
}
var $1763f6570e4d0a83$export$2e2bcd8739ae039 = $1763f6570e4d0a83$var$Script;

});

parcelRegister("6iLio", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49691c75b24f7450$export$2e2bcd8739ae039; });

var $8Eosr = parcelRequire("8Eosr");
class $49691c75b24f7450$var$Strike extends (0, $8Eosr.default) {
    static blotName = 'strike';
    static tagName = [
        'S',
        'STRIKE'
    ];
}
var $49691c75b24f7450$export$2e2bcd8739ae039 = $49691c75b24f7450$var$Strike;

});

parcelRegister("39BXO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24bfa92a4da322f2$export$2e2bcd8739ae039; });

var $4Xyhi = parcelRequire("4Xyhi");
class $24bfa92a4da322f2$var$Underline extends (0, $4Xyhi.default) {
    static blotName = 'underline';
    static tagName = 'U';
}
var $24bfa92a4da322f2$export$2e2bcd8739ae039 = $24bfa92a4da322f2$var$Underline;

});

parcelRegister("17H8C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d17e83842fafbb5$export$2e2bcd8739ae039; });

var $7ve13 = parcelRequire("7ve13");
class $0d17e83842fafbb5$var$Formula extends (0, $7ve13.default) {
    static blotName = 'formula';
    static className = 'ql-formula';
    static tagName = 'SPAN';
    static create(value) {
        // @ts-expect-error
        if (window.katex == null) throw new Error('Formula module requires KaTeX.');
        const node = super.create(value);
        if (typeof value === 'string') {
            // @ts-expect-error
            window.katex.render(value, node, {
                throwOnError: false,
                errorColor: '#f00'
            });
            node.setAttribute('data-value', value);
        }
        return node;
    }
    static value(domNode) {
        return domNode.getAttribute('data-value');
    }
    html() {
        const { formula: formula } = this.value();
        return `<span>${formula}</span>`;
    }
}
var $0d17e83842fafbb5$export$2e2bcd8739ae039 = $0d17e83842fafbb5$var$Formula;

});

parcelRegister("e88oW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a498545c064e793f$export$2e2bcd8739ae039; });

var $eYvg2 = parcelRequire("eYvg2");

var $3yeFB = parcelRequire("3yeFB");
const $a498545c064e793f$var$ATTRIBUTES = [
    'alt',
    'height',
    'width'
];
class $a498545c064e793f$var$Image extends (0, $eYvg2.EmbedBlot) {
    static blotName = 'image';
    static tagName = 'IMG';
    static create(value) {
        const node = super.create(value);
        if (typeof value === 'string') node.setAttribute('src', this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $a498545c064e793f$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static match(url) {
        return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
    }
    static sanitize(url) {
        return (0, $3yeFB.sanitize)(url, [
            'http',
            'https',
            'data'
        ]) ? url : '//:0';
    }
    static value(domNode) {
        return domNode.getAttribute('src');
    }
    format(name, value) {
        if ($a498545c064e793f$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
}
var $a498545c064e793f$export$2e2bcd8739ae039 = $a498545c064e793f$var$Image;

});

parcelRegister("4gNjr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31bee87f57c70603$export$2e2bcd8739ae039; });

var $4UH9n = parcelRequire("4UH9n");

var $3yeFB = parcelRequire("3yeFB");
const $31bee87f57c70603$var$ATTRIBUTES = [
    'height',
    'width'
];
class $31bee87f57c70603$var$Video extends (0, $4UH9n.BlockEmbed) {
    static blotName = 'video';
    static className = 'ql-video';
    static tagName = 'IFRAME';
    static create(value) {
        const node = super.create(value);
        node.setAttribute('frameborder', '0');
        node.setAttribute('allowfullscreen', 'true');
        node.setAttribute('src', this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $31bee87f57c70603$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static sanitize(url) {
        return (0, $3yeFB.default).sanitize(url);
    }
    static value(domNode) {
        return domNode.getAttribute('src');
    }
    format(name, value) {
        if ($31bee87f57c70603$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
    html() {
        const { video: video } = this.value();
        return `<a href="${video}">${video}</a>`;
    }
}
var $31bee87f57c70603$export$2e2bcd8739ae039 = $31bee87f57c70603$var$Video;

});

parcelRegister("fdaoy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b13022206e0be6d6$export$2e2bcd8739ae039; });

var $kHwOs = parcelRequire("kHwOs");

var $eYvg2 = parcelRequire("eYvg2");

var $4Xyhi = parcelRequire("4Xyhi");

var $5ubWu = parcelRequire("5ubWu");

var $cC34A = parcelRequire("cC34A");

var $4UH9n = parcelRequire("4UH9n");

var $ekYWe = parcelRequire("ekYWe");

var $4lEvv = parcelRequire("4lEvv");

var $fpYVL = parcelRequire("fpYVL");

var $hRRcn = parcelRequire("hRRcn");

var $63ASE = parcelRequire("63ASE");
const $b13022206e0be6d6$var$TokenAttributor = new (0, $eYvg2.ClassAttributor)('code-token', 'hljs', {
    scope: (0, $eYvg2.Scope).INLINE
});
class $b13022206e0be6d6$export$9460eee64f276be7 extends (0, $4Xyhi.default) {
    static formats(node, scroll) {
        while(node != null && node !== scroll.domNode){
            if (node.classList && node.classList.contains((0, $hRRcn.default).className)) // @ts-expect-error
            return super.formats(node, scroll);
            // @ts-expect-error
            node = node.parentNode;
        }
        return undefined;
    }
    constructor(scroll, domNode, value){
        // @ts-expect-error
        super(scroll, domNode, value);
        $b13022206e0be6d6$var$TokenAttributor.add(this.domNode, value);
    }
    format(format, value) {
        if (format !== $b13022206e0be6d6$export$9460eee64f276be7.blotName) super.format(format, value);
        else if (value) $b13022206e0be6d6$var$TokenAttributor.add(this.domNode, value);
        else {
            $b13022206e0be6d6$var$TokenAttributor.remove(this.domNode);
            this.domNode.classList.remove(this.statics.className);
        }
    }
    optimize() {
        // @ts-expect-error
        super.optimize(...arguments);
        if (!$b13022206e0be6d6$var$TokenAttributor.value(this.domNode)) this.unwrap();
    }
}
$b13022206e0be6d6$export$9460eee64f276be7.blotName = 'code-token';
$b13022206e0be6d6$export$9460eee64f276be7.className = 'ql-token';
class $b13022206e0be6d6$export$6c415d1fdae3dfdb extends (0, $hRRcn.default) {
    static create(value) {
        const domNode = super.create(value);
        if (typeof value === 'string') domNode.setAttribute('data-language', value);
        return domNode;
    }
    static formats(domNode) {
        // @ts-expect-error
        return domNode.getAttribute('data-language') || 'plain';
    }
    static register() {}
    format(name, value) {
        if (name === this.statics.blotName && value) // @ts-expect-error
        this.domNode.setAttribute('data-language', value);
        else super.format(name, value);
    }
    replaceWith(name, value) {
        this.formatAt(0, this.length(), $b13022206e0be6d6$export$9460eee64f276be7.blotName, false);
        return super.replaceWith(name, value);
    }
}
class $b13022206e0be6d6$var$SyntaxCodeBlockContainer extends (0, $hRRcn.CodeBlockContainer) {
    attach() {
        super.attach();
        this.forceNext = false;
        // @ts-expect-error
        this.scroll.emitMount(this);
    }
    format(name, value) {
        if (name === $b13022206e0be6d6$export$6c415d1fdae3dfdb.blotName) {
            this.forceNext = true;
            this.children.forEach((child)=>{
                // @ts-expect-error
                child.format(name, value);
            });
        }
    }
    formatAt(index, length, name, value) {
        if (name === $b13022206e0be6d6$export$6c415d1fdae3dfdb.blotName) this.forceNext = true;
        super.formatAt(index, length, name, value);
    }
    highlight(highlight) {
        let forced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.children.head == null) return;
        const nodes = Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode);
        const text = `${nodes.map((node)=>node.textContent).join('\n')}\n`;
        const language = $b13022206e0be6d6$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
        if (forced || this.forceNext || this.cachedText !== text) {
            if (text.trim().length > 0 || this.cachedText == null) {
                const oldDelta = this.children.reduce((delta, child)=>{
                    // @ts-expect-error
                    return delta.concat((0, $4UH9n.blockDelta)(child, false));
                }, new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))());
                const delta = highlight(text, language);
                oldDelta.diff(delta).reduce((index, _ref)=>{
                    let { retain: retain, attributes: attributes } = _ref;
                    // Should be all retains
                    if (!retain) return index;
                    if (attributes) Object.keys(attributes).forEach((format)=>{
                        if ([
                            $b13022206e0be6d6$export$6c415d1fdae3dfdb.blotName,
                            $b13022206e0be6d6$export$9460eee64f276be7.blotName
                        ].includes(format)) // @ts-expect-error
                        this.formatAt(index, retain, format, attributes[format]);
                    });
                    // @ts-expect-error
                    return index + retain;
                }, 0);
            }
            this.cachedText = text;
            this.forceNext = false;
        }
    }
    html(index, length) {
        const [codeBlock] = this.children.find(index);
        const language = codeBlock ? $b13022206e0be6d6$export$6c415d1fdae3dfdb.formats(codeBlock.domNode) : 'plain';
        return `<pre data-language="${language}">\n${(0, $fpYVL.escapeText)(this.code(index, length))}\n</pre>`;
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent != null && this.children.head != null && this.uiNode != null) {
            const language = $b13022206e0be6d6$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
            // @ts-expect-error
            if (language !== this.uiNode.value) // @ts-expect-error
            this.uiNode.value = language;
        }
    }
}
$b13022206e0be6d6$var$SyntaxCodeBlockContainer.allowedChildren = [
    $b13022206e0be6d6$export$6c415d1fdae3dfdb
];
$b13022206e0be6d6$export$6c415d1fdae3dfdb.requiredContainer = $b13022206e0be6d6$var$SyntaxCodeBlockContainer;
$b13022206e0be6d6$export$6c415d1fdae3dfdb.allowedChildren = [
    $b13022206e0be6d6$export$9460eee64f276be7,
    (0, $4lEvv.default),
    (0, $fpYVL.default),
    (0, $ekYWe.default)
];
const $b13022206e0be6d6$var$highlight = (lib, language, text)=>{
    if (typeof lib.versionString === 'string') {
        const majorVersion = lib.versionString.split('.')[0];
        if (parseInt(majorVersion, 10) >= 11) return lib.highlight(text, {
            language: language
        }).value;
    }
    return lib.highlight(language, text).value;
};
class $b13022206e0be6d6$export$2e2bcd8739ae039 extends (0, $cC34A.default) {
    static register() {
        (0, $5ubWu.default).register($b13022206e0be6d6$export$9460eee64f276be7, true);
        (0, $5ubWu.default).register($b13022206e0be6d6$export$6c415d1fdae3dfdb, true);
        (0, $5ubWu.default).register($b13022206e0be6d6$var$SyntaxCodeBlockContainer, true);
    }
    constructor(quill, options){
        super(quill, options);
        if (this.options.hljs == null) throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
        // @ts-expect-error Fix me later
        this.languages = this.options.languages.reduce((memo, _ref2)=>{
            let { key: key } = _ref2;
            memo[key] = true;
            return memo;
        }, {});
        this.highlightBlot = this.highlightBlot.bind(this);
        this.initListener();
        this.initTimer();
    }
    initListener() {
        this.quill.on((0, $5ubWu.default).events.SCROLL_BLOT_MOUNT, (blot)=>{
            if (!(blot instanceof $b13022206e0be6d6$var$SyntaxCodeBlockContainer)) return;
            const select = this.quill.root.ownerDocument.createElement('select');
            // @ts-expect-error Fix me later
            this.options.languages.forEach((_ref3)=>{
                let { key: key, label: label } = _ref3;
                const option = select.ownerDocument.createElement('option');
                option.textContent = label;
                option.setAttribute('value', key);
                select.appendChild(option);
            });
            select.addEventListener('change', ()=>{
                blot.format($b13022206e0be6d6$export$6c415d1fdae3dfdb.blotName, select.value);
                this.quill.root.focus(); // Prevent scrolling
                this.highlight(blot, true);
            });
            if (blot.uiNode == null) {
                blot.attachUI(select);
                if (blot.children.head) select.value = $b13022206e0be6d6$export$6c415d1fdae3dfdb.formats(blot.children.head.domNode);
            }
        });
    }
    initTimer() {
        let timer = null;
        this.quill.on((0, $5ubWu.default).events.SCROLL_OPTIMIZE, ()=>{
            if (timer) clearTimeout(timer);
            timer = setTimeout(()=>{
                this.highlight();
                timer = null;
            }, this.options.interval);
        });
    }
    highlight() {
        let blot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.quill.selection.composing) return;
        this.quill.update((0, $5ubWu.default).sources.USER);
        const range = this.quill.getSelection();
        const blots = blot == null ? this.quill.scroll.descendants($b13022206e0be6d6$var$SyntaxCodeBlockContainer) : [
            blot
        ];
        blots.forEach((container)=>{
            container.highlight(this.highlightBlot, force);
        });
        this.quill.update((0, $5ubWu.default).sources.SILENT);
        if (range != null) this.quill.setSelection(range, (0, $5ubWu.default).sources.SILENT);
    }
    highlightBlot(text) {
        let language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'plain';
        language = this.languages[language] ? language : 'plain';
        if (language === 'plain') return (0, $fpYVL.escapeText)(text).split('\n').reduce((delta, line, i)=>{
            if (i !== 0) delta.insert('\n', {
                [(0, $hRRcn.default).blotName]: language
            });
            return delta.insert(line);
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))());
        const container = this.quill.root.ownerDocument.createElement('div');
        container.classList.add((0, $hRRcn.default).className);
        container.innerHTML = $b13022206e0be6d6$var$highlight(this.options.hljs, language, text);
        return (0, $63ASE.traverse)(this.quill.scroll, container, [
            (node, delta)=>{
                // @ts-expect-error
                const value = $b13022206e0be6d6$var$TokenAttributor.value(node);
                if (value) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(delta.length(), {
                    [$b13022206e0be6d6$export$9460eee64f276be7.blotName]: value
                }));
                return delta;
            }
        ], [
            (node, delta)=>{
                // @ts-expect-error
                return node.data.split('\n').reduce((memo, nodeText, i)=>{
                    if (i !== 0) memo.insert('\n', {
                        [(0, $hRRcn.default).blotName]: language
                    });
                    return memo.insert(nodeText);
                }, delta);
            }
        ], new WeakMap());
    }
}
$b13022206e0be6d6$export$2e2bcd8739ae039.DEFAULTS = {
    hljs: (()=>{
        return window.hljs;
    })(),
    interval: 1000,
    languages: [
        {
            key: 'plain',
            label: 'Plain'
        },
        {
            key: 'bash',
            label: 'Bash'
        },
        {
            key: 'cpp',
            label: 'C++'
        },
        {
            key: 'cs',
            label: 'C#'
        },
        {
            key: 'css',
            label: 'CSS'
        },
        {
            key: 'diff',
            label: 'Diff'
        },
        {
            key: 'xml',
            label: 'HTML/XML'
        },
        {
            key: 'java',
            label: 'Java'
        },
        {
            key: 'javascript',
            label: 'JavaScript'
        },
        {
            key: 'markdown',
            label: 'Markdown'
        },
        {
            key: 'php',
            label: 'PHP'
        },
        {
            key: 'python',
            label: 'Python'
        },
        {
            key: 'ruby',
            label: 'Ruby'
        },
        {
            key: 'sql',
            label: 'SQL'
        }
    ]
};

});

parcelRegister("f4S9s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afa13c1e5f33e802$export$2e2bcd8739ae039; });

var $kHwOs = parcelRequire("kHwOs");

var $5ubWu = parcelRequire("5ubWu");

var $cC34A = parcelRequire("cC34A");

var $dKPJZ = parcelRequire("dKPJZ");
class $afa13c1e5f33e802$var$Table extends (0, $cC34A.default) {
    static register() {
        (0, $5ubWu.default).register((0, $dKPJZ.TableCell));
        (0, $5ubWu.default).register((0, $dKPJZ.TableRow));
        (0, $5ubWu.default).register((0, $dKPJZ.TableBody));
        (0, $5ubWu.default).register((0, $dKPJZ.TableContainer));
    }
    constructor(){
        super(...arguments);
        this.listenBalanceCells();
    }
    balanceTables() {
        this.quill.scroll.descendants((0, $dKPJZ.TableContainer)).forEach((table)=>{
            table.balanceCells();
        });
    }
    deleteColumn() {
        const [table, , cell] = this.getTable();
        if (cell == null) return;
        // @ts-expect-error
        table.deleteColumn(cell.cellOffset());
        this.quill.update((0, $5ubWu.default).sources.USER);
    }
    deleteRow() {
        const [, row] = this.getTable();
        if (row == null) return;
        row.remove();
        this.quill.update((0, $5ubWu.default).sources.USER);
    }
    deleteTable() {
        const [table] = this.getTable();
        if (table == null) return;
        // @ts-expect-error
        const offset = table.offset();
        // @ts-expect-error
        table.remove();
        this.quill.update((0, $5ubWu.default).sources.USER);
        this.quill.setSelection(offset, (0, $5ubWu.default).sources.SILENT);
    }
    getTable() {
        let range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.quill.getSelection();
        if (range == null) return [
            null,
            null,
            null,
            -1
        ];
        const [cell, offset] = this.quill.getLine(range.index);
        if (cell == null || cell.statics.blotName !== (0, $dKPJZ.TableCell).blotName) return [
            null,
            null,
            null,
            -1
        ];
        const row = cell.parent;
        const table = row.parent.parent;
        // @ts-expect-error
        return [
            table,
            row,
            cell,
            offset
        ];
    }
    insertColumn(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const column = cell.cellOffset();
        table.insertColumn(column + offset);
        this.quill.update((0, $5ubWu.default).sources.USER);
        let shift = row.rowOffset();
        if (offset === 0) shift += 1;
        this.quill.setSelection(range.index + shift, range.length, (0, $5ubWu.default).sources.SILENT);
    }
    insertColumnLeft() {
        this.insertColumn(0);
    }
    insertColumnRight() {
        this.insertColumn(1);
    }
    insertRow(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const index = row.rowOffset();
        table.insertRow(index + offset);
        this.quill.update((0, $5ubWu.default).sources.USER);
        if (offset > 0) this.quill.setSelection(range, (0, $5ubWu.default).sources.SILENT);
        else this.quill.setSelection(range.index + row.children.length, range.length, (0, $5ubWu.default).sources.SILENT);
    }
    insertRowAbove() {
        this.insertRow(0);
    }
    insertRowBelow() {
        this.insertRow(1);
    }
    insertTable(rows, columns) {
        const range = this.quill.getSelection();
        if (range == null) return;
        const delta = new Array(rows).fill(0).reduce((memo)=>{
            const text = new Array(columns).fill('\n').join('');
            return memo.insert(text, {
                table: (0, $dKPJZ.tableId)()
            });
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))().retain(range.index));
        this.quill.updateContents(delta, (0, $5ubWu.default).sources.USER);
        this.quill.setSelection(range.index, (0, $5ubWu.default).sources.SILENT);
        this.balanceTables();
    }
    listenBalanceCells() {
        this.quill.on((0, $5ubWu.default).events.SCROLL_OPTIMIZE, (mutations)=>{
            mutations.some((mutation)=>{
                if ([
                    'TD',
                    'TR',
                    'TBODY',
                    'TABLE'
                ].includes(mutation.target.tagName)) {
                    this.quill.once((0, $5ubWu.default).events.TEXT_CHANGE, (delta, old, source)=>{
                        if (source !== (0, $5ubWu.default).sources.USER) return;
                        this.balanceTables();
                    });
                    return true;
                }
                return false;
            });
        });
    }
}
var $afa13c1e5f33e802$export$2e2bcd8739ae039 = $afa13c1e5f33e802$var$Table;

});
parcelRegister("dKPJZ", function(module, exports) {

$parcel$export(module.exports, "TableCell", function () { return $a037b4dc6ef36339$export$1e4baea7053fc0e3; });
$parcel$export(module.exports, "tableId", function () { return $a037b4dc6ef36339$export$9bd6f73cbe857f1b; });
$parcel$export(module.exports, "TableRow", function () { return $a037b4dc6ef36339$export$b05581f4e764e162; });
$parcel$export(module.exports, "TableBody", function () { return $a037b4dc6ef36339$export$76ccd210b9029917; });
$parcel$export(module.exports, "TableContainer", function () { return $a037b4dc6ef36339$export$f2c3aea42b2a048f; });

var $4UH9n = parcelRequire("4UH9n");

var $hrKTM = parcelRequire("hrKTM");
class $a037b4dc6ef36339$export$1e4baea7053fc0e3 extends (0, $4UH9n.default) {
    static blotName = 'table';
    static tagName = 'TD';
    static create(value) {
        const node = super.create();
        if (value) node.setAttribute('data-row', value);
        else node.setAttribute('data-row', $a037b4dc6ef36339$export$9bd6f73cbe857f1b());
        return node;
    }
    static formats(domNode) {
        if (domNode.hasAttribute('data-row')) return domNode.getAttribute('data-row');
        return undefined;
    }
    cellOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    format(name, value) {
        if (name === $a037b4dc6ef36339$export$1e4baea7053fc0e3.blotName && value) this.domNode.setAttribute('data-row', value);
        else super.format(name, value);
    }
    row() {
        return this.parent;
    }
    rowOffset() {
        if (this.row()) return this.row().rowOffset();
        return -1;
    }
    table() {
        return this.row() && this.row().table();
    }
}
class $a037b4dc6ef36339$export$b05581f4e764e162 extends (0, $hrKTM.default) {
    static blotName = 'table-row';
    static tagName = 'TR';
    checkMerge() {
        // @ts-expect-error
        if (super.checkMerge() && this.next.children.head != null) {
            // @ts-expect-error
            const thisHead = this.children.head.formats();
            // @ts-expect-error
            const thisTail = this.children.tail.formats();
            // @ts-expect-error
            const nextHead = this.next.children.head.formats();
            // @ts-expect-error
            const nextTail = this.next.children.tail.formats();
            return thisHead.table === thisTail.table && thisHead.table === nextHead.table && thisHead.table === nextTail.table;
        }
        return false;
    }
    optimize(context) {
        super.optimize(context);
        this.children.forEach((child)=>{
            if (child.next == null) return;
            const childFormats = child.formats();
            const nextFormats = child.next.formats();
            if (childFormats.table !== nextFormats.table) {
                const next = this.splitAfter(child);
                if (next) // @ts-expect-error TODO: parameters of optimize() should be a optional
                next.optimize();
                // We might be able to merge with prev now
                if (this.prev) // @ts-expect-error TODO: parameters of optimize() should be a optional
                this.prev.optimize();
            }
        });
    }
    rowOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    table() {
        return this.parent && this.parent.parent;
    }
}
class $a037b4dc6ef36339$export$76ccd210b9029917 extends (0, $hrKTM.default) {
    static blotName = 'table-body';
    static tagName = 'TBODY';
}
class $a037b4dc6ef36339$export$f2c3aea42b2a048f extends (0, $hrKTM.default) {
    static blotName = 'table-container';
    static tagName = 'TABLE';
    balanceCells() {
        const rows = this.descendants($a037b4dc6ef36339$export$b05581f4e764e162);
        const maxColumns = rows.reduce((max, row)=>{
            return Math.max(row.children.length, max);
        }, 0);
        rows.forEach((row)=>{
            new Array(maxColumns - row.children.length).fill(0).forEach(()=>{
                let value;
                if (row.children.head != null) value = $a037b4dc6ef36339$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
                const blot = this.scroll.create($a037b4dc6ef36339$export$1e4baea7053fc0e3.blotName, value);
                row.appendChild(blot);
                // @ts-expect-error TODO: parameters of optimize() should be a optional
                blot.optimize(); // Add break blot
            });
        });
    }
    cells(column) {
        return this.rows().map((row)=>row.children.at(column));
    }
    deleteColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($a037b4dc6ef36339$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const cell = row.children.at(index);
            if (cell != null) cell.remove();
        });
    }
    insertColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($a037b4dc6ef36339$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const ref = row.children.at(index);
            // @ts-expect-error
            const value = $a037b4dc6ef36339$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
            const cell = this.scroll.create($a037b4dc6ef36339$export$1e4baea7053fc0e3.blotName, value);
            row.insertBefore(cell, ref);
        });
    }
    insertRow(index) {
        // @ts-expect-error
        const [body] = this.descendant($a037b4dc6ef36339$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        const id = $a037b4dc6ef36339$export$9bd6f73cbe857f1b();
        const row = this.scroll.create($a037b4dc6ef36339$export$b05581f4e764e162.blotName);
        body.children.head.children.forEach(()=>{
            const cell = this.scroll.create($a037b4dc6ef36339$export$1e4baea7053fc0e3.blotName, id);
            row.appendChild(cell);
        });
        const ref = body.children.at(index);
        body.insertBefore(row, ref);
    }
    rows() {
        const body = this.children.head;
        if (body == null) return [];
        return body.children.map((row)=>row);
    }
}
$a037b4dc6ef36339$export$f2c3aea42b2a048f.allowedChildren = [
    $a037b4dc6ef36339$export$76ccd210b9029917
];
$a037b4dc6ef36339$export$76ccd210b9029917.requiredContainer = $a037b4dc6ef36339$export$f2c3aea42b2a048f;
$a037b4dc6ef36339$export$76ccd210b9029917.allowedChildren = [
    $a037b4dc6ef36339$export$b05581f4e764e162
];
$a037b4dc6ef36339$export$b05581f4e764e162.requiredContainer = $a037b4dc6ef36339$export$76ccd210b9029917;
$a037b4dc6ef36339$export$b05581f4e764e162.allowedChildren = [
    $a037b4dc6ef36339$export$1e4baea7053fc0e3
];
$a037b4dc6ef36339$export$1e4baea7053fc0e3.requiredContainer = $a037b4dc6ef36339$export$b05581f4e764e162;
function $a037b4dc6ef36339$export$9bd6f73cbe857f1b() {
    const id = Math.random().toString(36).slice(2, 6);
    return `row-${id}`;
}

});


parcelRegister("9jTus", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c90ee9894f90610$export$2e2bcd8739ae039; });

var $kHwOs = parcelRequire("kHwOs");

var $eYvg2 = parcelRequire("eYvg2");

var $5ubWu = parcelRequire("5ubWu");

var $jzLjA = parcelRequire("jzLjA");

var $cC34A = parcelRequire("cC34A");
const $6c90ee9894f90610$var$debug = (0, $jzLjA.default)('quill:toolbar');
class $6c90ee9894f90610$export$2e2bcd8739ae039 extends (0, $cC34A.default) {
    constructor(quill, options){
        super(quill, options);
        if (Array.isArray(this.options.container)) {
            const container = document.createElement('div');
            container.setAttribute('role', 'toolbar');
            $6c90ee9894f90610$export$faadaf0198b97fbe(container, this.options.container);
            quill.container?.parentNode?.insertBefore(container, quill.container);
            this.container = container;
        } else if (typeof this.options.container === 'string') this.container = document.querySelector(this.options.container);
        else this.container = this.options.container;
        if (!(this.container instanceof HTMLElement)) {
            $6c90ee9894f90610$var$debug.error('Container required for toolbar', this.options);
            return;
        }
        this.container.classList.add('ql-toolbar');
        this.controls = [];
        this.handlers = {};
        if (this.options.handlers) Object.keys(this.options.handlers).forEach((format)=>{
            const handler = this.options.handlers?.[format];
            if (handler) this.addHandler(format, handler);
        });
        Array.from(this.container.querySelectorAll('button, select')).forEach((input)=>{
            // @ts-expect-error
            this.attach(input);
        });
        this.quill.on((0, $5ubWu.default).events.EDITOR_CHANGE, ()=>{
            const [range] = this.quill.selection.getRange(); // quill.getSelection triggers update
            this.update(range);
        });
    }
    addHandler(format, handler) {
        this.handlers[format] = handler;
    }
    attach(input) {
        let format = Array.from(input.classList).find((className)=>{
            return className.indexOf('ql-') === 0;
        });
        if (!format) return;
        format = format.slice(3);
        if (input.tagName === 'BUTTON') input.setAttribute('type', 'button');
        if (this.handlers[format] == null && this.quill.scroll.query(format) == null) {
            $6c90ee9894f90610$var$debug.warn('ignoring attaching to nonexistent format', format, input);
            return;
        }
        const eventName = input.tagName === 'SELECT' ? 'change' : 'click';
        input.addEventListener(eventName, (e)=>{
            let value;
            if (input.tagName === 'SELECT') {
                // @ts-expect-error
                if (input.selectedIndex < 0) return;
                // @ts-expect-error
                const selected = input.options[input.selectedIndex];
                if (selected.hasAttribute('selected')) value = false;
                else value = selected.value || false;
            } else {
                if (input.classList.contains('ql-active')) value = false;
                else // @ts-expect-error
                value = input.value || !input.hasAttribute('value');
                e.preventDefault();
            }
            this.quill.focus();
            const [range] = this.quill.selection.getRange();
            if (this.handlers[format] != null) this.handlers[format].call(this, value);
            else if (// @ts-expect-error
            this.quill.scroll.query(format).prototype instanceof (0, $eYvg2.EmbedBlot)) {
                value = prompt(`Enter ${format}`); // eslint-disable-line no-alert
                if (!value) return;
                this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($kHwOs)))()// @ts-expect-error Fix me later
                .retain(range.index)// @ts-expect-error Fix me later
                .delete(range.length).insert({
                    [format]: value
                }), (0, $5ubWu.default).sources.USER);
            } else this.quill.format(format, value, (0, $5ubWu.default).sources.USER);
            this.update(range);
        });
        this.controls.push([
            format,
            input
        ]);
    }
    update(range) {
        const formats = range == null ? {} : this.quill.getFormat(range);
        this.controls.forEach((pair)=>{
            const [format, input] = pair;
            if (input.tagName === 'SELECT') {
                let option = null;
                if (range == null) option = null;
                else if (formats[format] == null) option = input.querySelector('option[selected]');
                else if (!Array.isArray(formats[format])) {
                    let value = formats[format];
                    if (typeof value === 'string') value = value.replace(/"/g, '\\"');
                    option = input.querySelector(`option[value="${value}"]`);
                }
                if (option == null) {
                    // @ts-expect-error TODO fix me later
                    input.value = ''; // TODO make configurable?
                    // @ts-expect-error TODO fix me later
                    input.selectedIndex = -1;
                } else option.selected = true;
            } else if (range == null) {
                input.classList.remove('ql-active');
                input.setAttribute('aria-pressed', 'false');
            } else if (input.hasAttribute('value')) {
                // both being null should match (default values)
                // '1' should match with 1 (headers)
                const value = formats[format];
                const isActive = value === input.getAttribute('value') || value != null && value.toString() === input.getAttribute('value') || value == null && !input.getAttribute('value');
                input.classList.toggle('ql-active', isActive);
                input.setAttribute('aria-pressed', isActive.toString());
            } else {
                const isActive = formats[format] != null;
                input.classList.toggle('ql-active', isActive);
                input.setAttribute('aria-pressed', isActive.toString());
            }
        });
    }
}
$6c90ee9894f90610$export$2e2bcd8739ae039.DEFAULTS = {};
function $6c90ee9894f90610$var$addButton(container, format, value) {
    const input = document.createElement('button');
    input.setAttribute('type', 'button');
    input.classList.add(`ql-${format}`);
    input.setAttribute('aria-pressed', 'false');
    if (value != null) {
        input.value = value;
        input.setAttribute('aria-label', `${format}: ${value}`);
    } else input.setAttribute('aria-label', format);
    container.appendChild(input);
}
function $6c90ee9894f90610$export$faadaf0198b97fbe(container, groups) {
    if (!Array.isArray(groups[0])) // @ts-expect-error
    groups = [
        groups
    ];
    groups.forEach((controls)=>{
        const group = document.createElement('span');
        group.classList.add('ql-formats');
        controls.forEach((control)=>{
            if (typeof control === 'string') $6c90ee9894f90610$var$addButton(group, control);
            else {
                const format = Object.keys(control)[0];
                const value = control[format];
                if (Array.isArray(value)) $6c90ee9894f90610$var$addSelect(group, format, value);
                else $6c90ee9894f90610$var$addButton(group, format, value);
            }
        });
        container.appendChild(group);
    });
}
function $6c90ee9894f90610$var$addSelect(container, format, values) {
    const input = document.createElement('select');
    input.classList.add(`ql-${format}`);
    values.forEach((value)=>{
        const option = document.createElement('option');
        if (value !== false) option.setAttribute('value', String(value));
        else option.setAttribute('selected', 'selected');
        input.appendChild(option);
    });
    container.appendChild(input);
}
$6c90ee9894f90610$export$2e2bcd8739ae039.DEFAULTS = {
    container: null,
    handlers: {
        clean () {
            const range = this.quill.getSelection();
            if (range == null) return;
            if (range.length === 0) {
                const formats = this.quill.getFormat();
                Object.keys(formats).forEach((name)=>{
                    // Clean functionality in existing apps only clean inline formats
                    if (this.quill.scroll.query(name, (0, $eYvg2.Scope).INLINE) != null) this.quill.format(name, false, (0, $5ubWu.default).sources.USER);
                });
            } else this.quill.removeFormat(range.index, range.length, (0, $5ubWu.default).sources.USER);
        },
        direction (value) {
            const { align: align } = this.quill.getFormat();
            if (value === 'rtl' && align == null) this.quill.format('align', 'right', (0, $5ubWu.default).sources.USER);
            else if (!value && align === 'right') this.quill.format('align', false, (0, $5ubWu.default).sources.USER);
            this.quill.format('direction', value, (0, $5ubWu.default).sources.USER);
        },
        indent (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            // @ts-expect-error
            const indent = parseInt(formats.indent || 0, 10);
            if (value === '+1' || value === '-1') {
                let modifier = value === '+1' ? 1 : -1;
                if (formats.direction === 'rtl') modifier *= -1;
                this.quill.format('indent', indent + modifier, (0, $5ubWu.default).sources.USER);
            }
        },
        link (value) {
            if (value === true) value = prompt('Enter link URL:'); // eslint-disable-line no-alert
            this.quill.format('link', value, (0, $5ubWu.default).sources.USER);
        },
        list (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            if (value === 'check') {
                if (formats.list === 'checked' || formats.list === 'unchecked') this.quill.format('list', false, (0, $5ubWu.default).sources.USER);
                else this.quill.format('list', 'unchecked', (0, $5ubWu.default).sources.USER);
            } else this.quill.format('list', value, (0, $5ubWu.default).sources.USER);
        }
    }
};

});

parcelRegister("d94C1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $991fb17fdd479aca$export$2e2bcd8739ae039; });
const $991fb17fdd479aca$var$alignLeftIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"13\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"9\" y1=\"4\" y2=\"4\"/></svg>";
const $991fb17fdd479aca$var$alignCenterIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"14\" x2=\"4\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"12\" x2=\"6\" y1=\"4\" y2=\"4\"/></svg>";
const $991fb17fdd479aca$var$alignRightIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"5\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"9\" y1=\"4\" y2=\"4\"/></svg>";
const $991fb17fdd479aca$var$alignJustifyIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"4\" y2=\"4\"/></svg>";
const $991fb17fdd479aca$var$backgroundIcon = "<svg viewbox=\"0 0 18 18\"><g class=\"ql-fill ql-color-label\"><polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"/><rect height=\"1\" width=\"1\" x=\"4\" y=\"4\"/><polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"6\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"4\" y=\"7\"/><polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"12\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"9\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"15\"/><polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"8\"/><path d=\"M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z\"/><path d=\"M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z\"/><path d=\"M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z\"/><rect height=\"1\" width=\"1\" x=\"12\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"11\" y=\"3\"/><path d=\"M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"3\"/><rect height=\"1\" width=\"1\" x=\"6\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"5\" y=\"3\"/><rect height=\"1\" width=\"1\" x=\"9\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"14\"/><polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"/><rect height=\"1\" width=\"1\" x=\"13\" y=\"7\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"6\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"8\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"9\"/><path d=\"M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"3\"/><polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"12\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"13\" y=\"4\"/><polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"/><rect height=\"1\" width=\"1\" x=\"9\" y=\"14\"/><rect height=\"1\" width=\"1\" x=\"8\" y=\"15\"/><path d=\"M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z\"/><rect height=\"1\" width=\"1\" x=\"5\" y=\"15\"/><path d=\"M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z\"/><rect height=\"1\" width=\"1\" x=\"11\" y=\"15\"/><path d=\"M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"15\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"11\"/></g><polyline class=\"ql-stroke\" points=\"5.5 13 9 5 12.5 13\"/><line class=\"ql-stroke\" x1=\"11.63\" x2=\"6.38\" y1=\"11\" y2=\"11\"/></svg>";
const $991fb17fdd479aca$var$blockquoteIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-fill ql-stroke\" height=\"3\" width=\"3\" x=\"4\" y=\"5\"/><rect class=\"ql-fill ql-stroke\" height=\"3\" width=\"3\" x=\"11\" y=\"5\"/><path class=\"ql-even ql-fill ql-stroke\" d=\"M7,8c0,4.031-3,5-3,5\"/><path class=\"ql-even ql-fill ql-stroke\" d=\"M14,8c0,4.031-3,5-3,5\"/></svg>";
const $991fb17fdd479aca$var$boldIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-stroke\" d=\"M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z\"/><path class=\"ql-stroke\" d=\"M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z\"/></svg>";
const $991fb17fdd479aca$var$cleanIcon = "<svg class=\"\" viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"5\" x2=\"13\" y1=\"3\" y2=\"3\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"9.35\" y1=\"12\" y2=\"3\"/><line class=\"ql-stroke\" x1=\"11\" x2=\"15\" y1=\"11\" y2=\"15\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"11\" y1=\"11\" y2=\"15\"/><rect class=\"ql-fill\" height=\"1\" rx=\"0.5\" ry=\"0.5\" width=\"7\" x=\"2\" y=\"14\"/></svg>";
const $991fb17fdd479aca$var$codeIcon = "<svg viewbox=\"0 0 18 18\"><polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"/><polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"/><line class=\"ql-stroke\" x1=\"10\" x2=\"8\" y1=\"5\" y2=\"13\"/></svg>";
const $991fb17fdd479aca$var$colorIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-color-label ql-stroke ql-transparent\" x1=\"3\" x2=\"15\" y1=\"15\" y2=\"15\"/><polyline class=\"ql-stroke\" points=\"5.5 11 9 3 12.5 11\"/><line class=\"ql-stroke\" x1=\"11.63\" x2=\"6.38\" y1=\"9\" y2=\"9\"/></svg>";
const $991fb17fdd479aca$var$directionLeftToRightIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"/><line class=\"ql-stroke ql-fill\" x1=\"15\" x2=\"11\" y1=\"4\" y2=\"4\"/><path class=\"ql-fill\" d=\"M11,3a3,3,0,0,0,0,6h1V3H11Z\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"11\" y=\"4\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"13\" y=\"4\"/></svg>";
const $991fb17fdd479aca$var$directionRightToLeftIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"/><line class=\"ql-stroke ql-fill\" x1=\"9\" x2=\"5\" y1=\"4\" y2=\"4\"/><path class=\"ql-fill\" d=\"M5,3A3,3,0,0,0,5,9H6V3H5Z\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"5\" y=\"4\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"7\" y=\"4\"/></svg>";
const $991fb17fdd479aca$var$formulaIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z\"/><rect class=\"ql-fill\" height=\"1.6\" rx=\"0.8\" ry=\"0.8\" width=\"5\" x=\"5.15\" y=\"6.2\"/><path class=\"ql-fill\" d=\"M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z\"/></svg>";
const $991fb17fdd479aca$var$headerIcon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z\"/></svg>";
const $991fb17fdd479aca$var$header2Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $991fb17fdd479aca$var$header3Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.65186,12.30664a2.6742,2.6742,0,0,1-2.915,2.68457,3.96592,3.96592,0,0,1-2.25537-.6709.56007.56007,0,0,1-.13232-.83594L11.64648,13c.209-.34082.48389-.36328.82471-.1543a2.32654,2.32654,0,0,0,1.12256.33008c.71484,0,1.12207-.35156,1.12207-.78125,0-.61523-.61621-.86816-1.46338-.86816H13.2085a.65159.65159,0,0,1-.68213-.41895l-.05518-.10937a.67114.67114,0,0,1,.14307-.78125l.71533-.86914a8.55289,8.55289,0,0,1,.68213-.7373V8.58887a3.93913,3.93913,0,0,1-.748.05469H11.9873a.54085.54085,0,0,1-.605-.60547V7.59863a.54085.54085,0,0,1,.605-.60547h3.75146a.53773.53773,0,0,1,.60547.59375v.17676a1.03723,1.03723,0,0,1-.27539.748L14.74854,10.0293A2.31132,2.31132,0,0,1,16.65186,12.30664ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $991fb17fdd479aca$var$header4Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm7.05371,7.96582v.38477c0,.39648-.165.60547-.46191.60547h-.47314v1.29785a.54085.54085,0,0,1-.605.60547h-.69336a.54085.54085,0,0,1-.605-.60547V12.95605H11.333a.5412.5412,0,0,1-.60547-.60547v-.15332a1.199,1.199,0,0,1,.22021-.748l2.56348-4.05957a.7819.7819,0,0,1,.72607-.39648h1.27637a.54085.54085,0,0,1,.605.60547v3.7627h.33008A.54055.54055,0,0,1,17.05371,11.96582ZM14.28125,8.7207h-.022a4.18969,4.18969,0,0,1-.38525.81348l-1.188,1.80469v.02246h1.5293V9.60059A7.04058,7.04058,0,0,1,14.28125,8.7207Z\"/></svg>";
const $991fb17fdd479aca$var$header5Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.74023,12.18555a2.75131,2.75131,0,0,1-2.91553,2.80566,3.908,3.908,0,0,1-2.25537-.68164.54809.54809,0,0,1-.13184-.8252L11.73438,13c.209-.34082.48389-.36328.8252-.1543a2.23757,2.23757,0,0,0,1.1001.33008,1.01827,1.01827,0,0,0,1.1001-.96777c0-.61621-.53906-.97949-1.25439-.97949a2.15554,2.15554,0,0,0-.64893.09961,1.15209,1.15209,0,0,1-.814.01074l-.12109-.04395a.64116.64116,0,0,1-.45117-.71484l.231-3.00391a.56666.56666,0,0,1,.62744-.583H15.541a.54085.54085,0,0,1,.605.60547v.43945a.54085.54085,0,0,1-.605.60547H13.41748l-.04395.72559a1.29306,1.29306,0,0,1-.04395.30859h.022a2.39776,2.39776,0,0,1,.57227-.07715A2.53266,2.53266,0,0,1,16.74023,12.18555ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $991fb17fdd479aca$var$header6Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M14.51758,9.64453a1.85627,1.85627,0,0,0-1.24316.38477H13.252a1.73532,1.73532,0,0,1,1.72754-1.4082,2.66491,2.66491,0,0,1,.5498.06641c.35254.05469.57227.01074.70508-.40723l.16406-.5166a.53393.53393,0,0,0-.373-.75977,4.83723,4.83723,0,0,0-1.17773-.14258c-2.43164,0-3.7627,2.17773-3.7627,4.43359,0,2.47559,1.60645,3.69629,3.19043,3.69629A2.70585,2.70585,0,0,0,16.96,12.19727,2.43861,2.43861,0,0,0,14.51758,9.64453Zm-.23047,3.58691c-.67187,0-1.22168-.81445-1.22168-1.45215,0-.47363.30762-.583.72559-.583.96875,0,1.27734.59375,1.27734,1.12207A.82182.82182,0,0,1,14.28711,13.23145ZM10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Z\"/></svg>";
const $991fb17fdd479aca$var$italicIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"13\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"5\" x2=\"11\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"8\" x2=\"10\" y1=\"14\" y2=\"4\"/></svg>";
const $991fb17fdd479aca$var$imageIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"10\" width=\"12\" x=\"3\" y=\"4\"/><circle class=\"ql-fill\" cx=\"6\" cy=\"7\" r=\"1\"/><polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"/></svg>";
const $991fb17fdd479aca$var$indentIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"/></svg>";
const $991fb17fdd479aca$var$outdentIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-stroke\" points=\"5 7 5 11 3 9 5 7\"/></svg>";
const $991fb17fdd479aca$var$linkIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"11\" y1=\"7\" y2=\"11\"/><path class=\"ql-even ql-stroke\" d=\"M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z\"/><path class=\"ql-even ql-stroke\" d=\"M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z\"/></svg>";
const $991fb17fdd479aca$var$listBulletIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"14\" y2=\"14\"/></svg>";
const $991fb17fdd479aca$var$listCheckIcon = "<svg class=\"\" viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"4\" y2=\"4\"/><polyline class=\"ql-stroke\" points=\"3 4 4 5 6 3\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"14\" y2=\"14\"/><polyline class=\"ql-stroke\" points=\"3 14 4 15 6 13\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-stroke\" points=\"3 9 4 10 6 8\"/></svg>";
const $991fb17fdd479aca$var$listOrderedIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke ql-thin\" x1=\"2.5\" x2=\"4.5\" y1=\"5.5\" y2=\"5.5\"/><path class=\"ql-fill\" d=\"M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z\"/><path class=\"ql-stroke ql-thin\" d=\"M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156\"/><path class=\"ql-stroke ql-thin\" d=\"M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109\"/></svg>";
const $991fb17fdd479aca$var$subscriptIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z\"/><path class=\"ql-fill\" d=\"M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z\"/></svg>";
const $991fb17fdd479aca$var$superscriptIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z\"/><path class=\"ql-fill\" d=\"M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z\"/></svg>";
const $991fb17fdd479aca$var$strikeIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke ql-thin\" x1=\"15.5\" x2=\"2.5\" y1=\"8.5\" y2=\"9.5\"/><path class=\"ql-fill\" d=\"M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z\"/><path class=\"ql-fill\" d=\"M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z\"/></svg>";
const $991fb17fdd479aca$var$tableIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"12\" width=\"12\" x=\"3\" y=\"3\"/><rect class=\"ql-fill\" height=\"2\" width=\"3\" x=\"5\" y=\"5\"/><rect class=\"ql-fill\" height=\"2\" width=\"4\" x=\"9\" y=\"5\"/><g class=\"ql-fill ql-transparent\"><rect height=\"2\" width=\"3\" x=\"5\" y=\"8\"/><rect height=\"2\" width=\"4\" x=\"9\" y=\"8\"/><rect height=\"2\" width=\"3\" x=\"5\" y=\"11\"/><rect height=\"2\" width=\"4\" x=\"9\" y=\"11\"/></g></svg>";
const $991fb17fdd479aca$var$underlineIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-stroke\" d=\"M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3\"/><rect class=\"ql-fill\" height=\"1\" rx=\"0.5\" ry=\"0.5\" width=\"12\" x=\"3\" y=\"15\"/></svg>";
const $991fb17fdd479aca$var$videoIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"12\" width=\"12\" x=\"3\" y=\"3\"/><rect class=\"ql-fill\" height=\"12\" width=\"1\" x=\"5\" y=\"3\"/><rect class=\"ql-fill\" height=\"12\" width=\"1\" x=\"12\" y=\"3\"/><rect class=\"ql-fill\" height=\"2\" width=\"8\" x=\"5\" y=\"8\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"5\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"7\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"10\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"12\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"5\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"7\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"10\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"12\"/></svg>";
var $991fb17fdd479aca$export$2e2bcd8739ae039 = {
    align: {
        '': $991fb17fdd479aca$var$alignLeftIcon,
        center: $991fb17fdd479aca$var$alignCenterIcon,
        right: $991fb17fdd479aca$var$alignRightIcon,
        justify: $991fb17fdd479aca$var$alignJustifyIcon
    },
    background: $991fb17fdd479aca$var$backgroundIcon,
    blockquote: $991fb17fdd479aca$var$blockquoteIcon,
    bold: $991fb17fdd479aca$var$boldIcon,
    clean: $991fb17fdd479aca$var$cleanIcon,
    code: $991fb17fdd479aca$var$codeIcon,
    'code-block': $991fb17fdd479aca$var$codeIcon,
    color: $991fb17fdd479aca$var$colorIcon,
    direction: {
        '': $991fb17fdd479aca$var$directionLeftToRightIcon,
        rtl: $991fb17fdd479aca$var$directionRightToLeftIcon
    },
    formula: $991fb17fdd479aca$var$formulaIcon,
    header: {
        '1': $991fb17fdd479aca$var$headerIcon,
        '2': $991fb17fdd479aca$var$header2Icon,
        '3': $991fb17fdd479aca$var$header3Icon,
        '4': $991fb17fdd479aca$var$header4Icon,
        '5': $991fb17fdd479aca$var$header5Icon,
        '6': $991fb17fdd479aca$var$header6Icon
    },
    italic: $991fb17fdd479aca$var$italicIcon,
    image: $991fb17fdd479aca$var$imageIcon,
    indent: {
        '+1': $991fb17fdd479aca$var$indentIcon,
        '-1': $991fb17fdd479aca$var$outdentIcon
    },
    link: $991fb17fdd479aca$var$linkIcon,
    list: {
        bullet: $991fb17fdd479aca$var$listBulletIcon,
        check: $991fb17fdd479aca$var$listCheckIcon,
        ordered: $991fb17fdd479aca$var$listOrderedIcon
    },
    script: {
        sub: $991fb17fdd479aca$var$subscriptIcon,
        super: $991fb17fdd479aca$var$superscriptIcon
    },
    strike: $991fb17fdd479aca$var$strikeIcon,
    table: $991fb17fdd479aca$var$tableIcon,
    underline: $991fb17fdd479aca$var$underlineIcon,
    video: $991fb17fdd479aca$var$videoIcon
};

});

parcelRegister("bv0op", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85f2e4f6e170e3c2$export$2e2bcd8739ae039; });
const $85f2e4f6e170e3c2$var$DropdownIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke\" points=\"7 11 9 13 11 11 7 11\"/><polygon class=\"ql-stroke\" points=\"7 7 9 5 11 7 7 7\"/></svg>";
let $85f2e4f6e170e3c2$var$optionsCounter = 0;
function $85f2e4f6e170e3c2$var$toggleAriaAttribute(element, attribute) {
    element.setAttribute(attribute, `${!(element.getAttribute(attribute) === 'true')}`);
}
class $85f2e4f6e170e3c2$var$Picker {
    constructor(select){
        this.select = select;
        this.container = document.createElement('span');
        this.buildPicker();
        this.select.style.display = 'none';
        // @ts-expect-error Fix me later
        this.select.parentNode.insertBefore(this.container, this.select);
        this.label.addEventListener('mousedown', ()=>{
            this.togglePicker();
        });
        this.label.addEventListener('keydown', (event)=>{
            switch(event.key){
                case 'Enter':
                    this.togglePicker();
                    break;
                case 'Escape':
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        this.select.addEventListener('change', this.update.bind(this));
    }
    togglePicker() {
        this.container.classList.toggle('ql-expanded');
        // Toggle aria-expanded and aria-hidden to make the picker accessible
        $85f2e4f6e170e3c2$var$toggleAriaAttribute(this.label, 'aria-expanded');
        // @ts-expect-error
        $85f2e4f6e170e3c2$var$toggleAriaAttribute(this.options, 'aria-hidden');
    }
    buildItem(option) {
        const item = document.createElement('span');
        // @ts-expect-error
        item.tabIndex = '0';
        item.setAttribute('role', 'button');
        item.classList.add('ql-picker-item');
        const value = option.getAttribute('value');
        if (value) item.setAttribute('data-value', value);
        if (option.textContent) item.setAttribute('data-label', option.textContent);
        item.addEventListener('click', ()=>{
            this.selectItem(item, true);
        });
        item.addEventListener('keydown', (event)=>{
            switch(event.key){
                case 'Enter':
                    this.selectItem(item, true);
                    event.preventDefault();
                    break;
                case 'Escape':
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        return item;
    }
    buildLabel() {
        const label = document.createElement('span');
        label.classList.add('ql-picker-label');
        label.innerHTML = $85f2e4f6e170e3c2$var$DropdownIcon;
        // @ts-expect-error
        label.tabIndex = '0';
        label.setAttribute('role', 'button');
        label.setAttribute('aria-expanded', 'false');
        this.container.appendChild(label);
        return label;
    }
    buildOptions() {
        const options = document.createElement('span');
        options.classList.add('ql-picker-options');
        // Don't want screen readers to read this until options are visible
        options.setAttribute('aria-hidden', 'true');
        // @ts-expect-error
        options.tabIndex = '-1';
        // Need a unique id for aria-controls
        options.id = `ql-picker-options-${$85f2e4f6e170e3c2$var$optionsCounter}`;
        $85f2e4f6e170e3c2$var$optionsCounter += 1;
        this.label.setAttribute('aria-controls', options.id);
        // @ts-expect-error
        this.options = options;
        Array.from(this.select.options).forEach((option)=>{
            const item = this.buildItem(option);
            options.appendChild(item);
            if (option.selected === true) this.selectItem(item);
        });
        this.container.appendChild(options);
    }
    buildPicker() {
        Array.from(this.select.attributes).forEach((item)=>{
            this.container.setAttribute(item.name, item.value);
        });
        this.container.classList.add('ql-picker');
        this.label = this.buildLabel();
        this.buildOptions();
    }
    escape() {
        // Close menu and return focus to trigger label
        this.close();
        // Need setTimeout for accessibility to ensure that the browser executes
        // focus on the next process thread and after any DOM content changes
        setTimeout(()=>this.label.focus(), 1);
    }
    close() {
        this.container.classList.remove('ql-expanded');
        this.label.setAttribute('aria-expanded', 'false');
        // @ts-expect-error
        this.options.setAttribute('aria-hidden', 'true');
    }
    selectItem(item) {
        let trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        const selected = this.container.querySelector('.ql-selected');
        if (item === selected) return;
        if (selected != null) selected.classList.remove('ql-selected');
        if (item == null) return;
        item.classList.add('ql-selected');
        // @ts-expect-error Fix me later
        this.select.selectedIndex = Array.from(item.parentNode.children).indexOf(item);
        if (item.hasAttribute('data-value')) // @ts-expect-error Fix me later
        this.label.setAttribute('data-value', item.getAttribute('data-value'));
        else this.label.removeAttribute('data-value');
        if (item.hasAttribute('data-label')) // @ts-expect-error Fix me later
        this.label.setAttribute('data-label', item.getAttribute('data-label'));
        else this.label.removeAttribute('data-label');
        if (trigger) {
            this.select.dispatchEvent(new Event('change'));
            this.close();
        }
    }
    update() {
        let option;
        if (this.select.selectedIndex > -1) {
            const item = // @ts-expect-error Fix me later
            this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
            option = this.select.options[this.select.selectedIndex];
            // @ts-expect-error
            this.selectItem(item);
        } else this.selectItem(null);
        const isActive = option != null && option !== this.select.querySelector('option[selected]');
        this.label.classList.toggle('ql-active', isActive);
    }
}
var $85f2e4f6e170e3c2$export$2e2bcd8739ae039 = $85f2e4f6e170e3c2$var$Picker;

});

parcelRegister("7tZ3h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $572a997a5e622bd3$export$2e2bcd8739ae039; });

var $bv0op = parcelRequire("bv0op");
class $572a997a5e622bd3$var$ColorPicker extends (0, $bv0op.default) {
    constructor(select, label){
        super(select);
        this.label.innerHTML = label;
        this.container.classList.add('ql-color-picker');
        Array.from(this.container.querySelectorAll('.ql-picker-item')).slice(0, 7).forEach((item)=>{
            item.classList.add('ql-primary');
        });
    }
    buildItem(option) {
        const item = super.buildItem(option);
        item.style.backgroundColor = option.getAttribute('value') || '';
        return item;
    }
    selectItem(item, trigger) {
        super.selectItem(item, trigger);
        const colorLabel = this.label.querySelector('.ql-color-label');
        const value = item ? item.getAttribute('data-value') || '' : '';
        if (colorLabel) {
            if (colorLabel.tagName === 'line') colorLabel.style.stroke = value;
            else colorLabel.style.fill = value;
        }
    }
}
var $572a997a5e622bd3$export$2e2bcd8739ae039 = $572a997a5e622bd3$var$ColorPicker;

});

parcelRegister("43ibR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f358d743a371dea$export$2e2bcd8739ae039; });

var $bv0op = parcelRequire("bv0op");
class $2f358d743a371dea$var$IconPicker extends (0, $bv0op.default) {
    constructor(select, icons){
        super(select);
        this.container.classList.add('ql-icon-picker');
        Array.from(this.container.querySelectorAll('.ql-picker-item')).forEach((item)=>{
            item.innerHTML = icons[item.getAttribute('data-value') || ''];
        });
        this.defaultItem = this.container.querySelector('.ql-selected');
        this.selectItem(this.defaultItem);
    }
    selectItem(target, trigger) {
        super.selectItem(target, trigger);
        const item = target || this.defaultItem;
        if (item != null) {
            if (this.label.innerHTML === item.innerHTML) return;
            this.label.innerHTML = item.innerHTML;
        }
    }
}
var $2f358d743a371dea$export$2e2bcd8739ae039 = $2f358d743a371dea$var$IconPicker;

});

parcelRegister("4Fb6a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $365399b17f0b2f14$export$2e2bcd8739ae039; });
const $365399b17f0b2f14$var$isScrollable = (el)=>{
    const { overflowY: overflowY } = getComputedStyle(el, null);
    return overflowY !== 'visible' && overflowY !== 'clip';
};
class $365399b17f0b2f14$var$Tooltip {
    constructor(quill, boundsContainer){
        this.quill = quill;
        this.boundsContainer = boundsContainer || document.body;
        this.root = quill.addContainer('ql-tooltip');
        // @ts-expect-error
        this.root.innerHTML = this.constructor.TEMPLATE;
        if ($365399b17f0b2f14$var$isScrollable(this.quill.root)) this.quill.root.addEventListener('scroll', ()=>{
            this.root.style.marginTop = `${-1 * this.quill.root.scrollTop}px`;
        });
        this.hide();
    }
    hide() {
        this.root.classList.add('ql-hidden');
    }
    position(reference) {
        const left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
        // root.scrollTop should be 0 if scrollContainer !== root
        const top = reference.bottom + this.quill.root.scrollTop;
        this.root.style.left = `${left}px`;
        this.root.style.top = `${top}px`;
        this.root.classList.remove('ql-flip');
        const containerBounds = this.boundsContainer.getBoundingClientRect();
        const rootBounds = this.root.getBoundingClientRect();
        let shift = 0;
        if (rootBounds.right > containerBounds.right) {
            shift = containerBounds.right - rootBounds.right;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.left < containerBounds.left) {
            shift = containerBounds.left - rootBounds.left;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.bottom > containerBounds.bottom) {
            const height = rootBounds.bottom - rootBounds.top;
            const verticalShift = reference.bottom - reference.top + height;
            this.root.style.top = `${top - verticalShift}px`;
            this.root.classList.add('ql-flip');
        }
        return shift;
    }
    show() {
        this.root.classList.remove('ql-editing');
        this.root.classList.remove('ql-hidden');
    }
}
var $365399b17f0b2f14$export$2e2bcd8739ae039 = $365399b17f0b2f14$var$Tooltip;

});

parcelRegister("dOFk4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0efffaf9399876e$export$2e2bcd8739ae039; });

var $3izSM = parcelRequire("3izSM");

var $8AVGf = parcelRequire("8AVGf");

var $3I7zD = parcelRequire("3I7zD");

var $9iwdq = parcelRequire("9iwdq");

var $d94C1 = parcelRequire("d94C1");

var $5ubWu = parcelRequire("5ubWu");
const $a0efffaf9399876e$var$TOOLBAR_CONFIG = [
    [
        'bold',
        'italic',
        'link'
    ],
    [
        {
            header: 1
        },
        {
            header: 2
        },
        'blockquote'
    ]
];
class $a0efffaf9399876e$export$572b56f7a5e9813a extends (0, $3I7zD.BaseTooltip) {
    static TEMPLATE = [
        '<span class="ql-tooltip-arrow"></span>',
        '<div class="ql-tooltip-editor">',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-close"></a>',
        '</div>'
    ].join('');
    constructor(quill, bounds){
        super(quill, bounds);
        this.quill.on((0, $8AVGf.default).events.EDITOR_CHANGE, (type, range, oldRange, source)=>{
            if (type !== (0, $8AVGf.default).events.SELECTION_CHANGE) return;
            if (range != null && range.length > 0 && source === (0, $8AVGf.default).sources.USER) {
                this.show();
                // Lock our width so we will expand beyond our offsetParent boundaries
                this.root.style.left = '0px';
                this.root.style.width = '';
                this.root.style.width = `${this.root.offsetWidth}px`;
                const lines = this.quill.getLines(range.index, range.length);
                if (lines.length === 1) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                } else {
                    const lastLine = lines[lines.length - 1];
                    const index = this.quill.getIndex(lastLine);
                    const length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                    const indexBounds = this.quill.getBounds(new (0, $9iwdq.Range)(index, length));
                    if (indexBounds != null) this.position(indexBounds);
                }
            } else if (document.activeElement !== this.textbox && this.quill.hasFocus()) this.hide();
        });
    }
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector('.ql-close').addEventListener('click', ()=>{
            this.root.classList.remove('ql-editing');
        });
        this.quill.on((0, $8AVGf.default).events.SCROLL_OPTIMIZE, ()=>{
            // Let selection be restored by toolbar handlers before repositioning
            setTimeout(()=>{
                if (this.root.classList.contains('ql-hidden')) return;
                const range = this.quill.getSelection();
                if (range != null) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                }
            }, 1);
        });
    }
    cancel() {
        this.show();
    }
    position(reference) {
        const shift = super.position(reference);
        const arrow = this.root.querySelector('.ql-tooltip-arrow');
        // @ts-expect-error
        arrow.style.marginLeft = '';
        if (shift !== 0) // @ts-expect-error
        arrow.style.marginLeft = `${-1 * shift - arrow.offsetWidth / 2}px`;
        return shift;
    }
}
class $a0efffaf9399876e$export$2e2bcd8739ae039 extends (0, $3I7zD.default) {
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $a0efffaf9399876e$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add('ql-bubble');
    }
    extendToolbar(toolbar) {
        // @ts-expect-error
        this.tooltip = new $a0efffaf9399876e$export$572b56f7a5e9813a(this.quill, this.options.bounds);
        if (toolbar.container != null) {
            this.tooltip.root.appendChild(toolbar.container);
            this.buildButtons(toolbar.container.querySelectorAll('button'), (0, $d94C1.default));
            this.buildPickers(toolbar.container.querySelectorAll('select'), (0, $d94C1.default));
        }
    }
}
$a0efffaf9399876e$export$2e2bcd8739ae039.DEFAULTS = (0, $3izSM.default)({}, (0, $3I7zD.default).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (!value) this.quill.format('link', false, (0, $5ubWu.default).sources.USER);
                    else // @ts-expect-error
                    this.quill.theme.tooltip.edit();
                }
            }
        }
    }
});

});
parcelRegister("3I7zD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b3b5b2043ea6cfc$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "BaseTooltip", function () { return $2b3b5b2043ea6cfc$export$ba0102162f9e195c; });

var $3izSM = parcelRequire("3izSM");

var $8AVGf = parcelRequire("8AVGf");

var $8rmjg = parcelRequire("8rmjg");

var $7tZ3h = parcelRequire("7tZ3h");

var $43ibR = parcelRequire("43ibR");

var $bv0op = parcelRequire("bv0op");

var $4Fb6a = parcelRequire("4Fb6a");
const $2b3b5b2043ea6cfc$var$ALIGNS = [
    false,
    'center',
    'right',
    'justify'
];
const $2b3b5b2043ea6cfc$var$COLORS = [
    '#000000',
    '#e60000',
    '#ff9900',
    '#ffff00',
    '#008a00',
    '#0066cc',
    '#9933ff',
    '#ffffff',
    '#facccc',
    '#ffebcc',
    '#ffffcc',
    '#cce8cc',
    '#cce0f5',
    '#ebd6ff',
    '#bbbbbb',
    '#f06666',
    '#ffc266',
    '#ffff66',
    '#66b966',
    '#66a3e0',
    '#c285ff',
    '#888888',
    '#a10000',
    '#b26b00',
    '#b2b200',
    '#006100',
    '#0047b2',
    '#6b24b2',
    '#444444',
    '#5c0000',
    '#663d00',
    '#666600',
    '#003700',
    '#002966',
    '#3d1466'
];
const $2b3b5b2043ea6cfc$var$FONTS = [
    false,
    'serif',
    'monospace'
];
const $2b3b5b2043ea6cfc$var$HEADERS = [
    '1',
    '2',
    '3',
    false
];
const $2b3b5b2043ea6cfc$var$SIZES = [
    'small',
    false,
    'large',
    'huge'
];
class $2b3b5b2043ea6cfc$export$2e2bcd8739ae039 extends (0, $8rmjg.default) {
    constructor(quill, options){
        super(quill, options);
        const listener = (e)=>{
            if (!document.body.contains(quill.root)) {
                document.body.removeEventListener('click', listener);
                return;
            }
            if (this.tooltip != null && // @ts-expect-error
            !this.tooltip.root.contains(e.target) && // @ts-expect-error
            document.activeElement !== this.tooltip.textbox && !this.quill.hasFocus()) this.tooltip.hide();
            if (this.pickers != null) this.pickers.forEach((picker)=>{
                // @ts-expect-error
                if (!picker.container.contains(e.target)) picker.close();
            });
        };
        quill.emitter.listenDOM('click', document.body, listener);
    }
    addModule(name) {
        const module = super.addModule(name);
        if (name === 'toolbar') // @ts-expect-error
        this.extendToolbar(module);
        return module;
    }
    buildButtons(buttons, icons) {
        Array.from(buttons).forEach((button)=>{
            const className = button.getAttribute('class') || '';
            className.split(/\s+/).forEach((name)=>{
                if (!name.startsWith('ql-')) return;
                name = name.slice(3);
                if (icons[name] == null) return;
                if (name === 'direction') // @ts-expect-error
                button.innerHTML = icons[name][''] + icons[name].rtl;
                else if (typeof icons[name] === 'string') // @ts-expect-error
                button.innerHTML = icons[name];
                else {
                    // @ts-expect-error
                    const value = button.value || '';
                    // @ts-expect-error
                    if (value != null && icons[name][value]) // @ts-expect-error
                    button.innerHTML = icons[name][value];
                }
            });
        });
    }
    buildPickers(selects, icons) {
        this.pickers = Array.from(selects).map((select)=>{
            if (select.classList.contains('ql-align')) {
                if (select.querySelector('option') == null) $2b3b5b2043ea6cfc$var$fillSelect(select, $2b3b5b2043ea6cfc$var$ALIGNS);
                if (typeof icons.align === 'object') return new (0, $43ibR.default)(select, icons.align);
            }
            if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
                const format = select.classList.contains('ql-background') ? 'background' : 'color';
                if (select.querySelector('option') == null) $2b3b5b2043ea6cfc$var$fillSelect(select, $2b3b5b2043ea6cfc$var$COLORS, format === 'background' ? '#ffffff' : '#000000');
                return new (0, $7tZ3h.default)(select, icons[format]);
            }
            if (select.querySelector('option') == null) {
                if (select.classList.contains('ql-font')) $2b3b5b2043ea6cfc$var$fillSelect(select, $2b3b5b2043ea6cfc$var$FONTS);
                else if (select.classList.contains('ql-header')) $2b3b5b2043ea6cfc$var$fillSelect(select, $2b3b5b2043ea6cfc$var$HEADERS);
                else if (select.classList.contains('ql-size')) $2b3b5b2043ea6cfc$var$fillSelect(select, $2b3b5b2043ea6cfc$var$SIZES);
            }
            return new (0, $bv0op.default)(select);
        });
        const update = ()=>{
            this.pickers.forEach((picker)=>{
                picker.update();
            });
        };
        this.quill.on((0, $8AVGf.default).events.EDITOR_CHANGE, update);
    }
}
$2b3b5b2043ea6cfc$export$2e2bcd8739ae039.DEFAULTS = (0, $3izSM.default)({}, (0, $8rmjg.default).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                formula () {
                    this.quill.theme.tooltip.edit('formula');
                },
                image () {
                    let fileInput = this.container.querySelector('input.ql-image[type=file]');
                    if (fileInput == null) {
                        fileInput = document.createElement('input');
                        fileInput.setAttribute('type', 'file');
                        fileInput.setAttribute('accept', this.quill.uploader.options.mimetypes.join(', '));
                        fileInput.classList.add('ql-image');
                        fileInput.addEventListener('change', ()=>{
                            const range = this.quill.getSelection(true);
                            this.quill.uploader.upload(range, fileInput.files);
                            fileInput.value = '';
                        });
                        this.container.appendChild(fileInput);
                    }
                    fileInput.click();
                },
                video () {
                    this.quill.theme.tooltip.edit('video');
                }
            }
        }
    }
});
class $2b3b5b2043ea6cfc$export$ba0102162f9e195c extends (0, $4Fb6a.default) {
    constructor(quill, boundsContainer){
        super(quill, boundsContainer);
        this.textbox = this.root.querySelector('input[type="text"]');
        this.listen();
    }
    listen() {
        // @ts-expect-error Fix me later
        this.textbox.addEventListener('keydown', (event)=>{
            if (event.key === 'Enter') {
                this.save();
                event.preventDefault();
            } else if (event.key === 'Escape') {
                this.cancel();
                event.preventDefault();
            }
        });
    }
    cancel() {
        this.hide();
        this.restoreFocus();
    }
    edit() {
        let mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
        let preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        this.root.classList.remove('ql-hidden');
        this.root.classList.add('ql-editing');
        if (this.textbox == null) return;
        if (preview != null) this.textbox.value = preview;
        else if (mode !== this.root.getAttribute('data-mode')) this.textbox.value = '';
        const bounds = this.quill.getBounds(this.quill.selection.savedRange);
        if (bounds != null) this.position(bounds);
        this.textbox.select();
        this.textbox.setAttribute('placeholder', this.textbox.getAttribute(`data-${mode}`) || '');
        this.root.setAttribute('data-mode', mode);
    }
    restoreFocus() {
        this.quill.focus({
            preventScroll: true
        });
    }
    save() {
        // @ts-expect-error Fix me later
        let { value: value } = this.textbox;
        switch(this.root.getAttribute('data-mode')){
            case 'link':
                {
                    const { scrollTop: scrollTop } = this.quill.root;
                    if (this.linkRange) {
                        this.quill.formatText(this.linkRange, 'link', value, (0, $8AVGf.default).sources.USER);
                        delete this.linkRange;
                    } else {
                        this.restoreFocus();
                        this.quill.format('link', value, (0, $8AVGf.default).sources.USER);
                    }
                    this.quill.root.scrollTop = scrollTop;
                    break;
                }
            case 'video':
                value = $2b3b5b2043ea6cfc$var$extractVideoUrl(value);
            // eslint-disable-next-line no-fallthrough
            case 'formula':
                {
                    if (!value) break;
                    const range = this.quill.getSelection(true);
                    if (range != null) {
                        const index = range.index + range.length;
                        this.quill.insertEmbed(index, // @ts-expect-error Fix me later
                        this.root.getAttribute('data-mode'), value, (0, $8AVGf.default).sources.USER);
                        if (this.root.getAttribute('data-mode') === 'formula') this.quill.insertText(index + 1, ' ', (0, $8AVGf.default).sources.USER);
                        this.quill.setSelection(index + 2, (0, $8AVGf.default).sources.USER);
                    }
                    break;
                }
            default:
        }
        // @ts-expect-error Fix me later
        this.textbox.value = '';
        this.hide();
    }
}
function $2b3b5b2043ea6cfc$var$extractVideoUrl(url) {
    let match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (match) return `${match[1] || 'https'}://www.youtube.com/embed/${match[2]}?showinfo=0`;
    // eslint-disable-next-line no-cond-assign
    if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) return `${match[1] || 'https'}://player.vimeo.com/video/${match[2]}/`;
    return url;
}
function $2b3b5b2043ea6cfc$var$fillSelect(select, values) {
    let defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    values.forEach((value)=>{
        const option = document.createElement('option');
        if (value === defaultValue) option.setAttribute('selected', 'selected');
        else option.setAttribute('value', String(value));
        select.appendChild(option);
    });
}

});


parcelRegister("fbzOf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0e3a9189994bbc4$export$2e2bcd8739ae039; });

var $3izSM = parcelRequire("3izSM");

var $8AVGf = parcelRequire("8AVGf");

var $3I7zD = parcelRequire("3I7zD");

var $3yeFB = parcelRequire("3yeFB");

var $9iwdq = parcelRequire("9iwdq");

var $d94C1 = parcelRequire("d94C1");

var $5ubWu = parcelRequire("5ubWu");
const $b0e3a9189994bbc4$var$TOOLBAR_CONFIG = [
    [
        {
            header: [
                '1',
                '2',
                '3',
                false
            ]
        }
    ],
    [
        'bold',
        'italic',
        'underline',
        'link'
    ],
    [
        {
            list: 'ordered'
        },
        {
            list: 'bullet'
        }
    ],
    [
        'clean'
    ]
];
class $b0e3a9189994bbc4$var$SnowTooltip extends (0, $3I7zD.BaseTooltip) {
    static TEMPLATE = [
        '<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-action"></a>',
        '<a class="ql-remove"></a>'
    ].join('');
    preview = this.root.querySelector('a.ql-preview');
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector('a.ql-action').addEventListener('click', (event)=>{
            if (this.root.classList.contains('ql-editing')) this.save();
            else // @ts-expect-error Fix me later
            this.edit('link', this.preview.textContent);
            event.preventDefault();
        });
        // @ts-expect-error Fix me later
        this.root.querySelector('a.ql-remove').addEventListener('click', (event)=>{
            if (this.linkRange != null) {
                const range = this.linkRange;
                this.restoreFocus();
                this.quill.formatText(range, 'link', false, (0, $8AVGf.default).sources.USER);
                delete this.linkRange;
            }
            event.preventDefault();
            this.hide();
        });
        this.quill.on((0, $8AVGf.default).events.SELECTION_CHANGE, (range, oldRange, source)=>{
            if (range == null) return;
            if (range.length === 0 && source === (0, $8AVGf.default).sources.USER) {
                const [link, offset] = this.quill.scroll.descendant((0, $3yeFB.default), range.index);
                if (link != null) {
                    this.linkRange = new (0, $9iwdq.Range)(range.index - offset, link.length());
                    const preview = (0, $3yeFB.default).formats(link.domNode);
                    // @ts-expect-error Fix me later
                    this.preview.textContent = preview;
                    // @ts-expect-error Fix me later
                    this.preview.setAttribute('href', preview);
                    this.show();
                    const bounds = this.quill.getBounds(this.linkRange);
                    if (bounds != null) this.position(bounds);
                    return;
                }
            } else delete this.linkRange;
            this.hide();
        });
    }
    show() {
        super.show();
        this.root.removeAttribute('data-mode');
    }
}
class $b0e3a9189994bbc4$var$SnowTheme extends (0, $3I7zD.default) {
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $b0e3a9189994bbc4$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add('ql-snow');
    }
    extendToolbar(toolbar) {
        if (toolbar.container != null) {
            toolbar.container.classList.add('ql-snow');
            this.buildButtons(toolbar.container.querySelectorAll('button'), (0, $d94C1.default));
            this.buildPickers(toolbar.container.querySelectorAll('select'), (0, $d94C1.default));
            // @ts-expect-error
            this.tooltip = new $b0e3a9189994bbc4$var$SnowTooltip(this.quill, this.options.bounds);
            if (toolbar.container.querySelector('.ql-link')) this.quill.keyboard.addBinding({
                key: 'k',
                shortKey: true
            }, (_range, context)=>{
                toolbar.handlers.link.call(toolbar, !context.format.link);
            });
        }
    }
}
$b0e3a9189994bbc4$var$SnowTheme.DEFAULTS = (0, $3izSM.default)({}, (0, $3I7zD.default).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (value) {
                        const range = this.quill.getSelection();
                        if (range == null || range.length === 0) return;
                        let preview = this.quill.getText(range);
                        if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) preview = `mailto:${preview}`;
                        // @ts-expect-error
                        const { tooltip: tooltip } = this.quill.theme;
                        tooltip.edit('link', preview);
                    } else this.quill.format('link', false, (0, $5ubWu.default).sources.USER);
                }
            }
        }
    }
});
var $b0e3a9189994bbc4$export$2e2bcd8739ae039 = $b0e3a9189994bbc4$var$SnowTheme;

});


parcelRegister("ey3Jv", function(module, exports) {

var $keq6u = parcelRequire("keq6u");

var $lv5Eo = parcelRequire("lv5Eo");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $keq6u.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $lv5Eo;
module.exports = isBuffer;

});
parcelRegister("keq6u", function(module, exports) {

var $lMBYe = parcelRequire("lMBYe");
/** Detect free variable `self`. */ var $eba95d1b692937d0$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $eba95d1b692937d0$var$root = $lMBYe || $eba95d1b692937d0$var$freeSelf || Function('return this')();
module.exports = $eba95d1b692937d0$var$root;

});
parcelRegister("lMBYe", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $fdbb88d25afb8e4e$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $fdbb88d25afb8e4e$var$freeGlobal;

});


parcelRegister("lv5Eo", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $fa70e051f146c5b8$var$stubFalse() {
    return false;
}
module.exports = $fa70e051f146c5b8$var$stubFalse;

});


parcelRegister("i2urV", function(module, exports) {

var $lMBYe = parcelRequire("lMBYe");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $lMBYe.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("jexZI", function(module, exports) {

var $keq6u = parcelRequire("keq6u");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $keq6u.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("awzbB", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7a982fc3ea63d8a4$var$ReactIs, $7a982fc3ea63d8a4$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("s5PzN"))();

});

var $ede743d8c0d90f0b$exports = {};
$parcel$extendImportMap({
    "89Nig": "user_default.fd35f709.png",
    "3wbsB": "icon-pdf.7a025c2a.png",
    "83FL9": "icon-doc.4a2537d0.png",
    "dphDw": "icon-xcl.41f34213.png",
    "1EKZ2": "icon-vid.6fe41968.png",
    "dnYyC": "icon-msg.9f93970d.svg",
    "bhX3z": "building-photo.9df37ae7.jpg",
    "2nUDh": "pin.fea86983.svg",
    "jRbMB": "carousel-arrow.87d800bf.svg",
    "ZHpgD": "news-arrow.af7ffcbc.svg",
    "5ERi2": "logo-procore.2718c82e.png",
    "7xBTq": "logo-docebo.16b2c24a.png",
    "dosBv": "logo-helpdesk.c982e28e.svg",
    "kSmES": "logo-emburse.93886fe8.png",
    "7kNLR": "logo-adp.05469108.png",
    "fwPx7": "logo-buildr.f1512144.png",
    "9WPP3": "logo-openspace.6061b1ae.png",
    "b1XmQ": "logo-teams.aa334624.png",
    "5tiSp": "cheers.4fa0a885.png",
    "8Gfqa": "it-help.48f917c2.png",
    "kd7Cu": "logo_signin.cd5cef67.png",
    "cDiAF": "GooglePlay.80a32fba.png"
});


var $01ysi = parcelRequire("01ysi");
var $66e8bd72b116f830$exports = {};
'use strict';
function $66e8bd72b116f830$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($66e8bd72b116f830$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$66e8bd72b116f830$var$checkDCE();

$66e8bd72b116f830$exports = (parcelRequire("lTTfJ"));


/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $gRqVZ = parcelRequire("gRqVZ");

var $hYKvr = parcelRequire("hYKvr");
/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $80658610e38a69c8$var$_extends() {
    $80658610e38a69c8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $80658610e38a69c8$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $80658610e38a69c8$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($80658610e38a69c8$export$e19cd5f9376f8cee || ($80658610e38a69c8$export$e19cd5f9376f8cee = {}));
const $80658610e38a69c8$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $80658610e38a69c8$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $80658610e38a69c8$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $80658610e38a69c8$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $80658610e38a69c8$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $80658610e38a69c8$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $80658610e38a69c8$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $80658610e38a69c8$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $80658610e38a69c8$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $80658610e38a69c8$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $80658610e38a69c8$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $80658610e38a69c8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $80658610e38a69c8$export$fe53371bee54353d(to);
    }
    return $80658610e38a69c8$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $80658610e38a69c8$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $80658610e38a69c8$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $80658610e38a69c8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $80658610e38a69c8$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $80658610e38a69c8$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $80658610e38a69c8$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $80658610e38a69c8$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $80658610e38a69c8$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $80658610e38a69c8$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $80658610e38a69c8$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $80658610e38a69c8$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $80658610e38a69c8$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $80658610e38a69c8$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $80658610e38a69c8$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $80658610e38a69c8$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $80658610e38a69c8$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $80658610e38a69c8$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $80658610e38a69c8$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($80658610e38a69c8$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $80658610e38a69c8$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $80658610e38a69c8$export$e19cd5f9376f8cee.Push;
        let location = $80658610e38a69c8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $80658610e38a69c8$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $80658610e38a69c8$export$e19cd5f9376f8cee.Replace;
        let location = $80658610e38a69c8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $80658610e38a69c8$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $80658610e38a69c8$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $80658610e38a69c8$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($80658610e38a69c8$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($80658610e38a69c8$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $80658610e38a69c8$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($80658610e38a69c8$var$ResultType || ($80658610e38a69c8$var$ResultType = {}));
const $80658610e38a69c8$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $80658610e38a69c8$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $80658610e38a69c8$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $80658610e38a69c8$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $80658610e38a69c8$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($80658610e38a69c8$var$isIndexRoute(route)) {
            let indexRoute = $80658610e38a69c8$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $80658610e38a69c8$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $80658610e38a69c8$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $80658610e38a69c8$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $80658610e38a69c8$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $80658610e38a69c8$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $80658610e38a69c8$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $80658610e38a69c8$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $80658610e38a69c8$var$flattenRoutes(routes);
    $80658610e38a69c8$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $80658610e38a69c8$export$30d21fd6d7295f52(pathname);
        matches = $80658610e38a69c8$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $80658610e38a69c8$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $80658610e38a69c8$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $80658610e38a69c8$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $80658610e38a69c8$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $80658610e38a69c8$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $80658610e38a69c8$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $80658610e38a69c8$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $80658610e38a69c8$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $80658610e38a69c8$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $80658610e38a69c8$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $80658610e38a69c8$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $80658610e38a69c8$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $80658610e38a69c8$var$paramRe = /^:[\w-]+$/;
const $80658610e38a69c8$var$dynamicSegmentValue = 3;
const $80658610e38a69c8$var$indexRouteValue = 2;
const $80658610e38a69c8$var$emptySegmentValue = 1;
const $80658610e38a69c8$var$staticSegmentValue = 10;
const $80658610e38a69c8$var$splatPenalty = -2;
const $80658610e38a69c8$var$isSplat = (s)=>s === "*";
function $80658610e38a69c8$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($80658610e38a69c8$var$isSplat)) initialScore += $80658610e38a69c8$var$splatPenalty;
    if (index) initialScore += $80658610e38a69c8$var$indexRouteValue;
    return segments.filter((s)=>!$80658610e38a69c8$var$isSplat(s)).reduce((score, segment)=>score + ($80658610e38a69c8$var$paramRe.test(segment) ? $80658610e38a69c8$var$dynamicSegmentValue : segment === "" ? $80658610e38a69c8$var$emptySegmentValue : $80658610e38a69c8$var$staticSegmentValue), initialScore);
}
function $80658610e38a69c8$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $80658610e38a69c8$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $80658610e38a69c8$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $80658610e38a69c8$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $80658610e38a69c8$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $80658610e38a69c8$export$a5c6d149b50c1d86($80658610e38a69c8$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $80658610e38a69c8$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $80658610e38a69c8$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $80658610e38a69c8$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $80658610e38a69c8$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $80658610e38a69c8$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $80658610e38a69c8$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $80658610e38a69c8$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $80658610e38a69c8$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $80658610e38a69c8$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $80658610e38a69c8$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $80658610e38a69c8$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $80658610e38a69c8$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $80658610e38a69c8$var$isAbsoluteUrl = (url)=>$80658610e38a69c8$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $80658610e38a69c8$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $80658610e38a69c8$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($80658610e38a69c8$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $80658610e38a69c8$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $80658610e38a69c8$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $80658610e38a69c8$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $80658610e38a69c8$var$normalizeSearch(search),
        hash: $80658610e38a69c8$var$normalizeHash(hash)
    };
}
function $80658610e38a69c8$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $80658610e38a69c8$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $80658610e38a69c8$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $80658610e38a69c8$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $80658610e38a69c8$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $80658610e38a69c8$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $80658610e38a69c8$export$8ccf933b0513f8d0(toArg);
    else {
        to = $80658610e38a69c8$var$_extends({}, toArg);
        $80658610e38a69c8$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $80658610e38a69c8$var$getInvalidPathError("?", "pathname", "search", to));
        $80658610e38a69c8$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $80658610e38a69c8$var$getInvalidPathError("#", "pathname", "hash", to));
        $80658610e38a69c8$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $80658610e38a69c8$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $80658610e38a69c8$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $80658610e38a69c8$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $80658610e38a69c8$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $80658610e38a69c8$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $80658610e38a69c8$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $80658610e38a69c8$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $80658610e38a69c8$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $80658610e38a69c8$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $80658610e38a69c8$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $80658610e38a69c8$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $80658610e38a69c8$export$4051a07651545597(data, init) {
    return new $80658610e38a69c8$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $80658610e38a69c8$export$42a99a7a4bc0e76a extends Error {
}
class $80658610e38a69c8$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $80658610e38a69c8$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $80658610e38a69c8$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $80658610e38a69c8$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $80658610e38a69c8$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $80658610e38a69c8$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $80658610e38a69c8$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $80658610e38a69c8$var$unwrapTrackedPromise(value) {
    if (!$80658610e38a69c8$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $80658610e38a69c8$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $80658610e38a69c8$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $80658610e38a69c8$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $80658610e38a69c8$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $80658610e38a69c8$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $80658610e38a69c8$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $80658610e38a69c8$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $80658610e38a69c8$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $80658610e38a69c8$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $80658610e38a69c8$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $80658610e38a69c8$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $80658610e38a69c8$var$validMutationMethods = new Set($80658610e38a69c8$var$validMutationMethodsArr);
const $80658610e38a69c8$var$validRequestMethodsArr = [
    "get",
    ...$80658610e38a69c8$var$validMutationMethodsArr
];
const $80658610e38a69c8$var$validRequestMethods = new Set($80658610e38a69c8$var$validRequestMethodsArr);
const $80658610e38a69c8$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $80658610e38a69c8$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $80658610e38a69c8$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $80658610e38a69c8$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $80658610e38a69c8$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $80658610e38a69c8$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $80658610e38a69c8$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $80658610e38a69c8$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $80658610e38a69c8$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $80658610e38a69c8$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $80658610e38a69c8$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $80658610e38a69c8$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $80658610e38a69c8$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $80658610e38a69c8$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $80658610e38a69c8$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $80658610e38a69c8$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $80658610e38a69c8$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$80658610e38a69c8$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$80658610e38a69c8$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $80658610e38a69c8$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $80658610e38a69c8$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $80658610e38a69c8$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $80658610e38a69c8$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $80658610e38a69c8$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$80658610e38a69c8$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($80658610e38a69c8$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $80658610e38a69c8$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $80658610e38a69c8$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $80658610e38a69c8$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $80658610e38a69c8$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $80658610e38a69c8$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $80658610e38a69c8$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $80658610e38a69c8$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $80658610e38a69c8$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $80658610e38a69c8$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($80658610e38a69c8$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $80658610e38a69c8$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $80658610e38a69c8$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $80658610e38a69c8$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $80658610e38a69c8$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $80658610e38a69c8$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $80658610e38a69c8$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $80658610e38a69c8$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $80658610e38a69c8$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $80658610e38a69c8$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $80658610e38a69c8$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $80658610e38a69c8$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $80658610e38a69c8$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $80658610e38a69c8$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $80658610e38a69c8$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $80658610e38a69c8$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $80658610e38a69c8$var$findNearestBoundary(matches).route.id,
            {
                type: $80658610e38a69c8$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $80658610e38a69c8$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($80658610e38a69c8$var$isErrorResult(result) && $80658610e38a69c8$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $80658610e38a69c8$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $80658610e38a69c8$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $80658610e38a69c8$var$_extends({
            matches: updatedMatches || matches
        }, $80658610e38a69c8$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $80658610e38a69c8$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $80658610e38a69c8$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $80658610e38a69c8$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $80658610e38a69c8$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $80658610e38a69c8$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $80658610e38a69c8$var$ResultType.error,
            error: $80658610e38a69c8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($80658610e38a69c8$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $80658610e38a69c8$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($80658610e38a69c8$var$isDeferredResult(result)) throw $80658610e38a69c8$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($80658610e38a69c8$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $80658610e38a69c8$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $80658610e38a69c8$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $80658610e38a69c8$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $80658610e38a69c8$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($80658610e38a69c8$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $80658610e38a69c8$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $80658610e38a69c8$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $80658610e38a69c8$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $80658610e38a69c8$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $80658610e38a69c8$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $80658610e38a69c8$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $80658610e38a69c8$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $80658610e38a69c8$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $80658610e38a69c8$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $80658610e38a69c8$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$80658610e38a69c8$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $80658610e38a69c8$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $80658610e38a69c8$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $80658610e38a69c8$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $80658610e38a69c8$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $80658610e38a69c8$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $80658610e38a69c8$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $80658610e38a69c8$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $80658610e38a69c8$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $80658610e38a69c8$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $80658610e38a69c8$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $80658610e38a69c8$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $80658610e38a69c8$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($80658610e38a69c8$var$isRedirectResult(actionResult) || $80658610e38a69c8$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $80658610e38a69c8$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($80658610e38a69c8$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $80658610e38a69c8$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $80658610e38a69c8$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($80658610e38a69c8$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($80658610e38a69c8$var$isDeferredResult(actionResult)) throw $80658610e38a69c8$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $80658610e38a69c8$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $80658610e38a69c8$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $80658610e38a69c8$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $80658610e38a69c8$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $80658610e38a69c8$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $80658610e38a69c8$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $80658610e38a69c8$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $80658610e38a69c8$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $80658610e38a69c8$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $80658610e38a69c8$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $80658610e38a69c8$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $80658610e38a69c8$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $80658610e38a69c8$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $80658610e38a69c8$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $80658610e38a69c8$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $80658610e38a69c8$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($80658610e38a69c8$var$isDeferredResult(result)) result = await $80658610e38a69c8$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $80658610e38a69c8$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($80658610e38a69c8$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $80658610e38a69c8$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($80658610e38a69c8$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $80658610e38a69c8$export$3e9cee6b33872309(!$80658610e38a69c8$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $80658610e38a69c8$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $80658610e38a69c8$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $80658610e38a69c8$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $80658610e38a69c8$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($80658610e38a69c8$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $80658610e38a69c8$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $80658610e38a69c8$export$e19cd5f9376f8cee.Replace : $80658610e38a69c8$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $80658610e38a69c8$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($80658610e38a69c8$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $80658610e38a69c8$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $80658610e38a69c8$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $80658610e38a69c8$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $80658610e38a69c8$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $80658610e38a69c8$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($80658610e38a69c8$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $80658610e38a69c8$var$ResultType.redirect,
                response: $80658610e38a69c8$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $80658610e38a69c8$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $80658610e38a69c8$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $80658610e38a69c8$var$ResultType.error,
                    error: $80658610e38a69c8$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $80658610e38a69c8$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $80658610e38a69c8$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $80658610e38a69c8$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $80658610e38a69c8$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $80658610e38a69c8$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $80658610e38a69c8$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $80658610e38a69c8$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $80658610e38a69c8$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $80658610e38a69c8$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $80658610e38a69c8$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $80658610e38a69c8$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $80658610e38a69c8$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $80658610e38a69c8$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $80658610e38a69c8$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$80658610e38a69c8$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $80658610e38a69c8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $80658610e38a69c8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $80658610e38a69c8$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $80658610e38a69c8$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $80658610e38a69c8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $80658610e38a69c8$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $80658610e38a69c8$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $80658610e38a69c8$export$4d0306f8f6a4585b = Symbol("deferred");
function $80658610e38a69c8$export$3336b097a6fbc59a(routes, opts) {
    $80658610e38a69c8$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $80658610e38a69c8$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $80658610e38a69c8$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $80658610e38a69c8$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $80658610e38a69c8$var$createLocation("", $80658610e38a69c8$export$fe53371bee54353d(url), null, "default");
        let matches = $80658610e38a69c8$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$80658610e38a69c8$var$isValidMethod(method) && method !== "HEAD") {
            let error = $80658610e38a69c8$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $80658610e38a69c8$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $80658610e38a69c8$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $80658610e38a69c8$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($80658610e38a69c8$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $80658610e38a69c8$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $80658610e38a69c8$var$createLocation("", $80658610e38a69c8$export$fe53371bee54353d(url), null, "default");
        let matches = $80658610e38a69c8$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$80658610e38a69c8$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $80658610e38a69c8$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $80658610e38a69c8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $80658610e38a69c8$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $80658610e38a69c8$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $80658610e38a69c8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($80658610e38a69c8$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$80658610e38a69c8$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $80658610e38a69c8$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($80658610e38a69c8$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $80658610e38a69c8$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $80658610e38a69c8$var$isResponse(result) ? result : $80658610e38a69c8$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($80658610e38a69c8$var$isDataStrategyResult(e) && $80658610e38a69c8$var$isResponse(e.result)) {
                if (e.type === $80658610e38a69c8$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($80658610e38a69c8$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $80658610e38a69c8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $80658610e38a69c8$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $80658610e38a69c8$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($80658610e38a69c8$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($80658610e38a69c8$var$isDeferredResult(result)) {
            let error = $80658610e38a69c8$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $80658610e38a69c8$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($80658610e38a69c8$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($80658610e38a69c8$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $80658610e38a69c8$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $80658610e38a69c8$var$_extends({}, context, {
                statusCode: $80658610e38a69c8$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $80658610e38a69c8$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $80658610e38a69c8$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $80658610e38a69c8$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $80658610e38a69c8$var$isErrorResult(pendingActionResult[1]) ? $80658610e38a69c8$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $80658610e38a69c8$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $80658610e38a69c8$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $80658610e38a69c8$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $80658610e38a69c8$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $80658610e38a69c8$var$callDataStrategyImpl(dataStrategy || $80658610e38a69c8$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($80658610e38a69c8$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $80658610e38a69c8$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($80658610e38a69c8$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $80658610e38a69c8$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $80658610e38a69c8$export$fec11da027c70692(routes, context, error) {
    let newContext = $80658610e38a69c8$var$_extends({}, context, {
        statusCode: $80658610e38a69c8$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $80658610e38a69c8$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $80658610e38a69c8$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $80658610e38a69c8$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $80658610e38a69c8$export$cae722b0cc860f13(to ? to : ".", $80658610e38a69c8$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $80658610e38a69c8$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $80658610e38a69c8$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $80658610e38a69c8$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $80658610e38a69c8$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $80658610e38a69c8$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$80658610e38a69c8$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$80658610e38a69c8$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $80658610e38a69c8$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $80658610e38a69c8$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $80658610e38a69c8$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$80658610e38a69c8$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$80658610e38a69c8$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $80658610e38a69c8$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $80658610e38a69c8$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $80658610e38a69c8$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $80658610e38a69c8$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $80658610e38a69c8$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($80658610e38a69c8$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $80658610e38a69c8$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $80658610e38a69c8$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $80658610e38a69c8$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $80658610e38a69c8$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $80658610e38a69c8$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $80658610e38a69c8$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $80658610e38a69c8$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $80658610e38a69c8$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $80658610e38a69c8$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $80658610e38a69c8$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($80658610e38a69c8$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $80658610e38a69c8$var$shouldRevalidateLoader(match, $80658610e38a69c8$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $80658610e38a69c8$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $80658610e38a69c8$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $80658610e38a69c8$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $80658610e38a69c8$var$shouldRevalidateLoader(fetcherMatch, $80658610e38a69c8$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $80658610e38a69c8$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $80658610e38a69c8$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $80658610e38a69c8$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $80658610e38a69c8$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $80658610e38a69c8$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $80658610e38a69c8$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$80658610e38a69c8$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $80658610e38a69c8$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $80658610e38a69c8$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$80658610e38a69c8$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $80658610e38a69c8$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $80658610e38a69c8$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $80658610e38a69c8$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$80658610e38a69c8$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $80658610e38a69c8$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $80658610e38a69c8$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $80658610e38a69c8$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $80658610e38a69c8$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $80658610e38a69c8$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $80658610e38a69c8$var$ResultType.data,
                result: undefined
            });
        };
        return $80658610e38a69c8$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $80658610e38a69c8$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $80658610e38a69c8$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $80658610e38a69c8$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $80658610e38a69c8$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $80658610e38a69c8$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $80658610e38a69c8$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $80658610e38a69c8$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($80658610e38a69c8$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $80658610e38a69c8$var$ResultType.error,
                error: e
            };
        }
        if (type === $80658610e38a69c8$var$ResultType.error) return {
            type: $80658610e38a69c8$var$ResultType.error,
            error: new $80658610e38a69c8$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $80658610e38a69c8$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $80658610e38a69c8$var$ResultType.error) {
        if ($80658610e38a69c8$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $80658610e38a69c8$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $80658610e38a69c8$var$ResultType.error,
                error: new $80658610e38a69c8$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $80658610e38a69c8$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $80658610e38a69c8$var$ResultType.error,
            error: result,
            statusCode: $80658610e38a69c8$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($80658610e38a69c8$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $80658610e38a69c8$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($80658610e38a69c8$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $80658610e38a69c8$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $80658610e38a69c8$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $80658610e38a69c8$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $80658610e38a69c8$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$80658610e38a69c8$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $80658610e38a69c8$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $80658610e38a69c8$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($80658610e38a69c8$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $80658610e38a69c8$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $80658610e38a69c8$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($80658610e38a69c8$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $80658610e38a69c8$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $80658610e38a69c8$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $80658610e38a69c8$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $80658610e38a69c8$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $80658610e38a69c8$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $80658610e38a69c8$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $80658610e38a69c8$export$3e9cee6b33872309(!$80658610e38a69c8$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($80658610e38a69c8$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $80658610e38a69c8$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $80658610e38a69c8$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($80658610e38a69c8$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $80658610e38a69c8$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $80658610e38a69c8$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $80658610e38a69c8$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($80658610e38a69c8$var$isErrorResult(result)) {
            let boundaryMatch = $80658610e38a69c8$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $80658610e38a69c8$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($80658610e38a69c8$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $80658610e38a69c8$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($80658610e38a69c8$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $80658610e38a69c8$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $80658610e38a69c8$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $80658610e38a69c8$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $80658610e38a69c8$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $80658610e38a69c8$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $80658610e38a69c8$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $80658610e38a69c8$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $80658610e38a69c8$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $80658610e38a69c8$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $80658610e38a69c8$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $80658610e38a69c8$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($80658610e38a69c8$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $80658610e38a69c8$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $80658610e38a69c8$export$8ccf933b0513f8d0(path) : path;
    return $80658610e38a69c8$export$fe53371bee54353d($80658610e38a69c8$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $80658610e38a69c8$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $80658610e38a69c8$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $80658610e38a69c8$var$ResultType.data || result.type === $80658610e38a69c8$var$ResultType.error);
}
function $80658610e38a69c8$var$isRedirectDataStrategyResultResult(result) {
    return $80658610e38a69c8$var$isResponse(result.result) && $80658610e38a69c8$var$redirectStatusCodes.has(result.result.status);
}
function $80658610e38a69c8$var$isDeferredResult(result) {
    return result.type === $80658610e38a69c8$var$ResultType.deferred;
}
function $80658610e38a69c8$var$isErrorResult(result) {
    return result.type === $80658610e38a69c8$var$ResultType.error;
}
function $80658610e38a69c8$var$isRedirectResult(result) {
    return (result && result.type) === $80658610e38a69c8$var$ResultType.redirect;
}
function $80658610e38a69c8$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $80658610e38a69c8$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $80658610e38a69c8$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $80658610e38a69c8$var$isRedirectResponse(result) {
    if (!$80658610e38a69c8$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $80658610e38a69c8$var$isValidMethod(method) {
    return $80658610e38a69c8$var$validRequestMethods.has(method.toLowerCase());
}
function $80658610e38a69c8$var$isMutationMethod(method) {
    return $80658610e38a69c8$var$validMutationMethods.has(method.toLowerCase());
}
async function $80658610e38a69c8$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$80658610e38a69c8$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($80658610e38a69c8$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $80658610e38a69c8$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $80658610e38a69c8$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($80658610e38a69c8$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $80658610e38a69c8$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $80658610e38a69c8$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $80658610e38a69c8$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $80658610e38a69c8$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $80658610e38a69c8$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $80658610e38a69c8$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $80658610e38a69c8$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $80658610e38a69c8$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $80658610e38a69c8$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $80658610e38a69c8$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $80658610e38a69c8$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $80658610e38a69c8$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $80658610e38a69c8$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $80658610e38a69c8$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $80658610e38a69c8$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $80658610e38a69c8$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $80658610e38a69c8$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $80658610e38a69c8$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($80658610e38a69c8$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $80658610e38a69c8$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($80658610e38a69c8$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $80658610e38a69c8$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $gRqVZ = parcelRequire("gRqVZ");

function $372fcccf2bee01ac$var$_extends() {
    $372fcccf2bee01ac$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $372fcccf2bee01ac$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $372fcccf2bee01ac$export$3add0d5dce533e2e = /*#__PURE__*/ $gRqVZ.createContext(null);
const $372fcccf2bee01ac$export$145dfa71566a64dc = /*#__PURE__*/ $gRqVZ.createContext(null);
const $372fcccf2bee01ac$var$AwaitContext = /*#__PURE__*/ $gRqVZ.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $372fcccf2bee01ac$export$26749e8557646306 = /*#__PURE__*/ $gRqVZ.createContext(null);
const $372fcccf2bee01ac$export$c7914228fb69b0f5 = /*#__PURE__*/ $gRqVZ.createContext(null);
const $372fcccf2bee01ac$export$9072aa6dd1f93057 = /*#__PURE__*/ $gRqVZ.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $372fcccf2bee01ac$var$RouteErrorContext = /*#__PURE__*/ $gRqVZ.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $372fcccf2bee01ac$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$372fcccf2bee01ac$export$9c954a9d03d32f4a() && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $gRqVZ.useContext($372fcccf2bee01ac$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $372fcccf2bee01ac$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $80658610e38a69c8$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $372fcccf2bee01ac$export$9c954a9d03d32f4a() {
    return $gRqVZ.useContext($372fcccf2bee01ac$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $372fcccf2bee01ac$export$45d76561a5302f2b() {
    !$372fcccf2bee01ac$export$9c954a9d03d32f4a() && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
    return $gRqVZ.useContext($372fcccf2bee01ac$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $372fcccf2bee01ac$export$1b3f31771c5d07c() {
    return $gRqVZ.useContext($372fcccf2bee01ac$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $372fcccf2bee01ac$export$6c330e8992e8a295(pattern) {
    !$372fcccf2bee01ac$export$9c954a9d03d32f4a() && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $372fcccf2bee01ac$export$45d76561a5302f2b();
    return $gRqVZ.useMemo(()=>(0, $80658610e38a69c8$export$81336c211d5ff295)(pattern, (0, $80658610e38a69c8$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $372fcccf2bee01ac$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $372fcccf2bee01ac$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $gRqVZ.useContext($372fcccf2bee01ac$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $gRqVZ.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $372fcccf2bee01ac$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $gRqVZ.useContext($372fcccf2bee01ac$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $372fcccf2bee01ac$var$useNavigateStable() : $372fcccf2bee01ac$var$useNavigateUnstable();
}
function $372fcccf2bee01ac$var$useNavigateUnstable() {
    !$372fcccf2bee01ac$export$9c954a9d03d32f4a() && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
    let dataRouterContext = $gRqVZ.useContext($372fcccf2bee01ac$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $gRqVZ.useContext($372fcccf2bee01ac$export$26749e8557646306);
    let { matches: matches } = $gRqVZ.useContext($372fcccf2bee01ac$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $372fcccf2bee01ac$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $80658610e38a69c8$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $gRqVZ.useRef(false);
    $372fcccf2bee01ac$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $gRqVZ.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $80658610e38a69c8$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $80658610e38a69c8$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $372fcccf2bee01ac$var$OutletContext = /*#__PURE__*/ $gRqVZ.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $372fcccf2bee01ac$export$4138103a3ae699cc() {
    return $gRqVZ.useContext($372fcccf2bee01ac$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $372fcccf2bee01ac$export$a3be3530d8e40d0b(context) {
    let outlet = $gRqVZ.useContext($372fcccf2bee01ac$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $gRqVZ.createElement($372fcccf2bee01ac$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $372fcccf2bee01ac$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $gRqVZ.useContext($372fcccf2bee01ac$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $372fcccf2bee01ac$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $gRqVZ.useContext($372fcccf2bee01ac$export$26749e8557646306);
    let { matches: matches } = $gRqVZ.useContext($372fcccf2bee01ac$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $372fcccf2bee01ac$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $80658610e38a69c8$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $gRqVZ.useMemo(()=>(0, $80658610e38a69c8$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $372fcccf2bee01ac$export$5d3fca4a98652595(routes, locationArg) {
    return $372fcccf2bee01ac$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $372fcccf2bee01ac$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$372fcccf2bee01ac$export$9c954a9d03d32f4a() && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $gRqVZ.useContext($372fcccf2bee01ac$export$26749e8557646306);
    let { matches: parentMatches } = $gRqVZ.useContext($372fcccf2bee01ac$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $372fcccf2bee01ac$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $80658610e38a69c8$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $80658610e38a69c8$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $372fcccf2bee01ac$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $80658610e38a69c8$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $80658610e38a69c8$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $gRqVZ.createElement($372fcccf2bee01ac$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $372fcccf2bee01ac$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $80658610e38a69c8$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $372fcccf2bee01ac$var$DefaultErrorComponent() {
    let error = $372fcccf2bee01ac$export$ed527bf60f6e05f2();
    let message = (0, $80658610e38a69c8$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $gRqVZ.createElement($gRqVZ.Fragment, null, /*#__PURE__*/ $gRqVZ.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $gRqVZ.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $gRqVZ.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $372fcccf2bee01ac$var$defaultErrorElement = /*#__PURE__*/ $gRqVZ.createElement($372fcccf2bee01ac$var$DefaultErrorComponent, null);
class $372fcccf2bee01ac$var$RenderErrorBoundary extends $gRqVZ.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $gRqVZ.createElement($372fcccf2bee01ac$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $gRqVZ.createElement($372fcccf2bee01ac$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $372fcccf2bee01ac$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $gRqVZ.useContext($372fcccf2bee01ac$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $gRqVZ.createElement($372fcccf2bee01ac$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $372fcccf2bee01ac$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $372fcccf2bee01ac$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $372fcccf2bee01ac$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $gRqVZ.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $gRqVZ.createElement($372fcccf2bee01ac$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $gRqVZ.createElement($372fcccf2bee01ac$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $372fcccf2bee01ac$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($372fcccf2bee01ac$var$DataRouterHook || {});
var $372fcccf2bee01ac$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($372fcccf2bee01ac$var$DataRouterStateHook || {});
function $372fcccf2bee01ac$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $372fcccf2bee01ac$var$useDataRouterContext(hookName) {
    let ctx = $gRqVZ.useContext($372fcccf2bee01ac$export$3add0d5dce533e2e);
    !ctx && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
    return ctx;
}
function $372fcccf2bee01ac$var$useDataRouterState(hookName) {
    let state = $gRqVZ.useContext($372fcccf2bee01ac$export$145dfa71566a64dc);
    !state && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
    return state;
}
function $372fcccf2bee01ac$var$useRouteContext(hookName) {
    let route = $gRqVZ.useContext($372fcccf2bee01ac$export$9072aa6dd1f93057);
    !route && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $372fcccf2bee01ac$var$useCurrentRouteId(hookName) {
    let route = $372fcccf2bee01ac$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $372fcccf2bee01ac$export$5fc8298006ad9e58() {
    return $372fcccf2bee01ac$var$useCurrentRouteId($372fcccf2bee01ac$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $372fcccf2bee01ac$export$d0fd4b7106de2769() {
    let state = $372fcccf2bee01ac$var$useDataRouterState($372fcccf2bee01ac$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $372fcccf2bee01ac$export$600dc272ed516c15() {
    let dataRouterContext = $372fcccf2bee01ac$var$useDataRouterContext($372fcccf2bee01ac$var$DataRouterHook.UseRevalidator);
    let state = $372fcccf2bee01ac$var$useDataRouterState($372fcccf2bee01ac$var$DataRouterStateHook.UseRevalidator);
    return $gRqVZ.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $372fcccf2bee01ac$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $372fcccf2bee01ac$var$useDataRouterState($372fcccf2bee01ac$var$DataRouterStateHook.UseMatches);
    return $gRqVZ.useMemo(()=>matches.map((m)=>(0, $80658610e38a69c8$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $372fcccf2bee01ac$export$1448a5050d252c4d() {
    let state = $372fcccf2bee01ac$var$useDataRouterState($372fcccf2bee01ac$var$DataRouterStateHook.UseLoaderData);
    let routeId = $372fcccf2bee01ac$var$useCurrentRouteId($372fcccf2bee01ac$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $372fcccf2bee01ac$export$fd5d37484eab868d(routeId) {
    let state = $372fcccf2bee01ac$var$useDataRouterState($372fcccf2bee01ac$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $372fcccf2bee01ac$export$fdc00f3f26066d5e() {
    let state = $372fcccf2bee01ac$var$useDataRouterState($372fcccf2bee01ac$var$DataRouterStateHook.UseActionData);
    let routeId = $372fcccf2bee01ac$var$useCurrentRouteId($372fcccf2bee01ac$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $372fcccf2bee01ac$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $gRqVZ.useContext($372fcccf2bee01ac$var$RouteErrorContext);
    let state = $372fcccf2bee01ac$var$useDataRouterState($372fcccf2bee01ac$var$DataRouterStateHook.UseRouteError);
    let routeId = $372fcccf2bee01ac$var$useCurrentRouteId($372fcccf2bee01ac$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $372fcccf2bee01ac$export$78a72ddb39bdd145() {
    let value = $gRqVZ.useContext($372fcccf2bee01ac$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $372fcccf2bee01ac$export$17f53340677d5831() {
    let value = $gRqVZ.useContext($372fcccf2bee01ac$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $372fcccf2bee01ac$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $372fcccf2bee01ac$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $372fcccf2bee01ac$var$useDataRouterContext($372fcccf2bee01ac$var$DataRouterHook.UseBlocker);
    let state = $372fcccf2bee01ac$var$useDataRouterState($372fcccf2bee01ac$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $gRqVZ.useState("");
    let blockerFunction = $gRqVZ.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $372fcccf2bee01ac$var$_extends({}, currentLocation, {
                pathname: (0, $80658610e38a69c8$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $372fcccf2bee01ac$var$_extends({}, nextLocation, {
                pathname: (0, $80658610e38a69c8$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $gRqVZ.useEffect(()=>{
        let key = String(++$372fcccf2bee01ac$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $gRqVZ.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $80658610e38a69c8$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $372fcccf2bee01ac$var$useNavigateStable() {
    let { router: router } = $372fcccf2bee01ac$var$useDataRouterContext($372fcccf2bee01ac$var$DataRouterHook.UseNavigateStable);
    let id = $372fcccf2bee01ac$var$useCurrentRouteId($372fcccf2bee01ac$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $gRqVZ.useRef(false);
    $372fcccf2bee01ac$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $gRqVZ.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $372fcccf2bee01ac$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $372fcccf2bee01ac$var$alreadyWarned$1 = {};
function $372fcccf2bee01ac$var$warningOnce(key, cond, message) {
    if (!cond && !$372fcccf2bee01ac$var$alreadyWarned$1[key]) $372fcccf2bee01ac$var$alreadyWarned$1[key] = true;
}
const $372fcccf2bee01ac$var$alreadyWarned = {};
function $372fcccf2bee01ac$var$warnOnce(key, message) {}
const $372fcccf2bee01ac$var$logDeprecation = (flag, msg, link)=>$372fcccf2bee01ac$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $372fcccf2bee01ac$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $372fcccf2bee01ac$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $372fcccf2bee01ac$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $372fcccf2bee01ac$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $372fcccf2bee01ac$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $372fcccf2bee01ac$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $372fcccf2bee01ac$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $372fcccf2bee01ac$var$START_TRANSITION = "startTransition";
const $372fcccf2bee01ac$var$startTransitionImpl = $gRqVZ[$372fcccf2bee01ac$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $372fcccf2bee01ac$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $gRqVZ.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $gRqVZ.useCallback((newState)=>{
        if (v7_startTransition && $372fcccf2bee01ac$var$startTransitionImpl) $372fcccf2bee01ac$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $gRqVZ.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $gRqVZ.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $gRqVZ.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $gRqVZ.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $gRqVZ.useEffect(()=>$372fcccf2bee01ac$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $gRqVZ.createElement($gRqVZ.Fragment, null, /*#__PURE__*/ $gRqVZ.createElement($372fcccf2bee01ac$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $gRqVZ.createElement($372fcccf2bee01ac$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $gRqVZ.createElement($372fcccf2bee01ac$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $gRqVZ.createElement($372fcccf2bee01ac$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $372fcccf2bee01ac$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $372fcccf2bee01ac$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $372fcccf2bee01ac$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $gRqVZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $80658610e38a69c8$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $gRqVZ.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $gRqVZ.useCallback((newState)=>{
        v7_startTransition && $372fcccf2bee01ac$var$startTransitionImpl ? $372fcccf2bee01ac$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $gRqVZ.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $gRqVZ.useEffect(()=>$372fcccf2bee01ac$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $gRqVZ.createElement($372fcccf2bee01ac$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $372fcccf2bee01ac$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$372fcccf2bee01ac$export$9c954a9d03d32f4a() && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $gRqVZ.useContext($372fcccf2bee01ac$export$26749e8557646306);
    let { matches: matches } = $gRqVZ.useContext($372fcccf2bee01ac$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $372fcccf2bee01ac$export$45d76561a5302f2b();
    let navigate = $372fcccf2bee01ac$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $80658610e38a69c8$export$cae722b0cc860f13)(to, (0, $80658610e38a69c8$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $gRqVZ.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $372fcccf2bee01ac$export$910ae8079b2c2852(props) {
    return $372fcccf2bee01ac$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $372fcccf2bee01ac$export$e7b0ac011bb776c6(_props) {
    (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $372fcccf2bee01ac$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $80658610e38a69c8$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$372fcccf2bee01ac$export$9c954a9d03d32f4a() && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $gRqVZ.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $372fcccf2bee01ac$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $80658610e38a69c8$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $gRqVZ.useMemo(()=>{
        let trailingPathname = (0, $80658610e38a69c8$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $gRqVZ.createElement($372fcccf2bee01ac$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $gRqVZ.createElement($372fcccf2bee01ac$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $372fcccf2bee01ac$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $372fcccf2bee01ac$export$5d3fca4a98652595($372fcccf2bee01ac$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $372fcccf2bee01ac$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $gRqVZ.createElement($372fcccf2bee01ac$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $gRqVZ.createElement($372fcccf2bee01ac$var$ResolveAwait, null, children));
}
var $372fcccf2bee01ac$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($372fcccf2bee01ac$var$AwaitRenderStatus || {});
const $372fcccf2bee01ac$var$neverSettledPromise = new Promise(()=>{});
class $372fcccf2bee01ac$var$AwaitErrorBoundary extends $gRqVZ.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $372fcccf2bee01ac$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $372fcccf2bee01ac$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $372fcccf2bee01ac$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $372fcccf2bee01ac$var$AwaitRenderStatus.error : "_data" in promise ? $372fcccf2bee01ac$var$AwaitRenderStatus.success : $372fcccf2bee01ac$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $372fcccf2bee01ac$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $372fcccf2bee01ac$var$AwaitRenderStatus.error && promise._error instanceof (0, $80658610e38a69c8$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $372fcccf2bee01ac$var$neverSettledPromise;
        if (status === $372fcccf2bee01ac$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $372fcccf2bee01ac$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $gRqVZ.createElement($372fcccf2bee01ac$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $372fcccf2bee01ac$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $gRqVZ.createElement($372fcccf2bee01ac$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $372fcccf2bee01ac$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $372fcccf2bee01ac$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $gRqVZ.createElement($gRqVZ.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $372fcccf2bee01ac$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $gRqVZ.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $gRqVZ.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $gRqVZ.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $372fcccf2bee01ac$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $372fcccf2bee01ac$export$e7b0ac011bb776c6) && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $372fcccf2bee01ac$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $372fcccf2bee01ac$export$daf73786167a7f72(matches) {
    return $372fcccf2bee01ac$var$_renderMatches(matches);
}
function $372fcccf2bee01ac$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $gRqVZ.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $gRqVZ.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $gRqVZ.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $372fcccf2bee01ac$export$f30f7e456d254e83(routes, opts) {
    return (0, $80658610e38a69c8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $372fcccf2bee01ac$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $80658610e38a69c8$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $372fcccf2bee01ac$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $e3f57e4b1ea630bd$var$_extends() {
    $e3f57e4b1ea630bd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e3f57e4b1ea630bd$var$_extends.apply(this, arguments);
}
function $e3f57e4b1ea630bd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $e3f57e4b1ea630bd$var$defaultMethod = "get";
const $e3f57e4b1ea630bd$var$defaultEncType = "application/x-www-form-urlencoded";
function $e3f57e4b1ea630bd$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $e3f57e4b1ea630bd$var$isButtonElement(object) {
    return $e3f57e4b1ea630bd$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $e3f57e4b1ea630bd$var$isFormElement(object) {
    return $e3f57e4b1ea630bd$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $e3f57e4b1ea630bd$var$isInputElement(object) {
    return $e3f57e4b1ea630bd$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $e3f57e4b1ea630bd$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $e3f57e4b1ea630bd$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$e3f57e4b1ea630bd$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $e3f57e4b1ea630bd$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $e3f57e4b1ea630bd$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $e3f57e4b1ea630bd$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $e3f57e4b1ea630bd$var$_formDataSupportsSubmitter = null;
function $e3f57e4b1ea630bd$var$isFormDataSubmitterSupported() {
    if ($e3f57e4b1ea630bd$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $e3f57e4b1ea630bd$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $e3f57e4b1ea630bd$var$_formDataSupportsSubmitter = true;
    }
    return $e3f57e4b1ea630bd$var$_formDataSupportsSubmitter;
}
const $e3f57e4b1ea630bd$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $e3f57e4b1ea630bd$var$getFormEncType(encType) {
    if (encType != null && !$e3f57e4b1ea630bd$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $e3f57e4b1ea630bd$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($e3f57e4b1ea630bd$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $80658610e38a69c8$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $e3f57e4b1ea630bd$var$defaultMethod;
        encType = $e3f57e4b1ea630bd$var$getFormEncType(target.getAttribute("enctype")) || $e3f57e4b1ea630bd$var$defaultEncType;
        formData = new FormData(target);
    } else if ($e3f57e4b1ea630bd$var$isButtonElement(target) || $e3f57e4b1ea630bd$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $80658610e38a69c8$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $e3f57e4b1ea630bd$var$defaultMethod;
        encType = $e3f57e4b1ea630bd$var$getFormEncType(target.getAttribute("formenctype")) || $e3f57e4b1ea630bd$var$getFormEncType(form.getAttribute("enctype")) || $e3f57e4b1ea630bd$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$e3f57e4b1ea630bd$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($e3f57e4b1ea630bd$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $e3f57e4b1ea630bd$var$defaultMethod;
        action = null;
        encType = $e3f57e4b1ea630bd$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $e3f57e4b1ea630bd$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $e3f57e4b1ea630bd$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $e3f57e4b1ea630bd$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $e3f57e4b1ea630bd$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $e3f57e4b1ea630bd$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $e3f57e4b1ea630bd$export$1f3f55432a00e06d(routes, opts) {
    return (0, $80658610e38a69c8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $e3f57e4b1ea630bd$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $80658610e38a69c8$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $e3f57e4b1ea630bd$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $372fcccf2bee01ac$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $e3f57e4b1ea630bd$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $80658610e38a69c8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $e3f57e4b1ea630bd$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $80658610e38a69c8$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $e3f57e4b1ea630bd$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $372fcccf2bee01ac$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $e3f57e4b1ea630bd$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $e3f57e4b1ea630bd$var$_extends({}, state, {
        errors: $e3f57e4b1ea630bd$var$deserializeErrors(state.errors)
    });
    return state;
}
function $e3f57e4b1ea630bd$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $80658610e38a69c8$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $e3f57e4b1ea630bd$export$7ad602f0e94e62d1 = /*#__PURE__*/ $gRqVZ.createContext({
    isTransitioning: false
});
const $e3f57e4b1ea630bd$export$148fd98d095596d4 = /*#__PURE__*/ $gRqVZ.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $e3f57e4b1ea630bd$var$START_TRANSITION = "startTransition";
const $e3f57e4b1ea630bd$var$startTransitionImpl = $gRqVZ[$e3f57e4b1ea630bd$var$START_TRANSITION];
const $e3f57e4b1ea630bd$var$FLUSH_SYNC = "flushSync";
const $e3f57e4b1ea630bd$var$flushSyncImpl = $hYKvr[$e3f57e4b1ea630bd$var$FLUSH_SYNC];
const $e3f57e4b1ea630bd$var$USE_ID = "useId";
const $e3f57e4b1ea630bd$var$useIdImpl = $gRqVZ[$e3f57e4b1ea630bd$var$USE_ID];
function $e3f57e4b1ea630bd$var$startTransitionSafe(cb) {
    if ($e3f57e4b1ea630bd$var$startTransitionImpl) $e3f57e4b1ea630bd$var$startTransitionImpl(cb);
    else cb();
}
function $e3f57e4b1ea630bd$var$flushSyncSafe(cb) {
    if ($e3f57e4b1ea630bd$var$flushSyncImpl) $e3f57e4b1ea630bd$var$flushSyncImpl(cb);
    else cb();
}
class $e3f57e4b1ea630bd$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $e3f57e4b1ea630bd$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $gRqVZ.useState(router.state);
    let [pendingState, setPendingState] = $gRqVZ.useState();
    let [vtContext, setVtContext] = $gRqVZ.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $gRqVZ.useState();
    let [transition, setTransition] = $gRqVZ.useState();
    let [interruption, setInterruption] = $gRqVZ.useState();
    let fetcherData = $gRqVZ.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $gRqVZ.useCallback((cb)=>{
        if (v7_startTransition) $e3f57e4b1ea630bd$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $gRqVZ.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $e3f57e4b1ea630bd$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $e3f57e4b1ea630bd$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $e3f57e4b1ea630bd$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $e3f57e4b1ea630bd$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $e3f57e4b1ea630bd$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $gRqVZ.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $gRqVZ.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $e3f57e4b1ea630bd$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $gRqVZ.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $gRqVZ.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $gRqVZ.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $gRqVZ.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $gRqVZ.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $gRqVZ.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $gRqVZ.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $gRqVZ.useEffect(()=>(0, $372fcccf2bee01ac$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $gRqVZ.createElement($gRqVZ.Fragment, null, /*#__PURE__*/ $gRqVZ.createElement((0, $372fcccf2bee01ac$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $gRqVZ.createElement((0, $372fcccf2bee01ac$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $gRqVZ.createElement($e3f57e4b1ea630bd$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $gRqVZ.createElement($e3f57e4b1ea630bd$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $gRqVZ.createElement((0, $372fcccf2bee01ac$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $gRqVZ.createElement($e3f57e4b1ea630bd$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $e3f57e4b1ea630bd$var$MemoizedDataRoutes = /*#__PURE__*/ $gRqVZ.memo($e3f57e4b1ea630bd$var$DataRoutes);
function $e3f57e4b1ea630bd$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $372fcccf2bee01ac$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $e3f57e4b1ea630bd$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $gRqVZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $80658610e38a69c8$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $gRqVZ.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $gRqVZ.useCallback((newState)=>{
        v7_startTransition && $e3f57e4b1ea630bd$var$startTransitionImpl ? $e3f57e4b1ea630bd$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $gRqVZ.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $gRqVZ.useEffect(()=>(0, $372fcccf2bee01ac$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $gRqVZ.createElement((0, $372fcccf2bee01ac$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $e3f57e4b1ea630bd$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $gRqVZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $80658610e38a69c8$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $gRqVZ.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $gRqVZ.useCallback((newState)=>{
        v7_startTransition && $e3f57e4b1ea630bd$var$startTransitionImpl ? $e3f57e4b1ea630bd$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $gRqVZ.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $gRqVZ.useEffect(()=>(0, $372fcccf2bee01ac$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $gRqVZ.createElement((0, $372fcccf2bee01ac$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $e3f57e4b1ea630bd$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $gRqVZ.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $gRqVZ.useCallback((newState)=>{
        v7_startTransition && $e3f57e4b1ea630bd$var$startTransitionImpl ? $e3f57e4b1ea630bd$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $gRqVZ.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $gRqVZ.useEffect(()=>(0, $372fcccf2bee01ac$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $gRqVZ.createElement((0, $372fcccf2bee01ac$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $e3f57e4b1ea630bd$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $e3f57e4b1ea630bd$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $e3f57e4b1ea630bd$export$a6c7ac8248d6e38a = /*#__PURE__*/ $gRqVZ.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $e3f57e4b1ea630bd$var$_objectWithoutPropertiesLoose(_ref7, $e3f57e4b1ea630bd$var$_excluded);
    let { basename: basename } = $gRqVZ.useContext((0, $372fcccf2bee01ac$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $e3f57e4b1ea630bd$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($e3f57e4b1ea630bd$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $80658610e38a69c8$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $372fcccf2bee01ac$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $e3f57e4b1ea630bd$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $gRqVZ.createElement("a", $e3f57e4b1ea630bd$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $e3f57e4b1ea630bd$export$b0d92dbee9b5b60d = /*#__PURE__*/ $gRqVZ.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $e3f57e4b1ea630bd$var$_objectWithoutPropertiesLoose(_ref8, $e3f57e4b1ea630bd$var$_excluded2);
    let path = (0, $372fcccf2bee01ac$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $372fcccf2bee01ac$export$45d76561a5302f2b)();
    let routerState = $gRqVZ.useContext((0, $372fcccf2bee01ac$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $gRqVZ.useContext((0, $372fcccf2bee01ac$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $e3f57e4b1ea630bd$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $80658610e38a69c8$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $gRqVZ.createElement($e3f57e4b1ea630bd$export$a6c7ac8248d6e38a, $e3f57e4b1ea630bd$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $e3f57e4b1ea630bd$export$a7fed597f4b8afd8 = /*#__PURE__*/ $gRqVZ.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $e3f57e4b1ea630bd$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $e3f57e4b1ea630bd$var$_objectWithoutPropertiesLoose(_ref9, $e3f57e4b1ea630bd$var$_excluded3);
    let submit = $e3f57e4b1ea630bd$export$47c85c6e3a081d3();
    let formAction = $e3f57e4b1ea630bd$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $gRqVZ.createElement("form", $e3f57e4b1ea630bd$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $e3f57e4b1ea630bd$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $e3f57e4b1ea630bd$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $e3f57e4b1ea630bd$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($e3f57e4b1ea630bd$var$DataRouterHook || ($e3f57e4b1ea630bd$var$DataRouterHook = {}));
var $e3f57e4b1ea630bd$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($e3f57e4b1ea630bd$var$DataRouterStateHook || ($e3f57e4b1ea630bd$var$DataRouterStateHook = {}));
// Internal hooks
function $e3f57e4b1ea630bd$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $e3f57e4b1ea630bd$var$useDataRouterContext(hookName) {
    let ctx = $gRqVZ.useContext((0, $372fcccf2bee01ac$export$3add0d5dce533e2e));
    !ctx && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
    return ctx;
}
function $e3f57e4b1ea630bd$var$useDataRouterState(hookName) {
    let state = $gRqVZ.useContext((0, $372fcccf2bee01ac$export$145dfa71566a64dc));
    !state && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $e3f57e4b1ea630bd$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    let location = (0, $372fcccf2bee01ac$export$45d76561a5302f2b)();
    let path = (0, $372fcccf2bee01ac$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $gRqVZ.useCallback((event)=>{
        if ($e3f57e4b1ea630bd$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $80658610e38a69c8$export$fe53371bee54353d)(location) === (0, $80658610e38a69c8$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $e3f57e4b1ea630bd$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $gRqVZ.useRef($e3f57e4b1ea630bd$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $gRqVZ.useRef(false);
    let location = (0, $372fcccf2bee01ac$export$45d76561a5302f2b)();
    let searchParams = $gRqVZ.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $e3f57e4b1ea630bd$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    let setSearchParams = $gRqVZ.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $e3f57e4b1ea630bd$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $e3f57e4b1ea630bd$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $e3f57e4b1ea630bd$var$fetcherId = 0;
let $e3f57e4b1ea630bd$var$getUniqueFetcherId = ()=>"__" + String(++$e3f57e4b1ea630bd$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $e3f57e4b1ea630bd$export$47c85c6e3a081d3() {
    let { router: router } = $e3f57e4b1ea630bd$var$useDataRouterContext($e3f57e4b1ea630bd$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $gRqVZ.useContext((0, $372fcccf2bee01ac$export$26749e8557646306));
    let currentRouteId = (0, $372fcccf2bee01ac$export$5fc8298006ad9e58)();
    return $gRqVZ.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $e3f57e4b1ea630bd$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $e3f57e4b1ea630bd$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $e3f57e4b1ea630bd$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $e3f57e4b1ea630bd$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $gRqVZ.useContext((0, $372fcccf2bee01ac$export$26749e8557646306));
    let routeContext = $gRqVZ.useContext((0, $372fcccf2bee01ac$export$9072aa6dd1f93057));
    !routeContext && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $e3f57e4b1ea630bd$var$_extends({}, (0, $372fcccf2bee01ac$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $372fcccf2bee01ac$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $80658610e38a69c8$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $80658610e38a69c8$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $e3f57e4b1ea630bd$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $e3f57e4b1ea630bd$var$useDataRouterContext($e3f57e4b1ea630bd$var$DataRouterHook.UseFetcher);
    let state = $e3f57e4b1ea630bd$var$useDataRouterState($e3f57e4b1ea630bd$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $gRqVZ.useContext($e3f57e4b1ea630bd$export$148fd98d095596d4);
    let route = $gRqVZ.useContext((0, $372fcccf2bee01ac$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
    !route && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $e3f57e4b1ea630bd$var$useIdImpl ? $e3f57e4b1ea630bd$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $gRqVZ.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($e3f57e4b1ea630bd$var$getUniqueFetcherId());
    // Registration/cleanup
    $gRqVZ.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $gRqVZ.useCallback((href, opts)=>{
        !routeId && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $e3f57e4b1ea630bd$export$47c85c6e3a081d3();
    let submit = $gRqVZ.useCallback((target, opts)=>{
        submitImpl(target, $e3f57e4b1ea630bd$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $gRqVZ.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $gRqVZ.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $gRqVZ.createElement($e3f57e4b1ea630bd$export$a7fed597f4b8afd8, $e3f57e4b1ea630bd$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $80658610e38a69c8$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $gRqVZ.useMemo(()=>$e3f57e4b1ea630bd$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $e3f57e4b1ea630bd$export$fa996778a3a31087() {
    let state = $e3f57e4b1ea630bd$var$useDataRouterState($e3f57e4b1ea630bd$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $e3f57e4b1ea630bd$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $e3f57e4b1ea630bd$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $e3f57e4b1ea630bd$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $e3f57e4b1ea630bd$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $e3f57e4b1ea630bd$var$useDataRouterContext($e3f57e4b1ea630bd$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $e3f57e4b1ea630bd$var$useDataRouterState($e3f57e4b1ea630bd$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $gRqVZ.useContext((0, $372fcccf2bee01ac$export$26749e8557646306));
    let location = (0, $372fcccf2bee01ac$export$45d76561a5302f2b)();
    let matches = (0, $372fcccf2bee01ac$export$2378eb7f5ff86053)();
    let navigation = (0, $372fcccf2bee01ac$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $gRqVZ.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $e3f57e4b1ea630bd$var$usePageHide($gRqVZ.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $e3f57e4b1ea630bd$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $e3f57e4b1ea630bd$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($e3f57e4b1ea630bd$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $gRqVZ.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $e3f57e4b1ea630bd$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $e3f57e4b1ea630bd$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $gRqVZ.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($e3f57e4b1ea630bd$var$_extends({}, location, {
                    pathname: (0, $80658610e38a69c8$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($e3f57e4b1ea630bd$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $gRqVZ.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $e3f57e4b1ea630bd$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $gRqVZ.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $e3f57e4b1ea630bd$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $gRqVZ.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $e3f57e4b1ea630bd$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $372fcccf2bee01ac$export$b273b3273281a049)(when);
    $gRqVZ.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $gRqVZ.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $e3f57e4b1ea630bd$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $gRqVZ.useContext($e3f57e4b1ea630bd$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $80658610e38a69c8$export$3e9cee6b33872309)(false);
    let { basename: basename } = $e3f57e4b1ea630bd$var$useDataRouterContext($e3f57e4b1ea630bd$var$DataRouterHook.useViewTransitionState);
    let path = (0, $372fcccf2bee01ac$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $80658610e38a69c8$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $80658610e38a69c8$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $80658610e38a69c8$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $80658610e38a69c8$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $G7LU6 = parcelRequire("G7LU6");

var $gRqVZ = parcelRequire("gRqVZ");
var $184a604d3342f9e1$exports = {};
//
$184a604d3342f9e1$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $cc5ee8e733377844$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $cc5ee8e733377844$export$2e2bcd8739ae039 = $cc5ee8e733377844$var$stylis_min;


var $027bacc291a49817$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $027bacc291a49817$export$2e2bcd8739ae039 = $027bacc291a49817$var$unitlessKeys;



var $2Fkpb = parcelRequire("2Fkpb");

var $6q1gP = parcelRequire("6q1gP");
function $8999e1d77b7e12d9$var$y() {
    return ($8999e1d77b7e12d9$var$y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $8999e1d77b7e12d9$var$v = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $8999e1d77b7e12d9$var$g = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $G7LU6.typeOf)(t);
}, $8999e1d77b7e12d9$var$S = Object.freeze([]), $8999e1d77b7e12d9$var$w = Object.freeze({});
function $8999e1d77b7e12d9$var$E(e) {
    return "function" == typeof e;
}
function $8999e1d77b7e12d9$var$b(e) {
    return e.displayName || e.name || "Component";
}
function $8999e1d77b7e12d9$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $8999e1d77b7e12d9$var$N = "data-styled", $8999e1d77b7e12d9$export$83d89fbfd8236492 = "5.3.11", $8999e1d77b7e12d9$var$C = "undefined" != typeof window && "HTMLElement" in window, $8999e1d77b7e12d9$var$I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), $8999e1d77b7e12d9$var$P = {}, $8999e1d77b7e12d9$var$O = {};
function $8999e1d77b7e12d9$var$R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $8999e1d77b7e12d9$var$D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $8999e1d77b7e12d9$var$j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $8999e1d77b7e12d9$var$D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $8999e1d77b7e12d9$var$T = new Map, $8999e1d77b7e12d9$var$x = new Map, $8999e1d77b7e12d9$var$k = 1, $8999e1d77b7e12d9$var$V = function(e) {
    if ($8999e1d77b7e12d9$var$T.has(e)) return $8999e1d77b7e12d9$var$T.get(e);
    for(; $8999e1d77b7e12d9$var$x.has($8999e1d77b7e12d9$var$k);)$8999e1d77b7e12d9$var$k++;
    var t = $8999e1d77b7e12d9$var$k++;
    return $8999e1d77b7e12d9$var$T.set(e, t), $8999e1d77b7e12d9$var$x.set(t, e), t;
}, $8999e1d77b7e12d9$var$B = function(e) {
    return $8999e1d77b7e12d9$var$x.get(e);
}, $8999e1d77b7e12d9$var$z = function(e, t) {
    t >= $8999e1d77b7e12d9$var$k && ($8999e1d77b7e12d9$var$k = t + 1), $8999e1d77b7e12d9$var$T.set(e, t), $8999e1d77b7e12d9$var$x.set(t, e);
}, $8999e1d77b7e12d9$var$M = "style[" + $8999e1d77b7e12d9$var$N + '][data-styled-version="5.3.11"]', $8999e1d77b7e12d9$var$G = new RegExp("^" + $8999e1d77b7e12d9$var$N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $8999e1d77b7e12d9$var$L = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $8999e1d77b7e12d9$var$F = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($8999e1d77b7e12d9$var$G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($8999e1d77b7e12d9$var$z(u, c), $8999e1d77b7e12d9$var$L(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $8999e1d77b7e12d9$var$Y = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $8999e1d77b7e12d9$var$q = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($8999e1d77b7e12d9$var$N)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($8999e1d77b7e12d9$var$N, "active"), r.setAttribute("data-styled-version", "5.3.11");
    var i = $8999e1d77b7e12d9$var$Y();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $8999e1d77b7e12d9$var$H = function() {
    function e(e) {
        var t = this.element = $8999e1d77b7e12d9$var$q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $8999e1d77b7e12d9$var$D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $8999e1d77b7e12d9$var$$ = function() {
    function e(e) {
        var t = this.element = $8999e1d77b7e12d9$var$q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $8999e1d77b7e12d9$var$W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $8999e1d77b7e12d9$var$U = $8999e1d77b7e12d9$var$C, $8999e1d77b7e12d9$var$J = {
    isServer: !$8999e1d77b7e12d9$var$C,
    useCSSOMInjection: !$8999e1d77b7e12d9$var$I
}, $8999e1d77b7e12d9$var$X = function() {
    function e(e, t, n) {
        void 0 === e && (e = $8999e1d77b7e12d9$var$w), void 0 === t && (t = {}), this.options = $8999e1d77b7e12d9$var$y({}, $8999e1d77b7e12d9$var$J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $8999e1d77b7e12d9$var$C && $8999e1d77b7e12d9$var$U && ($8999e1d77b7e12d9$var$U = !1, function(e) {
            for(var t = document.querySelectorAll($8999e1d77b7e12d9$var$M), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($8999e1d77b7e12d9$var$N) && ($8999e1d77b7e12d9$var$F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $8999e1d77b7e12d9$var$V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($8999e1d77b7e12d9$var$y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $8999e1d77b7e12d9$var$W(o) : r ? new $8999e1d77b7e12d9$var$H(o) : new $8999e1d77b7e12d9$var$$(o), new $8999e1d77b7e12d9$var$j(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($8999e1d77b7e12d9$var$V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($8999e1d77b7e12d9$var$V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($8999e1d77b7e12d9$var$V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $8999e1d77b7e12d9$var$B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $8999e1d77b7e12d9$var$N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $8999e1d77b7e12d9$var$Z = /(a)(d)/gi, $8999e1d77b7e12d9$var$K = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $8999e1d77b7e12d9$var$Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $8999e1d77b7e12d9$var$K(t % 52) + n;
    return ($8999e1d77b7e12d9$var$K(t % 52) + n).replace($8999e1d77b7e12d9$var$Z, "$1-$2");
}
var $8999e1d77b7e12d9$var$ee = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $8999e1d77b7e12d9$var$te = function(e) {
    return $8999e1d77b7e12d9$var$ee(5381, e);
};
function $8999e1d77b7e12d9$var$ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($8999e1d77b7e12d9$var$E(n) && !$8999e1d77b7e12d9$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $8999e1d77b7e12d9$var$re = $8999e1d77b7e12d9$var$te("5.3.11"), $8999e1d77b7e12d9$var$oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $8999e1d77b7e12d9$var$ne(e), this.componentId = t, this.baseHash = $8999e1d77b7e12d9$var$ee($8999e1d77b7e12d9$var$re, t), this.baseStyle = n, $8999e1d77b7e12d9$var$X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $8999e1d77b7e12d9$var$_e(this.rules, e, t, n).join(""), i = $8999e1d77b7e12d9$var$Q($8999e1d77b7e12d9$var$ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $8999e1d77b7e12d9$var$ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $8999e1d77b7e12d9$var$_e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $8999e1d77b7e12d9$var$ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $8999e1d77b7e12d9$var$Q(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $8999e1d77b7e12d9$var$se = /^\s*\/\/.*$/gm, $8999e1d77b7e12d9$var$ie = [
    ":",
    "[",
    ".",
    "#"
];
function $8999e1d77b7e12d9$var$ae(e) {
    var t, n, r, o, s = void 0 === e ? $8999e1d77b7e12d9$var$w : e, i = s.options, a = void 0 === i ? $8999e1d77b7e12d9$var$w : i, c = s.plugins, u = void 0 === c ? $8999e1d77b7e12d9$var$S : c, l = new (0, $cc5ee8e733377844$export$2e2bcd8739ae039)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $8999e1d77b7e12d9$var$ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($8999e1d77b7e12d9$var$se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $8999e1d77b7e12d9$var$D(15), $8999e1d77b7e12d9$var$ee(e, t.name);
    }, 5381).toString() : "", m;
}
var $8999e1d77b7e12d9$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createContext(), $8999e1d77b7e12d9$export$91317688fc694efa = $8999e1d77b7e12d9$export$8c190ef828af4c86.Consumer, $8999e1d77b7e12d9$var$le = (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createContext(), $8999e1d77b7e12d9$var$de = ($8999e1d77b7e12d9$var$le.Consumer, new $8999e1d77b7e12d9$var$X), $8999e1d77b7e12d9$var$he = $8999e1d77b7e12d9$var$ae();
function $8999e1d77b7e12d9$var$pe() {
    return (0, $gRqVZ.useContext)($8999e1d77b7e12d9$export$8c190ef828af4c86) || $8999e1d77b7e12d9$var$de;
}
function $8999e1d77b7e12d9$var$fe() {
    return (0, $gRqVZ.useContext)($8999e1d77b7e12d9$var$le) || $8999e1d77b7e12d9$var$he;
}
function $8999e1d77b7e12d9$export$a473771da2f0ff7c(e) {
    var t = (0, $gRqVZ.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $8999e1d77b7e12d9$var$pe(), u = (0, $gRqVZ.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $gRqVZ.useMemo)(function() {
        return $8999e1d77b7e12d9$var$ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $gRqVZ.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($184a604d3342f9e1$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($8999e1d77b7e12d9$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($8999e1d77b7e12d9$var$le.Provider, {
        value: l
    }, (0, e.children)));
}
var $8999e1d77b7e12d9$var$ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $8999e1d77b7e12d9$var$he);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $8999e1d77b7e12d9$var$D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $8999e1d77b7e12d9$var$he), this.name + e.hash;
    }, e;
}(), $8999e1d77b7e12d9$var$ve = /([A-Z])/, $8999e1d77b7e12d9$var$ge = /([A-Z])/g, $8999e1d77b7e12d9$var$Se = /^ms-/, $8999e1d77b7e12d9$var$we = function(e) {
    return "-" + e.toLowerCase();
};
function $8999e1d77b7e12d9$var$Ee(e) {
    return $8999e1d77b7e12d9$var$ve.test(e) ? e.replace($8999e1d77b7e12d9$var$ge, $8999e1d77b7e12d9$var$we).replace($8999e1d77b7e12d9$var$Se, "-ms-") : e;
}
var $8999e1d77b7e12d9$var$be = function(e) {
    return null == e || !1 === e || "" === e;
};
function $8999e1d77b7e12d9$var$_e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $8999e1d77b7e12d9$var$_e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($8999e1d77b7e12d9$var$be(e)) return "";
    if ($8999e1d77b7e12d9$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($8999e1d77b7e12d9$var$E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $8999e1d77b7e12d9$var$_e(u, n, r, o);
    }
    var l;
    return e instanceof $8999e1d77b7e12d9$var$ye ? r ? (e.inject(r, o), e.getName(o)) : e : $8999e1d77b7e12d9$var$g(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$8999e1d77b7e12d9$var$be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $8999e1d77b7e12d9$var$E(t[i]) ? s.push($8999e1d77b7e12d9$var$Ee(i) + ":", t[i], ";") : $8999e1d77b7e12d9$var$g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($8999e1d77b7e12d9$var$Ee(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $027bacc291a49817$export$2e2bcd8739ae039) || r.startsWith("--") ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $8999e1d77b7e12d9$var$Ne = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $8999e1d77b7e12d9$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $8999e1d77b7e12d9$var$E(e) || $8999e1d77b7e12d9$var$g(e) ? $8999e1d77b7e12d9$var$Ne($8999e1d77b7e12d9$var$_e($8999e1d77b7e12d9$var$v($8999e1d77b7e12d9$var$S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $8999e1d77b7e12d9$var$Ne($8999e1d77b7e12d9$var$_e($8999e1d77b7e12d9$var$v(e, n)));
}
var $8999e1d77b7e12d9$var$Ce = /invalid hook call/i, $8999e1d77b7e12d9$var$Ie = new Set, $8999e1d77b7e12d9$var$Pe = function(e, t) {
    var n, r, o, e1;
}, $8999e1d77b7e12d9$var$Oe = function(e, t, n) {
    return void 0 === n && (n = $8999e1d77b7e12d9$var$w), e.theme !== n.theme && e.theme || t || n.theme;
}, $8999e1d77b7e12d9$var$Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $8999e1d77b7e12d9$var$De = /(^-|-$)/g;
function $8999e1d77b7e12d9$var$je(e) {
    return e.replace($8999e1d77b7e12d9$var$Re, "-").replace($8999e1d77b7e12d9$var$De, "");
}
var $8999e1d77b7e12d9$var$Te = function(e) {
    return $8999e1d77b7e12d9$var$Q($8999e1d77b7e12d9$var$te(e) >>> 0);
};
function $8999e1d77b7e12d9$var$xe(e) {
    return "string" == typeof e && true;
}
var $8999e1d77b7e12d9$var$ke = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $8999e1d77b7e12d9$var$Ve = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $8999e1d77b7e12d9$var$Be(e, t, n) {
    var r = e[n];
    $8999e1d77b7e12d9$var$ke(t) && $8999e1d77b7e12d9$var$ke(r) ? $8999e1d77b7e12d9$var$ze(r, t) : e[n] = t;
}
function $8999e1d77b7e12d9$var$ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($8999e1d77b7e12d9$var$ke(i)) for(var a in i)$8999e1d77b7e12d9$var$Ve(a) && $8999e1d77b7e12d9$var$Be(e, i[a], a);
    }
    return e;
}
var $8999e1d77b7e12d9$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createContext(), $8999e1d77b7e12d9$export$b631efc24e9d5e2f = $8999e1d77b7e12d9$export$2c657da244d00bd6.Consumer;
function $8999e1d77b7e12d9$export$d8964aec282183a3(e) {
    var t = (0, $gRqVZ.useContext)($8999e1d77b7e12d9$export$2c657da244d00bd6), n = (0, $gRqVZ.useMemo)(function() {
        return function(e, t) {
            if (!e) return $8999e1d77b7e12d9$var$D(14);
            if ($8999e1d77b7e12d9$var$E(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $8999e1d77b7e12d9$var$D(8) : t ? $8999e1d77b7e12d9$var$y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($8999e1d77b7e12d9$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $8999e1d77b7e12d9$var$Fe = {};
function $8999e1d77b7e12d9$var$Ye(e, t, n) {
    var o = $8999e1d77b7e12d9$export$7ba318d8d2f06c76(e), i = !$8999e1d77b7e12d9$var$xe(e), a = t.attrs, c = void 0 === a ? $8999e1d77b7e12d9$var$S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $8999e1d77b7e12d9$var$je(e);
        $8999e1d77b7e12d9$var$Fe[n] = ($8999e1d77b7e12d9$var$Fe[n] || 0) + 1;
        var r = n + "-" + $8999e1d77b7e12d9$var$Te("5.3.11" + n + $8999e1d77b7e12d9$var$Fe[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return $8999e1d77b7e12d9$var$xe(e) ? "styled." + e : "Styled(" + $8999e1d77b7e12d9$var$b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? $8999e1d77b7e12d9$var$je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new $8999e1d77b7e12d9$var$oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = $8999e1d77b7e12d9$var$w);
                var r = $8999e1d77b7e12d9$var$y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $8999e1d77b7e12d9$var$E(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($8999e1d77b7e12d9$var$Oe(t, (0, $gRqVZ.useContext)($8999e1d77b7e12d9$export$2c657da244d00bd6), a) || $8999e1d77b7e12d9$var$w, t, o), m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = $8999e1d77b7e12d9$var$pe(), s = $8999e1d77b7e12d9$var$fe(), i = t ? e.generateAndInjectStyles($8999e1d77b7e12d9$var$w, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, m, void 0), S = n, b = v.$as || t.$as || v.as || t.as || h, _ = $8999e1d77b7e12d9$var$xe(b), N = v !== t ? $8999e1d77b7e12d9$var$y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, $2Fkpb.default), b) : !_ || (0, $2Fkpb.default)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = $8999e1d77b7e12d9$var$y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, $gRqVZ.createElement)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $8999e1d77b7e12d9$var$S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($8999e1d77b7e12d9$var$xe(e) ? e : $8999e1d77b7e12d9$var$je($8999e1d77b7e12d9$var$b(e)));
        return $8999e1d77b7e12d9$var$Ye(e, $8999e1d77b7e12d9$var$y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $8999e1d77b7e12d9$var$ze({}, e.defaultProps, t) : t;
        }
    }), Object.defineProperty(A, "toString", {
        value: function() {
            return "." + A.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($6q1gP)))(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var $8999e1d77b7e12d9$var$qe = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $8999e1d77b7e12d9$var$w), !(0, $G7LU6.isValidElementType)(r)) return $8999e1d77b7e12d9$var$D(1, String(r));
        var s = function() {
            return t(r, o, $8999e1d77b7e12d9$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $8999e1d77b7e12d9$var$y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $8999e1d77b7e12d9$var$y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($8999e1d77b7e12d9$var$Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $8999e1d77b7e12d9$var$qe[e] = $8999e1d77b7e12d9$var$qe(e);
});
var $8999e1d77b7e12d9$var$He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $8999e1d77b7e12d9$var$ne(e), $8999e1d77b7e12d9$var$X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($8999e1d77b7e12d9$var$_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $8999e1d77b7e12d9$var$X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $8999e1d77b7e12d9$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $8999e1d77b7e12d9$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $8999e1d77b7e12d9$var$Te(JSON.stringify(i)), u = new $8999e1d77b7e12d9$var$He(i, a);
    function d(e) {
        var t = $8999e1d77b7e12d9$var$pe(), n = $8999e1d77b7e12d9$var$fe(), o = (0, $gRqVZ.useContext)($8999e1d77b7e12d9$export$2c657da244d00bd6), d = (0, $gRqVZ.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(d, e, t, o, n), (0, $gRqVZ.useLayoutEffect)(function() {
            if (!t.server) return h(d, e, t, o, n), function() {
                return u.removeStyles(d, t);
            };
        }, [
            d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $8999e1d77b7e12d9$var$P, n, o);
        else {
            var s = $8999e1d77b7e12d9$var$y({}, t, {
                theme: $8999e1d77b7e12d9$var$Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).memo(d);
}
function $8999e1d77b7e12d9$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $8999e1d77b7e12d9$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $8999e1d77b7e12d9$var$Te(o);
    return new $8999e1d77b7e12d9$var$ye(s, o);
}
var $8999e1d77b7e12d9$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $8999e1d77b7e12d9$var$Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $8999e1d77b7e12d9$var$N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $8999e1d77b7e12d9$var$D(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $8999e1d77b7e12d9$var$D(2);
            var n = ((t = {})[$8999e1d77b7e12d9$var$N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $8999e1d77b7e12d9$var$Y();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("style", $8999e1d77b7e12d9$var$y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $8999e1d77b7e12d9$var$X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $8999e1d77b7e12d9$var$D(2) : (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($8999e1d77b7e12d9$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $8999e1d77b7e12d9$var$D(3);
    }, e;
}(), $8999e1d77b7e12d9$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).forwardRef(function(t, n) {
        var o = (0, $gRqVZ.useContext)($8999e1d77b7e12d9$export$2c657da244d00bd6), i = e.defaultProps, a = $8999e1d77b7e12d9$var$Oe(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(e, $8999e1d77b7e12d9$var$y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6q1gP)))(t, e), t.displayName = "WithTheme(" + $8999e1d77b7e12d9$var$b(e) + ")", t;
}, $8999e1d77b7e12d9$export$93d4e7f90805808f = function() {
    return (0, $gRqVZ.useContext)($8999e1d77b7e12d9$export$2c657da244d00bd6);
}, $8999e1d77b7e12d9$export$5c87cfe6c475f500 = {
    StyleSheet: $8999e1d77b7e12d9$var$X,
    masterSheet: $8999e1d77b7e12d9$var$de
};
var $8999e1d77b7e12d9$export$2e2bcd8739ae039 = $8999e1d77b7e12d9$var$qe;




var $if2ZQ = parcelRequire("if2ZQ");
function $4c76512358ba4f48$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $0e5a4a59758d80fa$export$2e2bcd8739ae039(t, e) {
    return $0e5a4a59758d80fa$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0e5a4a59758d80fa$export$2e2bcd8739ae039(t, e);
}


function $56ac1d9e876095b6$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0e5a4a59758d80fa$export$2e2bcd8739ae039)(t, o);
}


function $f4e1869d2d3aba79$export$2e2bcd8739ae039(t) {
    return $f4e1869d2d3aba79$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $f4e1869d2d3aba79$export$2e2bcd8739ae039(t);
}



function $86ae209ce4c3e606$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}


function $2c62263bd98f6b07$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2c62263bd98f6b07$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $8b0956d5c112b38b$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $2c62263bd98f6b07$export$2e2bcd8739ae039)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $0e5a4a59758d80fa$export$2e2bcd8739ae039)(p, r.prototype), p;
}


function $869887ad8c4fa9ef$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $869887ad8c4fa9ef$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $86ae209ce4c3e606$export$2e2bcd8739ae039)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $8b0956d5c112b38b$export$2e2bcd8739ae039)(t, arguments, (0, $f4e1869d2d3aba79$export$2e2bcd8739ae039)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $0e5a4a59758d80fa$export$2e2bcd8739ae039)(Wrapper, t);
    }, $869887ad8c4fa9ef$export$2e2bcd8739ae039(t);
}


function $1a6b17165b999be2$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), e.raw = t, e;
}


function $e728873b0e612b3a$var$last() {
    var _ref;
    return _ref = arguments.length - 1, _ref < 0 || arguments.length <= _ref ? undefined : arguments[_ref];
}
function $e728873b0e612b3a$var$negation(a) {
    return -a;
}
function $e728873b0e612b3a$var$addition(a, b) {
    return a + b;
}
function $e728873b0e612b3a$var$subtraction(a, b) {
    return a - b;
}
function $e728873b0e612b3a$var$multiplication(a, b) {
    return a * b;
}
function $e728873b0e612b3a$var$division(a, b) {
    return a / b;
}
function $e728873b0e612b3a$var$max() {
    return Math.max.apply(Math, arguments);
}
function $e728873b0e612b3a$var$min() {
    return Math.min.apply(Math, arguments);
}
function $e728873b0e612b3a$var$comma() {
    return Array.of.apply(Array, arguments);
}
var $e728873b0e612b3a$var$defaultSymbols = {
    symbols: {
        '*': {
            infix: {
                symbol: '*',
                f: $e728873b0e612b3a$var$multiplication,
                notation: 'infix',
                precedence: 4,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: '*',
            regSymbol: '\\*'
        },
        '/': {
            infix: {
                symbol: '/',
                f: $e728873b0e612b3a$var$division,
                notation: 'infix',
                precedence: 4,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: '/',
            regSymbol: '/'
        },
        '+': {
            infix: {
                symbol: '+',
                f: $e728873b0e612b3a$var$addition,
                notation: 'infix',
                precedence: 2,
                rightToLeft: 0,
                argCount: 2
            },
            prefix: {
                symbol: '+',
                f: $e728873b0e612b3a$var$last,
                notation: 'prefix',
                precedence: 3,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '+',
            regSymbol: '\\+'
        },
        '-': {
            infix: {
                symbol: '-',
                f: $e728873b0e612b3a$var$subtraction,
                notation: 'infix',
                precedence: 2,
                rightToLeft: 0,
                argCount: 2
            },
            prefix: {
                symbol: '-',
                f: $e728873b0e612b3a$var$negation,
                notation: 'prefix',
                precedence: 3,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '-',
            regSymbol: '-'
        },
        ',': {
            infix: {
                symbol: ',',
                f: $e728873b0e612b3a$var$comma,
                notation: 'infix',
                precedence: 1,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: ',',
            regSymbol: ','
        },
        '(': {
            prefix: {
                symbol: '(',
                f: $e728873b0e612b3a$var$last,
                notation: 'prefix',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '(',
            regSymbol: '\\('
        },
        ')': {
            postfix: {
                symbol: ')',
                f: undefined,
                notation: 'postfix',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: ')',
            regSymbol: '\\)'
        },
        min: {
            func: {
                symbol: 'min',
                f: $e728873b0e612b3a$var$min,
                notation: 'func',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: 'min',
            regSymbol: 'min\\b'
        },
        max: {
            func: {
                symbol: 'max',
                f: $e728873b0e612b3a$var$max,
                notation: 'func',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: 'max',
            regSymbol: 'max\\b'
        }
    }
};
var $e728873b0e612b3a$var$defaultSymbolMap = $e728873b0e612b3a$var$defaultSymbols;
// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js
/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */ var $e728873b0e612b3a$var$ERRORS = {
    "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
    "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
    "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
    "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
    "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
    "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
    "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
    "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
    "9": "Please provide a number of steps to the modularScale helper.\n\n",
    "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
    "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
    "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
    "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
    "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
    "16": "You must provide a template to this method.\n\n",
    "17": "You passed an unsupported selector state to this method.\n\n",
    "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "23": "fontFace expects a name of a font-family.\n\n",
    "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "25": "fontFace expects localFonts to be an array.\n\n",
    "26": "fontFace expects fileFormats to be an array.\n\n",
    "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
    "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
    "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
    "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
    "36": "Property must be a string value.\n\n",
    "37": "Syntax Error at %s.\n\n",
    "38": "Formula contains a function that needs parentheses at %s.\n\n",
    "39": "Formula is missing closing parenthesis at %s.\n\n",
    "40": "Formula has too many closing parentheses at %s.\n\n",
    "41": "All values in a formula must have the same unit or be unitless.\n\n",
    "42": "Please provide a number of steps to the modularScale helper.\n\n",
    "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
    "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
    "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
    "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
    "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
    "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "53": "fontFace expects localFonts to be an array.\n\n",
    "54": "fontFace expects fileFormats to be an array.\n\n",
    "55": "fontFace expects a name of a font-family.\n\n",
    "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
    "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "61": "Property must be a string value.\n\n",
    "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
    "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
    "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
    "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
    "67": "You must provide a template to this method.\n\n",
    "68": "You passed an unsupported selector state to this method.\n\n",
    "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
    "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
    "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
    "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
    "73": "Please provide a valid CSS variable.\n\n",
    "74": "CSS variable not found and no default was provided.\n\n",
    "75": "important requires a valid style object, got a %s instead.\n\n",
    "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
    "77": "remToPx expects a value in \"rem\" but you provided it in \"%s\".\n\n",
    "78": "base must be set in \"px\" or \"%\" but you set it in \"%s\".\n"
};
/**
 * super basic version of sprintf
 * @private
 */ function $e728873b0e612b3a$var$format() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0];
    var b = [];
    var c;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */ var $e728873b0e612b3a$var$PolishedError = /*#__PURE__*/ function(_Error) {
    (0, $56ac1d9e876095b6$export$2e2bcd8739ae039)(PolishedError, _Error);
    function PolishedError(code) {
        var _this;
        var _len2, args, _key2;
        _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
        return (0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this);
    }
    return PolishedError;
}(/*#__PURE__*/ (0, $869887ad8c4fa9ef$export$2e2bcd8739ae039)(Error));
var $e728873b0e612b3a$var$unitRegExp = /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g;
// Merges additional math functionality into the defaults.
function $e728873b0e612b3a$var$mergeSymbolMaps(additionalSymbols) {
    var symbolMap = {};
    symbolMap.symbols = additionalSymbols ? (0, $if2ZQ.default)({}, $e728873b0e612b3a$var$defaultSymbolMap.symbols, additionalSymbols.symbols) : (0, $if2ZQ.default)({}, $e728873b0e612b3a$var$defaultSymbolMap.symbols);
    return symbolMap;
}
function $e728873b0e612b3a$var$exec(operators, values) {
    var _ref;
    var op = operators.pop();
    values.push(op.f.apply(op, (_ref = []).concat.apply(_ref, values.splice(-op.argCount))));
    return op.precedence;
}
function $e728873b0e612b3a$var$calculate(expression, additionalSymbols) {
    var symbolMap = $e728873b0e612b3a$var$mergeSymbolMaps(additionalSymbols);
    var match;
    var operators = [
        symbolMap.symbols['('].prefix
    ];
    var values = [];
    var pattern = new RegExp("\\d+(?:\\.\\d+)?|" + // ...and patterns for individual operators/function names
    Object.keys(symbolMap.symbols).map(function(key) {
        return symbolMap.symbols[key];
    })// longer symbols should be listed first
    // $FlowFixMe
    .sort(function(a, b) {
        return b.symbol.length - a.symbol.length;
    })// $FlowFixMe
    .map(function(val) {
        return val.regSymbol;
    }).join('|') + "|(\\S)", 'g');
    pattern.lastIndex = 0; // Reset regular expression object
    var afterValue = false;
    do {
        match = pattern.exec(expression);
        var _ref2 = match || [
            ')',
            undefined
        ], token = _ref2[0], bad = _ref2[1];
        var notNumber = symbolMap.symbols[token];
        var notNewValue = notNumber && !notNumber.prefix && !notNumber.func;
        var notAfterValue = !notNumber || !notNumber.postfix && !notNumber.infix;
        // Check for syntax errors:
        if (bad || (afterValue ? notAfterValue : notNewValue)) throw new $e728873b0e612b3a$var$PolishedError(37, match ? match.index : expression.length, expression);
        if (afterValue) {
            // We either have an infix or postfix operator (they should be mutually exclusive)
            var curr = notNumber.postfix || notNumber.infix;
            do {
                var prev = operators[operators.length - 1];
                if ((curr.precedence - prev.precedence || prev.rightToLeft) > 0) break;
            // Apply previous operator, since it has precedence over current one
            }while ($e728873b0e612b3a$var$exec(operators, values)); // Exit loop after executing an opening parenthesis or function
            afterValue = curr.notation === 'postfix';
            if (curr.symbol !== ')') {
                operators.push(curr);
                // Postfix always has precedence over any operator that follows after it
                if (afterValue) $e728873b0e612b3a$var$exec(operators, values);
            }
        } else if (notNumber) {
            // prefix operator or function
            operators.push(notNumber.prefix || notNumber.func);
            if (notNumber.func) {
                // Require an opening parenthesis
                match = pattern.exec(expression);
                if (!match || match[0] !== '(') throw new $e728873b0e612b3a$var$PolishedError(38, match ? match.index : expression.length, expression);
            }
        } else {
            // number
            values.push(+token);
            afterValue = true;
        }
    }while (match && operators.length);
    if (operators.length) throw new $e728873b0e612b3a$var$PolishedError(39, match ? match.index : expression.length, expression);
    else if (match) throw new $e728873b0e612b3a$var$PolishedError(40, match ? match.index : expression.length, expression);
    else return values.pop();
}
function $e728873b0e612b3a$var$reverseString(str) {
    return str.split('').reverse().join('');
}
/**
 * Helper for doing math with CSS Units. Accepts a formula as a string. All values in the formula must have the same unit (or be unitless). Supports complex formulas utliziing addition, subtraction, multiplication, division, square root, powers, factorial, min, max, as well as parentheses for order of operation.
 *
 *In cases where you need to do calculations with mixed units where one unit is a [relative length unit](https://developer.mozilla.org/en-US/docs/Web/CSS/length#Relative_length_units), you will want to use [CSS Calc](https://developer.mozilla.org/en-US/docs/Web/CSS/calc).
 *
 * *warning* While we've done everything possible to ensure math safely evalutes formulas expressed as strings, you should always use extreme caution when passing `math` user provided values.
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: math('12rem + 8rem'),
 *   fontSize: math('(12px + 2px) * 3'),
 *   fontSize: math('3px^2 + sqrt(4)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${math('12rem + 8rem')};
 *   fontSize: ${math('(12px + 2px) * 3')};
 *   fontSize: ${math('3px^2 + sqrt(4)')};
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   fontSize: '20rem',
 *   fontSize: '42px',
 *   fontSize: '11px',
 * }
 */ function $e728873b0e612b3a$export$1c891a3202c0ba6a(formula, additionalSymbols) {
    var reversedFormula = $e728873b0e612b3a$var$reverseString(formula);
    var formulaMatch = reversedFormula.match($e728873b0e612b3a$var$unitRegExp);
    // Check that all units are the same
    if (formulaMatch && !formulaMatch.every(function(unit) {
        return unit === formulaMatch[0];
    })) throw new $e728873b0e612b3a$var$PolishedError(41);
    var cleanFormula = $e728873b0e612b3a$var$reverseString(reversedFormula.replace($e728873b0e612b3a$var$unitRegExp, ''));
    return "" + $e728873b0e612b3a$var$calculate(cleanFormula, additionalSymbols) + (formulaMatch ? $e728873b0e612b3a$var$reverseString(formulaMatch[0]) : '');
}
var $e728873b0e612b3a$var$cssVariableRegex = /--[\S]*/g;
/**
 * Fetches the value of a passed CSS Variable in the :root scope, or otherwise returns a defaultValue if provided.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'background': cssVar('--background-color'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${cssVar('--background-color')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'background': 'red'
 * }
 */ function $e728873b0e612b3a$export$8b4981022bd80a4e(cssVariable, defaultValue) {
    if (!cssVariable || !cssVariable.match($e728873b0e612b3a$var$cssVariableRegex)) throw new $e728873b0e612b3a$var$PolishedError(73);
    var variableValue;
    /* eslint-disable */ /* istanbul ignore next */ if (typeof document !== 'undefined' && document.documentElement !== null) variableValue = getComputedStyle(document.documentElement).getPropertyValue(cssVariable);
    /* eslint-enable */ if (variableValue) return variableValue.trim();
    else if (defaultValue) return defaultValue;
    throw new $e728873b0e612b3a$var$PolishedError(74);
}
// @private
function $e728873b0e612b3a$var$capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $e728873b0e612b3a$var$positionMap$1 = [
    'Top',
    'Right',
    'Bottom',
    'Left'
];
function $e728873b0e612b3a$var$generateProperty(property, position) {
    if (!property) return position.toLowerCase();
    var splitProperty = property.split('-');
    if (splitProperty.length > 1) {
        splitProperty.splice(1, 0, position);
        return splitProperty.reduce(function(acc, val) {
            return "" + acc + $e728873b0e612b3a$var$capitalizeString(val);
        });
    }
    var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
    return property === joinedProperty ? "" + property + position : joinedProperty;
}
function $e728873b0e612b3a$var$generateStyles(property, valuesWithDefaults) {
    var styles = {};
    for(var i = 0; i < valuesWithDefaults.length; i += 1)if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) styles[$e728873b0e612b3a$var$generateProperty(property, $e728873b0e612b3a$var$positionMap$1[i])] = valuesWithDefaults[i];
    return styles;
}
/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $e728873b0e612b3a$export$4fc00c04dd60af95(property) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    //  prettier-ignore
    var firstValue = values[0], _values$ = values[1], secondValue = _values$ === void 0 ? firstValue : _values$, _values$2 = values[2], thirdValue = _values$2 === void 0 ? firstValue : _values$2, _values$3 = values[3], fourthValue = _values$3 === void 0 ? secondValue : _values$3;
    var valuesWithDefaults = [
        firstValue,
        secondValue,
        thirdValue,
        fourthValue
    ];
    return $e728873b0e612b3a$var$generateStyles(property, valuesWithDefaults);
}
/**
 * Check if a string ends with something
 * @private
 */ function $e728873b0e612b3a$var$endsWith(string, suffix) {
    return string.substr(-suffix.length) === suffix;
}
var $e728873b0e612b3a$var$cssRegex$1 = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value minus its unit of measure.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */ function $e728873b0e612b3a$export$ef04e38dc423904(value) {
    if (typeof value !== 'string') return value;
    var matchedValue = value.match($e728873b0e612b3a$var$cssRegex$1);
    return matchedValue ? parseFloat(value) : value;
}
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */ var $e728873b0e612b3a$var$pxtoFactory = function pxtoFactory(to) {
    return function(pxval, base) {
        if (base === void 0) base = '16px';
        var newPxval = pxval;
        var newBase = base;
        if (typeof pxval === 'string') {
            if (!$e728873b0e612b3a$var$endsWith(pxval, 'px')) throw new $e728873b0e612b3a$var$PolishedError(69, to, pxval);
            newPxval = $e728873b0e612b3a$export$ef04e38dc423904(pxval);
        }
        if (typeof base === 'string') {
            if (!$e728873b0e612b3a$var$endsWith(base, 'px')) throw new $e728873b0e612b3a$var$PolishedError(70, to, base);
            newBase = $e728873b0e612b3a$export$ef04e38dc423904(base);
        }
        if (typeof newPxval === 'string') throw new $e728873b0e612b3a$var$PolishedError(71, pxval, to);
        if (typeof newBase === 'string') throw new $e728873b0e612b3a$var$PolishedError(72, base, to);
        return "" + newPxval / newBase + to;
    };
};
var $e728873b0e612b3a$var$pixelsto = $e728873b0e612b3a$var$pxtoFactory;
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */ var $e728873b0e612b3a$var$em = $e728873b0e612b3a$var$pixelsto('em');
var $e728873b0e612b3a$export$c63c6f932822f543 = $e728873b0e612b3a$var$em;
var $e728873b0e612b3a$var$cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0],
 *   '--unit': getValueAndUnit('100px')[1],
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]};
 *   --unit: ${getValueAndUnit('100px')[1]};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100,
 *   '--unit': 'px',
 * }
 */ function $e728873b0e612b3a$export$feec6b849ef388ab(value) {
    if (typeof value !== 'string') return [
        value,
        ''
    ];
    var matchedValue = value.match($e728873b0e612b3a$var$cssRegex);
    if (matchedValue) return [
        parseFloat(value),
        matchedValue[2]
    ];
    return [
        value,
        undefined
    ];
}
/**
 * Helper for targeting rules in a style block generated by polished modules that need !important-level specificity. Can optionally specify a rule (or rules) to target specific rules.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...important(cover())
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${important(cover())}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute !important',
 *   'top': '0 !important',
 *   'right: '0 !important',
 *   'bottom': '0 !important',
 *   'left: '0 !important'
 * }
 */ function $e728873b0e612b3a$export$929888ab0c9f043c(styleBlock, rules) {
    if (typeof styleBlock !== 'object' || styleBlock === null) throw new $e728873b0e612b3a$var$PolishedError(75, typeof styleBlock);
    var newStyleBlock = {};
    Object.keys(styleBlock).forEach(function(key) {
        if (typeof styleBlock[key] === 'object' && styleBlock[key] !== null) newStyleBlock[key] = $e728873b0e612b3a$export$929888ab0c9f043c(styleBlock[key], rules);
        else if (!rules || rules && (rules === key || rules.indexOf(key) >= 0)) newStyleBlock[key] = styleBlock[key] + " !important";
        else newStyleBlock[key] = styleBlock[key];
    });
    return newStyleBlock;
}
var $e728873b0e612b3a$var$ratioNames = {
    minorSecond: 1.067,
    majorSecond: 1.125,
    minorThird: 1.2,
    majorThird: 1.25,
    perfectFourth: 1.333,
    augFourth: 1.414,
    perfectFifth: 1.5,
    minorSixth: 1.6,
    goldenSection: 1.618,
    majorSixth: 1.667,
    minorSeventh: 1.778,
    majorSeventh: 1.875,
    octave: 2,
    majorTenth: 2.5,
    majorEleventh: 2.667,
    majorTwelfth: 3,
    doubleOctave: 4
};
function $e728873b0e612b3a$var$getRatio(ratioName) {
    return $e728873b0e612b3a$var$ratioNames[ratioName];
}
/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing an em or rem value up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */ function $e728873b0e612b3a$export$c82a8a23c9e8bdb6(steps, base, ratio) {
    if (base === void 0) base = '1em';
    if (ratio === void 0) ratio = 1.333;
    if (typeof steps !== 'number') throw new $e728873b0e612b3a$var$PolishedError(42);
    if (typeof ratio === 'string' && !$e728873b0e612b3a$var$ratioNames[ratio]) throw new $e728873b0e612b3a$var$PolishedError(43);
    var _ref = typeof base === 'string' ? $e728873b0e612b3a$export$feec6b849ef388ab(base) : [
        base,
        ''
    ], realBase = _ref[0], unit = _ref[1];
    var realRatio = typeof ratio === 'string' ? $e728873b0e612b3a$var$getRatio(ratio) : ratio;
    if (typeof realBase === 'string') throw new $e728873b0e612b3a$var$PolishedError(44, base);
    return "" + realBase * Math.pow(realRatio, steps) + (unit || '');
}
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */ var $e728873b0e612b3a$var$rem = $e728873b0e612b3a$var$pixelsto('rem');
var $e728873b0e612b3a$export$fb1897a40d146f7f = $e728873b0e612b3a$var$rem;
var $e728873b0e612b3a$var$defaultFontSize = 16;
function $e728873b0e612b3a$var$convertBase(base) {
    var deconstructedValue = $e728873b0e612b3a$export$feec6b849ef388ab(base);
    if (deconstructedValue[1] === 'px') return parseFloat(base);
    if (deconstructedValue[1] === '%') return parseFloat(base) / 100 * $e728873b0e612b3a$var$defaultFontSize;
    throw new $e728873b0e612b3a$var$PolishedError(78, deconstructedValue[1]);
}
function $e728873b0e612b3a$var$getBaseFromDoc() {
    /* eslint-disable */ /* istanbul ignore next */ if (typeof document !== 'undefined' && document.documentElement !== null) {
        var rootFontSize = getComputedStyle(document.documentElement).fontSize;
        return rootFontSize ? $e728873b0e612b3a$var$convertBase(rootFontSize) : $e728873b0e612b3a$var$defaultFontSize;
    }
    /* eslint-enable */ /* istanbul ignore next */ return $e728873b0e612b3a$var$defaultFontSize;
}
/**
 * Convert rem values to px. By default, the base value is pulled from the font-size property on the root element (if it is set in % or px). It defaults to 16px if not found on the root. You can also override the base value by providing your own base in % or px.
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': remToPx('1.6rem')
 *   'height': remToPx('1.6rem', '10px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${remToPx('1.6rem')}
 *   height: ${remToPx('1.6rem', '10px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '25.6px',
 *   'height': '16px',
 * }
 */ function $e728873b0e612b3a$export$7e5d3caf0359a67a(value, base) {
    var deconstructedValue = $e728873b0e612b3a$export$feec6b849ef388ab(value);
    if (deconstructedValue[1] !== 'rem' && deconstructedValue[1] !== '') throw new $e728873b0e612b3a$var$PolishedError(77, deconstructedValue[1]);
    var newBase = base ? $e728873b0e612b3a$var$convertBase(base) : $e728873b0e612b3a$var$getBaseFromDoc();
    return deconstructedValue[0] * newBase + "px";
}
var $e728873b0e612b3a$var$functionsMap$3 = {
    back: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    circ: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    cubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    expo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    quad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    quart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    quint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    sine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeIn('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeIn('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function $e728873b0e612b3a$export$929e5a82286172a6(functionName) {
    return $e728873b0e612b3a$var$functionsMap$3[functionName.toLowerCase().trim()];
}
var $e728873b0e612b3a$var$functionsMap$2 = {
    back: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    circ: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    cubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    expo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    quad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    quart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    quint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    sine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeInOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeInOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
 * }
 */ function $e728873b0e612b3a$export$c07234257a03d5e9(functionName) {
    return $e728873b0e612b3a$var$functionsMap$2[functionName.toLowerCase().trim()];
}
var $e728873b0e612b3a$var$functionsMap$1 = {
    back: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    cubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    circ: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    expo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    quad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    quart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    quint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    sine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
 * }
 */ function $e728873b0e612b3a$export$57636bb43b1ccbb0(functionName) {
    return $e728873b0e612b3a$var$functionsMap$1[functionName.toLowerCase().trim()];
}
/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */ function $e728873b0e612b3a$export$cf95c51b03f10bae(fromSize, toSize, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    var _getValueAndUnit = $e728873b0e612b3a$export$feec6b849ef388ab(fromSize), unitlessFromSize = _getValueAndUnit[0], fromSizeUnit = _getValueAndUnit[1];
    var _getValueAndUnit2 = $e728873b0e612b3a$export$feec6b849ef388ab(toSize), unitlessToSize = _getValueAndUnit2[0], toSizeUnit = _getValueAndUnit2[1];
    var _getValueAndUnit3 = $e728873b0e612b3a$export$feec6b849ef388ab(minScreen), unitlessMinScreen = _getValueAndUnit3[0], minScreenUnit = _getValueAndUnit3[1];
    var _getValueAndUnit4 = $e728873b0e612b3a$export$feec6b849ef388ab(maxScreen), unitlessMaxScreen = _getValueAndUnit4[0], maxScreenUnit = _getValueAndUnit4[1];
    if (typeof unitlessMinScreen !== 'number' || typeof unitlessMaxScreen !== 'number' || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) throw new $e728873b0e612b3a$var$PolishedError(47);
    if (typeof unitlessFromSize !== 'number' || typeof unitlessToSize !== 'number' || fromSizeUnit !== toSizeUnit) throw new $e728873b0e612b3a$var$PolishedError(48);
    if (fromSizeUnit !== minScreenUnit || toSizeUnit !== maxScreenUnit) throw new $e728873b0e612b3a$var$PolishedError(76);
    var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
    var base = unitlessToSize - slope * unitlessMaxScreen;
    return "calc(" + base.toFixed(2) + (fromSizeUnit || '') + " + " + (100 * slope).toFixed(2) + "vw)";
}
/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */ function $e728873b0e612b3a$export$8c467e8859fdef13(parent) {
    var _ref;
    if (parent === void 0) parent = '&';
    var pseudoSelector = parent + "::after";
    return _ref = {}, _ref[pseudoSelector] = {
        clear: 'both',
        content: '""',
        display: 'table'
    }, _ref;
}
/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */ function $e728873b0e612b3a$export$4bdbf921f0c0fd8c(offset) {
    if (offset === void 0) offset = 0;
    return {
        position: 'absolute',
        top: offset,
        right: offset,
        bottom: offset,
        left: offset
    };
}
/**
 * CSS to represent truncated text with an ellipsis. You can optionally pass a max-width and number of lines before truncating.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */ function $e728873b0e612b3a$export$a5b94313d6908893(width, lines) {
    if (lines === void 0) lines = 1;
    var styles = {
        display: 'inline-block',
        maxWidth: width || '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        wordWrap: 'normal'
    };
    return lines > 1 ? (0, $if2ZQ.default)({}, styles, {
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: lines,
        display: '-webkit-box',
        whiteSpace: 'normal'
    }) : styles;
}
function $e728873b0e612b3a$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $e728873b0e612b3a$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e728873b0e612b3a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e728873b0e612b3a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e728873b0e612b3a$var$_arrayLikeToArray(o, minLen);
}
function $e728873b0e612b3a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */ function $e728873b0e612b3a$export$de4c2ac00f6121cf(cssProp, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    if (!Array.isArray(cssProp) && typeof cssProp !== 'object' || cssProp === null) throw new $e728873b0e612b3a$var$PolishedError(49);
    if (Array.isArray(cssProp)) {
        var mediaQueries = {};
        var fallbacks = {};
        for(var _iterator = $e728873b0e612b3a$var$_createForOfIteratorHelperLoose(cssProp), _step; !(_step = _iterator()).done;){
            var _extends2, _extends3;
            var obj = _step.value;
            if (!obj.prop || !obj.fromSize || !obj.toSize) throw new $e728873b0e612b3a$var$PolishedError(50);
            fallbacks[obj.prop] = obj.fromSize;
            mediaQueries["@media (min-width: " + minScreen + ")"] = (0, $if2ZQ.default)({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = $e728873b0e612b3a$export$cf95c51b03f10bae(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
            mediaQueries["@media (min-width: " + maxScreen + ")"] = (0, $if2ZQ.default)({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
        }
        return (0, $if2ZQ.default)({}, fallbacks, mediaQueries);
    } else {
        var _ref, _ref2, _ref3;
        if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) throw new $e728873b0e612b3a$var$PolishedError(51);
        return _ref3 = {}, _ref3[cssProp.prop] = cssProp.fromSize, _ref3["@media (min-width: " + minScreen + ")"] = (_ref = {}, _ref[cssProp.prop] = $e728873b0e612b3a$export$cf95c51b03f10bae(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref), _ref3["@media (min-width: " + maxScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = cssProp.toSize, _ref2), _ref3;
    }
}
var $e728873b0e612b3a$var$dataURIRegex = /^\s*data:([a-z]+\/[a-z-]+(;[a-z-]+=[a-z-]+)?)?(;charset=[a-z0-9-]+)?(;base64)?,[a-z0-9!$&',()*+,;=\-._~:@/?%\s]*\s*$/i;
var $e728873b0e612b3a$var$formatHintMap = {
    woff: 'woff',
    woff2: 'woff2',
    ttf: 'truetype',
    otf: 'opentype',
    eot: 'embedded-opentype',
    svg: 'svg',
    svgz: 'svg'
};
function $e728873b0e612b3a$var$generateFormatHint(format, formatHint) {
    if (!formatHint) return '';
    return " format(\"" + $e728873b0e612b3a$var$formatHintMap[format] + "\")";
}
function $e728873b0e612b3a$var$isDataURI(fontFilePath) {
    return !!fontFilePath.replace(/\s+/g, ' ').match($e728873b0e612b3a$var$dataURIRegex);
}
function $e728873b0e612b3a$var$generateFileReferences(fontFilePath, fileFormats, formatHint) {
    if ($e728873b0e612b3a$var$isDataURI(fontFilePath)) return "url(\"" + fontFilePath + "\")" + $e728873b0e612b3a$var$generateFormatHint(fileFormats[0], formatHint);
    var fileFontReferences = fileFormats.map(function(format) {
        return "url(\"" + fontFilePath + "." + format + "\")" + $e728873b0e612b3a$var$generateFormatHint(format, formatHint);
    });
    return fileFontReferences.join(', ');
}
function $e728873b0e612b3a$var$generateLocalReferences(localFonts) {
    var localFontReferences = localFonts.map(function(font) {
        return "local(\"" + font + "\")";
    });
    return localFontReferences.join(', ');
}
function $e728873b0e612b3a$var$generateSources(fontFilePath, localFonts, fileFormats, formatHint) {
    var fontReferences = [];
    if (localFonts) fontReferences.push($e728873b0e612b3a$var$generateLocalReferences(localFonts));
    if (fontFilePath) fontReferences.push($e728873b0e612b3a$var$generateFileReferences(fontFilePath, fileFormats, formatHint));
    return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration. Defaults to check for local copies of the font on the user's machine. You can disable this by passing `null` to localFonts.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro',
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * const GlobalStyle = createGlobalStyle`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro',
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */ function $e728873b0e612b3a$export$566c6c2ff0443c7(_ref) {
    var fontFamily = _ref.fontFamily, fontFilePath = _ref.fontFilePath, fontStretch = _ref.fontStretch, fontStyle = _ref.fontStyle, fontVariant = _ref.fontVariant, fontWeight = _ref.fontWeight, _ref$fileFormats = _ref.fileFormats, fileFormats = _ref$fileFormats === void 0 ? [
        'eot',
        'woff2',
        'woff',
        'ttf',
        'svg'
    ] : _ref$fileFormats, _ref$formatHint = _ref.formatHint, formatHint = _ref$formatHint === void 0 ? false : _ref$formatHint, _ref$localFonts = _ref.localFonts, localFonts = _ref$localFonts === void 0 ? [
        fontFamily
    ] : _ref$localFonts, unicodeRange = _ref.unicodeRange, fontDisplay = _ref.fontDisplay, fontVariationSettings = _ref.fontVariationSettings, fontFeatureSettings = _ref.fontFeatureSettings;
    // Error Handling
    if (!fontFamily) throw new $e728873b0e612b3a$var$PolishedError(55);
    if (!fontFilePath && !localFonts) throw new $e728873b0e612b3a$var$PolishedError(52);
    if (localFonts && !Array.isArray(localFonts)) throw new $e728873b0e612b3a$var$PolishedError(53);
    if (!Array.isArray(fileFormats)) throw new $e728873b0e612b3a$var$PolishedError(54);
    var fontFaceDeclaration = {
        '@font-face': {
            fontFamily: fontFamily,
            src: $e728873b0e612b3a$var$generateSources(fontFilePath, localFonts, fileFormats, formatHint),
            unicodeRange: unicodeRange,
            fontStretch: fontStretch,
            fontStyle: fontStyle,
            fontVariant: fontVariant,
            fontWeight: fontWeight,
            fontDisplay: fontDisplay,
            fontVariationSettings: fontVariationSettings,
            fontFeatureSettings: fontFeatureSettings
        }
    };
    // Removes undefined fields for cleaner css object.
    return JSON.parse(JSON.stringify(fontFaceDeclaration));
}
/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */ function $e728873b0e612b3a$export$27bef6389954e24d() {
    return {
        textIndent: '101%',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
}
/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */ function $e728873b0e612b3a$export$36e2157ae4e3cbdd() {
    return {
        border: '0',
        clip: 'rect(0 0 0 0)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    };
}
/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */ function $e728873b0e612b3a$export$e79006618d7c6cc3(ratio) {
    if (ratio === void 0) ratio = 1.3;
    return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}
function $e728873b0e612b3a$var$constructGradientValue(literals) {
    var template = '';
    for(var _len = arguments.length, substitutions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)substitutions[_key - 1] = arguments[_key];
    for(var i = 0; i < literals.length; i += 1){
        template += literals[i];
        if (i === substitutions.length - 1 && substitutions[i]) {
            var definedValues = substitutions.filter(function(substitute) {
                return !!substitute;
            });
            // Adds leading coma if properties preceed color-stops
            if (definedValues.length > 1) {
                template = template.slice(0, -1);
                template += ", " + substitutions[i];
            // No trailing space if color-stops is the only param provided
            } else if (definedValues.length === 1) template += "" + substitutions[i];
        } else if (substitutions[i]) template += substitutions[i] + " ";
    }
    return template.trim();
}
var $e728873b0e612b3a$var$_templateObject$1;
/**
 * CSS for declaring a linear gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#FFF',
 *   'backgroundImage': 'linear-gradient(to top right, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $e728873b0e612b3a$export$46def8197cf4dd4c(_ref) {
    var colorStops = _ref.colorStops, fallback = _ref.fallback, _ref$toDirection = _ref.toDirection, toDirection = _ref$toDirection === void 0 ? '' : _ref$toDirection;
    if (!colorStops || colorStops.length < 2) throw new $e728873b0e612b3a$var$PolishedError(56);
    return {
        backgroundColor: fallback || colorStops[0].replace(/,\s+/g, ',').split(' ')[0].replace(/,(?=\S)/g, ', '),
        backgroundImage: $e728873b0e612b3a$var$constructGradientValue($e728873b0e612b3a$var$_templateObject$1 || ($e728873b0e612b3a$var$_templateObject$1 = (0, $1a6b17165b999be2$export$2e2bcd8739ae039)([
            "linear-gradient(",
            "",
            ")"
        ])), toDirection, colorStops.join(', ').replace(/,(?=\S)/g, ', '))
    };
}
/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */ function $e728873b0e612b3a$export$a3295358bff77e() {
    var _ref;
    return [
        (_ref = {
            html: {
                lineHeight: '1.15',
                textSizeAdjust: '100%'
            },
            body: {
                margin: '0'
            },
            main: {
                display: 'block'
            },
            h1: {
                fontSize: '2em',
                margin: '0.67em 0'
            },
            hr: {
                boxSizing: 'content-box',
                height: '0',
                overflow: 'visible'
            },
            pre: {
                fontFamily: 'monospace, monospace',
                fontSize: '1em'
            },
            a: {
                backgroundColor: 'transparent'
            },
            'abbr[title]': {
                borderBottom: 'none',
                textDecoration: 'underline'
            }
        }, _ref["b,\n    strong"] = {
            fontWeight: 'bolder'
        }, _ref["code,\n    kbd,\n    samp"] = {
            fontFamily: 'monospace, monospace',
            fontSize: '1em'
        }, _ref.small = {
            fontSize: '80%'
        }, _ref["sub,\n    sup"] = {
            fontSize: '75%',
            lineHeight: '0',
            position: 'relative',
            verticalAlign: 'baseline'
        }, _ref.sub = {
            bottom: '-0.25em'
        }, _ref.sup = {
            top: '-0.5em'
        }, _ref.img = {
            borderStyle: 'none'
        }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
            fontFamily: 'inherit',
            fontSize: '100%',
            lineHeight: '1.15',
            margin: '0'
        }, _ref["button,\n    input"] = {
            overflow: 'visible'
        }, _ref["button,\n    select"] = {
            textTransform: 'none'
        }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
            WebkitAppearance: 'button'
        }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
            borderStyle: 'none',
            padding: '0'
        }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
            outline: '1px dotted ButtonText'
        }, _ref.fieldset = {
            padding: '0.35em 0.625em 0.75em'
        }, _ref.legend = {
            boxSizing: 'border-box',
            color: 'inherit',
            display: 'table',
            maxWidth: '100%',
            padding: '0',
            whiteSpace: 'normal'
        }, _ref.progress = {
            verticalAlign: 'baseline'
        }, _ref.textarea = {
            overflow: 'auto'
        }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
            boxSizing: 'border-box',
            padding: '0'
        }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
            height: 'auto'
        }, _ref['[type="search"]'] = {
            WebkitAppearance: 'textfield',
            outlineOffset: '-2px'
        }, _ref['[type="search"]::-webkit-search-decoration'] = {
            WebkitAppearance: 'none'
        }, _ref['::-webkit-file-upload-button'] = {
            WebkitAppearance: 'button',
            font: 'inherit'
        }, _ref.details = {
            display: 'block'
        }, _ref.summary = {
            display: 'list-item'
        }, _ref.template = {
            display: 'none'
        }, _ref['[hidden]'] = {
            display: 'none'
        }, _ref),
        {
            'abbr[title]': {
                textDecoration: 'underline dotted'
            }
        }
    ];
}
var $e728873b0e612b3a$var$_templateObject;
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $e728873b0e612b3a$export$3922d1ccb8631cd8(_ref) {
    var colorStops = _ref.colorStops, _ref$extent = _ref.extent, extent = _ref$extent === void 0 ? '' : _ref$extent, fallback = _ref.fallback, _ref$position = _ref.position, position = _ref$position === void 0 ? '' : _ref$position, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? '' : _ref$shape;
    if (!colorStops || colorStops.length < 2) throw new $e728873b0e612b3a$var$PolishedError(57);
    return {
        backgroundColor: fallback || colorStops[0].split(' ')[0],
        backgroundImage: $e728873b0e612b3a$var$constructGradientValue($e728873b0e612b3a$var$_templateObject || ($e728873b0e612b3a$var$_templateObject = (0, $1a6b17165b999be2$export$2e2bcd8739ae039)([
            "radial-gradient(",
            "",
            "",
            "",
            ")"
        ])), position, shape, extent, colorStops.join(', '))
    };
}
/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */ function $e728873b0e612b3a$export$19389033401d366a(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
    var _ref;
    if (extension === void 0) extension = 'png';
    if (retinaSuffix === void 0) retinaSuffix = '_2x';
    if (!filename) throw new $e728873b0e612b3a$var$PolishedError(58);
    // Replace the dot at the beginning of the passed extension if one exists
    var ext = extension.replace(/^\./, '');
    var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
    return _ref = {
        backgroundImage: "url(" + filename + "." + ext + ")"
    }, _ref[$e728873b0e612b3a$export$e79006618d7c6cc3()] = (0, $if2ZQ.default)({
        backgroundImage: "url(" + rFilename + ")"
    }, backgroundSize ? {
        backgroundSize: backgroundSize
    } : {}), _ref;
}
/* eslint-disable key-spacing */ var $e728873b0e612b3a$var$functionsMap = {
    easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
    easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
    easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/* eslint-enable key-spacing */ function $e728873b0e612b3a$var$getTimingFunction(functionName) {
    return $e728873b0e612b3a$var$functionsMap[functionName];
}
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @deprecated - This will be deprecated in v5 in favor of `easeIn`, `easeOut`, `easeInOut`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function $e728873b0e612b3a$export$61210fa83792a81(timingFunction) {
    return $e728873b0e612b3a$var$getTimingFunction(timingFunction);
}
var $e728873b0e612b3a$var$getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
    var fullWidth = "" + width[0] + (width[1] || '');
    var halfWidth = "" + width[0] / 2 + (width[1] || '');
    var fullHeight = "" + height[0] + (height[1] || '');
    var halfHeight = "" + height[0] / 2 + (height[1] || '');
    switch(pointingDirection){
        case 'top':
            return "0 " + halfWidth + " " + fullHeight + " " + halfWidth;
        case 'topLeft':
            return fullWidth + " " + fullHeight + " 0 0";
        case 'left':
            return halfHeight + " " + fullWidth + " " + halfHeight + " 0";
        case 'bottomLeft':
            return fullWidth + " 0 0 " + fullHeight;
        case 'bottom':
            return fullHeight + " " + halfWidth + " 0 " + halfWidth;
        case 'bottomRight':
            return "0 0 " + fullWidth + " " + fullHeight;
        case 'right':
            return halfHeight + " 0 " + halfHeight + " " + fullWidth;
        case 'topRight':
        default:
            return "0 " + fullWidth + " " + fullHeight + " 0";
    }
};
var $e728873b0e612b3a$var$getBorderColor = function getBorderColor(pointingDirection, foregroundColor) {
    switch(pointingDirection){
        case 'top':
        case 'bottomRight':
            return {
                borderBottomColor: foregroundColor
            };
        case 'right':
        case 'bottomLeft':
            return {
                borderLeftColor: foregroundColor
            };
        case 'bottom':
        case 'topLeft':
            return {
                borderTopColor: foregroundColor
            };
        case 'left':
        case 'topRight':
            return {
                borderRightColor: foregroundColor
            };
        default:
            throw new $e728873b0e612b3a$var$PolishedError(59);
    }
};
/**
 * CSS to represent triangle with any pointing direction with an optional background color.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent transparent transparent red',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */ function $e728873b0e612b3a$export$9eed783d03e0135c(_ref) {
    var pointingDirection = _ref.pointingDirection, height = _ref.height, width = _ref.width, foregroundColor = _ref.foregroundColor, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
    var widthAndUnit = $e728873b0e612b3a$export$feec6b849ef388ab(width);
    var heightAndUnit = $e728873b0e612b3a$export$feec6b849ef388ab(height);
    if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) throw new $e728873b0e612b3a$var$PolishedError(60);
    return (0, $if2ZQ.default)({
        width: '0',
        height: '0',
        borderColor: backgroundColor
    }, $e728873b0e612b3a$var$getBorderColor(pointingDirection, foregroundColor), {
        borderStyle: 'solid',
        borderWidth: $e728873b0e612b3a$var$getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit)
    });
}
/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */ function $e728873b0e612b3a$export$dca3d8ad656c34d2(wrap) {
    if (wrap === void 0) wrap = 'break-word';
    var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
    return {
        overflowWrap: wrap,
        wordWrap: wrap,
        wordBreak: wordBreak
    };
}
function $e728873b0e612b3a$var$colorToInt(color) {
    return Math.round(color * 255);
}
function $e728873b0e612b3a$var$convertToInt(red, green, blue) {
    return $e728873b0e612b3a$var$colorToInt(red) + "," + $e728873b0e612b3a$var$colorToInt(green) + "," + $e728873b0e612b3a$var$colorToInt(blue);
}
function $e728873b0e612b3a$var$hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0) convert = $e728873b0e612b3a$var$convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
    // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = (hue % 360 + 360) % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
var $e728873b0e612b3a$var$namedColorMap = {
    aliceblue: 'f0f8ff',
    antiquewhite: 'faebd7',
    aqua: '00ffff',
    aquamarine: '7fffd4',
    azure: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '000',
    blanchedalmond: 'ffebcd',
    blue: '0000ff',
    blueviolet: '8a2be2',
    brown: 'a52a2a',
    burlywood: 'deb887',
    cadetblue: '5f9ea0',
    chartreuse: '7fff00',
    chocolate: 'd2691e',
    coral: 'ff7f50',
    cornflowerblue: '6495ed',
    cornsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: '00ffff',
    darkblue: '00008b',
    darkcyan: '008b8b',
    darkgoldenrod: 'b8860b',
    darkgray: 'a9a9a9',
    darkgreen: '006400',
    darkgrey: 'a9a9a9',
    darkkhaki: 'bdb76b',
    darkmagenta: '8b008b',
    darkolivegreen: '556b2f',
    darkorange: 'ff8c00',
    darkorchid: '9932cc',
    darkred: '8b0000',
    darksalmon: 'e9967a',
    darkseagreen: '8fbc8f',
    darkslateblue: '483d8b',
    darkslategray: '2f4f4f',
    darkslategrey: '2f4f4f',
    darkturquoise: '00ced1',
    darkviolet: '9400d3',
    deeppink: 'ff1493',
    deepskyblue: '00bfff',
    dimgray: '696969',
    dimgrey: '696969',
    dodgerblue: '1e90ff',
    firebrick: 'b22222',
    floralwhite: 'fffaf0',
    forestgreen: '228b22',
    fuchsia: 'ff00ff',
    gainsboro: 'dcdcdc',
    ghostwhite: 'f8f8ff',
    gold: 'ffd700',
    goldenrod: 'daa520',
    gray: '808080',
    green: '008000',
    greenyellow: 'adff2f',
    grey: '808080',
    honeydew: 'f0fff0',
    hotpink: 'ff69b4',
    indianred: 'cd5c5c',
    indigo: '4b0082',
    ivory: 'fffff0',
    khaki: 'f0e68c',
    lavender: 'e6e6fa',
    lavenderblush: 'fff0f5',
    lawngreen: '7cfc00',
    lemonchiffon: 'fffacd',
    lightblue: 'add8e6',
    lightcoral: 'f08080',
    lightcyan: 'e0ffff',
    lightgoldenrodyellow: 'fafad2',
    lightgray: 'd3d3d3',
    lightgreen: '90ee90',
    lightgrey: 'd3d3d3',
    lightpink: 'ffb6c1',
    lightsalmon: 'ffa07a',
    lightseagreen: '20b2aa',
    lightskyblue: '87cefa',
    lightslategray: '789',
    lightslategrey: '789',
    lightsteelblue: 'b0c4de',
    lightyellow: 'ffffe0',
    lime: '0f0',
    limegreen: '32cd32',
    linen: 'faf0e6',
    magenta: 'f0f',
    maroon: '800000',
    mediumaquamarine: '66cdaa',
    mediumblue: '0000cd',
    mediumorchid: 'ba55d3',
    mediumpurple: '9370db',
    mediumseagreen: '3cb371',
    mediumslateblue: '7b68ee',
    mediumspringgreen: '00fa9a',
    mediumturquoise: '48d1cc',
    mediumvioletred: 'c71585',
    midnightblue: '191970',
    mintcream: 'f5fffa',
    mistyrose: 'ffe4e1',
    moccasin: 'ffe4b5',
    navajowhite: 'ffdead',
    navy: '000080',
    oldlace: 'fdf5e6',
    olive: '808000',
    olivedrab: '6b8e23',
    orange: 'ffa500',
    orangered: 'ff4500',
    orchid: 'da70d6',
    palegoldenrod: 'eee8aa',
    palegreen: '98fb98',
    paleturquoise: 'afeeee',
    palevioletred: 'db7093',
    papayawhip: 'ffefd5',
    peachpuff: 'ffdab9',
    peru: 'cd853f',
    pink: 'ffc0cb',
    plum: 'dda0dd',
    powderblue: 'b0e0e6',
    purple: '800080',
    rebeccapurple: '639',
    red: 'f00',
    rosybrown: 'bc8f8f',
    royalblue: '4169e1',
    saddlebrown: '8b4513',
    salmon: 'fa8072',
    sandybrown: 'f4a460',
    seagreen: '2e8b57',
    seashell: 'fff5ee',
    sienna: 'a0522d',
    silver: 'c0c0c0',
    skyblue: '87ceeb',
    slateblue: '6a5acd',
    slategray: '708090',
    slategrey: '708090',
    snow: 'fffafa',
    springgreen: '00ff7f',
    steelblue: '4682b4',
    tan: 'd2b48c',
    teal: '008080',
    thistle: 'd8bfd8',
    tomato: 'ff6347',
    turquoise: '40e0d0',
    violet: 'ee82ee',
    wheat: 'f5deb3',
    white: 'fff',
    whitesmoke: 'f5f5f5',
    yellow: 'ff0',
    yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */ function $e728873b0e612b3a$var$nameToHex(color) {
    if (typeof color !== 'string') return color;
    var normalizedColorName = color.toLowerCase();
    return $e728873b0e612b3a$var$namedColorMap[normalizedColorName] ? "#" + $e728873b0e612b3a$var$namedColorMap[normalizedColorName] : color;
}
var $e728873b0e612b3a$var$hexRegex = /^#[a-fA-F0-9]{6}$/;
var $e728873b0e612b3a$var$hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var $e728873b0e612b3a$var$reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var $e728873b0e612b3a$var$reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var $e728873b0e612b3a$var$rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var $e728873b0e612b3a$var$rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var $e728873b0e612b3a$var$hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var $e728873b0e612b3a$var$hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */ function $e728873b0e612b3a$export$2f48baff6995707a(color) {
    if (typeof color !== 'string') throw new $e728873b0e612b3a$var$PolishedError(3);
    var normalizedColor = $e728873b0e612b3a$var$nameToHex(color);
    if (normalizedColor.match($e728873b0e612b3a$var$hexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match($e728873b0e612b3a$var$hexRgbaRegex)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
            alpha: alpha
        };
    }
    if (normalizedColor.match($e728873b0e612b3a$var$reducedHexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
    if (normalizedColor.match($e728873b0e612b3a$var$reducedRgbaHexRegex)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha
        };
    }
    var rgbMatched = $e728873b0e612b3a$var$rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
    };
    var rgbaMatched = $e728873b0e612b3a$var$rgbaRegex.exec(normalizedColor.substring(0, 50));
    if (rgbaMatched) return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
    var hslMatched = $e728873b0e612b3a$var$hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10);
        var saturation = parseInt("" + hslMatched[2], 10) / 100;
        var lightness = parseInt("" + hslMatched[3], 10) / 100;
        var rgbColorString = "rgb(" + $e728873b0e612b3a$var$hslToRgb(hue, saturation, lightness) + ")";
        var hslRgbMatched = $e728873b0e612b3a$var$rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new $e728873b0e612b3a$var$PolishedError(4, normalizedColor, rgbColorString);
        return {
            red: parseInt("" + hslRgbMatched[1], 10),
            green: parseInt("" + hslRgbMatched[2], 10),
            blue: parseInt("" + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = $e728873b0e612b3a$var$hslaRegex.exec(normalizedColor.substring(0, 50));
    if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10);
        var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
        var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
        var _rgbColorString = "rgb(" + $e728873b0e612b3a$var$hslToRgb(_hue, _saturation, _lightness) + ")";
        var _hslRgbMatched = $e728873b0e612b3a$var$rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new $e728873b0e612b3a$var$PolishedError(4, normalizedColor, _rgbColorString);
        return {
            red: parseInt("" + _hslRgbMatched[1], 10),
            green: parseInt("" + _hslRgbMatched[2], 10),
            blue: parseInt("" + _hslRgbMatched[3], 10),
            alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
        };
    }
    throw new $e728873b0e612b3a$var$PolishedError(5);
}
function $e728873b0e612b3a$var$rgbToHsl(color) {
    // make sure rgb are contained in a set of [0, 255]
    var red = color.red / 255;
    var green = color.green / 255;
    var blue = color.blue / 255;
    var max = Math.max(red, green, blue);
    var min = Math.min(red, green, blue);
    var lightness = (max + min) / 2;
    if (max === min) {
        // achromatic
        if (color.alpha !== undefined) return {
            hue: 0,
            saturation: 0,
            lightness: lightness,
            alpha: color.alpha
        };
        else return {
            hue: 0,
            saturation: 0,
            lightness: lightness
        };
    }
    var hue;
    var delta = max - min;
    var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            // blue case
            hue = (red - green) / delta + 4;
            break;
    }
    hue *= 60;
    if (color.alpha !== undefined) return {
        hue: hue,
        saturation: saturation,
        lightness: lightness,
        alpha: color.alpha
    };
    return {
        hue: hue,
        saturation: saturation,
        lightness: lightness
    };
}
/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */ function $e728873b0e612b3a$export$1286688e1b3fde9c(color) {
    // Note: At a later stage we can optimize this function as right now a hsl
    // color would be parsed converted to rgb values and converted back to hsl.
    return $e728873b0e612b3a$var$rgbToHsl($e728873b0e612b3a$export$2f48baff6995707a(color));
}
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var $e728873b0e612b3a$var$reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
var $e728873b0e612b3a$var$reduceHexValue$1 = $e728873b0e612b3a$var$reduceHexValue;
function $e728873b0e612b3a$var$numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function $e728873b0e612b3a$var$colorToHex(color) {
    return $e728873b0e612b3a$var$numberToHex(Math.round(color * 255));
}
function $e728873b0e612b3a$var$convertToHex(red, green, blue) {
    return $e728873b0e612b3a$var$reduceHexValue$1("#" + $e728873b0e612b3a$var$colorToHex(red) + $e728873b0e612b3a$var$colorToHex(green) + $e728873b0e612b3a$var$colorToHex(blue));
}
function $e728873b0e612b3a$var$hslToHex(hue, saturation, lightness) {
    return $e728873b0e612b3a$var$hslToRgb(hue, saturation, lightness, $e728873b0e612b3a$var$convertToHex);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */ function $e728873b0e612b3a$export$8f4a7c0bb78e6ea8(value, saturation, lightness) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') return $e728873b0e612b3a$var$hslToHex(value, saturation, lightness);
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined) return $e728873b0e612b3a$var$hslToHex(value.hue, value.saturation, value.lightness);
    throw new $e728873b0e612b3a$var$PolishedError(1);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */ function $e728873b0e612b3a$export$810b04175080204c(value, saturation, lightness, alpha) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') return alpha >= 1 ? $e728873b0e612b3a$var$hslToHex(value, saturation, lightness) : "rgba(" + $e728873b0e612b3a$var$hslToRgb(value, saturation, lightness) + "," + alpha + ")";
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) return value.alpha >= 1 ? $e728873b0e612b3a$var$hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + $e728873b0e612b3a$var$hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
    throw new $e728873b0e612b3a$var$PolishedError(2);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function $e728873b0e612b3a$export$8972dc0e6ad9238f(value, green, blue) {
    if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') return $e728873b0e612b3a$var$reduceHexValue$1("#" + $e728873b0e612b3a$var$numberToHex(value) + $e728873b0e612b3a$var$numberToHex(green) + $e728873b0e612b3a$var$numberToHex(blue));
    else if (typeof value === 'object' && green === undefined && blue === undefined) return $e728873b0e612b3a$var$reduceHexValue$1("#" + $e728873b0e612b3a$var$numberToHex(value.red) + $e728873b0e612b3a$var$numberToHex(value.green) + $e728873b0e612b3a$var$numberToHex(value.blue));
    throw new $e728873b0e612b3a$var$PolishedError(6);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function $e728873b0e612b3a$export$4e46ac54fc82cf3b(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === 'string' && typeof secondValue === 'number') {
        var rgbValue = $e728873b0e612b3a$export$2f48baff6995707a(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') return fourthValue >= 1 ? $e728873b0e612b3a$export$8972dc0e6ad9238f(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
    else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? $e728873b0e612b3a$export$8972dc0e6ad9238f(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    throw new $e728873b0e612b3a$var$PolishedError(7);
}
var $e728873b0e612b3a$var$isRgb = function isRgb(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $e728873b0e612b3a$var$isRgba = function isRgba(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};
var $e728873b0e612b3a$var$isHsl = function isHsl(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $e728873b0e612b3a$var$isHsla = function isHsla(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $e728873b0e612b3a$export$42fe740cdf79b2df(color) {
    if (typeof color !== 'object') throw new $e728873b0e612b3a$var$PolishedError(8);
    if ($e728873b0e612b3a$var$isRgba(color)) return $e728873b0e612b3a$export$4e46ac54fc82cf3b(color);
    if ($e728873b0e612b3a$var$isRgb(color)) return $e728873b0e612b3a$export$8972dc0e6ad9238f(color);
    if ($e728873b0e612b3a$var$isHsla(color)) return $e728873b0e612b3a$export$810b04175080204c(color);
    if ($e728873b0e612b3a$var$isHsl(color)) return $e728873b0e612b3a$export$8f4a7c0bb78e6ea8(color);
    throw new $e728873b0e612b3a$var$PolishedError(8);
}
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function $e728873b0e612b3a$var$curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : $e728873b0e612b3a$var$curried(f, length, combined);
    };
}
// eslint-disable-next-line no-redeclare
function $e728873b0e612b3a$var$curry(f) {
    // eslint-disable-line no-redeclare
    return $e728873b0e612b3a$var$curried(f, f.length, []);
}
/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated around
 * the color wheel, always producing a positive hue value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */ function $e728873b0e612b3a$var$adjustHue(degree, color) {
    if (color === 'transparent') return color;
    var hslColor = $e728873b0e612b3a$export$1286688e1b3fde9c(color);
    return $e728873b0e612b3a$export$42fe740cdf79b2df((0, $if2ZQ.default)({}, hslColor, {
        hue: hslColor.hue + parseFloat(degree)
    }));
}
// prettier-ignore
var $e728873b0e612b3a$var$curriedAdjustHue = $e728873b0e612b3a$var$curry /* ::<number | string, string, string> */ ($e728873b0e612b3a$var$adjustHue);
var $e728873b0e612b3a$export$2b372a09365374d6 = $e728873b0e612b3a$var$curriedAdjustHue;
/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $e728873b0e612b3a$export$bd4f6f7e1823bc9e(color) {
    if (color === 'transparent') return color;
    var hslColor = $e728873b0e612b3a$export$1286688e1b3fde9c(color);
    return $e728873b0e612b3a$export$42fe740cdf79b2df((0, $if2ZQ.default)({}, hslColor, {
        hue: (hslColor.hue + 180) % 360
    }));
}
function $e728873b0e612b3a$var$guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */ function $e728873b0e612b3a$var$darken(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $e728873b0e612b3a$export$1286688e1b3fde9c(color);
    return $e728873b0e612b3a$export$42fe740cdf79b2df((0, $if2ZQ.default)({}, hslColor, {
        lightness: $e728873b0e612b3a$var$guard(0, 1, hslColor.lightness - parseFloat(amount))
    }));
}
// prettier-ignore
var $e728873b0e612b3a$var$curriedDarken = $e728873b0e612b3a$var$curry /* ::<number | string, string, string> */ ($e728873b0e612b3a$var$darken);
var $e728873b0e612b3a$export$4b073707ff63303 = $e728873b0e612b3a$var$curriedDarken;
/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */ function $e728873b0e612b3a$var$desaturate(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $e728873b0e612b3a$export$1286688e1b3fde9c(color);
    return $e728873b0e612b3a$export$42fe740cdf79b2df((0, $if2ZQ.default)({}, hslColor, {
        saturation: $e728873b0e612b3a$var$guard(0, 1, hslColor.saturation - parseFloat(amount))
    }));
}
// prettier-ignore
var $e728873b0e612b3a$var$curriedDesaturate = $e728873b0e612b3a$var$curry /* ::<number | string, string, string> */ ($e728873b0e612b3a$var$desaturate);
var $e728873b0e612b3a$export$fb75607d98509d9 = $e728873b0e612b3a$var$curriedDesaturate;
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */ function $e728873b0e612b3a$export$c852d90bf7403b62(color) {
    if (color === 'transparent') return 0;
    var rgbColor = $e728873b0e612b3a$export$2f48baff6995707a(color);
    var _Object$keys$map = Object.keys(rgbColor).map(function(key) {
        var channel = rgbColor[key] / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }), r = _Object$keys$map[0], g = _Object$keys$map[1], b = _Object$keys$map[2];
    return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}
/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 *
 * @example
 * const contrastRatio = getContrast('#444', '#fff');
 */ function $e728873b0e612b3a$export$850ce485a60d103b(color1, color2) {
    var luminance1 = $e728873b0e612b3a$export$c852d90bf7403b62(color1);
    var luminance2 = $e728873b0e612b3a$export$c852d90bf7403b62(color2);
    return parseFloat((luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05)).toFixed(2));
}
/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $e728873b0e612b3a$export$6f416a6db2dfcd5c(color) {
    if (color === 'transparent') return color;
    return $e728873b0e612b3a$export$42fe740cdf79b2df((0, $if2ZQ.default)({}, $e728873b0e612b3a$export$1286688e1b3fde9c(color), {
        saturation: 0
    }));
}
/**
 * Converts a HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $e728873b0e612b3a$export$97fc773b219a4ae(color) {
    if (typeof color === 'object' && typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number') {
        if (color.alpha && typeof color.alpha === 'number') return $e728873b0e612b3a$export$810b04175080204c({
            hue: color.hue,
            saturation: color.saturation,
            lightness: color.lightness,
            alpha: color.alpha
        });
        return $e728873b0e612b3a$export$8f4a7c0bb78e6ea8({
            hue: color.hue,
            saturation: color.saturation,
            lightness: color.lightness
        });
    }
    throw new $e728873b0e612b3a$var$PolishedError(45);
}
/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */ function $e728873b0e612b3a$export$6897c284b6f9f4dc(color) {
    if (color === 'transparent') return color;
    // parse color string to rgb
    var value = $e728873b0e612b3a$export$2f48baff6995707a(color);
    return $e728873b0e612b3a$export$42fe740cdf79b2df((0, $if2ZQ.default)({}, value, {
        red: 255 - value.red,
        green: 255 - value.green,
        blue: 255 - value.blue
    }));
}
/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */ function $e728873b0e612b3a$var$lighten(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $e728873b0e612b3a$export$1286688e1b3fde9c(color);
    return $e728873b0e612b3a$export$42fe740cdf79b2df((0, $if2ZQ.default)({}, hslColor, {
        lightness: $e728873b0e612b3a$var$guard(0, 1, hslColor.lightness + parseFloat(amount))
    }));
}
// prettier-ignore
var $e728873b0e612b3a$var$curriedLighten = $e728873b0e612b3a$var$curry /* ::<number | string, string, string> */ ($e728873b0e612b3a$var$lighten);
var $e728873b0e612b3a$export$c0816ed86df316af = $e728873b0e612b3a$var$curriedLighten;
/**
 * Determines which contrast guidelines have been met for two colors.
 * Based on the [contrast calculations recommended by W3](https://www.w3.org/WAI/WCAG21/Understanding/contrast-enhanced.html).
 *
 * @example
 * const scores = meetsContrastGuidelines('#444', '#fff');
 */ function $e728873b0e612b3a$export$bc0d548020bc5a2(color1, color2) {
    var contrastRatio = $e728873b0e612b3a$export$850ce485a60d103b(color1, color2);
    return {
        AA: contrastRatio >= 4.5,
        AALarge: contrastRatio >= 3,
        AAA: contrastRatio >= 7,
        AAALarge: contrastRatio >= 4.5
    };
}
/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function $e728873b0e612b3a$var$mix(weight, color, otherColor) {
    if (color === 'transparent') return otherColor;
    if (otherColor === 'transparent') return color;
    if (weight === 0) return otherColor;
    var parsedColor1 = $e728873b0e612b3a$export$2f48baff6995707a(color);
    var color1 = (0, $if2ZQ.default)({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
    });
    var parsedColor2 = $e728873b0e612b3a$export$2f48baff6995707a(otherColor);
    var color2 = (0, $if2ZQ.default)({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
    });
    // The formula is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
    var alphaDelta = color1.alpha - color2.alpha;
    var x = parseFloat(weight) * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha * parseFloat(weight) + color2.alpha * (1 - parseFloat(weight))
    };
    return $e728873b0e612b3a$export$4e46ac54fc82cf3b(mixedColor);
}
// prettier-ignore
var $e728873b0e612b3a$var$curriedMix = $e728873b0e612b3a$var$curry /* ::<number | string, string, string, string> */ ($e728873b0e612b3a$var$mix);
var $e728873b0e612b3a$export$2c9e8a9632a706b2 = $e728873b0e612b3a$var$curriedMix;
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */ function $e728873b0e612b3a$var$opacify(amount, color) {
    if (color === 'transparent') return color;
    var parsedColor = $e728873b0e612b3a$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $if2ZQ.default)({}, parsedColor, {
        alpha: $e728873b0e612b3a$var$guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
    });
    return $e728873b0e612b3a$export$4e46ac54fc82cf3b(colorWithAlpha);
}
// prettier-ignore
var $e728873b0e612b3a$var$curriedOpacify = $e728873b0e612b3a$var$curry /* ::<number | string, string, string> */ ($e728873b0e612b3a$var$opacify);
var $e728873b0e612b3a$export$f4f50e3877dd0530 = $e728873b0e612b3a$var$curriedOpacify;
var $e728873b0e612b3a$var$defaultReturnIfLightColor = '#000';
var $e728873b0e612b3a$var$defaultReturnIfDarkColor = '#fff';
/**
 * Returns black or white (or optional passed colors) for best
 * contrast depending on the luminosity of the given color.
 * When passing custom return colors, strict mode ensures that the
 * return color always meets or exceeds WCAG level AA or greater. If this test
 * fails, the default return color (black or white) is returned in place of the
 * custom return color. You can optionally turn off strict mode.
 *
 * Follows [W3C specs for readability](https://www.w3.org/TR/WCAG20-TECHS/G18.html).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('black', '#001', '#ff8'),
 *   color: readableColor('white', '#001', '#ff8'),
 *   color: readableColor('red', '#333', '#ddd', true)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('black', '#001', '#ff8')};
 *   color: ${readableColor('white', '#001', '#ff8')};
 *   color: ${readableColor('red', '#333', '#ddd', true)};
 * `
 *
 * // CSS in JS Output
 * element {
 *   color: "#fff";
 *   color: "#ff8";
 *   color: "#001";
 *   color: "#000";
 * }
 */ function $e728873b0e612b3a$export$61654c1796c44811(color, returnIfLightColor, returnIfDarkColor, strict) {
    if (returnIfLightColor === void 0) returnIfLightColor = $e728873b0e612b3a$var$defaultReturnIfLightColor;
    if (returnIfDarkColor === void 0) returnIfDarkColor = $e728873b0e612b3a$var$defaultReturnIfDarkColor;
    if (strict === void 0) strict = true;
    var isColorLight = $e728873b0e612b3a$export$c852d90bf7403b62(color) > 0.179;
    var preferredReturnColor = isColorLight ? returnIfLightColor : returnIfDarkColor;
    if (!strict || $e728873b0e612b3a$export$850ce485a60d103b(color, preferredReturnColor) >= 4.5) return preferredReturnColor;
    return isColorLight ? $e728873b0e612b3a$var$defaultReturnIfLightColor : $e728873b0e612b3a$var$defaultReturnIfDarkColor;
}
/**
 * Converts a RgbColor or RgbaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb` or `rgba`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100 }),
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 * }
 */ function $e728873b0e612b3a$export$34b0917fcca19deb(color) {
    if (typeof color === 'object' && typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number') {
        if (typeof color.alpha === 'number') return $e728873b0e612b3a$export$4e46ac54fc82cf3b({
            red: color.red,
            green: color.green,
            blue: color.blue,
            alpha: color.alpha
        });
        return $e728873b0e612b3a$export$8972dc0e6ad9238f({
            red: color.red,
            green: color.green,
            blue: color.blue
        });
    }
    throw new $e728873b0e612b3a$var$PolishedError(46);
}
/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */ function $e728873b0e612b3a$var$saturate(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $e728873b0e612b3a$export$1286688e1b3fde9c(color);
    return $e728873b0e612b3a$export$42fe740cdf79b2df((0, $if2ZQ.default)({}, hslColor, {
        saturation: $e728873b0e612b3a$var$guard(0, 1, hslColor.saturation + parseFloat(amount))
    }));
}
// prettier-ignore
var $e728873b0e612b3a$var$curriedSaturate = $e728873b0e612b3a$var$curry /* ::<number | string, string, string> */ ($e728873b0e612b3a$var$saturate);
var $e728873b0e612b3a$export$5fcac96f5a87e3db = $e728873b0e612b3a$var$curriedSaturate;
/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */ function $e728873b0e612b3a$var$setHue(hue, color) {
    if (color === 'transparent') return color;
    return $e728873b0e612b3a$export$42fe740cdf79b2df((0, $if2ZQ.default)({}, $e728873b0e612b3a$export$1286688e1b3fde9c(color), {
        hue: parseFloat(hue)
    }));
}
// prettier-ignore
var $e728873b0e612b3a$var$curriedSetHue = $e728873b0e612b3a$var$curry /* ::<number | string, string, string> */ ($e728873b0e612b3a$var$setHue);
var $e728873b0e612b3a$export$3bf58ce3e497a846 = $e728873b0e612b3a$var$curriedSetHue;
/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */ function $e728873b0e612b3a$var$setLightness(lightness, color) {
    if (color === 'transparent') return color;
    return $e728873b0e612b3a$export$42fe740cdf79b2df((0, $if2ZQ.default)({}, $e728873b0e612b3a$export$1286688e1b3fde9c(color), {
        lightness: parseFloat(lightness)
    }));
}
// prettier-ignore
var $e728873b0e612b3a$var$curriedSetLightness = $e728873b0e612b3a$var$curry /* ::<number | string, string, string> */ ($e728873b0e612b3a$var$setLightness);
var $e728873b0e612b3a$export$7ef5d725337b805d = $e728873b0e612b3a$var$curriedSetLightness;
/**
 * Sets the saturation of a color to the provided value. The saturation range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */ function $e728873b0e612b3a$var$setSaturation(saturation, color) {
    if (color === 'transparent') return color;
    return $e728873b0e612b3a$export$42fe740cdf79b2df((0, $if2ZQ.default)({}, $e728873b0e612b3a$export$1286688e1b3fde9c(color), {
        saturation: parseFloat(saturation)
    }));
}
// prettier-ignore
var $e728873b0e612b3a$var$curriedSetSaturation = $e728873b0e612b3a$var$curry /* ::<number | string, string, string> */ ($e728873b0e612b3a$var$setSaturation);
var $e728873b0e612b3a$export$b40fe421ea7a4f7e = $e728873b0e612b3a$var$curriedSetSaturation;
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */ function $e728873b0e612b3a$var$shade(percentage, color) {
    if (color === 'transparent') return color;
    return $e728873b0e612b3a$export$2c9e8a9632a706b2(parseFloat(percentage), 'rgb(0, 0, 0)', color);
}
// prettier-ignore
var $e728873b0e612b3a$var$curriedShade = $e728873b0e612b3a$var$curry /* ::<number | string, string, string> */ ($e728873b0e612b3a$var$shade);
var $e728873b0e612b3a$export$3e32adda0df4ef5d = $e728873b0e612b3a$var$curriedShade;
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function $e728873b0e612b3a$var$tint(percentage, color) {
    if (color === 'transparent') return color;
    return $e728873b0e612b3a$export$2c9e8a9632a706b2(parseFloat(percentage), 'rgb(255, 255, 255)', color);
}
// prettier-ignore
var $e728873b0e612b3a$var$curriedTint = $e728873b0e612b3a$var$curry /* ::<number | string, string, string> */ ($e728873b0e612b3a$var$tint);
var $e728873b0e612b3a$export$fc176dd65a27d98b = $e728873b0e612b3a$var$curriedTint;
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff'),
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')};
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */ function $e728873b0e612b3a$var$transparentize(amount, color) {
    if (color === 'transparent') return color;
    var parsedColor = $e728873b0e612b3a$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $if2ZQ.default)({}, parsedColor, {
        alpha: $e728873b0e612b3a$var$guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
    });
    return $e728873b0e612b3a$export$4e46ac54fc82cf3b(colorWithAlpha);
}
// prettier-ignore
var $e728873b0e612b3a$var$curriedTransparentize = $e728873b0e612b3a$var$curry /* ::<number | string, string, string> */ ($e728873b0e612b3a$var$transparentize);
var $e728873b0e612b3a$export$d11da87e55cc498f = $e728873b0e612b3a$var$curriedTransparentize;
/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */ function $e728873b0e612b3a$export$ecad260a8a5fef4f() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    // Allow single or multiple animations passed
    var multiMode = Array.isArray(args[0]);
    if (!multiMode && args.length > 8) throw new $e728873b0e612b3a$var$PolishedError(64);
    var code = args.map(function(arg) {
        if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) throw new $e728873b0e612b3a$var$PolishedError(65);
        if (Array.isArray(arg) && arg.length > 8) throw new $e728873b0e612b3a$var$PolishedError(66);
        return Array.isArray(arg) ? arg.join(' ') : arg;
    }).join(', ');
    return {
        animation: code
    };
}
/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */ function $e728873b0e612b3a$export$c7de706fee81cfb4() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        backgroundImage: properties.join(', ')
    };
}
/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */ function $e728873b0e612b3a$export$d041fef2b78b7906() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        background: properties.join(', ')
    };
}
var $e728873b0e612b3a$var$sideMap = [
    'top',
    'right',
    'bottom',
    'left'
];
/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */ function $e728873b0e612b3a$export$1edee58a52776cd9(sideKeyword) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if (typeof sideKeyword === 'string' && $e728873b0e612b3a$var$sideMap.indexOf(sideKeyword) >= 0) {
        var _ref;
        return _ref = {}, _ref["border" + $e728873b0e612b3a$var$capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + $e728873b0e612b3a$var$capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + $e728873b0e612b3a$var$capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
    } else {
        values.unshift(sideKeyword);
        return {
            borderWidth: values[0],
            borderStyle: values[1],
            borderColor: values[2]
        };
    }
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */ function $e728873b0e612b3a$export$e7fb0694ba2404fc() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $e728873b0e612b3a$export$4fc00c04dd60af95.apply(void 0, [
        'borderColor'
    ].concat(values));
}
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */ function $e728873b0e612b3a$export$7a57f79000377ca2(side, radius) {
    var uppercaseSide = $e728873b0e612b3a$var$capitalizeString(side);
    if (!radius && radius !== 0) throw new $e728873b0e612b3a$var$PolishedError(62);
    if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
        var _ref;
        return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
    }
    if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
        var _ref2;
        return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
    }
    throw new $e728873b0e612b3a$var$PolishedError(63);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */ function $e728873b0e612b3a$export$4d0a7f76ad443516() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $e728873b0e612b3a$export$4fc00c04dd60af95.apply(void 0, [
        'borderStyle'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */ function $e728873b0e612b3a$export$12879c7697ed953d() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $e728873b0e612b3a$export$4fc00c04dd60af95.apply(void 0, [
        'borderWidth'
    ].concat(values));
}
function $e728873b0e612b3a$var$generateSelectors(template, state) {
    var stateSuffix = state ? ":" + state : '';
    return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */ function $e728873b0e612b3a$var$statefulSelectors(states, template, stateMap) {
    if (!template) throw new $e728873b0e612b3a$var$PolishedError(67);
    if (states.length === 0) return $e728873b0e612b3a$var$generateSelectors(template, null);
    var selectors = [];
    for(var i = 0; i < states.length; i += 1){
        if (stateMap && stateMap.indexOf(states[i]) < 0) throw new $e728873b0e612b3a$var$PolishedError(68);
        selectors.push($e728873b0e612b3a$var$generateSelectors(template, states[i]));
    }
    selectors = selectors.join(',');
    return selectors;
}
var $e728873b0e612b3a$var$stateMap$1 = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $e728873b0e612b3a$var$template$1(state) {
    return "button" + state + ",\n  input[type=\"button\"]" + state + ",\n  input[type=\"reset\"]" + state + ",\n  input[type=\"submit\"]" + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */ function $e728873b0e612b3a$export$bbea856fdb3e3c5f() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $e728873b0e612b3a$var$statefulSelectors(states, $e728873b0e612b3a$var$template$1, $e728873b0e612b3a$var$stateMap$1);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */ function $e728873b0e612b3a$export$7ede87f9b603dd3c() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $e728873b0e612b3a$export$4fc00c04dd60af95.apply(void 0, [
        'margin'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $e728873b0e612b3a$export$6f98e8eaf0be1996() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $e728873b0e612b3a$export$4fc00c04dd60af95.apply(void 0, [
        'padding'
    ].concat(values));
}
var $e728873b0e612b3a$var$positionMap = [
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky'
];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */ function $e728873b0e612b3a$export$5880b8b5730aff45(firstValue) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if ($e728873b0e612b3a$var$positionMap.indexOf(firstValue) >= 0 && firstValue) return (0, $if2ZQ.default)({}, $e728873b0e612b3a$export$4fc00c04dd60af95.apply(void 0, [
        ''
    ].concat(values)), {
        position: firstValue
    });
    else return $e728873b0e612b3a$export$4fc00c04dd60af95.apply(void 0, [
        '',
        firstValue
    ].concat(values));
}
/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */ function $e728873b0e612b3a$export$346677f925de839c(height, width) {
    if (width === void 0) width = height;
    return {
        height: height,
        width: width
    };
}
var $e728873b0e612b3a$var$stateMap = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $e728873b0e612b3a$var$template(state) {
    return "input[type=\"color\"]" + state + ",\n    input[type=\"date\"]" + state + ",\n    input[type=\"datetime\"]" + state + ",\n    input[type=\"datetime-local\"]" + state + ",\n    input[type=\"email\"]" + state + ",\n    input[type=\"month\"]" + state + ",\n    input[type=\"number\"]" + state + ",\n    input[type=\"password\"]" + state + ",\n    input[type=\"search\"]" + state + ",\n    input[type=\"tel\"]" + state + ",\n    input[type=\"text\"]" + state + ",\n    input[type=\"time\"]" + state + ",\n    input[type=\"url\"]" + state + ",\n    input[type=\"week\"]" + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */ function $e728873b0e612b3a$export$baad927ee93ccf9c() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $e728873b0e612b3a$var$statefulSelectors(states, $e728873b0e612b3a$var$template, $e728873b0e612b3a$var$stateMap);
}
/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same transition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */ function $e728873b0e612b3a$export$622eca585e740ed5() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    if (Array.isArray(properties[0]) && properties.length === 2) {
        var value = properties[1];
        if (typeof value !== 'string') throw new $e728873b0e612b3a$var$PolishedError(61);
        var transitionsString = properties[0].map(function(property) {
            return property + " " + value;
        }).join(', ');
        return {
            transition: transitionsString
        };
    } else return {
        transition: properties.join(', ')
    };
}


const $0b5632181df8e81c$var$GlobalStyles = (0, $8999e1d77b7e12d9$export$f0f03736edb61697)`

	${(0, $e728873b0e612b3a$export$a3295358bff77e)()}

	:root {
		--spinner-color: ${(props)=>props.theme.colors.primary};
		--spinner-size: 64px;
		--spinner-stroke: 3px;
		--header-height: 54px;
		--container-min-width: 860px;
		--container-max-width: 1180px;
		--grid-basis: 16px;
		--color-black: #071633;
		--color-body: var(--color-black);
		--form-control-trim: #B4B9C1;
	}

	body, input, textarea {
		color:var(--color-body);
		font-family:-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
		-webkit-font-smoothing:antialiased; -moz-osx-font-smoothing:grayscale; font-smoothing:antialiased; text-rendering:optimizeLegibility;
	}

	h1, h2, h3, h4, h5, h6 {
		margin:0;
	}

	img {
		display:block; max-width:100%; height:auto;
	}

	a {
		color:var(--color-blue); text-decoration:underline;
	}

	p {
		&:first-child {
			margin-top:0;
		}
		&:last-child {
			margin-bottom:0;
		}
	}
	.user-rich-text {
		line-height: 1.8;
		font-weight: 300;
		strong {
			font-weight: 600;
		}
	}

`;
var $0b5632181df8e81c$export$2e2bcd8739ae039 = $0b5632181df8e81c$var$GlobalStyles;



var $gRqVZ = parcelRequire("gRqVZ");

function $aed2108b74da4cc9$var$ScrollToTopOnRouteChange() {
    const { pathname: pathname } = (0, $372fcccf2bee01ac$export$45d76561a5302f2b)();
    (0, $gRqVZ.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, [
        pathname
    ]);
    return null;
}
var $aed2108b74da4cc9$export$2e2bcd8739ae039 = $aed2108b74da4cc9$var$ScrollToTopOnRouteChange;



var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");

var $k8Bfo = parcelRequire("k8Bfo");
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $f5736330f86ea3cd$export$c10d0b04eaa80a43(value) {
    return typeof value == 'object' && value !== null;
}


function $ed0196359bade4d2$export$f5708dca728d7177(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}


const $74c927dfe0cc0151$var$LineRegExp = /\r\n|[\n\r]/g;
function $74c927dfe0cc0151$export$e7fd20fad3cf4b5f(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll($74c927dfe0cc0151$var$LineRegExp)){
        typeof match.index === 'number' || (0, $ed0196359bade4d2$export$f5708dca728d7177)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}



function $785b39a9576b75ed$export$96a9681e539deed(location) {
    return $785b39a9576b75ed$export$867940333fd9f869(location.source, (0, $74c927dfe0cc0151$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $785b39a9576b75ed$export$867940333fd9f869(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = ''.padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $785b39a9576b75ed$var$printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    '|',
                    subLine
                ]),
            [
                '|',
                '^'.padStart(subLineColumnNum)
            ],
            [
                '|',
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + $785b39a9576b75ed$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            '|',
            '^'.padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function $785b39a9576b75ed$var$printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? ' ' + line : '')).join('\n');
}


function $77ddb4277ee2c5df$var$toNormalizedOptions(args) {
    const firstArg = args[0];
    if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
class $77ddb4277ee2c5df$export$92d6ed0888e7cb7f extends Error {
    /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */ constructor(message, ...rawArgs){
        var _this$nodes, _nodeLocations$, _ref;
        const { nodes: nodes, source: source, positions: positions, path: path, originalError: originalError, extensions: extensions } = $77ddb4277ee2c5df$var$toNormalizedOptions(rawArgs);
        super(message);
        this.name = 'GraphQLError';
        this.path = path !== null && path !== void 0 ? path : undefined;
        this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        this.nodes = $77ddb4277ee2c5df$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = $77ddb4277ee2c5df$var$undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node)=>node.loc).filter((loc)=>loc != null)); // Compute locations in the source for the given nodes/positions.
        this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, $74c927dfe0cc0151$export$e7fd20fad3cf4b5f)(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>(0, $74c927dfe0cc0151$export$e7fd20fad3cf4b5f)(loc.source, loc.start));
        const originalExtensions = (0, $f5736330f86ea3cd$export$c10d0b04eaa80a43)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, 'stack', {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, $77ddb4277ee2c5df$export$92d6ed0888e7cb7f);
        else Object.defineProperty(this, 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
    get [Symbol.toStringTag]() {
        return 'GraphQLError';
    }
    toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += '\n\n' + (0, $785b39a9576b75ed$export$96a9681e539deed)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += '\n\n' + (0, $785b39a9576b75ed$export$867940333fd9f869)(this.source, location);
        return output;
    }
    toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
}
function $77ddb4277ee2c5df$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $77ddb4277ee2c5df$export$55ee1551a3f962e6(error) {
    return error.toString();
}
function $77ddb4277ee2c5df$export$7b5b869ee98c16ab(error) {
    return error.toJSON();
}


function $c0317f961f9abb5f$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $77ddb4277ee2c5df$export$92d6ed0888e7cb7f)(`Syntax Error: ${description}`, {
        source: source,
        positions: [
            position
        ]
    });
}


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $d53ea9002ec4d7a4$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return 'Location';
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $d53ea9002ec4d7a4$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return 'Token';
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $d53ea9002ec4d7a4$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'description',
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'description',
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'description',
        'name',
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ],
    TypeCoordinate: [
        'name'
    ],
    MemberCoordinate: [
        'name',
        'memberName'
    ],
    ArgumentCoordinate: [
        'name',
        'fieldName',
        'argumentName'
    ],
    DirectiveCoordinate: [
        'name'
    ],
    DirectiveArgumentCoordinate: [
        'name',
        'argumentName'
    ]
};
const $d53ea9002ec4d7a4$var$kindValues = new Set(Object.keys($d53ea9002ec4d7a4$export$4fcd777a40ccf407));
function $d53ea9002ec4d7a4$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === 'string' && $d53ea9002ec4d7a4$var$kindValues.has(maybeKind);
}
/** Name */ var $d53ea9002ec4d7a4$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode['QUERY'] = 'query';
    OperationTypeNode['MUTATION'] = 'mutation';
    OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})($d53ea9002ec4d7a4$export$f58c50edb4aef9d4 || ($d53ea9002ec4d7a4$export$f58c50edb4aef9d4 = {}));


/**
 * The set of allowed directive location values.
 */ var $c26fc906c3a2fa45$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    DirectiveLocation['QUERY'] = 'QUERY';
    DirectiveLocation['MUTATION'] = 'MUTATION';
    DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
    DirectiveLocation['FIELD'] = 'FIELD';
    DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
    DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
    DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
    DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
    DirectiveLocation['SCHEMA'] = 'SCHEMA';
    DirectiveLocation['SCALAR'] = 'SCALAR';
    DirectiveLocation['OBJECT'] = 'OBJECT';
    DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
    DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
    DirectiveLocation['INTERFACE'] = 'INTERFACE';
    DirectiveLocation['UNION'] = 'UNION';
    DirectiveLocation['ENUM'] = 'ENUM';
    DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
    DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
    DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})($c26fc906c3a2fa45$export$b45ffd2948484c41 || ($c26fc906c3a2fa45$export$b45ffd2948484c41 = {}));
 /**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */ 

/**
 * The set of allowed kind values for AST nodes.
 */ var $324243985983b985$export$a84bdc57c5122798;
(function(Kind) {
    Kind['NAME'] = 'Name';
    Kind['DOCUMENT'] = 'Document';
    Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
    Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
    Kind['SELECTION_SET'] = 'SelectionSet';
    Kind['FIELD'] = 'Field';
    Kind['ARGUMENT'] = 'Argument';
    Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
    Kind['INLINE_FRAGMENT'] = 'InlineFragment';
    Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
    Kind['VARIABLE'] = 'Variable';
    Kind['INT'] = 'IntValue';
    Kind['FLOAT'] = 'FloatValue';
    Kind['STRING'] = 'StringValue';
    Kind['BOOLEAN'] = 'BooleanValue';
    Kind['NULL'] = 'NullValue';
    Kind['ENUM'] = 'EnumValue';
    Kind['LIST'] = 'ListValue';
    Kind['OBJECT'] = 'ObjectValue';
    Kind['OBJECT_FIELD'] = 'ObjectField';
    Kind['DIRECTIVE'] = 'Directive';
    Kind['NAMED_TYPE'] = 'NamedType';
    Kind['LIST_TYPE'] = 'ListType';
    Kind['NON_NULL_TYPE'] = 'NonNullType';
    Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
    Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
    Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
    Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
    Kind['FIELD_DEFINITION'] = 'FieldDefinition';
    Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
    Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
    Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
    Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
    Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
    Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
    Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
    Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
    Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
    Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
    Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
    Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
    Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
    Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
    Kind['TYPE_COORDINATE'] = 'TypeCoordinate';
    Kind['MEMBER_COORDINATE'] = 'MemberCoordinate';
    Kind['ARGUMENT_COORDINATE'] = 'ArgumentCoordinate';
    Kind['DIRECTIVE_COORDINATE'] = 'DirectiveCoordinate';
    Kind['DIRECTIVE_ARGUMENT_COORDINATE'] = 'DirectiveArgumentCoordinate';
})($324243985983b985$export$a84bdc57c5122798 || ($324243985983b985$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 



/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $426cf8d696fae70c$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $426cf8d696fae70c$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $426cf8d696fae70c$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $426cf8d696fae70c$export$45a677ea7cb6d5c8(code) {
    return $426cf8d696fae70c$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $426cf8d696fae70c$export$d3f406ff46035894(code) {
    return $426cf8d696fae70c$export$79c5d5217943d6a7(code) || $426cf8d696fae70c$export$727d9dbc4fbb948f(code) || code === 0x005f;
}


function $cd2de6e6313a6d9b$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $cd2de6e6313a6d9b$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $cd2de6e6313a6d9b$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $426cf8d696fae70c$export$3c52dd84024ae72c)(str.charCodeAt(i)))++i;
    return i;
}
function $cd2de6e6313a6d9b$export$40862a63ef85e395(value) {
    if (value === '') return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $cd2de6e6313a6d9b$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $426cf8d696fae70c$export$3c52dd84024ae72c)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith('\\');
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ''; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $426cf8d696fae70c$export$3c52dd84024ae72c)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += '\n';
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += '\n';
    return '"""' + result + '"""';
}



/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $c39a1e3ed241ba43$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind['SOF'] = '<SOF>';
    TokenKind['EOF'] = '<EOF>';
    TokenKind['BANG'] = '!';
    TokenKind['DOLLAR'] = '$';
    TokenKind['AMP'] = '&';
    TokenKind['PAREN_L'] = '(';
    TokenKind['PAREN_R'] = ')';
    TokenKind['DOT'] = '.';
    TokenKind['SPREAD'] = '...';
    TokenKind['COLON'] = ':';
    TokenKind['EQUALS'] = '=';
    TokenKind['AT'] = '@';
    TokenKind['BRACKET_L'] = '[';
    TokenKind['BRACKET_R'] = ']';
    TokenKind['BRACE_L'] = '{';
    TokenKind['PIPE'] = '|';
    TokenKind['BRACE_R'] = '}';
    TokenKind['NAME'] = 'Name';
    TokenKind['INT'] = 'Int';
    TokenKind['FLOAT'] = 'Float';
    TokenKind['STRING'] = 'String';
    TokenKind['BLOCK_STRING'] = 'BlockString';
    TokenKind['COMMENT'] = 'Comment';
})($c39a1e3ed241ba43$export$8b9d26ab11394711 || ($c39a1e3ed241ba43$export$8b9d26ab11394711 = {}));
 /**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */ 

class $2186d94bd8518a07$export$6168dc8908a6c652 {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ constructor(source){
        const startOfFileToken = new (0, $d53ea9002ec4d7a4$export$50792b0e93539fde)((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    get [Symbol.toStringTag]() {
        return 'Lexer';
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = $2186d94bd8518a07$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).COMMENT);
        }
        return token;
    }
}
function $2186d94bd8518a07$export$59ac0f4da287406a(kind) {
    return kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BANG || kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).DOLLAR || kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).AMP || kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).PAREN_L || kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).PAREN_R || kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).DOT || kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).SPREAD || kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).COLON || kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).EQUALS || kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).AT || kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACKET_L || kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACKET_R || kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_L || kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).PIPE || kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function $2186d94bd8518a07$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function $2186d94bd8518a07$var$isSupplementaryCodePoint(body, location) {
    return $2186d94bd8518a07$var$isLeadingSurrogate(body.charCodeAt(location)) && $2186d94bd8518a07$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $2186d94bd8518a07$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $2186d94bd8518a07$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
function $2186d94bd8518a07$export$4b99857da92744e4(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    } // Unicode code point
    return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
function $2186d94bd8518a07$export$c255480b061bd6aa(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, $d53ea9002ec4d7a4$export$50792b0e93539fde)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $2186d94bd8518a07$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return $2186d94bd8518a07$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return $2186d94bd8518a07$export$c255480b061bd6aa(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BANG, position, position + 1);
            case 0x0024:
                // $
                return $2186d94bd8518a07$export$c255480b061bd6aa(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return $2186d94bd8518a07$export$c255480b061bd6aa(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).AMP, position, position + 1);
            case 0x0028:
                // (
                return $2186d94bd8518a07$export$c255480b061bd6aa(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return $2186d94bd8518a07$export$c255480b061bd6aa(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $2186d94bd8518a07$export$c255480b061bd6aa(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return $2186d94bd8518a07$export$c255480b061bd6aa(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).COLON, position, position + 1);
            case 0x003d:
                // =
                return $2186d94bd8518a07$export$c255480b061bd6aa(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return $2186d94bd8518a07$export$c255480b061bd6aa(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).AT, position, position + 1);
            case 0x005b:
                // [
                return $2186d94bd8518a07$export$c255480b061bd6aa(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return $2186d94bd8518a07$export$c255480b061bd6aa(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return $2186d94bd8518a07$export$c255480b061bd6aa(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return $2186d94bd8518a07$export$c255480b061bd6aa(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).PIPE, position, position + 1);
            case 0x007d:
                // }
                return $2186d94bd8518a07$export$c255480b061bd6aa(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $2186d94bd8518a07$var$readBlockString(lexer, position);
                return $2186d94bd8518a07$var$readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, $426cf8d696fae70c$export$727d9dbc4fbb948f)(code) || code === 0x002d) return $2186d94bd8518a07$var$readNumber(lexer, position, code);
         // Name
        if ((0, $426cf8d696fae70c$export$45a677ea7cb6d5c8)(code)) return $2186d94bd8518a07$export$ccff49e992952c96(lexer, position);
        throw (0, $c0317f961f9abb5f$export$bbee0c6176c019d4)(lexer.source, position, code === 0x0027 ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?' : $2186d94bd8518a07$var$isUnicodeScalarValue(code) || $2186d94bd8518a07$var$isSupplementaryCodePoint(body, position) ? `Unexpected character: ${$2186d94bd8518a07$export$4b99857da92744e4(lexer, position)}.` : `Invalid character: ${$2186d94bd8518a07$export$4b99857da92744e4(lexer, position)}.`);
    }
    return $2186d94bd8518a07$export$c255480b061bd6aa(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function $2186d94bd8518a07$var$readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($2186d94bd8518a07$var$isUnicodeScalarValue(code)) ++position;
        else if ($2186d94bd8518a07$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $2186d94bd8518a07$export$c255480b061bd6aa(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function $2186d94bd8518a07$var$readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $426cf8d696fae70c$export$727d9dbc4fbb948f)(code)) throw (0, $c0317f961f9abb5f$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, unexpected digit after 0: ${$2186d94bd8518a07$export$4b99857da92744e4(lexer, position)}.`);
    } else {
        position = $2186d94bd8518a07$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $2186d94bd8518a07$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $2186d94bd8518a07$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $426cf8d696fae70c$export$45a677ea7cb6d5c8)(code)) throw (0, $c0317f961f9abb5f$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, expected digit but got: ${$2186d94bd8518a07$export$4b99857da92744e4(lexer, position)}.`);
    return $2186d94bd8518a07$export$c255480b061bd6aa(lexer, isFloat ? (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).FLOAT : (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function $2186d94bd8518a07$var$readDigits(lexer, start, firstCode) {
    if (!(0, $426cf8d696fae70c$export$727d9dbc4fbb948f)(firstCode)) throw (0, $c0317f961f9abb5f$export$bbee0c6176c019d4)(lexer.source, start, `Invalid number, expected digit but got: ${$2186d94bd8518a07$export$4b99857da92744e4(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, $426cf8d696fae70c$export$727d9dbc4fbb948f)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function $2186d94bd8518a07$var$readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = '';
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $2186d94bd8518a07$export$c255480b061bd6aa(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $2186d94bd8518a07$var$readEscapedUnicodeVariableWidth(lexer, position) : $2186d94bd8518a07$var$readEscapedUnicodeFixedWidth(lexer, position) : $2186d94bd8518a07$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($2186d94bd8518a07$var$isUnicodeScalarValue(code)) ++position;
        else if ($2186d94bd8518a07$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $c0317f961f9abb5f$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$2186d94bd8518a07$export$4b99857da92744e4(lexer, position)}.`);
    }
    throw (0, $c0317f961f9abb5f$export$bbee0c6176c019d4)(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.
function $2186d94bd8518a07$var$readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$2186d94bd8518a07$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | $2186d94bd8518a07$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $c0317f961f9abb5f$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function $2186d94bd8518a07$var$readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = $2186d94bd8518a07$var$read16BitHexCode(body, position + 2);
    if ($2186d94bd8518a07$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($2186d94bd8518a07$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = $2186d94bd8518a07$var$read16BitHexCode(body, position + 8);
            if ($2186d94bd8518a07$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $c0317f961f9abb5f$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function $2186d94bd8518a07$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $2186d94bd8518a07$var$readHexDigit(body.charCodeAt(position)) << 12 | $2186d94bd8518a07$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $2186d94bd8518a07$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $2186d94bd8518a07$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function $2186d94bd8518a07$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function $2186d94bd8518a07$var$readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '\u0022',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: '\u005c',
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: '\u002f',
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: '\u0008',
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: '\u000c',
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: '\u000a',
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: '\u000d',
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: '\u0009',
                size: 2
            };
    }
    throw (0, $c0317f961f9abb5f$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function $2186d94bd8518a07$var$readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = '';
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = $2186d94bd8518a07$export$c255480b061bd6aa(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, (0, $cd2de6e6313a6d9b$export$d5ee19b441e8d2ae)(blockLines).join('\n'));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = '';
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if ($2186d94bd8518a07$var$isUnicodeScalarValue(code)) ++position;
        else if ($2186d94bd8518a07$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $c0317f961f9abb5f$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$2186d94bd8518a07$export$4b99857da92744e4(lexer, position)}.`);
    }
    throw (0, $c0317f961f9abb5f$export$bbee0c6176c019d4)(lexer.source, position, 'Unterminated string.');
}
function $2186d94bd8518a07$export$ccff49e992952c96(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, $426cf8d696fae70c$export$d3f406ff46035894)(code)) ++position;
        else break;
    }
    return $2186d94bd8518a07$export$c255480b061bd6aa(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).NAME, start, position, body.slice(start, position));
}







class $1461e84dafe37d24$export$1b46278b6a12726b {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   * Since a schema coordinate may not contain newline, this value is always 1.
   */ line = 1;
    /**
   * The character offset at which the current line begins.
   * Since a schema coordinate may not contain newline, this value is always 0.
   */ lineStart = 0;
    constructor(source){
        const startOfFileToken = new (0, $d53ea9002ec4d7a4$export$50792b0e93539fde)((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
    }
    get [Symbol.toStringTag]() {
        return 'SchemaCoordinateLexer';
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the current Lexer token.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).EOF) {
            // Read the next token and form a link in the token linked-list.
            const nextToken = $1461e84dafe37d24$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
            token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
            nextToken.prev = token;
            token = nextToken;
        }
        return token;
    }
}
/**
 * Gets the next token from the source starting at the given position.
 */ function $1461e84dafe37d24$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    const position = start;
    if (position < bodyLength) {
        const code = body.charCodeAt(position);
        switch(code){
            case 0x002e:
                // .
                return (0, $2186d94bd8518a07$export$c255480b061bd6aa)(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).DOT, position, position + 1);
            case 0x0028:
                // (
                return (0, $2186d94bd8518a07$export$c255480b061bd6aa)(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return (0, $2186d94bd8518a07$export$c255480b061bd6aa)(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).PAREN_R, position, position + 1);
            case 0x003a:
                // :
                return (0, $2186d94bd8518a07$export$c255480b061bd6aa)(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).COLON, position, position + 1);
            case 0x0040:
                // @
                return (0, $2186d94bd8518a07$export$c255480b061bd6aa)(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).AT, position, position + 1);
        } // Name
        if ((0, $426cf8d696fae70c$export$45a677ea7cb6d5c8)(code)) return (0, $2186d94bd8518a07$export$ccff49e992952c96)(lexer, position);
        throw (0, $c0317f961f9abb5f$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character: ${(0, $2186d94bd8518a07$export$4b99857da92744e4)(lexer, position)}.`);
    }
    return (0, $2186d94bd8518a07$export$c255480b061bd6aa)(lexer, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).EOF, bodyLength, bodyLength);
}


function $c4a46104edabf5e8$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


const $db53774dc0ce903e$var$MAX_ARRAY_LENGTH = 10;
const $db53774dc0ce903e$var$MAX_RECURSIVE_DEPTH = 2;
function $db53774dc0ce903e$export$9dec5d1b3b6a130d(value) {
    return $db53774dc0ce903e$var$formatValue(value, []);
}
function $db53774dc0ce903e$var$formatValue(value, seenValues) {
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? `[function ${value.name}]` : '[function]';
        case 'object':
            return $db53774dc0ce903e$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $db53774dc0ce903e$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return 'null';
    if (previouslySeenValues.includes(value)) return '[Circular]';
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($db53774dc0ce903e$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === 'string' ? jsonValue : $db53774dc0ce903e$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $db53774dc0ce903e$var$formatArray(value, seenValues);
    return $db53774dc0ce903e$var$formatObject(value, seenValues);
}
function $db53774dc0ce903e$var$isJSONable(value) {
    return typeof value.toJSON === 'function';
}
function $db53774dc0ce903e$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return '{}';
    if (seenValues.length > $db53774dc0ce903e$var$MAX_RECURSIVE_DEPTH) return '[' + $db53774dc0ce903e$var$getObjectTag(object) + ']';
    const properties = entries.map(([key, value])=>key + ': ' + $db53774dc0ce903e$var$formatValue(value, seenValues));
    return '{ ' + properties.join(', ') + ' }';
}
function $db53774dc0ce903e$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $db53774dc0ce903e$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    const len = Math.min($db53774dc0ce903e$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($db53774dc0ce903e$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return '[' + items.join(', ') + ']';
}
function $db53774dc0ce903e$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        const name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}



/* c8 ignore next 3 */ const $7ef2a9797dd7f4f9$var$isProduction = globalThis.process && // eslint-disable-next-line no-undef
true;
const $7ef2a9797dd7f4f9$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
$7ef2a9797dd7f4f9$var$isProduction ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === 'object' && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, $db53774dc0ce903e$export$9dec5d1b3b6a130d)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};


class $2dc1c46fedbb5771$export$1d2df86270c81ecb {
    constructor(body, name = 'GraphQL request', locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === 'string' || (0, $c4a46104edabf5e8$export$b6cb5906f04696c8)(false, `Body must be a string. Received: ${(0, $db53774dc0ce903e$export$9dec5d1b3b6a130d)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $c4a46104edabf5e8$export$b6cb5906f04696c8)(false, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $c4a46104edabf5e8$export$b6cb5906f04696c8)(false, 'column in locationOffset is 1-indexed and must be positive.');
    }
    get [Symbol.toStringTag]() {
        return 'Source';
    }
}
function $2dc1c46fedbb5771$export$75135ee9ed6e435b(source) {
    return (0, $7ef2a9797dd7f4f9$export$ca03416d6c9e029e)(source, $2dc1c46fedbb5771$export$1d2df86270c81ecb);
}



function $25ee39128c23f703$export$98e6a39c04603d36(source, options) {
    const parser = new $25ee39128c23f703$export$7acfa6ed01010e37(source, options);
    const document = parser.parseDocument();
    Object.defineProperty(document, 'tokenCount', {
        enumerable: false,
        value: parser.tokenCount
    });
    return document;
}
function $25ee39128c23f703$export$5303528d1070ff6f(source, options) {
    const parser = new $25ee39128c23f703$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).EOF);
    return value;
}
function $25ee39128c23f703$export$e14c466bd0916f7a(source, options) {
    const parser = new $25ee39128c23f703$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).EOF);
    return value;
}
function $25ee39128c23f703$export$28b8f402ccc88182(source, options) {
    const parser = new $25ee39128c23f703$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).EOF);
    return type;
}
function $25ee39128c23f703$export$87ea0c241caf7f8f(source) {
    const sourceObj = (0, $2dc1c46fedbb5771$export$75135ee9ed6e435b)(source) ? source : new (0, $2dc1c46fedbb5771$export$1d2df86270c81ecb)(source);
    const lexer = new (0, $1461e84dafe37d24$export$1b46278b6a12726b)(sourceObj);
    const parser = new $25ee39128c23f703$export$7acfa6ed01010e37(source, {
        lexer: lexer
    });
    parser.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).SOF);
    const coordinate = parser.parseSchemaCoordinate();
    parser.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).EOF);
    return coordinate;
}
class $25ee39128c23f703$export$7acfa6ed01010e37 {
    constructor(source, options = {}){
        const { lexer: lexer, ..._options } = options;
        if (lexer) this._lexer = lexer;
        else {
            const sourceObj = (0, $2dc1c46fedbb5771$export$75135ee9ed6e435b)(source) ? source : new (0, $2dc1c46fedbb5771$export$1d2df86270c81ecb)(source);
            this._lexer = new (0, $2186d94bd8518a07$export$6168dc8908a6c652)(sourceObj);
        }
        this._options = _options;
        this._tokenCounter = 0;
    }
    get tokenCount() {
        return this._tokenCounter;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ parseName() {
        const token = this.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).NAME);
        return this.node(token, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).NAME,
            value: token.value
        });
    }
    /**
   * Document : Definition+
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ parseDefinition() {
        if (this.peek((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
         // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (hasDescription && keywordToken.kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_L) throw (0, $c0317f961f9abb5f$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, 'Unexpected description, descriptions are not supported on shorthand queries.');
        if (keywordToken.kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).NAME) {
            switch(keywordToken.value){
                case 'schema':
                    return this.parseSchemaDefinition();
                case 'scalar':
                    return this.parseScalarTypeDefinition();
                case 'type':
                    return this.parseObjectTypeDefinition();
                case 'interface':
                    return this.parseInterfaceTypeDefinition();
                case 'union':
                    return this.parseUnionTypeDefinition();
                case 'enum':
                    return this.parseEnumTypeDefinition();
                case 'input':
                    return this.parseInputObjectTypeDefinition();
                case 'directive':
                    return this.parseDirectiveDefinition();
            }
            switch(keywordToken.value){
                case 'query':
                case 'mutation':
                case 'subscription':
                    return this.parseOperationDefinition();
                case 'fragment':
                    return this.parseFragmentDefinition();
            }
            if (hasDescription) throw (0, $c0317f961f9abb5f$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, 'Unexpected description, only GraphQL definitions support descriptions.');
            switch(keywordToken.value){
                case 'extend':
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_L)) return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: (0, $d53ea9002ec4d7a4$export$f58c50edb4aef9d4).QUERY,
            description: undefined,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const description = this.parseDescription();
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            description: description,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   */ parseOperationType() {
        const operationToken = this.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case 'query':
                return (0, $d53ea9002ec4d7a4$export$f58c50edb4aef9d4).QUERY;
            case 'mutation':
                return (0, $d53ea9002ec4d7a4$export$f58c50edb4aef9d4).MUTATION;
            case 'subscription':
                return (0, $d53ea9002ec4d7a4$export$f58c50edb4aef9d4).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ parseVariableDefinitions() {
        return this.optionalMany((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            description: this.parseDescription(),
            variable: this.parseVariable(),
            type: (this.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).DOLLAR);
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ parseSelection() {
        return this.peek((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).PAREN_L, item, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * Argument[Const] : Name : Value[?Const]
   */ parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).NAME)) return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            description: description,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            description: description,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   */ parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    }
    /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $324243985983b985$export$a84bdc57c5122798).INT,
                    value: token.value
                });
            case (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $324243985983b985$export$a84bdc57c5122798).FLOAT,
                    value: token.value
                });
            case (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).STRING:
            case (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).NAME:
                this.advanceLexer();
                switch(token.value){
                    case 'true':
                        return this.node(token, {
                            kind: (0, $324243985983b985$export$a84bdc57c5122798).BOOLEAN,
                            value: true
                        });
                    case 'false':
                        return this.node(token, {
                            kind: (0, $324243985983b985$export$a84bdc57c5122798).BOOLEAN,
                            value: false
                        });
                    case 'null':
                        return this.node(token, {
                            kind: (0, $324243985983b985$export$a84bdc57c5122798).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, $324243985983b985$export$a84bdc57c5122798).ENUM,
                            value: token.value
                        });
                }
            case (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).DOLLAR:
                if (isConst) {
                    this.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).DOLLAR);
                    if (this._lexer.token.kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, $c0317f961f9abb5f$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BLOCK_STRING
        });
    }
    /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).LIST,
            values: this.any((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACKET_L, item, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACKET_R)
        });
    }
    /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */ parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_L, item, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * ObjectField[Const] : Name : Value[?Const]
   */ parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    /**
   * Directives[Const] : Directive[?Const]+
   */ parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */ parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).AT);
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACKET_R);
            type = this.node(start, {
                kind: (0, $324243985983b985$export$a84bdc57c5122798).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BANG)) return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type
        });
        return type;
    }
    /**
   * NamedType : Name
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName()
        });
    }
    peekDescription() {
        return this.peek((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).STRING) || this.peek((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('schema');
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_R);
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('scalar');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('type');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword('implements') ? this.delimitedMany((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ parseFieldsDefinition() {
        return this.optionalMany((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ parseArgumentDefs() {
        return this.optionalMany((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('interface');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('union');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('enum');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseEnumValueName() {
        if (this._lexer.token.value === 'true' || this._lexer.token.value === 'false' || this._lexer.token.value === 'null') throw (0, $c0317f961f9abb5f$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, `${$25ee39128c23f703$var$getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('input');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, $c26fc906c3a2fa45$export$b45ffd2948484c41), name.value)) return name;
        throw this.unexpected(start);
    }
    /**
   * SchemaCoordinate :
   *   - Name
   *   - Name . Name
   *   - Name . Name ( Name : )
   *   - \@ Name
   *   - \@ Name ( Name : )
   */ parseSchemaCoordinate() {
        const start = this._lexer.token;
        const ofDirective = this.expectOptionalToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).AT);
        const name = this.parseName();
        let memberName;
        if (!ofDirective && this.expectOptionalToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).DOT)) memberName = this.parseName();
        let argumentName;
        if ((ofDirective || memberName) && this.expectOptionalToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).PAREN_L)) {
            argumentName = this.parseName();
            this.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).COLON);
            this.expectToken((0, $c39a1e3ed241ba43$export$8b9d26ab11394711).PAREN_R);
        }
        if (ofDirective) {
            if (argumentName) return this.node(start, {
                kind: (0, $324243985983b985$export$a84bdc57c5122798).DIRECTIVE_ARGUMENT_COORDINATE,
                name: name,
                argumentName: argumentName
            });
            return this.node(start, {
                kind: (0, $324243985983b985$export$a84bdc57c5122798).DIRECTIVE_COORDINATE,
                name: name
            });
        } else if (memberName) {
            if (argumentName) return this.node(start, {
                kind: (0, $324243985983b985$export$a84bdc57c5122798).ARGUMENT_COORDINATE,
                name: name,
                fieldName: memberName,
                argumentName: argumentName
            });
            return this.node(start, {
                kind: (0, $324243985983b985$export$a84bdc57c5122798).MEMBER_COORDINATE,
                name: name,
                memberName: memberName
            });
        }
        return this.node(start, {
            kind: (0, $324243985983b985$export$a84bdc57c5122798).TYPE_COORDINATE,
            name: name
        });
    }
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, $d53ea9002ec4d7a4$export$18a2be9195644f38)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, $c0317f961f9abb5f$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected ${$25ee39128c23f703$var$getTokenKindDesc(kind)}, found ${$25ee39128c23f703$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).NAME && token.value === value) this.advanceLexer();
        else throw (0, $c0317f961f9abb5f$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected "${value}", found ${$25ee39128c23f703$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ unexpected(atToken) {
        const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $c0317f961f9abb5f$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected ${$25ee39128c23f703$var$getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens: maxTokens } = this._options;
        const token = this._lexer.advance();
        if (token.kind !== (0, $c39a1e3ed241ba43$export$8b9d26ab11394711).EOF) {
            ++this._tokenCounter;
            if (maxTokens !== undefined && this._tokenCounter > maxTokens) throw (0, $c0317f961f9abb5f$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 */ function $25ee39128c23f703$var$getTokenDesc(token) {
    const value = token.value;
    return $25ee39128c23f703$var$getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $25ee39128c23f703$var$getTokenKindDesc(kind) {
    return (0, $2186d94bd8518a07$export$59ac0f4da287406a)(kind) ? `"${kind}"` : kind;
}


var $91606a2807685cb4$var$docCache = new Map();
var $91606a2807685cb4$var$fragmentSourceMap = new Map();
var $91606a2807685cb4$var$printFragmentWarnings = true;
var $91606a2807685cb4$var$experimentalFragmentVariables = false;
function $91606a2807685cb4$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $91606a2807685cb4$var$cacheKeyFromLoc(loc) {
    return $91606a2807685cb4$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $91606a2807685cb4$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $91606a2807685cb4$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $91606a2807685cb4$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($91606a2807685cb4$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $91606a2807685cb4$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $k8Bfo.__assign)((0, $k8Bfo.__assign)({}, ast), {
        definitions: definitions
    });
}
function $91606a2807685cb4$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $91606a2807685cb4$var$parseDocument(source) {
    var cacheKey = $91606a2807685cb4$var$normalize(source);
    if (!$91606a2807685cb4$var$docCache.has(cacheKey)) {
        var parsed = (0, $25ee39128c23f703$export$98e6a39c04603d36)(source, {
            experimentalFragmentVariables: $91606a2807685cb4$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $91606a2807685cb4$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $91606a2807685cb4$var$docCache.set(cacheKey, $91606a2807685cb4$var$stripLoc($91606a2807685cb4$var$processFragments(parsed)));
    }
    return $91606a2807685cb4$var$docCache.get(cacheKey);
}
function $91606a2807685cb4$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $91606a2807685cb4$var$parseDocument(result);
}
function $91606a2807685cb4$export$657554ef4dc7ac2d() {
    $91606a2807685cb4$var$docCache.clear();
    $91606a2807685cb4$var$fragmentSourceMap.clear();
}
function $91606a2807685cb4$export$e4294e638636c6ab() {
    $91606a2807685cb4$var$printFragmentWarnings = false;
}
function $91606a2807685cb4$export$78cf889af350c840() {
    $91606a2807685cb4$var$experimentalFragmentVariables = true;
}
function $91606a2807685cb4$export$5290df9bbbd3cfa() {
    $91606a2807685cb4$var$experimentalFragmentVariables = false;
}
var $91606a2807685cb4$var$extras = {
    gql: $91606a2807685cb4$export$72e4926bf8358653,
    resetCaches: $91606a2807685cb4$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $91606a2807685cb4$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $91606a2807685cb4$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $91606a2807685cb4$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $91606a2807685cb4$var$extras.gql, gql_1.resetCaches = $91606a2807685cb4$var$extras.resetCaches, gql_1.disableFragmentWarnings = $91606a2807685cb4$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $91606a2807685cb4$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $91606a2807685cb4$var$extras.disableExperimentalFragmentVariables;
})($91606a2807685cb4$export$72e4926bf8358653 || ($91606a2807685cb4$export$72e4926bf8358653 = {}));
$91606a2807685cb4$export$72e4926bf8358653["default"] = $91606a2807685cb4$export$72e4926bf8358653;
var $91606a2807685cb4$export$2e2bcd8739ae039 = $91606a2807685cb4$export$72e4926bf8358653;


const $57d3755bf6de1db3$export$1aa5a89531b7670d = Symbol.for("apollo.skipToken");

const { toString: $f6c3c7d1e328abb5$var$toString, hasOwnProperty: $f6c3c7d1e328abb5$var$hasOwnProperty } = Object.prototype;
const $f6c3c7d1e328abb5$var$fnToStr = Function.prototype.toString;
const $f6c3c7d1e328abb5$var$previousComparisons = new Map();
function $f6c3c7d1e328abb5$export$411ce8e5a71e3069(a, b) {
    try {
        return $f6c3c7d1e328abb5$var$check(a, b);
    } finally{
        $f6c3c7d1e328abb5$var$previousComparisons.clear();
    }
}
var // Allow default imports as well.
$f6c3c7d1e328abb5$export$2e2bcd8739ae039 = $f6c3c7d1e328abb5$export$411ce8e5a71e3069;
function $f6c3c7d1e328abb5$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = $f6c3c7d1e328abb5$var$toString.call(a);
    const bTag = $f6c3c7d1e328abb5$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            {
                if ($f6c3c7d1e328abb5$var$previouslyCompared(a, b)) return true;
                const aKeys = $f6c3c7d1e328abb5$var$definedKeys(a);
                const bKeys = $f6c3c7d1e328abb5$var$definedKeys(b);
                // If `a` and `b` have a different number of enumerable keys, they
                // must be different.
                const keyCount = aKeys.length;
                if (keyCount !== bKeys.length) return false;
                // Now make sure they have the same keys.
                for(let k = 0; k < keyCount; ++k){
                    if (!$f6c3c7d1e328abb5$var$hasOwnProperty.call(b, aKeys[k])) return false;
                }
                // Finally, check deep equality of all child properties.
                for(let k = 0; k < keyCount; ++k){
                    const key = aKeys[k];
                    if (!$f6c3c7d1e328abb5$var$check(a[key], b[key])) return false;
                }
                return true;
            }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == `${b}`;
        case '[object Map]':
        case '[object Set]':
            {
                if (a.size !== b.size) return false;
                if ($f6c3c7d1e328abb5$var$previouslyCompared(a, b)) return true;
                const aIterator = a.entries();
                const isMap = aTag === '[object Map]';
                while(true){
                    const info = aIterator.next();
                    if (info.done) break;
                    // If a instanceof Set, aValue === aKey.
                    const [aKey, aValue] = info.value;
                    // So this works the same way for both Set and Map.
                    if (!b.has(aKey)) return false;
                    // However, we care about deep equality of values only when dealing
                    // with Map structures.
                    if (isMap && !$f6c3c7d1e328abb5$var$check(aValue, b.get(aKey))) return false;
                }
                return true;
            }
        case '[object Uint16Array]':
        case '[object Uint8Array]':
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]':
            {
                let len = a.byteLength;
                if (len === b.byteLength) {
                    while(len-- && a[len] === b[len]);
                }
                return len === -1;
            }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]':
            {
                const aCode = $f6c3c7d1e328abb5$var$fnToStr.call(a);
                if (aCode !== $f6c3c7d1e328abb5$var$fnToStr.call(b)) return false;
                // We consider non-native functions equal if they have the same code
                // (native functions require === because their code is censored).
                // Note that this behavior is not entirely sound, since !== function
                // objects with the same code can behave differently depending on
                // their closure scope. However, any function can behave differently
                // depending on the values of its input arguments (including this)
                // and its calling context (including its closure scope), even
                // though the function object is === to itself; and it is entirely
                // possible for functions that are not === to behave exactly the
                // same under all conceivable circumstances. Because none of these
                // factors are statically decidable in JavaScript, JS function
                // equality is not well-defined. This ambiguity allows us to
                // consider the best possible heuristic among various imperfect
                // options, and equating non-native functions that have the same
                // code has enormous practical benefits, such as when comparing
                // functions that are repeatedly passed as fresh function
                // expressions within objects that are otherwise deeply equal. Since
                // any function created from the same syntactic expression (in the
                // same code location) will always stringify to the same code
                // according to fnToStr.call, we can reasonably expect these
                // repeatedly passed function expressions to have the same code, and
                // thus behave "the same" (with all the caveats mentioned above),
                // even though the runtime function objects are !== to one another.
                return !$f6c3c7d1e328abb5$var$endsWith(aCode, $f6c3c7d1e328abb5$var$nativeCodeSuffix);
            }
    }
    // Otherwise the values are not equal.
    return false;
}
function $f6c3c7d1e328abb5$var$definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter($f6c3c7d1e328abb5$var$isDefinedKey, obj);
}
function $f6c3c7d1e328abb5$var$isDefinedKey(key) {
    return this[key] !== void 0;
}
const $f6c3c7d1e328abb5$var$nativeCodeSuffix = "{ [native code] }";
function $f6c3c7d1e328abb5$var$endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function $f6c3c7d1e328abb5$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = $f6c3c7d1e328abb5$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $f6c3c7d1e328abb5$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}



var $gRqVZ = parcelRequire("gRqVZ");
/**
 * The current status of a query’s execution in our system.
 */ var $28ed6ef232a84776$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    /**
     * The query has never been run before and the query is now currently running. A query will still
     * have this network status even if a partial data result was returned from the cache, but a
     * query was dispatched anyway.
     */ NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    /**
     * If `setVariables` was called and a query was fired because of that then the network status
     * will be `setVariables` until the result of that query comes back.
     */ NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    /**
     * Indicates that `fetchMore` was called on this query and that the query created is currently in
     * flight.
     */ NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    /**
     * Similar to the `setVariables` network status. It means that `refetch` was called on a query
     * and the refetch request is currently in flight.
     */ NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    /**
     * Indicates that a polling query is currently in flight. So for example if you are polling a
     * query every 10 seconds then the network status will switch to `poll` every 10 seconds whenever
     * a poll request has been sent but not resolved.
     */ NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    /**
     * No request is in flight for this query, and no errors happened. Everything is OK.
     */ NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    /**
     * No request is in flight for this query, but one or more errors were detected.
     */ NetworkStatus[NetworkStatus["error"] = 8] = "error";
    /**
     * Indicates that a `@defer` query has received at least the first chunk of
     * the result but the full result has not yet been fully streamed to the
     * client.
     */ NetworkStatus[NetworkStatus["streaming"] = 9] = "streaming";
})($28ed6ef232a84776$export$bd096ddbd246c79c || ($28ed6ef232a84776$export$bd096ddbd246c79c = {}));


const $e15192e15b3ad6c1$export$a866f231438cc228 = globalThis.__DEV__ === true;



/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/ function $e79cca4a6323426e$export$417207af72fad9c9(obj) {
    return obj !== null && typeof obj === "object";
}


function $21caca133e428193$export$7e32b29e1cb162e1(value) {
    const workSet = new Set([
        value
    ]);
    workSet.forEach((obj)=>{
        if ((0, $e79cca4a6323426e$export$417207af72fad9c9)(obj) && $21caca133e428193$var$shallowFreeze(obj) === obj) Object.getOwnPropertyNames(obj).forEach((name)=>{
            if ((0, $e79cca4a6323426e$export$417207af72fad9c9)(obj[name])) workSet.add(obj[name]);
        });
    });
    return value;
}
function $21caca133e428193$var$shallowFreeze(obj) {
    if ((0, $e15192e15b3ad6c1$export$a866f231438cc228) && !Object.isFrozen(obj)) try {
        Object.freeze(obj);
    } catch (e) {
        // Some types like Uint8Array and Node.js's Buffer cannot be frozen, but
        // they all throw a TypeError when you try, so we re-throw any exceptions
        // that are not TypeErrors, since that would be unexpected.
        if (e instanceof TypeError) return null;
        throw e;
    }
    return obj;
}


function $4f666ffbf7bc8e40$export$7f9c177735b71f18(obj) {
    if (0, $e15192e15b3ad6c1$export$a866f231438cc228) (0, $21caca133e428193$export$7e32b29e1cb162e1)(obj);
    return obj;
}

/**
* @internal
* Used to set `extensions` on the GraphQL result without exposing it
* unnecessarily. Only use internally!
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/ const $16b2c739aa564ddd$export$bcc403bd3c6120cd = Symbol.for("apollo.result.extensions");
const $16b2c739aa564ddd$export$e49e8c01e90ecf85 = Symbol.for("apollo.result.streamInfo");
const $16b2c739aa564ddd$export$868b9638ff105835 = Symbol.for("apollo.observableQuery.variablesUnknown");



function $480dec63d9529d01$export$f8b8b9ce72e9ccbf(thunk) {
    try {
        return thunk();
    } catch  {}
}


var $14cc75f186f11782$export$2e2bcd8739ae039 = // long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
(0, $480dec63d9529d01$export$f8b8b9ce72e9ccbf)(()=>globalThis) || (0, $480dec63d9529d01$export$f8b8b9ce72e9ccbf)(()=>window) || (0, $480dec63d9529d01$export$f8b8b9ce72e9ccbf)(()=>self) || (0, $480dec63d9529d01$export$f8b8b9ce72e9ccbf)(()=>$parcel$global) || // improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
(0, $480dec63d9529d01$export$f8b8b9ce72e9ccbf)(function() {
    return (0, $480dec63d9529d01$export$f8b8b9ce72e9ccbf).constructor("return this")();
});


const $10d1d4b25cee1a9f$export$83d89fbfd8236492 = "4.1.9";
const $10d1d4b25cee1a9f$export$3f8fe6489e95757d = "esm";


const $7bc48cc8dd979395$var$prefixCounts = new Map();
function $7bc48cc8dd979395$export$d0c8ec0fe1b18b70(prefix) {
    const count = $7bc48cc8dd979395$var$prefixCounts.get(prefix) || 1;
    $7bc48cc8dd979395$var$prefixCounts.set(prefix, count + 1);
    return `${prefix}:${count}:${Math.random().toString(36).slice(2)}`;
}


function $c038a06252f02d7b$export$f341b4883239463f(value, space = 0) {
    const undefId = (0, $7bc48cc8dd979395$export$d0c8ec0fe1b18b70)("stringifyForDisplay");
    return JSON.stringify(value, (_, value)=>{
        return value === void 0 ? undefId : value;
    }, space).split(JSON.stringify(undefId)).join("<undefined>");
}


const $aa2d7231b5e28112$var$genericMessage = "Invariant Violation";
class $aa2d7231b5e28112$export$cea12affaee22fe8 extends Error {
    constructor(message = $aa2d7231b5e28112$var$genericMessage){
        super(message);
        this.name = $aa2d7231b5e28112$var$genericMessage;
        Object.setPrototypeOf(this, $aa2d7231b5e28112$export$cea12affaee22fe8.prototype);
    }
}
const $aa2d7231b5e28112$var$verbosityLevels = [
    "debug",
    "log",
    "warn",
    "error",
    "silent"
];
let $aa2d7231b5e28112$var$verbosityLevel = $aa2d7231b5e28112$var$verbosityLevels.indexOf((0, $e15192e15b3ad6c1$export$a866f231438cc228) ? "log" : "silent");
function $aa2d7231b5e28112$export$f5708dca728d7177(condition, ...args) {
    if (!condition) throw $aa2d7231b5e28112$export$3991762405098ea(...args);
}
function $aa2d7231b5e28112$var$wrapConsoleMethod(name) {
    return function(message, ...args) {
        if ($aa2d7231b5e28112$var$verbosityLevels.indexOf(name) >= $aa2d7231b5e28112$var$verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            const method = console[name] || console.log;
            if (typeof message === "number") {
                const arg0 = message;
                message = $aa2d7231b5e28112$var$getHandledErrorMsg(arg0);
                if (!message) {
                    message = $aa2d7231b5e28112$var$getFallbackErrorMsg(arg0, args);
                    args = [];
                }
            }
            method(message, ...args);
        }
    };
}
$aa2d7231b5e28112$export$f5708dca728d7177.debug = $aa2d7231b5e28112$var$wrapConsoleMethod("debug");
$aa2d7231b5e28112$export$f5708dca728d7177.log = $aa2d7231b5e28112$var$wrapConsoleMethod("log");
$aa2d7231b5e28112$export$f5708dca728d7177.warn = $aa2d7231b5e28112$var$wrapConsoleMethod("warn");
$aa2d7231b5e28112$export$f5708dca728d7177.error = $aa2d7231b5e28112$var$wrapConsoleMethod("error");
function $aa2d7231b5e28112$export$a80e09f2cd325fb8(level) {
    const old = $aa2d7231b5e28112$var$verbosityLevels[$aa2d7231b5e28112$var$verbosityLevel];
    $aa2d7231b5e28112$var$verbosityLevel = Math.max(0, $aa2d7231b5e28112$var$verbosityLevels.indexOf(level));
    return old;
}
function $aa2d7231b5e28112$export$3991762405098ea(message, ...optionalParams) {
    return new $aa2d7231b5e28112$export$cea12affaee22fe8($aa2d7231b5e28112$var$getHandledErrorMsg(message, optionalParams) || $aa2d7231b5e28112$var$getFallbackErrorMsg(message, optionalParams));
}
const $aa2d7231b5e28112$export$b8ca975fa04efdf3 = Symbol.for("ApolloErrorMessageHandler_" + (0, $10d1d4b25cee1a9f$export$83d89fbfd8236492));
function $aa2d7231b5e28112$var$stringify(arg) {
    if (typeof arg == "string") return arg;
    try {
        return (0, $c038a06252f02d7b$export$f341b4883239463f)(arg, 2).slice(0, 1000);
    } catch  {
        return "<non-serializable>";
    }
}
function $aa2d7231b5e28112$var$getHandledErrorMsg(message, messageArgs = []) {
    if (!message) return;
    return (0, $14cc75f186f11782$export$2e2bcd8739ae039)[$aa2d7231b5e28112$export$b8ca975fa04efdf3] && (0, $14cc75f186f11782$export$2e2bcd8739ae039)[$aa2d7231b5e28112$export$b8ca975fa04efdf3](message, messageArgs.map($aa2d7231b5e28112$var$stringify));
}
function $aa2d7231b5e28112$var$getFallbackErrorMsg(message, messageArgs = []) {
    if (!message) return;
    if (typeof message === "string") return messageArgs.reduce((msg, arg)=>msg.replace(/%[sdfo]/, $aa2d7231b5e28112$var$stringify(arg)), message);
    return `An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#${encodeURIComponent(JSON.stringify({
        version: $10d1d4b25cee1a9f$export$83d89fbfd8236492,
        message: message,
        args: messageArgs.map($aa2d7231b5e28112$var$stringify)
    }))}`;
}



var $gRqVZ = parcelRequire("gRqVZ");
let $6513ca5a44de9748$var$Ctx;
function $6513ca5a44de9748$var$noop() {}
function $6513ca5a44de9748$export$3e6dc71f325021bd() {
    if (!$6513ca5a44de9748$var$Ctx) // we want the initialization to be lazy because `createContext` would error on import in a RSC
    $6513ca5a44de9748$var$Ctx = $gRqVZ.createContext(null);
    return $gRqVZ.useCallback(/**
     * @returns true if the hook was called during render
     */ ()=>{
        const orig = console.error;
        try {
            console.error = $6513ca5a44de9748$var$noop;
            /**
             * `useContext` can be called conditionally during render, so this is safe.
             * (Also, during render we would want to throw as a reaction to this anyways, so it
             * wouldn't even matter if we got the order of hooks mixed up...)
             *
             * They cannot however be called outside of Render, and that's what we're testing here.
             *
             * Different versions of React have different behaviour on an invalid hook call:
             *
             * React 16.8 - 17: throws an error
             * https://github.com/facebook/react/blob/2b93d686e359c7afa299e2ec5cf63160a32a1155/packages/react/src/ReactHooks.js#L18-L26
             *
             * React 18 & 19: `console.error` in development, then `resolveDispatcher` returns `null` and a member access on `null` throws.
             * https://github.com/facebook/react/blob/58e8304483ebfadd02a295339b5e9a989ac98c6e/packages/react/src/ReactHooks.js#L28-L35
             */ $gRqVZ.useContext($6513ca5a44de9748$var$Ctx);
            return true;
        } catch (e) {
            return false;
        } finally{
            console.error = orig;
        }
    }, []);
}




var $gRqVZ = parcelRequire("gRqVZ");
function $77991ab9e45be800$export$722debc0e56fea39(memoFn, deps) {
    const ref = $gRqVZ.useRef(void 0);
    // eslint-disable-next-line react-hooks/refs
    if (!ref.current || !(0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(ref.current.deps, deps)) ref.current = {
        value: memoFn(),
        deps: deps
    };
    // eslint-disable-next-line react-hooks/refs
    return ref.current.value;
}



var $gRqVZ = parcelRequire("gRqVZ");

const $ebd6106883929fc9$export$71594e8a50f746f4 = typeof (0, $480dec63d9529d01$export$f8b8b9ce72e9ccbf)(()=>window.document.createElement) === "function";


const $b1ed6e86d00798d2$export$700979bc83e7db82 = (0, $ebd6106883929fc9$export$71594e8a50f746f4) ? $gRqVZ.useLayoutEffect : $gRqVZ.useEffect;



var $gRqVZ = parcelRequire("gRqVZ");


var $gRqVZ = parcelRequire("gRqVZ");

// To make sure Apollo Client doesn't create more than one React context
// (which can lead to problems like having an Apollo Client instance added
// in one context, then attempting to retrieve it from another different
// context), a single Apollo context is created and tracked in global state.
const $e1d3f667cb3a09be$var$contextKey = Symbol.for("__APOLLO_CONTEXT__");
function $e1d3f667cb3a09be$export$a47505d961ee3a1() {
    (0, $aa2d7231b5e28112$export$f5708dca728d7177)("createContext" in $gRqVZ, 37);
    let context = $gRqVZ.createContext[$e1d3f667cb3a09be$var$contextKey];
    if (!context) {
        Object.defineProperty($gRqVZ.createContext, $e1d3f667cb3a09be$var$contextKey, {
            value: context = $gRqVZ.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true
        });
        context.displayName = "ApolloContext";
    }
    return context;
}


function $b86ffbc6c4f7be29$export$eb9a56e7a29e494(override) {
    const context = $gRqVZ.useContext((0, $e1d3f667cb3a09be$export$a47505d961ee3a1)());
    const client = override || context.client;
    (0, $aa2d7231b5e28112$export$f5708dca728d7177)(!!client, 28);
    return client;
}



var $gRqVZ = parcelRequire("gRqVZ");




let $676f4b16c0a54ac9$var$didWarnUncachedGetSnapshot = false;
// Prevent webpack from complaining about our feature detection of the
// useSyncExternalStore property of the React namespace, which is expected not
// to exist when using React 17 and earlier, and that's fine.
const $676f4b16c0a54ac9$var$uSESKey = "useSyncExternalStore";
const $676f4b16c0a54ac9$var$realHook = $gRqVZ[$676f4b16c0a54ac9$var$uSESKey];
const $676f4b16c0a54ac9$var$isReactNative = (0, $480dec63d9529d01$export$f8b8b9ce72e9ccbf)(()=>navigator.product) == "ReactNative";
const $676f4b16c0a54ac9$var$usingJSDOM = // Following advice found in this comment from @domenic (maintainer of jsdom):
// https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
//
// Since we control the version of Jest and jsdom used when running Apollo
// Client tests, and that version is recent enough to include " jsdom/x.y.z"
// at the end of the user agent string, I believe this case is all we need to
// check. Testing for "Node.js" was recommended for backwards compatibility
// with older version of jsdom, but we don't have that problem.
(0, $480dec63d9529d01$export$f8b8b9ce72e9ccbf)(()=>navigator.userAgent.indexOf("jsdom") >= 0) || false;
// Our tests should all continue to pass if we remove this !usingJSDOM
// condition, thereby allowing useLayoutEffect when using jsdom. Unfortunately,
// if we allow useLayoutEffect, then useSyncExternalStore generates many
// warnings about useLayoutEffect doing nothing on the server. While these
// warnings are harmless, this !usingJSDOM condition seems to be the best way to
// prevent them (i.e. skipping useLayoutEffect when using jsdom).
const $676f4b16c0a54ac9$var$canUseLayoutEffect = ((0, $ebd6106883929fc9$export$71594e8a50f746f4) || $676f4b16c0a54ac9$var$isReactNative) && !$676f4b16c0a54ac9$var$usingJSDOM;
const $676f4b16c0a54ac9$export$306c0aa65ff9ec16 = $676f4b16c0a54ac9$var$realHook || ((subscribe, getSnapshot, getServerSnapshot)=>{
    // Read the current snapshot from the store on every render. Again, this
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    const value = getSnapshot();
    if (// DEVIATION: Using __DEV__
    (0, $e15192e15b3ad6c1$export$a866f231438cc228) && !$676f4b16c0a54ac9$var$didWarnUncachedGetSnapshot && // DEVIATION: Not using Object.is because we know our snapshots will never
    // be exotic primitive values like NaN, which is !== itself.
    value !== getSnapshot()) {
        $676f4b16c0a54ac9$var$didWarnUncachedGetSnapshot = true;
        // DEVIATION: Using invariant.error instead of console.error directly.
        (0, $aa2d7231b5e28112$export$f5708dca728d7177).error(34);
    }
    // Because updates are synchronous, we don't queue them. Instead we force a
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    const [{ inst: inst }, forceUpdate] = $gRqVZ.useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    });
    // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    if ($676f4b16c0a54ac9$var$canUseLayoutEffect) // DEVIATION: We avoid calling useLayoutEffect when !canUseLayoutEffect,
    // which may seem like a conditional hook, but this code ends up behaving
    // unconditionally (one way or the other) because canUseLayoutEffect is
    // constant.
    $gRqVZ.useLayoutEffect(()=>{
        Object.assign(inst, {
            value: value,
            getSnapshot: getSnapshot
        });
        // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($676f4b16c0a54ac9$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
    // React Hook React.useLayoutEffect has a missing dependency: 'inst'. Either include it or remove the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    else Object.assign(inst, {
        value: value,
        getSnapshot: getSnapshot
    });
    $gRqVZ.useEffect(()=>{
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($676f4b16c0a54ac9$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        // Subscribe to the store and return a clean-up function.
        return subscribe(function handleStoreChange() {
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($676f4b16c0a54ac9$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        });
    // React Hook React.useEffect has a missing dependency: 'inst'. Either include it or remove the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe
    ]);
    return value;
});
function $676f4b16c0a54ac9$var$checkIfSnapshotChanged({ value: value, getSnapshot: getSnapshot }) {
    try {
        return value !== getSnapshot();
    } catch  {
        return true;
    }
}


// The following methods, when called will execute the query, regardless of
// whether the useLazyQuery execute function was called before.
const $518e978e29b3d0d2$var$EAGER_METHODS = [
    "refetch",
    "fetchMore",
    "updateQuery",
    "startPolling",
    "stopPolling",
    "subscribeToMore"
];
function $518e978e29b3d0d2$export$fd83eea6ecd2d8fa(query, options) {
    const client = (0, $b86ffbc6c4f7be29$export$eb9a56e7a29e494)(options?.client);
    const previousDataRef = $gRqVZ.useRef(undefined);
    const resultRef = $gRqVZ.useRef(undefined);
    const stableOptions = (0, $77991ab9e45be800$export$722debc0e56fea39)(()=>options, [
        options
    ]);
    const calledDuringRender = (0, $6513ca5a44de9748$export$3e6dc71f325021bd)();
    function createObservable() {
        return client.watchQuery({
            ...options,
            query: query,
            initialFetchPolicy: options?.fetchPolicy,
            fetchPolicy: "standby",
            [(0, $16b2c739aa564ddd$export$868b9638ff105835)]: true
        });
    }
    const [currentClient, setCurrentClient] = $gRqVZ.useState(client);
    const [observable, setObservable] = $gRqVZ.useState(createObservable);
    if (currentClient !== client) {
        setCurrentClient(client);
        setObservable(createObservable());
    }
    // TODO: Revisit after we have RxJS in place. We should be able to use
    // observable.getCurrentResult() (or equivalent) to get these values which
    // will hopefully alleviate the need for us to use refs to track these values.
    const updateResult = $gRqVZ.useCallback((result, forceUpdate)=>{
        const previousData = resultRef.current?.data;
        if (previousData && !(0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(previousData, result.data)) previousDataRef.current = previousData;
        resultRef.current = result;
        forceUpdate();
    }, []);
    const observableResult = (0, $676f4b16c0a54ac9$export$306c0aa65ff9ec16)($gRqVZ.useCallback((forceUpdate)=>{
        const subscription = observable.subscribe((result)=>{
            if (!(0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(resultRef.current, result)) updateResult(result, forceUpdate);
        });
        return ()=>{
            subscription.unsubscribe();
        };
    }, [
        observable,
        updateResult
    ]), ()=>resultRef.current || $518e978e29b3d0d2$var$initialResult, ()=>$518e978e29b3d0d2$var$initialResult);
    // We use useMemo here to make sure the eager methods have a stable identity.
    const eagerMethods = $gRqVZ.useMemo(()=>{
        const eagerMethods = {};
        for (const key of $518e978e29b3d0d2$var$EAGER_METHODS)eagerMethods[key] = function(...args) {
            (0, $aa2d7231b5e28112$export$f5708dca728d7177)(resultRef.current, 29, key);
            // @ts-expect-error this is just to generic to type
            return observable[key](...args);
        };
        return eagerMethods;
    }, [
        observable
    ]);
    $gRqVZ.useEffect(()=>{
        const updatedOptions = {
            query: query,
            errorPolicy: stableOptions?.errorPolicy,
            refetchWritePolicy: stableOptions?.refetchWritePolicy,
            returnPartialData: stableOptions?.returnPartialData,
            notifyOnNetworkStatusChange: stableOptions?.notifyOnNetworkStatusChange,
            nextFetchPolicy: options?.nextFetchPolicy,
            skipPollAttempt: options?.skipPollAttempt
        };
        // Wait to apply the changed fetch policy until after the execute
        // function has been called. The execute function will handle setting the
        // the fetch policy away from standby for us when called for the first time.
        if (observable.options.fetchPolicy !== "standby" && stableOptions?.fetchPolicy) updatedOptions.fetchPolicy = stableOptions.fetchPolicy;
        observable.applyOptions(updatedOptions);
    }, [
        query,
        observable,
        stableOptions,
        // Ensure inline functions don't suffer from stale closures by checking for
        // these deps separately. @wry/equality doesn't compare function identity
        // so `stableOptions` isn't updated when using inline functions.
        options?.nextFetchPolicy,
        options?.skipPollAttempt
    ]);
    const execute = $gRqVZ.useCallback((...args)=>{
        (0, $aa2d7231b5e28112$export$f5708dca728d7177)(!calledDuringRender(), 30);
        const [executeOptions] = args;
        let fetchPolicy = observable.options.fetchPolicy;
        if (fetchPolicy === "standby") fetchPolicy = observable.options.initialFetchPolicy;
        return observable.reobserve({
            fetchPolicy: fetchPolicy,
            // If `variables` is not given, reset back to empty variables by
            // ensuring the key exists in options
            variables: executeOptions?.variables,
            context: executeOptions?.context ?? {}
        });
    }, [
        observable,
        calledDuringRender
    ]);
    const executeRef = $gRqVZ.useRef(execute);
    (0, $b1ed6e86d00798d2$export$700979bc83e7db82)(()=>{
        executeRef.current = execute;
    });
    const stableExecute = $gRqVZ.useCallback((...args)=>executeRef.current(...args), []);
    const result = $gRqVZ.useMemo(()=>{
        const { partial: partial, ...result } = observableResult;
        return {
            ...eagerMethods,
            ...result,
            client: client,
            // eslint-disable-next-line react-hooks/refs
            previousData: previousDataRef.current,
            variables: observable.variables,
            observable: observable,
            // eslint-disable-next-line react-hooks/refs
            called: !!resultRef.current
        };
    }, [
        client,
        observableResult,
        eagerMethods,
        observable
    ]);
    return [
        stableExecute,
        result
    ];
}
const $518e978e29b3d0d2$var$initialResult = (0, $4f666ffbf7bc8e40$export$7f9c177735b71f18)({
    data: undefined,
    dataState: "empty",
    loading: false,
    networkStatus: (0, $28ed6ef232a84776$export$bd096ddbd246c79c).ready,
    partial: true
});



var $gRqVZ = parcelRequire("gRqVZ");
/**
* Merges the provided objects shallowly and removes
* all properties with an `undefined` value
*
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/ function $8e62f7547d3f557e$export$8e16b83750b44988(...objects) {
    const result = {};
    objects.forEach((obj)=>{
        if (!obj) return;
        Reflect.ownKeys(obj).forEach((key)=>{
            const value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}


function $7e1dfc8c7a435d55$export$235b7fc70b9fc359(defaults, options) {
    return (0, $8e62f7547d3f557e$export$8e16b83750b44988)(defaults, options, options.variables && {
        variables: (0, $8e62f7547d3f557e$export$8e16b83750b44988)({
            ...defaults && defaults.variables,
            ...options.variables
        })
    });
}

function $eec24d8374c011ae$export$7ff41c6e01127226(promise) {
    promise.catch(()=>{});
    return promise;
}




function $1189962e9f7bce46$export$609860bf8b0084c(mutation, options) {
    const client = (0, $b86ffbc6c4f7be29$export$eb9a56e7a29e494)(options?.client);
    const [result, setResult] = $gRqVZ.useState(()=>$1189962e9f7bce46$var$createInitialResult(client));
    const ref = $gRqVZ.useRef({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options
    });
    (0, $b1ed6e86d00798d2$export$700979bc83e7db82)(()=>{
        Object.assign(ref.current, {
            client: client,
            options: options,
            mutation: mutation
        });
    });
    const execute = $gRqVZ.useCallback((executeOptions = {})=>{
        const { options: options, mutation: mutation } = ref.current;
        const baseOptions = {
            ...options,
            mutation: mutation
        };
        const client = executeOptions.client || ref.current.client;
        const context = typeof executeOptions.context === "function" ? executeOptions.context(options?.context) : executeOptions.context;
        if (!ref.current.result.loading && ref.current.isMounted) setResult(ref.current.result = {
            loading: true,
            error: undefined,
            data: undefined,
            called: true,
            client: client
        });
        const mutationId = ++ref.current.mutationId;
        const clientOptions = (0, $7e1dfc8c7a435d55$export$235b7fc70b9fc359)(baseOptions, {
            ...executeOptions,
            context: context
        });
        return (0, $eec24d8374c011ae$export$7ff41c6e01127226)(client.mutate(clientOptions).then((response)=>{
            const { data: data, error: error } = response;
            const onError = executeOptions.onError || ref.current.options?.onError;
            if (error && onError) onError(error, clientOptions);
            if (mutationId === ref.current.mutationId) {
                const result = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client
                };
                if (ref.current.isMounted && !(0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(ref.current.result, result)) setResult(ref.current.result = result);
            }
            const onCompleted = executeOptions.onCompleted || ref.current.options?.onCompleted;
            if (!error) onCompleted?.(response.data, clientOptions);
            return response;
        }, (error)=>{
            if (mutationId === ref.current.mutationId && ref.current.isMounted) {
                const result = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client
                };
                if (!(0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(ref.current.result, result)) setResult(ref.current.result = result);
            }
            const onError = executeOptions.onError || ref.current.options?.onError;
            if (onError) onError(error, clientOptions);
            throw error;
        }));
    }, []);
    const reset = $gRqVZ.useCallback(()=>{
        if (ref.current.isMounted) {
            const result = $1189962e9f7bce46$var$createInitialResult(ref.current.client);
            Object.assign(ref.current, {
                mutationId: 0,
                result: result
            });
            setResult(result);
        }
    }, []);
    $gRqVZ.useEffect(()=>{
        const current = ref.current;
        current.isMounted = true;
        return ()=>{
            current.isMounted = false;
        };
    }, []);
    return [
        execute,
        {
            reset: reset,
            ...result
        }
    ];
}
function $1189962e9f7bce46$var$createInitialResult(client) {
    return {
        data: undefined,
        error: undefined,
        called: false,
        loading: false,
        client: client
    };
}

/**
 * Function parameters in this file try to follow a common order for the sake of
 * readability and consistency. The order is as follows:
 *
 * resultData
 * observable
 * client
 * query
 * options
 * watchQueryOptions
 * makeWatchQueryOptions
 */ /**  */ 

var $gRqVZ = parcelRequire("gRqVZ");

var $k8Bfo = parcelRequire("k8Bfo");

var $k8Bfo = parcelRequire("k8Bfo");

var $k8Bfo = parcelRequire("k8Bfo");

var $k8Bfo = parcelRequire("k8Bfo");
function $15c7bfd29ceeeb4c$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}


function $140b8b2dd929bf6a$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $d645b11a39d77c3d$export$c9648b76fd580c34 = (0, $140b8b2dd929bf6a$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});


function $a0e9eed99caff378$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $effe293b9da5735b$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $k8Bfo.__values)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $d645b11a39d77c3d$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $k8Bfo.__values)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $effe293b9da5735b$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $d645b11a39d77c3d$export$c9648b76fd580c34)) errors = (0, $k8Bfo.__spreadArray)((0, $k8Bfo.__spreadArray)([], (0, $k8Bfo.__read)(errors)), (0, $k8Bfo.__read)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $d645b11a39d77c3d$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $effe293b9da5735b$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $a0e9eed99caff378$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $a0e9eed99caff378$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $effe293b9da5735b$export$610f9c3ca1a38dd8 = $effe293b9da5735b$export$f55210826850c514.EMPTY;
function $effe293b9da5735b$export$4f9221cbada3c4fc(value) {
    return value instanceof $effe293b9da5735b$export$f55210826850c514 || value && 'closed' in value && (0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(value.remove) && (0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(value.add) && (0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $effe293b9da5735b$var$execFinalizer(finalizer) {
    if ((0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $e87298bccbb95771$export$e19cd5f9376f8cee = function(_super) {
    (0, $k8Bfo.__extends)(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, $effe293b9da5735b$export$f55210826850c514));



var $k8Bfo = parcelRequire("k8Bfo");
var $5164a21174e5eda3$export$f0ca5e16f6f68711 = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $5164a21174e5eda3$export$f0ca5e16f6f68711.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, (0, $k8Bfo.__spreadArray)([
            handler,
            timeout
        ], (0, $k8Bfo.__read)(args)));
        return setInterval.apply(void 0, (0, $k8Bfo.__spreadArray)([
            handler,
            timeout
        ], (0, $k8Bfo.__read)(args)));
    },
    clearInterval: function(handle) {
        var delegate = $5164a21174e5eda3$export$f0ca5e16f6f68711.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};



var $36f9373025161954$export$b5369ffd7cb2211b = function(_super) {
    (0, $k8Bfo.__extends)(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return (0, $5164a21174e5eda3$export$f0ca5e16f6f68711).setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        if (id != null) (0, $5164a21174e5eda3$export$f0ca5e16f6f68711).clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error('Scheduled action threw falsy error');
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            (0, $a0e9eed99caff378$export$dae3f38077fc36c0)(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}((0, $e87298bccbb95771$export$e19cd5f9376f8cee));



var $k8Bfo = parcelRequire("k8Bfo");
var $c0626d8cd60d1bb4$var$nextHandle = 1;
var $c0626d8cd60d1bb4$var$resolved;
var $c0626d8cd60d1bb4$var$activeHandles = {};
function $c0626d8cd60d1bb4$var$findAndClearHandle(handle) {
    if (handle in $c0626d8cd60d1bb4$var$activeHandles) {
        delete $c0626d8cd60d1bb4$var$activeHandles[handle];
        return true;
    }
    return false;
}
var $c0626d8cd60d1bb4$export$9bf7f22d83f7b5af = {
    setImmediate: function(cb) {
        var handle = $c0626d8cd60d1bb4$var$nextHandle++;
        $c0626d8cd60d1bb4$var$activeHandles[handle] = true;
        if (!$c0626d8cd60d1bb4$var$resolved) $c0626d8cd60d1bb4$var$resolved = Promise.resolve();
        $c0626d8cd60d1bb4$var$resolved.then(function() {
            return $c0626d8cd60d1bb4$var$findAndClearHandle(handle) && cb();
        });
        return handle;
    },
    clearImmediate: function(handle) {
        $c0626d8cd60d1bb4$var$findAndClearHandle(handle);
    }
};
var $c0626d8cd60d1bb4$export$3967e9a9db29c776 = {
    pending: function() {
        return Object.keys($c0626d8cd60d1bb4$var$activeHandles).length;
    }
};


var $590b264e89fc595d$var$setImmediate = (0, $c0626d8cd60d1bb4$export$9bf7f22d83f7b5af).setImmediate, $590b264e89fc595d$var$clearImmediate = (0, $c0626d8cd60d1bb4$export$9bf7f22d83f7b5af).clearImmediate;
var $590b264e89fc595d$export$24f2eaeae9bdcb7c = {
    setImmediate: function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var delegate = $590b264e89fc595d$export$24f2eaeae9bdcb7c.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.setImmediate) || $590b264e89fc595d$var$setImmediate).apply(void 0, (0, $k8Bfo.__spreadArray)([], (0, $k8Bfo.__read)(args)));
    },
    clearImmediate: function(handle) {
        var delegate = $590b264e89fc595d$export$24f2eaeae9bdcb7c.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearImmediate) || $590b264e89fc595d$var$clearImmediate)(handle);
    },
    delegate: undefined
};


var $3aa2b485d7f1c189$export$6a72523e12463e75 = function(_super) {
    (0, $k8Bfo.__extends)(AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler._scheduled || (scheduler._scheduled = (0, $590b264e89fc595d$export$24f2eaeae9bdcb7c).setImmediate(scheduler.flush.bind(scheduler, undefined)));
    };
    AsapAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (delay != null ? delay > 0 : this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        var actions = scheduler.actions;
        if (id != null && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id) {
            (0, $590b264e89fc595d$export$24f2eaeae9bdcb7c).clearImmediate(id);
            if (scheduler._scheduled === id) scheduler._scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}((0, $36f9373025161954$export$b5369ffd7cb2211b));



var $k8Bfo = parcelRequire("k8Bfo");

var $k8Bfo = parcelRequire("k8Bfo");
var $09b6be3211b47876$export$c1895ea2d519a677 = {
    now: function() {
        return ($09b6be3211b47876$export$c1895ea2d519a677.delegate || Date).now();
    },
    delegate: undefined
};


var $86f7630f78252da4$export$d3e54bb8584cda7c = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = (0, $09b6be3211b47876$export$c1895ea2d519a677).now;
    return Scheduler;
}();


var $34d801dcaad6bbe2$export$4114a3ec92faa3c6 = function(_super) {
    (0, $k8Bfo.__extends)(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, $86f7630f78252da4$export$d3e54bb8584cda7c).now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, $86f7630f78252da4$export$d3e54bb8584cda7c));


var $5f50c6eeaca9eabe$export$e27ac4cacb0fee33 = function(_super) {
    (0, $k8Bfo.__extends)(AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function(action) {
        this._active = true;
        var flushId = this._scheduled;
        this._scheduled = undefined;
        var actions = this.actions;
        var error;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while ((action = actions[0]) && action.id === flushId && actions.shift());
        this._active = false;
        if (error) {
            while((action = actions[0]) && action.id === flushId && actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsapScheduler;
}((0, $34d801dcaad6bbe2$export$4114a3ec92faa3c6));


var $4dc97fa1641a3a5e$export$25915e3b9bb42559 = new (0, $5f50c6eeaca9eabe$export$e27ac4cacb0fee33)((0, $3aa2b485d7f1c189$export$6a72523e12463e75));
var $4dc97fa1641a3a5e$export$dc4d482300a341e1 = $4dc97fa1641a3a5e$export$25915e3b9bb42559;

function $617f62038feacfbb$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}



function $beab12e89343bf23$export$ebec8610810318c5(source) {
    return (0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(source === null || source === void 0 ? void 0 : source.lift);
}
function $beab12e89343bf23$export$871731df685d7753(init) {
    return function(source) {
        if ($beab12e89343bf23$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError('Unable to lift unknown Observable type');
    };
}



var $k8Bfo = parcelRequire("k8Bfo");

var $k8Bfo = parcelRequire("k8Bfo");


var $faa67ecdc3966937$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $k8Bfo = parcelRequire("k8Bfo");
var $2aa4984021871363$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $2aa4984021871363$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $k8Bfo.__spreadArray)([
            handler,
            timeout
        ], (0, $k8Bfo.__read)(args)));
        return setTimeout.apply(void 0, (0, $k8Bfo.__spreadArray)([
            handler,
            timeout
        ], (0, $k8Bfo.__read)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $2aa4984021871363$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $fbfcee34922855d4$export$ebf645db02d3e99f(err) {
    (0, $2aa4984021871363$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $faa67ecdc3966937$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $275d586f16abc759$export$8793edee2d425525() {}


var $f1c9bcb40aa28ad9$export$b7f97edb34bc1f87 = function() {
    return $f1c9bcb40aa28ad9$export$9c8f6e8d39c60cf3('C', undefined, undefined);
}();
function $f1c9bcb40aa28ad9$export$dd472c3d8fe5a85a(error) {
    return $f1c9bcb40aa28ad9$export$9c8f6e8d39c60cf3('E', undefined, error);
}
function $f1c9bcb40aa28ad9$export$ff9346b0d1d30313(value) {
    return $f1c9bcb40aa28ad9$export$9c8f6e8d39c60cf3('N', value, undefined);
}
function $f1c9bcb40aa28ad9$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $d729478010e38fd5$var$context = null;
function $d729478010e38fd5$export$d974811edc77eafa(cb) {
    if ((0, $faa67ecdc3966937$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$d729478010e38fd5$var$context;
        if (isRoot) $d729478010e38fd5$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $d729478010e38fd5$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $d729478010e38fd5$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $d729478010e38fd5$export$3e205fbb5df021e0(err) {
    if ((0, $faa67ecdc3966937$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $d729478010e38fd5$var$context) {
        $d729478010e38fd5$var$context.errorThrown = true;
        $d729478010e38fd5$var$context.error = err;
    }
}


var $fbf2224f7546e2e1$export$60959659b2c22881 = function(_super) {
    (0, $k8Bfo.__extends)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $effe293b9da5735b$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $fbf2224f7546e2e1$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $fbf2224f7546e2e1$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $fbf2224f7546e2e1$var$handleStoppedNotification((0, $f1c9bcb40aa28ad9$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $fbf2224f7546e2e1$var$handleStoppedNotification((0, $f1c9bcb40aa28ad9$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $fbf2224f7546e2e1$var$handleStoppedNotification((0, $f1c9bcb40aa28ad9$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $effe293b9da5735b$export$f55210826850c514));
var $fbf2224f7546e2e1$var$_bind = Function.prototype.bind;
function $fbf2224f7546e2e1$var$bind(fn, thisArg) {
    return $fbf2224f7546e2e1$var$_bind.call(fn, thisArg);
}
var $fbf2224f7546e2e1$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $fbf2224f7546e2e1$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $fbf2224f7546e2e1$var$handleUnhandledError(error);
        }
        else $fbf2224f7546e2e1$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $fbf2224f7546e2e1$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $fbf2224f7546e2e1$export$94eeb6a328cab6c7 = function(_super) {
    (0, $k8Bfo.__extends)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $faa67ecdc3966937$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $fbf2224f7546e2e1$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $fbf2224f7546e2e1$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $fbf2224f7546e2e1$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $fbf2224f7546e2e1$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($fbf2224f7546e2e1$export$60959659b2c22881);
function $fbf2224f7546e2e1$var$handleUnhandledError(error) {
    if ((0, $faa67ecdc3966937$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $d729478010e38fd5$export$3e205fbb5df021e0)(error);
    else (0, $fbfcee34922855d4$export$ebf645db02d3e99f)(error);
}
function $fbf2224f7546e2e1$var$defaultErrorHandler(err) {
    throw err;
}
function $fbf2224f7546e2e1$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $faa67ecdc3966937$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $2aa4984021871363$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $fbf2224f7546e2e1$export$88d395d20619a0af = {
    closed: true,
    next: (0, $275d586f16abc759$export$8793edee2d425525),
    error: $fbf2224f7546e2e1$var$defaultErrorHandler,
    complete: (0, $275d586f16abc759$export$8793edee2d425525)
};


function $da8da925672b7eb3$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $da8da925672b7eb3$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $da8da925672b7eb3$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $k8Bfo.__extends)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $fbf2224f7546e2e1$export$60959659b2c22881));


function $cfb9afa60710a0f8$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $beab12e89343bf23$export$871731df685d7753)(function(source, subscriber) {
        source.subscribe((0, $da8da925672b7eb3$export$b9e075132cc6937f)(subscriber, function(value) {
            return (0, $617f62038feacfbb$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $617f62038feacfbb$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $617f62038feacfbb$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}






var $gRqVZ = parcelRequire("gRqVZ");
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const $3fafa7abbadfcc3d$var$defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach: $3fafa7abbadfcc3d$var$forEach, slice: $3fafa7abbadfcc3d$var$slice } = Array.prototype;
const { hasOwnProperty: $3fafa7abbadfcc3d$var$hasOwnProperty } = Object.prototype;
class $3fafa7abbadfcc3d$export$73571c50d0f2507e {
    constructor(weakness = true, makeData = $3fafa7abbadfcc3d$var$defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup() {
        return this.lookupArray(arguments);
    }
    lookupArray(array) {
        let node = this;
        $3fafa7abbadfcc3d$var$forEach.call(array, (key)=>node = node.getChildTrie(key));
        return $3fafa7abbadfcc3d$var$hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData($3fafa7abbadfcc3d$var$slice.call(array));
    }
    peek() {
        return this.peekArray(arguments);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = node.mapFor(array[i], false);
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    remove() {
        return this.removeArray(arguments);
    }
    removeArray(array) {
        let data;
        if (array.length) {
            const head = array[0];
            const map = this.mapFor(head, false);
            const child = map && map.get(head);
            if (child) {
                data = child.removeArray($3fafa7abbadfcc3d$var$slice.call(array, 1));
                if (!child.data && !child.weak && !(child.strong && child.strong.size)) map.delete(head);
            }
        } else {
            data = this.data;
            delete this.data;
        }
        return data;
    }
    getChildTrie(key) {
        const map = this.mapFor(key, true);
        let child = map.get(key);
        if (!child) map.set(key, child = new $3fafa7abbadfcc3d$export$73571c50d0f2507e(this.weakness, this.makeData));
        return child;
    }
    mapFor(key, create) {
        return this.weakness && $3fafa7abbadfcc3d$var$isObjRef(key) ? this.weak || (create ? this.weak = new WeakMap : void 0) : this.strong || (create ? this.strong = new Map : void 0);
    }
}
function $3fafa7abbadfcc3d$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}



/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/ function $e82cc9300ae04077$export$2ce622d4a52d9584(value) {
    const promise = Promise.resolve(value);
    promise.status = "fulfilled";
    promise.value = value;
    return promise;
}

function $99f56904e15e19f3$var$isDecoratedPromise(promise) {
    return "status" in promise;
}
function $99f56904e15e19f3$export$5e69b74058d792cc(promise) {
    if ($99f56904e15e19f3$var$isDecoratedPromise(promise)) return promise;
    const pendingPromise = promise;
    pendingPromise.status = "pending";
    pendingPromise.then((value)=>{
        if (pendingPromise.status === "pending") {
            const fulfilledPromise = pendingPromise;
            fulfilledPromise.status = "fulfilled";
            fulfilledPromise.value = value;
        }
    }, (reason)=>{
        if (pendingPromise.status === "pending") {
            const rejectedPromise = pendingPromise;
            rejectedPromise.status = "rejected";
            rejectedPromise.reason = reason;
        }
    });
    return promise;
}


class $15c0371138dc5870$export$5ad20f9b6f32cad2 {
    observable;
    key = {};
    promise;
    resolve;
    reject;
    subscription;
    listeners = new Set();
    autoDisposeTimeoutId;
    references = 0;
    constructor(client, watchFragmentOptions, options){
        this.dispose = this.dispose.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleError = this.handleError.bind(this);
        this.observable = client.watchFragment(watchFragmentOptions);
        if (options.onDispose) this.onDispose = options.onDispose;
        const result = this.observable.getCurrentResult();
        // Start a timer that will automatically dispose of the query if the
        // suspended resource does not use this fragmentRef in the given time. This
        // helps prevent memory leaks when a component has unmounted before the
        // query has finished loading.
        const startDisposeTimer = ()=>{
            if (!this.references) this.autoDisposeTimeoutId = setTimeout(this.dispose, options.autoDisposeTimeoutMs ?? 30000);
        };
        this.promise = result.complete ? (0, $e82cc9300ae04077$export$2ce622d4a52d9584)(result.data) : this.createPendingPromise();
        this.subscribeToFragment();
        this.promise.then(startDisposeTimer, startDisposeTimer);
    }
    listen(listener) {
        this.listeners.add(listener);
        return ()=>{
            this.listeners.delete(listener);
        };
    }
    retain() {
        this.references++;
        clearTimeout(this.autoDisposeTimeoutId);
        let disposed = false;
        return ()=>{
            if (disposed) return;
            disposed = true;
            this.references--;
            setTimeout(()=>{
                if (!this.references) this.dispose();
            });
        };
    }
    dispose() {
        this.subscription.unsubscribe();
    }
    onDispose() {
    // noop. overridable by options
    }
    subscribeToFragment() {
        this.subscription = this.observable.subscribe(this.handleNext.bind(this), this.handleError.bind(this));
        // call `onDispose` when the subscription is finalized, either because it is
        // unsubscribed as a consequence of a `dispose` call or because the
        // ObservableQuery completes because of a `ApolloClient.stop()` call.
        this.subscription.add(this.onDispose);
    }
    handleNext(result) {
        switch(this.promise.status){
            case "pending":
                if (result.complete) return this.resolve?.(result.data);
                this.deliver(this.promise);
                break;
            case "fulfilled":
                // This can occur when we already have a result written to the cache and
                // we subscribe for the first time. We create a fulfilled promise in the
                // constructor with a value that is the same as the first emitted value
                // so we want to skip delivering it.
                if ((0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(this.promise.value, result.data)) return;
                this.promise = result.complete ? (0, $e82cc9300ae04077$export$2ce622d4a52d9584)(result.data) : this.createPendingPromise();
                this.deliver(this.promise);
        }
    }
    handleError(error) {
        this.reject?.(error);
    }
    deliver(promise) {
        this.listeners.forEach((listener)=>listener(promise));
    }
    createPendingPromise() {
        return (0, $99f56904e15e19f3$export$5e69b74058d792cc)(new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        }));
    }
}





function $1ed725e1b173ea41$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $beab12e89343bf23$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $da8da925672b7eb3$export$b9e075132cc6937f)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}


/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/ function $527fc289f26f9306$export$d22877ef6074ba31(reason) {
    const promise = Promise.reject(reason);
    // prevent potential edge cases leaking unhandled error rejections
    promise.catch(()=>{});
    promise.status = "rejected";
    promise.reason = reason;
    return promise;
}



const $4e2cb05b8bd9be48$var$QUERY_REFERENCE_SYMBOL = Symbol.for("apollo.internal.queryRef");
const $4e2cb05b8bd9be48$var$PROMISE_SYMBOL = Symbol.for("apollo.internal.refPromise");
function $4e2cb05b8bd9be48$export$d596989234857a70(internalQueryRef) {
    return {
        [$4e2cb05b8bd9be48$var$QUERY_REFERENCE_SYMBOL]: internalQueryRef,
        [$4e2cb05b8bd9be48$var$PROMISE_SYMBOL]: internalQueryRef.promise
    };
}
function $4e2cb05b8bd9be48$export$212d896173921d75(queryRef) {
    (0, $aa2d7231b5e28112$export$f5708dca728d7177)(!queryRef || $4e2cb05b8bd9be48$var$QUERY_REFERENCE_SYMBOL in queryRef, 27);
}
function $4e2cb05b8bd9be48$export$c9c310289852f904(queryRef) {
    const internalQueryRef = $4e2cb05b8bd9be48$export$39359b12e11a00e3(queryRef);
    return internalQueryRef.promise.status === "fulfilled" ? internalQueryRef.promise : queryRef[$4e2cb05b8bd9be48$var$PROMISE_SYMBOL];
}
function $4e2cb05b8bd9be48$export$39359b12e11a00e3(queryRef) {
    return queryRef[$4e2cb05b8bd9be48$var$QUERY_REFERENCE_SYMBOL];
}
function $4e2cb05b8bd9be48$export$24cbda35be00f1a(queryRef, promise) {
    queryRef[$4e2cb05b8bd9be48$var$PROMISE_SYMBOL] = promise;
}
const $4e2cb05b8bd9be48$var$OBSERVED_CHANGED_OPTIONS = [
    "context",
    "errorPolicy",
    "fetchPolicy",
    "refetchWritePolicy",
    "returnPartialData"
];
class $4e2cb05b8bd9be48$export$d72b52f31231b813 {
    result;
    key = {};
    observable;
    promise;
    queue;
    subscription;
    listeners = new Set();
    autoDisposeTimeoutId;
    resolve;
    reject;
    references = 0;
    softReferences = 0;
    constructor(observable, options){
        this.handleNext = this.handleNext.bind(this);
        this.dispose = this.dispose.bind(this);
        this.observable = observable;
        if (options.onDispose) this.onDispose = options.onDispose;
        this.setResult();
        this.subscribeToQuery();
        // Start a timer that will automatically dispose of the query if the
        // suspended resource does not use this queryRef in the given time. This
        // helps prevent memory leaks when a component has unmounted before the
        // query has finished loading.
        const startDisposeTimer = ()=>{
            if (!this.references) this.autoDisposeTimeoutId = setTimeout(this.dispose, options.autoDisposeTimeoutMs ?? 30000);
        };
        // We wait until the request has settled to ensure we don't dispose of the
        // query ref before the request finishes, otherwise we would leave the
        // promise in a pending state rendering the suspense boundary indefinitely.
        this.promise.then(startDisposeTimer, startDisposeTimer);
    }
    get disposed() {
        return this.subscription.closed;
    }
    get watchQueryOptions() {
        return this.observable.options;
    }
    reinitialize() {
        const { observable: observable } = this;
        const originalFetchPolicy = this.watchQueryOptions.fetchPolicy;
        const avoidNetworkRequests = originalFetchPolicy === "no-cache" || originalFetchPolicy === "standby";
        try {
            if (avoidNetworkRequests) observable.applyOptions({
                fetchPolicy: "standby"
            });
            else {
                observable.reset();
                observable.applyOptions({
                    fetchPolicy: "cache-first"
                });
            }
            if (!avoidNetworkRequests) this.setResult();
            this.subscribeToQuery();
        } finally{
            observable.applyOptions({
                fetchPolicy: originalFetchPolicy
            });
        }
    }
    retain() {
        this.references++;
        clearTimeout(this.autoDisposeTimeoutId);
        let disposed = false;
        return ()=>{
            if (disposed) return;
            disposed = true;
            this.references--;
            setTimeout(()=>{
                if (!this.references) this.dispose();
            });
        };
    }
    softRetain() {
        this.softReferences++;
        let disposed = false;
        return ()=>{
            // Tracking if this has already been called helps ensure that
            // multiple calls to this function won't decrement the reference
            // counter more than it should. Subsequent calls just result in a noop.
            if (disposed) return;
            disposed = true;
            this.softReferences--;
            setTimeout(()=>{
                if (!this.softReferences && !this.references) this.dispose();
            });
        };
    }
    didChangeOptions(watchQueryOptions) {
        return $4e2cb05b8bd9be48$var$OBSERVED_CHANGED_OPTIONS.some((option)=>option in watchQueryOptions && !(0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(this.watchQueryOptions[option], watchQueryOptions[option]));
    }
    applyOptions(watchQueryOptions) {
        const { fetchPolicy: currentFetchPolicy } = this.watchQueryOptions;
        // "standby" is used when `skip` is set to `true`. Detect when we've
        // enabled the query (i.e. `skip` is `false`) to execute a network request.
        if (currentFetchPolicy === "standby" && currentFetchPolicy !== watchQueryOptions.fetchPolicy) this.initiateFetch(this.observable.reobserve(watchQueryOptions));
        else this.observable.applyOptions(watchQueryOptions);
        return this.promise;
    }
    listen(listener) {
        this.listeners.add(listener);
        if (this.queue) {
            this.deliver(this.queue);
            this.queue = undefined;
        }
        return ()=>{
            this.listeners.delete(listener);
        };
    }
    refetch(variables) {
        return this.initiateFetch(this.observable.refetch(variables));
    }
    fetchMore(options) {
        return this.initiateFetch(this.observable.fetchMore(options));
    }
    dispose() {
        this.subscription.unsubscribe();
    }
    onDispose() {
    // noop. overridable by options
    }
    handleNext(result) {
        switch(this.promise.status){
            case "pending":
                // Maintain the last successful `data` value if the next result does not
                // have one.
                // TODO: This can likely be removed once
                // https://github.com/apollographql/apollo-client/issues/12667 is fixed
                if (result.data === void 0) {
                    result.data = this.result.data;
                    if (result.data) result.dataState = "complete";
                }
                if (this.shouldReject(result)) this.reject?.(result.error);
                else {
                    this.result = result;
                    this.resolve?.(result);
                }
                break;
            default:
                // This occurs when switching to a result that is fully cached when this
                // class is instantiated. ObservableQuery will run reobserve when
                // subscribing, which delivers a result from the cache.
                if (result.data === this.result.data && result.networkStatus === this.result.networkStatus) return;
                // Maintain the last successful `data` value if the next result does not
                // have one.
                if (result.data === void 0) result.data = this.result.data;
                if (this.shouldReject(result)) {
                    this.promise = (0, $527fc289f26f9306$export$d22877ef6074ba31)(result.error);
                    this.deliver(this.promise);
                } else {
                    this.result = result;
                    this.promise = (0, $e82cc9300ae04077$export$2ce622d4a52d9584)(result);
                    this.deliver(this.promise);
                }
                break;
        }
    }
    deliver(promise) {
        // Maintain a queue of the last item we tried to deliver so that we can
        // deliver it as soon as we get the first listener. This helps in cases such
        // as `@stream` where React may render a component and incremental results
        // are loaded in between when the component renders and effects are run. If
        // effects are run after the incremntal chunks are delivered, we'll have
        // rendered a stale value. The queue ensures we can deliver the most
        // up-to-date value as soon as the component is ready to listen for new
        // values.
        if (this.listeners.size === 0) this.queue = promise;
        this.listeners.forEach((listener)=>listener(promise));
    }
    initiateFetch(returnedPromise) {
        this.promise = this.createPendingPromise();
        this.promise.catch(()=>{});
        // If the data returned from the fetch is deeply equal to the data already
        // in the cache, `handleNext` will not be triggered leaving the promise we
        // created in a pending state forever. To avoid this situation, we attempt
        // to resolve the promise if `handleNext` hasn't been run to ensure the
        // promise is resolved correctly.
        returnedPromise.then(()=>{
            // In the case of `fetchMore`, this promise is resolved before a cache
            // result is emitted due to the fact that `fetchMore` sets a `no-cache`
            // fetch policy and runs `cache.batch` in its `.then` handler. Because
            // the timing is different, we accidentally run this update twice
            // causing an additional re-render with the `fetchMore` result by
            // itself. By wrapping in `setTimeout`, this should provide a short
            // delay to allow the `QueryInfo.notify` handler to run before this
            // promise is checked.
            // See https://github.com/apollographql/apollo-client/issues/11315 for
            // more information
            setTimeout(()=>{
                if (this.promise.status === "pending") {
                    // Use the current result from the observable instead of the value
                    // resolved from the promise. This avoids issues in some cases where
                    // the raw resolved value should not be the emitted value, such as
                    // when a `fetchMore` call returns an empty array after it has
                    // reached the end of the list.
                    //
                    // See the following for more information:
                    // https://github.com/apollographql/apollo-client/issues/11642
                    this.result = this.observable.getCurrentResult();
                    this.resolve?.(this.result);
                }
            });
        }).catch((error)=>this.reject?.(error));
        return returnedPromise;
    }
    subscribeToQuery() {
        this.subscription = this.observable.pipe((0, $1ed725e1b173ea41$export$3dea766d36a8935f)((result)=>!(0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(result, this.result))).subscribe(this.handleNext);
        // call `onDispose` when the subscription is finalized, either because it is
        // unsubscribed as a consequence of a `dispose` call or because the
        // ObservableQuery completes because of a `ApolloClient.stop()` call.
        this.subscription.add(this.onDispose);
    }
    setResult() {
        const result = this.observable.getCurrentResult();
        if ((0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(result, this.result)) return;
        this.result = result;
        this.promise = result.data ? (0, $e82cc9300ae04077$export$2ce622d4a52d9584)(result) : this.createPendingPromise();
    }
    shouldReject(result) {
        const { errorPolicy: errorPolicy = "none" } = this.watchQueryOptions;
        return result.error && errorPolicy === "none";
    }
    createPendingPromise() {
        return (0, $99f56904e15e19f3$export$5e69b74058d792cc)(new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        }));
    }
}


class $a68c52a98f1a0898$export$7a8323d1591be59f {
    queryRefs = new (0, $3fafa7abbadfcc3d$export$73571c50d0f2507e)();
    fragmentRefs = new (0, $3fafa7abbadfcc3d$export$73571c50d0f2507e)();
    options;
    constructor(options = {}){
        this.options = options;
    }
    getQueryRef(cacheKey, createObservable) {
        const ref = this.queryRefs.lookupArray(cacheKey);
        if (!ref.current) ref.current = new (0, $4e2cb05b8bd9be48$export$d72b52f31231b813)(createObservable(), {
            autoDisposeTimeoutMs: this.options.autoDisposeTimeoutMs,
            onDispose: ()=>{
                delete ref.current;
            }
        });
        return ref.current;
    }
    getFragmentRef(cacheKey, client, options) {
        const ref = this.fragmentRefs.lookupArray(cacheKey);
        if (!ref.current) ref.current = new (0, $15c0371138dc5870$export$5ad20f9b6f32cad2)(client, options, {
            autoDisposeTimeoutMs: this.options.autoDisposeTimeoutMs,
            onDispose: ()=>{
                delete ref.current;
            }
        });
        return ref.current;
    }
    add(cacheKey, queryRef) {
        const ref = this.queryRefs.lookupArray(cacheKey);
        ref.current = queryRef;
    }
}


const $656a72ab9e97214c$var$suspenseCacheSymbol = Symbol.for("apollo.suspenseCache");
function $656a72ab9e97214c$export$d841506be5d0acb2(client) {
    if (!client[$656a72ab9e97214c$var$suspenseCacheSymbol]) client[$656a72ab9e97214c$var$suspenseCacheSymbol] = new (0, $a68c52a98f1a0898$export$7a8323d1591be59f)(client.defaultOptions.react?.suspense);
    return client[$656a72ab9e97214c$var$suspenseCacheSymbol];
}



const $db5d299036dd6606$export$7747067cba9170ba = Symbol.for("apollo.hook.wrappers");



function $722bb6613a4cb86c$export$7f12579c79e39619(hookName, useHook, clientOrObsQuery) {
    // Priority-wise, the later entries in this array wrap
    // previous entries and could prevent them (and in the end,
    // even the original hook) from running
    const wrapperSources = [
        clientOrObsQuery["queryManager"],
        // if we are a hook (not `preloadQuery`), we are guaranteed to be inside of
        // a React render and can use context
        hookName.startsWith("use") ? // eslint-disable-next-line react-hooks/rules-of-hooks
        $gRqVZ.useContext((0, $e1d3f667cb3a09be$export$a47505d961ee3a1)()) : undefined
    ];
    let wrapped = useHook;
    for (const source of wrapperSources){
        const wrapper = source?.[0, $db5d299036dd6606$export$7747067cba9170ba]?.[hookName];
        if (wrapper) wrapped = wrapper(wrapped);
    }
    return wrapped;
}




const $e040a67118ad2df5$var$lastWatchOptions = Symbol();
function $e040a67118ad2df5$export$dd0a697e1782aedd(query, ...[options]) {
    "use no memo";
    return (0, $722bb6613a4cb86c$export$7f12579c79e39619)("useQuery", $e040a67118ad2df5$var$useQuery_, (0, $b86ffbc6c4f7be29$export$eb9a56e7a29e494)(typeof options === "object" ? options.client : undefined))(query, options);
}
function $e040a67118ad2df5$var$useQuery_(query, options = {}) {
    const client = (0, $b86ffbc6c4f7be29$export$eb9a56e7a29e494)(typeof options === "object" ? options.client : undefined);
    const { ssr: ssr } = typeof options === "object" ? options : {};
    const watchQueryOptions = $e040a67118ad2df5$var$useOptions(query, options, client.defaultOptions.watchQuery);
    function createState(previous) {
        const observable = client.watchQuery(watchQueryOptions);
        return {
            client: client,
            query: query,
            observable: observable,
            resultData: {
                current: observable.getCurrentResult(),
                // Reuse previousData from previous InternalState (if any) to provide
                // continuity of previousData even if/when the query or client changes.
                previousData: previous?.resultData.current.data,
                variables: observable.variables
            }
        };
    }
    let [state, setState] = $gRqVZ.useState(createState);
    if (client !== state.client || query !== state.query) // If the client or query have changed, we need to create a new InternalState.
    // This will trigger a re-render with the new state, but it will also continue
    // to run the current render function to completion.
    // Since we sometimes trigger some side-effects in the render function, we
    // re-assign `state` to the new state to ensure that those side-effects are
    // triggered with the new state.
    setState(state = createState(state));
    const { observable: observable, resultData: resultData } = state;
    $e040a67118ad2df5$var$useInitialFetchPolicyIfNecessary(watchQueryOptions, observable);
    $e040a67118ad2df5$var$useResubscribeIfNecessary(resultData, observable, watchQueryOptions);
    const result = $e040a67118ad2df5$var$useResult(observable, resultData, ssr);
    const obsQueryFields = $gRqVZ.useMemo(()=>({
            refetch: observable.refetch.bind(observable),
            fetchMore: observable.fetchMore.bind(observable),
            updateQuery: observable.updateQuery.bind(observable),
            startPolling: observable.startPolling.bind(observable),
            stopPolling: observable.stopPolling.bind(observable),
            subscribeToMore: observable.subscribeToMore.bind(observable)
        }), [
        observable
    ]);
    const previousData = resultData.previousData;
    return $gRqVZ.useMemo(()=>{
        const { partial: partial, ...rest } = result;
        return {
            ...rest,
            client: client,
            observable: observable,
            variables: observable.variables,
            previousData: previousData,
            ...obsQueryFields
        };
    }, [
        result,
        client,
        observable,
        previousData,
        obsQueryFields
    ]);
}
const $e040a67118ad2df5$var$fromSkipToken = Symbol();
function $e040a67118ad2df5$var$useOptions(query, options, defaultOptions) {
    return (0, $77991ab9e45be800$export$722debc0e56fea39)(()=>{
        if (options === (0, $57d3755bf6de1db3$export$1aa5a89531b7670d)) {
            const opts = {
                ...(0, $7e1dfc8c7a435d55$export$235b7fc70b9fc359)(defaultOptions, {
                    query: query,
                    fetchPolicy: "standby"
                }),
                [(0, $16b2c739aa564ddd$export$868b9638ff105835)]: true
            };
            opts[$e040a67118ad2df5$var$fromSkipToken] = true;
            return opts;
        }
        const watchQueryOptions = (0, $7e1dfc8c7a435d55$export$235b7fc70b9fc359)(defaultOptions, {
            ...options,
            query: query
        });
        if (options.skip) {
            watchQueryOptions.initialFetchPolicy = options.initialFetchPolicy || options.fetchPolicy;
            watchQueryOptions.fetchPolicy = "standby";
        }
        return watchQueryOptions;
    }, [
        query,
        options,
        defaultOptions
    ]);
}
function $e040a67118ad2df5$var$useInitialFetchPolicyIfNecessary(watchQueryOptions, observable) {
    "use no memo";
    if (!watchQueryOptions.fetchPolicy) watchQueryOptions.fetchPolicy = observable.options.initialFetchPolicy;
}
function $e040a67118ad2df5$var$useResult(observable, resultData, ssr) {
    "use no memo";
    const fetchPolicy = observable.options.fetchPolicy;
    return (0, $676f4b16c0a54ac9$export$306c0aa65ff9ec16)($gRqVZ.useCallback((handleStoreChange)=>{
        const subscription = observable// We use the asapScheduler here to prevent issues with trying to
        // update in the middle of a render. `reobserve` is kicked off in the
        // middle of a render and because RxJS emits values synchronously,
        // its possible for this `handleStoreChange` to be called in that same
        // render. This allows the render to complete before trying to emit a
        // new value.
        .pipe((0, $cfb9afa60710a0f8$export$9007f49c319d1ac7)((0, $4dc97fa1641a3a5e$export$25915e3b9bb42559))).subscribe((result)=>{
            const previous = resultData.current;
            if (// Avoid rerendering if the result is the same
            (0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(previous, result) && // Force rerender if the value was emitted because variables
            // changed, such as when calling `refetch(newVars)` which returns
            // the same data when `notifyOnNetworkStatusChange` is `false`.
            (0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(resultData.variables, observable.variables)) return;
            resultData.variables = observable.variables;
            if (previous.data && !(0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(previous.data, result.data)) resultData.previousData = previous.data;
            resultData.current = result;
            handleStoreChange();
        });
        // Do the "unsubscribe" with a short delay.
        // This way, an existing subscription can be reused without an additional
        // request if "unsubscribe"  and "resubscribe" to the same ObservableQuery
        // happen in very fast succession.
        return ()=>{
            setTimeout(()=>subscription.unsubscribe());
        };
    }, [
        observable,
        resultData
    ]), ()=>resultData.current, ()=>fetchPolicy !== "standby" && ssr === false || fetchPolicy === "no-cache" ? $e040a67118ad2df5$export$dd0a697e1782aedd.ssrDisabledResult : resultData.current);
}
// this hook is not compatible with any rules of React, and there's no good way to rewrite it.
// it should stay a separate hook that will not be optimized by the compiler
function $e040a67118ad2df5$var$useResubscribeIfNecessary(/** this hook will mutate properties on `resultData` */ resultData, /** this hook will mutate properties on `observable` */ observable, watchQueryOptions) {
    "use no memo";
    if (observable[$e040a67118ad2df5$var$lastWatchOptions] && !(0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(observable[$e040a67118ad2df5$var$lastWatchOptions], watchQueryOptions)) {
        // If skipToken was used to generate options, we won't know the correct
        // initialFetchPolicy until the hook is rerendered with real options, so we
        // set it the next time we get real options
        if (observable[$e040a67118ad2df5$var$lastWatchOptions][$e040a67118ad2df5$var$fromSkipToken] && !watchQueryOptions.initialFetchPolicy) watchQueryOptions.initialFetchPolicy = watchQueryOptions.fetchPolicy;
        // Though it might be tempting to postpone this reobserve call to the
        // useEffect block, we need getCurrentResult to return an appropriate
        // loading:true result synchronously (later within the same call to
        // useQuery). Since we already have this.observable here (not true for
        // the very first call to useQuery), we are not initiating any new
        // subscriptions, though it does feel less than ideal that reobserve
        // (potentially) kicks off a network request (for example, when the
        // variables have changed), which is technically a side-effect.
        if ($e040a67118ad2df5$var$shouldReobserve(observable[$e040a67118ad2df5$var$lastWatchOptions], watchQueryOptions)) observable.reobserve(watchQueryOptions);
        else observable.applyOptions(watchQueryOptions);
        // Make sure getCurrentResult returns a fresh ApolloQueryResult<TData>,
        // but save the current data as this.previousData, just like setResult
        // usually does.
        const result = observable.getCurrentResult();
        if (!(0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(result.data, resultData.current.data)) resultData.previousData = resultData.current.data || resultData.previousData;
        resultData.current = result;
        resultData.variables = observable.variables;
    }
    observable[$e040a67118ad2df5$var$lastWatchOptions] = watchQueryOptions;
}
function $e040a67118ad2df5$var$shouldReobserve(previousOptions, options) {
    return previousOptions.query !== options.query || !(0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(previousOptions.variables, options.variables) || previousOptions.fetchPolicy !== options.fetchPolicy && (options.fetchPolicy === "standby" || previousOptions.fetchPolicy === "standby");
}
$e040a67118ad2df5$export$dd0a697e1782aedd.ssrDisabledResult = (0, $4f666ffbf7bc8e40$export$7f9c177735b71f18)({
    loading: true,
    data: void 0,
    dataState: "empty",
    error: void 0,
    networkStatus: (0, $28ed6ef232a84776$export$bd096ddbd246c79c).loading,
    partial: true
});


var $gRqVZ = parcelRequire("gRqVZ");






var $gRqVZ = parcelRequire("gRqVZ");

// Prevent webpack from complaining about our feature detection of the
// use property of the React namespace, which is expected not
// to exist when using current stable versions, and that's fine.
const $677af4f28976dee6$var$useKey = "use";
const $677af4f28976dee6$var$realHook = $gRqVZ[$677af4f28976dee6$var$useKey];
const $677af4f28976dee6$export$92629c20d6a56587 = $677af4f28976dee6$var$realHook || function __use(promise) {
    const decoratedPromise = (0, $99f56904e15e19f3$export$5e69b74058d792cc)(promise);
    switch(decoratedPromise.status){
        case "pending":
            throw decoratedPromise;
        case "rejected":
            throw decoratedPromise.reason;
        case "fulfilled":
            return decoratedPromise.value;
    }
};


var $gRqVZ = parcelRequire("gRqVZ");


const $9f7df0d640a1952d$var$cacheSizeSymbol = Symbol.for("apollo.cacheSize");
const $9f7df0d640a1952d$export$f29926b23b28936b = {
    ...(0, $14cc75f186f11782$export$2e2bcd8739ae039)[$9f7df0d640a1952d$var$cacheSizeSymbol]
};


function $272455ec0e5fd782$var$defaultDispose() {}
class $272455ec0e5fd782$export$d3a0331d2c286dc8 {
    constructor(max = Infinity, dispose = $272455ec0e5fd782$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    get size() {
        return this.map.size;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    }
    clean() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            if (node === this.newest) this.newest = node.older;
            if (node === this.oldest) this.oldest = node.newer;
            if (node.newer) node.newer.older = node.older;
            if (node.older) node.older.newer = node.newer;
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    }
}

function $07bddf69ae669f38$var$noop() {}
const $07bddf69ae669f38$var$defaultDispose = $07bddf69ae669f38$var$noop;
const $07bddf69ae669f38$var$_WeakRef = typeof WeakRef !== "undefined" ? WeakRef : function(value) {
    return {
        deref: ()=>value
    };
};
const $07bddf69ae669f38$var$_WeakMap = typeof WeakMap !== "undefined" ? WeakMap : Map;
const $07bddf69ae669f38$var$_FinalizationRegistry = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : function() {
    return {
        register: $07bddf69ae669f38$var$noop,
        unregister: $07bddf69ae669f38$var$noop
    };
};
const $07bddf69ae669f38$var$finalizationBatchSize = 10024;
class $07bddf69ae669f38$export$87b462129af3b7d4 {
    constructor(max = Infinity, dispose = $07bddf69ae669f38$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new $07bddf69ae669f38$var$_WeakMap();
        this.newest = null;
        this.oldest = null;
        this.unfinalizedNodes = new Set();
        this.finalizationScheduled = false;
        this.size = 0;
        this.finalize = ()=>{
            const iterator = this.unfinalizedNodes.values();
            for(let i = 0; i < $07bddf69ae669f38$var$finalizationBatchSize; i++){
                const node = iterator.next().value;
                if (!node) break;
                this.unfinalizedNodes.delete(node);
                const key = node.key;
                delete node.key;
                node.keyRef = new $07bddf69ae669f38$var$_WeakRef(key);
                this.registry.register(key, node, node);
            }
            if (this.unfinalizedNodes.size > 0) queueMicrotask(this.finalize);
            else this.finalizationScheduled = false;
        };
        this.registry = new $07bddf69ae669f38$var$_FinalizationRegistry(this.deleteNode.bind(this));
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.scheduleFinalization(node);
        this.map.set(key, node);
        this.size++;
        return node.value;
    }
    clean() {
        while(this.oldest && this.size > this.max)this.deleteNode(this.oldest);
    }
    deleteNode(node) {
        if (node === this.newest) this.newest = node.older;
        if (node === this.oldest) this.oldest = node.newer;
        if (node.newer) node.newer.older = node.older;
        if (node.older) node.older.newer = node.newer;
        this.size--;
        const key = node.key || node.keyRef && node.keyRef.deref();
        this.dispose(node.value, key);
        if (!node.keyRef) this.unfinalizedNodes.delete(node);
        else this.registry.unregister(node);
        if (key) this.map.delete(key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            this.deleteNode(node);
            return true;
        }
        return false;
    }
    scheduleFinalization(node) {
        this.unfinalizedNodes.add(node);
        if (!this.finalizationScheduled) {
            this.finalizationScheduled = true;
            queueMicrotask(this.finalize);
        }
    }
}


const $1abac2280838e114$var$scheduledCleanup = new WeakSet();
function $1abac2280838e114$var$schedule(cache) {
    if (cache.size <= (cache.max || -1)) return;
    if (!$1abac2280838e114$var$scheduledCleanup.has(cache)) {
        $1abac2280838e114$var$scheduledCleanup.add(cache);
        setTimeout(()=>{
            cache.clean();
            $1abac2280838e114$var$scheduledCleanup.delete(cache);
        }, 100);
    }
}
const $1abac2280838e114$export$8dbad6f439bb2331 = function(max, dispose) {
    /*
    Some builds of `WeakCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ const cache = new (0, $07bddf69ae669f38$export$87b462129af3b7d4)(max, dispose);
    cache.set = function(key, value) {
        const ret = (0, $07bddf69ae669f38$export$87b462129af3b7d4).prototype.set.call(this, key, value);
        $1abac2280838e114$var$schedule(this);
        return ret;
    };
    return cache;
};
const $1abac2280838e114$export$5b4f745137d91413 = function(max, dispose) {
    /*
    Some builds of `StrongCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ const cache = new (0, $272455ec0e5fd782$export$d3a0331d2c286dc8)(max, dispose);
    cache.set = function(key, value) {
        const ret = (0, $272455ec0e5fd782$export$d3a0331d2c286dc8).prototype.set.call(this, key, value);
        $1abac2280838e114$var$schedule(this);
        return ret;
    };
    return cache;
};




const $0b54944ffd705e51$var$globalCaches = {};
function $0b54944ffd705e51$export$a8fcd406d9e37621(name, getSize) {
    $0b54944ffd705e51$var$globalCaches[name] = getSize;
}
const $0b54944ffd705e51$export$dfdba94ce46d2ea5 = (0, $e15192e15b3ad6c1$export$a866f231438cc228) ? $0b54944ffd705e51$var$_getApolloClientMemoryInternals : undefined;
const $0b54944ffd705e51$export$e95a5a2210e62466 = (0, $e15192e15b3ad6c1$export$a866f231438cc228) ? $0b54944ffd705e51$var$_getInMemoryCacheMemoryInternals : undefined;
const $0b54944ffd705e51$export$e7ed438e82606689 = (0, $e15192e15b3ad6c1$export$a866f231438cc228) ? $0b54944ffd705e51$var$_getApolloCacheMemoryInternals : undefined;
function $0b54944ffd705e51$var$getCurrentCacheSizes() {
    // `defaultCacheSizes` is a `const enum` that will be inlined during build, so we have to reconstruct it's shape here
    const defaults = {
        canonicalStringify: 1000 /* defaultCacheSizes["canonicalStringify"] */ ,
        checkDocument: 2000 /* defaultCacheSizes["checkDocument"] */ ,
        print: 2000 /* defaultCacheSizes["print"] */ ,
        "documentTransform.cache": 2000 /* defaultCacheSizes["documentTransform.cache"] */ ,
        "queryManager.getDocumentInfo": 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ ,
        "PersistedQueryLink.persistedQueryHashes": 2000 /* defaultCacheSizes["PersistedQueryLink.persistedQueryHashes"] */ ,
        "fragmentRegistry.transform": 2000 /* defaultCacheSizes["fragmentRegistry.transform"] */ ,
        "fragmentRegistry.lookup": 1000 /* defaultCacheSizes["fragmentRegistry.lookup"] */ ,
        "fragmentRegistry.findFragmentSpreads": 4000 /* defaultCacheSizes["fragmentRegistry.findFragmentSpreads"] */ ,
        "cache.fragmentQueryDocuments": 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
        "removeTypenameFromVariables.getVariableDefinitions": 2000 /* defaultCacheSizes["removeTypenameFromVariables.getVariableDefinitions"] */ ,
        "inMemoryCache.maybeBroadcastWatch": 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
        "inMemoryCache.executeSelectionSet": 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
        "inMemoryCache.executeSubSelectedArray": 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ 
    };
    return Object.fromEntries(Object.entries(defaults).map(([k, v])=>[
            k,
            (0, $9f7df0d640a1952d$export$f29926b23b28936b)[k] || v
        ]));
}
function $0b54944ffd705e51$var$_getApolloClientMemoryInternals() {
    if (!(0, $e15192e15b3ad6c1$export$a866f231438cc228)) throw new Error("only supported in development mode");
    return {
        limits: $0b54944ffd705e51$var$getCurrentCacheSizes(),
        sizes: {
            print: $0b54944ffd705e51$var$globalCaches.print?.(),
            canonicalStringify: $0b54944ffd705e51$var$globalCaches.canonicalStringify?.(),
            links: $0b54944ffd705e51$var$linkInfo(this.link),
            queryManager: {
                getDocumentInfo: this["queryManager"]["transformCache"].size,
                documentTransforms: $0b54944ffd705e51$var$transformInfo(this["queryManager"].documentTransform)
            },
            ...this.cache.getMemoryInternals?.()
        }
    };
}
function $0b54944ffd705e51$var$_getApolloCacheMemoryInternals() {
    return {
        cache: {
            fragmentQueryDocuments: $0b54944ffd705e51$var$getWrapperInformation(this["getFragmentDoc"])
        }
    };
}
function $0b54944ffd705e51$var$_getInMemoryCacheMemoryInternals() {
    const fragments = this.config.fragments;
    return {
        ...$0b54944ffd705e51$var$_getApolloCacheMemoryInternals.apply(this),
        addTypenameDocumentTransform: $0b54944ffd705e51$var$transformInfo(this["addTypenameTransform"]),
        inMemoryCache: {
            executeSelectionSet: $0b54944ffd705e51$var$getWrapperInformation(this["storeReader"]["executeSelectionSet"]),
            executeSubSelectedArray: $0b54944ffd705e51$var$getWrapperInformation(this["storeReader"]["executeSubSelectedArray"]),
            maybeBroadcastWatch: $0b54944ffd705e51$var$getWrapperInformation(this["maybeBroadcastWatch"])
        },
        fragmentRegistry: {
            findFragmentSpreads: $0b54944ffd705e51$var$getWrapperInformation(fragments?.findFragmentSpreads),
            lookup: $0b54944ffd705e51$var$getWrapperInformation(fragments?.lookup),
            transform: $0b54944ffd705e51$var$getWrapperInformation(fragments?.transform)
        }
    };
}
function $0b54944ffd705e51$var$isWrapper(f) {
    return !!f && "dirtyKey" in f;
}
function $0b54944ffd705e51$var$getWrapperInformation(f) {
    return $0b54944ffd705e51$var$isWrapper(f) ? f.size : undefined;
}
function $0b54944ffd705e51$var$isDefined(value) {
    return value != null;
}
function $0b54944ffd705e51$var$transformInfo(transform) {
    return $0b54944ffd705e51$var$recurseTransformInfo(transform).map((cache)=>({
            cache: cache
        }));
}
function $0b54944ffd705e51$var$recurseTransformInfo(transform) {
    return transform ? [
        $0b54944ffd705e51$var$getWrapperInformation(transform?.["performWork"]),
        ...$0b54944ffd705e51$var$recurseTransformInfo(transform?.["left"]),
        ...$0b54944ffd705e51$var$recurseTransformInfo(transform?.["right"])
    ].filter($0b54944ffd705e51$var$isDefined) : [];
}
function $0b54944ffd705e51$var$linkInfo(link) {
    return link ? [
        link?.getMemoryInternals?.(),
        ...$0b54944ffd705e51$var$linkInfo(link?.left),
        ...$0b54944ffd705e51$var$linkInfo(link?.right)
    ].filter($0b54944ffd705e51$var$isDefined) : [];
}


const $a82bc0d00c91b19f$export$88a0ad9b6f961b51 = Object.assign(function canonicalStringify(value) {
    return JSON.stringify(value, $a82bc0d00c91b19f$var$stableObjectReplacer);
}, {
    reset () {
        // Clearing the sortingMap will reclaim all cached memory, without
        // affecting the logical results of canonicalStringify, but potentially
        // sacrificing performance until the cache is refilled.
        $a82bc0d00c91b19f$var$sortingMap = new (0, $1abac2280838e114$export$5b4f745137d91413)((0, $9f7df0d640a1952d$export$f29926b23b28936b).canonicalStringify || 1000 /* defaultCacheSizes.canonicalStringify */ );
    }
});
if (0, $e15192e15b3ad6c1$export$a866f231438cc228) (0, $0b54944ffd705e51$export$a8fcd406d9e37621)("canonicalStringify", ()=>$a82bc0d00c91b19f$var$sortingMap.size);
// Values are JSON-serialized arrays of object keys (in any order), and values
// are sorted arrays of the same keys.
let $a82bc0d00c91b19f$var$sortingMap;
$a82bc0d00c91b19f$export$88a0ad9b6f961b51.reset();
// The JSON.stringify function takes an optional second argument called a
// replacer function. This function is called for each key-value pair in the
// object being stringified, and its return value is used instead of the
// original value. If the replacer function returns a new value, that value is
// stringified as JSON instead of the original value of the property.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter
function $a82bc0d00c91b19f$var$stableObjectReplacer(key, value) {
    if (value && typeof value === "object") {
        const proto = Object.getPrototypeOf(value);
        // We don't want to mess with objects that are not "plain" objects, which
        // means their prototype is either Object.prototype or null. This check also
        // prevents needlessly rearranging the indices of arrays.
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys is already sorted, let JSON.stringify serialize the original
            // value instead of creating a new object with keys in the same order.
            if (keys.every($a82bc0d00c91b19f$var$everyKeyInOrder)) return value;
            const unsortedKey = JSON.stringify(keys);
            let sortedKeys = $a82bc0d00c91b19f$var$sortingMap.get(unsortedKey);
            if (!sortedKeys) {
                keys.sort();
                const sortedKey = JSON.stringify(keys);
                // Checking for sortedKey in the sortingMap allows us to share the same
                // sorted array reference for all permutations of the same set of keys.
                sortedKeys = $a82bc0d00c91b19f$var$sortingMap.get(sortedKey) || keys;
                $a82bc0d00c91b19f$var$sortingMap.set(unsortedKey, sortedKeys);
                $a82bc0d00c91b19f$var$sortingMap.set(sortedKey, sortedKeys);
            }
            const sortedObject = Object.create(proto);
            // Reassigning the keys in sorted order will cause JSON.stringify to
            // serialize them in sorted order.
            sortedKeys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
// Since everything that happens in stableObjectReplacer benefits from being as
// efficient as possible, we use a static function as the callback for
// keys.every in order to test if the provided keys are already sorted without
// allocating extra memory for a callback.
function $a82bc0d00c91b19f$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}



function $bd9ebed9dbc5fc01$export$c575245edbf7ac9c(query, options) {
    const { queryKey: queryKey = [], variables: variables } = options;
    const canonicalVariables = (0, $a82bc0d00c91b19f$export$88a0ad9b6f961b51)(variables);
    // This state value let's us maintain the variables used for the cache key
    // when `skipToken` is used to skip a query after its been executed.
    // Since options aren't provided when using `skipToken`, `variables` would
    // otherwise disappear which means we'd return a new cache key without a
    // variables value which creates a new `ObservableQuery` instance. This was
    // particularly problematic when `refetchQueries` was used because it meant
    // refetching against an `ObservableQuery` instance that had no variables.
    let [cacheKeyVariables, setCacheKeyVariables] = $gRqVZ.useState(canonicalVariables);
    if (options !== (0, $57d3755bf6de1db3$export$1aa5a89531b7670d) && cacheKeyVariables !== canonicalVariables) setCacheKeyVariables(cacheKeyVariables = canonicalVariables);
    return [
        query,
        cacheKeyVariables,
        ...[].concat(queryKey)
    ];
}




function $ba512aa9b1c8dd7d$export$333620696aa09b04(options) {
    const { fetchPolicy: fetchPolicy, returnPartialData: returnPartialData } = options;
    $ba512aa9b1c8dd7d$var$validateFetchPolicy(fetchPolicy);
    $ba512aa9b1c8dd7d$var$validatePartialDataReturn(fetchPolicy, returnPartialData);
}
function $ba512aa9b1c8dd7d$var$validateFetchPolicy(fetchPolicy = "cache-first") {
    const supportedFetchPolicies = [
        "cache-first",
        "network-only",
        "no-cache",
        "cache-and-network"
    ];
    (0, $aa2d7231b5e28112$export$f5708dca728d7177)(supportedFetchPolicies.includes(fetchPolicy), 35, fetchPolicy);
}
function $ba512aa9b1c8dd7d$var$validatePartialDataReturn(fetchPolicy, returnPartialData) {
    if (fetchPolicy === "no-cache" && returnPartialData) (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).warn(36);
}



function $a54845280ff230ed$export$5bf2755c0a009e74(query, options) {
    "use no memo";
    return (0, $722bb6613a4cb86c$export$7f12579c79e39619)("useSuspenseQuery", $a54845280ff230ed$var$useSuspenseQuery_, (0, $b86ffbc6c4f7be29$export$eb9a56e7a29e494)(typeof options === "object" ? options.client : undefined))(query, options ?? {});
}
function $a54845280ff230ed$var$useSuspenseQuery_(query, options) {
    const client = (0, $b86ffbc6c4f7be29$export$eb9a56e7a29e494)(options.client);
    const suspenseCache = (0, $656a72ab9e97214c$export$d841506be5d0acb2)(client);
    const watchQueryOptions = $a54845280ff230ed$export$85ae642579670efb({
        client: client,
        query: query,
        options: options
    });
    const { fetchPolicy: fetchPolicy } = watchQueryOptions;
    const cacheKey = (0, $bd9ebed9dbc5fc01$export$c575245edbf7ac9c)(query, options);
    const queryRef = suspenseCache.getQueryRef(cacheKey, ()=>client.watchQuery(watchQueryOptions));
    let [current, setPromise] = $gRqVZ.useState([
        queryRef.key,
        queryRef.promise
    ]);
    // This saves us a re-execution of the render function when a variable changed.
    if (current[0] !== queryRef.key) {
        // eslint-disable-next-line react-hooks/immutability
        current[0] = queryRef.key;
        // eslint-disable-next-line react-hooks/immutability
        current[1] = queryRef.promise;
    }
    let promise = current[1];
    if (queryRef.didChangeOptions(watchQueryOptions)) // eslint-disable-next-line react-hooks/immutability
    current[1] = promise = queryRef.applyOptions(watchQueryOptions);
    $gRqVZ.useEffect(()=>{
        const dispose = queryRef.retain();
        const removeListener = queryRef.listen((promise)=>{
            setPromise([
                queryRef.key,
                promise
            ]);
        });
        return ()=>{
            removeListener();
            dispose();
        };
    }, [
        queryRef
    ]);
    const skipResult = $gRqVZ.useMemo(()=>{
        const error = queryRef.result.error;
        const complete = !!queryRef.result.data;
        return {
            loading: false,
            data: queryRef.result.data,
            dataState: queryRef.result.dataState,
            networkStatus: error ? (0, $28ed6ef232a84776$export$bd096ddbd246c79c).error : (0, $28ed6ef232a84776$export$bd096ddbd246c79c).ready,
            error: error,
            complete: complete,
            partial: !complete
        };
    }, [
        queryRef.result
    ]);
    const result = fetchPolicy === "standby" ? skipResult : (0, $677af4f28976dee6$export$92629c20d6a56587)(promise);
    const fetchMore = $gRqVZ.useCallback((options)=>{
        const promise = queryRef.fetchMore(options);
        setPromise([
            queryRef.key,
            queryRef.promise
        ]);
        return promise;
    }, [
        queryRef
    ]);
    const refetch = $gRqVZ.useCallback((variables)=>{
        const promise = queryRef.refetch(variables);
        setPromise([
            queryRef.key,
            queryRef.promise
        ]);
        return promise;
    }, [
        queryRef
    ]);
    // TODO: The internalQueryRef doesn't have TVariables' type information so we have to cast it here
    const subscribeToMore = queryRef.observable.subscribeToMore;
    return $gRqVZ.useMemo(()=>{
        return {
            client: client,
            data: result.data,
            dataState: result.dataState,
            error: result.error,
            networkStatus: result.networkStatus,
            fetchMore: fetchMore,
            refetch: refetch,
            subscribeToMore: subscribeToMore
        };
    }, [
        client,
        fetchMore,
        refetch,
        result,
        subscribeToMore
    ]);
}
function $a54845280ff230ed$export$85ae642579670efb({ client: client, query: query, options: options }) {
    return (0, $77991ab9e45be800$export$722debc0e56fea39)(()=>{
        if (options === (0, $57d3755bf6de1db3$export$1aa5a89531b7670d)) return {
            query: query,
            fetchPolicy: "standby",
            [(0, $16b2c739aa564ddd$export$868b9638ff105835)]: true
        };
        const fetchPolicy = options.fetchPolicy || client.defaultOptions.watchQuery?.fetchPolicy || "cache-first";
        const watchQueryOptions = {
            ...options,
            fetchPolicy: fetchPolicy,
            query: query,
            notifyOnNetworkStatusChange: false,
            nextFetchPolicy: void 0
        };
        if (0, $e15192e15b3ad6c1$export$a866f231438cc228) (0, $ba512aa9b1c8dd7d$export$333620696aa09b04)(watchQueryOptions);
        // Assign the updated fetch policy after our validation since `standby` is
        // not a supported fetch policy on its own without the use of `skip`.
        if (options.skip) watchQueryOptions.fetchPolicy = "standby";
        return watchQueryOptions;
    }, [
        client,
        options,
        query
    ]);
}


const $93486c083cb38a29$var$defaultOptions = {};
var $93486c083cb38a29$export$f53d19d11ff26988 = /*#__PURE__*/ function(Adp_Constraint) {
    /** unique or primary key constraint on columns "id" */ Adp_Constraint["AdpPkey"] = "adp_pkey";
    return Adp_Constraint;
}({});
var $93486c083cb38a29$export$d348bfd774802749 = /*#__PURE__*/ function(Adp_Select_Column) {
    /** column name */ Adp_Select_Column["CreatedAt"] = "created_at";
    /** column name */ Adp_Select_Column["Id"] = "id";
    /** column name */ Adp_Select_Column["PtoBalances"] = "ptoBalances";
    /** column name */ Adp_Select_Column["PtoRequests"] = "ptoRequests";
    /** column name */ Adp_Select_Column["UpdatedAt"] = "updated_at";
    /** column name */ Adp_Select_Column["Worker"] = "worker";
    return Adp_Select_Column;
}({});
var $93486c083cb38a29$export$6a30dbb08b769ef7 = /*#__PURE__*/ function(Adp_Update_Column) {
    /** column name */ Adp_Update_Column["CreatedAt"] = "created_at";
    /** column name */ Adp_Update_Column["Id"] = "id";
    /** column name */ Adp_Update_Column["PtoBalances"] = "ptoBalances";
    /** column name */ Adp_Update_Column["PtoRequests"] = "ptoRequests";
    /** column name */ Adp_Update_Column["UpdatedAt"] = "updated_at";
    /** column name */ Adp_Update_Column["Worker"] = "worker";
    return Adp_Update_Column;
}({});
var $93486c083cb38a29$export$52e85d6a32212949 = /*#__PURE__*/ function(BulletinDepartments_Constraint) {
    /** unique or primary key constraint on columns "department_id", "bulletin_id" */ BulletinDepartments_Constraint["BulletinDepartmentPkey"] = "bulletin_department_pkey";
    return BulletinDepartments_Constraint;
}({});
var $93486c083cb38a29$export$e31a2bb337eecb07 = /*#__PURE__*/ function(BulletinDepartments_Select_Column) {
    /** column name */ BulletinDepartments_Select_Column["BulletinId"] = "bulletinId";
    /** column name */ BulletinDepartments_Select_Column["DepartmentId"] = "departmentId";
    return BulletinDepartments_Select_Column;
}({});
var $93486c083cb38a29$export$1aa28f4252df70b2 = /*#__PURE__*/ function(BulletinDepartments_Update_Column) {
    /** column name */ BulletinDepartments_Update_Column["BulletinId"] = "bulletinId";
    /** column name */ BulletinDepartments_Update_Column["DepartmentId"] = "departmentId";
    return BulletinDepartments_Update_Column;
}({});
var $93486c083cb38a29$export$c3f7f31791ffd66f = /*#__PURE__*/ function(BulletinsResources_Constraint) {
    /** unique or primary key constraint on columns "id" */ BulletinsResources_Constraint["BulletinsResourcesPkey"] = "bulletins_resources_pkey";
    return BulletinsResources_Constraint;
}({});
var $93486c083cb38a29$export$f2103c3724866918 = /*#__PURE__*/ function(BulletinsResources_Select_Column) {
    /** column name */ BulletinsResources_Select_Column["BulletinId"] = "bulletinId";
    /** column name */ BulletinsResources_Select_Column["Id"] = "id";
    /** column name */ BulletinsResources_Select_Column["ResourceId"] = "resourceId";
    return BulletinsResources_Select_Column;
}({});
var $93486c083cb38a29$export$cab33add4be27d01 = /*#__PURE__*/ function(BulletinsResources_Update_Column) {
    /** column name */ BulletinsResources_Update_Column["BulletinId"] = "bulletinId";
    /** column name */ BulletinsResources_Update_Column["Id"] = "id";
    /** column name */ BulletinsResources_Update_Column["ResourceId"] = "resourceId";
    return BulletinsResources_Update_Column;
}({});
var $93486c083cb38a29$export$94a670a2724c765e = /*#__PURE__*/ function(Bulletins_Constraint) {
    /** unique or primary key constraint on columns "id" */ Bulletins_Constraint["BulletinsPkey"] = "bulletins_pkey";
    return Bulletins_Constraint;
}({});
var $93486c083cb38a29$export$d55aabc7f872d27d = /*#__PURE__*/ function(Bulletins_Select_Column) {
    /** column name */ Bulletins_Select_Column["AuthorId"] = "authorId";
    /** column name */ Bulletins_Select_Column["CreatedAt"] = "createdAt";
    /** column name */ Bulletins_Select_Column["Global"] = "global";
    /** column name */ Bulletins_Select_Column["Id"] = "id";
    /** column name */ Bulletins_Select_Column["LeadImageUploadId"] = "leadImageUploadId";
    /** column name */ Bulletins_Select_Column["ModelType"] = "modelType";
    /** column name */ Bulletins_Select_Column["Post"] = "post";
    /** column name */ Bulletins_Select_Column["Title"] = "title";
    /** column name */ Bulletins_Select_Column["UpdatedAt"] = "updatedAt";
    return Bulletins_Select_Column;
}({});
var $93486c083cb38a29$export$400e5a069865c89f = /*#__PURE__*/ function(Bulletins_Update_Column) {
    /** column name */ Bulletins_Update_Column["AuthorId"] = "authorId";
    /** column name */ Bulletins_Update_Column["CreatedAt"] = "createdAt";
    /** column name */ Bulletins_Update_Column["Global"] = "global";
    /** column name */ Bulletins_Update_Column["Id"] = "id";
    /** column name */ Bulletins_Update_Column["LeadImageUploadId"] = "leadImageUploadId";
    /** column name */ Bulletins_Update_Column["ModelType"] = "modelType";
    /** column name */ Bulletins_Update_Column["Post"] = "post";
    /** column name */ Bulletins_Update_Column["Title"] = "title";
    /** column name */ Bulletins_Update_Column["UpdatedAt"] = "updatedAt";
    return Bulletins_Update_Column;
}({});
var $93486c083cb38a29$export$4bda50d5ee3b020f = /*#__PURE__*/ function(CameraEmbeds_Constraint) {
    /** unique or primary key constraint on columns "id" */ CameraEmbeds_Constraint["CameraEmbedsPkey"] = "camera_embeds_pkey";
    return CameraEmbeds_Constraint;
}({});
var $93486c083cb38a29$export$c902b0abb9b9cd48 = /*#__PURE__*/ function(CameraEmbeds_Select_Column) {
    /** column name */ CameraEmbeds_Select_Column["Active"] = "active";
    /** column name */ CameraEmbeds_Select_Column["CreatedAt"] = "createdAt";
    /** column name */ CameraEmbeds_Select_Column["Id"] = "id";
    /** column name */ CameraEmbeds_Select_Column["JobsiteId"] = "jobsiteId";
    /** column name */ CameraEmbeds_Select_Column["Source"] = "source";
    /** column name */ CameraEmbeds_Select_Column["StillUrl"] = "stillUrl";
    /** column name */ CameraEmbeds_Select_Column["Title"] = "title";
    /** column name */ CameraEmbeds_Select_Column["UpdatedAt"] = "updatedAt";
    return CameraEmbeds_Select_Column;
}({});
var $93486c083cb38a29$export$457face8c08e5def = /*#__PURE__*/ function(CameraEmbeds_Update_Column) {
    /** column name */ CameraEmbeds_Update_Column["Active"] = "active";
    /** column name */ CameraEmbeds_Update_Column["CreatedAt"] = "createdAt";
    /** column name */ CameraEmbeds_Update_Column["Id"] = "id";
    /** column name */ CameraEmbeds_Update_Column["JobsiteId"] = "jobsiteId";
    /** column name */ CameraEmbeds_Update_Column["Source"] = "source";
    /** column name */ CameraEmbeds_Update_Column["StillUrl"] = "stillUrl";
    /** column name */ CameraEmbeds_Update_Column["Title"] = "title";
    /** column name */ CameraEmbeds_Update_Column["UpdatedAt"] = "updatedAt";
    return CameraEmbeds_Update_Column;
}({});
var $93486c083cb38a29$export$530ee02a7a2008e6 = /*#__PURE__*/ function(Comments_Constraint) {
    /** unique or primary key constraint on columns "id" */ Comments_Constraint["CommentsPkey"] = "comments_pkey";
    return Comments_Constraint;
}({});
var $93486c083cb38a29$export$ec5f4d44d55154fd = /*#__PURE__*/ function(Comments_Select_Column) {
    /** column name */ Comments_Select_Column["BulletinId"] = "bulletinId";
    /** column name */ Comments_Select_Column["Comment"] = "comment";
    /** column name */ Comments_Select_Column["CreatedAt"] = "createdAt";
    /** column name */ Comments_Select_Column["DiscussionId"] = "discussionId";
    /** column name */ Comments_Select_Column["Id"] = "id";
    /** column name */ Comments_Select_Column["NominationId"] = "nominationId";
    /** column name */ Comments_Select_Column["UpdatedAt"] = "updatedAt";
    /** column name */ Comments_Select_Column["UserId"] = "userId";
    return Comments_Select_Column;
}({});
var $93486c083cb38a29$export$e3449c328ae5d15c = /*#__PURE__*/ function(Comments_Update_Column) {
    /** column name */ Comments_Update_Column["BulletinId"] = "bulletinId";
    /** column name */ Comments_Update_Column["Comment"] = "comment";
    /** column name */ Comments_Update_Column["CreatedAt"] = "createdAt";
    /** column name */ Comments_Update_Column["DiscussionId"] = "discussionId";
    /** column name */ Comments_Update_Column["Id"] = "id";
    /** column name */ Comments_Update_Column["NominationId"] = "nominationId";
    /** column name */ Comments_Update_Column["UpdatedAt"] = "updatedAt";
    /** column name */ Comments_Update_Column["UserId"] = "userId";
    return Comments_Update_Column;
}({});
var $93486c083cb38a29$export$fbb02d6f630c2f23 = /*#__PURE__*/ function(Config_Constraint) {
    /** unique or primary key constraint on columns "key" */ Config_Constraint["ConfigPkey"] = "config_pkey";
    return Config_Constraint;
}({});
var $93486c083cb38a29$export$4ab94d8b333c656 = /*#__PURE__*/ function(Config_Select_Column) {
    /** column name */ Config_Select_Column["Key"] = "key";
    /** column name */ Config_Select_Column["Value"] = "value";
    return Config_Select_Column;
}({});
var $93486c083cb38a29$export$9a6c4a5b1ada44a1 = /*#__PURE__*/ function(Config_Update_Column) {
    /** column name */ Config_Update_Column["Key"] = "key";
    /** column name */ Config_Update_Column["Value"] = "value";
    return Config_Update_Column;
}({});
var $93486c083cb38a29$export$f498427507e51221 = /*#__PURE__*/ function(ContentsResources_Constraint) {
    /** unique or primary key constraint on columns "resource_id", "department_content_id" */ ContentsResources_Constraint["DepartmentContentsResourcesDepartmentContentIdResourcKey"] = "department_contents_resources_department_content_id_resourc_key";
    /** unique or primary key constraint on columns "id" */ ContentsResources_Constraint["DepartmentContentsResourcesPkey"] = "department_contents_resources_pkey";
    return ContentsResources_Constraint;
}({});
var $93486c083cb38a29$export$12d0b80db232f35b = /*#__PURE__*/ function(ContentsResources_Select_Column) {
    /** column name */ ContentsResources_Select_Column["DepartmentContentId"] = "departmentContentId";
    /** column name */ ContentsResources_Select_Column["Id"] = "id";
    /** column name */ ContentsResources_Select_Column["ResourceId"] = "resourceId";
    return ContentsResources_Select_Column;
}({});
var $93486c083cb38a29$export$67babffd72717320 = /*#__PURE__*/ function(ContentsResources_Update_Column) {
    /** column name */ ContentsResources_Update_Column["DepartmentContentId"] = "departmentContentId";
    /** column name */ ContentsResources_Update_Column["Id"] = "id";
    /** column name */ ContentsResources_Update_Column["ResourceId"] = "resourceId";
    return ContentsResources_Update_Column;
}({});
var $93486c083cb38a29$export$531eca6a37a66f70 = /*#__PURE__*/ function(Contents_Constraint) {
    /** unique or primary key constraint on columns "id" */ Contents_Constraint["DepartmentContentsPkey"] = "department_contents_pkey";
    return Contents_Constraint;
}({});
var $93486c083cb38a29$export$97f321162335afa3 = /*#__PURE__*/ function(Contents_Select_Column) {
    /** column name */ Contents_Select_Column["Active"] = "active";
    /** column name */ Contents_Select_Column["Body"] = "body";
    /** column name */ Contents_Select_Column["CreatedAt"] = "createdAt";
    /** column name */ Contents_Select_Column["DepartmentId"] = "departmentId";
    /** column name */ Contents_Select_Column["Id"] = "id";
    /** column name */ Contents_Select_Column["ParentId"] = "parentId";
    /** column name */ Contents_Select_Column["Title"] = "title";
    /** column name */ Contents_Select_Column["UpdatedAt"] = "updatedAt";
    return Contents_Select_Column;
}({});
var $93486c083cb38a29$export$cfc72305d7cb52b8 = /*#__PURE__*/ function(Contents_Select_Column_Contents_Aggregate_Bool_Exp_Bool_And_Arguments_Columns) {
    /** column name */ Contents_Select_Column_Contents_Aggregate_Bool_Exp_Bool_And_Arguments_Columns["Active"] = "active";
    return Contents_Select_Column_Contents_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
}({});
var $93486c083cb38a29$export$f93c2cdc02493355 = /*#__PURE__*/ function(Contents_Select_Column_Contents_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns) {
    /** column name */ Contents_Select_Column_Contents_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns["Active"] = "active";
    return Contents_Select_Column_Contents_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
}({});
var $93486c083cb38a29$export$3d354da0c5776505 = /*#__PURE__*/ function(Contents_Update_Column) {
    /** column name */ Contents_Update_Column["Active"] = "active";
    /** column name */ Contents_Update_Column["Body"] = "body";
    /** column name */ Contents_Update_Column["CreatedAt"] = "createdAt";
    /** column name */ Contents_Update_Column["DepartmentId"] = "departmentId";
    /** column name */ Contents_Update_Column["Id"] = "id";
    /** column name */ Contents_Update_Column["ParentId"] = "parentId";
    /** column name */ Contents_Update_Column["Title"] = "title";
    /** column name */ Contents_Update_Column["UpdatedAt"] = "updatedAt";
    return Contents_Update_Column;
}({});
var $93486c083cb38a29$export$a7538b1f460344bb = /*#__PURE__*/ function(Cursor_Ordering) {
    /** ascending ordering of the cursor */ Cursor_Ordering["Asc"] = "ASC";
    /** descending ordering of the cursor */ Cursor_Ordering["Desc"] = "DESC";
    return Cursor_Ordering;
}({});
var $93486c083cb38a29$export$f0a80a519891caf8 = /*#__PURE__*/ function(DepartmentFaqs_Constraint) {
    /** unique or primary key constraint on columns "id" */ DepartmentFaqs_Constraint["DepartmentFaqsPkey"] = "department_faqs_pkey";
    return DepartmentFaqs_Constraint;
}({});
var $93486c083cb38a29$export$a491b47b78113f96 = /*#__PURE__*/ function(DepartmentFaqs_Select_Column) {
    /** column name */ DepartmentFaqs_Select_Column["Answer"] = "answer";
    /** column name */ DepartmentFaqs_Select_Column["CreatedAt"] = "createdAt";
    /** column name */ DepartmentFaqs_Select_Column["DepartmentId"] = "departmentId";
    /** column name */ DepartmentFaqs_Select_Column["Id"] = "id";
    /** column name */ DepartmentFaqs_Select_Column["Question"] = "question";
    /** column name */ DepartmentFaqs_Select_Column["UpdatedAt"] = "updatedAt";
    return DepartmentFaqs_Select_Column;
}({});
var $93486c083cb38a29$export$75ae8cf5a0fa1878 = /*#__PURE__*/ function(DepartmentFaqs_Update_Column) {
    /** column name */ DepartmentFaqs_Update_Column["Answer"] = "answer";
    /** column name */ DepartmentFaqs_Update_Column["CreatedAt"] = "createdAt";
    /** column name */ DepartmentFaqs_Update_Column["DepartmentId"] = "departmentId";
    /** column name */ DepartmentFaqs_Update_Column["Id"] = "id";
    /** column name */ DepartmentFaqs_Update_Column["Question"] = "question";
    /** column name */ DepartmentFaqs_Update_Column["UpdatedAt"] = "updatedAt";
    return DepartmentFaqs_Update_Column;
}({});
var $93486c083cb38a29$export$e820d1a3b3e2ec38 = /*#__PURE__*/ function(DepartmentQuicklinks_Constraint) {
    /** unique or primary key constraint on columns "id" */ DepartmentQuicklinks_Constraint["DepartmentQuicklinksPkey"] = "department_quicklinks_pkey";
    return DepartmentQuicklinks_Constraint;
}({});
var $93486c083cb38a29$export$4f72a635e0dd18b0 = /*#__PURE__*/ function(DepartmentQuicklinks_Select_Column) {
    /** column name */ DepartmentQuicklinks_Select_Column["CreatedAt"] = "createdAt";
    /** column name */ DepartmentQuicklinks_Select_Column["DepartmentId"] = "departmentId";
    /** column name */ DepartmentQuicklinks_Select_Column["Description"] = "description";
    /** column name */ DepartmentQuicklinks_Select_Column["Id"] = "id";
    /** column name */ DepartmentQuicklinks_Select_Column["Title"] = "title";
    /** column name */ DepartmentQuicklinks_Select_Column["UpdatedAt"] = "updatedAt";
    /** column name */ DepartmentQuicklinks_Select_Column["Url"] = "url";
    return DepartmentQuicklinks_Select_Column;
}({});
var $93486c083cb38a29$export$baeac5b539b172a8 = /*#__PURE__*/ function(DepartmentQuicklinks_Update_Column) {
    /** column name */ DepartmentQuicklinks_Update_Column["CreatedAt"] = "createdAt";
    /** column name */ DepartmentQuicklinks_Update_Column["DepartmentId"] = "departmentId";
    /** column name */ DepartmentQuicklinks_Update_Column["Description"] = "description";
    /** column name */ DepartmentQuicklinks_Update_Column["Id"] = "id";
    /** column name */ DepartmentQuicklinks_Update_Column["Title"] = "title";
    /** column name */ DepartmentQuicklinks_Update_Column["UpdatedAt"] = "updatedAt";
    /** column name */ DepartmentQuicklinks_Update_Column["Url"] = "url";
    return DepartmentQuicklinks_Update_Column;
}({});
var $93486c083cb38a29$export$1682b1567ba89f2e = /*#__PURE__*/ function(Departments_Constraint) {
    /** unique or primary key constraint on columns "id" */ Departments_Constraint["DepartmentsPkey"] = "departments_pkey";
    return Departments_Constraint;
}({});
var $93486c083cb38a29$export$78cea3b005f236b7 = /*#__PURE__*/ function(Departments_Select_Column) {
    /** column name */ Departments_Select_Column["CreatedAt"] = "createdAt";
    /** column name */ Departments_Select_Column["Id"] = "id";
    /** column name */ Departments_Select_Column["LogoUploadId"] = "logoUploadId";
    /** column name */ Departments_Select_Column["MastheadUploadId"] = "mastheadUploadId";
    /** column name */ Departments_Select_Column["MissionStatement"] = "missionStatement";
    /** column name */ Departments_Select_Column["OwnerId"] = "ownerId";
    /** column name */ Departments_Select_Column["Title"] = "title";
    /** column name */ Departments_Select_Column["UpdatedAt"] = "updatedAt";
    return Departments_Select_Column;
}({});
var $93486c083cb38a29$export$631906627be30309 = /*#__PURE__*/ function(Departments_Update_Column) {
    /** column name */ Departments_Update_Column["CreatedAt"] = "createdAt";
    /** column name */ Departments_Update_Column["Id"] = "id";
    /** column name */ Departments_Update_Column["LogoUploadId"] = "logoUploadId";
    /** column name */ Departments_Update_Column["MastheadUploadId"] = "mastheadUploadId";
    /** column name */ Departments_Update_Column["MissionStatement"] = "missionStatement";
    /** column name */ Departments_Update_Column["OwnerId"] = "ownerId";
    /** column name */ Departments_Update_Column["Title"] = "title";
    /** column name */ Departments_Update_Column["UpdatedAt"] = "updatedAt";
    return Departments_Update_Column;
}({});
var $93486c083cb38a29$export$811486232135139c = /*#__PURE__*/ function(Discussions_Constraint) {
    /** unique or primary key constraint on columns "id" */ Discussions_Constraint["DiscussionsPkey"] = "discussions_pkey";
    return Discussions_Constraint;
}({});
var $93486c083cb38a29$export$612a4121efc24fd5 = /*#__PURE__*/ function(Discussions_Select_Column) {
    /** column name */ Discussions_Select_Column["AuthorId"] = "authorId";
    /** column name */ Discussions_Select_Column["CreatedAt"] = "createdAt";
    /** column name */ Discussions_Select_Column["DepartmentId"] = "departmentId";
    /** column name */ Discussions_Select_Column["Id"] = "id";
    /** column name */ Discussions_Select_Column["Post"] = "post";
    /** column name */ Discussions_Select_Column["Title"] = "title";
    /** column name */ Discussions_Select_Column["UpdatedAt"] = "updatedAt";
    return Discussions_Select_Column;
}({});
var $93486c083cb38a29$export$aec6fa8f4062dc76 = /*#__PURE__*/ function(Discussions_Update_Column) {
    /** column name */ Discussions_Update_Column["AuthorId"] = "authorId";
    /** column name */ Discussions_Update_Column["CreatedAt"] = "createdAt";
    /** column name */ Discussions_Update_Column["DepartmentId"] = "departmentId";
    /** column name */ Discussions_Update_Column["Id"] = "id";
    /** column name */ Discussions_Update_Column["Post"] = "post";
    /** column name */ Discussions_Update_Column["Title"] = "title";
    /** column name */ Discussions_Update_Column["UpdatedAt"] = "updatedAt";
    return Discussions_Update_Column;
}({});
var $93486c083cb38a29$export$9f086fe574a4142f = /*#__PURE__*/ function(EventTypes_Constraint) {
    /** unique or primary key constraint on columns "value" */ EventTypes_Constraint["EventTypesPkey"] = "event_types_pkey";
    return EventTypes_Constraint;
}({});
var $93486c083cb38a29$export$b6865b72c242600b = /*#__PURE__*/ function(EventTypes_Enum) {
    EventTypes_Enum["Birthday"] = "BIRTHDAY";
    EventTypes_Enum["Holiday"] = "HOLIDAY";
    EventTypes_Enum["IndustryEvent"] = "INDUSTRY_EVENT";
    EventTypes_Enum["NibbiEvent"] = "NIBBI_EVENT";
    EventTypes_Enum["OaklandOffice"] = "OAKLAND_OFFICE";
    EventTypes_Enum["Pto"] = "PTO";
    EventTypes_Enum["Training"] = "TRAINING";
    return EventTypes_Enum;
}({});
var $93486c083cb38a29$export$fda7dc42c1c527f1 = /*#__PURE__*/ function(EventTypes_Select_Column) {
    /** column name */ EventTypes_Select_Column["Comment"] = "comment";
    /** column name */ EventTypes_Select_Column["Value"] = "value";
    return EventTypes_Select_Column;
}({});
var $93486c083cb38a29$export$adbc7153456dd87 = /*#__PURE__*/ function(EventTypes_Update_Column) {
    /** column name */ EventTypes_Update_Column["Comment"] = "comment";
    /** column name */ EventTypes_Update_Column["Value"] = "value";
    return EventTypes_Update_Column;
}({});
var $93486c083cb38a29$export$2267abd9e65fe96c = /*#__PURE__*/ function(Events_Constraint) {
    /** unique or primary key constraint on columns "id" */ Events_Constraint["EventsPkey"] = "events_pkey";
    return Events_Constraint;
}({});
var $93486c083cb38a29$export$f6b3e5d84af07145 = /*#__PURE__*/ function(Events_Old_Constraint) {
    /** unique or primary key constraint on columns "id" */ Events_Old_Constraint["Idx_110095Primary"] = "idx_110095_primary";
    return Events_Old_Constraint;
}({});
var $93486c083cb38a29$export$a848997f9b712275 = /*#__PURE__*/ function(Events_Old_Select_Column) {
    /** column name */ Events_Old_Select_Column["AllDay"] = "all_day";
    /** column name */ Events_Old_Select_Column["CalendarType"] = "calendar_type";
    /** column name */ Events_Old_Select_Column["CreatedAt"] = "created_at";
    /** column name */ Events_Old_Select_Column["Description"] = "description";
    /** column name */ Events_Old_Select_Column["EndsAt"] = "ends_at";
    /** column name */ Events_Old_Select_Column["EventableId"] = "eventable_id";
    /** column name */ Events_Old_Select_Column["EventableType"] = "eventable_type";
    /** column name */ Events_Old_Select_Column["Id"] = "id";
    /** column name */ Events_Old_Select_Column["StartsAt"] = "starts_at";
    /** column name */ Events_Old_Select_Column["Title"] = "title";
    /** column name */ Events_Old_Select_Column["UpdatedAt"] = "updated_at";
    return Events_Old_Select_Column;
}({});
var $93486c083cb38a29$export$86ce57716c30fcc2 = /*#__PURE__*/ function(Events_Old_Update_Column) {
    /** column name */ Events_Old_Update_Column["AllDay"] = "all_day";
    /** column name */ Events_Old_Update_Column["CalendarType"] = "calendar_type";
    /** column name */ Events_Old_Update_Column["CreatedAt"] = "created_at";
    /** column name */ Events_Old_Update_Column["Description"] = "description";
    /** column name */ Events_Old_Update_Column["EndsAt"] = "ends_at";
    /** column name */ Events_Old_Update_Column["EventableId"] = "eventable_id";
    /** column name */ Events_Old_Update_Column["EventableType"] = "eventable_type";
    /** column name */ Events_Old_Update_Column["Id"] = "id";
    /** column name */ Events_Old_Update_Column["StartsAt"] = "starts_at";
    /** column name */ Events_Old_Update_Column["Title"] = "title";
    /** column name */ Events_Old_Update_Column["UpdatedAt"] = "updated_at";
    return Events_Old_Update_Column;
}({});
var $93486c083cb38a29$export$8a3a2b635295ce76 = /*#__PURE__*/ function(Events_Select_Column) {
    /** column name */ Events_Select_Column["AdpRequestId"] = "adp_request_id";
    /** column name */ Events_Select_Column["AllDay"] = "allDay";
    /** column name */ Events_Select_Column["Description"] = "description";
    /** column name */ Events_Select_Column["EndsAt"] = "endsAt";
    /** column name */ Events_Select_Column["Id"] = "id";
    /** column name */ Events_Select_Column["StartsAt"] = "startsAt";
    /** column name */ Events_Select_Column["Title"] = "title";
    /** column name */ Events_Select_Column["Type"] = "type";
    return Events_Select_Column;
}({});
var $93486c083cb38a29$export$177154096b4404b8 = /*#__PURE__*/ function(Events_Update_Column) {
    /** column name */ Events_Update_Column["AdpRequestId"] = "adp_request_id";
    /** column name */ Events_Update_Column["AllDay"] = "allDay";
    /** column name */ Events_Update_Column["Description"] = "description";
    /** column name */ Events_Update_Column["EndsAt"] = "endsAt";
    /** column name */ Events_Update_Column["Id"] = "id";
    /** column name */ Events_Update_Column["StartsAt"] = "startsAt";
    /** column name */ Events_Update_Column["Title"] = "title";
    /** column name */ Events_Update_Column["Type"] = "type";
    return Events_Update_Column;
}({});
var $93486c083cb38a29$export$1e283f0064df8ab2 = /*#__PURE__*/ function(FavoriteDiscussions_Constraint) {
    /** unique or primary key constraint on columns "id" */ FavoriteDiscussions_Constraint["FavoriteDiscussionsPkey"] = "favorite_discussions_pkey";
    return FavoriteDiscussions_Constraint;
}({});
var $93486c083cb38a29$export$fee80dd6c4ff7523 = /*#__PURE__*/ function(FavoriteDiscussions_Select_Column) {
    /** column name */ FavoriteDiscussions_Select_Column["DiscussionId"] = "discussionId";
    /** column name */ FavoriteDiscussions_Select_Column["Id"] = "id";
    /** column name */ FavoriteDiscussions_Select_Column["UserId"] = "userId";
    return FavoriteDiscussions_Select_Column;
}({});
var $93486c083cb38a29$export$f16a26241a3ae565 = /*#__PURE__*/ function(FavoriteDiscussions_Update_Column) {
    /** column name */ FavoriteDiscussions_Update_Column["DiscussionId"] = "discussionId";
    /** column name */ FavoriteDiscussions_Update_Column["Id"] = "id";
    /** column name */ FavoriteDiscussions_Update_Column["UserId"] = "userId";
    return FavoriteDiscussions_Update_Column;
}({});
var $93486c083cb38a29$export$58e67577d6c0cd1c = /*#__PURE__*/ function(FavoriteResources_Constraint) {
    /** unique or primary key constraint on columns "id" */ FavoriteResources_Constraint["FavoriteResourcesPkey"] = "favorite_resources_pkey";
    return FavoriteResources_Constraint;
}({});
var $93486c083cb38a29$export$36c23feb7bfd6466 = /*#__PURE__*/ function(FavoriteResources_Select_Column) {
    /** column name */ FavoriteResources_Select_Column["Id"] = "id";
    /** column name */ FavoriteResources_Select_Column["ResourceId"] = "resourceId";
    /** column name */ FavoriteResources_Select_Column["UserId"] = "userId";
    return FavoriteResources_Select_Column;
}({});
var $93486c083cb38a29$export$d3749e7208756b3 = /*#__PURE__*/ function(FavoriteResources_Update_Column) {
    /** column name */ FavoriteResources_Update_Column["Id"] = "id";
    /** column name */ FavoriteResources_Update_Column["ResourceId"] = "resourceId";
    /** column name */ FavoriteResources_Update_Column["UserId"] = "userId";
    return FavoriteResources_Update_Column;
}({});
var $93486c083cb38a29$export$8ef9a0eb623b40e8 = /*#__PURE__*/ function(Galleries_Constraint) {
    /** unique or primary key constraint on columns "id" */ Galleries_Constraint["GalleriesPkey"] = "galleries_pkey";
    return Galleries_Constraint;
}({});
var $93486c083cb38a29$export$6980778dc6fe4640 = /*#__PURE__*/ function(Galleries_Select_Column) {
    /** column name */ Galleries_Select_Column["Active"] = "active";
    /** column name */ Galleries_Select_Column["Children"] = "children";
    /** column name */ Galleries_Select_Column["CoverPhotoId"] = "coverPhotoId";
    /** column name */ Galleries_Select_Column["CreatedAt"] = "createdAt";
    /** column name */ Galleries_Select_Column["Date"] = "date";
    /** column name */ Galleries_Select_Column["Id"] = "id";
    /** column name */ Galleries_Select_Column["Title"] = "title";
    /** column name */ Galleries_Select_Column["UpdatedAt"] = "updatedAt";
    /** column name */ Galleries_Select_Column["VideoThumbnailUploadId"] = "videoThumbnailUploadId";
    /** column name */ Galleries_Select_Column["VideoUploadId"] = "videoUploadId";
    return Galleries_Select_Column;
}({});
var $93486c083cb38a29$export$da7901259575fc79 = /*#__PURE__*/ function(Galleries_Update_Column) {
    /** column name */ Galleries_Update_Column["Active"] = "active";
    /** column name */ Galleries_Update_Column["Children"] = "children";
    /** column name */ Galleries_Update_Column["CreatedAt"] = "createdAt";
    /** column name */ Galleries_Update_Column["Date"] = "date";
    /** column name */ Galleries_Update_Column["Id"] = "id";
    /** column name */ Galleries_Update_Column["Title"] = "title";
    /** column name */ Galleries_Update_Column["UpdatedAt"] = "updatedAt";
    /** column name */ Galleries_Update_Column["VideoThumbnailUploadId"] = "videoThumbnailUploadId";
    /** column name */ Galleries_Update_Column["VideoUploadId"] = "videoUploadId";
    return Galleries_Update_Column;
}({});
var $93486c083cb38a29$export$d9b54b4da1105abf = /*#__PURE__*/ function(GalleryPhotos_Constraint) {
    /** unique or primary key constraint on columns "id" */ GalleryPhotos_Constraint["GalleryPhotosPkey"] = "gallery_photos_pkey";
    return GalleryPhotos_Constraint;
}({});
var $93486c083cb38a29$export$bc239e71ff6a3dc4 = /*#__PURE__*/ function(GalleryPhotos_Select_Column) {
    /** column name */ GalleryPhotos_Select_Column["Caption"] = "caption";
    /** column name */ GalleryPhotos_Select_Column["CreatedAt"] = "createdAt";
    /** column name */ GalleryPhotos_Select_Column["GalleryId"] = "galleryId";
    /** column name */ GalleryPhotos_Select_Column["Id"] = "id";
    /** column name */ GalleryPhotos_Select_Column["ImageUploadId"] = "imageUploadId";
    return GalleryPhotos_Select_Column;
}({});
var $93486c083cb38a29$export$9483258ef7c74e15 = /*#__PURE__*/ function(GalleryPhotos_Update_Column) {
    /** column name */ GalleryPhotos_Update_Column["Caption"] = "caption";
    /** column name */ GalleryPhotos_Update_Column["CreatedAt"] = "createdAt";
    /** column name */ GalleryPhotos_Update_Column["GalleryId"] = "galleryId";
    /** column name */ GalleryPhotos_Update_Column["Id"] = "id";
    /** column name */ GalleryPhotos_Update_Column["ImageUploadId"] = "imageUploadId";
    return GalleryPhotos_Update_Column;
}({});
var $93486c083cb38a29$export$c3997d564a3570b9 = /*#__PURE__*/ function(Jobsites_Constraint) {
    /** unique or primary key constraint on columns "id" */ Jobsites_Constraint["JobsitesPkey"] = "jobsites_pkey";
    /** unique or primary key constraint on columns "title" */ Jobsites_Constraint["JobsitesTitleKey"] = "jobsites_title_key";
    return Jobsites_Constraint;
}({});
var $93486c083cb38a29$export$11a65431f8bb2593 = /*#__PURE__*/ function(Jobsites_Select_Column) {
    /** column name */ Jobsites_Select_Column["AltNames"] = "alt_names";
    /** column name */ Jobsites_Select_Column["CreatedAt"] = "createdAt";
    /** column name */ Jobsites_Select_Column["Id"] = "id";
    /** column name */ Jobsites_Select_Column["IsHidden"] = "isHidden";
    /** column name */ Jobsites_Select_Column["MainAddress"] = "mainAddress";
    /** column name */ Jobsites_Select_Column["MainAddress2"] = "mainAddress2";
    /** column name */ Jobsites_Select_Column["MainAddressCity"] = "mainAddressCity";
    /** column name */ Jobsites_Select_Column["MainAddressState"] = "mainAddressState";
    /** column name */ Jobsites_Select_Column["MainAddressZip"] = "mainAddressZip";
    /** column name */ Jobsites_Select_Column["OfficeAddress"] = "officeAddress";
    /** column name */ Jobsites_Select_Column["OfficeAddress2"] = "officeAddress2";
    /** column name */ Jobsites_Select_Column["OfficeAddressCity"] = "officeAddressCity";
    /** column name */ Jobsites_Select_Column["OfficeAddressState"] = "officeAddressState";
    /** column name */ Jobsites_Select_Column["OfficeAddressZip"] = "officeAddressZip";
    /** column name */ Jobsites_Select_Column["Phone"] = "phone";
    /** column name */ Jobsites_Select_Column["SiteNumber"] = "siteNumber";
    /** column name */ Jobsites_Select_Column["Title"] = "title";
    /** column name */ Jobsites_Select_Column["UpdatedAt"] = "updatedAt";
    return Jobsites_Select_Column;
}({});
var $93486c083cb38a29$export$bfd0c5ac9e4635a6 = /*#__PURE__*/ function(Jobsites_Update_Column) {
    /** column name */ Jobsites_Update_Column["AltNames"] = "alt_names";
    /** column name */ Jobsites_Update_Column["CreatedAt"] = "createdAt";
    /** column name */ Jobsites_Update_Column["Id"] = "id";
    /** column name */ Jobsites_Update_Column["IsHidden"] = "isHidden";
    /** column name */ Jobsites_Update_Column["MainAddress"] = "mainAddress";
    /** column name */ Jobsites_Update_Column["MainAddress2"] = "mainAddress2";
    /** column name */ Jobsites_Update_Column["MainAddressCity"] = "mainAddressCity";
    /** column name */ Jobsites_Update_Column["MainAddressState"] = "mainAddressState";
    /** column name */ Jobsites_Update_Column["MainAddressZip"] = "mainAddressZip";
    /** column name */ Jobsites_Update_Column["OfficeAddress"] = "officeAddress";
    /** column name */ Jobsites_Update_Column["OfficeAddress2"] = "officeAddress2";
    /** column name */ Jobsites_Update_Column["OfficeAddressCity"] = "officeAddressCity";
    /** column name */ Jobsites_Update_Column["OfficeAddressState"] = "officeAddressState";
    /** column name */ Jobsites_Update_Column["OfficeAddressZip"] = "officeAddressZip";
    /** column name */ Jobsites_Update_Column["Phone"] = "phone";
    /** column name */ Jobsites_Update_Column["SiteNumber"] = "siteNumber";
    /** column name */ Jobsites_Update_Column["Title"] = "title";
    /** column name */ Jobsites_Update_Column["UpdatedAt"] = "updatedAt";
    return Jobsites_Update_Column;
}({});
var $93486c083cb38a29$export$5712c5d5c5af3080 = /*#__PURE__*/ function(Order_By) {
    /** in ascending order, nulls last */ Order_By["Asc"] = "asc";
    /** in ascending order, nulls first */ Order_By["AscNullsFirst"] = "asc_nulls_first";
    /** in ascending order, nulls last */ Order_By["AscNullsLast"] = "asc_nulls_last";
    /** in descending order, nulls first */ Order_By["Desc"] = "desc";
    /** in descending order, nulls first */ Order_By["DescNullsFirst"] = "desc_nulls_first";
    /** in descending order, nulls last */ Order_By["DescNullsLast"] = "desc_nulls_last";
    return Order_By;
}({});
var $93486c083cb38a29$export$3b92580d00487f3d = /*#__PURE__*/ function(Pages_Constraint) {
    /** unique or primary key constraint on columns "slug" */ Pages_Constraint["PagesPkey"] = "pages_pkey";
    return Pages_Constraint;
}({});
var $93486c083cb38a29$export$4d66bb657c9993cc = /*#__PURE__*/ function(Pages_Select_Column) {
    /** column name */ Pages_Select_Column["Body"] = "body";
    /** column name */ Pages_Select_Column["Children"] = "children";
    /** column name */ Pages_Select_Column["CreatedAt"] = "createdAt";
    /** column name */ Pages_Select_Column["Id"] = "id";
    /** column name */ Pages_Select_Column["MastheadUploadId"] = "mastheadUploadId";
    /** column name */ Pages_Select_Column["Slug"] = "slug";
    /** column name */ Pages_Select_Column["Title"] = "title";
    /** column name */ Pages_Select_Column["UpdatedAt"] = "updatedAt";
    return Pages_Select_Column;
}({});
var $93486c083cb38a29$export$20fb5607fe8d79d2 = /*#__PURE__*/ function(Pages_Update_Column) {
    /** column name */ Pages_Update_Column["Body"] = "body";
    /** column name */ Pages_Update_Column["Children"] = "children";
    /** column name */ Pages_Update_Column["CreatedAt"] = "createdAt";
    /** column name */ Pages_Update_Column["Id"] = "id";
    /** column name */ Pages_Update_Column["MastheadUploadId"] = "mastheadUploadId";
    /** column name */ Pages_Update_Column["Slug"] = "slug";
    /** column name */ Pages_Update_Column["Title"] = "title";
    /** column name */ Pages_Update_Column["UpdatedAt"] = "updatedAt";
    return Pages_Update_Column;
}({});
var $93486c083cb38a29$export$e838cdbf9351421e = /*#__PURE__*/ function(Pto_Select_Column) {
    /** column name */ Pto_Select_Column["AllDay"] = "allDay";
    /** column name */ Pto_Select_Column["EndsAt"] = "endsAt";
    /** column name */ Pto_Select_Column["StartsAt"] = "startsAt";
    /** column name */ Pto_Select_Column["UserId"] = "userId";
    return Pto_Select_Column;
}({});
var $93486c083cb38a29$export$15fafcd23331e150 = /*#__PURE__*/ function(Resources_Constraint) {
    /** unique or primary key constraint on columns "id" */ Resources_Constraint["ResourcesPkey"] = "resources_pkey";
    return Resources_Constraint;
}({});
var $93486c083cb38a29$export$f9e3923326e4e2ae = /*#__PURE__*/ function(Resources_Select_Column) {
    /** column name */ Resources_Select_Column["CreatedAt"] = "createdAt";
    /** column name */ Resources_Select_Column["Deleted"] = "deleted";
    /** column name */ Resources_Select_Column["Description"] = "description";
    /** column name */ Resources_Select_Column["FileUploadId"] = "fileUploadId";
    /** column name */ Resources_Select_Column["Global"] = "global";
    /** column name */ Resources_Select_Column["Id"] = "id";
    /** column name */ Resources_Select_Column["ModelType"] = "modelType";
    /** column name */ Resources_Select_Column["Title"] = "title";
    return Resources_Select_Column;
}({});
var $93486c083cb38a29$export$72b78c4d5da64b1d = /*#__PURE__*/ function(Resources_Update_Column) {
    /** column name */ Resources_Update_Column["CreatedAt"] = "createdAt";
    /** column name */ Resources_Update_Column["Deleted"] = "deleted";
    /** column name */ Resources_Update_Column["Description"] = "description";
    /** column name */ Resources_Update_Column["FileUploadId"] = "fileUploadId";
    /** column name */ Resources_Update_Column["Global"] = "global";
    /** column name */ Resources_Update_Column["Id"] = "id";
    /** column name */ Resources_Update_Column["ModelType"] = "modelType";
    /** column name */ Resources_Update_Column["Title"] = "title";
    return Resources_Update_Column;
}({});
var $93486c083cb38a29$export$ea29b127cb3d99c4 = /*#__PURE__*/ function(Roles_Constraint) {
    /** unique or primary key constraint on columns "value" */ Roles_Constraint["RolesPkey"] = "roles_pkey";
    return Roles_Constraint;
}({});
var $93486c083cb38a29$export$5a804b3952f05718 = /*#__PURE__*/ function(Roles_Enum) {
    Roles_Enum["Crisis"] = "Crisis";
    Roles_Enum["Editor"] = "Editor";
    Roles_Enum["Gallery"] = "Gallery";
    Roles_Enum["SuperAdmin"] = "SuperAdmin";
    return Roles_Enum;
}({});
var $93486c083cb38a29$export$49713448a7222788 = /*#__PURE__*/ function(Roles_Select_Column) {
    /** column name */ Roles_Select_Column["Comment"] = "comment";
    /** column name */ Roles_Select_Column["Value"] = "value";
    return Roles_Select_Column;
}({});
var $93486c083cb38a29$export$bd0465730da5d7ee = /*#__PURE__*/ function(Roles_Update_Column) {
    /** column name */ Roles_Update_Column["Comment"] = "comment";
    /** column name */ Roles_Update_Column["Value"] = "value";
    return Roles_Update_Column;
}({});
var $93486c083cb38a29$export$7275e0e317872fb8 = /*#__PURE__*/ function(Search_Select_Column) {
    /** column name */ Search_Select_Column["Keywords"] = "keywords";
    /** column name */ Search_Select_Column["ModelId"] = "modelId";
    /** column name */ Search_Select_Column["ModelType"] = "modelType";
    return Search_Select_Column;
}({});
var $93486c083cb38a29$export$dbdbd0b652ea2422 = /*#__PURE__*/ function(Uploads_Constraint) {
    /** unique or primary key constraint on columns "id" */ Uploads_Constraint["UploadsPkey"] = "uploads_pkey";
    return Uploads_Constraint;
}({});
var $93486c083cb38a29$export$d5f1eb01a8e38b48 = /*#__PURE__*/ function(Uploads_Select_Column) {
    /** column name */ Uploads_Select_Column["CreatedAt"] = "createdAt";
    /** column name */ Uploads_Select_Column["CreatedBy"] = "createdBy";
    /** column name */ Uploads_Select_Column["Id"] = "id";
    /** column name */ Uploads_Select_Column["Key"] = "key";
    /** column name */ Uploads_Select_Column["Size"] = "size";
    /** column name */ Uploads_Select_Column["Type"] = "type";
    /** column name */ Uploads_Select_Column["Url"] = "url";
    return Uploads_Select_Column;
}({});
var $93486c083cb38a29$export$679c8b0777a40bee = /*#__PURE__*/ function(Uploads_Update_Column) {
    /** column name */ Uploads_Update_Column["CreatedAt"] = "createdAt";
    /** column name */ Uploads_Update_Column["CreatedBy"] = "createdBy";
    /** column name */ Uploads_Update_Column["Id"] = "id";
    /** column name */ Uploads_Update_Column["Key"] = "key";
    /** column name */ Uploads_Update_Column["Size"] = "size";
    /** column name */ Uploads_Update_Column["Type"] = "type";
    /** column name */ Uploads_Update_Column["Url"] = "url";
    return Uploads_Update_Column;
}({});
var $93486c083cb38a29$export$ee24f81f3f036620 = /*#__PURE__*/ function(UserRoles_Constraint) {
    /** unique or primary key constraint on columns "user_id", "role" */ UserRoles_Constraint["UserRolesPkey"] = "user_roles_pkey";
    return UserRoles_Constraint;
}({});
var $93486c083cb38a29$export$32b6dc01faf94857 = /*#__PURE__*/ function(UserRoles_Select_Column) {
    /** column name */ UserRoles_Select_Column["Role"] = "role";
    /** column name */ UserRoles_Select_Column["UserId"] = "userId";
    return UserRoles_Select_Column;
}({});
var $93486c083cb38a29$export$fa032c9f9b947443 = /*#__PURE__*/ function(UserRoles_Update_Column) {
    /** column name */ UserRoles_Update_Column["Role"] = "role";
    /** column name */ UserRoles_Update_Column["UserId"] = "userId";
    return UserRoles_Update_Column;
}({});
var $93486c083cb38a29$export$16d569b676da0ad4 = /*#__PURE__*/ function(Users_Constraint) {
    /** unique or primary key constraint on columns "adp_id" */ Users_Constraint["UsersAdpIdKey"] = "users_adp_id_key";
    /** unique or primary key constraint on columns "dn" */ Users_Constraint["UsersDnKey"] = "users_dn_key";
    /** unique or primary key constraint on columns "email" */ Users_Constraint["UsersEmailKey"] = "users_email_key";
    /** unique or primary key constraint on columns "id" */ Users_Constraint["UsersPkey"] = "users_pkey";
    /** unique or primary key constraint on columns "username" */ Users_Constraint["UsersUsernameKey"] = "users_username_key";
    return Users_Constraint;
}({});
var $93486c083cb38a29$export$84557dbff4764dd1 = /*#__PURE__*/ function(Users_Select_Column) {
    /** column name */ Users_Select_Column["AdpId"] = "adpId";
    /** column name */ Users_Select_Column["Birthday"] = "birthday";
    /** column name */ Users_Select_Column["CreatedAt"] = "createdAt";
    /** column name */ Users_Select_Column["DepartmentId"] = "departmentId";
    /** column name */ Users_Select_Column["Dn"] = "dn";
    /** column name */ Users_Select_Column["Email"] = "email";
    /** column name */ Users_Select_Column["EntraId"] = "entra_id";
    /** column name */ Users_Select_Column["FirstName"] = "firstName";
    /** column name */ Users_Select_Column["Id"] = "id";
    /** column name */ Users_Select_Column["IsActive"] = "isActive";
    /** column name */ Users_Select_Column["JobTitle"] = "jobTitle";
    /** column name */ Users_Select_Column["JobsiteId"] = "jobsiteId";
    /** column name */ Users_Select_Column["LastName"] = "lastName";
    /** column name */ Users_Select_Column["ModelType"] = "model_type";
    /** column name */ Users_Select_Column["PhoneCell"] = "phoneCell";
    /** column name */ Users_Select_Column["PhoneDirect"] = "phoneDirect";
    /** column name */ Users_Select_Column["PhoneExt"] = "phoneExt";
    /** column name */ Users_Select_Column["PhotoUploadId"] = "photoUploadId";
    /** column name */ Users_Select_Column["SupervisorId"] = "supervisorId";
    /** column name */ Users_Select_Column["UpdatedAt"] = "updatedAt";
    /** column name */ Users_Select_Column["Username"] = "username";
    /** column name */ Users_Select_Column["WorkerType"] = "workerType";
    return Users_Select_Column;
}({});
var $93486c083cb38a29$export$cd1961c4ba3e7449 = /*#__PURE__*/ function(Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns) {
    /** column name */ Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns["IsActive"] = "isActive";
    return Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
}({});
var $93486c083cb38a29$export$943f125f6365030 = /*#__PURE__*/ function(Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns) {
    /** column name */ Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns["IsActive"] = "isActive";
    return Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
}({});
var $93486c083cb38a29$export$ce156d4988e01a1 = /*#__PURE__*/ function(Users_Update_Column) {
    /** column name */ Users_Update_Column["AdpId"] = "adpId";
    /** column name */ Users_Update_Column["Birthday"] = "birthday";
    /** column name */ Users_Update_Column["CreatedAt"] = "createdAt";
    /** column name */ Users_Update_Column["DepartmentId"] = "departmentId";
    /** column name */ Users_Update_Column["Dn"] = "dn";
    /** column name */ Users_Update_Column["Email"] = "email";
    /** column name */ Users_Update_Column["EntraId"] = "entra_id";
    /** column name */ Users_Update_Column["FirstName"] = "firstName";
    /** column name */ Users_Update_Column["Id"] = "id";
    /** column name */ Users_Update_Column["IsActive"] = "isActive";
    /** column name */ Users_Update_Column["JobTitle"] = "jobTitle";
    /** column name */ Users_Update_Column["JobsiteId"] = "jobsiteId";
    /** column name */ Users_Update_Column["LastName"] = "lastName";
    /** column name */ Users_Update_Column["ModelType"] = "model_type";
    /** column name */ Users_Update_Column["PhoneCell"] = "phoneCell";
    /** column name */ Users_Update_Column["PhoneDirect"] = "phoneDirect";
    /** column name */ Users_Update_Column["PhoneExt"] = "phoneExt";
    /** column name */ Users_Update_Column["PhotoUploadId"] = "photoUploadId";
    /** column name */ Users_Update_Column["SupervisorId"] = "supervisorId";
    /** column name */ Users_Update_Column["UpdatedAt"] = "updatedAt";
    /** column name */ Users_Update_Column["Username"] = "username";
    /** column name */ Users_Update_Column["WorkerType"] = "workerType";
    return Users_Update_Column;
}({});
var $93486c083cb38a29$export$1ba0d8d40c8de0b5 = /*#__PURE__*/ function(V2_Adp_Associate_Certification_Constraint) {
    /** unique or primary key constraint on columns "id" */ V2_Adp_Associate_Certification_Constraint["AdpAssociateCertificationPkey"] = "adp_associate_certification_pkey";
    return V2_Adp_Associate_Certification_Constraint;
}({});
var $93486c083cb38a29$export$b0ef5a5653da557e = /*#__PURE__*/ function(V2_Adp_Associate_Certification_Select_Column) {
    /** column name */ V2_Adp_Associate_Certification_Select_Column["AssociateOid"] = "associate_oid";
    /** column name */ V2_Adp_Associate_Certification_Select_Column["CategoryCode"] = "category_code";
    /** column name */ V2_Adp_Associate_Certification_Select_Column["CertificationCode"] = "certification_code";
    /** column name */ V2_Adp_Associate_Certification_Select_Column["ExpirationDate"] = "expiration_date";
    /** column name */ V2_Adp_Associate_Certification_Select_Column["FirstIssueDate"] = "first_issue_date";
    /** column name */ V2_Adp_Associate_Certification_Select_Column["Id"] = "id";
    /** column name */ V2_Adp_Associate_Certification_Select_Column["Raw"] = "raw";
    /** column name */ V2_Adp_Associate_Certification_Select_Column["UpdatedAt"] = "updated_at";
    return V2_Adp_Associate_Certification_Select_Column;
}({});
var $93486c083cb38a29$export$230aa62727b4dc36 = /*#__PURE__*/ function(V2_Adp_Associate_Certification_Update_Column) {
    /** column name */ V2_Adp_Associate_Certification_Update_Column["AssociateOid"] = "associate_oid";
    /** column name */ V2_Adp_Associate_Certification_Update_Column["CategoryCode"] = "category_code";
    /** column name */ V2_Adp_Associate_Certification_Update_Column["CertificationCode"] = "certification_code";
    /** column name */ V2_Adp_Associate_Certification_Update_Column["ExpirationDate"] = "expiration_date";
    /** column name */ V2_Adp_Associate_Certification_Update_Column["FirstIssueDate"] = "first_issue_date";
    /** column name */ V2_Adp_Associate_Certification_Update_Column["Id"] = "id";
    /** column name */ V2_Adp_Associate_Certification_Update_Column["Raw"] = "raw";
    /** column name */ V2_Adp_Associate_Certification_Update_Column["UpdatedAt"] = "updated_at";
    return V2_Adp_Associate_Certification_Update_Column;
}({});
var $93486c083cb38a29$export$52a7295074206f61 = /*#__PURE__*/ function(V2_Adp_Associates_Constraint) {
    /** unique or primary key constraint on columns "associate_oid" */ V2_Adp_Associates_Constraint["AdpAssociatesPkey"] = "adp_associates_pkey";
    return V2_Adp_Associates_Constraint;
}({});
var $93486c083cb38a29$export$6134c30cc1062017 = /*#__PURE__*/ function(V2_Adp_Associates_Select_Column) {
    /** column name */ V2_Adp_Associates_Select_Column["AssociateOid"] = "associate_oid";
    /** column name */ V2_Adp_Associates_Select_Column["Emails"] = "emails";
    /** column name */ V2_Adp_Associates_Select_Column["FirstName"] = "first_name";
    /** column name */ V2_Adp_Associates_Select_Column["LastName"] = "last_name";
    /** column name */ V2_Adp_Associates_Select_Column["PositionIds"] = "position_ids";
    /** column name */ V2_Adp_Associates_Select_Column["Raw"] = "raw";
    /** column name */ V2_Adp_Associates_Select_Column["Status"] = "status";
    /** column name */ V2_Adp_Associates_Select_Column["UpdatedAt"] = "updated_at";
    /** column name */ V2_Adp_Associates_Select_Column["WorkerId"] = "worker_id";
    return V2_Adp_Associates_Select_Column;
}({});
var $93486c083cb38a29$export$4f169d5a1758f04f = /*#__PURE__*/ function(V2_Adp_Associates_Update_Column) {
    /** column name */ V2_Adp_Associates_Update_Column["AssociateOid"] = "associate_oid";
    /** column name */ V2_Adp_Associates_Update_Column["Emails"] = "emails";
    /** column name */ V2_Adp_Associates_Update_Column["FirstName"] = "first_name";
    /** column name */ V2_Adp_Associates_Update_Column["LastName"] = "last_name";
    /** column name */ V2_Adp_Associates_Update_Column["PositionIds"] = "position_ids";
    /** column name */ V2_Adp_Associates_Update_Column["Raw"] = "raw";
    /** column name */ V2_Adp_Associates_Update_Column["Status"] = "status";
    /** column name */ V2_Adp_Associates_Update_Column["UpdatedAt"] = "updated_at";
    /** column name */ V2_Adp_Associates_Update_Column["WorkerId"] = "worker_id";
    return V2_Adp_Associates_Update_Column;
}({});
var $93486c083cb38a29$export$6907e152c54f79a9 = /*#__PURE__*/ function(V2_Adp_Certification_Categories_Constraint) {
    /** unique or primary key constraint on columns "code" */ V2_Adp_Certification_Categories_Constraint["AdpCertificationCategoriesPkey"] = "adp_certification_categories_pkey";
    return V2_Adp_Certification_Categories_Constraint;
}({});
var $93486c083cb38a29$export$553b6ed6251154c6 = /*#__PURE__*/ function(V2_Adp_Certification_Categories_Select_Column) {
    /** column name */ V2_Adp_Certification_Categories_Select_Column["Code"] = "code";
    /** column name */ V2_Adp_Certification_Categories_Select_Column["Name"] = "name";
    /** column name */ V2_Adp_Certification_Categories_Select_Column["UpdatedAt"] = "updated_at";
    return V2_Adp_Certification_Categories_Select_Column;
}({});
var $93486c083cb38a29$export$40d98b9cde7f00ba = /*#__PURE__*/ function(V2_Adp_Certification_Categories_Update_Column) {
    /** column name */ V2_Adp_Certification_Categories_Update_Column["Code"] = "code";
    /** column name */ V2_Adp_Certification_Categories_Update_Column["Name"] = "name";
    /** column name */ V2_Adp_Certification_Categories_Update_Column["UpdatedAt"] = "updated_at";
    return V2_Adp_Certification_Categories_Update_Column;
}({});
var $93486c083cb38a29$export$33191ca370315c76 = /*#__PURE__*/ function(V2_Adp_Certifications_Constraint) {
    /** unique or primary key constraint on columns "code" */ V2_Adp_Certifications_Constraint["AdpCertificationsPkey"] = "adp_certifications_pkey";
    return V2_Adp_Certifications_Constraint;
}({});
var $93486c083cb38a29$export$9843cb0829baa6e6 = /*#__PURE__*/ function(V2_Adp_Certifications_Select_Column) {
    /** column name */ V2_Adp_Certifications_Select_Column["Code"] = "code";
    /** column name */ V2_Adp_Certifications_Select_Column["Description"] = "description";
    /** column name */ V2_Adp_Certifications_Select_Column["DoceboImportCourseId"] = "docebo_import_course_id";
    /** column name */ V2_Adp_Certifications_Select_Column["Name"] = "name";
    /** column name */ V2_Adp_Certifications_Select_Column["UpdatedAt"] = "updated_at";
    return V2_Adp_Certifications_Select_Column;
}({});
var $93486c083cb38a29$export$9cb1d32b0eb3fd40 = /*#__PURE__*/ function(V2_Adp_Certifications_Update_Column) {
    /** column name */ V2_Adp_Certifications_Update_Column["Code"] = "code";
    /** column name */ V2_Adp_Certifications_Update_Column["Description"] = "description";
    /** column name */ V2_Adp_Certifications_Update_Column["DoceboImportCourseId"] = "docebo_import_course_id";
    /** column name */ V2_Adp_Certifications_Update_Column["Name"] = "name";
    /** column name */ V2_Adp_Certifications_Update_Column["UpdatedAt"] = "updated_at";
    return V2_Adp_Certifications_Update_Column;
}({});
var $93486c083cb38a29$export$c28e54949e2f894c = /*#__PURE__*/ function(V2_Adp_License_Categories_Constraint) {
    /** unique or primary key constraint on columns "code" */ V2_Adp_License_Categories_Constraint["AdpLicenseCategoriesPkey"] = "adp_license_categories_pkey";
    return V2_Adp_License_Categories_Constraint;
}({});
var $93486c083cb38a29$export$a4bbaaef8fb7534f = /*#__PURE__*/ function(V2_Adp_License_Categories_Select_Column) {
    /** column name */ V2_Adp_License_Categories_Select_Column["Code"] = "code";
    /** column name */ V2_Adp_License_Categories_Select_Column["Name"] = "name";
    /** column name */ V2_Adp_License_Categories_Select_Column["UpdatedAt"] = "updated_at";
    return V2_Adp_License_Categories_Select_Column;
}({});
var $93486c083cb38a29$export$796e66f89d6c2a40 = /*#__PURE__*/ function(V2_Adp_License_Categories_Update_Column) {
    /** column name */ V2_Adp_License_Categories_Update_Column["Code"] = "code";
    /** column name */ V2_Adp_License_Categories_Update_Column["Name"] = "name";
    /** column name */ V2_Adp_License_Categories_Update_Column["UpdatedAt"] = "updated_at";
    return V2_Adp_License_Categories_Update_Column;
}({});
var $93486c083cb38a29$export$fb09df02897c73fc = /*#__PURE__*/ function(V2_Adp_Licenses_Constraint) {
    /** unique or primary key constraint on columns "code" */ V2_Adp_Licenses_Constraint["AdpLicensesPkey"] = "adp_licenses_pkey";
    return V2_Adp_Licenses_Constraint;
}({});
var $93486c083cb38a29$export$6580a8a8cd46d2fc = /*#__PURE__*/ function(V2_Adp_Licenses_Select_Column) {
    /** column name */ V2_Adp_Licenses_Select_Column["Code"] = "code";
    /** column name */ V2_Adp_Licenses_Select_Column["Description"] = "description";
    /** column name */ V2_Adp_Licenses_Select_Column["Name"] = "name";
    /** column name */ V2_Adp_Licenses_Select_Column["UpdatedAt"] = "updated_at";
    return V2_Adp_Licenses_Select_Column;
}({});
var $93486c083cb38a29$export$a9e402183d075882 = /*#__PURE__*/ function(V2_Adp_Licenses_Update_Column) {
    /** column name */ V2_Adp_Licenses_Update_Column["Code"] = "code";
    /** column name */ V2_Adp_Licenses_Update_Column["Description"] = "description";
    /** column name */ V2_Adp_Licenses_Update_Column["Name"] = "name";
    /** column name */ V2_Adp_Licenses_Update_Column["UpdatedAt"] = "updated_at";
    return V2_Adp_Licenses_Update_Column;
}({});
var $93486c083cb38a29$export$b7f7317cf063f734 = /*#__PURE__*/ function(V2_Docebo_Courses_Constraint) {
    /** unique or primary key constraint on columns "uid" */ V2_Docebo_Courses_Constraint["DoceboCoursesPkey"] = "docebo_courses_pkey";
    return V2_Docebo_Courses_Constraint;
}({});
var $93486c083cb38a29$export$3532bfe914161cf9 = /*#__PURE__*/ function(V2_Docebo_Courses_Select_Column) {
    /** column name */ V2_Docebo_Courses_Select_Column["AdpCertificationCategoryCode"] = "adp_certification_category_code";
    /** column name */ V2_Docebo_Courses_Select_Column["AdpCertificationCode"] = "adp_certification_code";
    /** column name */ V2_Docebo_Courses_Select_Column["AdpCertificationDays"] = "adp_certification_days";
    /** column name */ V2_Docebo_Courses_Select_Column["Code"] = "code";
    /** column name */ V2_Docebo_Courses_Select_Column["Img"] = "img";
    /** column name */ V2_Docebo_Courses_Select_Column["IsDeleted"] = "is_deleted";
    /** column name */ V2_Docebo_Courses_Select_Column["Name"] = "name";
    /** column name */ V2_Docebo_Courses_Select_Column["Raw"] = "raw";
    /** column name */ V2_Docebo_Courses_Select_Column["Uid"] = "uid";
    /** column name */ V2_Docebo_Courses_Select_Column["UpdatedAt"] = "updated_at";
    return V2_Docebo_Courses_Select_Column;
}({});
var $93486c083cb38a29$export$f0a160adffa0d73f = /*#__PURE__*/ function(V2_Docebo_Courses_Update_Column) {
    /** column name */ V2_Docebo_Courses_Update_Column["AdpCertificationCategoryCode"] = "adp_certification_category_code";
    /** column name */ V2_Docebo_Courses_Update_Column["AdpCertificationCode"] = "adp_certification_code";
    /** column name */ V2_Docebo_Courses_Update_Column["AdpCertificationDays"] = "adp_certification_days";
    /** column name */ V2_Docebo_Courses_Update_Column["Code"] = "code";
    /** column name */ V2_Docebo_Courses_Update_Column["Img"] = "img";
    /** column name */ V2_Docebo_Courses_Update_Column["IsDeleted"] = "is_deleted";
    /** column name */ V2_Docebo_Courses_Update_Column["Name"] = "name";
    /** column name */ V2_Docebo_Courses_Update_Column["Raw"] = "raw";
    /** column name */ V2_Docebo_Courses_Update_Column["Uid"] = "uid";
    /** column name */ V2_Docebo_Courses_Update_Column["UpdatedAt"] = "updated_at";
    return V2_Docebo_Courses_Update_Column;
}({});
var $93486c083cb38a29$export$9ceae5948eb31d78 = /*#__PURE__*/ function(V2_Months_Select_Column) {
    /** column name */ V2_Months_Select_Column["Id"] = "id";
    /** column name */ V2_Months_Select_Column["Month"] = "month";
    return V2_Months_Select_Column;
}({});
var $93486c083cb38a29$export$9033f78079476e = /*#__PURE__*/ function(V2_Nomination_Thumbsup_Constraint) {
    /** unique or primary key constraint on columns "user_id", "nomination_id" */ V2_Nomination_Thumbsup_Constraint["NominationThumbsupPkey"] = "nomination_thumbsup_pkey";
    return V2_Nomination_Thumbsup_Constraint;
}({});
var $93486c083cb38a29$export$86e6f4414d276eef = /*#__PURE__*/ function(V2_Nomination_Thumbsup_Select_Column) {
    /** column name */ V2_Nomination_Thumbsup_Select_Column["NominationId"] = "nomination_id";
    /** column name */ V2_Nomination_Thumbsup_Select_Column["UserId"] = "user_id";
    return V2_Nomination_Thumbsup_Select_Column;
}({});
var $93486c083cb38a29$export$5ff96160603850ce = /*#__PURE__*/ function(V2_Nomination_Thumbsup_Update_Column) {
    /** column name */ V2_Nomination_Thumbsup_Update_Column["NominationId"] = "nomination_id";
    /** column name */ V2_Nomination_Thumbsup_Update_Column["UserId"] = "user_id";
    return V2_Nomination_Thumbsup_Update_Column;
}({});
var $93486c083cb38a29$export$934adb3661e4b2cc = /*#__PURE__*/ function(V2_Nominations_Constraint) {
    /** unique or primary key constraint on columns "id" */ V2_Nominations_Constraint["NominationsPkey"] = "nominations_pkey";
    return V2_Nominations_Constraint;
}({});
var $93486c083cb38a29$export$69d282c176e5f5b6 = /*#__PURE__*/ function(V2_Nominations_Select_Column) {
    /** column name */ V2_Nominations_Select_Column["Category"] = "category";
    /** column name */ V2_Nominations_Select_Column["CreatedAt"] = "created_at";
    /** column name */ V2_Nominations_Select_Column["Description"] = "description";
    /** column name */ V2_Nominations_Select_Column["FromUserId"] = "from_user_id";
    /** column name */ V2_Nominations_Select_Column["Id"] = "id";
    /** column name */ V2_Nominations_Select_Column["IsDeleted"] = "is_deleted";
    /** column name */ V2_Nominations_Select_Column["Project"] = "project";
    /** column name */ V2_Nominations_Select_Column["ToName"] = "to_name";
    /** column name */ V2_Nominations_Select_Column["ToUserId"] = "to_user_id";
    return V2_Nominations_Select_Column;
}({});
var $93486c083cb38a29$export$664040f671b7b18e = /*#__PURE__*/ function(V2_Nominations_Update_Column) {
    /** column name */ V2_Nominations_Update_Column["Category"] = "category";
    /** column name */ V2_Nominations_Update_Column["CreatedAt"] = "created_at";
    /** column name */ V2_Nominations_Update_Column["Description"] = "description";
    /** column name */ V2_Nominations_Update_Column["FromUserId"] = "from_user_id";
    /** column name */ V2_Nominations_Update_Column["Id"] = "id";
    /** column name */ V2_Nominations_Update_Column["IsDeleted"] = "is_deleted";
    /** column name */ V2_Nominations_Update_Column["Project"] = "project";
    /** column name */ V2_Nominations_Update_Column["ToName"] = "to_name";
    /** column name */ V2_Nominations_Update_Column["ToUserId"] = "to_user_id";
    return V2_Nominations_Update_Column;
}({});
var $93486c083cb38a29$export$b2cedb61402339ef = /*#__PURE__*/ function(V2_Redemption_Codes_Constraint) {
    /** unique or primary key constraint on columns "id" */ V2_Redemption_Codes_Constraint["RedemptionCodesPkey"] = "redemption_codes_pkey";
    return V2_Redemption_Codes_Constraint;
}({});
var $93486c083cb38a29$export$1a6a680003f94f5e = /*#__PURE__*/ function(V2_Redemption_Codes_Select_Column) {
    /** column name */ V2_Redemption_Codes_Select_Column["Code"] = "code";
    /** column name */ V2_Redemption_Codes_Select_Column["Id"] = "id";
    /** column name */ V2_Redemption_Codes_Select_Column["UsedBy"] = "used_by";
    return V2_Redemption_Codes_Select_Column;
}({});
var $93486c083cb38a29$export$49ef33f7893164e9 = /*#__PURE__*/ function(V2_Redemption_Codes_Update_Column) {
    /** column name */ V2_Redemption_Codes_Update_Column["Code"] = "code";
    /** column name */ V2_Redemption_Codes_Update_Column["Id"] = "id";
    /** column name */ V2_Redemption_Codes_Update_Column["UsedBy"] = "used_by";
    return V2_Redemption_Codes_Update_Column;
}({});
const $93486c083cb38a29$export$b8d5095d717cda36 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  fragment resourceDetails on resources {
    id
    createdAt
    title
    description
    file {
      key
      url
      size
      type
      url
    }
  }
`;
const $93486c083cb38a29$export$384f4f587abeec8 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  fragment userBasic on users {
    id
    firstName
    lastName
    jobTitle
    profilePhotoUrl
  }
`;
const $93486c083cb38a29$export$d7bc6096322b0575 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  fragment commentDetails on comments {
    comment
    createdAt
    updatedAt
    id
    user {
      ...userBasic
    }
  }
  ${$93486c083cb38a29$export$384f4f587abeec8}
`;
const $93486c083cb38a29$export$2f6245eda63d427f = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  fragment discussionDetails on discussions {
    author {
      ...userBasic
    }
    comments(order_by: { createdAt: asc }) {
      ...commentDetails
    }
    id
    title
    createdAt
    post
    departmentId
  }
  ${$93486c083cb38a29$export$384f4f587abeec8}
  ${$93486c083cb38a29$export$d7bc6096322b0575}
`;
const $93486c083cb38a29$export$f5048f456aa06cdf = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  fragment userFavorites on users {
    favoriteResources(where: { resource: {} }) {
      resourceId
      id
      resource {
        ...resourceDetails
      }
    }
    favoriteDiscussions(where: { discussion: {} }) {
      discussionId
      id
      discussion {
        ...discussionDetails
      }
    }
  }
  ${$93486c083cb38a29$export$b8d5095d717cda36}
  ${$93486c083cb38a29$export$2f6245eda63d427f}
`;
const $93486c083cb38a29$export$94a25c9ea19fb9b5 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  fragment bulletinDetails on bulletins {
    id
    title
    createdAt
    global
    author {
      ...userBasic
    }
    leadImageUploadId
    leadWebUrl
    leadThumbUrl
    post
    comments(order_by: { createdAt: asc }) {
      ...commentDetails
    }
    bulletinDepartments {
      departmentId
    }
    bulletinResources(order_by: { resource: { createdAt: desc } }) {
      resource {
        ...resourceDetails
      }
    }
  }
  ${$93486c083cb38a29$export$384f4f587abeec8}
  ${$93486c083cb38a29$export$d7bc6096322b0575}
  ${$93486c083cb38a29$export$b8d5095d717cda36}
`;
const $93486c083cb38a29$export$b2dbb4d61e0c0725 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  fragment userDetails on users {
    ...userBasic
    department {
      title
    }
    supervisorId
    roles {
      role
    }
    email
    phoneCell
    phoneDirect
    phoneExt
    jobsite {
      title
    }
  }
  ${$93486c083cb38a29$export$384f4f587abeec8}
`;
const $93486c083cb38a29$export$a2d77ac6f8fee5d5 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  fragment departmentDetails on departments {
    id
    title
    missionStatement
    quicklinks {
      title
      url
      id
      description
    }
    contents(where: { active: { _eq: true }, parentId: { _is_null: true } }) {
      id
      title
      body
      parentId
      contentResources(
        where: { resource: { deleted: { _is_null: true } } }
        order_by: { resource: { createdAt: desc } }
      ) {
        resource {
          ...resourceDetails
        }
      }
      contents(where: { active: { _eq: true } }) {
        id
        title
        body
        parentId
        contentResources(
          where: { resource: { deleted: { _is_null: true } } }
          order_by: { resource: { createdAt: desc } }
        ) {
          resource {
            ...resourceDetails
          }
        }
      }
    }
    masthead {
      id
      publicUrl
      key
    }
    logo {
      id
      publicUrl
      key
    }
    faqs(order_by: { id: asc }) {
      id
      question
      answer
    }
    bulletins(order_by: { bulletin: { createdAt: desc } }) {
      bulletin {
        ...bulletinDetails
      }
    }
    discussions(order_by: { createdAt: desc }) {
      ...discussionDetails
    }
    employees(order_by: { lastName: asc }) {
      ...userDetails
    }
  }
  ${$93486c083cb38a29$export$b8d5095d717cda36}
  ${$93486c083cb38a29$export$94a25c9ea19fb9b5}
  ${$93486c083cb38a29$export$2f6245eda63d427f}
  ${$93486c083cb38a29$export$b2dbb4d61e0c0725}
`;
const $93486c083cb38a29$export$5382c2864ccd3da0 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  fragment event on events {
    type
    title
    startsAt
    id
    endsAt
    description
    allDay
  }
`;
const $93486c083cb38a29$export$bd95d134196d6ed2 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  fragment jobsite on jobsites {
    id
    mainAddress
    mainAddress2
    mainAddressCity
    mainAddressState
    mainAddressZip
    officeAddress
    officeAddress2
    officeAddressCity
    officeAddressState
    officeAddressZip
    phone
    siteNumber
    title
    alt_names
  }
`;
const $93486c083cb38a29$export$754aea510180ce7d = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  fragment orgChartUser on users {
    id
    firstName
    lastName
    supervisorId
    profilePhotoUrl
    jobTitle
    adpId
    department {
      title
    }
    jobsite {
      title
    }
    email
    phoneCell
    phoneDirect
    phoneExt
  }
`;
const $93486c083cb38a29$export$b97cc9278da8dfbb = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation addComment(
    $nominationId: Int = null
    $bulletinId: Int = null
    $discussionId: Int = null
    $comment: String!
  ) {
    insertComment(
      object: { nominationId: $nominationId, bulletinId: $bulletinId, comment: $comment, discussionId: $discussionId }
    ) {
      id
    }
  }
`;
function $93486c083cb38a29$export$950e3195c77fb453(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$b97cc9278da8dfbb, options);
}
const $93486c083cb38a29$export$1e50e01da44d543a = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation addUpload($key: String!, $size: Int!, $type: String!, $url: String!) {
    insertUpload(object: { key: $key, size: $size, type: $type, url: $url }) {
      id
      url
      publicUrl
    }
  }
`;
function $93486c083cb38a29$export$a234d0c49428cf6e(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$1e50e01da44d543a, options);
}
const $93486c083cb38a29$export$48d9dcb7b362a0a4 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation deleteContentResource($contentId: Int!, $resourceId: Int!) {
    deleteContentsResources(where: { departmentContentId: { _eq: $contentId }, resourceId: { _eq: $resourceId } }) {
      affected_rows
    }
  }
`;
function $93486c083cb38a29$export$df7ac65110b1fa66(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$48d9dcb7b362a0a4, options);
}
const $93486c083cb38a29$export$e96d66acab00564e = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation addResource($title: String!, $fileUploadId: Int!, $description: String!) {
    insertResource(object: { description: $description, fileUploadId: $fileUploadId, global: false, title: $title }) {
      id
    }
  }
`;
function $93486c083cb38a29$export$769b437a6cfba8c2(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$e96d66acab00564e, options);
}
const $93486c083cb38a29$export$d697fca52687604a = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation addContentsResource($departmentContentId: Int!, $resourceId: Int!) {
    insertContentsResource(object: { resourceId: $resourceId, departmentContentId: $departmentContentId }) {
      id
    }
  }
`;
function $93486c083cb38a29$export$13eb6ed7a9c1f926(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$d697fca52687604a, options);
}
const $93486c083cb38a29$export$7905b3ddeba626c6 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation updateProfilePic($userId: Int!, $uploadId: Int!) {
    updateUserById(pk_columns: { id: $userId }, _set: { photoUploadId: $uploadId }) {
      id
      profilePhotoUrl
    }
  }
`;
function $93486c083cb38a29$export$11678de5e6a25d7b(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$7905b3ddeba626c6, options);
}
const $93486c083cb38a29$export$3f904cd185746044 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation addBulletinsResource($bulletinId: Int!, $resourceId: Int!) {
    insertBulletinsResource(object: { resourceId: $resourceId, bulletinId: $bulletinId }) {
      id
    }
  }
`;
function $93486c083cb38a29$export$370436d71d6a33ba(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$3f904cd185746044, options);
}
const $93486c083cb38a29$export$f9170b61aacc5039 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation deleteBulletinsResource($bulletinId: Int!, $resourceId: Int!) {
    deleteBulletinsResources(where: { bulletinId: { _eq: $bulletinId }, resourceId: { _eq: $resourceId } }) {
      affected_rows
    }
  }
`;
function $93486c083cb38a29$export$67203bf74af72848(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$f9170b61aacc5039, options);
}
const $93486c083cb38a29$export$156dfe9403a52678 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation adminAddContent($body: String, $departmentId: Int, $parentId: Int, $title: String, $active: Boolean) {
    insertContent(
      object: { active: $active, body: $body, departmentId: $departmentId, parentId: $parentId, title: $title }
    ) {
      id
    }
  }
`;
function $93486c083cb38a29$export$33cf84748aa2c67d(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$156dfe9403a52678, options);
}
const $93486c083cb38a29$export$441a93b20b2b1c5d = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation adminUpdateContent($body: String, $parentId: Int, $title: String, $id: Int!) {
    updateContentById(pk_columns: { id: $id }, _set: { body: $body, parentId: $parentId, title: $title }) {
      id
      parentId
    }
  }
`;
function $93486c083cb38a29$export$ea11c48f10be89d2(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$441a93b20b2b1c5d, options);
}
const $93486c083cb38a29$export$76c94001e18dded4 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation disablePage($contentId: Int!) {
    updateContentById(pk_columns: { id: $contentId }, _set: { active: false }) {
      id
    }
  }
`;
function $93486c083cb38a29$export$7a3a20a6962063c2(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$76c94001e18dded4, options);
}
const $93486c083cb38a29$export$609dc349414eb054 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation updateDepartment(
    $departmentId: Int!
    $logoUploadId: Int
    $mastheadUploadId: Int
    $missionStatement: String!
    $title: String!
  ) {
    updateDepartmentById(
      pk_columns: { id: $departmentId }
      _set: {
        logoUploadId: $logoUploadId
        mastheadUploadId: $mastheadUploadId
        missionStatement: $missionStatement
        title: $title
      }
    ) {
      id
    }
  }
`;
function $93486c083cb38a29$export$8f4b8ade8406c1ee(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$609dc349414eb054, options);
}
const $93486c083cb38a29$export$191e5957a0f3f4c3 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation addBulletin($global: Boolean!, $leadImageUploadId: Int!, $post: String!, $title: String!) {
    insertBulletin(object: { global: $global, leadImageUploadId: $leadImageUploadId, post: $post, title: $title }) {
      id
    }
  }
`;
function $93486c083cb38a29$export$584ae9e174479d5(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$191e5957a0f3f4c3, options);
}
const $93486c083cb38a29$export$fee0ae6e7f5a90fb = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation addBulletinDepartments($objects: [bulletinDepartments_insert_input!]!) {
    insertBulletinDepartments(objects: $objects) {
      affected_rows
    }
  }
`;
function $93486c083cb38a29$export$c8de14961eb99050(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$fee0ae6e7f5a90fb, options);
}
const $93486c083cb38a29$export$a24499b33b804904 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation deleteBulletin($id: Int!) {
    deleteBulletins(where: { id: { _eq: $id } }) {
      affected_rows
    }
  }
`;
function $93486c083cb38a29$export$5c55bb68218f0242(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$a24499b33b804904, options);
}
const $93486c083cb38a29$export$71990034a1c50edf = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation updateBulletin($id: Int!, $global: Boolean!, $leadImageUploadId: Int!, $post: String!, $title: String!) {
    updateBulletinById(
      pk_columns: { id: $id }
      _set: { global: $global, leadImageUploadId: $leadImageUploadId, post: $post, title: $title }
    ) {
      id
    }
  }
`;
function $93486c083cb38a29$export$a7dfb8248ac4e481(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$71990034a1c50edf, options);
}
const $93486c083cb38a29$export$a25e5b8082fc73ef = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation refetchBulletin($id: Int!, $global: Boolean!) {
    updateBulletinById(pk_columns: { id: $id }, _set: { global: $global }) {
      id
    }
  }
`;
function $93486c083cb38a29$export$8239115b6cf37d38(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$a25e5b8082fc73ef, options);
}
const $93486c083cb38a29$export$29fba5b88a713a36 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation removeBulletinDepartments($departmentIds: [Int!]!, $bulletinId: Int!) {
    deleteBulletinDepartments(
      where: { departmentId: { _in: $departmentIds }, bulletin: { id: { _eq: $bulletinId } } }
    ) {
      affected_rows
    }
  }
`;
function $93486c083cb38a29$export$6df206a4428a9c81(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$29fba5b88a713a36, options);
}
const $93486c083cb38a29$export$d68319358eb86267 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation updateResourceFile($id: Int!, $fileUploadId: Int!) {
    updateResourceById(pk_columns: { id: $id }, _set: { fileUploadId: $fileUploadId }) {
      id
    }
  }
`;
function $93486c083cb38a29$export$97014a604d1b681d(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$d68319358eb86267, options);
}
const $93486c083cb38a29$export$44755bb9de26ea61 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation updateResourceData($id: Int!, $title: String!, $description: String!) {
    updateResourceById(pk_columns: { id: $id }, _set: { description: $description, title: $title }) {
      id
      title
      description
    }
  }
`;
function $93486c083cb38a29$export$8fe372e0be5a5d37(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$44755bb9de26ea61, options);
}
const $93486c083cb38a29$export$581ea1088280c740 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation deleteResource($id: Int = -1) {
    updateResources(where: { id: { _eq: $id } }, _set: { deleted: true }) {
      affected_rows
    }
  }
`;
function $93486c083cb38a29$export$276ec715eac70058(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$581ea1088280c740, options);
}
const $93486c083cb38a29$export$bc2155aaa05f3726 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation removeUserRole($role: roles_enum!, $userId: Int!) {
    deleteUserRoles(where: { role: { _eq: $role }, userId: { _eq: $userId } }) {
      affected_rows
    }
  }
`;
function $93486c083cb38a29$export$52639b1a58427e4e(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$bc2155aaa05f3726, options);
}
const $93486c083cb38a29$export$b02e4231c80ea4fd = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation addUserRole($input: userRoles_insert_input!) {
    insertUserRole(object: $input) {
      role
    }
  }
`;
function $93486c083cb38a29$export$f8b1b8fbf5b89d45(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$b02e4231c80ea4fd, options);
}
const $93486c083cb38a29$export$53cea2586f5e2e9f = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation updatePageMasthead($slug: String!, $mastheadUploadId: Int!) {
    updatePageBySlug(pk_columns: { slug: $slug }, _set: { mastheadUploadId: $mastheadUploadId }) {
      mastheadUploadId
    }
  }
`;
function $93486c083cb38a29$export$aeb2a06afafa0c69(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$53cea2586f5e2e9f, options);
}
const $93486c083cb38a29$export$5b190f0a812aee41 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation createDepartment($mastheadUploadId: Int!, $title: String!, $ownerId: Int!) {
    insertDepartment(
      object: { mastheadUploadId: $mastheadUploadId, missionStatement: "", title: $title, ownerId: $ownerId }
    ) {
      id
    }
  }
`;
function $93486c083cb38a29$export$1018408e8180dc25(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$5b190f0a812aee41, options);
}
const $93486c083cb38a29$export$507febade1ef80fa = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation createFaq($answer: String!, $departmentId: Int!, $question: String!) {
    insertDepartmentFaq(object: { answer: $answer, departmentId: $departmentId, question: $question }) {
      id
      question
      answer
    }
  }
`;
function $93486c083cb38a29$export$8887825256a2931c(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$507febade1ef80fa, options);
}
const $93486c083cb38a29$export$ae5888109ef6606a = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation updateFaq($id: Int!, $answer: String!, $question: String!) {
    updateDepartmentFaqById(pk_columns: { id: $id }, _set: { answer: $answer, question: $question }) {
      id
      question
      answer
    }
  }
`;
function $93486c083cb38a29$export$269f5b469b06e19d(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$ae5888109ef6606a, options);
}
const $93486c083cb38a29$export$99fbccb70facf417 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation deleteFaq($id: Int!) {
    deleteDepartmentFaqById(id: $id) {
      id
    }
  }
`;
function $93486c083cb38a29$export$44d8ad03c29758c0(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$99fbccb70facf417, options);
}
const $93486c083cb38a29$export$4468bb4b99e2814c = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation authenticateUser($username: String!, $password: String!) {
    authenticateUser(credentials: { username: $username, password: $password }) {
      accessToken
      userId
    }
  }
`;
function $93486c083cb38a29$export$b6f0d9793b6d1b9f(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$4468bb4b99e2814c, options);
}
const $93486c083cb38a29$export$fa5daff428a6850e = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation createDiscussion($departmentId: Int, $post: String!, $title: String!) {
    insertDiscussion(object: { departmentId: $departmentId, post: $post, title: $title }) {
      id
    }
  }
`;
function $93486c083cb38a29$export$214006b9150ed9a5(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$fa5daff428a6850e, options);
}
const $93486c083cb38a29$export$6246215d50715bb = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation deleteDiscussion($id: Int!) {
    deleteDiscussions(where: { id: { _eq: $id } }) {
      affected_rows
    }
  }
`;
function $93486c083cb38a29$export$2a8cd6783b4fbf7e(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$6246215d50715bb, options);
}
const $93486c083cb38a29$export$686a0e007ca521ff = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation updateDiscussion($id: Int!, $post: String!, $title: String!) {
    updateDiscussionById(pk_columns: { id: $id }, _set: { post: $post, title: $title }) {
      id
    }
  }
`;
function $93486c083cb38a29$export$6f5da27c4bf25cfa(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$686a0e007ca521ff, options);
}
const $93486c083cb38a29$export$bb823def2c2179d0 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation deleteComment($id: Int!) {
    deleteCommentById(id: $id) {
      id
    }
  }
`;
function $93486c083cb38a29$export$91bcd2720f6c2c6(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$bb823def2c2179d0, options);
}
const $93486c083cb38a29$export$f76ada095a85a9af = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation sendResourceEmail($resourceId: Int!, $to: String!) {
    sendResourceEmail(config: { resourceId: $resourceId, to: $to }) {
      success
      id
    }
  }
`;
function $93486c083cb38a29$export$7e6f65f40eaf7309(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$f76ada095a85a9af, options);
}
const $93486c083cb38a29$export$4292dfe803de8062 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation sendNominationEmail(
    $name: String!
    $category: String!
    $to: String!
    $mgr_to: String
    $html: String!
    $to_name: String!
  ) {
    sendNominationEmail(
      config: { name: $name, category: $category, to: $to, mgr_to: $mgr_to, html: $html, to_name: $to_name }
    ) {
      success
      id
    }
  }
`;
function $93486c083cb38a29$export$7c8d4dabf7d36a38(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$4292dfe803de8062, options);
}
const $93486c083cb38a29$export$8d6d892bc320188f = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation addFavoriteDiscussion($discussionId: Int) {
    insertFavoriteDiscussion(object: { discussionId: $discussionId }) {
      id
    }
  }
`;
function $93486c083cb38a29$export$d4d3e0709feb269a(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$8d6d892bc320188f, options);
}
const $93486c083cb38a29$export$cce5f55ebce97e7e = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation removeFavoriteDiscussion($discussionId: Int) {
    deleteFavoriteDiscussions(where: { discussionId: { _eq: $discussionId } }) {
      affected_rows
    }
  }
`;
function $93486c083cb38a29$export$9110c1b8a970644e(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$cce5f55ebce97e7e, options);
}
const $93486c083cb38a29$export$2c89929752c729e3 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation addFavoriteResource($resourceId: Int) {
    insertFavoriteResource(object: { resourceId: $resourceId }) {
      id
    }
  }
`;
function $93486c083cb38a29$export$1547767e0e33ea52(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$2c89929752c729e3, options);
}
const $93486c083cb38a29$export$678d396ec26e1232 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation removeFavoriteResource($resourceId: Int) {
    deleteFavoriteResources(where: { resourceId: { _eq: $resourceId } }) {
      affected_rows
    }
  }
`;
function $93486c083cb38a29$export$2b0a10b59053d5e(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$678d396ec26e1232, options);
}
const $93486c083cb38a29$export$a779bdd035092a6a = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation getPresignedUpload($isPublic: Boolean!, $fileName: String!, $type: String!) {
    getPresignedUpload(config: { fileName: $fileName, isPublic: $isPublic, type: $type }) {
      fields
      url
      presignedGetUrl
    }
  }
`;
function $93486c083cb38a29$export$7607b86c7a656099(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$a779bdd035092a6a, options);
}
const $93486c083cb38a29$export$1d4ffdf110a38ec8 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query getNominations {
    v2_nominations(where: { is_deleted: { _eq: false } }, order_by: { created_at: desc }) {
      category
      created_at
      description
      from_user_id
      id
      project
      thumbsup {
        user_id
      }
      to_name
      to_user_id
      comments(order_by: { createdAt: asc }) {
        ...commentDetails
      }
    }
  }
  ${$93486c083cb38a29$export$d7bc6096322b0575}
`;
function $93486c083cb38a29$export$cec00d923a51c1d2(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$1d4ffdf110a38ec8, options);
}
function $93486c083cb38a29$export$f3853613a640af0b(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$1d4ffdf110a38ec8, options);
}
function $93486c083cb38a29$export$c8e6c46edb5920c1(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$1d4ffdf110a38ec8, options);
}
const $93486c083cb38a29$export$1b2e2f6a71791c4f = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation addNomination(
    $category: String
    $description: String
    $from_user_id: Int
    $project: String
    $to_name: String
    $to_user_id: Int
  ) {
    insert_v2_nominations_one(
      object: {
        category: $category
        description: $description
        from_user_id: $from_user_id
        project: $project
        to_name: $to_name
        to_user_id: $to_user_id
      }
    ) {
      id
    }
  }
`;
function $93486c083cb38a29$export$81097d281b2cbceb(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$1b2e2f6a71791c4f, options);
}
const $93486c083cb38a29$export$3516f51c390d4126 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation removeNomination($_eq: Int) {
    update_v2_nominations(where: { id: { _eq: $_eq } }, _set: { is_deleted: true }) {
      affected_rows
    }
  }
`;
function $93486c083cb38a29$export$965ca2601dea06c(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$3516f51c390d4126, options);
}
const $93486c083cb38a29$export$f2ebdab7cd022313 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation addNominationThumbsUp($nomination_id: Int, $user_id: Int) {
    insert_v2_nomination_thumbsup_one(object: { nomination_id: $nomination_id, user_id: $user_id }) {
      nomination_id
      user_id
    }
  }
`;
function $93486c083cb38a29$export$30e7a94a0bae9c05(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$f2ebdab7cd022313, options);
}
const $93486c083cb38a29$export$cdbe2c675006d690 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation removeNominationThumbsUp($nomId: Int = 10, $userId: Int = 10) {
    delete_v2_nomination_thumbsup(where: { nomination_id: { _eq: $nomId }, user_id: { _eq: $userId } }) {
      affected_rows
    }
  }
`;
function $93486c083cb38a29$export$f534093cbfcfcdb2(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$cdbe2c675006d690, options);
}
const $93486c083cb38a29$export$2355efe99b382679 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation addQuicklink($departmentId: Int!, $description: String = "", $title: String!, $url: String!) {
    insertDepartmentQuicklink(
      object: { departmentId: $departmentId, description: $description, title: $title, url: $url }
    ) {
      id
    }
  }
`;
function $93486c083cb38a29$export$c2d52ac2119174a2(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$2355efe99b382679, options);
}
const $93486c083cb38a29$export$d347ad21939ddd94 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation updateQuicklink($id: Int!, $description: String!, $title: String!, $url: String!) {
    updateDepartmentQuicklinkById(
      pk_columns: { id: $id }
      _set: { description: $description, title: $title, url: $url }
    ) {
      id
    }
  }
`;
function $93486c083cb38a29$export$d48e304d3a2a8822(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$d347ad21939ddd94, options);
}
const $93486c083cb38a29$export$5c2ab52de0aa9bb3 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation deleteQuicklink($id: Int!) {
    deleteDepartmentQuicklinkById(id: $id) {
      id
    }
  }
`;
function $93486c083cb38a29$export$b4f11c8de6bbc054(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$5c2ab52de0aa9bb3, options);
}
const $93486c083cb38a29$export$f8a7188d1f50bcb4 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation sendCrisisNotification($title: String!, $text: String!) {
    sendCrisisNotification(title: $title, text: $text) {
      success
      message
      campaignId
    }
  }
`;
function $93486c083cb38a29$export$308c2c378aa8b747(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$f8a7188d1f50bcb4, options);
}
const $93486c083cb38a29$export$b8d305f3d115bf5 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation updateComment($id: Int!, $comment: String!) {
    updateCommentById(pk_columns: { id: $id }, _set: { comment: $comment }) {
      id
    }
  }
`;
function $93486c083cb38a29$export$1f95a39633797408(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$b8d305f3d115bf5, options);
}
const $93486c083cb38a29$export$8f4fbf1f6e3972d8 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation updateGalleryOrder($children: jsonb = []) {
    updatePageBySlug(pk_columns: { slug: "gallery" }, _set: { children: $children }) {
      id
    }
  }
`;
function $93486c083cb38a29$export$b75fe83a2756d1c7(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$8f4fbf1f6e3972d8, options);
}
const $93486c083cb38a29$export$149e318d21adb90f = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation updateGalleryPhotoOrder($id: Int!, $children: jsonb = []) {
    updateGalleryById(pk_columns: { id: $id }, _set: { children: $children }) {
      id
    }
  }
`;
function $93486c083cb38a29$export$87a6aee51120b824(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$149e318d21adb90f, options);
}
const $93486c083cb38a29$export$d148bacbf053d7d2 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation disableGallery($id: Int!) {
    updateGalleryById(pk_columns: { id: $id }, _set: { active: false }) {
      id
    }
  }
`;
function $93486c083cb38a29$export$b89ea64d2a13b36d(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$d148bacbf053d7d2, options);
}
const $93486c083cb38a29$export$8f34a21f623bbb5d = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation updateGallery(
    $id: Int!
    $date: timestamptz!
    $title: String!
    $videoUploadId: Int
    $videoThumbnailUploadId: Int
  ) {
    updateGalleryById(
      pk_columns: { id: $id }
      _set: {
        title: $title
        date: $date
        videoUploadId: $videoUploadId
        videoThumbnailUploadId: $videoThumbnailUploadId
      }
    ) {
      id
      title
      date
    }
  }
`;
function $93486c083cb38a29$export$ff44cc8239f86a48(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$8f34a21f623bbb5d, options);
}
const $93486c083cb38a29$export$1e4cd30b972187a9 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation createGallery(
    $date: timestamptz!
    $title: String!
    $photos: galleryPhotos_arr_rel_insert_input!
    $videoUploadId: Int
    $videoThumbnailUploadId: Int
  ) {
    insertGallery(
      object: {
        active: true
        date: $date
        title: $title
        photos: $photos
        videoUploadId: $videoUploadId
        videoThumbnailUploadId: $videoThumbnailUploadId
      }
    ) {
      id
    }
  }
`;
function $93486c083cb38a29$export$8c35d5623b21c9f5(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$1e4cd30b972187a9, options);
}
const $93486c083cb38a29$export$3dd7f25ddf5decb5 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation removeGalleryPhoto($id: Int!) {
    deleteGalleryPhotoById(id: $id) {
      id
    }
  }
`;
function $93486c083cb38a29$export$a0cb06c8b903595b(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$3dd7f25ddf5decb5, options);
}
const $93486c083cb38a29$export$b9267cf83a69dae8 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation addGalleryPhotos($objects: [galleryPhotos_insert_input!]!) {
    insertGalleryPhotos(objects: $objects) {
      affected_rows
    }
  }
`;
function $93486c083cb38a29$export$9e4a1835de3418b0(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$b9267cf83a69dae8, options);
}
const $93486c083cb38a29$export$e1c60a5c8bf8becb = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query bulletins {
    bulletins(order_by: { createdAt: desc }, where: { global: { _eq: true } }, limit: 10) {
      ...bulletinDetails
    }
  }
  ${$93486c083cb38a29$export$94a25c9ea19fb9b5}
`;
function $93486c083cb38a29$export$4d4ddd807f84394d(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$e1c60a5c8bf8becb, options);
}
function $93486c083cb38a29$export$b0735e0317ec24c2(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$e1c60a5c8bf8becb, options);
}
function $93486c083cb38a29$export$d6a1d2a8a7fc5cf8(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$e1c60a5c8bf8becb, options);
}
const $93486c083cb38a29$export$26013cd80a9bfac0 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query singleBulletin($id: Int!) {
    bulletins(where: { id: { _eq: $id } }) {
      ...bulletinDetails
    }
  }
  ${$93486c083cb38a29$export$94a25c9ea19fb9b5}
`;
function $93486c083cb38a29$export$cd249570f68f791d(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$26013cd80a9bfac0, options);
}
function $93486c083cb38a29$export$4e03c249e1d3611c(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$26013cd80a9bfac0, options);
}
function $93486c083cb38a29$export$d783383083f6baeb(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$26013cd80a9bfac0, options);
}
const $93486c083cb38a29$export$ce51e68352df2445 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query cameraEmbedsGetActive {
    cameraEmbeds(where: { active: { _eq: true } }, order_by: { createdAt: asc }) {
      id
      title
      source
      stillUrl
      active
      jobsiteId
    }
  }
`;
function $93486c083cb38a29$export$3923358757a3967b(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$ce51e68352df2445, options);
}
function $93486c083cb38a29$export$d3d8b635640320f9(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$ce51e68352df2445, options);
}
function $93486c083cb38a29$export$d354c9b6054babb7(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$ce51e68352df2445, options);
}
const $93486c083cb38a29$export$2973b49e44106e3f = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query companyDirectoryUsers {
    users(
      where: { _not: { username: { _in: ["roi", "mattw", "mcheckwood", "estevans"] } } }
      order_by: { lastName: asc }
    ) {
      ...userDetails
    }
  }
  ${$93486c083cb38a29$export$b2dbb4d61e0c0725}
`;
function $93486c083cb38a29$export$7258bf72bd405c60(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$2973b49e44106e3f, options);
}
function $93486c083cb38a29$export$60a0fd9aa7b9e04a(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$2973b49e44106e3f, options);
}
function $93486c083cb38a29$export$cfa6e8c737fed9d3(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$2973b49e44106e3f, options);
}
const $93486c083cb38a29$export$7a1d7c0a974ead17 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query configByKey($key: String!) {
    configByKey(key: $key) {
      value
    }
  }
`;
function $93486c083cb38a29$export$ecb06dbd95d54e0c(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$7a1d7c0a974ead17, options);
}
function $93486c083cb38a29$export$17f8285f23a1fb32(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$7a1d7c0a974ead17, options);
}
function $93486c083cb38a29$export$a7568f95276b932d(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$7a1d7c0a974ead17, options);
}
const $93486c083cb38a29$export$397516600bb4d3a2 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query currentUser {
    currentUser {
      userId
      user {
        ...userDetails
        ...userFavorites
        roles {
          role
        }
      }
    }
  }
  ${$93486c083cb38a29$export$b2dbb4d61e0c0725}
  ${$93486c083cb38a29$export$f5048f456aa06cdf}
`;
function $93486c083cb38a29$export$318bde49185e5a43(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$397516600bb4d3a2, options);
}
function $93486c083cb38a29$export$5c2913b448ed52a3(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$397516600bb4d3a2, options);
}
function $93486c083cb38a29$export$c744652b0ed78ea7(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$397516600bb4d3a2, options);
}
const $93486c083cb38a29$export$469db27ae601d23c = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query departmentDetails($departmentId: Int!) {
    department: departmentById(id: $departmentId) {
      ...departmentDetails
    }
  }
  ${$93486c083cb38a29$export$a2d77ac6f8fee5d5}
`;
function $93486c083cb38a29$export$722295c247fb669(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$469db27ae601d23c, options);
}
function $93486c083cb38a29$export$3eda48c23ec6eb8d(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$469db27ae601d23c, options);
}
function $93486c083cb38a29$export$19a3bb7cb849e6fe(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$469db27ae601d23c, options);
}
const $93486c083cb38a29$export$3ccc813ebbbf699d = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query departmentEmployees($departmentId: Int!) {
    departmentById(id: $departmentId) {
      employees {
        ...userDetails
      }
    }
  }
  ${$93486c083cb38a29$export$b2dbb4d61e0c0725}
`;
function $93486c083cb38a29$export$41a28deb3bd3c231(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$3ccc813ebbbf699d, options);
}
function $93486c083cb38a29$export$bcfd73d47eaa8d8e(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$3ccc813ebbbf699d, options);
}
function $93486c083cb38a29$export$b666065c705983fe(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$3ccc813ebbbf699d, options);
}
const $93486c083cb38a29$export$bdf6177c10023d5b = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query discussions {
    discussions(order_by: { createdAt: desc }, where: { departmentId: { _is_null: true } }) {
      ...discussionDetails
    }
  }
  ${$93486c083cb38a29$export$2f6245eda63d427f}
`;
function $93486c083cb38a29$export$a5344e78eb5e7c6d(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$bdf6177c10023d5b, options);
}
function $93486c083cb38a29$export$426080c1e097db1f(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$bdf6177c10023d5b, options);
}
function $93486c083cb38a29$export$ee637bb3a246b787(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$bdf6177c10023d5b, options);
}
const $93486c083cb38a29$export$573ba9c2cbf31e2d = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query events($startFrom: timestamptz!) {
    events(where: { startsAt: { _gte: $startFrom } }, order_by: { startsAt: asc }) {
      ...event
    }
  }
  ${$93486c083cb38a29$export$5382c2864ccd3da0}
`;
function $93486c083cb38a29$export$f264892194843ef2(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$573ba9c2cbf31e2d, options);
}
function $93486c083cb38a29$export$a8b5904f74a5a7a2(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$573ba9c2cbf31e2d, options);
}
function $93486c083cb38a29$export$2b0b4155e40e50d0(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$573ba9c2cbf31e2d, options);
}
const $93486c083cb38a29$export$2fb70465b0ac0158 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query eventsGetByDate($start: timestamptz!, $end: timestamptz!) {
    events(where: { _and: { startsAt: { _lte: $start }, endsAt: { _gte: $end } } }, order_by: { startsAt: asc }) {
      ...event
    }
  }
  ${$93486c083cb38a29$export$5382c2864ccd3da0}
`;
function $93486c083cb38a29$export$e9d9effeffeae5a(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$2fb70465b0ac0158, options);
}
function $93486c083cb38a29$export$9de7f1eeaf874396(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$2fb70465b0ac0158, options);
}
function $93486c083cb38a29$export$94b0f8142449f041(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$2fb70465b0ac0158, options);
}
const $93486c083cb38a29$export$f5b0ffdc6629c39b = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query getEventTypes {
    eventTypes {
      comment
      value
    }
  }
`;
function $93486c083cb38a29$export$b9310176858b0ab6(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$f5b0ffdc6629c39b, options);
}
function $93486c083cb38a29$export$ed46964804bf3802(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$f5b0ffdc6629c39b, options);
}
function $93486c083cb38a29$export$bed1f5b1367d090b(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$f5b0ffdc6629c39b, options);
}
const $93486c083cb38a29$export$b02e6c10e95202d8 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query getAllEvents {
    events {
      ...event
    }
  }
  ${$93486c083cb38a29$export$5382c2864ccd3da0}
`;
function $93486c083cb38a29$export$814fd1be80a6e6be(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$b02e6c10e95202d8, options);
}
function $93486c083cb38a29$export$c9afd904493668e0(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$b02e6c10e95202d8, options);
}
function $93486c083cb38a29$export$5a5897638cf46c96(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$b02e6c10e95202d8, options);
}
const $93486c083cb38a29$export$7e3a176b19b130d = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation createEvent(
    $allDay: Boolean!
    $description: String!
    $endsAt: timestamptz!
    $startsAt: timestamptz!
    $title: String!
    $type: eventTypes_enum!
  ) {
    insertEvent(
      object: {
        allDay: $allDay
        description: $description
        endsAt: $endsAt
        startsAt: $startsAt
        title: $title
        type: $type
      }
    ) {
      id
    }
  }
`;
function $93486c083cb38a29$export$c78810c1254c21c8(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$7e3a176b19b130d, options);
}
const $93486c083cb38a29$export$b490574f29263ac0 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation deleteEvent($id: Int!) {
    deleteEventById(id: $id) {
      id
    }
  }
`;
function $93486c083cb38a29$export$257c69caab61b878(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$b490574f29263ac0, options);
}
const $93486c083cb38a29$export$629c7ca71c17ab3d = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation updateEvent(
    $id: Int!
    $allDay: Boolean!
    $description: String!
    $endsAt: timestamptz!
    $startsAt: timestamptz!
    $title: String!
    $type: eventTypes_enum!
  ) {
    updateEventById(
      pk_columns: { id: $id }
      _set: {
        allDay: $allDay
        description: $description
        endsAt: $endsAt
        startsAt: $startsAt
        title: $title
        type: $type
      }
    ) {
      id
    }
  }
`;
function $93486c083cb38a29$export$d624085c29681b0a(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$629c7ca71c17ab3d, options);
}
const $93486c083cb38a29$export$bc912973c7913eac = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query galleriesGetAll {
    galleries(where: { active: { _eq: true } }) {
      id
      date
      title
      thumbUrl
      date
      children
      videoUpload {
        id
        publicUrl
        type
      }
      videoThumbnail {
        id
        publicUrl
      }
    }
    galleryPage: pagesBySlug(slug: "gallery") {
      children
    }
  }
`;
function $93486c083cb38a29$export$6954a324c39a3400(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$bc912973c7913eac, options);
}
function $93486c083cb38a29$export$8d1a6c075a1569c0(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$bc912973c7913eac, options);
}
function $93486c083cb38a29$export$a12991e865cd60ac(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$bc912973c7913eac, options);
}
const $93486c083cb38a29$export$232abb3e31c29db6 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query getGallery($id: Int!) {
    gallery: galleryById(id: $id) {
      id
      date
      title
      children
      photos {
        id
        image {
          publicUrl
        }
      }
      videoUpload {
        id
        publicUrl
        type
      }
      videoThumbnail {
        id
        publicUrl
      }
    }
  }
`;
function $93486c083cb38a29$export$b77182dfd58e82cf(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$232abb3e31c29db6, options);
}
function $93486c083cb38a29$export$4b2c274fad10cbb4(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$232abb3e31c29db6, options);
}
function $93486c083cb38a29$export$b572f6f9ba9c10dd(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$232abb3e31c29db6, options);
}
const $93486c083cb38a29$export$599f12b6bfc7c404 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query recent {
    bulletins(where: { global: { _eq: true } }, order_by: { createdAt: desc }, limit: 3) {
      ...bulletinDetails
    }
    discussions(order_by: { createdAt: desc }, limit: 3) {
      ...discussionDetails
    }
    resources(order_by: { createdAt: desc }, limit: 3) {
      ...resourceDetails
    }
  }
  ${$93486c083cb38a29$export$94a25c9ea19fb9b5}
  ${$93486c083cb38a29$export$2f6245eda63d427f}
  ${$93486c083cb38a29$export$b8d5095d717cda36}
`;
function $93486c083cb38a29$export$7ee0ee4227d82d94(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$599f12b6bfc7c404, options);
}
function $93486c083cb38a29$export$266ca063d587f512(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$599f12b6bfc7c404, options);
}
function $93486c083cb38a29$export$e17393a38298b3d1(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$599f12b6bfc7c404, options);
}
const $93486c083cb38a29$export$fc8938d393e5d7b1 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query recentBulletins {
    bulletins(where: { global: { _eq: true } }, order_by: { createdAt: desc }, limit: 5) {
      ...bulletinDetails
    }
  }
  ${$93486c083cb38a29$export$94a25c9ea19fb9b5}
`;
function $93486c083cb38a29$export$d0d6b485bf39808e(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$fc8938d393e5d7b1, options);
}
function $93486c083cb38a29$export$3f09fffd6ebeb1a6(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$fc8938d393e5d7b1, options);
}
function $93486c083cb38a29$export$1697750d1c7b2edc(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$fc8938d393e5d7b1, options);
}
const $93486c083cb38a29$export$3b3598aeb47b47f2 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query recentDiscussions {
    discussions(order_by: { createdAt: desc }, limit: 3) {
      ...discussionDetails
    }
  }
  ${$93486c083cb38a29$export$2f6245eda63d427f}
`;
function $93486c083cb38a29$export$52e1198f79679ec6(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$3b3598aeb47b47f2, options);
}
function $93486c083cb38a29$export$2b2b32e8da000928(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$3b3598aeb47b47f2, options);
}
function $93486c083cb38a29$export$a7966608b50f56f3(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$3b3598aeb47b47f2, options);
}
const $93486c083cb38a29$export$a6263c7b6b6a1b12 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query recentResources {
    resources(order_by: { createdAt: desc }, limit: 3) {
      ...resourceDetails
    }
  }
  ${$93486c083cb38a29$export$b8d5095d717cda36}
`;
function $93486c083cb38a29$export$b0a115e858c0b484(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$a6263c7b6b6a1b12, options);
}
function $93486c083cb38a29$export$d09811aefef291f8(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$a6263c7b6b6a1b12, options);
}
function $93486c083cb38a29$export$c4b21a2fa5d29e9c(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$a6263c7b6b6a1b12, options);
}
const $93486c083cb38a29$export$d80624777a38300c = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query allResources {
    resources(where: { deleted: { _is_null: true } }, order_by: { createdAt: desc }) {
      ...resourceDetails
    }
  }
  ${$93486c083cb38a29$export$b8d5095d717cda36}
`;
function $93486c083cb38a29$export$de72a3e3ea83f132(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$d80624777a38300c, options);
}
function $93486c083cb38a29$export$fde328d59d4e2b8e(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$d80624777a38300c, options);
}
function $93486c083cb38a29$export$437b14a53868da75(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$d80624777a38300c, options);
}
const $93486c083cb38a29$export$2f378e47d8340cd1 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query iosRedemptionCode {
    iosRedemptionCode {
      code
      url
    }
  }
`;
function $93486c083cb38a29$export$c93cc7c5ad94e959(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$2f378e47d8340cd1, options);
}
function $93486c083cb38a29$export$5aa87c875db9fb46(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$2f378e47d8340cd1, options);
}
function $93486c083cb38a29$export$c9b99c60b6fe5fae(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$2f378e47d8340cd1, options);
}
const $93486c083cb38a29$export$d7fdebc39d67346c = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query jobsites {
    jobsites(order_by: { title: asc }) {
      ...jobsite
    }
  }
  ${$93486c083cb38a29$export$bd95d134196d6ed2}
`;
function $93486c083cb38a29$export$f64f3247eeaa58a9(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$d7fdebc39d67346c, options);
}
function $93486c083cb38a29$export$36462643091d4fe4(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$d7fdebc39d67346c, options);
}
function $93486c083cb38a29$export$47f38a2b4fcbeb44(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$d7fdebc39d67346c, options);
}
const $93486c083cb38a29$export$3a9df1b5928f2911 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation createJobsite(
    $mainAddress: String!
    $mainAddress2: String
    $mainAddressCity: String!
    $mainAddressState: String!
    $mainAddressZip: String!
    $officeAddress: String
    $officeAddress2: String
    $officeAddressCity: String
    $officeAddressState: String
    $officeAddressZip: String
    $phone: String!
    $siteNumber: String!
    $title: String!
    $alt_names: String!
  ) {
    insertJobsite(
      object: {
        mainAddress: $mainAddress
        mainAddress2: $mainAddress2
        mainAddressCity: $mainAddressCity
        mainAddressState: $mainAddressState
        mainAddressZip: $mainAddressZip
        officeAddress: $officeAddress
        officeAddress2: $officeAddress2
        officeAddressCity: $officeAddressCity
        officeAddressState: $officeAddressState
        officeAddressZip: $officeAddressZip
        phone: $phone
        siteNumber: $siteNumber
        title: $title
        alt_names: $alt_names
      }
    ) {
      id
    }
  }
`;
function $93486c083cb38a29$export$d44cc90afff5d3b2(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$3a9df1b5928f2911, options);
}
const $93486c083cb38a29$export$1a47a6237a8ded70 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation updateJobsite(
    $id: Int!
    $mainAddress: String!
    $mainAddress2: String
    $mainAddressCity: String!
    $mainAddressState: String!
    $mainAddressZip: String!
    $officeAddress: String
    $officeAddress2: String
    $officeAddressCity: String
    $officeAddressState: String
    $officeAddressZip: String
    $phone: String!
    $siteNumber: String!
    $title: String!
    $alt_names: String!
  ) {
    updateJobsiteById(
      pk_columns: { id: $id }
      _set: {
        mainAddress: $mainAddress
        mainAddress2: $mainAddress2
        mainAddressCity: $mainAddressCity
        mainAddressState: $mainAddressState
        mainAddressZip: $mainAddressZip
        officeAddress: $officeAddress
        officeAddress2: $officeAddress2
        officeAddressCity: $officeAddressCity
        officeAddressState: $officeAddressState
        officeAddressZip: $officeAddressZip
        phone: $phone
        siteNumber: $siteNumber
        title: $title
        alt_names: $alt_names
      }
    ) {
      id
    }
  }
`;
function $93486c083cb38a29$export$83310d2b73219242(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$1a47a6237a8ded70, options);
}
const $93486c083cb38a29$export$7037dcda82dee9a5 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  mutation deleteJobsite($id: Int!) {
    deleteJobsiteById(id: $id) {
      id
    }
  }
`;
function $93486c083cb38a29$export$bf3b340cbc1be158(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$7037dcda82dee9a5, options);
}
const $93486c083cb38a29$export$5ec520cdfffd87f9 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query latestOrgChart {
    resources(where: { title: { _ilike: "%org% %chart%" } }, order_by: { createdAt: desc_nulls_last }, limit: 1) {
      ...resourceDetails
    }
  }
  ${$93486c083cb38a29$export$b8d5095d717cda36}
`;
function $93486c083cb38a29$export$404deecb7906e6a8(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$5ec520cdfffd87f9, options);
}
function $93486c083cb38a29$export$4703cb35399ab831(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$5ec520cdfffd87f9, options);
}
function $93486c083cb38a29$export$e5fad279cd8ea21a(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$5ec520cdfffd87f9, options);
}
const $93486c083cb38a29$export$28ce6bf21469a3e4 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query orgChartUsers {
    users(
      where: { workerType: { _eq: "F" }, _not: { username: { _in: ["roi", "mattw"] } } }
      order_by: { lastName: asc }
    ) {
      ...orgChartUser
    }
  }
  ${$93486c083cb38a29$export$754aea510180ce7d}
`;
function $93486c083cb38a29$export$2bd5ffe7a75ae513(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$28ce6bf21469a3e4, options);
}
function $93486c083cb38a29$export$f7a907ff0451877e(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$28ce6bf21469a3e4, options);
}
function $93486c083cb38a29$export$c6443e8a60881f06(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$28ce6bf21469a3e4, options);
}
const $93486c083cb38a29$export$e50791355ae8e493 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query pagesSignInMasthead {
    signinPage: pagesBySlug(slug: "sign-in") {
      masthead {
        publicUrl
        key
      }
    }
  }
`;
function $93486c083cb38a29$export$27db48495116d434(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$e50791355ae8e493, options);
}
function $93486c083cb38a29$export$415d5ab276c96326(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$e50791355ae8e493, options);
}
function $93486c083cb38a29$export$ef568bf9a6483c55(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$e50791355ae8e493, options);
}
const $93486c083cb38a29$export$25de7845cd69fc8e = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query search($keywords: String!) {
    search(where: { keywords: { _ilike: $keywords } }) {
      user {
        ...userDetails
      }
      modelType
      modelId
      resource {
        ...resourceDetails
        departmentContentsResources {
          departmentContent {
            departmentId
            parentId
            id
            title
          }
        }
      }
      bulletin {
        ...bulletinDetails
      }
    }
  }
  ${$93486c083cb38a29$export$b2dbb4d61e0c0725}
  ${$93486c083cb38a29$export$b8d5095d717cda36}
  ${$93486c083cb38a29$export$94a25c9ea19fb9b5}
`;
function $93486c083cb38a29$export$e985158d10c27e34(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$25de7845cd69fc8e, options);
}
function $93486c083cb38a29$export$a5ec40133e48a541(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$25de7845cd69fc8e, options);
}
function $93486c083cb38a29$export$73aa743e5cc183e8(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$25de7845cd69fc8e, options);
}
const $93486c083cb38a29$export$5cbbe0332ef90f3c = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query resourceSearch($_ilike: String) {
    resources(
      where: { deleted: { _is_null: true }, title: { _ilike: $_ilike } }
      limit: 10
      order_by: { createdAt: desc_nulls_last }
    ) {
      title
      id
      createdAt
      description
      file {
        key
        url
        type
        size
      }
    }
  }
`;
function $93486c083cb38a29$export$45db8b18d7460eb1(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$5cbbe0332ef90f3c, options);
}
function $93486c083cb38a29$export$8c1db51fc59eb34e(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$5cbbe0332ef90f3c, options);
}
function $93486c083cb38a29$export$203307065e91ad24(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$5cbbe0332ef90f3c, options);
}
const $93486c083cb38a29$export$f330b337bb948e00 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query siteMeta {
    departments {
      id
      title
      ownerId
      contents(where: { parentId: { _is_null: true }, active: { _eq: true } }) {
        id
        title
      }
      masthead {
        publicUrl
        key
      }
      logo {
        key
      }
    }
    pages {
      masthead {
        publicUrl
        key
      }
      slug
      title
      body
    }
  }
`;
function $93486c083cb38a29$export$67241447dc3e8d68(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$f330b337bb948e00, options);
}
function $93486c083cb38a29$export$fb58988cffcd0fd0(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$f330b337bb948e00, options);
}
function $93486c083cb38a29$export$cc4dd51650bbc80c(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$f330b337bb948e00, options);
}
const $93486c083cb38a29$export$6d5bc81e458b3414 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query tempGetAllPto {
    pto {
      startsAt
      allDay
      user {
        firstName
        lastName
      }
    }
  }
`;
function $93486c083cb38a29$export$637d939281487e1a(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$6d5bc81e458b3414, options);
}
function $93486c083cb38a29$export$f25f88b3769905d3(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$6d5bc81e458b3414, options);
}
function $93486c083cb38a29$export$b9b8ea1cc2b07083(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$6d5bc81e458b3414, options);
}
const $93486c083cb38a29$export$5396b4d9e81f017a = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query tempPto($id: Int!) {
    userById(id: $id) {
      adp {
        ptoBalances
        ptoRequests
      }
    }
  }
`;
function $93486c083cb38a29$export$768ffb86c8a02a0e(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$5396b4d9e81f017a, options);
}
function $93486c083cb38a29$export$d6d3796c59ced265(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$5396b4d9e81f017a, options);
}
function $93486c083cb38a29$export$e7f0ed1f21e2012d(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$5396b4d9e81f017a, options);
}
const $93486c083cb38a29$export$173cb491494ed890 = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query usersGetAll {
    users(where: { _not: { username: { _in: ["roi", "mattw"] } } }, order_by: { lastName: asc }) {
      ...userDetails
    }
  }
  ${$93486c083cb38a29$export$b2dbb4d61e0c0725}
`;
function $93486c083cb38a29$export$db5004fb9b9627eb(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$173cb491494ed890, options);
}
function $93486c083cb38a29$export$79b62c67111f226a(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$173cb491494ed890, options);
}
function $93486c083cb38a29$export$b5a18b320d206ed7(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$173cb491494ed890, options);
}
const $93486c083cb38a29$export$8d47e88c1ce8e96b = (0, $91606a2807685cb4$export$72e4926bf8358653)`
  query usersGetById($id: Int!) {
    users(where: { id: { _eq: $id } }) {
      ...userDetails
    }
  }
  ${$93486c083cb38a29$export$b2dbb4d61e0c0725}
`;
function $93486c083cb38a29$export$f793bbdd154e8931(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $e040a67118ad2df5$export$dd0a697e1782aedd($93486c083cb38a29$export$8d47e88c1ce8e96b, options);
}
function $93486c083cb38a29$export$baf780701b30f28c(baseOptions) {
    const options = {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $518e978e29b3d0d2$export$fd83eea6ecd2d8fa($93486c083cb38a29$export$8d47e88c1ce8e96b, options);
}
function $93486c083cb38a29$export$e1f6ce8f7eef873c(baseOptions) {
    const options = baseOptions === $57d3755bf6de1db3$export$1aa5a89531b7670d ? baseOptions : {
        ...$93486c083cb38a29$var$defaultOptions,
        ...baseOptions
    };
    return $a54845280ff230ed$export$5bf2755c0a009e74($93486c083cb38a29$export$8d47e88c1ce8e96b, options);
}



class $835d53c08bf1de77$export$b9721ef022f71a68 extends Error {
}
$835d53c08bf1de77$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $835d53c08bf1de77$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $835d53c08bf1de77$var$base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $835d53c08bf1de77$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $835d53c08bf1de77$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $835d53c08bf1de77$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") throw new $835d53c08bf1de77$export$b9721ef022f71a68(`Invalid token specified: missing part #${pos + 1}`);
    let decoded;
    try {
        decoded = $835d53c08bf1de77$var$base64UrlDecode(part);
    } catch (e) {
        throw new $835d53c08bf1de77$export$b9721ef022f71a68(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $835d53c08bf1de77$export$b9721ef022f71a68(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}



var $jIrNf = parcelRequire("jIrNf");
const $f8298f6bd5fca48e$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createContext(null);
function $f8298f6bd5fca48e$var$AuthGate({ children: children }) {
    const client = (0, $b86ffbc6c4f7be29$export$eb9a56e7a29e494)();
    const [accessToken, setAccessToken] = (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).useState(localStorage.accessToken);
    (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).useEffect(()=>{
        const badJwtHandler = ()=>{
            setAccessToken(null);
        };
        window.addEventListener('invalid-jwt', badJwtHandler);
        return ()=>window.removeEventListener('invalid-jwt', badJwtHandler);
    });
    if (accessToken) localStorage.setItem('accessToken', accessToken);
    else localStorage.removeItem('accessToken');
    const { data: data, loading: isLoading } = (0, $93486c083cb38a29$export$318bde49185e5a43)({
        skip: !accessToken
    });
    const [authenticateUser] = (0, $93486c083cb38a29$export$b6f0d9793b6d1b9f)({
        onCompleted () {
            client.clearStore();
        }
    });
    // Refresh accessToken if roles on token do not match current user roles
    (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).useEffect(()=>{
        if (data?.currentUser?.user?.roles) {
            const jwt = (0, $835d53c08bf1de77$export$fa1e2fb699b7861e)(accessToken);
            const tokenRoles = jwt['https://hasura.io/jwt/claims']['x-hasura-allowed-roles'];
            const compareRoles = tokenRoles.filter((r)=>r != 'user').sort();
            const roles = data.currentUser.user.roles.map((ur)=>ur.role).sort();
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).isEqual(roles, compareRoles)) {
                console.log('refetch jwt');
                authenticateUser({
                    variables: {
                        username: '',
                        password: ''
                    }
                }).then(({ data: data })=>setAccessToken(data.authenticateUser.accessToken));
            }
        }
    }, [
        data?.currentUser?.userId
    ]);
    const state = {
        isLoading: isLoading,
        setAccessToken: setAccessToken,
        user: accessToken ? data?.currentUser?.user : undefined
    };
    return /*#__PURE__*/ (0, $01ysi.jsx)($f8298f6bd5fca48e$var$Context.Provider, {
        value: state,
        children: children(state)
    });
}
function $f8298f6bd5fca48e$export$a609e16b0cfae3f1() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).useContext($f8298f6bd5fca48e$var$Context);
}
var $f8298f6bd5fca48e$export$2e2bcd8739ae039 = $f8298f6bd5fca48e$var$AuthGate;



var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");
const $152b72f1e80df695$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createContext(null);
class $152b72f1e80df695$var$Provider extends (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).PureComponent {
    constructor(props){
        super(props), this.state = {};
        for (const [screen, mq] of Object.entries(props.config)){
            const mql = window.matchMedia(mq);
            this.state[screen] = mql.matches;
            mql.addListener((e)=>{
                this.setState({
                    [screen]: e.matches
                });
            });
        }
        this.setBodyClasses();
    }
    componentDidUpdate() {
        this.setBodyClasses();
    }
    setBodyClasses() {
        for (const [screen, enabled] of Object.entries(this.state)){
            const className = `screen-${screen}`;
            const method = enabled ? 'add' : 'remove';
            document.body.classList[method](className);
        }
    }
    render() {
        return /*#__PURE__*/ (0, $01ysi.jsx)($152b72f1e80df695$var$Context.Provider, {
            value: this.state,
            children: this.props.children
        });
    }
}
class $152b72f1e80df695$var$Mq extends (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).PureComponent {
    static{
        this.Provider = $152b72f1e80df695$var$Provider;
    }
    static{
        this.withMq = (Component)=>(props)=>/*#__PURE__*/ (0, $01ysi.jsx)($152b72f1e80df695$var$Mq, {
                    children: (mq)=>/*#__PURE__*/ (0, $01ysi.jsx)(Component, {
                            mq: mq,
                            ...props
                        })
                });
    }
    render() {
        return /*#__PURE__*/ (0, $01ysi.jsx)($152b72f1e80df695$var$Context.Consumer, {
            ...this.props
        });
    }
}
function $152b72f1e80df695$export$6f722a2ab43a6843() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).useContext($152b72f1e80df695$var$Context);
}
var $152b72f1e80df695$export$2e2bcd8739ae039 = $152b72f1e80df695$var$Mq;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");

var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");

const $8eba5eb0a877e3f9$var$rotate = (0, $8999e1d77b7e12d9$export$d25ddfdf17c3ad3e)`
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
`;
const $8eba5eb0a877e3f9$export$52b4dfd89a6b3a1b = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: inline-block;
	position: relative;
	width: ${(props)=>props.size === 'xsm' ? '1rem' : props.size === 'sm' ? '25px' : '64px'};
	height: ${(props)=>props.size === 'xsm' ? '1rem' : props.size === 'sm' ? '25px' : '64px'};
	& > div {
		box-sizing: border-box;
		display: block;
		position: absolute;
		width: 85%;
		height: 85%;
		margin: 10%;
		border: 3px solid
			${(props)=>props.type === 'primary' ? props.theme.colors.primary : props.theme.colors.white};
		border-radius: 50%;
		animation: ${$8eba5eb0a877e3f9$var$rotate} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
		border-color: ${(props)=>props.type === 'primary' ? props.theme.colors.primary : props.theme.colors.white}
			transparent transparent transparent;
		&:nth-child(1) {
			animation-delay: -0.45s;
		}
		&:nth-child(2) {
			animation-delay: -0.3s;
		}
		&:nth-child(3) {
			animation-delay: -0.15s;
		}
	}
`;


const $a5fc2fd641867f25$var$Spinner = ({ className: className, size: size = 'lg', type: type = 'primary' })=>/*#__PURE__*/ (0, $01ysi.jsxs)((0, $8eba5eb0a877e3f9$export$52b4dfd89a6b3a1b), {
        className: className,
        id: "spinner",
        size: size,
        type: type,
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)("div", {}),
            /*#__PURE__*/ (0, $01ysi.jsx)("div", {}),
            /*#__PURE__*/ (0, $01ysi.jsx)("div", {}),
            /*#__PURE__*/ (0, $01ysi.jsx)("div", {})
        ]
    });
var $a5fc2fd641867f25$export$2e2bcd8739ae039 = $a5fc2fd641867f25$var$Spinner;
function $a5fc2fd641867f25$export$91fa629114bce97f() {
    return /*#__PURE__*/ (0, $01ysi.jsx)("div", {
        style: {
            width: '100%',
            textAlign: 'center'
        },
        children: /*#__PURE__*/ (0, $01ysi.jsx)($a5fc2fd641867f25$var$Spinner, {})
    });
}


var $c13f5dcd3b5a79d6$export$967ae6540d4e2ca8;
$c13f5dcd3b5a79d6$export$967ae6540d4e2ca8 = `_rp4Xq_appLoading`;


const $8d13d13871606beb$var$AppLoading = ()=>/*#__PURE__*/ (0, $01ysi.jsx)("div", {
        className: $c13f5dcd3b5a79d6$export$967ae6540d4e2ca8,
        children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $a5fc2fd641867f25$export$2e2bcd8739ae039), {})
    });
var $8d13d13871606beb$export$2e2bcd8739ae039 = $8d13d13871606beb$var$AppLoading;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");

var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");

var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");


var $e472631d3972460c$exports = {};
"use strict";
"use client";

var $dN8sB = parcelRequire("dN8sB");
Object.defineProperty($e472631d3972460c$exports, "__esModule", {
    value: true
});
$e472631d3972460c$exports.default = void 0;

var $e472631d3972460c$var$_createSvgIcon = $dN8sB((parcelRequire("hNM3I")));

var $01ysi = parcelRequire("01ysi");
var $e472631d3972460c$var$_default = $e472631d3972460c$exports.default = (0, $e472631d3972460c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $01ysi.jsx)("path", {
    d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5"
}), 'Room');


var $edb6c6ead0806272$exports = {};
"use strict";
"use client";

var $dN8sB = parcelRequire("dN8sB");
Object.defineProperty($edb6c6ead0806272$exports, "__esModule", {
    value: true
});
$edb6c6ead0806272$exports.default = void 0;

var $edb6c6ead0806272$var$_createSvgIcon = $dN8sB((parcelRequire("hNM3I")));

var $01ysi = parcelRequire("01ysi");
var $edb6c6ead0806272$var$_default = $edb6c6ead0806272$exports.default = (0, $edb6c6ead0806272$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $01ysi.jsx)("path", {
    d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02z"
}), 'Phone');



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $ag2w3 = parcelRequire("ag2w3");
var $519c95b753b7732e$exports = {};
var $72d1c9fd8dbb0ad6$exports = {};
var $ec8a9e886ebff8e0$exports = {};
function $ec8a9e886ebff8e0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ec8a9e886ebff8e0$exports = $ec8a9e886ebff8e0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ec8a9e886ebff8e0$exports.__esModule = true, $ec8a9e886ebff8e0$exports["default"] = $ec8a9e886ebff8e0$exports, $ec8a9e886ebff8e0$var$_typeof(o);
}
$ec8a9e886ebff8e0$exports = $ec8a9e886ebff8e0$var$_typeof, $ec8a9e886ebff8e0$exports.__esModule = true, $ec8a9e886ebff8e0$exports["default"] = $ec8a9e886ebff8e0$exports;


var $72d1c9fd8dbb0ad6$var$_typeof = $ec8a9e886ebff8e0$exports.default;
var $7166210cc3ab84b6$exports = {};

var $7166210cc3ab84b6$var$_typeof = $ec8a9e886ebff8e0$exports.default;
function $7166210cc3ab84b6$var$toPrimitive(t, r) {
    if ("object" != $7166210cc3ab84b6$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7166210cc3ab84b6$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$7166210cc3ab84b6$exports = $7166210cc3ab84b6$var$toPrimitive, $7166210cc3ab84b6$exports.__esModule = true, $7166210cc3ab84b6$exports["default"] = $7166210cc3ab84b6$exports;


function $72d1c9fd8dbb0ad6$var$toPropertyKey(t) {
    var i = $7166210cc3ab84b6$exports(t, "string");
    return "symbol" == $72d1c9fd8dbb0ad6$var$_typeof(i) ? i : i + "";
}
$72d1c9fd8dbb0ad6$exports = $72d1c9fd8dbb0ad6$var$toPropertyKey, $72d1c9fd8dbb0ad6$exports.__esModule = true, $72d1c9fd8dbb0ad6$exports["default"] = $72d1c9fd8dbb0ad6$exports;


function $519c95b753b7732e$var$_defineProperty(e, r, t) {
    return (r = $72d1c9fd8dbb0ad6$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$519c95b753b7732e$exports = $519c95b753b7732e$var$_defineProperty, $519c95b753b7732e$exports.__esModule = true, $519c95b753b7732e$exports["default"] = $519c95b753b7732e$exports;


var $90b8af3236d96777$exports = {};

var $2SaMy = parcelRequire("2SaMy");
function $90b8af3236d96777$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $2SaMy(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$90b8af3236d96777$exports = $90b8af3236d96777$var$_objectWithoutProperties, $90b8af3236d96777$exports.__esModule = true, $90b8af3236d96777$exports["default"] = $90b8af3236d96777$exports;



var $gRqVZ = parcelRequire("gRqVZ");

var $4a8454b298d0a02b$var$_excluded = [
    "children",
    "iconAttrs",
    "iconVerticalAlign",
    "iconViewBox",
    "size",
    "title"
];
function $4a8454b298d0a02b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4a8454b298d0a02b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4a8454b298d0a02b$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($519c95b753b7732e$exports)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4a8454b298d0a02b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $4a8454b298d0a02b$var$StyledIconBaseBase = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var children = props.children, iconAttrs = props.iconAttrs, iconVerticalAlign = props.iconVerticalAlign, iconViewBox = props.iconViewBox, size = props.size, title = props.title, otherProps = (0, (/*@__PURE__*/$parcel$interopDefault($90b8af3236d96777$exports)))(props, $4a8454b298d0a02b$var$_excluded);
    var iconProps = $4a8454b298d0a02b$var$_objectSpread($4a8454b298d0a02b$var$_objectSpread({
        viewBox: iconViewBox,
        height: props.height !== undefined ? props.height : size,
        width: props.width !== undefined ? props.width : size,
        'aria-hidden': title == null ? 'true' : undefined,
        focusable: 'false',
        role: title != null ? 'img' : undefined
    }, iconAttrs), otherProps);
    return /*#__PURE__*/ $gRqVZ.createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({}, iconProps, {
        ref: ref
    }), title && /*#__PURE__*/ $gRqVZ.createElement("title", {
        key: "icon-title"
    }, title), children);
});
var $4a8454b298d0a02b$export$7703187df0970acb = /*#__PURE__*/ (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)($4a8454b298d0a02b$var$StyledIconBaseBase).withConfig({
    displayName: "StyledIconBase",
    componentId: "sc-ea9ulj-0"
})([
    "display:inline-block;vertical-align:",
    ";overflow:hidden;"
], function(props) {
    return props.iconVerticalAlign;
});


var $008681c5a6c2a769$export$c22d792887f3cb87 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
    }));
});
$008681c5a6c2a769$export$c22d792887f3cb87.displayName = 'CaretDownFill';
var $008681c5a6c2a769$export$a36fa02a927616bb = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $a84fe49467631aef$export$cb86d8fdcb9f94b5 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
    }));
});
$a84fe49467631aef$export$cb86d8fdcb9f94b5.displayName = 'CaretUpFill';
var $a84fe49467631aef$export$ec424bda80ffdda5 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $fe1caaf8254f2ac5$export$970973453ca186b7 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"
    }));
});
$fe1caaf8254f2ac5$export$970973453ca186b7.displayName = 'CaretRightFill';
var $fe1caaf8254f2ac5$export$7554256da9082e90 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $780cee0797cae5da$export$c42ab4f9cd72fed3 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
    }));
});
$780cee0797cae5da$export$c42ab4f9cd72fed3.displayName = 'Eye';
var $780cee0797cae5da$export$197d5a81956ebb04 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $36fb27ce642053a4$export$540b644af6247088 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"
    }));
});
$36fb27ce642053a4$export$540b644af6247088.displayName = 'EyeSlash';
var $36fb27ce642053a4$export$85418fa2d8d40a84 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $59bc6484ee17bc69$export$a059d7a0f1f6fc48 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"
    }));
});
$59bc6484ee17bc69$export$a059d7a0f1f6fc48.displayName = 'Sun';
var $59bc6484ee17bc69$export$6eefb556168a2748 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $e4a24979e20ed9fc$export$a4f57375e50e81d5 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"
    }));
});
$e4a24979e20ed9fc$export$a4f57375e50e81d5.displayName = 'Facebook';
var $e4a24979e20ed9fc$export$7b54ec4b3cc10100 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $31d7a797966cc7d2$export$9e389cdad32a5b7a = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"
    }));
});
$31d7a797966cc7d2$export$9e389cdad32a5b7a.displayName = 'Twitter';
var $31d7a797966cc7d2$export$b07192d8009e43e7 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $61a2e5f5af330c28$export$ca041de6a87fe8b = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"
    }));
});
$61a2e5f5af330c28$export$ca041de6a87fe8b.displayName = 'Linkedin';
var $61a2e5f5af330c28$export$3edbd0b70a13e85b = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $0d072899aa4a889d$export$9967558ab3090fa1 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z"
    }));
});
$0d072899aa4a889d$export$9967558ab3090fa1.displayName = 'Youtube';
var $0d072899aa4a889d$export$7f304284fe56d8f3 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $3cf30fe56fd1629f$export$889aff59bd27773b = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"
    }));
});
$3cf30fe56fd1629f$export$889aff59bd27773b.displayName = 'Pencil';
var $3cf30fe56fd1629f$export$47520d044906de71 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $51c6ea681161bff5$export$99442c433de1441d = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        fillRule: "evenodd",
        d: "M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
    }));
});
$51c6ea681161bff5$export$99442c433de1441d.displayName = 'Trash';
var $51c6ea681161bff5$export$4573dae7fd1c195f = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $989849240f6109fe$export$4b85d3515bd863a5 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
    }));
});
$989849240f6109fe$export$4b85d3515bd863a5.displayName = 'Search';
var $989849240f6109fe$export$1b3ed80353bcfaa = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $a98c9f8299f9be25$export$2d9ac7aa84f97a08 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
    }));
});
$a98c9f8299f9be25$export$2d9ac7aa84f97a08.displayName = 'Plus';
var $a98c9f8299f9be25$export$979f6aa95122cdd = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $3f5de25d518e3bbc$export$1644ba17714857f1 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.565.565 0 0 0-.163-.505L1.71 6.745l4.052-.576a.525.525 0 0 0 .393-.288L8 2.223l1.847 3.658a.525.525 0 0 0 .393.288l4.052.575-2.906 2.77a.565.565 0 0 0-.163.506l.694 3.957-3.686-1.894a.503.503 0 0 0-.461 0z"
    }));
});
$3f5de25d518e3bbc$export$1644ba17714857f1.displayName = 'Star';
var $3f5de25d518e3bbc$export$c209462ec1432f22 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $15457c261efdedf5$export$7d9cb4bd8638e63e = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"
    }));
});
$15457c261efdedf5$export$7d9cb4bd8638e63e.displayName = 'StarFill';
var $15457c261efdedf5$export$d465b407f98e92a3 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $fa16d3b9d6307f73$export$a04a553a39b0cbf0 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("circle", {
        cx: 8,
        cy: 8,
        r: 8
    }));
});
$fa16d3b9d6307f73$export$a04a553a39b0cbf0.displayName = 'CircleFill';
var $fa16d3b9d6307f73$export$2b6d19c8857ddd74 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $bcfb7547ad2702cf$export$83b4e98970744671 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"
    }));
});
$bcfb7547ad2702cf$export$83b4e98970744671.displayName = 'Paperclip';
var $bcfb7547ad2702cf$export$12d81213c164b976 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $dae942ddd688b2e9$export$79c66221ddbb3eb1 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-.214c-2.162-1.241-4.49-1.843-6.912-2.083l.405 2.712A1 1 0 0 1 5.51 15.1h-.548a1 1 0 0 1-.916-.599l-1.85-3.49a68.14 68.14 0 0 0-.202-.003A2.014 2.014 0 0 1 0 9V7a2.02 2.02 0 0 1 1.992-2.013 74.663 74.663 0 0 0 2.483-.075c3.043-.154 6.148-.849 8.525-2.199V2.5zm1 0v11a.5.5 0 0 0 1 0v-11a.5.5 0 0 0-1 0zm-1 1.35c-2.344 1.205-5.209 1.842-8 2.033v4.233c.18.01.359.022.537.036 2.568.189 5.093.744 7.463 1.993V3.85zm-9 6.215v-4.13a95.09 95.09 0 0 1-1.992.052A1.02 1.02 0 0 0 1 7v2c0 .55.448 1.002 1.006 1.009A60.49 60.49 0 0 1 4 10.065zm-.657.975 1.609 3.037.01.024h.548l-.002-.014-.443-2.966a68.019 68.019 0 0 0-1.722-.082z"
    }));
});
$dae942ddd688b2e9$export$79c66221ddbb3eb1.displayName = 'Megaphone';
var $dae942ddd688b2e9$export$c1eeff2d23083176 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $03d9d30d229feb56$export$d49dffca20dba6f7 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894zm-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z"
    }));
});
$03d9d30d229feb56$export$d49dffca20dba6f7.displayName = 'Chat';
var $03d9d30d229feb56$export$8828519f0bb4ac52 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $d90a2948bc45fb70$export$a7f7c251c7c85cf5 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1v-1c0-1-1-4-6-4s-6 3-6 4v1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12z"
    }));
});
$d90a2948bc45fb70$export$a7f7c251c7c85cf5.displayName = 'PersonSquare';
var $d90a2948bc45fb70$export$c69649327b4c7073 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $f0e7a4a36037df80$export$78acf4525d8a74c4 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
    }));
});
$f0e7a4a36037df80$export$78acf4525d8a74c4.displayName = 'X';
var $f0e7a4a36037df80$export$26578827ed31671b = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $8113a63c16d8b82c$export$de284f94be6e29d2 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        fillRule: "evenodd",
        d: "M3.1 11.2a.5.5 0 0 1 .4-.2H6a.5.5 0 0 1 0 1H3.75L1.5 15h13l-2.25-3H10a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .4.2l3 4a.5.5 0 0 1-.4.8H.5a.5.5 0 0 1-.4-.8l3-4z"
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        fillRule: "evenodd",
        d: "M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999z"
    }));
});
$8113a63c16d8b82c$export$de284f94be6e29d2.displayName = 'PinMap';
var $8113a63c16d8b82c$export$5cabda3be35c04f6 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $b309836aa0724383$export$2de540f0cd7c073a = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z"
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
    }));
});
$b309836aa0724383$export$2de540f0cd7c073a.displayName = 'Phone';
var $b309836aa0724383$export$9135964346af2f03 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $24f70e6c5423ac94$export$594cd506591dcf26 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        fillRule: "evenodd",
        d: "M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
    }));
});
$24f70e6c5423ac94$export$594cd506591dcf26.displayName = 'TelephoneFill';
var $24f70e6c5423ac94$export$3150efb5dabe59c4 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $6d9aaf801032e965$export$4e2d65a9843399df = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.758 2.855L15 11.114v-5.73zm-.034 6.878L9.271 8.82 8 9.583 6.728 8.82l-5.694 3.44A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.739zM1 11.114l4.758-2.876L1 5.383v5.73z"
    }));
});
$6d9aaf801032e965$export$4e2d65a9843399df.displayName = 'Envelope';
var $6d9aaf801032e965$export$4006e486defeed30 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $7eab598995bb8795$export$cabca7ad06b7e207 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M5.485 6.879a.5.5 0 1 0-.97.242l1.5 6a.5.5 0 0 0 .967.01L8 9.402l1.018 3.73a.5.5 0 0 0 .967-.01l1.5-6a.5.5 0 0 0-.97-.242l-1.036 4.144-.997-3.655a.5.5 0 0 0-.964 0l-.997 3.655L5.485 6.88z"
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"
    }));
});
$7eab598995bb8795$export$cabca7ad06b7e207.displayName = 'FileEarmarkWord';
var $7eab598995bb8795$export$47c02b58a3c37627 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $f56fb9e0fe685cc1$export$1e9bbbacaf20997a = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M4.603 14.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.697 19.697 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.712 5.712 0 0 1-.911-.95 11.651 11.651 0 0 0-1.997.406 11.307 11.307 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.266.266 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.71 12.71 0 0 1 1.01-.193 11.744 11.744 0 0 1-.51-.858 20.801 20.801 0 0 1-.5 1.05zm2.446.45c.15.163.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.876 3.876 0 0 0-.612-.053zM8.078 7.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z"
    }));
});
$f56fb9e0fe685cc1$export$1e9bbbacaf20997a.displayName = 'FileEarmarkPdf';
var $f56fb9e0fe685cc1$export$b3c42b246ef5d500 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $d80380136de5b27f$export$3a083cd204da2316 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708l3 3z"
    }));
});
$d80380136de5b27f$export$3a083cd204da2316.displayName = 'CloudDownload';
var $d80380136de5b27f$export$9dad6508a37556c7 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $ed1df0e8c76ac51f$export$ad40adb82edd461d = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
    }));
});
$ed1df0e8c76ac51f$export$ad40adb82edd461d.displayName = 'CalendarEvent';
var $ed1df0e8c76ac51f$export$cc50d9d3a33dac79 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $f0ed8187b60954b1$export$9735c82c4bae3302 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 512 512"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        fill: "currentColor",
        d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"
    }));
});
$f0ed8187b60954b1$export$9735c82c4bae3302.displayName = 'Clock';
var $f0ed8187b60954b1$export$f8db61b1cab779cb = {
    height: 512,
    width: 512
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $bb9ca67df03de270$export$492e206091e683eb = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 448 512"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        fill: "currentColor",
        d: "M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    }));
});
$bb9ca67df03de270$export$492e206091e683eb.displayName = 'CalendarAlt';
var $bb9ca67df03de270$export$b822c2c7f8c11f21 = {
    height: 512,
    width: 448
};




var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $5249bfd995c58c8e$export$b6afa8811b7e644e = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 384 512"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        fill: "currentColor",
        d: "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z"
    }));
});
$5249bfd995c58c8e$export$b6afa8811b7e644e.displayName = 'File';
var $5249bfd995c58c8e$export$db4b87ad15a01ef5 = {
    height: 512,
    width: 384
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $62dd6abc00e8c54d$export$db69e95d0ffe9280 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 384 512"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        fill: "currentColor",
        d: "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm72-60V236c0-6.6 5.4-12 12-12h69.2c36.7 0 62.8 27 62.8 66.3 0 74.3-68.7 66.5-95.5 66.5V404c0 6.6-5.4 12-12 12H132c-6.6 0-12-5.4-12-12zm48.5-87.4h23c7.9 0 13.9-2.4 18.1-7.2 8.5-9.8 8.4-28.5.1-37.8-4.1-4.6-9.9-7-17.4-7h-23.9v52z"
    }));
});
$62dd6abc00e8c54d$export$db69e95d0ffe9280.displayName = 'FilePowerpoint';
var $62dd6abc00e8c54d$export$3cfbe8282df02471 = {
    height: 512,
    width: 384
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $6a14c6a918655516$export$3e431a229df88919 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        d: "M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z"
    }));
});
$6a14c6a918655516$export$3e431a229df88919.displayName = 'Image';
var $6a14c6a918655516$export$c4bbb2a3b42f8c85 = {
    height: 16,
    width: 16
};



var $ag2w3 = parcelRequire("ag2w3");

var $gRqVZ = parcelRequire("gRqVZ");

var $3da7744c6e165eb5$export$287f8fcc69caf433 = /*#__PURE__*/ $gRqVZ.forwardRef(function(props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
    };
    return /*#__PURE__*/ $gRqVZ.createElement((0, $4a8454b298d0a02b$export$7703187df0970acb), (0, (/*@__PURE__*/$parcel$interopDefault($ag2w3)))({
        iconAttrs: attrs,
        iconVerticalAlign: "middle",
        iconViewBox: "0 0 16 16"
    }, props, {
        ref: ref
    }), /*#__PURE__*/ $gRqVZ.createElement("path", {
        fillRule: "evenodd",
        d: "M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5zm11.5 5.175 3.5 1.556V4.269l-3.5 1.556v4.35zM2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2z"
    }));
});
$3da7744c6e165eb5$export$287f8fcc69caf433.displayName = 'CameraVideo';
var $3da7744c6e165eb5$export$e83719034fc9dd1b = {
    height: 16,
    width: 16
};





var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");
function $bc8f851965189ea9$var$NavLogo(props) {
    return /*#__PURE__*/ (0, $01ysi.jsxs)("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 70 37",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $01ysi.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                        id: "logo_svg__a",
                        d: "M11.98.291H.076v35.962H11.98V.291z"
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                        id: "logo_svg__c",
                        d: "M12.134.291H.229v35.962h11.905V.291z"
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                        id: "logo_svg__e",
                        d: "M0 36.253h69.865V.291H0z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $01ysi.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                        d: "M29.851 5.726h4.802v-5.1h-4.802v5.1zm0 30.511h4.802V7.627h-4.802v28.61z",
                        fill: "#bd5f28"
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsxs)("g", {
                        transform: "translate(0 .334)",
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsxs)("g", {
                                transform: "translate(36.878)",
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)("mask", {
                                        id: "logo_svg__b",
                                        fill: "#fff",
                                        children: /*#__PURE__*/ (0, $01ysi.jsx)("use", {
                                            xlinkHref: "#logo_svg__a"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                                        d: "M7.179 12.795c0-1.5-.55-1.752-1.151-1.752-.6 0-1.15.252-1.15 1.752v17.606c0 1.5.55 1.75 1.15 1.75.6 0 1.15-.25 1.15-1.75V12.795zM.076.291h4.802v8.803h.1c.7-1.1 1.9-2.151 3.45-2.151 1.852 0 3.552 1 3.552 3.351v22.609c0 2.349-1.7 3.35-3.551 3.35-1.45 0-2.7-1.001-3.451-2.051h-.1v1.701H.076V.291z",
                                        fill: "#bd5f28",
                                        mask: "url(#logo_svg__b)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsxs)("g", {
                                transform: "translate(50.63)",
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)("mask", {
                                        id: "logo_svg__d",
                                        fill: "#fff",
                                        children: /*#__PURE__*/ (0, $01ysi.jsx)("use", {
                                            xlinkHref: "#logo_svg__c"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                                        d: "M7.332 12.795c0-1.5-.55-1.752-1.15-1.752-.6 0-1.15.252-1.15 1.752v17.606c0 1.5.55 1.75 1.15 1.75.6 0 1.15-.25 1.15-1.75V12.795zM.229.291h4.803v8.803h.099c.7-1.1 1.9-2.151 3.451-2.151 1.85 0 3.552 1 3.552 3.351v22.609c0 2.349-1.701 3.35-3.552 3.35-1.45 0-2.7-1.001-3.451-2.051h-.1v1.701H.23V.291z",
                                        fill: "#bd5f28",
                                        mask: "url(#logo_svg__d)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)("mask", {
                                id: "logo_svg__f",
                                fill: "#fff",
                                children: /*#__PURE__*/ (0, $01ysi.jsx)("use", {
                                    xlinkHref: "#logo_svg__e"
                                })
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsxs)("g", {
                                mask: "url(#logo_svg__f)",
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                                        d: "M65.063 35.903h4.802V7.293h-4.802v28.61zm0-30.51h4.802V.29h-4.802v5.101zM15.822 7.207h4.802v1.65h.1c.7-1.35 2-2 3.301-2 3.652 0 3.701 2.15 3.701 5.151v23.81h-4.802v-23.11c0-.8-.05-1.751-1.05-1.751-1.2 0-1.25.95-1.25 1.751v23.11h-4.802V7.206z",
                                        fill: "#bd5f28"
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                                        d: "M6.965 29.183h-.246c-2.99 0-4.392.966-4.392 2.233 0 1.269 1.382 2.215 4.373 2.215h.245c2.99 0 4.391-.965 4.391-2.233 0-1.268-1.381-2.215-4.371-2.215m.095 7.04h-.436C2.442 36.223 0 34.256 0 31.398s2.442-4.807 6.605-4.807h.435c4.164 0 6.625 1.967 6.625 4.825s-2.442 4.807-6.605 4.807M.208 24.9v-2.346l7.23-3.766H.208v-2.48h13.249v2.195l-7.533 3.918h7.533v2.48zM.208 14.258v-6.89h2.347v4.373h3.066V7.88h2.347v3.861h3.142V7.293h2.347v6.965z",
                                        fill: props.type === 'light' ? '#fff' : '#888'
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $bc8f851965189ea9$export$2e2bcd8739ae039 = $bc8f851965189ea9$var$NavLogo;



var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");
var $b3793090e8255ee9$exports = {};
$b3793090e8255ee9$exports = $parcel$resolve("89Nig");


function $d2ab028d8623e892$var$UserProfilePhoto(props) {
    const [imgSrc, setImgSrc] = (0, $gRqVZ.useState)(props.src || (0, (/*@__PURE__*/$parcel$interopDefault($b3793090e8255ee9$exports))));
    return /*#__PURE__*/ (0, $01ysi.jsx)("img", {
        className: props.className,
        src: imgSrc,
        onError: ()=>setImgSrc((0, (/*@__PURE__*/$parcel$interopDefault($b3793090e8255ee9$exports))))
    });
}
var $d2ab028d8623e892$export$2e2bcd8739ae039 = $d2ab028d8623e892$var$UserProfilePhoto;


const $4eb583db17ee8a52$var$ExternalLink = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).a`
	transition: all 0.1s ease-in-out;
	text-decoration: none;
`;
const $4eb583db17ee8a52$var$InternalLink = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $e3f57e4b1ea630bd$export$a6c7ac8248d6e38a))`
	transition: all 0.1s ease-in-out;
	text-decoration: none;
`;
const $4eb583db17ee8a52$export$3dfe143f127ef20a = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	position: relative;
	min-height: 100vh;
`;
const $4eb583db17ee8a52$export$eb4ff40e34002c26 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	padding-bottom: 200px;
`;
const $4eb583db17ee8a52$export$42a852a2b6b56249 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	min-width: var(--container-min-width);
	max-width: var(--container-max-width);
	padding-left: var(--grid-basis);
	padding-right: var(--grid-basis);
	position: relative;
	margin: 0 auto;
`;
const $4eb583db17ee8a52$var$FlexSpaceBetween = (0, $8999e1d77b7e12d9$export$dbf350e5966cf602)`
	display: flex;
	justify-content: space-between;
`;
const $4eb583db17ee8a52$export$9a69ef0daa31fb4c = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	background: #f7f7f7;
	position: relative;
	height: 40px;
	border-bottom: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	line-height: 40px;
`;
const $4eb583db17ee8a52$export$4418626cb10d22e4 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).nav`
	height: 70px;
	border-bottom: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
`;
const $4eb583db17ee8a52$export$1e86fd0e1db89578 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)($4eb583db17ee8a52$export$42a852a2b6b56249)`
	${$4eb583db17ee8a52$var$FlexSpaceBetween}
	&.searchOpen {
		justify-content: start;
	}
	#logoLink {
		padding-left: 0px;
	}
`;
const $4eb583db17ee8a52$export$3ecba61df9708051 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	&:first-child {
		padding-left: 0px;
	}
`;
const $4eb583db17ee8a52$var$UtilityItemStyle = (0, $8999e1d77b7e12d9$export$dbf350e5966cf602)`
	padding-right: 20px;
	color: ${({ theme: theme })=>theme.colors.primaryTextColor};
	font-size: 12px;
	min-width: 90px;
	display: inline-block;
	&:hover {
		cursor: pointer;
	}
	&:last-child {
		padding-right: 0;
	}
`;
const $4eb583db17ee8a52$export$7ff085589970ee0a = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div``;
const $4eb583db17ee8a52$export$eb3d7c47ba9e5e55 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).span`
	${$4eb583db17ee8a52$var$UtilityItemStyle}
	&:hover {
		color: ${({ theme: theme })=>theme.colors.primary};
	}
`;
const $4eb583db17ee8a52$export$b7996bde93603ad = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)($4eb583db17ee8a52$var$InternalLink)`
	${$4eb583db17ee8a52$var$UtilityItemStyle}
`;
const $4eb583db17ee8a52$export$d6def513e747da1d = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)($4eb583db17ee8a52$var$ExternalLink)`
	${$4eb583db17ee8a52$var$UtilityItemStyle}
`;
const $4eb583db17ee8a52$export$acf59b376e961d86 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: none;
	opacity: 0;
	visibility: hidden;
`;
const $4eb583db17ee8a52$export$7cd623d16aecfb6 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: inline-block;
	${$4eb583db17ee8a52$var$UtilityItemStyle}
	&:hover ${$4eb583db17ee8a52$export$acf59b376e961d86} {
		display: block;
		opacity: 100;
		visibility: visible;
		position: absolute;
		top: 39px;
		padding: 20px;
		min-width: 150px;
		background: #fff;
		border: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
		z-index: 3;
		font-size: 14px;
		color: #868686;
	}
`;
const $4eb583db17ee8a52$export$953d8866debef0fc = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	font-weight: lighter;
	align-items: end;
	font-size: 40px;
	color: ${({ theme: theme })=>theme.colors.primaryTextColor};
`;
const $4eb583db17ee8a52$export$e6ff31bff12b7ff4 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $bc8f851965189ea9$export$2e2bcd8739ae039))`
	width: 70px;
	height: 70px;
	padding-right: 15px;
`;
const $4eb583db17ee8a52$export$62e09d66fce7f525 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).svg`
	height: 10px;
	width: 10px;
	color: #868686;
	padding-right: 5px;
	${$4eb583db17ee8a52$export$b7996bde93603ad}:hover & {
		color: ${({ theme: theme })=>theme.colors.primaryTextColor};
	}
	${$4eb583db17ee8a52$export$eb3d7c47ba9e5e55}:hover & {
		color: ${({ theme: theme })=>theme.colors.primaryTextColor};
	}
	${$4eb583db17ee8a52$export$d6def513e747da1d}:hover & {
		color: ${({ theme: theme })=>theme.colors.primaryTextColor};
	}
	${$4eb583db17ee8a52$export$7cd623d16aecfb6}:hover & {
		color: ${({ theme: theme })=>theme.colors.primaryTextColor};
	}
`;
const $4eb583db17ee8a52$export$6c0524ba53950d9f = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $d2ab028d8623e892$export$2e2bcd8739ae039))`
	display: inline-block;
	width: 20px;
	height: 20px;
	border-radius: 50%;
	object-fit: cover;
	vertical-align: middle;
	margin-right: 5px;
	border: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
`;
const $4eb583db17ee8a52$export$fe287eda140b3e9 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $008681c5a6c2a769$export$c22d792887f3cb87))`
	padding-left: 5px;
	padding-right: 0px;
	color: ${({ theme: theme })=>theme.colors.primaryTextColor};
`;
const $4eb583db17ee8a52$export$e60e4d92d53645d5 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $fe1caaf8254f2ac5$export$970973453ca186b7))`
	padding-left: 5px;
	padding-right: 0px;
	color: ${({ theme: theme })=>theme.colors.primaryTextColor};
`;
const $4eb583db17ee8a52$export$b615cd9717379c80 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	height: 70px;
	display: flex;
`;
const $4eb583db17ee8a52$export$e923b1fc1eae5c8a = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: none;
	opacity: 0;
	visibility: hidden;
	transition: visibility 0ms 350ms, opacity 350ms 0ms, top 350ms 0ms;
	border-radius: 3px;
	position: absolute;
	top: 55px;
	z-index: 6;
	background: #fff;
	border: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	box-shadow: 0 3px 2px rgba(1, 1, 1, 0.05);
	&:hover {
		display: block;
	}
`;
const $4eb583db17ee8a52$export$2d4ae60db1a382b6 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	width: max-content;
	a {
		padding: 15px;
		line-height: 10px;
	}
`;
const $4eb583db17ee8a52$export$5c76348ab647113a = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	background: #f7f7f7;
	display: none;
	opacity: 0;
	visibility: hidden;
	left: 300px;
	top: -1px;
	position: absolute;
	border: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	box-shadow: 0 3px 2px rgba(1, 1, 1, 0.05);
	border-top-right-radius: 3px;
	border-bottom-right-radius: 3px;
	min-width: 300px;
	width: max-content;
	line-height: 20px;
	min-height: 450px;
	z-index: 6;
	&:hover {
		display: block;
	}
	a {
		padding: 15px;
		line-height: 10px;
	}
`;
const $4eb583db17ee8a52$export$4d04858d81ea214c = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	min-height: 450px;
	width: 300px;
	&:hover ${$4eb583db17ee8a52$export$5c76348ab647113a} {
		display: block;
	}
`;
const $4eb583db17ee8a52$export$379c382dcbebc3aa = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	position: relative;
	&:hover ${$4eb583db17ee8a52$export$e923b1fc1eae5c8a} {
		display: block;
		visibility: visible;
		opacity: 100%;
		z-index: 6;
	}
	&:hover > div > ${$4eb583db17ee8a52$export$62e09d66fce7f525} {
		color: ${({ theme: theme })=>theme.colors.primary};
	}
`;
const $4eb583db17ee8a52$export$148fa54b77fc60e0 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	line-height: 40px;
	&:hover ${$4eb583db17ee8a52$export$5c76348ab647113a} {
		display: block;
		visibility: visible;
		opacity: 100%;
	}
`;
const $4eb583db17ee8a52$export$fd9000017733fabf = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	margin-top: 50px;
	padding: 30px 0;
	background: ${({ theme: theme })=>theme.colors.primaryTextColor};
	color: #868686;
	font-size: 12px;
	position: absolute;
	bottom: 0;
	width: 100%;
`;
const $4eb583db17ee8a52$export$ed03bcfca6361a0 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	padding-bottom: 20px;
	border-bottom: 1px solid #383838;
	${$4eb583db17ee8a52$var$FlexSpaceBetween}
`;
const $4eb583db17ee8a52$export$dee96cd6e4143da2 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	padding-top: 20px;
	padding-bottom: 20px;
	${$4eb583db17ee8a52$var$FlexSpaceBetween}
`;
const $4eb583db17ee8a52$export$2871ab481185660c = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)($4eb583db17ee8a52$var$InternalLink)`
	padding-right: 20px;
	&:hover {
		color: white;
	}
`;
const $4eb583db17ee8a52$export$e0513c91be1318ca = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)($4eb583db17ee8a52$var$ExternalLink)`
	padding-right: 20px;
	&:last-child {
		padding-right: 0px;
	}
	&:hover {
		color: white;
	}
`;
const $4eb583db17ee8a52$export$c8a2b06b49cc2e12 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)($4eb583db17ee8a52$var$ExternalLink)`
	padding-right: 5px;
	&:last-child {
		padding-right: 0px;
	}
	&:hover {
		color: white;
	}
`;
const $4eb583db17ee8a52$export$45bc2e96ae668f64 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).svg`
	transition: all 0.1s ease-in-out;
	height: 15px;
	color: #868686;
	padding-left: 5px;
	&:hover {
		color: white;
	}
`;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");

var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");
var $56afa7a268399ccc$exports = {};

$56afa7a268399ccc$exports = (parcelRequire("34DZz"));


var $a93ed4f7345ef0c7$exports = {};
"use strict";
Object.defineProperty($a93ed4f7345ef0c7$exports, "__esModule", {
    value: true
});

var $k8Bfo = parcelRequire("k8Bfo");

var $gRqVZ = parcelRequire("gRqVZ");

var $a93ed4f7345ef0c7$var$useAsyncFn_1 = $k8Bfo.__importDefault((parcelRequire("8wUEv")));
function $a93ed4f7345ef0c7$var$useAsync(fn, deps) {
    if (deps === void 0) deps = [];
    var _a = $a93ed4f7345ef0c7$var$useAsyncFn_1.default(fn, deps, {
        loading: true
    }), state = _a[0], callback = _a[1];
    $gRqVZ.useEffect(function() {
        callback();
    }, [
        callback
    ]);
    return state;
}
$a93ed4f7345ef0c7$exports.default = $a93ed4f7345ef0c7$var$useAsync;


const { get: $b7f2bb4232df9024$var$getWeatherBitAxios } = (0, (/*@__PURE__*/$parcel$interopDefault($56afa7a268399ccc$exports))).create({
    baseURL: 'https://api.weatherbit.io/v2.0/current',
    params: {
        key: '17302b753289429c897b46c197893c04',
        city: 'SanFrancisco,CA',
        units: 'I'
    }
});
const $b7f2bb4232df9024$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createContext(null);
function $b7f2bb4232df9024$export$af5f2e06b272a59f({ children: children }) {
    const state = (0, (/*@__PURE__*/$parcel$interopDefault($a93ed4f7345ef0c7$exports)))(async ()=>{
        const response = await $b7f2bb4232df9024$var$getWeatherBitAxios('/');
        const data = response.data.data[0];
        return {
            temp: `${data.temp} \xb0F`,
            description: data.weather.description,
            iconUrl: `https://www.weatherbit.io/static/img/icons/${data.weather.icon}.png`
        };
    });
    return /*#__PURE__*/ (0, $01ysi.jsx)($b7f2bb4232df9024$var$Context.Provider, {
        value: state,
        children: children
    });
}
function $b7f2bb4232df9024$export$70f96ff13bb51da8() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).useContext($b7f2bb4232df9024$var$Context);
}



function $2b5f38c9a88f5c8b$var$WeatherDropdownContent() {
    const weatherState = (0, $b7f2bb4232df9024$export$70f96ff13bb51da8)();
    if (weatherState.value) return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4eb583db17ee8a52$export$acf59b376e961d86), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4eb583db17ee8a52$export$953d8866debef0fc), {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)("img", {
                        src: weatherState.value.iconUrl
                    }),
                    weatherState.value.temp
                ]
            }),
            weatherState.value.description
        ]
    });
    return null;
}
var $2b5f38c9a88f5c8b$export$2e2bcd8739ae039 = $2b5f38c9a88f5c8b$var$WeatherDropdownContent;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");





var $489wz = parcelRequire("489wz");

var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");

var $gRqVZ = parcelRequire("gRqVZ");
var $a3bf69d734984e1c$var$_ = Object.defineProperty;
var $a3bf69d734984e1c$var$$ = (a, h, e)=>h in a ? $a3bf69d734984e1c$var$_(a, h, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : a[h] = e;
var $a3bf69d734984e1c$var$m = (a, h, e)=>$a3bf69d734984e1c$var$$(a, typeof h != "symbol" ? h + "" : h, e);
const $a3bf69d734984e1c$export$fd37ff38bd5cb31b = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    unit: "px"
}, $a3bf69d734984e1c$export$7d15b64cf5a3a4c4 = (a, h, e)=>Math.min(Math.max(a, h), e), $a3bf69d734984e1c$export$b02c518fbab8b887 = (...a)=>a.filter((h)=>h && typeof h == "string").join(" "), $a3bf69d734984e1c$export$1ef1fdd9ce87601b = (a, h)=>a === h || a.width === h.width && a.height === h.height && a.x === h.x && a.y === h.y && a.unit === h.unit;
function $a3bf69d734984e1c$export$996fb65e57171b85(a, h, e, n) {
    const t = $a3bf69d734984e1c$export$c405b7b148743d81(a, e, n);
    return a.width && (t.height = t.width / h), a.height && (t.width = t.height * h), t.y + t.height > n && (t.height = n - t.y, t.width = t.height * h), t.x + t.width > e && (t.width = e - t.x, t.height = t.width / h), a.unit === "%" ? $a3bf69d734984e1c$export$12d870c2af07ad5a(t, e, n) : t;
}
function $a3bf69d734984e1c$export$22e2caf9ef2c32c0(a, h, e) {
    const n = $a3bf69d734984e1c$export$c405b7b148743d81(a, h, e);
    return n.x = (h - n.width) / 2, n.y = (e - n.height) / 2, a.unit === "%" ? $a3bf69d734984e1c$export$12d870c2af07ad5a(n, h, e) : n;
}
function $a3bf69d734984e1c$export$12d870c2af07ad5a(a, h, e) {
    return a.unit === "%" ? {
        ...$a3bf69d734984e1c$export$fd37ff38bd5cb31b,
        ...a,
        unit: "%"
    } : {
        unit: "%",
        x: a.x ? a.x / h * 100 : 0,
        y: a.y ? a.y / e * 100 : 0,
        width: a.width ? a.width / h * 100 : 0,
        height: a.height ? a.height / e * 100 : 0
    };
}
function $a3bf69d734984e1c$export$c405b7b148743d81(a, h, e) {
    return a.unit ? a.unit === "px" ? {
        ...$a3bf69d734984e1c$export$fd37ff38bd5cb31b,
        ...a,
        unit: "px"
    } : {
        unit: "px",
        x: a.x ? a.x * h / 100 : 0,
        y: a.y ? a.y * e / 100 : 0,
        width: a.width ? a.width * h / 100 : 0,
        height: a.height ? a.height * e / 100 : 0
    } : {
        ...$a3bf69d734984e1c$export$fd37ff38bd5cb31b,
        ...a,
        unit: "px"
    };
}
function $a3bf69d734984e1c$export$3cda6d75d50eabc(a, h, e, n, t, d = 0, r = 0, o = n, w = t) {
    const i = {
        ...a
    };
    let s = Math.min(d, n), c = Math.min(r, t), g = Math.min(o, n), p = Math.min(w, t);
    h && (h > 1 ? (s = r ? r * h : s, c = s / h, g = o * h) : (c = d ? d / h : c, s = c * h, p = w / h)), i.y < 0 && (i.height = Math.max(i.height + i.y, c), i.y = 0), i.x < 0 && (i.width = Math.max(i.width + i.x, s), i.x = 0);
    const l = n - (i.x + i.width);
    l < 0 && (i.x = Math.min(i.x, n - s), i.width += l);
    const C = t - (i.y + i.height);
    if (C < 0 && (i.y = Math.min(i.y, t - c), i.height += C), i.width < s && ((e === "sw" || e == "nw") && (i.x -= s - i.width), i.width = s), i.height < c && ((e === "nw" || e == "ne") && (i.y -= c - i.height), i.height = c), i.width > g && ((e === "sw" || e == "nw") && (i.x -= g - i.width), i.width = g), i.height > p && ((e === "nw" || e == "ne") && (i.y -= p - i.height), i.height = p), h) {
        const y = i.width / i.height;
        if (y < h) {
            const f = Math.max(i.width / h, c);
            (e === "nw" || e == "ne") && (i.y -= f - i.height), i.height = f;
        } else if (y > h) {
            const f = Math.max(i.height * h, s);
            (e === "sw" || e == "nw") && (i.x -= f - i.width), i.width = f;
        }
    }
    return i;
}
function $a3bf69d734984e1c$export$eba630d9d6fdee89(a, h, e, n) {
    const t = {
        ...a
    };
    return h === "ArrowLeft" ? n === "nw" ? (t.x -= e, t.y -= e, t.width += e, t.height += e) : n === "w" ? (t.x -= e, t.width += e) : n === "sw" ? (t.x -= e, t.width += e, t.height += e) : n === "ne" ? (t.y += e, t.width -= e, t.height -= e) : n === "e" ? t.width -= e : n === "se" && (t.width -= e, t.height -= e) : h === "ArrowRight" && (n === "nw" ? (t.x += e, t.y += e, t.width -= e, t.height -= e) : n === "w" ? (t.x += e, t.width -= e) : n === "sw" ? (t.x += e, t.width -= e, t.height -= e) : n === "ne" ? (t.y -= e, t.width += e, t.height += e) : n === "e" ? t.width += e : n === "se" && (t.width += e, t.height += e)), h === "ArrowUp" ? n === "nw" ? (t.x -= e, t.y -= e, t.width += e, t.height += e) : n === "n" ? (t.y -= e, t.height += e) : n === "ne" ? (t.y -= e, t.width += e, t.height += e) : n === "sw" ? (t.x += e, t.width -= e, t.height -= e) : n === "s" ? t.height -= e : n === "se" && (t.width -= e, t.height -= e) : h === "ArrowDown" && (n === "nw" ? (t.x += e, t.y += e, t.width -= e, t.height -= e) : n === "n" ? (t.y += e, t.height -= e) : n === "ne" ? (t.y += e, t.width -= e, t.height -= e) : n === "sw" ? (t.x -= e, t.width += e, t.height += e) : n === "s" ? t.height += e : n === "se" && (t.width += e, t.height += e)), t;
}
const $a3bf69d734984e1c$var$M = {
    capture: !0,
    passive: !1
};
let $a3bf69d734984e1c$var$N = 0;
const $a3bf69d734984e1c$var$x = class x extends (0, $gRqVZ.PureComponent) {
    constructor(){
        super(...arguments);
        $a3bf69d734984e1c$var$m(this, "docMoveBound", !1);
        $a3bf69d734984e1c$var$m(this, "mouseDownOnCrop", !1);
        $a3bf69d734984e1c$var$m(this, "dragStarted", !1);
        $a3bf69d734984e1c$var$m(this, "evData", {
            startClientX: 0,
            startClientY: 0,
            startCropX: 0,
            startCropY: 0,
            clientX: 0,
            clientY: 0,
            isResize: !0
        });
        $a3bf69d734984e1c$var$m(this, "componentRef", (0, $gRqVZ.createRef)());
        $a3bf69d734984e1c$var$m(this, "mediaRef", (0, $gRqVZ.createRef)());
        $a3bf69d734984e1c$var$m(this, "resizeObserver");
        $a3bf69d734984e1c$var$m(this, "initChangeCalled", !1);
        $a3bf69d734984e1c$var$m(this, "instanceId", `rc-${$a3bf69d734984e1c$var$N++}`);
        $a3bf69d734984e1c$var$m(this, "state", {
            cropIsActive: !1,
            newCropIsBeingDrawn: !1
        });
        $a3bf69d734984e1c$var$m(this, "onCropPointerDown", (e)=>{
            const { crop: n, disabled: t } = this.props, d = this.getBox();
            if (!n) return;
            const r = $a3bf69d734984e1c$export$c405b7b148743d81(n, d.width, d.height);
            if (t) return;
            e.cancelable && e.preventDefault(), this.bindDocMove(), this.componentRef.current.focus({
                preventScroll: !0
            });
            const o = e.target.dataset.ord, w = !!o;
            let i = e.clientX, s = e.clientY, c = r.x, g = r.y;
            if (o) {
                const p = e.clientX - d.x, l = e.clientY - d.y;
                let C = 0, y = 0;
                o === "ne" || o == "e" ? (C = p - (r.x + r.width), y = l - r.y, c = r.x, g = r.y + r.height) : o === "se" || o === "s" ? (C = p - (r.x + r.width), y = l - (r.y + r.height), c = r.x, g = r.y) : o === "sw" || o == "w" ? (C = p - r.x, y = l - (r.y + r.height), c = r.x + r.width, g = r.y) : (o === "nw" || o == "n") && (C = p - r.x, y = l - r.y, c = r.x + r.width, g = r.y + r.height), i = c + d.x + C, s = g + d.y + y;
            }
            this.evData = {
                startClientX: i,
                startClientY: s,
                startCropX: c,
                startCropY: g,
                clientX: e.clientX,
                clientY: e.clientY,
                isResize: w,
                ord: o
            }, this.mouseDownOnCrop = !0, this.setState({
                cropIsActive: !0
            });
        });
        $a3bf69d734984e1c$var$m(this, "onComponentPointerDown", (e)=>{
            const { crop: n, disabled: t, locked: d, keepSelection: r, onChange: o } = this.props, w = this.getBox();
            if (t || d || r && n) return;
            e.cancelable && e.preventDefault(), this.bindDocMove(), this.componentRef.current.focus({
                preventScroll: !0
            });
            const i = e.clientX - w.x, s = e.clientY - w.y, c = {
                unit: "px",
                x: i,
                y: s,
                width: 0,
                height: 0
            };
            this.evData = {
                startClientX: e.clientX,
                startClientY: e.clientY,
                startCropX: i,
                startCropY: s,
                clientX: e.clientX,
                clientY: e.clientY,
                isResize: !0
            }, this.mouseDownOnCrop = !0, o($a3bf69d734984e1c$export$c405b7b148743d81(c, w.width, w.height), $a3bf69d734984e1c$export$12d870c2af07ad5a(c, w.width, w.height)), this.setState({
                cropIsActive: !0,
                newCropIsBeingDrawn: !0
            });
        });
        $a3bf69d734984e1c$var$m(this, "onDocPointerMove", (e)=>{
            const { crop: n, disabled: t, onChange: d, onDragStart: r } = this.props, o = this.getBox();
            if (t || !n || !this.mouseDownOnCrop) return;
            e.cancelable && e.preventDefault(), this.dragStarted || (this.dragStarted = !0, r && r(e));
            const { evData: w } = this;
            w.clientX = e.clientX, w.clientY = e.clientY;
            let i;
            w.isResize ? i = this.resizeCrop() : i = this.dragCrop(), $a3bf69d734984e1c$export$1ef1fdd9ce87601b(n, i) || d($a3bf69d734984e1c$export$c405b7b148743d81(i, o.width, o.height), $a3bf69d734984e1c$export$12d870c2af07ad5a(i, o.width, o.height));
        });
        $a3bf69d734984e1c$var$m(this, "onComponentKeyDown", (e)=>{
            const { crop: n, disabled: t, onChange: d, onComplete: r } = this.props;
            if (t) return;
            const o = e.key;
            let w = !1;
            if (!n) return;
            const i = this.getBox(), s = this.makePixelCrop(i), g = (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) ? x.nudgeStepLarge : e.shiftKey ? x.nudgeStepMedium : x.nudgeStep;
            if (o === "ArrowLeft" ? (s.x -= g, w = !0) : o === "ArrowRight" ? (s.x += g, w = !0) : o === "ArrowUp" ? (s.y -= g, w = !0) : o === "ArrowDown" && (s.y += g, w = !0), w) {
                e.cancelable && e.preventDefault(), s.x = $a3bf69d734984e1c$export$7d15b64cf5a3a4c4(s.x, 0, i.width - s.width), s.y = $a3bf69d734984e1c$export$7d15b64cf5a3a4c4(s.y, 0, i.height - s.height);
                const p = $a3bf69d734984e1c$export$c405b7b148743d81(s, i.width, i.height), l = $a3bf69d734984e1c$export$12d870c2af07ad5a(s, i.width, i.height);
                d(p, l), r && r(p, l);
            }
        });
        $a3bf69d734984e1c$var$m(this, "onHandlerKeyDown", (e, n)=>{
            const { aspect: t = 0, crop: d, disabled: r, minWidth: o = 0, minHeight: w = 0, maxWidth: i, maxHeight: s, onChange: c, onComplete: g } = this.props, p = this.getBox();
            if (r || !d) return;
            if (e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === "ArrowLeft" || e.key === "ArrowRight") e.stopPropagation(), e.preventDefault();
            else return;
            const C = (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) ? x.nudgeStepLarge : e.shiftKey ? x.nudgeStepMedium : x.nudgeStep, y = $a3bf69d734984e1c$export$c405b7b148743d81(d, p.width, p.height), f = $a3bf69d734984e1c$export$eba630d9d6fdee89(y, e.key, C, n), R = $a3bf69d734984e1c$export$3cda6d75d50eabc(f, t, n, p.width, p.height, o, w, i, s);
            if (!$a3bf69d734984e1c$export$1ef1fdd9ce87601b(d, R)) {
                const Y = $a3bf69d734984e1c$export$12d870c2af07ad5a(R, p.width, p.height);
                c(R, Y), g && g(R, Y);
            }
        });
        $a3bf69d734984e1c$var$m(this, "onDocPointerDone", (e)=>{
            const { crop: n, disabled: t, onComplete: d, onDragEnd: r } = this.props, o = this.getBox();
            this.unbindDocMove(), !(t || !n) && this.mouseDownOnCrop && (this.mouseDownOnCrop = !1, this.dragStarted = !1, r && r(e), d && d($a3bf69d734984e1c$export$c405b7b148743d81(n, o.width, o.height), $a3bf69d734984e1c$export$12d870c2af07ad5a(n, o.width, o.height)), this.setState({
                cropIsActive: !1,
                newCropIsBeingDrawn: !1
            }));
        });
        $a3bf69d734984e1c$var$m(this, "onDragFocus", ()=>{
            var e;
            (e = this.componentRef.current) == null || e.scrollTo(0, 0);
        });
    }
    get document() {
        return document;
    }
    // We unfortunately get the bounding box every time as x+y changes
    // due to scrolling.
    getBox() {
        const e = this.mediaRef.current;
        if (!e) return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        const { x: n, y: t, width: d, height: r } = e.getBoundingClientRect();
        return {
            x: n,
            y: t,
            width: d,
            height: r
        };
    }
    componentDidUpdate(e) {
        const { crop: n, onComplete: t } = this.props;
        if (t && !e.crop && n) {
            const { width: d, height: r } = this.getBox();
            d && r && t($a3bf69d734984e1c$export$c405b7b148743d81(n, d, r), $a3bf69d734984e1c$export$12d870c2af07ad5a(n, d, r));
        }
    }
    componentWillUnmount() {
        this.resizeObserver && this.resizeObserver.disconnect(), this.unbindDocMove();
    }
    bindDocMove() {
        this.docMoveBound || (this.document.addEventListener("pointermove", this.onDocPointerMove, $a3bf69d734984e1c$var$M), this.document.addEventListener("pointerup", this.onDocPointerDone, $a3bf69d734984e1c$var$M), this.document.addEventListener("pointercancel", this.onDocPointerDone, $a3bf69d734984e1c$var$M), this.docMoveBound = !0);
    }
    unbindDocMove() {
        this.docMoveBound && (this.document.removeEventListener("pointermove", this.onDocPointerMove, $a3bf69d734984e1c$var$M), this.document.removeEventListener("pointerup", this.onDocPointerDone, $a3bf69d734984e1c$var$M), this.document.removeEventListener("pointercancel", this.onDocPointerDone, $a3bf69d734984e1c$var$M), this.docMoveBound = !1);
    }
    getCropStyle() {
        const { crop: e } = this.props;
        if (e) return {
            top: `${e.y}${e.unit}`,
            left: `${e.x}${e.unit}`,
            width: `${e.width}${e.unit}`,
            height: `${e.height}${e.unit}`
        };
    }
    dragCrop() {
        const { evData: e } = this, n = this.getBox(), t = this.makePixelCrop(n), d = e.clientX - e.startClientX, r = e.clientY - e.startClientY;
        return t.x = $a3bf69d734984e1c$export$7d15b64cf5a3a4c4(e.startCropX + d, 0, n.width - t.width), t.y = $a3bf69d734984e1c$export$7d15b64cf5a3a4c4(e.startCropY + r, 0, n.height - t.height), t;
    }
    getPointRegion(e, n, t, d) {
        const { evData: r } = this, o = r.clientX - e.x, w = r.clientY - e.y;
        let i;
        d && n ? i = n === "nw" || n === "n" || n === "ne" : i = w < r.startCropY;
        let s;
        return t && n ? s = n === "nw" || n === "w" || n === "sw" : s = o < r.startCropX, s ? i ? "nw" : "sw" : i ? "ne" : "se";
    }
    resolveMinDimensions(e, n, t = 0, d = 0) {
        const r = Math.min(t, e.width), o = Math.min(d, e.height);
        return !n || !r && !o ? [
            r,
            o
        ] : n > 1 ? r ? [
            r,
            r / n
        ] : [
            o * n,
            o
        ] : o ? [
            o * n,
            o
        ] : [
            r,
            r / n
        ];
    }
    resizeCrop() {
        const { evData: e } = this, { aspect: n = 0, maxWidth: t, maxHeight: d } = this.props, r = this.getBox(), [o, w] = this.resolveMinDimensions(r, n, this.props.minWidth, this.props.minHeight);
        let i = this.makePixelCrop(r);
        const s = this.getPointRegion(r, e.ord, o, w), c = e.ord || s;
        let g = e.clientX - e.startClientX, p = e.clientY - e.startClientY;
        (o && c === "nw" || c === "w" || c === "sw") && (g = Math.min(g, -o)), (w && c === "nw" || c === "n" || c === "ne") && (p = Math.min(p, -w));
        const l = {
            unit: "px",
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        s === "ne" ? (l.x = e.startCropX, l.width = g, n ? (l.height = l.width / n, l.y = e.startCropY - l.height) : (l.height = Math.abs(p), l.y = e.startCropY - l.height)) : s === "se" ? (l.x = e.startCropX, l.y = e.startCropY, l.width = g, n ? l.height = l.width / n : l.height = p) : s === "sw" ? (l.x = e.startCropX + g, l.y = e.startCropY, l.width = Math.abs(g), n ? l.height = l.width / n : l.height = p) : s === "nw" && (l.x = e.startCropX + g, l.width = Math.abs(g), n ? (l.height = l.width / n, l.y = e.startCropY - l.height) : (l.height = Math.abs(p), l.y = e.startCropY + p));
        const C = $a3bf69d734984e1c$export$3cda6d75d50eabc(l, n, s, r.width, r.height, o, w, t, d);
        return n || x.xyOrds.indexOf(c) > -1 ? i = C : x.xOrds.indexOf(c) > -1 ? (i.x = C.x, i.width = C.width) : x.yOrds.indexOf(c) > -1 && (i.y = C.y, i.height = C.height), i.x = $a3bf69d734984e1c$export$7d15b64cf5a3a4c4(i.x, 0, r.width - i.width), i.y = $a3bf69d734984e1c$export$7d15b64cf5a3a4c4(i.y, 0, r.height - i.height), i;
    }
    renderCropSelection() {
        const { ariaLabels: e = x.defaultProps.ariaLabels, disabled: n, locked: t, renderSelectionAddon: d, ruleOfThirds: r, crop: o } = this.props, w = this.getCropStyle();
        if (o) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            style: w,
            className: "ReactCrop__crop-selection",
            onPointerDown: this.onCropPointerDown,
            "aria-label": e.cropArea,
            tabIndex: 0,
            onKeyDown: this.onComponentKeyDown,
            role: "group"
        }, !n && !t && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            className: "ReactCrop__drag-elements",
            onFocus: this.onDragFocus
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            className: "ReactCrop__drag-bar ord-n",
            "data-ord": "n"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            className: "ReactCrop__drag-bar ord-e",
            "data-ord": "e"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            className: "ReactCrop__drag-bar ord-s",
            "data-ord": "s"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            className: "ReactCrop__drag-bar ord-w",
            "data-ord": "w"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            className: "ReactCrop__drag-handle ord-nw",
            "data-ord": "nw",
            tabIndex: 0,
            "aria-label": e.nwDragHandle,
            onKeyDown: (i)=>this.onHandlerKeyDown(i, "nw"),
            role: "button"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            className: "ReactCrop__drag-handle ord-n",
            "data-ord": "n",
            tabIndex: 0,
            "aria-label": e.nDragHandle,
            onKeyDown: (i)=>this.onHandlerKeyDown(i, "n"),
            role: "button"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            className: "ReactCrop__drag-handle ord-ne",
            "data-ord": "ne",
            tabIndex: 0,
            "aria-label": e.neDragHandle,
            onKeyDown: (i)=>this.onHandlerKeyDown(i, "ne"),
            role: "button"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            className: "ReactCrop__drag-handle ord-e",
            "data-ord": "e",
            tabIndex: 0,
            "aria-label": e.eDragHandle,
            onKeyDown: (i)=>this.onHandlerKeyDown(i, "e"),
            role: "button"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            className: "ReactCrop__drag-handle ord-se",
            "data-ord": "se",
            tabIndex: 0,
            "aria-label": e.seDragHandle,
            onKeyDown: (i)=>this.onHandlerKeyDown(i, "se"),
            role: "button"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            className: "ReactCrop__drag-handle ord-s",
            "data-ord": "s",
            tabIndex: 0,
            "aria-label": e.sDragHandle,
            onKeyDown: (i)=>this.onHandlerKeyDown(i, "s"),
            role: "button"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            className: "ReactCrop__drag-handle ord-sw",
            "data-ord": "sw",
            tabIndex: 0,
            "aria-label": e.swDragHandle,
            onKeyDown: (i)=>this.onHandlerKeyDown(i, "sw"),
            role: "button"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            className: "ReactCrop__drag-handle ord-w",
            "data-ord": "w",
            tabIndex: 0,
            "aria-label": e.wDragHandle,
            onKeyDown: (i)=>this.onHandlerKeyDown(i, "w"),
            role: "button"
        })), d && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            className: "ReactCrop__selection-addon",
            onPointerDown: (i)=>i.stopPropagation()
        }, d(this.state)), r && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            className: "ReactCrop__rule-of-thirds-hz"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            className: "ReactCrop__rule-of-thirds-vt"
        })));
    }
    makePixelCrop(e) {
        const n = {
            ...$a3bf69d734984e1c$export$fd37ff38bd5cb31b,
            ...this.props.crop || {}
        };
        return $a3bf69d734984e1c$export$c405b7b148743d81(n, e.width, e.height);
    }
    render() {
        const { aspect: e, children: n, circularCrop: t, className: d, crop: r, disabled: o, locked: w, style: i, ruleOfThirds: s } = this.props, { cropIsActive: c, newCropIsBeingDrawn: g } = this.state, p = r ? this.renderCropSelection() : null, l = $a3bf69d734984e1c$export$b02c518fbab8b887("ReactCrop", d, c && "ReactCrop--active", o && "ReactCrop--disabled", w && "ReactCrop--locked", g && "ReactCrop--new-crop", r && e && "ReactCrop--fixed-aspect", r && t && "ReactCrop--circular-crop", r && s && "ReactCrop--rule-of-thirds", !this.dragStarted && r && !r.width && !r.height && "ReactCrop--invisible-crop", t && "ReactCrop--no-animate");
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            ref: this.componentRef,
            className: l,
            style: i
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            ref: this.mediaRef,
            className: "ReactCrop__child-wrapper",
            onPointerDown: this.onComponentPointerDown
        }, n), r ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("svg", {
            className: "ReactCrop__crop-mask",
            width: "100%",
            height: "100%"
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("defs", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("mask", {
            id: `hole-${this.instanceId}`
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("rect", {
            width: "100%",
            height: "100%",
            fill: "white"
        }), t ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("ellipse", {
            cx: `${r.x + r.width / 2}${r.unit}`,
            cy: `${r.y + r.height / 2}${r.unit}`,
            rx: `${r.width / 2}${r.unit}`,
            ry: `${r.height / 2}${r.unit}`,
            fill: "black"
        }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("rect", {
            x: `${r.x}${r.unit}`,
            y: `${r.y}${r.unit}`,
            width: `${r.width}${r.unit}`,
            height: `${r.height}${r.unit}`,
            fill: "black"
        }))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("rect", {
            fill: "black",
            fillOpacity: 0.5,
            width: "100%",
            height: "100%",
            mask: `url(#hole-${this.instanceId})`
        })) : void 0, p);
    }
};
$a3bf69d734984e1c$var$m($a3bf69d734984e1c$var$x, "xOrds", [
    "e",
    "w"
]), $a3bf69d734984e1c$var$m($a3bf69d734984e1c$var$x, "yOrds", [
    "n",
    "s"
]), $a3bf69d734984e1c$var$m($a3bf69d734984e1c$var$x, "xyOrds", [
    "nw",
    "ne",
    "se",
    "sw"
]), $a3bf69d734984e1c$var$m($a3bf69d734984e1c$var$x, "nudgeStep", 1), $a3bf69d734984e1c$var$m($a3bf69d734984e1c$var$x, "nudgeStepMedium", 10), $a3bf69d734984e1c$var$m($a3bf69d734984e1c$var$x, "nudgeStepLarge", 100), $a3bf69d734984e1c$var$m($a3bf69d734984e1c$var$x, "defaultProps", {
    ariaLabels: {
        cropArea: "Use the arrow keys to move the crop selection area",
        nwDragHandle: "Use the arrow keys to move the north west drag handle to change the crop selection area",
        nDragHandle: "Use the up and down arrow keys to move the north drag handle to change the crop selection area",
        neDragHandle: "Use the arrow keys to move the north east drag handle to change the crop selection area",
        eDragHandle: "Use the up and down arrow keys to move the east drag handle to change the crop selection area",
        seDragHandle: "Use the arrow keys to move the south east drag handle to change the crop selection area",
        sDragHandle: "Use the up and down arrow keys to move the south drag handle to change the crop selection area",
        swDragHandle: "Use the arrow keys to move the south west drag handle to change the crop selection area",
        wDragHandle: "Use the up and down arrow keys to move the west drag handle to change the crop selection area"
    }
});
let $a3bf69d734984e1c$export$16fa2f45be04daa8 = $a3bf69d734984e1c$var$x;




var $489wz = parcelRequire("489wz");



var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");

var $gRqVZ = parcelRequire("gRqVZ");
const $2851bf420eedb5b6$var$theme = 'snow';
const $2851bf420eedb5b6$var$modules = {
    toolbar: [
        [
            'bold',
            'italic',
            'underline',
            'strike'
        ],
        [
            {
                align: []
            }
        ],
        [
            {
                list: 'ordered'
            },
            {
                list: 'bullet'
            }
        ],
        [
            {
                indent: '-1'
            },
            {
                indent: '+1'
            }
        ],
        [
            {
                size: [
                    'small',
                    false,
                    'large',
                    'huge'
                ]
            }
        ],
        [
            {
                header: [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    false
                ]
            }
        ],
        [
            'link',
            'image',
            'video'
        ],
        [
            {
                color: []
            },
            {
                background: []
            }
        ],
        [
            'clean'
        ]
    ],
    clipboard: {
        matchVisual: false
    }
};
const $2851bf420eedb5b6$var$formats = [
    'bold',
    'italic',
    'underline',
    'strike',
    'align',
    'list',
    'indent',
    'size',
    'header',
    'link',
    'image',
    'video',
    'color',
    'background'
];
function $2851bf420eedb5b6$var$assign(target, _varArgs) {
    'use strict';
    if (target === null || target === undefined) throw new TypeError('Cannot convert undefined or null to object');
    const to = Object(target);
    for(let index = 1; index < arguments.length; index++){
        const nextSource = arguments[index];
        if (nextSource !== null && nextSource !== undefined) {
            for(const nextKey in nextSource)if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) to[nextKey] = nextSource[nextKey];
        }
    }
    return to;
}

const $2851bf420eedb5b6$export$207fcf29d6f9caaa = (options = {
    theme: $2851bf420eedb5b6$var$theme,
    modules: $2851bf420eedb5b6$var$modules,
    formats: $2851bf420eedb5b6$var$formats
})=>{
    const quillRef = (0, $gRqVZ.useRef)(null);
    const [isLoaded, setIsLoaded] = (0, $gRqVZ.useState)(false);
    const [obj, setObj] = (0, $gRqVZ.useState)({
        Quill: undefined,
        quillRef: quillRef,
        quill: undefined,
        editorRef: quillRef,
        editor: undefined
    });
    (0, $gRqVZ.useEffect)(()=>{
        if (!obj.Quill) setObj((prev)=>$2851bf420eedb5b6$var$assign(prev, {
                Quill: (parcelRequire("6KEih")).default
            }));
        if (obj.Quill && !obj.quill && quillRef && quillRef.current && isLoaded) {
            const opts = $2851bf420eedb5b6$var$assign(options, {
                modules: $2851bf420eedb5b6$var$assign($2851bf420eedb5b6$var$modules, options.modules),
                formats: options.formats || $2851bf420eedb5b6$var$formats,
                theme: options.theme || $2851bf420eedb5b6$var$theme
            });
            const quill = new obj.Quill(quillRef.current, opts);
            setObj($2851bf420eedb5b6$var$assign($2851bf420eedb5b6$var$assign({}, obj), {
                quill: quill,
                editor: quill
            }));
        }
        setIsLoaded(true);
    }, [
        isLoaded,
        obj,
        options
    ]);
    return obj;
};



function $26d46b50bce0f876$export$b3ef8585d8cbf390({ value: value, onChange: onChange, placeholder: placeholder, className: className, style: style }) {
    const { quill: quill, quillRef: quillRef } = (0, $2851bf420eedb5b6$export$207fcf29d6f9caaa)({
        theme: 'snow',
        placeholder: placeholder
    });
    (0, $gRqVZ.useEffect)(()=>{
        if (quill && value !== undefined && quill.root.innerHTML !== value) quill.clipboard.dangerouslyPasteHTML(value);
    }, [
        quill
    ]);
    (0, $gRqVZ.useEffect)(()=>{
        if (!quill || !onChange) return;
        const handler = ()=>onChange(quill.root.innerHTML);
        quill.on('text-change', handler);
        return ()=>{
            quill.off('text-change', handler);
        };
    }, [
        quill,
        onChange
    ]);
    return /*#__PURE__*/ (0, $01ysi.jsx)("div", {
        ref: quillRef,
        className: className,
        style: style
    });
}




var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");

const $e3b5b907a1c9d3aa$export$b04be29aa201d4f5 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).label`
	display: block;
	margin-bottom: 5px;
	font-size: 16px;
`;


function $837a9440f933970f$var$FormLabel({ children: children, className: className, ...props }) {
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $e3b5b907a1c9d3aa$export$b04be29aa201d4f5), {
        className: className,
        ...props,
        children: children
    });
}
var $837a9440f933970f$export$2e2bcd8739ae039 = $837a9440f933970f$var$FormLabel;


function $c3a904dfa5a64ea0$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $c3a904dfa5a64ea0$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c3a904dfa5a64ea0$export$2e2bcd8739ae039(o);
}



function $5eaedf59da6bfe4e$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $c3a904dfa5a64ea0$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $c3a904dfa5a64ea0$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $7d3150598a489b7f$export$2e2bcd8739ae039(t) {
    var i = (0, $5eaedf59da6bfe4e$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $c3a904dfa5a64ea0$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $6a740e003744eccd$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $7d3150598a489b7f$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $70cca8c76ff58c71$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $70cca8c76ff58c71$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $70cca8c76ff58c71$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6a740e003744eccd$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $70cca8c76ff58c71$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $818de7f427b1da9f$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $28555262f384806a$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $dcf644df350d464c$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $2a435729188bd903$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $dcf644df350d464c$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $dcf644df350d464c$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $1c04807b255dd26c$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $ebff776814199019$export$2e2bcd8739ae039(r, e) {
    return (0, $818de7f427b1da9f$export$2e2bcd8739ae039)(r) || (0, $28555262f384806a$export$2e2bcd8739ae039)(r, e) || (0, $2a435729188bd903$export$2e2bcd8739ae039)(r, e) || (0, $1c04807b255dd26c$export$2e2bcd8739ae039)();
}



var $2UY5J = parcelRequire("2UY5J");
function $f308b666a2f706a5$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $2UY5J.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $gRqVZ = parcelRequire("gRqVZ");
var $acf234d9f794d66f$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $acf234d9f794d66f$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $f308b666a2f706a5$export$2e2bcd8739ae039)(_ref, $acf234d9f794d66f$var$_excluded);
    var _useState = (0, $gRqVZ.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $gRqVZ.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $gRqVZ.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $gRqVZ.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $gRqVZ.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $gRqVZ.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $gRqVZ.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}



var $if2ZQ = parcelRequire("if2ZQ");

var $gRqVZ = parcelRequire("gRqVZ");

var $if2ZQ = parcelRequire("if2ZQ");

function $1b593a0d9ece4e71$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $3cc3752fa56847ba$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $7d3150598a489b7f$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $3cc3752fa56847ba$export$2e2bcd8739ae039(e, r, t) {
    return r && $3cc3752fa56847ba$var$_defineProperties(e.prototype, r), t && $3cc3752fa56847ba$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



function $b6146753adbeade6$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $0e5a4a59758d80fa$export$2e2bcd8739ae039)(t, e);
}






function $19a29e637fa61de7$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $c3a904dfa5a64ea0$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $4c76512358ba4f48$export$2e2bcd8739ae039)(t);
}


function $3147102548c82f4d$export$2e2bcd8739ae039(t) {
    var r = (0, $2c62263bd98f6b07$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $f4e1869d2d3aba79$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $f4e1869d2d3aba79$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $19a29e637fa61de7$export$2e2bcd8739ae039)(this, e);
    };
}



function $4f25da830c1046cb$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $dcf644df350d464c$export$2e2bcd8739ae039)(r);
}


function $a55341f9daa7f086$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $a03defb9d52624f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $fbac2d7879866840$export$2e2bcd8739ae039(r) {
    return (0, $4f25da830c1046cb$export$2e2bcd8739ae039)(r) || (0, $a55341f9daa7f086$export$2e2bcd8739ae039)(r) || (0, $2a435729188bd903$export$2e2bcd8739ae039)(r) || (0, $a03defb9d52624f2$export$2e2bcd8739ae039)();
}



var $gRqVZ = parcelRequire("gRqVZ");


var $if2ZQ = parcelRequire("if2ZQ");

var $50JbI = parcelRequire("50JbI");



function $3799099eb563ea4f$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}




var $gRqVZ = parcelRequire("gRqVZ");

var $hYKvr = parcelRequire("hYKvr");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $e6961ec414e5ebe2$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $e6961ec414e5ebe2$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $e6961ec414e5ebe2$export$803cd8101b6c182b = /*#__PURE__*/ $e6961ec414e5ebe2$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $e6961ec414e5ebe2$export$27b07d8a310ed8b5[0], side + "-" + $e6961ec414e5ebe2$export$27b07d8a310ed8b5[1]), []);
const $e6961ec414e5ebe2$export$96ec731ed4dcb222 = Math.min;
const $e6961ec414e5ebe2$export$8960430cfd85939f = Math.max;
const $e6961ec414e5ebe2$export$2077e0241d6afd3c = Math.round;
const $e6961ec414e5ebe2$export$a3fe094919f356fd = Math.floor;
const $e6961ec414e5ebe2$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $e6961ec414e5ebe2$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $e6961ec414e5ebe2$export$7d15b64cf5a3a4c4(start, value, end) {
    return $e6961ec414e5ebe2$export$8960430cfd85939f(start, $e6961ec414e5ebe2$export$96ec731ed4dcb222(value, end));
}
function $e6961ec414e5ebe2$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $e6961ec414e5ebe2$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $e6961ec414e5ebe2$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $e6961ec414e5ebe2$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $e6961ec414e5ebe2$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $e6961ec414e5ebe2$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $e6961ec414e5ebe2$export$2b57e0052a6d6d4c(placement) {
    return $e6961ec414e5ebe2$export$8a000a963141ac32($e6961ec414e5ebe2$export$f28e8f882010718a(placement));
}
function $e6961ec414e5ebe2$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $e6961ec414e5ebe2$export$f0989780f32bfcda(placement);
    const alignmentAxis = $e6961ec414e5ebe2$export$2b57e0052a6d6d4c(placement);
    const length = $e6961ec414e5ebe2$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $e6961ec414e5ebe2$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $e6961ec414e5ebe2$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $e6961ec414e5ebe2$export$496432a3699e50b1(placement) {
    const oppositePlacement = $e6961ec414e5ebe2$export$9c5e28bad23365fa(placement);
    return [
        $e6961ec414e5ebe2$export$2b182c584985588b(placement),
        oppositePlacement,
        $e6961ec414e5ebe2$export$2b182c584985588b(oppositePlacement)
    ];
}
function $e6961ec414e5ebe2$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $e6961ec414e5ebe2$var$lrPlacement = [
    'left',
    'right'
];
const $e6961ec414e5ebe2$var$rlPlacement = [
    'right',
    'left'
];
const $e6961ec414e5ebe2$var$tbPlacement = [
    'top',
    'bottom'
];
const $e6961ec414e5ebe2$var$btPlacement = [
    'bottom',
    'top'
];
function $e6961ec414e5ebe2$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $e6961ec414e5ebe2$var$rlPlacement : $e6961ec414e5ebe2$var$lrPlacement;
            return isStart ? $e6961ec414e5ebe2$var$lrPlacement : $e6961ec414e5ebe2$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $e6961ec414e5ebe2$var$tbPlacement : $e6961ec414e5ebe2$var$btPlacement;
        default:
            return [];
    }
}
function $e6961ec414e5ebe2$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $e6961ec414e5ebe2$export$f0989780f32bfcda(placement);
    let list = $e6961ec414e5ebe2$var$getSideList($e6961ec414e5ebe2$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($e6961ec414e5ebe2$export$2b182c584985588b));
    }
    return list;
}
function $e6961ec414e5ebe2$export$9c5e28bad23365fa(placement) {
    const side = $e6961ec414e5ebe2$export$3c915306cb7fc97a(placement);
    return $e6961ec414e5ebe2$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $e6961ec414e5ebe2$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $e6961ec414e5ebe2$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $e6961ec414e5ebe2$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $e6961ec414e5ebe2$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $60dcbe67de659b8b$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $e6961ec414e5ebe2$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $e6961ec414e5ebe2$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $e6961ec414e5ebe2$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $e6961ec414e5ebe2$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $e6961ec414e5ebe2$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $60dcbe67de659b8b$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $e6961ec414e5ebe2$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $e6961ec414e5ebe2$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $e6961ec414e5ebe2$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $e6961ec414e5ebe2$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $60dcbe67de659b8b$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $60dcbe67de659b8b$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $60dcbe67de659b8b$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $60dcbe67de659b8b$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $60dcbe67de659b8b$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $60dcbe67de659b8b$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $60dcbe67de659b8b$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $e6961ec414e5ebe2$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $e6961ec414e5ebe2$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $e6961ec414e5ebe2$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $e6961ec414e5ebe2$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $e6961ec414e5ebe2$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $e6961ec414e5ebe2$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $e6961ec414e5ebe2$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $e6961ec414e5ebe2$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $60dcbe67de659b8b$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $e6961ec414e5ebe2$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $e6961ec414e5ebe2$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $e6961ec414e5ebe2$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $e6961ec414e5ebe2$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $e6961ec414e5ebe2$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $60dcbe67de659b8b$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $e6961ec414e5ebe2$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $e6961ec414e5ebe2$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $e6961ec414e5ebe2$export$803cd8101b6c182b) ? $60dcbe67de659b8b$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $e6961ec414e5ebe2$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $e6961ec414e5ebe2$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $e6961ec414e5ebe2$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $e6961ec414e5ebe2$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $60dcbe67de659b8b$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $e6961ec414e5ebe2$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $e6961ec414e5ebe2$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $e6961ec414e5ebe2$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $e6961ec414e5ebe2$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $e6961ec414e5ebe2$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $e6961ec414e5ebe2$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $e6961ec414e5ebe2$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $e6961ec414e5ebe2$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $e6961ec414e5ebe2$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $e6961ec414e5ebe2$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $e6961ec414e5ebe2$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $60dcbe67de659b8b$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $60dcbe67de659b8b$var$isAnySideFullyClipped(overflow) {
    return (0, $e6961ec414e5ebe2$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $60dcbe67de659b8b$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $e6961ec414e5ebe2$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $60dcbe67de659b8b$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $60dcbe67de659b8b$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $60dcbe67de659b8b$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $60dcbe67de659b8b$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $60dcbe67de659b8b$var$getBoundingRect(rects) {
    const minX = (0, $e6961ec414e5ebe2$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $e6961ec414e5ebe2$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $e6961ec414e5ebe2$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $e6961ec414e5ebe2$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $60dcbe67de659b8b$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $e6961ec414e5ebe2$export$ee05aea0aeecbad4)($60dcbe67de659b8b$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $60dcbe67de659b8b$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $e6961ec414e5ebe2$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $60dcbe67de659b8b$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $e6961ec414e5ebe2$export$ee05aea0aeecbad4)($60dcbe67de659b8b$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $e6961ec414e5ebe2$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $e6961ec414e5ebe2$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $e6961ec414e5ebe2$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $e6961ec414e5ebe2$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $e6961ec414e5ebe2$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $e6961ec414e5ebe2$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $60dcbe67de659b8b$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $60dcbe67de659b8b$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $e6961ec414e5ebe2$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $e6961ec414e5ebe2$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $e6961ec414e5ebe2$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $60dcbe67de659b8b$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $e6961ec414e5ebe2$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $60dcbe67de659b8b$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $60dcbe67de659b8b$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $60dcbe67de659b8b$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $e6961ec414e5ebe2$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $e6961ec414e5ebe2$export$f28e8f882010718a)((0, $e6961ec414e5ebe2$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $e6961ec414e5ebe2$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $e6961ec414e5ebe2$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $e6961ec414e5ebe2$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $60dcbe67de659b8b$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $e6961ec414e5ebe2$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $e6961ec414e5ebe2$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $e6961ec414e5ebe2$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $e6961ec414e5ebe2$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $60dcbe67de659b8b$var$originSides.has((0, $e6961ec414e5ebe2$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $60dcbe67de659b8b$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $e6961ec414e5ebe2$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $e6961ec414e5ebe2$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $e6961ec414e5ebe2$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $e6961ec414e5ebe2$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $e6961ec414e5ebe2$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $e6961ec414e5ebe2$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $e6961ec414e5ebe2$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $e6961ec414e5ebe2$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $e6961ec414e5ebe2$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $e6961ec414e5ebe2$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $e6961ec414e5ebe2$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $e6961ec414e5ebe2$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $738e3bc94a5cc253$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $738e3bc94a5cc253$export$651544f548703224(node) {
    if ($738e3bc94a5cc253$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $738e3bc94a5cc253$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $738e3bc94a5cc253$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($738e3bc94a5cc253$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $738e3bc94a5cc253$export$8ee0fc9ee280b4ee(value) {
    if (!$738e3bc94a5cc253$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $738e3bc94a5cc253$export$38b2d434cce3ea22(value).Node;
}
function $738e3bc94a5cc253$export$45a5e7f76e0caa8d(value) {
    if (!$738e3bc94a5cc253$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $738e3bc94a5cc253$export$38b2d434cce3ea22(value).Element;
}
function $738e3bc94a5cc253$export$1b3bfaa9684536aa(value) {
    if (!$738e3bc94a5cc253$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $738e3bc94a5cc253$export$38b2d434cce3ea22(value).HTMLElement;
}
function $738e3bc94a5cc253$export$af51f0f06c0f328a(value) {
    if (!$738e3bc94a5cc253$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $738e3bc94a5cc253$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $738e3bc94a5cc253$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $738e3bc94a5cc253$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $738e3bc94a5cc253$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($738e3bc94a5cc253$export$651544f548703224(element));
}
function $738e3bc94a5cc253$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $738e3bc94a5cc253$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $738e3bc94a5cc253$var$containRe = /paint|layout|strict|content/;
const $738e3bc94a5cc253$var$isNotNone = (value)=>!!value && value !== 'none';
let $738e3bc94a5cc253$var$isWebKitValue;
function $738e3bc94a5cc253$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $738e3bc94a5cc253$export$45a5e7f76e0caa8d(elementOrCss) ? $738e3bc94a5cc253$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $738e3bc94a5cc253$var$isNotNone(css.transform) || $738e3bc94a5cc253$var$isNotNone(css.translate) || $738e3bc94a5cc253$var$isNotNone(css.scale) || $738e3bc94a5cc253$var$isNotNone(css.rotate) || $738e3bc94a5cc253$var$isNotNone(css.perspective) || !$738e3bc94a5cc253$export$78551043582a6a98() && ($738e3bc94a5cc253$var$isNotNone(css.backdropFilter) || $738e3bc94a5cc253$var$isNotNone(css.filter)) || $738e3bc94a5cc253$var$willChangeRe.test(css.willChange || '') || $738e3bc94a5cc253$var$containRe.test(css.contain || '');
}
function $738e3bc94a5cc253$export$940d8225183e1404(element) {
    let currentNode = $738e3bc94a5cc253$export$4e12058fc4d51d56(element);
    while($738e3bc94a5cc253$export$1b3bfaa9684536aa(currentNode) && !$738e3bc94a5cc253$export$d1162fb0b6d4cd51(currentNode)){
        if ($738e3bc94a5cc253$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($738e3bc94a5cc253$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $738e3bc94a5cc253$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $738e3bc94a5cc253$export$78551043582a6a98() {
    if ($738e3bc94a5cc253$var$isWebKitValue == null) $738e3bc94a5cc253$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $738e3bc94a5cc253$var$isWebKitValue;
}
function $738e3bc94a5cc253$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($738e3bc94a5cc253$export$651544f548703224(node));
}
function $738e3bc94a5cc253$export$3735103072e4a80(element) {
    return $738e3bc94a5cc253$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $738e3bc94a5cc253$export$dc8fc79fa2800137(element) {
    if ($738e3bc94a5cc253$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $738e3bc94a5cc253$export$4e12058fc4d51d56(node) {
    if ($738e3bc94a5cc253$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $738e3bc94a5cc253$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $738e3bc94a5cc253$export$e495491855dc5418(node);
    return $738e3bc94a5cc253$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $738e3bc94a5cc253$export$7cd01a57c8ca906c(node) {
    const parentNode = $738e3bc94a5cc253$export$4e12058fc4d51d56(node);
    if ($738e3bc94a5cc253$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($738e3bc94a5cc253$export$1b3bfaa9684536aa(parentNode) && $738e3bc94a5cc253$export$989e911fa9af580a(parentNode)) return parentNode;
    return $738e3bc94a5cc253$export$7cd01a57c8ca906c(parentNode);
}
function $738e3bc94a5cc253$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $738e3bc94a5cc253$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $738e3bc94a5cc253$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $738e3bc94a5cc253$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $738e3bc94a5cc253$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $738e3bc94a5cc253$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $738e3bc94a5cc253$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $738e3bc94a5cc253$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $2ba7605c2f9f8d68$var$getCssDimensions(element) {
    const css = (0, $738e3bc94a5cc253$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $738e3bc94a5cc253$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $e6961ec414e5ebe2$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $e6961ec414e5ebe2$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $2ba7605c2f9f8d68$var$unwrapElement(element) {
    return !(0, $738e3bc94a5cc253$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $2ba7605c2f9f8d68$var$getScale(element) {
    const domElement = $2ba7605c2f9f8d68$var$unwrapElement(element);
    if (!(0, $738e3bc94a5cc253$export$1b3bfaa9684536aa)(domElement)) return (0, $e6961ec414e5ebe2$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $2ba7605c2f9f8d68$var$getCssDimensions(domElement);
    let x = ($ ? (0, $e6961ec414e5ebe2$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $e6961ec414e5ebe2$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $2ba7605c2f9f8d68$var$noOffsets = /*#__PURE__*/ (0, $e6961ec414e5ebe2$export$a397704b5e280835)(0);
function $2ba7605c2f9f8d68$var$getVisualOffsets(element) {
    const win = (0, $738e3bc94a5cc253$export$38b2d434cce3ea22)(element);
    if (!(0, $738e3bc94a5cc253$export$78551043582a6a98)() || !win.visualViewport) return $2ba7605c2f9f8d68$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $2ba7605c2f9f8d68$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $738e3bc94a5cc253$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $2ba7605c2f9f8d68$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $2ba7605c2f9f8d68$var$unwrapElement(element);
    let scale = (0, $e6961ec414e5ebe2$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $738e3bc94a5cc253$export$45a5e7f76e0caa8d)(offsetParent)) scale = $2ba7605c2f9f8d68$var$getScale(offsetParent);
        } else scale = $2ba7605c2f9f8d68$var$getScale(element);
    }
    const visualOffsets = $2ba7605c2f9f8d68$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $2ba7605c2f9f8d68$var$getVisualOffsets(domElement) : (0, $e6961ec414e5ebe2$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $738e3bc94a5cc253$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $738e3bc94a5cc253$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $738e3bc94a5cc253$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $738e3bc94a5cc253$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $2ba7605c2f9f8d68$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $738e3bc94a5cc253$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $738e3bc94a5cc253$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $738e3bc94a5cc253$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $e6961ec414e5ebe2$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $2ba7605c2f9f8d68$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $738e3bc94a5cc253$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $2ba7605c2f9f8d68$var$getBoundingClientRect((0, $738e3bc94a5cc253$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $2ba7605c2f9f8d68$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $2ba7605c2f9f8d68$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $2ba7605c2f9f8d68$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $738e3bc94a5cc253$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $738e3bc94a5cc253$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $e6961ec414e5ebe2$export$a397704b5e280835)(1);
    const offsets = (0, $e6961ec414e5ebe2$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $738e3bc94a5cc253$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $738e3bc94a5cc253$export$651544f548703224)(offsetParent) !== 'body' || (0, $738e3bc94a5cc253$export$989e911fa9af580a)(documentElement)) scroll = (0, $738e3bc94a5cc253$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $2ba7605c2f9f8d68$var$getBoundingClientRect(offsetParent);
            scale = $2ba7605c2f9f8d68$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $2ba7605c2f9f8d68$var$getHTMLOffset(documentElement, scroll) : (0, $e6961ec414e5ebe2$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $2ba7605c2f9f8d68$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $2ba7605c2f9f8d68$var$getDocumentRect(element) {
    const html = (0, $738e3bc94a5cc253$export$e495491855dc5418)(element);
    const scroll = (0, $738e3bc94a5cc253$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $e6961ec414e5ebe2$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $e6961ec414e5ebe2$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $2ba7605c2f9f8d68$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $738e3bc94a5cc253$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $e6961ec414e5ebe2$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $2ba7605c2f9f8d68$var$SCROLLBAR_MAX = 25;
function $2ba7605c2f9f8d68$var$getViewportRect(element, strategy) {
    const win = (0, $738e3bc94a5cc253$export$38b2d434cce3ea22)(element);
    const html = (0, $738e3bc94a5cc253$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $738e3bc94a5cc253$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $2ba7605c2f9f8d68$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $2ba7605c2f9f8d68$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $2ba7605c2f9f8d68$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $2ba7605c2f9f8d68$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $2ba7605c2f9f8d68$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $738e3bc94a5cc253$export$1b3bfaa9684536aa)(element) ? $2ba7605c2f9f8d68$var$getScale(element) : (0, $e6961ec414e5ebe2$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $2ba7605c2f9f8d68$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $2ba7605c2f9f8d68$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $2ba7605c2f9f8d68$var$getDocumentRect((0, $738e3bc94a5cc253$export$e495491855dc5418)(element));
    else if ((0, $738e3bc94a5cc253$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $2ba7605c2f9f8d68$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $2ba7605c2f9f8d68$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $e6961ec414e5ebe2$export$ee05aea0aeecbad4)(rect);
}
function $2ba7605c2f9f8d68$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $738e3bc94a5cc253$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $738e3bc94a5cc253$export$45a5e7f76e0caa8d)(parentNode) || (0, $738e3bc94a5cc253$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $738e3bc94a5cc253$export$3735103072e4a80)(parentNode).position === 'fixed' || $2ba7605c2f9f8d68$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $2ba7605c2f9f8d68$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $738e3bc94a5cc253$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $738e3bc94a5cc253$export$45a5e7f76e0caa8d)(el) && (0, $738e3bc94a5cc253$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $738e3bc94a5cc253$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $738e3bc94a5cc253$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $738e3bc94a5cc253$export$45a5e7f76e0caa8d)(currentNode) && !(0, $738e3bc94a5cc253$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $738e3bc94a5cc253$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $738e3bc94a5cc253$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, $738e3bc94a5cc253$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $2ba7605c2f9f8d68$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $738e3bc94a5cc253$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $2ba7605c2f9f8d68$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $738e3bc94a5cc253$export$89e651af02346cd4)(element) ? [] : $2ba7605c2f9f8d68$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $2ba7605c2f9f8d68$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $2ba7605c2f9f8d68$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $e6961ec414e5ebe2$export$8960430cfd85939f)(rect.top, top);
        right = (0, $e6961ec414e5ebe2$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $e6961ec414e5ebe2$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $e6961ec414e5ebe2$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $2ba7605c2f9f8d68$var$getDimensions(element) {
    const { width: width, height: height } = $2ba7605c2f9f8d68$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $2ba7605c2f9f8d68$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $738e3bc94a5cc253$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $738e3bc94a5cc253$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $2ba7605c2f9f8d68$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $e6961ec414e5ebe2$export$a397704b5e280835)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $2ba7605c2f9f8d68$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $738e3bc94a5cc253$export$651544f548703224)(offsetParent) !== 'body' || (0, $738e3bc94a5cc253$export$989e911fa9af580a)(documentElement)) scroll = (0, $738e3bc94a5cc253$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $2ba7605c2f9f8d68$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $2ba7605c2f9f8d68$var$getHTMLOffset(documentElement, scroll) : (0, $e6961ec414e5ebe2$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $2ba7605c2f9f8d68$var$isStaticPositioned(element) {
    return (0, $738e3bc94a5cc253$export$3735103072e4a80)(element).position === 'static';
}
function $2ba7605c2f9f8d68$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $738e3bc94a5cc253$export$1b3bfaa9684536aa)(element) || (0, $738e3bc94a5cc253$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $738e3bc94a5cc253$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $2ba7605c2f9f8d68$var$getOffsetParent(element, polyfill) {
    const win = (0, $738e3bc94a5cc253$export$38b2d434cce3ea22)(element);
    if ((0, $738e3bc94a5cc253$export$89e651af02346cd4)(element)) return win;
    if (!(0, $738e3bc94a5cc253$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $738e3bc94a5cc253$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $738e3bc94a5cc253$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $738e3bc94a5cc253$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$2ba7605c2f9f8d68$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $738e3bc94a5cc253$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $2ba7605c2f9f8d68$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $738e3bc94a5cc253$export$71535ffaa902797f)(offsetParent) && $2ba7605c2f9f8d68$var$isStaticPositioned(offsetParent))offsetParent = $2ba7605c2f9f8d68$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $738e3bc94a5cc253$export$d1162fb0b6d4cd51)(offsetParent) && $2ba7605c2f9f8d68$var$isStaticPositioned(offsetParent) && !(0, $738e3bc94a5cc253$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $738e3bc94a5cc253$export$940d8225183e1404)(element) || win;
}
const $2ba7605c2f9f8d68$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $2ba7605c2f9f8d68$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $2ba7605c2f9f8d68$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $2ba7605c2f9f8d68$var$isRTL(element) {
    return (0, $738e3bc94a5cc253$export$3735103072e4a80)(element).direction === 'rtl';
}
const $2ba7605c2f9f8d68$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $2ba7605c2f9f8d68$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $738e3bc94a5cc253$export$e495491855dc5418,
    getClippingRect: $2ba7605c2f9f8d68$var$getClippingRect,
    getOffsetParent: $2ba7605c2f9f8d68$var$getOffsetParent,
    getElementRects: $2ba7605c2f9f8d68$var$getElementRects,
    getClientRects: $2ba7605c2f9f8d68$var$getClientRects,
    getDimensions: $2ba7605c2f9f8d68$var$getDimensions,
    getScale: $2ba7605c2f9f8d68$var$getScale,
    isElement: $738e3bc94a5cc253$export$45a5e7f76e0caa8d,
    isRTL: $2ba7605c2f9f8d68$var$isRTL
};
function $2ba7605c2f9f8d68$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $2ba7605c2f9f8d68$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $738e3bc94a5cc253$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $e6961ec414e5ebe2$export$a3fe094919f356fd)(top);
        const insetRight = (0, $e6961ec414e5ebe2$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $e6961ec414e5ebe2$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $e6961ec414e5ebe2$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $e6961ec414e5ebe2$export$8960430cfd85939f)(0, (0, $e6961ec414e5ebe2$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$2ba7605c2f9f8d68$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $2ba7605c2f9f8d68$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $2ba7605c2f9f8d68$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $738e3bc94a5cc253$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $738e3bc94a5cc253$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $2ba7605c2f9f8d68$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $2ba7605c2f9f8d68$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $2ba7605c2f9f8d68$var$getBoundingClientRect(reference);
        if (prevRefRect && !$2ba7605c2f9f8d68$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $2ba7605c2f9f8d68$export$37b6bde19b108ecc = (0, $60dcbe67de659b8b$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $2ba7605c2f9f8d68$export$cc800923e997bb8 = (0, $60dcbe67de659b8b$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $2ba7605c2f9f8d68$export$91fb6ecbd551914 = (0, $60dcbe67de659b8b$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $2ba7605c2f9f8d68$export$fba63a578e423eb = (0, $60dcbe67de659b8b$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $2ba7605c2f9f8d68$export$8a83211c878a3f1f = (0, $60dcbe67de659b8b$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $2ba7605c2f9f8d68$export$346677f925de839c = (0, $60dcbe67de659b8b$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $2ba7605c2f9f8d68$export$fe8985bb6374093c = (0, $60dcbe67de659b8b$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $2ba7605c2f9f8d68$export$f2120bbfa5450bd2 = (0, $60dcbe67de659b8b$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $2ba7605c2f9f8d68$export$18c8ad048e32c7d5 = (0, $60dcbe67de659b8b$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $2ba7605c2f9f8d68$export$7bf07e38f3dc4b69 = (0, $60dcbe67de659b8b$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $2ba7605c2f9f8d68$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $2ba7605c2f9f8d68$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $60dcbe67de659b8b$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $gRqVZ = parcelRequire("gRqVZ");
var $da8820fef20aa765$export$2e2bcd8739ae039 = (0, $gRqVZ.useLayoutEffect);


var $72284f2bcce33c5d$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $72284f2bcce33c5d$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $72284f2bcce33c5d$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $72284f2bcce33c5d$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($72284f2bcce33c5d$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $72284f2bcce33c5d$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($72284f2bcce33c5d$var$isArray(value)) return value.filter(Boolean);
    if ((0, $c3a904dfa5a64ea0$export$2e2bcd8739ae039)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $72284f2bcce33c5d$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $f308b666a2f706a5$export$2e2bcd8739ae039)(props, $72284f2bcce33c5d$var$_excluded$4);
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $72284f2bcce33c5d$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $72284f2bcce33c5d$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $72284f2bcce33c5d$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $72284f2bcce33c5d$var$normalizedHeight(el) {
    if ($72284f2bcce33c5d$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $72284f2bcce33c5d$var$getScrollTop(el) {
    if ($72284f2bcce33c5d$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $72284f2bcce33c5d$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($72284f2bcce33c5d$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $72284f2bcce33c5d$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $72284f2bcce33c5d$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $72284f2bcce33c5d$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $72284f2bcce33c5d$export$b4171a6734a65d42;
    var start = $72284f2bcce33c5d$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $72284f2bcce33c5d$var$easeOutCubic(currentTime, start, change, duration);
        $72284f2bcce33c5d$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $72284f2bcce33c5d$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $72284f2bcce33c5d$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $72284f2bcce33c5d$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $72284f2bcce33c5d$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $72284f2bcce33c5d$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $72284f2bcce33c5d$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $72284f2bcce33c5d$var$passiveOptionAccessed = false;
var $72284f2bcce33c5d$var$options = {
    get passive () {
        return $72284f2bcce33c5d$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $72284f2bcce33c5d$var$w = typeof window !== 'undefined' ? window : {};
if ($72284f2bcce33c5d$var$w.addEventListener && $72284f2bcce33c5d$var$w.removeEventListener) {
    $72284f2bcce33c5d$var$w.addEventListener('p', $72284f2bcce33c5d$export$b4171a6734a65d42, $72284f2bcce33c5d$var$options);
    $72284f2bcce33c5d$var$w.removeEventListener('p', $72284f2bcce33c5d$export$b4171a6734a65d42, false);
}
var $72284f2bcce33c5d$export$2408f22a0fab9ae5 = $72284f2bcce33c5d$var$passiveOptionAccessed;
function $72284f2bcce33c5d$export$3466f893ebf79586(item) {
    return item != null;
}
function $72284f2bcce33c5d$var$isArray(arg) {
    return Array.isArray(arg);
}
function $72284f2bcce33c5d$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $72284f2bcce33c5d$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $72284f2bcce33c5d$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $72284f2bcce33c5d$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $72284f2bcce33c5d$var$_excluded$3 = [
    "children",
    "innerProps"
], $72284f2bcce33c5d$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $72284f2bcce33c5d$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $72284f2bcce33c5d$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $72284f2bcce33c5d$var$normalizedHeight(scrollParent);
    var scrollTop = $72284f2bcce33c5d$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $72284f2bcce33c5d$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $72284f2bcce33c5d$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $72284f2bcce33c5d$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $72284f2bcce33c5d$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $72284f2bcce33c5d$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $72284f2bcce33c5d$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $72284f2bcce33c5d$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $72284f2bcce33c5d$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: 'menu'
    }, (0, $6a740e003744eccd$export$2e2bcd8739ae039)(_objectSpread2, $72284f2bcce33c5d$var$alignToControl(placement), '100%'), (0, $6a740e003744eccd$export$2e2bcd8739ae039)(_objectSpread2, "position", 'absolute'), (0, $6a740e003744eccd$export$2e2bcd8739ae039)(_objectSpread2, "width", '100%'), (0, $6a740e003744eccd$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $72284f2bcce33c5d$var$PortalPlacementContext = /*#__PURE__*/ (0, $gRqVZ.createContext)(null);
// NOTE: internal only
var $72284f2bcce33c5d$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $gRqVZ.useContext)($72284f2bcce33c5d$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $gRqVZ.useRef)(null);
    var _useState = (0, $gRqVZ.useState)(maxMenuHeight), _useState2 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $gRqVZ.useState)(null), _useState4 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $da8820fef20aa765$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $72284f2bcce33c5d$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $72284f2bcce33c5d$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $72284f2bcce33c5d$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $50JbI.jsx)("div", (0, $if2ZQ.default)({}, $72284f2bcce33c5d$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $72284f2bcce33c5d$var$Menu$1 = $72284f2bcce33c5d$var$Menu;
// ==============================
// Menu List
// ==============================
var $72284f2bcce33c5d$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $72284f2bcce33c5d$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $50JbI.jsx)("div", (0, $if2ZQ.default)({}, $72284f2bcce33c5d$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $72284f2bcce33c5d$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $72284f2bcce33c5d$export$3b14a55fb2447963 = $72284f2bcce33c5d$var$noticeCSS;
var $72284f2bcce33c5d$export$342063e11d6c3cad = $72284f2bcce33c5d$var$noticeCSS;
var $72284f2bcce33c5d$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $f308b666a2f706a5$export$2e2bcd8739ae039)(_ref6, $72284f2bcce33c5d$var$_excluded$3);
    return (0, $50JbI.jsx)("div", (0, $if2ZQ.default)({}, $72284f2bcce33c5d$var$getStyleProps((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var $72284f2bcce33c5d$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $f308b666a2f706a5$export$2e2bcd8739ae039)(_ref7, $72284f2bcce33c5d$var$_excluded2$1);
    return (0, $50JbI.jsx)("div", (0, $if2ZQ.default)({}, $72284f2bcce33c5d$var$getStyleProps((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $72284f2bcce33c5d$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $72284f2bcce33c5d$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $gRqVZ.useRef)(null);
    var cleanupRef = (0, $gRqVZ.useRef)(null);
    var _useState5 = (0, $gRqVZ.useState)($72284f2bcce33c5d$var$coercePlacement(menuPlacement)), _useState6 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $gRqVZ.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $gRqVZ.useState)(null), _useState8 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $gRqVZ.useCallback)(function() {
        if (!controlElement) return;
        var rect = $72284f2bcce33c5d$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $da8820fef20aa765$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $gRqVZ.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $2ba7605c2f9f8d68$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $da8820fef20aa765$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $gRqVZ.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $50JbI.jsx)("div", (0, $if2ZQ.default)({
        ref: setMenuPortalElement
    }, $72284f2bcce33c5d$var$getStyleProps((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $50JbI.jsx)($72284f2bcce33c5d$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $hYKvr.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $72284f2bcce33c5d$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $72284f2bcce33c5d$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $50JbI.jsx)("div", (0, $if2ZQ.default)({}, $72284f2bcce33c5d$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $72284f2bcce33c5d$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $72284f2bcce33c5d$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $50JbI.jsx)("div", (0, $if2ZQ.default)({}, $72284f2bcce33c5d$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $72284f2bcce33c5d$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $72284f2bcce33c5d$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $50JbI.jsx)("div", (0, $if2ZQ.default)({}, $72284f2bcce33c5d$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $72284f2bcce33c5d$var$_templateObject;
var $72284f2bcce33c5d$var$_excluded$2 = [
    "size"
], $72284f2bcce33c5d$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $72284f2bcce33c5d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $72284f2bcce33c5d$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $72284f2bcce33c5d$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $f308b666a2f706a5$export$2e2bcd8739ae039)(_ref, $72284f2bcce33c5d$var$_excluded$2);
    return (0, $50JbI.jsx)("svg", (0, $if2ZQ.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $72284f2bcce33c5d$var$_ref2
    }, props));
};
var $72284f2bcce33c5d$var$CrossIcon = function CrossIcon(props) {
    return (0, $50JbI.jsx)($72284f2bcce33c5d$var$Svg, (0, $if2ZQ.default)({
        size: 20
    }, props), (0, $50JbI.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $72284f2bcce33c5d$var$DownChevron = function DownChevron(props) {
    return (0, $50JbI.jsx)($72284f2bcce33c5d$var$Svg, (0, $if2ZQ.default)({
        size: 20
    }, props), (0, $50JbI.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $72284f2bcce33c5d$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $72284f2bcce33c5d$export$f1e1789686576879 = $72284f2bcce33c5d$var$baseCSS;
var $72284f2bcce33c5d$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $50JbI.jsx)("div", (0, $if2ZQ.default)({}, $72284f2bcce33c5d$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $50JbI.jsx)($72284f2bcce33c5d$var$DownChevron, null));
};
var $72284f2bcce33c5d$export$407448d2b89b1813 = $72284f2bcce33c5d$var$baseCSS;
var $72284f2bcce33c5d$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $50JbI.jsx)("div", (0, $if2ZQ.default)({}, $72284f2bcce33c5d$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $50JbI.jsx)($72284f2bcce33c5d$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $72284f2bcce33c5d$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $72284f2bcce33c5d$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $50JbI.jsx)("span", (0, $if2ZQ.default)({}, innerProps, $72284f2bcce33c5d$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $72284f2bcce33c5d$var$loadingDotAnimations = (0, $50JbI.keyframes)($72284f2bcce33c5d$var$_templateObject || ($72284f2bcce33c5d$var$_templateObject = (0, $3799099eb563ea4f$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $72284f2bcce33c5d$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $72284f2bcce33c5d$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $50JbI.jsx)("span", {
        css: /*#__PURE__*/ (0, $50JbI.css)({
            animation: "".concat($72284f2bcce33c5d$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $72284f2bcce33c5d$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $f308b666a2f706a5$export$2e2bcd8739ae039)(_ref7, $72284f2bcce33c5d$var$_excluded2);
    return (0, $50JbI.jsx)("div", (0, $if2ZQ.default)({}, $72284f2bcce33c5d$var$getStyleProps((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $50JbI.jsx)($72284f2bcce33c5d$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $50JbI.jsx)($72284f2bcce33c5d$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $50JbI.jsx)($72284f2bcce33c5d$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $72284f2bcce33c5d$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $72284f2bcce33c5d$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $50JbI.jsx)("div", (0, $if2ZQ.default)({
        ref: innerRef
    }, $72284f2bcce33c5d$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $72284f2bcce33c5d$var$Control$1 = $72284f2bcce33c5d$var$Control;
var $72284f2bcce33c5d$var$_excluded$1 = [
    "data"
];
var $72284f2bcce33c5d$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $72284f2bcce33c5d$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $50JbI.jsx)("div", (0, $if2ZQ.default)({}, $72284f2bcce33c5d$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $50JbI.jsx)(Heading, (0, $if2ZQ.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $50JbI.jsx)("div", null, children));
};
var $72284f2bcce33c5d$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $72284f2bcce33c5d$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $72284f2bcce33c5d$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $f308b666a2f706a5$export$2e2bcd8739ae039)(_cleanCommonProps, $72284f2bcce33c5d$var$_excluded$1);
    return (0, $50JbI.jsx)("div", (0, $if2ZQ.default)({}, $72284f2bcce33c5d$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $72284f2bcce33c5d$var$Group$1 = $72284f2bcce33c5d$var$Group;
var $72284f2bcce33c5d$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $72284f2bcce33c5d$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $72284f2bcce33c5d$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $72284f2bcce33c5d$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $72284f2bcce33c5d$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $72284f2bcce33c5d$var$spacingStyle)
};
var $72284f2bcce33c5d$var$inputStyle = function inputStyle(isHidden) {
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $72284f2bcce33c5d$var$spacingStyle);
};
var $72284f2bcce33c5d$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $72284f2bcce33c5d$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $f308b666a2f706a5$export$2e2bcd8739ae039)(_cleanCommonProps, $72284f2bcce33c5d$var$_excluded);
    return (0, $50JbI.jsx)("div", (0, $if2ZQ.default)({}, $72284f2bcce33c5d$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $50JbI.jsx)("input", (0, $if2ZQ.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $72284f2bcce33c5d$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $72284f2bcce33c5d$var$Input$1 = $72284f2bcce33c5d$var$Input;
var $72284f2bcce33c5d$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $72284f2bcce33c5d$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $72284f2bcce33c5d$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $72284f2bcce33c5d$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $50JbI.jsx)("div", innerProps, children);
};
var $72284f2bcce33c5d$var$MultiValueContainer = $72284f2bcce33c5d$var$MultiValueGeneric;
var $72284f2bcce33c5d$var$MultiValueLabel = $72284f2bcce33c5d$var$MultiValueGeneric;
function $72284f2bcce33c5d$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $50JbI.jsx)("div", (0, $if2ZQ.default)({
        role: "button"
    }, innerProps), children || (0, $50JbI.jsx)($72284f2bcce33c5d$var$CrossIcon, {
        size: 14
    }));
}
var $72284f2bcce33c5d$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $50JbI.jsx)(Container, {
        data: data,
        innerProps: (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, $72284f2bcce33c5d$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $50JbI.jsx)(Label, {
        data: data,
        innerProps: (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, $72284f2bcce33c5d$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $50JbI.jsx)(Remove, {
        data: data,
        innerProps: (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, $72284f2bcce33c5d$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $72284f2bcce33c5d$var$MultiValue$1 = $72284f2bcce33c5d$var$MultiValue;
var $72284f2bcce33c5d$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $72284f2bcce33c5d$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $50JbI.jsx)("div", (0, $if2ZQ.default)({}, $72284f2bcce33c5d$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $72284f2bcce33c5d$var$Option$1 = $72284f2bcce33c5d$var$Option;
var $72284f2bcce33c5d$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $72284f2bcce33c5d$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $50JbI.jsx)("div", (0, $if2ZQ.default)({}, $72284f2bcce33c5d$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $72284f2bcce33c5d$var$Placeholder$1 = $72284f2bcce33c5d$var$Placeholder;
var $72284f2bcce33c5d$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $72284f2bcce33c5d$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $50JbI.jsx)("div", (0, $if2ZQ.default)({}, $72284f2bcce33c5d$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $72284f2bcce33c5d$var$SingleValue$1 = $72284f2bcce33c5d$var$SingleValue;
var $72284f2bcce33c5d$export$db3b6bfb95261072 = {
    ClearIndicator: $72284f2bcce33c5d$var$ClearIndicator,
    Control: $72284f2bcce33c5d$var$Control$1,
    DropdownIndicator: $72284f2bcce33c5d$var$DropdownIndicator,
    DownChevron: $72284f2bcce33c5d$var$DownChevron,
    CrossIcon: $72284f2bcce33c5d$var$CrossIcon,
    Group: $72284f2bcce33c5d$var$Group$1,
    GroupHeading: $72284f2bcce33c5d$var$GroupHeading,
    IndicatorsContainer: $72284f2bcce33c5d$var$IndicatorsContainer,
    IndicatorSeparator: $72284f2bcce33c5d$var$IndicatorSeparator,
    Input: $72284f2bcce33c5d$var$Input$1,
    LoadingIndicator: $72284f2bcce33c5d$var$LoadingIndicator,
    Menu: $72284f2bcce33c5d$var$Menu$1,
    MenuList: $72284f2bcce33c5d$var$MenuList,
    MenuPortal: $72284f2bcce33c5d$var$MenuPortal,
    LoadingMessage: $72284f2bcce33c5d$var$LoadingMessage,
    NoOptionsMessage: $72284f2bcce33c5d$var$NoOptionsMessage,
    MultiValue: $72284f2bcce33c5d$var$MultiValue$1,
    MultiValueContainer: $72284f2bcce33c5d$var$MultiValueContainer,
    MultiValueLabel: $72284f2bcce33c5d$var$MultiValueLabel,
    MultiValueRemove: $72284f2bcce33c5d$var$MultiValueRemove,
    Option: $72284f2bcce33c5d$var$Option$1,
    Placeholder: $72284f2bcce33c5d$var$Placeholder$1,
    SelectContainer: $72284f2bcce33c5d$var$SelectContainer,
    SingleValue: $72284f2bcce33c5d$var$SingleValue$1,
    ValueContainer: $72284f2bcce33c5d$var$ValueContainer
};
var $72284f2bcce33c5d$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, $72284f2bcce33c5d$export$db3b6bfb95261072), props.components);
};



var $50JbI = parcelRequire("50JbI");
var $9cd2825578c66be2$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $9cd2825578c66be2$var$isEqual(first, second) {
    if (first === second) return true;
    if ($9cd2825578c66be2$var$safeIsNaN(first) && $9cd2825578c66be2$var$safeIsNaN(second)) return true;
    return false;
}
function $9cd2825578c66be2$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$9cd2825578c66be2$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $9cd2825578c66be2$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $9cd2825578c66be2$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $fce97aec83003ffd$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $fce97aec83003ffd$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $fce97aec83003ffd$var$A11yText = function A11yText(props) {
    return (0, $50JbI.jsx)("span", (0, $if2ZQ.default)({
        css: $fce97aec83003ffd$var$_ref
    }, props));
};
var $fce97aec83003ffd$var$A11yText$1 = $fce97aec83003ffd$var$A11yText;
var $fce97aec83003ffd$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $fce97aec83003ffd$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $gRqVZ.useMemo)(function() {
        return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, $fce97aec83003ffd$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $gRqVZ.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $gRqVZ.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $gRqVZ.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, $gRqVZ.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $50JbI.jsx)((0, $gRqVZ.Fragment), null, (0, $50JbI.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $50JbI.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $50JbI.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, $50JbI.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $50JbI.jsx)((0, $gRqVZ.Fragment), null, (0, $50JbI.jsx)($fce97aec83003ffd$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $50JbI.jsx)($fce97aec83003ffd$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $fce97aec83003ffd$var$LiveRegion$1 = $fce97aec83003ffd$var$LiveRegion;
var $fce97aec83003ffd$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $fce97aec83003ffd$var$anyDiacritic = new RegExp('[' + $fce97aec83003ffd$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $fce97aec83003ffd$var$diacriticToBase = {};
for(var $fce97aec83003ffd$var$i = 0; $fce97aec83003ffd$var$i < $fce97aec83003ffd$var$diacritics.length; $fce97aec83003ffd$var$i++){
    var $fce97aec83003ffd$var$diacritic = $fce97aec83003ffd$var$diacritics[$fce97aec83003ffd$var$i];
    for(var $fce97aec83003ffd$var$j = 0; $fce97aec83003ffd$var$j < $fce97aec83003ffd$var$diacritic.letters.length; $fce97aec83003ffd$var$j++)$fce97aec83003ffd$var$diacriticToBase[$fce97aec83003ffd$var$diacritic.letters[$fce97aec83003ffd$var$j]] = $fce97aec83003ffd$var$diacritic.base;
}
var $fce97aec83003ffd$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($fce97aec83003ffd$var$anyDiacritic, function(match) {
        return $fce97aec83003ffd$var$diacriticToBase[match];
    });
};
var $fce97aec83003ffd$var$memoizedStripDiacriticsForInput = (0, $9cd2825578c66be2$export$2e2bcd8739ae039)($fce97aec83003ffd$var$stripDiacritics);
var $fce97aec83003ffd$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $fce97aec83003ffd$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $fce97aec83003ffd$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $fce97aec83003ffd$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $fce97aec83003ffd$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $fce97aec83003ffd$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $fce97aec83003ffd$var$memoizedStripDiacriticsForInput(input);
            candidate = $fce97aec83003ffd$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $fce97aec83003ffd$var$_excluded = [
    "innerRef"
];
function $fce97aec83003ffd$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $f308b666a2f706a5$export$2e2bcd8739ae039)(_ref, $fce97aec83003ffd$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $72284f2bcce33c5d$export$43caf9889c228507)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $50JbI.jsx)("input", (0, $if2ZQ.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $50JbI.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $fce97aec83003ffd$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $fce97aec83003ffd$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $gRqVZ.useRef)(false);
    var isTop = (0, $gRqVZ.useRef)(false);
    var touchStart = (0, $gRqVZ.useRef)(0);
    var scrollTarget = (0, $gRqVZ.useRef)(null);
    var handleEventDelta = (0, $gRqVZ.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $fce97aec83003ffd$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $gRqVZ.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $gRqVZ.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $gRqVZ.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $gRqVZ.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $72284f2bcce33c5d$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $gRqVZ.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $gRqVZ.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $fce97aec83003ffd$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $fce97aec83003ffd$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $fce97aec83003ffd$var$preventTouchMove(e) {
    if (e.cancelable) e.preventDefault();
}
function $fce97aec83003ffd$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $fce97aec83003ffd$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $fce97aec83003ffd$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $fce97aec83003ffd$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $fce97aec83003ffd$var$activeScrollLocks = 0;
var $fce97aec83003ffd$var$listenerOptions = {
    capture: false,
    passive: false
};
function $fce97aec83003ffd$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $gRqVZ.useRef)({});
    var scrollTarget = (0, $gRqVZ.useRef)(null);
    var addScrollLock = (0, $gRqVZ.useCallback)(function(touchScrollTarget) {
        if (!$fce97aec83003ffd$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $fce97aec83003ffd$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $fce97aec83003ffd$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($fce97aec83003ffd$var$LOCK_STYLES).forEach(function(key) {
                var val = $fce97aec83003ffd$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $fce97aec83003ffd$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $fce97aec83003ffd$var$preventTouchMove, $fce97aec83003ffd$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $fce97aec83003ffd$var$preventInertiaScroll, $fce97aec83003ffd$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $fce97aec83003ffd$var$allowTouchMove, $fce97aec83003ffd$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $fce97aec83003ffd$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $gRqVZ.useCallback)(function(touchScrollTarget) {
        if (!$fce97aec83003ffd$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $fce97aec83003ffd$var$activeScrollLocks = Math.max($fce97aec83003ffd$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $fce97aec83003ffd$var$activeScrollLocks < 1) $fce97aec83003ffd$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $fce97aec83003ffd$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $fce97aec83003ffd$var$preventTouchMove, $fce97aec83003ffd$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $fce97aec83003ffd$var$preventInertiaScroll, $fce97aec83003ffd$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $fce97aec83003ffd$var$allowTouchMove, $fce97aec83003ffd$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $gRqVZ.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $fce97aec83003ffd$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fce97aec83003ffd$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $fce97aec83003ffd$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $fce97aec83003ffd$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $fce97aec83003ffd$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $fce97aec83003ffd$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $50JbI.jsx)((0, $gRqVZ.Fragment), null, lockEnabled && (0, $50JbI.jsx)("div", {
        onClick: $fce97aec83003ffd$var$blurSelectInput,
        css: $fce97aec83003ffd$var$_ref2$1
    }), children(targetRef));
}
function $fce97aec83003ffd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fce97aec83003ffd$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $fce97aec83003ffd$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $50JbI.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $fce97aec83003ffd$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $fce97aec83003ffd$var$RequiredInput$1 = $fce97aec83003ffd$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $fce97aec83003ffd$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $fce97aec83003ffd$var$isIPhone() {
    return $fce97aec83003ffd$var$testPlatform(/^iPhone/i);
}
function $fce97aec83003ffd$var$isMac() {
    return $fce97aec83003ffd$var$testPlatform(/^Mac/i);
}
function $fce97aec83003ffd$var$isIPad() {
    return $fce97aec83003ffd$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $fce97aec83003ffd$var$isMac() && navigator.maxTouchPoints > 1;
}
function $fce97aec83003ffd$var$isIOS() {
    return $fce97aec83003ffd$var$isIPhone() || $fce97aec83003ffd$var$isIPad();
}
function $fce97aec83003ffd$var$isAppleDevice() {
    return $fce97aec83003ffd$var$isMac() || $fce97aec83003ffd$var$isIOS();
}
var $fce97aec83003ffd$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $fce97aec83003ffd$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $fce97aec83003ffd$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $fce97aec83003ffd$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $fce97aec83003ffd$var$defaultStyles = {
    clearIndicator: (0, $72284f2bcce33c5d$export$407448d2b89b1813),
    container: (0, $72284f2bcce33c5d$export$8b22cf2602fb60ce),
    control: (0, $72284f2bcce33c5d$export$4368d992c4eafac0),
    dropdownIndicator: (0, $72284f2bcce33c5d$export$f1e1789686576879),
    group: (0, $72284f2bcce33c5d$export$39b482c5e57630a8),
    groupHeading: (0, $72284f2bcce33c5d$export$2d1720544b23b823),
    indicatorsContainer: (0, $72284f2bcce33c5d$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $72284f2bcce33c5d$export$dda1d9f60106f0e9),
    input: (0, $72284f2bcce33c5d$export$35e795649ee09318),
    loadingIndicator: (0, $72284f2bcce33c5d$export$882b5998b3b9117c),
    loadingMessage: (0, $72284f2bcce33c5d$export$342063e11d6c3cad),
    menu: (0, $72284f2bcce33c5d$export$953cecd6e717a553),
    menuList: (0, $72284f2bcce33c5d$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $72284f2bcce33c5d$export$ae1af26003f05816),
    multiValue: (0, $72284f2bcce33c5d$export$ffb5f4729a158638),
    multiValueLabel: (0, $72284f2bcce33c5d$export$9e5f44173e64f162),
    multiValueRemove: (0, $72284f2bcce33c5d$export$625550452a3fa3ec),
    noOptionsMessage: (0, $72284f2bcce33c5d$export$3b14a55fb2447963),
    option: (0, $72284f2bcce33c5d$export$90a7f3efeed30595),
    placeholder: (0, $72284f2bcce33c5d$export$efccba1c4a2ef57b),
    singleValue: (0, $72284f2bcce33c5d$export$d141bba7fdc215a3),
    valueContainer: (0, $72284f2bcce33c5d$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $fce97aec83003ffd$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $fce97aec83003ffd$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $fce97aec83003ffd$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $fce97aec83003ffd$var$baseUnit = 4;
// The minimum height of the control
var $fce97aec83003ffd$var$controlHeight = 38;
// The amount of space between the control and menu */
var $fce97aec83003ffd$var$menuGutter = $fce97aec83003ffd$var$baseUnit * 2;
var $fce97aec83003ffd$var$spacing = {
    baseUnit: $fce97aec83003ffd$var$baseUnit,
    controlHeight: $fce97aec83003ffd$var$controlHeight,
    menuGutter: $fce97aec83003ffd$var$menuGutter
};
var $fce97aec83003ffd$export$4368d992c4eafac0 = {
    borderRadius: $fce97aec83003ffd$var$borderRadius,
    colors: $fce97aec83003ffd$var$colors,
    spacing: $fce97aec83003ffd$var$spacing
};
var $fce97aec83003ffd$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $72284f2bcce33c5d$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $72284f2bcce33c5d$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $fce97aec83003ffd$export$db3b6bfb95261072(),
    formatGroupLabel: $fce97aec83003ffd$var$formatGroupLabel,
    getOptionLabel: $fce97aec83003ffd$export$8b22cf2602fb60ce,
    getOptionValue: $fce97aec83003ffd$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $fce97aec83003ffd$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $72284f2bcce33c5d$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $fce97aec83003ffd$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $fce97aec83003ffd$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $fce97aec83003ffd$var$_isOptionSelected(props, option, selectValue);
    var label = $fce97aec83003ffd$var$getOptionLabel(props, option);
    var value = $fce97aec83003ffd$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $fce97aec83003ffd$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $fce97aec83003ffd$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $fce97aec83003ffd$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $fce97aec83003ffd$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $fce97aec83003ffd$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $72284f2bcce33c5d$export$3466f893ebf79586));
}
function $fce97aec83003ffd$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fbac2d7879866840$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $fce97aec83003ffd$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fbac2d7879866840$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $fce97aec83003ffd$var$buildFocusableOptions(props, selectValue) {
    return $fce97aec83003ffd$var$buildFocusableOptionsFromCategorizedOptions($fce97aec83003ffd$var$buildCategorizedOptions(props, selectValue));
}
function $fce97aec83003ffd$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$fce97aec83003ffd$var$shouldHideSelectedOptions(props) || !isSelected) && $fce97aec83003ffd$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $fce97aec83003ffd$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $fce97aec83003ffd$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $fce97aec83003ffd$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $fce97aec83003ffd$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $fce97aec83003ffd$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $fce97aec83003ffd$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $fce97aec83003ffd$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $fce97aec83003ffd$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $fce97aec83003ffd$var$getOptionValue(props, i) === candidate;
    });
}
function $fce97aec83003ffd$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $fce97aec83003ffd$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $fce97aec83003ffd$var$instanceId = 1;
var $fce97aec83003ffd$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: '',
            isAppleDevice: false
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $72284f2bcce33c5d$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $72284f2bcce33c5d$export$ef35774e6d314e91)([].concat((0, $fbac2d7879866840$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $72284f2bcce33c5d$export$e7094788287c5e9b)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $72284f2bcce33c5d$export$e7094788287c5e9b)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $72284f2bcce33c5d$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $72284f2bcce33c5d$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $72284f2bcce33c5d$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $fce97aec83003ffd$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $fce97aec83003ffd$var$buildFocusableOptionsWithIds($fce97aec83003ffd$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $72284f2bcce33c5d$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $fce97aec83003ffd$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $fce97aec83003ffd$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $fce97aec83003ffd$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $72284f2bcce33c5d$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $fce97aec83003ffd$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $fce97aec83003ffd$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $72284f2bcce33c5d$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $fce97aec83003ffd$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$fce97aec83003ffd$var$instanceId);
        _this.state.selectValue = (0, $72284f2bcce33c5d$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $fce97aec83003ffd$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $72284f2bcce33c5d$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                if ($fce97aec83003ffd$var$isAppleDevice()) // eslint-disable-next-line react/no-did-mount-set-state
                this.setState({
                    isAppleDevice: true
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $72284f2bcce33c5d$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $fce97aec83003ffd$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($fce97aec83003ffd$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, $fce97aec83003ffd$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $fce97aec83003ffd$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $fce97aec83003ffd$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $fce97aec83003ffd$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.state.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $gRqVZ.createElement($fce97aec83003ffd$var$DummyInput, (0, $if2ZQ.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $72284f2bcce33c5d$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $gRqVZ.createElement(Input, (0, $if2ZQ.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $gRqVZ.createElement(Placeholder, (0, $if2ZQ.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $gRqVZ.createElement(MultiValue, (0, $if2ZQ.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $gRqVZ.createElement(SingleValue, (0, $if2ZQ.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $gRqVZ.createElement(ClearIndicator, (0, $if2ZQ.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $gRqVZ.createElement(LoadingIndicator, (0, $if2ZQ.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $gRqVZ.createElement(IndicatorSeparator, (0, $if2ZQ.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $gRqVZ.createElement(DropdownIndicator, (0, $if2ZQ.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.state.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $gRqVZ.createElement(Option, (0, $if2ZQ.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $gRqVZ.createElement(Group, (0, $if2ZQ.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $gRqVZ.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $gRqVZ.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $gRqVZ.createElement((0, $72284f2bcce33c5d$export$3a1a48c8f6ef640e), (0, $if2ZQ.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $gRqVZ.createElement(Menu, (0, $if2ZQ.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $gRqVZ.createElement($fce97aec83003ffd$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $gRqVZ.createElement(MenuList, (0, $if2ZQ.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $gRqVZ.createElement(MenuPortal, (0, $if2ZQ.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $gRqVZ.createElement($fce97aec83003ffd$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $gRqVZ.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $gRqVZ.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $gRqVZ.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $gRqVZ.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $gRqVZ.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $gRqVZ.createElement($fce97aec83003ffd$var$LiveRegion$1, (0, $if2ZQ.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.state.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $gRqVZ.createElement(SelectContainer, (0, $if2ZQ.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $gRqVZ.createElement(Control, (0, $if2ZQ.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $gRqVZ.createElement(ValueContainer, (0, $if2ZQ.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $gRqVZ.createElement(IndicatorsContainer, (0, $if2ZQ.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $72284f2bcce33c5d$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $fce97aec83003ffd$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $fce97aec83003ffd$var$buildFocusableOptionsWithIds($fce97aec83003ffd$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $fce97aec83003ffd$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $fce97aec83003ffd$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $fce97aec83003ffd$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $72284f2bcce33c5d$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $gRqVZ.Component));
$fce97aec83003ffd$export$25ce5a424b770e84.defaultProps = $fce97aec83003ffd$export$407448d2b89b1813;



var $8DRs0 = parcelRequire("8DRs0");

var $fohPQ = parcelRequire("fohPQ");

var $a1ae55611ef4d787$exports = {};

function $a1ae55611ef4d787$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a1ae55611ef4d787$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a1ae55611ef4d787$var$ownKeys(Object(t), !0).forEach(function(r) {
            $519c95b753b7732e$exports(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a1ae55611ef4d787$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
$a1ae55611ef4d787$exports = $a1ae55611ef4d787$var$_objectSpread2, $a1ae55611ef4d787$exports.__esModule = true, $a1ae55611ef4d787$exports["default"] = $a1ae55611ef4d787$exports;


var $ddda6f3d5abaa4b5$exports = {};
var $22a9fe2bb4bdb66e$exports = {};
function $22a9fe2bb4bdb66e$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$22a9fe2bb4bdb66e$exports = $22a9fe2bb4bdb66e$var$_arrayWithHoles, $22a9fe2bb4bdb66e$exports.__esModule = true, $22a9fe2bb4bdb66e$exports["default"] = $22a9fe2bb4bdb66e$exports;


var $4c4d01e2d55a4609$exports = {};
function $4c4d01e2d55a4609$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$4c4d01e2d55a4609$exports = $4c4d01e2d55a4609$var$_iterableToArrayLimit, $4c4d01e2d55a4609$exports.__esModule = true, $4c4d01e2d55a4609$exports["default"] = $4c4d01e2d55a4609$exports;


var $c0a9d2a855b6c614$exports = {};
var $235fef6fdbce0415$exports = {};
function $235fef6fdbce0415$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$235fef6fdbce0415$exports = $235fef6fdbce0415$var$_arrayLikeToArray, $235fef6fdbce0415$exports.__esModule = true, $235fef6fdbce0415$exports["default"] = $235fef6fdbce0415$exports;


function $c0a9d2a855b6c614$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $235fef6fdbce0415$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $235fef6fdbce0415$exports(r, a) : void 0;
    }
}
$c0a9d2a855b6c614$exports = $c0a9d2a855b6c614$var$_unsupportedIterableToArray, $c0a9d2a855b6c614$exports.__esModule = true, $c0a9d2a855b6c614$exports["default"] = $c0a9d2a855b6c614$exports;


var $5fbc5a6a99b9ea27$exports = {};
function $5fbc5a6a99b9ea27$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$5fbc5a6a99b9ea27$exports = $5fbc5a6a99b9ea27$var$_nonIterableRest, $5fbc5a6a99b9ea27$exports.__esModule = true, $5fbc5a6a99b9ea27$exports["default"] = $5fbc5a6a99b9ea27$exports;


function $ddda6f3d5abaa4b5$var$_slicedToArray(r, e) {
    return $22a9fe2bb4bdb66e$exports(r) || $4c4d01e2d55a4609$exports(r, e) || $c0a9d2a855b6c614$exports(r, e) || $5fbc5a6a99b9ea27$exports();
}
$ddda6f3d5abaa4b5$exports = $ddda6f3d5abaa4b5$var$_slicedToArray, $ddda6f3d5abaa4b5$exports.__esModule = true, $ddda6f3d5abaa4b5$exports["default"] = $ddda6f3d5abaa4b5$exports;



var $38ced2af12da97ab$exports = {};
function $38ced2af12da97ab$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$38ced2af12da97ab$exports = $38ced2af12da97ab$var$_classCallCheck, $38ced2af12da97ab$exports.__esModule = true, $38ced2af12da97ab$exports["default"] = $38ced2af12da97ab$exports;


var $adc0436b282f43b9$exports = {};

function $adc0436b282f43b9$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $72d1c9fd8dbb0ad6$exports(o.key), o);
    }
}
function $adc0436b282f43b9$var$_createClass(e, r, t) {
    return r && $adc0436b282f43b9$var$_defineProperties(e.prototype, r), t && $adc0436b282f43b9$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$adc0436b282f43b9$exports = $adc0436b282f43b9$var$_createClass, $adc0436b282f43b9$exports.__esModule = true, $adc0436b282f43b9$exports["default"] = $adc0436b282f43b9$exports;


var $9145e91010ba83ba$exports = {};
var $4e93ee3dda0a3d9b$exports = {};
function $4e93ee3dda0a3d9b$var$_setPrototypeOf(t, e) {
    return $4e93ee3dda0a3d9b$exports = $4e93ee3dda0a3d9b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $4e93ee3dda0a3d9b$exports.__esModule = true, $4e93ee3dda0a3d9b$exports["default"] = $4e93ee3dda0a3d9b$exports, $4e93ee3dda0a3d9b$var$_setPrototypeOf(t, e);
}
$4e93ee3dda0a3d9b$exports = $4e93ee3dda0a3d9b$var$_setPrototypeOf, $4e93ee3dda0a3d9b$exports.__esModule = true, $4e93ee3dda0a3d9b$exports["default"] = $4e93ee3dda0a3d9b$exports;


function $9145e91010ba83ba$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $4e93ee3dda0a3d9b$exports(t, e);
}
$9145e91010ba83ba$exports = $9145e91010ba83ba$var$_inherits, $9145e91010ba83ba$exports.__esModule = true, $9145e91010ba83ba$exports["default"] = $9145e91010ba83ba$exports;


var $fadfabf8a5dc2206$exports = {};
var $d05ca5f56e209a79$exports = {};
function $d05ca5f56e209a79$var$_getPrototypeOf(t) {
    return $d05ca5f56e209a79$exports = $d05ca5f56e209a79$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $d05ca5f56e209a79$exports.__esModule = true, $d05ca5f56e209a79$exports["default"] = $d05ca5f56e209a79$exports, $d05ca5f56e209a79$var$_getPrototypeOf(t);
}
$d05ca5f56e209a79$exports = $d05ca5f56e209a79$var$_getPrototypeOf, $d05ca5f56e209a79$exports.__esModule = true, $d05ca5f56e209a79$exports["default"] = $d05ca5f56e209a79$exports;


var $8b7bba6ab451d6aa$exports = {};
function $8b7bba6ab451d6aa$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8b7bba6ab451d6aa$exports = $8b7bba6ab451d6aa$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, $8b7bba6ab451d6aa$exports.__esModule = true, $8b7bba6ab451d6aa$exports["default"] = $8b7bba6ab451d6aa$exports)();
}
$8b7bba6ab451d6aa$exports = $8b7bba6ab451d6aa$var$_isNativeReflectConstruct, $8b7bba6ab451d6aa$exports.__esModule = true, $8b7bba6ab451d6aa$exports["default"] = $8b7bba6ab451d6aa$exports;


var $0c677906238bab3d$exports = {};

var $0c677906238bab3d$var$_typeof = $ec8a9e886ebff8e0$exports.default;
var $9b22ed2f29ec6891$exports = {};
function $9b22ed2f29ec6891$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$9b22ed2f29ec6891$exports = $9b22ed2f29ec6891$var$_assertThisInitialized, $9b22ed2f29ec6891$exports.__esModule = true, $9b22ed2f29ec6891$exports["default"] = $9b22ed2f29ec6891$exports;


function $0c677906238bab3d$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $0c677906238bab3d$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $9b22ed2f29ec6891$exports(t);
}
$0c677906238bab3d$exports = $0c677906238bab3d$var$_possibleConstructorReturn, $0c677906238bab3d$exports.__esModule = true, $0c677906238bab3d$exports["default"] = $0c677906238bab3d$exports;


function $fadfabf8a5dc2206$var$_createSuper(t) {
    var r = $8b7bba6ab451d6aa$exports();
    return function() {
        var e, o = $d05ca5f56e209a79$exports(t);
        if (r) {
            var s = $d05ca5f56e209a79$exports(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $0c677906238bab3d$exports(this, e);
    };
}
$fadfabf8a5dc2206$exports = $fadfabf8a5dc2206$var$_createSuper, $fadfabf8a5dc2206$exports.__esModule = true, $fadfabf8a5dc2206$exports["default"] = $fadfabf8a5dc2206$exports;


var $1129e4293e9b6664$exports = {};
var $b154f955ae90a375$exports = {};

function $b154f955ae90a375$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $235fef6fdbce0415$exports(r);
}
$b154f955ae90a375$exports = $b154f955ae90a375$var$_arrayWithoutHoles, $b154f955ae90a375$exports.__esModule = true, $b154f955ae90a375$exports["default"] = $b154f955ae90a375$exports;


var $e43b30dbe441f6a4$exports = {};
function $e43b30dbe441f6a4$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
$e43b30dbe441f6a4$exports = $e43b30dbe441f6a4$var$_iterableToArray, $e43b30dbe441f6a4$exports.__esModule = true, $e43b30dbe441f6a4$exports["default"] = $e43b30dbe441f6a4$exports;



var $20be38abae978379$exports = {};
function $20be38abae978379$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$20be38abae978379$exports = $20be38abae978379$var$_nonIterableSpread, $20be38abae978379$exports.__esModule = true, $20be38abae978379$exports["default"] = $20be38abae978379$exports;


function $1129e4293e9b6664$var$_toConsumableArray(r) {
    return $b154f955ae90a375$exports(r) || $e43b30dbe441f6a4$exports(r) || $c0a9d2a855b6c614$exports(r) || $20be38abae978379$exports();
}
$1129e4293e9b6664$exports = $1129e4293e9b6664$var$_toConsumableArray, $1129e4293e9b6664$exports.__esModule = true, $1129e4293e9b6664$exports["default"] = $1129e4293e9b6664$exports;




var $dc009cc82016762c$exports = {};
function $dc009cc82016762c$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
$dc009cc82016762c$exports = $dc009cc82016762c$var$_taggedTemplateLiteral, $dc009cc82016762c$exports.__esModule = true, $dc009cc82016762c$exports["default"] = $dc009cc82016762c$exports;



parcelRequire("hYKvr");


var $5d837ac9ba9aa3e0$var$StateManagedSelect = /*#__PURE__*/ (0, $gRqVZ.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $acf234d9f794d66f$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $gRqVZ.createElement((0, $fce97aec83003ffd$export$25ce5a424b770e84), (0, $if2ZQ.default)({
        ref: ref
    }, baseSelectProps));
});
var $5d837ac9ba9aa3e0$export$2e2bcd8739ae039 = $5d837ac9ba9aa3e0$var$StateManagedSelect;
var $5d837ac9ba9aa3e0$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $gRqVZ.useMemo)(function() {
        return (0, $fohPQ.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $gRqVZ.createElement((0, $8DRs0.C), {
        value: emotionCache
    }, children);
};



var $if2ZQ = parcelRequire("if2ZQ");

var $gRqVZ = parcelRequire("gRqVZ");






var $gRqVZ = parcelRequire("gRqVZ");


var $1104ca5290a458cd$var$_excluded = [
    "allowCreateWhileLoading",
    "createOptionPosition",
    "formatCreateLabel",
    "isValidNewOption",
    "getNewOptionData",
    "onCreateOption",
    "options",
    "onChange"
];
var $1104ca5290a458cd$var$compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var accessors = arguments.length > 2 ? arguments[2] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var $1104ca5290a458cd$var$builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return "Create \"".concat(inputValue, "\"");
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
        return !(!inputValue || selectValue.some(function(option) {
            return $1104ca5290a458cd$var$compareOption(inputValue, option, accessors);
        }) || selectOptions.some(function(option) {
            return $1104ca5290a458cd$var$compareOption(inputValue, option, accessors);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
function $1104ca5290a458cd$export$3b14a55fb2447963(_ref) {
    var _ref$allowCreateWhile = _ref.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? 'last' : _ref$createOptionPosi, _ref$formatCreateLabe = _ref.formatCreateLabel, formatCreateLabel = _ref$formatCreateLabe === void 0 ? $1104ca5290a458cd$var$builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref.isValidNewOption, isValidNewOption = _ref$isValidNewOption === void 0 ? $1104ca5290a458cd$var$builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref.getNewOptionData, getNewOptionData = _ref$getNewOptionData === void 0 ? $1104ca5290a458cd$var$builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref.onCreateOption, _ref$options = _ref.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref.onChange, restSelectProps = (0, $f308b666a2f706a5$export$2e2bcd8739ae039)(_ref, $1104ca5290a458cd$var$_excluded);
    var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1 = _restSelectProps$getO === void 0 ? (0, $fce97aec83003ffd$export$39b482c5e57630a8) : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? (0, $fce97aec83003ffd$export$8b22cf2602fb60ce) : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
    var newOption = (0, $gRqVZ.useMemo)(function() {
        return isValidNewOption(inputValue, (0, $72284f2bcce33c5d$export$7f8ddf7c7c20b3cd)(value), propsOptions, {
            getOptionValue: getOptionValue$1,
            getOptionLabel: getOptionLabel$1
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
    }, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel$1,
        getOptionValue$1,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    var options = (0, $gRqVZ.useMemo)(function() {
        return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption
        ].concat((0, $fbac2d7879866840$export$2e2bcd8739ae039)(propsOptions)) : [].concat((0, $fbac2d7879866840$export$2e2bcd8739ae039)(propsOptions), [
            newOption
        ]) : propsOptions;
    }, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    var onChange = (0, $gRqVZ.useCallback)(function(newValue, actionMeta) {
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        var valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                var newOptionData = getNewOptionData(inputValue, inputValue);
                var newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $72284f2bcce33c5d$export$96f57966bedc81b4)(isMulti, [].concat((0, $fbac2d7879866840$export$2e2bcd8739ae039)((0, $72284f2bcce33c5d$export$7f8ddf7c7c20b3cd)(value)), [
                    newOptionData
                ]), newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        options: options,
        onChange: onChange
    });
}















parcelRequire("hYKvr");



var $512edffc7cf24172$var$CreatableSelect = /*#__PURE__*/ (0, $gRqVZ.forwardRef)(function(props, ref) {
    var creatableProps = (0, $acf234d9f794d66f$export$3b14a55fb2447963)(props);
    var selectProps = (0, $1104ca5290a458cd$export$3b14a55fb2447963)(creatableProps);
    return /*#__PURE__*/ $gRqVZ.createElement((0, $fce97aec83003ffd$export$25ce5a424b770e84), (0, $if2ZQ.default)({
        ref: ref
    }, selectProps));
});
var $512edffc7cf24172$export$2e2bcd8739ae039 = $512edffc7cf24172$var$CreatableSelect;


var $13ac1a6b716cd701$export$3c33887335500a87;
$13ac1a6b716cd701$export$3c33887335500a87 = `kDxiYG_quill`;



var $jIrNf = parcelRequire("jIrNf");


var $489wz = parcelRequire("489wz");
const $2519c42fed6cedee$export$b01f3642f3f3388c = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $489wz.Field))`
	width: ${(props)=>props.type === 'checkbox' ? '14px' : '100%'};
	margin-right: 5px;
	padding: 0.75rem 1rem;
	background: #fff;
	border: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	box-shadow: none;
	border-radius: 3px;
	&:focus {
		outline: none;
	}
	&:disabled {
		background: #eee;
	}
`;
const $2519c42fed6cedee$export$4e4cd7174ee09603 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	margin-top: 5px;
	input {
		display: none;
	}
	label {
		padding: 0.5rem 0.75rem;
		background: #fff;
		border: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
		box-shadow: none;
		border-radius: 3px;
		font-size: 14px;
		&:hover {
			cursor: pointer;
			background-color: ${({ theme: theme })=>theme.colors.lightGray};
		}
		&:focus {
			outline: none;
		}
		&:disabled {
			background: #eee;
		}
	}
`;
const $2519c42fed6cedee$export$a4654c742baf9825 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	width: 90%;
	padding-top: 20px;
	/* terrible */
	&.third {
		width: 30%;
		display: inline-block;
	}
	&.twothird {
		width: 60%;
		display: inline-block;
	}
	&.quarter {
		width: 22.5%;
		display: inline-block;
	}
	&.half {
		width: 45%;
		display: inline-block;
	}
`;
const $2519c42fed6cedee$export$b4ed99042fe5b08e = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $489wz.Field))`
	appearance: none;
	background-color: ${({ theme: theme })=>theme.colors.white};
	border: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	border-radius: 3px;
	height: 20px;
	width: 20px;
	margin-right: 5px;
	&:checked {
		background-color: ${({ theme: theme })=>theme.colors.white};
		font-size: 14px;
		&::after {
			content: '✔';
			/* TODO: figure out why this primary color isn't applying to the content checkmark */
			color: ${({ theme: theme })=>theme.colors.primary};
			font-size: 10px;
			margin-left: 2px;
			line-height: 20px;
			transition: background-color 0.5s ease-in-out;
		}
	}
`;
const $2519c42fed6cedee$export$d19e81f14a73d84c = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	justify-content: space-between;
	& span {
		padding: 0px 10px;
		align-self: center;
	}
`;
const $2519c42fed6cedee$export$b532c2c5ca69a972 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	padding-top: 20px;
	border-top: ${(props)=>!props.$hideBorderTop && `1px solid ${props.theme.colors.borderGray}`};
	margin-top: 30px;
`;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");


const $32c3454e141c39d9$var$BaseButton = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).button`
	font-size: 20px;
	width: 100%;
	margin: 0;
	padding: 8px 0;
	border: none;
	color: #fff;
	cursor: pointer;
	&[disabled] {
		cursor: not-allowed;
		opacity: 0.5;
	}
`;
const $32c3454e141c39d9$var$PrimaryButton = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)($32c3454e141c39d9$var$BaseButton)`
	background-color: ${(props)=>props.theme.colors.primary};
	width: ${(props)=>props.$autoWidth ? 'auto' : '200px'};
	&:hover {
		background-color: ${(props)=>props.theme.colors.primaryDark};
	}
`;
const $32c3454e141c39d9$var$SecondaryButton = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)($32c3454e141c39d9$var$BaseButton)`
	background-color: ${(props)=>props.theme.colors.primary};
	font-size: 1rem;
	border-radius: 3px;
	padding: 10px 30px;
	width: ${(props)=>props.$autoWidth ? 'auto' : '200px'};
	&:hover {
		background-color: ${(props)=>props.theme.colors.primaryDark};
	}
`;
const $32c3454e141c39d9$var$TertiaryButton = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)($32c3454e141c39d9$var$BaseButton)`
	font-size: 1rem;
	border-radius: 3px;
	padding: 10px 30px;
	width: ${(props)=>props.$autoWidth ? 'auto' : '100px'};
	color: ${(props)=>props.theme.colors.primary};
	background: none;
`;
const $32c3454e141c39d9$var$OutlineButton = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)($32c3454e141c39d9$var$BaseButton)`
	background-color: white;
	color: #8e8e8e;
	font-size: 1rem;
	border-radius: 3px;
	padding: 10px 30px;
	width: ${(props)=>props.$autoWidth ? 'auto' : '200px'};
	border: 1px solid #e7e7e7;
	&:hover {
		background-color: ${(props)=>props.theme.colors.lightGray};
	}
`;
const $32c3454e141c39d9$var$ButtonModeMap = {
    primary: $32c3454e141c39d9$var$PrimaryButton,
    secondary: $32c3454e141c39d9$var$SecondaryButton,
    tertiary: $32c3454e141c39d9$var$TertiaryButton,
    outline: $32c3454e141c39d9$var$OutlineButton
};
function $32c3454e141c39d9$var$Button({ loading: loading, children: children, mode: mode = 'primary', ...props }) {
    const DynamicButton = $32c3454e141c39d9$var$ButtonModeMap[mode];
    return /*#__PURE__*/ (0, $01ysi.jsx)(DynamicButton, {
        ...props,
        children: loading ? /*#__PURE__*/ (0, $01ysi.jsx)((0, $a5fc2fd641867f25$export$2e2bcd8739ae039), {
            size: "xsm",
            type: "secondary"
        }) : children
    });
}
var $32c3454e141c39d9$export$2e2bcd8739ae039 = $32c3454e141c39d9$var$Button;


const $241e7cea7cf41e5a$var$CheckboxFormLabel = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $837a9440f933970f$export$2e2bcd8739ae039))`
	display: flex;
	align-items: center;
`;
const $241e7cea7cf41e5a$var$PaperclipIcon = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $bcfb7547ad2702cf$export$83b4e98970744671))`
	width: 20px;
	height: 20px;
	margin-right: 10px;
`;
const $241e7cea7cf41e5a$var$FlexContainer = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	align-items: center;
	label {
		margin-right: 10px;
	}
`;
const $241e7cea7cf41e5a$var$MAX_OUTPUT_DIMENSION = 2400;
function $241e7cea7cf41e5a$var$getCroppedImg(image, crop) {
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const fullWidth = crop.width * scaleX;
    const fullHeight = crop.height * scaleY;
    const capScale = Math.min(1, $241e7cea7cf41e5a$var$MAX_OUTPUT_DIMENSION / Math.max(fullWidth, fullHeight));
    canvas.width = Math.round(fullWidth * capScale);
    canvas.height = Math.round(fullHeight * capScale);
    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, canvas.width, canvas.height);
    return new Promise((resolve)=>{
        canvas.toBlob((blob)=>{
            resolve(blob);
        }, 'image/jpeg', 0.9);
    });
}
// TODO: fix these prop types
function $241e7cea7cf41e5a$var$FormField(props) {
    const aspect = props.image?.aspect;
    const imgRef = (0, $gRqVZ.useRef)(null);
    const [crop, setCrop] = (0, $gRqVZ.useState)(undefined);
    const { setFieldValue: setFieldValue, values: values, isSubmitting: isSubmitting } = (0, $489wz.useFormikContext)();
    const navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    const [fileUploadId] = (0, $gRqVZ.useState)('fileUpload-' + Math.random().toString(36).replace(/[^a-z]+/g, ''));
    if (props.type === 'checkbox') return /*#__PURE__*/ (0, $01ysi.jsx)((0, $2519c42fed6cedee$export$a4654c742baf9825), {
        className: props.className,
        children: /*#__PURE__*/ (0, $01ysi.jsxs)($241e7cea7cf41e5a$var$CheckboxFormLabel, {
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $2519c42fed6cedee$export$b4ed99042fe5b08e), {
                    ...props
                }),
                props.label
            ]
        })
    });
    if (props.type === 'richText') return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2519c42fed6cedee$export$a4654c742baf9825), {
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $837a9440f933970f$export$2e2bcd8739ae039), {
                children: props.label
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $26d46b50bce0f876$export$b3ef8585d8cbf390), {
                className: $13ac1a6b716cd701$export$3c33887335500a87,
                style: {
                    backgroundColor: 'white'
                },
                value: props.value,
                onChange: props.onChange,
                placeholder: props.placeholder
            })
        ]
    });
    if (props.type === 'select2') return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2519c42fed6cedee$export$a4654c742baf9825), {
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $837a9440f933970f$export$2e2bcd8739ae039), {
                children: props.label
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $5d837ac9ba9aa3e0$export$2e2bcd8739ae039), {
                options: props.options,
                onChange: (value)=>{
                    if (props.onChange) props.onChange(value);
                    setFieldValue(props.name, value);
                },
                value: (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).get(values, props.name),
                isMulti: props.isMulti,
                formatOptionLabel: props.formatOptionLabel,
                isClearable: props.$isClearable
            })
        ]
    });
    if (props.type === 'select2-create') return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2519c42fed6cedee$export$a4654c742baf9825), {
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $837a9440f933970f$export$2e2bcd8739ae039), {
                children: props.label
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $512edffc7cf24172$export$2e2bcd8739ae039), {
                options: props.options,
                placeholder: props.placeholder,
                onChange: (value)=>{
                    if (props.onChange) props.onChange(value);
                    setFieldValue(props.name, value);
                },
                isClearable: true,
                formatOptionLabel: props.formatOptionLabel,
                formatCreateLabel: props.formatCreateLabel
            })
        ]
    });
    if (props.type === 'select') return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2519c42fed6cedee$export$a4654c742baf9825), {
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $837a9440f933970f$export$2e2bcd8739ae039), {
                children: props.label
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $2519c42fed6cedee$export$b01f3642f3f3388c), {
                forwardedAs: "select",
                ...props,
                children: props.options.map((option)=>/*#__PURE__*/ (0, $01ysi.jsx)("option", {
                        value: option.value,
                        children: option.label
                    }, option.value))
            })
        ]
    });
    if (props.type === 'file') return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2519c42fed6cedee$export$a4654c742baf9825), {
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $837a9440f933970f$export$2e2bcd8739ae039), {
                children: props.label
            }),
            props.image && (values[props.name] ? /*#__PURE__*/ (0, $01ysi.jsx)((0, $a3bf69d734984e1c$export$16fa2f45be04daa8), {
                crop: crop,
                aspect: aspect,
                onChange: (newCrop)=>setCrop(newCrop),
                onComplete: async (crop)=>{
                    const blob = await $241e7cea7cf41e5a$var$getCroppedImg(imgRef.current, crop);
                    const { file: file, url: url } = values[props.name];
                    if (blob) blob.name = file.name;
                    setFieldValue(props.name, {
                        file: blob,
                        url: url
                    });
                },
                children: /*#__PURE__*/ (0, $01ysi.jsx)("img", {
                    src: values[props.name].url,
                    ref: imgRef,
                    onLoad: (e)=>{
                        imgRef.current = e.currentTarget;
                        const { width: width, height: height } = e.currentTarget;
                        setCrop((0, $a3bf69d734984e1c$export$22e2caf9ef2c32c0)((0, $a3bf69d734984e1c$export$996fb65e57171b85)({
                            unit: '%',
                            width: 100
                        }, aspect, width, height), width, height));
                    }
                })
            }) : props.image.existing ? /*#__PURE__*/ (0, $01ysi.jsx)("img", {
                src: props.image.existing
            }) : null),
            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2519c42fed6cedee$export$4e4cd7174ee09603), {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsxs)($241e7cea7cf41e5a$var$FlexContainer, {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $837a9440f933970f$export$2e2bcd8739ae039), {
                                htmlFor: fileUploadId,
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)($241e7cea7cf41e5a$var$PaperclipIcon, {}),
                                    props.buttonLabel || 'Upload'
                                ]
                            }),
                            values[props.name] && !props.multiple && /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                                children: values[props.name].file.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)("input", {
                        id: fileUploadId,
                        type: "file",
                        multiple: props.multiple,
                        onChange: (e)=>{
                            if (props.onChange) return props.onChange(e);
                            const fieldValue = props.multiple ? {} : {
                                file: e.currentTarget.files[0],
                                url: URL.createObjectURL(e.currentTarget.files[0])
                            };
                            setCrop(undefined);
                            setFieldValue(props.name, fieldValue);
                        }
                    })
                ]
            })
        ]
    });
    if (props.type === 'timeDateGroup') {
        const { allDay: allDay } = values;
        return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2519c42fed6cedee$export$a4654c742baf9825), {
            className: props.className,
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $837a9440f933970f$export$2e2bcd8739ae039), {
                    children: props.label
                }),
                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2519c42fed6cedee$export$d19e81f14a73d84c), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $2519c42fed6cedee$export$b01f3642f3f3388c), {
                            name: "from.date",
                            type: "date",
                            placeholder: "Select Date"
                        }),
                        !allDay && /*#__PURE__*/ (0, $01ysi.jsx)((0, $2519c42fed6cedee$export$b01f3642f3f3388c), {
                            name: "from.time",
                            type: "time",
                            placeholder: "Select time"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                            children: "to"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $2519c42fed6cedee$export$b01f3642f3f3388c), {
                            name: "to.date",
                            type: "date",
                            placeholder: "Select Date"
                        }),
                        !allDay && /*#__PURE__*/ (0, $01ysi.jsx)((0, $2519c42fed6cedee$export$b01f3642f3f3388c), {
                            name: "to.time",
                            type: "time",
                            placeholder: "Select Time"
                        }),
                        ' '
                    ]
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)($241e7cea7cf41e5a$var$FormField, {
                    name: "allDay",
                    type: "checkbox",
                    label: "All day"
                })
            ]
        });
    }
    if (props.type === 'formButtons') {
        const onClick = typeof props.onCancel === 'string' ? ()=>navigate(props.onCancel) : props.onCancel || (()=>navigate('..'));
        return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2519c42fed6cedee$export$b532c2c5ca69a972), {
            $hideBorderTop: props.hideBorderTop,
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $32c3454e141c39d9$export$2e2bcd8739ae039), {
                    mode: "secondary",
                    type: "submit",
                    disabled: isSubmitting || props.isLoading || props.disabled,
                    loading: isSubmitting || props.isLoading,
                    $autoWidth: props.autoWidth,
                    children: props.submitLabel || 'Submit'
                }),
                !props.$hideCancel && /*#__PURE__*/ (0, $01ysi.jsx)((0, $32c3454e141c39d9$export$2e2bcd8739ae039), {
                    mode: "tertiary",
                    onClick: onClick,
                    disabled: isSubmitting,
                    children: "Cancel"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2519c42fed6cedee$export$a4654c742baf9825), {
        className: props.className,
        children: [
            props.label && /*#__PURE__*/ (0, $01ysi.jsx)((0, $837a9440f933970f$export$2e2bcd8739ae039), {
                children: props.label
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $2519c42fed6cedee$export$b01f3642f3f3388c), {
                ...props
            })
        ]
    });
}
const $241e7cea7cf41e5a$export$1ff3c3f08ae963c0 = (0, $2519c42fed6cedee$export$b532c2c5ca69a972);
var $241e7cea7cf41e5a$export$2e2bcd8739ae039 = $241e7cea7cf41e5a$var$FormField;



var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");


const $63e9a7af5676c306$export$cae179f078f4b4a4 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $f0e7a4a36037df80$export$78acf4525d8a74c4))`
	width: ${(props)=>props.size === 'small' ? '30px' : '45px'};
	height: ${(props)=>props.size === 'small' ? '30px' : '45px'};
	color: ${(props)=>props.theme.colors[props.color]};
	top: 0;
	right: 0;
	position: absolute;
	float: right;
	padding-top: 15px;
	padding-right: 15px;
	&:hover {
		cursor: pointer;
	}
`;
const $63e9a7af5676c306$var$getBackground = (showBackground, backgroundColor)=>{
    if (!showBackground) return null;
    return backgroundColor === 'light' ? `rgba(255, 255, 255, 0.8)` : `rgba(34, 34, 34, 0.97)`;
};
const $63e9a7af5676c306$export$547754aada6e339f = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	@keyframes fadein {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 10;
	box-shadow: inset 0px 8px 10px -10px rgb(0 0 0 / 50%);
	overflow: auto;
	background-color: ${(props)=>$63e9a7af5676c306$var$getBackground(props.$showBackground, props.$backgroundColor)};
	animation: fadein 0.3s ease;
	cursor: default;
`;
const $63e9a7af5676c306$var$ModalContents = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	background-color: white;
	padding: 2rem;
	position: relative;
	width: calc(100% - 40px);
	max-width: 700px;
	transform: ${(props)=>{
    const height = props.$tall ? '10vh' : '30vh';
    return `translate(calc(50vw - 390px), ${height});`;
}};
`;
const $63e9a7af5676c306$var$ModalHeading = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).h1`
	font-weight: lighter;
	line-height: 40px;
	color: ${(props)=>props.theme.colors.primaryTextColor};
	font-size: 28px;
	padding-bottom: 20px;
`;
const $63e9a7af5676c306$var$Modal = ({ showBackground: showBackground = true, backgroundColor: backgroundColor = 'light', children: children })=>{
    return /*#__PURE__*/ (0, $01ysi.jsx)($63e9a7af5676c306$export$547754aada6e339f, {
        $showBackground: showBackground,
        $backgroundColor: backgroundColor,
        children: children
    });
};
var $63e9a7af5676c306$export$2e2bcd8739ae039 = $63e9a7af5676c306$var$Modal;
function $63e9a7af5676c306$export$33ffd74ebf07f060({ children: children, backgroundColor: backgroundColor = 'dark', header: header, tall: tall, onClose: onClose }) {
    const [isOpen, setIsOpen] = (0, $gRqVZ.useState)(false);
    const closeModal = ()=>{
        if (onClose) onClose();
        setIsOpen(false);
    };
    const upHandler = ({ key: key })=>{
        if (key === 'Escape' && isOpen) closeModal();
    };
    (0, $gRqVZ.useEffect)(()=>{
        window.addEventListener('keyup', upHandler);
        return ()=>{
            window.removeEventListener('keyup', upHandler);
        };
    }, [
        isOpen
    ]);
    const modal = isOpen ? /*#__PURE__*/ (0, $01ysi.jsx)($63e9a7af5676c306$var$Modal, {
        backgroundColor: backgroundColor,
        children: /*#__PURE__*/ (0, $01ysi.jsxs)($63e9a7af5676c306$var$ModalContents, {
            $tall: tall,
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)($63e9a7af5676c306$export$cae179f078f4b4a4, {
                    onClick: ()=>closeModal()
                }),
                header && /*#__PURE__*/ (0, $01ysi.jsx)($63e9a7af5676c306$var$ModalHeading, {
                    children: header
                }),
                children
            ]
        })
    }) : null;
    return [
        modal,
        setIsOpen,
        isOpen
    ];
}



const $a2c6c12bc7500c5d$export$b20424b4610825c3 = (isPublic = true)=>{
    const [getPresignedUpload] = (0, $93486c083cb38a29$export$7607b86c7a656099)();
    const [addUpload] = (0, $93486c083cb38a29$export$a234d0c49428cf6e)();
    const upload = async (file)=>{
        const { size: size, name: name, type: type } = file;
        const isVideo = type.startsWith('video/');
        if (isVideo && size > 524288000) throw new Error('Video files must be under 500MB');
        const prefix = Math.floor(Math.random() * 100000000).toString();
        const fileName = `${prefix}-${name}`.replace(/[^a-zA-Z0-9_.]+/g, '_');
        const result = await getPresignedUpload({
            variables: {
                type: type,
                fileName: fileName,
                isPublic: isPublic
            }
        });
        const { fields: fields, url: url, presignedGetUrl: presignedGetUrl } = result.data.getPresignedUpload;
        console.log('Presigned upload data', fields, url, presignedGetUrl);
        const formData = new FormData();
        for (const [key, value] of Object.entries(fields))formData.append(key, value);
        formData.append('file', file);
        // Upload the file to S3
        console.log('Uploading to S3', url, formData);
        const s3Response = await fetch(url, {
            method: 'post',
            body: formData
        });
        if (!s3Response.ok) throw new Error(`Upload to storage failed (${s3Response.status})`);
        const newUpload = await addUpload({
            variables: {
                key: `staging/uploads/${fileName}`,
                size: size,
                type: type,
                url: presignedGetUrl
            }
        });
        return {
            uploadId: newUpload.data.insertUpload.id,
            publicUrl: newUpload.data.insertUpload.publicUrl,
            mediaType: isVideo ? 'video' : 'image'
        };
    };
    return [
        upload
    ];
};


const $21b05f4b21d71f23$var$SaveError = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	color: ${(props)=>props.theme.colors.red};
`;
function $21b05f4b21d71f23$var$UserDropdownContent() {
    const { setAccessToken: setAccessToken, user: user } = (0, $f8298f6bd5fca48e$export$a609e16b0cfae3f1)();
    const [profilePicModal, setUpdatingProfilePic] = (0, $63e9a7af5676c306$export$33ffd74ebf07f060)({
        header: 'Update Profile Picture',
        children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Formik), {
            initialValues: {
                file: null
            },
            onSubmit: async (values, { setStatus: setStatus })=>{
                setStatus(undefined);
                try {
                    const { uploadId: uploadId } = await upload(values.file.file);
                    await updateProfilePic({
                        variables: {
                            userId: user.id,
                            uploadId: uploadId
                        }
                    });
                } catch (e) {
                    setStatus('Failed to update profile picture. Please try again.');
                    return;
                }
                setUpdatingProfilePic(false);
            },
            children: ({ status: status })=>/*#__PURE__*/ (0, $01ysi.jsxs)((0, $489wz.Form), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                            name: "file",
                            type: "file",
                            label: "Update Profile Picture",
                            buttonLabel: "Upload an image",
                            image: {
                                aspect: 1
                            }
                        }),
                        status && /*#__PURE__*/ (0, $01ysi.jsx)($21b05f4b21d71f23$var$SaveError, {
                            children: status
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                            type: "formButtons",
                            onCancel: ()=>setUpdatingProfilePic(false),
                            hideBorderTop: true
                        })
                    ]
                })
        })
    });
    const [upload] = (0, $a2c6c12bc7500c5d$export$b20424b4610825c3)();
    const [updateProfilePic] = (0, $93486c083cb38a29$export$11678de5e6a25d7b)();
    const signout = ()=>{
        setAccessToken(null);
        localStorage.__promptNextLogin = 'yes';
    };
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4eb583db17ee8a52$export$acf59b376e961d86), {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$eb3d7c47ba9e5e55), {
                        onClick: ()=>setUpdatingProfilePic(true),
                        children: "Update Profile Picture"
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$eb3d7c47ba9e5e55), {
                        onClick: signout,
                        children: "Logout"
                    })
                ]
            }),
            profilePicModal
        ]
    });
}
var $21b05f4b21d71f23$export$2e2bcd8739ae039 = $21b05f4b21d71f23$var$UserDropdownContent;




var $gRqVZ = parcelRequire("gRqVZ");

var $gRqVZ = parcelRequire("gRqVZ");
var $c025e83aae109727$var$useInterval = function(callback, delay) {
    var savedCallback = (0, $gRqVZ.useRef)(function() {});
    (0, $gRqVZ.useEffect)(function() {
        savedCallback.current = callback;
    });
    (0, $gRqVZ.useEffect)(function() {
        if (delay !== null) {
            var interval_1 = setInterval(function() {
                return savedCallback.current();
            }, delay || 0);
            return function() {
                return clearInterval(interval_1);
            };
        }
        return undefined;
    }, [
        delay
    ]);
};
var $c025e83aae109727$export$2e2bcd8739ae039 = $c025e83aae109727$var$useInterval;


var $7de12bd144294bc3$exports = {};
!function(t, e) {
    $7de12bd144294bc3$exports = e();
}($7de12bd144294bc3$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


var $4ffe3ac414eccd26$exports = {};
!function(e, t) {
    $4ffe3ac414eccd26$exports = t();
}($4ffe3ac414eccd26$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});


(0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($4ffe3ac414eccd26$exports))));
function $19246af67240231a$var$useCurrentDate() {
    const [currentDate, setCurrentDate] = (0, $gRqVZ.useState)((0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))());
    (0, $c025e83aae109727$export$2e2bcd8739ae039)(()=>{
        setCurrentDate((0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))());
    }, 1000);
    return {
        dateStamp: currentDate.format('ll'),
        timeStamp: currentDate.format('LTS'),
        moment: currentDate
    };
}
var $19246af67240231a$export$2e2bcd8739ae039 = $19246af67240231a$var$useCurrentDate;




function $e75f9f9569755185$var$UtilityHeader() {
    const weatherState = (0, $b7f2bb4232df9024$export$70f96ff13bb51da8)();
    const { dateStamp: dateStamp, timeStamp: timeStamp } = (0, $19246af67240231a$export$2e2bcd8739ae039)();
    const { user: user } = (0, $f8298f6bd5fca48e$export$a609e16b0cfae3f1)();
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$9a69ef0daa31fb4c), {
        children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4eb583db17ee8a52$export$1e86fd0e1db89578), {
            children: [
                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4eb583db17ee8a52$export$3ecba61df9708051), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4eb583db17ee8a52$export$b7996bde93603ad), {
                            to: "#",
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$62e09d66fce7f525), {
                                    as: (0, $f0ed8187b60954b1$export$9735c82c4bae3302)
                                }),
                                timeStamp
                            ]
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4eb583db17ee8a52$export$b7996bde93603ad), {
                            to: "/calendar",
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$62e09d66fce7f525), {
                                    as: (0, $bb9ca67df03de270$export$492e206091e683eb)
                                }),
                                dateStamp
                            ]
                        }),
                        weatherState.value && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4eb583db17ee8a52$export$7cd623d16aecfb6), {
                            href: "https://weather.com/weather/today/l/USCA0987:1:US",
                            as: (0, $4eb583db17ee8a52$export$d6def513e747da1d),
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$62e09d66fce7f525), {
                                    as: (0, $59bc6484ee17bc69$export$a059d7a0f1f6fc48)
                                }),
                                weatherState.value.temp,
                                " - ",
                                weatherState.value.description,
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $2b5f38c9a88f5c8b$export$2e2bcd8739ae039), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$7ff085589970ee0a), {
                    children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4eb583db17ee8a52$export$7cd623d16aecfb6), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$6c0524ba53950d9f), {
                                src: user?.profilePhotoUrl
                            }),
                            "Logged in as ",
                            user && user.firstName,
                            " ",
                            user && user.lastName,
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $21b05f4b21d71f23$export$2e2bcd8739ae039), {})
                        ]
                    })
                })
            ]
        })
    });
}
var $e75f9f9569755185$export$2e2bcd8739ae039 = $e75f9f9569755185$var$UtilityHeader;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");
var $1aa98e792ef58eec$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($1aa98e792ef58eec$exports) {
        classNames.default = classNames;
        $1aa98e792ef58eec$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");


var $gRqVZ = parcelRequire("gRqVZ");

var $gRqVZ = parcelRequire("gRqVZ");
const $342ff180c8a4d32a$var$useLatest = (current)=>{
    const storedValue = $gRqVZ.useRef(current);
    $gRqVZ.useEffect(()=>{
        storedValue.current = current;
    });
    return storedValue;
};
var $342ff180c8a4d32a$export$2e2bcd8739ae039 = $342ff180c8a4d32a$var$useLatest;


const $6b73f0e093ed2d4b$export$40ae01be0011c1e6 = (callback, wait = 100, leading = false)=>{
    const storedCallback = (0, $342ff180c8a4d32a$export$2e2bcd8739ae039)(callback);
    const timeout = $gRqVZ.useRef();
    const deps = [
        wait,
        leading,
        storedCallback
    ]; // Cleans up pending timeouts when the deps change
    function _ref() {
        timeout.current && clearTimeout(timeout.current);
        timeout.current = void 0;
    }
    $gRqVZ.useEffect(()=>_ref, deps);
    function _ref2() {
        timeout.current = void 0;
    }
    return $gRqVZ.useCallback(function() {
        // eslint-disable-next-line prefer-rest-params
        const args = arguments;
        const { current: current } = timeout; // Calls on leading edge
        if (current === void 0 && leading) {
            timeout.current = setTimeout(_ref2, wait); // eslint-disable-next-line prefer-spread
            return storedCallback.current.apply(null, args);
        } // Clear the timeout every call and start waiting again
        current && clearTimeout(current); // Waits for `wait` before invoking the callback
        timeout.current = setTimeout(()=>{
            timeout.current = void 0;
            storedCallback.current.apply(null, args);
        }, wait);
    }, deps);
};
const $6b73f0e093ed2d4b$export$21805fee57372823 = (initialState, wait, leading)=>{
    const state = $gRqVZ.useState(initialState);
    return [
        state[0],
        $6b73f0e093ed2d4b$export$40ae01be0011c1e6(state[1], wait, leading),
        state[1]
    ];
};






const $8e482691af7da592$export$f04a61298a47a40f = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).svg`
	height: 15px;
	width: 15px;
	color: ${({ theme: theme })=>theme.colors.primaryTextColor};
	padding-right: 5px;
`;
const $8e482691af7da592$export$28149cf0bae31b97 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	align-items: center;
	font-size: 13px;
	&:hover {
		cursor: pointer;
	}
	&.searchOpen {
		width: 100%;
	}
`;
const $8e482691af7da592$export$55d7609a8f1eccd2 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).input`
	width: 100%;
	border: none;
	outline: none;
	line-height: 1.5;
	font-size: 18px;
`;
const $8e482691af7da592$export$33cbe09c46cf89a = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $f0e7a4a36037df80$export$78acf4525d8a74c4))`
	width: 25px;
	height: 25px;
`;



var $jIrNf = parcelRequire("jIrNf");
const $2693f7ea46500e8f$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createContext(null);
const $2693f7ea46500e8f$var$orderResults = (results, searchSort)=>{
    const typeIteree = 'modelType';
    const bulletinIteree = (result)=>{
        if (result.modelType === 'bulletin') {
            if (searchSort.startsWith('name')) return result.bulletin?.title;
            else if (searchSort.startsWith('date')) return result.bulletin?.createdAt;
        }
    };
    const resourceIteree = (result)=>{
        if (result.modelType === 'resources') {
            if (searchSort.startsWith('name')) return result.resource?.title;
            else if (searchSort.startsWith('date')) return result.resource?.createdAt;
        }
    };
    const userIteree = (result)=>{
        if (result.modelType === 'users') return result.user?.firstName;
    };
    const userSort = searchSort === 'nameDesc' ? 'desc' : 'asc';
    const dir = [
        'nameDesc',
        'dateDesc'
    ].includes(searchSort) ? 'desc' : 'asc';
    return (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).orderBy(results, [
        typeIteree,
        bulletinIteree,
        resourceIteree,
        userIteree
    ], [
        'desc',
        dir,
        dir,
        userSort
    ]);
};
function $2693f7ea46500e8f$export$a14e94a710e3b3ab({ children: children }) {
    const [searchKeywords, setSearchKeywords] = (0, $6b73f0e093ed2d4b$export$21805fee57372823)('', 250);
    const [searchSort, setSearchSort] = (0, $gRqVZ.useState)('dateDesc');
    const [searchOpen, setSearchOpen] = (0, $gRqVZ.useState)(false);
    const { data: data, loading: loading, error: error } = (0, $93486c083cb38a29$export$e985158d10c27e34)({
        variables: {
            keywords: `%${searchKeywords}%`
        },
        skip: searchKeywords.length < 2
    });
    const results = data?.search ? $2693f7ea46500e8f$var$orderResults(data.search, searchSort) : undefined;
    return /*#__PURE__*/ (0, $01ysi.jsx)($2693f7ea46500e8f$var$Context.Provider, {
        value: {
            searchKeywords: searchKeywords,
            setSearchKeywords: setSearchKeywords,
            searchSort: searchSort,
            setSearchSort: setSearchSort,
            searchOpen: searchOpen,
            setSearchOpen: setSearchOpen,
            results: results,
            loading: loading,
            error: error
        },
        children: children
    });
}
function $2693f7ea46500e8f$export$bd221a7c56b93941() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).useContext($2693f7ea46500e8f$var$Context);
}
function $2693f7ea46500e8f$var$Search() {
    const { setSearchKeywords: setSearchKeywords, searchOpen: searchOpen, setSearchOpen: setSearchOpen } = $2693f7ea46500e8f$export$bd221a7c56b93941();
    const toggleSearch = ()=>{
        setSearchOpen(!searchOpen);
    };
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $8e482691af7da592$export$28149cf0bae31b97), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1aa98e792ef58eec$exports)))({
            ['searchOpen']: searchOpen
        }),
        children: [
            /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                onClick: toggleSearch,
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $8e482691af7da592$export$f04a61298a47a40f), {
                        as: (0, $989849240f6109fe$export$4b85d3515bd863a5)
                    }),
                    !searchOpen && /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                        children: "Search"
                    })
                ]
            }),
            searchOpen && /*#__PURE__*/ (0, $01ysi.jsx)((0, $8e482691af7da592$export$55d7609a8f1eccd2), {
                type: "text",
                placeholder: "Start typing...",
                onChange: (e)=>setSearchKeywords(e.target.value),
                autoFocus: true
            }),
            searchOpen && /*#__PURE__*/ (0, $01ysi.jsx)((0, $8e482691af7da592$export$33cbe09c46cf89a), {
                onClick: toggleSearch
            })
        ]
    });
}
var $2693f7ea46500e8f$export$2e2bcd8739ae039 = $2693f7ea46500e8f$var$Search;



var $jIrNf = parcelRequire("jIrNf");
const $f5ed445ed8b66a2e$export$27c7e12f9cea6f4d = [
    {
        title: 'Overview',
        path: 'overview'
    },
    {
        title: 'Dept. Team',
        path: 'team'
    },
    {
        title: 'News & Announcements',
        path: 'news',
        subLinks: [
            {
                title: 'Create a new announcement',
                path: 'publish',
                adminOnly: true
            }
        ]
    },
    {
        title: 'Discussions',
        path: 'discussions',
        subLinks: [
            {
                title: 'Create a new discussion',
                path: 'publish'
            }
        ]
    }
];
const $f5ed445ed8b66a2e$var$editDepartmentRoutes = [
    {
        title: 'FAQ',
        path: 'faqs',
        subLinks: [
            {
                title: 'Create a new question',
                path: 'publish',
                adminOnly: true
            }
        ]
    },
    {
        title: 'Edit Department',
        path: 'edit',
        adminOnly: true
    },
    {
        title: 'Manage Quick Links',
        path: 'quick-links',
        adminOnly: true,
        subLinks: [
            {
                title: 'Create a new link',
                path: 'publish'
            }
        ]
    },
    {
        title: 'Add New Page',
        path: 'content/publish',
        adminOnly: true
    }
];
const $f5ed445ed8b66a2e$export$148d59d0130da180 = (department, isAdmin)=>{
    const adminFilter = isAdmin ? ()=>true : (r)=>!r.adminOnly;
    const commonRoutesContent = $f5ed445ed8b66a2e$export$27c7e12f9cea6f4d.filter(adminFilter).map((route)=>{
        const { title: title } = route;
        const to = `/departments/${department.id}/${route.path}`;
        const subLinks = route.subLinks?.filter(adminFilter).map((subLink)=>({
                title: subLink.title,
                to: `${to}/${subLink.path}`
            }));
        return {
            title: title,
            to: to,
            subLinks: subLinks
        };
    });
    const departmentSpecificRoutes = (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).chain(department.contents).map((content)=>{
        const { title: title } = content;
        const to = `/departments/${department.id}/contents/${content.id}`;
        const subLinks = content.contents && (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).chain(content.contents).map((subLink)=>({
                title: subLink.title,
                to: `${to}/${subLink.id}`
            })).orderBy('title').value();
        return {
            title: title,
            to: to,
            subLinks: subLinks
        };
    }).orderBy('title').value();
    const editDepartmentLinks = $f5ed445ed8b66a2e$var$editDepartmentRoutes.filter(adminFilter).map((link)=>{
        const { title: title } = link;
        const to = `/departments/${department.id}/${link.path}`;
        const subLinks = link.subLinks?.filter(adminFilter).map((subLink)=>({
                title: subLink.title,
                to: `${to}/${subLink.path}`
            }));
        return {
            title: title,
            to: to,
            subLinks: subLinks
        };
    });
    return [
        ...commonRoutesContent,
        ...departmentSpecificRoutes,
        ...editDepartmentLinks
    ];
};



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");

var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");



const $82fc1d9685dfa321$export$4c2f3def9501b358 = (0, $8999e1d77b7e12d9$export$dbf350e5966cf602)`
	transition: all 0.1s ease-in-out;
	padding: 0px 15px;
	font-size: 13px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	text-decoration: none;
	cursor: pointer;
	&:hover {
		color: ${({ theme: theme })=>theme.colors.primary};
		svg {
			color: ${({ theme: theme })=>theme.colors.primary};
		}
	}
	&.current {
		display: flex;
		color: ${({ theme: theme })=>theme.colors.primary};
		svg {
			color: ${({ theme: theme })=>theme.colors.primary};
		}
	}
`;
const $82fc1d9685dfa321$export$c42d5fd08085a81a = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $e3f57e4b1ea630bd$export$b0d92dbee9b5b60d))`
	${$82fc1d9685dfa321$export$4c2f3def9501b358}
`;
const $82fc1d9685dfa321$export$e3925dbaeffcc83f = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	${$82fc1d9685dfa321$export$4c2f3def9501b358}
	&.primary {
		line-height: 70px;
	}
`;



function $b37734d97fc999d6$var$NavLink({ title: title, children: children, to: to, id: id, sublinkIsActive: sublinkIsActive, primary: primary }) {
    // logic to highlight the Departments and People nav items when one of their sub-routes is the active route
    // there's probably a better way to do this
    const location = (0, $372fcccf2bee01ac$export$45d76561a5302f2b)();
    const currentLocationRoute = location.pathname.split('/')[1];
    const currentTitle = title && title.toLowerCase();
    const peopleDropdownLinks = [
        'org-chart',
        'company-directory'
    ];
    const activeNavDropdown = primary && currentLocationRoute === currentTitle || currentTitle === 'people' && peopleDropdownLinks.includes(currentLocationRoute);
    const isDetailState = location.pathname.split('/').pop().match(/\d+/)?.length > 0;
    const isParentActive = location.pathname.startsWith(to + '/') && isDetailState && location.pathname.split('/').length != to.split('/').length;
    if (!to) return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $82fc1d9685dfa321$export$e3925dbaeffcc83f), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1aa98e792ef58eec$exports)))({
            ['current']: activeNavDropdown || sublinkIsActive,
            ['primary']: primary
        }),
        children: [
            title,
            children
        ]
    });
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $82fc1d9685dfa321$export$c42d5fd08085a81a), {
        to: to,
        id: id,
        className: ({ isActive: isActive })=>(0, (/*@__PURE__*/$parcel$interopDefault($1aa98e792ef58eec$exports)))({
                ['current']: isActive || activeNavDropdown || sublinkIsActive || isParentActive,
                ['primary']: primary
            }),
        end: true,
        children: [
            title,
            children
        ]
    });
}
var $b37734d97fc999d6$export$2e2bcd8739ae039 = $b37734d97fc999d6$var$NavLink;



function $5d341687a35482b5$var$NavDropdown({ title: title, content: content, subMenuStyle: subMenuStyle }) {
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4eb583db17ee8a52$export$379c382dcbebc3aa), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $b37734d97fc999d6$export$2e2bcd8739ae039), {
                primary: true,
                title: title,
                children: content && /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$62e09d66fce7f525), {
                    as: (0, $4eb583db17ee8a52$export$fe287eda140b3e9)
                })
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$e923b1fc1eae5c8a), {
                as: subMenuStyle,
                children: content.map((dropdownItem)=>{
                    const key = `${title}-${dropdownItem.title}`;
                    if (dropdownItem.content) return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4eb583db17ee8a52$export$148fa54b77fc60e0), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $b37734d97fc999d6$export$2e2bcd8739ae039), {
                                title: dropdownItem.title,
                                to: dropdownItem.to,
                                children: dropdownItem.content && /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$62e09d66fce7f525), {
                                    as: (0, $4eb583db17ee8a52$export$e60e4d92d53645d5)
                                })
                            }, key),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$5c76348ab647113a), {
                                children: dropdownItem.content.map((sideLink)=>{
                                    const sideLinkKey = `${dropdownItem.title}-${sideLink.title}`;
                                    if (sideLink.href) return /*#__PURE__*/ (0, $01ysi.jsx)((0, $b37734d97fc999d6$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $01ysi.jsx)("a", {
                                            href: sideLink.href,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            style: {
                                                textDecoration: 'none',
                                                color: 'inherit'
                                            },
                                            children: sideLink.title
                                        })
                                    }, sideLinkKey);
                                    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $b37734d97fc999d6$export$2e2bcd8739ae039), {
                                        title: sideLink.title,
                                        to: sideLink.to
                                    }, sideLinkKey);
                                })
                            })
                        ]
                    }, `submenu-${dropdownItem.title}`);
                    if (dropdownItem.href) return /*#__PURE__*/ (0, $01ysi.jsx)((0, $b37734d97fc999d6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $01ysi.jsx)("a", {
                            href: dropdownItem.href,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            style: {
                                textDecoration: 'none',
                                color: 'inherit'
                            },
                            children: dropdownItem.title
                        })
                    }, key);
                    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $b37734d97fc999d6$export$2e2bcd8739ae039), {
                        title: dropdownItem.title,
                        to: dropdownItem.to
                    }, key);
                })
            })
        ]
    });
}
var $5d341687a35482b5$export$2e2bcd8739ae039 = $5d341687a35482b5$var$NavDropdown;






var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");

var $jIrNf = parcelRequire("jIrNf");

const $6e3a19da527b7fab$export$ff989fa3ff87b5af = ()=>{
    const { user: user } = (0, $f8298f6bd5fca48e$export$a609e16b0cfae3f1)();
    const roles = (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).map(user.roles, 'role');
    const hasRole = (neededRoles)=>(0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).intersection(roles, (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).flatten([
            neededRoles
        ])).length > 0;
    const useRole = hasRole('SuperAdmin') ? 'SuperAdmin' : hasRole('Editor') ? 'Editor' : hasRole('Gallery') ? 'Gallery' : 'user';
    return {
        roles: roles,
        hasRole: hasRole,
        isAdmin: hasRole([
            'SuperAdmin',
            'Editor'
        ]),
        isGalleryAdmin: hasRole([
            'SuperAdmin',
            'Editor',
            'Gallery'
        ]),
        useRole: useRole,
        useRoleUnless: (condition)=>condition ? undefined : useRole
    };
};
function $6e3a19da527b7fab$export$d56e283436f735f9(props) {
    const { hasRole: hasRole } = $6e3a19da527b7fab$export$ff989fa3ff87b5af();
    if (hasRole(props.role)) return /*#__PURE__*/ (0, $01ysi.jsx)((0, $01ysi.Fragment), {
        children: props.children
    });
    else return null;
}


function $9a1dd6fa292b0c8a$var$NavHeader() {
    const { siteMeta: siteMeta } = (0, $6f7f49c0f054a62d$export$55c0e3cb4fbc46cf)();
    const departments = siteMeta.departments;
    const { searchOpen: searchOpen } = (0, $2693f7ea46500e8f$export$bd221a7c56b93941)();
    const { isAdmin: isAdmin } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$4418626cb10d22e4), {
        children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4eb583db17ee8a52$export$1e86fd0e1db89578), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1aa98e792ef58eec$exports)))({
                ['searchOpen']: !!searchOpen
            }),
            children: [
                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4eb583db17ee8a52$export$b615cd9717379c80), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $b37734d97fc999d6$export$2e2bcd8739ae039), {
                            to: "/home",
                            id: "logoLink",
                            children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$e6ff31bff12b7ff4), {
                                type: "dark"
                            })
                        }),
                        !searchOpen && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $5d341687a35482b5$export$2e2bcd8739ae039), {
                                    title: "Departments",
                                    subMenuStyle: (0, $4eb583db17ee8a52$export$4d04858d81ea214c),
                                    content: departments.map((department)=>({
                                            title: department.title,
                                            content: (0, $f5ed445ed8b66a2e$export$148d59d0130da180)(department, isAdmin),
                                            to: `/departments/${department.id}/overview`
                                        }))
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $b37734d97fc999d6$export$2e2bcd8739ae039), {
                                    title: "News & Resources",
                                    to: "/news",
                                    primary: true
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $5d341687a35482b5$export$2e2bcd8739ae039), {
                                    title: "People",
                                    subMenuStyle: (0, $4eb583db17ee8a52$export$2d4ae60db1a382b6),
                                    content: [
                                        {
                                            title: 'Company Directory',
                                            to: '/company-directory'
                                        },
                                        {
                                            title: 'Org Chart',
                                            to: '/org-chart'
                                        }
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $b37734d97fc999d6$export$2e2bcd8739ae039), {
                                    title: "Discussions",
                                    to: "/discussions",
                                    primary: true
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $5d341687a35482b5$export$2e2bcd8739ae039), {
                                    title: "Galleries",
                                    subMenuStyle: (0, $4eb583db17ee8a52$export$2d4ae60db1a382b6),
                                    content: [
                                        {
                                            title: 'Photo/Video Gallery',
                                            to: '/gallery'
                                        },
                                        {
                                            title: 'Job Site Gallery',
                                            to: '/jobsite-videos'
                                        }
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $b37734d97fc999d6$export$2e2bcd8739ae039), {
                                    title: "Calendar",
                                    to: "/calendar",
                                    primary: true
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $5d341687a35482b5$export$2e2bcd8739ae039), {
                                    title: "IT Services",
                                    subMenuStyle: (0, $4eb583db17ee8a52$export$2d4ae60db1a382b6),
                                    content: [
                                        {
                                            title: 'IT Help',
                                            href: 'https://ithelp.nibbi.com'
                                        },
                                        {
                                            title: 'IT Knowledgebase',
                                            href: 'https://ithelp.nibbi.com/a/solutions/categories/31000003643/folders/31000023542'
                                        }
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $2693f7ea46500e8f$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
var $9a1dd6fa292b0c8a$export$2e2bcd8739ae039 = $9a1dd6fa292b0c8a$var$NavHeader;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");



function $1ead20da5b0b8ee0$var$Footer() {
    const thisYear = new Date().getFullYear();
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$fd9000017733fabf), {
        children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4eb583db17ee8a52$export$42a852a2b6b56249), {
            children: [
                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4eb583db17ee8a52$export$ed03bcfca6361a0), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$2871ab481185660c), {
                                    to: "/feedback",
                                    children: "Intranet Feedback"
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $6e3a19da527b7fab$export$d56e283436f735f9), {
                                    role: "SuperAdmin",
                                    children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$2871ab481185660c), {
                                        to: "/admin",
                                        children: "Intranet Admin"
                                    })
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $6e3a19da527b7fab$export$d56e283436f735f9), {
                                    role: "Crisis",
                                    children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$2871ab481185660c), {
                                        to: "/crisis-notifications",
                                        children: "Crisis Notifications"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$e0513c91be1318ca), {
                                    href: "https://www.nibbi.com",
                                    children: "Visit: www.nibbi.com"
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$e0513c91be1318ca), {
                                    href: "https://www.nibbiconcrete.com",
                                    children: "Visit: www.nibbiconcrete.com"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4eb583db17ee8a52$export$dee96cd6e4143da2), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                            children: [
                                "\xa9 ",
                                thisYear,
                                " Nibbi Brothers General Contractors"
                            ]
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                            children: [
                                "Follow Nibbi:",
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$c8a2b06b49cc2e12), {
                                    href: "https://www.facebook.com/pages/Nibbi-Brothers-General-Contractors/225301220837912",
                                    children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$45bc2e96ae668f64), {
                                        as: (0, $e4a24979e20ed9fc$export$a4f57375e50e81d5)
                                    })
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$c8a2b06b49cc2e12), {
                                    href: "https://twitter.com/#!/nibbibrothers",
                                    children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$45bc2e96ae668f64), {
                                        as: (0, $31d7a797966cc7d2$export$9e389cdad32a5b7a)
                                    })
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$c8a2b06b49cc2e12), {
                                    href: "http://www.linkedin.com/company/130071",
                                    children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$45bc2e96ae668f64), {
                                        as: (0, $61a2e5f5af330c28$export$ca041de6a87fe8b)
                                    })
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$c8a2b06b49cc2e12), {
                                    href: "https://www.youtube.com/nibbibrothers/",
                                    children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $4eb583db17ee8a52$export$45bc2e96ae668f64), {
                                        as: (0, $0d072899aa4a889d$export$9967558ab3090fa1)
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $1ead20da5b0b8ee0$export$2e2bcd8739ae039 = $1ead20da5b0b8ee0$var$Footer;





var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");

const $a45e69cf1a9414fe$var$Container = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	min-width: var(--container-min-width);
	max-width: var(--container-max-width);
	margin: 0 auto;
	padding-left: var(--grid-basis);
	padding-right: var(--grid-basis);
`;
var $a45e69cf1a9414fe$export$2e2bcd8739ae039 = $a45e69cf1a9414fe$var$Container;




const $e98c5b00ea87e556$export$1e86fd0e1db89578 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	margin-bottom: 80px;
	h1 {
		position: absolute;
		color: #fff;
		background: ${(props)=>props.theme.colors.primary};
		display: inline-block;
		padding: 0px 15px 5px 15px;
		font-size: 4rem;
		transform: translateY(-50%);
		font-weight: lighter;
	}
`;
const $e98c5b00ea87e556$export$e6ff31bff12b7ff4 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $bc8f851965189ea9$export$2e2bcd8739ae039))`
	margin-top: 25px;
	height: 230px;
	width: 230px;
`;
const $e98c5b00ea87e556$export$77ca71ab6249b8a1 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	height: 230px;
	background: linear-gradient(to right, rgba(0, 0, 0, 0.6) 15%, rgba(0, 0, 0, 0));
	h2 {
		font-size: 30px;
		display: block;
		line-height: 28px;
		color: #fff;
		font-weight: 300;
		position: absolute;
		margin-top: 30px;
	}
`;
const $e98c5b00ea87e556$export$7986be6df0b01cbf = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	width: 100%;
	height: 230px;
	background: url(${(props)=>props.imageUrl});
	background-size: cover;
	background-position: center;
	position: relative;
`;


function $1cc0b2ae0e4c17ef$var$Header({ imageUrl: imageUrl, title: title, hideTitle: hideTitle }) {
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $e98c5b00ea87e556$export$1e86fd0e1db89578), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $e98c5b00ea87e556$export$7986be6df0b01cbf), {
                imageUrl: imageUrl,
                children: title === 'Home' && /*#__PURE__*/ (0, $01ysi.jsx)((0, $e98c5b00ea87e556$export$77ca71ab6249b8a1), {
                    children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)("h2", {
                                children: "Welcome to"
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $e98c5b00ea87e556$export$e6ff31bff12b7ff4), {
                                type: "light"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
                children: !hideTitle && /*#__PURE__*/ (0, $01ysi.jsx)("h1", {
                    children: title
                })
            })
        ]
    });
}
var $1cc0b2ae0e4c17ef$export$2e2bcd8739ae039 = $1cc0b2ae0e4c17ef$var$Header;




var $jIrNf = parcelRequire("jIrNf");

var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");



var $489wz = parcelRequire("489wz");





var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");

var $261bfcb45405d60c$exports = {};
/*!
 2020 Jason Mulligan <jason.mulligan@avoidwork.com>
 @version 6.4.0
*/ !function(e, i) {
    $261bfcb45405d60c$exports = i();
}($261bfcb45405d60c$exports, function() {
    "use strict";
    var e = /^(b|B)$/, i = {
        iec: {
            bits: [
                "b",
                "Kib",
                "Mib",
                "Gib",
                "Tib",
                "Pib",
                "Eib",
                "Zib",
                "Yib"
            ],
            bytes: [
                "B",
                "KiB",
                "MiB",
                "GiB",
                "TiB",
                "PiB",
                "EiB",
                "ZiB",
                "YiB"
            ]
        },
        jedec: {
            bits: [
                "b",
                "Kb",
                "Mb",
                "Gb",
                "Tb",
                "Pb",
                "Eb",
                "Zb",
                "Yb"
            ],
            bytes: [
                "B",
                "KB",
                "MB",
                "GB",
                "TB",
                "PB",
                "EB",
                "ZB",
                "YB"
            ]
        }
    }, t = {
        iec: [
            "",
            "kibi",
            "mebi",
            "gibi",
            "tebi",
            "pebi",
            "exbi",
            "zebi",
            "yobi"
        ],
        jedec: [
            "",
            "kilo",
            "mega",
            "giga",
            "tera",
            "peta",
            "exa",
            "zetta",
            "yotta"
        ]
    }, o = {
        floor: Math.floor,
        ceil: Math.ceil
    };
    function n(n) {
        var r, a, b, l, s, c, d, f, p, u, B, h, g, y, M, m, v, x, N, j, T, E = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, w = [], P = 0;
        if (isNaN(n)) throw new TypeError("Invalid number");
        if (b = !0 === E.bits, M = !0 === E.unix, h = !0 === E.pad, a = E.base || 2, g = void 0 !== E.round ? E.round : M ? 1 : 2, d = void 0 !== E.locale ? E.locale : "", f = E.localeOptions || {}, m = void 0 !== E.separator ? E.separator : "", v = void 0 !== E.spacer ? E.spacer : M ? "" : " ", N = E.symbols || {}, x = 2 === a && E.standard || "jedec", B = E.output || "string", s = !0 === E.fullform, c = E.fullforms instanceof Array ? E.fullforms : [], r = void 0 !== E.exponent ? E.exponent : -1, j = o[E.roundingMethod] || Math.round, p = (u = Number(n)) < 0, l = a > 2 ? 1e3 : 1024, T = !1 === isNaN(E.precision) ? parseInt(E.precision, 10) : 0, p && (u = -u), (-1 === r || isNaN(r)) && (r = Math.floor(Math.log(u) / Math.log(l))) < 0 && (r = 0), r > 8 && (T > 0 && (T += 8 - r), r = 8), "exponent" === B) return r;
        if (0 === u) w[0] = 0, y = w[1] = M ? "" : i[x][b ? "bits" : "bytes"][r];
        else {
            P = u / (2 === a ? Math.pow(2, 10 * r) : Math.pow(1e3, r)), b && (P *= 8) >= l && r < 8 && (P /= l, r++);
            var k = Math.pow(10, r > 0 ? g : 0);
            w[0] = j(P * k) / k, w[0] === l && r < 8 && void 0 === E.exponent && (w[0] = 1, r++), y = w[1] = 10 === a && 1 === r ? b ? "kb" : "kB" : i[x][b ? "bits" : "bytes"][r], M && (w[1] = "jedec" === x ? w[1].charAt(0) : r > 0 ? w[1].replace(/B$/, "") : w[1], e.test(w[1]) && (w[0] = Math.floor(w[0]), w[1] = ""));
        }
        if (p && (w[0] = -w[0]), T > 0 && (w[0] = w[0].toPrecision(T)), w[1] = N[w[1]] || w[1], !0 === d ? w[0] = w[0].toLocaleString() : d.length > 0 ? w[0] = w[0].toLocaleString(d, f) : m.length > 0 && (w[0] = w[0].toString().replace(".", m)), h && !1 === Number.isInteger(w[0]) && g > 0) {
            var G = m || ".", K = w[0].toString().split(G), S = K[1] || "", Y = S.length, Z = g - Y;
            w[0] = "".concat(K[0]).concat(G).concat(S.padEnd(Y + Z, "0"));
        }
        return s && (w[1] = c[r] ? c[r] : t[x][r] + (b ? "bit" : "byte") + (1 === w[0] ? "" : "s")), "array" === B ? w : "object" === B ? {
            value: w[0],
            symbol: w[1],
            exponent: r,
            unit: y
        } : w.join(v);
    }
    return n.partial = function(e) {
        return function(i) {
            return n(i, e);
        };
    }, n;
});



var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");


var $489wz = parcelRequire("489wz");




var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");


const $dc9a635df58d972f$var$LoadingCircle = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $fa16d3b9d6307f73$export$a04a553a39b0cbf0))`
	height: 0.5rem;
	color: ${(props)=>props.theme.colors.primary};
	animation: fader 1s infinite;
	@keyframes fader {
		0% {
			opacity: 1;
		}
		50% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
`;
function $dc9a635df58d972f$export$2e2bcd8739ae039(props) {
    if (props.loading) return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
        children: [
            ' ',
            /*#__PURE__*/ (0, $01ysi.jsx)($dc9a635df58d972f$var$LoadingCircle, {})
        ]
    });
    return null;
}





var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");



var $jIrNf = parcelRequire("jIrNf");
var $cb5501dda223b37b$exports = {};
$cb5501dda223b37b$exports = $parcel$resolve("3wbsB");


var $ba6cc1d4f90306bb$exports = {};
$ba6cc1d4f90306bb$exports = $parcel$resolve("83FL9");


var $72615e33d3c3f395$exports = {};
$72615e33d3c3f395$exports = $parcel$resolve("dphDw");


var $5a6661fb83c8beab$exports = {};
$5a6661fb83c8beab$exports = $parcel$resolve("1EKZ2");


var $da97009c52b6d100$exports = {};
$da97009c52b6d100$exports = $parcel$resolve("dnYyC");


const $c24e7102e91cf921$export$a81c54d4a9749214 = {
    pdf: (0, $f56fb9e0fe685cc1$export$1e9bbbacaf20997a),
    doc: (0, $7eab598995bb8795$export$cabca7ad06b7e207),
    docx: (0, $7eab598995bb8795$export$cabca7ad06b7e207),
    ppt: (0, $62dd6abc00e8c54d$export$db69e95d0ffe9280)
};
const $c24e7102e91cf921$export$db724ce055e3f493 = {
    pdf: (0, (/*@__PURE__*/$parcel$interopDefault($cb5501dda223b37b$exports))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($ba6cc1d4f90306bb$exports))),
    docx: (0, (/*@__PURE__*/$parcel$interopDefault($ba6cc1d4f90306bb$exports))),
    xls: (0, (/*@__PURE__*/$parcel$interopDefault($72615e33d3c3f395$exports))),
    xlsx: (0, (/*@__PURE__*/$parcel$interopDefault($72615e33d3c3f395$exports))),
    mp4: (0, (/*@__PURE__*/$parcel$interopDefault($5a6661fb83c8beab$exports))),
    mov: (0, (/*@__PURE__*/$parcel$interopDefault($5a6661fb83c8beab$exports))),
    m4v: (0, (/*@__PURE__*/$parcel$interopDefault($5a6661fb83c8beab$exports))),
    webm: (0, (/*@__PURE__*/$parcel$interopDefault($5a6661fb83c8beab$exports))),
    msg: (0, (/*@__PURE__*/$parcel$interopDefault($da97009c52b6d100$exports))),
    eml: (0, (/*@__PURE__*/$parcel$interopDefault($da97009c52b6d100$exports)))
};
const $c24e7102e91cf921$export$36040f8ad2870528 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).img`
	display: block;
	flex-shrink: 0;
	width: 39px;
	height: 41px;
	object-fit: contain;
`;
function $c24e7102e91cf921$export$6fa511e0fa84d4de(iconBuilder, designerIconBuilder = (icon)=>icon) {
    const defaultIcon = iconBuilder((0, $5249bfd995c58c8e$export$b6afa8811b7e644e));
    const extIcons = (0, $jIrNf.mapValues)($c24e7102e91cf921$export$a81c54d4a9749214, (sourceIcon)=>iconBuilder(sourceIcon));
    const DesignerIcon = designerIconBuilder($c24e7102e91cf921$export$36040f8ad2870528);
    return function({ ext: ext, ...props }) {
        const designerSrc = $c24e7102e91cf921$export$db724ce055e3f493[String(ext ?? '').toLowerCase()];
        if (designerSrc) return /*#__PURE__*/ (0, $01ysi.jsx)(DesignerIcon, {
            src: designerSrc,
            alt: "",
            className: props.className
        });
        const Icon = extIcons[ext] ?? defaultIcon;
        return /*#__PURE__*/ (0, $01ysi.jsx)(Icon, {
            ...props
        });
    };
}


const $2a43bd8e1e541626$export$cae179f078f4b4a4 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $f0e7a4a36037df80$export$78acf4525d8a74c4))`
	width: ${(props)=>props.size === 'small' ? '30px' : '45px'};
	height: ${(props)=>props.size === 'small' ? '30px' : '45px'};
	color: ${(props)=>props.theme.colors[props.color]};
	top: 0;
	right: 0;
	position: absolute;
	float: right;
	padding-top: 15px;
	padding-right: 15px;
	&:hover {
		cursor: pointer;
	}
`;
const $2a43bd8e1e541626$export$5209328e970e4e96 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).h1`
	color: white;
	font-size: 36px;
	font-weight: 300;
	margin-bottom: 5px;
`;
const $2a43bd8e1e541626$export$e36c0b8b1ac2f50a = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).h2`
	color: white;
	font-size: 20px;
	font-weight: 300;
	opacity: 85%;
`;
const $2a43bd8e1e541626$export$9d2b4227a95687cc = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	justify-content: space-around;
	padding-top: 50px;
`;
const $2a43bd8e1e541626$export$1d0f50334281c528 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	background-color: white;
	width: 60%;
	height: calc(100vh - 100px);
	iframe {
		width: 100%;
		height: 100%;
	}
`;
const $2a43bd8e1e541626$export$62a8c1071504de27 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	width: 30%;
`;
const $2a43bd8e1e541626$var$makeIcon = (sourceIcon)=>{
    return (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)(sourceIcon)`
		color: ${({ theme: theme })=>theme.colors.neonGreen};
		width: 25px;
		height: 25px;
		background-color: white;
		border: 1px solid ${({ theme: theme })=>theme.colors.neonGreen};
		padding: 8px;
		border-radius: 5px;
		margin-bottom: 10px;
	`;
};
const $2a43bd8e1e541626$var$makeDesignerIcon = (sourceIcon)=>{
    return (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)(sourceIcon)`
		margin-bottom: 10px;
	`;
};
const $2a43bd8e1e541626$export$8c1a3d13e85d78b7 = (0, $c24e7102e91cf921$export$6fa511e0fa84d4de)($2a43bd8e1e541626$var$makeIcon, $2a43bd8e1e541626$var$makeDesignerIcon);
const $2a43bd8e1e541626$export$48377ae1c677702b = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	padding-top: 20px;
	color: ${({ theme: theme })=>theme.colors.primary};
`;
const $2a43bd8e1e541626$var$IconStyles = (0, $8999e1d77b7e12d9$export$dbf350e5966cf602)`
	width: 15px;
	height: 15px;
	padding-right: 5px;
`;
const $2a43bd8e1e541626$export$229c2a4b55a611f4 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $6d9aaf801032e965$export$4e2d65a9843399df))`
	${$2a43bd8e1e541626$var$IconStyles}
`;
const $2a43bd8e1e541626$export$2ad141e9e3d81b82 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $3cf30fe56fd1629f$export$889aff59bd27773b))`
	${$2a43bd8e1e541626$var$IconStyles}
`;
const $2a43bd8e1e541626$export$d23329de703dffc4 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $51c6ea681161bff5$export$99442c433de1441d))`
	${$2a43bd8e1e541626$var$IconStyles}
`;
const $2a43bd8e1e541626$export$4e54df4252b4a99c = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $d80380136de5b27f$export$3a083cd204da2316))`
	${$2a43bd8e1e541626$var$IconStyles}
`;
const $2a43bd8e1e541626$export$ac212121da6e7305 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	padding-bottom: 5px;
	a {
		text-decoration: none;
	}
	&:hover {
		cursor: pointer;
	}
`;
const $2a43bd8e1e541626$export$1ea2b9acb8e9adc6 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	position: fixed;
	overflow: auto;
	top: 20vh;
	right: 0;
	bottom: 0;
	left: 50vh;
	background-color: ${({ theme: theme })=>theme.colors.white};
	width: 400px;
	height: 200px;
	box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
	border-radius: 3px;
	border: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	padding: 40px;
	color: ${({ theme: theme })=>theme.colors.primaryTextColor};

	input {
		margin-top: 20px;
		width: calc(100% - 40px);
	}
`;
const $2a43bd8e1e541626$export$2e0a83ec2e27ecbb = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	padding-bottom: 20px;
	margin-bottom: 20px;
	border-bottom: 1px solid #535353;
`;
const $2a43bd8e1e541626$export$353f5b6fc5456de1 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).button`
	color: ${({ theme: theme })=>theme.colors.white};
	background-color: ${({ theme: theme })=>theme.colors.primary};
	padding: 10px 15px;
	border-radius: 3px;
	border: none;
	margin: 10px auto;
	display: block;
	width: ${(props)=>props?.fullWidth && '100%'};
	transition: all 0.1s ease-in-out;
	&:hover {
		cursor: pointer;
		background-color: ${({ theme: theme })=>theme.colors.primaryDark};
	}
`;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");




const $75673e4a99422ae0$var$IconStyles = (0, $8999e1d77b7e12d9$export$dbf350e5966cf602)`
	width: 15px;
	height: 15px;
	padding-right: 5px;
	margin-bottom: 3px;
`;
const $75673e4a99422ae0$var$FavoriteContainer = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).span`
	color: ${(props)=>props.$favorited ? props.theme.colors.primary : ''};
	&:hover {
		cursor: pointer;
	}
`;
const $75673e4a99422ae0$var$FavoritedIcon = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $15457c261efdedf5$export$7d9cb4bd8638e63e))`
	${$75673e4a99422ae0$var$IconStyles}
	color: ${({ theme: theme })=>theme.colors.primary};
`;
const $75673e4a99422ae0$var$FavoriteIcon = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $3f5de25d518e3bbc$export$1644ba17714857f1))`
	${$75673e4a99422ae0$var$IconStyles}
`;
const $75673e4a99422ae0$var$LoadingCircle = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $fa16d3b9d6307f73$export$a04a553a39b0cbf0))`
	height: 0.5rem;
	color: ${(props)=>props.theme.colors.primary};
	animation: fader 1s infinite;
	@keyframes fader {
		0% {
			opacity: 1;
		}
		50% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
`;
function $75673e4a99422ae0$export$2e2bcd8739ae039(props) {
    const { user: user } = (0, $f8298f6bd5fca48e$export$a609e16b0cfae3f1)();
    const [addFavoriteDiscussion, { loading: addFavoriteDiscussionLoading }] = (0, $93486c083cb38a29$export$d4d3e0709feb269a)({
        refetchQueries: [
            'currentUser'
        ],
        awaitRefetchQueries: true
    });
    const [removeFavoriteDiscussion, { loading: removeFavoriteDiscussionLoading }] = (0, $93486c083cb38a29$export$9110c1b8a970644e)({
        refetchQueries: [
            'currentUser'
        ],
        awaitRefetchQueries: true
    });
    const [addFavoriteResource, { loading: addFavoriteResourceLoading }] = (0, $93486c083cb38a29$export$1547767e0e33ea52)({
        refetchQueries: [
            'currentUser'
        ],
        awaitRefetchQueries: true
    });
    const [removeFavoriteResource, { loading: removeFavoriteResourceLoading }] = (0, $93486c083cb38a29$export$2b0a10b59053d5e)({
        refetchQueries: [
            'currentUser'
        ],
        awaitRefetchQueries: true
    });
    const loading = addFavoriteDiscussionLoading || removeFavoriteDiscussionLoading || addFavoriteResourceLoading || removeFavoriteResourceLoading;
    const typeLookup = {
        discussions: {
            isFavoritedLookup: ()=>user.favoriteDiscussions.find((fav)=>fav.discussionId === props.data.id),
            addFavorite: ()=>addFavoriteDiscussion({
                    variables: {
                        discussionId: props.data.id
                    }
                }),
            removeFavorite: ()=>removeFavoriteDiscussion({
                    variables: {
                        discussionId: props.data.id
                    }
                })
        },
        resources: {
            isFavoritedLookup: ()=>user.favoriteResources.find((fav)=>fav.resourceId === props.data.id),
            addFavorite: ()=>addFavoriteResource({
                    variables: {
                        resourceId: props.data.id
                    }
                }),
            removeFavorite: ()=>removeFavoriteResource({
                    variables: {
                        resourceId: props.data.id
                    }
                })
        }
    };
    if (!props.data.__typename) return null;
    const isFavorited = typeLookup[props.data.__typename].isFavoritedLookup();
    const toggle = ()=>{
        if (loading) return;
        if (isFavorited) typeLookup[props.data.__typename].removeFavorite();
        else typeLookup[props.data.__typename].addFavorite();
    };
    return /*#__PURE__*/ (0, $01ysi.jsxs)("span", {
        onClick: toggle,
        children: [
            isFavorited ? /*#__PURE__*/ (0, $01ysi.jsxs)($75673e4a99422ae0$var$FavoriteContainer, {
                $favorited: true,
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)($75673e4a99422ae0$var$FavoritedIcon, {}),
                    "Favorited"
                ]
            }) : /*#__PURE__*/ (0, $01ysi.jsxs)($75673e4a99422ae0$var$FavoriteContainer, {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)($75673e4a99422ae0$var$FavoriteIcon, {}),
                    "Favorite"
                ]
            }),
            ' ',
            loading && /*#__PURE__*/ (0, $01ysi.jsx)($75673e4a99422ae0$var$LoadingCircle, {})
        ]
    });
}





var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");
function $17faf2022da0c55b$var$RichText({ html: html, className: className }) {
    return /*#__PURE__*/ (0, $01ysi.jsx)("div", {
        className: `user-rich-text ${className || ''}`,
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
}
var $17faf2022da0c55b$export$2e2bcd8739ae039 = $17faf2022da0c55b$var$RichText;



const $83c95e5072a5afa6$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createContext(null);
function $83c95e5072a5afa6$export$9f6abfd74295843b() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).useContext($83c95e5072a5afa6$var$Context);
}
function $83c95e5072a5afa6$export$2ed61928bd1aa480({ children: children }) {
    const [resourceOpen, setResourceOpen] = (0, $gRqVZ.useState)(false);
    const [resource, setResource] = (0, $gRqVZ.useState)();
    return /*#__PURE__*/ (0, $01ysi.jsx)($83c95e5072a5afa6$var$Context.Provider, {
        value: {
            resourceOpen: resourceOpen,
            setResourceOpen: setResourceOpen,
            resource: resource,
            setResource: setResource
        },
        children: children
    });
}
const $83c95e5072a5afa6$var$ResourceDialog = ()=>{
    const [editingResource, setEditingResource] = (0, $gRqVZ.useState)(false);
    const { resourceOpen: resourceOpen, setResourceOpen: setResourceOpen, resource: resource } = $83c95e5072a5afa6$export$9f6abfd74295843b();
    const [upload] = (0, $a2c6c12bc7500c5d$export$b20424b4610825c3)(false);
    const [updateResourceFile] = (0, $93486c083cb38a29$export$97014a604d1b681d)();
    const [updateResourceData] = (0, $93486c083cb38a29$export$8fe372e0be5a5d37)();
    const [deleteResource, { loading: deleteLoading }] = (0, $93486c083cb38a29$export$276ec715eac70058)({
        refetchQueries: [
            'search',
            'departmentDetails'
        ],
        awaitRefetchQueries: true
    });
    const [presignedUrl, setPresignedUrl] = (0, $gRqVZ.useState)('');
    const { isAdmin: isAdmin, useRole: useRole } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    const [getPresignedUpload] = (0, $93486c083cb38a29$export$7607b86c7a656099)();
    let fileName = '';
    if (resource.file?.key.startsWith("documents/")) fileName = resource.file?.key.split('/')[1];
    else fileName = resource.file?.key.split('/')[2];
    const getPresignedUrl = async ()=>{
        console.log('resource:', resource);
        const result = await getPresignedUpload({
            variables: {
                type: resource.file?.type,
                fileName: fileName,
                isPublic: true
            }
        });
        const { presignedGetUrl: presignedGetUrl } = result.data.getPresignedUpload;
        console.log('presigned url:', presignedGetUrl);
        setPresignedUrl(presignedGetUrl);
    };
    (0, $gRqVZ.useEffect)(()=>{
        if (resource) getPresignedUrl();
    }, [
        resource
    ]);
    const closeResource = ()=>{
        setResourceOpen(!resourceOpen);
    };
    const createdDateString = (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(resource.createdAt).format('lll');
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $63e9a7af5676c306$export$2e2bcd8739ae039), {
        backgroundColor: "dark",
        children: [
            resourceOpen && /*#__PURE__*/ (0, $01ysi.jsx)((0, $2a43bd8e1e541626$export$cae179f078f4b4a4), {
                onClick: closeResource,
                color: "white"
            }),
            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2a43bd8e1e541626$export$9d2b4227a95687cc), {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $2a43bd8e1e541626$export$1d0f50334281c528), {
                        children: resource.file?.type === 'application/pdf' ? /*#__PURE__*/ (0, $01ysi.jsx)("iframe", {
                            src: presignedUrl
                        }) : 'No Preview'
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2a43bd8e1e541626$export$62a8c1071504de27), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $2a43bd8e1e541626$export$8c1a3d13e85d78b7), {
                                ext: resource.file?.key.split('.').pop()
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $2a43bd8e1e541626$export$5209328e970e4e96), {
                                children: resource.title
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $2a43bd8e1e541626$export$e36c0b8b1ac2f50a), {
                                children: createdDateString
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2a43bd8e1e541626$export$48377ae1c677702b), {
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)("a", {
                                        href: presignedUrl,
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2a43bd8e1e541626$export$353f5b6fc5456de1), {
                                            fullWidth: true,
                                            children: [
                                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $2a43bd8e1e541626$export$4e54df4252b4a99c), {}),
                                                "Download ",
                                                resource.file.size ? `(${(0, (/*@__PURE__*/$parcel$interopDefault($261bfcb45405d60c$exports)))(resource.file.size)})` : ''
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $2a43bd8e1e541626$export$2e0a83ec2e27ecbb), {}),
                                    resource.description?.length > 0 && /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                                        style: {
                                            color: '#ddd'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $17faf2022da0c55b$export$2e2bcd8739ae039), {
                                                html: resource.description
                                            }),
                                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $2a43bd8e1e541626$export$2e0a83ec2e27ecbb), {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $75673e4a99422ae0$export$2e2bcd8739ae039), {
                                        data: resource
                                    }),
                                    isAdmin && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2a43bd8e1e541626$export$ac212121da6e7305), {
                                                children: [
                                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $2a43bd8e1e541626$export$2ad141e9e3d81b82), {}),
                                                    /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                                                        onClick: ()=>setEditingResource(!editingResource),
                                                        children: "Edit this resource"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2a43bd8e1e541626$export$ac212121da6e7305), {
                                                onClick: async ()=>{
                                                    if (confirm('Are you sure you want to delete this resource?')) {
                                                        await deleteResource({
                                                            context: {
                                                                useRole: useRole
                                                            },
                                                            variables: {
                                                                id: resource.id
                                                            }
                                                        });
                                                        closeResource();
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $2a43bd8e1e541626$export$d23329de703dffc4), {}),
                                                    "Delete this resource",
                                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $dc9a635df58d972f$export$2e2bcd8739ae039), {
                                                        loading: deleteLoading
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            editingResource && /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                                style: {
                                    marginTop: '1rem',
                                    backgroundColor: 'white',
                                    padding: '1rem',
                                    borderRadius: '4px'
                                },
                                children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Formik), {
                                    initialValues: {
                                        title: resource.title,
                                        file: null,
                                        description: resource.description ?? ''
                                    },
                                    onSubmit: async (values)=>{
                                        if (values.file) {
                                            const { uploadId: uploadId } = await upload(values.file.file);
                                            await updateResourceFile({
                                                context: {
                                                    useRole: useRole
                                                },
                                                variables: {
                                                    id: resource.id,
                                                    fileUploadId: uploadId
                                                }
                                            });
                                        }
                                        await updateResourceData({
                                            context: {
                                                useRole: useRole
                                            },
                                            variables: {
                                                id: resource.id,
                                                title: values.title,
                                                description: values.description
                                            }
                                        });
                                        setEditingResource(false);
                                    },
                                    children: ({ values: values, setFieldValue: setFieldValue })=>{
                                        return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $489wz.Form), {
                                            children: [
                                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                                    name: "title",
                                                    type: "text",
                                                    label: "Resource Title"
                                                }),
                                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                                    name: "description",
                                                    type: "richText",
                                                    label: "Description",
                                                    value: values.description,
                                                    placeholder: "Tell us about the document...",
                                                    onChange: (val)=>setFieldValue('description', val)
                                                }),
                                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                                    hideBorderTop: true,
                                                    type: "formButtons",
                                                    submitLabel: "Save Resource",
                                                    onCancel: ()=>setEditingResource(false)
                                                })
                                            ]
                                        });
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $83c95e5072a5afa6$export$2e2bcd8739ae039 = $83c95e5072a5afa6$var$ResourceDialog;



var $jIrNf = parcelRequire("jIrNf");






const $965ad126b9c0d2a7$var$getIconSizeAndColor = ($displaySize, $iconColor, theme)=>{
    return `
	max-width: ${theme.linkCardSize.iconSize[$displaySize]};
	min-width: ${theme.linkCardSize.iconSize[$displaySize]};
	max-height: ${theme.linkCardSize.iconSize[$displaySize]};
	min-height: ${theme.linkCardSize.iconSize[$displaySize]};
	color: ${theme.colors[$iconColor]};
	border: 1px solid ${theme.colors[$iconColor]};
	`;
};
const $965ad126b9c0d2a7$var$IconStyles = (0, $8999e1d77b7e12d9$export$dbf350e5966cf602)`
	padding: 7px;
	border-radius: 3px;
	margin-right: 15px;
	align-self: center;
`;
const $965ad126b9c0d2a7$var$makeIcon = (sourceIcon)=>{
    return (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)(sourceIcon)`
		${$965ad126b9c0d2a7$var$IconStyles}
		${({ $displaySize: $displaySize, $iconColor: $iconColor, theme: theme })=>$965ad126b9c0d2a7$var$getIconSizeAndColor($displaySize, $iconColor, theme)}
	`;
};
const $965ad126b9c0d2a7$export$d8ae61ac39c9383c = $965ad126b9c0d2a7$var$makeIcon((0, $dae942ddd688b2e9$export$79c66221ddbb3eb1));
const $965ad126b9c0d2a7$export$d8a79927ee18e665 = $965ad126b9c0d2a7$var$makeIcon((0, $03d9d30d229feb56$export$d49dffca20dba6f7));
const $965ad126b9c0d2a7$export$7dcc8f518762622d = $965ad126b9c0d2a7$var$makeIcon((0, $d90a2948bc45fb70$export$a7f7c251c7c85cf5));
const $965ad126b9c0d2a7$var$makeDesignerIcon = (sourceIcon)=>{
    return (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)(sourceIcon)`
		margin-right: 15px;
		align-self: center;
	`;
};
const $965ad126b9c0d2a7$export$8c1a3d13e85d78b7 = (0, $c24e7102e91cf921$export$6fa511e0fa84d4de)($965ad126b9c0d2a7$var$makeIcon, $965ad126b9c0d2a7$var$makeDesignerIcon);
const $965ad126b9c0d2a7$export$7e6af4d109382e92 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	${$965ad126b9c0d2a7$var$IconStyles}
	width: 40px;
	height: 40px;
	background: url(${(props)=>props.$profilePhotoUrl});
	background-size: cover;
`;
const $965ad126b9c0d2a7$export$8463c987d12d7028 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	border-bottom: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	line-height: normal;
	padding: 15px 0px;
	&:last-child {
		border-bottom: none;
	}
`;
const $965ad126b9c0d2a7$export$283e28d91a9a885d = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $e3f57e4b1ea630bd$export$b0d92dbee9b5b60d))`
	transition: all 0.1s ease-in-out;
	display: block;
	text-decoration: none;
	padding-bottom: 5px;
	font-size: ${({ $displaySize: $displaySize })=>$displaySize === 'lg' ? '22px' : '16px'};
	color: ${({ theme: theme })=>theme.colors.primaryTextColor};
	&:hover {
		color: ${({ theme: theme })=>theme.colors.primary};
	}
`;
const $965ad126b9c0d2a7$export$33f1b01688923142 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	font-size: 14px;
	color: ${({ theme: theme })=>theme.colors.lightestGray};
	& + & {
		padding-top: 0.5rem;
	}
`;
const $965ad126b9c0d2a7$export$585a3b23e887288b = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	align-items: center;
	line-height: ${(props)=>props.$hasSubtitle ? 'normal' : '50px'};
`;
const $965ad126b9c0d2a7$export$6be4972368479c02 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	background-color: ${({ theme: theme, $color: $color })=>theme.colors[$color]};
	color: ${({ theme: theme })=>theme.colors.white};
	display: inline-block;
	padding: 2px 5px;
	border-radius: 2px;
	font-size: 14px;
	line-height: 14px;
	margin-left: 10px;
	height: 16px;
`;
const $965ad126b9c0d2a7$export$a6c7ac8248d6e38a = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).a`
	color: ${({ theme: theme })=>theme.colors.primary};
	text-decoration: none;
	cursor: pointer;
`;
const $965ad126b9c0d2a7$export$c8e5c1392561c508 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).svg`
	height: 1rem;
	height: 1rem;
`;
const $965ad126b9c0d2a7$export$4e28bce62ddcd0dd = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).svg`
	height: 1rem;
	height: 1rem;
	padding-right: 0.5rem;
`;
const $965ad126b9c0d2a7$export$31fb910100fd5f81 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $e3f57e4b1ea630bd$export$b0d92dbee9b5b60d))`
	color: ${({ theme: theme })=>theme.colors.primary};
	text-decoration: none;
`;



function $cb071fc609c78ddc$var$getIcon(type, $displaySize, iconColor, ext, profilePhotoUrl) {
    switch(type){
        case 'discussions':
            return /*#__PURE__*/ (0, $01ysi.jsx)((0, $965ad126b9c0d2a7$export$d8a79927ee18e665), {
                $displaySize: $displaySize,
                $iconColor: iconColor
            });
        case 'bulletins':
            return /*#__PURE__*/ (0, $01ysi.jsx)((0, $965ad126b9c0d2a7$export$d8ae61ac39c9383c), {
                $displaySize: $displaySize,
                $iconColor: iconColor
            });
        case 'resources':
            return /*#__PURE__*/ (0, $01ysi.jsx)((0, $965ad126b9c0d2a7$export$8c1a3d13e85d78b7), {
                $displaySize: $displaySize,
                $iconColor: iconColor,
                ext: ext
            });
        case 'users':
            return profilePhotoUrl ? /*#__PURE__*/ (0, $01ysi.jsx)((0, $965ad126b9c0d2a7$export$7e6af4d109382e92), {
                $profilePhotoUrl: profilePhotoUrl
            }) : /*#__PURE__*/ (0, $01ysi.jsx)((0, $965ad126b9c0d2a7$export$7dcc8f518762622d), {
                $displaySize: $displaySize,
                $iconColor: iconColor
            });
        default:
            return null;
    }
}
// const getSignedUrl=async(_type: string, _fileName: string)=>{
// 	const [getPresignedUpload] = useGetPresignedUploadMutation()
// 	const result = await getPresignedUpload({
// 		variables: {
// 			type:_type,
// 			fileName:_fileName,
// 			isPublic: true
// 		}
// 	})
// 	return result.data.getPresignedUpload
// }
function $cb071fc609c78ddc$var$LinkCard(props) {
    if (!props.data) return null;
    const { data: siteMetaData } = (0, $93486c083cb38a29$export$67241447dc3e8d68)();
    const { setResource: setResource, setResourceOpen: setResourceOpen } = (0, $83c95e5072a5afa6$export$9f6abfd74295843b)();
    let to = '';
    let onClick = props.onClick;
    const onResourceContextClick = props.onResourceContextClick;
    let title;
    let subtitle = [];
    let badgeText;
    let badgeColor = 'neonGreen';
    let iconColor = 'neonGreen';
    const resourceContext = (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).get(props.data, 'departmentContentsResources.departmentContent');
    let resourceContextDepartmentTitle = null;
    if (resourceContext && onResourceContextClick) resourceContextDepartmentTitle = siteMetaData.departments.find((d)=>d.id === resourceContext.departmentId)?.title;
    switch(props.data.__typename){
        case 'bulletins':
            title = props.data.title;
            subtitle = (0, $jIrNf.compact)([
                (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(props.data.createdAt).format('ll'),
                props.data.author && `by ${props.data.author.firstName} ${props.data.author.lastName}`
            ]);
            to = props.departmentId > 0 ? `/departments/${props.departmentId}/news/${props.data.id}` : `/news/${props.modelId}`;
            badgeText = 'Announcement';
            badgeColor = 'red';
            iconColor = 'red';
            break;
        case 'discussions':
            title = props.data.title;
            badgeText = 'Discussion';
            badgeColor = 'teal';
            subtitle = (0, $jIrNf.compact)([
                (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(props.data.createdAt).format('ll'),
                props.data.author && `by ${props.data.author.firstName} ${props.data.author.lastName}`
            ]);
            to = props.departmentId > 0 || props.data.departmentId > 0 ? `/departments/${props.departmentId || props.data.departmentId}/discussions/${props.data.id}` : `/discussions/${props.data.id}`;
            break;
        case 'resources':
            if (props.data.file) {
                title = props.data.title;
                badgeText = 'Resource';
                subtitle = [
                    (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(props.data.createdAt).format('lll'),
                    (0, (/*@__PURE__*/$parcel$interopDefault($261bfcb45405d60c$exports)))(props.data.file.size)
                ];
                onClick = ()=>{
                    setResourceOpen(true);
                    setResource(props.data);
                };
            }
            break;
        case 'users':
            badgeText = 'User';
            badgeColor = 'royalBlue';
            iconColor = 'lightestGray';
            title = `${props.data.firstName} ${props.data.lastName}`;
            subtitle = (0, $jIrNf.compact)([
                props.data?.department?.title,
                props.data?.jobTitle
            ]);
            break;
    }
    const Icon = $cb071fc609c78ddc$var$getIcon(props.data.__typename, props.$displaySize ?? 'med', iconColor, props.data.__typename === 'resources' ? props?.data?.file?.key.split('.').pop() : null, props.data.__typename === 'users' ? props?.data?.profilePhotoUrl : null);
    if (!title) return null;
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $965ad126b9c0d2a7$export$8463c987d12d7028), {
        children: [
            Icon,
            /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsxs)((0, $965ad126b9c0d2a7$export$585a3b23e887288b), {
                        $hasSubtitle: subtitle?.length > 0,
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $965ad126b9c0d2a7$export$283e28d91a9a885d), {
                                to: to,
                                $displaySize: props.$displaySize ?? 'med',
                                onClick: onClick,
                                children: title
                            }),
                            props.showTypeBadge && /*#__PURE__*/ (0, $01ysi.jsx)((0, $965ad126b9c0d2a7$export$6be4972368479c02), {
                                $color: badgeColor,
                                children: badgeText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsxs)((0, $965ad126b9c0d2a7$export$33f1b01688923142), {
                        children: [
                            subtitle.join(" \u2022 "),
                            props.data.__typename === 'resources' && resourceContextDepartmentTitle && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
                                children: [
                                    " \u2022 ",
                                    /*#__PURE__*/ (0, $01ysi.jsxs)("span", {
                                        style: {
                                            cursor: 'pointer',
                                            color: '#bd5f28'
                                        },
                                        onClick: ()=>{
                                            onResourceContextClick(resourceContext);
                                        },
                                        children: [
                                            resourceContextDepartmentTitle,
                                            " \u2192 ",
                                            resourceContext.title
                                        ]
                                    })
                                ]
                            }),
                            props.data.__typename === 'discussions' && props.showSubtitleActions && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
                                children: [
                                    " \u2022 ",
                                    /*#__PURE__*/ (0, $01ysi.jsxs)((0, $965ad126b9c0d2a7$export$31fb910100fd5f81), {
                                        to: `${props.data.id}`,
                                        children: [
                                            props.data.comments.length,
                                            " comments"
                                        ]
                                    })
                                ]
                            }),
                            props.data.__typename === 'discussions' && props.showSubtitleActions && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
                                children: [
                                    " \u2022 ",
                                    " ",
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $75673e4a99422ae0$export$2e2bcd8739ae039), {
                                        data: props.data
                                    })
                                ]
                            })
                        ]
                    }),
                    props.editActions?.remove && /*#__PURE__*/ (0, $01ysi.jsx)((0, $965ad126b9c0d2a7$export$33f1b01688923142), {
                        children: props.data.__typename === 'resources' && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $965ad126b9c0d2a7$export$a6c7ac8248d6e38a), {
                            onClick: props.editActions.remove,
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $965ad126b9c0d2a7$export$4e28bce62ddcd0dd), {
                                    as: (0, $51c6ea681161bff5$export$99442c433de1441d)
                                }),
                                "Remove"
                            ]
                        })
                    }),
                    props.editActions?.add && /*#__PURE__*/ (0, $01ysi.jsx)((0, $965ad126b9c0d2a7$export$33f1b01688923142), {
                        children: props.data.__typename === 'resources' && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $965ad126b9c0d2a7$export$a6c7ac8248d6e38a), {
                            onClick: props.editActions.add,
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $965ad126b9c0d2a7$export$c8e5c1392561c508), {
                                    as: (0, $a98c9f8299f9be25$export$2d9ac7aa84f97a08)
                                }),
                                "Add"
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var $cb071fc609c78ddc$export$2e2bcd8739ae039 = $cb071fc609c78ddc$var$LinkCard;





var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");

var $gRqVZ = parcelRequire("gRqVZ");
function $f54f7e013472440a$var$isObject(subject) {
    return Object.prototype.toString.call(subject) === '[object Object]';
}
function $f54f7e013472440a$var$isRecord(subject) {
    return $f54f7e013472440a$var$isObject(subject) || Array.isArray(subject);
}
function $f54f7e013472440a$export$71594e8a50f746f4() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
function $f54f7e013472440a$export$1ace03bbcd701468(optionsA, optionsB) {
    const optionsAKeys = Object.keys(optionsA);
    const optionsBKeys = Object.keys(optionsB);
    if (optionsAKeys.length !== optionsBKeys.length) return false;
    const breakpointsA = JSON.stringify(Object.keys(optionsA.breakpoints || {}));
    const breakpointsB = JSON.stringify(Object.keys(optionsB.breakpoints || {}));
    if (breakpointsA !== breakpointsB) return false;
    return optionsAKeys.every((key)=>{
        const valueA = optionsA[key];
        const valueB = optionsB[key];
        if (typeof valueA === 'function') return `${valueA}` === `${valueB}`;
        if (!$f54f7e013472440a$var$isRecord(valueA) || !$f54f7e013472440a$var$isRecord(valueB)) return valueA === valueB;
        return $f54f7e013472440a$export$1ace03bbcd701468(valueA, valueB);
    });
}
function $f54f7e013472440a$export$919604828c9466f3(plugins) {
    return plugins.concat().sort((a, b)=>a.name > b.name ? 1 : -1).map((plugin)=>plugin.options);
}
function $f54f7e013472440a$export$8a8daedc629f7568(pluginsA, pluginsB) {
    if (pluginsA.length !== pluginsB.length) return false;
    const optionsA = $f54f7e013472440a$export$919604828c9466f3(pluginsA);
    const optionsB = $f54f7e013472440a$export$919604828c9466f3(pluginsB);
    return optionsA.every((optionA, index)=>{
        const optionB = optionsB[index];
        return $f54f7e013472440a$export$1ace03bbcd701468(optionA, optionB);
    });
}


function $beb68572c1766b4f$var$isNumber(subject) {
    return typeof subject === 'number';
}
function $beb68572c1766b4f$var$isString(subject) {
    return typeof subject === 'string';
}
function $beb68572c1766b4f$var$isBoolean(subject) {
    return typeof subject === 'boolean';
}
function $beb68572c1766b4f$var$isObject(subject) {
    return Object.prototype.toString.call(subject) === '[object Object]';
}
function $beb68572c1766b4f$var$mathAbs(n) {
    return Math.abs(n);
}
function $beb68572c1766b4f$var$mathSign(n) {
    return Math.sign(n);
}
function $beb68572c1766b4f$var$deltaAbs(valueB, valueA) {
    return $beb68572c1766b4f$var$mathAbs(valueB - valueA);
}
function $beb68572c1766b4f$var$factorAbs(valueB, valueA) {
    if (valueB === 0 || valueA === 0) return 0;
    if ($beb68572c1766b4f$var$mathAbs(valueB) <= $beb68572c1766b4f$var$mathAbs(valueA)) return 0;
    const diff = $beb68572c1766b4f$var$deltaAbs($beb68572c1766b4f$var$mathAbs(valueB), $beb68572c1766b4f$var$mathAbs(valueA));
    return $beb68572c1766b4f$var$mathAbs(diff / valueB);
}
function $beb68572c1766b4f$var$roundToTwoDecimals(num) {
    return Math.round(num * 100) / 100;
}
function $beb68572c1766b4f$var$arrayKeys(array) {
    return $beb68572c1766b4f$var$objectKeys(array).map(Number);
}
function $beb68572c1766b4f$var$arrayLast(array) {
    return array[$beb68572c1766b4f$var$arrayLastIndex(array)];
}
function $beb68572c1766b4f$var$arrayLastIndex(array) {
    return Math.max(0, array.length - 1);
}
function $beb68572c1766b4f$var$arrayIsLastIndex(array, index) {
    return index === $beb68572c1766b4f$var$arrayLastIndex(array);
}
function $beb68572c1766b4f$var$arrayFromNumber(n, startAt = 0) {
    return Array.from(Array(n), (_, i)=>startAt + i);
}
function $beb68572c1766b4f$var$objectKeys(object) {
    return Object.keys(object);
}
function $beb68572c1766b4f$var$objectsMergeDeep(objectA, objectB) {
    return [
        objectA,
        objectB
    ].reduce((mergedObjects, currentObject)=>{
        $beb68572c1766b4f$var$objectKeys(currentObject).forEach((key)=>{
            const valueA = mergedObjects[key];
            const valueB = currentObject[key];
            const areObjects = $beb68572c1766b4f$var$isObject(valueA) && $beb68572c1766b4f$var$isObject(valueB);
            mergedObjects[key] = areObjects ? $beb68572c1766b4f$var$objectsMergeDeep(valueA, valueB) : valueB;
        });
        return mergedObjects;
    }, {});
}
function $beb68572c1766b4f$var$isMouseEvent(evt, ownerWindow) {
    return typeof ownerWindow.MouseEvent !== 'undefined' && evt instanceof ownerWindow.MouseEvent;
}
function $beb68572c1766b4f$var$Alignment(align, viewSize) {
    const predefined = {
        start: start,
        center: center,
        end: end
    };
    function start() {
        return 0;
    }
    function center(n) {
        return end(n) / 2;
    }
    function end(n) {
        return viewSize - n;
    }
    function measure(n, index) {
        if ($beb68572c1766b4f$var$isString(align)) return predefined[align](n);
        return align(viewSize, n, index);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $beb68572c1766b4f$var$EventStore() {
    let listeners = [];
    function add(node, type, handler, options = {
        passive: true
    }) {
        let removeListener;
        if ('addEventListener' in node) {
            node.addEventListener(type, handler, options);
            removeListener = ()=>node.removeEventListener(type, handler, options);
        } else {
            const legacyMediaQueryList = node;
            legacyMediaQueryList.addListener(handler);
            removeListener = ()=>legacyMediaQueryList.removeListener(handler);
        }
        listeners.push(removeListener);
        return self;
    }
    function clear() {
        listeners = listeners.filter((remove)=>remove());
    }
    const self = {
        add: add,
        clear: clear
    };
    return self;
}
function $beb68572c1766b4f$var$Animations(ownerDocument, ownerWindow, update, render) {
    const documentVisibleHandler = $beb68572c1766b4f$var$EventStore();
    const fixedTimeStep = 1000 / 60;
    let lastTimeStamp = null;
    let accumulatedTime = 0;
    let animationId = 0;
    function init() {
        documentVisibleHandler.add(ownerDocument, 'visibilitychange', ()=>{
            if (ownerDocument.hidden) reset();
        });
    }
    function destroy() {
        stop();
        documentVisibleHandler.clear();
    }
    function animate(timeStamp) {
        if (!animationId) return;
        if (!lastTimeStamp) {
            lastTimeStamp = timeStamp;
            update();
            update();
        }
        const timeElapsed = timeStamp - lastTimeStamp;
        lastTimeStamp = timeStamp;
        accumulatedTime += timeElapsed;
        while(accumulatedTime >= fixedTimeStep){
            update();
            accumulatedTime -= fixedTimeStep;
        }
        const alpha = accumulatedTime / fixedTimeStep;
        render(alpha);
        if (animationId) animationId = ownerWindow.requestAnimationFrame(animate);
    }
    function start() {
        if (animationId) return;
        animationId = ownerWindow.requestAnimationFrame(animate);
    }
    function stop() {
        ownerWindow.cancelAnimationFrame(animationId);
        lastTimeStamp = null;
        accumulatedTime = 0;
        animationId = 0;
    }
    function reset() {
        lastTimeStamp = null;
        accumulatedTime = 0;
    }
    const self = {
        init: init,
        destroy: destroy,
        start: start,
        stop: stop,
        update: update,
        render: render
    };
    return self;
}
function $beb68572c1766b4f$var$Axis(axis, contentDirection) {
    const isRightToLeft = contentDirection === 'rtl';
    const isVertical = axis === 'y';
    const scroll = isVertical ? 'y' : 'x';
    const cross = isVertical ? 'x' : 'y';
    const sign = !isVertical && isRightToLeft ? -1 : 1;
    const startEdge = getStartEdge();
    const endEdge = getEndEdge();
    function measureSize(nodeRect) {
        const { height: height, width: width } = nodeRect;
        return isVertical ? height : width;
    }
    function getStartEdge() {
        if (isVertical) return 'top';
        return isRightToLeft ? 'right' : 'left';
    }
    function getEndEdge() {
        if (isVertical) return 'bottom';
        return isRightToLeft ? 'left' : 'right';
    }
    function direction(n) {
        return n * sign;
    }
    const self = {
        scroll: scroll,
        cross: cross,
        startEdge: startEdge,
        endEdge: endEdge,
        measureSize: measureSize,
        direction: direction
    };
    return self;
}
function $beb68572c1766b4f$var$Limit(min = 0, max = 0) {
    const length = $beb68572c1766b4f$var$mathAbs(min - max);
    function reachedMin(n) {
        return n < min;
    }
    function reachedMax(n) {
        return n > max;
    }
    function reachedAny(n) {
        return reachedMin(n) || reachedMax(n);
    }
    function constrain(n) {
        if (!reachedAny(n)) return n;
        return reachedMin(n) ? min : max;
    }
    function removeOffset(n) {
        if (!length) return n;
        return n - length * Math.ceil((n - max) / length);
    }
    const self = {
        length: length,
        max: max,
        min: min,
        constrain: constrain,
        reachedAny: reachedAny,
        reachedMax: reachedMax,
        reachedMin: reachedMin,
        removeOffset: removeOffset
    };
    return self;
}
function $beb68572c1766b4f$var$Counter(max, start, loop) {
    const { constrain: constrain } = $beb68572c1766b4f$var$Limit(0, max);
    const loopEnd = max + 1;
    let counter = withinLimit(start);
    function withinLimit(n) {
        return !loop ? constrain(n) : $beb68572c1766b4f$var$mathAbs((loopEnd + n) % loopEnd);
    }
    function get() {
        return counter;
    }
    function set(n) {
        counter = withinLimit(n);
        return self;
    }
    function add(n) {
        return clone().set(get() + n);
    }
    function clone() {
        return $beb68572c1766b4f$var$Counter(max, get(), loop);
    }
    const self = {
        get: get,
        set: set,
        add: add,
        clone: clone
    };
    return self;
}
function $beb68572c1766b4f$var$DragHandler(axis, rootNode, ownerDocument, ownerWindow, target, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, baseFriction, watchDrag) {
    const { cross: crossAxis, direction: direction } = axis;
    const focusNodes = [
        'INPUT',
        'SELECT',
        'TEXTAREA'
    ];
    const nonPassiveEvent = {
        passive: false
    };
    const initEvents = $beb68572c1766b4f$var$EventStore();
    const dragEvents = $beb68572c1766b4f$var$EventStore();
    const goToNextThreshold = $beb68572c1766b4f$var$Limit(50, 225).constrain(percentOfView.measure(20));
    const snapForceBoost = {
        mouse: 300,
        touch: 400
    };
    const freeForceBoost = {
        mouse: 500,
        touch: 600
    };
    const baseSpeed = dragFree ? 43 : 25;
    let isMoving = false;
    let startScroll = 0;
    let startCross = 0;
    let pointerIsDown = false;
    let preventScroll = false;
    let preventClick = false;
    let isMouse = false;
    function init(emblaApi) {
        if (!watchDrag) return;
        function downIfAllowed(evt) {
            if ($beb68572c1766b4f$var$isBoolean(watchDrag) || watchDrag(emblaApi, evt)) down(evt);
        }
        const node = rootNode;
        initEvents.add(node, 'dragstart', (evt)=>evt.preventDefault(), nonPassiveEvent).add(node, 'touchmove', ()=>undefined, nonPassiveEvent).add(node, 'touchend', ()=>undefined).add(node, 'touchstart', downIfAllowed).add(node, 'mousedown', downIfAllowed).add(node, 'touchcancel', up).add(node, 'contextmenu', up).add(node, 'click', click, true);
    }
    function destroy() {
        initEvents.clear();
        dragEvents.clear();
    }
    function addDragEvents() {
        const node = isMouse ? ownerDocument : rootNode;
        dragEvents.add(node, 'touchmove', move, nonPassiveEvent).add(node, 'touchend', up).add(node, 'mousemove', move, nonPassiveEvent).add(node, 'mouseup', up);
    }
    function isFocusNode(node) {
        const nodeName = node.nodeName || '';
        return focusNodes.includes(nodeName);
    }
    function forceBoost() {
        const boost = dragFree ? freeForceBoost : snapForceBoost;
        const type = isMouse ? 'mouse' : 'touch';
        return boost[type];
    }
    function allowedForce(force, targetChanged) {
        const next = index.add($beb68572c1766b4f$var$mathSign(force) * -1);
        const baseForce = scrollTarget.byDistance(force, !dragFree).distance;
        if (dragFree || $beb68572c1766b4f$var$mathAbs(force) < goToNextThreshold) return baseForce;
        if (skipSnaps && targetChanged) return baseForce * 0.5;
        return scrollTarget.byIndex(next.get(), 0).distance;
    }
    function down(evt) {
        const isMouseEvt = $beb68572c1766b4f$var$isMouseEvent(evt, ownerWindow);
        isMouse = isMouseEvt;
        preventClick = dragFree && isMouseEvt && !evt.buttons && isMoving;
        isMoving = $beb68572c1766b4f$var$deltaAbs(target.get(), location.get()) >= 2;
        if (isMouseEvt && evt.button !== 0) return;
        if (isFocusNode(evt.target)) return;
        pointerIsDown = true;
        dragTracker.pointerDown(evt);
        scrollBody.useFriction(0).useDuration(0);
        target.set(location);
        addDragEvents();
        startScroll = dragTracker.readPoint(evt);
        startCross = dragTracker.readPoint(evt, crossAxis);
        eventHandler.emit('pointerDown');
    }
    function move(evt) {
        const isTouchEvt = !$beb68572c1766b4f$var$isMouseEvent(evt, ownerWindow);
        if (isTouchEvt && evt.touches.length >= 2) return up(evt);
        const lastScroll = dragTracker.readPoint(evt);
        const lastCross = dragTracker.readPoint(evt, crossAxis);
        const diffScroll = $beb68572c1766b4f$var$deltaAbs(lastScroll, startScroll);
        const diffCross = $beb68572c1766b4f$var$deltaAbs(lastCross, startCross);
        if (!preventScroll && !isMouse) {
            if (!evt.cancelable) return up(evt);
            preventScroll = diffScroll > diffCross;
            if (!preventScroll) return up(evt);
        }
        const diff = dragTracker.pointerMove(evt);
        if (diffScroll > dragThreshold) preventClick = true;
        scrollBody.useFriction(0.3).useDuration(0.75);
        animation.start();
        target.add(direction(diff));
        evt.preventDefault();
    }
    function up(evt) {
        const currentLocation = scrollTarget.byDistance(0, false);
        const targetChanged = currentLocation.index !== index.get();
        const rawForce = dragTracker.pointerUp(evt) * forceBoost();
        const force = allowedForce(direction(rawForce), targetChanged);
        const forceFactor = $beb68572c1766b4f$var$factorAbs(rawForce, force);
        const speed = baseSpeed - 10 * forceFactor;
        const friction = baseFriction + forceFactor / 50;
        preventScroll = false;
        pointerIsDown = false;
        dragEvents.clear();
        scrollBody.useDuration(speed).useFriction(friction);
        scrollTo.distance(force, !dragFree);
        isMouse = false;
        eventHandler.emit('pointerUp');
    }
    function click(evt) {
        if (preventClick) {
            evt.stopPropagation();
            evt.preventDefault();
            preventClick = false;
        }
    }
    function pointerDown() {
        return pointerIsDown;
    }
    const self = {
        init: init,
        destroy: destroy,
        pointerDown: pointerDown
    };
    return self;
}
function $beb68572c1766b4f$var$DragTracker(axis, ownerWindow) {
    const logInterval = 170;
    let startEvent;
    let lastEvent;
    function readTime(evt) {
        return evt.timeStamp;
    }
    function readPoint(evt, evtAxis) {
        const property = evtAxis || axis.scroll;
        const coord = `client${property === 'x' ? 'X' : 'Y'}`;
        return ($beb68572c1766b4f$var$isMouseEvent(evt, ownerWindow) ? evt : evt.touches[0])[coord];
    }
    function pointerDown(evt) {
        startEvent = evt;
        lastEvent = evt;
        return readPoint(evt);
    }
    function pointerMove(evt) {
        const diff = readPoint(evt) - readPoint(lastEvent);
        const expired = readTime(evt) - readTime(startEvent) > logInterval;
        lastEvent = evt;
        if (expired) startEvent = evt;
        return diff;
    }
    function pointerUp(evt) {
        if (!startEvent || !lastEvent) return 0;
        const diffDrag = readPoint(lastEvent) - readPoint(startEvent);
        const diffTime = readTime(evt) - readTime(startEvent);
        const expired = readTime(evt) - readTime(lastEvent) > logInterval;
        const force = diffDrag / diffTime;
        const isFlick = diffTime && !expired && $beb68572c1766b4f$var$mathAbs(force) > 0.1;
        return isFlick ? force : 0;
    }
    const self = {
        pointerDown: pointerDown,
        pointerMove: pointerMove,
        pointerUp: pointerUp,
        readPoint: readPoint
    };
    return self;
}
function $beb68572c1766b4f$var$NodeRects() {
    function measure(node) {
        const { offsetTop: offsetTop, offsetLeft: offsetLeft, offsetWidth: offsetWidth, offsetHeight: offsetHeight } = node;
        const offset = {
            top: offsetTop,
            right: offsetLeft + offsetWidth,
            bottom: offsetTop + offsetHeight,
            left: offsetLeft,
            width: offsetWidth,
            height: offsetHeight
        };
        return offset;
    }
    const self = {
        measure: measure
    };
    return self;
}
function $beb68572c1766b4f$var$PercentOfView(viewSize) {
    function measure(n) {
        return viewSize * (n / 100);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $beb68572c1766b4f$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects) {
    const observeNodes = [
        container
    ].concat(slides);
    let resizeObserver;
    let containerSize;
    let slideSizes = [];
    let destroyed = false;
    function readSize(node) {
        return axis.measureSize(nodeRects.measure(node));
    }
    function init(emblaApi) {
        if (!watchResize) return;
        containerSize = readSize(container);
        slideSizes = slides.map(readSize);
        function defaultCallback(entries) {
            for (const entry of entries){
                if (destroyed) return;
                const isContainer = entry.target === container;
                const slideIndex = slides.indexOf(entry.target);
                const lastSize = isContainer ? containerSize : slideSizes[slideIndex];
                const newSize = readSize(isContainer ? container : slides[slideIndex]);
                const diffSize = $beb68572c1766b4f$var$mathAbs(newSize - lastSize);
                if (diffSize >= 0.5) {
                    emblaApi.reInit();
                    eventHandler.emit('resize');
                    break;
                }
            }
        }
        resizeObserver = new ResizeObserver((entries)=>{
            if ($beb68572c1766b4f$var$isBoolean(watchResize) || watchResize(emblaApi, entries)) defaultCallback(entries);
        });
        ownerWindow.requestAnimationFrame(()=>{
            observeNodes.forEach((node)=>resizeObserver.observe(node));
        });
    }
    function destroy() {
        destroyed = true;
        if (resizeObserver) resizeObserver.disconnect();
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $beb68572c1766b4f$var$ScrollBody(location, offsetLocation, previousLocation, target, baseDuration, baseFriction) {
    let scrollVelocity = 0;
    let scrollDirection = 0;
    let scrollDuration = baseDuration;
    let scrollFriction = baseFriction;
    let rawLocation = location.get();
    let rawLocationPrevious = 0;
    function seek() {
        const displacement = target.get() - location.get();
        const isInstant = !scrollDuration;
        let scrollDistance = 0;
        if (isInstant) {
            scrollVelocity = 0;
            previousLocation.set(target);
            location.set(target);
            scrollDistance = displacement;
        } else {
            previousLocation.set(location);
            scrollVelocity += displacement / scrollDuration;
            scrollVelocity *= scrollFriction;
            rawLocation += scrollVelocity;
            location.add(scrollVelocity);
            scrollDistance = rawLocation - rawLocationPrevious;
        }
        scrollDirection = $beb68572c1766b4f$var$mathSign(scrollDistance);
        rawLocationPrevious = rawLocation;
        return self;
    }
    function settled() {
        const diff = target.get() - offsetLocation.get();
        return $beb68572c1766b4f$var$mathAbs(diff) < 0.001;
    }
    function duration() {
        return scrollDuration;
    }
    function direction() {
        return scrollDirection;
    }
    function velocity() {
        return scrollVelocity;
    }
    function useBaseDuration() {
        return useDuration(baseDuration);
    }
    function useBaseFriction() {
        return useFriction(baseFriction);
    }
    function useDuration(n) {
        scrollDuration = n;
        return self;
    }
    function useFriction(n) {
        scrollFriction = n;
        return self;
    }
    const self = {
        direction: direction,
        duration: duration,
        velocity: velocity,
        seek: seek,
        settled: settled,
        useBaseFriction: useBaseFriction,
        useBaseDuration: useBaseDuration,
        useFriction: useFriction,
        useDuration: useDuration
    };
    return self;
}
function $beb68572c1766b4f$var$ScrollBounds(limit, location, target, scrollBody, percentOfView) {
    const pullBackThreshold = percentOfView.measure(10);
    const edgeOffsetTolerance = percentOfView.measure(50);
    const frictionLimit = $beb68572c1766b4f$var$Limit(0.1, 0.99);
    let disabled = false;
    function shouldConstrain() {
        if (disabled) return false;
        if (!limit.reachedAny(target.get())) return false;
        if (!limit.reachedAny(location.get())) return false;
        return true;
    }
    function constrain(pointerDown) {
        if (!shouldConstrain()) return;
        const edge = limit.reachedMin(location.get()) ? 'min' : 'max';
        const diffToEdge = $beb68572c1766b4f$var$mathAbs(limit[edge] - location.get());
        const diffToTarget = target.get() - location.get();
        const friction = frictionLimit.constrain(diffToEdge / edgeOffsetTolerance);
        target.subtract(diffToTarget * friction);
        if (!pointerDown && $beb68572c1766b4f$var$mathAbs(diffToTarget) < pullBackThreshold) {
            target.set(limit.constrain(target.get()));
            scrollBody.useDuration(25).useBaseFriction();
        }
    }
    function toggleActive(active) {
        disabled = !active;
    }
    const self = {
        shouldConstrain: shouldConstrain,
        constrain: constrain,
        toggleActive: toggleActive
    };
    return self;
}
function $beb68572c1766b4f$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance) {
    const scrollBounds = $beb68572c1766b4f$var$Limit(-contentSize + viewSize, 0);
    const snapsBounded = measureBounded();
    const scrollContainLimit = findScrollContainLimit();
    const snapsContained = measureContained();
    function usePixelTolerance(bound, snap) {
        return $beb68572c1766b4f$var$deltaAbs(bound, snap) <= 1;
    }
    function findScrollContainLimit() {
        const startSnap = snapsBounded[0];
        const endSnap = $beb68572c1766b4f$var$arrayLast(snapsBounded);
        const min = snapsBounded.lastIndexOf(startSnap);
        const max = snapsBounded.indexOf(endSnap) + 1;
        return $beb68572c1766b4f$var$Limit(min, max);
    }
    function measureBounded() {
        return snapsAligned.map((snapAligned, index)=>{
            const { min: min, max: max } = scrollBounds;
            const snap = scrollBounds.constrain(snapAligned);
            const isFirst = !index;
            const isLast = $beb68572c1766b4f$var$arrayIsLastIndex(snapsAligned, index);
            if (isFirst) return max;
            if (isLast) return min;
            if (usePixelTolerance(min, snap)) return min;
            if (usePixelTolerance(max, snap)) return max;
            return snap;
        }).map((scrollBound)=>parseFloat(scrollBound.toFixed(3)));
    }
    function measureContained() {
        if (contentSize <= viewSize + pixelTolerance) return [
            scrollBounds.max
        ];
        if (containScroll === 'keepSnaps') return snapsBounded;
        const { min: min, max: max } = scrollContainLimit;
        return snapsBounded.slice(min, max);
    }
    const self = {
        snapsContained: snapsContained,
        scrollContainLimit: scrollContainLimit
    };
    return self;
}
function $beb68572c1766b4f$var$ScrollLimit(contentSize, scrollSnaps, loop) {
    const max = scrollSnaps[0];
    const min = loop ? max - contentSize : $beb68572c1766b4f$var$arrayLast(scrollSnaps);
    const limit = $beb68572c1766b4f$var$Limit(min, max);
    const self = {
        limit: limit
    };
    return self;
}
function $beb68572c1766b4f$var$ScrollLooper(contentSize, limit, location, vectors) {
    const jointSafety = 0.1;
    const min = limit.min + jointSafety;
    const max = limit.max + jointSafety;
    const { reachedMin: reachedMin, reachedMax: reachedMax } = $beb68572c1766b4f$var$Limit(min, max);
    function shouldLoop(direction) {
        if (direction === 1) return reachedMax(location.get());
        if (direction === -1) return reachedMin(location.get());
        return false;
    }
    function loop(direction) {
        if (!shouldLoop(direction)) return;
        const loopDistance = contentSize * (direction * -1);
        vectors.forEach((v)=>v.add(loopDistance));
    }
    const self = {
        loop: loop
    };
    return self;
}
function $beb68572c1766b4f$var$ScrollProgress(limit) {
    const { max: max, length: length } = limit;
    function get(n) {
        const currentLocation = n - max;
        return length ? currentLocation / -length : 0;
    }
    const self = {
        get: get
    };
    return self;
}
function $beb68572c1766b4f$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll) {
    const { startEdge: startEdge, endEdge: endEdge } = axis;
    const { groupSlides: groupSlides } = slidesToScroll;
    const alignments = measureSizes().map(alignment.measure);
    const snaps = measureUnaligned();
    const snapsAligned = measureAligned();
    function measureSizes() {
        return groupSlides(slideRects).map((rects)=>$beb68572c1766b4f$var$arrayLast(rects)[endEdge] - rects[0][startEdge]).map($beb68572c1766b4f$var$mathAbs);
    }
    function measureUnaligned() {
        return slideRects.map((rect)=>containerRect[startEdge] - rect[startEdge]).map((snap)=>-$beb68572c1766b4f$var$mathAbs(snap));
    }
    function measureAligned() {
        return groupSlides(snaps).map((g)=>g[0]).map((snap, index)=>snap + alignments[index]);
    }
    const self = {
        snaps: snaps,
        snapsAligned: snapsAligned
    };
    return self;
}
function $beb68572c1766b4f$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes) {
    const { groupSlides: groupSlides } = slidesToScroll;
    const { min: min, max: max } = scrollContainLimit;
    const slideRegistry = createSlideRegistry();
    function createSlideRegistry() {
        const groupedSlideIndexes = groupSlides(slideIndexes);
        const doNotContain = !containSnaps || containScroll === 'keepSnaps';
        if (scrollSnaps.length === 1) return [
            slideIndexes
        ];
        if (doNotContain) return groupedSlideIndexes;
        return groupedSlideIndexes.slice(min, max).map((group, index, groups)=>{
            const isFirst = !index;
            const isLast = $beb68572c1766b4f$var$arrayIsLastIndex(groups, index);
            if (isFirst) {
                const range = $beb68572c1766b4f$var$arrayLast(groups[0]) + 1;
                return $beb68572c1766b4f$var$arrayFromNumber(range);
            }
            if (isLast) {
                const range = $beb68572c1766b4f$var$arrayLastIndex(slideIndexes) - $beb68572c1766b4f$var$arrayLast(groups)[0] + 1;
                return $beb68572c1766b4f$var$arrayFromNumber(range, $beb68572c1766b4f$var$arrayLast(groups)[0]);
            }
            return group;
        });
    }
    const self = {
        slideRegistry: slideRegistry
    };
    return self;
}
function $beb68572c1766b4f$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
    const { reachedAny: reachedAny, removeOffset: removeOffset, constrain: constrain } = limit;
    function minDistance(distances) {
        return distances.concat().sort((a, b)=>$beb68572c1766b4f$var$mathAbs(a) - $beb68572c1766b4f$var$mathAbs(b))[0];
    }
    function findTargetSnap(target) {
        const distance = loop ? removeOffset(target) : constrain(target);
        const ascDiffsToSnaps = scrollSnaps.map((snap, index)=>({
                diff: shortcut(snap - distance, 0),
                index: index
            })).sort((d1, d2)=>$beb68572c1766b4f$var$mathAbs(d1.diff) - $beb68572c1766b4f$var$mathAbs(d2.diff));
        const { index: index } = ascDiffsToSnaps[0];
        return {
            index: index,
            distance: distance
        };
    }
    function shortcut(target, direction) {
        const targets = [
            target,
            target + contentSize,
            target - contentSize
        ];
        if (!loop) return target;
        if (!direction) return minDistance(targets);
        const matchingTargets = targets.filter((t)=>$beb68572c1766b4f$var$mathSign(t) === direction);
        if (matchingTargets.length) return minDistance(matchingTargets);
        return $beb68572c1766b4f$var$arrayLast(targets) - contentSize;
    }
    function byIndex(index, direction) {
        const diffToSnap = scrollSnaps[index] - targetVector.get();
        const distance = shortcut(diffToSnap, direction);
        return {
            index: index,
            distance: distance
        };
    }
    function byDistance(distance, snap) {
        const target = targetVector.get() + distance;
        const { index: index, distance: targetSnapDistance } = findTargetSnap(target);
        const reachedBound = !loop && reachedAny(target);
        if (!snap || reachedBound) return {
            index: index,
            distance: distance
        };
        const diffToSnap = scrollSnaps[index] - targetSnapDistance;
        const snapDistance = distance + shortcut(diffToSnap, 0);
        return {
            index: index,
            distance: snapDistance
        };
    }
    const self = {
        byDistance: byDistance,
        byIndex: byIndex,
        shortcut: shortcut
    };
    return self;
}
function $beb68572c1766b4f$var$ScrollTo(animation, indexCurrent, indexPrevious, scrollBody, scrollTarget, targetVector, eventHandler) {
    function scrollTo(target) {
        const distanceDiff = target.distance;
        const indexDiff = target.index !== indexCurrent.get();
        targetVector.add(distanceDiff);
        if (distanceDiff) {
            if (scrollBody.duration()) animation.start();
            else {
                animation.update();
                animation.render(1);
                animation.update();
            }
        }
        if (indexDiff) {
            indexPrevious.set(indexCurrent.get());
            indexCurrent.set(target.index);
            eventHandler.emit('select');
        }
    }
    function distance(n, snap) {
        const target = scrollTarget.byDistance(n, snap);
        scrollTo(target);
    }
    function index(n, direction) {
        const targetIndex = indexCurrent.clone().set(n);
        const target = scrollTarget.byIndex(targetIndex.get(), direction);
        scrollTo(target);
    }
    const self = {
        distance: distance,
        index: index
    };
    return self;
}
function $beb68572c1766b4f$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus) {
    const focusListenerOptions = {
        passive: true,
        capture: true
    };
    let lastTabPressTime = 0;
    function init(emblaApi) {
        if (!watchFocus) return;
        function defaultCallback(index) {
            const nowTime = new Date().getTime();
            const diffTime = nowTime - lastTabPressTime;
            if (diffTime > 10) return;
            eventHandler.emit('slideFocusStart');
            root.scrollLeft = 0;
            const group = slideRegistry.findIndex((group)=>group.includes(index));
            if (!$beb68572c1766b4f$var$isNumber(group)) return;
            scrollBody.useDuration(0);
            scrollTo.index(group, 0);
            eventHandler.emit('slideFocus');
        }
        eventStore.add(document, 'keydown', registerTabPress, false);
        slides.forEach((slide, slideIndex)=>{
            eventStore.add(slide, 'focus', (evt)=>{
                if ($beb68572c1766b4f$var$isBoolean(watchFocus) || watchFocus(emblaApi, evt)) defaultCallback(slideIndex);
            }, focusListenerOptions);
        });
    }
    function registerTabPress(event) {
        if (event.code === 'Tab') lastTabPressTime = new Date().getTime();
    }
    const self = {
        init: init
    };
    return self;
}
function $beb68572c1766b4f$var$Vector1D(initialValue) {
    let value = initialValue;
    function get() {
        return value;
    }
    function set(n) {
        value = normalizeInput(n);
    }
    function add(n) {
        value += normalizeInput(n);
    }
    function subtract(n) {
        value -= normalizeInput(n);
    }
    function normalizeInput(n) {
        return $beb68572c1766b4f$var$isNumber(n) ? n : n.get();
    }
    const self = {
        get: get,
        set: set,
        add: add,
        subtract: subtract
    };
    return self;
}
function $beb68572c1766b4f$var$Translate(axis, container) {
    const translate = axis.scroll === 'x' ? x : y;
    const containerStyle = container.style;
    let previousTarget = null;
    let disabled = false;
    function x(n) {
        return `translate3d(${n}px,0px,0px)`;
    }
    function y(n) {
        return `translate3d(0px,${n}px,0px)`;
    }
    function to(target) {
        if (disabled) return;
        const newTarget = $beb68572c1766b4f$var$roundToTwoDecimals(axis.direction(target));
        if (newTarget === previousTarget) return;
        containerStyle.transform = translate(newTarget);
        previousTarget = newTarget;
    }
    function toggleActive(active) {
        disabled = !active;
    }
    function clear() {
        if (disabled) return;
        containerStyle.transform = '';
        if (!container.getAttribute('style')) container.removeAttribute('style');
    }
    const self = {
        clear: clear,
        to: to,
        toggleActive: toggleActive
    };
    return self;
}
function $beb68572c1766b4f$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, location, slides) {
    const roundingSafety = 0.5;
    const ascItems = $beb68572c1766b4f$var$arrayKeys(slideSizesWithGaps);
    const descItems = $beb68572c1766b4f$var$arrayKeys(slideSizesWithGaps).reverse();
    const loopPoints = startPoints().concat(endPoints());
    function removeSlideSizes(indexes, from) {
        return indexes.reduce((a, i)=>{
            return a - slideSizesWithGaps[i];
        }, from);
    }
    function slidesInGap(indexes, gap) {
        return indexes.reduce((a, i)=>{
            const remainingGap = removeSlideSizes(a, gap);
            return remainingGap > 0 ? a.concat([
                i
            ]) : a;
        }, []);
    }
    function findSlideBounds(offset) {
        return snaps.map((snap, index)=>({
                start: snap - slideSizes[index] + roundingSafety + offset,
                end: snap + viewSize - roundingSafety + offset
            }));
    }
    function findLoopPoints(indexes, offset, isEndEdge) {
        const slideBounds = findSlideBounds(offset);
        return indexes.map((index)=>{
            const initial = isEndEdge ? 0 : -contentSize;
            const altered = isEndEdge ? contentSize : 0;
            const boundEdge = isEndEdge ? 'end' : 'start';
            const loopPoint = slideBounds[index][boundEdge];
            return {
                index: index,
                loopPoint: loopPoint,
                slideLocation: $beb68572c1766b4f$var$Vector1D(-1),
                translate: $beb68572c1766b4f$var$Translate(axis, slides[index]),
                target: ()=>location.get() > loopPoint ? initial : altered
            };
        });
    }
    function startPoints() {
        const gap = scrollSnaps[0];
        const indexes = slidesInGap(descItems, gap);
        return findLoopPoints(indexes, contentSize, false);
    }
    function endPoints() {
        const gap = viewSize - scrollSnaps[0] - 1;
        const indexes = slidesInGap(ascItems, gap);
        return findLoopPoints(indexes, -contentSize, true);
    }
    function canLoop() {
        return loopPoints.every(({ index: index })=>{
            const otherIndexes = ascItems.filter((i)=>i !== index);
            return removeSlideSizes(otherIndexes, viewSize) <= 0.1;
        });
    }
    function loop() {
        loopPoints.forEach((loopPoint)=>{
            const { target: target, translate: translate, slideLocation: slideLocation } = loopPoint;
            const shiftLocation = target();
            if (shiftLocation === slideLocation.get()) return;
            translate.to(shiftLocation);
            slideLocation.set(shiftLocation);
        });
    }
    function clear() {
        loopPoints.forEach((loopPoint)=>loopPoint.translate.clear());
    }
    const self = {
        canLoop: canLoop,
        clear: clear,
        loop: loop,
        loopPoints: loopPoints
    };
    return self;
}
function $beb68572c1766b4f$var$SlidesHandler(container, eventHandler, watchSlides) {
    let mutationObserver;
    let destroyed = false;
    function init(emblaApi) {
        if (!watchSlides) return;
        function defaultCallback(mutations) {
            for (const mutation of mutations)if (mutation.type === 'childList') {
                emblaApi.reInit();
                eventHandler.emit('slidesChanged');
                break;
            }
        }
        mutationObserver = new MutationObserver((mutations)=>{
            if (destroyed) return;
            if ($beb68572c1766b4f$var$isBoolean(watchSlides) || watchSlides(emblaApi, mutations)) defaultCallback(mutations);
        });
        mutationObserver.observe(container, {
            childList: true
        });
    }
    function destroy() {
        if (mutationObserver) mutationObserver.disconnect();
        destroyed = true;
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $beb68572c1766b4f$var$SlidesInView(container, slides, eventHandler, threshold) {
    const intersectionEntryMap = {};
    let inViewCache = null;
    let notInViewCache = null;
    let intersectionObserver;
    let destroyed = false;
    function init() {
        intersectionObserver = new IntersectionObserver((entries)=>{
            if (destroyed) return;
            entries.forEach((entry)=>{
                const index = slides.indexOf(entry.target);
                intersectionEntryMap[index] = entry;
            });
            inViewCache = null;
            notInViewCache = null;
            eventHandler.emit('slidesInView');
        }, {
            root: container.parentElement,
            threshold: threshold
        });
        slides.forEach((slide)=>intersectionObserver.observe(slide));
    }
    function destroy() {
        if (intersectionObserver) intersectionObserver.disconnect();
        destroyed = true;
    }
    function createInViewList(inView) {
        return $beb68572c1766b4f$var$objectKeys(intersectionEntryMap).reduce((list, slideIndex)=>{
            const index = parseInt(slideIndex);
            const { isIntersecting: isIntersecting } = intersectionEntryMap[index];
            const inViewMatch = inView && isIntersecting;
            const notInViewMatch = !inView && !isIntersecting;
            if (inViewMatch || notInViewMatch) list.push(index);
            return list;
        }, []);
    }
    function get(inView = true) {
        if (inView && inViewCache) return inViewCache;
        if (!inView && notInViewCache) return notInViewCache;
        const slideIndexes = createInViewList(inView);
        if (inView) inViewCache = slideIndexes;
        if (!inView) notInViewCache = slideIndexes;
        return slideIndexes;
    }
    const self = {
        init: init,
        destroy: destroy,
        get: get
    };
    return self;
}
function $beb68572c1766b4f$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow) {
    const { measureSize: measureSize, startEdge: startEdge, endEdge: endEdge } = axis;
    const withEdgeGap = slideRects[0] && readEdgeGap;
    const startGap = measureStartGap();
    const endGap = measureEndGap();
    const slideSizes = slideRects.map(measureSize);
    const slideSizesWithGaps = measureWithGaps();
    function measureStartGap() {
        if (!withEdgeGap) return 0;
        const slideRect = slideRects[0];
        return $beb68572c1766b4f$var$mathAbs(containerRect[startEdge] - slideRect[startEdge]);
    }
    function measureEndGap() {
        if (!withEdgeGap) return 0;
        const style = ownerWindow.getComputedStyle($beb68572c1766b4f$var$arrayLast(slides));
        return parseFloat(style.getPropertyValue(`margin-${endEdge}`));
    }
    function measureWithGaps() {
        return slideRects.map((rect, index, rects)=>{
            const isFirst = !index;
            const isLast = $beb68572c1766b4f$var$arrayIsLastIndex(rects, index);
            if (isFirst) return slideSizes[index] + startGap;
            if (isLast) return slideSizes[index] + endGap;
            return rects[index + 1][startEdge] - rect[startEdge];
        }).map($beb68572c1766b4f$var$mathAbs);
    }
    const self = {
        slideSizes: slideSizes,
        slideSizesWithGaps: slideSizesWithGaps,
        startGap: startGap,
        endGap: endGap
    };
    return self;
}
function $beb68572c1766b4f$var$SlidesToScroll(axis, viewSize, slidesToScroll, loop, containerRect, slideRects, startGap, endGap, pixelTolerance) {
    const { startEdge: startEdge, endEdge: endEdge, direction: direction } = axis;
    const groupByNumber = $beb68572c1766b4f$var$isNumber(slidesToScroll);
    function byNumber(array, groupSize) {
        return $beb68572c1766b4f$var$arrayKeys(array).filter((i)=>i % groupSize === 0).map((i)=>array.slice(i, i + groupSize));
    }
    function bySize(array) {
        if (!array.length) return [];
        return $beb68572c1766b4f$var$arrayKeys(array).reduce((groups, rectB, index)=>{
            const rectA = $beb68572c1766b4f$var$arrayLast(groups) || 0;
            const isFirst = rectA === 0;
            const isLast = rectB === $beb68572c1766b4f$var$arrayLastIndex(array);
            const edgeA = containerRect[startEdge] - slideRects[rectA][startEdge];
            const edgeB = containerRect[startEdge] - slideRects[rectB][endEdge];
            const gapA = !loop && isFirst ? direction(startGap) : 0;
            const gapB = !loop && isLast ? direction(endGap) : 0;
            const chunkSize = $beb68572c1766b4f$var$mathAbs(edgeB - gapB - (edgeA + gapA));
            if (index && chunkSize > viewSize + pixelTolerance) groups.push(rectB);
            if (isLast) groups.push(array.length);
            return groups;
        }, []).map((currentSize, index, groups)=>{
            const previousSize = Math.max(groups[index - 1] || 0);
            return array.slice(previousSize, currentSize);
        });
    }
    function groupSlides(array) {
        return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
    }
    const self = {
        groupSlides: groupSlides
    };
    return self;
}
function $beb68572c1766b4f$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler) {
    // Options
    const { align: align, axis: scrollAxis, direction: direction, startIndex: startIndex, loop: loop, duration: duration, dragFree: dragFree, dragThreshold: dragThreshold, inViewThreshold: inViewThreshold, slidesToScroll: groupSlides, skipSnaps: skipSnaps, containScroll: containScroll, watchResize: watchResize, watchSlides: watchSlides, watchDrag: watchDrag, watchFocus: watchFocus } = options;
    // Measurements
    const pixelTolerance = 2;
    const nodeRects = $beb68572c1766b4f$var$NodeRects();
    const containerRect = nodeRects.measure(container);
    const slideRects = slides.map(nodeRects.measure);
    const axis = $beb68572c1766b4f$var$Axis(scrollAxis, direction);
    const viewSize = axis.measureSize(containerRect);
    const percentOfView = $beb68572c1766b4f$var$PercentOfView(viewSize);
    const alignment = $beb68572c1766b4f$var$Alignment(align, viewSize);
    const containSnaps = !loop && !!containScroll;
    const readEdgeGap = loop || !!containScroll;
    const { slideSizes: slideSizes, slideSizesWithGaps: slideSizesWithGaps, startGap: startGap, endGap: endGap } = $beb68572c1766b4f$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow);
    const slidesToScroll = $beb68572c1766b4f$var$SlidesToScroll(axis, viewSize, groupSlides, loop, containerRect, slideRects, startGap, endGap, pixelTolerance);
    const { snaps: snaps, snapsAligned: snapsAligned } = $beb68572c1766b4f$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll);
    const contentSize = -$beb68572c1766b4f$var$arrayLast(snaps) + $beb68572c1766b4f$var$arrayLast(slideSizesWithGaps);
    const { snapsContained: snapsContained, scrollContainLimit: scrollContainLimit } = $beb68572c1766b4f$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance);
    const scrollSnaps = containSnaps ? snapsContained : snapsAligned;
    const { limit: limit } = $beb68572c1766b4f$var$ScrollLimit(contentSize, scrollSnaps, loop);
    // Indexes
    const index = $beb68572c1766b4f$var$Counter($beb68572c1766b4f$var$arrayLastIndex(scrollSnaps), startIndex, loop);
    const indexPrevious = index.clone();
    const slideIndexes = $beb68572c1766b4f$var$arrayKeys(slides);
    // Animation
    const update = ({ dragHandler: dragHandler, scrollBody: scrollBody, scrollBounds: scrollBounds, options: { loop: loop } })=>{
        if (!loop) scrollBounds.constrain(dragHandler.pointerDown());
        scrollBody.seek();
    };
    const render = ({ scrollBody: scrollBody, translate: translate, location: location, offsetLocation: offsetLocation, previousLocation: previousLocation, scrollLooper: scrollLooper, slideLooper: slideLooper, dragHandler: dragHandler, animation: animation, eventHandler: eventHandler, scrollBounds: scrollBounds, options: { loop: loop } }, alpha)=>{
        const shouldSettle = scrollBody.settled();
        const withinBounds = !scrollBounds.shouldConstrain();
        const hasSettled = loop ? shouldSettle : shouldSettle && withinBounds;
        const hasSettledAndIdle = hasSettled && !dragHandler.pointerDown();
        if (hasSettledAndIdle) animation.stop();
        const interpolatedLocation = location.get() * alpha + previousLocation.get() * (1 - alpha);
        offsetLocation.set(interpolatedLocation);
        if (loop) {
            scrollLooper.loop(scrollBody.direction());
            slideLooper.loop();
        }
        translate.to(offsetLocation.get());
        if (hasSettledAndIdle) eventHandler.emit('settle');
        if (!hasSettled) eventHandler.emit('scroll');
    };
    const animation = $beb68572c1766b4f$var$Animations(ownerDocument, ownerWindow, ()=>update(engine), (alpha)=>render(engine, alpha));
    // Shared
    const friction = 0.68;
    const startLocation = scrollSnaps[index.get()];
    const location = $beb68572c1766b4f$var$Vector1D(startLocation);
    const previousLocation = $beb68572c1766b4f$var$Vector1D(startLocation);
    const offsetLocation = $beb68572c1766b4f$var$Vector1D(startLocation);
    const target = $beb68572c1766b4f$var$Vector1D(startLocation);
    const scrollBody = $beb68572c1766b4f$var$ScrollBody(location, offsetLocation, previousLocation, target, duration, friction);
    const scrollTarget = $beb68572c1766b4f$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
    const scrollTo = $beb68572c1766b4f$var$ScrollTo(animation, index, indexPrevious, scrollBody, scrollTarget, target, eventHandler);
    const scrollProgress = $beb68572c1766b4f$var$ScrollProgress(limit);
    const eventStore = $beb68572c1766b4f$var$EventStore();
    const slidesInView = $beb68572c1766b4f$var$SlidesInView(container, slides, eventHandler, inViewThreshold);
    const { slideRegistry: slideRegistry } = $beb68572c1766b4f$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes);
    const slideFocus = $beb68572c1766b4f$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus);
    // Engine
    const engine = {
        ownerDocument: ownerDocument,
        ownerWindow: ownerWindow,
        eventHandler: eventHandler,
        containerRect: containerRect,
        slideRects: slideRects,
        animation: animation,
        axis: axis,
        dragHandler: $beb68572c1766b4f$var$DragHandler(axis, root, ownerDocument, ownerWindow, target, $beb68572c1766b4f$var$DragTracker(axis, ownerWindow), location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, friction, watchDrag),
        eventStore: eventStore,
        percentOfView: percentOfView,
        index: index,
        indexPrevious: indexPrevious,
        limit: limit,
        location: location,
        offsetLocation: offsetLocation,
        previousLocation: previousLocation,
        options: options,
        resizeHandler: $beb68572c1766b4f$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects),
        scrollBody: scrollBody,
        scrollBounds: $beb68572c1766b4f$var$ScrollBounds(limit, offsetLocation, target, scrollBody, percentOfView),
        scrollLooper: $beb68572c1766b4f$var$ScrollLooper(contentSize, limit, offsetLocation, [
            location,
            offsetLocation,
            previousLocation,
            target
        ]),
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnaps.map(scrollProgress.get),
        scrollSnaps: scrollSnaps,
        scrollTarget: scrollTarget,
        scrollTo: scrollTo,
        slideLooper: $beb68572c1766b4f$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides),
        slideFocus: slideFocus,
        slidesHandler: $beb68572c1766b4f$var$SlidesHandler(container, eventHandler, watchSlides),
        slidesInView: slidesInView,
        slideIndexes: slideIndexes,
        slideRegistry: slideRegistry,
        slidesToScroll: slidesToScroll,
        target: target,
        translate: $beb68572c1766b4f$var$Translate(axis, container)
    };
    return engine;
}
function $beb68572c1766b4f$var$EventHandler() {
    let listeners = {};
    let api;
    function init(emblaApi) {
        api = emblaApi;
    }
    function getListeners(evt) {
        return listeners[evt] || [];
    }
    function emit(evt) {
        getListeners(evt).forEach((e)=>e(api, evt));
        return self;
    }
    function on(evt, cb) {
        listeners[evt] = getListeners(evt).concat([
            cb
        ]);
        return self;
    }
    function off(evt, cb) {
        listeners[evt] = getListeners(evt).filter((e)=>e !== cb);
        return self;
    }
    function clear() {
        listeners = {};
    }
    const self = {
        init: init,
        emit: emit,
        off: off,
        on: on,
        clear: clear
    };
    return self;
}
const $beb68572c1766b4f$var$defaultOptions = {
    align: 'center',
    axis: 'x',
    container: null,
    slides: null,
    containScroll: 'trimSnaps',
    direction: 'ltr',
    slidesToScroll: 1,
    inViewThreshold: 0,
    breakpoints: {},
    dragFree: false,
    dragThreshold: 10,
    loop: false,
    skipSnaps: false,
    duration: 25,
    startIndex: 0,
    active: true,
    watchDrag: true,
    watchResize: true,
    watchSlides: true,
    watchFocus: true
};
function $beb68572c1766b4f$var$OptionsHandler(ownerWindow) {
    function mergeOptions(optionsA, optionsB) {
        return $beb68572c1766b4f$var$objectsMergeDeep(optionsA, optionsB || {});
    }
    function optionsAtMedia(options) {
        const optionsAtMedia = options.breakpoints || {};
        const matchedMediaOptions = $beb68572c1766b4f$var$objectKeys(optionsAtMedia).filter((media)=>ownerWindow.matchMedia(media).matches).map((media)=>optionsAtMedia[media]).reduce((a, mediaOption)=>mergeOptions(a, mediaOption), {});
        return mergeOptions(options, matchedMediaOptions);
    }
    function optionsMediaQueries(optionsList) {
        return optionsList.map((options)=>$beb68572c1766b4f$var$objectKeys(options.breakpoints || {})).reduce((acc, mediaQueries)=>acc.concat(mediaQueries), []).map(ownerWindow.matchMedia);
    }
    const self = {
        mergeOptions: mergeOptions,
        optionsAtMedia: optionsAtMedia,
        optionsMediaQueries: optionsMediaQueries
    };
    return self;
}
function $beb68572c1766b4f$var$PluginsHandler(optionsHandler) {
    let activePlugins = [];
    function init(emblaApi, plugins) {
        activePlugins = plugins.filter(({ options: options })=>optionsHandler.optionsAtMedia(options).active !== false);
        activePlugins.forEach((plugin)=>plugin.init(emblaApi, optionsHandler));
        return plugins.reduce((map, plugin)=>Object.assign(map, {
                [plugin.name]: plugin
            }), {});
    }
    function destroy() {
        activePlugins = activePlugins.filter((plugin)=>plugin.destroy());
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $beb68572c1766b4f$export$2e2bcd8739ae039(root, userOptions, userPlugins) {
    const ownerDocument = root.ownerDocument;
    const ownerWindow = ownerDocument.defaultView;
    const optionsHandler = $beb68572c1766b4f$var$OptionsHandler(ownerWindow);
    const pluginsHandler = $beb68572c1766b4f$var$PluginsHandler(optionsHandler);
    const mediaHandlers = $beb68572c1766b4f$var$EventStore();
    const eventHandler = $beb68572c1766b4f$var$EventHandler();
    const { mergeOptions: mergeOptions, optionsAtMedia: optionsAtMedia, optionsMediaQueries: optionsMediaQueries } = optionsHandler;
    const { on: on, off: off, emit: emit } = eventHandler;
    const reInit = reActivate;
    let destroyed = false;
    let engine;
    let optionsBase = mergeOptions($beb68572c1766b4f$var$defaultOptions, $beb68572c1766b4f$export$2e2bcd8739ae039.globalOptions);
    let options = mergeOptions(optionsBase);
    let pluginList = [];
    let pluginApis;
    let container;
    let slides;
    function storeElements() {
        const { container: userContainer, slides: userSlides } = options;
        const customContainer = $beb68572c1766b4f$var$isString(userContainer) ? root.querySelector(userContainer) : userContainer;
        container = customContainer || root.children[0];
        const customSlides = $beb68572c1766b4f$var$isString(userSlides) ? container.querySelectorAll(userSlides) : userSlides;
        slides = [].slice.call(customSlides || container.children);
    }
    function createEngine(options) {
        const engine = $beb68572c1766b4f$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler);
        if (options.loop && !engine.slideLooper.canLoop()) {
            const optionsWithoutLoop = Object.assign({}, options, {
                loop: false
            });
            return createEngine(optionsWithoutLoop);
        }
        return engine;
    }
    function activate(withOptions, withPlugins) {
        if (destroyed) return;
        optionsBase = mergeOptions(optionsBase, withOptions);
        options = optionsAtMedia(optionsBase);
        pluginList = withPlugins || pluginList;
        storeElements();
        engine = createEngine(options);
        optionsMediaQueries([
            optionsBase,
            ...pluginList.map(({ options: options })=>options)
        ]).forEach((query)=>mediaHandlers.add(query, 'change', reActivate));
        if (!options.active) return;
        engine.translate.to(engine.location.get());
        engine.animation.init();
        engine.slidesInView.init();
        engine.slideFocus.init(self);
        engine.eventHandler.init(self);
        engine.resizeHandler.init(self);
        engine.slidesHandler.init(self);
        if (engine.options.loop) engine.slideLooper.loop();
        if (container.offsetParent && slides.length) engine.dragHandler.init(self);
        pluginApis = pluginsHandler.init(self, pluginList);
    }
    function reActivate(withOptions, withPlugins) {
        const startIndex = selectedScrollSnap();
        deActivate();
        activate(mergeOptions({
            startIndex: startIndex
        }, withOptions), withPlugins);
        eventHandler.emit('reInit');
    }
    function deActivate() {
        engine.dragHandler.destroy();
        engine.eventStore.clear();
        engine.translate.clear();
        engine.slideLooper.clear();
        engine.resizeHandler.destroy();
        engine.slidesHandler.destroy();
        engine.slidesInView.destroy();
        engine.animation.destroy();
        pluginsHandler.destroy();
        mediaHandlers.clear();
    }
    function destroy() {
        if (destroyed) return;
        destroyed = true;
        mediaHandlers.clear();
        deActivate();
        eventHandler.emit('destroy');
        eventHandler.clear();
    }
    function scrollTo(index, jump, direction) {
        if (!options.active || destroyed) return;
        engine.scrollBody.useBaseFriction().useDuration(jump === true ? 0 : options.duration);
        engine.scrollTo.index(index, direction || 0);
    }
    function scrollNext(jump) {
        const next = engine.index.add(1).get();
        scrollTo(next, jump, -1);
    }
    function scrollPrev(jump) {
        const prev = engine.index.add(-1).get();
        scrollTo(prev, jump, 1);
    }
    function canScrollNext() {
        const next = engine.index.add(1).get();
        return next !== selectedScrollSnap();
    }
    function canScrollPrev() {
        const prev = engine.index.add(-1).get();
        return prev !== selectedScrollSnap();
    }
    function scrollSnapList() {
        return engine.scrollSnapList;
    }
    function scrollProgress() {
        return engine.scrollProgress.get(engine.offsetLocation.get());
    }
    function selectedScrollSnap() {
        return engine.index.get();
    }
    function previousScrollSnap() {
        return engine.indexPrevious.get();
    }
    function slidesInView() {
        return engine.slidesInView.get();
    }
    function slidesNotInView() {
        return engine.slidesInView.get(false);
    }
    function plugins() {
        return pluginApis;
    }
    function internalEngine() {
        return engine;
    }
    function rootNode() {
        return root;
    }
    function containerNode() {
        return container;
    }
    function slideNodes() {
        return slides;
    }
    const self = {
        canScrollNext: canScrollNext,
        canScrollPrev: canScrollPrev,
        containerNode: containerNode,
        internalEngine: internalEngine,
        destroy: destroy,
        off: off,
        on: on,
        emit: emit,
        plugins: plugins,
        previousScrollSnap: previousScrollSnap,
        reInit: reInit,
        rootNode: rootNode,
        scrollNext: scrollNext,
        scrollPrev: scrollPrev,
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnapList,
        scrollTo: scrollTo,
        selectedScrollSnap: selectedScrollSnap,
        slideNodes: slideNodes,
        slidesInView: slidesInView,
        slidesNotInView: slidesNotInView
    };
    activate(userOptions, userPlugins);
    setTimeout(()=>eventHandler.emit('init'), 0);
    return self;
}
$beb68572c1766b4f$export$2e2bcd8739ae039.globalOptions = undefined;


function $ee80a659baec94a2$export$2e2bcd8739ae039(options = {}, plugins = []) {
    const storedOptions = (0, $gRqVZ.useRef)(options);
    const storedPlugins = (0, $gRqVZ.useRef)(plugins);
    const [emblaApi, setEmblaApi] = (0, $gRqVZ.useState)();
    const [viewport, setViewport] = (0, $gRqVZ.useState)();
    const reInit = (0, $gRqVZ.useCallback)(()=>{
        if (emblaApi) emblaApi.reInit(storedOptions.current, storedPlugins.current);
    }, [
        emblaApi
    ]);
    (0, $gRqVZ.useEffect)(()=>{
        if ((0, $f54f7e013472440a$export$1ace03bbcd701468)(storedOptions.current, options)) return;
        storedOptions.current = options;
        reInit();
    }, [
        options,
        reInit
    ]);
    (0, $gRqVZ.useEffect)(()=>{
        if ((0, $f54f7e013472440a$export$8a8daedc629f7568)(storedPlugins.current, plugins)) return;
        storedPlugins.current = plugins;
        reInit();
    }, [
        plugins,
        reInit
    ]);
    (0, $gRqVZ.useEffect)(()=>{
        if ((0, $f54f7e013472440a$export$71594e8a50f746f4)() && viewport) {
            (0, $beb68572c1766b4f$export$2e2bcd8739ae039).globalOptions = $ee80a659baec94a2$export$2e2bcd8739ae039.globalOptions;
            const newEmblaApi = (0, $beb68572c1766b4f$export$2e2bcd8739ae039)(viewport, storedOptions.current, storedPlugins.current);
            setEmblaApi(newEmblaApi);
            return ()=>newEmblaApi.destroy();
        } else setEmblaApi(undefined);
    }, [
        viewport,
        setEmblaApi
    ]);
    return [
        setViewport,
        emblaApi
    ];
}
$ee80a659baec94a2$export$2e2bcd8739ae039.globalOptions = undefined;


const $b3dde559e8f18f40$var$defaultOptions = {
    active: true,
    breakpoints: {},
    delay: 4000,
    jump: false,
    playOnInit: true,
    stopOnFocusIn: true,
    stopOnInteraction: true,
    stopOnMouseEnter: false,
    stopOnLastSnap: false,
    rootNode: null
};
function $b3dde559e8f18f40$var$normalizeDelay(emblaApi, delay) {
    const scrollSnaps = emblaApi.scrollSnapList();
    if (typeof delay === 'number') return scrollSnaps.map(()=>delay);
    return delay(scrollSnaps, emblaApi);
}
function $b3dde559e8f18f40$var$getAutoplayRootNode(emblaApi, rootNode) {
    const emblaRootNode = emblaApi.rootNode();
    return rootNode && rootNode(emblaRootNode) || emblaRootNode;
}
function $b3dde559e8f18f40$export$2e2bcd8739ae039(userOptions = {}) {
    let options;
    let emblaApi;
    let destroyed;
    let delay;
    let timerStartTime = null;
    let timerId = 0;
    let autoplayActive = false;
    let mouseIsOver = false;
    let playOnDocumentVisible = false;
    let jump = false;
    function init(emblaApiInstance, optionsHandler) {
        emblaApi = emblaApiInstance;
        const { mergeOptions: mergeOptions, optionsAtMedia: optionsAtMedia } = optionsHandler;
        const optionsBase = mergeOptions($b3dde559e8f18f40$var$defaultOptions, $b3dde559e8f18f40$export$2e2bcd8739ae039.globalOptions);
        const allOptions = mergeOptions(optionsBase, userOptions);
        options = optionsAtMedia(allOptions);
        if (emblaApi.scrollSnapList().length <= 1) return;
        jump = options.jump;
        destroyed = false;
        delay = $b3dde559e8f18f40$var$normalizeDelay(emblaApi, options.delay);
        const { eventStore: eventStore, ownerDocument: ownerDocument } = emblaApi.internalEngine();
        const isDraggable = !!emblaApi.internalEngine().options.watchDrag;
        const root = $b3dde559e8f18f40$var$getAutoplayRootNode(emblaApi, options.rootNode);
        eventStore.add(ownerDocument, 'visibilitychange', visibilityChange);
        if (isDraggable) emblaApi.on('pointerDown', pointerDown);
        if (isDraggable && !options.stopOnInteraction) emblaApi.on('pointerUp', pointerUp);
        if (options.stopOnMouseEnter) eventStore.add(root, 'mouseenter', mouseEnter);
        if (options.stopOnMouseEnter && !options.stopOnInteraction) eventStore.add(root, 'mouseleave', mouseLeave);
        if (options.stopOnFocusIn) emblaApi.on('slideFocusStart', stopAutoplay);
        if (options.stopOnFocusIn && !options.stopOnInteraction) eventStore.add(emblaApi.containerNode(), 'focusout', startAutoplay);
        if (options.playOnInit) startAutoplay();
    }
    function destroy() {
        emblaApi.off('pointerDown', pointerDown).off('pointerUp', pointerUp).off('slideFocusStart', stopAutoplay);
        stopAutoplay();
        destroyed = true;
        autoplayActive = false;
    }
    function setTimer() {
        const { ownerWindow: ownerWindow } = emblaApi.internalEngine();
        ownerWindow.clearTimeout(timerId);
        timerId = ownerWindow.setTimeout(next, delay[emblaApi.selectedScrollSnap()]);
        timerStartTime = new Date().getTime();
        emblaApi.emit('autoplay:timerset');
    }
    function clearTimer() {
        const { ownerWindow: ownerWindow } = emblaApi.internalEngine();
        ownerWindow.clearTimeout(timerId);
        timerId = 0;
        timerStartTime = null;
        emblaApi.emit('autoplay:timerstopped');
    }
    function startAutoplay() {
        if (destroyed) return;
        if (documentIsHidden()) {
            playOnDocumentVisible = true;
            return;
        }
        if (!autoplayActive) emblaApi.emit('autoplay:play');
        setTimer();
        autoplayActive = true;
    }
    function stopAutoplay() {
        if (destroyed) return;
        if (autoplayActive) emblaApi.emit('autoplay:stop');
        clearTimer();
        autoplayActive = false;
    }
    function visibilityChange() {
        if (documentIsHidden()) {
            playOnDocumentVisible = autoplayActive;
            return stopAutoplay();
        }
        if (playOnDocumentVisible) startAutoplay();
    }
    function documentIsHidden() {
        const { ownerDocument: ownerDocument } = emblaApi.internalEngine();
        return ownerDocument.visibilityState === 'hidden';
    }
    function pointerDown() {
        if (!mouseIsOver) stopAutoplay();
    }
    function pointerUp() {
        if (!mouseIsOver) startAutoplay();
    }
    function mouseEnter() {
        mouseIsOver = true;
        stopAutoplay();
    }
    function mouseLeave() {
        mouseIsOver = false;
        startAutoplay();
    }
    function play(jumpOverride) {
        if (typeof jumpOverride !== 'undefined') jump = jumpOverride;
        startAutoplay();
    }
    function stop() {
        if (autoplayActive) stopAutoplay();
    }
    function reset() {
        if (autoplayActive) startAutoplay();
    }
    function isPlaying() {
        return autoplayActive;
    }
    function next() {
        const { index: index } = emblaApi.internalEngine();
        const nextIndex = index.clone().add(1).get();
        const lastIndex = emblaApi.scrollSnapList().length - 1;
        const kill = options.stopOnLastSnap && nextIndex === lastIndex;
        if (emblaApi.canScrollNext()) emblaApi.scrollNext(jump);
        else emblaApi.scrollTo(0, jump);
        emblaApi.emit('autoplay:select');
        if (kill) return stopAutoplay();
        startAutoplay();
    }
    function timeUntilNext() {
        if (!timerStartTime) return null;
        const currentDelay = delay[emblaApi.selectedScrollSnap()];
        const timePastSinceStart = new Date().getTime() - timerStartTime;
        return currentDelay - timePastSinceStart;
    }
    const self = {
        name: 'autoplay',
        options: userOptions,
        init: init,
        destroy: destroy,
        play: play,
        stop: stop,
        reset: reset,
        isPlaying: isPlaying,
        timeUntilNext: timeUntilNext
    };
    return self;
}
$b3dde559e8f18f40$export$2e2bcd8739ae039.globalOptions = undefined;








var $089fefbb4c64ea33$exports = {};
$089fefbb4c64ea33$exports = $parcel$resolve("bhX3z");


var $4e2339bb823f0a18$exports = {};
$4e2339bb823f0a18$exports = $parcel$resolve("2nUDh");


const $4d926900275fb07e$export$72d7ca7a5d1d4807 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).h2`
	font-size: 33px;
	font-weight: 700;
	line-height: normal;
	color: ${({ theme: theme })=>theme.colors.primary};
`;
const $4d926900275fb07e$var$outlineButtonStyles = (0, $8999e1d77b7e12d9$export$dbf350e5966cf602)`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	height: 45px;
	background: ${({ theme: theme })=>theme.colors.white};
	border: 2px solid ${({ theme: theme })=>theme.colors.primary};
	border-radius: 6px;
	padding: 0 15px;
	font-size: 19px;
	font-weight: 700;
	line-height: 1;
	color: ${({ theme: theme })=>theme.colors.primary};
	text-decoration: none;
	text-align: center;
	cursor: pointer;
	&:hover {
		background: ${({ theme: theme })=>theme.colors.lightestBackground};
	}
`;
const $4d926900275fb07e$export$5749dbf81b0a6091 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $e3f57e4b1ea630bd$export$a6c7ac8248d6e38a))`
	${$4d926900275fb07e$var$outlineButtonStyles}
`;
const $4d926900275fb07e$export$f534bea3063673d5 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).button`
	${$4d926900275fb07e$var$outlineButtonStyles}
	margin: 0;
`;
const $4d926900275fb07e$export$7bddc6b0975743f = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	position: relative;
	width: 100%;
	height: 500px;
	overflow: hidden;
`;
const $4d926900275fb07e$export$b48948ecdfe2fb65 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	overflow: hidden;
	height: 100%;
`;
const $4d926900275fb07e$export$9ecf6fc9fbf9b157 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	height: 100%;
`;
const $4d926900275fb07e$export$39886c3d31694c2 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	flex: 0 0 100%;
	min-width: 0;
	height: 100%;
	position: relative;
	background-color: ${({ theme: theme })=>theme.colors.primaryTextColor};
	background-image: ${({ $imageUrl: $imageUrl })=>$imageUrl ? `url(${$imageUrl})` : 'none'};
	background-size: cover;
	background-position: center;
	&:before {
		content: '';
		position: absolute;
		inset: 0;
		background: rgba(0, 0, 0, 0.1);
	}
`;
const $4d926900275fb07e$export$b86a52c69bb08cae = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039))`
	position: ${({ $controls: $controls })=>$controls ? 'absolute' : 'relative'};
	${({ $controls: $controls })=>$controls && `
		left: 0;
		right: 0;
		bottom: 50px;
		pointer-events: none;
		> * {
			pointer-events: auto;
		}
	`}
	height: ${({ $controls: $controls })=>$controls ? 'auto' : '100%'};
`;
const $4d926900275fb07e$export$15bd5b730a840bdc = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	position: absolute;
	top: 65px;
	left: var(--grid-basis);
	width: 600px;
	height: 320px;
	box-sizing: border-box;
	padding: 40px 39px;
	background: rgba(51, 51, 51, 0.8);
	color: ${({ theme: theme })=>theme.colors.white};
	display: flex;
	flex-direction: column;
	align-items: flex-start;
`;
const $4d926900275fb07e$export$6610b2408fd9ffae = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	font-size: 18px;
	font-weight: 700;
	line-height: 22px;
	text-transform: uppercase;
`;
const $4d926900275fb07e$export$815fb821483d8e08 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).h1`
	font-size: 35px;
	font-weight: 700;
	line-height: 39px;
	width: 530px;
	margin-top: 20px;
	max-height: 78px;
	overflow: hidden;
`;
const $4d926900275fb07e$export$b4aeea2b399f616b = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	font-size: 18px;
	font-weight: 700;
	line-height: 20px;
	margin-top: 8px;
	white-space: nowrap;
`;
const $4d926900275fb07e$export$41aa1446ee640076 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)($4d926900275fb07e$export$5749dbf81b0a6091)`
	margin-top: auto;
`;
const $4d926900275fb07e$export$8efef2f36fab2485 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).button`
	position: absolute;
	bottom: 0;
	${({ $side: $side })=>$side === 'left' ? 'left: -5px;' : 'left: calc(var(--grid-basis) + 621px);'}
	width: 10px;
	height: 25px;
	padding: 0;
	border: 0;
	background: none;
	cursor: pointer;
	transform: translateY(9px);
	img {
		width: 10px;
		height: 25px;
		transform: ${({ $side: $side })=>$side === 'left' ? 'scaleX(-1)' : 'none'};
	}
`;
const $4d926900275fb07e$export$4287ec18b34ae11f = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	position: absolute;
	bottom: 0;
	left: calc(var(--grid-basis) + 3px);
	width: 600px;
	display: flex;
	gap: 20px;
	height: 7px;
	align-items: center;
`;
const $4d926900275fb07e$export$8da5f933f6fa9dbc = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).button`
	flex: 1 0 0;
	min-width: 1px;
	height: 5px;
	padding: 0;
	border: 0;
	cursor: pointer;
	background: ${({ $active: $active, theme: theme })=>$active ? theme.colors.primary : 'rgba(255, 255, 255, 0.9)'};
`;
const $4d926900275fb07e$export$9e368b1938327da9 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $e3f57e4b1ea630bd$export$a6c7ac8248d6e38a))`
	position: absolute;
	right: 0;
	bottom: 41px;
	width: 192px;
	height: 48px;
	box-sizing: border-box;
	padding: 0 18px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: rgba(51, 51, 51, 0.8);
	color: ${({ theme: theme })=>theme.colors.white};
	font-size: 20px;
	font-weight: 700;
	text-decoration: none;
	img {
		width: 12px;
		height: 22px;
	}
	&:hover {
		background: rgba(51, 51, 51, 0.95);
	}
`;
const $4d926900275fb07e$export$49179fad9cbb4914 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	gap: 40px;
	margin-top: 49px;
`;
const $4d926900275fb07e$export$dfe40b807d13c5aa = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	flex: 1 1 0;
	min-width: 0;
	display: flex;
	flex-direction: column;
	padding-bottom: 47px;
`;
const $4d926900275fb07e$export$39569374dd0a7ae4 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	position: relative;
	flex: 0 0 780px;
	max-width: 780px;
	box-sizing: border-box;
	background: ${({ theme: theme })=>theme.colors.lightestBackground};
	padding: 23px 36px 47px;
`;
const $4d926900275fb07e$export$49ee65310093c629 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).img`
	display: block;
	width: 166px;
	height: auto;
`;
const $4d926900275fb07e$export$675ffd416e9f6cb2 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).p`
	width: 478px;
	margin: 14px 0 0;
	font-size: 31px;
	line-height: 37px;
`;
const $4d926900275fb07e$export$f9ea6d490fa8f29b = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)($4d926900275fb07e$export$f534bea3063673d5)`
	position: absolute;
	top: 81px;
	right: 63px;
	white-space: nowrap;
`;
const $4d926900275fb07e$export$86df63557533e379 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).h3`
	margin-top: 40px;
	font-size: 22px;
	font-weight: 700;
	line-height: normal;
	color: ${({ theme: theme })=>theme.colors.primary};
`;
const $4d926900275fb07e$export$d0d461570bb05eef = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 32px;
	margin-top: 21px;
`;
const $4d926900275fb07e$export$c01249859845133d = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	flex-direction: column;
	gap: 36px;
	margin-top: 24px;
	${(0, $965ad126b9c0d2a7$export$8463c987d12d7028)} {
		padding: 0;
		border-bottom: none;
		align-items: flex-start;
		> img,
		> svg {
			margin-right: 12px;
			align-self: flex-start;
		}
	}
	${(0, $965ad126b9c0d2a7$export$585a3b23e887288b)} {
		line-height: 24px;
	}
	${(0, $965ad126b9c0d2a7$export$283e28d91a9a885d)} {
		padding-bottom: 0;
		font-size: 18px;
		line-height: 24px;
	}
	${(0, $965ad126b9c0d2a7$export$33f1b01688923142)} {
		font-size: 15px;
		line-height: 24px;
		color: ${({ theme: theme })=>theme.colors.mutedText};
	}
`;
const $4d926900275fb07e$export$3a8184ef57a56b16 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).h3`
	display: flex;
	align-items: center;
	margin-top: 59px;
	font-size: 24px;
	font-weight: 700;
	line-height: normal;
	color: ${({ theme: theme })=>theme.colors.primary};
`;
const $4d926900275fb07e$export$264a15c11cb11239 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).img.attrs({
    src: (0, (/*@__PURE__*/$parcel$interopDefault($4e2339bb823f0a18$exports))),
    alt: ''
})`
	width: 24px;
	height: 43px;
	margin-left: 4px;
	margin-right: 18px;
	transform: rotate(30deg);
`;
const $4d926900275fb07e$export$e7e90c8c67c6df42 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)($4d926900275fb07e$export$c01249859845133d)`
	margin-top: 17px;
`;
const $4d926900275fb07e$export$ed56e549b7f4213a = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).p`
	margin: 25px 0 0;
	font-size: 15px;
	line-height: 24px;
	color: ${({ theme: theme })=>theme.colors.mutedText};
`;
const $4d926900275fb07e$export$4b44a6d406dc5013 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $e3f57e4b1ea630bd$export$a6c7ac8248d6e38a))`
	align-self: flex-start;
	margin-top: auto;
	padding-top: 40px;
	font-size: 18px;
	line-height: 22px;
	color: ${({ theme: theme })=>theme.colors.primary};
	text-decoration: none;
`;
const $4d926900275fb07e$export$73f3a977a5f5ed3a = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)($4d926900275fb07e$export$72d7ca7a5d1d4807)`
	margin-top: 44px;
`;
const $4d926900275fb07e$export$deaa961060ae6da3 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	gap: 20px;
	margin-top: 14px;
`;
const $4d926900275fb07e$export$235cb65c20ad2b7 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).a`
	display: flex;
	flex-direction: column;
	align-items: center;
	box-sizing: border-box;
	width: 130px;
	height: 130px;
	border: 2px solid ${({ theme: theme })=>theme.colors.mediumGray};
	text-decoration: none;
	color: inherit;
	&:hover {
		border-color: ${({ theme: theme })=>theme.colors.primary};
	}
`;
const $4d926900275fb07e$export$45bd27b5be5a3547 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 36px;
	margin-top: 23px;
	img {
		display: block;
	}
`;
const $4d926900275fb07e$export$330e75be0cbe7bcf = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).span`
	margin-top: ${({ $twoLines: $twoLines })=>$twoLines ? '7px' : '16px'};
	font-size: 18px;
	line-height: 21px;
	text-align: center;
	white-space: pre-line;
`;
const $4d926900275fb07e$export$c52c3e010ee27681 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)($4d926900275fb07e$export$72d7ca7a5d1d4807)`
	margin-top: 47px;
`;
const $4d926900275fb07e$export$71a8c55be3ec72cf = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	margin-top: 21px;
`;
const $4d926900275fb07e$export$6197db13564fe49b = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	position: relative;
	width: 100%;
	height: 340px;
	margin-top: 54px;
	background-size: cover;
	background-position: center;
	background-image: url(${(0, (/*@__PURE__*/$parcel$interopDefault($089fefbb4c64ea33$exports)))});
`;
const $4d926900275fb07e$export$e56e199144073d66 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039))`
	padding-top: 50px;
`;
const $4d926900275fb07e$export$35d6cd4f175d16cb = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	justify-content: space-between;
	box-sizing: border-box;
	height: 228px;
	padding: 33px 68px 0;
	background: rgba(51, 51, 51, 0.8);
`;
const $4d926900275fb07e$export$c84356afd4299847 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	width: 484px;
	text-align: center;
	color: ${({ theme: theme })=>theme.colors.white};
	h4 {
		margin: 0 0 10px;
		font-size: 33px;
		font-weight: 700;
		line-height: 37px;
		color: ${({ theme: theme })=>theme.colors.primary};
	}
	p {
		margin: 0;
		font-size: 28px;
		font-weight: 400;
		line-height: 34px;
	}
`;
const $4d926900275fb07e$export$aa94567eee2dd6a9 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	margin-top: 44px;
	color: ${({ theme: theme })=>theme.colors.primaryTextColor};
	h3 {
		margin: 0;
		font-size: 33px;
		font-weight: 700;
		line-height: normal;
		text-align: center;
		color: ${({ theme: theme })=>theme.colors.primary};
	}
`;
const $4d926900275fb07e$export$a61354fecfb7e020 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	align-items: flex-start;
	gap: 20px;
	margin-top: 45px;
	margin-bottom: 53px; /* + the content wrapper's own bottom padding = 102px to the footer, as in the Figma */
`;
const $4d926900275fb07e$export$44dbc8d42127124a = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	flex: 0 0 380px;
	display: flex;
	flex-direction: column;
	gap: 50px;
`;
const $4d926900275fb07e$export$83092fdad39ac601 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	h4 {
		margin: 0;
		font-size: 24px;
		font-weight: 700;
		line-height: 37px;
		text-align: center;
		color: ${({ theme: theme })=>theme.colors.primary};
	}
	p {
		margin: 5px 0 0;
		font-size: 16px;
		line-height: 22px;
	}
`;


var $a1ce5366ee0815df$exports = {};
$a1ce5366ee0815df$exports = $parcel$resolve("jRbMB");


var $fe42d234db759e38$exports = {};
$fe42d234db759e38$exports = $parcel$resolve("ZHpgD");


const $a1ab066ba033e276$var$AUTOPLAY_DELAY_MS = 6000;
function $a1ab066ba033e276$var$HeroCarousel({ bulletins: bulletins }) {
    const { siteMeta: siteMeta } = (0, $6f7f49c0f054a62d$export$55c0e3cb4fbc46cf)();
    const [emblaRef, emblaApi] = (0, $ee80a659baec94a2$export$2e2bcd8739ae039)({
        loop: true
    }, [
        (0, $b3dde559e8f18f40$export$2e2bcd8739ae039)({
            delay: $a1ab066ba033e276$var$AUTOPLAY_DELAY_MS,
            stopOnMouseEnter: true,
            stopOnInteraction: false
        })
    ]);
    const [selectedIndex, setSelectedIndex] = (0, $gRqVZ.useState)(0);
    (0, $gRqVZ.useEffect)(()=>{
        if (!emblaApi) return;
        const onSelect = ()=>setSelectedIndex(emblaApi.selectedScrollSnap());
        onSelect();
        emblaApi.on('select', onSelect);
        emblaApi.on('reInit', onSelect);
        return ()=>{
            emblaApi.off('select', onSelect);
            emblaApi.off('reInit', onSelect);
        };
    }, [
        emblaApi
    ]);
    const scrollPrev = (0, $gRqVZ.useCallback)(()=>emblaApi?.scrollPrev(), [
        emblaApi
    ]);
    const scrollNext = (0, $gRqVZ.useCallback)(()=>emblaApi?.scrollNext(), [
        emblaApi
    ]);
    const scrollTo = (0, $gRqVZ.useCallback)((index)=>emblaApi?.scrollTo(index), [
        emblaApi
    ]);
    const departmentTitle = (bulletin)=>{
        const departmentId = bulletin.bulletinDepartments?.[0]?.departmentId;
        return siteMeta.departments.find((d)=>d.id === departmentId)?.title;
    };
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$7bddc6b0975743f), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$b48948ecdfe2fb65), {
                ref: emblaRef,
                children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$9ecf6fc9fbf9b157), {
                    children: bulletins.map((b)=>{
                        const department = departmentTitle(b);
                        const meta = [
                            (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(b.createdAt).format('MMMM D, YYYY')
                        ];
                        if (b.author?.firstName) meta.push(`By ${b.author.firstName} ${b.author.lastName}`);
                        return /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$39886c3d31694c2), {
                            $imageUrl: b.leadWebUrl,
                            children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$b86a52c69bb08cae), {
                                children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$15bd5b730a840bdc), {
                                    children: [
                                        department && /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$6610b2408fd9ffae), {
                                            children: department
                                        }),
                                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$815fb821483d8e08), {
                                            children: b.title
                                        }),
                                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$b4aeea2b399f616b), {
                                            children: meta.join(" \u2022 ")
                                        }),
                                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$41aa1446ee640076), {
                                            to: `/news/${b.id}`,
                                            children: "Read more"
                                        })
                                    ]
                                })
                            })
                        }, `hero-slide-${b.id}`);
                    })
                })
            }),
            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$b86a52c69bb08cae), {
                $controls: true,
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$8efef2f36fab2485), {
                        $side: "left",
                        onClick: scrollPrev,
                        "aria-label": "Previous story",
                        children: /*#__PURE__*/ (0, $01ysi.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($a1ce5366ee0815df$exports))),
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$4287ec18b34ae11f), {
                        children: bulletins.map((b, index)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$8da5f933f6fa9dbc), {
                                $active: index === selectedIndex,
                                onClick: ()=>scrollTo(index),
                                "aria-label": `Go to story ${index + 1}`
                            }, `hero-bar-${b.id}`))
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$8efef2f36fab2485), {
                        $side: "right",
                        onClick: scrollNext,
                        "aria-label": "Next story",
                        children: /*#__PURE__*/ (0, $01ysi.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($a1ce5366ee0815df$exports))),
                            alt: ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$9e368b1938327da9), {
                to: "/news",
                children: [
                    "More news",
                    /*#__PURE__*/ (0, $01ysi.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($fe42d234db759e38$exports))),
                        alt: ""
                    })
                ]
            })
        ]
    });
}
var $a1ab066ba033e276$export$2e2bcd8739ae039 = $a1ab066ba033e276$var$HeroCarousel;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");

var $39b8241948efc23a$exports = {};
$39b8241948efc23a$exports = $parcel$resolve("5ERi2");


var $41e42a3bd593d8ad$exports = {};
$41e42a3bd593d8ad$exports = $parcel$resolve("7xBTq");


var $c1127400a3acfed4$exports = {};
$c1127400a3acfed4$exports = $parcel$resolve("dosBv");


var $8aa489504c97abdd$exports = {};
$8aa489504c97abdd$exports = $parcel$resolve("kSmES");


var $b48ba59c19d916f5$exports = {};
$b48ba59c19d916f5$exports = $parcel$resolve("7kNLR");


var $7a39e4c777c9dadd$exports = {};
$7a39e4c777c9dadd$exports = $parcel$resolve("fwPx7");


var $6a59dd80f0356302$exports = {};
$6a59dd80f0356302$exports = $parcel$resolve("9WPP3");


var $cc93d3d0674bd2d3$exports = {};
$cc93d3d0674bd2d3$exports = $parcel$resolve("b1XmQ");


// TODO(NIBBI-113): '#' hrefs are placeholders until the real URLs are confirmed
const $37e13e4fab35f1f0$var$links = [
    {
        label: 'Procore',
        href: '#',
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($39b8241948efc23a$exports))),
        width: 36,
        height: 36
    },
    {
        label: 'Docebo',
        href: 'https://nibbi.docebosaas.com/',
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($41e42a3bd593d8ad$exports))),
        width: 36,
        height: 36
    },
    {
        label: 'Help Desk',
        href: 'https://ithelp.nibbi.com',
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($c1127400a3acfed4$exports))),
        width: 37,
        height: 37
    },
    {
        label: 'Emburse',
        href: '#',
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($8aa489504c97abdd$exports))),
        width: 36,
        height: 36
    },
    {
        label: 'ADP',
        href: '#',
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($b48ba59c19d916f5$exports))),
        width: 49,
        height: 28
    },
    {
        label: 'Builder',
        href: '#',
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($7a39e4c777c9dadd$exports))),
        width: 36,
        height: 36
    },
    {
        label: 'OpenSpace',
        href: '#',
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($6a59dd80f0356302$exports))),
        width: 38,
        height: 38
    },
    {
        label: 'SharePoint\nTeams',
        href: '#',
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($cc93d3d0674bd2d3$exports))),
        width: 36,
        height: 36
    }
];
function $37e13e4fab35f1f0$var$FrequentlyAccessed() {
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$73f3a977a5f5ed3a), {
                children: "Frequently Accessed Links"
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$deaa961060ae6da3), {
                children: $37e13e4fab35f1f0$var$links.map((link)=>{
                    const external = link.href !== '#';
                    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$235cb65c20ad2b7), {
                        href: link.href,
                        target: external ? '_blank' : undefined,
                        rel: external ? 'noopener noreferrer' : undefined,
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$45bd27b5be5a3547), {
                                children: /*#__PURE__*/ (0, $01ysi.jsx)("img", {
                                    src: link.logo,
                                    alt: "",
                                    width: link.width,
                                    height: link.height
                                })
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$330e75be0cbe7bcf), {
                                $twoLines: link.label.includes('\n'),
                                children: link.label
                            })
                        ]
                    }, link.label);
                })
            })
        ]
    });
}
var $37e13e4fab35f1f0$export$2e2bcd8739ae039 = $37e13e4fab35f1f0$var$FrequentlyAccessed;



var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");
var $5eff7e36978b7498$exports = {};
$5eff7e36978b7498$exports = function load(src, opts, cb) {
    var head = document.head || document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    if (typeof opts === 'function') {
        cb = opts;
        opts = {};
    }
    opts = opts || {};
    cb = cb || function() {};
    script.type = opts.type || 'text/javascript';
    script.charset = opts.charset || 'utf8';
    script.async = 'async' in opts ? !!opts.async : true;
    script.src = src;
    if (opts.attrs) $5eff7e36978b7498$var$setAttributes(script, opts.attrs);
    if (opts.text) script.text = '' + opts.text;
    var onend = 'onload' in script ? $5eff7e36978b7498$var$stdOnEnd : $5eff7e36978b7498$var$ieOnEnd;
    onend(script, cb);
    // some good legacy browsers (firefox) fail the 'in' detection above
    // so as a fallback we always set onload
    // old IE will ignore this and new IE will set onload
    if (!script.onload) $5eff7e36978b7498$var$stdOnEnd(script, cb);
    head.appendChild(script);
};
function $5eff7e36978b7498$var$setAttributes(script, attrs) {
    for(var attr in attrs)script.setAttribute(attr, attrs[attr]);
}
function $5eff7e36978b7498$var$stdOnEnd(script, cb) {
    script.onload = function() {
        this.onerror = this.onload = null;
        cb(null, script);
    };
    script.onerror = function() {
        // this.onload = null here is necessary
        // because even IE9 works not like others
        this.onerror = this.onload = null;
        cb(new Error('Failed to load ' + this.src), script);
    };
}
function $5eff7e36978b7498$var$ieOnEnd(script, cb) {
    script.onreadystatechange = function() {
        if (this.readyState != 'complete' && this.readyState != 'loaded') return;
        this.onreadystatechange = null;
        cb(null, script) // there is no way to catch loading errors in IE8
        ;
    };
}


async function $1ac13e913efa91d0$var$loadScript(url, opts = {}) {
    return new Promise((resolve, reject)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($5eff7e36978b7498$exports)))(url, opts, (err, script)=>{
            if (err) reject(err);
            else resolve(script);
        });
    });
}
var $1ac13e913efa91d0$export$2e2bcd8739ae039 = $1ac13e913efa91d0$var$loadScript;



const $34c2b2a28ed152e1$var$ELFSIGHT_PLATFORM_URL = 'https://elfsightcdn.com/platform.js';
const $34c2b2a28ed152e1$var$ELFSIGHT_APP_CLASS = 'elfsight-app-d24c3cfb-b1fd-41cd-996e-7a119b316218';
function $34c2b2a28ed152e1$var$SocialFeed() {
    (0, $gRqVZ.useEffect)(()=>{
        if (document.querySelector(`script[src="${$34c2b2a28ed152e1$var$ELFSIGHT_PLATFORM_URL}"]`)) return;
        (0, $1ac13e913efa91d0$export$2e2bcd8739ae039)($34c2b2a28ed152e1$var$ELFSIGHT_PLATFORM_URL, {
            async: true
        }).catch(()=>{
        /* the feed simply stays empty if the Elfsight platform fails to load */ });
    }, []);
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$c52c3e010ee27681), {
                children: "What\u2019s new on social media?"
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$71a8c55be3ec72cf), {
                children: /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                    className: $34c2b2a28ed152e1$var$ELFSIGHT_APP_CLASS,
                    "data-elfsight-app-lazy": true
                })
            })
        ]
    });
}
var $34c2b2a28ed152e1$export$2e2bcd8739ae039 = $34c2b2a28ed152e1$var$SocialFeed;



var $5b358dfa2d749906$exports = {};
$5b358dfa2d749906$exports = $parcel$resolve("5tiSp");



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");




var $jIrNf = parcelRequire("jIrNf");



const $9659c1d5fc1e253c$export$60332b2344f7fe41 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	margin-bottom: 20px;
	padding: ${(props)=>props.$flat ? undefined : `20px`};
	position: relative;
	border: 1px solid ${({ theme: theme, $flat: $flat })=>$flat ? 'transparent' : theme.colors.lightGray};
	border-radius: 3px;
	width: ${(props)=>props.$fullWidth ? '90%' : `calc(50% - 50px)`};
	padding-bottom: ${(props)=>props.$flat ? `20px` : undefined};
	border-bottom: ${(props)=>props.$flat ? `1px solid ${props.theme.colors.lightGray}` : undefined};
`;
const $9659c1d5fc1e253c$export$3553ba97f17c08a9 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	background-color: ${({ theme: theme })=>theme.colors.lightGray};
	border-radius: 3px;
	padding: 16px;
	margin-top: 1rem;
`;
const $9659c1d5fc1e253c$export$c9831f72f461db7f = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	cursor: ${(props)=>props.$clickable ? 'pointer' : undefined};
`;
const $9659c1d5fc1e253c$export$3b4b746f9037aa5e = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	margin-left: 15px;
	h1 {
		font-size: 18px;
		font-weight: 400;
		line-height: 25px;
	}
	h2 {
		font-size: 16px;
		font-weight: 300;
		line-height: 25px;
	}
	h3 {
		font-size: 16px;
		color: ${({ theme: theme })=>theme.colors.lightestGray};
		font-weight: 300;
		line-height: 25px;
	}
	h4 {
		font-size: 14px;
		font-weight: 500;
		line-height: 25px;
	}
`;
const $9659c1d5fc1e253c$export$c5b1627c831752b2 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $d2ab028d8623e892$export$2e2bcd8739ae039))`
	height: 64px;
	width: 64px;
`;
const $9659c1d5fc1e253c$export$1fb65d170d1a95bd = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	min-width: 0;
`;
const $9659c1d5fc1e253c$export$9e528c5a3604495 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	align-items: center;
	gap: 20px;
	cursor: ${(props)=>props.$clickable ? 'pointer' : undefined};
`;
const $9659c1d5fc1e253c$export$902bfb0e958a48dc = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $d2ab028d8623e892$export$2e2bcd8739ae039))`
	flex: 0 0 90px;
	width: 90px;
	height: 90px;
	object-fit: cover;
`;
const $9659c1d5fc1e253c$export$b7471996d5fe5bf0 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	min-width: 0;
	h1 {
		font-size: 20px;
		font-weight: 400;
		line-height: 25px;
	}
	h2 {
		font-size: 18px;
		font-weight: 400;
		line-height: 25px;
	}
	p {
		margin: 15px 0 0;
		font-size: 15px;
		line-height: 21px;
		color: ${({ theme: theme })=>theme.colors.mutedText};
	}
`;
const $9659c1d5fc1e253c$export$5a7d29d0faf3de61 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	margin-top: 26px;
	font-size: 18px;
	line-height: 22px;
	p {
		margin: 0;
	}
	p + p {
		margin-top: 22px;
	}
`;
const $9659c1d5fc1e253c$export$695826fd6668d68 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).a`
	display: inline-block;
	margin-top: 22px;
	font-size: 18px;
	line-height: 22px;
	color: ${({ theme: theme })=>theme.colors.primary};
	text-decoration: none;
	cursor: pointer;
`;
const $9659c1d5fc1e253c$export$2e0a83ec2e27ecbb = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	margin: 10px 0px;
	border-bottom: 1px solid ${({ theme: theme })=>theme.colors.lightGray};
`;
// margin (not padding) so the 15px stays the glyph's own size under either
// box-sizing — with border-box, padding is subtracted from the width and the
// icon renders at a third of its intended scale.
const $9659c1d5fc1e253c$var$IconStyles = (0, $8999e1d77b7e12d9$export$dbf350e5966cf602)`
	width: 15px;
	height: 15px;
	color: ${({ theme: theme })=>theme.colors.lightestGray};
	margin-right: 10px;
`;
const $9659c1d5fc1e253c$export$ec1acb4261485f12 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $8113a63c16d8b82c$export$de284f94be6e29d2))`
	${$9659c1d5fc1e253c$var$IconStyles}
`;
const $9659c1d5fc1e253c$export$e7079545947d7d77 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $b309836aa0724383$export$2de540f0cd7c073a))`
	${$9659c1d5fc1e253c$var$IconStyles}
`;
const $9659c1d5fc1e253c$export$ef57f0a6129d7b2e = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $24f70e6c5423ac94$export$594cd506591dcf26))`
	${$9659c1d5fc1e253c$var$IconStyles}
`;
const $9659c1d5fc1e253c$export$229c2a4b55a611f4 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $6d9aaf801032e965$export$4e2d65a9843399df))`
	${$9659c1d5fc1e253c$var$IconStyles}
`;
const $9659c1d5fc1e253c$export$edcef7aeb244b633 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).section`
	display: flex;
	flex-wrap: wrap;
`;
const $9659c1d5fc1e253c$export$edd98d03726b2474 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).a`
	width: 50%;
	display: flex;
	align-items: center;
	padding-top: 15px;
	color: ${({ theme: theme })=>theme.colors.primary};
	text-decoration: none;
	font-size: 15px;
	&:hover {
		cursor: pointer;
	}
`;






var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");

var $489wz = parcelRequire("489wz");

var $0ba967bcdbe74473$exports = {};
!function(r, e) {
    $0ba967bcdbe74473$exports = e();
}($0ba967bcdbe74473$exports, function() {
    "use strict";
    return function(r, e, t) {
        r = r || {};
        var n = e.prototype, o = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        };
        function i(r, e, t, o) {
            return n.fromToBase(r, e, t, o);
        }
        t.en.relativeTime = o, n.fromToBase = function(e, n, i, d, u) {
            for(var f, a, s, l = i.$locale().relativeTime || o, h = r.thresholds || [
                {
                    l: "s",
                    r: 44,
                    d: "second"
                },
                {
                    l: "m",
                    r: 89
                },
                {
                    l: "mm",
                    r: 44,
                    d: "minute"
                },
                {
                    l: "h",
                    r: 89
                },
                {
                    l: "hh",
                    r: 21,
                    d: "hour"
                },
                {
                    l: "d",
                    r: 35
                },
                {
                    l: "dd",
                    r: 25,
                    d: "day"
                },
                {
                    l: "M",
                    r: 45
                },
                {
                    l: "MM",
                    r: 10,
                    d: "month"
                },
                {
                    l: "y",
                    r: 17
                },
                {
                    l: "yy",
                    d: "year"
                }
            ], m = h.length, c = 0; c < m; c += 1){
                var y = h[c];
                y.d && (f = d ? t(e).diff(i, y.d, !0) : i.diff(e, y.d, !0));
                var p = (r.rounding || Math.round)(Math.abs(f));
                if (s = f > 0, p <= y.r || !y.r) {
                    p <= 1 && c > 0 && (y = h[c - 1]);
                    var v = l[y.l];
                    u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n, y.l, s);
                    break;
                }
            }
            if (n) return a;
            var M = s ? l.future : l.past;
            return "function" == typeof M ? M(a) : M.replace("%s", a);
        }, n.to = function(r, e) {
            return i(r, e, this, !0);
        }, n.from = function(r, e) {
            return i(r, e, this);
        };
        var d = function(r) {
            return r.$u ? t.utc() : t();
        };
        n.toNow = function(r) {
            return this.to(d(this), r);
        }, n.fromNow = function(r) {
            return this.from(d(this), r);
        };
    };
});







function $8e914d5dfc637c4d$export$e985158d10c27e34(baseOptions) {
    const { data: data, loading: loading, error: error } = $93486c083cb38a29$export$e985158d10c27e34(baseOptions);
    let typedData;
    if (data) typedData = data.search.map((searchData)=>{
        switch(searchData.modelType){
            case 'bulletin':
                return searchData;
            case 'resources':
                return searchData;
            case 'users':
                return searchData;
        }
    });
    return {
        data: typedData ? {
            search: typedData
        } : null,
        loading: loading,
        error: error
    };
}
function $8e914d5dfc637c4d$export$91a825dae171a9cd(id, skip) {
    const { data: data, loading: loading, error: error } = $93486c083cb38a29$export$b77182dfd58e82cf({
        variables: {
            id: id
        },
        skip: skip
    });
    if (data?.gallery) {
        const gallery = data.gallery;
        let orderedPhotos = gallery.photos || [];
        if (orderedPhotos.length > 0) {
            const lookup = {};
            const idList = gallery.children;
            idList.forEach((id, idx)=>lookup[id] = idx);
            orderedPhotos = [
                ...orderedPhotos
            ].sort((a, b)=>{
                return (lookup[a.id] || -1) - (lookup[b.id] || -1);
            });
        }
        const media = [];
        // Video always first
        if (gallery.videoUpload?.publicUrl) media.push({
            type: 'video',
            url: gallery.videoUpload.publicUrl,
            thumbnailUrl: gallery.videoThumbnail?.publicUrl || ''
        });
        orderedPhotos.forEach((photo)=>{
            if (photo.image?.publicUrl) media.push({
                type: 'photo',
                id: photo.id,
                url: photo.image.publicUrl
            });
        });
        return {
            loading: loading,
            error: error,
            data: {
                ...data,
                gallery: {
                    ...data.gallery,
                    photos: orderedPhotos
                }
            },
            media: media
        };
    }
    return {
        data: data,
        loading: loading,
        error: error,
        media: []
    };
}
function $8e914d5dfc637c4d$export$2729cbcf847987e9() {
    const { data: data, loading: loading, error: error } = $93486c083cb38a29$export$6954a324c39a3400();
    if (data?.galleries?.length > 0) {
        const lookup = {};
        const idList = data.galleryPage.children;
        idList.forEach((id, idx)=>lookup[id] = idx);
        const orderedGalleries = [
            ...data.galleries
        ].sort((a, b)=>{
            return (lookup[a.id] || -1) - (lookup[b.id] || -1);
        });
        return {
            loading: loading,
            error: error,
            data: {
                ...data,
                galleries: orderedGalleries
            }
        };
    }
    return {
        data: data,
        loading: loading,
        error: error
    };
}
function $8e914d5dfc637c4d$export$722295c247fb669(baseOptions) {
    const { data: data, loading: loading, error: error } = $93486c083cb38a29$export$722295c247fb669(baseOptions);
    if (data) return {
        loading: loading,
        error: error,
        data: {
            department: {
                ...data.department,
                bulletins: data.department.bulletins.filter((b)=>Boolean(b.bulletin?.id)).map((b)=>b.bulletin)
            }
        }
    };
    return {
        data: null,
        loading: loading,
        error: error
    };
}
function $8e914d5dfc637c4d$export$950e3195c77fb453(baseOptions) {
    return $1189962e9f7bce46$export$609860bf8b0084c($93486c083cb38a29$export$b97cc9278da8dfbb, baseOptions);
}





var $489wz = parcelRequire("489wz");
const $58533d8bcb3cb802$export$cf345ef34cd72655 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	font-size: 16px;
	color: ${({ theme: theme })=>theme.colors.lightestGray};
	display: flex;
	align-items: center;
	img {
		height: 30px;
		width: 30px;
		float: left;
		padding-left: 0;
		padding-right: 10px;
	}
`;
const $58533d8bcb3cb802$export$3dca724502e10d6c = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	clear: both;
	margin-top: 8px;
`;
const $58533d8bcb3cb802$export$f0e840de44c4fb31 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	clear: both;
	margin-top: 20px;
	padding: 40px 30px 60px 30px;
	background-color: ${({ theme: theme })=>theme.colors.lightGray};
	border-radius: 3px;
	h2 {
		font-size: 18px;
		margin-bottom: 25px;
		font-weight: 400;
	}
`;
const $58533d8bcb3cb802$export$4857ba7068d0bed8 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	padding-bottom: 30px;
	margin-bottom: 30px;
	border-bottom: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	p {
		font-size: 12px;
		font-weight: lighter;
	}
`;
const $58533d8bcb3cb802$export$5e7d9181d5d7cbc5 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	padding-top: 8px;
	padding-bottom: 8px;
	border-top: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	font-size: 80%;
	line-height: 24px;
	p {
		font-size: 12px;
		font-weight: lighter;
	}
	img {
		float: left;
		width: 24px;
		padding-left: 0px;
		padding-right: 12px;
	}
	.commenter {
		font-weight: 500;
		padding-right: 0.5rem;
	}
	.comment {
		font-weight: 400;
	}
`;
const $58533d8bcb3cb802$export$4d299b491347818a = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).span`
	font-weight: 300;
	font-size: 95%;
	line-height: 1.4;
`;
const $58533d8bcb3cb802$export$f5af24b6a9fda285 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	padding-bottom: 10px;
	img {
		float: left;
		width: 50px;
		padding-left: 0px;
		padding-right: 20px;
	}
	h3 {
		display: inline-block;
		font-size: 16px;
		font-weight: normal;
	}
	h4 {
		padding-left: 15px;
		display: inline-block;
		font-size: 12px;
		font-weight: lighter;
	}
`;
const $58533d8bcb3cb802$export$a2ca5d39feff539 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).button`
	padding-top: 10px;
	display: inline-block;
	color: ${({ theme: theme })=>theme.colors.primary};
	font-size: 14px;
	border: none;
	background: none;
	&:first-child {
		padding-right: 10px;
	}
	&:hover {
		cursor: pointer;
	}
`;
const $58533d8bcb3cb802$export$55ec0e499a2afded = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $489wz.Form))`
	input {
		width: 80%;
	}
`;
const $58533d8bcb3cb802$export$9a23e13e04a85659 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $489wz.Form))`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	padding-top: 8px;
	border-top: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	> div {
		width: 80%;
		> div {
			padding-top: 0;
		}
	}
	> button {
		width: 20%;
		padding-top: 0;
	}
	img {
		float: left;
		width: 50px;
		height: 50px;
		padding-left: 0px;
		padding-right: 20px;
	}
`;
const $58533d8bcb3cb802$export$27f8dc785229f9ee = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $489wz.Form))`
	div {
		display: flex;
		padding-bottom: 10px;
	}
	img {
		float: left;
		width: 50px;
		height: 50px;
		padding-left: 0px;
		padding-right: 20px;
	}

	button {
		float: right;
	}
`;


(0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($0ba967bcdbe74473$exports))));
function $d408feb4a7311f71$var$Comments(props) {
    const { user: user } = (0, $f8298f6bd5fca48e$export$a609e16b0cfae3f1)();
    const { comments: comments, bulletinId: bulletinId, discussionId: discussionId, nominationId: nominationId } = props;
    const [editingCommentId, setEditingCommentId] = (0, $gRqVZ.useState)(-1);
    const refetchArray = Array.isArray(props.refetch) ? props.refetch : [
        props.refetch
    ];
    const [addCommentMutation, { loading: addCommentLoading }] = (0, $8e914d5dfc637c4d$export$950e3195c77fb453)({
        refetchQueries: refetchArray,
        awaitRefetchQueries: true
    });
    const [deleteCommentMutation] = (0, $93486c083cb38a29$export$91bcd2720f6c2c6)({
        refetchQueries: refetchArray,
        awaitRefetchQueries: true
    });
    const [updateCommentMutation] = (0, $93486c083cb38a29$export$1f95a39633797408)({
        refetchQueries: refetchArray,
        awaitRefetchQueries: true
    });
    const addComment = async (values, actions)=>{
        const { comment: comment } = values;
        if (!comment.length) return;
        await addCommentMutation({
            variables: {
                comment: comment,
                bulletinId: +bulletinId > 0 ? +bulletinId : null,
                discussionId: +discussionId > 0 ? +discussionId : null,
                nominationId: +nominationId > 0 ? +nominationId : null
            }
        });
        actions.resetForm();
    };
    const updateComment = (values)=>{
        updateCommentMutation({
            variables: {
                id: values.commentId,
                comment: values.updatedComment
            }
        });
    };
    const deleteComment = (commentId)=>{
        deleteCommentMutation({
            variables: {
                id: commentId
            }
        });
    };
    const update = (values)=>{
        setEditingCommentId(-1);
        updateComment(values);
    };
    const OuterContainer = props.tiny ? (0, $58533d8bcb3cb802$export$3dca724502e10d6c) : (0, $58533d8bcb3cb802$export$f0e840de44c4fb31);
    const AddCommentElement = props.tiny ? (0, $58533d8bcb3cb802$export$9a23e13e04a85659) : (0, $58533d8bcb3cb802$export$27f8dc785229f9ee);
    return /*#__PURE__*/ (0, $01ysi.jsxs)(OuterContainer, {
        children: [
            !props.tiny && /*#__PURE__*/ (0, $01ysi.jsx)("h2", {
                children: "Comments"
            }),
            comments?.map((comment)=>{
                const canEditComment = comment.user?.id === user?.id;
                if (props.tiny) return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $58533d8bcb3cb802$export$5e7d9181d5d7cbc5), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $d2ab028d8623e892$export$2e2bcd8739ae039), {
                            src: comment.user?.profilePhotoUrl
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsxs)("span", {
                            className: "commenter",
                            children: [
                                comment.user?.firstName,
                                " ",
                                comment.user?.lastName
                            ]
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                            className: "comment",
                            children: comment.comment
                        })
                    ]
                }, comment.id);
                return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $58533d8bcb3cb802$export$4857ba7068d0bed8), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsxs)((0, $58533d8bcb3cb802$export$f5af24b6a9fda285), {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $d2ab028d8623e892$export$2e2bcd8739ae039), {
                                    src: comment.user?.profilePhotoUrl
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsxs)("h3", {
                                    children: [
                                        comment.user?.firstName,
                                        " ",
                                        comment.user?.lastName
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)("h4", {
                                    children: comment.user?.jobTitle
                                })
                            ]
                        }),
                        comment.id === editingCommentId ? /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Formik), {
                            initialValues: {
                                commentId: comment.id,
                                updatedComment: comment.comment
                            },
                            onSubmit: update,
                            children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $58533d8bcb3cb802$export$55ec0e499a2afded), {
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                        name: "updatedComment",
                                        type: "textarea"
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $58533d8bcb3cb802$export$a2ca5d39feff539), {
                                        type: "submit",
                                        children: "Update Comment"
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $58533d8bcb3cb802$export$a2ca5d39feff539), {
                                        onClick: ()=>setEditingCommentId(-1),
                                        children: "Cancel"
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $01ysi.jsx)((0, $58533d8bcb3cb802$export$4d299b491347818a), {
                            children: comment.comment
                        }),
                        canEditComment && editingCommentId !== comment.id && /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $58533d8bcb3cb802$export$a2ca5d39feff539), {
                                    onClick: ()=>setEditingCommentId(comment.id),
                                    children: "Update"
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $58533d8bcb3cb802$export$a2ca5d39feff539), {
                                    onClick: ()=>deleteComment(comment.id),
                                    children: "Delete"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsxs)("p", {
                            children: [
                                comment.updatedAt !== comment.createdAt && 'Edited ',
                                (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(comment?.updatedAt || comment?.createdAt).fromNow()
                            ]
                        })
                    ]
                }, comment.id);
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Formik), {
                initialValues: {
                    comment: ''
                },
                onSubmit: addComment,
                children: /*#__PURE__*/ (0, $01ysi.jsxs)(AddCommentElement, {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                            children: [
                                !props.tiny && /*#__PURE__*/ (0, $01ysi.jsx)((0, $d2ab028d8623e892$export$2e2bcd8739ae039), {
                                    src: user.profilePhotoUrl
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                    name: "comment",
                                    type: "textarea",
                                    placeholder: "Write a reply...",
                                    disabled: addCommentLoading
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $58533d8bcb3cb802$export$a2ca5d39feff539), {
                            type: "submit",
                            children: "Add Comment"
                        })
                    ]
                })
            })
        ]
    });
}
var $d408feb4a7311f71$export$2e2bcd8739ae039 = $d408feb4a7311f71$var$Comments;


function $b7cf2e00be4cfa04$var$PersonCard({ person: person, fullWidth: fullWidth = false }) {
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $9659c1d5fc1e253c$export$60332b2344f7fe41), {
        $fullWidth: fullWidth,
        children: [
            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $9659c1d5fc1e253c$export$c9831f72f461db7f), {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $9659c1d5fc1e253c$export$c5b1627c831752b2), {
                        src: person?.profilePhotoUrl
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsxs)((0, $9659c1d5fc1e253c$export$3b4b746f9037aa5e), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsxs)("h1", {
                                children: [
                                    person.firstName,
                                    " ",
                                    person.lastName
                                ]
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)("h2", {
                                children: person.jobTitle
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)("h3", {
                                children: person.department?.title
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $9659c1d5fc1e253c$export$2e0a83ec2e27ecbb), {}),
            person?.jobsite?.title,
            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $9659c1d5fc1e253c$export$edcef7aeb244b633), {
                children: [
                    person.phoneExt && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $9659c1d5fc1e253c$export$edd98d03726b2474), {
                        href: `tel:${person.phoneDirect}`,
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $9659c1d5fc1e253c$export$ec1acb4261485f12), {}),
                            "Ext. ",
                            person.phoneExt
                        ]
                    }),
                    person.phoneDirect && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $9659c1d5fc1e253c$export$edd98d03726b2474), {
                        href: `tel:${person.phoneDirect}`,
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $9659c1d5fc1e253c$export$ef57f0a6129d7b2e), {}),
                            person.phoneDirect
                        ]
                    }),
                    person.phoneCell && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $9659c1d5fc1e253c$export$edd98d03726b2474), {
                        href: `tel:${person.phoneCell}`,
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $9659c1d5fc1e253c$export$e7079545947d7d77), {}),
                            person.phoneCell
                        ]
                    }),
                    person.email && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $9659c1d5fc1e253c$export$edd98d03726b2474), {
                        href: `mailto:${person.email}`,
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $9659c1d5fc1e253c$export$229c2a4b55a611f4), {}),
                            person.email
                        ]
                    })
                ]
            })
        ]
    });
}
const $b7cf2e00be4cfa04$var$OrangeLink = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).a`
	text-decoration: none;
	cursor: pointer;
	color: ${({ theme: theme })=>theme.colors.primary};
	line-height: 40px;
	padding-right: 20px;
`;
function $b7cf2e00be4cfa04$var$noop() {}
const $b7cf2e00be4cfa04$var$EXCERPT_MAX_CHARS = 400;
// Plain-text paragraphs of a rich-text description, cut to EXCERPT_MAX_CHARS with a trailing "..."
function $b7cf2e00be4cfa04$var$excerptParagraphs(html) {
    const element = document.createElement('div');
    element.innerHTML = html || '';
    const blocks = element.children.length > 0 ? Array.from(element.children).map((child)=>child.textContent.trim()) : [
        element.textContent.trim()
    ];
    const paragraphs = [];
    let remaining = $b7cf2e00be4cfa04$var$EXCERPT_MAX_CHARS;
    let truncated = false;
    for (const block of blocks){
        if (!block) continue;
        if (remaining <= 0) {
            truncated = true;
            break;
        }
        if (block.length > remaining) {
            paragraphs.push(block.substr(0, remaining));
            truncated = true;
            break;
        }
        paragraphs.push(block);
        remaining -= block.length;
    }
    if (truncated && paragraphs.length > 0) paragraphs[paragraphs.length - 1] = `${paragraphs[paragraphs.length - 1].replace(/[\s.]+$/, '')}...`;
    return paragraphs;
}
function $b7cf2e00be4cfa04$export$b6971e2dca177010({ person: person, values: values, full: full = false, excerpt: excerpt = false, onRemove: onRemove = $b7cf2e00be4cfa04$var$noop, clicked: clicked, usersById: usersById }) {
    const { user: user } = (0, $f8298f6bd5fca48e$export$a609e16b0cfae3f1)();
    const [addThumbsUp] = (0, $93486c083cb38a29$export$30e7a94a0bae9c05)({
        refetchQueries: [
            'getNominations'
        ],
        awaitRefetchQueries: true
    });
    const [removeThumbsUp] = (0, $93486c083cb38a29$export$f534093cbfcfcdb2)({
        refetchQueries: [
            'getNominations'
        ],
        awaitRefetchQueries: true
    });
    const count = values.thumbsup.length;
    const thumbsUpFromMe = values.thumbsup.find((t)=>t.user_id === user.id);
    const toggle = async ()=>{
        if (thumbsUpFromMe) await removeThumbsUp({
            variables: {
                nomId: values.id,
                userId: user.id
            }
        });
        else await addThumbsUp({
            variables: {
                nomination_id: values.id,
                user_id: user.id
            }
        });
    };
    const fromUser = usersById[values.from_user_id] || {};
    if (excerpt) return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $9659c1d5fc1e253c$export$1fb65d170d1a95bd), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $9659c1d5fc1e253c$export$9e528c5a3604495), {
                onClick: clicked || $b7cf2e00be4cfa04$var$noop,
                $clickable: !!clicked,
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $9659c1d5fc1e253c$export$902bfb0e958a48dc), {
                        src: person?.profilePhotoUrl
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsxs)((0, $9659c1d5fc1e253c$export$b7471996d5fe5bf0), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsxs)("h1", {
                                children: [
                                    person.firstName,
                                    " ",
                                    person.lastName
                                ]
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)("h2", {
                                children: values.category
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsxs)("p", {
                                children: [
                                    "Nominated by ",
                                    fromUser.firstName || '',
                                    " ",
                                    fromUser.lastName || '',
                                    /*#__PURE__*/ (0, $01ysi.jsx)("br", {}),
                                    (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(values.created_at).format('ll')
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $9659c1d5fc1e253c$export$5a7d29d0faf3de61), {
                children: $b7cf2e00be4cfa04$var$excerptParagraphs(values.description).map((paragraph, index)=>/*#__PURE__*/ (0, $01ysi.jsx)("p", {
                        children: paragraph
                    }, `${values.id}-excerpt-${index}`))
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $9659c1d5fc1e253c$export$695826fd6668d68), {
                onClick: clicked || $b7cf2e00be4cfa04$var$noop,
                children: "Read more"
            })
        ]
    });
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $9659c1d5fc1e253c$export$60332b2344f7fe41), {
        $fullWidth: true,
        $flat: true,
        children: [
            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $9659c1d5fc1e253c$export$c9831f72f461db7f), {
                onClick: clicked || $b7cf2e00be4cfa04$var$noop,
                $clickable: !!clicked,
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $9659c1d5fc1e253c$export$c5b1627c831752b2), {
                        src: person?.profilePhotoUrl
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsxs)((0, $9659c1d5fc1e253c$export$3b4b746f9037aa5e), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsxs)("h1", {
                                children: [
                                    person.firstName,
                                    " ",
                                    person.lastName
                                ]
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)("h2", {
                                children: values.category
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsxs)("h2", {
                                style: {
                                    color: '#777',
                                    fontSize: '75%'
                                },
                                children: [
                                    "by ",
                                    fromUser.firstName || '',
                                    " ",
                                    fromUser.lastName || '',
                                    " on",
                                    ' ',
                                    (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(values.created_at).format('ll')
                                ]
                            })
                        ]
                    })
                ]
            }),
            full && /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                style: {
                    paddingBottom: '1rem'
                },
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                        style: {
                            paddingTop: '1rem'
                        },
                        children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $17faf2022da0c55b$export$2e2bcd8739ae039), {
                            html: values.description
                        })
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $6e3a19da527b7fab$export$d56e283436f735f9), {
                        role: [
                            'SuperAdmin',
                            'Editor'
                        ],
                        children: /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                            style: {
                                paddingTop: '1rem'
                            },
                            children: /*#__PURE__*/ (0, $01ysi.jsx)($b7cf2e00be4cfa04$var$OrangeLink, {
                                onClick: onRemove,
                                children: "Remove Nomination"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsxs)((0, $9659c1d5fc1e253c$export$3553ba97f17c08a9), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                                style: {
                                    userSelect: 'none',
                                    display: 'flex',
                                    alignItems: 'center',
                                    paddingBottom: '4px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                                        onClick: toggle,
                                        style: {
                                            borderRadius: '8px',
                                            backgroundColor: thumbsUpFromMe ? 'rgb(99, 210, 130)' : undefined,
                                            border: '1px solid rgb(210, 210, 210)',
                                            padding: '0.5rem'
                                        },
                                        children: "\uD83D\uDC4D"
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                                        style: {
                                            paddingLeft: '1rem'
                                        },
                                        children: values.thumbsup.length > 0 && /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                                            style: {
                                                fontSize: '80%',
                                                lineHeight: '1.5'
                                            },
                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).chain(values.thumbsup).map((tu)=>usersById[tu.user_id]).compact().map((user)=>`${user.firstName} ${user.lastName}`).value().join(', ')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $d408feb4a7311f71$export$2e2bcd8739ae039), {
                                nominationId: values.id,
                                comments: values.comments,
                                refetch: [
                                    'getNominations'
                                ],
                                tiny: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $b7cf2e00be4cfa04$export$2e2bcd8739ae039 = $b7cf2e00be4cfa04$var$PersonCard;




var $jIrNf = parcelRequire("jIrNf");

var $awzbB = parcelRequire("awzbB");

var $gRqVZ = parcelRequire("gRqVZ");

var $gRqVZ = parcelRequire("gRqVZ");
function $cc9abbd4afa29def$var$makeTypeChecker(tabsRole) {
    return (element)=>!!element.type && element.type.tabsRole === tabsRole;
}
const $cc9abbd4afa29def$export$bdc9792d96913679 = $cc9abbd4afa29def$var$makeTypeChecker("Tab");
const $cc9abbd4afa29def$export$9c326233b9ae5588 = $cc9abbd4afa29def$var$makeTypeChecker("TabList");
const $cc9abbd4afa29def$export$9e12445c79db89b = $cc9abbd4afa29def$var$makeTypeChecker("TabPanel");


function $77493ca55e56cb45$var$isTabChild(child) {
    return (0, $cc9abbd4afa29def$export$bdc9792d96913679)(child) || (0, $cc9abbd4afa29def$export$9c326233b9ae5588)(child) || (0, $cc9abbd4afa29def$export$9e12445c79db89b)(child);
}
function $77493ca55e56cb45$export$ce7eaaed37329a1b(children, callback) {
    return (0, $gRqVZ.Children).map(children, (child)=>{
        if (child === null) return null;
        if ($77493ca55e56cb45$var$isTabChild(child)) return callback(child);
        if (child.props && child.props.children && typeof child.props.children === "object") return (0, $gRqVZ.cloneElement)(child, {
            ...child.props,
            children: $77493ca55e56cb45$export$ce7eaaed37329a1b(child.props.children, callback)
        });
        return child;
    });
}
function $77493ca55e56cb45$export$519ada94592b97fc(children, callback) {
    return (0, $gRqVZ.Children).forEach(children, (child)=>{
        if (child === null) return;
        if ((0, $cc9abbd4afa29def$export$bdc9792d96913679)(child) || (0, $cc9abbd4afa29def$export$9e12445c79db89b)(child)) callback(child);
        else if (child.props && child.props.children && typeof child.props.children === "object") {
            if ((0, $cc9abbd4afa29def$export$9c326233b9ae5588)(child)) callback(child);
            $77493ca55e56cb45$export$519ada94592b97fc(child.props.children, callback);
        }
    });
}



function $e97ac14e4521455d$export$3cf85bc178307212(props, propName, componentName) {
    let error;
    let tabsCount = 0;
    let panelsCount = 0;
    let tabListFound = false;
    const listTabs = [];
    const children = props[propName];
    (0, $77493ca55e56cb45$export$519ada94592b97fc)(children, (child)=>{
        if ((0, $cc9abbd4afa29def$export$9c326233b9ae5588)(child)) {
            if (child.props && child.props.children && typeof child.props.children === "object") (0, $77493ca55e56cb45$export$519ada94592b97fc)(child.props.children, (listChild)=>listTabs.push(listChild));
            if (tabListFound) error = new Error("Found multiple 'TabList' components inside 'Tabs'. Only one is allowed.");
            tabListFound = true;
        }
        if ((0, $cc9abbd4afa29def$export$bdc9792d96913679)(child)) {
            if (!tabListFound || listTabs.indexOf(child) === -1) error = new Error("Found a 'Tab' component outside of the 'TabList' component. 'Tab' components have to be inside the 'TabList' component.");
            tabsCount++;
        } else if ((0, $cc9abbd4afa29def$export$9e12445c79db89b)(child)) panelsCount++;
    });
    if (!error && tabsCount !== panelsCount) error = new Error(`There should be an equal number of 'Tab' and 'TabPanel' in \`${componentName}\`. ` + `Received ${tabsCount} 'Tab' and ${panelsCount} 'TabPanel'.`);
    return error;
}
function $e97ac14e4521455d$export$34b1d66fd6b9b91a(props, propName, componentName, location, propFullName) {
    const prop = props[propName];
    const name = propFullName || propName;
    let error = null;
    if (prop && typeof prop !== "function") error = new Error(`Invalid ${location} \`${name}\` of type \`${typeof prop}\` supplied ` + `to \`${componentName}\`, expected \`function\`.`);
    else if (props.selectedIndex != null && prop == null) error = new Error(`The ${location} \`${name}\` is marked as required in \`${componentName}\`, but ` + `its value is \`undefined\` or \`null\`.\n` + `\`onSelect\` is required when \`selectedIndex\` is also set. Not doing so will ` + `make the tabs not do anything, as \`selectedIndex\` indicates that you want to ` + `handle the selected tab yourself.\n` + `If you only want to set the inital tab replace \`selectedIndex\` with \`defaultIndex\`.`);
    return error;
}
function $e97ac14e4521455d$export$7293c2cd8d9ce46(props, propName, componentName, location, propFullName) {
    const prop = props[propName];
    const name = propFullName || propName;
    let error = null;
    if (prop != null && typeof prop !== "number") error = new Error(`Invalid ${location} \`${name}\` of type \`${typeof prop}\` supplied to ` + `\`${componentName}\`, expected \`number\`.`);
    else if (props.defaultIndex != null && prop != null) return new Error(`The ${location} \`${name}\` cannot be used together with \`defaultIndex\` ` + `in \`${componentName}\`.\n` + `Either remove \`${name}\` to let \`${componentName}\` handle the selected ` + `tab internally or remove \`defaultIndex\` to handle it yourself.`);
    return error;
}



var $awzbB = parcelRequire("awzbB");

var $gRqVZ = parcelRequire("gRqVZ");

var $5RjKS = parcelRequire("5RjKS");



function $79b9f269c63a6c84$export$1cb810e64a236e12(children) {
    let tabCount = 0;
    (0, $77493ca55e56cb45$export$519ada94592b97fc)(children, (child)=>{
        if ((0, $cc9abbd4afa29def$export$bdc9792d96913679)(child)) tabCount++;
    });
    return tabCount;
}




function $129aed36fcd2cd4d$var$isNode(node) {
    return node && "getAttribute" in node;
}
function $129aed36fcd2cd4d$var$isTabNode(node) {
    return $129aed36fcd2cd4d$var$isNode(node) && node.getAttribute("data-rttab");
}
function $129aed36fcd2cd4d$var$isTabDisabled(node) {
    return $129aed36fcd2cd4d$var$isNode(node) && node.getAttribute("aria-disabled") === "true";
}
let $129aed36fcd2cd4d$var$canUseActiveElement;
function $129aed36fcd2cd4d$var$determineCanUseActiveElement(environment) {
    const env = environment || (typeof window !== "undefined" ? window : undefined);
    try {
        $129aed36fcd2cd4d$var$canUseActiveElement = !!(typeof env !== "undefined" && env.document && env.document.activeElement);
    } catch (e) {
        $129aed36fcd2cd4d$var$canUseActiveElement = false;
    }
}
const $129aed36fcd2cd4d$var$defaultProps = {
    className: "react-tabs",
    focus: false
};
const $129aed36fcd2cd4d$var$propTypes = {
    children: (0, $e97ac14e4521455d$export$3cf85bc178307212)
};
const $129aed36fcd2cd4d$var$UncontrolledTabs = (props)=>{
    (0, $awzbB.checkPropTypes)($129aed36fcd2cd4d$var$propTypes, props, "prop", "UncontrolledTabs");
    let tabNodes = (0, $gRqVZ.useRef)([]);
    let tabIds = (0, $gRqVZ.useRef)([]);
    const ref = (0, $gRqVZ.useRef)();
    function setSelected(index, event) {
        if (index < 0 || index >= getTabsCount()) return;
        const { onSelect: onSelect, selectedIndex: selectedIndex } = props;
        onSelect(index, selectedIndex, event);
    }
    function getNextTab(index) {
        const count = getTabsCount();
        for(let i = index + 1; i < count; i++){
            if (!$129aed36fcd2cd4d$var$isTabDisabled(getTab(i))) return i;
        }
        for(let i = 0; i < index; i++){
            if (!$129aed36fcd2cd4d$var$isTabDisabled(getTab(i))) return i;
        }
        return index;
    }
    function getPrevTab(index) {
        let i = index;
        while(i--){
            if (!$129aed36fcd2cd4d$var$isTabDisabled(getTab(i))) return i;
        }
        i = getTabsCount();
        while(i-- > index){
            if (!$129aed36fcd2cd4d$var$isTabDisabled(getTab(i))) return i;
        }
        return index;
    }
    function getFirstTab() {
        const count = getTabsCount();
        for(let i = 0; i < count; i++){
            if (!$129aed36fcd2cd4d$var$isTabDisabled(getTab(i))) return i;
        }
        return null;
    }
    function getLastTab() {
        let i = getTabsCount();
        while(i--){
            if (!$129aed36fcd2cd4d$var$isTabDisabled(getTab(i))) return i;
        }
        return null;
    }
    function getTabsCount() {
        const { children: children } = props;
        return (0, $79b9f269c63a6c84$export$1cb810e64a236e12)(children);
    }
    function getTab(index) {
        return tabNodes.current[`tabs-${index}`];
    }
    function getChildren() {
        let index = 0;
        const { children: children, disabledTabClassName: disabledTabClassName, focus: focus, forceRenderTabPanel: forceRenderTabPanel, selectedIndex: selectedIndex, selectedTabClassName: selectedTabClassName, selectedTabPanelClassName: selectedTabPanelClassName, environment: environment } = props;
        tabIds.current = tabIds.current || [];
        let diff = tabIds.current.length - getTabsCount();
        const id = (0, $gRqVZ.useId)();
        while(diff++ < 0)tabIds.current.push(`${id}${tabIds.current.length}`);
        return (0, $77493ca55e56cb45$export$ce7eaaed37329a1b)(children, (child)=>{
            let result = child;
            if ((0, $cc9abbd4afa29def$export$9c326233b9ae5588)(child)) {
                let listIndex = 0;
                let wasTabFocused = false;
                if ($129aed36fcd2cd4d$var$canUseActiveElement == null) $129aed36fcd2cd4d$var$determineCanUseActiveElement(environment);
                const env = environment || (typeof window !== "undefined" ? window : undefined);
                if ($129aed36fcd2cd4d$var$canUseActiveElement && env) wasTabFocused = (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Children.toArray(child.props.children).filter((0, $cc9abbd4afa29def$export$bdc9792d96913679)).some((tab, i)=>env.document.activeElement === getTab(i));
                result = (0, $gRqVZ.cloneElement)(child, {
                    children: (0, $77493ca55e56cb45$export$ce7eaaed37329a1b)(child.props.children, (tab)=>{
                        const key = `tabs-${listIndex}`;
                        const selected = selectedIndex === listIndex;
                        const props = {
                            tabRef: (node)=>{
                                tabNodes.current[key] = node;
                            },
                            id: tabIds.current[listIndex],
                            selected: selected,
                            focus: selected && (focus || wasTabFocused)
                        };
                        if (selectedTabClassName) props.selectedClassName = selectedTabClassName;
                        if (disabledTabClassName) props.disabledClassName = disabledTabClassName;
                        listIndex++;
                        return (0, $gRqVZ.cloneElement)(tab, props);
                    })
                });
            } else if ((0, $cc9abbd4afa29def$export$9e12445c79db89b)(child)) {
                const props = {
                    id: tabIds.current[index],
                    selected: selectedIndex === index
                };
                if (forceRenderTabPanel) props.forceRender = forceRenderTabPanel;
                if (selectedTabPanelClassName) props.selectedClassName = selectedTabPanelClassName;
                index++;
                result = (0, $gRqVZ.cloneElement)(child, props);
            }
            return result;
        });
    }
    function handleKeyDown(e) {
        const { direction: direction, disableUpDownKeys: disableUpDownKeys, disableLeftRightKeys: disableLeftRightKeys } = props;
        if (isTabFromContainer(e.target)) {
            let { selectedIndex: index } = props;
            let preventDefault = false;
            let useSelectedIndex = false;
            if (e.code === "Space" || e.keyCode === 32 || e.code === "Enter" || e.keyCode === 13) {
                preventDefault = true;
                useSelectedIndex = false;
                handleClick(e);
            }
            if (!disableLeftRightKeys && (e.keyCode === 37 || e.code === "ArrowLeft") || !disableUpDownKeys && (e.keyCode === 38 || e.code === "ArrowUp")) {
                if (direction === "rtl") index = getNextTab(index);
                else index = getPrevTab(index);
                preventDefault = true;
                useSelectedIndex = true;
            } else if (!disableLeftRightKeys && (e.keyCode === 39 || e.code === "ArrowRight") || !disableUpDownKeys && (e.keyCode === 40 || e.code === "ArrowDown")) {
                if (direction === "rtl") index = getPrevTab(index);
                else index = getNextTab(index);
                preventDefault = true;
                useSelectedIndex = true;
            } else if (e.keyCode === 35 || e.code === "End") {
                index = getLastTab();
                preventDefault = true;
                useSelectedIndex = true;
            } else if (e.keyCode === 36 || e.code === "Home") {
                index = getFirstTab();
                preventDefault = true;
                useSelectedIndex = true;
            }
            if (preventDefault) e.preventDefault();
            if (useSelectedIndex) setSelected(index, e);
        }
    }
    function handleClick(e) {
        let node = e.target;
        do if (isTabFromContainer(node)) {
            if ($129aed36fcd2cd4d$var$isTabDisabled(node)) return;
            const index = [].slice.call(node.parentNode.children).filter($129aed36fcd2cd4d$var$isTabNode).indexOf(node);
            setSelected(index, e);
            return;
        }
        while ((node = node.parentNode) != null);
    }
    function isTabFromContainer(node) {
        if (!$129aed36fcd2cd4d$var$isTabNode(node)) return false;
        let nodeAncestor = node.parentElement;
        do {
            if (nodeAncestor === ref.current) return true;
            if (nodeAncestor.getAttribute("data-rttabs")) break;
            nodeAncestor = nodeAncestor.parentElement;
        }while (nodeAncestor);
        return false;
    }
    const { children: children, className: className, disabledTabClassName: disabledTabClassName, domRef: domRef, focus: focus, forceRenderTabPanel: forceRenderTabPanel, onSelect: onSelect, selectedIndex: selectedIndex, selectedTabClassName: selectedTabClassName, selectedTabPanelClassName: selectedTabPanelClassName, environment: environment, disableUpDownKeys: disableUpDownKeys, disableLeftRightKeys: disableLeftRightKeys, ...attributes } = {
        ...$129aed36fcd2cd4d$var$defaultProps,
        ...props
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", Object.assign({}, attributes, {
        className: (0, $5RjKS.default)(className),
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        ref: (node)=>{
            ref.current = node;
            if (domRef) domRef(node);
        },
        "data-rttabs": true
    }), getChildren());
};
var $129aed36fcd2cd4d$export$2e2bcd8739ae039 = $129aed36fcd2cd4d$var$UncontrolledTabs;



const $0b5f155847b26aea$var$MODE_CONTROLLED = 0;
const $0b5f155847b26aea$var$MODE_UNCONTROLLED = 1;
const $0b5f155847b26aea$var$propTypes = {
    children: (0, $e97ac14e4521455d$export$3cf85bc178307212),
    onSelect: (0, $e97ac14e4521455d$export$34b1d66fd6b9b91a),
    selectedIndex: (0, $e97ac14e4521455d$export$7293c2cd8d9ce46)
};
const $0b5f155847b26aea$var$defaultProps = {
    defaultFocus: false,
    focusTabOnClick: true,
    forceRenderTabPanel: false,
    selectedIndex: null,
    defaultIndex: null,
    environment: null,
    disableUpDownKeys: false,
    disableLeftRightKeys: false
};
const $0b5f155847b26aea$var$getModeFromProps = (props)=>{
    return props.selectedIndex === null ? $0b5f155847b26aea$var$MODE_UNCONTROLLED : $0b5f155847b26aea$var$MODE_CONTROLLED;
};
const $0b5f155847b26aea$var$checkForIllegalModeChange = (props, mode)=>{};
const $0b5f155847b26aea$var$Tabs = (props)=>{
    (0, $awzbB.checkPropTypes)($0b5f155847b26aea$var$propTypes, props, "prop", "Tabs");
    const { children: children, defaultFocus: defaultFocus, defaultIndex: defaultIndex, focusTabOnClick: focusTabOnClick, onSelect: onSelect, ...attributes } = {
        ...$0b5f155847b26aea$var$defaultProps,
        ...props
    };
    const [focus, setFocus] = (0, $gRqVZ.useState)(defaultFocus);
    const [mode] = (0, $gRqVZ.useState)($0b5f155847b26aea$var$getModeFromProps(attributes));
    const [selectedIndex, setSelectedIndex] = (0, $gRqVZ.useState)(mode === $0b5f155847b26aea$var$MODE_UNCONTROLLED ? defaultIndex || 0 : null);
    (0, $gRqVZ.useEffect)(()=>{
        setFocus(false);
    }, []);
    if (mode === $0b5f155847b26aea$var$MODE_UNCONTROLLED) {
        const tabsCount = (0, $79b9f269c63a6c84$export$1cb810e64a236e12)(children);
        (0, $gRqVZ.useEffect)(()=>{
            if (selectedIndex != null) {
                const maxTabIndex = Math.max(0, tabsCount - 1);
                setSelectedIndex(Math.min(selectedIndex, maxTabIndex));
            }
        }, [
            tabsCount
        ]);
    }
    $0b5f155847b26aea$var$checkForIllegalModeChange(attributes, mode);
    const handleSelected = (index, last, event)=>{
        if (typeof onSelect === "function") {
            if (onSelect(index, last, event) === false) return;
        }
        if (focusTabOnClick) setFocus(true);
        if (mode === $0b5f155847b26aea$var$MODE_UNCONTROLLED) setSelectedIndex(index);
    };
    let subProps = {
        ...props,
        ...attributes
    };
    subProps.focus = focus;
    subProps.onSelect = handleSelected;
    if (selectedIndex != null) subProps.selectedIndex = selectedIndex;
    delete subProps.defaultFocus;
    delete subProps.defaultIndex;
    delete subProps.focusTabOnClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement((0, $129aed36fcd2cd4d$export$2e2bcd8739ae039), subProps, children);
};
$0b5f155847b26aea$var$Tabs.tabsRole = "Tabs";
var $0b5f155847b26aea$export$2e2bcd8739ae039 = $0b5f155847b26aea$var$Tabs;



var $gRqVZ = parcelRequire("gRqVZ");

var $5RjKS = parcelRequire("5RjKS");
const $6bbe05191fca3492$var$defaultProps = {
    className: "react-tabs__tab-list"
};
const $6bbe05191fca3492$var$TabList = (props)=>{
    const { children: children, className: className, ...attributes } = {
        ...$6bbe05191fca3492$var$defaultProps,
        ...props
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("ul", Object.assign({}, attributes, {
        className: (0, $5RjKS.default)(className),
        role: "tablist"
    }), children);
};
$6bbe05191fca3492$var$TabList.tabsRole = "TabList";
var $6bbe05191fca3492$export$2e2bcd8739ae039 = $6bbe05191fca3492$var$TabList;



var $gRqVZ = parcelRequire("gRqVZ");

var $5RjKS = parcelRequire("5RjKS");
const $9f86117f466b34a0$var$DEFAULT_CLASS = "react-tabs__tab";
const $9f86117f466b34a0$var$defaultProps = {
    className: $9f86117f466b34a0$var$DEFAULT_CLASS,
    disabledClassName: `${$9f86117f466b34a0$var$DEFAULT_CLASS}--disabled`,
    focus: false,
    id: null,
    selected: false,
    selectedClassName: `${$9f86117f466b34a0$var$DEFAULT_CLASS}--selected`
};
const $9f86117f466b34a0$var$Tab = (props)=>{
    let nodeRef = (0, $gRqVZ.useRef)();
    const { children: children, className: className, disabled: disabled, disabledClassName: disabledClassName, focus: focus, id: id, selected: selected, selectedClassName: selectedClassName, tabIndex: tabIndex, tabRef: tabRef, ...attributes } = {
        ...$9f86117f466b34a0$var$defaultProps,
        ...props
    };
    (0, $gRqVZ.useEffect)(()=>{
        if (selected && focus) nodeRef.current.focus();
    }, [
        selected,
        focus
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("li", Object.assign({}, attributes, {
        className: (0, $5RjKS.default)(className, {
            [selectedClassName]: selected,
            [disabledClassName]: disabled
        }),
        ref: (node)=>{
            nodeRef.current = node;
            if (tabRef) tabRef(node);
        },
        role: "tab",
        id: `tab${id}`,
        "aria-selected": selected ? "true" : "false",
        "aria-disabled": disabled ? "true" : "false",
        "aria-controls": `panel${id}`,
        tabIndex: tabIndex || (selected ? "0" : null),
        "data-rttab": true
    }), children);
};
$9f86117f466b34a0$var$Tab.tabsRole = "Tab";
var $9f86117f466b34a0$export$2e2bcd8739ae039 = $9f86117f466b34a0$var$Tab;



var $gRqVZ = parcelRequire("gRqVZ");

var $5RjKS = parcelRequire("5RjKS");
const $00dc234844cc7684$var$DEFAULT_CLASS = "react-tabs__tab-panel";
const $00dc234844cc7684$var$defaultProps = {
    className: $00dc234844cc7684$var$DEFAULT_CLASS,
    forceRender: false,
    selectedClassName: `${$00dc234844cc7684$var$DEFAULT_CLASS}--selected`
};
const $00dc234844cc7684$var$TabPanel = (props)=>{
    const { children: children, className: className, forceRender: forceRender, id: id, selected: selected, selectedClassName: selectedClassName, ...attributes } = {
        ...$00dc234844cc7684$var$defaultProps,
        ...props
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", Object.assign({}, attributes, {
        className: (0, $5RjKS.default)(className, {
            [selectedClassName]: selected
        }),
        role: "tabpanel",
        id: `panel${id}`,
        "aria-labelledby": `tab${id}`
    }), forceRender || selected ? children : null);
};
$00dc234844cc7684$var$TabPanel.tabsRole = "TabPanel";
var $00dc234844cc7684$export$2e2bcd8739ae039 = $00dc234844cc7684$var$TabPanel;




const $cffdf4453f44ed2d$export$e51a686c67fdaa2d = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $6bbe05191fca3492$export$2e2bcd8739ae039))`
	display: flex;
	list-style: none;
	padding-left: 0;
`;
const $cffdf4453f44ed2d$export$3e41faf802a29e71 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $9f86117f466b34a0$export$2e2bcd8739ae039))`
	padding: 15px 10px;
	margin-right: 10px;
	&:hover {
		cursor: pointer;
		color: ${({ theme: theme })=>theme.colors.primary};
	}
	&.active {
		font-weight: 500;
		color: ${({ theme: theme })=>theme.colors.primary};
		border-bottom: 2px solid ${({ theme: theme })=>theme.colors.primary};
	}
`;
const $cffdf4453f44ed2d$export$9c591276dfd5d919 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $00dc234844cc7684$export$2e2bcd8739ae039))``;
function $cffdf4453f44ed2d$var$HomeRoute() {
    const { user: user } = (0, $f8298f6bd5fca48e$export$a609e16b0cfae3f1)();
    const { siteMeta: siteMeta } = (0, $6f7f49c0f054a62d$export$55c0e3cb4fbc46cf)();
    const { data: newsData, loading: newsLoading } = (0, $93486c083cb38a29$export$d0d6b485bf39808e)();
    const { data: resourcesData } = (0, $93486c083cb38a29$export$b0a115e858c0b484)();
    const favoriteResources = user.favoriteResources.map((fav)=>fav.resource);
    const bulletins = newsData?.bulletins ?? [];
    const homeMastheadUrl = siteMeta.pages.find((page)=>page.slug === 'home')?.masthead?.publicUrl;
    const { loading: usersLoading, data: usersData } = (0, $93486c083cb38a29$export$db5004fb9b9627eb)();
    const userOptions = (usersData?.users ?? []).map((u)=>({
            label: `${u.firstName} ${u.lastName}`,
            value: `${u.id}`
        }));
    const categoryOptions = [
        {
            value: 'Culture',
            label: 'Culture'
        },
        {
            value: 'Safety',
            label: 'Safety'
        },
        {
            value: 'Sustainability',
            label: 'Sustainability'
        },
        {
            value: 'Initiative',
            label: 'Initiative',
            explainer: 'Went the extra mile'
        },
        {
            value: 'Mentoring',
            label: 'Mentoring',
            explainer: 'Provided guidance and support to someone outside the scope of their job'
        },
        {
            value: 'Innovation',
            label: 'Innovation',
            explainer: 'Improved a process'
        },
        {
            value: 'Community',
            label: 'Community',
            explainer: 'Initiated or participated in a community project on behalf of Nibbi, or went the extra mile to build relationships in the communities where we work'
        },
        {
            value: 'Excellence',
            label: 'Excellence',
            explainer: 'Outstanding result such as financial, schedule, quality, or resolving a sticky issue'
        },
        {
            value: 'Client Service',
            label: 'Client Service',
            explainer: 'Exceeded client expectations, or Nibbi awarded a new job as a direct result of a person or team effort'
        }
    ];
    const [currentTab, setCurrentTab] = (0, $gRqVZ.useState)(0);
    const [singleNom, setSingleNom] = (0, $gRqVZ.useState)(null);
    const { data: nominationsRawData } = (0, $93486c083cb38a29$export$cec00d923a51c1d2)({
        skip: !(usersData?.users.length > 0)
    });
    const nominationsLoaded = Boolean(nominationsRawData?.v2_nominations);
    const usersById = (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).keyBy(usersData?.users || [], 'id');
    let nominations = [];
    let tabNominations = [];
    if (nominationsLoaded) {
        const thisMonthStart = (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))().startOf('month');
        const thisMonthEnd = (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))().endOf('month');
        const lastMonthStart = (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))().subtract(1, 'month').startOf('month');
        const lastMonthEnd = (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))().subtract(1, 'month').endOf('month');
        nominations = nominationsRawData.v2_nominations.map((n)=>{
            return {
                id: n.id,
                user: usersById[n.to_user_id] || {
                    firstName: n.to_name
                },
                values: n
            };
        });
        if (singleNom) tabNominations = nominations.filter((n)=>n.id === singleNom);
        else if (currentTab === 0) tabNominations = nominations.filter((nom)=>(0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(nom.values.created_at).isAfter(thisMonthStart) && (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(nom.values.created_at).isBefore(thisMonthEnd));
        else if (currentTab === 1) tabNominations = nominations.filter((nom)=>(0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(nom.values.created_at).isAfter(lastMonthStart) && (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(nom.values.created_at).isBefore(lastMonthEnd));
        else tabNominations = nominations;
    }
    const [addNominationMutation] = (0, $93486c083cb38a29$export$81097d281b2cbceb)({
        refetchQueries: [
            'getNominations'
        ],
        awaitRefetchQueries: true
    });
    const [sendNominationEmail] = (0, $93486c083cb38a29$export$7c8d4dabf7d36a38)();
    const [removeNominationMutation] = (0, $93486c083cb38a29$export$965ca2601dea06c)({
        refetchQueries: [
            'getNominations'
        ],
        awaitRefetchQueries: true
    });
    const nomModalHeader = singleNom ? 'Cheers Nomination' : 'Cheers Nominations';
    const [allNomsModal, setShowAllNominations] = (0, $63e9a7af5676c306$export$33ffd74ebf07f060)({
        tall: true,
        header: nomModalHeader,
        onClose: ()=>{
            setSingleNom(null);
        },
        children: /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
            children: [
                !singleNom && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $0b5f155847b26aea$export$2e2bcd8739ae039), {
                    style: {
                        paddingBottom: '1rem'
                    },
                    selectedIndex: currentTab,
                    selectedTabClassName: "active",
                    onSelect: (index)=>{
                        setCurrentTab(index);
                    },
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsxs)($cffdf4453f44ed2d$export$e51a686c67fdaa2d, {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)($cffdf4453f44ed2d$export$3e41faf802a29e71, {
                                    children: "This Month"
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)($cffdf4453f44ed2d$export$3e41faf802a29e71, {
                                    children: "Last Month"
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)($cffdf4453f44ed2d$export$3e41faf802a29e71, {
                                    children: "All Time"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)($cffdf4453f44ed2d$export$9c591276dfd5d919, {}),
                        /*#__PURE__*/ (0, $01ysi.jsx)($cffdf4453f44ed2d$export$9c591276dfd5d919, {}),
                        /*#__PURE__*/ (0, $01ysi.jsx)($cffdf4453f44ed2d$export$9c591276dfd5d919, {})
                    ]
                }),
                tabNominations.length === 0 && /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                    children: [
                        currentTab === 0 && /*#__PURE__*/ (0, $01ysi.jsx)("em", {
                            children: "There have been no nominations this month."
                        }),
                        currentTab === 1 && /*#__PURE__*/ (0, $01ysi.jsx)("em", {
                            children: "There were no nominations last month."
                        }),
                        currentTab === 2 && /*#__PURE__*/ (0, $01ysi.jsx)("em", {
                            children: "There have been no nominations."
                        })
                    ]
                }),
                tabNominations.map((nom)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $b7cf2e00be4cfa04$export$b6971e2dca177010), {
                        person: nom.user,
                        values: nom.values,
                        usersById: usersById,
                        full: true,
                        onRemove: async ()=>{
                            if (confirm('Are you sure you want to remove this nomination?')) await removeNominationMutation({
                                variables: {
                                    _eq: nom.id
                                }
                            });
                        }
                    }, nom.id))
            ]
        })
    });
    const defaultNominatingName = '...';
    const [nominatingName, setNominatingName] = (0, $gRqVZ.useState)(defaultNominatingName);
    const [nominationModal, setNominationModal, nominationModalOpen] = (0, $63e9a7af5676c306$export$33ffd74ebf07f060)({
        tall: true,
        header: `Cheers to ${nominatingName}`,
        children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Formik), {
            initialValues: {
                userId: {
                    value: -1
                },
                project: '',
                category: {
                    value: ''
                },
                description: ''
            },
            validate: (values)=>{
                const errors = {};
                if (!values.userId || values.userId?.value === -1) errors.userId = 'Choose or type in the name of a person';
                if (values.category.value === '') errors.category = 'Choose a category';
                return errors;
            },
            onSubmit: async (values)=>{
                const toUserId = +values.userId.value > 0 ? +values.userId.value : null;
                let toUserName = '';
                if (!toUserId) toUserName = values.userId.value.toString() || '';
                await addNominationMutation({
                    variables: {
                        category: values.category.value,
                        description: values.description,
                        from_user_id: user.id,
                        project: values.project,
                        to_name: toUserName,
                        to_user_id: toUserId
                    }
                });
                const userId = +values.userId?.value;
                const { email: email, supervisorId: supervisorId, firstName: firstName, lastName: lastName } = usersById[userId] ?? {};
                let mgrEmail = null;
                if (supervisorId) {
                    const supervisorEmail = usersById[supervisorId]?.email;
                    if (supervisorEmail) mgrEmail = supervisorEmail;
                }
                if (userId > 0 && email) {
                    const emailVariables = {
                        to: email,
                        mgr_to: mgrEmail,
                        category: values.category.value,
                        html: values.description,
                        name: `${user.firstName || ''} ${user.lastName || ''}`,
                        to_name: `${firstName || ''} ${lastName || ''}`
                    };
                    if (location.host.endsWith('1234')) {
                        emailVariables.to = `test+${emailVariables.to.split('@')[0]}@mweber.xyz`;
                        if (emailVariables.mgr_to) emailVariables.mgr_to = `test+${emailVariables.mgr_to.split('@')[0]}@mweber.xyz`;
                    }
                    await sendNominationEmail({
                        variables: emailVariables
                    });
                }
                setNominationModal(false);
            },
            children: ({ values: values, setFieldValue: setFieldValue, errors: errors, touched: touched })=>{
                return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $489wz.Form), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                            name: "userId",
                            type: "select2-create",
                            label: "Who are you nominating?",
                            options: userOptions,
                            onChange: (value)=>{
                                const name = value?.label ? `${value?.label}!` : defaultNominatingName;
                                if (name !== nominatingName) setNominatingName(name);
                            },
                            formatCreateLabel: (name)=>/*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $01ysi.jsx)("em", {
                                            children: "Add"
                                        }),
                                        " ",
                                        name
                                    ]
                                }),
                            placeholder: "If not listed, type a full name and click Add"
                        }),
                        touched.userId && errors.userId && /*#__PURE__*/ (0, $01ysi.jsx)("em", {
                            style: {
                                fontSize: '80%',
                                color: 'red'
                            },
                            children: errors.userId
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                            name: "category",
                            type: "select2",
                            label: "Which category are you nominating for?",
                            options: categoryOptions,
                            formatOptionLabel: (data, { context: context })=>{
                                return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                                            children: data.label
                                        }),
                                        context === 'menu' && data.explainer && /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                                            style: {
                                                fontSize: '75%',
                                                color: values.category.value === data.value ? 'white' : '#777'
                                            },
                                            children: data.explainer
                                        })
                                    ]
                                });
                            }
                        }),
                        touched.category && errors.category && /*#__PURE__*/ (0, $01ysi.jsx)("em", {
                            style: {
                                fontSize: '80%',
                                color: 'red'
                            },
                            children: errors.category
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                            name: "description",
                            type: "richText",
                            label: "Describe what inspired your nomination",
                            value: values.description,
                            placeholder: "",
                            onChange: (val)=>setFieldValue('description', val)
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                            type: "formButtons",
                            onCancel: ()=>setNominationModal(false),
                            hideBorderTop: true
                        })
                    ]
                });
            }
        })
    });
    (0, $gRqVZ.useEffect)(()=>{
        if (!nominationModalOpen && nominatingName !== defaultNominatingName) setNominatingName(defaultNominatingName);
    }, [
        nominatingName,
        nominationModalOpen
    ]);
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
        children: [
            nominationModal,
            allNomsModal,
            bulletins.length > 0 ? /*#__PURE__*/ (0, $01ysi.jsx)((0, $a1ab066ba033e276$export$2e2bcd8739ae039), {
                bulletins: bulletins
            }) : !newsLoading && /*#__PURE__*/ (0, $01ysi.jsx)((0, $1cc0b2ae0e4c17ef$export$2e2bcd8739ae039), {
                imageUrl: homeMastheadUrl,
                title: "Home",
                hideTitle: true
            }),
            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$49179fad9cbb4914), {
                        children: [
                            nominationsLoaded && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$39569374dd0a7ae4), {
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$49ee65310093c629), {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5b358dfa2d749906$exports))),
                                        alt: "Cheers!"
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$675ffd416e9f6cb2), {
                                        children: "Give a shout out to those who have gone the extra mile!"
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$f9ea6d490fa8f29b), {
                                        type: "button",
                                        onClick: ()=>setNominationModal(true),
                                        children: "Nominate Someone"
                                    }),
                                    nominations.length > 0 && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$86df63557533e379), {
                                                children: "Recent Nominations"
                                            }),
                                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$d0d461570bb05eef), {
                                                children: nominations.slice(0, 2).map((nom)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $b7cf2e00be4cfa04$export$b6971e2dca177010), {
                                                        person: nom.user,
                                                        values: nom.values,
                                                        usersById: usersById,
                                                        excerpt: true,
                                                        clicked: ()=>{
                                                            setSingleNom(nom.id);
                                                            setShowAllNominations(true);
                                                        }
                                                    }, nom.id))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$dfe40b807d13c5aa), {
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$72d7ca7a5d1d4807), {
                                        children: "Resources"
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$c01249859845133d), {
                                        children: (resourcesData?.resources || []).map((resource)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $cb071fc609c78ddc$export$2e2bcd8739ae039), {
                                                data: resource,
                                                $displaySize: "lg"
                                            }, `resources:${resource.id}`))
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$3a8184ef57a56b16), {
                                        children: [
                                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$264a15c11cb11239), {}),
                                            "Favorites"
                                        ]
                                    }),
                                    favoriteResources.length > 0 ? /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$e7e90c8c67c6df42), {
                                        children: favoriteResources.map((resource)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $cb071fc609c78ddc$export$2e2bcd8739ae039), {
                                                data: resource,
                                                $displaySize: "lg"
                                            }, `resources:${resource.id}`))
                                    }) : /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$ed56e549b7f4213a), {
                                        children: "You do not have any favorite resources yet."
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$4b44a6d406dc5013), {
                                        to: "/resources",
                                        children: "More resources"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $37e13e4fab35f1f0$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $34c2b2a28ed152e1$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$6197db13564fe49b), {
                children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $4d926900275fb07e$export$e56e199144073d66), {
                    children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$35d6cd4f175d16cb), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$c84356afd4299847), {
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)("h4", {
                                        children: "Mission Statement"
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)("p", {
                                        children: "Serving our clients and community by building safely with integrity, innovation and quality."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$c84356afd4299847), {
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)("h4", {
                                        children: "Vision Statement"
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)("p", {
                                        children: "Be the well-respected builder and employer of choice, focused on safety, quality and profitability."
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$aa94567eee2dd6a9), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)("h3", {
                            children: "Our Core Values"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$a61354fecfb7e020), {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$44dbc8d42127124a), {
                                    children: [
                                        /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$83092fdad39ac601), {
                                            children: [
                                                /*#__PURE__*/ (0, $01ysi.jsx)("h4", {
                                                    children: "Safety"
                                                }),
                                                /*#__PURE__*/ (0, $01ysi.jsx)("p", {
                                                    children: "We are firmly committed to maintaining the safest possible jobsite for our employees, subcontractors, clients and the community. We constantly work to improve awareness and accident prevention through continual staff training and highly detailed pre-task planning."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$83092fdad39ac601), {
                                            children: [
                                                /*#__PURE__*/ (0, $01ysi.jsx)("h4", {
                                                    children: "Honesty & Integrity"
                                                }),
                                                /*#__PURE__*/ (0, $01ysi.jsx)("p", {
                                                    children: "Nibbi operates with the highest professional and ethical standards. We stand behind our work and do what is best for each project, allowing our corporate culture and values to guide our conduct."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$44dbc8d42127124a), {
                                    children: [
                                        /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$83092fdad39ac601), {
                                            children: [
                                                /*#__PURE__*/ (0, $01ysi.jsx)("h4", {
                                                    children: "Client Focus"
                                                }),
                                                /*#__PURE__*/ (0, $01ysi.jsx)("p", {
                                                    children: "Our highest priority is helping our clients find solutions to achieve their objectives. We continuously strive to better serve our clients through collaboration, innovation and efficiency."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$83092fdad39ac601), {
                                            children: [
                                                /*#__PURE__*/ (0, $01ysi.jsx)("h4", {
                                                    children: "Social Responsibility"
                                                }),
                                                /*#__PURE__*/ (0, $01ysi.jsx)("p", {
                                                    children: "We genuinely care for the communities in which we live and work. We give our time, talent and resources to local communities and organizations in need. We practice sustainable and green construction processes and are environmentally conscious in our everyday work lives."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$83092fdad39ac601), {
                                            children: [
                                                /*#__PURE__*/ (0, $01ysi.jsx)("h4", {
                                                    children: "Family Culture"
                                                }),
                                                /*#__PURE__*/ (0, $01ysi.jsx)("p", {
                                                    children: "We are proud of our emphasis on fostering a strong sense of family through caring, mutual respect and promoting a strong work / life balance."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$44dbc8d42127124a), {
                                    children: [
                                        /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$83092fdad39ac601), {
                                            children: [
                                                /*#__PURE__*/ (0, $01ysi.jsx)("h4", {
                                                    children: "Opportunity"
                                                }),
                                                /*#__PURE__*/ (0, $01ysi.jsx)("p", {
                                                    children: "We provide dynamic career opportunities and mentoring for our employees. We encourage leadership training and continuing education at all levels. We continuously strive to recruit and develop the best talent."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4d926900275fb07e$export$83092fdad39ac601), {
                                            children: [
                                                /*#__PURE__*/ (0, $01ysi.jsx)("h4", {
                                                    children: "Financial Stability"
                                                }),
                                                /*#__PURE__*/ (0, $01ysi.jsx)("p", {
                                                    children: "Nibbi believes great companies are built on sound financial practices and a history of solid financial results. We are committed to effectively managing our financial resources and earning a consistent profit to support our clients\u2019 needs and achieve our long-term goals."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
var $cffdf4453f44ed2d$export$2e2bcd8739ae039 = $cffdf4453f44ed2d$var$HomeRoute;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");

var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");



const $650460b78c406cba$export$54c2e3dc7acea9f5 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).ul`
	margin: 0;
	padding: 0;
	list-style: none;
	> li + li {
		margin-top: 16px;
	}
`;
const $650460b78c406cba$export$a7b06bfba60a8a78 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).li`
	display: block;
`;
const $650460b78c406cba$export$b08a9033b36413fb = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	opacity: 0.8;
	font-size: 80%;
`;



function $ced951540982f79e$var$CompanyDirectory() {
    const { loading: loading, data: data } = (0, $93486c083cb38a29$export$db5004fb9b9627eb)();
    const users = data?.users;
    return loading ? /*#__PURE__*/ (0, $01ysi.jsx)((0, $8d13d13871606beb$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $01ysi.jsx)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $650460b78c406cba$export$54c2e3dc7acea9f5), {
            children: users.map((user)=>{
                const manager = users.find((u)=>u.id === user.managerId);
                return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $650460b78c406cba$export$a7b06bfba60a8a78), {
                    children: [
                        user.firstName,
                        " ",
                        user.lastName,
                        /*#__PURE__*/ (0, $01ysi.jsxs)((0, $650460b78c406cba$export$b08a9033b36413fb), {
                            children: [
                                user.department?.title ?? 'No Department',
                                " - ",
                                user.title,
                                manager && /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                                    children: [
                                        "Manager: ",
                                        manager.firstName,
                                        " ",
                                        manager.lastName
                                    ]
                                })
                            ]
                        })
                    ]
                }, user.id);
            })
        })
    });
}
var $ced951540982f79e$export$2e2bcd8739ae039 = $ced951540982f79e$var$CompanyDirectory;


function $839dd07d6fb046f9$var$UsersRoute() {
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $ced951540982f79e$export$2e2bcd8739ae039), {});
}
var $839dd07d6fb046f9$export$2e2bcd8739ae039 = $839dd07d6fb046f9$var$UsersRoute;



var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");





const $2510a4d11c024ddc$export$f39f3f768bc98e3d = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	padding-right: 25px;
`;
const $2510a4d11c024ddc$export$4df68285e3a811a1 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	background: ${({ theme: theme })=>theme.colors.lightGray};
	width: 300px;
	${(0, $82fc1d9685dfa321$export$c42d5fd08085a81a)}, ${(0, $82fc1d9685dfa321$export$e3925dbaeffcc83f)} {
		border-bottom: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
		padding: 12px 20px;
		font-size: 14px;
		&:last-child {
			border-bottom: none;
		}
		&.current {
			font-weight: bold;
			border-left: 5px solid ${({ theme: theme })=>theme.colors.primary};
			color: ${({ theme: theme })=>theme.colors.primary};
		}
	}
`;
const $2510a4d11c024ddc$export$bba984930aaf8051 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).img`
	padding-bottom: 20px;
`;
const $2510a4d11c024ddc$export$5b73b7d3ddc41bc6 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: none;
	&.displayLinks {
		display: block;
		background: ${({ theme: theme })=>theme.colors.darkGray};
		padding: 10px 0px;
	}
`;
const $2510a4d11c024ddc$export$112d9800d37be814 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $e3f57e4b1ea630bd$export$b0d92dbee9b5b60d))`
	${(0, $82fc1d9685dfa321$export$4c2f3def9501b358)}
	padding: 5px 20px;
	color: ${({ theme: theme })=>theme.colors.lightestGray};
	font-size: 14px;
`;
const $2510a4d11c024ddc$export$5deb52c8002207a7 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div``;
const $2510a4d11c024ddc$export$1d5c6c6cbddb6734 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).span`
	font-weight: 600;
	font-size: 25px;
	color: ${({ theme: theme })=>theme.colors.lightestGray};
`;



function $f17ceecf287e1f86$var$getSublinksOpenIndicator(showSubLinks, subLinks, sublinkIsActive) {
    if (showSubLinks || sublinkIsActive) return '-';
    if (subLinks?.length > 0) return '+';
    return null;
}
function $f17ceecf287e1f86$var$Sidebar({ logoUrl: logoUrl, links: links, children: children }) {
    const { isAdmin: isAdmin } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    const adminFilter = isAdmin ? ()=>true : (r)=>!r.adminOnly;
    const filteredLinks = links.filter(adminFilter);
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2510a4d11c024ddc$export$f39f3f768bc98e3d), {
        children: [
            logoUrl && /*#__PURE__*/ (0, $01ysi.jsx)((0, $2510a4d11c024ddc$export$bba984930aaf8051), {
                src: logoUrl
            }),
            filteredLinks.length > 0 && /*#__PURE__*/ (0, $01ysi.jsx)((0, $2510a4d11c024ddc$export$4df68285e3a811a1), {
                children: filteredLinks.map((link)=>{
                    const showSubLinks = location.pathname === link.to && link.subLinks?.length > 0;
                    const sublinkIsActive = location.pathname.startsWith(link.to + '/') && link.subLinks?.length > 0 && location.pathname.split('/').length != link.to.split('/').length;
                    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2510a4d11c024ddc$export$5deb52c8002207a7), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $b37734d97fc999d6$export$2e2bcd8739ae039), {
                                to: link.to,
                                sublinkIsActive: sublinkIsActive,
                                children: [
                                    link.title,
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $2510a4d11c024ddc$export$1d5c6c6cbddb6734), {
                                        children: $f17ceecf287e1f86$var$getSublinksOpenIndicator(showSubLinks, link.subLinks, sublinkIsActive)
                                    })
                                ]
                            }, `sidebar-nav-${link.title}`),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $2510a4d11c024ddc$export$5b73b7d3ddc41bc6), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1aa98e792ef58eec$exports)))({
                                    ['displayLinks']: showSubLinks || sublinkIsActive
                                }),
                                children: link.subLinks?.map((subLink)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $2510a4d11c024ddc$export$112d9800d37be814), {
                                        to: subLink.to,
                                        className: ({ isActive: isActive })=>isActive ? 'current' : '',
                                        end: true,
                                        children: subLink.title
                                    }, `sublink-${link.title}-${subLink.title}`))
                            })
                        ]
                    }, `sidebar-links-${link.title}`);
                })
            }),
            children
        ]
    });
}
var $f17ceecf287e1f86$export$2e2bcd8739ae039 = $f17ceecf287e1f86$var$Sidebar;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");

const $38e8ff2ff45ad7fb$var$Layout = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	> *:nth-child(2) {
		width: 100%;
	}
`;
function $38e8ff2ff45ad7fb$var$LayoutWithSidebar({ children: children }) {
    return /*#__PURE__*/ (0, $01ysi.jsx)($38e8ff2ff45ad7fb$var$Layout, {
        children: children
    });
}
var $38e8ff2ff45ad7fb$export$2e2bcd8739ae039 = $38e8ff2ff45ad7fb$var$LayoutWithSidebar;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");

var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");



const $4a2a2ef728baaca5$export$66d74d3543aad6b8 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	border-top: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	font-size: 16px;
	display: flex;
	margin-top: 20px;
`;
const $4a2a2ef728baaca5$export$6e2c8f0811a474ce = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	padding: 0px 10px;
	margin-top: 10px;
`;
const $4a2a2ef728baaca5$export$9093d7f37b4946de = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $e3f57e4b1ea630bd$export$b0d92dbee9b5b60d))`
	text-decoration: none;
	font-weight: 300;
	color: ${({ theme: theme })=>theme.colors.primary};
`;
const $4a2a2ef728baaca5$export$8b251419efc915eb = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	justify-content: space-between;
	margin: 15px 0px;
	h2 {
		font-weight: 500;
		font-size: 16px;
	}
`;


function $1c3b3c5e1c4e70d7$export$2e2bcd8739ae039(props) {
    if (props.data.length == 0 && !props.emptyText) return null;
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4a2a2ef728baaca5$export$6e2c8f0811a474ce), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4a2a2ef728baaca5$export$8b251419efc915eb), {
                children: [
                    props.title && /*#__PURE__*/ (0, $01ysi.jsx)("h2", {
                        children: props.title
                    }),
                    props.headerLink && /*#__PURE__*/ (0, $01ysi.jsx)((0, $4a2a2ef728baaca5$export$9093d7f37b4946de), {
                        to: props.headerLink.to,
                        children: props.headerLink.title
                    })
                ]
            }),
            props.data.map((linkCardData)=>{
                return /*#__PURE__*/ (0, $01ysi.jsx)((0, $cb071fc609c78ddc$export$2e2bcd8739ae039), {
                    data: linkCardData,
                    departmentId: props.departmentId,
                    showSubtitleActions: props.showSubtitleActions
                }, `${linkCardData.__typename}:${linkCardData.id}`);
            }),
            props.data.length === 0 && /*#__PURE__*/ (0, $01ysi.jsx)("p", {
                children: props.emptyText
            })
        ]
    });
}




const $621b466dce1f9db7$var$SideBySide = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	border-top: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	font-size: 16px;
	display: flex;
	margin-top: 20px;
	> * {
		width: 100%;
	}
`;
function $621b466dce1f9db7$var$LatestNewsAndDiscussions() {
    const department = (0, $154dffb4cf685475$export$5c120892d522df6d)();
    const { bulletins: bulletins, discussions: discussions } = department;
    const showSection = bulletins.length > 0 || discussions.length > 0;
    return showSection ? /*#__PURE__*/ (0, $01ysi.jsxs)($621b466dce1f9db7$var$SideBySide, {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $1c3b3c5e1c4e70d7$export$2e2bcd8739ae039), {
                title: "Latest News",
                departmentId: department.id,
                data: bulletins.slice(0, 3),
                headerLink: {
                    title: 'See All News & Announcements',
                    to: `/departments/${department.id}/news/`
                }
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $1c3b3c5e1c4e70d7$export$2e2bcd8739ae039), {
                title: "Recent Discussions",
                departmentId: department.id,
                data: discussions.slice(0, 3),
                headerLink: {
                    title: 'See All Discussions',
                    to: `/departments/${department.id}/discussions/`
                }
            })
        ]
    }) : null;
}
var $621b466dce1f9db7$export$2e2bcd8739ae039 = $621b466dce1f9db7$var$LatestNewsAndDiscussions;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");


var $jIrNf = parcelRequire("jIrNf");

var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");


const $355796544c0c0b43$var$Breadcrumbs = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).h1`
	font-weight: lighter;
	line-height: 40px;
	font-size: 20px;
	padding-bottom: 20px;
	a {
		text-decoration: none;
		color: ${({ theme: theme })=>theme.colors.primary};
	}
`;
const $355796544c0c0b43$var$Heading = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).h1`
	font-weight: lighter;
	line-height: 40px;
	color: ${(props)=>props.primaryColor ? props.theme.colors.primary : props.theme.colors.primaryTextColor};
	font-size: 40px;
	padding-bottom: 20px;
`;
function $355796544c0c0b43$var$PageHeader({ children: children, parents: parents, primaryColor: primaryColor = true }) {
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
        children: [
            parents?.length > 0 && /*#__PURE__*/ (0, $01ysi.jsx)($355796544c0c0b43$var$Breadcrumbs, {
                children: parents.map((p, index)=>/*#__PURE__*/ (0, $01ysi.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $e3f57e4b1ea630bd$export$b0d92dbee9b5b60d), {
                                to: p.to,
                                children: p.title
                            }),
                            ' / '
                        ]
                    }, index))
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)($355796544c0c0b43$var$Heading, {
                primaryColor: primaryColor,
                children: children
            })
        ]
    });
}
var $355796544c0c0b43$export$2e2bcd8739ae039 = $355796544c0c0b43$var$PageHeader;


function $a0dff761b892795c$var$ContentHeader({ children: children, parent: parent, showBreadcrumbs: showBreadcrumbs = true, primaryColor: primaryColor }) {
    primaryColor ??= true;
    const department = (0, $154dffb4cf685475$export$5c120892d522df6d)();
    const parents = (0, $jIrNf.compact)([
        showBreadcrumbs && {
            to: `/departments/${department.id}/overview`,
            title: department.title
        },
        parent?.__typename === 'contents' && {
            to: `/departments/${department.id}/contents/${parent.id}`,
            title: parent.title
        },
        parent?.__typename === 'static' && {
            to: parent.to,
            title: parent.label
        }
    ]);
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $355796544c0c0b43$export$2e2bcd8739ae039), {
        primaryColor: primaryColor,
        parents: parents,
        children: children
    });
}
var $a0dff761b892795c$export$2e2bcd8739ae039 = $a0dff761b892795c$var$ContentHeader;



const $8f154b5038c2a17a$var$BodyText = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	line-height: 1.625;
	color: ${({ theme: theme })=>theme.colors.primaryTextColor};
	ul {
		li + li {
			margin-top: 8px;
		}
	}
	h3 {
		font-weight: normal;
		line-height: 40px;
		font-size: 32px;
	}
	h4 {
		font-weight: normal;
		line-height: 30px;
		font-size: 25px;
	}
`;
var $8f154b5038c2a17a$export$2e2bcd8739ae039 = $8f154b5038c2a17a$var$BodyText;


function $bd1dd58c3466d235$var$Overview() {
    const department = (0, $154dffb4cf685475$export$5c120892d522df6d)();
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $8f154b5038c2a17a$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $a0dff761b892795c$export$2e2bcd8739ae039), {
                showBreadcrumbs: false,
                children: "Mission Statement"
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $17faf2022da0c55b$export$2e2bcd8739ae039), {
                html: department.missionStatement
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $621b466dce1f9db7$export$2e2bcd8739ae039), {})
        ]
    });
}
var $bd1dd58c3466d235$export$2e2bcd8739ae039 = $bd1dd58c3466d235$var$Overview;



var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");





var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");

const $85e77696c506735f$var$StyledSelect = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).select`
	background-color: white;
	border: 1px solid ${({ theme: theme })=>theme.colors.lightGray};
	padding: 10px;
	border-radius: 3px;
`;
function $85e77696c506735f$var$Select({ children: children, ...props }) {
    return /*#__PURE__*/ (0, $01ysi.jsx)($85e77696c506735f$var$StyledSelect, {
        ...props,
        children: children
    });
}
var $85e77696c506735f$export$2e2bcd8739ae039 = $85e77696c506735f$var$Select;



const $87a6c986bb5a7467$export$e3201a7a340f76b8 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	h2 {
		margin-bottom: 15px;
		font-size: 35px;
		font-weight: 300;
	}
	p,
	li {
		color: ${({ theme: theme })=>theme.colors.primaryTextColor};
		line-height: 1.8;
		font-weight: 300;
	}
	h3 {
		margin: 15px 0px;
		font-size: 25px;
		font-weight: 300;
	}
`;
const $87a6c986bb5a7467$export$77f388591e028595 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	padding-bottom: 10px;
	span {
		color: ${({ theme: theme })=>theme.colors.primary};
		text-decoration: none;
		&:not(:last-child) {
			padding-right: 15px;
		}
		&:hover {
			cursor: pointer;
		}
	}
`;







var $jIrNf = parcelRequire("jIrNf");
function $8d0e3fc0f3f02fc6$var$Contents() {
    const navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    const department = (0, $154dffb4cf685475$export$5c120892d522df6d)();
    const { contentsId: contentsId, subContentsId: subContentsId } = (0, $372fcccf2bee01ac$export$99eaa27ddbbb95ef)();
    const [isEditing, setIsEditing] = (0, $gRqVZ.useState)(false);
    const [disablePage] = (0, $93486c083cb38a29$export$7a3a20a6962063c2)({
        refetchQueries: [
            'departmentDetails'
        ],
        awaitRefetchQueries: true
    });
    const { isAdmin: isAdmin, useRole: useRole } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    const [sortIdx, setSortIdx] = (0, $gRqVZ.useState)(0);
    const sortOptions = [
        {
            value: [
                'resource.createdAt',
                'desc'
            ],
            label: 'Newest'
        },
        {
            value: [
                'resource.createdAt',
                'asc'
            ],
            label: 'Oldest'
        },
        {
            value: [
                'resource.title',
                'asc'
            ],
            label: 'Name'
        }
    ];
    const [sortField, sortDir] = sortOptions[sortIdx].value;
    const primaryContents = department.contents.find((content)=>content.id === +contentsId);
    const content = subContentsId ? primaryContents.contents.find((subContent)=>subContent.id === +subContentsId) : primaryContents;
    const contentResources = content?.contentResources ? (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).orderBy(content.contentResources, [
        sortField
    ], [
        sortDir
    ]) : [];
    (0, $gRqVZ.useEffect)(()=>{
        setIsEditing(false);
    }, [
        content?.id
    ]);
    if (!content) return null;
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $87a6c986bb5a7467$export$e3201a7a340f76b8), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $a0dff761b892795c$export$2e2bcd8739ae039), {
                parent: subContentsId ? primaryContents : null,
                primaryColor: false,
                children: content.title
            }),
            isAdmin && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $87a6c986bb5a7467$export$77f388591e028595), {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                        onClick: ()=>setIsEditing(!isEditing),
                        children: "Edit"
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                        onClick: async ()=>{
                            if (confirm('Are you sure you want to delete this page?')) {
                                await disablePage({
                                    context: {
                                        useRole: useRole
                                    },
                                    variables: {
                                        contentId: content.id
                                    }
                                });
                                navigate(`/departments/${department.id}/overview`);
                            }
                        },
                        children: "Delete"
                    })
                ]
            }),
            isEditing && /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $c4d5c805500e2fac$export$2e2bcd8739ae039), {
                    existing: content,
                    cancelEditing: ()=>setIsEditing(false)
                })
            }),
            !isEditing && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $17faf2022da0c55b$export$2e2bcd8739ae039), {
                        html: content.body
                    }),
                    contentResources.length > 0 && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)("h3", {
                                        children: "Related Resources"
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsxs)("span", {
                                        style: {
                                            margin: '15px 0px'
                                        },
                                        children: [
                                            "Sort results by:",
                                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $85e77696c506735f$export$2e2bcd8739ae039), {
                                                onChange: (e)=>setSortIdx(+e.target.value),
                                                children: sortOptions.map((sortOption, index)=>/*#__PURE__*/ (0, $01ysi.jsx)("option", {
                                                        value: index,
                                                        children: sortOption.label
                                                    }, `${sortOption.value}-${index}`))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            contentResources.map(({ resource: resource }, index)=>{
                                return /*#__PURE__*/ (0, $01ysi.jsx)((0, $cb071fc609c78ddc$export$2e2bcd8739ae039), {
                                    data: resource
                                }, `${resource.title}-${index}`);
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $8d0e3fc0f3f02fc6$export$2e2bcd8739ae039 = $8d0e3fc0f3f02fc6$var$Contents;



var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");


var $489wz = parcelRequire("489wz");

var $jIrNf = parcelRequire("jIrNf");






var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");


var $489wz = parcelRequire("489wz");

var $jIrNf = parcelRequire("jIrNf");








const $da9019bf6e3ae76e$var$Link = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).a`
	color: ${({ theme: theme })=>theme.colors.primary};
	text-decoration: none;
	cursor: pointer;
`;
const $da9019bf6e3ae76e$var$Icon = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).svg`
	height: 1.1rem;
	width: 1.1rem;
	color: ${({ theme: theme })=>theme.colors.primaryTextColor};
	position: absolute;
	top: 0.5rem;
	left: 0.5rem;
`;
const $da9019bf6e3ae76e$var$SearchInput = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).input`
	line-height: 1.5;
	font-size: 18px;
	padding-left: 2rem;
`;
const $da9019bf6e3ae76e$var$FormFieldWrapper = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	width: 90%;
	padding-top: 20px;
	&:last-of-type {
		padding-bottom: 30px;
	}
`;
const $da9019bf6e3ae76e$export$3f334e7477d7f2cd = (existingResources)=>{
    const [creatingResource, setCreatingResource] = (0, $gRqVZ.useState)(false);
    const [resourceSearch, setResourceSearch] = (0, $gRqVZ.useState)('');
    const { data: resourceSearchData } = (0, $93486c083cb38a29$export$45db8b18d7460eb1)({
        skip: resourceSearch.length < 3,
        variables: {
            _ilike: `%${resourceSearch}%`
        }
    });
    const [upload] = (0, $a2c6c12bc7500c5d$export$b20424b4610825c3)(false);
    const [resourceActions, setResourceActions] = (0, $gRqVZ.useState)((0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).chain(existingResources).keyBy('id').mapValues((existing)=>({
            resource: existing,
            action: 'none',
            data: {}
        })).value());
    const [addingResourceModal, setAddingResource, addingResource] = (0, $63e9a7af5676c306$export$33ffd74ebf07f060)({
        tall: true,
        header: creatingResource ? 'Create related resource' : 'Add related resource',
        children: creatingResource ? /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Formik), {
            initialValues: {
                title: '',
                file: null,
                description: ''
            },
            onSubmit: async (values)=>{
                const file = values.file.file;
                const { uploadId: uploadId } = await upload(file);
                const fakeId = Math.floor(Math.random() * 100000000) + 10000000;
                setResourceActions({
                    ...resourceActions,
                    [fakeId]: {
                        action: 'new',
                        data: {
                            uploadId: uploadId,
                            title: values.title,
                            description: values.description
                        },
                        resource: {
                            __typename: 'resources',
                            createdAt: new Date().toISOString(),
                            description: '',
                            id: fakeId,
                            title: values.title,
                            file: {
                                key: '',
                                size: file.size,
                                type: file.type,
                                url: ''
                            }
                        }
                    }
                });
                setAddingResource(false);
            },
            children: ({ values: values, setFieldValue: setFieldValue })=>{
                return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $489wz.Form), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                            name: "title",
                            type: "text",
                            label: "Resource Title"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                            name: "file",
                            type: "file",
                            label: "Upload document"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                            name: "description",
                            type: "richText",
                            label: "Description",
                            value: values.description,
                            placeholder: "Tell us about the document...",
                            onChange: (val)=>setFieldValue('description', val)
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                            hideBorderTop: true,
                            type: "formButtons",
                            submitLabel: "Create Resource",
                            onCancel: ()=>setAddingResource(false)
                        })
                    ]
                });
            }
        }) : /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                    style: {
                        position: 'relative'
                    },
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)($da9019bf6e3ae76e$var$Icon, {
                            as: (0, $989849240f6109fe$export$4b85d3515bd863a5)
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)($da9019bf6e3ae76e$var$SearchInput, {
                            type: "text",
                            onChange: (e)=>setResourceSearch(e.target.value)
                        })
                    ]
                }),
                resourceSearchData?.resources && resourceSearchData.resources.filter((resource)=>!resourceActions[resource.id] || ![
                        'none',
                        'add'
                    ].includes(resourceActions[resource.id].action)).map((resource)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $cb071fc609c78ddc$export$2e2bcd8739ae039), {
                        data: resource,
                        editActions: {
                            add: async ()=>{
                                if (resourceActions[resource.id]?.action === 'remove') setResourceActions({
                                    ...resourceActions,
                                    [resource.id]: {
                                        resource: resource,
                                        action: 'none',
                                        data: {}
                                    }
                                });
                                else setResourceActions({
                                    ...resourceActions,
                                    [resource.id]: {
                                        resource: resource,
                                        action: 'add',
                                        data: {}
                                    }
                                });
                                setAddingResource(false);
                            }
                        }
                    }, resource.id.toString())),
                /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                    style: {
                        paddingTop: '3rem'
                    },
                    children: [
                        "Looking to create a new resource?",
                        ' ',
                        /*#__PURE__*/ (0, $01ysi.jsx)($da9019bf6e3ae76e$var$Link, {
                            onClick: ()=>setCreatingResource(true),
                            children: "You can do that here."
                        })
                    ]
                })
            ]
        })
    });
    if (!addingResource) {
        if (resourceSearch != '') setResourceSearch('');
        if (creatingResource) setCreatingResource(false);
    }
    const addResourcesFormFields = /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsxs)($da9019bf6e3ae76e$var$FormFieldWrapper, {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $837a9440f933970f$export$2e2bcd8739ae039), {
                        children: "Related Resources"
                    }),
                    (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).chain(resourceActions).filter((ra)=>[
                            'none',
                            'add',
                            'new'
                        ].includes(ra.action)).orderBy('resource.title').map((resourceAction)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $cb071fc609c78ddc$export$2e2bcd8739ae039), {
                            data: resourceAction.resource,
                            editActions: {
                                remove: ()=>{
                                    if ([
                                        'add',
                                        'new'
                                    ].includes(resourceAction.action)) setResourceActions((0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).omit(resourceActions, resourceAction.resource.id));
                                    else if (resourceAction.action === 'none') setResourceActions({
                                        ...resourceActions,
                                        [resourceAction.resource.id]: {
                                            action: 'remove',
                                            data: {
                                                resourceId: resourceAction.resource.id
                                            }
                                        }
                                    });
                                }
                            }
                        }, `${resourceAction.resource.id}`)).value()
                ]
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)($da9019bf6e3ae76e$var$FormFieldWrapper, {
                children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $32c3454e141c39d9$export$2e2bcd8739ae039), {
                    $autoWidth: true,
                    mode: "outline",
                    type: "button",
                    onClick: ()=>setAddingResource(true),
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $a98c9f8299f9be25$export$2d9ac7aa84f97a08), {
                            style: {
                                height: '1rem'
                            }
                        }),
                        " Add Resource"
                    ]
                })
            })
        ]
    });
    return [
        addResourcesFormFields,
        addingResourceModal,
        resourceActions
    ];
};


function $c4d5c805500e2fac$var$ContentsPublish({ existing: existing, cancelEditing: cancelEditing }) {
    const navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    const department = (0, $154dffb4cf685475$export$5c120892d522df6d)();
    const [addContent] = (0, $93486c083cb38a29$export$33cf84748aa2c67d)({
        awaitRefetchQueries: true
    });
    const [updateContent] = (0, $93486c083cb38a29$export$ea11c48f10be89d2)({
        refetchQueries: [
            'departmentDetails'
        ],
        awaitRefetchQueries: true
    });
    const [convertedText, setConvertedText] = (0, $gRqVZ.useState)(existing?.body || '');
    const [deleteContentResource] = (0, $93486c083cb38a29$export$df7ac65110b1fa66)();
    const [addResource] = (0, $93486c083cb38a29$export$769b437a6cfba8c2)();
    const [addContentResource] = (0, $93486c083cb38a29$export$13eb6ed7a9c1f926)();
    const [addResourcesFormFields, addingResourceModal, resourceActions] = (0, $da9019bf6e3ae76e$export$3f334e7477d7f2cd)((0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).map(existing?.contentResources ?? [], 'resource'));
    const { useRole: useRole } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    const onSubmit = async (values)=>{
        const context = {
            useRole: useRole
        };
        const contentVariables = {
            body: convertedText,
            departmentId: department.id,
            parentId: +values.parentId || null,
            title: values.title,
            active: true
        };
        let contentId = existing?.id;
        if (!contentId) {
            const newContent = await addContent({
                context: context,
                variables: contentVariables
            });
            contentId = newContent.data.insertContent.id;
        }
        const resourceWork = (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).map(resourceActions, async (resourceAction)=>{
            if (resourceAction.action === 'remove') return deleteContentResource({
                context: context,
                variables: {
                    contentId: contentId,
                    resourceId: resourceAction.data.resourceId
                }
            });
            else if (resourceAction.action === 'new') {
                const newResource = await addResource({
                    context: context,
                    variables: {
                        title: resourceAction.data.title,
                        fileUploadId: resourceAction.data.uploadId,
                        description: resourceAction.data.description
                    }
                });
                return addContentResource({
                    context: context,
                    variables: {
                        departmentContentId: contentId,
                        resourceId: newResource.data.insertResource.id
                    }
                });
            } else if (resourceAction.action === 'add') return addContentResource({
                context: context,
                variables: {
                    departmentContentId: contentId,
                    resourceId: resourceAction.resource.id
                }
            });
        });
        await Promise.all(resourceWork);
        const variables = {
            body: convertedText,
            departmentId: department.id,
            parentId: +values.parentId || null,
            title: values.title,
            active: true
        };
        const contentUpdate = await updateContent({
            context: context,
            variables: {
                ...variables,
                id: contentId
            }
        });
        const result = contentUpdate.data.updateContentById;
        if (existing && existing.parentId == result.parentId && existing.id == result.id) cancelEditing();
        else {
            const to = result.parentId ? `/departments/${department.id}/contents/${result.parentId}/${result.id}` : `/departments/${department.id}/contents/${result.id}`;
            navigate(to);
        }
    };
    const baseParentOptions = [
        {
            value: '-',
            label: 'Top Level (none)'
        }
    ];
    const departmentParentOptions = department.contents// Prevent content with children from being a child
    .filter(()=>!existing?.contents?.length)// Prevent content from being a child of itself
    .filter((c)=>!existing?.id || existing.id != c.id).map((c)=>({
            value: c.id.toString(),
            label: c.title
        }));
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Formik), {
                initialValues: {
                    title: existing?.title || '',
                    parentId: existing?.parentId || '-'
                },
                onSubmit: onSubmit,
                children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $489wz.Form), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                            type: "text",
                            name: "title",
                            placeholder: "Title",
                            label: "Page Title"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                            type: "select",
                            name: "parentId",
                            label: "Parent",
                            options: [
                                ...baseParentOptions,
                                ...departmentParentOptions
                            ]
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                            name: "body",
                            type: "richText",
                            label: "Body",
                            value: convertedText,
                            onChange: setConvertedText
                        }),
                        addResourcesFormFields,
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                            type: "formButtons",
                            submitLabel: existing ? 'Update' : 'Create',
                            onCancel: ()=>cancelEditing()
                        })
                    ]
                })
            }),
            addingResourceModal
        ]
    });
}
function $c4d5c805500e2fac$export$3ab11e1088ed68b6() {
    return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $a0dff761b892795c$export$2e2bcd8739ae039), {
                children: "Publish Department Content"
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)($c4d5c805500e2fac$var$ContentsPublish, {})
        ]
    });
}
var $c4d5c805500e2fac$export$2e2bcd8739ae039 = $c4d5c805500e2fac$var$ContentsPublish;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");



var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");



const $e31d34649965b23c$export$13972abd9b5cf021 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	font-size: 20px;
	padding: 20px 0px;
	border-top: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	&:last-child {
		border-bottom: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	}
`;
const $e31d34649965b23c$export$133773870222880f = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	color: ${({ theme: theme })=>theme.colors.primary};
	&:hover {
		cursor: pointer;
	}
	&.expanded {
		color: ${({ theme: theme })=>theme.colors.primaryTextColor};
	}
`;
const $e31d34649965b23c$export$aec14294028030b8 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	transition: all 350ms ease;
	overflow: hidden;
	max-height: 0px;
	color: ${({ theme: theme })=>theme.colors.lightestGray};
	font-size: 18px;
	line-height: 1.5;
	&.expanded {
		padding-top: 15px;
		overflow: auto;
		max-height: 400px;
	}
`;
const $e31d34649965b23c$var$IconStyles = (0, $8999e1d77b7e12d9$export$dbf350e5966cf602)`
	width: 10px;
	height: 10px;
	padding-left: 15px;
	&.expanded {
	}
`;
const $e31d34649965b23c$export$1fa5a43af950a186 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $008681c5a6c2a769$export$c22d792887f3cb87))`
	color: ${({ theme: theme })=>theme.colors.lightestGray};
	${$e31d34649965b23c$var$IconStyles}
`;
const $e31d34649965b23c$export$2624c5890f1bbcf7 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $a84fe49467631aef$export$cb86d8fdcb9f94b5))`
	color: ${({ theme: theme })=>theme.colors.primaryTextColor};

	${$e31d34649965b23c$var$IconStyles}
`;


function $2e9edf66e62aa575$var$Accordian({ previewText: previewText, expandedText: expandedText, className: className, children: children }) {
    const [open, setOpen] = (0, $gRqVZ.useState)(false);
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $e31d34649965b23c$export$13972abd9b5cf021), {
        className: className,
        children: [
            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $e31d34649965b23c$export$133773870222880f), {
                className: open && 'expanded',
                onClick: ()=>setOpen(!open),
                children: [
                    previewText,
                    open ? /*#__PURE__*/ (0, $01ysi.jsx)((0, $e31d34649965b23c$export$2624c5890f1bbcf7), {}) : /*#__PURE__*/ (0, $01ysi.jsx)((0, $e31d34649965b23c$export$1fa5a43af950a186), {})
                ]
            }),
            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $e31d34649965b23c$export$aec14294028030b8), {
                className: open && 'expanded',
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $17faf2022da0c55b$export$2e2bcd8739ae039), {
                        html: expandedText
                    }),
                    children
                ]
            })
        ]
    });
}
var $2e9edf66e62aa575$export$2e2bcd8739ae039 = $2e9edf66e62aa575$var$Accordian;



var $489wz = parcelRequire("489wz");





const $3ae21bbfd70e6c4e$var$Action = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).span`
	color: ${({ theme: theme })=>theme.colors.primary};
	font-size: 90%;
	text-decoration: none;
	cursor: pointer;
`;
function $3ae21bbfd70e6c4e$export$a5770036f9a8c476() {
    const { useRole: useRole } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    const department = (0, $154dffb4cf685475$export$5c120892d522df6d)();
    const navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    const { faqId: faqId } = (0, $372fcccf2bee01ac$export$99eaa27ddbbb95ef)();
    const refetchConfig = {
        refetchQueries: [
            'departmentDetails'
        ],
        awaitRefetchQueries: true
    };
    const [createFaq] = (0, $93486c083cb38a29$export$8887825256a2931c)(refetchConfig);
    const [updateFaq] = (0, $93486c083cb38a29$export$269f5b469b06e19d)(refetchConfig);
    const existing = department.faqs.find((faq)=>faq.id === +faqId);
    const initialValues = {
        question: existing?.question || '',
        answer: existing?.answer || ''
    };
    return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $a0dff761b892795c$export$2e2bcd8739ae039), {
                children: "Publish FAQ"
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Formik), {
                initialValues: initialValues,
                onSubmit: async (values)=>{
                    if (existing) await updateFaq({
                        variables: {
                            id: existing.id,
                            question: values.question,
                            answer: values.answer
                        },
                        context: {
                            useRole: useRole
                        }
                    });
                    else await createFaq({
                        variables: {
                            departmentId: department.id,
                            question: values.question,
                            answer: values.answer
                        },
                        context: {
                            useRole: useRole
                        }
                    });
                    await navigate('..');
                },
                children: ({ values: values, setFieldValue: setFieldValue })=>/*#__PURE__*/ (0, $01ysi.jsxs)((0, $489wz.Form), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                name: "question",
                                label: "Question",
                                placeholder: "Question",
                                type: "text"
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                name: "answer",
                                label: "Answer",
                                placeholder: "Answer",
                                type: "richText",
                                onChange: (val)=>setFieldValue('answer', val),
                                value: values.answer
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                type: "formButtons"
                            })
                        ]
                    })
            })
        ]
    });
}
function $3ae21bbfd70e6c4e$var$FAQ() {
    const department = (0, $154dffb4cf685475$export$5c120892d522df6d)();
    const navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    const [deleteFaq] = (0, $93486c083cb38a29$export$44d8ad03c29758c0)({
        refetchQueries: [
            'departmentDetails'
        ],
        awaitRefetchQueries: true
    });
    const { useRole: useRole } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $a0dff761b892795c$export$2e2bcd8739ae039), {
                children: "FAQ"
            }),
            department.faqs.map((faq)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $2e9edf66e62aa575$export$2e2bcd8739ae039), {
                    previewText: faq.question,
                    expandedText: faq.answer,
                    children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $6e3a19da527b7fab$export$d56e283436f735f9), {
                        role: [
                            'SuperAdmin',
                            'Editor'
                        ],
                        children: /*#__PURE__*/ (0, $01ysi.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)($3ae21bbfd70e6c4e$var$Action, {
                                    onClick: ()=>navigate(`/departments/${department.id}/faqs/${faq.id}`),
                                    children: "Edit"
                                }),
                                ' ',
                                "\u2022",
                                ' ',
                                /*#__PURE__*/ (0, $01ysi.jsx)($3ae21bbfd70e6c4e$var$Action, {
                                    onClick: async ()=>{
                                        if (confirm('Are you sure you want to delete this FAQ?')) await deleteFaq({
                                            context: {
                                                useRole: useRole
                                            },
                                            variables: {
                                                id: faq.id
                                            }
                                        });
                                    },
                                    children: "Delete"
                                })
                            ]
                        })
                    })
                }, faq.question))
        ]
    });
}
var $3ae21bbfd70e6c4e$export$2e2bcd8739ae039 = $3ae21bbfd70e6c4e$var$FAQ;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");






var $jIrNf = parcelRequire("jIrNf");
const $7ecfa2846d771e64$var$TeamContainer = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
`;
function $7ecfa2846d771e64$var$Team() {
    const department = (0, $154dffb4cf685475$export$5c120892d522df6d)();
    const { data: data } = (0, $93486c083cb38a29$export$41a28deb3bd3c231)({
        variables: {
            departmentId: department.id
        }
    });
    return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $a0dff761b892795c$export$2e2bcd8739ae039), {
                children: "Dept Team."
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)($7ecfa2846d771e64$var$TeamContainer, {
                children: data?.departmentById?.employees && (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).orderBy(data.departmentById.employees, [
                    'lastName',
                    'firstName'
                ]).map((person)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $b7cf2e00be4cfa04$export$2e2bcd8739ae039), {
                        person: person
                    }, person.id))
            })
        ]
    });
}
var $7ecfa2846d771e64$export$2e2bcd8739ae039 = $7ecfa2846d771e64$var$Team;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");





const $2a1ffd4b92f41eeb$export$2af48443ab6e6178 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	width: ${(props)=>props.$stacked ? '31%' : '100%'};
	padding-left: 3%;
	display: ${(props)=>props.$stacked ? 'inline-grid' : 'flex'};
	border-bottom: ${(props)=>!props.$stacked && !props.$noBorder && `1px solid ${props.theme.colors.lightGray}`};
	&:first-child {
		padding-left: ${(props)=>props.$stacked ? 0 : undefined};
	}
`;
const $2a1ffd4b92f41eeb$export$3e431a229df88919 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).img`
	width: ${(props)=>props.$stacked && '100%'};
	height: ${(props)=>!props.$stacked && `${props.$wide ? '150' : '100'}px`};
	margin-top: ${(props)=>!props.$stacked && '20px'};
	margin-right: ${(props)=>!props.$stacked && '15px'};
	border-radius: 3px;
	&:hover {
		cursor: pointer;
	}
`;
const $2a1ffd4b92f41eeb$export$33f1b01688923142 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	font-size: 14px;
	color: ${({ theme: theme })=>theme.colors.lightestGray};
	margin-bottom: ${(props)=>props.$stacked ? '15px' : '5px'};
`;
const $2a1ffd4b92f41eeb$export$a6c7ac8248d6e38a = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $e3f57e4b1ea630bd$export$b0d92dbee9b5b60d))`
	display: block;
	margin-top: ${(props)=>props.$stacked ? '10px' : '5px'};
	margin-bottom: 20px;
	color: ${({ theme: theme })=>theme.colors.primary};
	text-decoration: none;
	&:hover {
		cursor: pointer;
	}
`;
const $2a1ffd4b92f41eeb$export$db23f68ecd911efa = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $e3f57e4b1ea630bd$export$b0d92dbee9b5b60d))`
	font-size: 24px;
	line-height: 30px;
	transition: all 0.1s ease-in-out;
	text-decoration: none;
	color: ${({ theme: theme })=>theme.colors.primaryTextColor};
	margin: 15px 0px 10px 0px;
	font-weight: 300;
	display: block;
	&:hover {
		color: ${({ theme: theme })=>theme.colors.primary};
		cursor: pointer;
	}
`;
const $2a1ffd4b92f41eeb$export$1bc11a519365884e = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $17faf2022da0c55b$export$2e2bcd8739ae039))`
	p {
		line-height: 25px;
		font-size: 15px;
		color: ${({ theme: theme })=>theme.colors.primaryTextColor};
	}
`;


function $2ba354589c9f4590$var$truncate(html) {
    const element = document.createElement('div');
    element.innerHTML = html;
    const firstLine = element.innerText.split(/\n+/)[0];
    return `<p>${firstLine.substr(0, 120)}...</p>`;
}
function $2ba354589c9f4590$var$ImageCard({ data: data, $stacked: $stacked, $wide: $wide, $noBorder: $noBorder, departmentId: departmentId, $botPadding: $botPadding }) {
    if (!data) return null;
    const subtitle = [
        `${(0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(data.createdAt).format('ll')}`
    ];
    if (data?.author?.firstName) subtitle.push(`by ${data.author.firstName} ${data.author?.lastName}`);
    const imageSrc = $stacked ? data.leadWebUrl : data.leadThumbUrl;
    const keepReadingHref = departmentId ? `/departments/${departmentId}/news/${data.id}` : `/news/${data.id}`;
    const navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2a1ffd4b92f41eeb$export$2af48443ab6e6178), {
        $stacked: $stacked,
        $noBorder: $noBorder,
        children: [
            imageSrc && /*#__PURE__*/ (0, $01ysi.jsx)((0, $2a1ffd4b92f41eeb$export$3e431a229df88919), {
                $stacked: $stacked,
                $wide: $wide,
                src: imageSrc,
                onClick: ()=>navigate(keepReadingHref)
            }),
            /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                style: {
                    paddingBottom: $botPadding ? '1rem' : ''
                },
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $2a1ffd4b92f41eeb$export$db23f68ecd911efa), {
                        to: keepReadingHref,
                        children: data.title
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $2a1ffd4b92f41eeb$export$33f1b01688923142), {
                        $stacked: $stacked,
                        children: subtitle.join(" \u2022 ")
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $2a1ffd4b92f41eeb$export$1bc11a519365884e), {
                        html: $2ba354589c9f4590$var$truncate(data.post)
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $2a1ffd4b92f41eeb$export$a6c7ac8248d6e38a), {
                        $stacked: $stacked,
                        to: keepReadingHref,
                        children: "Keep reading"
                    })
                ]
            })
        ]
    });
}
var $2ba354589c9f4590$export$2e2bcd8739ae039 = $2ba354589c9f4590$var$ImageCard;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");

var $489wz = parcelRequire("489wz");











var $jIrNf = parcelRequire("jIrNf");


const $35b01a16b505efb7$var$RichTextField = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039))`
	width: 94%;
`;
function $35b01a16b505efb7$var$NewsPublish({ departmentId: departmentId, existing: existing }) {
    const { siteMeta: siteMeta } = (0, $6f7f49c0f054a62d$export$55c0e3cb4fbc46cf)();
    const [upload] = (0, $a2c6c12bc7500c5d$export$b20424b4610825c3)();
    const refetchConfig = {
        refetchQueries: [
            'departmentDetails',
            'bulletins'
        ],
        awaitRefetchQueries: true
    };
    const [addBulletin] = (0, $93486c083cb38a29$export$584ae9e174479d5)(refetchConfig);
    const [addBulletinDepartments] = (0, $93486c083cb38a29$export$c8de14961eb99050)(refetchConfig);
    const [updateBulletin] = (0, $93486c083cb38a29$export$a7dfb8248ac4e481)(refetchConfig);
    const [refetchBulletin] = (0, $93486c083cb38a29$export$8239115b6cf37d38)(refetchConfig);
    const [removeBulletinDepartments] = (0, $93486c083cb38a29$export$6df206a4428a9c81)(refetchConfig);
    const navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    const { useRole: useRole } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    const [addResourcesFormFields, addingResourceModal, resourceActions] = (0, $da9019bf6e3ae76e$export$3f334e7477d7f2cd)((0, $jIrNf.map)(existing?.bulletinResources ?? [], 'resource'));
    const [addResource] = (0, $93486c083cb38a29$export$769b437a6cfba8c2)();
    const [addBulletinResource] = (0, $93486c083cb38a29$export$370436d71d6a33ba)();
    const [deleteBulletinResource] = (0, $93486c083cb38a29$export$67203bf74af72848)();
    const departments = siteMeta.departments;
    const options = departments.map((d)=>{
        return {
            value: d.id,
            label: d.title
        };
    });
    const initialDepartments = existing?.id ? options.filter((o)=>existing.bulletinDepartments.map((bd)=>bd.departmentId).includes(o.value)) : departmentId > 0 ? options.filter((o)=>o.value === departmentId) : [];
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Formik), {
                initialValues: {
                    title: existing?.title ?? '',
                    date: (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(existing?.createdAt).format('YYYY-MM-DD'),
                    departments: initialDepartments,
                    global: existing?.global ?? !(departmentId > 0),
                    articleImage: null,
                    postContent: existing?.post ?? ''
                },
                onSubmit: async (values)=>{
                    let articleUploadId = null;
                    if (values.articleImage) articleUploadId = (await upload(values.articleImage.file)).uploadId;
                    let bulletinId = 0;
                    if (existing) bulletinId = (await updateBulletin({
                        context: {
                            useRole: useRole
                        },
                        variables: {
                            id: existing.id,
                            global: values.global,
                            leadImageUploadId: articleUploadId ?? existing.leadImageUploadId,
                            post: values.postContent,
                            title: values.title
                        }
                    })).data.updateBulletinById.id;
                    else bulletinId = (await addBulletin({
                        context: {
                            useRole: useRole
                        },
                        variables: {
                            global: values.global,
                            leadImageUploadId: articleUploadId,
                            post: values.postContent,
                            title: values.title
                        }
                    })).data.insertBulletin.id;
                    const originalDepartmentIds = (0, $jIrNf.map)(initialDepartments, 'value');
                    const departmentIds = (0, $jIrNf.map)(values.departments, 'value');
                    const departmentsToAdd = (0, $jIrNf.difference)(departmentIds, existing ? originalDepartmentIds : []);
                    const departmentsToRemove = (0, $jIrNf.difference)(originalDepartmentIds, departmentIds);
                    if (departmentsToAdd.length) await addBulletinDepartments({
                        context: {
                            useRole: useRole
                        },
                        // this type error is due to the forced Maybe -> T mapping and cannot be avoided
                        variables: {
                            objects: departmentsToAdd.map((deptId)=>({
                                    bulletinId: bulletinId,
                                    departmentId: deptId
                                }))
                        }
                    });
                    if (departmentsToRemove.length) await removeBulletinDepartments({
                        context: {
                            useRole: useRole
                        },
                        variables: {
                            bulletinId: bulletinId,
                            departmentIds: departmentsToRemove
                        }
                    });
                    const resourceWork = (0, $jIrNf.map)(resourceActions, async (resourceAction)=>{
                        if (resourceAction.action === 'remove') return deleteBulletinResource({
                            context: {
                                useRole: useRole
                            },
                            variables: {
                                bulletinId: bulletinId,
                                resourceId: resourceAction.data.resourceId
                            }
                        });
                        else if (resourceAction.action === 'new') {
                            const newResource = await addResource({
                                context: {
                                    useRole: useRole
                                },
                                variables: {
                                    title: resourceAction.data.title,
                                    fileUploadId: resourceAction.data.uploadId,
                                    description: resourceAction.data.description
                                }
                            });
                            return addBulletinResource({
                                context: {
                                    useRole: useRole
                                },
                                variables: {
                                    bulletinId: bulletinId,
                                    resourceId: newResource.data.insertResource.id
                                }
                            });
                        } else if (resourceAction.action === 'add') return addBulletinResource({
                            context: {
                                useRole: useRole
                            },
                            variables: {
                                bulletinId: bulletinId,
                                resourceId: resourceAction.resource.id
                            }
                        });
                    });
                    if (resourceWork.length) {
                        await Promise.all(resourceWork);
                        await refetchBulletin({
                            context: {
                                useRole: useRole
                            },
                            variables: {
                                id: bulletinId,
                                global: values.global
                            }
                        });
                    }
                    navigate('..');
                },
                children: ({ values: values, setFieldValue: setFieldValue })=>{
                    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $489wz.Form), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                name: "title",
                                type: "text",
                                placeholder: "News Announcement Title",
                                label: "Title"
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                name: "date",
                                type: "date",
                                placeholder: "Select Date",
                                label: "Date"
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                name: "global",
                                type: "checkbox",
                                label: "Make this a global bulletin"
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2519c42fed6cedee$export$a4654c742baf9825), {
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $837a9440f933970f$export$2e2bcd8739ae039), {
                                        children: "Departments"
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $5d837ac9ba9aa3e0$export$2e2bcd8739ae039), {
                                        options: options,
                                        isMulti: true,
                                        onChange: (value)=>setFieldValue('departments', value),
                                        defaultValue: values.departments
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                name: "articleImage",
                                type: "file",
                                label: "Article Image",
                                image: {
                                    aspect: 1.5,
                                    existing: existing?.leadWebUrl
                                }
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)($35b01a16b505efb7$var$RichTextField, {
                                name: "postContent",
                                type: "richText",
                                label: "Post Content",
                                value: values.postContent,
                                onChange: (val)=>setFieldValue('postContent', val)
                            }),
                            addResourcesFormFields,
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                type: "formButtons",
                                submitLabel: `${existing?.id ? 'Save' : 'Create'} News Announcement`,
                                autoWidth: true
                            })
                        ]
                    });
                }
            }),
            addingResourceModal
        ]
    });
}
var $35b01a16b505efb7$export$2e2bcd8739ae039 = $35b01a16b505efb7$var$NewsPublish;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");





var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");







const $4b2c4fbc67b15092$export$e8e8576633b8face = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	img.article-image {
		width: 40%;
		float: right;
		padding: 0px 20px 20px 10px;
	}
`;
const $4b2c4fbc67b15092$export$92a3b71769b709c9 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	font-weight: 300;
	line-height: 25px;
`;
const $4b2c4fbc67b15092$export$e800da7956a82316 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	color: ${({ theme: theme })=>theme.colors.lightestGray};
	padding-bottom: 1rem;
	img {
		width: 40px;
		padding-left: 0px;
		padding-right: 20px;
	}
	span {
		line-height: 40px;
		padding-right: 10px;
	}
`;
const $4b2c4fbc67b15092$export$49fa3c3f8fe9a109 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	padding-bottom: 1rem;
`;
const $4b2c4fbc67b15092$export$8e2dadda648b8122 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $e3f57e4b1ea630bd$export$b0d92dbee9b5b60d))`
	text-decoration: none;
	color: ${({ theme: theme })=>theme.colors.primary};
	line-height: 40px;
	padding-right: 20px;
`;
const $4b2c4fbc67b15092$export$a4efb6ba9e80181d = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).a`
	text-decoration: none;
	cursor: pointer;
	color: ${({ theme: theme })=>theme.colors.primary};
	line-height: 40px;
	padding-right: 20px;
`;
const $4b2c4fbc67b15092$export$2c34eec202f63577 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).h2`
	color: ${({ theme: theme })=>theme.colors.primaryTextColor};
	font-size: 20px;
	font-weight: lighter;
	padding-bottom: 1rem;
`;







(0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($0ba967bcdbe74473$exports))));
// todo: commentsRefetch -> mutationRefetch
function $ae37069f12c6c62d$var$NewsDetail(props) {
    const { bulletin: bulletin, commentsRefetch: commentsRefetch } = props;
    const navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    const [deleteBulletin] = (0, $93486c083cb38a29$export$5c55bb68218f0242)({
        refetchQueries: [
            commentsRefetch
        ],
        awaitRefetchQueries: true
    });
    const { useRole: useRole } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $372fcccf2bee01ac$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                path: "/",
                element: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4b2c4fbc67b15092$export$e8e8576633b8face), {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4b2c4fbc67b15092$export$e800da7956a82316), {
                                    children: [
                                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $d2ab028d8623e892$export$2e2bcd8739ae039), {
                                            src: bulletin.author?.profilePhotoUrl
                                        }),
                                        /*#__PURE__*/ (0, $01ysi.jsxs)("span", {
                                            children: [
                                                bulletin.author?.firstName,
                                                " ",
                                                bulletin.author?.lastName
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                                            children: "\u2022"
                                        }),
                                        /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(bulletin.createdAt).format('ll')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $6e3a19da527b7fab$export$d56e283436f735f9), {
                                    role: [
                                        'SuperAdmin',
                                        'Editor'
                                    ],
                                    children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4b2c4fbc67b15092$export$49fa3c3f8fe9a109), {
                                        children: [
                                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $4b2c4fbc67b15092$export$8e2dadda648b8122), {
                                                to: "publish",
                                                children: "Edit"
                                            }),
                                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $4b2c4fbc67b15092$export$a4efb6ba9e80181d), {
                                                onClick: async ()=>{
                                                    if (confirm('Are you sure you want to delete this news announcement?')) {
                                                        await deleteBulletin({
                                                            context: {
                                                                useRole: useRole
                                                            },
                                                            variables: {
                                                                id: bulletin.id
                                                            }
                                                        });
                                                        navigate('..');
                                                    }
                                                },
                                                children: "Delete"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)("img", {
                                    src: bulletin.leadWebUrl,
                                    className: "article-image"
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $4b2c4fbc67b15092$export$92a3b71769b709c9), {
                                    children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $17faf2022da0c55b$export$2e2bcd8739ae039), {
                                        html: bulletin.post
                                    })
                                })
                            ]
                        }),
                        bulletin.bulletinResources.length > 0 && /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                            style: {
                                clear: 'both',
                                paddingTop: '3rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $4b2c4fbc67b15092$export$2c34eec202f63577), {
                                    children: "Related Resources"
                                }),
                                bulletin.bulletinResources.map(({ resource: resource }, index)=>{
                                    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $cb071fc609c78ddc$export$2e2bcd8739ae039), {
                                        data: resource
                                    }, `${resource.title}-${index}`);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $d408feb4a7311f71$export$2e2bcd8739ae039), {
                            comments: bulletin.comments,
                            bulletinId: +bulletin.id,
                            refetch: commentsRefetch
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                path: "/publish",
                element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $35b01a16b505efb7$export$2e2bcd8739ae039), {
                    existing: bulletin
                })
            })
        ]
    });
}
var $ae37069f12c6c62d$export$2e2bcd8739ae039 = $ae37069f12c6c62d$var$NewsDetail;



(0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($0ba967bcdbe74473$exports))));
function $5aae9de27ec0aab8$var$NewsDetailRoute() {
    const { bulletinId: bulletinId } = (0, $372fcccf2bee01ac$export$99eaa27ddbbb95ef)();
    const department = (0, $154dffb4cf685475$export$5c120892d522df6d)();
    const bulletin = department.bulletins.find((b)=>b.id == +bulletinId);
    return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $a0dff761b892795c$export$2e2bcd8739ae039), {
                primaryColor: false,
                parent: {
                    to: `/departments/${department.id}/news`,
                    label: 'News & Announcements',
                    __typename: 'static'
                },
                children: bulletin.title
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $ae37069f12c6c62d$export$2e2bcd8739ae039), {
                bulletin: bulletin,
                commentsRefetch: "departmentDetails"
            })
        ]
    });
}
var $5aae9de27ec0aab8$export$2e2bcd8739ae039 = $5aae9de27ec0aab8$var$NewsDetailRoute;



function $7d6ea75e7d612a71$var$Newslist() {
    const department = (0, $154dffb4cf685475$export$5c120892d522df6d)();
    return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $a0dff761b892795c$export$2e2bcd8739ae039), {
                children: "News & Announcements"
            }),
            department.bulletins.map((b)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $2ba354589c9f4590$export$2e2bcd8739ae039), {
                    data: b,
                    departmentId: department.id
                }, b.id))
        ]
    });
}
function $7d6ea75e7d612a71$var$News() {
    const department = (0, $154dffb4cf685475$export$5c120892d522df6d)();
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $372fcccf2bee01ac$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                path: "/",
                element: /*#__PURE__*/ (0, $01ysi.jsx)($7d6ea75e7d612a71$var$Newslist, {})
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                path: "/:bulletinId/*",
                element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $5aae9de27ec0aab8$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                path: "/publish",
                element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $35b01a16b505efb7$export$2e2bcd8739ae039), {
                    departmentId: department?.id
                })
            })
        ]
    });
}
var $7d6ea75e7d612a71$export$2e2bcd8739ae039 = $7d6ea75e7d612a71$var$News;




var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");


var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");





const $77464f2f26b81980$export$54ec01a60f47d33d = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).table`
	width: 100%;
	table-layout: fixed;
	font-size: 14px;
	line-height: 2.3;
	font-weight: 300;
	text-align: left;
	padding-bottom: 0.5rem;
	border-collapse: collapse;
`;
const $77464f2f26b81980$export$e93312b7773dfcac = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).thead``;
const $77464f2f26b81980$export$8b251419efc915eb = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).th`
	font-weight: 500;
	width: ${(props)=>props.$width ? `${props.$width}px` : undefined};
`;
const $77464f2f26b81980$export$4d82ce4c37371892 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).th`
	font-weight: 500;
	width: 100px;
`;
const $77464f2f26b81980$export$d90409754c76221d = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).th`
	width: 64px;
`;
const $77464f2f26b81980$export$4b2c32e08f77ff18 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).tbody``;
const $77464f2f26b81980$export$b59bdbef9ce70de2 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).tr`
	border-bottom: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
`;
const $77464f2f26b81980$export$2ad141e9e3d81b82 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $3cf30fe56fd1629f$export$889aff59bd27773b))`
	color: ${({ theme: theme })=>theme.colors.primary};
	width: 15px;
	height: 15px;
	margin-right: 15px;
	cursor: pointer;
`;
const $77464f2f26b81980$export$1ae95d1a7411cb7b = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $51c6ea681161bff5$export$99442c433de1441d))`
	color: ${({ theme: theme })=>theme.colors.primary};
	width: 15px;
	height: 15px;
	cursor: pointer;
`;
const $77464f2f26b81980$export$b52183d5cfb26dc9 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).td`
	text-align: right;
`;





function $360526ef96303096$var$QuickLinksList() {
    const department = (0, $154dffb4cf685475$export$5c120892d522df6d)();
    const [deleteQuicklink] = (0, $93486c083cb38a29$export$b4f11c8de6bbc054)({
        refetchQueries: [
            'departmentDetails'
        ],
        awaitRefetchQueries: true
    });
    const { useRole: useRole } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $a0dff761b892795c$export$2e2bcd8739ae039), {
                children: "Quick Links"
            }),
            /*#__PURE__*/ (0, $01ysi.jsxs)($77464f2f26b81980$export$54ec01a60f47d33d, {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$e93312b7773dfcac, {
                        children: /*#__PURE__*/ (0, $01ysi.jsxs)($77464f2f26b81980$export$b59bdbef9ce70de2, {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$8b251419efc915eb, {
                                    children: "Title"
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$8b251419efc915eb, {
                                    children: "Description"
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$8b251419efc915eb, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$4b2c32e08f77ff18, {
                        children: department.quicklinks.map((ql)=>/*#__PURE__*/ (0, $01ysi.jsxs)($77464f2f26b81980$export$b59bdbef9ce70de2, {
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)("td", {
                                        children: ql.title
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $17faf2022da0c55b$export$2e2bcd8739ae039), {
                                            html: ql.description
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsxs)($77464f2f26b81980$export$b52183d5cfb26dc9, {
                                        children: [
                                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $e3f57e4b1ea630bd$export$a6c7ac8248d6e38a), {
                                                to: `${ql.id}/publish`,
                                                children: /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$2ad141e9e3d81b82, {})
                                            }),
                                            /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$1ae95d1a7411cb7b, {
                                                onClick: async ()=>{
                                                    if (confirm('Are you sure you want to delete this quicklink?')) deleteQuicklink({
                                                        context: {
                                                            useRole: useRole
                                                        },
                                                        variables: {
                                                            id: ql.id
                                                        }
                                                    });
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }, ql.title))
                    })
                ]
            })
        ]
    });
}
var $360526ef96303096$export$2e2bcd8739ae039 = $360526ef96303096$var$QuickLinksList;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");

var $489wz = parcelRequire("489wz");







const $5e6dc5e7925fe17b$var$Error = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).span`
	color: red;
	font-size: 12px;
`;
function $5e6dc5e7925fe17b$var$validate(values) {
    const errors = {};
    if (!values?.url?.startsWith('http')) errors.url = `Please enter a valid url starting with 'http' or 'https'`;
    if (!values?.url) errors.url = 'Required';
    if (!values?.title) errors.title = 'Required';
    return errors;
}
function $5e6dc5e7925fe17b$var$QuickLinksForm() {
    const department = (0, $154dffb4cf685475$export$5c120892d522df6d)();
    const navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    const params = (0, $372fcccf2bee01ac$export$99eaa27ddbbb95ef)();
    const [addQuicklink] = (0, $93486c083cb38a29$export$c2d52ac2119174a2)({
        refetchQueries: [
            'departmentDetails'
        ],
        awaitRefetchQueries: true
    });
    const [updateQuicklink] = (0, $93486c083cb38a29$export$d48e304d3a2a8822)({
        refetchQueries: [
            'departmentDetails'
        ],
        awaitRefetchQueries: true
    });
    const { useRole: useRole } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    const quickLink = department.quicklinks.find((ql)=>ql.id === +params?.id);
    const prefillInitialValues = {
        title: quickLink?.title || '',
        description: quickLink?.description || '',
        url: quickLink?.url || ''
    };
    return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $a0dff761b892795c$export$2e2bcd8739ae039), {
                children: "Publish Quick Link"
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Formik), {
                initialValues: prefillInitialValues,
                validate: $5e6dc5e7925fe17b$var$validate,
                onSubmit: async (values)=>{
                    if (quickLink) await updateQuicklink({
                        context: {
                            useRole: useRole
                        },
                        variables: {
                            id: quickLink.id,
                            title: values.title,
                            description: values.description,
                            url: values.url
                        }
                    });
                    else await addQuicklink({
                        context: {
                            useRole: useRole
                        },
                        variables: {
                            departmentId: department.id,
                            title: values.title,
                            description: values.description,
                            url: values.url
                        }
                    });
                    navigate(`/departments/${department.id}/quick-links`);
                },
                children: ({ values: values, setFieldValue: setFieldValue, errors: errors, touched: touched })=>/*#__PURE__*/ (0, $01ysi.jsxs)((0, $489wz.Form), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                name: "title",
                                label: "Title",
                                placeholder: "Title",
                                type: "text"
                            }),
                            errors.title && touched.title && /*#__PURE__*/ (0, $01ysi.jsx)($5e6dc5e7925fe17b$var$Error, {
                                children: errors.title
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                name: "description",
                                label: "Description",
                                placeholder: "Link description...",
                                type: "richText",
                                onChange: (val)=>setFieldValue('description', val),
                                value: values.description
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                name: "url",
                                label: "Link Address",
                                placeholder: "URL",
                                type: "text"
                            }),
                            errors.url && touched.url && /*#__PURE__*/ (0, $01ysi.jsx)($5e6dc5e7925fe17b$var$Error, {
                                children: errors.url
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                type: "formButtons",
                                onCancel: ()=>navigate(`/departments/${department.id}/quick-links`)
                            })
                        ]
                    })
            })
        ]
    });
}
var $5e6dc5e7925fe17b$export$2e2bcd8739ae039 = $5e6dc5e7925fe17b$var$QuickLinksForm;


function $63287d4023863677$var$QuickLinksRoutes() {
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $372fcccf2bee01ac$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                path: "/",
                element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $360526ef96303096$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                path: "/publish",
                element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $5e6dc5e7925fe17b$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                path: "/:id/publish",
                element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $5e6dc5e7925fe17b$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
var $63287d4023863677$export$2e2bcd8739ae039 = $63287d4023863677$var$QuickLinksRoutes;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");

var $489wz = parcelRequire("489wz");








const $946ae089fd6fe2d4$var$SaveError = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	color: ${(props)=>props.theme.colors.red};
`;
function $946ae089fd6fe2d4$var$EditDepartment() {
    const [upload] = (0, $a2c6c12bc7500c5d$export$b20424b4610825c3)();
    const department = (0, $154dffb4cf685475$export$5c120892d522df6d)();
    const [updateDepartment] = (0, $93486c083cb38a29$export$8f4b8ade8406c1ee)({
        refetchQueries: [
            'departmentDetails'
        ],
        awaitRefetchQueries: true
    });
    const { useRole: useRole } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    const navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    const prefillInitialValues = {
        title: department.title,
        image: null,
        missionStatement: department.missionStatement
    };
    return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $a0dff761b892795c$export$2e2bcd8739ae039), {
                children: "Edit Department"
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Formik), {
                initialValues: prefillInitialValues,
                onSubmit: async (values, { setStatus: setStatus })=>{
                    setStatus(undefined);
                    try {
                        let mastheadId = department.masthead?.id ?? null;
                        if (values.image) mastheadId = (await upload(values.image.file)).uploadId;
                        await updateDepartment({
                            context: {
                                useRole: useRole
                            },
                            variables: {
                                departmentId: department.id,
                                logoUploadId: department.logo?.id ?? null,
                                mastheadUploadId: mastheadId,
                                missionStatement: values.missionStatement,
                                title: values.title
                            }
                        });
                    } catch (e) {
                        setStatus('Failed to save department. Please try again.');
                        return;
                    }
                    navigate(`/departments/${department.id}/overview`);
                },
                children: ({ values: values, setFieldValue: setFieldValue, status: status })=>/*#__PURE__*/ (0, $01ysi.jsxs)((0, $489wz.Form), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                name: "title",
                                label: "Title",
                                placeholder: "Title",
                                type: "text"
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                name: "image",
                                label: "Masthead Image",
                                type: "file",
                                image: {
                                    aspect: 160 / 15,
                                    existing: department.masthead?.publicUrl
                                }
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                name: "missionStatement",
                                label: "Mission Statement",
                                type: "richText",
                                onChange: (val)=>setFieldValue('missionStatement', val),
                                value: values.missionStatement
                            }),
                            status && /*#__PURE__*/ (0, $01ysi.jsx)($946ae089fd6fe2d4$var$SaveError, {
                                children: status
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                type: "formButtons",
                                submitLabel: "Save Department",
                                onCancel: ()=>navigate(`/departments/${department.id}/overview`)
                            })
                        ]
                    })
            })
        ]
    });
}
var $946ae089fd6fe2d4$export$2e2bcd8739ae039 = $946ae089fd6fe2d4$var$EditDepartment;







const $2577c7b87258bece$export$a97c5ce30fc4f2c1 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).a`
	display: block;
	border-bottom: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	color: ${({ theme: theme })=>theme.colors.primary};
	padding: 15px 0px;
	text-decoration: none;
	font-size: 14px;
	&:last-child {
		border-bottom: none;
	}
`;
const $2577c7b87258bece$export$466cdc317043f6cb = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	border: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	padding: 20px;
	margin-top: 20px;
	width: 260px;
	h3 {
		margin-bottom: 15px;
		font-weight: normal;
		font-size: 16px;
	}
`;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");


var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");

var $489wz = parcelRequire("489wz");













const $3e779ae9cb0ef3d8$var$AuthorInformation = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	color: #777;
	display: flex;
	align-items: center;
	img {
		width: 3rem;
		padding-left: 0px;
		padding-right: 20px;
	}
	span {
		padding-right: 10px;
	}
`;
const $3e779ae9cb0ef3d8$var$DiscussionAction = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).span`
	cursor: pointer;
	color: ${({ theme: theme })=>theme.colors.primary};
`;
function $3e779ae9cb0ef3d8$export$39e473df7a8e24b(props) {
    const { discussion: discussion } = props;
    const [editingDiscussion, setEditingDiscussion] = (0, $gRqVZ.useState)(false);
    const { user: user } = (0, $f8298f6bd5fca48e$export$a609e16b0cfae3f1)();
    const navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    const [deleteDiscussion] = (0, $93486c083cb38a29$export$2a8cd6783b4fbf7e)({
        refetchQueries: [
            'discussions',
            'departmentDetails'
        ],
        awaitRefetchQueries: true
    });
    const { isAdmin: isAdmin, useRoleUnless: useRoleUnless } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    if (editingDiscussion) return /*#__PURE__*/ (0, $01ysi.jsx)($3e779ae9cb0ef3d8$export$e98b2539973fc229, {
        existing: discussion,
        onCancel: ()=>setEditingDiscussion(false)
    });
    if (!discussion) return null;
    return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsxs)($3e779ae9cb0ef3d8$var$AuthorInformation, {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $d2ab028d8623e892$export$2e2bcd8739ae039), {
                        src: discussion.author?.profilePhotoUrl
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsxs)("span", {
                        children: [
                            discussion.author?.firstName,
                            " ",
                            discussion.author?.lastName
                        ]
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                        children: " \u2022 "
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(discussion?.createdAt).format('ll')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                style: {
                    paddingBottom: '2rem',
                    paddingTop: '2rem'
                },
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $75673e4a99422ae0$export$2e2bcd8739ae039), {
                        data: discussion
                    }),
                    (isAdmin || discussion.author?.id === user.id) && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
                        children: [
                            " \u2022 ",
                            /*#__PURE__*/ (0, $01ysi.jsx)($3e779ae9cb0ef3d8$var$DiscussionAction, {
                                onClick: ()=>setEditingDiscussion(true),
                                children: "Edit"
                            }),
                            " \u2022 ",
                            /*#__PURE__*/ (0, $01ysi.jsx)($3e779ae9cb0ef3d8$var$DiscussionAction, {
                                onClick: async ()=>{
                                    if (confirm('Are you sure you want to delete this discussion?')) {
                                        await deleteDiscussion({
                                            variables: {
                                                id: discussion.id
                                            },
                                            context: {
                                                useRole: useRoleUnless(discussion.author?.id === user.id)
                                            }
                                        });
                                        navigate('..');
                                    }
                                },
                                children: "Delete"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $8f154b5038c2a17a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $17faf2022da0c55b$export$2e2bcd8739ae039), {
                    html: discussion.post
                })
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $d408feb4a7311f71$export$2e2bcd8739ae039), {
                discussionId: discussion.id,
                comments: discussion.comments,
                refetch: [
                    'discussions',
                    'departmentDetails'
                ]
            })
        ]
    });
}
function $3e779ae9cb0ef3d8$export$5e191a6234f05919({ departmentId: departmentId, discussions: discussions = [] }) {
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $1c3b3c5e1c4e70d7$export$2e2bcd8739ae039), {
        departmentId: departmentId,
        data: discussions,
        showSubtitleActions: true
    });
}
function $3e779ae9cb0ef3d8$export$e98b2539973fc229(props) {
    const navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    const isUpdate = Boolean(props.existing);
    const { user: user } = (0, $f8298f6bd5fca48e$export$a609e16b0cfae3f1)();
    const { useRoleUnless: useRoleUnless } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    const refetchConfig = {
        refetchQueries: [
            'discussions',
            'departmentDetails'
        ],
        awaitRefetchQueries: true
    };
    const [createDiscussion] = (0, $93486c083cb38a29$export$214006b9150ed9a5)(refetchConfig);
    const [updateDiscussion] = (0, $93486c083cb38a29$export$6f5da27c4bf25cfa)(refetchConfig);
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Formik), {
        initialValues: {
            title: props.existing?.title ?? '',
            post: props.existing?.post ?? ''
        },
        onSubmit: async (values)=>{
            if (isUpdate) {
                await updateDiscussion({
                    variables: {
                        id: props.existing.id,
                        post: values.post,
                        title: values.title
                    },
                    context: {
                        useRole: useRoleUnless(props.existing?.author?.id === user.id)
                    }
                });
                props.onCancel();
            } else {
                const { data: data } = await createDiscussion({
                    variables: {
                        departmentId: props.departmentId || null,
                        post: values.post,
                        title: values.title
                    }
                });
                navigate(`../${data.insertDiscussion.id}`);
            }
        },
        children: ({ values: values, setFieldValue: setFieldValue })=>{
            return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $489wz.Form), {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        name: "title",
                        type: "text",
                        placeholder: "Discussion Title",
                        label: "Title"
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        name: "body",
                        type: "richText",
                        label: "Discussion Content",
                        value: values.post,
                        placeholder: "Write your post here...",
                        onChange: (val)=>setFieldValue('post', val)
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        type: "formButtons",
                        submitLabel: `${isUpdate ? 'Update' : 'Create'} discussion`,
                        onCancel: props.onCancel
                    })
                ]
            });
        }
    });
}




function $3249612f35a7002f$var$DeptDiscussionsDetail() {
    const department = (0, $154dffb4cf685475$export$5c120892d522df6d)();
    const { discussionId: discussionId } = (0, $372fcccf2bee01ac$export$99eaa27ddbbb95ef)();
    const discussion = department.discussions.find((d)=>d.id === +discussionId);
    if (!discussion) return null;
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $a0dff761b892795c$export$2e2bcd8739ae039), {
                primaryColor: false,
                parent: {
                    __typename: 'static',
                    to: '..',
                    label: 'Discussions'
                },
                children: discussion.title
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $3e779ae9cb0ef3d8$export$39e473df7a8e24b), {
                discussion: discussion
            })
        ]
    });
}
function $3249612f35a7002f$export$37d1979485c92102() {
    const department = (0, $154dffb4cf685475$export$5c120892d522df6d)();
    return /*#__PURE__*/ (0, $01ysi.jsx)("div", {
        children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $372fcccf2bee01ac$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                    path: "/",
                    element: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $a0dff761b892795c$export$2e2bcd8739ae039), {
                                children: "Discussions"
                            }),
                            department.discussions.length === 0 && /*#__PURE__*/ (0, $01ysi.jsx)("p", {
                                children: "This department does not have any discussions yet!"
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $3e779ae9cb0ef3d8$export$5e191a6234f05919), {
                                departmentId: department.id,
                                discussions: department.discussions
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                    path: "/publish",
                    element: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $a0dff761b892795c$export$2e2bcd8739ae039), {
                                parent: {
                                    __typename: 'static',
                                    to: '..',
                                    label: 'Discussions'
                                },
                                children: "Publish Discussion"
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $3e779ae9cb0ef3d8$export$e98b2539973fc229), {
                                departmentId: department.id
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                    path: "/:discussionId",
                    element: /*#__PURE__*/ (0, $01ysi.jsx)($3249612f35a7002f$var$DeptDiscussionsDetail, {})
                })
            ]
        })
    });
}



const $154dffb4cf685475$var$DepartmentContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createContext(null);
function $154dffb4cf685475$var$getCorrectedHref(href) {
    return href.startsWith('http') ? href : `https://${href}`;
}
function $154dffb4cf685475$var$DepartmentRoute() {
    const { isAdmin: isAdmin } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    const { departmentId: departmentId } = (0, $372fcccf2bee01ac$export$99eaa27ddbbb95ef)();
    const { data: data, loading: loading } = (0, $8e914d5dfc637c4d$export$722295c247fb669)({
        variables: {
            departmentId: +departmentId
        }
    });
    if (loading) return null;
    const department = data.department;
    if (!department) return /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$444b3ab0cb9aec40), {
        to: "/"
    });
    return /*#__PURE__*/ (0, $01ysi.jsx)($154dffb4cf685475$var$DepartmentContext.Provider, {
        value: department,
        children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $38e8ff2ff45ad7fb$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $f17ceecf287e1f86$export$2e2bcd8739ae039), {
                        logoUrl: department.logo?.publicUrl,
                        links: (0, $f5ed445ed8b66a2e$export$148d59d0130da180)(department, isAdmin),
                        children: department.quicklinks.length > 0 && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2577c7b87258bece$export$466cdc317043f6cb), {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)("h3", {
                                    children: "Quick Links"
                                }),
                                department.quicklinks.map((quickLink)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $2577c7b87258bece$export$a97c5ce30fc4f2c1), {
                                        href: $154dffb4cf685475$var$getCorrectedHref(quickLink.url),
                                        target: "_blank",
                                        children: quickLink.title
                                    }, `quicklink-${quickLink.title}`))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsxs)((0, $372fcccf2bee01ac$export$3565eb3d00ca5a74), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                path: "/overview",
                                element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $bd1dd58c3466d235$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                path: "/team",
                                element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $7ecfa2846d771e64$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                path: "/news/*",
                                element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $7d6ea75e7d612a71$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                path: "/discussions/*",
                                element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $3249612f35a7002f$export$37d1979485c92102), {})
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                path: "/contents/:contentsId",
                                element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $8d0e3fc0f3f02fc6$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                path: "/contents/:contentsId/:subContentsId",
                                element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $8d0e3fc0f3f02fc6$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                path: "/faqs/*",
                                element: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $372fcccf2bee01ac$export$3565eb3d00ca5a74), {
                                    children: [
                                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                            path: "/",
                                            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $3ae21bbfd70e6c4e$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                            path: "/publish",
                                            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $3ae21bbfd70e6c4e$export$a5770036f9a8c476), {})
                                        }),
                                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                            path: "/:faqId",
                                            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $3ae21bbfd70e6c4e$export$a5770036f9a8c476), {})
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                path: "/edit",
                                element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $946ae089fd6fe2d4$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                path: "/quick-links/*",
                                element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $63287d4023863677$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                path: "/content/publish",
                                element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $c4d5c805500e2fac$export$3ab11e1088ed68b6), {})
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function $154dffb4cf685475$export$5c120892d522df6d() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).useContext($154dffb4cf685475$var$DepartmentContext);
}
var $154dffb4cf685475$export$2e2bcd8739ae039 = $154dffb4cf685475$var$DepartmentRoute;



var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");


var $jIrNf = parcelRequire("jIrNf");






var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");

const $e2bc44ccf855d907$var$StyledInput = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).input`
	background-color: white;
	border: 1px solid ${({ theme: theme })=>theme.colors.lightGray};
	padding: 10px;
	border-radius: 3px;
`;
function $e2bc44ccf855d907$var$TextInput(props) {
    return /*#__PURE__*/ (0, $01ysi.jsx)($e2bc44ccf855d907$var$StyledInput, {
        ...props
    });
}
var $e2bc44ccf855d907$export$2e2bcd8739ae039 = $e2bc44ccf855d907$var$TextInput;




var $01ysi = parcelRequire("01ysi");

var $if2ZQ = parcelRequire("if2ZQ");

var $2UY5J = parcelRequire("2UY5J");

var $gRqVZ = parcelRequire("gRqVZ");

var $5RjKS = parcelRequire("5RjKS");

var $15iRw = parcelRequire("15iRw");

var $euX6z = parcelRequire("euX6z");
var $bnOCc = parcelRequire("bnOCc");

var $bmFJp = parcelRequire("bmFJp");

var $gRqVZ = parcelRequire("gRqVZ");
parcelRequire("50JbI");
var $8DRs0 = parcelRequire("8DRs0");
'use client';
function $fa316fe2f4d999c7$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $fa316fe2f4d999c7$var$useTheme(defaultTheme = null) {
    const contextTheme = $gRqVZ.useContext((0, $8DRs0.T));
    return !contextTheme || $fa316fe2f4d999c7$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $fa316fe2f4d999c7$export$2e2bcd8739ae039 = $fa316fe2f4d999c7$var$useTheme;


'use client';
const $914e35017106b4cb$export$35e57303dbd8a66 = (0, $bmFJp.default)();
function $914e35017106b4cb$var$useTheme(defaultTheme = $914e35017106b4cb$export$35e57303dbd8a66) {
    return (0, $fa316fe2f4d999c7$export$2e2bcd8739ae039)(defaultTheme);
}
var $914e35017106b4cb$export$2e2bcd8739ae039 = $914e35017106b4cb$var$useTheme;



var $01ysi = parcelRequire("01ysi");
'use client';
const $47fa985c1f202365$var$_excluded = [
    "className",
    "component"
];
function $47fa985c1f202365$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $15iRw.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $euX6z.default));
    const Box = /*#__PURE__*/ $gRqVZ.forwardRef(function Box(inProps, ref) {
        const theme = (0, $914e35017106b4cb$export$2e2bcd8739ae039)(defaultTheme);
        const _extendSxProp = (0, $bnOCc.default)(inProps), { className: className, component: component = 'div' } = _extendSxProp, other = (0, $2UY5J.default)(_extendSxProp, $47fa985c1f202365$var$_excluded);
        return /*#__PURE__*/ (0, $01ysi.jsx)(BoxRoot, (0, $if2ZQ.default)({
            as: component,
            ref: ref,
            className: (0, $5RjKS.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $4JlxW = parcelRequire("4JlxW");

var $1kZhP = parcelRequire("1kZhP");

var $1WdmB = parcelRequire("1WdmB");

var $bJKzs = parcelRequire("bJKzs");
const $a967171dd3d0b253$var$boxClasses = (0, $bJKzs.default)('MuiBox', [
    'root'
]);
var $a967171dd3d0b253$export$2e2bcd8739ae039 = $a967171dd3d0b253$var$boxClasses;


'use client';
const $3e4306c97c8d2a8d$var$defaultTheme = (0, $1kZhP.default)();
const $3e4306c97c8d2a8d$var$Box = (0, $47fa985c1f202365$export$2e2bcd8739ae039)({
    themeId: (0, $1WdmB.default),
    defaultTheme: $3e4306c97c8d2a8d$var$defaultTheme,
    defaultClassName: (0, $a967171dd3d0b253$export$2e2bcd8739ae039).root,
    generateClassName: (0, $4JlxW.default).generate
});
var $3e4306c97c8d2a8d$export$2e2bcd8739ae039 = $3e4306c97c8d2a8d$var$Box;


var $2UY5J = parcelRequire("2UY5J");

var $if2ZQ = parcelRequire("if2ZQ");

var $gRqVZ = parcelRequire("gRqVZ");


var $5RjKS = parcelRequire("5RjKS");

var $3EQY1 = parcelRequire("3EQY1");

var $bnOCc = parcelRequire("bnOCc");

var $kKoGD = parcelRequire("kKoGD");


var $4EIqH = parcelRequire("4EIqH");

var $eXJcZ = parcelRequire("eXJcZ");
parcelRequire("gRqVZ");


var $5B4J7 = parcelRequire("5B4J7");

var $1WdmB = parcelRequire("1WdmB");
'use client';
function $b62797eb3d4f8805$export$2e2bcd8739ae039() {
    const theme = (0, $914e35017106b4cb$export$2e2bcd8739ae039)((0, $5B4J7.default));
    return theme[0, $1WdmB.default] || theme;
}



var $gRqVZ = parcelRequire("gRqVZ");
'use client';
/**
 * @ignore - internal component.
 */ const $97db3f64d13879aa$var$GridContext = /*#__PURE__*/ $gRqVZ.createContext();
var $97db3f64d13879aa$export$2e2bcd8739ae039 = $97db3f64d13879aa$var$GridContext;



var $bJKzs = parcelRequire("bJKzs");

var $dhwoc = parcelRequire("dhwoc");
function $50674579f0008c14$export$9973ac5fd0181f33(slot) {
    return (0, $dhwoc.default)('MuiGrid', slot);
}
const $50674579f0008c14$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $50674579f0008c14$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $50674579f0008c14$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $50674579f0008c14$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $50674579f0008c14$var$gridClasses = (0, $bJKzs.default)('MuiGrid', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$50674579f0008c14$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$50674579f0008c14$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$50674579f0008c14$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$50674579f0008c14$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$50674579f0008c14$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$50674579f0008c14$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$50674579f0008c14$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$50674579f0008c14$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $50674579f0008c14$export$2e2bcd8739ae039 = $50674579f0008c14$var$gridClasses;



var $01ysi = parcelRequire("01ysi");
'use client';
const $7fa8fcc842821aaa$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $7fa8fcc842821aaa$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), '') || 'px'}`;
}
function $7fa8fcc842821aaa$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, $3EQY1.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${$7fa8fcc842821aaa$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $if2ZQ.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $7fa8fcc842821aaa$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $3EQY1.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $3EQY1.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf('column') === 0) output[`& > .${(0, $50674579f0008c14$export$2e2bcd8739ae039).item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $7fa8fcc842821aaa$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $7fa8fcc842821aaa$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $3EQY1.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = $7fa8fcc842821aaa$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $3EQY1.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `-${$7fa8fcc842821aaa$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $50674579f0008c14$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $7fa8fcc842821aaa$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $50674579f0008c14$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $7fa8fcc842821aaa$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $3EQY1.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = $7fa8fcc842821aaa$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $3EQY1.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                width: `calc(100% + ${$7fa8fcc842821aaa$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$7fa8fcc842821aaa$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $50674579f0008c14$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $7fa8fcc842821aaa$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${(0, $50674579f0008c14$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $7fa8fcc842821aaa$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $7fa8fcc842821aaa$var$GridRoot = (0, $4EIqH.default)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $7fa8fcc842821aaa$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $if2ZQ.default)({
        boxSizing: 'border-box'
    }, ownerState.container && {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%'
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== 'wrap' && {
        flexWrap: ownerState.wrap
    }), $7fa8fcc842821aaa$export$71d4225eeb1bc13e, $7fa8fcc842821aaa$export$380604d7c79f9e8f, $7fa8fcc842821aaa$export$4315fba5128fb4a1, $7fa8fcc842821aaa$export$ca2a698f6020fda);
function $7fa8fcc842821aaa$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $7fa8fcc842821aaa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $7fa8fcc842821aaa$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $kKoGD.default)(slots, (0, $50674579f0008c14$export$9973ac5fd0181f33), classes);
};
const $7fa8fcc842821aaa$var$Grid = /*#__PURE__*/ $gRqVZ.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $eXJcZ.useDefaultProps)({
        props: inProps,
        name: 'MuiGrid'
    });
    const { breakpoints: breakpoints } = (0, $b62797eb3d4f8805$export$2e2bcd8739ae039)();
    const props = (0, $bnOCc.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = 'div', container: container = false, direction: direction = 'row', item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = 'wrap', zeroMinWidth: zeroMinWidth = false } = props, other = (0, $2UY5J.default)(props, $7fa8fcc842821aaa$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $gRqVZ.useContext((0, $97db3f64d13879aa$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $if2ZQ.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $if2ZQ.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $7fa8fcc842821aaa$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $97db3f64d13879aa$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $01ysi.jsx)($7fa8fcc842821aaa$var$GridRoot, (0, $if2ZQ.default)({
            ownerState: ownerState,
            className: (0, $5RjKS.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $7fa8fcc842821aaa$export$2e2bcd8739ae039 = $7fa8fcc842821aaa$var$Grid;


var $2UY5J = parcelRequire("2UY5J");

var $if2ZQ = parcelRequire("if2ZQ");

var $gRqVZ = parcelRequire("gRqVZ");


var $5RjKS = parcelRequire("5RjKS");


var $kKoGD = parcelRequire("kKoGD");

var $f6KN8 = parcelRequire("f6KN8");

var $4EIqH = parcelRequire("4EIqH");

var $eXJcZ = parcelRequire("eXJcZ");

var $gRqVZ = parcelRequire("gRqVZ");

var $gRqVZ = parcelRequire("gRqVZ");
'use client';
const $fddc17aa946f5521$var$UNINITIALIZED = {};
function $fddc17aa946f5521$export$2e2bcd8739ae039(init, initArg) {
    const ref = $gRqVZ.useRef($fddc17aa946f5521$var$UNINITIALIZED);
    if (ref.current === $fddc17aa946f5521$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $gRqVZ = parcelRequire("gRqVZ");
'use client';
const $32f441ea07b9e6d5$var$EMPTY = [];
function $32f441ea07b9e6d5$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $gRqVZ.useEffect(fn, $32f441ea07b9e6d5$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $5fc618ac4c0a7b1b$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $5fc618ac4c0a7b1b$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $5fc618ac4c0a7b1b$export$2e2bcd8739ae039() {
    const timeout = (0, $fddc17aa946f5521$export$2e2bcd8739ae039)($5fc618ac4c0a7b1b$export$786b4da70f00938b.create).current;
    (0, $32f441ea07b9e6d5$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


'use client';
let $104a03ca3bb72c23$var$hadKeyboardEvent = true;
let $104a03ca3bb72c23$var$hadFocusVisibleRecently = false;
const $104a03ca3bb72c23$var$hadFocusVisibleRecentlyTimeout = new (0, $5fc618ac4c0a7b1b$export$786b4da70f00938b)();
const $104a03ca3bb72c23$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $104a03ca3bb72c23$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $104a03ca3bb72c23$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $104a03ca3bb72c23$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $104a03ca3bb72c23$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $104a03ca3bb72c23$var$handlePointerDown() {
    $104a03ca3bb72c23$var$hadKeyboardEvent = false;
}
function $104a03ca3bb72c23$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($104a03ca3bb72c23$var$hadFocusVisibleRecently) $104a03ca3bb72c23$var$hadKeyboardEvent = true;
    }
}
function $104a03ca3bb72c23$var$prepare(doc) {
    doc.addEventListener('keydown', $104a03ca3bb72c23$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $104a03ca3bb72c23$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $104a03ca3bb72c23$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $104a03ca3bb72c23$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $104a03ca3bb72c23$var$handleVisibilityChange, true);
}
function $104a03ca3bb72c23$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $104a03ca3bb72c23$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $104a03ca3bb72c23$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $104a03ca3bb72c23$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $104a03ca3bb72c23$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $104a03ca3bb72c23$var$handleVisibilityChange, true);
}
function $104a03ca3bb72c23$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $104a03ca3bb72c23$var$hadKeyboardEvent || $104a03ca3bb72c23$var$focusTriggersKeyboardModality(target);
}
function $104a03ca3bb72c23$export$2e2bcd8739ae039() {
    const ref = $gRqVZ.useCallback((node)=>{
        if (node != null) $104a03ca3bb72c23$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $gRqVZ.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $104a03ca3bb72c23$var$hadFocusVisibleRecently = true;
            $104a03ca3bb72c23$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $104a03ca3bb72c23$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($104a03ca3bb72c23$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


'use client';
var $9bee19ebd10f48b9$export$2e2bcd8739ae039 = (0, $104a03ca3bb72c23$export$2e2bcd8739ae039);



var $gRqVZ = parcelRequire("gRqVZ");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $b7a36528be695460$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $32e9d22f982ee50e$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $gRqVZ.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $b7a36528be695460$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


'use client';
var $7a543fd84c4ce35a$export$2e2bcd8739ae039 = (0, $32e9d22f982ee50e$export$2e2bcd8739ae039);



var $2UY5J = parcelRequire("2UY5J");

var $if2ZQ = parcelRequire("if2ZQ");

var $gRqVZ = parcelRequire("gRqVZ");


var $5RjKS = parcelRequire("5RjKS");

var $bnOCc = parcelRequire("bnOCc");

var $kKoGD = parcelRequire("kKoGD");

var $4EIqH = parcelRequire("4EIqH");

var $eXJcZ = parcelRequire("eXJcZ");

var $f6KN8 = parcelRequire("f6KN8");

var $bJKzs = parcelRequire("bJKzs");

var $dhwoc = parcelRequire("dhwoc");
function $65b4a3b87f247718$export$24c1f8f60cbac79e(slot) {
    return (0, $dhwoc.default)('MuiTypography', slot);
}
const $65b4a3b87f247718$var$typographyClasses = (0, $bJKzs.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $65b4a3b87f247718$export$2e2bcd8739ae039 = $65b4a3b87f247718$var$typographyClasses;



var $01ysi = parcelRequire("01ysi");
'use client';
const $7b0b802526d18fac$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $7b0b802526d18fac$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $f6KN8.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $kKoGD.default)(slots, (0, $65b4a3b87f247718$export$24c1f8f60cbac79e), classes);
};
const $7b0b802526d18fac$export$140e2f5526d3cad8 = (0, $4EIqH.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $f6KN8.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $if2ZQ.default)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $7b0b802526d18fac$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $7b0b802526d18fac$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $7b0b802526d18fac$var$transformDeprecatedColors = (color)=>{
    return $7b0b802526d18fac$var$colorTransformations[color] || color;
};
const $7b0b802526d18fac$var$Typography = /*#__PURE__*/ $gRqVZ.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $eXJcZ.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $7b0b802526d18fac$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $bnOCc.default)((0, $if2ZQ.default)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $7b0b802526d18fac$var$defaultVariantMapping } = props, other = (0, $2UY5J.default)(props, $7b0b802526d18fac$var$_excluded);
    const ownerState = (0, $if2ZQ.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $7b0b802526d18fac$var$defaultVariantMapping[variant]) || 'span';
    const classes = $7b0b802526d18fac$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $01ysi.jsx)($7b0b802526d18fac$export$140e2f5526d3cad8, (0, $if2ZQ.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $5RjKS.default)(classes.root, className)
    }, other));
});
var $7b0b802526d18fac$export$2e2bcd8739ae039 = $7b0b802526d18fac$var$Typography;



var $bJKzs = parcelRequire("bJKzs");

var $dhwoc = parcelRequire("dhwoc");
function $9824a45f89e76b23$export$d6efab9620b78fec(slot) {
    return (0, $dhwoc.default)('MuiLink', slot);
}
const $9824a45f89e76b23$var$linkClasses = (0, $bJKzs.default)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $9824a45f89e76b23$export$2e2bcd8739ae039 = $9824a45f89e76b23$var$linkClasses;



var $du93j = parcelRequire("du93j");

var $5olLg = parcelRequire("5olLg");
const $7de19d25b326c919$export$c4e140d5d351182b = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $7de19d25b326c919$var$transformDeprecatedColors = (color)=>{
    return $7de19d25b326c919$export$c4e140d5d351182b[color] || color;
};
const $7de19d25b326c919$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $7de19d25b326c919$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $du93j.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $du93j.getPath)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $5olLg.alpha)(color, 0.4);
};
var $7de19d25b326c919$export$2e2bcd8739ae039 = $7de19d25b326c919$var$getTextDecoration;



var $01ysi = parcelRequire("01ysi");
'use client';
const $9cf30fcf5d406047$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $9cf30fcf5d406047$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $f6KN8.default)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $kKoGD.default)(slots, (0, $9824a45f89e76b23$export$d6efab9620b78fec), classes);
};
const $9cf30fcf5d406047$var$LinkRoot = (0, $4EIqH.default)((0, $7b0b802526d18fac$export$2e2bcd8739ae039), {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $f6KN8.default)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $if2ZQ.default)({}, ownerState.underline === 'none' && {
        textDecoration: 'none'
    }, ownerState.underline === 'hover' && {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    }, ownerState.underline === 'always' && (0, $if2ZQ.default)({
        textDecoration: 'underline'
    }, ownerState.color !== 'inherit' && {
        textDecorationColor: (0, $7de19d25b326c919$export$2e2bcd8739ae039)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        '&:hover': {
            textDecorationColor: 'inherit'
        }
    }), ownerState.component === 'button' && {
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        [`&.${(0, $9824a45f89e76b23$export$2e2bcd8739ae039).focusVisible}`]: {
            outline: 'auto'
        }
    });
});
const $9cf30fcf5d406047$var$Link = /*#__PURE__*/ $gRqVZ.forwardRef(function Link(inProps, ref) {
    const props = (0, $eXJcZ.useDefaultProps)({
        props: inProps,
        name: 'MuiLink'
    });
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx } = props, other = (0, $2UY5J.default)(props, $9cf30fcf5d406047$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $9bee19ebd10f48b9$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $gRqVZ.useState(false);
    const handlerRef = (0, $7a543fd84c4ce35a$export$2e2bcd8739ae039)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $if2ZQ.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $9cf30fcf5d406047$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $01ysi.jsx)($9cf30fcf5d406047$var$LinkRoot, (0, $if2ZQ.default)({
        color: color,
        className: (0, $5RjKS.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $7de19d25b326c919$export$c4e140d5d351182b)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $9cf30fcf5d406047$export$2e2bcd8739ae039 = $9cf30fcf5d406047$var$Link;



var $2UY5J = parcelRequire("2UY5J");

var $if2ZQ = parcelRequire("if2ZQ");

var $gRqVZ = parcelRequire("gRqVZ");


var $5RjKS = parcelRequire("5RjKS");

var $b6XT3 = parcelRequire("b6XT3");

var $dhwoc = parcelRequire("dhwoc");

var $kKoGD = parcelRequire("kKoGD");

var $if2ZQ = parcelRequire("if2ZQ");

var $2UY5J = parcelRequire("2UY5J");

var $15iRw = parcelRequire("15iRw");

var $b6XT3 = parcelRequire("b6XT3");



var $bmFJp = parcelRequire("bmFJp");

var $euX6z = parcelRequire("euX6z");
const $8c295ac5c3c304a8$var$_excluded = [
    "ownerState"
], $8c295ac5c3c304a8$var$_excluded2 = [
    "variants"
], $8c295ac5c3c304a8$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $8c295ac5c3c304a8$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $8c295ac5c3c304a8$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $8c295ac5c3c304a8$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $8c295ac5c3c304a8$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $8c295ac5c3c304a8$export$35e57303dbd8a66 = (0, $bmFJp.default)();
const $8c295ac5c3c304a8$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $8c295ac5c3c304a8$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $8c295ac5c3c304a8$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $8c295ac5c3c304a8$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $8c295ac5c3c304a8$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $2UY5J.default)(_ref, $8c295ac5c3c304a8$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $if2ZQ.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$8c295ac5c3c304a8$var$processStyleArg(resolvedStyle, (0, $if2ZQ.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $2UY5J.default)(resolvedStylesArg, $8c295ac5c3c304a8$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $if2ZQ.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $if2ZQ.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $8c295ac5c3c304a8$var$shallowLayer((0, $15iRw.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $8c295ac5c3c304a8$var$shallowLayer((0, $15iRw.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $8c295ac5c3c304a8$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $8c295ac5c3c304a8$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $8c295ac5c3c304a8$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $8c295ac5c3c304a8$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $euX6z.default)((0, $if2ZQ.default)({}, props, {
            theme: $8c295ac5c3c304a8$var$resolveTheme((0, $if2ZQ.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $15iRw.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $8c295ac5c3c304a8$var$defaultOverridesResolver($8c295ac5c3c304a8$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $2UY5J.default)(inputOptions, $8c295ac5c3c304a8$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $8c295ac5c3c304a8$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($8c295ac5c3c304a8$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $15iRw.default)(tag, (0, $if2ZQ.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $b6XT3.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $8c295ac5c3c304a8$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $8c295ac5c3c304a8$var$processStyleArg(stylesArg, (0, $if2ZQ.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $8c295ac5c3c304a8$var$resolveTheme((0, $if2ZQ.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $8c295ac5c3c304a8$var$processStyleArg(slotStyle, (0, $if2ZQ.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $8c295ac5c3c304a8$var$resolveTheme((0, $if2ZQ.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $8c295ac5c3c304a8$var$processStyleArg({
                    variants: themeVariants
                }, (0, $if2ZQ.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $6a808f776bbf0d39$var$styled = (0, $8c295ac5c3c304a8$export$2e2bcd8739ae039)();
var $6a808f776bbf0d39$export$2e2bcd8739ae039 = $6a808f776bbf0d39$var$styled;



var $3NvHU = parcelRequire("3NvHU");
function $3d3a9816c8a05608$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $3NvHU.default)(theme.components[name].defaultProps, props);
}



'use client';
function $42bead049cfd18c7$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $914e35017106b4cb$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $3d3a9816c8a05608$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}



var $bnOCc = parcelRequire("bnOCc");

var $bmFJp = parcelRequire("bmFJp");

var $3EQY1 = parcelRequire("3EQY1");

var $dtIKp = parcelRequire("dtIKp");

var $01ysi = parcelRequire("01ysi");
const $fefcd19bd7761406$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $fefcd19bd7761406$var$defaultTheme = (0, $bmFJp.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $fefcd19bd7761406$var$defaultCreateStyledComponent = (0, $6a808f776bbf0d39$export$2e2bcd8739ae039)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $fefcd19bd7761406$var$useThemePropsDefault(props) {
    return (0, $42bead049cfd18c7$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $fefcd19bd7761406$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $fefcd19bd7761406$var$joinChildren(children, separator) {
    const childrenArray = $gRqVZ.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $gRqVZ.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $fefcd19bd7761406$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $fefcd19bd7761406$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $if2ZQ.default)({
        display: 'flex',
        flexDirection: 'column'
    }, (0, $3EQY1.handleBreakpoints)({
        theme: theme
    }, (0, $3EQY1.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $dtIKp.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $3EQY1.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $3EQY1.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $dtIKp.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$fefcd19bd7761406$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $dtIKp.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $b6XT3.default)(styles, (0, $3EQY1.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $3EQY1.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $fefcd19bd7761406$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $fefcd19bd7761406$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $fefcd19bd7761406$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $kKoGD.default)(slots, (slot)=>(0, $dhwoc.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($fefcd19bd7761406$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $gRqVZ.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $bnOCc.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $2UY5J.default)(props, $fefcd19bd7761406$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $01ysi.jsx)(StackRoot, (0, $if2ZQ.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $5RjKS.default)(classes.root, className)
        }, other, {
            children: divider ? $fefcd19bd7761406$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $4EIqH = parcelRequire("4EIqH");

var $eXJcZ = parcelRequire("eXJcZ");
'use client';
const $5ce7c99cb8ebffb6$var$Stack = (0, $fefcd19bd7761406$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $4EIqH.default)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $eXJcZ.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $5ce7c99cb8ebffb6$export$2e2bcd8739ae039 = $5ce7c99cb8ebffb6$var$Stack;



function $85f36703c6beb577$var$AddressView(address) {
    const streetAddress = `${address.line1}${address.line2 ? `, ${address.line2}` : ''}`;
    const mapsLink = `https://maps.google.com/?q=${streetAddress},${address.city}+${address.stateAbbrev}+${address.zipCode}`;
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $7b0b802526d18fac$export$2e2bcd8739ae039), {
        component: (0, $9cf30fcf5d406047$export$2e2bcd8739ae039),
        href: mapsLink,
        target: "_blank",
        sx: {
            lineHeight: '1.3'
        },
        children: [
            streetAddress,
            /*#__PURE__*/ (0, $01ysi.jsx)("br", {}),
            address.city,
            ", ",
            address.stateAbbrev,
            " ",
            address.zipCode
        ]
    });
}
function $85f36703c6beb577$var$JobsitePanel({ jobsite: jobsite }) {
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $3e4306c97c8d2a8d$export$2e2bcd8739ae039), {
        sx: {
            background: '#f3f3f3',
            p: 3,
            mb: 4
        },
        children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $5ce7c99cb8ebffb6$export$2e2bcd8739ae039), {
            spacing: 2,
            children: [
                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $7b0b802526d18fac$export$2e2bcd8739ae039), {
                    children: [
                        jobsite.title,
                        jobsite.siteNumber && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $3e4306c97c8d2a8d$export$2e2bcd8739ae039), {
                            component: "span",
                            sx: {
                                ml: 1,
                                opacity: 0.5
                            },
                            children: [
                                "#",
                                jobsite.siteNumber
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $3e4306c97c8d2a8d$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $7fa8fcc842821aaa$export$2e2bcd8739ae039), {
                        container: true,
                        spacing: 2,
                        children: [
                            jobsite.mainAddress && /*#__PURE__*/ (0, $01ysi.jsx)((0, $7fa8fcc842821aaa$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 6,
                                children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $5ce7c99cb8ebffb6$export$2e2bcd8739ae039), {
                                    spacing: 2,
                                    children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $5ce7c99cb8ebffb6$export$2e2bcd8739ae039), {
                                        direction: "row",
                                        spacing: 0.5,
                                        children: [
                                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $3e4306c97c8d2a8d$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pt: '1px'
                                                },
                                                children: /*#__PURE__*/ (0, $01ysi.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e472631d3972460c$exports))), {
                                                    color: "primary"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $3e4306c97c8d2a8d$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $7b0b802526d18fac$export$2e2bcd8739ae039), {
                                                        children: "Jobsite Address"
                                                    }),
                                                    /*#__PURE__*/ (0, $01ysi.jsx)($85f36703c6beb577$var$AddressView, {
                                                        line1: jobsite.mainAddress,
                                                        line2: jobsite.mainAddress2,
                                                        city: jobsite.mainAddressCity,
                                                        stateAbbrev: jobsite.mainAddressState,
                                                        zipCode: jobsite.mainAddressZip
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            jobsite.officeAddress && /*#__PURE__*/ (0, $01ysi.jsx)((0, $7fa8fcc842821aaa$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 6,
                                children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $5ce7c99cb8ebffb6$export$2e2bcd8739ae039), {
                                    spacing: 2,
                                    children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $5ce7c99cb8ebffb6$export$2e2bcd8739ae039), {
                                        direction: "row",
                                        spacing: 0.5,
                                        children: [
                                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $3e4306c97c8d2a8d$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pt: '1px'
                                                },
                                                children: /*#__PURE__*/ (0, $01ysi.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e472631d3972460c$exports))), {
                                                    color: "primary"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $3e4306c97c8d2a8d$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $7b0b802526d18fac$export$2e2bcd8739ae039), {
                                                        children: "Jobsite Address"
                                                    }),
                                                    /*#__PURE__*/ (0, $01ysi.jsx)($85f36703c6beb577$var$AddressView, {
                                                        line1: jobsite.officeAddress,
                                                        line2: jobsite.officeAddress2,
                                                        city: jobsite.officeAddressCity,
                                                        stateAbbrev: jobsite.officeAddressState,
                                                        zipCode: jobsite.officeAddressZip
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                }),
                jobsite.phone && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $5ce7c99cb8ebffb6$export$2e2bcd8739ae039), {
                    direction: "row",
                    spacing: 0.5,
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $3e4306c97c8d2a8d$export$2e2bcd8739ae039), {
                            sx: {
                                pt: '1px'
                            },
                            children: /*#__PURE__*/ (0, $01ysi.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($edb6c6ead0806272$exports))), {})
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsxs)((0, $3e4306c97c8d2a8d$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $7b0b802526d18fac$export$2e2bcd8739ae039), {
                                    children: "Phone Number"
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $7b0b802526d18fac$export$2e2bcd8739ae039), {
                                    children: jobsite.phone
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $85f36703c6beb577$export$2e2bcd8739ae039 = $85f36703c6beb577$var$JobsitePanel;



const $84dca12f95d704fb$export$e0b231e8f936e738 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	h1 {
		color: ${({ theme: theme })=>theme.colors.primary};
		font-weight: lighter;
		font-size: 40px;
		line-height: 40px;
		padding-bottom: 30px;
	}
`;
const $84dca12f95d704fb$export$b5894098dc618b3e = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	/* Larger photo than the shared 64px, per NIBBI-92. flex-shrink guard because
	   at 120px a wide text column can squeeze the photo (it couldn't at 64px). */
	img {
		width: 120px;
		height: 120px;
		flex-shrink: 0;
	}
	h1 {
		color: ${({ theme: theme })=>theme.colors.primaryTextColor};
		font-size: 18px;
		font-weight: 400;
		line-height: 25px;
		padding-bottom: 0;
	}
`;
const $84dca12f95d704fb$export$c3c37dc9d4df2597 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	justify-content: space-between;
	padding-bottom: 20px;
	select {
		width: 40%;
		margin-right: 20px;
	}
`;
const $84dca12f95d704fb$export$2e0a83ec2e27ecbb = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	margin: 20px 0px;
	border-bottom: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
`;
const $84dca12f95d704fb$export$33897744af16c59b = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 40%;
	padding-bottom: 30px;
	input {
		margin-left: 30px;
	}
`;



const $2c406d71a571f9f0$var$sidebarLinks = [
    {
        title: 'Company Directory',
        to: '/company-directory'
    },
    {
        title: 'Organizational Chart',
        to: '/org-chart'
    }
];
const $2c406d71a571f9f0$var$NO_SELECTION = '-';
const $2c406d71a571f9f0$var$sortOptions = [
    {
        label: 'Last Name, A-Z',
        value: 'lastName'
    },
    {
        label: 'First Name, A-Z',
        value: 'firstName'
    },
    {
        label: 'Department, A-Z',
        value: [
            'department.title',
            'lastName'
        ]
    }
];
function $2c406d71a571f9f0$var$Directory() {
    const { data: data, loading: loading } = (0, $93486c083cb38a29$export$7258bf72bd405c60)();
    const { data: jobsiteData } = (0, $93486c083cb38a29$export$f64f3247eeaa58a9)();
    // Seed the name filter from a ?name= query param so the org chart can deep-link
    // straight to a person here. Read once on mount; later typing owns the state.
    const [searchParams] = (0, $e3f57e4b1ea630bd$export$f1a78c17382fe22a)();
    const initialName = searchParams.get('name') ?? '';
    const [filters, setFilters] = (0, $gRqVZ.useState)({
        titleOrDepartment: '-',
        jobsite: '-',
        name: initialName,
        sort: $2c406d71a571f9f0$var$sortOptions[0]
    });
    const activeJobSite = jobsiteData?.jobsites.find((jobsite)=>jobsite.title === filters.jobsite);
    const filteredUsers = data?.users?.filter((u)=>{
        const fullName = `${u.firstName} ${u.lastName}`.toLowerCase();
        if (filters.titleOrDepartment !== $2c406d71a571f9f0$var$NO_SELECTION) {
            if (u?.jobTitle !== filters.titleOrDepartment && u?.department?.title !== filters.titleOrDepartment) return false;
        }
        if (filters.jobsite !== $2c406d71a571f9f0$var$NO_SELECTION) {
            if (u?.jobsite?.title !== filters.jobsite) return false;
        }
        if (filters.name.length) {
            const lowercaseNameSearch = filters.name.toLowerCase().trim();
            if (!fullName.includes(lowercaseNameSearch)) return false;
        }
        return true;
    }) ?? [];
    const filteredAndSortedUsers = (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).orderBy(filteredUsers, filters.sort.value);
    const jobTitleOptions = (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).chain(data?.users).map((user)=>user?.jobTitle).compact().groupBy().pickBy((list)=>list.length > 2).keys().value();
    const departmentOptions = (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).chain(data?.users).map((user)=>user?.department?.title).compact().uniq().value();
    const jobSiteOptions = (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).chain(jobsiteData?.jobsites).map((j)=>j.title).compact().uniq().value();
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $38e8ff2ff45ad7fb$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $f17ceecf287e1f86$export$2e2bcd8739ae039), {
                    links: $2c406d71a571f9f0$var$sidebarLinks
                }),
                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $84dca12f95d704fb$export$e0b231e8f936e738), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)("h1", {
                            children: "Company Directory"
                        }),
                        loading ? /*#__PURE__*/ (0, $01ysi.jsx)((0, $a5fc2fd641867f25$export$91fa629114bce97f), {}) : /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $84dca12f95d704fb$export$c3c37dc9d4df2597), {
                                    children: [
                                        /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $85e77696c506735f$export$2e2bcd8739ae039), {
                                                    onChange: (e)=>setFilters({
                                                            ...filters,
                                                            titleOrDepartment: e.target.value
                                                        }),
                                                    children: [
                                                        /*#__PURE__*/ (0, $01ysi.jsx)("option", {
                                                            value: $2c406d71a571f9f0$var$NO_SELECTION,
                                                            children: "Any Job Title & Department"
                                                        }),
                                                        /*#__PURE__*/ (0, $01ysi.jsx)("optgroup", {
                                                            label: "Job titles",
                                                            children: jobTitleOptions.map((option)=>/*#__PURE__*/ (0, $01ysi.jsx)("option", {
                                                                    value: option,
                                                                    children: option
                                                                }, option))
                                                        }),
                                                        /*#__PURE__*/ (0, $01ysi.jsx)("optgroup", {
                                                            label: "Departments",
                                                            children: departmentOptions.map((option)=>/*#__PURE__*/ (0, $01ysi.jsx)("option", {
                                                                    value: option,
                                                                    children: option
                                                                }, option))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $85e77696c506735f$export$2e2bcd8739ae039), {
                                                    onChange: (e)=>setFilters({
                                                            ...filters,
                                                            jobsite: e.target.value
                                                        }),
                                                    children: [
                                                        /*#__PURE__*/ (0, $01ysi.jsx)("option", {
                                                            value: $2c406d71a571f9f0$var$NO_SELECTION,
                                                            children: "Any Job Site"
                                                        }),
                                                        jobSiteOptions.sort().map((option)=>/*#__PURE__*/ (0, $01ysi.jsx)("option", {
                                                                value: option,
                                                                children: option
                                                            }, option))
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $e2bc44ccf855d907$export$2e2bcd8739ae039), {
                                            type: "text",
                                            placeholder: "Search by name",
                                            value: filters.name,
                                            onChange: (e)=>setFilters({
                                                    ...filters,
                                                    name: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $84dca12f95d704fb$export$2e0a83ec2e27ecbb), {}),
                                activeJobSite && /*#__PURE__*/ (0, $01ysi.jsx)((0, $85f36703c6beb577$export$2e2bcd8739ae039), {
                                    jobsite: activeJobSite
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $84dca12f95d704fb$export$33897744af16c59b), {
                                    children: [
                                        "Sort results by",
                                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $85e77696c506735f$export$2e2bcd8739ae039), {
                                            onChange: (e)=>setFilters({
                                                    ...filters,
                                                    sort: $2c406d71a571f9f0$var$sortOptions[e.target.value]
                                                }),
                                            children: $2c406d71a571f9f0$var$sortOptions.map((sortOption, index)=>/*#__PURE__*/ (0, $01ysi.jsx)("option", {
                                                    value: index,
                                                    children: sortOption.label
                                                }, `${sortOption.value}-${index}`))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $84dca12f95d704fb$export$b5894098dc618b3e), {
                                    children: filteredAndSortedUsers.map((user)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $b7cf2e00be4cfa04$export$2e2bcd8739ae039), {
                                            person: user
                                        }, user.id))
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $2c406d71a571f9f0$export$2e2bcd8739ae039 = $2c406d71a571f9f0$var$Directory;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");









const $50e3fcbe9e5fb527$export$e9d03fcc84d41d58 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	border: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	padding: 20px;
	margin-top: 20px;
	width: 260px;
	h3 {
		margin-bottom: 15px;
		font-weight: normal;
		font-size: 16px;
	}
`;
const $50e3fcbe9e5fb527$export$754f42ddee2c4511 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $e3f57e4b1ea630bd$export$b0d92dbee9b5b60d))`
	display: block;
	border-bottom: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	color: ${({ theme: theme })=>theme.colors.primary};
	padding: 15px 0px;
	text-decoration: none;
	font-size: 14px;
	&:last-child {
		border-bottom: none;
	}
`;




const $66c440d29c26d289$var$sidebarLinks = [
    {
        title: 'Discussions',
        to: '/discussions'
    },
    {
        title: 'Create New Discussion',
        to: '/discussions/publish'
    }
];
function $66c440d29c26d289$var$DiscussionsListRoute(props) {
    if (!props.discussions) return null;
    return /*#__PURE__*/ (0, $01ysi.jsx)("div", {
        children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $3e779ae9cb0ef3d8$export$5e191a6234f05919), {
            discussions: props.discussions
        })
    });
}
function $66c440d29c26d289$var$DiscussionsDetailRoute(props) {
    const { discussionId: discussionId } = (0, $372fcccf2bee01ac$export$99eaa27ddbbb95ef)();
    const discussion = props.discussions?.find((d)=>d.id === +discussionId);
    if (!discussion) return null;
    return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $355796544c0c0b43$export$2e2bcd8739ae039), {
                parents: [
                    {
                        to: '/discussions',
                        title: 'Discussions'
                    }
                ],
                primaryColor: false,
                children: discussion.title
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $3e779ae9cb0ef3d8$export$39e473df7a8e24b), {
                discussion: discussion
            })
        ]
    });
}
function $66c440d29c26d289$var$Discussions() {
    const { siteMeta: siteMeta } = (0, $6f7f49c0f054a62d$export$55c0e3cb4fbc46cf)();
    const departments = siteMeta.departments;
    const { data: data, loading: loading } = (0, $93486c083cb38a29$export$a5344e78eb5e7c6d)();
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $38e8ff2ff45ad7fb$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $f17ceecf287e1f86$export$2e2bcd8739ae039), {
                    links: $66c440d29c26d289$var$sidebarLinks,
                    children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $50e3fcbe9e5fb527$export$e9d03fcc84d41d58), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)("h3", {
                                children: "Jump to Department Board"
                            }),
                            departments.map((d)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $50e3fcbe9e5fb527$export$754f42ddee2c4511), {
                                    to: `/departments/${d.id}/discussions`,
                                    children: d.title
                                }, d.id))
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $372fcccf2bee01ac$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                            path: "/",
                            element: loading ? /*#__PURE__*/ (0, $01ysi.jsx)((0, $a5fc2fd641867f25$export$91fa629114bce97f), {}) : /*#__PURE__*/ (0, $01ysi.jsx)($66c440d29c26d289$var$DiscussionsListRoute, {
                                discussions: data?.discussions
                            })
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                            path: "/publish",
                            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $3e779ae9cb0ef3d8$export$e98b2539973fc229), {})
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                            path: "/:discussionId",
                            element: /*#__PURE__*/ (0, $01ysi.jsx)($66c440d29c26d289$var$DiscussionsDetailRoute, {
                                discussions: data?.discussions
                            })
                        })
                    ]
                })
            ]
        })
    });
}
var $66c440d29c26d289$export$2e2bcd8739ae039 = $66c440d29c26d289$var$Discussions;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");


function $7d3aa74f2569f1a7$var$WIP() {
    return /*#__PURE__*/ (0, $01ysi.jsx)("div", {
        children: "Work In Progress"
    });
}
function $7d3aa74f2569f1a7$export$e7b0ac011bb776c6(props = {}) {
    const location = (0, $372fcccf2bee01ac$export$45d76561a5302f2b)();
    const params = (0, $372fcccf2bee01ac$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)("h1", {
                children: props.title || ''
            }),
            $7d3aa74f2569f1a7$var$WIP(),
            /*#__PURE__*/ (0, $01ysi.jsxs)("pre", {
                children: [
                    "Location: ",
                    JSON.stringify(location, null, 2)
                ]
            }),
            /*#__PURE__*/ (0, $01ysi.jsxs)("pre", {
                children: [
                    "Params: ",
                    JSON.stringify(params, null, 2)
                ]
            })
        ]
    });
}
var $7d3aa74f2569f1a7$export$2e2bcd8739ae039 = $7d3aa74f2569f1a7$var$WIP;





var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");






const $34db3c723d99d05f$export$28149cf0bae31b97 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	position: absolute;
	top: 110px;
	left: 0;
	width: 100%;
	height: calc(100% - 110px);
	padding-top: 10px;
	z-index: 10;
	box-shadow: inset 0px 8px 10px -10px rgb(0 0 0 / 50%);
	background-color: rgba(255, 255, 255, 0.95);
	overflow: auto;
	h1 {
		margin-top: 20px;
		font-weight: 400;
		text-align: center;
		font-size: 25px;
	}
	& > #spinner {
		display: block;
		margin: 20px auto;
	}
`;
const $34db3c723d99d05f$export$e51a686c67fdaa2d = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $6bbe05191fca3492$export$2e2bcd8739ae039))`
	display: flex;
	list-style: none;
	padding-left: 0;
`;
const $34db3c723d99d05f$export$3e41faf802a29e71 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $9f86117f466b34a0$export$2e2bcd8739ae039))`
	padding: 15px 10px;
	margin-right: 10px;
	&:hover {
		cursor: pointer;
		color: ${({ theme: theme })=>theme.colors.primary};
	}
	&.active {
		font-weight: 500;
		color: ${({ theme: theme })=>theme.colors.primary};
		border-bottom: 2px solid ${({ theme: theme })=>theme.colors.primary};
	}
`;
const $34db3c723d99d05f$export$9c591276dfd5d919 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $00dc234844cc7684$export$2e2bcd8739ae039))``;




var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");




const $8542608f45f7ce05$export$2209693d0f1ab4df = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	position: fixed;
	top: 25%;
	left: 30%;
	background-color: ${({ theme: theme })=>theme.colors.white};
	width: 450px;
	height: 250px;
	box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
	border-radius: 3px;
	border: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	padding: 40px;
	color: ${({ theme: theme })=>theme.colors.primaryTextColor};
	h1 {
		margin-top: 0px;
		text-align: left;
	}
`;
const $8542608f45f7ce05$export$cae179f078f4b4a4 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $f0e7a4a36037df80$export$78acf4525d8a74c4))`
	width: 30px;
	height: 30px;
	color: ${(props)=>props.theme.colors.borderGray};
	top: 0;
	right: 0;
	position: absolute;
	float: right;
	padding-top: 15px;
	padding-right: 15px;
	&:hover {
		cursor: pointer;
	}
`;
const $8542608f45f7ce05$var$UserModal = ({ person: person, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $63e9a7af5676c306$export$2e2bcd8739ae039), {
        backgroundColor: "dark",
        children: /*#__PURE__*/ (0, $01ysi.jsxs)($8542608f45f7ce05$export$2209693d0f1ab4df, {
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)($8542608f45f7ce05$export$cae179f078f4b4a4, {
                    onClick: onClose
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $b7cf2e00be4cfa04$export$2e2bcd8739ae039), {
                    person: person,
                    fullWidth: true
                })
            ]
        })
    });
};
var $8542608f45f7ce05$export$2e2bcd8739ae039 = $8542608f45f7ce05$var$UserModal;




const $f134475015c955ff$var$TABS = {
    ALL_RESULTS: 0,
    RESOURCES: 1,
    ANNOUNCEMENTS: 2,
    PEOPLE: 3,
    DISCUSSIONS: 4
};
const $f134475015c955ff$var$SEARCH_RESULT_TYPE_MAP = {
    resources: 'resource',
    bulletin: 'news',
    users: 'user'
};
const $f134475015c955ff$var$sortOptions = [
    {
        label: 'Newest',
        value: 'dateDesc'
    },
    {
        label: 'Oldest',
        value: 'dateAsc'
    },
    {
        label: 'Name, A - Z',
        value: 'nameAsc'
    },
    {
        label: 'Name, Z - A',
        value: 'nameDesc'
    }
];
const $f134475015c955ff$var$SearchResults = ()=>{
    const { results: results, loading: loading, searchKeywords: searchKeywords, setSearchOpen: setSearchOpen, searchSort: searchSort, setSearchSort: setSearchSort } = (0, $2693f7ea46500e8f$export$bd221a7c56b93941)();
    const [currentTab, setCurrentTab] = (0, $gRqVZ.useState)($f134475015c955ff$var$TABS.ALL_RESULTS);
    const [userModalOpen, setUserModalOpen] = (0, $gRqVZ.useState)(false);
    const [userModalData, setUserModalData] = (0, $gRqVZ.useState)();
    const navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    const resources = results?.filter((result)=>result.modelType === 'resources') ?? [];
    const announcements = results?.filter((result)=>result.modelType === 'bulletin') ?? [];
    const users = results?.filter((result)=>result.modelType === 'users') ?? [];
    const getOnClick = (resultType, user)=>{
        if (resultType === $f134475015c955ff$var$SEARCH_RESULT_TYPE_MAP.users) return ()=>{
            setUserModalOpen(true);
            setUserModalData(user);
        };
        else if (resultType === $f134475015c955ff$var$SEARCH_RESULT_TYPE_MAP.bulletin) return ()=>{
            setSearchOpen(false);
        };
    };
    const onResourceContextClick = (context)=>{
        setSearchOpen(false);
        if (context.parentId) navigate(`/departments/${context.departmentId}/contents/${context.parentId}/${context.id}`);
        else navigate(`/departments/${context.departmentId}/contents/${context.id}`);
    };
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $34db3c723d99d05f$export$28149cf0bae31b97), {
        children: [
            loading ? /*#__PURE__*/ (0, $01ysi.jsx)((0, $a5fc2fd641867f25$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $01ysi.jsxs)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
                children: [
                    results?.length === 0 && /*#__PURE__*/ (0, $01ysi.jsxs)("h1", {
                        children: [
                            "No results found for ",
                            /*#__PURE__*/ (0, $01ysi.jsx)("b", {
                                children: searchKeywords
                            })
                        ]
                    }),
                    results?.length > 0 && /*#__PURE__*/ (0, $01ysi.jsx)((0, $01ysi.Fragment), {
                        children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $0b5f155847b26aea$export$2e2bcd8739ae039), {
                            selectedIndex: currentTab,
                            selectedTabClassName: "active",
                            onSelect: (index)=>{
                                setCurrentTab(index);
                            },
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $34db3c723d99d05f$export$e51a686c67fdaa2d), {
                                    children: [
                                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $34db3c723d99d05f$export$3e41faf802a29e71), {
                                            children: "All Results"
                                        }),
                                        resources.length > 0 && /*#__PURE__*/ (0, $01ysi.jsx)((0, $34db3c723d99d05f$export$3e41faf802a29e71), {
                                            children: "Resources"
                                        }),
                                        announcements.length > 0 && /*#__PURE__*/ (0, $01ysi.jsx)((0, $34db3c723d99d05f$export$3e41faf802a29e71), {
                                            children: "Announcements"
                                        }),
                                        users.length > 0 && /*#__PURE__*/ (0, $01ysi.jsx)((0, $34db3c723d99d05f$export$3e41faf802a29e71), {
                                            children: "Users"
                                        }),
                                        /*#__PURE__*/ (0, $01ysi.jsxs)("span", {
                                            style: {
                                                marginLeft: 'auto'
                                            },
                                            children: [
                                                "Sort results by:",
                                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $85e77696c506735f$export$2e2bcd8739ae039), {
                                                    onChange: (e)=>setSearchSort(e.target.value),
                                                    children: $f134475015c955ff$var$sortOptions.map((sortOption)=>/*#__PURE__*/ (0, $01ysi.jsx)("option", {
                                                            value: sortOption.value,
                                                            children: sortOption.label
                                                        }, `${sortOption.value}`))
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $34db3c723d99d05f$export$9c591276dfd5d919), {
                                    children: results.map((result, index)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $cb071fc609c78ddc$export$2e2bcd8739ae039), {
                                            data: result.resource || result.user || result.bulletin,
                                            $displaySize: "lg",
                                            modelId: result.modelId,
                                            showTypeBadge: true,
                                            departmentId: result.bulletin?.global === false && result.bulletin.bulletinDepartments?.[0]?.departmentId || undefined,
                                            onClick: getOnClick($f134475015c955ff$var$SEARCH_RESULT_TYPE_MAP[result.modelType], result.user),
                                            onResourceContextClick: onResourceContextClick
                                        }, `${$f134475015c955ff$var$SEARCH_RESULT_TYPE_MAP[result.modelType]}-${index}`))
                                }),
                                resources.length > 0 && /*#__PURE__*/ (0, $01ysi.jsx)((0, $34db3c723d99d05f$export$9c591276dfd5d919), {
                                    children: resources.map((result, index)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $cb071fc609c78ddc$export$2e2bcd8739ae039), {
                                            data: result.resource,
                                            $displaySize: "lg",
                                            modelId: result.modelId,
                                            showTypeBadge: true,
                                            onResourceContextClick: onResourceContextClick
                                        }, `resource-${index}`))
                                }),
                                announcements.length > 0 && /*#__PURE__*/ (0, $01ysi.jsx)((0, $34db3c723d99d05f$export$9c591276dfd5d919), {
                                    children: announcements.map((result, index)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $cb071fc609c78ddc$export$2e2bcd8739ae039), {
                                            data: result.bulletin,
                                            $displaySize: "lg",
                                            modelId: result.modelId,
                                            showTypeBadge: true
                                        }, `news-${index}`))
                                }),
                                users.length > 0 && /*#__PURE__*/ (0, $01ysi.jsx)((0, $34db3c723d99d05f$export$9c591276dfd5d919), {
                                    children: users.map((result, index)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $cb071fc609c78ddc$export$2e2bcd8739ae039), {
                                            data: result.user,
                                            $displaySize: "lg",
                                            modelId: result.modelId,
                                            showTypeBadge: true,
                                            onClick: getOnClick($f134475015c955ff$var$SEARCH_RESULT_TYPE_MAP[result.modelType], result.user)
                                        }, `user-${index}`))
                                })
                            ]
                        })
                    })
                ]
            }),
            userModalOpen && userModalData && /*#__PURE__*/ (0, $01ysi.jsx)((0, $8542608f45f7ce05$export$2e2bcd8739ae039), {
                person: userModalData,
                onClose: ()=>{
                    setUserModalOpen(false);
                    setUserModalData(null);
                }
            })
        ]
    });
};
var $f134475015c955ff$export$2e2bcd8739ae039 = $f134475015c955ff$var$SearchResults;



var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");









function $db22c8b683e5147b$export$2e2bcd8739ae039(t, o, e) {
    return o = (0, $f4e1869d2d3aba79$export$2e2bcd8739ae039)(o), (0, $19a29e637fa61de7$export$2e2bcd8739ae039)(t, (0, $2c62263bd98f6b07$export$2e2bcd8739ae039)() ? Reflect.construct(o, e || [], (0, $f4e1869d2d3aba79$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}




function $db2152db93f40e4f$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $db2152db93f40e4f$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $db2152db93f40e4f$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $db2152db93f40e4f$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $db2152db93f40e4f$export$2e2bcd8739ae039 = $db2152db93f40e4f$export$4f5d2d50c9deca37;



var $gRqVZ = parcelRequire("gRqVZ");

var $if2ZQ = parcelRequire("if2ZQ");

var $2UY5J = parcelRequire("2UY5J");

var $gRqVZ = parcelRequire("gRqVZ");
var $466b99331d7e73e3$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $466b99331d7e73e3$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$466b99331d7e73e3$exports = $466b99331d7e73e3$var$invariant;


var $30e77266492a8676$var$noop = function noop() {};
function $30e77266492a8676$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $30e77266492a8676$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $30e77266492a8676$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$30e77266492a8676$export$26cbf8c37e721e67(prop)] = $30e77266492a8676$var$noop;
        var handler;
    });
    return propTypes;
}
function $30e77266492a8676$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $30e77266492a8676$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $30e77266492a8676$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $9343263716f05a63$var$_toPropertyKey(arg) {
    var key = $9343263716f05a63$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $9343263716f05a63$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $9343263716f05a63$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $gRqVZ.useRef)(propValue !== undefined);
    var _useState = (0, $gRqVZ.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $gRqVZ.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $9343263716f05a63$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$30e77266492a8676$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $2UY5J.default)(_ref, [
            $30e77266492a8676$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($9343263716f05a63$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $9343263716f05a63$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $if2ZQ.default)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}



var $2UY5J = parcelRequire("2UY5J");

var $if2ZQ = parcelRequire("if2ZQ");


var $gRqVZ = parcelRequire("gRqVZ");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $b3ce409d5451cdc8$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $b3ce409d5451cdc8$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $b3ce409d5451cdc8$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$b3ce409d5451cdc8$var$componentWillMount.__suppressDeprecationWarning = true;
$b3ce409d5451cdc8$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$b3ce409d5451cdc8$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $b3ce409d5451cdc8$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $b3ce409d5451cdc8$var$componentWillMount;
        prototype.componentWillReceiveProps = $b3ce409d5451cdc8$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $b3ce409d5451cdc8$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $541facd42d47846b$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $541facd42d47846b$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $30e77266492a8676$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($30e77266492a8676$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($466b99331d7e73e3$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $56ac1d9e876095b6$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $if2ZQ.default)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$30e77266492a8676$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $if2ZQ.default)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$30e77266492a8676$export$12ae2baa35bd9b8b(props, key) && $30e77266492a8676$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$30e77266492a8676$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $2UY5J.default)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(Component, (0, $if2ZQ.default)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Component);
    (0, $b3ce409d5451cdc8$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $if2ZQ.default)({
        innerRef: function innerRef() {}
    }, $30e77266492a8676$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(UncontrolledComponent, (0, $if2ZQ.default)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $541facd42d47846b$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $541facd42d47846b$export$2e2bcd8739ae039(newComponent, (0, $if2ZQ.default)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}





var $awzbB = parcelRequire("awzbB");

var $f8eddd003dbc1436$exports = {};

$parcel$export($f8eddd003dbc1436$exports, "add", function () { return $f8eddd003dbc1436$export$e16d8520af44a096; });
$parcel$export($f8eddd003dbc1436$exports, "subtract", function () { return $f8eddd003dbc1436$export$4e2d2ead65e5f7e3; });
$parcel$export($f8eddd003dbc1436$exports, "startOf", function () { return $f8eddd003dbc1436$export$38d7278c783c77a7; });
$parcel$export($f8eddd003dbc1436$exports, "month", function () { return $f8eddd003dbc1436$export$af5de1609f06c8e6; });
$parcel$export($f8eddd003dbc1436$exports, "date", function () { return $f8eddd003dbc1436$export$324d90190a8b822a; });
$parcel$export($f8eddd003dbc1436$exports, "hours", function () { return $f8eddd003dbc1436$export$8d468796d69cdad1; });
$parcel$export($f8eddd003dbc1436$exports, "minutes", function () { return $f8eddd003dbc1436$export$666252b437cce0c7; });
$parcel$export($f8eddd003dbc1436$exports, "seconds", function () { return $f8eddd003dbc1436$export$4792e48abc550fa1; });
$parcel$export($f8eddd003dbc1436$exports, "milliseconds", function () { return $f8eddd003dbc1436$export$9a27fac83d67afd3; });
$parcel$export($f8eddd003dbc1436$exports, "year", function () { return $f8eddd003dbc1436$export$31803937850fb2da; });
$parcel$export($f8eddd003dbc1436$exports, "weekday", function () { return $f8eddd003dbc1436$export$b7f7efbe9ab39b25; });
$parcel$export($f8eddd003dbc1436$exports, "endOf", function () { return $f8eddd003dbc1436$export$2d3c3037220ab47a; });
$parcel$export($f8eddd003dbc1436$exports, "eq", function () { return $f8eddd003dbc1436$export$9663ddc1cf085b32; });
$parcel$export($f8eddd003dbc1436$exports, "neq", function () { return $f8eddd003dbc1436$export$9bc858421bf255d1; });
$parcel$export($f8eddd003dbc1436$exports, "gt", function () { return $f8eddd003dbc1436$export$dafeacbfe3530cd9; });
$parcel$export($f8eddd003dbc1436$exports, "gte", function () { return $f8eddd003dbc1436$export$aac79e834d1b4aed; });
$parcel$export($f8eddd003dbc1436$exports, "lt", function () { return $f8eddd003dbc1436$export$b961576059b7aeb6; });
$parcel$export($f8eddd003dbc1436$exports, "lte", function () { return $f8eddd003dbc1436$export$489c007ed603c05d; });
$parcel$export($f8eddd003dbc1436$exports, "min", function () { return $f8eddd003dbc1436$export$96ec731ed4dcb222; });
$parcel$export($f8eddd003dbc1436$exports, "max", function () { return $f8eddd003dbc1436$export$8960430cfd85939f; });
$parcel$export($f8eddd003dbc1436$exports, "inRange", function () { return $f8eddd003dbc1436$export$ddf89a9c5af38f94; });
$parcel$export($f8eddd003dbc1436$exports, "day", function () { return $f8eddd003dbc1436$export$d2d39d1adcc883a2; });
$parcel$export($f8eddd003dbc1436$exports, "decade", function () { return $f8eddd003dbc1436$export$5b86ea63a640289f; });
$parcel$export($f8eddd003dbc1436$exports, "century", function () { return $f8eddd003dbc1436$export$2c6a90a816708bc5; });
$parcel$export($f8eddd003dbc1436$exports, "diff", function () { return $f8eddd003dbc1436$export$a37e3c603d7117e5; });
var $f8eddd003dbc1436$var$MILI = 'milliseconds', $f8eddd003dbc1436$var$SECONDS = 'seconds', $f8eddd003dbc1436$var$MINUTES = 'minutes', $f8eddd003dbc1436$var$HOURS = 'hours', $f8eddd003dbc1436$var$DAY = 'day', $f8eddd003dbc1436$var$WEEK = 'week', $f8eddd003dbc1436$var$MONTH = 'month', $f8eddd003dbc1436$var$YEAR = 'year', $f8eddd003dbc1436$var$DECADE = 'decade', $f8eddd003dbc1436$var$CENTURY = 'century';
var $f8eddd003dbc1436$var$multiplierMilli = {
    'milliseconds': 1,
    'seconds': 1000,
    'minutes': 60000,
    'hours': 3600000,
    'day': 86400000,
    'week': 604800000
};
var $f8eddd003dbc1436$var$multiplierMonth = {
    'month': 1,
    'year': 12,
    'decade': 120,
    'century': 1200
};
function $f8eddd003dbc1436$var$daysOf(year) {
    return [
        31,
        $f8eddd003dbc1436$var$daysInFeb(year),
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
}
function $f8eddd003dbc1436$var$daysInFeb(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0 ? 29 : 28;
}
function $f8eddd003dbc1436$export$e16d8520af44a096(d, num, unit) {
    d = new Date(d);
    switch(unit){
        case $f8eddd003dbc1436$var$MILI:
        case $f8eddd003dbc1436$var$SECONDS:
        case $f8eddd003dbc1436$var$MINUTES:
        case $f8eddd003dbc1436$var$HOURS:
        case $f8eddd003dbc1436$var$DAY:
        case $f8eddd003dbc1436$var$WEEK:
            return $f8eddd003dbc1436$var$addMillis(d, num * $f8eddd003dbc1436$var$multiplierMilli[unit]);
        case $f8eddd003dbc1436$var$MONTH:
        case $f8eddd003dbc1436$var$YEAR:
        case $f8eddd003dbc1436$var$DECADE:
        case $f8eddd003dbc1436$var$CENTURY:
            return $f8eddd003dbc1436$var$addMonths(d, num * $f8eddd003dbc1436$var$multiplierMonth[unit]);
    }
    throw new TypeError('Invalid units: "' + unit + '"');
}
function $f8eddd003dbc1436$var$addMillis(d, num) {
    var nextDate = new Date(+d + num);
    return $f8eddd003dbc1436$var$solveDST(d, nextDate);
}
function $f8eddd003dbc1436$var$addMonths(d, num) {
    var year = d.getFullYear(), month = d.getMonth(), day = d.getDate(), totalMonths = year * 12 + month + num, nextYear = Math.trunc(totalMonths / 12), nextMonth = totalMonths % 12, nextDay = Math.min(day, $f8eddd003dbc1436$var$daysOf(nextYear)[nextMonth]);
    var nextDate = new Date(d);
    nextDate.setFullYear(nextYear);
    // To avoid a bug when sets the Feb month
    // with a date > 28 or date > 29 (leap year)
    nextDate.setDate(1);
    nextDate.setMonth(nextMonth);
    nextDate.setDate(nextDay);
    return nextDate;
}
function $f8eddd003dbc1436$var$solveDST(currentDate, nextDate) {
    var currentOffset = currentDate.getTimezoneOffset(), nextOffset = nextDate.getTimezoneOffset();
    // if is DST, add the difference in minutes
    // else the difference is zero
    var diffMinutes = nextOffset - currentOffset;
    return new Date(+nextDate + diffMinutes * $f8eddd003dbc1436$var$multiplierMilli['minutes']);
}
function $f8eddd003dbc1436$export$4e2d2ead65e5f7e3(d, num, unit) {
    return $f8eddd003dbc1436$export$e16d8520af44a096(d, -num, unit);
}
function $f8eddd003dbc1436$export$38d7278c783c77a7(d, unit, firstOfWeek) {
    d = new Date(d);
    switch(unit){
        case $f8eddd003dbc1436$var$CENTURY:
        case $f8eddd003dbc1436$var$DECADE:
        case $f8eddd003dbc1436$var$YEAR:
            d = $f8eddd003dbc1436$export$af5de1609f06c8e6(d, 0);
        case $f8eddd003dbc1436$var$MONTH:
            d = $f8eddd003dbc1436$export$324d90190a8b822a(d, 1);
        case $f8eddd003dbc1436$var$WEEK:
        case $f8eddd003dbc1436$var$DAY:
            d = $f8eddd003dbc1436$export$8d468796d69cdad1(d, 0);
        case $f8eddd003dbc1436$var$HOURS:
            d = $f8eddd003dbc1436$export$666252b437cce0c7(d, 0);
        case $f8eddd003dbc1436$var$MINUTES:
            d = $f8eddd003dbc1436$export$4792e48abc550fa1(d, 0);
        case $f8eddd003dbc1436$var$SECONDS:
            d = $f8eddd003dbc1436$export$9a27fac83d67afd3(d, 0);
    }
    if (unit === $f8eddd003dbc1436$var$DECADE) d = $f8eddd003dbc1436$export$4e2d2ead65e5f7e3(d, $f8eddd003dbc1436$export$31803937850fb2da(d) % 10, 'year');
    if (unit === $f8eddd003dbc1436$var$CENTURY) d = $f8eddd003dbc1436$export$4e2d2ead65e5f7e3(d, $f8eddd003dbc1436$export$31803937850fb2da(d) % 100, 'year');
    if (unit === $f8eddd003dbc1436$var$WEEK) d = $f8eddd003dbc1436$export$b7f7efbe9ab39b25(d, 0, firstOfWeek);
    return d;
}
function $f8eddd003dbc1436$export$2d3c3037220ab47a(d, unit, firstOfWeek) {
    d = new Date(d);
    d = $f8eddd003dbc1436$export$38d7278c783c77a7(d, unit, firstOfWeek);
    switch(unit){
        case $f8eddd003dbc1436$var$CENTURY:
        case $f8eddd003dbc1436$var$DECADE:
        case $f8eddd003dbc1436$var$YEAR:
        case $f8eddd003dbc1436$var$MONTH:
        case $f8eddd003dbc1436$var$WEEK:
            d = $f8eddd003dbc1436$export$e16d8520af44a096(d, 1, unit);
            d = $f8eddd003dbc1436$export$4e2d2ead65e5f7e3(d, 1, $f8eddd003dbc1436$var$DAY);
            d.setHours(23, 59, 59, 999);
            break;
        case $f8eddd003dbc1436$var$DAY:
            d.setHours(23, 59, 59, 999);
            break;
        case $f8eddd003dbc1436$var$HOURS:
        case $f8eddd003dbc1436$var$MINUTES:
        case $f8eddd003dbc1436$var$SECONDS:
            d = $f8eddd003dbc1436$export$e16d8520af44a096(d, 1, unit);
            d = $f8eddd003dbc1436$export$4e2d2ead65e5f7e3(d, 1, $f8eddd003dbc1436$var$MILI);
    }
    return d;
}
var $f8eddd003dbc1436$export$9663ddc1cf085b32 = $f8eddd003dbc1436$var$createComparer(function(a, b) {
    return a === b;
});
var $f8eddd003dbc1436$export$9bc858421bf255d1 = $f8eddd003dbc1436$var$createComparer(function(a, b) {
    return a !== b;
});
var $f8eddd003dbc1436$export$dafeacbfe3530cd9 = $f8eddd003dbc1436$var$createComparer(function(a, b) {
    return a > b;
});
var $f8eddd003dbc1436$export$aac79e834d1b4aed = $f8eddd003dbc1436$var$createComparer(function(a, b) {
    return a >= b;
});
var $f8eddd003dbc1436$export$b961576059b7aeb6 = $f8eddd003dbc1436$var$createComparer(function(a, b) {
    return a < b;
});
var $f8eddd003dbc1436$export$489c007ed603c05d = $f8eddd003dbc1436$var$createComparer(function(a, b) {
    return a <= b;
});
function $f8eddd003dbc1436$export$96ec731ed4dcb222() {
    return new Date(Math.min.apply(Math, arguments));
}
function $f8eddd003dbc1436$export$8960430cfd85939f() {
    return new Date(Math.max.apply(Math, arguments));
}
function $f8eddd003dbc1436$export$ddf89a9c5af38f94(day, min, max, unit) {
    unit = unit || 'day';
    return (!min || $f8eddd003dbc1436$export$aac79e834d1b4aed(day, min, unit)) && (!max || $f8eddd003dbc1436$export$489c007ed603c05d(day, max, unit));
}
var $f8eddd003dbc1436$export$9a27fac83d67afd3 = $f8eddd003dbc1436$var$createAccessor('Milliseconds');
var $f8eddd003dbc1436$export$4792e48abc550fa1 = $f8eddd003dbc1436$var$createAccessor('Seconds');
var $f8eddd003dbc1436$export$666252b437cce0c7 = $f8eddd003dbc1436$var$createAccessor('Minutes');
var $f8eddd003dbc1436$export$8d468796d69cdad1 = $f8eddd003dbc1436$var$createAccessor('Hours');
var $f8eddd003dbc1436$export$d2d39d1adcc883a2 = $f8eddd003dbc1436$var$createAccessor('Day');
var $f8eddd003dbc1436$export$324d90190a8b822a = $f8eddd003dbc1436$var$createAccessor('Date');
var $f8eddd003dbc1436$export$af5de1609f06c8e6 = $f8eddd003dbc1436$var$createAccessor('Month');
var $f8eddd003dbc1436$export$31803937850fb2da = $f8eddd003dbc1436$var$createAccessor('FullYear');
function $f8eddd003dbc1436$export$5b86ea63a640289f(d, val) {
    return val === undefined ? $f8eddd003dbc1436$export$31803937850fb2da($f8eddd003dbc1436$export$38d7278c783c77a7(d, $f8eddd003dbc1436$var$DECADE)) : $f8eddd003dbc1436$export$e16d8520af44a096(d, val + 10, $f8eddd003dbc1436$var$YEAR);
}
function $f8eddd003dbc1436$export$2c6a90a816708bc5(d, val) {
    return val === undefined ? $f8eddd003dbc1436$export$31803937850fb2da($f8eddd003dbc1436$export$38d7278c783c77a7(d, $f8eddd003dbc1436$var$CENTURY)) : $f8eddd003dbc1436$export$e16d8520af44a096(d, val + 100, $f8eddd003dbc1436$var$YEAR);
}
function $f8eddd003dbc1436$export$b7f7efbe9ab39b25(d, val, firstDay) {
    var w = ($f8eddd003dbc1436$export$d2d39d1adcc883a2(d) + 7 - (firstDay || 0)) % 7;
    return val === undefined ? w : $f8eddd003dbc1436$export$e16d8520af44a096(d, val - w, $f8eddd003dbc1436$var$DAY);
}
function $f8eddd003dbc1436$export$a37e3c603d7117e5(date1, date2, unit, asFloat) {
    var dividend, divisor, result;
    switch(unit){
        case $f8eddd003dbc1436$var$MILI:
        case $f8eddd003dbc1436$var$SECONDS:
        case $f8eddd003dbc1436$var$MINUTES:
        case $f8eddd003dbc1436$var$HOURS:
        case $f8eddd003dbc1436$var$DAY:
        case $f8eddd003dbc1436$var$WEEK:
            dividend = date2.getTime() - date1.getTime();
            break;
        case $f8eddd003dbc1436$var$MONTH:
        case $f8eddd003dbc1436$var$YEAR:
        case $f8eddd003dbc1436$var$DECADE:
        case $f8eddd003dbc1436$var$CENTURY:
            dividend = ($f8eddd003dbc1436$export$31803937850fb2da(date2) - $f8eddd003dbc1436$export$31803937850fb2da(date1)) * 12 + $f8eddd003dbc1436$export$af5de1609f06c8e6(date2) - $f8eddd003dbc1436$export$af5de1609f06c8e6(date1);
            break;
        default:
            throw new TypeError('Invalid units: "' + unit + '"');
    }
    switch(unit){
        case $f8eddd003dbc1436$var$MILI:
            divisor = 1;
            break;
        case $f8eddd003dbc1436$var$SECONDS:
            divisor = 1000;
            break;
        case $f8eddd003dbc1436$var$MINUTES:
            divisor = 60000;
            break;
        case $f8eddd003dbc1436$var$HOURS:
            divisor = 3600000;
            break;
        case $f8eddd003dbc1436$var$DAY:
            divisor = 86400000;
            break;
        case $f8eddd003dbc1436$var$WEEK:
            divisor = 604800000;
            break;
        case $f8eddd003dbc1436$var$MONTH:
            divisor = 1;
            break;
        case $f8eddd003dbc1436$var$YEAR:
            divisor = 12;
            break;
        case $f8eddd003dbc1436$var$DECADE:
            divisor = 120;
            break;
        case $f8eddd003dbc1436$var$CENTURY:
            divisor = 1200;
            break;
        default:
            throw new TypeError('Invalid units: "' + unit + '"');
    }
    result = dividend / divisor;
    return asFloat ? result : Math.round(result);
}
function $f8eddd003dbc1436$var$createAccessor(method) {
    var hourLength = function(method) {
        switch(method){
            case 'Milliseconds':
                return 3600000;
            case 'Seconds':
                return 3600;
            case 'Minutes':
                return 60;
            case 'Hours':
                return 1;
            default:
                return null;
        }
    }(method);
    return function(d, val) {
        if (val === undefined) return d['get' + method]();
        var dateOut = new Date(d);
        dateOut['set' + method](val);
        if (hourLength && dateOut['get' + method]() != val && (method === 'Hours' || val >= hourLength && dateOut.getHours() - d.getHours() < Math.floor(val / hourLength))) //Skip DST hour, if it occurs
        dateOut['set' + method](val + hourLength);
        return dateOut;
    };
}
function $f8eddd003dbc1436$var$createComparer(operator) {
    return function(a, b, unit) {
        return operator(+$f8eddd003dbc1436$export$38d7278c783c77a7(a, unit), +$f8eddd003dbc1436$export$38d7278c783c77a7(b, unit));
    };
}




var $5f27ac4c26d09397$exports = {};
var $51476ae3b005f3c6$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $51476ae3b005f3c6$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$51476ae3b005f3c6$exports = $51476ae3b005f3c6$var$baseSlice;


var $5ce7f5854ad79775$exports = {};
var $4407ef85bda41b8e$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $4407ef85bda41b8e$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$4407ef85bda41b8e$exports = $4407ef85bda41b8e$var$eq;


var $0e382c48d62f9029$exports = {};
var $323a1d4ebc031189$exports = {};
var $2bee838a2d69c279$exports = {};
var $b6c34d3fc7779ecd$exports = {};

var $keq6u = parcelRequire("keq6u");
/** Built-in value references. */ var $b6c34d3fc7779ecd$var$Symbol = $keq6u.Symbol;
$b6c34d3fc7779ecd$exports = $b6c34d3fc7779ecd$var$Symbol;


var $db493d5eb6371633$exports = {};

/** Used for built-in method references. */ var $db493d5eb6371633$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $db493d5eb6371633$var$hasOwnProperty = $db493d5eb6371633$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $db493d5eb6371633$var$nativeObjectToString = $db493d5eb6371633$var$objectProto.toString;
/** Built-in value references. */ var $db493d5eb6371633$var$symToStringTag = $b6c34d3fc7779ecd$exports ? $b6c34d3fc7779ecd$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $db493d5eb6371633$var$getRawTag(value) {
    var isOwn = $db493d5eb6371633$var$hasOwnProperty.call(value, $db493d5eb6371633$var$symToStringTag), tag = value[$db493d5eb6371633$var$symToStringTag];
    try {
        value[$db493d5eb6371633$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $db493d5eb6371633$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$db493d5eb6371633$var$symToStringTag] = tag;
        else delete value[$db493d5eb6371633$var$symToStringTag];
    }
    return result;
}
$db493d5eb6371633$exports = $db493d5eb6371633$var$getRawTag;


var $49e56a360ebcfd60$exports = {};
/** Used for built-in method references. */ var $49e56a360ebcfd60$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $49e56a360ebcfd60$var$nativeObjectToString = $49e56a360ebcfd60$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $49e56a360ebcfd60$var$objectToString(value) {
    return $49e56a360ebcfd60$var$nativeObjectToString.call(value);
}
$49e56a360ebcfd60$exports = $49e56a360ebcfd60$var$objectToString;


/** `Object#toString` result references. */ var $2bee838a2d69c279$var$nullTag = '[object Null]', $2bee838a2d69c279$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $2bee838a2d69c279$var$symToStringTag = $b6c34d3fc7779ecd$exports ? $b6c34d3fc7779ecd$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $2bee838a2d69c279$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $2bee838a2d69c279$var$undefinedTag : $2bee838a2d69c279$var$nullTag;
    return $2bee838a2d69c279$var$symToStringTag && $2bee838a2d69c279$var$symToStringTag in Object(value) ? $db493d5eb6371633$exports(value) : $49e56a360ebcfd60$exports(value);
}
$2bee838a2d69c279$exports = $2bee838a2d69c279$var$baseGetTag;


var $3eb8329121eae2bf$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $3eb8329121eae2bf$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$3eb8329121eae2bf$exports = $3eb8329121eae2bf$var$isObject;


/** `Object#toString` result references. */ var $323a1d4ebc031189$var$asyncTag = '[object AsyncFunction]', $323a1d4ebc031189$var$funcTag = '[object Function]', $323a1d4ebc031189$var$genTag = '[object GeneratorFunction]', $323a1d4ebc031189$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $323a1d4ebc031189$var$isFunction(value) {
    if (!$3eb8329121eae2bf$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $2bee838a2d69c279$exports(value);
    return tag == $323a1d4ebc031189$var$funcTag || tag == $323a1d4ebc031189$var$genTag || tag == $323a1d4ebc031189$var$asyncTag || tag == $323a1d4ebc031189$var$proxyTag;
}
$323a1d4ebc031189$exports = $323a1d4ebc031189$var$isFunction;


var $ab7aa2d0632f3723$exports = {};
/** Used as references for various `Number` constants. */ var $ab7aa2d0632f3723$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $ab7aa2d0632f3723$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $ab7aa2d0632f3723$var$MAX_SAFE_INTEGER;
}
$ab7aa2d0632f3723$exports = $ab7aa2d0632f3723$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $0e382c48d62f9029$var$isArrayLike(value) {
    return value != null && $ab7aa2d0632f3723$exports(value.length) && !$323a1d4ebc031189$exports(value);
}
$0e382c48d62f9029$exports = $0e382c48d62f9029$var$isArrayLike;


var $cee267ee972b0340$exports = {};
/** Used as references for various `Number` constants. */ var $cee267ee972b0340$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $cee267ee972b0340$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $cee267ee972b0340$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $cee267ee972b0340$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $cee267ee972b0340$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$cee267ee972b0340$exports = $cee267ee972b0340$var$isIndex;



/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $5ce7f5854ad79775$var$isIterateeCall(value, index, object) {
    if (!$3eb8329121eae2bf$exports(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $0e382c48d62f9029$exports(object) && $cee267ee972b0340$exports(index, object.length) : type == 'string' && index in object) return $4407ef85bda41b8e$exports(object[index], value);
    return false;
}
$5ce7f5854ad79775$exports = $5ce7f5854ad79775$var$isIterateeCall;


var $2e7523fa77e42e3e$exports = {};
var $af4655bb90090965$exports = {};
var $4313d2a4e9f74180$exports = {};
var $bdcc3b9063fd8d7e$exports = {};
var $24dfd71c6c2864cf$exports = {};
/** Used to match a single whitespace character. */ var $24dfd71c6c2864cf$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $24dfd71c6c2864cf$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $24dfd71c6c2864cf$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$24dfd71c6c2864cf$exports = $24dfd71c6c2864cf$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $bdcc3b9063fd8d7e$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $bdcc3b9063fd8d7e$var$baseTrim(string) {
    return string ? string.slice(0, $24dfd71c6c2864cf$exports(string) + 1).replace($bdcc3b9063fd8d7e$var$reTrimStart, '') : string;
}
$bdcc3b9063fd8d7e$exports = $bdcc3b9063fd8d7e$var$baseTrim;



var $3c132c7cf40a9860$exports = {};

var $eeeaa33c41c300ed$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $eeeaa33c41c300ed$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$eeeaa33c41c300ed$exports = $eeeaa33c41c300ed$var$isObjectLike;


/** `Object#toString` result references. */ var $3c132c7cf40a9860$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $3c132c7cf40a9860$var$isSymbol(value) {
    return typeof value == 'symbol' || $eeeaa33c41c300ed$exports(value) && $2bee838a2d69c279$exports(value) == $3c132c7cf40a9860$var$symbolTag;
}
$3c132c7cf40a9860$exports = $3c132c7cf40a9860$var$isSymbol;


/** Used as references for various `Number` constants. */ var $4313d2a4e9f74180$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $4313d2a4e9f74180$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $4313d2a4e9f74180$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $4313d2a4e9f74180$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $4313d2a4e9f74180$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $4313d2a4e9f74180$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($3c132c7cf40a9860$exports(value)) return $4313d2a4e9f74180$var$NAN;
    if ($3eb8329121eae2bf$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $3eb8329121eae2bf$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $bdcc3b9063fd8d7e$exports(value);
    var isBinary = $4313d2a4e9f74180$var$reIsBinary.test(value);
    return isBinary || $4313d2a4e9f74180$var$reIsOctal.test(value) ? $4313d2a4e9f74180$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $4313d2a4e9f74180$var$reIsBadHex.test(value) ? $4313d2a4e9f74180$var$NAN : +value;
}
$4313d2a4e9f74180$exports = $4313d2a4e9f74180$var$toNumber;


/** Used as references for various `Number` constants. */ var $af4655bb90090965$var$INFINITY = 1 / 0, $af4655bb90090965$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $af4655bb90090965$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $4313d2a4e9f74180$exports(value);
    if (value === $af4655bb90090965$var$INFINITY || value === -$af4655bb90090965$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $af4655bb90090965$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$af4655bb90090965$exports = $af4655bb90090965$var$toFinite;


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $2e7523fa77e42e3e$var$toInteger(value) {
    var result = $af4655bb90090965$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$2e7523fa77e42e3e$exports = $2e7523fa77e42e3e$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $5f27ac4c26d09397$var$nativeCeil = Math.ceil, $5f27ac4c26d09397$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $5f27ac4c26d09397$var$chunk(array, size, guard) {
    if (guard ? $5ce7f5854ad79775$exports(array, size, guard) : size === undefined) size = 1;
    else size = $5f27ac4c26d09397$var$nativeMax($2e7523fa77e42e3e$exports(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($5f27ac4c26d09397$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = $51476ae3b005f3c6$exports(array, index, index += size);
    return result;
}
$5f27ac4c26d09397$exports = $5f27ac4c26d09397$var$chunk;



var $if2ZQ = parcelRequire("if2ZQ");
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $6cbe4b8881f057f1$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $78290ae83dc1627b$export$2e2bcd8739ae039(node) {
    var doc = (0, $6cbe4b8881f057f1$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $b4dce3240def3fd8$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $78290ae83dc1627b$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $b87735da17237570$var$rUpper = /([A-Z])/g;
function $b87735da17237570$export$2e2bcd8739ae039(string) {
    return string.replace($b87735da17237570$var$rUpper, '-$1').toLowerCase();
}


var $1e62b0bd7b75aeb0$var$msPattern = /^ms-/;
function $1e62b0bd7b75aeb0$export$2e2bcd8739ae039(string) {
    return (0, $b87735da17237570$export$2e2bcd8739ae039)(string).replace($1e62b0bd7b75aeb0$var$msPattern, '-ms-');
}


var $e15a8bab67002324$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $e15a8bab67002324$export$2e2bcd8739ae039(value) {
    return !!(value && $e15a8bab67002324$var$supportedTransforms.test(value));
}


function $c27166d3adbef964$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $1e62b0bd7b75aeb0$export$2e2bcd8739ae039)(property)) || (0, $b4dce3240def3fd8$export$2e2bcd8739ae039)(node).getPropertyValue((0, $1e62b0bd7b75aeb0$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $1e62b0bd7b75aeb0$export$2e2bcd8739ae039)(key));
        else if ((0, $e15a8bab67002324$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $1e62b0bd7b75aeb0$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $c27166d3adbef964$export$2e2bcd8739ae039 = $c27166d3adbef964$var$style;


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $78634a75aa69345d$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}



function $39c80f72d50ee62f$export$2e2bcd8739ae039(element) {
    return 'nodeType' in element && element.nodeType === document.DOCUMENT_NODE;
}


function $73dd4e5d3cfde323$export$2e2bcd8739ae039(node) {
    if ('window' in node && node.window === node) return node;
    if ((0, $39c80f72d50ee62f$export$2e2bcd8739ae039)(node)) return node.defaultView || false;
    return false;
}


function $6aace2b81e0d24f9$export$2e2bcd8739ae039(offset) {
    var prop = offset === 'pageXOffset' ? 'scrollLeft' : 'scrollTop';
    function scrollAccessor(node, val) {
        var win = (0, $73dd4e5d3cfde323$export$2e2bcd8739ae039)(node);
        if (val === undefined) return win ? win[offset] : node[prop];
        if (win) win.scrollTo(win[offset], val);
        else node[prop] = val;
    }
    return scrollAccessor;
}


var /**
 * Gets or sets the scroll left position of a given element.
 * 
 * @param node the element
 * @param val the position to set
 */ $954bbff4f39b794f$export$2e2bcd8739ae039 = (0, $6aace2b81e0d24f9$export$2e2bcd8739ae039)('pageXOffset');



var /**
 * Gets or sets the scroll top position of a given element.
 * 
 * @param node the element
 * @param val the position to set
 */ $50754d4a04d03787$export$2e2bcd8739ae039 = (0, $6aace2b81e0d24f9$export$2e2bcd8739ae039)('pageYOffset');


function $2f02d0066d00e531$export$2e2bcd8739ae039(node) {
    var doc = (0, $6cbe4b8881f057f1$export$2e2bcd8739ae039)(node);
    var box = {
        top: 0,
        left: 0,
        height: 0,
        width: 0
    };
    var docElem = doc && doc.documentElement; // Make sure it's not a disconnected DOM node
    if (!docElem || !(0, $78634a75aa69345d$export$2e2bcd8739ae039)(docElem, node)) return box;
    if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();
    box = {
        top: box.top + (0, $50754d4a04d03787$export$2e2bcd8739ae039)(docElem) - (docElem.clientTop || 0),
        left: box.left + (0, $954bbff4f39b794f$export$2e2bcd8739ae039)(docElem) - (docElem.clientLeft || 0),
        width: box.width,
        height: box.height
    };
    return box;
}




var $bbf95e09adec8e39$var$isHTMLElement = function isHTMLElement(e) {
    return !!e && 'offsetParent' in e;
};
function $bbf95e09adec8e39$export$2e2bcd8739ae039(node) {
    var doc = (0, $6cbe4b8881f057f1$export$2e2bcd8739ae039)(node);
    var parent = node && node.offsetParent;
    while($bbf95e09adec8e39$var$isHTMLElement(parent) && parent.nodeName !== 'HTML' && (0, $c27166d3adbef964$export$2e2bcd8739ae039)(parent, 'position') === 'static')parent = parent.offsetParent;
    return parent || doc.documentElement;
}




var $1c04ca32884af598$var$nodeName = function nodeName(node) {
    return node.nodeName && node.nodeName.toLowerCase();
};
function $1c04ca32884af598$export$2e2bcd8739ae039(node, offsetParent) {
    var parentOffset = {
        top: 0,
        left: 0
    };
    var offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
    // because it is its only offset parent
    if ((0, $c27166d3adbef964$export$2e2bcd8739ae039)(node, 'position') === 'fixed') offset = node.getBoundingClientRect();
    else {
        var parent = offsetParent || (0, $bbf95e09adec8e39$export$2e2bcd8739ae039)(node);
        offset = (0, $2f02d0066d00e531$export$2e2bcd8739ae039)(node);
        if ($1c04ca32884af598$var$nodeName(parent) !== 'html') parentOffset = (0, $2f02d0066d00e531$export$2e2bcd8739ae039)(parent);
        var borderTop = String((0, $c27166d3adbef964$export$2e2bcd8739ae039)(parent, 'borderTopWidth') || 0);
        parentOffset.top += parseInt(borderTop, 10) - (0, $50754d4a04d03787$export$2e2bcd8739ae039)(parent) || 0;
        var borderLeft = String((0, $c27166d3adbef964$export$2e2bcd8739ae039)(parent, 'borderLeftWidth') || 0);
        parentOffset.left += parseInt(borderLeft, 10) - (0, $954bbff4f39b794f$export$2e2bcd8739ae039)(parent) || 0;
    }
    var marginTop = String((0, $c27166d3adbef964$export$2e2bcd8739ae039)(node, 'marginTop') || 0);
    var marginLeft = String((0, $c27166d3adbef964$export$2e2bcd8739ae039)(node, 'marginLeft') || 0); // Subtract parent offsets and node margins
    return (0, $if2ZQ.default)({}, offset, {
        top: offset.top - parentOffset.top - (parseInt(marginTop, 10) || 0),
        left: offset.left - parentOffset.left - (parseInt(marginLeft, 10) || 0)
    });
}


var $439157458583ebf2$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


/* https://github.com/component/raf */ var $3f65a5846d5d2f64$var$prev = new Date().getTime();
function $3f65a5846d5d2f64$var$fallback(fn) {
    var curr = new Date().getTime();
    var ms = Math.max(0, 16 - (curr - $3f65a5846d5d2f64$var$prev));
    var handle = setTimeout(fn, ms);
    $3f65a5846d5d2f64$var$prev = curr;
    return handle;
}
var $3f65a5846d5d2f64$var$vendors = [
    '',
    'webkit',
    'moz',
    'o',
    'ms'
];
var $3f65a5846d5d2f64$var$cancelMethod = 'clearTimeout';
var $3f65a5846d5d2f64$var$rafImpl = $3f65a5846d5d2f64$var$fallback; // eslint-disable-next-line import/no-mutable-exports
var $3f65a5846d5d2f64$var$getKey = function getKey(vendor, k) {
    return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + "AnimationFrame";
};
if (0, $439157458583ebf2$export$2e2bcd8739ae039) $3f65a5846d5d2f64$var$vendors.some(function(vendor) {
    var rafMethod = $3f65a5846d5d2f64$var$getKey(vendor, 'request');
    if (rafMethod in window) {
        $3f65a5846d5d2f64$var$cancelMethod = $3f65a5846d5d2f64$var$getKey(vendor, 'cancel'); // @ts-ignore
        $3f65a5846d5d2f64$var$rafImpl = function rafImpl(cb) {
            return window[rafMethod](cb);
        };
    }
    return !!$3f65a5846d5d2f64$var$rafImpl;
});
var $3f65a5846d5d2f64$export$70b61ad426ddbe54 = function cancel(id) {
    // @ts-ignore
    if (typeof window[$3f65a5846d5d2f64$var$cancelMethod] === 'function') window[$3f65a5846d5d2f64$var$cancelMethod](id);
};
var $3f65a5846d5d2f64$export$b5fe3f66a567bec0 = $3f65a5846d5d2f64$var$rafImpl;



var $if2ZQ = parcelRequire("if2ZQ");

var $2UY5J = parcelRequire("2UY5J");

var $awzbB = parcelRequire("awzbB");

var $gRqVZ = parcelRequire("gRqVZ");

var $hYKvr = parcelRequire("hYKvr");

var $gRqVZ = parcelRequire("gRqVZ");
function $3eb326945b96d4db$export$2e2bcd8739ae039() {
    return (0, $gRqVZ.useState)(null);
}



var $gRqVZ = parcelRequire("gRqVZ");
const $8a041e504c3129e9$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $8a041e504c3129e9$export$c9058316764c140e(refA, refB) {
    const a = $8a041e504c3129e9$var$toFnRef(refA);
    const b = $8a041e504c3129e9$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $8a041e504c3129e9$var$useMergedRefs(refA, refB) {
    return (0, $gRqVZ.useMemo)(()=>$8a041e504c3129e9$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $8a041e504c3129e9$export$2e2bcd8739ae039 = $8a041e504c3129e9$var$useMergedRefs;


var $e2e461894f6a3983$export$1e95b668f3b82d = 'top';
var $e2e461894f6a3983$export$40e543e69a8b3fbb = 'bottom';
var $e2e461894f6a3983$export$79ffe56a765070d2 = 'right';
var $e2e461894f6a3983$export$eabcd2c8791e7bf4 = 'left';
var $e2e461894f6a3983$export$dfb5619354ba860 = 'auto';
var $e2e461894f6a3983$export$aec2ce47c367b8c3 = [
    $e2e461894f6a3983$export$1e95b668f3b82d,
    $e2e461894f6a3983$export$40e543e69a8b3fbb,
    $e2e461894f6a3983$export$79ffe56a765070d2,
    $e2e461894f6a3983$export$eabcd2c8791e7bf4
];
var $e2e461894f6a3983$export$b3571188c770cc5a = 'start';
var $e2e461894f6a3983$export$bd5df0f255a350f8 = 'end';
var $e2e461894f6a3983$export$390fd549c5303b4d = 'clippingParents';
var $e2e461894f6a3983$export$d7b7311ec04a3e8f = 'viewport';
var $e2e461894f6a3983$export$ae5ab1c730825774 = 'popper';
var $e2e461894f6a3983$export$ca50aac9f3ba507f = 'reference';
var $e2e461894f6a3983$export$368f9a87e87fa4e1 = /*#__PURE__*/ $e2e461894f6a3983$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $e2e461894f6a3983$export$b3571188c770cc5a,
        placement + "-" + $e2e461894f6a3983$export$bd5df0f255a350f8
    ]);
}, []);
var $e2e461894f6a3983$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($e2e461894f6a3983$export$aec2ce47c367b8c3, [
    $e2e461894f6a3983$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $e2e461894f6a3983$export$b3571188c770cc5a,
        placement + "-" + $e2e461894f6a3983$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $e2e461894f6a3983$export$421679a7c3d56e = 'beforeRead';
var $e2e461894f6a3983$export$aafa59e2e03f2942 = 'read';
var $e2e461894f6a3983$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $e2e461894f6a3983$export$c65e99957a05207c = 'beforeMain';
var $e2e461894f6a3983$export$f22da7240b7add18 = 'main';
var $e2e461894f6a3983$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $e2e461894f6a3983$export$8d4d2d70e7d46032 = 'beforeWrite';
var $e2e461894f6a3983$export$68d8715fc104d294 = 'write';
var $e2e461894f6a3983$export$70a6e5159acce2e6 = 'afterWrite';
var $e2e461894f6a3983$export$d087d3878fdf71d5 = [
    $e2e461894f6a3983$export$421679a7c3d56e,
    $e2e461894f6a3983$export$aafa59e2e03f2942,
    $e2e461894f6a3983$export$6964f6c886723980,
    $e2e461894f6a3983$export$c65e99957a05207c,
    $e2e461894f6a3983$export$f22da7240b7add18,
    $e2e461894f6a3983$export$bab79516f2d662fe,
    $e2e461894f6a3983$export$8d4d2d70e7d46032,
    $e2e461894f6a3983$export$68d8715fc104d294,
    $e2e461894f6a3983$export$70a6e5159acce2e6
];



var $if2ZQ = parcelRequire("if2ZQ");

var $2UY5J = parcelRequire("2UY5J");

var $gRqVZ = parcelRequire("gRqVZ");

var $gRqVZ = parcelRequire("gRqVZ");

var $gRqVZ = parcelRequire("gRqVZ");
function $ecf87262d46f0f99$export$2e2bcd8739ae039() {
    const mounted = (0, $gRqVZ.useRef)(true);
    const isMounted = (0, $gRqVZ.useRef)(()=>mounted.current);
    (0, $gRqVZ.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}


/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $931f97c845b6f93f$var$useSafeState(state) {
    const isMounted = (0, $ecf87262d46f0f99$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $gRqVZ.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $931f97c845b6f93f$export$2e2bcd8739ae039 = $931f97c845b6f93f$var$useSafeState;



function $0d086fd98b2397aa$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $fdd42445174d1b7b$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $533c3c521a5e892b$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $fdd42445174d1b7b$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $533c3c521a5e892b$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $fdd42445174d1b7b$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $533c3c521a5e892b$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $fdd42445174d1b7b$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $03b636ac1c3a9c52$export$8960430cfd85939f = Math.max;
var $03b636ac1c3a9c52$export$96ec731ed4dcb222 = Math.min;
var $03b636ac1c3a9c52$export$2077e0241d6afd3c = Math.round;



function $b3ff03caadc48982$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $568306a20c2144a4$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $b3ff03caadc48982$export$2e2bcd8739ae039)());
}


function $f7ad695310ceb4e5$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $533c3c521a5e892b$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $03b636ac1c3a9c52$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $03b636ac1c3a9c52$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $533c3c521a5e892b$export$45a5e7f76e0caa8d)(element) ? (0, $fdd42445174d1b7b$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $568306a20c2144a4$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $2b3cf9db35961eb1$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $f7ad695310ceb4e5$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $1ffa6209398fb5b3$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $533c3c521a5e892b$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $d458a7f0df00cfc4$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}



function $1abb7ef3ea1532fa$export$2e2bcd8739ae039(element) {
    return (0, $fdd42445174d1b7b$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $7b66eee274ff3084$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $d458a7f0df00cfc4$export$2e2bcd8739ae039)(element)) >= 0;
}




function $3315ab8edad09a61$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $533c3c521a5e892b$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $39342b2c15c9120f$export$2e2bcd8739ae039(element) {
    if ((0, $d458a7f0df00cfc4$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $533c3c521a5e892b$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $3315ab8edad09a61$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $70d37240e76d32d7$var$getTrueOffsetParent(element) {
    if (!(0, $533c3c521a5e892b$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $1abb7ef3ea1532fa$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $70d37240e76d32d7$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $b3ff03caadc48982$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $b3ff03caadc48982$export$2e2bcd8739ae039)());
    if (isIE && (0, $533c3c521a5e892b$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $1abb7ef3ea1532fa$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $39342b2c15c9120f$export$2e2bcd8739ae039)(element);
    if ((0, $533c3c521a5e892b$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $533c3c521a5e892b$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $d458a7f0df00cfc4$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $1abb7ef3ea1532fa$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $70d37240e76d32d7$export$2e2bcd8739ae039(element) {
    var window = (0, $fdd42445174d1b7b$export$2e2bcd8739ae039)(element);
    var offsetParent = $70d37240e76d32d7$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $7b66eee274ff3084$export$2e2bcd8739ae039)(offsetParent) && (0, $1abb7ef3ea1532fa$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $70d37240e76d32d7$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $d458a7f0df00cfc4$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $d458a7f0df00cfc4$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $1abb7ef3ea1532fa$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $70d37240e76d32d7$var$getContainingBlock(element) || window;
}


function $3ea0940023679cf4$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $876226d6970e7849$export$f28d906d67a997f3(min, value, max) {
    return (0, $03b636ac1c3a9c52$export$8960430cfd85939f)(min, (0, $03b636ac1c3a9c52$export$96ec731ed4dcb222)(value, max));
}
function $876226d6970e7849$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $876226d6970e7849$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $7f1d2c4d479f3478$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $f024aaee1f4e90e5$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $7f1d2c4d479f3478$export$2e2bcd8739ae039)(), paddingObject);
}


function $c2aa91e30902e84c$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $0da542b8f5c95870$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $f024aaee1f4e90e5$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c2aa91e30902e84c$export$2e2bcd8739ae039)(padding, (0, $e2e461894f6a3983$export$aec2ce47c367b8c3)));
};
function $0da542b8f5c95870$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $0d086fd98b2397aa$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $3ea0940023679cf4$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $e2e461894f6a3983$export$eabcd2c8791e7bf4),
        (0, $e2e461894f6a3983$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $0da542b8f5c95870$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $2b3cf9db35961eb1$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $e2e461894f6a3983$export$1e95b668f3b82d) : (0, $e2e461894f6a3983$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $e2e461894f6a3983$export$40e543e69a8b3fbb) : (0, $e2e461894f6a3983$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $70d37240e76d32d7$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $876226d6970e7849$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $0da542b8f5c95870$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $1ffa6209398fb5b3$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $0da542b8f5c95870$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $0da542b8f5c95870$var$arrow,
    effect: $0da542b8f5c95870$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $4389214fc47476b5$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $8a9319a178906689$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $8a9319a178906689$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $03b636ac1c3a9c52$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $03b636ac1c3a9c52$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $8a9319a178906689$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $e2e461894f6a3983$export$eabcd2c8791e7bf4);
    var sideY = (0, $e2e461894f6a3983$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $70d37240e76d32d7$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $fdd42445174d1b7b$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $3315ab8edad09a61$export$2e2bcd8739ae039)(popper);
            if ((0, $1abb7ef3ea1532fa$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $e2e461894f6a3983$export$1e95b668f3b82d) || (placement === (0, $e2e461894f6a3983$export$eabcd2c8791e7bf4) || placement === (0, $e2e461894f6a3983$export$79ffe56a765070d2)) && variation === (0, $e2e461894f6a3983$export$bd5df0f255a350f8)) {
            sideY = (0, $e2e461894f6a3983$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $e2e461894f6a3983$export$eabcd2c8791e7bf4) || (placement === (0, $e2e461894f6a3983$export$1e95b668f3b82d) || placement === (0, $e2e461894f6a3983$export$40e543e69a8b3fbb)) && variation === (0, $e2e461894f6a3983$export$bd5df0f255a350f8)) {
            sideX = (0, $e2e461894f6a3983$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $8a9319a178906689$var$unsetSides);
    var _ref4 = roundOffsets === true ? $8a9319a178906689$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $fdd42445174d1b7b$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $8a9319a178906689$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $0d086fd98b2397aa$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $4389214fc47476b5$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $8a9319a178906689$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $8a9319a178906689$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8a9319a178906689$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $8a9319a178906689$var$computeStyles,
    data: {}
};



var $d00e7ed7d4c98ce9$var$passive = {
    passive: true
};
function $d00e7ed7d4c98ce9$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $fdd42445174d1b7b$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $d00e7ed7d4c98ce9$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $d00e7ed7d4c98ce9$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $d00e7ed7d4c98ce9$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $d00e7ed7d4c98ce9$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $d00e7ed7d4c98ce9$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $d00e7ed7d4c98ce9$var$effect,
    data: {}
};


var $be957293b6bcb735$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $be957293b6bcb735$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $be957293b6bcb735$var$hash[matched];
    });
}



var $f2b4771a5d86e561$var$hash = {
    start: 'end',
    end: 'start'
};
function $f2b4771a5d86e561$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $f2b4771a5d86e561$var$hash[matched];
    });
}








function $c2120d79d03770ef$export$2e2bcd8739ae039(node) {
    var win = (0, $fdd42445174d1b7b$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $fc99a070542a1878$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $f7ad695310ceb4e5$export$2e2bcd8739ae039)((0, $3315ab8edad09a61$export$2e2bcd8739ae039)(element)).left + (0, $c2120d79d03770ef$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $b85ae0c5a01122f7$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $fdd42445174d1b7b$export$2e2bcd8739ae039)(element);
    var html = (0, $3315ab8edad09a61$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $568306a20c2144a4$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $fc99a070542a1878$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $2459f736a2284a5a$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $3315ab8edad09a61$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $c2120d79d03770ef$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $03b636ac1c3a9c52$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $03b636ac1c3a9c52$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $fc99a070542a1878$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $1abb7ef3ea1532fa$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $03b636ac1c3a9c52$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $e57fcc18a0b2eab3$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $1abb7ef3ea1532fa$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $b83944a9e3e73ca2$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $d458a7f0df00cfc4$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $533c3c521a5e892b$export$1b3bfaa9684536aa)(node) && (0, $e57fcc18a0b2eab3$export$2e2bcd8739ae039)(node)) return node;
    return $b83944a9e3e73ca2$export$2e2bcd8739ae039((0, $39342b2c15c9120f$export$2e2bcd8739ae039)(node));
}





function $5b0399aa378efe24$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $b83944a9e3e73ca2$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $fdd42445174d1b7b$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $e57fcc18a0b2eab3$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($5b0399aa378efe24$export$2e2bcd8739ae039((0, $39342b2c15c9120f$export$2e2bcd8739ae039)(target)));
}










function $e106ef718b72b2aa$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $dd4981c2f1be3c74$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $f7ad695310ceb4e5$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $dd4981c2f1be3c74$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $e2e461894f6a3983$export$d7b7311ec04a3e8f) ? (0, $e106ef718b72b2aa$export$2e2bcd8739ae039)((0, $b85ae0c5a01122f7$export$2e2bcd8739ae039)(element, strategy)) : (0, $533c3c521a5e892b$export$45a5e7f76e0caa8d)(clippingParent) ? $dd4981c2f1be3c74$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $e106ef718b72b2aa$export$2e2bcd8739ae039)((0, $2459f736a2284a5a$export$2e2bcd8739ae039)((0, $3315ab8edad09a61$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $dd4981c2f1be3c74$var$getClippingParents(element) {
    var clippingParents = (0, $5b0399aa378efe24$export$2e2bcd8739ae039)((0, $39342b2c15c9120f$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $1abb7ef3ea1532fa$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $533c3c521a5e892b$export$1b3bfaa9684536aa)(element) ? (0, $70d37240e76d32d7$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $533c3c521a5e892b$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $533c3c521a5e892b$export$45a5e7f76e0caa8d)(clippingParent) && (0, $1ffa6209398fb5b3$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $d458a7f0df00cfc4$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $dd4981c2f1be3c74$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $dd4981c2f1be3c74$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $dd4981c2f1be3c74$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $03b636ac1c3a9c52$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $03b636ac1c3a9c52$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $03b636ac1c3a9c52$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $03b636ac1c3a9c52$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $dd4981c2f1be3c74$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $0580ff3337ca968e$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $0d086fd98b2397aa$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $4389214fc47476b5$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $e2e461894f6a3983$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $e2e461894f6a3983$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $e2e461894f6a3983$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $e2e461894f6a3983$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $3ea0940023679cf4$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $e2e461894f6a3983$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $e2e461894f6a3983$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $693a09f3451ba1f9$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $e2e461894f6a3983$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $e2e461894f6a3983$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $e2e461894f6a3983$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $f024aaee1f4e90e5$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c2aa91e30902e84c$export$2e2bcd8739ae039)(padding, (0, $e2e461894f6a3983$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $e2e461894f6a3983$export$ae5ab1c730825774) ? (0, $e2e461894f6a3983$export$ca50aac9f3ba507f) : (0, $e2e461894f6a3983$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $dd4981c2f1be3c74$export$2e2bcd8739ae039)((0, $533c3c521a5e892b$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $3315ab8edad09a61$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $f7ad695310ceb4e5$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $0580ff3337ca968e$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $e106ef718b72b2aa$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $e2e461894f6a3983$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $e2e461894f6a3983$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $e2e461894f6a3983$export$79ffe56a765070d2),
                (0, $e2e461894f6a3983$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $e2e461894f6a3983$export$1e95b668f3b82d),
                (0, $e2e461894f6a3983$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $adab89ba8cb36a83$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $e2e461894f6a3983$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $4389214fc47476b5$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $e2e461894f6a3983$export$368f9a87e87fa4e1) : (0, $e2e461894f6a3983$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $4389214fc47476b5$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $e2e461894f6a3983$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $693a09f3451ba1f9$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $0d086fd98b2397aa$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $6cd0a2479a56d434$var$getExpandedFallbackPlacements(placement) {
    if ((0, $0d086fd98b2397aa$export$2e2bcd8739ae039)(placement) === (0, $e2e461894f6a3983$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $be957293b6bcb735$export$2e2bcd8739ae039)(placement);
    return [
        (0, $f2b4771a5d86e561$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $f2b4771a5d86e561$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $6cd0a2479a56d434$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $0d086fd98b2397aa$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $be957293b6bcb735$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $6cd0a2479a56d434$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $0d086fd98b2397aa$export$2e2bcd8739ae039)(placement) === (0, $e2e461894f6a3983$export$dfb5619354ba860) ? (0, $adab89ba8cb36a83$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $0d086fd98b2397aa$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $4389214fc47476b5$export$2e2bcd8739ae039)(placement) === (0, $e2e461894f6a3983$export$b3571188c770cc5a);
        var isVertical = [
            (0, $e2e461894f6a3983$export$1e95b668f3b82d),
            (0, $e2e461894f6a3983$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $693a09f3451ba1f9$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $e2e461894f6a3983$export$79ffe56a765070d2) : (0, $e2e461894f6a3983$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $e2e461894f6a3983$export$40e543e69a8b3fbb) : (0, $e2e461894f6a3983$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $be957293b6bcb735$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $be957293b6bcb735$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $6cd0a2479a56d434$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $6cd0a2479a56d434$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $3904d17c6e05ffba$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $3904d17c6e05ffba$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $e2e461894f6a3983$export$1e95b668f3b82d),
        (0, $e2e461894f6a3983$export$79ffe56a765070d2),
        (0, $e2e461894f6a3983$export$40e543e69a8b3fbb),
        (0, $e2e461894f6a3983$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $3904d17c6e05ffba$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $693a09f3451ba1f9$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $693a09f3451ba1f9$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $3904d17c6e05ffba$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $3904d17c6e05ffba$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $3904d17c6e05ffba$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $3904d17c6e05ffba$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $3904d17c6e05ffba$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $3904d17c6e05ffba$var$hide
};




function $b4a59a9e7b6a07c7$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $0d086fd98b2397aa$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $e2e461894f6a3983$export$eabcd2c8791e7bf4),
        (0, $e2e461894f6a3983$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $e2e461894f6a3983$export$eabcd2c8791e7bf4),
        (0, $e2e461894f6a3983$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $b4a59a9e7b6a07c7$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $e2e461894f6a3983$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $b4a59a9e7b6a07c7$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $b4a59a9e7b6a07c7$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $b4a59a9e7b6a07c7$var$offset
};



function $f136495194fce87f$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $0580ff3337ca968e$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $f136495194fce87f$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $f136495194fce87f$var$popperOffsets,
    data: {}
};





function $03c01e5f35cd33d4$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $1bd836b86daf5b56$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $693a09f3451ba1f9$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $0d086fd98b2397aa$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $4389214fc47476b5$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $3ea0940023679cf4$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $03c01e5f35cd33d4$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $e2e461894f6a3983$export$1e95b668f3b82d) : (0, $e2e461894f6a3983$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $e2e461894f6a3983$export$40e543e69a8b3fbb) : (0, $e2e461894f6a3983$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $e2e461894f6a3983$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $e2e461894f6a3983$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $2b3cf9db35961eb1$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $7f1d2c4d479f3478$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $876226d6970e7849$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $70d37240e76d32d7$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $876226d6970e7849$export$f28d906d67a997f3)(tether ? (0, $03b636ac1c3a9c52$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $03b636ac1c3a9c52$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $e2e461894f6a3983$export$1e95b668f3b82d) : (0, $e2e461894f6a3983$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $e2e461894f6a3983$export$40e543e69a8b3fbb) : (0, $e2e461894f6a3983$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $e2e461894f6a3983$export$1e95b668f3b82d),
            (0, $e2e461894f6a3983$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $876226d6970e7849$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $876226d6970e7849$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $1bd836b86daf5b56$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $1bd836b86daf5b56$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};







function $444f198f72ed6924$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $8b37ffd55042778a$export$2e2bcd8739ae039(node) {
    if (node === (0, $fdd42445174d1b7b$export$2e2bcd8739ae039)(node) || !(0, $533c3c521a5e892b$export$1b3bfaa9684536aa)(node)) return (0, $c2120d79d03770ef$export$2e2bcd8739ae039)(node);
    else return (0, $444f198f72ed6924$export$2e2bcd8739ae039)(node);
}








function $62a5e694da75dc59$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $03b636ac1c3a9c52$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $03b636ac1c3a9c52$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $62a5e694da75dc59$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $533c3c521a5e892b$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $533c3c521a5e892b$export$1b3bfaa9684536aa)(offsetParent) && $62a5e694da75dc59$var$isElementScaled(offsetParent);
    var documentElement = (0, $3315ab8edad09a61$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $f7ad695310ceb4e5$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $d458a7f0df00cfc4$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $e57fcc18a0b2eab3$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $8b37ffd55042778a$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $533c3c521a5e892b$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $f7ad695310ceb4e5$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $fc99a070542a1878$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $9232340fbc374720$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $9232340fbc374720$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $9232340fbc374720$var$order(modifiers); // order based on phase
    return (0, $e2e461894f6a3983$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $1cb7a85d7861c72b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $fe38652a902153c7$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $840a3b65c6e9a7e7$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $840a3b65c6e9a7e7$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $840a3b65c6e9a7e7$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $840a3b65c6e9a7e7$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $840a3b65c6e9a7e7$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $533c3c521a5e892b$export$45a5e7f76e0caa8d)(reference) ? (0, $5b0399aa378efe24$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $5b0399aa378efe24$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $5b0399aa378efe24$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $9232340fbc374720$export$2e2bcd8739ae039)((0, $fe38652a902153c7$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$840a3b65c6e9a7e7$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $62a5e694da75dc59$export$2e2bcd8739ae039)(reference, (0, $70d37240e76d32d7$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $2b3cf9db35961eb1$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $1cb7a85d7861c72b$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$840a3b65c6e9a7e7$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $840a3b65c6e9a7e7$export$8f7491d57c8f97a9 = /*#__PURE__*/ $840a3b65c6e9a7e7$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


var $24f0e885861829ae$export$8f7491d57c8f97a9 = (0, $840a3b65c6e9a7e7$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $3904d17c6e05ffba$export$2e2bcd8739ae039),
        (0, $f136495194fce87f$export$2e2bcd8739ae039),
        (0, $8a9319a178906689$export$2e2bcd8739ae039),
        (0, $d00e7ed7d4c98ce9$export$2e2bcd8739ae039),
        (0, $b4a59a9e7b6a07c7$export$2e2bcd8739ae039),
        (0, $6cd0a2479a56d434$export$2e2bcd8739ae039),
        (0, $1bd836b86daf5b56$export$2e2bcd8739ae039),
        (0, $0da542b8f5c95870$export$2e2bcd8739ae039)
    ]
});


var $50d96e5f73e679a0$var$initialPopperStyles = function initialPopperStyles(position) {
    return {
        position: position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
};
var $50d96e5f73e679a0$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false
}; // In order to satisfy the current usage of options, including undefined
var $50d96e5f73e679a0$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: function effect(_ref) {
        var state = _ref.state;
        return function() {
            var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper;
            if ('removeAttribute' in reference) {
                var ids = (reference.getAttribute('aria-describedby') || '').split(',').filter(function(id) {
                    return id.trim() !== popper.id;
                });
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        };
    },
    fn: function fn(_ref2) {
        var _popper$getAttribute;
        var state = _ref2.state;
        var _state$elements2 = state.elements, popper = _state$elements2.popper, reference = _state$elements2.reference;
        var role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            var ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? ids + "," + popper.id : popper.id);
        }
    }
};
var $50d96e5f73e679a0$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {boolean=}    options.eventsEnabled have Popper listen on window resize events to reposition the element
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $50d96e5f73e679a0$var$usePopper(referenceElement, popperElement, _temp) {
    var _ref3 = _temp === void 0 ? {} : _temp, _ref3$enabled = _ref3.enabled, enabled = _ref3$enabled === void 0 ? true : _ref3$enabled, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? 'bottom' : _ref3$placement, _ref3$strategy = _ref3.strategy, strategy = _ref3$strategy === void 0 ? 'absolute' : _ref3$strategy, _ref3$modifiers = _ref3.modifiers, modifiers = _ref3$modifiers === void 0 ? $50d96e5f73e679a0$var$EMPTY_MODIFIERS : _ref3$modifiers, config = (0, $2UY5J.default)(_ref3, [
        "enabled",
        "placement",
        "strategy",
        "modifiers"
    ]);
    var popperInstanceRef = (0, $gRqVZ.useRef)();
    var update = (0, $gRqVZ.useCallback)(function() {
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    var forceUpdate = (0, $gRqVZ.useCallback)(function() {
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    var _useSafeState = (0, $931f97c845b6f93f$export$2e2bcd8739ae039)((0, $gRqVZ.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: $50d96e5f73e679a0$var$initialPopperStyles(strategy),
            arrow: {}
        }
    })), popperState = _useSafeState[0], setState = _useSafeState[1];
    var updateModifier = (0, $gRqVZ.useMemo)(function() {
        return {
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref4) {
                var state = _ref4.state;
                var styles = {};
                var attributes = {};
                Object.keys(state.elements).forEach(function(element) {
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        };
    }, [
        update,
        forceUpdate,
        setState
    ]);
    (0, $gRqVZ.useEffect)(function() {
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [].concat(modifiers, [
                updateModifier,
                $50d96e5f73e679a0$var$disabledApplyStylesModifier
            ])
        }); // intentionally NOT re-running on new modifiers
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        strategy,
        placement,
        updateModifier,
        enabled
    ]);
    (0, $gRqVZ.useEffect)(function() {
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $24f0e885861829ae$export$8f7491d57c8f97a9)(referenceElement, popperElement, (0, $if2ZQ.default)({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [].concat(modifiers, [
                $50d96e5f73e679a0$var$ariaDescribedByModifier,
                updateModifier
            ])
        }));
        return function() {
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState(function(s) {
                    return (0, $if2ZQ.default)({}, s, {
                        attributes: {},
                        styles: {
                            popper: $50d96e5f73e679a0$var$initialPopperStyles(strategy)
                        }
                    });
                });
            }
        }; // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $50d96e5f73e679a0$export$2e2bcd8739ae039 = $50d96e5f73e679a0$var$usePopper;



/* eslint-disable no-return-assign */ 
var $d90c39900fa7fb82$export$63fefd044b2bc624 = false;
var $d90c39900fa7fb82$export$a614c6b395900f69 = false;
try {
    var $d90c39900fa7fb82$var$options = {
        get passive () {
            return $d90c39900fa7fb82$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $d90c39900fa7fb82$export$a614c6b395900f69 = $d90c39900fa7fb82$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $439157458583ebf2$export$2e2bcd8739ae039) {
        window.addEventListener('test', $d90c39900fa7fb82$var$options, $d90c39900fa7fb82$var$options);
        window.removeEventListener('test', $d90c39900fa7fb82$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $d90c39900fa7fb82$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$d90c39900fa7fb82$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$d90c39900fa7fb82$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $d90c39900fa7fb82$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $d90c39900fa7fb82$export$2e2bcd8739ae039 = $d90c39900fa7fb82$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $ae75b4bb5922f712$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $ae75b4bb5922f712$export$2e2bcd8739ae039 = $ae75b4bb5922f712$var$removeEventListener;


function $a58a5ebbc7740204$var$listen(node, eventName, handler, options) {
    (0, $d90c39900fa7fb82$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $ae75b4bb5922f712$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $a58a5ebbc7740204$export$2e2bcd8739ae039 = $a58a5ebbc7740204$var$listen;



var $gRqVZ = parcelRequire("gRqVZ");

var $gRqVZ = parcelRequire("gRqVZ");

var $gRqVZ = parcelRequire("gRqVZ");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $ed3262a07322d193$var$useCommittedRef(value) {
    const ref = (0, $gRqVZ.useRef)(value);
    (0, $gRqVZ.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $ed3262a07322d193$export$2e2bcd8739ae039 = $ed3262a07322d193$var$useCommittedRef;


function $31bf63707f81e806$export$2e2bcd8739ae039(fn) {
    const ref = (0, $ed3262a07322d193$export$2e2bcd8739ae039)(fn);
    return (0, $gRqVZ.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}


var $f1caac85b571eaa5$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $f1caac85b571eaa5$var$__DEV__ = false;
var $f1caac85b571eaa5$var$warning = function() {};
if ($f1caac85b571eaa5$var$__DEV__) {
    var $f1caac85b571eaa5$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $f1caac85b571eaa5$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $f1caac85b571eaa5$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$f1caac85b571eaa5$exports = $f1caac85b571eaa5$var$warning;




var $hYKvr = parcelRequire("hYKvr");
function $d7dfc91d2dc6fa27$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($hYKvr))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}


var $1644061f452f6ead$export$2e2bcd8739ae039 = function(componentOrElement) {
    return (0, $6cbe4b8881f057f1$export$2e2bcd8739ae039)((0, $d7dfc91d2dc6fa27$export$2e2bcd8739ae039)(componentOrElement));
};


var $7a5e221fbb20b039$var$escapeKeyCode = 27;
var $7a5e221fbb20b039$var$noop = function noop() {};
function $7a5e221fbb20b039$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $7a5e221fbb20b039$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $7a5e221fbb20b039$var$getRefTarget = function getRefTarget(ref) {
    return ref && ('current' in ref ? ref.current : ref);
};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $7a5e221fbb20b039$var$useRootClose(ref, onRootClose, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, disabled = _ref.disabled, _ref$clickTrigger = _ref.clickTrigger, clickTrigger = _ref$clickTrigger === void 0 ? 'click' : _ref$clickTrigger;
    var preventMouseRootCloseRef = (0, $gRqVZ.useRef)(false);
    var onClose = onRootClose || $7a5e221fbb20b039$var$noop;
    var handleMouseCapture = (0, $gRqVZ.useCallback)(function(e) {
        var _e$composedPath$;
        var currentTarget = $7a5e221fbb20b039$var$getRefTarget(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($f1caac85b571eaa5$exports)))(!!currentTarget, "RootClose captured a close event but does not have a ref to compare it to. useRootClose(), should be passed a ref that resolves to a DOM node");
        preventMouseRootCloseRef.current = !currentTarget || $7a5e221fbb20b039$var$isModifiedEvent(e) || !$7a5e221fbb20b039$var$isLeftClickEvent(e) || !!(0, $78634a75aa69345d$export$2e2bcd8739ae039)(currentTarget, (_e$composedPath$ = e.composedPath == null ? void 0 : e.composedPath()[0]) != null ? _e$composedPath$ : e.target);
    }, [
        ref
    ]);
    var handleMouse = (0, $31bf63707f81e806$export$2e2bcd8739ae039)(function(e) {
        if (!preventMouseRootCloseRef.current) onClose(e);
    });
    var handleKeyUp = (0, $31bf63707f81e806$export$2e2bcd8739ae039)(function(e) {
        if (e.keyCode === $7a5e221fbb20b039$var$escapeKeyCode) onClose(e);
    });
    (0, $gRqVZ.useEffect)(function() {
        if (disabled || ref == null) return undefined; // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        var currentEvent = window.event;
        var doc = (0, $1644061f452f6ead$export$2e2bcd8739ae039)($7a5e221fbb20b039$var$getRefTarget(ref)); // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        var removeMouseCaptureListener = (0, $a58a5ebbc7740204$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        var removeMouseListener = (0, $a58a5ebbc7740204$export$2e2bcd8739ae039)(doc, clickTrigger, function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        var removeKeyupListener = (0, $a58a5ebbc7740204$export$2e2bcd8739ae039)(doc, 'keyup', function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        var mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map(function(el) {
            return (0, $a58a5ebbc7740204$export$2e2bcd8739ae039)(el, 'mousemove', $7a5e221fbb20b039$var$noop);
        });
        return function() {
            removeMouseCaptureListener();
            removeMouseListener();
            removeKeyupListener();
            mobileSafariHackListeners.forEach(function(remove) {
                return remove();
            });
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleMouse,
        handleKeyUp
    ]);
}
var $7a5e221fbb20b039$export$2e2bcd8739ae039 = $7a5e221fbb20b039$var$useRootClose;




var $gRqVZ = parcelRequire("gRqVZ");
var $fb1aaae4221ca855$export$c91fd81e6d65f84a = function resolveContainerRef(ref) {
    var _ref;
    if (typeof document === 'undefined') return null;
    if (ref == null) return (0, $6cbe4b8881f057f1$export$2e2bcd8739ae039)().body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if ((_ref = ref) != null && _ref.nodeType) return ref || null;
    return null;
};
function $fb1aaae4221ca855$export$2e2bcd8739ae039(ref, onResolved) {
    var _useState = (0, $gRqVZ.useState)(function() {
        return $fb1aaae4221ca855$export$c91fd81e6d65f84a(ref);
    }), resolvedRef = _useState[0], setRef = _useState[1];
    if (!resolvedRef) {
        var earlyRef = $fb1aaae4221ca855$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $gRqVZ.useEffect)(function() {
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $gRqVZ.useEffect)(function() {
        var nextRef = $fb1aaae4221ca855$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}



var $if2ZQ = parcelRequire("if2ZQ");
function $74f79564d7fce88a$export$ba6dad097c8f5c38(modifiers) {
    var result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
     // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach(function(m) {
        result[m.name] = m;
    });
    return result;
}
function $74f79564d7fce88a$export$af3a999d4a134c86(map) {
    if (map === void 0) map = {};
    if (Array.isArray(map)) return map;
    return Object.keys(map).map(function(k) {
        map[k].name = k;
        return map[k];
    });
}
function $74f79564d7fce88a$export$2e2bcd8739ae039(_ref) {
    var _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    var enabled = _ref.enabled, enableEvents = _ref.enableEvents, placement = _ref.placement, flip = _ref.flip, offset = _ref.offset, fixed = _ref.fixed, containerPadding = _ref.containerPadding, arrowElement = _ref.arrowElement, _ref$popperConfig = _ref.popperConfig, popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig;
    var modifiers = $74f79564d7fce88a$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return (0, $if2ZQ.default)({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $74f79564d7fce88a$export$af3a999d4a134c86((0, $if2ZQ.default)({}, modifiers, {
            eventListeners: {
                enabled: enableEvents
            },
            preventOverflow: (0, $if2ZQ.default)({}, modifiers.preventOverflow, {
                options: containerPadding ? (0, $if2ZQ.default)({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: (0, $if2ZQ.default)({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: (0, $if2ZQ.default)({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: (0, $if2ZQ.default)({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: (0, $if2ZQ.default)({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}


/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ var $fd6b16e8c359e5db$var$Overlay = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).forwardRef(function(props, outerRef) {
    var flip = props.flip, offset = props.offset, placement = props.placement, _props$containerPaddi = props.containerPadding, containerPadding = _props$containerPaddi === void 0 ? 5 : _props$containerPaddi, _props$popperConfig = props.popperConfig, popperConfig = _props$popperConfig === void 0 ? {} : _props$popperConfig, Transition = props.transition;
    var _useCallbackRef = (0, $3eb326945b96d4db$export$2e2bcd8739ae039)(), rootElement = _useCallbackRef[0], attachRef = _useCallbackRef[1];
    var _useCallbackRef2 = (0, $3eb326945b96d4db$export$2e2bcd8739ae039)(), arrowElement = _useCallbackRef2[0], attachArrowRef = _useCallbackRef2[1];
    var mergedRef = (0, $8a041e504c3129e9$export$2e2bcd8739ae039)(attachRef, outerRef);
    var container = (0, $fb1aaae4221ca855$export$2e2bcd8739ae039)(props.container);
    var target = (0, $fb1aaae4221ca855$export$2e2bcd8739ae039)(props.target);
    var _useState = (0, $gRqVZ.useState)(!props.show), exited = _useState[0], setExited = _useState[1];
    var _usePopper = (0, $50d96e5f73e679a0$export$2e2bcd8739ae039)(target, rootElement, (0, $74f79564d7fce88a$export$2e2bcd8739ae039)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    })), styles = _usePopper.styles, attributes = _usePopper.attributes, popper = (0, $2UY5J.default)(_usePopper, [
        "styles",
        "attributes"
    ]);
    if (props.show) {
        if (exited) setExited(false);
    } else if (!props.transition && !exited) setExited(true);
    var handleHidden = function handleHidden() {
        setExited(true);
        if (props.onExited) props.onExited.apply(props, arguments);
    }; // Don't un-render the overlay while it's transitioning out.
    var mountOverlay = props.show || Transition && !exited;
    (0, $7a5e221fbb20b039$export$2e2bcd8739ae039)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    var child = props.children((0, $if2ZQ.default)({}, popper, {
        show: !!props.show,
        props: (0, $if2ZQ.default)({}, attributes.popper, {
            style: styles.popper,
            ref: mergedRef
        }),
        arrowProps: (0, $if2ZQ.default)({}, attributes.arrow, {
            style: styles.arrow,
            ref: attachArrowRef
        })
    }));
    if (Transition) {
        var onExit = props.onExit, onExiting = props.onExiting, onEnter = props.onEnter, onEntering = props.onEntering, onEntered = props.onEntered;
        child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(Transition, {
            "in": props.show,
            appear: true,
            onExit: onExit,
            onExiting: onExiting,
            onExited: handleHidden,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered
        }, child);
    }
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hYKvr))).createPortal(child, container) : null;
});
$fd6b16e8c359e5db$var$Overlay.displayName = 'Overlay';
$fd6b16e8c359e5db$var$Overlay.propTypes = {
    /**
   * Set the visibility of the Overlay
   */ show: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).bool,
    /** Specify where the overlay element is positioned in relation to the target element */ placement: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).oneOf((0, $e2e461894f6a3983$export$803cd8101b6c182b)),
    /**
   * A DOM Element, Ref to an element, or function that returns either. The `target` element is where
   * the overlay is positioned relative to.
   */ target: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).any,
    /**
   * A DOM Element, Ref to an element, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).any,
    /**
   * Enables the Popper.js `flip` modifier, allowing the Overlay to
   * automatically adjust it's placement in case of overlap with the viewport or toggle.
   * Refer to the [flip docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled) for more info
   */ flip: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).bool,
    /**
   * A render prop that returns an element to overlay and position. See
   * the [react-popper documentation](https://github.com/FezVrasta/react-popper#children) for more info.
   *
   * @type {Function ({
   *   show: boolean,
   *   placement: Placement,
   *   update: () => void,
   *   forceUpdate: () => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     aria-labelledby: ?string
   *     [string]: string | number,
   *   },
   *   arrowProps: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     [string]: string | number,
   *   },
   * }) => React.Element}
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func.isRequired,
    /**
   * Control how much space there is between the edge of the boundary element and overlay.
   * A convenience shortcut to setting `popperConfig.modfiers.preventOverflow.padding`
   */ containerPadding: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).number,
    /**
   * A set of popper options and props passed directly to react-popper's Popper component.
   */ popperConfig: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).object,
    /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */ rootClose: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).bool,
    /**
   * Specify event for toggling overlay
   */ rootCloseEvent: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).oneOf([
        'click',
        'mousedown'
    ]),
    /**
   * Specify disabled for disable RootCloseWrapper
   */ rootCloseDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).bool,
    /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */ onHide: function onHide(props) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (props.rootClose) {
            var _PropTypes$func;
            return (_PropTypes$func = (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func).isRequired.apply(_PropTypes$func, [
                props
            ].concat(args));
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func.apply((0, (/*@__PURE__*/$parcel$interopDefault($awzbB))), [
            props
        ].concat(args));
    },
    /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */ // @ts-ignore
    transition: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).elementType,
    /**
   * Callback fired before the Overlay transitions in
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func,
    /**
   * Callback fired as the Overlay begins to transition in
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func,
    /**
   * Callback fired after the Overlay finishes transitioning in
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func,
    /**
   * Callback fired right before the Overlay transitions out
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func,
    /**
   * Callback fired as the Overlay begins to transition out
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func,
    /**
   * Callback fired after the Overlay finishes transitioning out
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func
};
var $fd6b16e8c359e5db$export$2e2bcd8739ae039 = $fd6b16e8c359e5db$var$Overlay;



var $56a939b6be7c5af5$exports = {};
var $2cbc2ceff246b896$exports = {};
var $d52f94816deaa10d$exports = {};
var $79e5feaebbbdc67f$exports = {};
var $26311e37187a9048$exports = {};
var $dc6b7306acfc4926$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $dc6b7306acfc4926$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$dc6b7306acfc4926$exports = $dc6b7306acfc4926$var$listCacheClear;


var $8c78bfc2b2d319c9$exports = {};
var $40ae834ec93b82be$exports = {};

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $40ae834ec93b82be$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($4407ef85bda41b8e$exports(array[length][0], key)) return length;
    }
    return -1;
}
$40ae834ec93b82be$exports = $40ae834ec93b82be$var$assocIndexOf;


/** Used for built-in method references. */ var $8c78bfc2b2d319c9$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $8c78bfc2b2d319c9$var$splice = $8c78bfc2b2d319c9$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8c78bfc2b2d319c9$var$listCacheDelete(key) {
    var data = this.__data__, index = $40ae834ec93b82be$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $8c78bfc2b2d319c9$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$8c78bfc2b2d319c9$exports = $8c78bfc2b2d319c9$var$listCacheDelete;


var $53c5f3b10b294696$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $53c5f3b10b294696$var$listCacheGet(key) {
    var data = this.__data__, index = $40ae834ec93b82be$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$53c5f3b10b294696$exports = $53c5f3b10b294696$var$listCacheGet;


var $6c8d274cf9d90011$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6c8d274cf9d90011$var$listCacheHas(key) {
    return $40ae834ec93b82be$exports(this.__data__, key) > -1;
}
$6c8d274cf9d90011$exports = $6c8d274cf9d90011$var$listCacheHas;


var $94936acb9cf906a7$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $94936acb9cf906a7$var$listCacheSet(key, value) {
    var data = this.__data__, index = $40ae834ec93b82be$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$94936acb9cf906a7$exports = $94936acb9cf906a7$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $26311e37187a9048$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$26311e37187a9048$var$ListCache.prototype.clear = $dc6b7306acfc4926$exports;
$26311e37187a9048$var$ListCache.prototype['delete'] = $8c78bfc2b2d319c9$exports;
$26311e37187a9048$var$ListCache.prototype.get = $53c5f3b10b294696$exports;
$26311e37187a9048$var$ListCache.prototype.has = $6c8d274cf9d90011$exports;
$26311e37187a9048$var$ListCache.prototype.set = $94936acb9cf906a7$exports;
$26311e37187a9048$exports = $26311e37187a9048$var$ListCache;


var $8d6a05714ccff2dc$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $8d6a05714ccff2dc$var$stackClear() {
    this.__data__ = new $26311e37187a9048$exports;
    this.size = 0;
}
$8d6a05714ccff2dc$exports = $8d6a05714ccff2dc$var$stackClear;


var $37c667ead1490042$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $37c667ead1490042$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$37c667ead1490042$exports = $37c667ead1490042$var$stackDelete;


var $5a57fa0c556f55ed$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5a57fa0c556f55ed$var$stackGet(key) {
    return this.__data__.get(key);
}
$5a57fa0c556f55ed$exports = $5a57fa0c556f55ed$var$stackGet;


var $0282b07a178b5702$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0282b07a178b5702$var$stackHas(key) {
    return this.__data__.has(key);
}
$0282b07a178b5702$exports = $0282b07a178b5702$var$stackHas;


var $ae1a95bbcbe8c7cd$exports = {};

var $c1bce9761814e4b0$exports = {};
var $bb172e5f73072340$exports = {};
var $9ea31144a2fc4466$exports = {};

var $7eb89552ee9b1513$exports = {};
var $f27b60461b078292$exports = {};

var $keq6u = parcelRequire("keq6u");
/** Used to detect overreaching core-js shims. */ var $f27b60461b078292$var$coreJsData = $keq6u["__core-js_shared__"];
$f27b60461b078292$exports = $f27b60461b078292$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $7eb89552ee9b1513$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($f27b60461b078292$exports && $f27b60461b078292$exports.keys && $f27b60461b078292$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $7eb89552ee9b1513$var$isMasked(func) {
    return !!$7eb89552ee9b1513$var$maskSrcKey && $7eb89552ee9b1513$var$maskSrcKey in func;
}
$7eb89552ee9b1513$exports = $7eb89552ee9b1513$var$isMasked;



var $51987eebd80c5088$exports = {};
/** Used for built-in method references. */ var $51987eebd80c5088$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $51987eebd80c5088$var$funcToString = $51987eebd80c5088$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $51987eebd80c5088$var$toSource(func) {
    if (func != null) {
        try {
            return $51987eebd80c5088$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$51987eebd80c5088$exports = $51987eebd80c5088$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $9ea31144a2fc4466$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $9ea31144a2fc4466$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $9ea31144a2fc4466$var$funcProto = Function.prototype, $9ea31144a2fc4466$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $9ea31144a2fc4466$var$funcToString = $9ea31144a2fc4466$var$funcProto.toString;
/** Used to check objects for own properties. */ var $9ea31144a2fc4466$var$hasOwnProperty = $9ea31144a2fc4466$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $9ea31144a2fc4466$var$reIsNative = RegExp('^' + $9ea31144a2fc4466$var$funcToString.call($9ea31144a2fc4466$var$hasOwnProperty).replace($9ea31144a2fc4466$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $9ea31144a2fc4466$var$baseIsNative(value) {
    if (!$3eb8329121eae2bf$exports(value) || $7eb89552ee9b1513$exports(value)) return false;
    var pattern = $323a1d4ebc031189$exports(value) ? $9ea31144a2fc4466$var$reIsNative : $9ea31144a2fc4466$var$reIsHostCtor;
    return pattern.test($51987eebd80c5088$exports(value));
}
$9ea31144a2fc4466$exports = $9ea31144a2fc4466$var$baseIsNative;


var $667bc70dbd70cba0$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $667bc70dbd70cba0$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$667bc70dbd70cba0$exports = $667bc70dbd70cba0$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $bb172e5f73072340$var$getNative(object, key) {
    var value = $667bc70dbd70cba0$exports(object, key);
    return $9ea31144a2fc4466$exports(value) ? value : undefined;
}
$bb172e5f73072340$exports = $bb172e5f73072340$var$getNative;



var $keq6u = parcelRequire("keq6u");
/* Built-in method references that are verified to be native. */ var $c1bce9761814e4b0$var$Map = $bb172e5f73072340$exports($keq6u, 'Map');
$c1bce9761814e4b0$exports = $c1bce9761814e4b0$var$Map;


var $1c36b93bb3873081$exports = {};
var $58b4895fd7707ce9$exports = {};
var $5bbcc37335a18596$exports = {};
var $a23080892a1f5cb9$exports = {};
var $f33024769ccff0f4$exports = {};

/* Built-in method references that are verified to be native. */ var $f33024769ccff0f4$var$nativeCreate = $bb172e5f73072340$exports(Object, 'create');
$f33024769ccff0f4$exports = $f33024769ccff0f4$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $a23080892a1f5cb9$var$hashClear() {
    this.__data__ = $f33024769ccff0f4$exports ? $f33024769ccff0f4$exports(null) : {};
    this.size = 0;
}
$a23080892a1f5cb9$exports = $a23080892a1f5cb9$var$hashClear;


var $28059697d94e124b$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $28059697d94e124b$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$28059697d94e124b$exports = $28059697d94e124b$var$hashDelete;


var $769decd634c70a32$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $769decd634c70a32$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $769decd634c70a32$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $769decd634c70a32$var$hasOwnProperty = $769decd634c70a32$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $769decd634c70a32$var$hashGet(key) {
    var data = this.__data__;
    if ($f33024769ccff0f4$exports) {
        var result = data[key];
        return result === $769decd634c70a32$var$HASH_UNDEFINED ? undefined : result;
    }
    return $769decd634c70a32$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$769decd634c70a32$exports = $769decd634c70a32$var$hashGet;


var $1356713a07ac9f37$exports = {};

/** Used for built-in method references. */ var $1356713a07ac9f37$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1356713a07ac9f37$var$hasOwnProperty = $1356713a07ac9f37$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1356713a07ac9f37$var$hashHas(key) {
    var data = this.__data__;
    return $f33024769ccff0f4$exports ? data[key] !== undefined : $1356713a07ac9f37$var$hasOwnProperty.call(data, key);
}
$1356713a07ac9f37$exports = $1356713a07ac9f37$var$hashHas;


var $60bc71681860af35$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $60bc71681860af35$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $60bc71681860af35$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $f33024769ccff0f4$exports && value === undefined ? $60bc71681860af35$var$HASH_UNDEFINED : value;
    return this;
}
$60bc71681860af35$exports = $60bc71681860af35$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $5bbcc37335a18596$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$5bbcc37335a18596$var$Hash.prototype.clear = $a23080892a1f5cb9$exports;
$5bbcc37335a18596$var$Hash.prototype['delete'] = $28059697d94e124b$exports;
$5bbcc37335a18596$var$Hash.prototype.get = $769decd634c70a32$exports;
$5bbcc37335a18596$var$Hash.prototype.has = $1356713a07ac9f37$exports;
$5bbcc37335a18596$var$Hash.prototype.set = $60bc71681860af35$exports;
$5bbcc37335a18596$exports = $5bbcc37335a18596$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $58b4895fd7707ce9$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $5bbcc37335a18596$exports,
        'map': new ($c1bce9761814e4b0$exports || $26311e37187a9048$exports),
        'string': new $5bbcc37335a18596$exports
    };
}
$58b4895fd7707ce9$exports = $58b4895fd7707ce9$var$mapCacheClear;


var $ce3ac183d63e8cc4$exports = {};
var $c15d40fcab7ca2fe$exports = {};
var $2c678792c1645842$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $2c678792c1645842$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$2c678792c1645842$exports = $2c678792c1645842$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c15d40fcab7ca2fe$var$getMapData(map, key) {
    var data = map.__data__;
    return $2c678792c1645842$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$c15d40fcab7ca2fe$exports = $c15d40fcab7ca2fe$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ce3ac183d63e8cc4$var$mapCacheDelete(key) {
    var result = $c15d40fcab7ca2fe$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$ce3ac183d63e8cc4$exports = $ce3ac183d63e8cc4$var$mapCacheDelete;


var $6f90ff5c358585f2$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6f90ff5c358585f2$var$mapCacheGet(key) {
    return $c15d40fcab7ca2fe$exports(this, key).get(key);
}
$6f90ff5c358585f2$exports = $6f90ff5c358585f2$var$mapCacheGet;


var $a44d9137585c75be$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a44d9137585c75be$var$mapCacheHas(key) {
    return $c15d40fcab7ca2fe$exports(this, key).has(key);
}
$a44d9137585c75be$exports = $a44d9137585c75be$var$mapCacheHas;


var $7f9865bd3dbf06f5$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $7f9865bd3dbf06f5$var$mapCacheSet(key, value) {
    var data = $c15d40fcab7ca2fe$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$7f9865bd3dbf06f5$exports = $7f9865bd3dbf06f5$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1c36b93bb3873081$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$1c36b93bb3873081$var$MapCache.prototype.clear = $58b4895fd7707ce9$exports;
$1c36b93bb3873081$var$MapCache.prototype['delete'] = $ce3ac183d63e8cc4$exports;
$1c36b93bb3873081$var$MapCache.prototype.get = $6f90ff5c358585f2$exports;
$1c36b93bb3873081$var$MapCache.prototype.has = $a44d9137585c75be$exports;
$1c36b93bb3873081$var$MapCache.prototype.set = $7f9865bd3dbf06f5$exports;
$1c36b93bb3873081$exports = $1c36b93bb3873081$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $ae1a95bbcbe8c7cd$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $ae1a95bbcbe8c7cd$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $26311e37187a9048$exports) {
        var pairs = data.__data__;
        if (!$c1bce9761814e4b0$exports || pairs.length < $ae1a95bbcbe8c7cd$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $1c36b93bb3873081$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$ae1a95bbcbe8c7cd$exports = $ae1a95bbcbe8c7cd$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $79e5feaebbbdc67f$var$Stack(entries) {
    var data = this.__data__ = new $26311e37187a9048$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$79e5feaebbbdc67f$var$Stack.prototype.clear = $8d6a05714ccff2dc$exports;
$79e5feaebbbdc67f$var$Stack.prototype['delete'] = $37c667ead1490042$exports;
$79e5feaebbbdc67f$var$Stack.prototype.get = $5a57fa0c556f55ed$exports;
$79e5feaebbbdc67f$var$Stack.prototype.has = $0282b07a178b5702$exports;
$79e5feaebbbdc67f$var$Stack.prototype.set = $ae1a95bbcbe8c7cd$exports;
$79e5feaebbbdc67f$exports = $79e5feaebbbdc67f$var$Stack;


var $638220c15a2d4b9e$exports = {};
var $3cc82245c3fe3dda$exports = {};

var $97b8ed47623c69a8$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $97b8ed47623c69a8$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $97b8ed47623c69a8$var$setCacheAdd(value) {
    this.__data__.set(value, $97b8ed47623c69a8$var$HASH_UNDEFINED);
    return this;
}
$97b8ed47623c69a8$exports = $97b8ed47623c69a8$var$setCacheAdd;


var $bef61dae0c7f6ce8$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $bef61dae0c7f6ce8$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$bef61dae0c7f6ce8$exports = $bef61dae0c7f6ce8$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $3cc82245c3fe3dda$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $1c36b93bb3873081$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$3cc82245c3fe3dda$var$SetCache.prototype.add = $3cc82245c3fe3dda$var$SetCache.prototype.push = $97b8ed47623c69a8$exports;
$3cc82245c3fe3dda$var$SetCache.prototype.has = $bef61dae0c7f6ce8$exports;
$3cc82245c3fe3dda$exports = $3cc82245c3fe3dda$var$SetCache;


var $ad914f5bfde88b6e$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $ad914f5bfde88b6e$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$ad914f5bfde88b6e$exports = $ad914f5bfde88b6e$var$arraySome;


var $cc615fd32d4d25aa$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $cc615fd32d4d25aa$var$cacheHas(cache, key) {
    return cache.has(key);
}
$cc615fd32d4d25aa$exports = $cc615fd32d4d25aa$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $638220c15a2d4b9e$var$COMPARE_PARTIAL_FLAG = 1, $638220c15a2d4b9e$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $638220c15a2d4b9e$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $638220c15a2d4b9e$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $638220c15a2d4b9e$var$COMPARE_UNORDERED_FLAG ? new $3cc82245c3fe3dda$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$ad914f5bfde88b6e$exports(other, function(othValue, othIndex) {
                if (!$cc615fd32d4d25aa$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$638220c15a2d4b9e$exports = $638220c15a2d4b9e$var$equalArrays;


var $41197111d4a6759e$exports = {};

var $f90fbd3432792bbd$exports = {};

var $keq6u = parcelRequire("keq6u");
/** Built-in value references. */ var $f90fbd3432792bbd$var$Uint8Array = $keq6u.Uint8Array;
$f90fbd3432792bbd$exports = $f90fbd3432792bbd$var$Uint8Array;




var $e34108ab3b2724cc$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $e34108ab3b2724cc$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$e34108ab3b2724cc$exports = $e34108ab3b2724cc$var$mapToArray;


var $d25f045d6c3b7654$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $d25f045d6c3b7654$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$d25f045d6c3b7654$exports = $d25f045d6c3b7654$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $41197111d4a6759e$var$COMPARE_PARTIAL_FLAG = 1, $41197111d4a6759e$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $41197111d4a6759e$var$boolTag = '[object Boolean]', $41197111d4a6759e$var$dateTag = '[object Date]', $41197111d4a6759e$var$errorTag = '[object Error]', $41197111d4a6759e$var$mapTag = '[object Map]', $41197111d4a6759e$var$numberTag = '[object Number]', $41197111d4a6759e$var$regexpTag = '[object RegExp]', $41197111d4a6759e$var$setTag = '[object Set]', $41197111d4a6759e$var$stringTag = '[object String]', $41197111d4a6759e$var$symbolTag = '[object Symbol]';
var $41197111d4a6759e$var$arrayBufferTag = '[object ArrayBuffer]', $41197111d4a6759e$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $41197111d4a6759e$var$symbolProto = $b6c34d3fc7779ecd$exports ? $b6c34d3fc7779ecd$exports.prototype : undefined, $41197111d4a6759e$var$symbolValueOf = $41197111d4a6759e$var$symbolProto ? $41197111d4a6759e$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $41197111d4a6759e$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $41197111d4a6759e$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $41197111d4a6759e$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $f90fbd3432792bbd$exports(object), new $f90fbd3432792bbd$exports(other))) return false;
            return true;
        case $41197111d4a6759e$var$boolTag:
        case $41197111d4a6759e$var$dateTag:
        case $41197111d4a6759e$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $4407ef85bda41b8e$exports(+object, +other);
        case $41197111d4a6759e$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $41197111d4a6759e$var$regexpTag:
        case $41197111d4a6759e$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $41197111d4a6759e$var$mapTag:
            var convert = $e34108ab3b2724cc$exports;
        case $41197111d4a6759e$var$setTag:
            var isPartial = bitmask & $41197111d4a6759e$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $d25f045d6c3b7654$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $41197111d4a6759e$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $638220c15a2d4b9e$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $41197111d4a6759e$var$symbolTag:
            if ($41197111d4a6759e$var$symbolValueOf) return $41197111d4a6759e$var$symbolValueOf.call(object) == $41197111d4a6759e$var$symbolValueOf.call(other);
    }
    return false;
}
$41197111d4a6759e$exports = $41197111d4a6759e$var$equalByTag;


var $640851b3947ac7b3$exports = {};
var $7658ec0048c18829$exports = {};
var $df65dfe77f7627eb$exports = {};
var $1ec3a34d6a2d4b59$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $1ec3a34d6a2d4b59$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$1ec3a34d6a2d4b59$exports = $1ec3a34d6a2d4b59$var$arrayPush;


var $bfb6fd0a7f3a4f01$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $bfb6fd0a7f3a4f01$var$isArray = Array.isArray;
$bfb6fd0a7f3a4f01$exports = $bfb6fd0a7f3a4f01$var$isArray;


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $df65dfe77f7627eb$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $bfb6fd0a7f3a4f01$exports(object) ? result : $1ec3a34d6a2d4b59$exports(result, symbolsFunc(object));
}
$df65dfe77f7627eb$exports = $df65dfe77f7627eb$var$baseGetAllKeys;


var $ab46c99388f43cbb$exports = {};
var $8ed19ef3c5b8d6c7$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $8ed19ef3c5b8d6c7$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$8ed19ef3c5b8d6c7$exports = $8ed19ef3c5b8d6c7$var$arrayFilter;


var $7e99033d29cab5bd$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $7e99033d29cab5bd$var$stubArray() {
    return [];
}
$7e99033d29cab5bd$exports = $7e99033d29cab5bd$var$stubArray;


/** Used for built-in method references. */ var $ab46c99388f43cbb$var$objectProto = Object.prototype;
/** Built-in value references. */ var $ab46c99388f43cbb$var$propertyIsEnumerable = $ab46c99388f43cbb$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ab46c99388f43cbb$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $ab46c99388f43cbb$var$getSymbols = !$ab46c99388f43cbb$var$nativeGetSymbols ? $7e99033d29cab5bd$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $8ed19ef3c5b8d6c7$exports($ab46c99388f43cbb$var$nativeGetSymbols(object), function(symbol) {
        return $ab46c99388f43cbb$var$propertyIsEnumerable.call(object, symbol);
    });
};
$ab46c99388f43cbb$exports = $ab46c99388f43cbb$var$getSymbols;


var $84f9d372f6c75fea$exports = {};
var $a5a4db5a8c280cda$exports = {};
var $e2d2042c560c7889$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $e2d2042c560c7889$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$e2d2042c560c7889$exports = $e2d2042c560c7889$var$baseTimes;


var $2abc73751df5a69e$exports = {};
var $8a15d46f43784a23$exports = {};


/** `Object#toString` result references. */ var $8a15d46f43784a23$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $8a15d46f43784a23$var$baseIsArguments(value) {
    return $eeeaa33c41c300ed$exports(value) && $2bee838a2d69c279$exports(value) == $8a15d46f43784a23$var$argsTag;
}
$8a15d46f43784a23$exports = $8a15d46f43784a23$var$baseIsArguments;



/** Used for built-in method references. */ var $2abc73751df5a69e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2abc73751df5a69e$var$hasOwnProperty = $2abc73751df5a69e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $2abc73751df5a69e$var$propertyIsEnumerable = $2abc73751df5a69e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $2abc73751df5a69e$var$isArguments = $8a15d46f43784a23$exports(function() {
    return arguments;
}()) ? $8a15d46f43784a23$exports : function(value) {
    return $eeeaa33c41c300ed$exports(value) && $2abc73751df5a69e$var$hasOwnProperty.call(value, 'callee') && !$2abc73751df5a69e$var$propertyIsEnumerable.call(value, 'callee');
};
$2abc73751df5a69e$exports = $2abc73751df5a69e$var$isArguments;




var $ey3Jv = parcelRequire("ey3Jv");

var $2335228ab76a41ec$exports = {};
var $787f49efcb78634e$exports = {};



/** `Object#toString` result references. */ var $787f49efcb78634e$var$argsTag = '[object Arguments]', $787f49efcb78634e$var$arrayTag = '[object Array]', $787f49efcb78634e$var$boolTag = '[object Boolean]', $787f49efcb78634e$var$dateTag = '[object Date]', $787f49efcb78634e$var$errorTag = '[object Error]', $787f49efcb78634e$var$funcTag = '[object Function]', $787f49efcb78634e$var$mapTag = '[object Map]', $787f49efcb78634e$var$numberTag = '[object Number]', $787f49efcb78634e$var$objectTag = '[object Object]', $787f49efcb78634e$var$regexpTag = '[object RegExp]', $787f49efcb78634e$var$setTag = '[object Set]', $787f49efcb78634e$var$stringTag = '[object String]', $787f49efcb78634e$var$weakMapTag = '[object WeakMap]';
var $787f49efcb78634e$var$arrayBufferTag = '[object ArrayBuffer]', $787f49efcb78634e$var$dataViewTag = '[object DataView]', $787f49efcb78634e$var$float32Tag = '[object Float32Array]', $787f49efcb78634e$var$float64Tag = '[object Float64Array]', $787f49efcb78634e$var$int8Tag = '[object Int8Array]', $787f49efcb78634e$var$int16Tag = '[object Int16Array]', $787f49efcb78634e$var$int32Tag = '[object Int32Array]', $787f49efcb78634e$var$uint8Tag = '[object Uint8Array]', $787f49efcb78634e$var$uint8ClampedTag = '[object Uint8ClampedArray]', $787f49efcb78634e$var$uint16Tag = '[object Uint16Array]', $787f49efcb78634e$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $787f49efcb78634e$var$typedArrayTags = {};
$787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$float32Tag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$float64Tag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$int8Tag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$int16Tag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$int32Tag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$uint8Tag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$uint8ClampedTag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$uint16Tag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$uint32Tag] = true;
$787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$argsTag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$arrayTag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$arrayBufferTag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$boolTag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$dataViewTag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$dateTag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$errorTag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$funcTag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$mapTag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$numberTag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$objectTag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$regexpTag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$setTag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$stringTag] = $787f49efcb78634e$var$typedArrayTags[$787f49efcb78634e$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $787f49efcb78634e$var$baseIsTypedArray(value) {
    return $eeeaa33c41c300ed$exports(value) && $ab7aa2d0632f3723$exports(value.length) && !!$787f49efcb78634e$var$typedArrayTags[$2bee838a2d69c279$exports(value)];
}
$787f49efcb78634e$exports = $787f49efcb78634e$var$baseIsTypedArray;


var $b818c51b856e7d8e$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $b818c51b856e7d8e$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$b818c51b856e7d8e$exports = $b818c51b856e7d8e$var$baseUnary;



var $i2urV = parcelRequire("i2urV");
/* Node.js helper references. */ var $2335228ab76a41ec$var$nodeIsTypedArray = $i2urV && $i2urV.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $2335228ab76a41ec$var$isTypedArray = $2335228ab76a41ec$var$nodeIsTypedArray ? $b818c51b856e7d8e$exports($2335228ab76a41ec$var$nodeIsTypedArray) : $787f49efcb78634e$exports;
$2335228ab76a41ec$exports = $2335228ab76a41ec$var$isTypedArray;


/** Used for built-in method references. */ var $a5a4db5a8c280cda$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a5a4db5a8c280cda$var$hasOwnProperty = $a5a4db5a8c280cda$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $a5a4db5a8c280cda$var$arrayLikeKeys(value, inherited) {
    var isArr = $bfb6fd0a7f3a4f01$exports(value), isArg = !isArr && $2abc73751df5a69e$exports(value), isBuff = !isArr && !isArg && $ey3Jv(value), isType = !isArr && !isArg && !isBuff && $2335228ab76a41ec$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $e2d2042c560c7889$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $a5a4db5a8c280cda$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $cee267ee972b0340$exports(key, length)))) result.push(key);
    return result;
}
$a5a4db5a8c280cda$exports = $a5a4db5a8c280cda$var$arrayLikeKeys;


var $182d488b5b637d11$exports = {};
var $3e54379d5cad0936$exports = {};
/** Used for built-in method references. */ var $3e54379d5cad0936$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $3e54379d5cad0936$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $3e54379d5cad0936$var$objectProto;
    return value === proto;
}
$3e54379d5cad0936$exports = $3e54379d5cad0936$var$isPrototype;


var $5ccd89c2326ab605$exports = {};
var $37ed44e224efdd11$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $37ed44e224efdd11$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$37ed44e224efdd11$exports = $37ed44e224efdd11$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $5ccd89c2326ab605$var$nativeKeys = $37ed44e224efdd11$exports(Object.keys, Object);
$5ccd89c2326ab605$exports = $5ccd89c2326ab605$var$nativeKeys;


/** Used for built-in method references. */ var $182d488b5b637d11$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $182d488b5b637d11$var$hasOwnProperty = $182d488b5b637d11$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $182d488b5b637d11$var$baseKeys(object) {
    if (!$3e54379d5cad0936$exports(object)) return $5ccd89c2326ab605$exports(object);
    var result = [];
    for(var key in Object(object))if ($182d488b5b637d11$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$182d488b5b637d11$exports = $182d488b5b637d11$var$baseKeys;



/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $84f9d372f6c75fea$var$keys(object) {
    return $0e382c48d62f9029$exports(object) ? $a5a4db5a8c280cda$exports(object) : $182d488b5b637d11$exports(object);
}
$84f9d372f6c75fea$exports = $84f9d372f6c75fea$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7658ec0048c18829$var$getAllKeys(object) {
    return $df65dfe77f7627eb$exports(object, $84f9d372f6c75fea$exports, $ab46c99388f43cbb$exports);
}
$7658ec0048c18829$exports = $7658ec0048c18829$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $640851b3947ac7b3$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $640851b3947ac7b3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $640851b3947ac7b3$var$hasOwnProperty = $640851b3947ac7b3$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $640851b3947ac7b3$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $640851b3947ac7b3$var$COMPARE_PARTIAL_FLAG, objProps = $7658ec0048c18829$exports(object), objLength = objProps.length, othProps = $7658ec0048c18829$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $640851b3947ac7b3$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$640851b3947ac7b3$exports = $640851b3947ac7b3$var$equalObjects;


var $6c015227ec5e02ad$exports = {};
var $ac5c1f797070a930$exports = {};


var $keq6u = parcelRequire("keq6u");
/* Built-in method references that are verified to be native. */ var $ac5c1f797070a930$var$DataView = $bb172e5f73072340$exports($keq6u, 'DataView');
$ac5c1f797070a930$exports = $ac5c1f797070a930$var$DataView;



var $9164335865b681e2$exports = {};


var $keq6u = parcelRequire("keq6u");
/* Built-in method references that are verified to be native. */ var $9164335865b681e2$var$Promise = $bb172e5f73072340$exports($keq6u, 'Promise');
$9164335865b681e2$exports = $9164335865b681e2$var$Promise;


var $3dfb779258d082a5$exports = {};


var $keq6u = parcelRequire("keq6u");
/* Built-in method references that are verified to be native. */ var $3dfb779258d082a5$var$Set = $bb172e5f73072340$exports($keq6u, 'Set');
$3dfb779258d082a5$exports = $3dfb779258d082a5$var$Set;


var $a3e8136b78f57b18$exports = {};


var $keq6u = parcelRequire("keq6u");
/* Built-in method references that are verified to be native. */ var $a3e8136b78f57b18$var$WeakMap = $bb172e5f73072340$exports($keq6u, 'WeakMap');
$a3e8136b78f57b18$exports = $a3e8136b78f57b18$var$WeakMap;




/** `Object#toString` result references. */ var $6c015227ec5e02ad$var$mapTag = '[object Map]', $6c015227ec5e02ad$var$objectTag = '[object Object]', $6c015227ec5e02ad$var$promiseTag = '[object Promise]', $6c015227ec5e02ad$var$setTag = '[object Set]', $6c015227ec5e02ad$var$weakMapTag = '[object WeakMap]';
var $6c015227ec5e02ad$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $6c015227ec5e02ad$var$dataViewCtorString = $51987eebd80c5088$exports($ac5c1f797070a930$exports), $6c015227ec5e02ad$var$mapCtorString = $51987eebd80c5088$exports($c1bce9761814e4b0$exports), $6c015227ec5e02ad$var$promiseCtorString = $51987eebd80c5088$exports($9164335865b681e2$exports), $6c015227ec5e02ad$var$setCtorString = $51987eebd80c5088$exports($3dfb779258d082a5$exports), $6c015227ec5e02ad$var$weakMapCtorString = $51987eebd80c5088$exports($a3e8136b78f57b18$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $6c015227ec5e02ad$var$getTag = $2bee838a2d69c279$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($ac5c1f797070a930$exports && $6c015227ec5e02ad$var$getTag(new $ac5c1f797070a930$exports(new ArrayBuffer(1))) != $6c015227ec5e02ad$var$dataViewTag || $c1bce9761814e4b0$exports && $6c015227ec5e02ad$var$getTag(new $c1bce9761814e4b0$exports) != $6c015227ec5e02ad$var$mapTag || $9164335865b681e2$exports && $6c015227ec5e02ad$var$getTag($9164335865b681e2$exports.resolve()) != $6c015227ec5e02ad$var$promiseTag || $3dfb779258d082a5$exports && $6c015227ec5e02ad$var$getTag(new $3dfb779258d082a5$exports) != $6c015227ec5e02ad$var$setTag || $a3e8136b78f57b18$exports && $6c015227ec5e02ad$var$getTag(new $a3e8136b78f57b18$exports) != $6c015227ec5e02ad$var$weakMapTag) $6c015227ec5e02ad$var$getTag = function(value) {
    var result = $2bee838a2d69c279$exports(value), Ctor = result == $6c015227ec5e02ad$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $51987eebd80c5088$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $6c015227ec5e02ad$var$dataViewCtorString:
            return $6c015227ec5e02ad$var$dataViewTag;
        case $6c015227ec5e02ad$var$mapCtorString:
            return $6c015227ec5e02ad$var$mapTag;
        case $6c015227ec5e02ad$var$promiseCtorString:
            return $6c015227ec5e02ad$var$promiseTag;
        case $6c015227ec5e02ad$var$setCtorString:
            return $6c015227ec5e02ad$var$setTag;
        case $6c015227ec5e02ad$var$weakMapCtorString:
            return $6c015227ec5e02ad$var$weakMapTag;
    }
    return result;
};
$6c015227ec5e02ad$exports = $6c015227ec5e02ad$var$getTag;




var $ey3Jv = parcelRequire("ey3Jv");

/** Used to compose bitmasks for value comparisons. */ var $d52f94816deaa10d$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $d52f94816deaa10d$var$argsTag = '[object Arguments]', $d52f94816deaa10d$var$arrayTag = '[object Array]', $d52f94816deaa10d$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $d52f94816deaa10d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d52f94816deaa10d$var$hasOwnProperty = $d52f94816deaa10d$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $d52f94816deaa10d$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $bfb6fd0a7f3a4f01$exports(object), othIsArr = $bfb6fd0a7f3a4f01$exports(other), objTag = objIsArr ? $d52f94816deaa10d$var$arrayTag : $6c015227ec5e02ad$exports(object), othTag = othIsArr ? $d52f94816deaa10d$var$arrayTag : $6c015227ec5e02ad$exports(other);
    objTag = objTag == $d52f94816deaa10d$var$argsTag ? $d52f94816deaa10d$var$objectTag : objTag;
    othTag = othTag == $d52f94816deaa10d$var$argsTag ? $d52f94816deaa10d$var$objectTag : othTag;
    var objIsObj = objTag == $d52f94816deaa10d$var$objectTag, othIsObj = othTag == $d52f94816deaa10d$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $ey3Jv(object)) {
        if (!$ey3Jv(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $79e5feaebbbdc67f$exports);
        return objIsArr || $2335228ab76a41ec$exports(object) ? $638220c15a2d4b9e$exports(object, other, bitmask, customizer, equalFunc, stack) : $41197111d4a6759e$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $d52f94816deaa10d$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $d52f94816deaa10d$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $d52f94816deaa10d$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $79e5feaebbbdc67f$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $79e5feaebbbdc67f$exports);
    return $640851b3947ac7b3$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$d52f94816deaa10d$exports = $d52f94816deaa10d$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $2cbc2ceff246b896$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$eeeaa33c41c300ed$exports(value) && !$eeeaa33c41c300ed$exports(other)) return value !== value && other !== other;
    return $d52f94816deaa10d$exports(value, other, bitmask, customizer, $2cbc2ceff246b896$var$baseIsEqual, stack);
}
$2cbc2ceff246b896$exports = $2cbc2ceff246b896$var$baseIsEqual;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $56a939b6be7c5af5$var$isEqual(value, other) {
    return $2cbc2ceff246b896$exports(value, other);
}
$56a939b6be7c5af5$exports = $56a939b6be7c5af5$var$isEqual;




function $ea9791f530d8abb6$export$2e2bcd8739ae039(node, client) {
    var win = (0, $73dd4e5d3cfde323$export$2e2bcd8739ae039)(node);
    return win ? win.innerHeight : client ? node.clientHeight : (0, $2f02d0066d00e531$export$2e2bcd8739ae039)(node).height;
}


var $1384fa5ca030d7db$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $1384fa5ca030d7db$export$2e2bcd8739ae039(element, selector) {
    return $1384fa5ca030d7db$var$toArray(element.querySelectorAll(selector));
}



var $af0c1e52face072e$var$matchesImpl;
function $af0c1e52face072e$export$2e2bcd8739ae039(node, selector) {
    if (!$af0c1e52face072e$var$matchesImpl) {
        var body = document.body;
        var nativeMatch = body.matches || body.matchesSelector || body.webkitMatchesSelector || body.mozMatchesSelector || body.msMatchesSelector;
        $af0c1e52face072e$var$matchesImpl = function matchesImpl(n, s) {
            return nativeMatch.call(n, s);
        };
    }
    return $af0c1e52face072e$var$matchesImpl(node, selector);
}


function $575cfafa38ebd59c$export$2e2bcd8739ae039(node, selector, stopAt) {
    if (node.closest && !stopAt) node.closest(selector);
    var nextNode = node;
    do {
        if ((0, $af0c1e52face072e$export$2e2bcd8739ae039)(nextNode, selector)) return nextNode;
        nextNode = nextNode.parentElement;
    }while (nextNode && nextNode !== stopAt && nextNode.nodeType === document.ELEMENT_NODE);
    return null;
}



var $c6c5d1d8f7384862$exports = {};
var $c2fff01232fe3f7b$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $c2fff01232fe3f7b$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$c2fff01232fe3f7b$exports = $c2fff01232fe3f7b$var$baseFindIndex;


var $d1fad1d76f5c17a2$exports = {};
var $0fb674e520c777e4$exports = {};
var $31b567269e94e54f$exports = {};


/** Used to compose bitmasks for value comparisons. */ var $31b567269e94e54f$var$COMPARE_PARTIAL_FLAG = 1, $31b567269e94e54f$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $31b567269e94e54f$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $79e5feaebbbdc67f$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $2cbc2ceff246b896$exports(srcValue, objValue, $31b567269e94e54f$var$COMPARE_PARTIAL_FLAG | $31b567269e94e54f$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$31b567269e94e54f$exports = $31b567269e94e54f$var$baseIsMatch;


var $f499b9413ee0c1a9$exports = {};
var $b6c40ddbc4d8ec4a$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $b6c40ddbc4d8ec4a$var$isStrictComparable(value) {
    return value === value && !$3eb8329121eae2bf$exports(value);
}
$b6c40ddbc4d8ec4a$exports = $b6c40ddbc4d8ec4a$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $f499b9413ee0c1a9$var$getMatchData(object) {
    var result = $84f9d372f6c75fea$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $b6c40ddbc4d8ec4a$exports(value)
        ];
    }
    return result;
}
$f499b9413ee0c1a9$exports = $f499b9413ee0c1a9$var$getMatchData;


var $536af6d1cd035a31$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $536af6d1cd035a31$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$536af6d1cd035a31$exports = $536af6d1cd035a31$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $0fb674e520c777e4$var$baseMatches(source) {
    var matchData = $f499b9413ee0c1a9$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $536af6d1cd035a31$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $31b567269e94e54f$exports(object, source, matchData);
    };
}
$0fb674e520c777e4$exports = $0fb674e520c777e4$var$baseMatches;


var $0d058a17be9d5a9c$exports = {};

var $47421346afb95bef$exports = {};
var $a033fa5a331356cc$exports = {};
var $4000b4d8c4db7a40$exports = {};

var $fcfe8634146616a1$exports = {};


/** Used to match property names within property paths. */ var $fcfe8634146616a1$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $fcfe8634146616a1$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $fcfe8634146616a1$var$isKey(value, object) {
    if ($bfb6fd0a7f3a4f01$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $3c132c7cf40a9860$exports(value)) return true;
    return $fcfe8634146616a1$var$reIsPlainProp.test(value) || !$fcfe8634146616a1$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$fcfe8634146616a1$exports = $fcfe8634146616a1$var$isKey;


var $9266d775a0745c20$exports = {};
var $b879b365f0969f68$exports = {};
var $fd9ada205a5bad5e$exports = {};

/** Error message constants. */ var $fd9ada205a5bad5e$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $fd9ada205a5bad5e$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($fd9ada205a5bad5e$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($fd9ada205a5bad5e$var$memoize.Cache || $1c36b93bb3873081$exports);
    return memoized;
}
// Expose `MapCache`.
$fd9ada205a5bad5e$var$memoize.Cache = $1c36b93bb3873081$exports;
$fd9ada205a5bad5e$exports = $fd9ada205a5bad5e$var$memoize;


/** Used as the maximum memoize cache size. */ var $b879b365f0969f68$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $b879b365f0969f68$var$memoizeCapped(func) {
    var result = $fd9ada205a5bad5e$exports(func, function(key) {
        if (cache.size === $b879b365f0969f68$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$b879b365f0969f68$exports = $b879b365f0969f68$var$memoizeCapped;


/** Used to match property names within property paths. */ var $9266d775a0745c20$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $9266d775a0745c20$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $9266d775a0745c20$var$stringToPath = $b879b365f0969f68$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($9266d775a0745c20$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($9266d775a0745c20$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$9266d775a0745c20$exports = $9266d775a0745c20$var$stringToPath;


var $d7ccbc5c7fb135c6$exports = {};
var $f9e36736643b4243$exports = {};

var $f3999e86c9d7b521$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $f3999e86c9d7b521$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$f3999e86c9d7b521$exports = $f3999e86c9d7b521$var$arrayMap;




/** Used as references for various `Number` constants. */ var $f9e36736643b4243$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f9e36736643b4243$var$symbolProto = $b6c34d3fc7779ecd$exports ? $b6c34d3fc7779ecd$exports.prototype : undefined, $f9e36736643b4243$var$symbolToString = $f9e36736643b4243$var$symbolProto ? $f9e36736643b4243$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f9e36736643b4243$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($bfb6fd0a7f3a4f01$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $f3999e86c9d7b521$exports(value, $f9e36736643b4243$var$baseToString) + '';
    if ($3c132c7cf40a9860$exports(value)) return $f9e36736643b4243$var$symbolToString ? $f9e36736643b4243$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f9e36736643b4243$var$INFINITY ? '-0' : result;
}
$f9e36736643b4243$exports = $f9e36736643b4243$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $d7ccbc5c7fb135c6$var$toString(value) {
    return value == null ? '' : $f9e36736643b4243$exports(value);
}
$d7ccbc5c7fb135c6$exports = $d7ccbc5c7fb135c6$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $4000b4d8c4db7a40$var$castPath(value, object) {
    if ($bfb6fd0a7f3a4f01$exports(value)) return value;
    return $fcfe8634146616a1$exports(value, object) ? [
        value
    ] : $9266d775a0745c20$exports($d7ccbc5c7fb135c6$exports(value));
}
$4000b4d8c4db7a40$exports = $4000b4d8c4db7a40$var$castPath;


var $9ba58b0a05f59856$exports = {};

/** Used as references for various `Number` constants. */ var $9ba58b0a05f59856$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $9ba58b0a05f59856$var$toKey(value) {
    if (typeof value == 'string' || $3c132c7cf40a9860$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$9ba58b0a05f59856$var$INFINITY ? '-0' : result;
}
$9ba58b0a05f59856$exports = $9ba58b0a05f59856$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $a033fa5a331356cc$var$baseGet(object, path) {
    path = $4000b4d8c4db7a40$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$9ba58b0a05f59856$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$a033fa5a331356cc$exports = $a033fa5a331356cc$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $47421346afb95bef$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $a033fa5a331356cc$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$47421346afb95bef$exports = $47421346afb95bef$var$get;


var $e9958b4e1fa73cb8$exports = {};
var $79a5316c90324f5f$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $79a5316c90324f5f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$79a5316c90324f5f$exports = $79a5316c90324f5f$var$baseHasIn;


var $caca2bebede84b40$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $caca2bebede84b40$var$hasPath(object, path, hasFunc) {
    path = $4000b4d8c4db7a40$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $9ba58b0a05f59856$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $ab7aa2d0632f3723$exports(length) && $cee267ee972b0340$exports(key, length) && ($bfb6fd0a7f3a4f01$exports(object) || $2abc73751df5a69e$exports(object));
}
$caca2bebede84b40$exports = $caca2bebede84b40$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $e9958b4e1fa73cb8$var$hasIn(object, path) {
    return object != null && $caca2bebede84b40$exports(object, path, $79a5316c90324f5f$exports);
}
$e9958b4e1fa73cb8$exports = $e9958b4e1fa73cb8$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $0d058a17be9d5a9c$var$COMPARE_PARTIAL_FLAG = 1, $0d058a17be9d5a9c$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $0d058a17be9d5a9c$var$baseMatchesProperty(path, srcValue) {
    if ($fcfe8634146616a1$exports(path) && $b6c40ddbc4d8ec4a$exports(srcValue)) return $536af6d1cd035a31$exports($9ba58b0a05f59856$exports(path), srcValue);
    return function(object) {
        var objValue = $47421346afb95bef$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $e9958b4e1fa73cb8$exports(object, path) : $2cbc2ceff246b896$exports(srcValue, objValue, $0d058a17be9d5a9c$var$COMPARE_PARTIAL_FLAG | $0d058a17be9d5a9c$var$COMPARE_UNORDERED_FLAG);
    };
}
$0d058a17be9d5a9c$exports = $0d058a17be9d5a9c$var$baseMatchesProperty;


var $f5cca9653f2beaf7$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $f5cca9653f2beaf7$var$identity(value) {
    return value;
}
$f5cca9653f2beaf7$exports = $f5cca9653f2beaf7$var$identity;



var $6e75b1772d57e563$exports = {};
var $b953a51128137b12$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $b953a51128137b12$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$b953a51128137b12$exports = $b953a51128137b12$var$baseProperty;


var $4f207b2a452f2304$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $4f207b2a452f2304$var$basePropertyDeep(path) {
    return function(object) {
        return $a033fa5a331356cc$exports(object, path);
    };
}
$4f207b2a452f2304$exports = $4f207b2a452f2304$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $6e75b1772d57e563$var$property(path) {
    return $fcfe8634146616a1$exports(path) ? $b953a51128137b12$exports($9ba58b0a05f59856$exports(path)) : $4f207b2a452f2304$exports(path);
}
$6e75b1772d57e563$exports = $6e75b1772d57e563$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $d1fad1d76f5c17a2$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $f5cca9653f2beaf7$exports;
    if (typeof value == 'object') return $bfb6fd0a7f3a4f01$exports(value) ? $0d058a17be9d5a9c$exports(value[0], value[1]) : $0fb674e520c777e4$exports(value);
    return $6e75b1772d57e563$exports(value);
}
$d1fad1d76f5c17a2$exports = $d1fad1d76f5c17a2$var$baseIteratee;



/* Built-in method references for those with the same name as other `lodash` methods. */ var $c6c5d1d8f7384862$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $c6c5d1d8f7384862$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $2e7523fa77e42e3e$exports(fromIndex);
    if (index < 0) index = $c6c5d1d8f7384862$var$nativeMax(length + index, 0);
    return $c2fff01232fe3f7b$exports(array, $d1fad1d76f5c17a2$exports(predicate, 3), index);
}
$c6c5d1d8f7384862$exports = $c6c5d1d8f7384862$var$findIndex;


var $493955b6799bbc8b$exports = {};
var $9c841491530e5eb8$exports = {};
var $a257bd67d2e983f6$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a257bd67d2e983f6$var$nativeCeil = Math.ceil, $a257bd67d2e983f6$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $a257bd67d2e983f6$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $a257bd67d2e983f6$var$nativeMax($a257bd67d2e983f6$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$a257bd67d2e983f6$exports = $a257bd67d2e983f6$var$baseRange;




/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $9c841491530e5eb8$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $5ce7f5854ad79775$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $af4655bb90090965$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $af4655bb90090965$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $af4655bb90090965$exports(step);
        return $a257bd67d2e983f6$exports(start, end, step, fromRight);
    };
}
$9c841491530e5eb8$exports = $9c841491530e5eb8$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $493955b6799bbc8b$var$range = $9c841491530e5eb8$exports();
$493955b6799bbc8b$exports = $493955b6799bbc8b$var$range;





function $18a30c8ab2ccc592$export$2e2bcd8739ae039(node, client) {
    var win = (0, $73dd4e5d3cfde323$export$2e2bcd8739ae039)(node);
    return win ? win.innerWidth : client ? node.clientWidth : (0, $2f02d0066d00e531$export$2e2bcd8739ae039)(node).width;
}


var $5aa1fc3d501b351b$exports = {};
var $44f1c307f9859dfd$exports = {};

var $b227f490fa4e8f52$exports = {};



/** Built-in value references. */ var $b227f490fa4e8f52$var$spreadableSymbol = $b6c34d3fc7779ecd$exports ? $b6c34d3fc7779ecd$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $b227f490fa4e8f52$var$isFlattenable(value) {
    return $bfb6fd0a7f3a4f01$exports(value) || $2abc73751df5a69e$exports(value) || !!($b227f490fa4e8f52$var$spreadableSymbol && value && value[$b227f490fa4e8f52$var$spreadableSymbol]);
}
$b227f490fa4e8f52$exports = $b227f490fa4e8f52$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $44f1c307f9859dfd$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $b227f490fa4e8f52$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $44f1c307f9859dfd$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $1ec3a34d6a2d4b59$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$44f1c307f9859dfd$exports = $44f1c307f9859dfd$var$baseFlatten;


var $e1629966f21a5cc0$exports = {};



var $622b71b237e23c66$exports = {};
var $dd151fada4d2ae1b$exports = {};
var $d8667f7a45debfd2$exports = {};
var $d259ba606978a148$exports = {};
var $a886f31ca6c5ab88$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $a886f31ca6c5ab88$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$a886f31ca6c5ab88$exports = $a886f31ca6c5ab88$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $d259ba606978a148$var$baseFor = $a886f31ca6c5ab88$exports();
$d259ba606978a148$exports = $d259ba606978a148$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $d8667f7a45debfd2$var$baseForOwn(object, iteratee) {
    return object && $d259ba606978a148$exports(object, iteratee, $84f9d372f6c75fea$exports);
}
$d8667f7a45debfd2$exports = $d8667f7a45debfd2$var$baseForOwn;


var $84ac85193bfa7c60$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $84ac85193bfa7c60$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$0e382c48d62f9029$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$84ac85193bfa7c60$exports = $84ac85193bfa7c60$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $dd151fada4d2ae1b$var$baseEach = $84ac85193bfa7c60$exports($d8667f7a45debfd2$exports);
$dd151fada4d2ae1b$exports = $dd151fada4d2ae1b$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $622b71b237e23c66$var$baseMap(collection, iteratee) {
    var index = -1, result = $0e382c48d62f9029$exports(collection) ? Array(collection.length) : [];
    $dd151fada4d2ae1b$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$622b71b237e23c66$exports = $622b71b237e23c66$var$baseMap;


var $a6cd4bdb2c5c45c2$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $a6cd4bdb2c5c45c2$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$a6cd4bdb2c5c45c2$exports = $a6cd4bdb2c5c45c2$var$baseSortBy;



var $19facdc7865739ad$exports = {};
var $1ce881ec61dad853$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $1ce881ec61dad853$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $3c132c7cf40a9860$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $3c132c7cf40a9860$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$1ce881ec61dad853$exports = $1ce881ec61dad853$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $19facdc7865739ad$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $1ce881ec61dad853$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$19facdc7865739ad$exports = $19facdc7865739ad$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $e1629966f21a5cc0$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $f3999e86c9d7b521$exports(iteratees, function(iteratee) {
        if ($bfb6fd0a7f3a4f01$exports(iteratee)) return function(value) {
            return $a033fa5a331356cc$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $f5cca9653f2beaf7$exports
    ];
    var index = -1;
    iteratees = $f3999e86c9d7b521$exports(iteratees, $b818c51b856e7d8e$exports($d1fad1d76f5c17a2$exports));
    var result = $622b71b237e23c66$exports(collection, function(value, key, collection) {
        var criteria = $f3999e86c9d7b521$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $a6cd4bdb2c5c45c2$exports(result, function(object, other) {
        return $19facdc7865739ad$exports(object, other, orders);
    });
}
$e1629966f21a5cc0$exports = $e1629966f21a5cc0$var$baseOrderBy;


var $bec3c63b3b5d25a3$exports = {};

var $791e20d15bca2267$exports = {};
var $c6b04bb82ef01afc$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $c6b04bb82ef01afc$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$c6b04bb82ef01afc$exports = $c6b04bb82ef01afc$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $791e20d15bca2267$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $791e20d15bca2267$var$overRest(func, start, transform) {
    start = $791e20d15bca2267$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $791e20d15bca2267$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $c6b04bb82ef01afc$exports(func, this, otherArgs);
    };
}
$791e20d15bca2267$exports = $791e20d15bca2267$var$overRest;


var $5029ec0a4922e637$exports = {};
var $ffb8426cc5b83929$exports = {};
var $389d5694a833993b$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $389d5694a833993b$var$constant(value) {
    return function() {
        return value;
    };
}
$389d5694a833993b$exports = $389d5694a833993b$var$constant;


var $976d727f1bd33df1$exports = {};

var $976d727f1bd33df1$var$defineProperty = function() {
    try {
        var func = $bb172e5f73072340$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$976d727f1bd33df1$exports = $976d727f1bd33df1$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $ffb8426cc5b83929$var$baseSetToString = !$976d727f1bd33df1$exports ? $f5cca9653f2beaf7$exports : function(func, string) {
    return $976d727f1bd33df1$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $389d5694a833993b$exports(string),
        'writable': true
    });
};
$ffb8426cc5b83929$exports = $ffb8426cc5b83929$var$baseSetToString;


var $2942711fa1fa1d59$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $2942711fa1fa1d59$var$HOT_COUNT = 800, $2942711fa1fa1d59$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2942711fa1fa1d59$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $2942711fa1fa1d59$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $2942711fa1fa1d59$var$nativeNow(), remaining = $2942711fa1fa1d59$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $2942711fa1fa1d59$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$2942711fa1fa1d59$exports = $2942711fa1fa1d59$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $5029ec0a4922e637$var$setToString = $2942711fa1fa1d59$exports($ffb8426cc5b83929$exports);
$5029ec0a4922e637$exports = $5029ec0a4922e637$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $bec3c63b3b5d25a3$var$baseRest(func, start) {
    return $5029ec0a4922e637$exports($791e20d15bca2267$exports(func, start, $f5cca9653f2beaf7$exports), func + '');
}
$bec3c63b3b5d25a3$exports = $bec3c63b3b5d25a3$var$baseRest;



/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $5aa1fc3d501b351b$var$sortBy = $bec3c63b3b5d25a3$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $5ce7f5854ad79775$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $5ce7f5854ad79775$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $e1629966f21a5cc0$exports(collection, $44f1c307f9859dfd$exports(iteratees, 1), []);
});
$5aa1fc3d501b351b$exports = $5aa1fc3d501b351b$var$sortBy;



var $1ceeb7c22fe75025$var$size;
function $1ceeb7c22fe75025$export$2e2bcd8739ae039(recalc) {
    if (!$1ceeb7c22fe75025$var$size && $1ceeb7c22fe75025$var$size !== 0 || recalc) {
        if (0, $439157458583ebf2$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $1ceeb7c22fe75025$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $1ceeb7c22fe75025$var$size;
}






function $bf3e6cea5f80d91f$export$2e2bcd8739ae039(r) {
    return (0, $818de7f427b1da9f$export$2e2bcd8739ae039)(r) || (0, $a55341f9daa7f086$export$2e2bcd8739ae039)(r) || (0, $2a435729188bd903$export$2e2bcd8739ae039)(r) || (0, $1c04807b255dd26c$export$2e2bcd8739ae039)();
}


/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $9a574d402e6597d3$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $3d8dfb1f4ad73ac5$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $9a574d402e6597d3$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}


function $d4f0b488dfc15082$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $d4f0b488dfc15082$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $d4f0b488dfc15082$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $d4f0b488dfc15082$var$replaceClassName(element.className && element.className.baseVal || '', className));
}


var $c967c285f657b8a4$exports = {};



var $9899fbdec1d1721f$exports = {};

var $366a1140c7077a01$exports = {};


var $830d5d183b80a965$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $830d5d183b80a965$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$830d5d183b80a965$exports = $830d5d183b80a965$var$nativeKeysIn;


/** Used for built-in method references. */ var $366a1140c7077a01$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $366a1140c7077a01$var$hasOwnProperty = $366a1140c7077a01$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $366a1140c7077a01$var$baseKeysIn(object) {
    if (!$3eb8329121eae2bf$exports(object)) return $830d5d183b80a965$exports(object);
    var isProto = $3e54379d5cad0936$exports(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$366a1140c7077a01$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$366a1140c7077a01$exports = $366a1140c7077a01$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $9899fbdec1d1721f$var$keysIn(object) {
    return $0e382c48d62f9029$exports(object) ? $a5a4db5a8c280cda$exports(object, true) : $366a1140c7077a01$exports(object);
}
$9899fbdec1d1721f$exports = $9899fbdec1d1721f$var$keysIn;


/** Used for built-in method references. */ var $c967c285f657b8a4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c967c285f657b8a4$var$hasOwnProperty = $c967c285f657b8a4$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $c967c285f657b8a4$var$defaults = $bec3c63b3b5d25a3$exports(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && $5ce7f5854ad79775$exports(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = $9899fbdec1d1721f$exports(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || $4407ef85bda41b8e$exports(value, $c967c285f657b8a4$var$objectProto[key]) && !$c967c285f657b8a4$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
$c967c285f657b8a4$exports = $c967c285f657b8a4$var$defaults;


var $bc64489b77d0a43c$exports = {};
var $b40ac4810f7d7ebf$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $b40ac4810f7d7ebf$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $976d727f1bd33df1$exports) $976d727f1bd33df1$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$b40ac4810f7d7ebf$exports = $b40ac4810f7d7ebf$var$baseAssignValue;




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $bc64489b77d0a43c$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $d1fad1d76f5c17a2$exports(iteratee, 3);
    $d8667f7a45debfd2$exports(object, function(value, key, object) {
        $b40ac4810f7d7ebf$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$bc64489b77d0a43c$exports = $bc64489b77d0a43c$var$mapValues;


var $adbc5e5ed3bd9f01$exports = {};

var $119f9d73f5e295d7$exports = {};

var $46443713f14ab726$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $46443713f14ab726$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$46443713f14ab726$exports = $46443713f14ab726$var$arrayEach;


var $402c26e404f07a2e$exports = {};


/** Used for built-in method references. */ var $402c26e404f07a2e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $402c26e404f07a2e$var$hasOwnProperty = $402c26e404f07a2e$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $402c26e404f07a2e$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($402c26e404f07a2e$var$hasOwnProperty.call(object, key) && $4407ef85bda41b8e$exports(objValue, value)) || value === undefined && !(key in object)) $b40ac4810f7d7ebf$exports(object, key, value);
}
$402c26e404f07a2e$exports = $402c26e404f07a2e$var$assignValue;


var $b45a93f32a273c7a$exports = {};
var $d04fab20f3b3cd21$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $d04fab20f3b3cd21$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $b40ac4810f7d7ebf$exports(object, key, newValue);
        else $402c26e404f07a2e$exports(object, key, newValue);
    }
    return object;
}
$d04fab20f3b3cd21$exports = $d04fab20f3b3cd21$var$copyObject;



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $b45a93f32a273c7a$var$baseAssign(object, source) {
    return object && $d04fab20f3b3cd21$exports(source, $84f9d372f6c75fea$exports(source), object);
}
$b45a93f32a273c7a$exports = $b45a93f32a273c7a$var$baseAssign;


var $1eea773e9b4dfd98$exports = {};


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $1eea773e9b4dfd98$var$baseAssignIn(object, source) {
    return object && $d04fab20f3b3cd21$exports(source, $9899fbdec1d1721f$exports(source), object);
}
$1eea773e9b4dfd98$exports = $1eea773e9b4dfd98$var$baseAssignIn;



var $jexZI = parcelRequire("jexZI");
var $d8dfdfd97dac6836$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $d8dfdfd97dac6836$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$d8dfdfd97dac6836$exports = $d8dfdfd97dac6836$var$copyArray;


var $ae898d679cd22077$exports = {};


/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $ae898d679cd22077$var$copySymbols(source, object) {
    return $d04fab20f3b3cd21$exports(source, $ab46c99388f43cbb$exports(source), object);
}
$ae898d679cd22077$exports = $ae898d679cd22077$var$copySymbols;


var $20efdbfde4fba732$exports = {};

var $3bbf17ad0bd83c88$exports = {};

var $7c5953eaddbe31c2$exports = {};

/** Built-in value references. */ var $7c5953eaddbe31c2$var$getPrototype = $37ed44e224efdd11$exports(Object.getPrototypeOf, Object);
$7c5953eaddbe31c2$exports = $7c5953eaddbe31c2$var$getPrototype;




/* Built-in method references for those with the same name as other `lodash` methods. */ var $3bbf17ad0bd83c88$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $3bbf17ad0bd83c88$var$getSymbolsIn = !$3bbf17ad0bd83c88$var$nativeGetSymbols ? $7e99033d29cab5bd$exports : function(object) {
    var result = [];
    while(object){
        $1ec3a34d6a2d4b59$exports(result, $ab46c99388f43cbb$exports(object));
        object = $7c5953eaddbe31c2$exports(object);
    }
    return result;
};
$3bbf17ad0bd83c88$exports = $3bbf17ad0bd83c88$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $20efdbfde4fba732$var$copySymbolsIn(source, object) {
    return $d04fab20f3b3cd21$exports(source, $3bbf17ad0bd83c88$exports(source), object);
}
$20efdbfde4fba732$exports = $20efdbfde4fba732$var$copySymbolsIn;



var $2b49db98ee717406$exports = {};



/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $2b49db98ee717406$var$getAllKeysIn(object) {
    return $df65dfe77f7627eb$exports(object, $9899fbdec1d1721f$exports, $3bbf17ad0bd83c88$exports);
}
$2b49db98ee717406$exports = $2b49db98ee717406$var$getAllKeysIn;



var $274d1ce376f0f59b$exports = {};
/** Used for built-in method references. */ var $274d1ce376f0f59b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $274d1ce376f0f59b$var$hasOwnProperty = $274d1ce376f0f59b$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $274d1ce376f0f59b$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $274d1ce376f0f59b$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$274d1ce376f0f59b$exports = $274d1ce376f0f59b$var$initCloneArray;


var $43f51ab1e2f9aff5$exports = {};
var $e789ffe2a2d96a25$exports = {};

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $e789ffe2a2d96a25$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $f90fbd3432792bbd$exports(result).set(new $f90fbd3432792bbd$exports(arrayBuffer));
    return result;
}
$e789ffe2a2d96a25$exports = $e789ffe2a2d96a25$var$cloneArrayBuffer;


var $1ea1206afcc4ca53$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $1ea1206afcc4ca53$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $e789ffe2a2d96a25$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$1ea1206afcc4ca53$exports = $1ea1206afcc4ca53$var$cloneDataView;


var $4ad5aaaad86984a4$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $4ad5aaaad86984a4$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $4ad5aaaad86984a4$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $4ad5aaaad86984a4$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$4ad5aaaad86984a4$exports = $4ad5aaaad86984a4$var$cloneRegExp;


var $e4a210e57182d1de$exports = {};

/** Used to convert symbols to primitives and strings. */ var $e4a210e57182d1de$var$symbolProto = $b6c34d3fc7779ecd$exports ? $b6c34d3fc7779ecd$exports.prototype : undefined, $e4a210e57182d1de$var$symbolValueOf = $e4a210e57182d1de$var$symbolProto ? $e4a210e57182d1de$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $e4a210e57182d1de$var$cloneSymbol(symbol) {
    return $e4a210e57182d1de$var$symbolValueOf ? Object($e4a210e57182d1de$var$symbolValueOf.call(symbol)) : {};
}
$e4a210e57182d1de$exports = $e4a210e57182d1de$var$cloneSymbol;


var $ab2b478c888ff2a3$exports = {};

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $ab2b478c888ff2a3$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $e789ffe2a2d96a25$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$ab2b478c888ff2a3$exports = $ab2b478c888ff2a3$var$cloneTypedArray;


/** `Object#toString` result references. */ var $43f51ab1e2f9aff5$var$boolTag = '[object Boolean]', $43f51ab1e2f9aff5$var$dateTag = '[object Date]', $43f51ab1e2f9aff5$var$mapTag = '[object Map]', $43f51ab1e2f9aff5$var$numberTag = '[object Number]', $43f51ab1e2f9aff5$var$regexpTag = '[object RegExp]', $43f51ab1e2f9aff5$var$setTag = '[object Set]', $43f51ab1e2f9aff5$var$stringTag = '[object String]', $43f51ab1e2f9aff5$var$symbolTag = '[object Symbol]';
var $43f51ab1e2f9aff5$var$arrayBufferTag = '[object ArrayBuffer]', $43f51ab1e2f9aff5$var$dataViewTag = '[object DataView]', $43f51ab1e2f9aff5$var$float32Tag = '[object Float32Array]', $43f51ab1e2f9aff5$var$float64Tag = '[object Float64Array]', $43f51ab1e2f9aff5$var$int8Tag = '[object Int8Array]', $43f51ab1e2f9aff5$var$int16Tag = '[object Int16Array]', $43f51ab1e2f9aff5$var$int32Tag = '[object Int32Array]', $43f51ab1e2f9aff5$var$uint8Tag = '[object Uint8Array]', $43f51ab1e2f9aff5$var$uint8ClampedTag = '[object Uint8ClampedArray]', $43f51ab1e2f9aff5$var$uint16Tag = '[object Uint16Array]', $43f51ab1e2f9aff5$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $43f51ab1e2f9aff5$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $43f51ab1e2f9aff5$var$arrayBufferTag:
            return $e789ffe2a2d96a25$exports(object);
        case $43f51ab1e2f9aff5$var$boolTag:
        case $43f51ab1e2f9aff5$var$dateTag:
            return new Ctor(+object);
        case $43f51ab1e2f9aff5$var$dataViewTag:
            return $1ea1206afcc4ca53$exports(object, isDeep);
        case $43f51ab1e2f9aff5$var$float32Tag:
        case $43f51ab1e2f9aff5$var$float64Tag:
        case $43f51ab1e2f9aff5$var$int8Tag:
        case $43f51ab1e2f9aff5$var$int16Tag:
        case $43f51ab1e2f9aff5$var$int32Tag:
        case $43f51ab1e2f9aff5$var$uint8Tag:
        case $43f51ab1e2f9aff5$var$uint8ClampedTag:
        case $43f51ab1e2f9aff5$var$uint16Tag:
        case $43f51ab1e2f9aff5$var$uint32Tag:
            return $ab2b478c888ff2a3$exports(object, isDeep);
        case $43f51ab1e2f9aff5$var$mapTag:
            return new Ctor;
        case $43f51ab1e2f9aff5$var$numberTag:
        case $43f51ab1e2f9aff5$var$stringTag:
            return new Ctor(object);
        case $43f51ab1e2f9aff5$var$regexpTag:
            return $4ad5aaaad86984a4$exports(object);
        case $43f51ab1e2f9aff5$var$setTag:
            return new Ctor;
        case $43f51ab1e2f9aff5$var$symbolTag:
            return $e4a210e57182d1de$exports(object);
    }
}
$43f51ab1e2f9aff5$exports = $43f51ab1e2f9aff5$var$initCloneByTag;


var $f378eccaf2173f58$exports = {};
var $560551df184ad264$exports = {};

/** Built-in value references. */ var $560551df184ad264$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $560551df184ad264$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$3eb8329121eae2bf$exports(proto)) return {};
        if ($560551df184ad264$var$objectCreate) return $560551df184ad264$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$560551df184ad264$exports = $560551df184ad264$var$baseCreate;




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $f378eccaf2173f58$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$3e54379d5cad0936$exports(object) ? $560551df184ad264$exports($7c5953eaddbe31c2$exports(object)) : {};
}
$f378eccaf2173f58$exports = $f378eccaf2173f58$var$initCloneObject;




var $ey3Jv = parcelRequire("ey3Jv");
var $09a059b505670e85$exports = {};
var $3be9e2a235ca7a8c$exports = {};


/** `Object#toString` result references. */ var $3be9e2a235ca7a8c$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $3be9e2a235ca7a8c$var$baseIsMap(value) {
    return $eeeaa33c41c300ed$exports(value) && $6c015227ec5e02ad$exports(value) == $3be9e2a235ca7a8c$var$mapTag;
}
$3be9e2a235ca7a8c$exports = $3be9e2a235ca7a8c$var$baseIsMap;




var $i2urV = parcelRequire("i2urV");
/* Node.js helper references. */ var $09a059b505670e85$var$nodeIsMap = $i2urV && $i2urV.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $09a059b505670e85$var$isMap = $09a059b505670e85$var$nodeIsMap ? $b818c51b856e7d8e$exports($09a059b505670e85$var$nodeIsMap) : $3be9e2a235ca7a8c$exports;
$09a059b505670e85$exports = $09a059b505670e85$var$isMap;



var $9d560cb6898d253e$exports = {};
var $f279c516fe96054d$exports = {};


/** `Object#toString` result references. */ var $f279c516fe96054d$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $f279c516fe96054d$var$baseIsSet(value) {
    return $eeeaa33c41c300ed$exports(value) && $6c015227ec5e02ad$exports(value) == $f279c516fe96054d$var$setTag;
}
$f279c516fe96054d$exports = $f279c516fe96054d$var$baseIsSet;




var $i2urV = parcelRequire("i2urV");
/* Node.js helper references. */ var $9d560cb6898d253e$var$nodeIsSet = $i2urV && $i2urV.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $9d560cb6898d253e$var$isSet = $9d560cb6898d253e$var$nodeIsSet ? $b818c51b856e7d8e$exports($9d560cb6898d253e$var$nodeIsSet) : $f279c516fe96054d$exports;
$9d560cb6898d253e$exports = $9d560cb6898d253e$var$isSet;




/** Used to compose bitmasks for cloning. */ var $119f9d73f5e295d7$var$CLONE_DEEP_FLAG = 1, $119f9d73f5e295d7$var$CLONE_FLAT_FLAG = 2, $119f9d73f5e295d7$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $119f9d73f5e295d7$var$argsTag = '[object Arguments]', $119f9d73f5e295d7$var$arrayTag = '[object Array]', $119f9d73f5e295d7$var$boolTag = '[object Boolean]', $119f9d73f5e295d7$var$dateTag = '[object Date]', $119f9d73f5e295d7$var$errorTag = '[object Error]', $119f9d73f5e295d7$var$funcTag = '[object Function]', $119f9d73f5e295d7$var$genTag = '[object GeneratorFunction]', $119f9d73f5e295d7$var$mapTag = '[object Map]', $119f9d73f5e295d7$var$numberTag = '[object Number]', $119f9d73f5e295d7$var$objectTag = '[object Object]', $119f9d73f5e295d7$var$regexpTag = '[object RegExp]', $119f9d73f5e295d7$var$setTag = '[object Set]', $119f9d73f5e295d7$var$stringTag = '[object String]', $119f9d73f5e295d7$var$symbolTag = '[object Symbol]', $119f9d73f5e295d7$var$weakMapTag = '[object WeakMap]';
var $119f9d73f5e295d7$var$arrayBufferTag = '[object ArrayBuffer]', $119f9d73f5e295d7$var$dataViewTag = '[object DataView]', $119f9d73f5e295d7$var$float32Tag = '[object Float32Array]', $119f9d73f5e295d7$var$float64Tag = '[object Float64Array]', $119f9d73f5e295d7$var$int8Tag = '[object Int8Array]', $119f9d73f5e295d7$var$int16Tag = '[object Int16Array]', $119f9d73f5e295d7$var$int32Tag = '[object Int32Array]', $119f9d73f5e295d7$var$uint8Tag = '[object Uint8Array]', $119f9d73f5e295d7$var$uint8ClampedTag = '[object Uint8ClampedArray]', $119f9d73f5e295d7$var$uint16Tag = '[object Uint16Array]', $119f9d73f5e295d7$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $119f9d73f5e295d7$var$cloneableTags = {};
$119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$argsTag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$arrayTag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$arrayBufferTag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$dataViewTag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$boolTag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$dateTag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$float32Tag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$float64Tag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$int8Tag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$int16Tag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$int32Tag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$mapTag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$numberTag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$objectTag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$regexpTag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$setTag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$stringTag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$symbolTag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$uint8Tag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$uint8ClampedTag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$uint16Tag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$uint32Tag] = true;
$119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$errorTag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$funcTag] = $119f9d73f5e295d7$var$cloneableTags[$119f9d73f5e295d7$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $119f9d73f5e295d7$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $119f9d73f5e295d7$var$CLONE_DEEP_FLAG, isFlat = bitmask & $119f9d73f5e295d7$var$CLONE_FLAT_FLAG, isFull = bitmask & $119f9d73f5e295d7$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$3eb8329121eae2bf$exports(value)) return value;
    var isArr = $bfb6fd0a7f3a4f01$exports(value);
    if (isArr) {
        result = $274d1ce376f0f59b$exports(value);
        if (!isDeep) return $d8dfdfd97dac6836$exports(value, result);
    } else {
        var tag = $6c015227ec5e02ad$exports(value), isFunc = tag == $119f9d73f5e295d7$var$funcTag || tag == $119f9d73f5e295d7$var$genTag;
        if ($ey3Jv(value)) return $jexZI(value, isDeep);
        if (tag == $119f9d73f5e295d7$var$objectTag || tag == $119f9d73f5e295d7$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $f378eccaf2173f58$exports(value);
            if (!isDeep) return isFlat ? $20efdbfde4fba732$exports(value, $1eea773e9b4dfd98$exports(result, value)) : $ae898d679cd22077$exports(value, $b45a93f32a273c7a$exports(result, value));
        } else {
            if (!$119f9d73f5e295d7$var$cloneableTags[tag]) return object ? value : {};
            result = $43f51ab1e2f9aff5$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $79e5feaebbbdc67f$exports);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($9d560cb6898d253e$exports(value)) value.forEach(function(subValue) {
        result.add($119f9d73f5e295d7$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($09a059b505670e85$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $119f9d73f5e295d7$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $2b49db98ee717406$exports : $7658ec0048c18829$exports : isFlat ? $9899fbdec1d1721f$exports : $84f9d372f6c75fea$exports;
    var props = isArr ? undefined : keysFunc(value);
    $46443713f14ab726$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $402c26e404f07a2e$exports(result, key, $119f9d73f5e295d7$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$119f9d73f5e295d7$exports = $119f9d73f5e295d7$var$baseClone;


var $df34e432e7abf876$exports = {};

var $d640b6e7837ca6b4$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $d640b6e7837ca6b4$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$d640b6e7837ca6b4$exports = $d640b6e7837ca6b4$var$last;


var $a3f25ffaf3d04a4e$exports = {};


/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $a3f25ffaf3d04a4e$var$parent(object, path) {
    return path.length < 2 ? object : $a033fa5a331356cc$exports(object, $51476ae3b005f3c6$exports(path, 0, -1));
}
$a3f25ffaf3d04a4e$exports = $a3f25ffaf3d04a4e$var$parent;



/** Used for built-in method references. */ var $df34e432e7abf876$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $df34e432e7abf876$var$hasOwnProperty = $df34e432e7abf876$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $df34e432e7abf876$var$baseUnset(object, path) {
    path = $4000b4d8c4db7a40$exports(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $9ba58b0a05f59856$exports(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$df34e432e7abf876$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $a3f25ffaf3d04a4e$exports(object, path);
    return obj == null || delete obj[$9ba58b0a05f59856$exports($d640b6e7837ca6b4$exports(path))];
}
$df34e432e7abf876$exports = $df34e432e7abf876$var$baseUnset;




var $dc9eb24b6f5105a9$exports = {};
var $4d1c1fa80bf6fd50$exports = {};



/** `Object#toString` result references. */ var $4d1c1fa80bf6fd50$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $4d1c1fa80bf6fd50$var$funcProto = Function.prototype, $4d1c1fa80bf6fd50$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $4d1c1fa80bf6fd50$var$funcToString = $4d1c1fa80bf6fd50$var$funcProto.toString;
/** Used to check objects for own properties. */ var $4d1c1fa80bf6fd50$var$hasOwnProperty = $4d1c1fa80bf6fd50$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $4d1c1fa80bf6fd50$var$objectCtorString = $4d1c1fa80bf6fd50$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $4d1c1fa80bf6fd50$var$isPlainObject(value) {
    if (!$eeeaa33c41c300ed$exports(value) || $2bee838a2d69c279$exports(value) != $4d1c1fa80bf6fd50$var$objectTag) return false;
    var proto = $7c5953eaddbe31c2$exports(value);
    if (proto === null) return true;
    var Ctor = $4d1c1fa80bf6fd50$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $4d1c1fa80bf6fd50$var$funcToString.call(Ctor) == $4d1c1fa80bf6fd50$var$objectCtorString;
}
$4d1c1fa80bf6fd50$exports = $4d1c1fa80bf6fd50$var$isPlainObject;


/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $dc9eb24b6f5105a9$var$customOmitClone(value) {
    return $4d1c1fa80bf6fd50$exports(value) ? undefined : value;
}
$dc9eb24b6f5105a9$exports = $dc9eb24b6f5105a9$var$customOmitClone;


var $a3ffe62283786b24$exports = {};
var $94adacf635ff58a3$exports = {};

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $94adacf635ff58a3$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $44f1c307f9859dfd$exports(array, 1) : [];
}
$94adacf635ff58a3$exports = $94adacf635ff58a3$var$flatten;




/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $a3ffe62283786b24$var$flatRest(func) {
    return $5029ec0a4922e637$exports($791e20d15bca2267$exports(func, undefined, $94adacf635ff58a3$exports), func + '');
}
$a3ffe62283786b24$exports = $a3ffe62283786b24$var$flatRest;



/** Used to compose bitmasks for cloning. */ var $adbc5e5ed3bd9f01$var$CLONE_DEEP_FLAG = 1, $adbc5e5ed3bd9f01$var$CLONE_FLAT_FLAG = 2, $adbc5e5ed3bd9f01$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $adbc5e5ed3bd9f01$var$omit = $a3ffe62283786b24$exports(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $f3999e86c9d7b521$exports(paths, function(path) {
        path = $4000b4d8c4db7a40$exports(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $d04fab20f3b3cd21$exports(object, $2b49db98ee717406$exports(object), result);
    if (isDeep) result = $119f9d73f5e295d7$exports(result, $adbc5e5ed3bd9f01$var$CLONE_DEEP_FLAG | $adbc5e5ed3bd9f01$var$CLONE_FLAT_FLAG | $adbc5e5ed3bd9f01$var$CLONE_SYMBOLS_FLAG, $dc9eb24b6f5105a9$exports);
    var length = paths.length;
    while(length--)$df34e432e7abf876$exports(result, paths[length]);
    return result;
});
$adbc5e5ed3bd9f01$exports = $adbc5e5ed3bd9f01$var$omit;


var $ace71a80aaafdfb0$exports = {};







var $ey3Jv = parcelRequire("ey3Jv");



/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */ function $ace71a80aaafdfb0$var$transform(object, iteratee, accumulator) {
    var isArr = $bfb6fd0a7f3a4f01$exports(object), isArrLike = isArr || $ey3Jv(object) || $2335228ab76a41ec$exports(object);
    iteratee = $d1fad1d76f5c17a2$exports(iteratee, 4);
    if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) accumulator = isArr ? new Ctor : [];
        else if ($3eb8329121eae2bf$exports(object)) accumulator = $323a1d4ebc031189$exports(Ctor) ? $560551df184ad264$exports($7c5953eaddbe31c2$exports(object)) : {};
        else accumulator = {};
    }
    (isArrLike ? $46443713f14ab726$exports : $d8667f7a45debfd2$exports)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
    });
    return accumulator;
}
$ace71a80aaafdfb0$exports = $ace71a80aaafdfb0$var$transform;


var $559e71256bc2de9f$exports = {};
!function(e, i) {
    $559e71256bc2de9f$exports = i();
}($559e71256bc2de9f$exports, function() {
    "use strict";
    return function(e, i, t) {
        i.prototype.isBetween = function(e, i, s, f) {
            var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
    };
});


var $cfb78c20cf088101$exports = {};
!function(e, t) {
    $cfb78c20cf088101$exports = t();
}($cfb78c20cf088101$exports, function() {
    "use strict";
    return function(e, t) {
        t.prototype.isSameOrAfter = function(e, t) {
            return this.isSame(e, t) || this.isAfter(e, t);
        };
    };
});


var $66bbd4964f91cc0c$exports = {};
!function(e, i) {
    $66bbd4964f91cc0c$exports = i();
}($66bbd4964f91cc0c$exports, function() {
    "use strict";
    return function(e, i) {
        i.prototype.isSameOrBefore = function(e, i) {
            return this.isSame(e, i) || this.isBefore(e, i);
        };
    };
});


var $60ceee39fbfa7b0b$exports = {};
!function(n, e) {
    $60ceee39fbfa7b0b$exports = e();
}($60ceee39fbfa7b0b$exports, function() {
    "use strict";
    return function(n, e, t) {
        var r = e.prototype, o = function(n) {
            return n && (n.indexOf ? n : n.s);
        }, u = function(n, e, t, r, u) {
            var i = n.name ? n : n.$locale(), a = o(i[e]), s = o(i[t]), f = a || s.map(function(n) {
                return n.slice(0, r);
            });
            if (!u) return f;
            var d = i.weekStart;
            return f.map(function(n, e) {
                return f[(e + (d || 0)) % 7];
            });
        }, i = function() {
            return t.Ls[t.locale()];
        }, a = function(n, e) {
            return n.formats[e] || function(n) {
                return n.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(n, e, t) {
                    return e || t.slice(1);
                });
            }(n.formats[e.toUpperCase()]);
        }, s = function() {
            var n = this;
            return {
                months: function(e) {
                    return e ? e.format("MMMM") : u(n, "months");
                },
                monthsShort: function(e) {
                    return e ? e.format("MMM") : u(n, "monthsShort", "months", 3);
                },
                firstDayOfWeek: function() {
                    return n.$locale().weekStart || 0;
                },
                weekdays: function(e) {
                    return e ? e.format("dddd") : u(n, "weekdays");
                },
                weekdaysMin: function(e) {
                    return e ? e.format("dd") : u(n, "weekdaysMin", "weekdays", 2);
                },
                weekdaysShort: function(e) {
                    return e ? e.format("ddd") : u(n, "weekdaysShort", "weekdays", 3);
                },
                longDateFormat: function(e) {
                    return a(n.$locale(), e);
                },
                meridiem: this.$locale().meridiem,
                ordinal: this.$locale().ordinal
            };
        };
        r.localeData = function() {
            return s.bind(this)();
        }, t.localeData = function() {
            var n = i();
            return {
                firstDayOfWeek: function() {
                    return n.weekStart || 0;
                },
                weekdays: function() {
                    return t.weekdays();
                },
                weekdaysShort: function() {
                    return t.weekdaysShort();
                },
                weekdaysMin: function() {
                    return t.weekdaysMin();
                },
                months: function() {
                    return t.months();
                },
                monthsShort: function() {
                    return t.monthsShort();
                },
                longDateFormat: function(e) {
                    return a(n, e);
                },
                meridiem: n.meridiem,
                ordinal: n.ordinal
            };
        }, t.months = function() {
            return u(i(), "months");
        }, t.monthsShort = function() {
            return u(i(), "monthsShort", "months", 3);
        }, t.weekdays = function(n) {
            return u(i(), "weekdays", null, null, n);
        }, t.weekdaysShort = function(n) {
            return u(i(), "weekdaysShort", "weekdays", 3, n);
        }, t.weekdaysMin = function(n) {
            return u(i(), "weekdaysMin", "weekdays", 2, n);
        };
    };
});



var $22bc16777e706ced$exports = {};
!function(e, n) {
    $22bc16777e706ced$exports = n();
}($22bc16777e706ced$exports, function() {
    "use strict";
    return function(e, n, t) {
        var i = function(e, n) {
            if (!n || !n.length || 1 === n.length && !n[0] || 1 === n.length && Array.isArray(n[0]) && !n[0].length) return null;
            var t;
            1 === n.length && n[0].length > 0 && (n = n[0]);
            t = (n = n.filter(function(e) {
                return e;
            }))[0];
            for(var i = 1; i < n.length; i += 1)n[i].isValid() && !n[i][e](t) || (t = n[i]);
            return t;
        };
        t.max = function() {
            var e = [].slice.call(arguments, 0);
            return i("isAfter", e);
        }, t.min = function() {
            var e = [].slice.call(arguments, 0);
            return i("isBefore", e);
        };
    };
});


var $35aece7ad906b57b$exports = {};
!function(t, i) {
    $35aece7ad906b57b$exports = i();
}($35aece7ad906b57b$exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var r = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), r.call(this, t);
        };
        var o = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else o.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s;
            if (0 === u) return this.utc(f);
            var r = this.clone();
            if (f) return r.$offset = u, r.$u = !1, r;
            var o = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            return (r = this.local().add(u + o, t)).$offset = u, r.$x.$localOffset = o, r;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});


var $209ec42a43e4e1db$exports = {};
!function(e, t) {
    $209ec42a43e4e1db$exports = t();
}($209ec42a43e4e1db$exports, function() {
    "use strict";
    return function(e, t) {
        t.prototype.isLeapYear = function() {
            return this.$y % 4 == 0 && this.$y % 100 != 0 || this.$y % 400 == 0;
        };
    };
});


function $f145fa6d412a8ce0$var$NoopWrapper(props) {
    return props.children;
}
var $f145fa6d412a8ce0$export$444b3ab0cb9aec40 = {
    PREVIOUS: 'PREV',
    NEXT: 'NEXT',
    TODAY: 'TODAY',
    DATE: 'DATE'
};
var $f145fa6d412a8ce0$export$5cb791131c501f6a = {
    MONTH: 'month',
    WEEK: 'week',
    WORK_WEEK: 'work_week',
    DAY: 'day',
    AGENDA: 'agenda'
};
var $f145fa6d412a8ce0$var$viewNames$1 = Object.keys($f145fa6d412a8ce0$export$5cb791131c501f6a).map(function(k) {
    return $f145fa6d412a8ce0$export$5cb791131c501f6a[k];
});
(0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func
]);
(0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).any;
(0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func;
/**
 * accepts either an array of builtin view names:
 *
 * ```
 * views={['month', 'day', 'agenda']}
 * ```
 *
 * or an object hash of the view name and the component (or boolean for builtin)
 *
 * ```
 * views={{
 *   month: true,
 *   week: false,
 *   workweek: WorkWeekViewComponent,
 * }}
 * ```
 */ (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).oneOf($f145fa6d412a8ce0$var$viewNames$1)),
    (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).objectOf(function(prop, key) {
        var isBuiltinView = $f145fa6d412a8ce0$var$viewNames$1.indexOf(key) !== -1 && typeof prop[key] === 'boolean';
        if (isBuiltinView) return null;
        else {
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
            return (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).elementType.apply((0, (/*@__PURE__*/$parcel$interopDefault($awzbB))), [
                prop,
                key
            ].concat(args));
        }
    })
]);
(0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).oneOf([
        'overlap',
        'no-overlap'
    ]),
    (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func
]);
/* eslint no-fallthrough: off */ var $f145fa6d412a8ce0$var$MILLI = {
    seconds: 1000,
    minutes: 60000,
    hours: 3600000,
    day: 86400000
};
function $f145fa6d412a8ce0$var$firstVisibleDay(date, localizer) {
    var firstOfMonth = $f8eddd003dbc1436$exports.startOf(date, 'month');
    return $f8eddd003dbc1436$exports.startOf(firstOfMonth, 'week', localizer.startOfWeek());
}
function $f145fa6d412a8ce0$var$lastVisibleDay(date, localizer) {
    var endOfMonth = $f8eddd003dbc1436$exports.endOf(date, 'month');
    return $f8eddd003dbc1436$exports.endOf(endOfMonth, 'week', localizer.startOfWeek());
}
function $f145fa6d412a8ce0$var$visibleDays(date, localizer) {
    var current = $f145fa6d412a8ce0$var$firstVisibleDay(date, localizer), last = $f145fa6d412a8ce0$var$lastVisibleDay(date, localizer), days = [];
    while($f8eddd003dbc1436$exports.lte(current, last, 'day')){
        days.push(current);
        current = $f8eddd003dbc1436$exports.add(current, 1, 'day');
    }
    return days;
}
function $f145fa6d412a8ce0$var$ceil(date, unit) {
    var floor = $f8eddd003dbc1436$exports.startOf(date, unit);
    return $f8eddd003dbc1436$exports.eq(floor, date) ? floor : $f8eddd003dbc1436$exports.add(floor, 1, unit);
}
function $f145fa6d412a8ce0$var$range(start, end) {
    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
    var current = start, days = [];
    while($f8eddd003dbc1436$exports.lte(current, end, unit)){
        days.push(current);
        current = $f8eddd003dbc1436$exports.add(current, 1, unit);
    }
    return days;
}
function $f145fa6d412a8ce0$var$merge(date, time) {
    if (time == null && date == null) return null;
    if (time == null) time = new Date();
    if (date == null) date = new Date();
    date = $f8eddd003dbc1436$exports.startOf(date, 'day');
    date = $f8eddd003dbc1436$exports.hours(date, $f8eddd003dbc1436$exports.hours(time));
    date = $f8eddd003dbc1436$exports.minutes(date, $f8eddd003dbc1436$exports.minutes(time));
    date = $f8eddd003dbc1436$exports.seconds(date, $f8eddd003dbc1436$exports.seconds(time));
    return $f8eddd003dbc1436$exports.milliseconds(date, $f8eddd003dbc1436$exports.milliseconds(time));
}
function $f145fa6d412a8ce0$var$isJustDate(date) {
    return $f8eddd003dbc1436$exports.hours(date) === 0 && $f8eddd003dbc1436$exports.minutes(date) === 0 && $f8eddd003dbc1436$exports.seconds(date) === 0 && $f8eddd003dbc1436$exports.milliseconds(date) === 0;
}
function $f145fa6d412a8ce0$var$duration(start, end, unit, firstOfWeek) {
    if (unit === 'day') unit = 'date';
    return Math.abs(// eslint-disable-next-line import/namespace
    $f8eddd003dbc1436$exports[unit](start, undefined, firstOfWeek) - // eslint-disable-next-line import/namespace
    $f8eddd003dbc1436$exports[unit](end, undefined, firstOfWeek));
}
function $f145fa6d412a8ce0$var$diff(dateA, dateB, unit) {
    if (!unit || unit === 'milliseconds') return Math.abs(+dateA - +dateB);
    // the .round() handles an edge case
    // with DST where the total won't be exact
    // since one day in the range may be shorter/longer by an hour
    return Math.round(Math.abs(+$f8eddd003dbc1436$exports.startOf(dateA, unit) / $f145fa6d412a8ce0$var$MILLI[unit] - +$f8eddd003dbc1436$exports.startOf(dateB, unit) / $f145fa6d412a8ce0$var$MILLI[unit]));
}
var $f145fa6d412a8ce0$var$localePropType = (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func
]);
function $f145fa6d412a8ce0$var$_format(localizer, formatter, value, format, culture) {
    var result = typeof format === 'function' ? format(value, culture, localizer) : formatter.call(localizer, value, format, culture);
    (0, (/*@__PURE__*/$parcel$interopDefault($466b99331d7e73e3$exports)))(result == null || typeof result === 'string', '`localizer format(..)` must return a string, null, or undefined');
    return result;
}
/**
 * This date conversion was moved out of TimeSlots.js, to
 * allow for localizer override
 * @param {Date} dt - The date to start from
 * @param {Number} minutesFromMidnight
 * @param {Number} offset
 * @returns {Date}
 */ function $f145fa6d412a8ce0$var$getSlotDate(dt, minutesFromMidnight, offset) {
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 0, minutesFromMidnight + offset, 0, 0);
}
function $f145fa6d412a8ce0$var$getDstOffset(start, end) {
    return start.getTimezoneOffset() - end.getTimezoneOffset();
}
// if the start is on a DST-changing day but *after* the moment of DST
// transition we need to add those extra minutes to our minutesFromMidnight
function $f145fa6d412a8ce0$var$getTotalMin(start, end) {
    return $f145fa6d412a8ce0$var$diff(start, end, 'minutes') + $f145fa6d412a8ce0$var$getDstOffset(start, end);
}
function $f145fa6d412a8ce0$var$getMinutesFromMidnight(start) {
    var daystart = (0, $f8eddd003dbc1436$export$38d7278c783c77a7)(start, 'day');
    return $f145fa6d412a8ce0$var$diff(daystart, start, 'minutes') + $f145fa6d412a8ce0$var$getDstOffset(daystart, start);
}
// These two are used by DateSlotMetrics
function $f145fa6d412a8ce0$var$continuesPrior(start, first) {
    return (0, $f8eddd003dbc1436$export$b961576059b7aeb6)(start, first, 'day');
}
function $f145fa6d412a8ce0$var$continuesAfter(start, end, last) {
    var singleDayDuration = (0, $f8eddd003dbc1436$export$9663ddc1cf085b32)(start, end, 'minutes');
    return singleDayDuration ? (0, $f8eddd003dbc1436$export$aac79e834d1b4aed)(end, last, 'minutes') : (0, $f8eddd003dbc1436$export$dafeacbfe3530cd9)(end, last, 'minutes');
}
function $f145fa6d412a8ce0$var$daySpan(start, end) {
    return $f145fa6d412a8ce0$var$duration(start, end, 'day');
}
// These two are used by eventLevels
function $f145fa6d412a8ce0$var$sortEvents$1(_ref) {
    var _ref$evtA = _ref.evtA, aStart = _ref$evtA.start, aEnd = _ref$evtA.end, aAllDay = _ref$evtA.allDay, _ref$evtB = _ref.evtB, bStart = _ref$evtB.start, bEnd = _ref$evtB.end, bAllDay = _ref$evtB.allDay;
    var startSort = +(0, $f8eddd003dbc1436$export$38d7278c783c77a7)(aStart, 'day') - +(0, $f8eddd003dbc1436$export$38d7278c783c77a7)(bStart, 'day');
    var durA = $f145fa6d412a8ce0$var$daySpan(aStart, aEnd);
    var durB = $f145fa6d412a8ce0$var$daySpan(bStart, bEnd);
    return startSort || // sort by start Day first
    durB - durA || // events spanning multiple days go first
    !!bAllDay - !!aAllDay || // then allDay single day events
    +aStart - +bStart || // then sort by start time
    +aEnd - +bEnd // then sort by end time
    ;
}
function $f145fa6d412a8ce0$var$inEventRange(_ref2) {
    var _ref2$event = _ref2.event, start = _ref2$event.start, end = _ref2$event.end, _ref2$range = _ref2.range, rangeStart = _ref2$range.start, rangeEnd = _ref2$range.end;
    var eStart = (0, $f8eddd003dbc1436$export$38d7278c783c77a7)(start, 'day');
    var startsBeforeEnd = (0, $f8eddd003dbc1436$export$489c007ed603c05d)(eStart, rangeEnd, 'day');
    // when the event is zero duration we need to handle a bit differently
    var sameMin = (0, $f8eddd003dbc1436$export$9bc858421bf255d1)(eStart, end, 'minutes');
    var endsAfterStart = sameMin ? (0, $f8eddd003dbc1436$export$dafeacbfe3530cd9)(end, rangeStart, 'minutes') : (0, $f8eddd003dbc1436$export$aac79e834d1b4aed)(end, rangeStart, 'minutes');
    return startsBeforeEnd && endsAfterStart;
}
// other localizers treats 'day' and 'date' equality very differently, so we
// abstract the change the 'localizer.eq(date1, date2, 'day') into this
// new method, where they can be treated correctly by the localizer overrides
function $f145fa6d412a8ce0$var$isSameDate(date1, date2) {
    return (0, $f8eddd003dbc1436$export$9663ddc1cf085b32)(date1, date2, 'day');
}
function $f145fa6d412a8ce0$var$startAndEndAreDateOnly(start, end) {
    return $f145fa6d412a8ce0$var$isJustDate(start) && $f145fa6d412a8ce0$var$isJustDate(end);
}
var $f145fa6d412a8ce0$export$193ddab16544ff5b = /*#__PURE__*/ (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(function DateLocalizer(spec) {
    var _this = this;
    (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, DateLocalizer);
    (0, (/*@__PURE__*/$parcel$interopDefault($466b99331d7e73e3$exports)))(typeof spec.format === 'function', 'date localizer `format(..)` must be a function');
    (0, (/*@__PURE__*/$parcel$interopDefault($466b99331d7e73e3$exports)))(typeof spec.firstOfWeek === 'function', 'date localizer `firstOfWeek(..)` must be a function');
    this.propType = spec.propType || $f145fa6d412a8ce0$var$localePropType;
    this.formats = spec.formats;
    this.format = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return $f145fa6d412a8ce0$var$_format.apply(void 0, [
            _this,
            spec.format
        ].concat(args));
    };
    // These date arithmetic methods can be overriden by the localizer
    this.startOfWeek = spec.firstOfWeek;
    this.merge = spec.merge || $f145fa6d412a8ce0$var$merge;
    this.inRange = spec.inRange || (0, $f8eddd003dbc1436$export$ddf89a9c5af38f94);
    this.lt = spec.lt || (0, $f8eddd003dbc1436$export$b961576059b7aeb6);
    this.lte = spec.lte || (0, $f8eddd003dbc1436$export$489c007ed603c05d);
    this.gt = spec.gt || (0, $f8eddd003dbc1436$export$dafeacbfe3530cd9);
    this.gte = spec.gte || (0, $f8eddd003dbc1436$export$aac79e834d1b4aed);
    this.eq = spec.eq || (0, $f8eddd003dbc1436$export$9663ddc1cf085b32);
    this.neq = spec.neq || (0, $f8eddd003dbc1436$export$9bc858421bf255d1);
    this.startOf = spec.startOf || (0, $f8eddd003dbc1436$export$38d7278c783c77a7);
    this.endOf = spec.endOf || (0, $f8eddd003dbc1436$export$2d3c3037220ab47a);
    this.add = spec.add || (0, $f8eddd003dbc1436$export$e16d8520af44a096);
    this.range = spec.range || $f145fa6d412a8ce0$var$range;
    this.diff = spec.diff || $f145fa6d412a8ce0$var$diff;
    this.ceil = spec.ceil || $f145fa6d412a8ce0$var$ceil;
    this.min = spec.min || (0, $f8eddd003dbc1436$export$96ec731ed4dcb222);
    this.max = spec.max || (0, $f8eddd003dbc1436$export$8960430cfd85939f);
    this.minutes = spec.minutes || (0, $f8eddd003dbc1436$export$666252b437cce0c7);
    this.daySpan = spec.daySpan || $f145fa6d412a8ce0$var$daySpan;
    this.firstVisibleDay = spec.firstVisibleDay || $f145fa6d412a8ce0$var$firstVisibleDay;
    this.lastVisibleDay = spec.lastVisibleDay || $f145fa6d412a8ce0$var$lastVisibleDay;
    this.visibleDays = spec.visibleDays || $f145fa6d412a8ce0$var$visibleDays;
    this.getSlotDate = spec.getSlotDate || $f145fa6d412a8ce0$var$getSlotDate;
    this.getTimezoneOffset = spec.getTimezoneOffset || function(value) {
        return value.getTimezoneOffset();
    };
    this.getDstOffset = spec.getDstOffset || $f145fa6d412a8ce0$var$getDstOffset;
    this.getTotalMin = spec.getTotalMin || $f145fa6d412a8ce0$var$getTotalMin;
    this.getMinutesFromMidnight = spec.getMinutesFromMidnight || $f145fa6d412a8ce0$var$getMinutesFromMidnight;
    this.continuesPrior = spec.continuesPrior || $f145fa6d412a8ce0$var$continuesPrior;
    this.continuesAfter = spec.continuesAfter || $f145fa6d412a8ce0$var$continuesAfter;
    this.sortEvents = spec.sortEvents || $f145fa6d412a8ce0$var$sortEvents$1;
    this.inEventRange = spec.inEventRange || $f145fa6d412a8ce0$var$inEventRange;
    this.isSameDate = spec.isSameDate || $f145fa6d412a8ce0$var$isSameDate;
    this.startAndEndAreDateOnly = spec.startAndEndAreDateOnly || $f145fa6d412a8ce0$var$startAndEndAreDateOnly;
    this.segmentOffset = spec.browserTZOffset ? spec.browserTZOffset() : 0;
});
function $f145fa6d412a8ce0$var$mergeWithDefaults(localizer, culture, formatOverrides, messages) {
    var formats = (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, localizer.formats), formatOverrides);
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, localizer), {}, {
        messages: messages,
        startOfWeek: function startOfWeek() {
            return localizer.startOfWeek(culture);
        },
        format: function format(value, _format2) {
            return localizer.format(value, formats[_format2] || _format2, culture);
        }
    });
}
var $f145fa6d412a8ce0$var$Toolbar = /*#__PURE__*/ function(_React$Component) {
    function Toolbar() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, Toolbar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $db22c8b683e5147b$export$2e2bcd8739ae039)(this, Toolbar, [].concat(args));
        _this.navigate = function(action) {
            _this.props.onNavigate(action);
        };
        _this.view = function(view) {
            _this.props.onView(view);
        };
        return _this;
    }
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(Toolbar, _React$Component);
    return (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(Toolbar, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, messages = _this$props.localizer.messages, label = _this$props.label;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                    className: "rbc-toolbar"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("span", {
                    className: "rbc-btn-group"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("button", {
                    type: "button",
                    onClick: this.navigate.bind(null, $f145fa6d412a8ce0$export$444b3ab0cb9aec40.TODAY)
                }, messages.today), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("button", {
                    type: "button",
                    onClick: this.navigate.bind(null, $f145fa6d412a8ce0$export$444b3ab0cb9aec40.PREVIOUS)
                }, messages.previous), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("button", {
                    type: "button",
                    onClick: this.navigate.bind(null, $f145fa6d412a8ce0$export$444b3ab0cb9aec40.NEXT)
                }, messages.next)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("span", {
                    className: "rbc-toolbar-label"
                }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("span", {
                    className: "rbc-btn-group"
                }, this.viewNamesGroup(messages)));
            }
        },
        {
            key: "viewNamesGroup",
            value: function viewNamesGroup(messages) {
                var _this2 = this;
                var viewNames = this.props.views;
                var view = this.props.view;
                if (viewNames.length > 1) return viewNames.map(function(name) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("button", {
                        type: "button",
                        key: name,
                        className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)({
                            'rbc-active': view === name
                        }),
                        onClick: _this2.view.bind(null, name)
                    }, messages[name]);
                });
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Component);
function $f145fa6d412a8ce0$var$notify(handler, args) {
    handler && handler.apply(null, [].concat(args));
}
var $f145fa6d412a8ce0$var$defaultMessages = {
    date: 'Date',
    time: 'Time',
    event: 'Event',
    allDay: 'All Day',
    week: 'Week',
    work_week: 'Work Week',
    day: 'Day',
    month: 'Month',
    previous: 'Back',
    next: 'Next',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    today: 'Today',
    agenda: 'Agenda',
    noEventsInRange: 'There are no events in this range.',
    showMore: function showMore(total) {
        return "+".concat(total, " more");
    }
};
function $f145fa6d412a8ce0$var$messages(msgs) {
    return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, $f145fa6d412a8ce0$var$defaultMessages), msgs);
}
function $f145fa6d412a8ce0$var$useClickOutside(_ref) {
    var ref = _ref.ref, callback = _ref.callback;
    (0, $gRqVZ.useEffect)(function() {
        var handleClickOutside = function handleClickOutside(e) {
            if (ref.current && !ref.current.contains(e.target)) callback();
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function() {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        ref,
        callback
    ]);
}
var $f145fa6d412a8ce0$var$_excluded$7 = [
    "style",
    "className",
    "event",
    "selected",
    "isAllDay",
    "onSelect",
    "onDoubleClick",
    "onKeyPress",
    "localizer",
    "continuesPrior",
    "continuesAfter",
    "accessors",
    "getters",
    "children",
    "components",
    "slotStart",
    "slotEnd"
];
var $f145fa6d412a8ce0$var$EventCell = /*#__PURE__*/ function(_React$Component) {
    function EventCell() {
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, EventCell);
        return (0, $db22c8b683e5147b$export$2e2bcd8739ae039)(this, EventCell, arguments);
    }
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(EventCell, _React$Component);
    return (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(EventCell, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, style = _this$props.style, className = _this$props.className, event = _this$props.event, selected = _this$props.selected, isAllDay = _this$props.isAllDay, onSelect = _this$props.onSelect, _onDoubleClick = _this$props.onDoubleClick, onKeyPress = _this$props.onKeyPress, localizer = _this$props.localizer, continuesPrior = _this$props.continuesPrior, continuesAfter = _this$props.continuesAfter, accessors = _this$props.accessors, getters = _this$props.getters, children = _this$props.children, _this$props$component = _this$props.components, Event = _this$props$component.event, EventWrapper = _this$props$component.eventWrapper, slotStart = _this$props.slotStart, slotEnd = _this$props.slotEnd, props = (0, $f308b666a2f706a5$export$2e2bcd8739ae039)(_this$props, $f145fa6d412a8ce0$var$_excluded$7);
                delete props.resizable;
                var title = accessors.title(event);
                var tooltip = accessors.tooltip(event);
                var end = accessors.end(event);
                var start = accessors.start(event);
                var allDay = accessors.allDay(event);
                var showAsAllDay = isAllDay || allDay || localizer.diff(start, localizer.ceil(end, 'day'), 'day') > 1;
                var userProps = getters.eventProp(event, start, end, selected);
                var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                    className: "rbc-event-content",
                    title: tooltip || undefined
                }, Event ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(Event, {
                    event: event,
                    continuesPrior: continuesPrior,
                    continuesAfter: continuesAfter,
                    title: title,
                    isAllDay: allDay,
                    localizer: localizer,
                    slotStart: slotStart,
                    slotEnd: slotEnd
                }) : title);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(EventWrapper, Object.assign({}, this.props, {
                    type: "date"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", Object.assign({}, props, {
                    style: (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, userProps.style), style),
                    className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)('rbc-event', className, userProps.className, {
                        'rbc-selected': selected,
                        'rbc-event-allday': showAsAllDay,
                        'rbc-event-continues-prior': continuesPrior,
                        'rbc-event-continues-after': continuesAfter
                    }),
                    onClick: function onClick(e) {
                        return onSelect && onSelect(event, e);
                    },
                    onDoubleClick: function onDoubleClick(e) {
                        return _onDoubleClick && _onDoubleClick(event, e);
                    },
                    onKeyDown: function onKeyDown(e) {
                        return onKeyPress && onKeyPress(event, e);
                    }
                }), typeof children === 'function' ? children(content) : content));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Component);
function $f145fa6d412a8ce0$var$isSelected(event, selected) {
    if (!event || selected == null) return false;
    return (0, (/*@__PURE__*/$parcel$interopDefault($56a939b6be7c5af5$exports)))(event, selected);
}
function $f145fa6d412a8ce0$var$slotWidth(rowBox, slots) {
    var rowWidth = rowBox.right - rowBox.left;
    var cellWidth = rowWidth / slots;
    return cellWidth;
}
function $f145fa6d412a8ce0$var$getSlotAtX(rowBox, x, rtl, slots) {
    var cellWidth = $f145fa6d412a8ce0$var$slotWidth(rowBox, slots);
    return rtl ? slots - 1 - Math.floor((x - rowBox.left) / cellWidth) : Math.floor((x - rowBox.left) / cellWidth);
}
function $f145fa6d412a8ce0$var$pointInBox(box, _ref) {
    var x = _ref.x, y = _ref.y;
    return y >= box.top && y <= box.bottom && x >= box.left && x <= box.right;
}
function $f145fa6d412a8ce0$var$dateCellSelection(start, rowBox, box, slots, rtl) {
    var startIdx = -1;
    var endIdx = -1;
    var lastSlotIdx = slots - 1;
    var cellWidth = $f145fa6d412a8ce0$var$slotWidth(rowBox, slots);
    // cell under the mouse
    var currentSlot = $f145fa6d412a8ce0$var$getSlotAtX(rowBox, box.x, rtl, slots);
    // Identify row as either the initial row
    // or the row under the current mouse point
    var isCurrentRow = rowBox.top < box.y && rowBox.bottom > box.y;
    var isStartRow = rowBox.top < start.y && rowBox.bottom > start.y;
    // this row's position relative to the start point
    var isAboveStart = start.y > rowBox.bottom;
    var isBelowStart = rowBox.top > start.y;
    var isBetween = box.top < rowBox.top && box.bottom > rowBox.bottom;
    // this row is between the current and start rows, so entirely selected
    if (isBetween) {
        startIdx = 0;
        endIdx = lastSlotIdx;
    }
    if (isCurrentRow) {
        if (isBelowStart) {
            startIdx = 0;
            endIdx = currentSlot;
        } else if (isAboveStart) {
            startIdx = currentSlot;
            endIdx = lastSlotIdx;
        }
    }
    if (isStartRow) {
        // select the cell under the initial point
        startIdx = endIdx = rtl ? lastSlotIdx - Math.floor((start.x - rowBox.left) / cellWidth) : Math.floor((start.x - rowBox.left) / cellWidth);
        if (isCurrentRow) {
            if (currentSlot < startIdx) startIdx = currentSlot;
            else endIdx = currentSlot; //select current range
        } else if (start.y < box.y) // the current row is below start row
        // select cells to the right of the start cell
        endIdx = lastSlotIdx;
        else // select cells to the left of the start cell
        startIdx = 0;
    }
    return {
        startIdx: startIdx,
        endIdx: endIdx
    };
}
/**
 * Changes to react-overlays cause issue with auto positioning,
 * so we need to manually calculate the position of the popper,
 * and constrain it to the Month container.
 */ function $f145fa6d412a8ce0$var$getPosition(_ref) {
    var target = _ref.target, offset = _ref.offset, container = _ref.container, box = _ref.box;
    var _getOffset = (0, $2f02d0066d00e531$export$2e2bcd8739ae039)(target), top = _getOffset.top, left = _getOffset.left, width = _getOffset.width, height = _getOffset.height;
    var _getOffset2 = (0, $2f02d0066d00e531$export$2e2bcd8739ae039)(container), cTop = _getOffset2.top, cLeft = _getOffset2.left, cWidth = _getOffset2.width, cHeight = _getOffset2.height;
    var _getOffset3 = (0, $2f02d0066d00e531$export$2e2bcd8739ae039)(box), bWidth = _getOffset3.width, bHeight = _getOffset3.height;
    var viewBottom = cTop + cHeight;
    var viewRight = cLeft + cWidth;
    var bottom = top + bHeight;
    var right = left + bWidth;
    var x = offset.x, y = offset.y;
    var topOffset = bottom > viewBottom ? top - bHeight - y : top + y + height;
    var leftOffset = right > viewRight ? left + x - bWidth + width : left + x;
    return {
        topOffset: topOffset,
        leftOffset: leftOffset
    };
}
function $f145fa6d412a8ce0$var$Pop(_ref2) {
    var containerRef = _ref2.containerRef, accessors = _ref2.accessors, getters = _ref2.getters, selected = _ref2.selected, components = _ref2.components, localizer = _ref2.localizer, position = _ref2.position, show = _ref2.show, events = _ref2.events, slotStart = _ref2.slotStart, slotEnd = _ref2.slotEnd, onSelect = _ref2.onSelect, onDoubleClick = _ref2.onDoubleClick, onKeyPress = _ref2.onKeyPress, handleDragStart = _ref2.handleDragStart, popperRef = _ref2.popperRef, target = _ref2.target, offset = _ref2.offset;
    $f145fa6d412a8ce0$var$useClickOutside({
        ref: popperRef,
        callback: show
    });
    (0, $gRqVZ.useLayoutEffect)(function() {
        var _getPosition = $f145fa6d412a8ce0$var$getPosition({
            target: target,
            offset: offset,
            container: containerRef.current,
            box: popperRef.current
        }), topOffset = _getPosition.topOffset, leftOffset = _getPosition.leftOffset;
        popperRef.current.style.top = "".concat(topOffset, "px");
        popperRef.current.style.left = "".concat(leftOffset, "px");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        offset.x,
        offset.y,
        target
    ]);
    var width = position.width;
    var style = {
        minWidth: width + width / 2
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
        style: style,
        className: "rbc-overlay",
        ref: popperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
        className: "rbc-overlay-header"
    }, localizer.format(slotStart, 'dayHeaderFormat')), events.map(function(event, idx) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$EventCell, {
            key: idx,
            type: "popup",
            localizer: localizer,
            event: event,
            getters: getters,
            onSelect: onSelect,
            accessors: accessors,
            components: components,
            onDoubleClick: onDoubleClick,
            onKeyPress: onKeyPress,
            continuesPrior: localizer.lt(accessors.end(event), slotStart, 'day'),
            continuesAfter: localizer.gte(accessors.start(event), slotEnd, 'day'),
            slotStart: slotStart,
            slotEnd: slotEnd,
            selected: $f145fa6d412a8ce0$var$isSelected(event, selected),
            draggable: true,
            onDragStart: function onDragStart() {
                return handleDragStart(event);
            },
            onDragEnd: function onDragEnd() {
                return show();
            }
        });
    }));
}
var $f145fa6d412a8ce0$var$Popup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$Pop, Object.assign({}, props, {
        popperRef: ref
    }));
});
$f145fa6d412a8ce0$var$Popup.propTypes = {
    accessors: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).object.isRequired,
    getters: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).object.isRequired,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).object,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).object.isRequired,
    localizer: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).object.isRequired,
    position: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).object.isRequired,
    show: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func.isRequired,
    events: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).array.isRequired,
    slotStart: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).instanceOf(Date).isRequired,
    slotEnd: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).instanceOf(Date),
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func,
    onDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func,
    onKeyPress: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func,
    handleDragStart: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).object,
    offset: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).number,
        y: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).number
    })
};
function $f145fa6d412a8ce0$var$CalOverlay(_ref) {
    var containerRef = _ref.containerRef, _ref$popupOffset = _ref.popupOffset, popupOffset = _ref$popupOffset === void 0 ? 5 : _ref$popupOffset, overlay = _ref.overlay, accessors = _ref.accessors, localizer = _ref.localizer, components = _ref.components, getters = _ref.getters, selected = _ref.selected, handleSelectEvent = _ref.handleSelectEvent, handleDoubleClickEvent = _ref.handleDoubleClickEvent, handleKeyPressEvent = _ref.handleKeyPressEvent, handleDragStart = _ref.handleDragStart, onHide = _ref.onHide, overlayDisplay = _ref.overlayDisplay;
    var popperRef = (0, $gRqVZ.useRef)(null);
    if (!overlay.position) return null;
    var offset = popupOffset;
    if (!isNaN(popupOffset)) offset = {
        x: popupOffset,
        y: popupOffset
    };
    var position = overlay.position, events = overlay.events, date = overlay.date, end = overlay.end;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement((0, $fd6b16e8c359e5db$export$2e2bcd8739ae039), {
        rootClose: true,
        flip: true,
        show: true,
        placement: "bottom",
        onHide: onHide,
        target: overlay.target
    }, function(_ref2) {
        var props = _ref2.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$Popup, Object.assign({}, props, {
            containerRef: containerRef,
            ref: popperRef,
            target: overlay.target,
            offset: offset,
            accessors: accessors,
            getters: getters,
            selected: selected,
            components: components,
            localizer: localizer,
            position: position,
            show: overlayDisplay,
            events: events,
            slotStart: date,
            slotEnd: end,
            onSelect: handleSelectEvent,
            onDoubleClick: handleDoubleClickEvent,
            onKeyPress: handleKeyPressEvent,
            handleDragStart: handleDragStart
        }));
    });
}
var $f145fa6d412a8ce0$var$PopOverlay = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$CalOverlay, Object.assign({}, props, {
        containerRef: ref
    }));
});
$f145fa6d412a8ce0$var$PopOverlay.propTypes = {
    popupOffset: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).shape({
            x: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).number,
            y: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).number
        })
    ]),
    overlay: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).shape({
        position: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).object,
        events: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).array,
        date: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).instanceOf(Date),
        end: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).instanceOf(Date)
    }),
    accessors: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).object.isRequired,
    localizer: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).object.isRequired,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).object.isRequired,
    getters: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).object.isRequired,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).object,
    handleSelectEvent: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func,
    handleDoubleClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func,
    handleKeyPressEvent: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func,
    handleDragStart: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func,
    onHide: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func,
    overlayDisplay: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func
};
function $f145fa6d412a8ce0$var$addEventListener(type, handler) {
    var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
    return (0, $a58a5ebbc7740204$export$2e2bcd8739ae039)(target, type, handler, {
        passive: false
    });
}
function $f145fa6d412a8ce0$var$isOverContainer(container, x, y) {
    return !container || (0, $78634a75aa69345d$export$2e2bcd8739ae039)(container, document.elementFromPoint(x, y));
}
function $f145fa6d412a8ce0$var$getEventNodeFromPoint(node, _ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    var target = document.elementFromPoint(clientX, clientY);
    return (0, $575cfafa38ebd59c$export$2e2bcd8739ae039)(target, '.rbc-event', node);
}
function $f145fa6d412a8ce0$var$getShowMoreNodeFromPoint(node, _ref2) {
    var clientX = _ref2.clientX, clientY = _ref2.clientY;
    var target = document.elementFromPoint(clientX, clientY);
    return (0, $575cfafa38ebd59c$export$2e2bcd8739ae039)(target, '.rbc-show-more', node);
}
function $f145fa6d412a8ce0$var$isEvent(node, bounds) {
    return !!$f145fa6d412a8ce0$var$getEventNodeFromPoint(node, bounds);
}
function $f145fa6d412a8ce0$var$isShowMore(node, bounds) {
    return !!$f145fa6d412a8ce0$var$getShowMoreNodeFromPoint(node, bounds);
}
function $f145fa6d412a8ce0$var$getEventCoordinates(e) {
    var target = e;
    if (e.touches && e.touches.length) target = e.touches[0];
    return {
        clientX: target.clientX,
        clientY: target.clientY,
        pageX: target.pageX,
        pageY: target.pageY
    };
}
var $f145fa6d412a8ce0$var$clickTolerance = 5;
var $f145fa6d412a8ce0$var$clickInterval = 250;
var $f145fa6d412a8ce0$var$Selection = /*#__PURE__*/ function() {
    function Selection(node) {
        var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref3$global = _ref3.global, global = _ref3$global === void 0 ? false : _ref3$global, _ref3$longPressThresh = _ref3.longPressThreshold, longPressThreshold = _ref3$longPressThresh === void 0 ? 250 : _ref3$longPressThresh, _ref3$validContainers = _ref3.validContainers, validContainers = _ref3$validContainers === void 0 ? [] : _ref3$validContainers;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, Selection);
        this._initialEvent = null;
        this.selecting = false;
        this.isDetached = false;
        this.container = node;
        this.globalMouse = !node || global;
        this.longPressThreshold = longPressThreshold;
        this.validContainers = validContainers;
        this._listeners = Object.create(null);
        this._handleInitialEvent = this._handleInitialEvent.bind(this);
        this._handleMoveEvent = this._handleMoveEvent.bind(this);
        this._handleTerminatingEvent = this._handleTerminatingEvent.bind(this);
        this._keyListener = this._keyListener.bind(this);
        this._dropFromOutsideListener = this._dropFromOutsideListener.bind(this);
        this._dragOverFromOutsideListener = this._dragOverFromOutsideListener.bind(this);
        // Fixes an iOS 10 bug where scrolling could not be prevented on the window.
        // https://github.com/metafizzy/flickity/issues/457#issuecomment-254501356
        this._removeTouchMoveWindowListener = $f145fa6d412a8ce0$var$addEventListener('touchmove', function() {}, window);
        this._removeKeyDownListener = $f145fa6d412a8ce0$var$addEventListener('keydown', this._keyListener);
        this._removeKeyUpListener = $f145fa6d412a8ce0$var$addEventListener('keyup', this._keyListener);
        this._removeDropFromOutsideListener = $f145fa6d412a8ce0$var$addEventListener('drop', this._dropFromOutsideListener);
        this._removeDragOverFromOutsideListener = $f145fa6d412a8ce0$var$addEventListener('dragover', this._dragOverFromOutsideListener);
        this._addInitialEventListener();
    }
    return (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(Selection, [
        {
            key: "on",
            value: function on(type, handler) {
                var handlers = this._listeners[type] || (this._listeners[type] = []);
                handlers.push(handler);
                return {
                    remove: function remove() {
                        var idx = handlers.indexOf(handler);
                        if (idx !== -1) handlers.splice(idx, 1);
                    }
                };
            }
        },
        {
            key: "emit",
            value: function emit(type) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                var result;
                var handlers = this._listeners[type] || [];
                handlers.forEach(function(fn) {
                    if (result === undefined) result = fn.apply(void 0, args);
                });
                return result;
            }
        },
        {
            key: "teardown",
            value: function teardown() {
                this._initialEvent = null;
                this._initialEventData = null;
                this._selectRect = null;
                this.selecting = false;
                this._lastClickData = null;
                this.isDetached = true;
                this._listeners = Object.create(null);
                this._removeTouchMoveWindowListener && this._removeTouchMoveWindowListener();
                this._removeInitialEventListener && this._removeInitialEventListener();
                this._removeEndListener && this._removeEndListener();
                this._onEscListener && this._onEscListener();
                this._removeMoveListener && this._removeMoveListener();
                this._removeKeyUpListener && this._removeKeyUpListener();
                this._removeKeyDownListener && this._removeKeyDownListener();
                this._removeDropFromOutsideListener && this._removeDropFromOutsideListener();
                this._removeDragOverFromOutsideListener && this._removeDragOverFromOutsideListener();
            }
        },
        {
            key: "isSelected",
            value: function isSelected(node) {
                var box = this._selectRect;
                if (!box || !this.selecting) return false;
                return $f145fa6d412a8ce0$var$objectsCollide(box, $f145fa6d412a8ce0$var$getBoundsForNode(node));
            }
        },
        {
            key: "filter",
            value: function filter(items) {
                var box = this._selectRect;
                //not selecting
                if (!box || !this.selecting) return [];
                return items.filter(this.isSelected, this);
            }
        },
        {
            key: "_addLongPressListener",
            value: function _addLongPressListener(handler, initialEvent) {
                var _this = this;
                var timer = null;
                var removeTouchMoveListener = null;
                var removeTouchEndListener = null;
                var handleTouchStart = function handleTouchStart(initialEvent) {
                    timer = setTimeout(function() {
                        cleanup();
                        handler(initialEvent);
                    }, _this.longPressThreshold);
                    removeTouchMoveListener = $f145fa6d412a8ce0$var$addEventListener('touchmove', function() {
                        return cleanup();
                    });
                    removeTouchEndListener = $f145fa6d412a8ce0$var$addEventListener('touchend', function() {
                        return cleanup();
                    });
                };
                var removeTouchStartListener = $f145fa6d412a8ce0$var$addEventListener('touchstart', handleTouchStart);
                var cleanup = function cleanup() {
                    if (timer) clearTimeout(timer);
                    if (removeTouchMoveListener) removeTouchMoveListener();
                    if (removeTouchEndListener) removeTouchEndListener();
                    timer = null;
                    removeTouchMoveListener = null;
                    removeTouchEndListener = null;
                };
                if (initialEvent) handleTouchStart(initialEvent);
                return function() {
                    cleanup();
                    removeTouchStartListener();
                };
            }
        },
        {
            key: "_addInitialEventListener",
            value: function _addInitialEventListener() {
                var _this2 = this;
                var removeMouseDownListener = $f145fa6d412a8ce0$var$addEventListener('mousedown', function(e) {
                    _this2._removeInitialEventListener();
                    _this2._handleInitialEvent(e);
                    _this2._removeInitialEventListener = $f145fa6d412a8ce0$var$addEventListener('mousedown', _this2._handleInitialEvent);
                });
                var removeTouchStartListener = $f145fa6d412a8ce0$var$addEventListener('touchstart', function(e) {
                    _this2._removeInitialEventListener();
                    _this2._removeInitialEventListener = _this2._addLongPressListener(_this2._handleInitialEvent, e);
                });
                this._removeInitialEventListener = function() {
                    removeMouseDownListener();
                    removeTouchStartListener();
                };
            }
        },
        {
            key: "_dropFromOutsideListener",
            value: function _dropFromOutsideListener(e) {
                var _getEventCoordinates = $f145fa6d412a8ce0$var$getEventCoordinates(e), pageX = _getEventCoordinates.pageX, pageY = _getEventCoordinates.pageY, clientX = _getEventCoordinates.clientX, clientY = _getEventCoordinates.clientY;
                this.emit('dropFromOutside', {
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
                e.preventDefault();
            }
        },
        {
            key: "_dragOverFromOutsideListener",
            value: function _dragOverFromOutsideListener(e) {
                var _getEventCoordinates2 = $f145fa6d412a8ce0$var$getEventCoordinates(e), pageX = _getEventCoordinates2.pageX, pageY = _getEventCoordinates2.pageY, clientX = _getEventCoordinates2.clientX, clientY = _getEventCoordinates2.clientY;
                this.emit('dragOverFromOutside', {
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
                e.preventDefault();
            }
        },
        {
            key: "_handleInitialEvent",
            value: function _handleInitialEvent(e) {
                this._initialEvent = e;
                if (this.isDetached) return;
                var _getEventCoordinates3 = $f145fa6d412a8ce0$var$getEventCoordinates(e), clientX = _getEventCoordinates3.clientX, clientY = _getEventCoordinates3.clientY, pageX = _getEventCoordinates3.pageX, pageY = _getEventCoordinates3.pageY;
                var node = this.container(), collides, offsetData;
                // Right clicks
                if (e.which === 3 || e.button === 2 || !$f145fa6d412a8ce0$var$isOverContainer(node, clientX, clientY)) return;
                if (!this.globalMouse && node && !(0, $78634a75aa69345d$export$2e2bcd8739ae039)(node, e.target)) {
                    var _normalizeDistance = $f145fa6d412a8ce0$var$normalizeDistance(0), top = _normalizeDistance.top, left = _normalizeDistance.left, bottom = _normalizeDistance.bottom, right = _normalizeDistance.right;
                    offsetData = $f145fa6d412a8ce0$var$getBoundsForNode(node);
                    collides = $f145fa6d412a8ce0$var$objectsCollide({
                        top: offsetData.top - top,
                        left: offsetData.left - left,
                        bottom: offsetData.bottom + bottom,
                        right: offsetData.right + right
                    }, {
                        top: pageY,
                        left: pageX
                    });
                    if (!collides) return;
                }
                var result = this.emit('beforeSelect', this._initialEventData = {
                    isTouch: /^touch/.test(e.type),
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
                if (result === false) return;
                switch(e.type){
                    case 'mousedown':
                        this._removeEndListener = $f145fa6d412a8ce0$var$addEventListener('mouseup', this._handleTerminatingEvent);
                        this._onEscListener = $f145fa6d412a8ce0$var$addEventListener('keydown', this._handleTerminatingEvent);
                        this._removeMoveListener = $f145fa6d412a8ce0$var$addEventListener('mousemove', this._handleMoveEvent);
                        break;
                    case 'touchstart':
                        this._handleMoveEvent(e);
                        this._removeEndListener = $f145fa6d412a8ce0$var$addEventListener('touchend', this._handleTerminatingEvent);
                        this._removeMoveListener = $f145fa6d412a8ce0$var$addEventListener('touchmove', this._handleMoveEvent);
                        break;
                }
            }
        },
        {
            key: "_isWithinValidContainer",
            value: function _isWithinValidContainer(e) {
                var eventTarget = e.target;
                var containers = this.validContainers;
                if (!containers || !containers.length || !eventTarget) return true;
                return containers.some(function(target) {
                    return !!eventTarget.closest(target);
                });
            }
        },
        {
            key: "_handleTerminatingEvent",
            value: function _handleTerminatingEvent(e) {
                var selecting = this.selecting;
                var bounds = this._selectRect;
                // If it's not in selecting state, it's a click event
                if (!selecting && e.type.includes('key')) e = this._initialEvent;
                this.selecting = false;
                this._removeEndListener && this._removeEndListener();
                this._removeMoveListener && this._removeMoveListener();
                this._selectRect = null;
                this._initialEvent = null;
                this._initialEventData = null;
                if (!e) return;
                var inRoot = !this.container || (0, $78634a75aa69345d$export$2e2bcd8739ae039)(this.container(), e.target);
                var isWithinValidContainer = this._isWithinValidContainer(e);
                if (e.key === 'Escape' || !isWithinValidContainer) return this.emit('reset');
                if (!selecting && inRoot) return this._handleClickEvent(e);
                // User drag-clicked in the Selectable area
                if (selecting) return this.emit('select', bounds);
                return this.emit('reset');
            }
        },
        {
            key: "_handleClickEvent",
            value: function _handleClickEvent(e) {
                var _getEventCoordinates4 = $f145fa6d412a8ce0$var$getEventCoordinates(e), pageX = _getEventCoordinates4.pageX, pageY = _getEventCoordinates4.pageY, clientX = _getEventCoordinates4.clientX, clientY = _getEventCoordinates4.clientY;
                var now = new Date().getTime();
                if (this._lastClickData && now - this._lastClickData.timestamp < $f145fa6d412a8ce0$var$clickInterval) {
                    // Double click event
                    this._lastClickData = null;
                    return this.emit('doubleClick', {
                        x: pageX,
                        y: pageY,
                        clientX: clientX,
                        clientY: clientY
                    });
                }
                // Click event
                this._lastClickData = {
                    timestamp: now
                };
                return this.emit('click', {
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
            }
        },
        {
            key: "_handleMoveEvent",
            value: function _handleMoveEvent(e) {
                if (this._initialEventData === null || this.isDetached) return;
                var _this$_initialEventDa = this._initialEventData, x = _this$_initialEventDa.x, y = _this$_initialEventDa.y;
                var _getEventCoordinates5 = $f145fa6d412a8ce0$var$getEventCoordinates(e), pageX = _getEventCoordinates5.pageX, pageY = _getEventCoordinates5.pageY;
                var w = Math.abs(x - pageX);
                var h = Math.abs(y - pageY);
                var left = Math.min(pageX, x), top = Math.min(pageY, y), old = this.selecting;
                var click = this.isClick(pageX, pageY);
                // Prevent emitting selectStart event until mouse is moved.
                // in Chrome on Windows, mouseMove event may be fired just after mouseDown event.
                if (click && !old && !(w || h)) return;
                if (!old && !click) this.emit('selectStart', this._initialEventData);
                if (!click) {
                    this.selecting = true;
                    this._selectRect = {
                        top: top,
                        left: left,
                        x: pageX,
                        y: pageY,
                        right: left + w,
                        bottom: top + h
                    };
                    this.emit('selecting', this._selectRect);
                }
                e.preventDefault();
            }
        },
        {
            key: "_keyListener",
            value: function _keyListener(e) {
                this.ctrl = e.metaKey || e.ctrlKey;
            }
        },
        {
            key: "isClick",
            value: function isClick(pageX, pageY) {
                var _this$_initialEventDa2 = this._initialEventData, x = _this$_initialEventDa2.x, y = _this$_initialEventDa2.y, isTouch = _this$_initialEventDa2.isTouch;
                return !isTouch && Math.abs(pageX - x) <= $f145fa6d412a8ce0$var$clickTolerance && Math.abs(pageY - y) <= $f145fa6d412a8ce0$var$clickTolerance;
            }
        }
    ]);
}();
/**
 * Resolve the disance prop from either an Int or an Object
 * @return {Object}
 */ function $f145fa6d412a8ce0$var$normalizeDistance() {
    var distance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if ((0, $c3a904dfa5a64ea0$export$2e2bcd8739ae039)(distance) !== 'object') distance = {
        top: distance,
        left: distance,
        right: distance,
        bottom: distance
    };
    return distance;
}
/**
 * Given two objects containing "top", "left", "offsetWidth" and "offsetHeight"
 * properties, determine if they collide.
 * @param  {Object|HTMLElement} a
 * @param  {Object|HTMLElement} b
 * @return {bool}
 */ function $f145fa6d412a8ce0$var$objectsCollide(nodeA, nodeB) {
    var tolerance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var _getBoundsForNode = $f145fa6d412a8ce0$var$getBoundsForNode(nodeA), aTop = _getBoundsForNode.top, aLeft = _getBoundsForNode.left, _getBoundsForNode$rig = _getBoundsForNode.right, aRight = _getBoundsForNode$rig === void 0 ? aLeft : _getBoundsForNode$rig, _getBoundsForNode$bot = _getBoundsForNode.bottom, aBottom = _getBoundsForNode$bot === void 0 ? aTop : _getBoundsForNode$bot;
    var _getBoundsForNode2 = $f145fa6d412a8ce0$var$getBoundsForNode(nodeB), bTop = _getBoundsForNode2.top, bLeft = _getBoundsForNode2.left, _getBoundsForNode2$ri = _getBoundsForNode2.right, bRight = _getBoundsForNode2$ri === void 0 ? bLeft : _getBoundsForNode2$ri, _getBoundsForNode2$bo = _getBoundsForNode2.bottom, bBottom = _getBoundsForNode2$bo === void 0 ? bTop : _getBoundsForNode2$bo;
    return !// 'a' bottom doesn't touch 'b' top
    (aBottom - tolerance < bTop || // 'a' top doesn't touch 'b' bottom
    aTop + tolerance > bBottom || // 'a' right doesn't touch 'b' left
    aRight - tolerance < bLeft || // 'a' left doesn't touch 'b' right
    aLeft + tolerance > bRight);
}
/**
 * Given a node, get everything needed to calculate its boundaries
 * @param  {HTMLElement} node
 * @return {Object}
 */ function $f145fa6d412a8ce0$var$getBoundsForNode(node) {
    if (!node.getBoundingClientRect) return node;
    var rect = node.getBoundingClientRect(), left = rect.left + $f145fa6d412a8ce0$var$pageOffset('left'), top = rect.top + $f145fa6d412a8ce0$var$pageOffset('top');
    return {
        top: top,
        left: left,
        right: (node.offsetWidth || 0) + left,
        bottom: (node.offsetHeight || 0) + top
    };
}
function $f145fa6d412a8ce0$var$pageOffset(dir) {
    if (dir === 'left') return window.pageXOffset || document.body.scrollLeft || 0;
    if (dir === 'top') return window.pageYOffset || document.body.scrollTop || 0;
}
var $f145fa6d412a8ce0$var$BackgroundCells = /*#__PURE__*/ function(_React$Component) {
    function BackgroundCells(props, context) {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, BackgroundCells);
        _this = (0, $db22c8b683e5147b$export$2e2bcd8739ae039)(this, BackgroundCells, [
            props,
            context
        ]);
        _this.state = {
            selecting: false
        };
        _this.containerRef = /*#__PURE__*/ (0, $gRqVZ.createRef)();
        return _this;
    }
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(BackgroundCells, _React$Component);
    return (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(BackgroundCells, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.selectable && this._selectable();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._teardownSelectable();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (!prevProps.selectable && this.props.selectable) this._selectable();
                if (prevProps.selectable && !this.props.selectable) this._teardownSelectable();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, range = _this$props.range, getNow = _this$props.getNow, getters = _this$props.getters, currentDate = _this$props.date, Wrapper = _this$props.components.dateCellWrapper, localizer = _this$props.localizer;
                var _this$state = this.state, selecting = _this$state.selecting, startIdx = _this$state.startIdx, endIdx = _this$state.endIdx;
                var current = getNow();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                    className: "rbc-row-bg",
                    ref: this.containerRef
                }, range.map(function(date, index) {
                    var selected = selecting && index >= startIdx && index <= endIdx;
                    var _getters$dayProp = getters.dayProp(date), className = _getters$dayProp.className, style = _getters$dayProp.style;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(Wrapper, {
                        key: index,
                        value: date,
                        range: range
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                        style: style,
                        className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)('rbc-day-bg', className, selected && 'rbc-selected-cell', localizer.isSameDate(date, current) && 'rbc-today', currentDate && localizer.neq(currentDate, date, 'month') && 'rbc-off-range-bg')
                    }));
                }));
            }
        },
        {
            key: "_selectable",
            value: function _selectable() {
                var _this2 = this;
                var node = this.containerRef.current;
                var selector = this._selector = new $f145fa6d412a8ce0$var$Selection(this.props.container, {
                    longPressThreshold: this.props.longPressThreshold
                });
                var selectorClicksHandler = function selectorClicksHandler(point, actionType) {
                    if (!$f145fa6d412a8ce0$var$isEvent(node, point) && !$f145fa6d412a8ce0$var$isShowMore(node, point)) {
                        var rowBox = $f145fa6d412a8ce0$var$getBoundsForNode(node);
                        var _this2$props = _this2.props, range = _this2$props.range, rtl = _this2$props.rtl;
                        if ($f145fa6d412a8ce0$var$pointInBox(rowBox, point)) {
                            var currentCell = $f145fa6d412a8ce0$var$getSlotAtX(rowBox, point.x, rtl, range.length);
                            _this2._selectSlot({
                                startIdx: currentCell,
                                endIdx: currentCell,
                                action: actionType,
                                box: point
                            });
                        }
                    }
                    _this2._initial = {};
                    _this2.setState({
                        selecting: false
                    });
                };
                selector.on('selecting', function(box) {
                    var _this2$props2 = _this2.props, range = _this2$props2.range, rtl = _this2$props2.rtl;
                    var startIdx = -1;
                    var endIdx = -1;
                    if (!_this2.state.selecting) {
                        $f145fa6d412a8ce0$var$notify(_this2.props.onSelectStart, [
                            box
                        ]);
                        _this2._initial = {
                            x: box.x,
                            y: box.y
                        };
                    }
                    if (selector.isSelected(node)) {
                        var nodeBox = $f145fa6d412a8ce0$var$getBoundsForNode(node);
                        var _dateCellSelection = $f145fa6d412a8ce0$var$dateCellSelection(_this2._initial, nodeBox, box, range.length, rtl);
                        startIdx = _dateCellSelection.startIdx;
                        endIdx = _dateCellSelection.endIdx;
                    }
                    _this2.setState({
                        selecting: true,
                        startIdx: startIdx,
                        endIdx: endIdx
                    });
                });
                selector.on('beforeSelect', function(box) {
                    if (_this2.props.selectable !== 'ignoreEvents') return;
                    return !$f145fa6d412a8ce0$var$isEvent(_this2.containerRef.current, box);
                });
                selector.on('click', function(point) {
                    return selectorClicksHandler(point, 'click');
                });
                selector.on('doubleClick', function(point) {
                    return selectorClicksHandler(point, 'doubleClick');
                });
                selector.on('select', function(bounds) {
                    _this2._selectSlot((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, _this2.state), {}, {
                        action: 'select',
                        bounds: bounds
                    }));
                    _this2._initial = {};
                    _this2.setState({
                        selecting: false
                    });
                    $f145fa6d412a8ce0$var$notify(_this2.props.onSelectEnd, [
                        _this2.state
                    ]);
                });
            }
        },
        {
            key: "_teardownSelectable",
            value: function _teardownSelectable() {
                if (!this._selector) return;
                this._selector.teardown();
                this._selector = null;
            }
        },
        {
            key: "_selectSlot",
            value: function _selectSlot(_ref) {
                var endIdx = _ref.endIdx, startIdx = _ref.startIdx, action = _ref.action, bounds = _ref.bounds, box = _ref.box;
                if (endIdx !== -1 && startIdx !== -1) this.props.onSelectSlot && this.props.onSelectSlot({
                    start: startIdx,
                    end: endIdx,
                    action: action,
                    bounds: bounds,
                    box: box,
                    resourceId: this.props.resourceId
                });
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Component);
/* eslint-disable react/prop-types */ var $f145fa6d412a8ce0$var$EventRowMixin = {
    propTypes: {
        slotMetrics: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).object.isRequired,
        selected: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).object,
        isAllDay: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).bool,
        accessors: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).object.isRequired,
        localizer: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).object.isRequired,
        components: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).object.isRequired,
        getters: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).object.isRequired,
        onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func,
        onDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func,
        onKeyPress: (0, (/*@__PURE__*/$parcel$interopDefault($awzbB))).func
    },
    defaultProps: {
        segments: [],
        selected: {}
    },
    renderEvent: function renderEvent(props, event) {
        var selected = props.selected;
        props.isAllDay;
        var accessors = props.accessors, getters = props.getters, onSelect = props.onSelect, onDoubleClick = props.onDoubleClick, onKeyPress = props.onKeyPress, localizer = props.localizer, slotMetrics = props.slotMetrics, components = props.components, resizable = props.resizable;
        var continuesPrior = slotMetrics.continuesPrior(event);
        var continuesAfter = slotMetrics.continuesAfter(event);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$EventCell, {
            event: event,
            getters: getters,
            localizer: localizer,
            accessors: accessors,
            components: components,
            onSelect: onSelect,
            onDoubleClick: onDoubleClick,
            onKeyPress: onKeyPress,
            continuesPrior: continuesPrior,
            continuesAfter: continuesAfter,
            slotStart: slotMetrics.first,
            slotEnd: slotMetrics.last,
            selected: $f145fa6d412a8ce0$var$isSelected(event, selected),
            resizable: resizable
        });
    },
    renderSpan: function renderSpan(slots, len, key) {
        var content = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
        var per = Math.abs(len) / slots * 100 + '%';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            key: key,
            className: "rbc-row-segment",
            style: {
                WebkitFlexBasis: per,
                flexBasis: per,
                maxWidth: per
            }
        }, content);
    }
};
var $f145fa6d412a8ce0$var$EventRow = /*#__PURE__*/ function(_React$Component) {
    function EventRow() {
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, EventRow);
        return (0, $db22c8b683e5147b$export$2e2bcd8739ae039)(this, EventRow, arguments);
    }
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(EventRow, _React$Component);
    return (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(EventRow, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, segments = _this$props.segments, slots = _this$props.slotMetrics.slots, className = _this$props.className;
                var lastEnd = 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                    className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)(className, 'rbc-row')
                }, segments.reduce(function(row, _ref, li) {
                    var event = _ref.event, left = _ref.left, right = _ref.right, span = _ref.span;
                    var key = '_lvl_' + li;
                    var gap = left - lastEnd;
                    var content = $f145fa6d412a8ce0$var$EventRowMixin.renderEvent(_this.props, event);
                    if (gap) row.push($f145fa6d412a8ce0$var$EventRowMixin.renderSpan(slots, gap, "".concat(key, "_gap")));
                    row.push($f145fa6d412a8ce0$var$EventRowMixin.renderSpan(slots, span, key, content));
                    lastEnd = right + 1;
                    return row;
                }, []));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Component);
$f145fa6d412a8ce0$var$EventRow.defaultProps = (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, $f145fa6d412a8ce0$var$EventRowMixin.defaultProps);
function $f145fa6d412a8ce0$var$endOfRange(_ref) {
    var dateRange = _ref.dateRange, _ref$unit = _ref.unit, unit = _ref$unit === void 0 ? 'day' : _ref$unit, localizer = _ref.localizer;
    return {
        first: dateRange[0],
        last: localizer.add(dateRange[dateRange.length - 1], 1, unit)
    };
}
// properly calculating segments requires working with dates in
// the timezone we're working with, so we use the localizer
function $f145fa6d412a8ce0$var$eventSegments(event, range, accessors, localizer) {
    var _endOfRange = $f145fa6d412a8ce0$var$endOfRange({
        dateRange: range,
        localizer: localizer
    }), first = _endOfRange.first, last = _endOfRange.last;
    var slots = localizer.diff(first, last, 'day');
    var start = localizer.max(localizer.startOf(accessors.start(event), 'day'), first);
    var end = localizer.min(localizer.ceil(accessors.end(event), 'day'), last);
    var padding = (0, (/*@__PURE__*/$parcel$interopDefault($c6c5d1d8f7384862$exports)))(range, function(x) {
        return localizer.isSameDate(x, start);
    });
    var span = localizer.diff(start, end, 'day');
    span = Math.min(span, slots);
    // The segmentOffset is necessary when adjusting for timezones
    // ahead of the browser timezone
    span = Math.max(span - localizer.segmentOffset, 1);
    return {
        event: event,
        span: span,
        left: padding + 1,
        right: Math.max(padding + span, 1)
    };
}
function $f145fa6d412a8ce0$var$eventLevels(rowSegments) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
    var i, j, seg, levels = [], extra = [];
    for(i = 0; i < rowSegments.length; i++){
        seg = rowSegments[i];
        for(j = 0; j < levels.length; j++)if (!$f145fa6d412a8ce0$var$segsOverlap(seg, levels[j])) break;
        if (j >= limit) extra.push(seg);
        else (levels[j] || (levels[j] = [])).push(seg);
    }
    for(i = 0; i < levels.length; i++)levels[i].sort(function(a, b) {
        return a.left - b.left;
    }); //eslint-disable-line
    return {
        levels: levels,
        extra: extra
    };
}
function $f145fa6d412a8ce0$var$inRange(e, start, end, accessors, localizer) {
    var event = {
        start: accessors.start(e),
        end: accessors.end(e)
    };
    var range = {
        start: start,
        end: end
    };
    return localizer.inEventRange({
        event: event,
        range: range
    });
}
function $f145fa6d412a8ce0$var$segsOverlap(seg, otherSegs) {
    return otherSegs.some(function(otherSeg) {
        return otherSeg.left <= seg.right && otherSeg.right >= seg.left;
    });
}
function $f145fa6d412a8ce0$var$sortWeekEvents(events, accessors, localizer) {
    var base = (0, $fbac2d7879866840$export$2e2bcd8739ae039)(events);
    var multiDayEvents = [];
    var standardEvents = [];
    base.forEach(function(event) {
        var startCheck = accessors.start(event);
        var endCheck = accessors.end(event);
        if (localizer.daySpan(startCheck, endCheck) > 1) multiDayEvents.push(event);
        else standardEvents.push(event);
    });
    var multiSorted = multiDayEvents.sort(function(a, b) {
        return $f145fa6d412a8ce0$var$sortEvents(a, b, accessors, localizer);
    });
    var standardSorted = standardEvents.sort(function(a, b) {
        return $f145fa6d412a8ce0$var$sortEvents(a, b, accessors, localizer);
    });
    return [].concat((0, $fbac2d7879866840$export$2e2bcd8739ae039)(multiSorted), (0, $fbac2d7879866840$export$2e2bcd8739ae039)(standardSorted));
}
function $f145fa6d412a8ce0$var$sortEvents(eventA, eventB, accessors, localizer) {
    var evtA = {
        start: accessors.start(eventA),
        end: accessors.end(eventA),
        allDay: accessors.allDay(eventA)
    };
    var evtB = {
        start: accessors.start(eventB),
        end: accessors.end(eventB),
        allDay: accessors.allDay(eventB)
    };
    return localizer.sortEvents({
        evtA: evtA,
        evtB: evtB
    });
}
// Modified: Check if a segment spans through this slot (including events that started earlier)
var $f145fa6d412a8ce0$var$isSegmentInSlot$1 = function isSegmentInSlot(seg, slot) {
    return seg.left <= slot && seg.right >= slot;
};
var $f145fa6d412a8ce0$var$eventsInSlot = function eventsInSlot(segments, slot) {
    return segments.filter(function(seg) {
        return $f145fa6d412a8ce0$var$isSegmentInSlot$1(seg, slot);
    }).map(function(seg) {
        return seg.event;
    });
};
var $f145fa6d412a8ce0$var$EventEndingRow = /*#__PURE__*/ function(_React$Component) {
    function EventEndingRow() {
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, EventEndingRow);
        return (0, $db22c8b683e5147b$export$2e2bcd8739ae039)(this, EventEndingRow, arguments);
    }
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(EventEndingRow, _React$Component);
    return (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(EventEndingRow, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, segments = _this$props.segments, slots = _this$props.slotMetrics.slots;
                var rowSegments = $f145fa6d412a8ce0$var$eventLevels(segments).levels[0];
                var current = 1, lastEnd = 1, row = [];
                while(current <= slots){
                    var key = '_lvl_' + current;
                    // Find segment that starts at or spans through current slot
                    var _ref = rowSegments.filter(function(seg) {
                        return $f145fa6d412a8ce0$var$isSegmentInSlot$1(seg, current);
                    })[0] || {}, event = _ref.event, left = _ref.left, right = _ref.right, span = _ref.span;
                    if (!event) {
                        // No visible event starts at this slot, but check if we need a "more" button
                        // for hidden events that span this slot
                        var hiddenEvents = this.getHiddenEventsForSlot(segments, current);
                        if (hiddenEvents.length > 0) {
                            var _gap = current - lastEnd;
                            if (_gap) row.push($f145fa6d412a8ce0$var$EventRowMixin.renderSpan(slots, _gap, key + '_gap'));
                            row.push($f145fa6d412a8ce0$var$EventRowMixin.renderSpan(slots, 1, key, this.renderShowMore(segments, current)));
                            lastEnd = current = current + 1;
                            continue;
                        }
                        current++;
                        continue;
                    }
                    var gap = Math.max(0, left - lastEnd);
                    if (this.canRenderSlotEvent(left, span)) {
                        var content = $f145fa6d412a8ce0$var$EventRowMixin.renderEvent(this.props, event);
                        if (gap) row.push($f145fa6d412a8ce0$var$EventRowMixin.renderSpan(slots, gap, key + '_gap'));
                        row.push($f145fa6d412a8ce0$var$EventRowMixin.renderSpan(slots, span, key, content));
                        lastEnd = current = right + 1;
                    } else {
                        if (gap) row.push($f145fa6d412a8ce0$var$EventRowMixin.renderSpan(slots, gap, key + '_gap'));
                        row.push($f145fa6d412a8ce0$var$EventRowMixin.renderSpan(slots, 1, key, this.renderShowMore(segments, current)));
                        lastEnd = current = current + 1;
                    }
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                    className: "rbc-row"
                }, row);
            }
        },
        {
            key: "getHiddenEventsForSlot",
            value: function getHiddenEventsForSlot(segments, slot) {
                // Get all events (visible and hidden) for this slot
                var allEventsInSlot = $f145fa6d412a8ce0$var$eventsInSlot(segments, slot);
                // Get visible events for this slot from the first level
                var rowSegments = $f145fa6d412a8ce0$var$eventLevels(segments).levels[0];
                var visibleEventsInSlot = rowSegments.filter(function(seg) {
                    return $f145fa6d412a8ce0$var$isSegmentInSlot$1(seg, slot);
                }).map(function(seg) {
                    return seg.event;
                });
                // Return events that are in allEventsInSlot but not in visibleEventsInSlot
                return allEventsInSlot.filter(function(event) {
                    return !visibleEventsInSlot.some(function(visEvent) {
                        return visEvent === event;
                    });
                });
            }
        },
        {
            key: "canRenderSlotEvent",
            value: function canRenderSlotEvent(slot, span) {
                var segments = this.props.segments;
                return (0, (/*@__PURE__*/$parcel$interopDefault($493955b6799bbc8b$exports)))(slot, slot + span).every(function(s) {
                    var count = $f145fa6d412a8ce0$var$eventsInSlot(segments, s).length;
                    return count === 1;
                });
            }
        },
        {
            key: "renderShowMore",
            value: function renderShowMore(segments, slot) {
                var _this = this;
                var _this$props2 = this.props, localizer = _this$props2.localizer, slotMetrics = _this$props2.slotMetrics, components = _this$props2.components;
                var events = slotMetrics.getEventsForSlot(slot);
                var remainingEvents = $f145fa6d412a8ce0$var$eventsInSlot(segments, slot);
                var count = remainingEvents.length;
                if (components !== null && components !== void 0 && components.showMore) {
                    var ShowMore = components.showMore;
                    // The received slot seems to be 1-based, but the range we use to pull the date is 0-based
                    var slotDate = slotMetrics.getDateForSlot(slot - 1);
                    return count ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(ShowMore, {
                        localizer: localizer,
                        slotDate: slotDate,
                        slot: slot,
                        count: count,
                        events: events,
                        remainingEvents: remainingEvents
                    }) : false;
                }
                return count ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("button", {
                    type: "button",
                    key: 'sm_' + slot,
                    className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)('rbc-button-link', 'rbc-show-more'),
                    onClick: function onClick(e) {
                        return _this.showMore(slot, e);
                    }
                }, localizer.messages.showMore(count, remainingEvents, events)) : false;
            }
        },
        {
            key: "showMore",
            value: function showMore(slot, e) {
                e.preventDefault();
                e.stopPropagation();
                this.props.onShowMore(slot, e.target);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Component);
$f145fa6d412a8ce0$var$EventEndingRow.defaultProps = (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, $f145fa6d412a8ce0$var$EventRowMixin.defaultProps);
var $f145fa6d412a8ce0$var$ScrollableWeekWrapper = function ScrollableWeekWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
        className: "rbc-row-content-scroll-container"
    }, children);
};
var $f145fa6d412a8ce0$var$isSegmentInSlot = function isSegmentInSlot(seg, slot) {
    return seg.left <= slot && seg.right >= slot;
};
var $f145fa6d412a8ce0$var$isEqual = function isEqual(a, b) {
    return a[0].range === b[0].range && a[0].events === b[0].events;
};
function $f145fa6d412a8ce0$var$getSlotMetrics$1() {
    return (0, $9cd2825578c66be2$export$2e2bcd8739ae039)(function(options) {
        var range = options.range, events = options.events, maxRows = options.maxRows, minRows = options.minRows, accessors = options.accessors, localizer = options.localizer;
        var _endOfRange = $f145fa6d412a8ce0$var$endOfRange({
            dateRange: range,
            localizer: localizer
        }), first = _endOfRange.first, last = _endOfRange.last;
        var segments = events.map(function(evt) {
            return $f145fa6d412a8ce0$var$eventSegments(evt, range, accessors, localizer);
        });
        var _eventLevels = $f145fa6d412a8ce0$var$eventLevels(segments, Math.max(maxRows - 1, 1)), levels = _eventLevels.levels, extra = _eventLevels.extra;
        // Subtract 1 from minRows to not include showMore button row when
        // it would be rendered
        var minEventRows = extra.length > 0 ? minRows - 1 : minRows;
        while(levels.length < minEventRows)levels.push([]);
        return {
            first: first,
            last: last,
            levels: levels,
            extra: extra,
            range: range,
            slots: range.length,
            clone: function clone(args) {
                var metrics = $f145fa6d412a8ce0$var$getSlotMetrics$1();
                return metrics((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, options), args));
            },
            getDateForSlot: function getDateForSlot(slotNumber) {
                return range[slotNumber];
            },
            getSlotForDate: function getSlotForDate(date) {
                return range.find(function(r) {
                    return localizer.isSameDate(r, date);
                });
            },
            getEventsForSlot: function getEventsForSlot(slot) {
                return segments.filter(function(seg) {
                    return $f145fa6d412a8ce0$var$isSegmentInSlot(seg, slot);
                }).map(function(seg) {
                    return seg.event;
                });
            },
            continuesPrior: function continuesPrior(event) {
                return localizer.continuesPrior(accessors.start(event), first);
            },
            continuesAfter: function continuesAfter(event) {
                var start = accessors.start(event);
                var end = accessors.end(event);
                return localizer.continuesAfter(start, end, last);
            }
        };
    }, $f145fa6d412a8ce0$var$isEqual);
}
var $f145fa6d412a8ce0$var$DateContentRow = /*#__PURE__*/ function(_React$Component) {
    function DateContentRow() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, DateContentRow);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $db22c8b683e5147b$export$2e2bcd8739ae039)(this, DateContentRow, [].concat(args));
        _this.handleSelectSlot = function(slot) {
            var _this$props = _this.props, range = _this$props.range, onSelectSlot = _this$props.onSelectSlot;
            onSelectSlot(range.slice(slot.start, slot.end + 1), slot);
        };
        _this.handleShowMore = function(slot, target) {
            var _this$props2 = _this.props, range = _this$props2.range, onShowMore = _this$props2.onShowMore;
            var metrics = _this.slotMetrics(_this.props);
            var row = (0, $1384fa5ca030d7db$export$2e2bcd8739ae039)(_this.containerRef.current, '.rbc-row-bg')[0];
            var cell;
            if (row) cell = row.children[slot - 1];
            var events = metrics.getEventsForSlot(slot);
            onShowMore(events, range[slot - 1], cell, slot, target);
        };
        _this.getContainer = function() {
            var container = _this.props.container;
            return container ? container() : _this.containerRef.current;
        };
        _this.renderHeadingCell = function(date, index) {
            var _this$props3 = _this.props, renderHeader = _this$props3.renderHeader, getNow = _this$props3.getNow, localizer = _this$props3.localizer;
            return renderHeader({
                date: date,
                key: "header_".concat(index),
                className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)('rbc-date-cell', localizer.isSameDate(date, getNow()) && 'rbc-now')
            });
        };
        _this.renderDummy = function() {
            var _this$props4 = _this.props, className = _this$props4.className, range = _this$props4.range, renderHeader = _this$props4.renderHeader, showAllEvents = _this$props4.showAllEvents;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                className: className,
                ref: _this.containerRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)('rbc-row-content', showAllEvents && 'rbc-row-content-scrollable')
            }, renderHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                className: "rbc-row",
                ref: _this.headingRowRef
            }, range.map(_this.renderHeadingCell)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                className: "rbc-row",
                ref: _this.eventRowRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                className: "rbc-row-segment"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                className: "rbc-event"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                className: "rbc-event-content"
            }, "\xA0"))))));
        };
        _this.containerRef = /*#__PURE__*/ (0, $gRqVZ.createRef)();
        _this.headingRowRef = /*#__PURE__*/ (0, $gRqVZ.createRef)();
        _this.eventRowRef = /*#__PURE__*/ (0, $gRqVZ.createRef)();
        _this.slotMetrics = $f145fa6d412a8ce0$var$getSlotMetrics$1();
        return _this;
    }
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(DateContentRow, _React$Component);
    return (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(DateContentRow, [
        {
            key: "getRowLimit",
            value: function getRowLimit() {
                var _this$headingRowRef;
                /* Guessing this only gets called on the dummyRow */ var eventHeight = (0, $ea9791f530d8abb6$export$2e2bcd8739ae039)(this.eventRowRef.current);
                var headingHeight = (_this$headingRowRef = this.headingRowRef) !== null && _this$headingRowRef !== void 0 && _this$headingRowRef.current ? (0, $ea9791f530d8abb6$export$2e2bcd8739ae039)(this.headingRowRef.current) : 0;
                var eventSpace = (0, $ea9791f530d8abb6$export$2e2bcd8739ae039)(this.containerRef.current) - headingHeight;
                return Math.max(Math.floor(eventSpace / eventHeight), 1);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, date = _this$props5.date, rtl = _this$props5.rtl, range = _this$props5.range, className = _this$props5.className, selected = _this$props5.selected, selectable = _this$props5.selectable, renderForMeasure = _this$props5.renderForMeasure, accessors = _this$props5.accessors, getters = _this$props5.getters, components = _this$props5.components, getNow = _this$props5.getNow, renderHeader = _this$props5.renderHeader, onSelect = _this$props5.onSelect, localizer = _this$props5.localizer, onSelectStart = _this$props5.onSelectStart, onSelectEnd = _this$props5.onSelectEnd, onDoubleClick = _this$props5.onDoubleClick, onKeyPress = _this$props5.onKeyPress, resourceId = _this$props5.resourceId, longPressThreshold = _this$props5.longPressThreshold, isAllDay = _this$props5.isAllDay, resizable = _this$props5.resizable, showAllEvents = _this$props5.showAllEvents;
                if (renderForMeasure) return this.renderDummy();
                var metrics = this.slotMetrics(this.props);
                var levels = metrics.levels, extra = metrics.extra;
                var ScrollableWeekComponent = showAllEvents ? $f145fa6d412a8ce0$var$ScrollableWeekWrapper : $f145fa6d412a8ce0$var$NoopWrapper;
                var WeekWrapper = components.weekWrapper;
                var eventRowProps = {
                    selected: selected,
                    accessors: accessors,
                    getters: getters,
                    localizer: localizer,
                    components: components,
                    onSelect: onSelect,
                    onDoubleClick: onDoubleClick,
                    onKeyPress: onKeyPress,
                    resourceId: resourceId,
                    slotMetrics: metrics,
                    resizable: resizable
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                    className: className,
                    role: "rowgroup",
                    ref: this.containerRef
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$BackgroundCells, {
                    localizer: localizer,
                    date: date,
                    getNow: getNow,
                    rtl: rtl,
                    range: range,
                    selectable: selectable,
                    container: this.getContainer,
                    getters: getters,
                    onSelectStart: onSelectStart,
                    onSelectEnd: onSelectEnd,
                    onSelectSlot: this.handleSelectSlot,
                    components: components,
                    longPressThreshold: longPressThreshold,
                    resourceId: resourceId
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                    className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)('rbc-row-content', showAllEvents && 'rbc-row-content-scrollable'),
                    role: "row"
                }, renderHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                    className: "rbc-row ",
                    ref: this.headingRowRef
                }, range.map(this.renderHeadingCell)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(ScrollableWeekComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(WeekWrapper, Object.assign({
                    isAllDay: isAllDay
                }, eventRowProps, {
                    rtl: this.props.rtl
                }), levels.map(function(segs, idx) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$EventRow, Object.assign({
                        key: idx,
                        segments: segs
                    }, eventRowProps));
                }), !!extra.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$EventEndingRow, Object.assign({
                    segments: extra,
                    onShowMore: this.handleShowMore
                }, eventRowProps))))));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Component);
$f145fa6d412a8ce0$var$DateContentRow.defaultProps = {
    minRows: 0,
    maxRows: Infinity
};
var $f145fa6d412a8ce0$var$Header = function Header(_ref) {
    var label = _ref.label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("span", {
        role: "columnheader",
        "aria-sort": "none"
    }, label);
};
var $f145fa6d412a8ce0$var$DateHeader = function DateHeader(_ref) {
    var label = _ref.label, drilldownView = _ref.drilldownView, onDrillDown = _ref.onDrillDown;
    if (!drilldownView) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("span", null, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("button", {
        type: "button",
        className: "rbc-button-link",
        onClick: onDrillDown
    }, label);
};
var $f145fa6d412a8ce0$var$_excluded$6 = [
    "date",
    "className"
];
var $f145fa6d412a8ce0$var$eventsForWeek = function eventsForWeek(evts, start, end, accessors, localizer) {
    return evts.filter(function(e) {
        return $f145fa6d412a8ce0$var$inRange(e, start, end, accessors, localizer);
    });
};
var $f145fa6d412a8ce0$var$MonthView = /*#__PURE__*/ function(_React$Component) {
    function MonthView() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, MonthView);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = (0, $db22c8b683e5147b$export$2e2bcd8739ae039)(this, MonthView, [].concat(_args));
        _this.getContainer = function() {
            return _this.containerRef.current;
        };
        _this.renderWeek = function(week, weekIdx) {
            var _this$props = _this.props, events = _this$props.events, components = _this$props.components, selectable = _this$props.selectable, getNow = _this$props.getNow, selected = _this$props.selected, date = _this$props.date, localizer = _this$props.localizer, longPressThreshold = _this$props.longPressThreshold, accessors = _this$props.accessors, getters = _this$props.getters, showAllEvents = _this$props.showAllEvents;
            var _this$state = _this.state, needLimitMeasure = _this$state.needLimitMeasure, rowLimit = _this$state.rowLimit;
            // let's not mutate props
            var weeksEvents = $f145fa6d412a8ce0$var$eventsForWeek((0, $fbac2d7879866840$export$2e2bcd8739ae039)(events), week[0], week[week.length - 1], accessors, localizer);
            var sorted = $f145fa6d412a8ce0$var$sortWeekEvents(weeksEvents, accessors, localizer);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$DateContentRow, {
                key: weekIdx,
                ref: weekIdx === 0 ? _this.slotRowRef : undefined,
                container: _this.getContainer,
                className: "rbc-month-row",
                getNow: getNow,
                date: date,
                range: week,
                events: sorted,
                maxRows: showAllEvents ? Infinity : rowLimit,
                selected: selected,
                selectable: selectable,
                components: components,
                accessors: accessors,
                getters: getters,
                localizer: localizer,
                renderHeader: _this.readerDateHeading,
                renderForMeasure: needLimitMeasure,
                onShowMore: _this.handleShowMore,
                onSelect: _this.handleSelectEvent,
                onDoubleClick: _this.handleDoubleClickEvent,
                onKeyPress: _this.handleKeyPressEvent,
                onSelectSlot: _this.handleSelectSlot,
                longPressThreshold: longPressThreshold,
                rtl: _this.props.rtl,
                resizable: _this.props.resizable,
                showAllEvents: showAllEvents
            });
        };
        _this.readerDateHeading = function(_ref) {
            var date = _ref.date, className = _ref.className, props = (0, $f308b666a2f706a5$export$2e2bcd8739ae039)(_ref, $f145fa6d412a8ce0$var$_excluded$6);
            var _this$props2 = _this.props, currentDate = _this$props2.date, getDrilldownView = _this$props2.getDrilldownView, localizer = _this$props2.localizer;
            var isOffRange = localizer.neq(currentDate, date, 'month');
            var isCurrent = localizer.isSameDate(date, currentDate);
            var drilldownView = getDrilldownView(date);
            var label = localizer.format(date, 'dateFormat');
            var DateHeaderComponent = _this.props.components.dateHeader || $f145fa6d412a8ce0$var$DateHeader;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", Object.assign({}, props, {
                className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)(className, isOffRange && 'rbc-off-range', isCurrent && 'rbc-current'),
                role: "cell"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(DateHeaderComponent, {
                label: label,
                date: date,
                drilldownView: drilldownView,
                isOffRange: isOffRange,
                onDrillDown: function onDrillDown(e) {
                    return _this.handleHeadingClick(date, drilldownView, e);
                }
            }));
        };
        _this.handleSelectSlot = function(range, slotInfo) {
            _this._pendingSelection = _this._pendingSelection.concat(range);
            clearTimeout(_this._selectTimer);
            _this._selectTimer = setTimeout(function() {
                return _this.selectDates(slotInfo);
            });
        };
        _this.handleHeadingClick = function(date, view, e) {
            e.preventDefault();
            _this.clearSelection();
            $f145fa6d412a8ce0$var$notify(_this.props.onDrillDown, [
                date,
                view
            ]);
        };
        _this.handleSelectEvent = function() {
            _this.clearSelection();
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            $f145fa6d412a8ce0$var$notify(_this.props.onSelectEvent, args);
        };
        _this.handleDoubleClickEvent = function() {
            _this.clearSelection();
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            $f145fa6d412a8ce0$var$notify(_this.props.onDoubleClickEvent, args);
        };
        _this.handleKeyPressEvent = function() {
            _this.clearSelection();
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            $f145fa6d412a8ce0$var$notify(_this.props.onKeyPressEvent, args);
        };
        _this.handleShowMore = function(events, date, cell, slot, target) {
            var _this$props3 = _this.props, popup = _this$props3.popup, onDrillDown = _this$props3.onDrillDown, onShowMore = _this$props3.onShowMore, getDrilldownView = _this$props3.getDrilldownView, doShowMoreDrillDown = _this$props3.doShowMoreDrillDown;
            //cancel any pending selections so only the event click goes through.
            _this.clearSelection();
            if (popup) {
                var position = (0, $1c04ca32884af598$export$2e2bcd8739ae039)(cell, _this.containerRef.current);
                _this.setState({
                    overlay: {
                        date: date,
                        events: events,
                        position: position,
                        target: target
                    }
                });
            } else if (doShowMoreDrillDown) $f145fa6d412a8ce0$var$notify(onDrillDown, [
                date,
                getDrilldownView(date) || $f145fa6d412a8ce0$export$5cb791131c501f6a.DAY
            ]);
            $f145fa6d412a8ce0$var$notify(onShowMore, [
                events,
                date,
                slot
            ]);
        };
        _this.overlayDisplay = function() {
            _this.setState({
                overlay: null
            });
        };
        _this.state = {
            rowLimit: 5,
            needLimitMeasure: true,
            date: null
        };
        _this.containerRef = /*#__PURE__*/ (0, $gRqVZ.createRef)();
        _this.slotRowRef = /*#__PURE__*/ (0, $gRqVZ.createRef)();
        _this._bgRows = [];
        _this._pendingSelection = [];
        return _this;
    }
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(MonthView, _React$Component);
    return (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(MonthView, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                var running;
                if (this.state.needLimitMeasure) this.measureRowLimit(this.props);
                window.addEventListener('resize', this._resizeListener = function() {
                    if (!running) $3f65a5846d5d2f64$export$b5fe3f66a567bec0(function() {
                        running = false;
                        _this2.setState({
                            needLimitMeasure: true
                        }); //eslint-disable-line
                    });
                }, false);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this.state.needLimitMeasure) this.measureRowLimit(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener('resize', this._resizeListener, false);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, date = _this$props4.date, localizer = _this$props4.localizer, className = _this$props4.className, month = localizer.visibleDays(date, localizer), weeks = (0, (/*@__PURE__*/$parcel$interopDefault($5f27ac4c26d09397$exports)))(month, 7);
                this._weekCount = weeks.length;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                    className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)('rbc-month-view', className),
                    role: "table",
                    "aria-label": "Month View",
                    ref: this.containerRef
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                    className: "rbc-row rbc-month-header",
                    role: "row"
                }, this.renderHeaders(weeks[0])), weeks.map(this.renderWeek), this.props.popup && this.renderOverlay());
            }
        },
        {
            key: "renderHeaders",
            value: function renderHeaders(row) {
                var _this$props5 = this.props, localizer = _this$props5.localizer, components = _this$props5.components;
                var first = row[0];
                var last = row[row.length - 1];
                var HeaderComponent = components.header || $f145fa6d412a8ce0$var$Header;
                return localizer.range(first, last, 'day').map(function(day, idx) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                        key: 'header_' + idx,
                        className: "rbc-header"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(HeaderComponent, {
                        date: day,
                        localizer: localizer,
                        label: localizer.format(day, 'weekdayFormat')
                    }));
                });
            }
        },
        {
            key: "renderOverlay",
            value: function renderOverlay() {
                var _this$state$overlay, _this$state2, _this3 = this;
                var overlay = (_this$state$overlay = (_this$state2 = this.state) === null || _this$state2 === void 0 ? void 0 : _this$state2.overlay) !== null && _this$state$overlay !== void 0 ? _this$state$overlay : {};
                var _this$props6 = this.props, accessors = _this$props6.accessors, localizer = _this$props6.localizer, components = _this$props6.components, getters = _this$props6.getters, selected = _this$props6.selected, popupOffset = _this$props6.popupOffset, handleDragStart = _this$props6.handleDragStart;
                var onHide = function onHide() {
                    return _this3.setState({
                        overlay: null
                    });
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$PopOverlay, {
                    overlay: overlay,
                    accessors: accessors,
                    localizer: localizer,
                    components: components,
                    getters: getters,
                    selected: selected,
                    popupOffset: popupOffset,
                    ref: this.containerRef,
                    handleKeyPressEvent: this.handleKeyPressEvent,
                    handleSelectEvent: this.handleSelectEvent,
                    handleDoubleClickEvent: this.handleDoubleClickEvent,
                    handleDragStart: handleDragStart,
                    show: !!overlay.position,
                    overlayDisplay: this.overlayDisplay,
                    onHide: onHide
                });
            /* return (
        <Overlay
          rootClose
          placement="bottom"
          show={!!overlay.position}
          onHide={() => this.setState({ overlay: null })}
          target={() => overlay.target}
        >
          {({ props }) => (
            <Popup
              {...props}
              popupOffset={popupOffset}
              accessors={accessors}
              getters={getters}
              selected={selected}
              components={components}
              localizer={localizer}
              position={overlay.position}
              show={this.overlayDisplay}
              events={overlay.events}
              slotStart={overlay.date}
              slotEnd={overlay.end}
              onSelect={this.handleSelectEvent}
              onDoubleClick={this.handleDoubleClickEvent}
              onKeyPress={this.handleKeyPressEvent}
              handleDragStart={this.props.handleDragStart}
            />
          )}
        </Overlay>
      ) */ }
        },
        {
            key: "measureRowLimit",
            value: function measureRowLimit() {
                this.setState({
                    needLimitMeasure: false,
                    rowLimit: this.slotRowRef.current.getRowLimit()
                });
            }
        },
        {
            key: "selectDates",
            value: function selectDates(slotInfo) {
                var slots = this._pendingSelection.slice();
                this._pendingSelection = [];
                slots.sort(function(a, b) {
                    return +a - +b;
                });
                var start = new Date(slots[0]);
                var end = new Date(slots[slots.length - 1]);
                end.setDate(slots[slots.length - 1].getDate() + 1);
                $f145fa6d412a8ce0$var$notify(this.props.onSelectSlot, {
                    slots: slots,
                    start: start,
                    end: end,
                    action: slotInfo.action,
                    bounds: slotInfo.bounds,
                    box: slotInfo.box
                });
            }
        },
        {
            key: "clearSelection",
            value: function clearSelection() {
                clearTimeout(this._selectTimer);
                this._pendingSelection = [];
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(_ref2, state) {
                var date = _ref2.date, localizer = _ref2.localizer;
                return {
                    date: date,
                    needLimitMeasure: localizer.neq(date, state.date, 'month')
                };
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Component);
$f145fa6d412a8ce0$var$MonthView.range = function(date, _ref3) {
    var localizer = _ref3.localizer;
    var start = localizer.firstVisibleDay(date, localizer);
    var end = localizer.lastVisibleDay(date, localizer);
    return {
        start: start,
        end: end
    };
};
$f145fa6d412a8ce0$var$MonthView.navigate = function(date, action, _ref4) {
    var localizer = _ref4.localizer;
    switch(action){
        case $f145fa6d412a8ce0$export$444b3ab0cb9aec40.PREVIOUS:
            return localizer.add(date, -1, 'month');
        case $f145fa6d412a8ce0$export$444b3ab0cb9aec40.NEXT:
            return localizer.add(date, 1, 'month');
        default:
            return date;
    }
};
$f145fa6d412a8ce0$var$MonthView.title = function(date, _ref5) {
    var localizer = _ref5.localizer;
    return localizer.format(date, 'monthHeaderFormat');
};
var $f145fa6d412a8ce0$var$getKey = function getKey(_ref) {
    var min = _ref.min, max = _ref.max, step = _ref.step, slots = _ref.slots, localizer = _ref.localizer;
    return "".concat(+localizer.startOf(min, 'minutes')) + "".concat(+localizer.startOf(max, 'minutes')) + "".concat(step, "-").concat(slots);
};
function $f145fa6d412a8ce0$var$getSlotMetrics(_ref2) {
    var start = _ref2.min, end = _ref2.max, step = _ref2.step, timeslots = _ref2.timeslots, localizer = _ref2.localizer;
    var key = $f145fa6d412a8ce0$var$getKey({
        start: start,
        end: end,
        step: step,
        timeslots: timeslots,
        localizer: localizer
    });
    // DST differences are handled inside the localizer
    var totalMin = 1 + localizer.getTotalMin(start, end);
    var minutesFromMidnight = localizer.getMinutesFromMidnight(start);
    var numGroups = Math.ceil((totalMin - 1) / (step * timeslots));
    var numSlots = numGroups * timeslots;
    var groups = new Array(numGroups);
    var slots = new Array(numSlots);
    // Each slot date is created from "zero", instead of adding `step` to
    // the previous one, in order to avoid DST oddities
    for(var grp = 0; grp < numGroups; grp++){
        groups[grp] = new Array(timeslots);
        for(var slot = 0; slot < timeslots; slot++){
            var slotIdx = grp * timeslots + slot;
            var minFromStart = slotIdx * step;
            // A date with total minutes calculated from the start of the day
            slots[slotIdx] = groups[grp][slot] = localizer.getSlotDate(start, minutesFromMidnight, minFromStart);
        }
    }
    // Necessary to be able to select up until the last timeslot in a day
    var lastSlotMinFromStart = slots.length * step;
    slots.push(localizer.getSlotDate(start, minutesFromMidnight, lastSlotMinFromStart));
    function positionFromDate(date) {
        var diff = localizer.diff(start, date, 'minutes') + localizer.getDstOffset(start, date);
        return Math.min(diff, totalMin);
    }
    return {
        groups: groups,
        update: function update(args) {
            if ($f145fa6d412a8ce0$var$getKey(args) !== key) return $f145fa6d412a8ce0$var$getSlotMetrics(args);
            return this;
        },
        dateIsInGroup: function dateIsInGroup(date, groupIndex) {
            var nextGroup = groups[groupIndex + 1];
            return localizer.inRange(date, groups[groupIndex][0], nextGroup ? nextGroup[0] : end, 'minutes');
        },
        nextSlot: function nextSlot(slot) {
            // We cannot guarantee that the slot object must be in slots,
            // because after each update, a new slots array will be created.
            var next = slots[Math.min(slots.findIndex(function(s) {
                return s === slot || localizer.eq(s, slot);
            }) + 1, slots.length - 1)];
            // in the case of the last slot we won't a long enough range so manually get it
            if (localizer.eq(next, slot)) next = localizer.add(slot, step, 'minutes');
            return next;
        },
        closestSlotToPosition: function closestSlotToPosition(percent) {
            var slot = Math.min(slots.length - 1, Math.max(0, Math.floor(percent * numSlots)));
            return slots[slot];
        },
        closestSlotFromPoint: function closestSlotFromPoint(point, boundaryRect) {
            var range = Math.abs(boundaryRect.top - boundaryRect.bottom);
            return this.closestSlotToPosition((point.y - boundaryRect.top) / range);
        },
        closestSlotFromDate: function closestSlotFromDate(date) {
            var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            if (localizer.lt(date, start, 'minutes')) return slots[0];
            if (localizer.gt(date, end, 'minutes')) return slots[slots.length - 1];
            var diffMins = localizer.diff(start, date, 'minutes');
            return slots[(diffMins - diffMins % step) / step + offset];
        },
        startsBeforeDay: function startsBeforeDay(date) {
            return localizer.lt(date, start, 'day');
        },
        startsAfterDay: function startsAfterDay(date) {
            return localizer.gt(date, end, 'day');
        },
        startsBefore: function startsBefore(date) {
            return localizer.lt(localizer.merge(start, date), start, 'minutes');
        },
        startsAfter: function startsAfter(date) {
            return localizer.gt(localizer.merge(end, date), end, 'minutes');
        },
        getRange: function getRange(rangeStart, rangeEnd, ignoreMin, ignoreMax) {
            if (!ignoreMin) rangeStart = localizer.min(end, localizer.max(start, rangeStart));
            if (!ignoreMax) rangeEnd = localizer.min(end, localizer.max(start, rangeEnd));
            var rangeStartMin = positionFromDate(rangeStart);
            var rangeEndMin = positionFromDate(rangeEnd);
            var top = rangeEndMin > step * numSlots && !localizer.eq(end, rangeEnd) ? (rangeStartMin - step) / (step * numSlots) * 100 : rangeStartMin / (step * numSlots) * 100;
            return {
                top: top,
                height: rangeEndMin / (step * numSlots) * 100 - top,
                start: positionFromDate(rangeStart),
                startDate: rangeStart,
                end: positionFromDate(rangeEnd),
                endDate: rangeEnd
            };
        },
        getCurrentTimePosition: function getCurrentTimePosition(rangeStart) {
            var rangeStartMin = positionFromDate(rangeStart);
            var top = rangeStartMin / (step * numSlots) * 100;
            return top;
        }
    };
}
var $f145fa6d412a8ce0$var$Event = /*#__PURE__*/ function() {
    function Event(data, _ref) {
        var accessors = _ref.accessors, slotMetrics = _ref.slotMetrics;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, Event);
        var _slotMetrics$getRange = slotMetrics.getRange(accessors.start(data), accessors.end(data)), start = _slotMetrics$getRange.start, startDate = _slotMetrics$getRange.startDate, end = _slotMetrics$getRange.end, endDate = _slotMetrics$getRange.endDate, top = _slotMetrics$getRange.top, height = _slotMetrics$getRange.height;
        this.start = start;
        this.end = end;
        this.startMs = +startDate;
        this.endMs = +endDate;
        this.top = top;
        this.height = height;
        this.data = data;
    }
    /**
   * The event's width without any overlap.
   */ return (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(Event, [
        {
            key: "_width",
            get: function get() {
                // The container event's width is determined by the maximum number of
                // events in any of its rows.
                if (this.rows) {
                    var columns = this.rows.reduce(function(max, row) {
                        return Math.max(max, row.leaves.length + 1);
                    }, // add itself
                    0) + 1; // add the container
                    return 100 / columns;
                }
                // The row event's width is the space left by the container, divided
                // among itself and its leaves.
                if (this.leaves) {
                    var availableWidth = 100 - this.container._width;
                    return availableWidth / (this.leaves.length + 1);
                }
                // The leaf event's width is determined by its row's width
                return this.row._width;
            }
        },
        {
            key: "width",
            get: function get() {
                var noOverlap = this._width;
                var overlap = Math.min(100, this._width * 1.7);
                // Containers can always grow.
                if (this.rows) return overlap;
                // Rows can grow if they have leaves.
                if (this.leaves) return this.leaves.length > 0 ? overlap : noOverlap;
                // Leaves can grow unless they're the last item in a row.
                var leaves = this.row.leaves;
                var index = leaves.indexOf(this);
                return index === leaves.length - 1 ? noOverlap : overlap;
            }
        },
        {
            key: "xOffset",
            get: function get() {
                // Containers have no offset.
                if (this.rows) return 0;
                // Rows always start where their container ends.
                if (this.leaves) return this.container._width;
                // Leaves are spread out evenly on the space left by its row.
                var _this$row = this.row, leaves = _this$row.leaves, xOffset = _this$row.xOffset, _width = _this$row._width;
                var index = leaves.indexOf(this) + 1;
                return xOffset + index * _width;
            }
        }
    ]);
}();
/**
 * Return true if event a and b is considered to be on the same row.
 */ function $f145fa6d412a8ce0$var$onSameRow(a, b, minimumStartDifference) {
    return(// Occupies the same start slot.
    Math.abs(b.start - a.start) < minimumStartDifference || // A's start slot overlaps with b's end slot.
    b.start > a.start && b.start < a.end);
}
function $f145fa6d412a8ce0$var$sortByRender(events) {
    var sortedByTime = (0, (/*@__PURE__*/$parcel$interopDefault($5aa1fc3d501b351b$exports)))(events, [
        'startMs',
        function(e) {
            return -e.endMs;
        }
    ]);
    var sorted = [];
    while(sortedByTime.length > 0){
        var event = sortedByTime.shift();
        sorted.push(event);
        for(var i = 0; i < sortedByTime.length; i++){
            var test = sortedByTime[i];
            // Still inside this event, look for next.
            if (event.endMs > test.startMs) continue;
            // We've found the first event of the next event group.
            // If that event is not right next to our current event, we have to
            // move it here.
            if (i > 0) {
                var _event = sortedByTime.splice(i, 1)[0];
                sorted.push(_event);
            }
            break;
        }
    }
    return sorted;
}
function $f145fa6d412a8ce0$var$getStyledEvents$1(_ref2) {
    var events = _ref2.events, minimumStartDifference = _ref2.minimumStartDifference, slotMetrics = _ref2.slotMetrics, accessors = _ref2.accessors;
    // Create proxy events and order them so that we don't have
    // to fiddle with z-indexes.
    var proxies = events.map(function(event) {
        return new $f145fa6d412a8ce0$var$Event(event, {
            slotMetrics: slotMetrics,
            accessors: accessors
        });
    });
    var eventsInRenderOrder = $f145fa6d412a8ce0$var$sortByRender(proxies);
    // Group overlapping events, while keeping order.
    // Every event is always one of: container, row or leaf.
    // Containers can contain rows, and rows can contain leaves.
    var containerEvents = [];
    var _loop = function _loop() {
        var event = eventsInRenderOrder[i];
        // Check if this event can go into a container event.
        var container = containerEvents.find(function(c) {
            return c.end > event.start || Math.abs(event.start - c.start) < minimumStartDifference;
        });
        // Couldn't find a container — that means this event is a container.
        if (!container) {
            event.rows = [];
            containerEvents.push(event);
            return 1; // continue
        }
        // Found a container for the event.
        event.container = container;
        // Check if the event can be placed in an existing row.
        // Start looking from behind.
        var row = null;
        for(var j = container.rows.length - 1; !row && j >= 0; j--)if ($f145fa6d412a8ce0$var$onSameRow(container.rows[j], event, minimumStartDifference)) row = container.rows[j];
        if (row) {
            // Found a row, so add it.
            row.leaves.push(event);
            event.row = row;
        } else {
            // Couldn't find a row – that means this event is a row.
            event.leaves = [];
            container.rows.push(event);
        }
    };
    for(var i = 0; i < eventsInRenderOrder.length; i++){
        if (_loop()) continue;
    }
    // Return the original events, along with their styles.
    return eventsInRenderOrder.map(function(event) {
        return {
            event: event.data,
            style: {
                top: event.top,
                height: event.height,
                width: event.width,
                xOffset: Math.max(0, event.xOffset)
            }
        };
    });
}
function $f145fa6d412a8ce0$var$getMaxIdxDFS(node, maxIdx, visited) {
    for(var i = 0; i < node.friends.length; ++i){
        if (visited.indexOf(node.friends[i]) > -1) continue;
        maxIdx = maxIdx > node.friends[i].idx ? maxIdx : node.friends[i].idx;
        // TODO : trace it by not object but kinda index or something for performance
        visited.push(node.friends[i]);
        var newIdx = $f145fa6d412a8ce0$var$getMaxIdxDFS(node.friends[i], maxIdx, visited);
        maxIdx = maxIdx > newIdx ? maxIdx : newIdx;
    }
    return maxIdx;
}
function $f145fa6d412a8ce0$var$noOverlap(_ref) {
    var events = _ref.events, minimumStartDifference = _ref.minimumStartDifference, slotMetrics = _ref.slotMetrics, accessors = _ref.accessors;
    var styledEvents = $f145fa6d412a8ce0$var$getStyledEvents$1({
        events: events,
        minimumStartDifference: minimumStartDifference,
        slotMetrics: slotMetrics,
        accessors: accessors
    });
    styledEvents.sort(function(a, b) {
        a = a.style;
        b = b.style;
        if (a.top !== b.top) return a.top > b.top ? 1 : -1;
        else if (a.height !== b.height) return a.top + a.height < b.top + b.height ? 1 : -1;
        else return 0;
    });
    for(var i = 0; i < styledEvents.length; ++i){
        styledEvents[i].friends = [];
        delete styledEvents[i].style.left;
        delete styledEvents[i].style.left;
        delete styledEvents[i].idx;
        delete styledEvents[i].size;
    }
    for(var _i2 = 0; _i2 < styledEvents.length - 1; ++_i2){
        var se1 = styledEvents[_i2];
        var y1 = se1.style.top;
        var y2 = se1.style.top + se1.style.height;
        for(var j = _i2 + 1; j < styledEvents.length; ++j){
            var se2 = styledEvents[j];
            var y3 = se2.style.top;
            var y4 = se2.style.top + se2.style.height;
            if (y3 >= y1 && y4 <= y2 || y4 > y1 && y4 <= y2 || y3 >= y1 && y3 < y2) {
                // TODO : hashmap would be effective for performance
                se1.friends.push(se2);
                se2.friends.push(se1);
            }
        }
    }
    for(var _i4 = 0; _i4 < styledEvents.length; ++_i4){
        var se = styledEvents[_i4];
        var bitmap = [];
        for(var _j2 = 0; _j2 < 100; ++_j2)bitmap.push(1); // 1 means available
        for(var _j4 = 0; _j4 < se.friends.length; ++_j4)if (se.friends[_j4].idx !== undefined) bitmap[se.friends[_j4].idx] = 0; // 0 means reserved
        se.idx = bitmap.indexOf(1);
    }
    for(var _i6 = 0; _i6 < styledEvents.length; ++_i6){
        var size = 0;
        if (styledEvents[_i6].size) continue;
        var allFriends = [];
        var maxIdx = $f145fa6d412a8ce0$var$getMaxIdxDFS(styledEvents[_i6], 0, allFriends);
        size = 100 / (maxIdx + 1);
        styledEvents[_i6].size = size;
        for(var _j6 = 0; _j6 < allFriends.length; ++_j6)allFriends[_j6].size = size;
    }
    for(var _i8 = 0; _i8 < styledEvents.length; ++_i8){
        var e = styledEvents[_i8];
        e.style.left = e.idx * e.size;
        // stretch to maximum
        var _maxIdx = 0;
        for(var _j8 = 0; _j8 < e.friends.length; ++_j8){
            var idx = e.friends[_j8].idx;
            _maxIdx = _maxIdx > idx ? _maxIdx : idx;
        }
        if (_maxIdx <= e.idx) e.size = 100 - e.idx * e.size;
        // padding between events
        // for this feature, `width` is not percentage based unit anymore
        // it will be used with calc()
        var padding = e.idx === 0 ? 0 : 3;
        e.style.width = "calc(".concat(e.size, "% - ").concat(padding, "px)");
        e.style.height = "calc(".concat(e.style.height, "% - 2px)");
        e.style.xOffset = "calc(".concat(e.style.left, "% + ").concat(padding, "px)");
    }
    return styledEvents;
}
/*eslint no-unused-vars: "off"*/ var $f145fa6d412a8ce0$var$DefaultAlgorithms = {
    overlap: $f145fa6d412a8ce0$var$getStyledEvents$1,
    'no-overlap': $f145fa6d412a8ce0$var$noOverlap
};
function $f145fa6d412a8ce0$var$isFunction(a) {
    return !!(a && a.constructor && a.call && a.apply);
}
//
function $f145fa6d412a8ce0$var$getStyledEvents(_ref) {
    _ref.events;
    _ref.minimumStartDifference;
    _ref.slotMetrics;
    _ref.accessors;
    var dayLayoutAlgorithm = _ref.dayLayoutAlgorithm;
    var algorithm = dayLayoutAlgorithm;
    if (dayLayoutAlgorithm in $f145fa6d412a8ce0$var$DefaultAlgorithms) algorithm = $f145fa6d412a8ce0$var$DefaultAlgorithms[dayLayoutAlgorithm];
    if (!$f145fa6d412a8ce0$var$isFunction(algorithm)) // invalid algorithm
    return [];
    return algorithm.apply(this, arguments);
}
var $f145fa6d412a8ce0$var$TimeSlotGroup = /*#__PURE__*/ function(_Component) {
    function TimeSlotGroup() {
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, TimeSlotGroup);
        return (0, $db22c8b683e5147b$export$2e2bcd8739ae039)(this, TimeSlotGroup, arguments);
    }
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(TimeSlotGroup, _Component);
    return (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(TimeSlotGroup, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, renderSlot = _this$props.renderSlot, resource = _this$props.resource, group = _this$props.group, getters = _this$props.getters, _this$props$component = _this$props.components, _this$props$component2 = _this$props$component === void 0 ? {} : _this$props$component, _this$props$component3 = _this$props$component2.timeSlotWrapper, Wrapper = _this$props$component3 === void 0 ? $f145fa6d412a8ce0$var$NoopWrapper : _this$props$component3;
                var groupProps = getters ? getters.slotGroupProp(group) : {};
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", Object.assign({
                    className: "rbc-timeslot-group"
                }, groupProps), group.map(function(value, idx) {
                    var slotProps = getters ? getters.slotProp(value, resource) : {};
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(Wrapper, {
                        key: idx,
                        value: value,
                        resource: resource
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", Object.assign({}, slotProps, {
                        className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)('rbc-time-slot', slotProps.className)
                    }), renderSlot && renderSlot(value, idx)));
                }));
            }
        }
    ]);
}((0, $gRqVZ.Component));
function $f145fa6d412a8ce0$var$stringifyPercent(v) {
    return typeof v === 'string' ? v : v + '%';
}
/* eslint-disable react/prop-types */ function $f145fa6d412a8ce0$var$TimeGridEvent(props) {
    var style = props.style, className = props.className, event = props.event, accessors = props.accessors, rtl = props.rtl, selected = props.selected, label = props.label, continuesPrior = props.continuesPrior, continuesAfter = props.continuesAfter, getters = props.getters, onClick = props.onClick, onDoubleClick = props.onDoubleClick, isBackgroundEvent = props.isBackgroundEvent, onKeyPress = props.onKeyPress, _props$components = props.components, Event = _props$components.event, EventWrapper = _props$components.eventWrapper;
    var title = accessors.title(event);
    var tooltip = accessors.tooltip(event);
    var end = accessors.end(event);
    var start = accessors.start(event);
    var userProps = getters.eventProp(event, start, end, selected);
    var inner = [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            key: "1",
            className: "rbc-event-label"
        }, label),
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
            key: "2",
            className: "rbc-event-content"
        }, Event ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(Event, {
            event: event,
            title: title
        }) : title)
    ];
    var height = style.height, top = style.top, width = style.width, xOffset = style.xOffset;
    var eventStyle = (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, userProps.style), {}, (0, $6a740e003744eccd$export$2e2bcd8739ae039)({
        top: $f145fa6d412a8ce0$var$stringifyPercent(top),
        height: $f145fa6d412a8ce0$var$stringifyPercent(height),
        width: $f145fa6d412a8ce0$var$stringifyPercent(width)
    }, rtl ? 'right' : 'left', $f145fa6d412a8ce0$var$stringifyPercent(xOffset)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(EventWrapper, Object.assign({
        type: "time"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
        role: "button",
        tabIndex: 0,
        onClick: onClick,
        onDoubleClick: onDoubleClick,
        style: eventStyle,
        onKeyDown: onKeyPress,
        title: tooltip ? (typeof label === 'string' ? label + ': ' : '') + tooltip : undefined,
        className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)(isBackgroundEvent ? 'rbc-background-event' : 'rbc-event', className, userProps.className, {
            'rbc-selected': selected,
            'rbc-event-continues-earlier': continuesPrior,
            'rbc-event-continues-later': continuesAfter
        })
    }, inner));
}
var $f145fa6d412a8ce0$var$DayColumnWrapper = function DayColumnWrapper(_ref) {
    var children = _ref.children, className = _ref.className, style = _ref.style, innerRef = _ref.innerRef;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
        className: className,
        style: style,
        ref: innerRef
    }, children);
};
var $f145fa6d412a8ce0$var$DayColumnWrapper$1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$DayColumnWrapper, Object.assign({}, props, {
        innerRef: ref
    }));
});
var $f145fa6d412a8ce0$var$_excluded$5 = [
    "dayProp"
], $f145fa6d412a8ce0$var$_excluded2$1 = [
    "eventContainerWrapper",
    "timeIndicatorWrapper"
];
var $f145fa6d412a8ce0$var$DayColumn = /*#__PURE__*/ function(_React$Component) {
    function DayColumn() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, DayColumn);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = (0, $db22c8b683e5147b$export$2e2bcd8739ae039)(this, DayColumn, [].concat(_args));
        _this.state = {
            selecting: false,
            timeIndicatorPosition: null
        };
        _this.intervalTriggered = false;
        _this.renderEvents = function(_ref) {
            var events = _ref.events, isBackgroundEvent = _ref.isBackgroundEvent;
            var _this$props = _this.props, rtl = _this$props.rtl, selected = _this$props.selected, accessors = _this$props.accessors, localizer = _this$props.localizer, getters = _this$props.getters, components = _this$props.components, step = _this$props.step, timeslots = _this$props.timeslots, dayLayoutAlgorithm = _this$props.dayLayoutAlgorithm, resizable = _this$props.resizable;
            var _this2 = _this, slotMetrics = _this2.slotMetrics;
            var messages = localizer.messages;
            var styledEvents = $f145fa6d412a8ce0$var$getStyledEvents({
                events: events,
                accessors: accessors,
                slotMetrics: slotMetrics,
                minimumStartDifference: Math.ceil(step * timeslots / 2),
                dayLayoutAlgorithm: dayLayoutAlgorithm
            });
            return styledEvents.map(function(_ref2, idx) {
                var _accessors$eventId;
                var event = _ref2.event, style = _ref2.style;
                var end = accessors.end(event);
                var start = accessors.start(event);
                var key = (_accessors$eventId = accessors.eventId(event)) !== null && _accessors$eventId !== void 0 ? _accessors$eventId : 'evt_' + idx;
                var format = 'eventTimeRangeFormat';
                var label;
                var startsBeforeDay = slotMetrics.startsBeforeDay(start);
                var startsAfterDay = slotMetrics.startsAfterDay(end);
                if (startsBeforeDay) format = 'eventTimeRangeEndFormat';
                else if (startsAfterDay) format = 'eventTimeRangeStartFormat';
                if (startsBeforeDay && startsAfterDay) label = messages.allDay;
                else label = localizer.format({
                    start: start,
                    end: end
                }, format);
                var continuesPrior = startsBeforeDay || slotMetrics.startsBefore(start);
                var continuesAfter = startsAfterDay || slotMetrics.startsAfter(end);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$TimeGridEvent, {
                    style: style,
                    event: event,
                    label: label,
                    key: key,
                    getters: getters,
                    rtl: rtl,
                    components: components,
                    continuesPrior: continuesPrior,
                    continuesAfter: continuesAfter,
                    accessors: accessors,
                    resource: _this.props.resource,
                    selected: $f145fa6d412a8ce0$var$isSelected(event, selected),
                    onClick: function onClick(e) {
                        return _this._select((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, event), _this.props.resource && {
                            sourceResource: _this.props.resource
                        }), isBackgroundEvent && {
                            isBackgroundEvent: true
                        }), e);
                    },
                    onDoubleClick: function onDoubleClick(e) {
                        return _this._doubleClick(event, e);
                    },
                    isBackgroundEvent: isBackgroundEvent,
                    onKeyPress: function onKeyPress(e) {
                        return _this._keyPress(event, e);
                    },
                    resizable: resizable
                });
            });
        };
        _this._selectable = function() {
            var node = _this.containerRef.current;
            var _this$props2 = _this.props, longPressThreshold = _this$props2.longPressThreshold, localizer = _this$props2.localizer;
            var selector = _this._selector = new $f145fa6d412a8ce0$var$Selection(function() {
                return node;
            }, {
                longPressThreshold: longPressThreshold
            });
            var maybeSelect = function maybeSelect(box) {
                var onSelecting = _this.props.onSelecting;
                var current = _this.state || {};
                var state = selectionState(box);
                var start = state.startDate, end = state.endDate;
                if (onSelecting) {
                    if (localizer.eq(current.startDate, start, 'minutes') && localizer.eq(current.endDate, end, 'minutes') || onSelecting({
                        start: start,
                        end: end,
                        resourceId: _this.props.resource
                    }) === false) return;
                }
                if (_this.state.start !== state.start || _this.state.end !== state.end || _this.state.selecting !== state.selecting) _this.setState(state);
            };
            var selectionState = function selectionState(point) {
                var currentSlot = _this.slotMetrics.closestSlotFromPoint(point, $f145fa6d412a8ce0$var$getBoundsForNode(node));
                if (!_this.state.selecting) _this._initialSlot = currentSlot;
                var initialSlot = _this._initialSlot;
                if (localizer.lte(initialSlot, currentSlot)) currentSlot = _this.slotMetrics.nextSlot(currentSlot);
                else if (localizer.gt(initialSlot, currentSlot)) initialSlot = _this.slotMetrics.nextSlot(initialSlot);
                var selectRange = _this.slotMetrics.getRange(localizer.min(initialSlot, currentSlot), localizer.max(initialSlot, currentSlot));
                return (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, selectRange), {}, {
                    selecting: true,
                    top: "".concat(selectRange.top, "%"),
                    height: "".concat(selectRange.height, "%")
                });
            };
            var selectorClicksHandler = function selectorClicksHandler(box, actionType) {
                if (!$f145fa6d412a8ce0$var$isEvent(_this.containerRef.current, box)) {
                    var _selectionState = selectionState(box), startDate = _selectionState.startDate, endDate = _selectionState.endDate;
                    _this._selectSlot({
                        startDate: startDate,
                        endDate: endDate,
                        action: actionType,
                        box: box
                    });
                }
                _this.setState({
                    selecting: false
                });
            };
            selector.on('selecting', maybeSelect);
            selector.on('selectStart', maybeSelect);
            selector.on('beforeSelect', function(box) {
                if (_this.props.selectable !== 'ignoreEvents') return;
                return !$f145fa6d412a8ce0$var$isEvent(_this.containerRef.current, box);
            });
            selector.on('click', function(box) {
                return selectorClicksHandler(box, 'click');
            });
            selector.on('doubleClick', function(box) {
                return selectorClicksHandler(box, 'doubleClick');
            });
            selector.on('select', function(bounds) {
                if (_this.state.selecting) {
                    _this._selectSlot((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, _this.state), {}, {
                        action: 'select',
                        bounds: bounds
                    }));
                    _this.setState({
                        selecting: false
                    });
                }
            });
            selector.on('reset', function() {
                if (_this.state.selecting) _this.setState({
                    selecting: false
                });
            });
        };
        _this._teardownSelectable = function() {
            if (!_this._selector) return;
            _this._selector.teardown();
            _this._selector = null;
        };
        _this._selectSlot = function(_ref3) {
            var startDate = _ref3.startDate, endDate = _ref3.endDate, action = _ref3.action, bounds = _ref3.bounds, box = _ref3.box;
            var current = startDate, slots = [];
            while(_this.props.localizer.lte(current, endDate)){
                slots.push(current);
                current = new Date(+current + _this.props.step * 60000); // using Date ensures not to create an endless loop the day DST begins
            }
            $f145fa6d412a8ce0$var$notify(_this.props.onSelectSlot, {
                slots: slots,
                start: startDate,
                end: endDate,
                resourceId: _this.props.resource,
                action: action,
                bounds: bounds,
                box: box
            });
        };
        _this._select = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            $f145fa6d412a8ce0$var$notify(_this.props.onSelectEvent, args);
        };
        _this._doubleClick = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            $f145fa6d412a8ce0$var$notify(_this.props.onDoubleClickEvent, args);
        };
        _this._keyPress = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            $f145fa6d412a8ce0$var$notify(_this.props.onKeyPressEvent, args);
        };
        _this.slotMetrics = $f145fa6d412a8ce0$var$getSlotMetrics(_this.props);
        _this.containerRef = /*#__PURE__*/ (0, $gRqVZ.createRef)();
        return _this;
    }
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(DayColumn, _React$Component);
    return (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(DayColumn, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.selectable && this._selectable();
                if (this.props.isNow) this.setTimeIndicatorPositionUpdateInterval();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._teardownSelectable();
                this.clearTimeIndicatorInterval();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.selectable && !prevProps.selectable) this._selectable();
                if (!this.props.selectable && prevProps.selectable) this._teardownSelectable();
                var _this$props3 = this.props, getNow = _this$props3.getNow, isNow = _this$props3.isNow, localizer = _this$props3.localizer, date = _this$props3.date, min = _this$props3.min, max = _this$props3.max;
                var getNowChanged = localizer.neq(prevProps.getNow(), getNow(), 'minutes');
                if (prevProps.isNow !== isNow || getNowChanged) {
                    this.clearTimeIndicatorInterval();
                    if (isNow) {
                        var tail = !getNowChanged && localizer.eq(prevProps.date, date, 'minutes') && prevState.timeIndicatorPosition === this.state.timeIndicatorPosition;
                        this.setTimeIndicatorPositionUpdateInterval(tail);
                    }
                } else if (isNow && (localizer.neq(prevProps.min, min, 'minutes') || localizer.neq(prevProps.max, max, 'minutes'))) this.positionTimeIndicator();
            }
        },
        {
            key: "setTimeIndicatorPositionUpdateInterval",
            value: function setTimeIndicatorPositionUpdateInterval() {
                var _this3 = this;
                var tail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                if (!this.intervalTriggered && !tail) this.positionTimeIndicator();
                this._timeIndicatorTimeout = window.setTimeout(function() {
                    _this3.intervalTriggered = true;
                    _this3.positionTimeIndicator();
                    _this3.setTimeIndicatorPositionUpdateInterval();
                }, 60000);
            }
        },
        {
            key: "clearTimeIndicatorInterval",
            value: function clearTimeIndicatorInterval() {
                this.intervalTriggered = false;
                window.clearTimeout(this._timeIndicatorTimeout);
            }
        },
        {
            key: "positionTimeIndicator",
            value: function positionTimeIndicator() {
                var _this$props4 = this.props, min = _this$props4.min, max = _this$props4.max, getNow = _this$props4.getNow;
                var current = getNow();
                if (current >= min && current <= max) {
                    var top = this.slotMetrics.getCurrentTimePosition(current);
                    this.intervalTriggered = true;
                    this.setState({
                        timeIndicatorPosition: top
                    });
                } else this.clearTimeIndicatorInterval();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, date = _this$props5.date, max = _this$props5.max, rtl = _this$props5.rtl, isNow = _this$props5.isNow, resource = _this$props5.resource, accessors = _this$props5.accessors, localizer = _this$props5.localizer, _this$props5$getters = _this$props5.getters, dayProp = _this$props5$getters.dayProp, getters = (0, $f308b666a2f706a5$export$2e2bcd8739ae039)(_this$props5$getters, $f145fa6d412a8ce0$var$_excluded$5), _this$props5$componen = _this$props5.components, EventContainer = _this$props5$componen.eventContainerWrapper, TimeIndicatorWrapper = _this$props5$componen.timeIndicatorWrapper, components = (0, $f308b666a2f706a5$export$2e2bcd8739ae039)(_this$props5$componen, $f145fa6d412a8ce0$var$_excluded2$1);
                this.slotMetrics = this.slotMetrics.update(this.props);
                var slotMetrics = this.slotMetrics;
                var _this$state = this.state, selecting = _this$state.selecting, top = _this$state.top, height = _this$state.height, startDate = _this$state.startDate, endDate = _this$state.endDate;
                var selectDates = {
                    start: startDate,
                    end: endDate
                };
                var _dayProp = dayProp(max, resource), className = _dayProp.className, style = _dayProp.style;
                var timeIndicatorProps = {
                    className: 'rbc-current-time-indicator',
                    style: {
                        top: "".concat(this.state.timeIndicatorPosition, "%")
                    }
                };
                var DayColumnWrapperComponent = components.dayColumnWrapper || $f145fa6d412a8ce0$var$DayColumnWrapper$1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(DayColumnWrapperComponent, {
                    ref: this.containerRef,
                    date: date,
                    style: style,
                    className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)(className, 'rbc-day-slot', 'rbc-time-column', isNow && 'rbc-now', isNow && 'rbc-today', // WHY
                    selecting && 'rbc-slot-selecting'),
                    slotMetrics: slotMetrics,
                    resource: resource
                }, slotMetrics.groups.map(function(grp, idx) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$TimeSlotGroup, {
                        key: idx,
                        group: grp,
                        resource: resource,
                        getters: getters,
                        components: components
                    });
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(EventContainer, {
                    localizer: localizer,
                    resource: resource,
                    accessors: accessors,
                    getters: getters,
                    components: components,
                    slotMetrics: slotMetrics
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                    className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)('rbc-events-container', rtl && 'rtl')
                }, this.renderEvents({
                    events: this.props.backgroundEvents,
                    isBackgroundEvent: true
                }), this.renderEvents({
                    events: this.props.events
                }))), selecting && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                    className: "rbc-slot-selection",
                    style: {
                        top: top,
                        height: height
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("span", null, localizer.format(selectDates, 'selectRangeFormat'))), isNow && this.intervalTriggered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(TimeIndicatorWrapper, timeIndicatorProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", timeIndicatorProps)));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Component);
$f145fa6d412a8ce0$var$DayColumn.defaultProps = {
    dragThroughEvents: true,
    timeslots: 2
};
var $f145fa6d412a8ce0$var$ResourceHeader = function ResourceHeader(_ref) {
    var label = _ref.label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Fragment, null, label);
};
var $f145fa6d412a8ce0$var$TimeGridHeader = /*#__PURE__*/ function(_React$Component) {
    function TimeGridHeader() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, TimeGridHeader);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $db22c8b683e5147b$export$2e2bcd8739ae039)(this, TimeGridHeader, [].concat(args));
        _this.handleHeaderClick = function(date, view, e) {
            e.preventDefault();
            $f145fa6d412a8ce0$var$notify(_this.props.onDrillDown, [
                date,
                view
            ]);
        };
        _this.renderRow = function(resource) {
            var _this$props = _this.props, events = _this$props.events, rtl = _this$props.rtl, selectable = _this$props.selectable, getNow = _this$props.getNow, range = _this$props.range, getters = _this$props.getters, localizer = _this$props.localizer, accessors = _this$props.accessors, components = _this$props.components, resizable = _this$props.resizable;
            var resourceId = accessors.resourceId(resource);
            var eventsToDisplay = resource ? events.filter(function(event) {
                return accessors.resource(event) === resourceId;
            }) : events;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$DateContentRow, {
                isAllDay: true,
                rtl: rtl,
                getNow: getNow,
                minRows: 2,
                maxRows: _this.props.allDayMaxRows + 1,
                range: range,
                events: eventsToDisplay,
                resourceId: resourceId,
                className: "rbc-allday-cell",
                selectable: selectable,
                selected: _this.props.selected,
                components: components,
                accessors: accessors,
                getters: getters,
                localizer: localizer,
                onSelect: _this.props.onSelectEvent,
                onShowMore: _this.props.onShowMore,
                onDoubleClick: _this.props.onDoubleClickEvent,
                onKeyPress: _this.props.onKeyPressEvent,
                onSelectSlot: _this.props.onSelectSlot,
                longPressThreshold: _this.props.longPressThreshold,
                resizable: resizable
            });
        };
        return _this;
    }
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(TimeGridHeader, _React$Component);
    return (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(TimeGridHeader, [
        {
            key: "renderHeaderCells",
            value: function renderHeaderCells(range) {
                var _this2 = this;
                var _this$props2 = this.props, localizer = _this$props2.localizer, getDrilldownView = _this$props2.getDrilldownView, getNow = _this$props2.getNow, dayProp = _this$props2.getters.dayProp, _this$props2$componen = _this$props2.components.header, HeaderComponent = _this$props2$componen === void 0 ? $f145fa6d412a8ce0$var$Header : _this$props2$componen;
                var today = getNow();
                return range.map(function(date, i) {
                    var drilldownView = getDrilldownView(date);
                    var label = localizer.format(date, 'dayFormat');
                    var _dayProp = dayProp(date), className = _dayProp.className, style = _dayProp.style;
                    var header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(HeaderComponent, {
                        date: date,
                        label: label,
                        localizer: localizer
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                        key: i,
                        style: style,
                        className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)('rbc-header', className, localizer.isSameDate(date, today) && 'rbc-today')
                    }, drilldownView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("button", {
                        type: "button",
                        className: "rbc-button-link",
                        onClick: function onClick(e) {
                            return _this2.handleHeaderClick(date, drilldownView, e);
                        }
                    }, header) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("span", null, header));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props3 = this.props, width = _this$props3.width, rtl = _this$props3.rtl, resources = _this$props3.resources, range = _this$props3.range, events = _this$props3.events, getNow = _this$props3.getNow, accessors = _this$props3.accessors, selectable = _this$props3.selectable, components = _this$props3.components, getters = _this$props3.getters, scrollRef = _this$props3.scrollRef, localizer = _this$props3.localizer, isOverflowing = _this$props3.isOverflowing, _this$props3$componen = _this$props3.components, TimeGutterHeader = _this$props3$componen.timeGutterHeader, _this$props3$componen2 = _this$props3$componen.resourceHeader, ResourceHeaderComponent = _this$props3$componen2 === void 0 ? $f145fa6d412a8ce0$var$ResourceHeader : _this$props3$componen2, resizable = _this$props3.resizable;
                var style = {};
                if (isOverflowing) style[rtl ? 'marginLeft' : 'marginRight'] = "".concat((0, $1ceeb7c22fe75025$export$2e2bcd8739ae039)() - 1, "px");
                var groupedEvents = resources.groupEvents(events);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                    style: style,
                    ref: scrollRef,
                    className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)('rbc-time-header', isOverflowing && 'rbc-overflowing')
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                    className: "rbc-label rbc-time-header-gutter",
                    style: {
                        width: width,
                        minWidth: width,
                        maxWidth: width
                    }
                }, TimeGutterHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(TimeGutterHeader, null)), resources.map(function(_ref, idx) {
                    var _ref2 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_ref, 2), id = _ref2[0], resource = _ref2[1];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                        className: "rbc-time-header-content",
                        key: id || idx
                    }, resource && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                        className: "rbc-row rbc-row-resource",
                        key: "resource_".concat(idx)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                        className: "rbc-header"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(ResourceHeaderComponent, {
                        index: idx,
                        label: accessors.resourceTitle(resource),
                        resource: resource
                    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                        className: "rbc-row rbc-time-header-cell".concat(range.length <= 1 ? ' rbc-time-header-cell-single-day' : '')
                    }, _this3.renderHeaderCells(range)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$DateContentRow, {
                        isAllDay: true,
                        rtl: rtl,
                        getNow: getNow,
                        minRows: 2,
                        maxRows: _this3.props.allDayMaxRows + 1,
                        range: range,
                        events: groupedEvents.get(id) || [],
                        resourceId: resource && id,
                        className: "rbc-allday-cell",
                        selectable: selectable,
                        selected: _this3.props.selected,
                        components: components,
                        accessors: accessors,
                        getters: getters,
                        localizer: localizer,
                        onSelect: _this3.props.onSelectEvent,
                        onShowMore: _this3.props.onShowMore,
                        onDoubleClick: _this3.props.onDoubleClickEvent,
                        onKeyDown: _this3.props.onKeyPressEvent,
                        onSelectSlot: _this3.props.onSelectSlot,
                        longPressThreshold: _this3.props.longPressThreshold,
                        resizable: resizable
                    }));
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Component);
var $f145fa6d412a8ce0$var$TimeGridHeaderResources = /*#__PURE__*/ function(_React$Component) {
    function TimeGridHeaderResources() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, TimeGridHeaderResources);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $db22c8b683e5147b$export$2e2bcd8739ae039)(this, TimeGridHeaderResources, [].concat(args));
        _this.handleHeaderClick = function(date, view, e) {
            e.preventDefault();
            $f145fa6d412a8ce0$var$notify(_this.props.onDrillDown, [
                date,
                view
            ]);
        };
        return _this;
    }
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(TimeGridHeaderResources, _React$Component);
    return (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(TimeGridHeaderResources, [
        {
            key: "renderHeaderCells",
            value: function renderHeaderCells(range) {
                var _this2 = this;
                var _this$props = this.props, localizer = _this$props.localizer, getDrilldownView = _this$props.getDrilldownView, getNow = _this$props.getNow, dayProp = _this$props.getters.dayProp, _this$props$component = _this$props.components, _this$props$component2 = _this$props$component.header, HeaderComponent = _this$props$component2 === void 0 ? $f145fa6d412a8ce0$var$Header : _this$props$component2, _this$props$component3 = _this$props$component.resourceHeader, ResourceHeaderComponent = _this$props$component3 === void 0 ? $f145fa6d412a8ce0$var$ResourceHeader : _this$props$component3, resources = _this$props.resources, accessors = _this$props.accessors, events = _this$props.events, rtl = _this$props.rtl, selectable = _this$props.selectable, components = _this$props.components, getters = _this$props.getters, resizable = _this$props.resizable;
                var today = getNow();
                var groupedEvents = resources.groupEvents(events);
                return range.map(function(date, idx) {
                    var drilldownView = getDrilldownView(date);
                    var label = localizer.format(date, 'dayFormat');
                    var _dayProp = dayProp(date), className = _dayProp.className, style = _dayProp.style;
                    var header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(HeaderComponent, {
                        date: date,
                        label: label,
                        localizer: localizer
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                        key: idx,
                        className: "rbc-time-header-content rbc-resource-grouping"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                        className: "rbc-row rbc-time-header-cell".concat(range.length <= 1 ? ' rbc-time-header-cell-single-day' : '')
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                        style: style,
                        className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)('rbc-header', className, localizer.isSameDate(date, today) && 'rbc-today')
                    }, drilldownView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("button", {
                        type: "button",
                        className: "rbc-button-link",
                        onClick: function onClick(e) {
                            return _this2.handleHeaderClick(date, drilldownView, e);
                        }
                    }, header) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("span", null, header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                        className: "rbc-row"
                    }, resources.map(function(_ref, idx) {
                        var _ref2 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_ref, 2), id = _ref2[0], resource = _ref2[1];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                            key: "resource_".concat(id, "_").concat(idx),
                            className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)('rbc-header', className, localizer.isSameDate(date, today) && 'rbc-today')
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(ResourceHeaderComponent, {
                            index: idx,
                            label: accessors.resourceTitle(resource),
                            resource: resource
                        }));
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                        className: "rbc-row rbc-m-b-negative-3 rbc-h-full"
                    }, resources.map(function(_ref3, idx) {
                        var _ref4 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_ref3, 2), id = _ref4[0], resource = _ref4[1];
                        // Filter the grouped events by the current date.
                        var filteredEvents = (groupedEvents.get(id) || []).filter(function(event) {
                            return localizer.isSameDate(event.start, date) || localizer.isSameDate(event.end, date);
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$DateContentRow, {
                            key: "resource_".concat(id, "_").concat(idx),
                            isAllDay: true,
                            rtl: rtl,
                            getNow: getNow,
                            minRows: 2,
                            maxRows: _this2.props.allDayMaxRows + 1,
                            range: [
                                date
                            ] // This ensures that only the single day is rendered
                            ,
                            events: filteredEvents // Only show filtered events for this day.
                            ,
                            resourceId: resource && id,
                            className: "rbc-allday-cell",
                            selectable: selectable,
                            selected: _this2.props.selected,
                            components: components,
                            accessors: accessors,
                            getters: getters,
                            localizer: localizer,
                            onSelect: _this2.props.onSelectEvent,
                            onShowMore: _this2.props.onShowMore,
                            onDoubleClick: _this2.props.onDoubleClickEvent,
                            onKeyDown: _this2.props.onKeyPressEvent,
                            onSelectSlot: _this2.props.onSelectSlot,
                            longPressThreshold: _this2.props.longPressThreshold,
                            resizable: resizable
                        });
                    })));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, width = _this$props2.width, rtl = _this$props2.rtl, range = _this$props2.range, scrollRef = _this$props2.scrollRef, isOverflowing = _this$props2.isOverflowing, TimeGutterHeader = _this$props2.components.timeGutterHeader;
                var style = {};
                if (isOverflowing) style[rtl ? 'marginLeft' : 'marginRight'] = "".concat((0, $1ceeb7c22fe75025$export$2e2bcd8739ae039)() - 1, "px");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                    style: style,
                    ref: scrollRef,
                    className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)('rbc-time-header', isOverflowing && 'rbc-overflowing')
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                    className: "rbc-label rbc-time-header-gutter",
                    style: {
                        width: width,
                        minWidth: width,
                        maxWidth: width
                    }
                }, TimeGutterHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(TimeGutterHeader, null)), this.renderHeaderCells(range));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Component);
/**
 * Since the TimeGutter only displays the 'times' of slots in a day, and is separate
 * from the Day Columns themselves, we check to see if the range contains an offset difference
 * and, if so, change the beginning and end 'date' by a day to properly display the slots times
 * used.
 */ function $f145fa6d412a8ce0$var$adjustForDST(_ref) {
    var min = _ref.min, max = _ref.max, localizer = _ref.localizer;
    if (localizer.getTimezoneOffset(min) !== localizer.getTimezoneOffset(max)) return {
        start: localizer.add(min, -1, 'day'),
        end: localizer.add(max, -1, 'day')
    };
    return {
        start: min,
        end: max
    };
}
var $f145fa6d412a8ce0$var$TimeGutter = function TimeGutter(_ref2) {
    var min = _ref2.min, max = _ref2.max, timeslots = _ref2.timeslots, step = _ref2.step, localizer = _ref2.localizer, getNow = _ref2.getNow, resource = _ref2.resource, components = _ref2.components, getters = _ref2.getters, gutterRef = _ref2.gutterRef;
    var TimeGutterWrapper = components.timeGutterWrapper;
    var _useMemo = (0, $gRqVZ.useMemo)(function() {
        return $f145fa6d412a8ce0$var$adjustForDST({
            min: min,
            max: max,
            localizer: localizer
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        min === null || min === void 0 ? void 0 : min.toISOString(),
        max === null || max === void 0 ? void 0 : max.toISOString(),
        localizer
    ]), start = _useMemo.start, end = _useMemo.end;
    var _useState = (0, $gRqVZ.useState)($f145fa6d412a8ce0$var$getSlotMetrics({
        min: start,
        max: end,
        timeslots: timeslots,
        step: step,
        localizer: localizer
    })), _useState2 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_useState, 2), slotMetrics = _useState2[0], setSlotMetrics = _useState2[1];
    (0, $gRqVZ.useEffect)(function() {
        if (slotMetrics) setSlotMetrics(slotMetrics.update({
            min: start,
            max: end,
            timeslots: timeslots,
            step: step,
            localizer: localizer
        }));
    /**
     * We don't want this to fire when slotMetrics is updated as it would recursively bomb
     */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        start === null || start === void 0 ? void 0 : start.toISOString(),
        end === null || end === void 0 ? void 0 : end.toISOString(),
        timeslots,
        step
    ]);
    var renderSlot = (0, $gRqVZ.useCallback)(function(value, idx) {
        if (idx) return null; // don't return the first (0) idx
        var isNow = slotMetrics.dateIsInGroup(getNow(), idx);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("span", {
            className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)('rbc-label', isNow && 'rbc-now')
        }, localizer.format(value, 'timeGutterFormat'));
    }, [
        slotMetrics,
        localizer,
        getNow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(TimeGutterWrapper, {
        slotMetrics: slotMetrics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
        className: "rbc-time-gutter rbc-time-column",
        ref: gutterRef
    }, slotMetrics.groups.map(function(grp, idx) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$TimeSlotGroup, {
            key: idx,
            group: grp,
            resource: resource,
            components: components,
            renderSlot: renderSlot,
            getters: getters
        });
    })));
};
var $f145fa6d412a8ce0$var$TimeGutter$1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$TimeGutter, Object.assign({
        gutterRef: ref
    }, props));
});
var $f145fa6d412a8ce0$var$NONE = {};
function $f145fa6d412a8ce0$var$Resources(resources, accessors) {
    return {
        map: function map(fn) {
            if (!resources) return [
                fn([
                    $f145fa6d412a8ce0$var$NONE,
                    null
                ], 0)
            ];
            return resources.map(function(resource, idx) {
                return fn([
                    accessors.resourceId(resource),
                    resource
                ], idx);
            });
        },
        groupEvents: function groupEvents(events) {
            var eventsByResource = new Map();
            if (!resources) {
                // Return all events if resources are not provided
                eventsByResource.set($f145fa6d412a8ce0$var$NONE, events);
                return eventsByResource;
            }
            events.forEach(function(event) {
                var id = accessors.resource(event) || $f145fa6d412a8ce0$var$NONE;
                if (Array.isArray(id)) id.forEach(function(item) {
                    var resourceEvents = eventsByResource.get(item) || [];
                    resourceEvents.push(event);
                    eventsByResource.set(item, resourceEvents);
                });
                else {
                    var resourceEvents = eventsByResource.get(id) || [];
                    resourceEvents.push(event);
                    eventsByResource.set(id, resourceEvents);
                }
            });
            return eventsByResource;
        }
    };
}
var $f145fa6d412a8ce0$var$TimeGrid = /*#__PURE__*/ function(_Component) {
    function TimeGrid(props) {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, TimeGrid);
        _this = (0, $db22c8b683e5147b$export$2e2bcd8739ae039)(this, TimeGrid, [
            props
        ]);
        _this.handleScroll = function(e) {
            if (_this.scrollRef.current) _this.scrollRef.current.scrollLeft = e.target.scrollLeft;
        };
        _this.handleResize = function() {
            $3f65a5846d5d2f64$export$70b61ad426ddbe54(_this.rafHandle);
            _this.rafHandle = $3f65a5846d5d2f64$export$b5fe3f66a567bec0(_this.checkOverflow);
        };
        _this.handleKeyPressEvent = function() {
            _this.clearSelection();
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            $f145fa6d412a8ce0$var$notify(_this.props.onKeyPressEvent, args);
        };
        _this.handleSelectEvent = function() {
            //cancel any pending selections so only the event click goes through.
            _this.clearSelection();
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            $f145fa6d412a8ce0$var$notify(_this.props.onSelectEvent, args);
        };
        _this.handleDoubleClickEvent = function() {
            _this.clearSelection();
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            $f145fa6d412a8ce0$var$notify(_this.props.onDoubleClickEvent, args);
        };
        _this.handleShowMore = function(events, date, cell, slot, target) {
            var _this$props = _this.props, popup = _this$props.popup, onDrillDown = _this$props.onDrillDown, onShowMore = _this$props.onShowMore, getDrilldownView = _this$props.getDrilldownView, doShowMoreDrillDown = _this$props.doShowMoreDrillDown;
            _this.clearSelection();
            if (popup) {
                var position = (0, $1c04ca32884af598$export$2e2bcd8739ae039)(cell, _this.containerRef.current);
                _this.setState({
                    overlay: {
                        date: date,
                        events: events,
                        position: (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, position), {}, {
                            width: '200px'
                        }),
                        target: target
                    }
                });
            } else if (doShowMoreDrillDown) $f145fa6d412a8ce0$var$notify(onDrillDown, [
                date,
                getDrilldownView(date) || $f145fa6d412a8ce0$export$5cb791131c501f6a.DAY
            ]);
            $f145fa6d412a8ce0$var$notify(onShowMore, [
                events,
                date,
                slot
            ]);
        };
        _this.handleSelectAllDaySlot = function(slots, slotInfo) {
            var onSelectSlot = _this.props.onSelectSlot;
            var start = new Date(slots[0]);
            var end = new Date(slots[slots.length - 1]);
            end.setDate(slots[slots.length - 1].getDate() + 1);
            $f145fa6d412a8ce0$var$notify(onSelectSlot, {
                slots: slots,
                start: start,
                end: end,
                action: slotInfo.action,
                resourceId: slotInfo.resourceId
            });
        };
        _this.overlayDisplay = function() {
            _this.setState({
                overlay: null
            });
        };
        _this.checkOverflow = function() {
            if (_this._updatingOverflow) return;
            var content = _this.contentRef.current;
            if (!(content !== null && content !== void 0 && content.scrollHeight)) return;
            var isOverflowing = content.scrollHeight > content.clientHeight;
            if (_this.state.isOverflowing !== isOverflowing) {
                _this._updatingOverflow = true;
                _this.setState({
                    isOverflowing: isOverflowing
                }, function() {
                    _this._updatingOverflow = false;
                });
            }
        };
        _this.memoizedResources = (0, $9cd2825578c66be2$export$2e2bcd8739ae039)(function(resources, accessors) {
            return $f145fa6d412a8ce0$var$Resources(resources, accessors);
        });
        _this.state = {
            gutterWidth: undefined,
            isOverflowing: null
        };
        _this.scrollRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createRef();
        _this.contentRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createRef();
        _this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createRef();
        _this._scrollRatio = null;
        _this.gutterRef = /*#__PURE__*/ (0, $gRqVZ.createRef)();
        return _this;
    }
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(TimeGrid, _Component);
    return (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(TimeGrid, [
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate() {
                this.checkOverflow();
                return null;
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.width == null) this.measureGutter();
                this.calculateScroll();
                this.applyScroll();
                window.addEventListener('resize', this.handleResize);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener('resize', this.handleResize);
                $3f65a5846d5d2f64$export$70b61ad426ddbe54(this.rafHandle);
                if (this.measureGutterAnimationFrameRequest) window.cancelAnimationFrame(this.measureGutterAnimationFrameRequest);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.applyScroll();
            }
        },
        {
            key: "renderDayColumn",
            value: function renderDayColumn(date, id, resource, groupedEvents, groupedBackgroundEvents, localizer, accessors, components, dayLayoutAlgorithm, now) {
                var _this$props2 = this.props, min = _this$props2.min, max = _this$props2.max;
                var daysEvents = (groupedEvents.get(id) || []).filter(function(event) {
                    return localizer.inRange(date, accessors.start(event), accessors.end(event), 'day');
                });
                var daysBackgroundEvents = (groupedBackgroundEvents.get(id) || []).filter(function(event) {
                    return localizer.inRange(date, accessors.start(event), accessors.end(event), 'day');
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$DayColumn, Object.assign({}, this.props, {
                    localizer: localizer,
                    min: localizer.merge(date, min),
                    max: localizer.merge(date, max),
                    resource: resource && id,
                    components: components,
                    isNow: localizer.isSameDate(date, now),
                    key: "".concat(id, "-").concat(date),
                    date: date,
                    events: daysEvents,
                    backgroundEvents: daysBackgroundEvents,
                    dayLayoutAlgorithm: dayLayoutAlgorithm
                }));
            }
        },
        {
            key: "renderResourcesFirst",
            value: function renderResourcesFirst(range, resources, groupedEvents, groupedBackgroundEvents, localizer, accessors, now, components, dayLayoutAlgorithm) {
                var _this2 = this;
                return resources.map(function(_ref) {
                    var _ref2 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_ref, 2), id = _ref2[0], resource = _ref2[1];
                    return range.map(function(date) {
                        return _this2.renderDayColumn(date, id, resource, groupedEvents, groupedBackgroundEvents, localizer, accessors, components, dayLayoutAlgorithm, now);
                    });
                });
            }
        },
        {
            key: "renderRangeFirst",
            value: function renderRangeFirst(range, resources, groupedEvents, groupedBackgroundEvents, localizer, accessors, now, components, dayLayoutAlgorithm) {
                var _this3 = this;
                return range.map(function(date) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                        style: {
                            display: 'flex',
                            minHeight: '100%',
                            flex: 1
                        },
                        key: date
                    }, resources.map(function(_ref3) {
                        var _ref4 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_ref3, 2), id = _ref4[0], resource = _ref4[1];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                            style: {
                                flex: 1
                            },
                            key: accessors.resourceId(resource)
                        }, _this3.renderDayColumn(date, id, resource, groupedEvents, groupedBackgroundEvents, localizer, accessors, components, dayLayoutAlgorithm, now));
                    }));
                });
            }
        },
        {
            key: "renderEvents",
            value: function renderEvents(range, events, backgroundEvents, now) {
                var _this$props3 = this.props, accessors = _this$props3.accessors, localizer = _this$props3.localizer, resourceGroupingLayout = _this$props3.resourceGroupingLayout, components = _this$props3.components, dayLayoutAlgorithm = _this$props3.dayLayoutAlgorithm;
                var resources = this.memoizedResources(this.props.resources, accessors);
                var groupedEvents = resources.groupEvents(events);
                var groupedBackgroundEvents = resources.groupEvents(backgroundEvents);
                if (!resourceGroupingLayout) return this.renderResourcesFirst(range, resources, groupedEvents, groupedBackgroundEvents, localizer, accessors, now, components, dayLayoutAlgorithm);
                else return this.renderRangeFirst(range, resources, groupedEvents, groupedBackgroundEvents, localizer, accessors, now, components, dayLayoutAlgorithm);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props$allDayMax;
                var _this$props4 = this.props, events = _this$props4.events, backgroundEvents = _this$props4.backgroundEvents, range = _this$props4.range, width = _this$props4.width, rtl = _this$props4.rtl, selected = _this$props4.selected, getNow = _this$props4.getNow, resources = _this$props4.resources, components = _this$props4.components, accessors = _this$props4.accessors, getters = _this$props4.getters, localizer = _this$props4.localizer, min = _this$props4.min, max = _this$props4.max, showMultiDayTimes = _this$props4.showMultiDayTimes, longPressThreshold = _this$props4.longPressThreshold, resizable = _this$props4.resizable, resourceGroupingLayout = _this$props4.resourceGroupingLayout;
                width = width || this.state.gutterWidth;
                var start = range[0], end = range[range.length - 1];
                this.slots = range.length;
                var allDayEvents = [], rangeEvents = [], rangeBackgroundEvents = [];
                events.forEach(function(event) {
                    if ($f145fa6d412a8ce0$var$inRange(event, start, end, accessors, localizer)) {
                        var eStart = accessors.start(event), eEnd = accessors.end(event);
                        if (accessors.allDay(event) || localizer.startAndEndAreDateOnly(eStart, eEnd) || !showMultiDayTimes && !localizer.isSameDate(eStart, eEnd)) allDayEvents.push(event);
                        else rangeEvents.push(event);
                    }
                });
                backgroundEvents.forEach(function(event) {
                    if ($f145fa6d412a8ce0$var$inRange(event, start, end, accessors, localizer)) rangeBackgroundEvents.push(event);
                });
                allDayEvents.sort(function(a, b) {
                    return $f145fa6d412a8ce0$var$sortEvents(a, b, accessors, localizer);
                });
                var headerProps = {
                    range: range,
                    events: allDayEvents,
                    width: width,
                    rtl: rtl,
                    getNow: getNow,
                    localizer: localizer,
                    selected: selected,
                    allDayMaxRows: this.props.showAllEvents ? Infinity : (_this$props$allDayMax = this.props.allDayMaxRows) !== null && _this$props$allDayMax !== void 0 ? _this$props$allDayMax : Infinity,
                    resources: this.memoizedResources(resources, accessors),
                    selectable: this.props.selectable,
                    accessors: accessors,
                    getters: getters,
                    components: components,
                    scrollRef: this.scrollRef,
                    isOverflowing: this.state.isOverflowing,
                    longPressThreshold: longPressThreshold,
                    onSelectSlot: this.handleSelectAllDaySlot,
                    onSelectEvent: this.handleSelectEvent,
                    onShowMore: this.handleShowMore,
                    onDoubleClickEvent: this.props.onDoubleClickEvent,
                    onKeyPressEvent: this.props.onKeyPressEvent,
                    onDrillDown: this.props.onDrillDown,
                    getDrilldownView: this.props.getDrilldownView,
                    resizable: resizable
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                    className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)('rbc-time-view', resources && 'rbc-time-view-resources'),
                    ref: this.containerRef
                }, resources && resources.length > 1 && resourceGroupingLayout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$TimeGridHeaderResources, headerProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$TimeGridHeader, headerProps), this.props.popup && this.renderOverlay(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
                    ref: this.contentRef,
                    className: "rbc-time-content",
                    onScroll: this.handleScroll
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$TimeGutter$1, {
                    date: start,
                    ref: this.gutterRef,
                    localizer: localizer,
                    min: localizer.merge(start, min),
                    max: localizer.merge(start, max),
                    step: this.props.step,
                    getNow: this.props.getNow,
                    timeslots: this.props.timeslots,
                    components: components,
                    className: "rbc-time-gutter",
                    getters: getters
                }), this.renderEvents(range, rangeEvents, rangeBackgroundEvents, getNow())));
            }
        },
        {
            key: "renderOverlay",
            value: function renderOverlay() {
                var _this$state$overlay, _this$state, _this4 = this;
                var overlay = (_this$state$overlay = (_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.overlay) !== null && _this$state$overlay !== void 0 ? _this$state$overlay : {};
                var _this$props5 = this.props, accessors = _this$props5.accessors, localizer = _this$props5.localizer, components = _this$props5.components, getters = _this$props5.getters, selected = _this$props5.selected, popupOffset = _this$props5.popupOffset, handleDragStart = _this$props5.handleDragStart;
                var onHide = function onHide() {
                    return _this4.setState({
                        overlay: null
                    });
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$PopOverlay, {
                    overlay: overlay,
                    accessors: accessors,
                    localizer: localizer,
                    components: components,
                    getters: getters,
                    selected: selected,
                    popupOffset: popupOffset,
                    ref: this.containerRef,
                    handleKeyPressEvent: this.handleKeyPressEvent,
                    handleSelectEvent: this.handleSelectEvent,
                    handleDoubleClickEvent: this.handleDoubleClickEvent,
                    handleDragStart: handleDragStart,
                    show: !!overlay.position,
                    overlayDisplay: this.overlayDisplay,
                    onHide: onHide
                });
            }
        },
        {
            key: "clearSelection",
            value: function clearSelection() {
                clearTimeout(this._selectTimer);
                this._pendingSelection = [];
            }
        },
        {
            key: "measureGutter",
            value: function measureGutter() {
                var _this5 = this;
                if (this.measureGutterAnimationFrameRequest) window.cancelAnimationFrame(this.measureGutterAnimationFrameRequest);
                this.measureGutterAnimationFrameRequest = window.requestAnimationFrame(function() {
                    var _this5$gutterRef;
                    var width = (_this5$gutterRef = _this5.gutterRef) !== null && _this5$gutterRef !== void 0 && _this5$gutterRef.current ? (0, $18a30c8ab2ccc592$export$2e2bcd8739ae039)(_this5.gutterRef.current) : undefined;
                    if (width && _this5.state.gutterWidth !== width) _this5.setState({
                        gutterWidth: width
                    });
                });
            }
        },
        {
            key: "applyScroll",
            value: function applyScroll() {
                // If auto-scroll is disabled, we don't actually apply the scroll
                if (this._scrollRatio != null && this.props.enableAutoScroll === true) {
                    var content = this.contentRef.current;
                    content.scrollTop = content.scrollHeight * this._scrollRatio;
                    // Only do this once
                    this._scrollRatio = null;
                }
            }
        },
        {
            key: "calculateScroll",
            value: function calculateScroll() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var min = props.min, max = props.max, scrollToTime = props.scrollToTime, localizer = props.localizer;
                var diffMillis = localizer.diff(localizer.merge(scrollToTime, min), scrollToTime, 'milliseconds');
                var totalMillis = localizer.diff(min, max, 'milliseconds');
                this._scrollRatio = diffMillis / totalMillis;
            }
        }
    ]);
}((0, $gRqVZ.Component));
$f145fa6d412a8ce0$var$TimeGrid.defaultProps = {
    step: 30,
    timeslots: 2,
    // To be compatible with old versions, default as `false`.
    resourceGroupingLayout: false
};
var $f145fa6d412a8ce0$var$_excluded$4 = [
    "date",
    "localizer",
    "min",
    "max",
    "scrollToTime",
    "enableAutoScroll"
];
var $f145fa6d412a8ce0$var$Day = /*#__PURE__*/ function(_React$Component) {
    function Day() {
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, Day);
        return (0, $db22c8b683e5147b$export$2e2bcd8739ae039)(this, Day, arguments);
    }
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(Day, _React$Component);
    return (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(Day, [
        {
            key: "render",
            value: function render() {
                /**
       * This allows us to default min, max, and scrollToTime
       * using our localizer. This is necessary until such time
       * as TODO: TimeGrid is converted to a functional component.
       */ var _this$props = this.props, date = _this$props.date, localizer = _this$props.localizer, _this$props$min = _this$props.min, min = _this$props$min === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$min, _this$props$max = _this$props.max, max = _this$props$max === void 0 ? localizer.endOf(new Date(), 'day') : _this$props$max, _this$props$scrollToT = _this$props.scrollToTime, scrollToTime = _this$props$scrollToT === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$scrollToT, _this$props$enableAut = _this$props.enableAutoScroll, enableAutoScroll = _this$props$enableAut === void 0 ? true : _this$props$enableAut, props = (0, $f308b666a2f706a5$export$2e2bcd8739ae039)(_this$props, $f145fa6d412a8ce0$var$_excluded$4);
                var range = Day.range(date, {
                    localizer: localizer
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$TimeGrid, Object.assign({}, props, {
                    range: range,
                    eventOffset: 10,
                    localizer: localizer,
                    min: min,
                    max: max,
                    scrollToTime: scrollToTime,
                    enableAutoScroll: enableAutoScroll
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Component);
$f145fa6d412a8ce0$var$Day.range = function(date, _ref) {
    var localizer = _ref.localizer;
    return [
        localizer.startOf(date, 'day')
    ];
};
$f145fa6d412a8ce0$var$Day.navigate = function(date, action, _ref2) {
    var localizer = _ref2.localizer;
    switch(action){
        case $f145fa6d412a8ce0$export$444b3ab0cb9aec40.PREVIOUS:
            return localizer.add(date, -1, 'day');
        case $f145fa6d412a8ce0$export$444b3ab0cb9aec40.NEXT:
            return localizer.add(date, 1, 'day');
        default:
            return date;
    }
};
$f145fa6d412a8ce0$var$Day.title = function(date, _ref3) {
    var localizer = _ref3.localizer;
    return localizer.format(date, 'dayHeaderFormat');
};
var $f145fa6d412a8ce0$var$_excluded$3 = [
    "date",
    "localizer",
    "min",
    "max",
    "scrollToTime",
    "enableAutoScroll"
];
var $f145fa6d412a8ce0$var$Week = /*#__PURE__*/ function(_React$Component) {
    function Week() {
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, Week);
        return (0, $db22c8b683e5147b$export$2e2bcd8739ae039)(this, Week, arguments);
    }
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(Week, _React$Component);
    return (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(Week, [
        {
            key: "render",
            value: function render() {
                /**
       * This allows us to default min, max, and scrollToTime
       * using our localizer. This is necessary until such time
       * as TimeGrid is converted to a functional component.
       */ var _this$props = this.props, date = _this$props.date, localizer = _this$props.localizer, _this$props$min = _this$props.min, min = _this$props$min === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$min, _this$props$max = _this$props.max, max = _this$props$max === void 0 ? localizer.endOf(new Date(), 'day') : _this$props$max, _this$props$scrollToT = _this$props.scrollToTime, scrollToTime = _this$props$scrollToT === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$scrollToT, _this$props$enableAut = _this$props.enableAutoScroll, enableAutoScroll = _this$props$enableAut === void 0 ? true : _this$props$enableAut, props = (0, $f308b666a2f706a5$export$2e2bcd8739ae039)(_this$props, $f145fa6d412a8ce0$var$_excluded$3);
                var range = Week.range(date, this.props);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$TimeGrid, Object.assign({}, props, {
                    range: range,
                    eventOffset: 15,
                    localizer: localizer,
                    min: min,
                    max: max,
                    scrollToTime: scrollToTime,
                    enableAutoScroll: enableAutoScroll
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Component);
$f145fa6d412a8ce0$var$Week.defaultProps = $f145fa6d412a8ce0$var$TimeGrid.defaultProps;
$f145fa6d412a8ce0$var$Week.navigate = function(date, action, _ref) {
    var localizer = _ref.localizer;
    switch(action){
        case $f145fa6d412a8ce0$export$444b3ab0cb9aec40.PREVIOUS:
            return localizer.add(date, -1, 'week');
        case $f145fa6d412a8ce0$export$444b3ab0cb9aec40.NEXT:
            return localizer.add(date, 1, 'week');
        default:
            return date;
    }
};
$f145fa6d412a8ce0$var$Week.range = function(date, _ref2) {
    var localizer = _ref2.localizer;
    var firstOfWeek = localizer.startOfWeek();
    var start = localizer.startOf(date, 'week', firstOfWeek);
    var end = localizer.endOf(date, 'week', firstOfWeek);
    return localizer.range(start, end);
};
$f145fa6d412a8ce0$var$Week.title = function(date, _ref3) {
    var localizer = _ref3.localizer;
    var _Week$range = $f145fa6d412a8ce0$var$Week.range(date, {
        localizer: localizer
    }), _Week$range2 = (0, $bf3e6cea5f80d91f$export$2e2bcd8739ae039)(_Week$range), start = _Week$range2[0], rest = _Week$range2.slice(1);
    return localizer.format({
        start: start,
        end: rest.pop()
    }, 'dayRangeHeaderFormat');
};
var $f145fa6d412a8ce0$var$_excluded$2 = [
    "date",
    "localizer",
    "min",
    "max",
    "scrollToTime",
    "enableAutoScroll"
];
function $f145fa6d412a8ce0$var$workWeekRange(date, options) {
    return $f145fa6d412a8ce0$var$Week.range(date, options).filter(function(d) {
        return [
            6,
            0
        ].indexOf(d.getDay()) === -1;
    });
}
var $f145fa6d412a8ce0$var$WorkWeek = /*#__PURE__*/ function(_React$Component) {
    function WorkWeek() {
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, WorkWeek);
        return (0, $db22c8b683e5147b$export$2e2bcd8739ae039)(this, WorkWeek, arguments);
    }
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(WorkWeek, _React$Component);
    return (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(WorkWeek, [
        {
            key: "render",
            value: function render() {
                /**
       * This allows us to default min, max, and scrollToTime
       * using our localizer. This is necessary until such time
       * as TimeGrid is converted to a functional component.
       */ var _this$props = this.props, date = _this$props.date, localizer = _this$props.localizer, _this$props$min = _this$props.min, min = _this$props$min === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$min, _this$props$max = _this$props.max, max = _this$props$max === void 0 ? localizer.endOf(new Date(), 'day') : _this$props$max, _this$props$scrollToT = _this$props.scrollToTime, scrollToTime = _this$props$scrollToT === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$scrollToT, _this$props$enableAut = _this$props.enableAutoScroll, enableAutoScroll = _this$props$enableAut === void 0 ? true : _this$props$enableAut, props = (0, $f308b666a2f706a5$export$2e2bcd8739ae039)(_this$props, $f145fa6d412a8ce0$var$_excluded$2);
                var range = $f145fa6d412a8ce0$var$workWeekRange(date, this.props);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($f145fa6d412a8ce0$var$TimeGrid, Object.assign({}, props, {
                    range: range,
                    eventOffset: 15,
                    localizer: localizer,
                    min: min,
                    max: max,
                    scrollToTime: scrollToTime,
                    enableAutoScroll: enableAutoScroll
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Component);
$f145fa6d412a8ce0$var$WorkWeek.defaultProps = $f145fa6d412a8ce0$var$TimeGrid.defaultProps;
$f145fa6d412a8ce0$var$WorkWeek.range = $f145fa6d412a8ce0$var$workWeekRange;
$f145fa6d412a8ce0$var$WorkWeek.navigate = $f145fa6d412a8ce0$var$Week.navigate;
$f145fa6d412a8ce0$var$WorkWeek.title = function(date, _ref) {
    var localizer = _ref.localizer;
    var _workWeekRange = $f145fa6d412a8ce0$var$workWeekRange(date, {
        localizer: localizer
    }), _workWeekRange2 = (0, $bf3e6cea5f80d91f$export$2e2bcd8739ae039)(_workWeekRange), start = _workWeekRange2[0], rest = _workWeekRange2.slice(1);
    return localizer.format({
        start: start,
        end: rest.pop()
    }, 'dayRangeHeaderFormat');
};
var $f145fa6d412a8ce0$var$DEFAULT_LENGTH = 30;
function $f145fa6d412a8ce0$var$Agenda(_ref) {
    var accessors = _ref.accessors, components = _ref.components, date = _ref.date, events = _ref.events, getters = _ref.getters, _ref$length = _ref.length, length = _ref$length === void 0 ? $f145fa6d412a8ce0$var$DEFAULT_LENGTH : _ref$length, localizer = _ref.localizer, onDoubleClickEvent = _ref.onDoubleClickEvent, onSelectEvent = _ref.onSelectEvent, selected = _ref.selected;
    var headerRef = (0, $gRqVZ.useRef)(null);
    var dateColRef = (0, $gRqVZ.useRef)(null);
    var timeColRef = (0, $gRqVZ.useRef)(null);
    var contentRef = (0, $gRqVZ.useRef)(null);
    var tbodyRef = (0, $gRqVZ.useRef)(null);
    (0, $gRqVZ.useEffect)(function() {
        _adjustHeader();
    });
    var renderDay = function renderDay(day, events, dayKey) {
        var Event = components.event, AgendaDate = components.date;
        events = events.filter(function(e) {
            return $f145fa6d412a8ce0$var$inRange(e, localizer.startOf(day, 'day'), localizer.endOf(day, 'day'), accessors, localizer);
        });
        return events.map(function(event, idx) {
            var title = accessors.title(event);
            var end = accessors.end(event);
            var start = accessors.start(event);
            var userProps = getters.eventProp(event, start, end, $f145fa6d412a8ce0$var$isSelected(event, selected));
            var dateLabel = idx === 0 && localizer.format(day, 'agendaDateFormat');
            var first = idx === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("td", {
                rowSpan: events.length,
                className: "rbc-agenda-date-cell"
            }, AgendaDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(AgendaDate, {
                day: day,
                label: dateLabel
            }) : dateLabel) : false;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("tr", {
                key: dayKey + '_' + idx,
                className: userProps.className,
                style: userProps.style
            }, first, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("td", {
                className: "rbc-agenda-time-cell"
            }, timeRangeLabel(day, event)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("td", {
                className: "rbc-agenda-event-cell",
                onClick: function onClick(e) {
                    return onSelectEvent && onSelectEvent(event, e);
                },
                onDoubleClick: function onDoubleClick(e) {
                    return onDoubleClickEvent && onDoubleClickEvent(event, e);
                }
            }, Event ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(Event, {
                event: event,
                title: title
            }) : title));
        }, []);
    };
    var timeRangeLabel = function timeRangeLabel(day, event) {
        var labelClass = '', TimeComponent = components.time, label = localizer.messages.allDay;
        var end = accessors.end(event);
        var start = accessors.start(event);
        if (!accessors.allDay(event)) {
            if (localizer.eq(start, end)) label = localizer.format(start, 'agendaTimeFormat');
            else if (localizer.isSameDate(start, end)) label = localizer.format({
                start: start,
                end: end
            }, 'agendaTimeRangeFormat');
            else if (localizer.isSameDate(day, start)) label = localizer.format(start, 'agendaTimeFormat');
            else if (localizer.isSameDate(day, end)) label = localizer.format(end, 'agendaTimeFormat');
        }
        if (localizer.gt(day, start, 'day')) labelClass = 'rbc-continues-prior';
        if (localizer.lt(day, end, 'day')) labelClass += ' rbc-continues-after';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("span", {
            className: labelClass.trim()
        }, TimeComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(TimeComponent, {
            event: event,
            day: day,
            label: label
        }) : label);
    };
    var _adjustHeader = function _adjustHeader() {
        if (!tbodyRef.current) return;
        var header = headerRef.current;
        var firstRow = tbodyRef.current.firstChild;
        if (!firstRow) return;
        var isOverflowing = contentRef.current.scrollHeight > contentRef.current.clientHeight;
        var _widths = [];
        var widths = _widths;
        _widths = [
            (0, $18a30c8ab2ccc592$export$2e2bcd8739ae039)(firstRow.children[0]),
            (0, $18a30c8ab2ccc592$export$2e2bcd8739ae039)(firstRow.children[1])
        ];
        if (widths[0] !== _widths[0] || widths[1] !== _widths[1]) {
            dateColRef.current.style.width = _widths[0] + 'px';
            timeColRef.current.style.width = _widths[1] + 'px';
        }
        if (isOverflowing) {
            (0, $3d8dfb1f4ad73ac5$export$2e2bcd8739ae039)(header, 'rbc-header-overflowing');
            header.style.marginRight = (0, $1ceeb7c22fe75025$export$2e2bcd8739ae039)() + 'px';
        } else (0, $d4f0b488dfc15082$export$2e2bcd8739ae039)(header, 'rbc-header-overflowing');
    };
    var messages = localizer.messages;
    var end = localizer.add(date, length, 'day');
    var range = localizer.range(date, end, 'day');
    events = events.filter(function(event) {
        return $f145fa6d412a8ce0$var$inRange(event, localizer.startOf(date, 'day'), localizer.endOf(end, 'day'), accessors, localizer);
    });
    events.sort(function(a, b) {
        return +accessors.start(a) - +accessors.start(b);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
        className: "rbc-agenda-view"
    }, events.length !== 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("table", {
        ref: headerRef,
        className: "rbc-agenda-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("th", {
        className: "rbc-header",
        ref: dateColRef
    }, messages.date), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("th", {
        className: "rbc-header",
        ref: timeColRef
    }, messages.time), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("th", {
        className: "rbc-header"
    }, messages.event)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
        className: "rbc-agenda-content",
        ref: contentRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("table", {
        className: "rbc-agenda-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("tbody", {
        ref: tbodyRef
    }, range.map(function(day, idx) {
        return renderDay(day, events, idx);
    }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("span", {
        className: "rbc-agenda-empty"
    }, messages.noEventsInRange));
}
$f145fa6d412a8ce0$var$Agenda.range = function(start, _ref2) {
    var _ref2$length = _ref2.length, length = _ref2$length === void 0 ? $f145fa6d412a8ce0$var$DEFAULT_LENGTH : _ref2$length, localizer = _ref2.localizer;
    var end = localizer.add(start, length, 'day');
    return {
        start: start,
        end: end
    };
};
$f145fa6d412a8ce0$var$Agenda.navigate = function(date, action, _ref3) {
    var _ref3$length = _ref3.length, length = _ref3$length === void 0 ? $f145fa6d412a8ce0$var$DEFAULT_LENGTH : _ref3$length, localizer = _ref3.localizer;
    switch(action){
        case $f145fa6d412a8ce0$export$444b3ab0cb9aec40.PREVIOUS:
            return localizer.add(date, -length, 'day');
        case $f145fa6d412a8ce0$export$444b3ab0cb9aec40.NEXT:
            return localizer.add(date, length, 'day');
        default:
            return date;
    }
};
$f145fa6d412a8ce0$var$Agenda.title = function(start, _ref4) {
    var _ref4$length = _ref4.length, length = _ref4$length === void 0 ? $f145fa6d412a8ce0$var$DEFAULT_LENGTH : _ref4$length, localizer = _ref4.localizer;
    var end = localizer.add(start, length, 'day');
    return localizer.format({
        start: start,
        end: end
    }, 'agendaHeaderFormat');
};
var $f145fa6d412a8ce0$var$VIEWS = (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $6a740e003744eccd$export$2e2bcd8739ae039)({}, $f145fa6d412a8ce0$export$5cb791131c501f6a.MONTH, $f145fa6d412a8ce0$var$MonthView), $f145fa6d412a8ce0$export$5cb791131c501f6a.WEEK, $f145fa6d412a8ce0$var$Week), $f145fa6d412a8ce0$export$5cb791131c501f6a.WORK_WEEK, $f145fa6d412a8ce0$var$WorkWeek), $f145fa6d412a8ce0$export$5cb791131c501f6a.DAY, $f145fa6d412a8ce0$var$Day), $f145fa6d412a8ce0$export$5cb791131c501f6a.AGENDA, $f145fa6d412a8ce0$var$Agenda);
var $f145fa6d412a8ce0$var$_excluded$1 = [
    "action",
    "date",
    "today"
];
function $f145fa6d412a8ce0$export$d947e5f4f4c48d48(View, _ref) {
    var action = _ref.action, date = _ref.date, today = _ref.today, props = (0, $f308b666a2f706a5$export$2e2bcd8739ae039)(_ref, $f145fa6d412a8ce0$var$_excluded$1);
    View = typeof View === 'string' ? $f145fa6d412a8ce0$var$VIEWS[View] : View;
    switch(action){
        case $f145fa6d412a8ce0$export$444b3ab0cb9aec40.TODAY:
            date = today || new Date();
            break;
        case $f145fa6d412a8ce0$export$444b3ab0cb9aec40.DATE:
            break;
        default:
            (0, (/*@__PURE__*/$parcel$interopDefault($466b99331d7e73e3$exports)))(View && typeof View.navigate === 'function', 'Calendar View components must implement a static `.navigate(date, action)` method.s');
            date = View.navigate(date, action, props);
    }
    return date;
}
/**
 * Retrieve via an accessor-like property
 *
 *    accessor(obj, 'name')   // => retrieves obj['name']
 *    accessor(data, func)    // => retrieves func(data)
 *    ... otherwise null
 */ function $f145fa6d412a8ce0$var$accessor(data, field) {
    var value = null;
    if (typeof field === 'function') value = field(data);
    else if (typeof field === 'string' && (0, $c3a904dfa5a64ea0$export$2e2bcd8739ae039)(data) === 'object' && data != null && field in data) value = data[field];
    return value;
}
var $f145fa6d412a8ce0$var$wrapAccessor = function wrapAccessor(acc) {
    return function(data) {
        return $f145fa6d412a8ce0$var$accessor(data, acc);
    };
};
var $f145fa6d412a8ce0$var$_excluded = [
    "view",
    "date",
    "getNow",
    "onNavigate"
], $f145fa6d412a8ce0$var$_excluded2 = [
    "view",
    "toolbar",
    "events",
    "backgroundEvents",
    "resourceGroupingLayout",
    "style",
    "className",
    "elementProps",
    "date",
    "getNow",
    "length",
    "showMultiDayTimes",
    "onShowMore",
    "doShowMoreDrillDown",
    "components",
    "formats",
    "messages",
    "culture"
];
function $f145fa6d412a8ce0$var$viewNames(_views) {
    if (Array.isArray(_views)) return _views;
    var views = [];
    for(var _i = 0, _Object$entries = Object.entries(_views); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, $ebff776814199019$export$2e2bcd8739ae039)(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (value) views.push(key);
    }
    return views;
}
function $f145fa6d412a8ce0$var$isValidView(view, _ref) {
    var _views = _ref.views;
    var names = $f145fa6d412a8ce0$var$viewNames(_views);
    return names.indexOf(view) !== -1;
}
var $f145fa6d412a8ce0$var$Calendar = /*#__PURE__*/ function(_React$Component) {
    function Calendar() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, Calendar);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = (0, $db22c8b683e5147b$export$2e2bcd8739ae039)(this, Calendar, [].concat(_args));
        _this.getViews = function() {
            var views = _this.props.views;
            if (Array.isArray(views)) return (0, (/*@__PURE__*/$parcel$interopDefault($ace71a80aaafdfb0$exports)))(views, function(obj, name) {
                return obj[name] = $f145fa6d412a8ce0$var$VIEWS[name];
            }, {});
            if ((0, $c3a904dfa5a64ea0$export$2e2bcd8739ae039)(views) === 'object') return (0, (/*@__PURE__*/$parcel$interopDefault($bc64489b77d0a43c$exports)))(views, function(value, key) {
                if (value === true) return $f145fa6d412a8ce0$var$VIEWS[key];
                return value;
            });
            return $f145fa6d412a8ce0$var$VIEWS;
        };
        _this.getView = function() {
            var views = _this.getViews();
            return views[_this.props.view];
        };
        _this.getDrilldownView = function(date) {
            var _this$props = _this.props, view = _this$props.view, drilldownView = _this$props.drilldownView, getDrilldownView = _this$props.getDrilldownView;
            if (!getDrilldownView) return drilldownView;
            return getDrilldownView(date, view, Object.keys(_this.getViews()));
        };
        /**
     *
     * @param date
     * @param viewComponent
     * @param {'month'|'week'|'work_week'|'day'|'agenda'} [view] - optional
     * parameter. It appears when range change on view changing. It could be handy
     * when you need to have both: range and view type at once, i.e. for manage rbc
     * state via url
     */ _this.handleRangeChange = function(date, viewComponent, view) {
            var _this$props2 = _this.props, onRangeChange = _this$props2.onRangeChange, localizer = _this$props2.localizer;
            if (onRangeChange) {
                if (viewComponent.range) onRangeChange(viewComponent.range(date, {
                    localizer: localizer
                }), view);
            }
        };
        _this.handleNavigate = function(action, newDate) {
            var _this$props3 = _this.props, view = _this$props3.view, date = _this$props3.date, getNow = _this$props3.getNow, onNavigate = _this$props3.onNavigate, props = (0, $f308b666a2f706a5$export$2e2bcd8739ae039)(_this$props3, $f145fa6d412a8ce0$var$_excluded);
            var ViewComponent = _this.getView();
            var today = getNow();
            date = $f145fa6d412a8ce0$export$d947e5f4f4c48d48(ViewComponent, (0, $70cca8c76ff58c71$export$2e2bcd8739ae039)((0, $70cca8c76ff58c71$export$2e2bcd8739ae039)({}, props), {}, {
                action: action,
                date: newDate || date || today,
                today: today
            }));
            onNavigate(date, view, action);
            _this.handleRangeChange(date, ViewComponent);
        };
        _this.handleViewChange = function(view) {
            if (view !== _this.props.view && $f145fa6d412a8ce0$var$isValidView(view, _this.props)) _this.props.onView(view);
            var views = _this.getViews();
            _this.handleRangeChange(_this.props.date || _this.props.getNow(), views[view], view);
        };
        _this.handleSelectEvent = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            $f145fa6d412a8ce0$var$notify(_this.props.onSelectEvent, args);
        };
        _this.handleDoubleClickEvent = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            $f145fa6d412a8ce0$var$notify(_this.props.onDoubleClickEvent, args);
        };
        _this.handleKeyPressEvent = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            $f145fa6d412a8ce0$var$notify(_this.props.onKeyPressEvent, args);
        };
        _this.handleSelectSlot = function(slotInfo) {
            $f145fa6d412a8ce0$var$notify(_this.props.onSelectSlot, slotInfo);
        };
        _this.handleDrillDown = function(date, view) {
            var onDrillDown = _this.props.onDrillDown;
            if (onDrillDown) {
                onDrillDown(date, view, _this.drilldownView);
                return;
            }
            if (view) _this.handleViewChange(view);
            _this.handleNavigate($f145fa6d412a8ce0$export$444b3ab0cb9aec40.DATE, date);
        };
        _this.state = {
            context: Calendar.getContext(_this.props)
        };
        return _this;
    }
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(Calendar, _React$Component);
    return (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(Calendar, [
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, view = _this$props4.view, toolbar = _this$props4.toolbar, events = _this$props4.events, backgroundEvents = _this$props4.backgroundEvents, resourceGroupingLayout = _this$props4.resourceGroupingLayout, style = _this$props4.style, className = _this$props4.className, elementProps = _this$props4.elementProps, current = _this$props4.date, getNow = _this$props4.getNow, length = _this$props4.length, showMultiDayTimes = _this$props4.showMultiDayTimes, onShowMore = _this$props4.onShowMore, doShowMoreDrillDown = _this$props4.doShowMoreDrillDown;
                _this$props4.components;
                _this$props4.formats;
                _this$props4.messages;
                _this$props4.culture;
                var props = (0, $f308b666a2f706a5$export$2e2bcd8739ae039)(_this$props4, $f145fa6d412a8ce0$var$_excluded2);
                current = current || getNow();
                var View = this.getView();
                var _this$state$context = this.state.context, accessors = _this$state$context.accessors, components = _this$state$context.components, getters = _this$state$context.getters, localizer = _this$state$context.localizer, viewNames = _this$state$context.viewNames;
                var CalToolbar = components.toolbar || $f145fa6d412a8ce0$var$Toolbar;
                var label = View.title(current, {
                    localizer: localizer,
                    length: length
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", Object.assign({}, elementProps, {
                    className: (0, $db2152db93f40e4f$export$2e2bcd8739ae039)(className, 'rbc-calendar', props.rtl && 'rbc-rtl'),
                    style: style
                }), toolbar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(CalToolbar, {
                    date: current,
                    view: view,
                    views: viewNames,
                    label: label,
                    onView: this.handleViewChange,
                    onNavigate: this.handleNavigate,
                    localizer: localizer
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(View, Object.assign({}, props, {
                    events: events,
                    backgroundEvents: backgroundEvents,
                    date: current,
                    getNow: getNow,
                    length: length,
                    localizer: localizer,
                    getters: getters,
                    components: components,
                    accessors: accessors,
                    showMultiDayTimes: showMultiDayTimes,
                    getDrilldownView: this.getDrilldownView,
                    onNavigate: this.handleNavigate,
                    onDrillDown: this.handleDrillDown,
                    onSelectEvent: this.handleSelectEvent,
                    onDoubleClickEvent: this.handleDoubleClickEvent,
                    onKeyPressEvent: this.handleKeyPressEvent,
                    onSelectSlot: this.handleSelectSlot,
                    onShowMore: onShowMore,
                    doShowMoreDrillDown: doShowMoreDrillDown,
                    resourceGroupingLayout: resourceGroupingLayout
                })));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps) {
                return {
                    context: Calendar.getContext(nextProps)
                };
            }
        },
        {
            key: "getContext",
            value: function getContext(_ref2) {
                var startAccessor = _ref2.startAccessor, endAccessor = _ref2.endAccessor, allDayAccessor = _ref2.allDayAccessor, tooltipAccessor = _ref2.tooltipAccessor, titleAccessor = _ref2.titleAccessor, resourceAccessor = _ref2.resourceAccessor, resourceIdAccessor = _ref2.resourceIdAccessor, resourceTitleAccessor = _ref2.resourceTitleAccessor, eventIdAccessor = _ref2.eventIdAccessor, eventPropGetter = _ref2.eventPropGetter, backgroundEventPropGetter = _ref2.backgroundEventPropGetter, slotPropGetter = _ref2.slotPropGetter, slotGroupPropGetter = _ref2.slotGroupPropGetter, dayPropGetter = _ref2.dayPropGetter, view = _ref2.view, views = _ref2.views, localizer = _ref2.localizer, culture = _ref2.culture, _ref2$messages = _ref2.messages, messages$1 = _ref2$messages === void 0 ? {} : _ref2$messages, _ref2$components = _ref2.components, components = _ref2$components === void 0 ? {} : _ref2$components, _ref2$formats = _ref2.formats, formats = _ref2$formats === void 0 ? {} : _ref2$formats;
                var names = $f145fa6d412a8ce0$var$viewNames(views);
                var msgs = $f145fa6d412a8ce0$var$messages(messages$1);
                return {
                    viewNames: names,
                    localizer: $f145fa6d412a8ce0$var$mergeWithDefaults(localizer, culture, formats, msgs),
                    getters: {
                        eventProp: function eventProp() {
                            return eventPropGetter && eventPropGetter.apply(void 0, arguments) || {};
                        },
                        backgroundEventProp: function backgroundEventProp() {
                            return backgroundEventPropGetter && backgroundEventPropGetter.apply(void 0, arguments) || {};
                        },
                        slotProp: function slotProp() {
                            return slotPropGetter && slotPropGetter.apply(void 0, arguments) || {};
                        },
                        slotGroupProp: function slotGroupProp() {
                            return slotGroupPropGetter && slotGroupPropGetter.apply(void 0, arguments) || {};
                        },
                        dayProp: function dayProp() {
                            return dayPropGetter && dayPropGetter.apply(void 0, arguments) || {};
                        }
                    },
                    components: (0, (/*@__PURE__*/$parcel$interopDefault($c967c285f657b8a4$exports)))(components[view] || {}, (0, (/*@__PURE__*/$parcel$interopDefault($adbc5e5ed3bd9f01$exports)))(components, names), {
                        eventWrapper: $f145fa6d412a8ce0$var$NoopWrapper,
                        backgroundEventWrapper: $f145fa6d412a8ce0$var$NoopWrapper,
                        eventContainerWrapper: $f145fa6d412a8ce0$var$NoopWrapper,
                        dateCellWrapper: $f145fa6d412a8ce0$var$NoopWrapper,
                        weekWrapper: $f145fa6d412a8ce0$var$NoopWrapper,
                        timeSlotWrapper: $f145fa6d412a8ce0$var$NoopWrapper,
                        timeGutterWrapper: $f145fa6d412a8ce0$var$NoopWrapper,
                        timeIndicatorWrapper: $f145fa6d412a8ce0$var$NoopWrapper
                    }),
                    accessors: {
                        start: $f145fa6d412a8ce0$var$wrapAccessor(startAccessor),
                        end: $f145fa6d412a8ce0$var$wrapAccessor(endAccessor),
                        allDay: $f145fa6d412a8ce0$var$wrapAccessor(allDayAccessor),
                        tooltip: $f145fa6d412a8ce0$var$wrapAccessor(tooltipAccessor),
                        title: $f145fa6d412a8ce0$var$wrapAccessor(titleAccessor),
                        resource: $f145fa6d412a8ce0$var$wrapAccessor(resourceAccessor),
                        resourceId: $f145fa6d412a8ce0$var$wrapAccessor(resourceIdAccessor),
                        resourceTitle: $f145fa6d412a8ce0$var$wrapAccessor(resourceTitleAccessor),
                        eventId: $f145fa6d412a8ce0$var$wrapAccessor(eventIdAccessor)
                    }
                };
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Component);
$f145fa6d412a8ce0$var$Calendar.defaultProps = {
    events: [],
    backgroundEvents: [],
    elementProps: {},
    popup: false,
    toolbar: true,
    view: $f145fa6d412a8ce0$export$5cb791131c501f6a.MONTH,
    views: [
        $f145fa6d412a8ce0$export$5cb791131c501f6a.MONTH,
        $f145fa6d412a8ce0$export$5cb791131c501f6a.WEEK,
        $f145fa6d412a8ce0$export$5cb791131c501f6a.DAY,
        $f145fa6d412a8ce0$export$5cb791131c501f6a.AGENDA
    ],
    step: 30,
    length: 30,
    allDayMaxRows: Infinity,
    doShowMoreDrillDown: true,
    drilldownView: $f145fa6d412a8ce0$export$5cb791131c501f6a.DAY,
    titleAccessor: 'title',
    tooltipAccessor: 'title',
    allDayAccessor: 'allDay',
    startAccessor: 'start',
    endAccessor: 'end',
    resourceAccessor: 'resourceId',
    resourceIdAccessor: 'id',
    resourceTitleAccessor: 'title',
    eventIdAccessor: 'id',
    longPressThreshold: 250,
    getNow: function getNow() {
        return new Date();
    },
    dayLayoutAlgorithm: 'overlap'
};
var $f145fa6d412a8ce0$export$e1aef45b828286de = (0, $541facd42d47846b$export$2e2bcd8739ae039)($f145fa6d412a8ce0$var$Calendar, {
    view: 'onView',
    date: 'onNavigate',
    selected: 'onSelectEvent'
});
var $f145fa6d412a8ce0$var$weekRangeFormat$5 = function weekRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return local.format(start, 'MMMM DD', culture) + " \u2013 " + // updated to use this localizer 'eq()' method
    local.format(end, local.eq(start, end, 'month') ? 'DD' : 'MMMM DD', culture);
};
var $f145fa6d412a8ce0$var$dateRangeFormat$5 = function dateRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return local.format(start, 'L', culture) + " \u2013 " + local.format(end, 'L', culture);
};
var $f145fa6d412a8ce0$var$timeRangeFormat$5 = function timeRangeFormat(_ref3, culture, local) {
    var start = _ref3.start, end = _ref3.end;
    return local.format(start, 'LT', culture) + " \u2013 " + local.format(end, 'LT', culture);
};
var $f145fa6d412a8ce0$var$timeRangeStartFormat$5 = function timeRangeStartFormat(_ref4, culture, local) {
    var start = _ref4.start;
    return local.format(start, 'LT', culture) + " \u2013 ";
};
var $f145fa6d412a8ce0$var$timeRangeEndFormat$5 = function timeRangeEndFormat(_ref5, culture, local) {
    var end = _ref5.end;
    return " \u2013 " + local.format(end, 'LT', culture);
};
var $f145fa6d412a8ce0$var$formats$5 = {
    dateFormat: 'DD',
    dayFormat: 'DD ddd',
    weekdayFormat: 'ddd',
    selectRangeFormat: $f145fa6d412a8ce0$var$timeRangeFormat$5,
    eventTimeRangeFormat: $f145fa6d412a8ce0$var$timeRangeFormat$5,
    eventTimeRangeStartFormat: $f145fa6d412a8ce0$var$timeRangeStartFormat$5,
    eventTimeRangeEndFormat: $f145fa6d412a8ce0$var$timeRangeEndFormat$5,
    timeGutterFormat: 'LT',
    monthHeaderFormat: 'MMMM YYYY',
    dayHeaderFormat: 'dddd MMM DD',
    dayRangeHeaderFormat: $f145fa6d412a8ce0$var$weekRangeFormat$5,
    agendaHeaderFormat: $f145fa6d412a8ce0$var$dateRangeFormat$5,
    agendaDateFormat: 'ddd MMM DD',
    agendaTimeFormat: 'LT',
    agendaTimeRangeFormat: $f145fa6d412a8ce0$var$timeRangeFormat$5
};
function $f145fa6d412a8ce0$var$fixUnit$2(unit) {
    var datePart = unit ? unit.toLowerCase() : unit;
    if (datePart === 'FullYear') datePart = 'year';
    else if (!datePart) datePart = undefined;
    return datePart;
}
function $f145fa6d412a8ce0$export$29814e003152ab50(moment) {
    var locale = function locale(m, c) {
        return c ? m.locale(c) : m;
    };
    function getTimezoneOffset(date) {
        // ensures this gets cast to timezone
        return moment(date).toDate().getTimezoneOffset();
    }
    function getDstOffset(start, end) {
        var _st$_z$name, _st$_z;
        // convert to moment, in case
        // Calculate the offset in the timezone of the Events (local)
        // not in the timezone of the calendar (moment.tz)
        var st = moment(start).local();
        var ed = moment(end).local();
        // if not using moment timezone
        if (!moment.tz) return st.toDate().getTimezoneOffset() - ed.toDate().getTimezoneOffset();
        /**
     * If using moment-timezone, and a timezone has been applied, then
     * use this to get the proper timezone offset, otherwise default
     * the timezone to the browser local
     */ var tzName = (_st$_z$name = st === null || st === void 0 ? void 0 : (_st$_z = st._z) === null || _st$_z === void 0 ? void 0 : _st$_z.name) !== null && _st$_z$name !== void 0 ? _st$_z$name : moment.tz.guess();
        var startOffset = moment.tz.zone(tzName).utcOffset(+st);
        var endOffset = moment.tz.zone(tzName).utcOffset(+ed);
        return startOffset - endOffset;
    }
    function getDayStartDstOffset(start) {
        var dayStart = moment(start).startOf('day');
        return getDstOffset(dayStart, start);
    }
    /*** BEGIN localized date arithmetic methods with moment ***/ function defineComparators(a, b, unit) {
        var datePart = $f145fa6d412a8ce0$var$fixUnit$2(unit);
        var dtA = datePart ? moment(a).startOf(datePart) : moment(a);
        var dtB = datePart ? moment(b).startOf(datePart) : moment(b);
        return [
            dtA,
            dtB,
            datePart
        ];
    }
    function startOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $f145fa6d412a8ce0$var$fixUnit$2(unit);
        if (datePart) return moment(date).startOf(datePart).toDate();
        return moment(date).toDate();
    }
    function endOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $f145fa6d412a8ce0$var$fixUnit$2(unit);
        if (datePart) return moment(date).endOf(datePart).toDate();
        return moment(date).toDate();
    }
    // moment comparison operations *always* convert both sides to moment objects
    // prior to running the comparisons
    function eq(a, b, unit) {
        var _defineComparators = defineComparators(a, b, unit), _defineComparators2 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_defineComparators, 3), dtA = _defineComparators2[0], dtB = _defineComparators2[1], datePart = _defineComparators2[2];
        return dtA.isSame(dtB, datePart);
    }
    function neq(a, b, unit) {
        return !eq(a, b, unit);
    }
    function gt(a, b, unit) {
        var _defineComparators3 = defineComparators(a, b, unit), _defineComparators4 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_defineComparators3, 3), dtA = _defineComparators4[0], dtB = _defineComparators4[1], datePart = _defineComparators4[2];
        return dtA.isAfter(dtB, datePart);
    }
    function lt(a, b, unit) {
        var _defineComparators5 = defineComparators(a, b, unit), _defineComparators6 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_defineComparators5, 3), dtA = _defineComparators6[0], dtB = _defineComparators6[1], datePart = _defineComparators6[2];
        return dtA.isBefore(dtB, datePart);
    }
    function gte(a, b, unit) {
        var _defineComparators7 = defineComparators(a, b, unit), _defineComparators8 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_defineComparators7, 3), dtA = _defineComparators8[0], dtB = _defineComparators8[1], datePart = _defineComparators8[2];
        return dtA.isSameOrBefore(dtB, datePart);
    }
    function lte(a, b, unit) {
        var _defineComparators9 = defineComparators(a, b, unit), _defineComparators10 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_defineComparators9, 3), dtA = _defineComparators10[0], dtB = _defineComparators10[1], datePart = _defineComparators10[2];
        return dtA.isSameOrBefore(dtB, datePart);
    }
    function inRange(day, min, max) {
        var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'day';
        var datePart = $f145fa6d412a8ce0$var$fixUnit$2(unit);
        var mDay = moment(day);
        var mMin = moment(min);
        var mMax = moment(max);
        return mDay.isBetween(mMin, mMax, datePart, '[]');
    }
    function min(dateA, dateB) {
        var dtA = moment(dateA);
        var dtB = moment(dateB);
        var minDt = moment.min(dtA, dtB);
        return minDt.toDate();
    }
    function max(dateA, dateB) {
        var dtA = moment(dateA);
        var dtB = moment(dateB);
        var maxDt = moment.max(dtA, dtB);
        return maxDt.toDate();
    }
    function merge(date, time) {
        if (!date && !time) return null;
        var tm = moment(time).format('HH:mm:ss');
        var dt = moment(date).startOf('day').format('MM/DD/YYYY');
        // We do it this way to avoid issues when timezone switching
        return moment("".concat(dt, " ").concat(tm), 'MM/DD/YYYY HH:mm:ss').toDate();
    }
    function add(date, adder, unit) {
        var datePart = $f145fa6d412a8ce0$var$fixUnit$2(unit);
        return moment(date).add(adder, datePart).toDate();
    }
    function range(start, end) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $f145fa6d412a8ce0$var$fixUnit$2(unit);
        // because the add method will put these in tz, we have to start that way
        var current = moment(start).toDate();
        var days = [];
        while(lte(current, end)){
            days.push(current);
            current = add(current, 1, datePart);
        }
        return days;
    }
    function ceil(date, unit) {
        var datePart = $f145fa6d412a8ce0$var$fixUnit$2(unit);
        var floor = startOf(date, datePart);
        return eq(floor, date) ? floor : add(floor, 1, datePart);
    }
    function diff(a, b) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $f145fa6d412a8ce0$var$fixUnit$2(unit);
        // don't use 'defineComparators' here, as we don't want to mutate the values
        var dtA = moment(a);
        var dtB = moment(b);
        return dtB.diff(dtA, datePart);
    }
    function minutes(date) {
        var dt = moment(date);
        return dt.minutes();
    }
    function firstOfWeek(culture) {
        var data = culture ? moment.localeData(culture) : moment.localeData();
        return data ? data.firstDayOfWeek() : 0;
    }
    function firstVisibleDay(date) {
        return moment(date).startOf('month').startOf('week').toDate();
    }
    function lastVisibleDay(date) {
        return moment(date).endOf('month').endOf('week').toDate();
    }
    function visibleDays(date) {
        var current = firstVisibleDay(date);
        var last = lastVisibleDay(date);
        var days = [];
        while(lte(current, last)){
            days.push(current);
            current = add(current, 1, 'd');
        }
        return days;
    }
    /*** END localized date arithmetic methods with moment ***/ /**
   * Moved from TimeSlots.js, this method overrides the method of the same name
   * in the localizer.js, using moment to construct the js Date
   * @param {Date} dt - date to start with
   * @param {Number} minutesFromMidnight
   * @param {Number} offset
   * @returns {Date}
   */ function getSlotDate(dt, minutesFromMidnight, offset) {
        return moment(dt).startOf('day').minute(minutesFromMidnight + offset).toDate();
    }
    // moment will automatically handle DST differences in it's calculations
    function getTotalMin(start, end) {
        return diff(start, end, 'minutes');
    }
    function getMinutesFromMidnight(start) {
        var dayStart = moment(start).startOf('day');
        var day = moment(start);
        return day.diff(dayStart, 'minutes') + getDayStartDstOffset(start);
    }
    // These two are used by DateSlotMetrics
    function continuesPrior(start, first) {
        var mStart = moment(start);
        var mFirst = moment(first);
        return mStart.isBefore(mFirst, 'day');
    }
    function continuesAfter(start, end, last) {
        var mEnd = moment(end);
        var mLast = moment(last);
        return mEnd.isSameOrAfter(mLast, 'minutes');
    }
    function daySpan(start, end) {
        var mStart = moment(start);
        var mEnd = moment(end);
        var dur = moment.duration(mEnd.diff(mStart));
        return dur.days();
    }
    // These two are used by eventLevels
    function sortEvents(_ref6) {
        var _ref6$evtA = _ref6.evtA, aStart = _ref6$evtA.start, aEnd = _ref6$evtA.end, aAllDay = _ref6$evtA.allDay, _ref6$evtB = _ref6.evtB, bStart = _ref6$evtB.start, bEnd = _ref6$evtB.end, bAllDay = _ref6$evtB.allDay;
        var startSort = +startOf(aStart, 'day') - +startOf(bStart, 'day');
        var durA = daySpan(aStart, aEnd);
        var durB = daySpan(bStart, bEnd);
        return startSort || // sort by start Day first
        durB - durA || // events spanning multiple days go first
        !!bAllDay - !!aAllDay || // then allDay single day events
        +aStart - +bStart || // then sort by start time *don't need moment conversion here
        +aEnd - +bEnd // then sort by end time *don't need moment conversion here either
        ;
    }
    function inEventRange(_ref7) {
        var _ref7$event = _ref7.event, start = _ref7$event.start, end = _ref7$event.end, _ref7$range = _ref7.range, rangeStart = _ref7$range.start, rangeEnd = _ref7$range.end;
        var startOfDay = moment(start).startOf('day');
        var eEnd = moment(end);
        var rStart = moment(rangeStart);
        var rEnd = moment(rangeEnd);
        var startsBeforeEnd = startOfDay.isSameOrBefore(rEnd, 'day');
        // when the event is zero duration we need to handle a bit differently
        var sameMin = !startOfDay.isSame(eEnd, 'minutes');
        var endsAfterStart = sameMin ? eEnd.isAfter(rStart, 'minutes') : eEnd.isSameOrAfter(rStart, 'minutes');
        return startsBeforeEnd && endsAfterStart;
    }
    function isSameDate(date1, date2) {
        var dt = moment(date1);
        var dt2 = moment(date2);
        return dt.isSame(dt2, 'day');
    }
    /**
   * This method, called once in the localizer constructor, is used by eventLevels
   * 'eventSegments()' to assist in determining the 'span' of the event in the display,
   * specifically when using a timezone that is greater than the browser native timezone.
   * @returns number
   */ function browserTZOffset() {
        /**
     * Date.prototype.getTimezoneOffset horrifically flips the positive/negative from
     * what you see in it's string, so we have to jump through some hoops to get a value
     * we can actually compare.
     */ var dt = new Date();
        var neg = /-/.test(dt.toString()) ? '-' : '';
        var dtOffset = dt.getTimezoneOffset();
        var comparator = Number("".concat(neg).concat(Math.abs(dtOffset)));
        // moment correctly provides positive/negative offset, as expected
        var mtOffset = moment().utcOffset();
        return mtOffset > comparator ? 1 : 0;
    }
    return new $f145fa6d412a8ce0$export$193ddab16544ff5b({
        formats: $f145fa6d412a8ce0$var$formats$5,
        firstOfWeek: firstOfWeek,
        firstVisibleDay: firstVisibleDay,
        lastVisibleDay: lastVisibleDay,
        visibleDays: visibleDays,
        format: function format(value, _format, culture) {
            return locale(moment(value), culture).format(_format);
        },
        lt: lt,
        lte: lte,
        gt: gt,
        gte: gte,
        eq: eq,
        neq: neq,
        merge: merge,
        inRange: inRange,
        startOf: startOf,
        endOf: endOf,
        range: range,
        add: add,
        diff: diff,
        ceil: ceil,
        min: min,
        max: max,
        minutes: minutes,
        getSlotDate: getSlotDate,
        getTimezoneOffset: getTimezoneOffset,
        getDstOffset: getDstOffset,
        getTotalMin: getTotalMin,
        getMinutesFromMidnight: getMinutesFromMidnight,
        continuesPrior: continuesPrior,
        continuesAfter: continuesAfter,
        sortEvents: sortEvents,
        inEventRange: inEventRange,
        isSameDate: isSameDate,
        daySpan: daySpan,
        browserTZOffset: browserTZOffset
    });
}
function $f145fa6d412a8ce0$var$pluralizeUnit(unit) {
    return /s$/.test(unit) ? unit : unit + 's';
}
var $f145fa6d412a8ce0$var$weekRangeFormat$4 = function weekRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return local.format(start, 'MMMM dd', culture) + " \u2013 " + // updated to use this localizer 'eq()' method
    local.format(end, local.eq(start, end, 'month') ? 'dd' : 'MMMM dd', culture);
};
var $f145fa6d412a8ce0$var$dateRangeFormat$4 = function dateRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return local.format(start, 'D', culture) + " \u2013 " + local.format(end, 'D', culture);
};
var $f145fa6d412a8ce0$var$timeRangeFormat$4 = function timeRangeFormat(_ref3, culture, local) {
    var start = _ref3.start, end = _ref3.end;
    return local.format(start, 't', culture) + " \u2013 " + local.format(end, 't', culture);
};
var $f145fa6d412a8ce0$var$timeRangeStartFormat$4 = function timeRangeStartFormat(_ref4, culture, local) {
    var start = _ref4.start;
    return local.format(start, 't', culture) + " \u2013 ";
};
var $f145fa6d412a8ce0$var$timeRangeEndFormat$4 = function timeRangeEndFormat(_ref5, culture, local) {
    var end = _ref5.end;
    return " \u2013 " + local.format(end, 't', culture);
};
var $f145fa6d412a8ce0$var$formats$4 = {
    dateFormat: 'dd',
    dayFormat: 'dd EEE',
    weekdayFormat: 'EEE',
    selectRangeFormat: $f145fa6d412a8ce0$var$timeRangeFormat$4,
    eventTimeRangeFormat: $f145fa6d412a8ce0$var$timeRangeFormat$4,
    eventTimeRangeStartFormat: $f145fa6d412a8ce0$var$timeRangeStartFormat$4,
    eventTimeRangeEndFormat: $f145fa6d412a8ce0$var$timeRangeEndFormat$4,
    timeGutterFormat: 't',
    monthHeaderFormat: 'MMMM yyyy',
    dayHeaderFormat: 'EEEE MMM dd',
    dayRangeHeaderFormat: $f145fa6d412a8ce0$var$weekRangeFormat$4,
    agendaHeaderFormat: $f145fa6d412a8ce0$var$dateRangeFormat$4,
    agendaDateFormat: 'EEE MMM dd',
    agendaTimeFormat: 't',
    agendaTimeRangeFormat: $f145fa6d412a8ce0$var$timeRangeFormat$4
};
function $f145fa6d412a8ce0$var$fixUnit$1(unit) {
    var datePart = unit ? $f145fa6d412a8ce0$var$pluralizeUnit(unit.toLowerCase()) : unit;
    if (datePart === 'FullYear') datePart = 'year';
    else if (!datePart) datePart = undefined;
    return datePart;
}
// Luxon does not currently have weekInfo by culture
// Luxon uses 1 based values for month and weekday
// So we default to Sunday (7)
function $f145fa6d412a8ce0$export$d65cc979272e65c7(DateTime) {
    var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref6$firstDayOfWeek = _ref6.firstDayOfWeek, firstDayOfWeek = _ref6$firstDayOfWeek === void 0 ? 7 : _ref6$firstDayOfWeek;
    function formatDate(value, format) {
        return DateTime.fromJSDate(value).toFormat(format);
    }
    function formatDateWithCulture(value, culture, format) {
        return DateTime.fromJSDate(value).setLocale(culture).toFormat(format);
    }
    /*** BEGIN localized date arithmetic methods with Luxon ***/ function defineComparators(a, b, unit) {
        var datePart = $f145fa6d412a8ce0$var$fixUnit$1(unit);
        var dtA = datePart ? DateTime.fromJSDate(a).startOf(datePart) : DateTime.fromJSDate(a);
        var dtB = datePart ? DateTime.fromJSDate(b).startOf(datePart) : DateTime.fromJSDate(b);
        return [
            dtA,
            dtB,
            datePart
        ];
    }
    // Since Luxon (and current Intl API) has no support
    // for culture based weekInfo, we need to handle
    // the start of the week differently
    // depending on locale, the firstDayOfWeek could also be Saturday, Sunday or Monday
    function startOfDTWeek(dtObj) {
        var weekday = dtObj.weekday;
        if (weekday === firstDayOfWeek) return dtObj.startOf('day'); // already beginning of week
        else if (firstDayOfWeek === 1) return dtObj.startOf('week'); // fow is Monday, which is Luxon default
        var diff = firstDayOfWeek === 7 ? weekday : weekday + (7 - firstDayOfWeek);
        return dtObj.minus({
            day: diff
        }).startOf('day');
    }
    function endOfDTWeek(dtObj) {
        var weekday = dtObj.weekday;
        var eow = firstDayOfWeek === 1 ? 7 : firstDayOfWeek - 1;
        if (weekday === eow) return dtObj.endOf('day'); // already last day of the week
        else if (firstDayOfWeek === 1) return dtObj.endOf('week'); // use Luxon default (Sunday)
        var fromDate = firstDayOfWeek > eow ? dtObj.plus({
            day: firstDayOfWeek - eow
        }) : dtObj;
        return fromDate.set({
            weekday: eow
        }).endOf('day');
    }
    // This returns a DateTime instance
    function startOfDT() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $f145fa6d412a8ce0$var$fixUnit$1(unit);
        if (datePart) {
            var dt = DateTime.fromJSDate(date);
            return datePart.includes('week') ? startOfDTWeek(dt) : dt.startOf(datePart);
        }
        return DateTime.fromJSDate(date);
    }
    function firstOfWeek() {
        return firstDayOfWeek;
    }
    // This returns a JS Date from a DateTime instance
    function startOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        return startOfDT(date, unit).toJSDate();
    }
    // This returns a DateTime instance
    function endOfDT() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $f145fa6d412a8ce0$var$fixUnit$1(unit);
        if (datePart) {
            var dt = DateTime.fromJSDate(date);
            return datePart.includes('week') ? endOfDTWeek(dt) : dt.endOf(datePart);
        }
        return DateTime.fromJSDate(date);
    }
    function endOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        return endOfDT(date, unit).toJSDate();
    }
    function eq(a, b, unit) {
        var _defineComparators = defineComparators(a, b, unit), _defineComparators2 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_defineComparators, 2), dtA = _defineComparators2[0], dtB = _defineComparators2[1];
        return +dtA == +dtB;
    }
    function neq(a, b, unit) {
        return !eq(a, b, unit);
    }
    function gt(a, b, unit) {
        var _defineComparators3 = defineComparators(a, b, unit), _defineComparators4 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_defineComparators3, 2), dtA = _defineComparators4[0], dtB = _defineComparators4[1];
        return +dtA > +dtB;
    }
    function lt(a, b, unit) {
        var _defineComparators5 = defineComparators(a, b, unit), _defineComparators6 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_defineComparators5, 2), dtA = _defineComparators6[0], dtB = _defineComparators6[1];
        return +dtA < +dtB;
    }
    function gte(a, b, unit) {
        var _defineComparators7 = defineComparators(a, b, unit), _defineComparators8 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_defineComparators7, 2), dtA = _defineComparators8[0], dtB = _defineComparators8[1];
        return +dtA >= +dtB;
    }
    function lte(a, b, unit) {
        var _defineComparators9 = defineComparators(a, b, unit), _defineComparators10 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_defineComparators9, 2), dtA = _defineComparators10[0], dtB = _defineComparators10[1];
        return +dtA <= +dtB;
    }
    function inRange(day, min, max) {
        var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'day';
        var datePart = $f145fa6d412a8ce0$var$fixUnit$1(unit);
        var mDay = startOfDT(day, datePart);
        var mMin = startOfDT(min, datePart);
        var mMax = startOfDT(max, datePart);
        return +mDay >= +mMin && +mDay <= +mMax;
    }
    function min(dateA, dateB) {
        var dtA = DateTime.fromJSDate(dateA);
        var dtB = DateTime.fromJSDate(dateB);
        var minDt = DateTime.min(dtA, dtB);
        return minDt.toJSDate();
    }
    function max(dateA, dateB) {
        var dtA = DateTime.fromJSDate(dateA);
        var dtB = DateTime.fromJSDate(dateB);
        var maxDt = DateTime.max(dtA, dtB);
        return maxDt.toJSDate();
    }
    function merge(date, time) {
        if (!date && !time) return null;
        var tm = DateTime.fromJSDate(time);
        var dt = startOfDT(date, 'day');
        return dt.set({
            hour: tm.hour,
            minute: tm.minute,
            second: tm.second,
            millisecond: tm.millisecond
        }).toJSDate();
    }
    function add(date, adder, unit) {
        var datePart = $f145fa6d412a8ce0$var$fixUnit$1(unit);
        return DateTime.fromJSDate(date).plus((0, $6a740e003744eccd$export$2e2bcd8739ae039)({}, datePart, adder)).toJSDate();
    }
    function range(start, end) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $f145fa6d412a8ce0$var$fixUnit$1(unit);
        var current = DateTime.fromJSDate(start).toJSDate(); // this is to get it to tz
        var days = [];
        while(lte(current, end)){
            days.push(current);
            current = add(current, 1, datePart);
        }
        return days;
    }
    function ceil(date, unit) {
        var datePart = $f145fa6d412a8ce0$var$fixUnit$1(unit);
        var floor = startOf(date, datePart);
        return eq(floor, date) ? floor : add(floor, 1, datePart);
    }
    function diff(a, b) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $f145fa6d412a8ce0$var$fixUnit$1(unit);
        // don't use 'defineComparators' here, as we don't want to mutate the values
        var dtA = DateTime.fromJSDate(a);
        var dtB = DateTime.fromJSDate(b);
        return Math.floor(dtB.diff(dtA, datePart, {
            conversionAccuracy: 'longterm'
        }).toObject()[datePart]);
    }
    function firstVisibleDay(date) {
        var startOfMonth = startOfDT(date, 'month');
        return startOfDTWeek(startOfMonth).toJSDate();
    }
    function lastVisibleDay(date) {
        var endOfMonth = endOfDT(date, 'month');
        return endOfDTWeek(endOfMonth).toJSDate();
    }
    function visibleDays(date) {
        var current = firstVisibleDay(date);
        var last = lastVisibleDay(date);
        var days = [];
        while(lte(current, last)){
            days.push(current);
            current = add(current, 1, 'day');
        }
        return days;
    }
    /*** END localized date arithmetic methods with moment ***/ /**
   * Moved from TimeSlots.js, this method overrides the method of the same name
   * in the localizer.js, using moment to construct the js Date
   * @param {Date} dt - date to start with
   * @param {Number} minutesFromMidnight
   * @param {Number} offset
   * @returns {Date}
   */ function getSlotDate(dt, minutesFromMidnight, offset) {
        return startOfDT(dt, 'day').set({
            minutes: minutesFromMidnight + offset
        }).toJSDate();
    }
    // Luxon will automatically handle DST differences in it's calculations
    function getTotalMin(start, end) {
        return diff(start, end, 'minutes');
    }
    function getMinutesFromMidnight(start) {
        var dayStart = startOfDT(start, 'day');
        var day = DateTime.fromJSDate(start);
        return Math.round(day.diff(dayStart, 'minutes', {
            conversionAccuracy: 'longterm'
        }).toObject().minutes);
    }
    // These two are used by DateSlotMetrics
    function continuesPrior(start, first) {
        return lt(start, first);
    }
    function continuesAfter(start, end, last) {
        return gte(end, last);
    }
    function daySpan(start, end) {
        var dtStart = DateTime.fromJSDate(start);
        var dtEnd = DateTime.fromJSDate(end);
        return dtEnd.diff(dtStart).as('days');
    }
    // These two are used by eventLevels
    function sortEvents(_ref7) {
        var _ref7$evtA = _ref7.evtA, aStart = _ref7$evtA.start, aEnd = _ref7$evtA.end, aAllDay = _ref7$evtA.allDay, _ref7$evtB = _ref7.evtB, bStart = _ref7$evtB.start, bEnd = _ref7$evtB.end, bAllDay = _ref7$evtB.allDay;
        var startSort = +startOf(aStart, 'day') - +startOf(bStart, 'day');
        var durA = daySpan(aStart, aEnd);
        var durB = daySpan(bStart, bEnd);
        return startSort || // sort by start Day first
        durB - durA || // events spanning multiple days go first
        !!bAllDay - !!aAllDay || // then allDay single day events
        +aStart - +bStart || // then sort by start time *don't need moment conversion here
        +aEnd - +bEnd // then sort by end time *don't need moment conversion here either
        ;
    }
    function inEventRange(_ref8) {
        var _ref8$event = _ref8.event, start = _ref8$event.start, end = _ref8$event.end, _ref8$range = _ref8.range, rangeStart = _ref8$range.start, rangeEnd = _ref8$range.end;
        var eStart = startOf(start, 'day');
        var startsBeforeEnd = lte(eStart, rangeEnd, 'day');
        // when the event is zero duration we need to handle a bit differently
        var sameMin = neq(eStart, end, 'minutes');
        var endsAfterStart = sameMin ? gt(end, rangeStart, 'minutes') : gte(end, rangeStart, 'minutes');
        return startsBeforeEnd && endsAfterStart;
    }
    // moment treats 'day' and 'date' equality very different
    // moment(date1).isSame(date2, 'day') would test that they were both the same day of the week
    // moment(date1).isSame(date2, 'date') would test that they were both the same date of the month of the year
    function isSameDate(date1, date2) {
        var dt = DateTime.fromJSDate(date1);
        var dt2 = DateTime.fromJSDate(date2);
        return dt.hasSame(dt2, 'day');
    }
    /**
   * This method, called once in the localizer constructor, is used by eventLevels
   * 'eventSegments()' to assist in determining the 'span' of the event in the display,
   * specifically when using a timezone that is greater than the browser native timezone.
   * @returns number
   */ function browserTZOffset() {
        /**
     * Date.prototype.getTimezoneOffset horrifically flips the positive/negative from
     * what you see in it's string, so we have to jump through some hoops to get a value
     * we can actually compare.
     */ var dt = new Date();
        var neg = /-/.test(dt.toString()) ? '-' : '';
        var dtOffset = dt.getTimezoneOffset();
        var comparator = Number("".concat(neg).concat(Math.abs(dtOffset)));
        // moment correctly provides positive/negative offset, as expected
        var mtOffset = DateTime.local().offset;
        return mtOffset > comparator ? 1 : 0;
    }
    return new $f145fa6d412a8ce0$export$193ddab16544ff5b({
        format: function format(value, _format, culture) {
            if (culture) return formatDateWithCulture(value, culture, _format);
            return formatDate(value, _format);
        },
        formats: $f145fa6d412a8ce0$var$formats$4,
        firstOfWeek: firstOfWeek,
        firstVisibleDay: firstVisibleDay,
        lastVisibleDay: lastVisibleDay,
        visibleDays: visibleDays,
        lt: lt,
        lte: lte,
        gt: gt,
        gte: gte,
        eq: eq,
        neq: neq,
        merge: merge,
        inRange: inRange,
        startOf: startOf,
        endOf: endOf,
        range: range,
        add: add,
        diff: diff,
        ceil: ceil,
        min: min,
        max: max,
        getSlotDate: getSlotDate,
        getTotalMin: getTotalMin,
        getMinutesFromMidnight: getMinutesFromMidnight,
        continuesPrior: continuesPrior,
        continuesAfter: continuesAfter,
        sortEvents: sortEvents,
        inEventRange: inEventRange,
        isSameDate: isSameDate,
        daySpan: daySpan,
        browserTZOffset: browserTZOffset
    });
}
var $f145fa6d412a8ce0$var$dateRangeFormat$3 = function dateRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return local.format(start, 'd', culture) + " \u2013 " + local.format(end, 'd', culture);
};
var $f145fa6d412a8ce0$var$timeRangeFormat$3 = function timeRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return local.format(start, 't', culture) + " \u2013 " + local.format(end, 't', culture);
};
var $f145fa6d412a8ce0$var$timeRangeStartFormat$3 = function timeRangeStartFormat(_ref3, culture, local) {
    var start = _ref3.start;
    return local.format(start, 't', culture) + " \u2013 ";
};
var $f145fa6d412a8ce0$var$timeRangeEndFormat$3 = function timeRangeEndFormat(_ref4, culture, local) {
    var end = _ref4.end;
    return " \u2013 " + local.format(end, 't', culture);
};
var $f145fa6d412a8ce0$var$weekRangeFormat$3 = function weekRangeFormat(_ref5, culture, local) {
    var start = _ref5.start, end = _ref5.end;
    return local.format(start, 'MMM dd', culture) + " \u2013 " + local.format(end, (0, $f8eddd003dbc1436$export$9663ddc1cf085b32)(start, end, 'month') ? 'dd' : 'MMM dd', culture);
};
var $f145fa6d412a8ce0$var$formats$3 = {
    dateFormat: 'dd',
    dayFormat: 'ddd dd/MM',
    weekdayFormat: 'ddd',
    selectRangeFormat: $f145fa6d412a8ce0$var$timeRangeFormat$3,
    eventTimeRangeFormat: $f145fa6d412a8ce0$var$timeRangeFormat$3,
    eventTimeRangeStartFormat: $f145fa6d412a8ce0$var$timeRangeStartFormat$3,
    eventTimeRangeEndFormat: $f145fa6d412a8ce0$var$timeRangeEndFormat$3,
    timeGutterFormat: 't',
    monthHeaderFormat: 'Y',
    dayHeaderFormat: 'dddd MMM dd',
    dayRangeHeaderFormat: $f145fa6d412a8ce0$var$weekRangeFormat$3,
    agendaHeaderFormat: $f145fa6d412a8ce0$var$dateRangeFormat$3,
    agendaDateFormat: 'ddd MMM dd',
    agendaTimeFormat: 't',
    agendaTimeRangeFormat: $f145fa6d412a8ce0$var$timeRangeFormat$3
};
function $f145fa6d412a8ce0$var$oldGlobalize(globalize) {
    function getCulture(culture) {
        return culture ? globalize.findClosestCulture(culture) : globalize.culture();
    }
    function firstOfWeek(culture) {
        culture = getCulture(culture);
        return culture && culture.calendar.firstDay || 0;
    }
    return new $f145fa6d412a8ce0$export$193ddab16544ff5b({
        firstOfWeek: firstOfWeek,
        formats: $f145fa6d412a8ce0$var$formats$3,
        format: function format(value, _format, culture) {
            return globalize.format(value, _format, culture);
        }
    });
}
// TODO: fix the globalizeLocalizer to work with globalize 1.x
var $f145fa6d412a8ce0$var$dateRangeFormat$2 = function dateRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return local.format(start, {
        date: 'short'
    }, culture) + " \u2013 " + local.format(end, {
        date: 'short'
    }, culture);
};
var $f145fa6d412a8ce0$var$timeRangeFormat$2 = function timeRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return local.format(start, {
        time: 'short'
    }, culture) + " \u2013 " + local.format(end, {
        time: 'short'
    }, culture);
};
var $f145fa6d412a8ce0$var$timeRangeStartFormat$2 = function timeRangeStartFormat(_ref3, culture, local) {
    var start = _ref3.start;
    return local.format(start, {
        time: 'short'
    }, culture) + " \u2013 ";
};
var $f145fa6d412a8ce0$var$timeRangeEndFormat$2 = function timeRangeEndFormat(_ref4, culture, local) {
    var end = _ref4.end;
    return " \u2013 " + local.format(end, {
        time: 'short'
    }, culture);
};
var $f145fa6d412a8ce0$var$weekRangeFormat$2 = function weekRangeFormat(_ref5, culture, local) {
    var start = _ref5.start, end = _ref5.end;
    return local.format(start, 'MMM dd', culture) + " \u2013 " + local.format(end, (0, $f8eddd003dbc1436$export$9663ddc1cf085b32)(start, end, 'month') ? 'dd' : 'MMM dd', culture);
};
var $f145fa6d412a8ce0$var$formats$2 = {
    dateFormat: 'dd',
    dayFormat: 'eee dd/MM',
    weekdayFormat: 'eee',
    selectRangeFormat: $f145fa6d412a8ce0$var$timeRangeFormat$2,
    eventTimeRangeFormat: $f145fa6d412a8ce0$var$timeRangeFormat$2,
    eventTimeRangeStartFormat: $f145fa6d412a8ce0$var$timeRangeStartFormat$2,
    eventTimeRangeEndFormat: $f145fa6d412a8ce0$var$timeRangeEndFormat$2,
    timeGutterFormat: {
        time: 'short'
    },
    monthHeaderFormat: 'MMMM yyyy',
    dayHeaderFormat: 'eeee MMM dd',
    dayRangeHeaderFormat: $f145fa6d412a8ce0$var$weekRangeFormat$2,
    agendaHeaderFormat: $f145fa6d412a8ce0$var$dateRangeFormat$2,
    agendaDateFormat: 'eee MMM dd',
    agendaTimeFormat: {
        time: 'short'
    },
    agendaTimeRangeFormat: $f145fa6d412a8ce0$var$timeRangeFormat$2
};
function $f145fa6d412a8ce0$export$d670461b50de9b9d(globalize) {
    var locale = function locale(culture) {
        return culture ? globalize(culture) : globalize;
    };
    // return the first day of the week from the locale data. Defaults to 'world'
    // territory if no territory is derivable from CLDR.
    // Failing to use CLDR supplemental (not loaded?), revert to the original
    // method of getting first day of week.
    function firstOfWeek(culture) {
        try {
            var days = [
                'sun',
                'mon',
                'tue',
                'wed',
                'thu',
                'fri',
                'sat'
            ];
            var cldr = locale(culture).cldr;
            var territory = cldr.attributes.territory;
            var weekData = cldr.get('supplemental').weekData;
            var firstDay = weekData.firstDay[territory || '001'];
            return days.indexOf(firstDay);
        } catch (e) {
            // maybe cldr supplemental is not loaded? revert to original method
            var date = new Date();
            //cldr-data doesn't seem to be zero based
            var localeDay = Math.max(parseInt(locale(culture).formatDate(date, {
                raw: 'e'
            }), 10) - 1, 0);
            return Math.abs(date.getDay() - localeDay);
        }
    }
    if (!globalize.load) return $f145fa6d412a8ce0$var$oldGlobalize(globalize);
    return new $f145fa6d412a8ce0$export$193ddab16544ff5b({
        firstOfWeek: firstOfWeek,
        formats: $f145fa6d412a8ce0$var$formats$2,
        format: function format(value, _format, culture) {
            _format = typeof _format === 'string' ? {
                raw: _format
            } : _format;
            return locale(culture).formatDate(value, _format);
        }
    });
}
var $f145fa6d412a8ce0$var$dateRangeFormat$1 = function dateRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return "".concat(local.format(start, 'P', culture), " \u2013 ").concat(local.format(end, 'P', culture));
};
var $f145fa6d412a8ce0$var$timeRangeFormat$1 = function timeRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return "".concat(local.format(start, 'p', culture), " \u2013 ").concat(local.format(end, 'p', culture));
};
var $f145fa6d412a8ce0$var$timeRangeStartFormat$1 = function timeRangeStartFormat(_ref3, culture, local) {
    var start = _ref3.start;
    return "".concat(local.format(start, 'h:mma', culture), " \u2013 ");
};
var $f145fa6d412a8ce0$var$timeRangeEndFormat$1 = function timeRangeEndFormat(_ref4, culture, local) {
    var end = _ref4.end;
    return " \u2013 ".concat(local.format(end, 'h:mma', culture));
};
var $f145fa6d412a8ce0$var$weekRangeFormat$1 = function weekRangeFormat(_ref5, culture, local) {
    var start = _ref5.start, end = _ref5.end;
    return "".concat(local.format(start, 'MMMM dd', culture), " \u2013 ").concat(local.format(end, (0, $f8eddd003dbc1436$export$9663ddc1cf085b32)(start, end, 'month') ? 'dd' : 'MMMM dd', culture));
};
var $f145fa6d412a8ce0$var$formats$1 = {
    dateFormat: 'dd',
    dayFormat: 'dd eee',
    weekdayFormat: 'ccc',
    selectRangeFormat: $f145fa6d412a8ce0$var$timeRangeFormat$1,
    eventTimeRangeFormat: $f145fa6d412a8ce0$var$timeRangeFormat$1,
    eventTimeRangeStartFormat: $f145fa6d412a8ce0$var$timeRangeStartFormat$1,
    eventTimeRangeEndFormat: $f145fa6d412a8ce0$var$timeRangeEndFormat$1,
    timeGutterFormat: 'p',
    monthHeaderFormat: 'MMMM yyyy',
    dayHeaderFormat: 'cccc MMM dd',
    dayRangeHeaderFormat: $f145fa6d412a8ce0$var$weekRangeFormat$1,
    agendaHeaderFormat: $f145fa6d412a8ce0$var$dateRangeFormat$1,
    agendaDateFormat: 'ccc MMM dd',
    agendaTimeFormat: 'p',
    agendaTimeRangeFormat: $f145fa6d412a8ce0$var$timeRangeFormat$1
};
var $f145fa6d412a8ce0$export$3fa2fdf84427788c = function dateFnsLocalizer(_ref6) {
    var startOfWeek = _ref6.startOfWeek, getDay = _ref6.getDay, _format = _ref6.format, locales = _ref6.locales;
    return new $f145fa6d412a8ce0$export$193ddab16544ff5b({
        formats: $f145fa6d412a8ce0$var$formats$1,
        firstOfWeek: function firstOfWeek(culture) {
            return getDay(startOfWeek(new Date(), {
                locale: locales[culture]
            }));
        },
        format: function format(value, formatString, culture) {
            return _format(new Date(value), formatString, {
                locale: locales[culture]
            });
        }
    });
};
var $f145fa6d412a8ce0$var$weekRangeFormat = function weekRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return local.format(start, 'MMMM DD', culture) + " \u2013 " + // updated to use this localizer 'eq()' method
    local.format(end, local.eq(start, end, 'month') ? 'DD' : 'MMMM DD', culture);
};
var $f145fa6d412a8ce0$var$dateRangeFormat = function dateRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return local.format(start, 'L', culture) + " \u2013 " + local.format(end, 'L', culture);
};
var $f145fa6d412a8ce0$var$timeRangeFormat = function timeRangeFormat(_ref3, culture, local) {
    var start = _ref3.start, end = _ref3.end;
    return local.format(start, 'LT', culture) + " \u2013 " + local.format(end, 'LT', culture);
};
var $f145fa6d412a8ce0$var$timeRangeStartFormat = function timeRangeStartFormat(_ref4, culture, local) {
    var start = _ref4.start;
    return local.format(start, 'LT', culture) + " \u2013 ";
};
var $f145fa6d412a8ce0$var$timeRangeEndFormat = function timeRangeEndFormat(_ref5, culture, local) {
    var end = _ref5.end;
    return " \u2013 " + local.format(end, 'LT', culture);
};
var $f145fa6d412a8ce0$var$formats = {
    dateFormat: 'DD',
    dayFormat: 'DD ddd',
    weekdayFormat: 'ddd',
    selectRangeFormat: $f145fa6d412a8ce0$var$timeRangeFormat,
    eventTimeRangeFormat: $f145fa6d412a8ce0$var$timeRangeFormat,
    eventTimeRangeStartFormat: $f145fa6d412a8ce0$var$timeRangeStartFormat,
    eventTimeRangeEndFormat: $f145fa6d412a8ce0$var$timeRangeEndFormat,
    timeGutterFormat: 'LT',
    monthHeaderFormat: 'MMMM YYYY',
    dayHeaderFormat: 'dddd MMM DD',
    dayRangeHeaderFormat: $f145fa6d412a8ce0$var$weekRangeFormat,
    agendaHeaderFormat: $f145fa6d412a8ce0$var$dateRangeFormat,
    agendaDateFormat: 'ddd MMM DD',
    agendaTimeFormat: 'LT',
    agendaTimeRangeFormat: $f145fa6d412a8ce0$var$timeRangeFormat
};
function $f145fa6d412a8ce0$var$fixUnit(unit) {
    var datePart = unit ? unit.toLowerCase() : unit;
    if (datePart === 'FullYear') datePart = 'year';
    else if (!datePart) datePart = undefined;
    return datePart;
}
function $f145fa6d412a8ce0$export$42f9cc272b1e62cd(dayjsLib) {
    // load dayjs plugins
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($559e71256bc2de9f$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($cfb78c20cf088101$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($66bbd4964f91cc0c$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($60ceee39fbfa7b0b$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($4ffe3ac414eccd26$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($22bc16777e706ced$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($35aece7ad906b57b$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($209ec42a43e4e1db$exports))));
    var locale = function locale(dj, c) {
        return c ? dj.locale(c) : dj;
    };
    // if the timezone plugin is loaded,
    // then use the timezone aware version
    var dayjs = dayjsLib.tz ? dayjsLib.tz : dayjsLib;
    function getTimezoneOffset(date) {
        // ensures this gets cast to timezone
        return dayjs(date).toDate().getTimezoneOffset();
    }
    function getDstOffset(start, end) {
        var _st$tz$$x$$timezone;
        // convert to dayjs, in case
        var st = dayjs(start);
        var ed = dayjs(end);
        // if not using the dayjs timezone plugin
        if (!dayjs.tz) return st.toDate().getTimezoneOffset() - ed.toDate().getTimezoneOffset();
        /**
     * If a default timezone has been applied, then
     * use this to get the proper timezone offset, otherwise default
     * the timezone to the browser local
     */ var tzName = (_st$tz$$x$$timezone = st.tz().$x.$timezone) !== null && _st$tz$$x$$timezone !== void 0 ? _st$tz$$x$$timezone : dayjsLib.tz.guess();
        // invert offsets to be inline with moment.js
        var startOffset = -dayjs.tz(+st, tzName).utcOffset();
        var endOffset = -dayjs.tz(+ed, tzName).utcOffset();
        return startOffset - endOffset;
    }
    function getDayStartDstOffset(start) {
        var dayStart = dayjs(start).startOf('day');
        return getDstOffset(dayStart, start);
    }
    /*** BEGIN localized date arithmetic methods with dayjs ***/ function defineComparators(a, b, unit) {
        var datePart = $f145fa6d412a8ce0$var$fixUnit(unit);
        var dtA = datePart ? dayjs(a).startOf(datePart) : dayjs(a);
        var dtB = datePart ? dayjs(b).startOf(datePart) : dayjs(b);
        return [
            dtA,
            dtB,
            datePart
        ];
    }
    function startOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $f145fa6d412a8ce0$var$fixUnit(unit);
        if (datePart) return dayjs(date).startOf(datePart).toDate();
        return dayjs(date).toDate();
    }
    function endOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $f145fa6d412a8ce0$var$fixUnit(unit);
        if (datePart) return dayjs(date).endOf(datePart).toDate();
        return dayjs(date).toDate();
    }
    // dayjs comparison operations *always* convert both sides to dayjs objects
    // prior to running the comparisons
    function eq(a, b, unit) {
        var _defineComparators = defineComparators(a, b, unit), _defineComparators2 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_defineComparators, 3), dtA = _defineComparators2[0], dtB = _defineComparators2[1], datePart = _defineComparators2[2];
        return dtA.isSame(dtB, datePart);
    }
    function neq(a, b, unit) {
        return !eq(a, b, unit);
    }
    function gt(a, b, unit) {
        var _defineComparators3 = defineComparators(a, b, unit), _defineComparators4 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_defineComparators3, 3), dtA = _defineComparators4[0], dtB = _defineComparators4[1], datePart = _defineComparators4[2];
        return dtA.isAfter(dtB, datePart);
    }
    function lt(a, b, unit) {
        var _defineComparators5 = defineComparators(a, b, unit), _defineComparators6 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_defineComparators5, 3), dtA = _defineComparators6[0], dtB = _defineComparators6[1], datePart = _defineComparators6[2];
        return dtA.isBefore(dtB, datePart);
    }
    function gte(a, b, unit) {
        var _defineComparators7 = defineComparators(a, b, unit), _defineComparators8 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_defineComparators7, 3), dtA = _defineComparators8[0], dtB = _defineComparators8[1], datePart = _defineComparators8[2];
        return dtA.isSameOrBefore(dtB, datePart);
    }
    function lte(a, b, unit) {
        var _defineComparators9 = defineComparators(a, b, unit), _defineComparators10 = (0, $ebff776814199019$export$2e2bcd8739ae039)(_defineComparators9, 3), dtA = _defineComparators10[0], dtB = _defineComparators10[1], datePart = _defineComparators10[2];
        return dtA.isSameOrBefore(dtB, datePart);
    }
    function inRange(day, min, max) {
        var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'day';
        var datePart = $f145fa6d412a8ce0$var$fixUnit(unit);
        var djDay = dayjs(day);
        var djMin = dayjs(min);
        var djMax = dayjs(max);
        return djDay.isBetween(djMin, djMax, datePart, '[]');
    }
    function min(dateA, dateB) {
        var dtA = dayjs(dateA);
        var dtB = dayjs(dateB);
        var minDt = dayjsLib.min(dtA, dtB);
        return minDt.toDate();
    }
    function max(dateA, dateB) {
        var dtA = dayjs(dateA);
        var dtB = dayjs(dateB);
        var maxDt = dayjsLib.max(dtA, dtB);
        return maxDt.toDate();
    }
    function merge(date, time) {
        if (!date && !time) return null;
        var tm = dayjs(time).format('HH:mm:ss');
        var dt = dayjs(date).startOf('day').format('MM/DD/YYYY');
        // We do it this way to avoid issues when timezone switching
        return dayjs("".concat(dt, " ").concat(tm)).toDate();
    }
    function add(date, adder, unit) {
        var datePart = $f145fa6d412a8ce0$var$fixUnit(unit);
        return dayjs(date).add(adder, datePart).toDate();
    }
    function range(start, end) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $f145fa6d412a8ce0$var$fixUnit(unit);
        // because the add method will put these in tz, we have to start that way
        var current = dayjs(start).toDate();
        var days = [];
        while(lte(current, end)){
            days.push(current);
            current = add(current, 1, datePart);
        }
        return days;
    }
    function ceil(date, unit) {
        var datePart = $f145fa6d412a8ce0$var$fixUnit(unit);
        var floor = startOf(date, datePart);
        return eq(floor, date) ? floor : add(floor, 1, datePart);
    }
    function diff(a, b) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $f145fa6d412a8ce0$var$fixUnit(unit);
        // don't use 'defineComparators' here, as we don't want to mutate the values
        var dtA = dayjs(a);
        var dtB = dayjs(b);
        return dtB.diff(dtA, datePart);
    }
    function minutes(date) {
        var dt = dayjs(date);
        return dt.minutes();
    }
    function firstOfWeek(culture) {
        var data = culture ? dayjsLib.localeData(culture) : dayjsLib.localeData();
        return data ? data.firstDayOfWeek() : 0;
    }
    function firstVisibleDay(date) {
        var firstDayOfMonth = dayjs(date).startOf('month');
        var firstDayOfWeek = dayjs(firstDayOfMonth).startOf('week');
        // special handling for leapyears until Dayjs patches it
        if (dayjs(firstDayOfMonth).isLeapYear()) {
            var day = firstDayOfMonth.toDate().getDay(), _diff = firstDayOfMonth.toDate().getDate() - day + (day == 0 ? -6 : 1);
            firstDayOfWeek.date(_diff);
        }
        return firstDayOfWeek.toDate();
    }
    function lastVisibleDay(date) {
        return dayjs(date).endOf('month').endOf('week').toDate();
    }
    function visibleDays(date) {
        var current = firstVisibleDay(date);
        var last = lastVisibleDay(date);
        var days = [];
        while(lte(current, last)){
            days.push(current);
            current = add(current, 1, 'd');
        }
        return days;
    }
    /*** END localized date arithmetic methods with dayjs ***/ /**
   * Moved from TimeSlots.js, this method overrides the method of the same name
   * in the localizer.js, using dayjs to construct the js Date
   * @param {Date} dt - date to start with
   * @param {Number} minutesFromMidnight
   * @param {Number} offset
   * @returns {Date}
   */ function getSlotDate(dt, minutesFromMidnight, offset) {
        return dayjs(dt).startOf('day').minute(minutesFromMidnight + offset).toDate();
    }
    // dayjs will automatically handle DST differences in it's calculations
    function getTotalMin(start, end) {
        return diff(start, end, 'minutes');
    }
    function getMinutesFromMidnight(start) {
        var dayStart = dayjs(start).startOf('day');
        var day = dayjs(start);
        return day.diff(dayStart, 'minutes') + getDayStartDstOffset(start);
    }
    // These two are used by DateSlotMetrics
    function continuesPrior(start, first) {
        var djStart = dayjs(start);
        var djFirst = dayjs(first);
        return djStart.isBefore(djFirst, 'day');
    }
    function continuesAfter(start, end, last) {
        var djEnd = dayjs(end);
        var djLast = dayjs(last);
        return djEnd.isSameOrAfter(djLast, 'minutes');
    }
    function daySpan(start, end) {
        var startDay = dayjs(start);
        var endDay = dayjs(end);
        return endDay.diff(startDay, 'day');
    }
    // These two are used by eventLevels
    function sortEvents(_ref6) {
        var _ref6$evtA = _ref6.evtA, aStart = _ref6$evtA.start, aEnd = _ref6$evtA.end, aAllDay = _ref6$evtA.allDay, _ref6$evtB = _ref6.evtB, bStart = _ref6$evtB.start, bEnd = _ref6$evtB.end, bAllDay = _ref6$evtB.allDay;
        var startSort = +startOf(aStart, 'day') - +startOf(bStart, 'day');
        var durA = daySpan(aStart, aEnd);
        var durB = daySpan(bStart, bEnd);
        return startSort || // sort by start Day first
        durB - durA || // events spanning multiple days go first
        !!bAllDay - !!aAllDay || // then allDay single day events
        +aStart - +bStart || // then sort by start time *don't need dayjs conversion here
        +aEnd - +bEnd // then sort by end time *don't need dayjs conversion here either
        ;
    }
    function inEventRange(_ref7) {
        var _ref7$event = _ref7.event, start = _ref7$event.start, end = _ref7$event.end, _ref7$range = _ref7.range, rangeStart = _ref7$range.start, rangeEnd = _ref7$range.end;
        var startOfDay = dayjs(start).startOf('day');
        var eEnd = dayjs(end);
        var rStart = dayjs(rangeStart);
        var rEnd = dayjs(rangeEnd);
        var startsBeforeEnd = startOfDay.isSameOrBefore(rEnd, 'day');
        // when the event is zero duration we need to handle a bit differently
        var sameMin = !startOfDay.isSame(eEnd, 'minutes');
        var endsAfterStart = sameMin ? eEnd.isAfter(rStart, 'minutes') : eEnd.isSameOrAfter(rStart, 'minutes');
        return startsBeforeEnd && endsAfterStart;
    }
    function isSameDate(date1, date2) {
        var dt = dayjs(date1);
        var dt2 = dayjs(date2);
        return dt.isSame(dt2, 'day');
    }
    /**
   * This method, called once in the localizer constructor, is used by eventLevels
   * 'eventSegments()' to assist in determining the 'span' of the event in the display,
   * specifically when using a timezone that is greater than the browser native timezone.
   * @returns number
   */ function browserTZOffset() {
        /**
     * Date.prototype.getTimezoneOffset horrifically flips the positive/negative from
     * what you see in it's string, so we have to jump through some hoops to get a value
     * we can actually compare.
     */ var dt = new Date();
        var neg = /-/.test(dt.toString()) ? '-' : '';
        var dtOffset = dt.getTimezoneOffset();
        var comparator = Number("".concat(neg).concat(Math.abs(dtOffset)));
        // dayjs correctly provides positive/negative offset, as expected
        var mtOffset = dayjs().utcOffset();
        return mtOffset > comparator ? 1 : 0;
    }
    return new $f145fa6d412a8ce0$export$193ddab16544ff5b({
        formats: $f145fa6d412a8ce0$var$formats,
        firstOfWeek: firstOfWeek,
        firstVisibleDay: firstVisibleDay,
        lastVisibleDay: lastVisibleDay,
        visibleDays: visibleDays,
        format: function format(value, _format, culture) {
            return locale(dayjs(value), culture).format(_format);
        },
        lt: lt,
        lte: lte,
        gt: gt,
        gte: gte,
        eq: eq,
        neq: neq,
        merge: merge,
        inRange: inRange,
        startOf: startOf,
        endOf: endOf,
        range: range,
        add: add,
        diff: diff,
        ceil: ceil,
        min: min,
        max: max,
        minutes: minutes,
        getSlotDate: getSlotDate,
        getTimezoneOffset: getTimezoneOffset,
        getDstOffset: getDstOffset,
        getTotalMin: getTotalMin,
        getMinutesFromMidnight: getMinutesFromMidnight,
        continuesPrior: continuesPrior,
        continuesAfter: continuesAfter,
        sortEvents: sortEvents,
        inEventRange: inEventRange,
        isSameDate: isSameDate,
        browserTZOffset: browserTZOffset
    });
}
var $f145fa6d412a8ce0$export$9b5ac10f59f76296 = {
    eventWrapper: $f145fa6d412a8ce0$var$NoopWrapper,
    timeSlotWrapper: $f145fa6d412a8ce0$var$NoopWrapper,
    dateCellWrapper: $f145fa6d412a8ce0$var$NoopWrapper
};



function $a564fd7a14298f13$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}


function $fba7816475aee1cd$export$2e2bcd8739ae039(value) {
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $c3a904dfa5a64ea0$export$2e2bcd8739ae039)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}




function $6526d60635038ea1$export$2e2bcd8739ae039(argument) {
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $c3a904dfa5a64ea0$export$2e2bcd8739ae039)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $2fbb8c323430abd0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $fba7816475aee1cd$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $6526d60635038ea1$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $df6acc0d794a1a2a$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $c2ff3331b7baba1a$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $6526d60635038ea1$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $df6acc0d794a1a2a$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $f5a7cbda4c6fdf30$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $df6acc0d794a1a2a$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $c2ff3331b7baba1a$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $2a02947a93a3da38$var$MILLISECONDS_IN_DAY = 86400000;
function $2a02947a93a3da38$export$2e2bcd8739ae039(dirtyDate) {
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6526d60635038ea1$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $2a02947a93a3da38$var$MILLISECONDS_IN_DAY) + 1;
}





function $dd62d86ef354c390$export$2e2bcd8739ae039(dirtyDate) {
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $6526d60635038ea1$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $3116d13f2231c96e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6526d60635038ea1$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $dd62d86ef354c390$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $dd62d86ef354c390$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $d22a85247e2ad110$export$2e2bcd8739ae039(dirtyDate) {
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $3116d13f2231c96e$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $dd62d86ef354c390$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $78e9b190086ecda7$var$MILLISECONDS_IN_WEEK = 604800000;
function $78e9b190086ecda7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6526d60635038ea1$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $dd62d86ef354c390$export$2e2bcd8739ae039)(date).getTime() - (0, $d22a85247e2ad110$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $78e9b190086ecda7$var$MILLISECONDS_IN_WEEK) + 1;
}







var $4afd0dd7a75f7813$var$defaultOptions = {};
function $4afd0dd7a75f7813$export$430a3269e24b912e() {
    return $4afd0dd7a75f7813$var$defaultOptions;
}
function $4afd0dd7a75f7813$export$95365be1b0704abc(newOptions) {
    $4afd0dd7a75f7813$var$defaultOptions = newOptions;
}


function $829de591b0ea1f90$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $4afd0dd7a75f7813$export$430a3269e24b912e)();
    var weekStartsOn = (0, $df6acc0d794a1a2a$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $6526d60635038ea1$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $a4ed963852df01f4$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6526d60635038ea1$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $4afd0dd7a75f7813$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $df6acc0d794a1a2a$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $829de591b0ea1f90$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $829de591b0ea1f90$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $7dee36b224e60d30$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $4afd0dd7a75f7813$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $df6acc0d794a1a2a$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $a4ed963852df01f4$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $829de591b0ea1f90$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $66ebd184715d8baa$var$MILLISECONDS_IN_WEEK = 604800000;
function $66ebd184715d8baa$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6526d60635038ea1$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $829de591b0ea1f90$export$2e2bcd8739ae039)(date, options).getTime() - (0, $7dee36b224e60d30$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $66ebd184715d8baa$var$MILLISECONDS_IN_WEEK) + 1;
}



function $e1b362b92d61222c$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $9df9a4847a6ffdde$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $9df9a4847a6ffdde$export$2e2bcd8739ae039 = $9df9a4847a6ffdde$var$formatters;


var $a52afd2e09204e0d$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $a52afd2e09204e0d$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $9df9a4847a6ffdde$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $a4ed963852df01f4$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $3116d13f2231c96e$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $9df9a4847a6ffdde$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $66ebd184715d8baa$export$2e2bcd8739ae039)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $78e9b190086ecda7$export$2e2bcd8739ae039)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $9df9a4847a6ffdde$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $2a02947a93a3da38$export$2e2bcd8739ae039)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $a52afd2e09204e0d$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $a52afd2e09204e0d$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $a52afd2e09204e0d$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $a52afd2e09204e0d$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $a52afd2e09204e0d$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $a52afd2e09204e0d$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $9df9a4847a6ffdde$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $9df9a4847a6ffdde$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $9df9a4847a6ffdde$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $9df9a4847a6ffdde$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $9df9a4847a6ffdde$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $a52afd2e09204e0d$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $a52afd2e09204e0d$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $a52afd2e09204e0d$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $a52afd2e09204e0d$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $a52afd2e09204e0d$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $a52afd2e09204e0d$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $a52afd2e09204e0d$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $a52afd2e09204e0d$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $a52afd2e09204e0d$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $a52afd2e09204e0d$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $a52afd2e09204e0d$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(minutes, 2);
}
function $a52afd2e09204e0d$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $a52afd2e09204e0d$var$formatTimezone(offset, dirtyDelimiter);
}
function $a52afd2e09204e0d$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $e1b362b92d61222c$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $a52afd2e09204e0d$export$2e2bcd8739ae039 = $a52afd2e09204e0d$var$formatters;


var $6a256e9165ab693c$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $6a256e9165ab693c$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $6a256e9165ab693c$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $6a256e9165ab693c$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $6a256e9165ab693c$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $6a256e9165ab693c$var$timeLongFormatter(timePattern, formatLong));
};
var $6a256e9165ab693c$var$longFormatters = {
    p: $6a256e9165ab693c$var$timeLongFormatter,
    P: $6a256e9165ab693c$var$dateTimeLongFormatter
};
var $6a256e9165ab693c$export$2e2bcd8739ae039 = $6a256e9165ab693c$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $2a44756760880c80$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $40554194d3fe763b$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $40554194d3fe763b$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $40554194d3fe763b$export$c6cc36aa33304772(token) {
    return $40554194d3fe763b$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $40554194d3fe763b$export$c6b49d6dceb604a1(token) {
    return $40554194d3fe763b$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $40554194d3fe763b$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $2e3f228926fe4f38$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $2e3f228926fe4f38$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $2e3f228926fe4f38$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $2e3f228926fe4f38$export$2e2bcd8739ae039 = $2e3f228926fe4f38$var$formatDistance;


function $83acb485c090f8f4$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $41f0f21ebb8b25fa$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $41f0f21ebb8b25fa$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $41f0f21ebb8b25fa$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $41f0f21ebb8b25fa$var$formatLong = {
    date: (0, $83acb485c090f8f4$export$2e2bcd8739ae039)({
        formats: $41f0f21ebb8b25fa$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $83acb485c090f8f4$export$2e2bcd8739ae039)({
        formats: $41f0f21ebb8b25fa$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $83acb485c090f8f4$export$2e2bcd8739ae039)({
        formats: $41f0f21ebb8b25fa$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $41f0f21ebb8b25fa$export$2e2bcd8739ae039 = $41f0f21ebb8b25fa$var$formatLong;


var $9c8fac08d475eea3$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $9c8fac08d475eea3$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9c8fac08d475eea3$var$formatRelativeLocale[token];
};
var $9c8fac08d475eea3$export$2e2bcd8739ae039 = $9c8fac08d475eea3$var$formatRelative;


function $cedd0a9200573643$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $aa9eba125cdd2229$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $aa9eba125cdd2229$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $aa9eba125cdd2229$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $aa9eba125cdd2229$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $aa9eba125cdd2229$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $aa9eba125cdd2229$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $aa9eba125cdd2229$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $aa9eba125cdd2229$var$localize = {
    ordinalNumber: $aa9eba125cdd2229$var$ordinalNumber,
    era: (0, $cedd0a9200573643$export$2e2bcd8739ae039)({
        values: $aa9eba125cdd2229$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $cedd0a9200573643$export$2e2bcd8739ae039)({
        values: $aa9eba125cdd2229$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $cedd0a9200573643$export$2e2bcd8739ae039)({
        values: $aa9eba125cdd2229$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $cedd0a9200573643$export$2e2bcd8739ae039)({
        values: $aa9eba125cdd2229$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $cedd0a9200573643$export$2e2bcd8739ae039)({
        values: $aa9eba125cdd2229$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $aa9eba125cdd2229$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $aa9eba125cdd2229$export$2e2bcd8739ae039 = $aa9eba125cdd2229$var$localize;


function $9f559e4a5f4f090c$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $9f559e4a5f4f090c$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $9f559e4a5f4f090c$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $9f559e4a5f4f090c$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $9f559e4a5f4f090c$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $f329ee458babf09f$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $0de4354753a35202$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $0de4354753a35202$var$parseOrdinalNumberPattern = /\d+/i;
var $0de4354753a35202$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $0de4354753a35202$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $0de4354753a35202$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $0de4354753a35202$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0de4354753a35202$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $0de4354753a35202$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $0de4354753a35202$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $0de4354753a35202$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $0de4354753a35202$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $0de4354753a35202$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $0de4354753a35202$var$match = {
    ordinalNumber: (0, $f329ee458babf09f$export$2e2bcd8739ae039)({
        matchPattern: $0de4354753a35202$var$matchOrdinalNumberPattern,
        parsePattern: $0de4354753a35202$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9f559e4a5f4f090c$export$2e2bcd8739ae039)({
        matchPatterns: $0de4354753a35202$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0de4354753a35202$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $9f559e4a5f4f090c$export$2e2bcd8739ae039)({
        matchPatterns: $0de4354753a35202$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0de4354753a35202$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9f559e4a5f4f090c$export$2e2bcd8739ae039)({
        matchPatterns: $0de4354753a35202$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0de4354753a35202$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $9f559e4a5f4f090c$export$2e2bcd8739ae039)({
        matchPatterns: $0de4354753a35202$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0de4354753a35202$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $9f559e4a5f4f090c$export$2e2bcd8739ae039)({
        matchPatterns: $0de4354753a35202$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $0de4354753a35202$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0de4354753a35202$export$2e2bcd8739ae039 = $0de4354753a35202$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $1db029a71357c34e$var$locale = {
    code: 'en-US',
    formatDistance: (0, $2e3f228926fe4f38$export$2e2bcd8739ae039),
    formatLong: (0, $41f0f21ebb8b25fa$export$2e2bcd8739ae039),
    formatRelative: (0, $9c8fac08d475eea3$export$2e2bcd8739ae039),
    localize: (0, $aa9eba125cdd2229$export$2e2bcd8739ae039),
    match: (0, $0de4354753a35202$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $1db029a71357c34e$export$2e2bcd8739ae039 = $1db029a71357c34e$var$locale;


var $a6796ef0435bd087$export$2e2bcd8739ae039 = (0, $1db029a71357c34e$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $97c33a3e713864b7$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $97c33a3e713864b7$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $97c33a3e713864b7$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $97c33a3e713864b7$var$doubleQuoteRegExp = /''/g;
var $97c33a3e713864b7$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $97c33a3e713864b7$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $4afd0dd7a75f7813$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $a6796ef0435bd087$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $df6acc0d794a1a2a$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $df6acc0d794a1a2a$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $6526d60635038ea1$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $2fbb8c323430abd0$export$2e2bcd8739ae039)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $2a44756760880c80$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $f5a7cbda4c6fdf30$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($97c33a3e713864b7$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $6a256e9165ab693c$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($97c33a3e713864b7$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $97c33a3e713864b7$var$cleanEscapedString(substring);
        var formatter = (0, $a52afd2e09204e0d$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $40554194d3fe763b$export$c6b49d6dceb604a1)(substring)) (0, $40554194d3fe763b$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $40554194d3fe763b$export$c6cc36aa33304772)(substring)) (0, $40554194d3fe763b$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($97c33a3e713864b7$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $97c33a3e713864b7$var$cleanEscapedString(input) {
    var matched = input.match($97c33a3e713864b7$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($97c33a3e713864b7$var$doubleQuoteRegExp, "'");
}




function $5d716443340dbadf$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $2a435729188bd903$export$2e2bcd8739ae039)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}





function $8d6367b198794a6b$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}













var $2b702420d16a3107$var$TIMEZONE_UNIT_PRIORITY = 10;
var $2b702420d16a3107$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, Setter);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)(this, "subPriority", 0);
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $2b702420d16a3107$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(ValueSetter, _Setter);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($2b702420d16a3107$export$81d53e3678089a6);
var $2b702420d16a3107$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this2), "priority", $2b702420d16a3107$var$TIMEZONE_UNIT_PRIORITY);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($2b702420d16a3107$export$81d53e3678089a6);












var $3300bd3c53cdebfa$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, Parser);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)(this, "incompatibleTokens", void 0);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)(this, "subPriority", void 0);
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $2b702420d16a3107$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();


var $8f954b499a788f39$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(EraParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(EraParser);
    function EraParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 140);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));









/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $ff9f47fda6bf34a6$export$dfd9b671c89acc8e = 7;
var $ff9f47fda6bf34a6$export$3913210603d8e9ae = 365.2425;
var $ff9f47fda6bf34a6$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $ff9f47fda6bf34a6$export$91246f0b9bd9beff = 60000;
var $ff9f47fda6bf34a6$export$7f72910d6dfd237a = 3600000;
var $ff9f47fda6bf34a6$export$397c2d5776aa9055 = 1000;
var $ff9f47fda6bf34a6$export$4dec998e48f9c246 = -$ff9f47fda6bf34a6$export$81caae6e1cc7a622;
var $ff9f47fda6bf34a6$export$f2f5ae5a8e2d8f9f = 60;
var $ff9f47fda6bf34a6$export$3c58128db900d44e = 3;
var $ff9f47fda6bf34a6$export$80d7e435f744f319 = 12;
var $ff9f47fda6bf34a6$export$4db7641526e3241f = 4;
var $ff9f47fda6bf34a6$export$698aec755e92c695 = 3600;
var $ff9f47fda6bf34a6$export$a77c1a7ebebe2a5a = 60;
var $ff9f47fda6bf34a6$export$815a9362476d2fe3 = $ff9f47fda6bf34a6$export$698aec755e92c695 * 24;
var $ff9f47fda6bf34a6$export$34804a017b31e2fe = $ff9f47fda6bf34a6$export$815a9362476d2fe3 * 7;
var $ff9f47fda6bf34a6$export$7271e9e3478110d1 = $ff9f47fda6bf34a6$export$815a9362476d2fe3 * $ff9f47fda6bf34a6$export$3913210603d8e9ae;
var $ff9f47fda6bf34a6$export$8e6600bbdee7dabb = $ff9f47fda6bf34a6$export$7271e9e3478110d1 / 12;
var $ff9f47fda6bf34a6$export$be1dccf2de902d31 = $ff9f47fda6bf34a6$export$8e6600bbdee7dabb * 3;


var $3e81caac65858bdf$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $3e81caac65858bdf$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $b8614ad077e7ede2$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $b8614ad077e7ede2$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $b8614ad077e7ede2$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $ff9f47fda6bf34a6$export$7f72910d6dfd237a) + minutes * (0, $ff9f47fda6bf34a6$export$91246f0b9bd9beff) + seconds * (0, $ff9f47fda6bf34a6$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $b8614ad077e7ede2$export$d931c43c4608a164(dateString) {
    return $b8614ad077e7ede2$export$cc7cc9e2a3ff9388((0, $3e81caac65858bdf$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $b8614ad077e7ede2$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $b8614ad077e7ede2$export$cc7cc9e2a3ff9388((0, $3e81caac65858bdf$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $b8614ad077e7ede2$export$cc7cc9e2a3ff9388((0, $3e81caac65858bdf$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $b8614ad077e7ede2$export$cc7cc9e2a3ff9388((0, $3e81caac65858bdf$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $b8614ad077e7ede2$export$cc7cc9e2a3ff9388((0, $3e81caac65858bdf$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $b8614ad077e7ede2$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $b8614ad077e7ede2$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $b8614ad077e7ede2$export$cc7cc9e2a3ff9388((0, $3e81caac65858bdf$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $b8614ad077e7ede2$export$cc7cc9e2a3ff9388((0, $3e81caac65858bdf$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $b8614ad077e7ede2$export$cc7cc9e2a3ff9388((0, $3e81caac65858bdf$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $b8614ad077e7ede2$export$cc7cc9e2a3ff9388((0, $3e81caac65858bdf$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $b8614ad077e7ede2$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $b8614ad077e7ede2$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $b8614ad077e7ede2$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $b8614ad077e7ede2$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


var $037ff7fb02c7505b$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(YearParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(YearParser);
    function YearParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)((0, $b8614ad077e7ede2$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)((0, $b8614ad077e7ede2$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $b8614ad077e7ede2$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));












var $e5d35c40ae2867b6$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(LocalWeekYearParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)((0, $b8614ad077e7ede2$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)((0, $b8614ad077e7ede2$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $a4ed963852df01f4$export$2e2bcd8739ae039)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $b8614ad077e7ede2$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $829de591b0ea1f90$export$2e2bcd8739ae039)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $829de591b0ea1f90$export$2e2bcd8739ae039)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));











var $e7e03b5a516d4622$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(ISOWeekYearParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $b8614ad077e7ede2$export$2c9307b2e29c533c)(4, dateString);
                return (0, $b8614ad077e7ede2$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $dd62d86ef354c390$export$2e2bcd8739ae039)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));










var $e2e35b7e77304f66$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(ExtendedYearParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $b8614ad077e7ede2$export$2c9307b2e29c533c)(4, dateString);
                return (0, $b8614ad077e7ede2$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));










var $01e80bae5205f629$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(QuarterParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $b8614ad077e7ede2$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));










var $afe8e0c6393669f2$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(StandAloneQuarterParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $b8614ad077e7ede2$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));











var $dc458dc70513da04$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(MonthParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 110);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)((0, $b8614ad077e7ede2$export$cc7cc9e2a3ff9388)((0, $3e81caac65858bdf$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)((0, $b8614ad077e7ede2$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));











var $71a78dd23233f65e$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(StandAloneMonthParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 110);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)((0, $b8614ad077e7ede2$export$cc7cc9e2a3ff9388)((0, $3e81caac65858bdf$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)((0, $b8614ad077e7ede2$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));















function $5464923eeaa33554$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $6526d60635038ea1$export$2e2bcd8739ae039)(dirtyDate);
    var week = (0, $df6acc0d794a1a2a$export$2e2bcd8739ae039)(dirtyWeek);
    var diff = (0, $66ebd184715d8baa$export$2e2bcd8739ae039)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $ad0ee8436986ee80$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(LocalWeekParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $b8614ad077e7ede2$export$cc7cc9e2a3ff9388)((0, $3e81caac65858bdf$export$c123ee06d9da8480).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $b8614ad077e7ede2$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $829de591b0ea1f90$export$2e2bcd8739ae039)((0, $5464923eeaa33554$export$2e2bcd8739ae039)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));















function $240c457c4b417d59$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $6526d60635038ea1$export$2e2bcd8739ae039)(dirtyDate);
    var isoWeek = (0, $df6acc0d794a1a2a$export$2e2bcd8739ae039)(dirtyISOWeek);
    var diff = (0, $78e9b190086ecda7$export$2e2bcd8739ae039)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $27cb5c0d6a1b0e9e$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(ISOWeekParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $b8614ad077e7ede2$export$cc7cc9e2a3ff9388)((0, $3e81caac65858bdf$export$c123ee06d9da8480).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $b8614ad077e7ede2$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $dd62d86ef354c390$export$2e2bcd8739ae039)((0, $240c457c4b417d59$export$2e2bcd8739ae039)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));











var $ba31889ded537c45$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $ba31889ded537c45$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $ba31889ded537c45$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(DateParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(DateParser);
    function DateParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "subPriority", 1);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $b8614ad077e7ede2$export$cc7cc9e2a3ff9388)((0, $3e81caac65858bdf$export$c123ee06d9da8480).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $b8614ad077e7ede2$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $b8614ad077e7ede2$export$3d50627710b84d75)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $ba31889ded537c45$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $ba31889ded537c45$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));











var $80047586c6b23170$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(DayOfYearParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "subpriority", 1);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $b8614ad077e7ede2$export$cc7cc9e2a3ff9388)((0, $3e81caac65858bdf$export$c123ee06d9da8480).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $b8614ad077e7ede2$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $b8614ad077e7ede2$export$3d50627710b84d75)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));













function $9ec0dec372114c11$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $4afd0dd7a75f7813$export$430a3269e24b912e)();
    var weekStartsOn = (0, $df6acc0d794a1a2a$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $6526d60635038ea1$export$2e2bcd8739ae039)(dirtyDate);
    var day = (0, $df6acc0d794a1a2a$export$2e2bcd8739ae039)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $cefec6ebafc97268$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(DayParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(DayParser);
    function DayParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $9ec0dec372114c11$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));











var $1519080921a2c824$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(LocalDayParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)((0, $b8614ad077e7ede2$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $9ec0dec372114c11$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));











var $43c4dd787f485005$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)((0, $b8614ad077e7ede2$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $9ec0dec372114c11$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));













function $245bb28c153ed34e$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(2, arguments);
    var day = (0, $df6acc0d794a1a2a$export$2e2bcd8739ae039)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $6526d60635038ea1$export$2e2bcd8739ae039)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $ab33fdb53f7c17a8$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(ISODayParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $b8614ad077e7ede2$export$513bb01536146ab6)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $245bb28c153ed34e$export$2e2bcd8739ae039)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));










var $d4e1f2ca267c7120$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(AMPMParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $b8614ad077e7ede2$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));










var $5e9fa4be8b9ecd91$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(AMPMMidnightParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $b8614ad077e7ede2$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));










var $d2c81c55f607a8b6$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(DayPeriodParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $b8614ad077e7ede2$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));











var $31eac1743a4dd1d9$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(Hour1to12Parser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $b8614ad077e7ede2$export$cc7cc9e2a3ff9388)((0, $3e81caac65858bdf$export$c123ee06d9da8480).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $b8614ad077e7ede2$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));











var $b2d974ccaa931ee4$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(Hour0to23Parser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $b8614ad077e7ede2$export$cc7cc9e2a3ff9388)((0, $3e81caac65858bdf$export$c123ee06d9da8480).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $b8614ad077e7ede2$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));











var $40adf5ec489fa8b1$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(Hour0To11Parser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $b8614ad077e7ede2$export$cc7cc9e2a3ff9388)((0, $3e81caac65858bdf$export$c123ee06d9da8480).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $b8614ad077e7ede2$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));











var $32f2b406cddea0fe$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(Hour1To24Parser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $b8614ad077e7ede2$export$cc7cc9e2a3ff9388)((0, $3e81caac65858bdf$export$c123ee06d9da8480).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $b8614ad077e7ede2$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));











var $1d63c09d7c2e8584$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(MinuteParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 60);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $b8614ad077e7ede2$export$cc7cc9e2a3ff9388)((0, $3e81caac65858bdf$export$c123ee06d9da8480).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $b8614ad077e7ede2$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));











var $0d0d1755be4bf92f$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(SecondParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 50);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $b8614ad077e7ede2$export$cc7cc9e2a3ff9388)((0, $3e81caac65858bdf$export$c123ee06d9da8480).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $b8614ad077e7ede2$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));










var $ecce5bab0c36098f$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(FractionOfSecondParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 30);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $b8614ad077e7ede2$export$4f84e3a82c7b538)((0, $b8614ad077e7ede2$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));











var $c4277042e4b4edf5$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $b8614ad077e7ede2$export$6497f4c0ecdfba8e)((0, $3e81caac65858bdf$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $b8614ad077e7ede2$export$6497f4c0ecdfba8e)((0, $3e81caac65858bdf$export$a7ee192b982af9c1).basic, dateString);
                    case 'XXXX':
                        return (0, $b8614ad077e7ede2$export$6497f4c0ecdfba8e)((0, $3e81caac65858bdf$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $b8614ad077e7ede2$export$6497f4c0ecdfba8e)((0, $3e81caac65858bdf$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $b8614ad077e7ede2$export$6497f4c0ecdfba8e)((0, $3e81caac65858bdf$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));











var $28058b9698f987f4$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(ISOTimezoneParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $b8614ad077e7ede2$export$6497f4c0ecdfba8e)((0, $3e81caac65858bdf$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $b8614ad077e7ede2$export$6497f4c0ecdfba8e)((0, $3e81caac65858bdf$export$a7ee192b982af9c1).basic, dateString);
                    case 'xxxx':
                        return (0, $b8614ad077e7ede2$export$6497f4c0ecdfba8e)((0, $3e81caac65858bdf$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $b8614ad077e7ede2$export$6497f4c0ecdfba8e)((0, $3e81caac65858bdf$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $b8614ad077e7ede2$export$6497f4c0ecdfba8e)((0, $3e81caac65858bdf$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));










var $d76f53c7f7b9c58a$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(TimestampSecondsParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 40);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $b8614ad077e7ede2$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));










var $f18105aba917258c$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $b6146753adbeade6$export$2e2bcd8739ae039)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $3147102548c82f4d$export$2e2bcd8739ae039)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $1b593a0d9ece4e71$export$2e2bcd8739ae039)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "priority", 20);
        (0, $6a740e003744eccd$export$2e2bcd8739ae039)((0, $4c76512358ba4f48$export$2e2bcd8739ae039)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $3cc3752fa56847ba$export$2e2bcd8739ae039)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $b8614ad077e7ede2$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $3300bd3c53cdebfa$export$7acfa6ed01010e37));


var $b13695130162242d$export$19131010e7fd8373 = {
    G: new (0, $8f954b499a788f39$export$8e5a1d3f85a9688)(),
    y: new (0, $037ff7fb02c7505b$export$48d352de7cd4a988)(),
    Y: new (0, $e5d35c40ae2867b6$export$b8ef38dfcf05d5db)(),
    R: new (0, $e7e03b5a516d4622$export$951d1df011fde06f)(),
    u: new (0, $e2e35b7e77304f66$export$bad9d2ea38e8f1a)(),
    Q: new (0, $01e80bae5205f629$export$5cb0f701186dde1d)(),
    q: new (0, $afe8e0c6393669f2$export$300c0c2990e20e6d)(),
    M: new (0, $dc458dc70513da04$export$400dd8b40ef138a3)(),
    L: new (0, $71a78dd23233f65e$export$1d7eaa53eaa5deba)(),
    w: new (0, $ad0ee8436986ee80$export$c4005ffc174e07c0)(),
    I: new (0, $27cb5c0d6a1b0e9e$export$6fc8dbedd560a6af)(),
    d: new (0, $ba31889ded537c45$export$e8d4b28a20981dd2)(),
    D: new (0, $80047586c6b23170$export$6cfe0d613455f615)(),
    E: new (0, $cefec6ebafc97268$export$1b03c8b76262f7bd)(),
    e: new (0, $1519080921a2c824$export$44d1c127ab42c480)(),
    c: new (0, $43c4dd787f485005$export$e447a647caaaec1d)(),
    i: new (0, $ab33fdb53f7c17a8$export$693fb1e525095b2a)(),
    a: new (0, $d4e1f2ca267c7120$export$8d1e08492351df91)(),
    b: new (0, $5e9fa4be8b9ecd91$export$73ca2bd0a17d273)(),
    B: new (0, $d2c81c55f607a8b6$export$bb9212adf05373db)(),
    h: new (0, $31eac1743a4dd1d9$export$8a04050a727a1756)(),
    H: new (0, $b2d974ccaa931ee4$export$e56f4dea2c3e56dd)(),
    K: new (0, $40adf5ec489fa8b1$export$cbbe855312f87d77)(),
    k: new (0, $32f2b406cddea0fe$export$6008046d2b34b6a5)(),
    m: new (0, $1d63c09d7c2e8584$export$2b52670d9e2be53)(),
    s: new (0, $0d0d1755be4bf92f$export$94d46d540cf1366a)(),
    S: new (0, $ecce5bab0c36098f$export$b8e6f8b2d70893b1)(),
    X: new (0, $c4277042e4b4edf5$export$104d901d49fea29b)(),
    x: new (0, $28058b9698f987f4$export$12910e5204b52b9)(),
    t: new (0, $d76f53c7f7b9c58a$export$2cd8bf877a05e96)(),
    T: new (0, $f18105aba917258c$export$6d8f69c6906d6368)()
};



// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $88d93c5832804e62$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $88d93c5832804e62$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $88d93c5832804e62$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $88d93c5832804e62$var$doubleQuoteRegExp = /''/g;
var $88d93c5832804e62$var$notWhitespaceRegExp = /\S/;
var $88d93c5832804e62$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $88d93c5832804e62$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $4afd0dd7a75f7813$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $a6796ef0435bd087$export$2e2bcd8739ae039);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $df6acc0d794a1a2a$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $df6acc0d794a1a2a$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $6526d60635038ea1$export$2e2bcd8739ae039)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $2b702420d16a3107$export$5aaf7ff7f09ea4ee)()
    ];
    var tokens = formatString.match($88d93c5832804e62$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $6a256e9165ab693c$export$2e2bcd8739ae039)) {
            var longFormatter = (0, $6a256e9165ab693c$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($88d93c5832804e62$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $5d716443340dbadf$export$2e2bcd8739ae039)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $40554194d3fe763b$export$c6b49d6dceb604a1)(token)) (0, $40554194d3fe763b$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $40554194d3fe763b$export$c6cc36aa33304772)(token)) (0, $40554194d3fe763b$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $b13695130162242d$export$19131010e7fd8373)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($88d93c5832804e62$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $88d93c5832804e62$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $c3a904dfa5a64ea0$export$2e2bcd8739ae039)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $88d93c5832804e62$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $6526d60635038ea1$export$2e2bcd8739ae039)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $f5a7cbda4c6fdf30$export$2e2bcd8739ae039)(date, (0, $2a44756760880c80$export$2e2bcd8739ae039)(date));
    var flags = {};
    var _iterator2 = (0, $5d716443340dbadf$export$2e2bcd8739ae039)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $8d6367b198794a6b$export$2e2bcd8739ae039)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $88d93c5832804e62$var$cleanEscapedString(input) {
    return input.match($88d93c5832804e62$var$escapedStringRegExp)[1].replace($88d93c5832804e62$var$doubleQuoteRegExp, "'");
}






function $f65cf8485e1e6348$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $4afd0dd7a75f7813$export$430a3269e24b912e)();
    var weekStartsOn = (0, $df6acc0d794a1a2a$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $6526d60635038ea1$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}




function $2288f74c78a6f0a7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $a564fd7a14298f13$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6526d60635038ea1$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    return day;
}











const $7a6c46ab34a6f39b$export$9eb9467136ef56ff = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	padding-top: 1rem;
`;
const $7a6c46ab34a6f39b$export$e19cd5f9376f8cee = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $e3f57e4b1ea630bd$export$b0d92dbee9b5b60d))`
	text-decoration: none;
	color: ${({ theme: theme })=>theme.colors.primary};
	line-height: 40px;
	padding-right: 20px;
`;
const $7a6c46ab34a6f39b$export$51485461e6c971ae = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).a`
	text-decoration: none;
	cursor: pointer;
	color: ${({ theme: theme })=>theme.colors.primary};
	line-height: 40px;
	padding-right: 20px;
`;
const $7a6c46ab34a6f39b$export$92a576f896a9bf72 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).form`
	border: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	padding: 20px;
	margin-top: 20px;
	width: 260px;
	h3 {
		margin-bottom: 15px;
		font-weight: 500;
		font-size: 16px;
	}
`;
const $7a6c46ab34a6f39b$export$2f96f6f204f87534 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	align-items: center;
	padding: 5px 0px;
	cursor: pointer;
`;
const $7a6c46ab34a6f39b$export$290bf4a64a511fa6 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).label`
	font-size: 13px;
	padding-left: 5px;
	cursor: pointer;
`;
const $7a6c46ab34a6f39b$export$5fda1783bb83f57b = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $ed1df0e8c76ac51f$export$ad40adb82edd461d))`
	height: 1rem;
	width: 1rem;
`;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");

function $bb50aee31402fbe6$var$Filter(props) {
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $7a6c46ab34a6f39b$export$2f96f6f204f87534), {
        onClick: props.toggle,
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                style: {
                    height: '1rem',
                    width: '1rem',
                    backgroundColor: props.toggled ? props.color : 'white',
                    display: 'inline-block',
                    border: '1px solid #ccc'
                }
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $7a6c46ab34a6f39b$export$290bf4a64a511fa6), {
                children: props.title
            })
        ]
    });
}
var $bb50aee31402fbe6$export$2e2bcd8739ae039 = $bb50aee31402fbe6$var$Filter;



var $jIrNf = parcelRequire("jIrNf");
const $965c163f78c932d5$export$e1f75a2fa907d754 = {
    NIBBI_EVENT: {
        label: 'Nibbi Event',
        color: '#bd5f28'
    },
    BIRTHDAY: {
        label: 'Birthday',
        color: '#0a079e'
    },
    INDUSTRY_EVENT: {
        label: 'Industry Event',
        color: '#19b747'
    },
    TRAINING: {
        label: 'Training',
        color: '#ffb745'
    },
    PTO: {
        label: 'PTO',
        color: '#916fcc'
    },
    HOLIDAY: {
        label: 'Holiday',
        color: '#e21717'
    },
    OAKLAND_OFFICE: {
        label: 'Oakland Office',
        color: '#f8a91c'
    }
};



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");

var $489wz = parcelRequire("489wz");





var $98bb7dc7fcb134dc$exports = {};
!function(t, e) {
    $98bb7dc7fcb134dc$exports = e();
}($98bb7dc7fcb134dc$exports, function() {
    "use strict";
    var t = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    }, e = {};
    return function(n, i, o) {
        var r, a = function(t, n, i) {
            void 0 === i && (i = {});
            var o = new Date(t), r = function(t, n) {
                void 0 === n && (n = {});
                var i = n.timeZoneName || "short", o = t + "|" + i, r = e[o];
                return r || (r = new Intl.DateTimeFormat("en-US", {
                    hour12: !1,
                    timeZone: t,
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    timeZoneName: i
                }), e[o] = r), r;
            }(n, i);
            return r.formatToParts(o);
        }, u = function(e, n) {
            for(var i = a(e, n), r = [], u = 0; u < i.length; u += 1){
                var f = i[u], s = f.type, m = f.value, c = t[s];
                c >= 0 && (r[c] = parseInt(m, 10));
            }
            var d = r[3], l = 24 === d ? 0 : d, h = r[0] + "-" + r[1] + "-" + r[2] + " " + l + ":" + r[4] + ":" + r[5] + ":000", v = +e;
            return (o.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
        }, f = i.prototype;
        f.tz = function(t, e) {
            void 0 === t && (t = r);
            var n, i = this.utcOffset(), a = this.toDate(), u = a.toLocaleString("en-US", {
                timeZone: t
            }), f = Math.round((a - new Date(u)) / 1e3 / 60), s = 15 * -Math.round(a.getTimezoneOffset() / 15) - f;
            if (!Number(s)) n = this.utcOffset(0, e);
            else if (n = o(u, {
                locale: this.$L
            }).$set("millisecond", this.$ms).utcOffset(s, !0), e) {
                var m = n.utcOffset();
                n = n.add(i - m, "minute");
            }
            return n.$x.$timezone = t, n;
        }, f.offsetName = function(t) {
            var e = this.$x.$timezone || o.tz.guess(), n = a(this.valueOf(), e, {
                timeZoneName: t
            }).find(function(t) {
                return "timezonename" === t.type.toLowerCase();
            });
            return n && n.value;
        };
        var s = f.startOf;
        f.startOf = function(t, e) {
            if (!this.$x || !this.$x.$timezone) return s.call(this, t, e);
            var n = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), {
                locale: this.$L
            });
            return s.call(n, t, e).tz(this.$x.$timezone, !0);
        }, o.tz = function(t, e, n) {
            var i = n && e, a = n || e || r, f = u(+o(), a);
            if ("string" != typeof t) return o(t).tz(a);
            var s = function(t, e, n) {
                var i = t - 60 * e * 1e3, o = u(i, n);
                if (e === o) return [
                    i,
                    e
                ];
                var r = u(i -= 60 * (o - e) * 1e3, n);
                return o === r ? [
                    i,
                    o
                ] : [
                    t - 60 * Math.min(o, r) * 1e3,
                    Math.max(o, r)
                ];
            }(o.utc(t, i).valueOf(), f, a), m = s[0], c = s[1], d = o(m).utcOffset(c);
            return d.$x.$timezone = a, d;
        }, o.tz.guess = function() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(t) {
            r = t;
        };
    };
});



(0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($35aece7ad906b57b$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($98bb7dc7fcb134dc$exports))));
const $6cafdd0b837ff013$var$eventOptions = [
    {
        label: 'Nibbi Event',
        value: 'NIBBI_EVENT'
    },
    {
        label: 'Birthday',
        value: 'BIRTHDAY'
    },
    {
        label: 'Industry Event',
        value: 'INDUSTRY_EVENT'
    },
    {
        label: 'Training',
        value: 'TRAINING'
    },
    {
        label: 'Holiday',
        value: 'HOLIDAY'
    },
    {
        label: 'Oakland Office',
        value: 'OAKLAND_OFFICE'
    }
];
function $6cafdd0b837ff013$var$CreateNewEvent() {
    const navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    const params = (0, $372fcccf2bee01ac$export$99eaa27ddbbb95ef)();
    const { data: eventsData } = (0, $93486c083cb38a29$export$814fd1be80a6e6be)({
        skip: !params.eventId
    });
    const [createEvent] = (0, $93486c083cb38a29$export$c78810c1254c21c8)({
        refetchQueries: [
            {
                query: (0, $93486c083cb38a29$export$b02e6c10e95202d8)
            }
        ],
        awaitRefetchQueries: true
    });
    const [updateEvent] = (0, $93486c083cb38a29$export$d624085c29681b0a)({
        refetchQueries: [
            {
                query: (0, $93486c083cb38a29$export$b02e6c10e95202d8)
            }
        ],
        awaitRefetchQueries: true
    });
    const { useRole: useRole } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    if (params.eventId && !eventsData) return null;
    const existing = params.eventId && eventsData.events.find((ev)=>ev.id === +params.eventId);
    let initialValues = {
        eventTitle: '',
        from: {
            date: '',
            time: ''
        },
        to: {
            date: '',
            time: ''
        },
        allDay: false,
        eventType: $6cafdd0b837ff013$var$eventOptions[0],
        eventDescription: ''
    };
    if (existing) {
        const parseDate = (input)=>{
            const [date, time] = (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(input).tz('America/Los_Angeles').format('YYYY-MM-DD HH:mm').split(' ');
            return {
                date: date,
                time: time
            };
        };
        initialValues = {
            eventTitle: existing.title,
            from: parseDate(existing.startsAt),
            to: parseDate(existing.endsAt),
            allDay: existing.allDay,
            eventType: $6cafdd0b837ff013$var$eventOptions.find((eo)=>eo.value === existing.type),
            eventDescription: existing.description || ''
        };
    }
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Formik), {
        enableReinitialize: true,
        initialValues: initialValues,
        onSubmit: async (values)=>{
            const startDate = (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports))).tz(`${values.from.date} ${values.allDay || !values.from.time ? '08:00' : values.from.time}`, 'America/Los_Angeles').toISOString();
            const endDate = (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports))).tz(`${values.to.date} ${values.allDay || !values.to.time ? '08:00' : values.to.time}`, 'America/Los_Angeles').toISOString();
            const variables = {
                allDay: values.allDay,
                startsAt: startDate,
                endsAt: endDate,
                description: values.eventDescription,
                title: values.eventTitle,
                type: values.eventType.value
            };
            if (existing) {
                await updateEvent({
                    context: {
                        useRole: useRole
                    },
                    variables: {
                        ...variables,
                        id: existing.id
                    }
                });
                navigate('../..');
            } else {
                await createEvent({
                    context: {
                        useRole: useRole
                    },
                    variables: variables
                });
                navigate('..');
            }
        },
        children: ({ setFieldValue: setFieldValue, values: values })=>/*#__PURE__*/ (0, $01ysi.jsxs)((0, $489wz.Form), {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        name: "eventTitle",
                        type: "text",
                        label: "Event Title",
                        placeholder: "Event title"
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        type: "timeDateGroup",
                        label: "Date and Time"
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        name: "eventType",
                        type: "select2",
                        label: "Event Type",
                        options: $6cafdd0b837ff013$var$eventOptions
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        name: "eventDescription",
                        type: "richText",
                        label: "Event Description",
                        value: values.eventDescription,
                        placeholder: "Write an optional description here...",
                        onChange: (val)=>setFieldValue('eventDescription', val)
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        type: "formButtons",
                        onCancel: existing ? '../..' : undefined
                    })
                ]
            })
    });
}
var $6cafdd0b837ff013$export$2e2bcd8739ae039 = $6cafdd0b837ff013$var$CreateNewEvent;






const $6e352ea6786000e7$var$locales = {
    'en-US': (0, $1db029a71357c34e$export$2e2bcd8739ae039)
};
const $6e352ea6786000e7$var$localizer = (0, $f145fa6d412a8ce0$export$3fa2fdf84427788c)({
    format: $97c33a3e713864b7$export$2e2bcd8739ae039,
    parse: $88d93c5832804e62$export$2e2bcd8739ae039,
    startOfWeek: $f65cf8485e1e6348$export$2e2bcd8739ae039,
    getDay: $2288f74c78a6f0a7$export$2e2bcd8739ae039,
    locales: $6e352ea6786000e7$var$locales
});
const $6e352ea6786000e7$var$calendarSidebarLinks = [
    {
        title: 'Calendar',
        to: '/calendar'
    },
    {
        title: 'Create New Event',
        to: '/calendar/publish',
        adminOnly: true
    }
];
function $6e352ea6786000e7$var$CalendarRoute() {
    const [eventDetail, setEventDetail] = (0, $gRqVZ.useState)(null);
    const { useRole: useRole } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    const [deleteEvent] = (0, $93486c083cb38a29$export$257c69caab61b878)({
        refetchQueries: [
            {
                query: (0, $93486c083cb38a29$export$b02e6c10e95202d8)
            }
        ],
        awaitRefetchQueries: true
    });
    const [eventDetailModal, setShowingEventDetailModal] = (0, $63e9a7af5676c306$export$33ffd74ebf07f060)({
        header: eventDetail?.title,
        children: eventDetail && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
            children: [
                /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                    style: {
                        color: '#868686'
                    },
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $7a6c46ab34a6f39b$export$5fda1783bb83f57b), {}),
                        " ",
                        (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(eventDetail.start).format(eventDetail.allDay ? 'LL' : 'LLL'),
                        ' - ',
                        (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(eventDetail.end).format(eventDetail.allDay ? 'LL' : 'LLL')
                    ]
                }),
                eventDetail.type !== 'PTO' && /*#__PURE__*/ (0, $01ysi.jsx)((0, $6e3a19da527b7fab$export$d56e283436f735f9), {
                    role: [
                        'SuperAdmin',
                        'Editor'
                    ],
                    children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $7a6c46ab34a6f39b$export$9eb9467136ef56ff), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $7a6c46ab34a6f39b$export$e19cd5f9376f8cee), {
                                to: `edit/${eventDetail.id}`,
                                children: "Edit"
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $7a6c46ab34a6f39b$export$51485461e6c971ae), {
                                onClick: async ()=>{
                                    if (confirm('Are you sure you want to delete this event?')) {
                                        await deleteEvent({
                                            context: {
                                                useRole: useRole
                                            },
                                            variables: {
                                                id: eventDetail.id
                                            }
                                        });
                                        setShowingEventDetailModal(false);
                                    }
                                },
                                children: "Delete"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                    style: {
                        paddingTop: '2rem'
                    },
                    children: eventDetail.description?.length > 0 ? /*#__PURE__*/ (0, $01ysi.jsx)((0, $17faf2022da0c55b$export$2e2bcd8739ae039), {
                        html: eventDetail.description
                    }) : 'This event does not have a description'
                })
            ]
        })
    });
    const [filters, setFilters] = (0, $gRqVZ.useState)((0, $jIrNf.mapValues)((0, $965c163f78c932d5$export$e1f75a2fa907d754), ()=>false));
    const { data: eventsData } = (0, $93486c083cb38a29$export$814fd1be80a6e6be)();
    const showTypes = !(0, $jIrNf.some)(filters) ? (0, $jIrNf.keys)((0, $965c163f78c932d5$export$e1f75a2fa907d754)) : (0, $jIrNf.keys)((0, $jIrNf.pickBy)(filters));
    const events = (eventsData?.events ?? []).map((d)=>{
        return {
            id: d.id,
            title: d.title,
            start: (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(d.startsAt).toDate(),
            end: (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(d.endsAt).toDate(),
            allDay: d.allDay,
            type: d.type,
            description: d.description
        };
    }).filter((d)=>showTypes.includes(d.type));
    const eventPropGetter = (ev)=>{
        const style = {
            backgroundColor: ev.type === 'ADPPTO' ? 'red' : (0, $965c163f78c932d5$export$e1f75a2fa907d754)[ev?.type]?.color
        };
        return {
            style: style
        };
    };
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
        children: [
            eventDetailModal,
            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $38e8ff2ff45ad7fb$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $f17ceecf287e1f86$export$2e2bcd8739ae039), {
                        links: $6e352ea6786000e7$var$calendarSidebarLinks,
                        children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $7a6c46ab34a6f39b$export$92a576f896a9bf72), {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)("h3", {
                                    children: "Calendar Filters"
                                }),
                                Object.entries((0, $965c163f78c932d5$export$e1f75a2fa907d754)).map(([eventType, eventTypeConfig])=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $bb50aee31402fbe6$export$2e2bcd8739ae039), {
                                        toggle: ()=>{
                                            setFilters({
                                                ...filters,
                                                [eventType]: !filters[eventType]
                                            });
                                        },
                                        toggled: filters[eventType],
                                        title: eventTypeConfig.label,
                                        color: eventTypeConfig.color
                                    }, eventType))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $f145fa6d412a8ce0$export$e1aef45b828286de), {
                        localizer: $6e352ea6786000e7$var$localizer,
                        events: events,
                        startAccessor: "start",
                        endAccessor: "end",
                        eventPropGetter: eventPropGetter,
                        onSelectEvent: async (event)=>{
                            await setEventDetail(event);
                            await setShowingEventDetailModal(true);
                        },
                        style: {
                            height: 800,
                            width: 1200
                        },
                        views: {
                            month: true,
                            week: true,
                            day: true
                        }
                    })
                ]
            })
        ]
    });
}
function $6e352ea6786000e7$var$CalendarForm() {
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $38e8ff2ff45ad7fb$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $f17ceecf287e1f86$export$2e2bcd8739ae039), {
                    links: $6e352ea6786000e7$var$calendarSidebarLinks
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $6cafdd0b837ff013$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
function $6e352ea6786000e7$var$GalleryRoute() {
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $372fcccf2bee01ac$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                    path: "/",
                    element: /*#__PURE__*/ (0, $01ysi.jsx)($6e352ea6786000e7$var$CalendarRoute, {})
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                    path: "/publish",
                    element: /*#__PURE__*/ (0, $01ysi.jsx)($6e352ea6786000e7$var$CalendarForm, {})
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                    path: "/edit/:eventId",
                    element: /*#__PURE__*/ (0, $01ysi.jsx)($6e352ea6786000e7$var$CalendarForm, {})
                })
            ]
        })
    });
}
var $6e352ea6786000e7$export$2e2bcd8739ae039 = $6e352ea6786000e7$var$GalleryRoute;



var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");







var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");



var $gRqVZ = parcelRequire("gRqVZ");
const $a036e438091559f5$export$83fe3bee12eb51bb = "carousel";
const $a036e438091559f5$export$b861c6f4d58b4c2f = "controller";
const $a036e438091559f5$export$607ce719f0ec9b98 = "navigation";
const $a036e438091559f5$export$52cbc29cf5406ba8 = "no-scroll";
const $a036e438091559f5$export$9d2e4856063e1a22 = "portal";
const $a036e438091559f5$export$62f3c66ae8dab8a3 = "root";
const $a036e438091559f5$export$5414719b40b8294f = "toolbar";
const $a036e438091559f5$export$a23b14c1465897d = "captions";
const $a036e438091559f5$export$8ae0dbe553798d04 = "counter";
const $a036e438091559f5$export$ace9d67c0f2290af = "download";
const $a036e438091559f5$export$4792108761b262a9 = "fullscreen";
const $a036e438091559f5$export$c21ea5a712f18fb6 = "inline";
const $a036e438091559f5$export$6bbdc870e6ef9c88 = "share";
const $a036e438091559f5$export$be7dc72e63e6ef2e = "slideshow";
const $a036e438091559f5$export$6bf9d56640f46f01 = "thumbnails";
const $a036e438091559f5$export$929980e2a2c57ecf = "zoom";
const $a036e438091559f5$export$554a1415841c52a8 = "loading";
const $a036e438091559f5$export$38ce62e512432ebb = "playing";
const $a036e438091559f5$export$2ed3c80dbc178d91 = "error";
const $a036e438091559f5$export$a195e517d37aaa33 = "complete";
const $a036e438091559f5$export$e51f1c6d74b54a13 = "placeholder";
const $a036e438091559f5$export$6751782e799f6445 = (status)=>`active-slide-${status}`;
const $a036e438091559f5$export$7ab73e7383503259 = $a036e438091559f5$export$6751782e799f6445($a036e438091559f5$export$554a1415841c52a8);
const $a036e438091559f5$export$ccb5eb0b2db52ae8 = $a036e438091559f5$export$6751782e799f6445($a036e438091559f5$export$38ce62e512432ebb);
const $a036e438091559f5$export$817be438d1d0e4cf = $a036e438091559f5$export$6751782e799f6445($a036e438091559f5$export$2ed3c80dbc178d91);
const $a036e438091559f5$export$2ec1d32caeb97dfe = $a036e438091559f5$export$6751782e799f6445($a036e438091559f5$export$a195e517d37aaa33);
const $a036e438091559f5$export$37b171d829eeeaa2 = "fullsize";
const $a036e438091559f5$export$974a68ef150451f5 = "flex_center";
const $a036e438091559f5$export$b6426a00c33a0175 = "no_scroll";
const $a036e438091559f5$export$651541414233b476 = "no_scroll_padding";
const $a036e438091559f5$export$8d922915837a38d3 = "slide";
const $a036e438091559f5$export$ac396c284080b10c = "slide_wrapper";
const $a036e438091559f5$export$bb41c4fe76dce9db = "slide_wrapper_interactive";
const $a036e438091559f5$export$a007161537026955 = "prev";
const $a036e438091559f5$export$f1d7a854db833ed4 = "next";
const $a036e438091559f5$export$c43bd1a4101c4078 = "swipe";
const $a036e438091559f5$export$493a596486210a21 = "close";
const $a036e438091559f5$export$e15fc153f45a963d = "onPointerDown";
const $a036e438091559f5$export$1f8863949fbdd7e5 = "onPointerMove";
const $a036e438091559f5$export$2d868b67a5791b8a = "onPointerUp";
const $a036e438091559f5$export$526cafa85592f1a5 = "onPointerLeave";
const $a036e438091559f5$export$22151cee048c4be9 = "onPointerCancel";
const $a036e438091559f5$export$1aba4f3521686ca9 = "onKeyDown";
const $a036e438091559f5$export$bdb9f99d61a6879b = "onKeyUp";
const $a036e438091559f5$export$5635dc9d647242c7 = "onWheel";
const $a036e438091559f5$export$e8d60d9b5ceff7c0 = "Escape";
const $a036e438091559f5$export$17dec1da9b0e2eb3 = "ArrowLeft";
const $a036e438091559f5$export$91898c0e7e48903 = "ArrowRight";
const $a036e438091559f5$export$d62fb7722b07f2f3 = "button";
const $a036e438091559f5$export$c5f5ca1963fed141 = "icon";
const $a036e438091559f5$export$eff7fe5eefd707ad = "contain";
const $a036e438091559f5$export$9a9f12fc3f1c1e4f = "cover";
const $a036e438091559f5$export$b149fc25cb186fec = "Unknown action type";



var $hYKvr = parcelRequire("hYKvr");
"use client";
const $c552f4c6f5978452$var$cssPrefix$3 = "yarl__";
function $c552f4c6f5978452$export$4f5d2d50c9deca37(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $c552f4c6f5978452$export$1283875077dc8f0a(name) {
    return `${$c552f4c6f5978452$var$cssPrefix$3}${name}`;
}
function $c552f4c6f5978452$export$8b4981022bd80a4e(name) {
    return `--${$c552f4c6f5978452$var$cssPrefix$3}${name}`;
}
function $c552f4c6f5978452$export$195c4126907dde97(base, prefix) {
    return `${base}${prefix ? `_${prefix}` : ""}`;
}
function $c552f4c6f5978452$export$3e7cd27eed1727c(base) {
    return (prefix)=>$c552f4c6f5978452$export$195c4126907dde97(base, prefix);
}
function $c552f4c6f5978452$export$1c4d965eb6f65dfa(labels, defaultLabel) {
    var _a;
    return (_a = labels === null || labels === void 0 ? void 0 : labels[defaultLabel]) !== null && _a !== void 0 ? _a : defaultLabel;
}
function $c552f4c6f5978452$export$1237798dc640739a(labels, defaultLabel) {
    return $c552f4c6f5978452$export$1c4d965eb6f65dfa(labels, defaultLabel);
}
function $c552f4c6f5978452$export$77152303d9076b8(labels, slides, index) {
    return $c552f4c6f5978452$export$1c4d965eb6f65dfa(labels, "{index} of {total}").replace(/\{index}/g, `${$c552f4c6f5978452$export$501611100333094a(index, slides.length) + 1}`).replace(/\{total}/g, `${slides.length}`);
}
function $c552f4c6f5978452$export$de863c629cb9919d(...cleaners) {
    return ()=>{
        cleaners.forEach((cleaner)=>{
            cleaner();
        });
    };
}
function $c552f4c6f5978452$export$aac3e49c3c8b5cb0(name, contextName, context) {
    return ()=>{
        const ctx = $gRqVZ.useContext(context);
        if (!ctx) throw new Error(`${name} must be used within a ${contextName}.Provider`);
        return ctx;
    };
}
function $c552f4c6f5978452$export$fef62134eea24008() {
    return typeof window !== "undefined";
}
function $c552f4c6f5978452$export$2077e0241d6afd3c(value, decimals = 0) {
    const factor = 10 ** decimals;
    return Math.round((value + Number.EPSILON) * factor) / factor;
}
function $c552f4c6f5978452$export$55ec18c411514c07(slide) {
    return slide.type === undefined || slide.type === "image";
}
function $c552f4c6f5978452$export$f5ba2f5b3fd12e6e(image, imageFit) {
    return image.imageFit === (0, $a036e438091559f5$export$9a9f12fc3f1c1e4f) || image.imageFit !== (0, $a036e438091559f5$export$eff7fe5eefd707ad) && imageFit === (0, $a036e438091559f5$export$9a9f12fc3f1c1e4f);
}
function $c552f4c6f5978452$export$5f87784a266e50a4(value) {
    return typeof value === "string" ? Number.parseInt(value, 10) : value;
}
function $c552f4c6f5978452$export$7871fb532d320d99(input) {
    if (typeof input === "number") return {
        pixel: input
    };
    if (typeof input === "string") {
        const value = $c552f4c6f5978452$export$5f87784a266e50a4(input);
        return input.endsWith("%") ? {
            percent: value
        } : {
            pixel: value
        };
    }
    return {
        pixel: 0
    };
}
function $c552f4c6f5978452$export$7ff571008bce9900(containerRect, padding) {
    const paddingValue = $c552f4c6f5978452$export$7871fb532d320d99(padding);
    const paddingPixels = paddingValue.percent !== undefined ? containerRect.width / 100 * paddingValue.percent : paddingValue.pixel;
    return {
        width: Math.max(containerRect.width - 2 * paddingPixels, 0),
        height: Math.max(containerRect.height - 2 * paddingPixels, 0)
    };
}
function $c552f4c6f5978452$export$508f096bfcdaac40() {
    return ($c552f4c6f5978452$export$fef62134eea24008() ? window === null || window === void 0 ? void 0 : window.devicePixelRatio : undefined) || 1;
}
function $c552f4c6f5978452$export$501611100333094a(index, slidesCount) {
    return slidesCount > 0 ? (index % slidesCount + slidesCount) % slidesCount : 0;
}
function $c552f4c6f5978452$export$883ece934910f98d(slides) {
    return slides.length > 0;
}
function $c552f4c6f5978452$export$cdfb855c5eb3bc84(slides, index) {
    return slides[$c552f4c6f5978452$export$501611100333094a(index, slides.length)];
}
function $c552f4c6f5978452$export$9f2f3fed4fdffdfc(slides, index) {
    return $c552f4c6f5978452$export$883ece934910f98d(slides) ? $c552f4c6f5978452$export$cdfb855c5eb3bc84(slides, index) : undefined;
}
function $c552f4c6f5978452$export$b2184449b7659b5a(slide) {
    return $c552f4c6f5978452$export$55ec18c411514c07(slide) ? slide.src : undefined;
}
function $c552f4c6f5978452$export$34ce6a408311d810(toolbar, key, button) {
    if (!button) return toolbar;
    const { buttons: buttons, ...restToolbar } = toolbar;
    const index = buttons.findIndex((item)=>item === key);
    const buttonWithKey = $gRqVZ.isValidElement(button) ? $gRqVZ.cloneElement(button, {
        key: key
    }, null) : button;
    if (index >= 0) {
        const result = [
            ...buttons
        ];
        result.splice(index, 1, buttonWithKey);
        return {
            buttons: result,
            ...restToolbar
        };
    }
    return {
        buttons: [
            buttonWithKey,
            ...buttons
        ],
        ...restToolbar
    };
}
function $c552f4c6f5978452$export$e88693bab67822d1() {
    const stopPropagation = (event)=>{
        event.stopPropagation();
    };
    return {
        onPointerDown: stopPropagation,
        onKeyDown: stopPropagation,
        onWheel: stopPropagation
    };
}
function $c552f4c6f5978452$export$aab7f3145c728301(carousel, slides, minimum = 0) {
    return Math.min(carousel.preload, Math.max(carousel.finite ? slides.length - 1 : Math.floor(slides.length / 2), minimum));
}
const $c552f4c6f5978452$var$isReact19 = Number($gRqVZ.version.split(".")[0]) >= 19;
function $c552f4c6f5978452$export$9c64d01b28c1f747(condition) {
    const legacyValue = condition ? "" : undefined;
    return {
        inert: $c552f4c6f5978452$var$isReact19 ? condition : legacyValue
    };
}
function $c552f4c6f5978452$export$b7a864e1eaef9de5(node) {
    node.scrollTop;
}
const $c552f4c6f5978452$export$d626463445cef3e9 = {
    open: false,
    close: ()=>{},
    index: 0,
    slides: [],
    render: {},
    plugins: [],
    toolbar: {
        buttons: [
            (0, $a036e438091559f5$export$493a596486210a21)
        ]
    },
    labels: {},
    animation: {
        fade: 250,
        swipe: 500,
        easing: {
            fade: "ease",
            swipe: "ease-out",
            navigation: "ease-in-out"
        }
    },
    carousel: {
        finite: false,
        preload: 2,
        padding: "16px",
        spacing: "30%",
        imageFit: (0, $a036e438091559f5$export$eff7fe5eefd707ad),
        imageProps: {}
    },
    controller: {
        ref: null,
        focus: true,
        aria: false,
        touchAction: "none",
        closeOnPullUp: false,
        closeOnPullDown: false,
        closeOnBackdropClick: false,
        preventDefaultWheelX: true,
        preventDefaultWheelY: false,
        disableSwipeNavigation: false
    },
    portal: {},
    noScroll: {
        disabled: false
    },
    on: {},
    styles: {},
    className: ""
};
function $c552f4c6f5978452$export$c5ba3739ffba980d(name, component) {
    return {
        name: name,
        component: component
    };
}
function $c552f4c6f5978452$export$270e7ba5936d3c48(module, children) {
    return {
        module: module,
        children: children
    };
}
function $c552f4c6f5978452$var$traverseNode(node, target, apply) {
    if (node.module.name === target) return apply(node);
    if (node.children) return [
        $c552f4c6f5978452$export$270e7ba5936d3c48(node.module, node.children.flatMap((n)=>{
            var _a;
            return (_a = $c552f4c6f5978452$var$traverseNode(n, target, apply)) !== null && _a !== void 0 ? _a : [];
        }))
    ];
    return [
        node
    ];
}
function $c552f4c6f5978452$var$traverse(nodes, target, apply) {
    return nodes.flatMap((node)=>{
        var _a;
        return (_a = $c552f4c6f5978452$var$traverseNode(node, target, apply)) !== null && _a !== void 0 ? _a : [];
    });
}
function $c552f4c6f5978452$export$bc996c07eb970c78(root, plugins = [], augmentations = []) {
    let config = root;
    const contains = (target)=>{
        const nodes = [
            ...config
        ];
        while(nodes.length > 0){
            const node = nodes.pop();
            if ((node === null || node === void 0 ? void 0 : node.module.name) === target) return true;
            if (node === null || node === void 0 ? void 0 : node.children) nodes.push(...node.children);
        }
        return false;
    };
    const addParent = (target, module)=>{
        if (target === "") {
            config = [
                $c552f4c6f5978452$export$270e7ba5936d3c48(module, config)
            ];
            return;
        }
        config = $c552f4c6f5978452$var$traverse(config, target, (node)=>[
                $c552f4c6f5978452$export$270e7ba5936d3c48(module, [
                    node
                ])
            ]);
    };
    const append = (target, module)=>{
        config = $c552f4c6f5978452$var$traverse(config, target, (node)=>[
                $c552f4c6f5978452$export$270e7ba5936d3c48(node.module, [
                    $c552f4c6f5978452$export$270e7ba5936d3c48(module, node.children)
                ])
            ]);
    };
    const addChild = (target, module, precede)=>{
        config = $c552f4c6f5978452$var$traverse(config, target, (node)=>{
            var _a;
            return [
                $c552f4c6f5978452$export$270e7ba5936d3c48(node.module, [
                    ...precede ? [
                        $c552f4c6f5978452$export$270e7ba5936d3c48(module)
                    ] : [],
                    ...(_a = node.children) !== null && _a !== void 0 ? _a : [],
                    ...!precede ? [
                        $c552f4c6f5978452$export$270e7ba5936d3c48(module)
                    ] : []
                ])
            ];
        });
    };
    const addSibling = (target, module, precede)=>{
        config = $c552f4c6f5978452$var$traverse(config, target, (node)=>[
                ...precede ? [
                    $c552f4c6f5978452$export$270e7ba5936d3c48(module)
                ] : [],
                node,
                ...!precede ? [
                    $c552f4c6f5978452$export$270e7ba5936d3c48(module)
                ] : []
            ]);
    };
    const addModule = (module)=>{
        append((0, $a036e438091559f5$export$b861c6f4d58b4c2f), module);
    };
    const replace = (target, module)=>{
        config = $c552f4c6f5978452$var$traverse(config, target, (node)=>[
                $c552f4c6f5978452$export$270e7ba5936d3c48(module, node.children)
            ]);
    };
    const remove = (target)=>{
        config = $c552f4c6f5978452$var$traverse(config, target, (node)=>node.children);
    };
    const augment = (augmentation)=>{
        augmentations.push(augmentation);
    };
    plugins.forEach((plugin)=>{
        plugin({
            contains: contains,
            addParent: addParent,
            append: append,
            addChild: addChild,
            addSibling: addSibling,
            addModule: addModule,
            replace: replace,
            remove: remove,
            augment: augment
        });
    });
    return {
        config: config,
        augmentation: (props)=>augmentations.reduce((acc, augmentation)=>augmentation(acc), props)
    };
}
const $c552f4c6f5978452$export$bec71e4205979323 = $gRqVZ.createContext(null);
const $c552f4c6f5978452$export$3992c64d261ded5a = $c552f4c6f5978452$export$aac3e49c3c8b5cb0("useA11yContext", "A11yContext", $c552f4c6f5978452$export$bec71e4205979323);
function $c552f4c6f5978452$export$e41a845d3e53ea09({ children: children }) {
    const [focusWithin, setFocusWithin] = $gRqVZ.useState(false);
    const [autoPlaying, setAutoPlaying] = $gRqVZ.useState(false);
    const context = $gRqVZ.useMemo(()=>{
        const trackFocusWithin = (onFocus, onBlur)=>{
            const trackAndDelegate = (focusWithinValue)=>(event)=>{
                    var _a;
                    if (!event.currentTarget.contains(event.relatedTarget)) setFocusWithin(focusWithinValue);
                    (_a = focusWithinValue ? onFocus : onBlur) === null || _a === void 0 || _a(event);
                };
            return {
                onFocus: trackAndDelegate(true),
                onBlur: trackAndDelegate(false)
            };
        };
        return {
            focusWithin: focusWithin,
            trackFocusWithin: trackFocusWithin,
            autoPlaying: autoPlaying,
            setAutoPlaying: setAutoPlaying
        };
    }, [
        focusWithin,
        autoPlaying
    ]);
    return $gRqVZ.createElement($c552f4c6f5978452$export$bec71e4205979323.Provider, {
        value: context
    }, children);
}
const $c552f4c6f5978452$export$41b6c5189865fe72 = $gRqVZ.createContext(null);
const $c552f4c6f5978452$export$c199d36c2862b6ed = $c552f4c6f5978452$export$aac3e49c3c8b5cb0("useDocument", "DocumentContext", $c552f4c6f5978452$export$41b6c5189865fe72);
function $c552f4c6f5978452$export$30e869153d18a2e6({ nodeRef: nodeRef, children: children }) {
    const context = $gRqVZ.useMemo(()=>{
        const getOwnerDocument = (node)=>{
            var _a;
            return ((_a = node || nodeRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument) || document;
        };
        const getOwnerWindow = (node)=>{
            var _a;
            return ((_a = getOwnerDocument(node)) === null || _a === void 0 ? void 0 : _a.defaultView) || window;
        };
        return {
            getOwnerDocument: getOwnerDocument,
            getOwnerWindow: getOwnerWindow
        };
    }, [
        nodeRef
    ]);
    return $gRqVZ.createElement($c552f4c6f5978452$export$41b6c5189865fe72.Provider, {
        value: context
    }, children);
}
const $c552f4c6f5978452$export$f4208dae105d4d3 = $gRqVZ.createContext(null);
const $c552f4c6f5978452$export$91a992459f6e0f07 = $c552f4c6f5978452$export$aac3e49c3c8b5cb0("useEvents", "EventsContext", $c552f4c6f5978452$export$f4208dae105d4d3);
function $c552f4c6f5978452$export$686accdd53ac150f({ children: children }) {
    const [subscriptions] = $gRqVZ.useState({});
    $gRqVZ.useEffect(()=>()=>{
            Object.keys(subscriptions).forEach((topic)=>delete subscriptions[topic]);
        }, [
        subscriptions
    ]);
    const context = $gRqVZ.useMemo(()=>{
        const unsubscribe = (topic, callback)=>{
            var _a;
            (_a = subscriptions[topic]) === null || _a === void 0 || _a.splice(0, subscriptions[topic].length, ...subscriptions[topic].filter((cb)=>cb !== callback));
        };
        const subscribe = (topic, callback)=>{
            if (!subscriptions[topic]) subscriptions[topic] = [];
            subscriptions[topic].push(callback);
            return ()=>unsubscribe(topic, callback);
        };
        const publish = (...[topic, event])=>{
            var _a;
            (_a = subscriptions[topic]) === null || _a === void 0 || _a.forEach((callback)=>callback(event));
        };
        return {
            publish: publish,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };
    }, [
        subscriptions
    ]);
    return $gRqVZ.createElement($c552f4c6f5978452$export$f4208dae105d4d3.Provider, {
        value: context
    }, children);
}
const $c552f4c6f5978452$export$9f6b9cbf1d54cc28 = $gRqVZ.createContext(null);
const $c552f4c6f5978452$export$d930f3536e1c64f6 = $c552f4c6f5978452$export$aac3e49c3c8b5cb0("useLightboxProps", "LightboxPropsContext", $c552f4c6f5978452$export$9f6b9cbf1d54cc28);
function $c552f4c6f5978452$export$7141a340a3dea601({ children: children, ...props }) {
    return $gRqVZ.createElement($c552f4c6f5978452$export$9f6b9cbf1d54cc28.Provider, {
        value: props
    }, children);
}
const $c552f4c6f5978452$export$c24db94cf7704d3a = $gRqVZ.createContext(null);
const $c552f4c6f5978452$export$566121e2bbc52eec = $c552f4c6f5978452$export$aac3e49c3c8b5cb0("useLightboxState", "LightboxStateContext", $c552f4c6f5978452$export$c24db94cf7704d3a);
const $c552f4c6f5978452$export$42eb31c6c0f01c10 = $gRqVZ.createContext(null);
const $c552f4c6f5978452$export$9463bb14d6ba055e = $c552f4c6f5978452$export$aac3e49c3c8b5cb0("useLightboxDispatch", "LightboxDispatchContext", $c552f4c6f5978452$export$42eb31c6c0f01c10);
function $c552f4c6f5978452$var$reducer(state, action) {
    switch(action.type){
        case "swipe":
            {
                const { slides: slides } = state;
                const increment = (action === null || action === void 0 ? void 0 : action.increment) || 0;
                const globalIndex = state.globalIndex + increment;
                const currentIndex = $c552f4c6f5978452$export$501611100333094a(globalIndex, slides.length);
                const currentSlide = $c552f4c6f5978452$export$9f2f3fed4fdffdfc(slides, currentIndex);
                const animation = increment || action.duration !== undefined ? {
                    increment: increment,
                    duration: action.duration,
                    easing: action.easing
                } : undefined;
                return {
                    slides: slides,
                    currentIndex: currentIndex,
                    globalIndex: globalIndex,
                    currentSlide: currentSlide,
                    animation: animation
                };
            }
        case "update":
            if (action.slides !== state.slides || action.index !== state.currentIndex) return {
                slides: action.slides,
                currentIndex: action.index,
                globalIndex: action.index,
                currentSlide: $c552f4c6f5978452$export$9f2f3fed4fdffdfc(action.slides, action.index)
            };
            return state;
        default:
            throw new Error((0, $a036e438091559f5$export$b149fc25cb186fec));
    }
}
function $c552f4c6f5978452$export$62d2e1d2e7609988({ slides: slides, index: index, children: children }) {
    const [state, dispatch] = $gRqVZ.useReducer($c552f4c6f5978452$var$reducer, {
        slides: slides,
        currentIndex: index,
        globalIndex: index,
        currentSlide: $c552f4c6f5978452$export$9f2f3fed4fdffdfc(slides, index)
    });
    const [prevSlides, setPrevSlides] = $gRqVZ.useState(slides);
    const [prevIndex, setPrevIndex] = $gRqVZ.useState(index);
    if (slides !== prevSlides || index !== prevIndex) {
        setPrevSlides(slides);
        setPrevIndex(index);
        dispatch({
            type: "update",
            slides: slides,
            index: index
        });
    }
    const context = $gRqVZ.useMemo(()=>({
            ...state,
            state: state,
            dispatch: dispatch
        }), [
        state,
        dispatch
    ]);
    return $gRqVZ.createElement($c552f4c6f5978452$export$42eb31c6c0f01c10.Provider, {
        value: dispatch
    }, $gRqVZ.createElement($c552f4c6f5978452$export$c24db94cf7704d3a.Provider, {
        value: context
    }, children));
}
const $c552f4c6f5978452$export$e96e3cec40decff1 = $gRqVZ.createContext(null);
const $c552f4c6f5978452$export$57c05a83b72fe7b = $c552f4c6f5978452$export$aac3e49c3c8b5cb0("useRTLContext", "RTLContext", $c552f4c6f5978452$export$e96e3cec40decff1);
function $c552f4c6f5978452$export$625eb40e2215f320({ isRTL: isRTL, children: children }) {
    const context = $gRqVZ.useMemo(()=>({
            isRTL: isRTL
        }), [
        isRTL
    ]);
    return $gRqVZ.createElement($c552f4c6f5978452$export$e96e3cec40decff1.Provider, {
        value: context
    }, children);
}
const $c552f4c6f5978452$export$e338b1178a56544e = $gRqVZ.createContext(null);
const $c552f4c6f5978452$export$1bc7162631c81b3f = $c552f4c6f5978452$export$aac3e49c3c8b5cb0("useTimeouts", "TimeoutsContext", $c552f4c6f5978452$export$e338b1178a56544e);
function $c552f4c6f5978452$export$9d9954f5885fa393({ children: children }) {
    const [timeouts] = $gRqVZ.useState([]);
    $gRqVZ.useEffect(()=>()=>{
            timeouts.forEach((tid)=>window.clearTimeout(tid));
            timeouts.splice(0, timeouts.length);
        }, [
        timeouts
    ]);
    const context = $gRqVZ.useMemo(()=>{
        const removeTimeout = (id)=>{
            timeouts.splice(0, timeouts.length, ...timeouts.filter((tid)=>tid !== id));
        };
        const setTimeout = (fn, delay)=>{
            const id = window.setTimeout(()=>{
                removeTimeout(id);
                fn();
            }, delay);
            timeouts.push(id);
            return id;
        };
        const clearTimeout = (id)=>{
            if (id !== undefined) {
                removeTimeout(id);
                window.clearTimeout(id);
            }
        };
        return {
            setTimeout: setTimeout,
            clearTimeout: clearTimeout
        };
    }, [
        timeouts
    ]);
    return $gRqVZ.createElement($c552f4c6f5978452$export$e338b1178a56544e.Provider, {
        value: context
    }, children);
}
const $c552f4c6f5978452$export$c25acd513dcc8062 = $gRqVZ.forwardRef(function IconButton({ label: label, className: className, icon: Icon, renderIcon: renderIcon, onClick: onClick, style: style, ...rest }, ref) {
    const { styles: styles, labels: labels } = $c552f4c6f5978452$export$d930f3536e1c64f6();
    const buttonLabel = $c552f4c6f5978452$export$1c4d965eb6f65dfa(labels, label);
    return $gRqVZ.createElement("button", {
        ref: ref,
        type: "button",
        title: buttonLabel,
        "aria-label": buttonLabel,
        className: $c552f4c6f5978452$export$4f5d2d50c9deca37($c552f4c6f5978452$export$1283875077dc8f0a((0, $a036e438091559f5$export$d62fb7722b07f2f3)), className),
        onClick: onClick,
        style: {
            ...style,
            ...styles.button
        },
        ...rest
    }, renderIcon ? renderIcon() : $gRqVZ.createElement(Icon, {
        className: $c552f4c6f5978452$export$1283875077dc8f0a((0, $a036e438091559f5$export$c5f5ca1963fed141)),
        style: styles.icon
    }));
});
function $c552f4c6f5978452$var$svgIcon(name, children) {
    const icon = (props)=>$gRqVZ.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24",
            "aria-hidden": "true",
            focusable: "false",
            ...props
        }, children);
    icon.displayName = name;
    return icon;
}
function $c552f4c6f5978452$export$274edc73af1ae9c8(name, glyph) {
    return $c552f4c6f5978452$var$svgIcon(name, $gRqVZ.createElement("g", {
        fill: "currentColor"
    }, $gRqVZ.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), glyph));
}
function $c552f4c6f5978452$export$6b1fd58c1dc933ec(name, glyph) {
    return $c552f4c6f5978452$var$svgIcon(name, $gRqVZ.createElement($gRqVZ.Fragment, null, $gRqVZ.createElement("defs", null, $gRqVZ.createElement("mask", {
        id: "strike"
    }, $gRqVZ.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "white"
    }), $gRqVZ.createElement("path", {
        d: "M0 0L24 24",
        stroke: "black",
        strokeWidth: 4
    }))), $gRqVZ.createElement("path", {
        d: "M0.70707 2.121320L21.878680 23.292883",
        stroke: "currentColor",
        strokeWidth: 2
    }), $gRqVZ.createElement("g", {
        fill: "currentColor",
        mask: "url(#strike)"
    }, $gRqVZ.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), glyph)));
}
const $c552f4c6f5978452$export$cae179f078f4b4a4 = $c552f4c6f5978452$export$274edc73af1ae9c8("Close", $gRqVZ.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}));
const $c552f4c6f5978452$export$d05925e1c7f3f136 = $c552f4c6f5978452$export$274edc73af1ae9c8("Previous", $gRqVZ.createElement("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}));
const $c552f4c6f5978452$export$3da0e0ec94bd4ce1 = $c552f4c6f5978452$export$274edc73af1ae9c8("Next", $gRqVZ.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}));
const $c552f4c6f5978452$export$b936c55164dcf1db = $c552f4c6f5978452$export$274edc73af1ae9c8("Loading", $gRqVZ.createElement($gRqVZ.Fragment, null, Array.from({
    length: 8
}).map((_, index, array)=>$gRqVZ.createElement("line", {
        key: index,
        x1: "12",
        y1: "6.5",
        x2: "12",
        y2: "1.8",
        strokeLinecap: "round",
        strokeWidth: "2.6",
        stroke: "currentColor",
        strokeOpacity: 1 / array.length * (index + 1),
        transform: `rotate(${360 / array.length * index}, 12, 12)`
    }))));
const $c552f4c6f5978452$export$19bc16ee58e19b3d = $c552f4c6f5978452$export$274edc73af1ae9c8("Error", $gRqVZ.createElement("path", {
    d: "M21.9,21.9l-8.49-8.49l0,0L3.59,3.59l0,0L2.1,2.1L0.69,3.51L3,5.83V19c0,1.1,0.9,2,2,2h13.17l2.31,2.31L21.9,21.9z M5,18 l3.5-4.5l2.5,3.01L12.17,15l3,3H5z M21,18.17L5.83,3H19c1.1,0,2,0.9,2,2V18.17z"
}));
const $c552f4c6f5978452$export$e5c5a5f917a5871c = $c552f4c6f5978452$export$fef62134eea24008() ? $gRqVZ.useLayoutEffect : $gRqVZ.useEffect;
function $c552f4c6f5978452$export$f3e625e1b2b31d60() {
    const [reduceMotion, setReduceMotion] = $gRqVZ.useState(false);
    $gRqVZ.useEffect(()=>{
        var _a, _b;
        const mediaQuery = (_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, "(prefers-reduced-motion: reduce)");
        setReduceMotion(mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.matches);
        const listener = (event)=>setReduceMotion(event.matches);
        (_b = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.addEventListener) === null || _b === void 0 || _b.call(mediaQuery, "change", listener);
        return ()=>{
            var _a;
            return (_a = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(mediaQuery, "change", listener);
        };
    }, []);
    return reduceMotion;
}
function $c552f4c6f5978452$var$currentTransformation(node) {
    let x = 0;
    let y = 0;
    let z = 0;
    const matrix = window.getComputedStyle(node).transform;
    const matcher = matrix.match(/matrix.*\((.+)\)/);
    if (matcher) {
        const values = matcher[1].split(",").map($c552f4c6f5978452$export$5f87784a266e50a4);
        if (values.length === 6) {
            x = values[4];
            y = values[5];
        } else if (values.length === 16) {
            x = values[12];
            y = values[13];
            z = values[14];
        }
    }
    return {
        x: x,
        y: y,
        z: z
    };
}
function $c552f4c6f5978452$export$9e2608686d4ad846(nodeRef, computeAnimation) {
    const snapshot = $gRqVZ.useRef(undefined);
    const animation = $gRqVZ.useRef(undefined);
    const reduceMotion = $c552f4c6f5978452$export$f3e625e1b2b31d60();
    $c552f4c6f5978452$export$e5c5a5f917a5871c(()=>{
        var _a, _b, _c;
        if (nodeRef.current && snapshot.current !== undefined && !reduceMotion) {
            const { keyframes: keyframes, duration: duration, easing: easing, onfinish: onfinish } = computeAnimation(snapshot.current, nodeRef.current.getBoundingClientRect(), $c552f4c6f5978452$var$currentTransformation(nodeRef.current)) || {};
            if (keyframes && duration) {
                (_a = animation.current) === null || _a === void 0 || _a.cancel();
                animation.current = undefined;
                try {
                    animation.current = (_c = (_b = nodeRef.current).animate) === null || _c === void 0 ? void 0 : _c.call(_b, keyframes, {
                        duration: duration,
                        easing: easing
                    });
                } catch (err) {
                    console.error(err);
                }
                if (animation.current) animation.current.onfinish = ()=>{
                    animation.current = undefined;
                    onfinish === null || onfinish === void 0 || onfinish();
                };
            }
        }
        snapshot.current = undefined;
    });
    return {
        prepareAnimation: (currentSnapshot)=>{
            snapshot.current = currentSnapshot;
        },
        isAnimationPlaying: ()=>{
            var _a;
            return ((_a = animation.current) === null || _a === void 0 ? void 0 : _a.playState) === "running";
        }
    };
}
function $c552f4c6f5978452$export$b1d85de58d38d09d() {
    const containerRef = $gRqVZ.useRef(null);
    const observerRef = $gRqVZ.useRef(undefined);
    const [containerRect, setContainerRect] = $gRqVZ.useState();
    const setContainerRef = $gRqVZ.useCallback((node)=>{
        containerRef.current = node;
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = undefined;
        }
        const updateContainerRect = ()=>{
            if (node) {
                const styles = window.getComputedStyle(node);
                const parse = (value)=>parseFloat(value) || 0;
                setContainerRect({
                    width: Math.round(node.clientWidth - parse(styles.paddingLeft) - parse(styles.paddingRight)),
                    height: Math.round(node.clientHeight - parse(styles.paddingTop) - parse(styles.paddingBottom))
                });
            } else setContainerRect(undefined);
        };
        updateContainerRect();
        if (node && typeof ResizeObserver !== "undefined") {
            observerRef.current = new ResizeObserver(updateContainerRect);
            observerRef.current.observe(node);
        }
    }, []);
    return {
        setContainerRef: setContainerRef,
        containerRef: containerRef,
        containerRect: containerRect
    };
}
function $c552f4c6f5978452$export$69f38700ea0cb3b9() {
    const timeoutId = $gRqVZ.useRef(undefined);
    const { setTimeout: setTimeout, clearTimeout: clearTimeout } = $c552f4c6f5978452$export$1bc7162631c81b3f();
    return $gRqVZ.useCallback((callback, delay)=>{
        clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay > 0 ? delay : 0);
    }, [
        setTimeout,
        clearTimeout
    ]);
}
function $c552f4c6f5978452$export$ee5b5d04074a389e(fn) {
    const ref = $gRqVZ.useRef(fn);
    $c552f4c6f5978452$export$e5c5a5f917a5871c(()=>{
        ref.current = fn;
    });
    return $gRqVZ.useCallback((...args)=>{
        var _a;
        return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.call(ref, ...args);
    }, []);
}
function $c552f4c6f5978452$export$4bb192c7cacf928f(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function $c552f4c6f5978452$export$ebc1e1560c2dffa5(refA, refB) {
    return $gRqVZ.useMemo(()=>refA == null && refB == null ? null : (refValue)=>{
            $c552f4c6f5978452$export$4bb192c7cacf928f(refA, refValue);
            $c552f4c6f5978452$export$4bb192c7cacf928f(refB, refValue);
        }, [
        refA,
        refB
    ]);
}
function $c552f4c6f5978452$export$2bd1c19440b9235c(focus, disabled = false) {
    const focused = $gRqVZ.useRef(false);
    $c552f4c6f5978452$export$e5c5a5f917a5871c(()=>{
        if (disabled && focused.current) {
            focused.current = false;
            focus();
        }
    }, [
        disabled,
        focus
    ]);
    const onFocus = $gRqVZ.useCallback(()=>{
        focused.current = true;
    }, []);
    const onBlur = $gRqVZ.useCallback(()=>{
        focused.current = false;
    }, []);
    return {
        onFocus: onFocus,
        onBlur: onBlur
    };
}
function $c552f4c6f5978452$export$81f015b3ec5d61cf() {
    return $c552f4c6f5978452$export$57c05a83b72fe7b().isRTL;
}
function $c552f4c6f5978452$export$19012f58216d597f() {
    const [subscribers] = $gRqVZ.useState({});
    const notifySubscribers = $gRqVZ.useCallback((type, event)=>{
        var _a;
        (_a = subscribers[type]) === null || _a === void 0 || _a.forEach((listener)=>{
            if (!event.isPropagationStopped()) listener(event);
        });
    }, [
        subscribers
    ]);
    const registerSensors = $gRqVZ.useMemo(()=>({
            onPointerDown: (event)=>notifySubscribers((0, $a036e438091559f5$export$e15fc153f45a963d), event),
            onPointerMove: (event)=>notifySubscribers((0, $a036e438091559f5$export$1f8863949fbdd7e5), event),
            onPointerUp: (event)=>notifySubscribers((0, $a036e438091559f5$export$2d868b67a5791b8a), event),
            onPointerLeave: (event)=>notifySubscribers((0, $a036e438091559f5$export$526cafa85592f1a5), event),
            onPointerCancel: (event)=>notifySubscribers((0, $a036e438091559f5$export$22151cee048c4be9), event),
            onKeyDown: (event)=>notifySubscribers((0, $a036e438091559f5$export$1aba4f3521686ca9), event),
            onKeyUp: (event)=>notifySubscribers((0, $a036e438091559f5$export$bdb9f99d61a6879b), event),
            onWheel: (event)=>notifySubscribers((0, $a036e438091559f5$export$5635dc9d647242c7), event)
        }), [
        notifySubscribers
    ]);
    const subscribeSensors = $gRqVZ.useCallback((type, callback)=>{
        if (!subscribers[type]) subscribers[type] = [];
        subscribers[type].unshift(callback);
        return ()=>{
            const listeners = subscribers[type];
            if (listeners) listeners.splice(0, listeners.length, ...listeners.filter((el)=>el !== callback));
        };
    }, [
        subscribers
    ]);
    return {
        registerSensors: registerSensors,
        subscribeSensors: subscribeSensors
    };
}
function $c552f4c6f5978452$export$8b7b9481d6186f21(callback, delay) {
    const lastCallbackTime = $gRqVZ.useRef(0);
    const delayCallback = $c552f4c6f5978452$export$69f38700ea0cb3b9();
    const executeCallback = $c552f4c6f5978452$export$ee5b5d04074a389e((...args)=>{
        lastCallbackTime.current = Date.now();
        callback(args);
    });
    return $gRqVZ.useCallback((...args)=>{
        delayCallback(()=>{
            executeCallback(args);
        }, delay - (Date.now() - lastCallbackTime.current));
    }, [
        delay,
        executeCallback,
        delayCallback
    ]);
}
const $c552f4c6f5978452$var$slidePrefix = $c552f4c6f5978452$export$3e7cd27eed1727c("slide");
const $c552f4c6f5978452$var$slideImagePrefix = $c552f4c6f5978452$export$3e7cd27eed1727c("slide_image");
function $c552f4c6f5978452$export$ef86b1d52c77b27b({ slide: image, offset: offset, render: render, rect: rect, imageFit: imageFit, imageProps: imageProps, onClick: onClick, onLoad: onLoad, onError: onError, style: style }) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const [status, setStatus] = $gRqVZ.useState((0, $a036e438091559f5$export$554a1415841c52a8));
    const { publish: publish } = $c552f4c6f5978452$export$91a992459f6e0f07();
    const { setTimeout: setTimeout } = $c552f4c6f5978452$export$1bc7162631c81b3f();
    const imageRef = $gRqVZ.useRef(null);
    $gRqVZ.useEffect(()=>{
        if (offset === 0) publish((0, $a036e438091559f5$export$6751782e799f6445)(status));
    }, [
        offset,
        status,
        publish
    ]);
    const handleLoading = $c552f4c6f5978452$export$ee5b5d04074a389e((img)=>{
        ("decode" in img ? img.decode() : Promise.resolve()).catch(()=>{}).then(()=>{
            if (!img.parentNode) return;
            setStatus((0, $a036e438091559f5$export$a195e517d37aaa33));
            setTimeout(()=>{
                onLoad === null || onLoad === void 0 || onLoad(img);
            }, 0);
        });
    });
    const setImageRef = $gRqVZ.useCallback((img)=>{
        imageRef.current = img;
        if (img === null || img === void 0 ? void 0 : img.complete) handleLoading(img);
    }, [
        handleLoading
    ]);
    const handleOnLoad = $gRqVZ.useCallback((event)=>{
        handleLoading(event.currentTarget);
    }, [
        handleLoading
    ]);
    const handleOnError = $c552f4c6f5978452$export$ee5b5d04074a389e(()=>{
        setStatus((0, $a036e438091559f5$export$2ed3c80dbc178d91));
        onError === null || onError === void 0 || onError();
    });
    const cover = $c552f4c6f5978452$export$f5ba2f5b3fd12e6e(image, imageFit);
    const nonInfinite = (value, fallback)=>Number.isFinite(value) ? value : fallback;
    const maxWidth = nonInfinite(Math.max(...((_b = (_a = image.srcSet) === null || _a === void 0 ? void 0 : _a.map((x)=>x.width)) !== null && _b !== void 0 ? _b : []).concat(image.width ? [
        image.width
    ] : []).filter(Boolean)), ((_c = imageRef.current) === null || _c === void 0 ? void 0 : _c.naturalWidth) || 0);
    const maxHeight = nonInfinite(Math.max(...((_e = (_d = image.srcSet) === null || _d === void 0 ? void 0 : _d.map((x)=>x.height)) !== null && _e !== void 0 ? _e : []).concat(image.height ? [
        image.height
    ] : []).filter(Boolean)), ((_f = imageRef.current) === null || _f === void 0 ? void 0 : _f.naturalHeight) || 0);
    const defaultStyle = maxWidth && maxHeight ? {
        maxWidth: `min(${maxWidth}px, 100%)`,
        maxHeight: `min(${maxHeight}px, 100%)`
    } : {
        maxWidth: "100%",
        maxHeight: "100%"
    };
    const srcSet = (_g = image.srcSet) === null || _g === void 0 ? void 0 : _g.slice().sort((a, b)=>a.width - b.width).map((item)=>`${item.src} ${item.width}w`).join(", ");
    const estimateActualWidth = ()=>rect && !cover && image.width && image.height ? rect.height / image.height * image.width : Number.MAX_VALUE;
    const sizes = srcSet && rect && $c552f4c6f5978452$export$fef62134eea24008() ? `${Math.round(Math.min(estimateActualWidth(), rect.width))}px` : undefined;
    const { style: imagePropsStyle, className: imagePropsClassName, ...restImageProps } = (typeof imageProps === "function" ? imageProps(image) : imageProps) || {};
    return $gRqVZ.createElement($gRqVZ.Fragment, null, $gRqVZ.createElement("img", {
        ref: setImageRef,
        onLoad: handleOnLoad,
        onError: handleOnError,
        onClick: onClick,
        draggable: false,
        className: $c552f4c6f5978452$export$4f5d2d50c9deca37($c552f4c6f5978452$export$1283875077dc8f0a($c552f4c6f5978452$var$slideImagePrefix()), cover && $c552f4c6f5978452$export$1283875077dc8f0a($c552f4c6f5978452$var$slideImagePrefix("cover")), status !== (0, $a036e438091559f5$export$a195e517d37aaa33) && $c552f4c6f5978452$export$1283875077dc8f0a($c552f4c6f5978452$var$slideImagePrefix("loading")), imagePropsClassName),
        style: {
            ...defaultStyle,
            ...style,
            ...imagePropsStyle
        },
        ...restImageProps,
        alt: (_h = image.alt) !== null && _h !== void 0 ? _h : "",
        sizes: sizes,
        srcSet: srcSet,
        src: image.src
    }), status !== (0, $a036e438091559f5$export$a195e517d37aaa33) && $gRqVZ.createElement("div", {
        className: $c552f4c6f5978452$export$1283875077dc8f0a($c552f4c6f5978452$var$slidePrefix((0, $a036e438091559f5$export$e51f1c6d74b54a13)))
    }, status === (0, $a036e438091559f5$export$554a1415841c52a8) && ((render === null || render === void 0 ? void 0 : render.iconLoading) ? render.iconLoading() : $gRqVZ.createElement($c552f4c6f5978452$export$b936c55164dcf1db, {
        className: $c552f4c6f5978452$export$4f5d2d50c9deca37($c552f4c6f5978452$export$1283875077dc8f0a((0, $a036e438091559f5$export$c5f5ca1963fed141)), $c552f4c6f5978452$export$1283875077dc8f0a($c552f4c6f5978452$var$slidePrefix((0, $a036e438091559f5$export$554a1415841c52a8))))
    })), status === (0, $a036e438091559f5$export$2ed3c80dbc178d91) && ((render === null || render === void 0 ? void 0 : render.iconError) ? render.iconError() : $gRqVZ.createElement($c552f4c6f5978452$export$19bc16ee58e19b3d, {
        className: $c552f4c6f5978452$export$4f5d2d50c9deca37($c552f4c6f5978452$export$1283875077dc8f0a((0, $a036e438091559f5$export$c5f5ca1963fed141)), $c552f4c6f5978452$export$1283875077dc8f0a($c552f4c6f5978452$var$slidePrefix((0, $a036e438091559f5$export$2ed3c80dbc178d91))))
    }))));
}
const $c552f4c6f5978452$export$597a6f74cf288f82 = $gRqVZ.forwardRef(function LightboxRoot({ className: className, children: children, onFocus: onFocus, onBlur: onBlur, ...rest }, ref) {
    const nodeRef = $gRqVZ.useRef(null);
    const [isRTL, setIsRTL] = $gRqVZ.useState(false);
    const { trackFocusWithin: trackFocusWithin } = $c552f4c6f5978452$export$3992c64d261ded5a();
    const detectRTL = $c552f4c6f5978452$export$ee5b5d04074a389e(()=>{
        if (nodeRef.current) {
            const rtl = window.getComputedStyle(nodeRef.current).direction === "rtl";
            if (rtl !== isRTL) setIsRTL(rtl);
        }
    });
    $gRqVZ.useEffect(detectRTL);
    return $gRqVZ.createElement($c552f4c6f5978452$export$30e869153d18a2e6, {
        nodeRef: nodeRef
    }, $gRqVZ.createElement($c552f4c6f5978452$export$625eb40e2215f320, {
        isRTL: isRTL
    }, $gRqVZ.createElement("div", {
        ref: $c552f4c6f5978452$export$ebc1e1560c2dffa5(ref, nodeRef),
        className: $c552f4c6f5978452$export$4f5d2d50c9deca37($c552f4c6f5978452$export$1283875077dc8f0a("root"), className),
        ...trackFocusWithin(onFocus, onBlur),
        ...rest
    }, children)));
});
var $c552f4c6f5978452$export$59f0048f451fc458;
(function(SwipeState) {
    SwipeState[SwipeState["NONE"] = 0] = "NONE";
    SwipeState[SwipeState["SWIPE"] = 1] = "SWIPE";
    SwipeState[SwipeState["PULL"] = 2] = "PULL";
    SwipeState[SwipeState["ANIMATION"] = 3] = "ANIMATION";
})($c552f4c6f5978452$export$59f0048f451fc458 || ($c552f4c6f5978452$export$59f0048f451fc458 = {}));
function $c552f4c6f5978452$export$69c48c1cbbd6dc69(subscribeSensors, onPointerDown, onPointerMove, onPointerUp, disabled) {
    $gRqVZ.useEffect(()=>!disabled ? $c552f4c6f5978452$export$de863c629cb9919d(subscribeSensors((0, $a036e438091559f5$export$e15fc153f45a963d), onPointerDown), subscribeSensors((0, $a036e438091559f5$export$1f8863949fbdd7e5), onPointerMove), subscribeSensors((0, $a036e438091559f5$export$2d868b67a5791b8a), onPointerUp), subscribeSensors((0, $a036e438091559f5$export$526cafa85592f1a5), onPointerUp), subscribeSensors((0, $a036e438091559f5$export$22151cee048c4be9), onPointerUp)) : ()=>{}, [
        subscribeSensors,
        onPointerDown,
        onPointerMove,
        onPointerUp,
        disabled
    ]);
}
var $c552f4c6f5978452$var$Gesture;
(function(Gesture) {
    Gesture[Gesture["NONE"] = 0] = "NONE";
    Gesture[Gesture["SWIPE"] = 1] = "SWIPE";
    Gesture[Gesture["PULL"] = 2] = "PULL";
})($c552f4c6f5978452$var$Gesture || ($c552f4c6f5978452$var$Gesture = {}));
const $c552f4c6f5978452$var$SWIPE_THRESHOLD = 30;
function $c552f4c6f5978452$export$abaee32ee49963c1({ disableSwipeNavigation: disableSwipeNavigation, closeOnBackdropClick: closeOnBackdropClick }, subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel, pullUpEnabled, pullDownEnabled, onPullStart, onPullProgress, onPullFinish, onPullCancel, onClose) {
    const offset = $gRqVZ.useRef(0);
    const pointers = $gRqVZ.useRef([]);
    const activePointer = $gRqVZ.useRef(undefined);
    const startTime = $gRqVZ.useRef(0);
    const gesture = $gRqVZ.useRef($c552f4c6f5978452$var$Gesture.NONE);
    const clearPointer = $gRqVZ.useCallback((event)=>{
        if (activePointer.current === event.pointerId) {
            activePointer.current = undefined;
            gesture.current = $c552f4c6f5978452$var$Gesture.NONE;
        }
        const currentPointers = pointers.current;
        currentPointers.splice(0, currentPointers.length, ...currentPointers.filter((p)=>p.pointerId !== event.pointerId));
    }, []);
    const addPointer = $gRqVZ.useCallback((event)=>{
        clearPointer(event);
        event.persist();
        pointers.current.push(event);
    }, [
        clearPointer
    ]);
    const lookupPointer = $gRqVZ.useCallback((event)=>pointers.current.find(({ pointerId: pointerId })=>event.pointerId === pointerId), []);
    const onPointerDown = $c552f4c6f5978452$export$ee5b5d04074a389e((event)=>{
        addPointer(event);
    });
    const exceedsPullThreshold = (value, threshold)=>pullDownEnabled && value > threshold || pullUpEnabled && value < -threshold;
    const onPointerUp = $c552f4c6f5978452$export$ee5b5d04074a389e((event)=>{
        const pointer = lookupPointer(event);
        if (pointer) {
            if (activePointer.current === event.pointerId) {
                const duration = Date.now() - startTime.current;
                const currentOffset = offset.current;
                if (gesture.current === $c552f4c6f5978452$var$Gesture.SWIPE) {
                    if (Math.abs(currentOffset) > 0.3 * containerWidth || Math.abs(currentOffset) > 5 && duration < swipeAnimationDuration) onSwipeFinish(currentOffset, duration);
                    else onSwipeCancel(currentOffset);
                } else if (gesture.current === $c552f4c6f5978452$var$Gesture.PULL) {
                    if (exceedsPullThreshold(currentOffset, 2 * $c552f4c6f5978452$var$SWIPE_THRESHOLD)) onPullFinish(currentOffset, duration);
                    else onPullCancel(currentOffset);
                }
                offset.current = 0;
                gesture.current = $c552f4c6f5978452$var$Gesture.NONE;
            } else {
                const { target: target } = event;
                if (closeOnBackdropClick && target instanceof HTMLElement && target === pointer.target && (target.classList.contains($c552f4c6f5978452$export$1283875077dc8f0a((0, $a036e438091559f5$export$8d922915837a38d3))) || target.classList.contains($c552f4c6f5978452$export$1283875077dc8f0a((0, $a036e438091559f5$export$ac396c284080b10c))))) onClose();
            }
        }
        clearPointer(event);
    });
    const onPointerMove = $c552f4c6f5978452$export$ee5b5d04074a389e((event)=>{
        const pointer = lookupPointer(event);
        if (pointer) {
            const isCurrentPointer = activePointer.current === event.pointerId;
            if (event.buttons === 0) {
                if (isCurrentPointer && offset.current !== 0) onPointerUp(event);
                else clearPointer(pointer);
                return;
            }
            const deltaX = event.clientX - pointer.clientX;
            const deltaY = event.clientY - pointer.clientY;
            if (activePointer.current === undefined) {
                const startGesture = (newGesture)=>{
                    addPointer(event);
                    activePointer.current = event.pointerId;
                    startTime.current = Date.now();
                    gesture.current = newGesture;
                };
                if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > $c552f4c6f5978452$var$SWIPE_THRESHOLD && isSwipeValid(deltaX)) {
                    if (!disableSwipeNavigation) {
                        startGesture($c552f4c6f5978452$var$Gesture.SWIPE);
                        onSwipeStart();
                    }
                } else if (Math.abs(deltaY) > Math.abs(deltaX) && exceedsPullThreshold(deltaY, $c552f4c6f5978452$var$SWIPE_THRESHOLD)) {
                    startGesture($c552f4c6f5978452$var$Gesture.PULL);
                    onPullStart();
                }
            } else if (isCurrentPointer) {
                if (gesture.current === $c552f4c6f5978452$var$Gesture.SWIPE) {
                    offset.current = deltaX;
                    onSwipeProgress(deltaX);
                } else if (gesture.current === $c552f4c6f5978452$var$Gesture.PULL) {
                    offset.current = deltaY;
                    onPullProgress(deltaY);
                }
            }
        }
    });
    $c552f4c6f5978452$export$69c48c1cbbd6dc69(subscribeSensors, onPointerDown, onPointerMove, onPointerUp);
}
function $c552f4c6f5978452$export$145fefb2d7286388({ preventDefaultWheelX: preventDefaultWheelX, preventDefaultWheelY: preventDefaultWheelY }) {
    const ref = $gRqVZ.useRef(null);
    const listener = $c552f4c6f5978452$export$ee5b5d04074a389e((event)=>{
        const horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
        if (horizontal && preventDefaultWheelX || !horizontal && preventDefaultWheelY || event.ctrlKey) event.preventDefault();
    });
    return $gRqVZ.useCallback((node)=>{
        var _a;
        if (node) node.addEventListener("wheel", listener, {
            passive: false
        });
        else (_a = ref.current) === null || _a === void 0 || _a.removeEventListener("wheel", listener);
        ref.current = node;
    }, [
        listener
    ]);
}
function $c552f4c6f5978452$export$10506de8b6841445(swipeState, subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel) {
    const offset = $gRqVZ.useRef(0);
    const intent = $gRqVZ.useRef(0);
    const intentCleanup = $gRqVZ.useRef(undefined);
    const resetCleanup = $gRqVZ.useRef(undefined);
    const wheelInertia = $gRqVZ.useRef(0);
    const wheelInertiaCleanup = $gRqVZ.useRef(undefined);
    const startTime = $gRqVZ.useRef(0);
    const { setTimeout: setTimeout, clearTimeout: clearTimeout } = $c552f4c6f5978452$export$1bc7162631c81b3f();
    const cancelSwipeIntentCleanup = $gRqVZ.useCallback(()=>{
        if (intentCleanup.current) {
            clearTimeout(intentCleanup.current);
            intentCleanup.current = undefined;
        }
    }, [
        clearTimeout
    ]);
    const cancelSwipeResetCleanup = $gRqVZ.useCallback(()=>{
        if (resetCleanup.current) {
            clearTimeout(resetCleanup.current);
            resetCleanup.current = undefined;
        }
    }, [
        clearTimeout
    ]);
    const handleCleanup = $c552f4c6f5978452$export$ee5b5d04074a389e(()=>{
        if (swipeState !== $c552f4c6f5978452$export$59f0048f451fc458.SWIPE) {
            offset.current = 0;
            startTime.current = 0;
            cancelSwipeIntentCleanup();
            cancelSwipeResetCleanup();
        }
    });
    $gRqVZ.useEffect(handleCleanup, [
        swipeState,
        handleCleanup
    ]);
    const handleCancelSwipe = $c552f4c6f5978452$export$ee5b5d04074a389e((currentSwipeOffset)=>{
        resetCleanup.current = undefined;
        if (offset.current === currentSwipeOffset) onSwipeCancel(offset.current);
    });
    const onWheel = $c552f4c6f5978452$export$ee5b5d04074a389e((event)=>{
        if (event.ctrlKey) return;
        if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) return;
        const setWheelInertia = (inertia)=>{
            wheelInertia.current = inertia;
            clearTimeout(wheelInertiaCleanup.current);
            wheelInertiaCleanup.current = inertia > 0 ? setTimeout(()=>{
                wheelInertia.current = 0;
                wheelInertiaCleanup.current = undefined;
            }, 300) : undefined;
        };
        if (swipeState === $c552f4c6f5978452$export$59f0048f451fc458.NONE) {
            if (Math.abs(event.deltaX) <= 1.2 * Math.abs(wheelInertia.current)) {
                setWheelInertia(event.deltaX);
                return;
            }
            if (!isSwipeValid(-event.deltaX)) return;
            intent.current += event.deltaX;
            cancelSwipeIntentCleanup();
            if (Math.abs(intent.current) > 30) {
                intent.current = 0;
                setWheelInertia(0);
                startTime.current = Date.now();
                onSwipeStart();
            } else {
                const currentSwipeIntent = intent.current;
                intentCleanup.current = setTimeout(()=>{
                    intentCleanup.current = undefined;
                    if (currentSwipeIntent === intent.current) intent.current = 0;
                }, swipeAnimationDuration);
            }
        } else if (swipeState === $c552f4c6f5978452$export$59f0048f451fc458.SWIPE) {
            let newSwipeOffset = offset.current - event.deltaX;
            newSwipeOffset = Math.min(Math.abs(newSwipeOffset), containerWidth) * Math.sign(newSwipeOffset);
            offset.current = newSwipeOffset;
            onSwipeProgress(newSwipeOffset);
            cancelSwipeResetCleanup();
            if (Math.abs(newSwipeOffset) > 0.2 * containerWidth) {
                setWheelInertia(event.deltaX);
                onSwipeFinish(newSwipeOffset, Date.now() - startTime.current);
                return;
            }
            resetCleanup.current = setTimeout(()=>handleCancelSwipe(newSwipeOffset), 2 * swipeAnimationDuration);
        } else setWheelInertia(event.deltaX);
    });
    $gRqVZ.useEffect(()=>subscribeSensors((0, $a036e438091559f5$export$5635dc9d647242c7), onWheel), [
        subscribeSensors,
        onWheel
    ]);
}
const $c552f4c6f5978452$var$cssContainerPrefix = $c552f4c6f5978452$export$3e7cd27eed1727c("container");
const $c552f4c6f5978452$export$e92ff191b0c59550 = $gRqVZ.createContext(null);
const $c552f4c6f5978452$export$e8c786024a2b0a79 = $c552f4c6f5978452$export$aac3e49c3c8b5cb0("useController", "ControllerContext", $c552f4c6f5978452$export$e92ff191b0c59550);
function $c552f4c6f5978452$export$bd0bf19f25da8474({ children: children, ...props }) {
    var _a;
    const { carousel: carousel, animation: animation, controller: controller, on: on, styles: styles, render: render } = props;
    const { closeOnPullUp: closeOnPullUp, closeOnPullDown: closeOnPullDown, preventDefaultWheelX: preventDefaultWheelX, preventDefaultWheelY: preventDefaultWheelY } = controller;
    const [toolbarWidth, setToolbarWidth] = $gRqVZ.useState();
    const state = $c552f4c6f5978452$export$566121e2bbc52eec();
    const dispatch = $c552f4c6f5978452$export$9463bb14d6ba055e();
    const [swipeState, setSwipeState] = $gRqVZ.useState($c552f4c6f5978452$export$59f0048f451fc458.NONE);
    const swipeOffset = $gRqVZ.useRef(0);
    const pullOffset = $gRqVZ.useRef(0);
    const pullOpacity = $gRqVZ.useRef(1);
    const { registerSensors: registerSensors, subscribeSensors: subscribeSensors } = $c552f4c6f5978452$export$19012f58216d597f();
    const { subscribe: subscribe, publish: publish } = $c552f4c6f5978452$export$91a992459f6e0f07();
    const cleanupAnimationIncrement = $c552f4c6f5978452$export$69f38700ea0cb3b9();
    const cleanupSwipeOffset = $c552f4c6f5978452$export$69f38700ea0cb3b9();
    const cleanupPullOffset = $c552f4c6f5978452$export$69f38700ea0cb3b9();
    const { containerRef: containerRef, setContainerRef: setContainerRef, containerRect: containerRect } = $c552f4c6f5978452$export$b1d85de58d38d09d();
    const handleContainerRef = $c552f4c6f5978452$export$ebc1e1560c2dffa5($c552f4c6f5978452$export$145fefb2d7286388({
        preventDefaultWheelX: preventDefaultWheelX,
        preventDefaultWheelY: preventDefaultWheelY
    }), setContainerRef);
    const carouselRef = $gRqVZ.useRef(null);
    const setCarouselRef = $c552f4c6f5978452$export$ebc1e1560c2dffa5(carouselRef, undefined);
    const { getOwnerDocument: getOwnerDocument } = $c552f4c6f5978452$export$c199d36c2862b6ed();
    const isRTL = $c552f4c6f5978452$export$81f015b3ec5d61cf();
    const rtl = (value)=>(isRTL ? -1 : 1) * (typeof value === "number" ? value : 1);
    const focus = $c552f4c6f5978452$export$ee5b5d04074a389e(()=>{
        var _a;
        return (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    });
    const getLightboxProps = $c552f4c6f5978452$export$ee5b5d04074a389e(()=>props);
    const getLightboxState = $c552f4c6f5978452$export$ee5b5d04074a389e(()=>state);
    const prev = $gRqVZ.useCallback((params)=>publish((0, $a036e438091559f5$export$a007161537026955), params), [
        publish
    ]);
    const next = $gRqVZ.useCallback((params)=>publish((0, $a036e438091559f5$export$f1d7a854db833ed4), params), [
        publish
    ]);
    const close = $gRqVZ.useCallback(()=>publish((0, $a036e438091559f5$export$493a596486210a21)), [
        publish
    ]);
    const isSwipeValid = (offset)=>!(carousel.finite && (rtl(offset) > 0 && state.currentIndex === 0 || rtl(offset) < 0 && state.currentIndex === state.slides.length - 1));
    const setSwipeOffset = (offset)=>{
        var _a;
        swipeOffset.current = offset;
        (_a = containerRef.current) === null || _a === void 0 || _a.style.setProperty($c552f4c6f5978452$export$8b4981022bd80a4e("swipe_offset"), `${Math.round(offset)}px`);
    };
    const setPullOffset = (offset)=>{
        var _a, _b;
        pullOffset.current = offset;
        pullOpacity.current = (()=>{
            const threshold = 60;
            const minOpacity = 0.5;
            const offsetValue = (()=>{
                if (closeOnPullDown && offset > 0) return offset;
                if (closeOnPullUp && offset < 0) return -offset;
                return 0;
            })();
            return Math.min(Math.max($c552f4c6f5978452$export$2077e0241d6afd3c(1 - offsetValue / threshold * (1 - minOpacity), 2), minOpacity), 1);
        })();
        (_a = containerRef.current) === null || _a === void 0 || _a.style.setProperty($c552f4c6f5978452$export$8b4981022bd80a4e("pull_offset"), `${Math.round(offset)}px`);
        (_b = containerRef.current) === null || _b === void 0 || _b.style.setProperty($c552f4c6f5978452$export$8b4981022bd80a4e("pull_opacity"), `${pullOpacity.current}`);
    };
    const { prepareAnimation: preparePullAnimation } = $c552f4c6f5978452$export$9e2608686d4ad846(carouselRef, (snapshot, rect, translate)=>{
        if (carouselRef.current && containerRect) return {
            keyframes: [
                {
                    transform: `translate(0, ${snapshot.rect.y - rect.y + translate.y}px)`,
                    opacity: snapshot.opacity
                },
                {
                    transform: "translate(0, 0)",
                    opacity: 1
                }
            ],
            duration: snapshot.duration,
            easing: animation.easing.fade
        };
        return undefined;
    });
    const pull = (offset, cancel)=>{
        if (closeOnPullUp || closeOnPullDown) {
            setPullOffset(offset);
            let duration = 0;
            if (carouselRef.current) {
                duration = animation.fade * (cancel ? 2 : 1);
                preparePullAnimation({
                    rect: carouselRef.current.getBoundingClientRect(),
                    opacity: pullOpacity.current,
                    duration: duration
                });
            }
            cleanupPullOffset(()=>{
                setPullOffset(0);
                setSwipeState($c552f4c6f5978452$export$59f0048f451fc458.NONE);
            }, duration);
            setSwipeState($c552f4c6f5978452$export$59f0048f451fc458.ANIMATION);
            if (!cancel) close();
        }
    };
    const { prepareAnimation: prepareAnimation, isAnimationPlaying: isAnimationPlaying } = $c552f4c6f5978452$export$9e2608686d4ad846(carouselRef, (snapshot, rect, translate)=>{
        var _a;
        if (carouselRef.current && containerRect && ((_a = state.animation) === null || _a === void 0 ? void 0 : _a.duration)) {
            const parsedSpacing = $c552f4c6f5978452$export$7871fb532d320d99(carousel.spacing);
            const spacingValue = (parsedSpacing.percent ? parsedSpacing.percent * containerRect.width / 100 : parsedSpacing.pixel) || 0;
            return {
                keyframes: [
                    {
                        transform: `translate(${rtl(state.globalIndex - snapshot.index) * (containerRect.width + spacingValue) + snapshot.rect.x - rect.x + translate.x}px, 0)`
                    },
                    {
                        transform: "translate(0, 0)"
                    }
                ],
                duration: state.animation.duration,
                easing: state.animation.easing
            };
        }
        return undefined;
    });
    const swipe = $c552f4c6f5978452$export$ee5b5d04074a389e((action)=>{
        var _a, _b;
        const currentSwipeOffset = action.offset || 0;
        const swipeDuration = !currentSwipeOffset ? (_a = animation.navigation) !== null && _a !== void 0 ? _a : animation.swipe : animation.swipe;
        const swipeEasing = !currentSwipeOffset && !isAnimationPlaying() ? animation.easing.navigation : animation.easing.swipe;
        let { direction: direction } = action;
        const count = (_b = action.count) !== null && _b !== void 0 ? _b : 1;
        let newSwipeState = $c552f4c6f5978452$export$59f0048f451fc458.ANIMATION;
        let newSwipeAnimationDuration = swipeDuration * count;
        if (!direction) {
            const containerWidth = containerRect === null || containerRect === void 0 ? void 0 : containerRect.width;
            const elapsedTime = action.duration || 0;
            const expectedTime = containerWidth ? swipeDuration / containerWidth * Math.abs(currentSwipeOffset) : swipeDuration;
            if (count !== 0) {
                if (elapsedTime < expectedTime) newSwipeAnimationDuration = newSwipeAnimationDuration / expectedTime * Math.max(elapsedTime, expectedTime / 5);
                else if (containerWidth) newSwipeAnimationDuration = swipeDuration / containerWidth * (containerWidth - Math.abs(currentSwipeOffset));
                direction = rtl(currentSwipeOffset) > 0 ? (0, $a036e438091559f5$export$a007161537026955) : (0, $a036e438091559f5$export$f1d7a854db833ed4);
            } else newSwipeAnimationDuration = swipeDuration / 2;
        }
        let increment = 0;
        if (direction === (0, $a036e438091559f5$export$a007161537026955)) {
            if (isSwipeValid(rtl(1))) increment = -count;
            else {
                newSwipeState = $c552f4c6f5978452$export$59f0048f451fc458.NONE;
                newSwipeAnimationDuration = swipeDuration;
            }
        } else if (direction === (0, $a036e438091559f5$export$f1d7a854db833ed4)) {
            if (isSwipeValid(rtl(-1))) increment = count;
            else {
                newSwipeState = $c552f4c6f5978452$export$59f0048f451fc458.NONE;
                newSwipeAnimationDuration = swipeDuration;
            }
        }
        newSwipeAnimationDuration = Math.round(newSwipeAnimationDuration);
        cleanupSwipeOffset(()=>{
            setSwipeOffset(0);
            setSwipeState($c552f4c6f5978452$export$59f0048f451fc458.NONE);
        }, newSwipeAnimationDuration);
        if (carouselRef.current) prepareAnimation({
            rect: carouselRef.current.getBoundingClientRect(),
            index: state.globalIndex
        });
        setSwipeState(newSwipeState);
        publish((0, $a036e438091559f5$export$c43bd1a4101c4078), {
            type: "swipe",
            increment: increment,
            duration: newSwipeAnimationDuration,
            easing: swipeEasing
        });
    });
    $gRqVZ.useEffect(()=>{
        var _a, _b;
        if (((_a = state.animation) === null || _a === void 0 ? void 0 : _a.increment) && ((_b = state.animation) === null || _b === void 0 ? void 0 : _b.duration)) cleanupAnimationIncrement(()=>dispatch({
                type: "swipe",
                increment: 0
            }), state.animation.duration);
    }, [
        state.animation,
        dispatch,
        cleanupAnimationIncrement
    ]);
    const swipeParams = [
        subscribeSensors,
        isSwipeValid,
        (containerRect === null || containerRect === void 0 ? void 0 : containerRect.width) || 0,
        animation.swipe,
        ()=>setSwipeState($c552f4c6f5978452$export$59f0048f451fc458.SWIPE),
        (offset)=>setSwipeOffset(offset),
        (offset, duration)=>swipe({
                offset: offset,
                duration: duration,
                count: 1
            }),
        (offset)=>swipe({
                offset: offset,
                count: 0
            })
    ];
    const pullParams = [
        ()=>{
            if (closeOnPullDown) setSwipeState($c552f4c6f5978452$export$59f0048f451fc458.PULL);
        },
        (offset)=>setPullOffset(offset),
        (offset)=>pull(offset),
        (offset)=>pull(offset, true)
    ];
    $c552f4c6f5978452$export$abaee32ee49963c1(controller, ...swipeParams, closeOnPullUp, closeOnPullDown, ...pullParams, close);
    $c552f4c6f5978452$export$10506de8b6841445(swipeState, ...swipeParams);
    const focusOnMount = $c552f4c6f5978452$export$ee5b5d04074a389e(()=>{
        if (controller.focus && getOwnerDocument().querySelector(`.${$c552f4c6f5978452$export$1283875077dc8f0a((0, $a036e438091559f5$export$9d2e4856063e1a22))} .${$c552f4c6f5978452$export$1283875077dc8f0a($c552f4c6f5978452$var$cssContainerPrefix())}`)) focus();
    });
    $gRqVZ.useEffect(focusOnMount, [
        focusOnMount
    ]);
    const onViewCallback = $c552f4c6f5978452$export$ee5b5d04074a389e(()=>{
        var _a;
        (_a = on.view) === null || _a === void 0 || _a.call(on, {
            index: state.currentIndex
        });
    });
    $gRqVZ.useEffect(onViewCallback, [
        state.globalIndex,
        onViewCallback
    ]);
    $gRqVZ.useEffect(()=>$c552f4c6f5978452$export$de863c629cb9919d(subscribe((0, $a036e438091559f5$export$a007161537026955), (action)=>swipe({
                direction: (0, $a036e438091559f5$export$a007161537026955),
                ...action
            })), subscribe((0, $a036e438091559f5$export$f1d7a854db833ed4), (action)=>swipe({
                direction: (0, $a036e438091559f5$export$f1d7a854db833ed4),
                ...action
            })), subscribe((0, $a036e438091559f5$export$c43bd1a4101c4078), (action)=>dispatch(action))), [
        subscribe,
        swipe,
        dispatch
    ]);
    const context = $gRqVZ.useMemo(()=>({
            prev: prev,
            next: next,
            close: close,
            focus: focus,
            slideRect: containerRect ? $c552f4c6f5978452$export$7ff571008bce9900(containerRect, carousel.padding) : {
                width: 0,
                height: 0
            },
            containerRect: containerRect || {
                width: 0,
                height: 0
            },
            subscribeSensors: subscribeSensors,
            containerRef: containerRef,
            setCarouselRef: setCarouselRef,
            toolbarWidth: toolbarWidth,
            setToolbarWidth: setToolbarWidth
        }), [
        prev,
        next,
        close,
        focus,
        subscribeSensors,
        containerRect,
        containerRef,
        setCarouselRef,
        toolbarWidth,
        setToolbarWidth,
        carousel.padding
    ]);
    $gRqVZ.useImperativeHandle(controller.ref, ()=>({
            prev: prev,
            next: next,
            close: close,
            focus: focus,
            getLightboxProps: getLightboxProps,
            getLightboxState: getLightboxState
        }), [
        prev,
        next,
        close,
        focus,
        getLightboxProps,
        getLightboxState
    ]);
    return $gRqVZ.createElement("div", {
        ref: handleContainerRef,
        className: $c552f4c6f5978452$export$4f5d2d50c9deca37($c552f4c6f5978452$export$1283875077dc8f0a($c552f4c6f5978452$var$cssContainerPrefix()), $c552f4c6f5978452$export$1283875077dc8f0a((0, $a036e438091559f5$export$974a68ef150451f5))),
        style: {
            ...swipeState === $c552f4c6f5978452$export$59f0048f451fc458.SWIPE ? {
                [$c552f4c6f5978452$export$8b4981022bd80a4e("swipe_offset")]: `${Math.round(swipeOffset.current)}px`
            } : null,
            ...swipeState === $c552f4c6f5978452$export$59f0048f451fc458.PULL ? {
                [$c552f4c6f5978452$export$8b4981022bd80a4e("pull_offset")]: `${Math.round(pullOffset.current)}px`,
                [$c552f4c6f5978452$export$8b4981022bd80a4e("pull_opacity")]: `${pullOpacity.current}`
            } : null,
            ...controller.touchAction !== "none" ? {
                [$c552f4c6f5978452$export$8b4981022bd80a4e("controller_touch_action")]: controller.touchAction
            } : null,
            ...styles.container
        },
        tabIndex: -1,
        ...registerSensors
    }, containerRect && $gRqVZ.createElement($c552f4c6f5978452$export$e92ff191b0c59550.Provider, {
        value: context
    }, children, (_a = render.controls) === null || _a === void 0 ? void 0 : _a.call(render)));
}
const $c552f4c6f5978452$export$be59d34228c8ec8a = $c552f4c6f5978452$export$c5ba3739ffba980d((0, $a036e438091559f5$export$b861c6f4d58b4c2f), $c552f4c6f5978452$export$bd0bf19f25da8474);
function $c552f4c6f5978452$var$cssPrefix$2(value) {
    return $c552f4c6f5978452$export$195c4126907dde97((0, $a036e438091559f5$export$83fe3bee12eb51bb), value);
}
function $c552f4c6f5978452$var$cssSlidePrefix(value) {
    return $c552f4c6f5978452$export$195c4126907dde97((0, $a036e438091559f5$export$8d922915837a38d3), value);
}
function $c552f4c6f5978452$var$CarouselSlide({ slide: slide, offset: offset }) {
    const containerRef = $gRqVZ.useRef(null);
    const { currentIndex: currentIndex, slides: slides } = $c552f4c6f5978452$export$566121e2bbc52eec();
    const { slideRect: slideRect, focus: focus } = $c552f4c6f5978452$export$e8c786024a2b0a79();
    const { render: render, carousel: { imageFit: imageFit, imageProps: imageProps }, on: { click: onClick }, styles: { slide: style }, labels: labels } = $c552f4c6f5978452$export$d930f3536e1c64f6();
    const { getOwnerDocument: getOwnerDocument } = $c552f4c6f5978452$export$c199d36c2862b6ed();
    const offscreen = offset !== 0;
    $gRqVZ.useEffect(()=>{
        var _a;
        if (offscreen && ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(getOwnerDocument().activeElement))) focus();
    }, [
        offscreen,
        focus,
        getOwnerDocument
    ]);
    const renderSlide = ()=>{
        var _a, _b, _c, _d;
        let rendered = (_a = render.slide) === null || _a === void 0 ? void 0 : _a.call(render, {
            slide: slide,
            offset: offset,
            rect: slideRect
        });
        if (!rendered && $c552f4c6f5978452$export$55ec18c411514c07(slide)) rendered = $gRqVZ.createElement($c552f4c6f5978452$export$ef86b1d52c77b27b, {
            slide: slide,
            offset: offset,
            render: render,
            rect: slideRect,
            imageFit: imageFit,
            imageProps: imageProps,
            onClick: !offscreen ? ()=>onClick === null || onClick === void 0 ? void 0 : onClick({
                    index: currentIndex
                }) : undefined
        });
        return rendered ? $gRqVZ.createElement($gRqVZ.Fragment, null, (_b = render.slideHeader) === null || _b === void 0 ? void 0 : _b.call(render, {
            slide: slide
        }), ((_c = render.slideContainer) !== null && _c !== void 0 ? _c : ({ children: children })=>children)({
            slide: slide,
            children: rendered
        }), (_d = render.slideFooter) === null || _d === void 0 ? void 0 : _d.call(render, {
            slide: slide
        })) : null;
    };
    return $gRqVZ.createElement("div", {
        ref: containerRef,
        className: $c552f4c6f5978452$export$4f5d2d50c9deca37($c552f4c6f5978452$export$1283875077dc8f0a($c552f4c6f5978452$var$cssSlidePrefix()), !offscreen && $c552f4c6f5978452$export$1283875077dc8f0a($c552f4c6f5978452$var$cssSlidePrefix("current")), $c552f4c6f5978452$export$1283875077dc8f0a((0, $a036e438091559f5$export$974a68ef150451f5))),
        ...$c552f4c6f5978452$export$9c64d01b28c1f747(offscreen),
        style: style,
        role: "group",
        "aria-roledescription": $c552f4c6f5978452$export$1c4d965eb6f65dfa(labels, "Slide"),
        "aria-label": $c552f4c6f5978452$export$77152303d9076b8(labels, slides, currentIndex + offset)
    }, renderSlide());
}
function $c552f4c6f5978452$var$Placeholder() {
    const style = $c552f4c6f5978452$export$d930f3536e1c64f6().styles.slide;
    return $gRqVZ.createElement("div", {
        className: $c552f4c6f5978452$export$1283875077dc8f0a((0, $a036e438091559f5$export$8d922915837a38d3)),
        style: style
    });
}
function $c552f4c6f5978452$export$144901db2ea8e967({ carousel: carousel, labels: labels }) {
    const { slides: slides, currentIndex: currentIndex, globalIndex: globalIndex } = $c552f4c6f5978452$export$566121e2bbc52eec();
    const { setCarouselRef: setCarouselRef } = $c552f4c6f5978452$export$e8c786024a2b0a79();
    const { autoPlaying: autoPlaying, focusWithin: focusWithin } = $c552f4c6f5978452$export$3992c64d261ded5a();
    const spacingValue = $c552f4c6f5978452$export$7871fb532d320d99(carousel.spacing);
    const paddingValue = $c552f4c6f5978452$export$7871fb532d320d99(carousel.padding);
    const preload = $c552f4c6f5978452$export$aab7f3145c728301(carousel, slides, 1);
    const items = [];
    if ($c552f4c6f5978452$export$883ece934910f98d(slides)) for(let index = currentIndex - preload; index <= currentIndex + preload; index += 1){
        const slide = $c552f4c6f5978452$export$cdfb855c5eb3bc84(slides, index);
        const key = globalIndex - currentIndex + index;
        const placeholder = carousel.finite && (index < 0 || index > slides.length - 1);
        items.push(!placeholder ? {
            key: [
                `${key}`,
                $c552f4c6f5978452$export$b2184449b7659b5a(slide)
            ].filter(Boolean).join("|"),
            offset: index - currentIndex,
            slide: slide
        } : {
            key: key
        });
    }
    return $gRqVZ.createElement("div", {
        ref: setCarouselRef,
        className: $c552f4c6f5978452$export$4f5d2d50c9deca37($c552f4c6f5978452$export$1283875077dc8f0a($c552f4c6f5978452$var$cssPrefix$2()), items.length > 0 && $c552f4c6f5978452$export$1283875077dc8f0a($c552f4c6f5978452$var$cssPrefix$2("with_slides"))),
        style: {
            [`${$c552f4c6f5978452$export$8b4981022bd80a4e($c552f4c6f5978452$var$cssPrefix$2("slides_count"))}`]: items.length,
            [`${$c552f4c6f5978452$export$8b4981022bd80a4e($c552f4c6f5978452$var$cssPrefix$2("spacing_px"))}`]: spacingValue.pixel || 0,
            [`${$c552f4c6f5978452$export$8b4981022bd80a4e($c552f4c6f5978452$var$cssPrefix$2("spacing_percent"))}`]: spacingValue.percent || 0,
            [`${$c552f4c6f5978452$export$8b4981022bd80a4e($c552f4c6f5978452$var$cssPrefix$2("padding_px"))}`]: paddingValue.pixel || 0,
            [`${$c552f4c6f5978452$export$8b4981022bd80a4e($c552f4c6f5978452$var$cssPrefix$2("padding_percent"))}`]: paddingValue.percent || 0
        },
        role: "region",
        "aria-live": autoPlaying && !focusWithin ? "off" : "polite",
        "aria-roledescription": $c552f4c6f5978452$export$1c4d965eb6f65dfa(labels, "Carousel"),
        "aria-label": $c552f4c6f5978452$export$1c4d965eb6f65dfa(labels, "Photo gallery")
    }, items.map(({ key: key, slide: slide, offset: offset })=>slide ? $gRqVZ.createElement($c552f4c6f5978452$var$CarouselSlide, {
            key: key,
            slide: slide,
            offset: offset
        }) : $gRqVZ.createElement($c552f4c6f5978452$var$Placeholder, {
            key: key
        })));
}
const $c552f4c6f5978452$export$9c087759a323a56c = $c552f4c6f5978452$export$c5ba3739ffba980d((0, $a036e438091559f5$export$83fe3bee12eb51bb), $c552f4c6f5978452$export$144901db2ea8e967);
function $c552f4c6f5978452$export$e482f4662aebc4a0() {
    const { carousel: carousel } = $c552f4c6f5978452$export$d930f3536e1c64f6();
    const { slides: slides, currentIndex: currentIndex } = $c552f4c6f5978452$export$566121e2bbc52eec();
    const prevDisabled = slides.length === 0 || carousel.finite && currentIndex === 0;
    const nextDisabled = slides.length === 0 || carousel.finite && currentIndex === slides.length - 1;
    return {
        prevDisabled: prevDisabled,
        nextDisabled: nextDisabled
    };
}
function $c552f4c6f5978452$export$4da28cf324280418(subscribeSensors) {
    var _a;
    const isRTL = $c552f4c6f5978452$export$81f015b3ec5d61cf();
    const { publish: publish } = $c552f4c6f5978452$export$91a992459f6e0f07();
    const { animation: animation } = $c552f4c6f5978452$export$d930f3536e1c64f6();
    const { prevDisabled: prevDisabled, nextDisabled: nextDisabled } = $c552f4c6f5978452$export$e482f4662aebc4a0();
    const throttle = ((_a = animation.navigation) !== null && _a !== void 0 ? _a : animation.swipe) / 2;
    const prev = $c552f4c6f5978452$export$8b7b9481d6186f21(()=>publish((0, $a036e438091559f5$export$a007161537026955)), throttle);
    const next = $c552f4c6f5978452$export$8b7b9481d6186f21(()=>publish((0, $a036e438091559f5$export$f1d7a854db833ed4)), throttle);
    const handleKeyDown = $c552f4c6f5978452$export$ee5b5d04074a389e((event)=>{
        switch(event.key){
            case 0, $a036e438091559f5$export$e8d60d9b5ceff7c0:
                publish((0, $a036e438091559f5$export$493a596486210a21));
                break;
            case 0, $a036e438091559f5$export$17dec1da9b0e2eb3:
                if (!(isRTL ? nextDisabled : prevDisabled)) (isRTL ? next : prev)();
                break;
            case 0, $a036e438091559f5$export$91898c0e7e48903:
                if (!(isRTL ? prevDisabled : nextDisabled)) (isRTL ? prev : next)();
                break;
            default:
        }
    });
    $gRqVZ.useEffect(()=>subscribeSensors((0, $a036e438091559f5$export$1aba4f3521686ca9), handleKeyDown), [
        subscribeSensors,
        handleKeyDown
    ]);
}
function $c552f4c6f5978452$export$e2d1bd910e689283({ label: label, icon: icon, renderIcon: renderIcon, action: action, onClick: onClick, disabled: disabled, style: style }) {
    return $gRqVZ.createElement($c552f4c6f5978452$export$c25acd513dcc8062, {
        label: label,
        icon: icon,
        renderIcon: renderIcon,
        className: $c552f4c6f5978452$export$1283875077dc8f0a(`navigation_${action}`),
        disabled: disabled,
        onClick: onClick,
        style: style,
        ...$c552f4c6f5978452$export$2bd1c19440b9235c($c552f4c6f5978452$export$e8c786024a2b0a79().focus, disabled)
    });
}
function $c552f4c6f5978452$export$b8a61e5c71402559({ render: { buttonPrev: buttonPrev, buttonNext: buttonNext, iconPrev: iconPrev, iconNext: iconNext }, styles: styles }) {
    const { prev: prev, next: next, subscribeSensors: subscribeSensors } = $c552f4c6f5978452$export$e8c786024a2b0a79();
    const { prevDisabled: prevDisabled, nextDisabled: nextDisabled } = $c552f4c6f5978452$export$e482f4662aebc4a0();
    $c552f4c6f5978452$export$4da28cf324280418(subscribeSensors);
    return $gRqVZ.createElement($gRqVZ.Fragment, null, buttonPrev ? buttonPrev() : $gRqVZ.createElement($c552f4c6f5978452$export$e2d1bd910e689283, {
        label: "Previous",
        action: (0, $a036e438091559f5$export$a007161537026955),
        icon: $c552f4c6f5978452$export$d05925e1c7f3f136,
        renderIcon: iconPrev,
        style: styles.navigationPrev,
        disabled: prevDisabled,
        onClick: prev
    }), buttonNext ? buttonNext() : $gRqVZ.createElement($c552f4c6f5978452$export$e2d1bd910e689283, {
        label: "Next",
        action: (0, $a036e438091559f5$export$f1d7a854db833ed4),
        icon: $c552f4c6f5978452$export$3da0e0ec94bd4ce1,
        renderIcon: iconNext,
        style: styles.navigationNext,
        disabled: nextDisabled,
        onClick: next
    }));
}
const $c552f4c6f5978452$export$6c16e1ac15089858 = $c552f4c6f5978452$export$c5ba3739ffba980d((0, $a036e438091559f5$export$607ce719f0ec9b98), $c552f4c6f5978452$export$b8a61e5c71402559);
const $c552f4c6f5978452$var$noScroll = $c552f4c6f5978452$export$1283875077dc8f0a((0, $a036e438091559f5$export$b6426a00c33a0175));
const $c552f4c6f5978452$var$noScrollPadding = $c552f4c6f5978452$export$1283875077dc8f0a((0, $a036e438091559f5$export$651541414233b476));
function $c552f4c6f5978452$var$isHTMLElement(element) {
    return "style" in element;
}
function $c552f4c6f5978452$var$padScrollbar(element, padding, rtl) {
    const styles = window.getComputedStyle(element);
    const property = rtl ? "padding-left" : "padding-right";
    const computedValue = rtl ? styles.paddingLeft : styles.paddingRight;
    const originalValue = element.style.getPropertyValue(property);
    element.style.setProperty(property, `${($c552f4c6f5978452$export$5f87784a266e50a4(computedValue) || 0) + padding}px`);
    return ()=>{
        if (originalValue) element.style.setProperty(property, originalValue);
        else element.style.removeProperty(property);
    };
}
function $c552f4c6f5978452$export$bbae9e931237726f({ noScroll: { disabled: disabled }, children: children }) {
    const rtl = $c552f4c6f5978452$export$81f015b3ec5d61cf();
    const { getOwnerDocument: getOwnerDocument, getOwnerWindow: getOwnerWindow } = $c552f4c6f5978452$export$c199d36c2862b6ed();
    $gRqVZ.useEffect(()=>{
        if (disabled) return ()=>{};
        const cleanup = [];
        const ownerWindow = getOwnerWindow();
        const { body: body, documentElement: documentElement } = getOwnerDocument();
        const scrollbar = Math.round(ownerWindow.innerWidth - documentElement.clientWidth);
        if (scrollbar > 0) {
            cleanup.push($c552f4c6f5978452$var$padScrollbar(body, scrollbar, rtl));
            const elements = body.getElementsByTagName("*");
            for(let i = 0; i < elements.length; i += 1){
                const element = elements[i];
                if ($c552f4c6f5978452$var$isHTMLElement(element) && ownerWindow.getComputedStyle(element).getPropertyValue("position") === "fixed" && !element.classList.contains($c552f4c6f5978452$var$noScrollPadding)) cleanup.push($c552f4c6f5978452$var$padScrollbar(element, scrollbar, rtl));
            }
        }
        body.classList.add($c552f4c6f5978452$var$noScroll);
        return ()=>{
            body.classList.remove($c552f4c6f5978452$var$noScroll);
            cleanup.forEach((clean)=>clean());
        };
    }, [
        rtl,
        disabled,
        getOwnerDocument,
        getOwnerWindow
    ]);
    return $gRqVZ.createElement($gRqVZ.Fragment, null, children);
}
const $c552f4c6f5978452$export$7ded5f1cd4840ad = $c552f4c6f5978452$export$c5ba3739ffba980d((0, $a036e438091559f5$export$52cbc29cf5406ba8), $c552f4c6f5978452$export$bbae9e931237726f);
function $c552f4c6f5978452$var$cssPrefix$1(value) {
    return $c552f4c6f5978452$export$195c4126907dde97((0, $a036e438091559f5$export$9d2e4856063e1a22), value);
}
function $c552f4c6f5978452$var$setAttribute(element, attribute, value) {
    const previousValue = element.getAttribute(attribute);
    element.setAttribute(attribute, value);
    return ()=>{
        if (previousValue) element.setAttribute(attribute, previousValue);
        else element.removeAttribute(attribute);
    };
}
function $c552f4c6f5978452$export$602eac185826482c({ portal: { root: root, container: { className: containerClassName, style: containerStyle, ...containerRest } = {} }, animation: animation, styles: styles, className: className, on: on, close: close, labels: labels, children: children }) {
    const [mounted, setMounted] = $gRqVZ.useState(false);
    const [visible, setVisible] = $gRqVZ.useState(false);
    const cleanup = $gRqVZ.useRef([]);
    const restoreFocus = $gRqVZ.useRef(null);
    const { setTimeout: setTimeout } = $c552f4c6f5978452$export$1bc7162631c81b3f();
    const { subscribe: subscribe } = $c552f4c6f5978452$export$91a992459f6e0f07();
    const reduceMotion = $c552f4c6f5978452$export$f3e625e1b2b31d60();
    const animationDuration = !reduceMotion ? animation.fade : 0;
    $gRqVZ.useEffect(()=>{
        setMounted(true);
        return ()=>{
            setMounted(false);
            setVisible(false);
        };
    }, []);
    const handleCleanup = $c552f4c6f5978452$export$ee5b5d04074a389e(()=>{
        cleanup.current.forEach((clean)=>clean());
        cleanup.current = [];
    });
    const handleClose = $c552f4c6f5978452$export$ee5b5d04074a389e(()=>{
        var _a;
        setVisible(false);
        handleCleanup();
        (_a = on.exiting) === null || _a === void 0 || _a.call(on);
        setTimeout(()=>{
            var _a;
            (_a = on.exited) === null || _a === void 0 || _a.call(on);
            close();
        }, animationDuration);
    });
    $gRqVZ.useEffect(()=>subscribe((0, $a036e438091559f5$export$493a596486210a21), handleClose), [
        subscribe,
        handleClose
    ]);
    const handleEnter = $c552f4c6f5978452$export$ee5b5d04074a389e((node)=>{
        var _a, _b, _c;
        $c552f4c6f5978452$export$b7a864e1eaef9de5(node);
        setVisible(true);
        (_a = on.entering) === null || _a === void 0 || _a.call(on);
        const elements = (_c = (_b = node.parentNode) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : [];
        for(let i = 0; i < elements.length; i += 1){
            const element = elements[i];
            if ([
                "TEMPLATE",
                "SCRIPT",
                "STYLE"
            ].indexOf(element.tagName) === -1 && element !== node) {
                cleanup.current.push($c552f4c6f5978452$var$setAttribute(element, "inert", ""));
                cleanup.current.push($c552f4c6f5978452$var$setAttribute(element, "aria-hidden", "true"));
            }
        }
        cleanup.current.push(()=>{
            var _a, _b;
            (_b = (_a = restoreFocus.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 || _b.call(_a);
        });
        setTimeout(()=>{
            var _a;
            (_a = on.entered) === null || _a === void 0 || _a.call(on);
        }, animationDuration);
    });
    const handleRef = $gRqVZ.useCallback((node)=>{
        if (node) handleEnter(node);
        else handleCleanup();
    }, [
        handleEnter,
        handleCleanup
    ]);
    return mounted ? (0, $hYKvr.createPortal)($gRqVZ.createElement($c552f4c6f5978452$export$597a6f74cf288f82, {
        ref: handleRef,
        className: $c552f4c6f5978452$export$4f5d2d50c9deca37(className, containerClassName, $c552f4c6f5978452$export$1283875077dc8f0a($c552f4c6f5978452$var$cssPrefix$1()), $c552f4c6f5978452$export$1283875077dc8f0a((0, $a036e438091559f5$export$651541414233b476)), visible && $c552f4c6f5978452$export$1283875077dc8f0a($c552f4c6f5978452$var$cssPrefix$1("open"))),
        "aria-modal": true,
        role: "dialog",
        "aria-label": $c552f4c6f5978452$export$1c4d965eb6f65dfa(labels, "Lightbox"),
        style: {
            ...animation.fade !== $c552f4c6f5978452$export$d626463445cef3e9.animation.fade ? {
                [$c552f4c6f5978452$export$8b4981022bd80a4e("fade_animation_duration")]: `${animationDuration}ms`
            } : null,
            ...animation.easing.fade !== $c552f4c6f5978452$export$d626463445cef3e9.animation.easing.fade ? {
                [$c552f4c6f5978452$export$8b4981022bd80a4e("fade_animation_timing_function")]: animation.easing.fade
            } : null,
            ...styles.root,
            ...containerStyle
        },
        onFocus: (event)=>{
            if (!restoreFocus.current) restoreFocus.current = event.relatedTarget;
        },
        ...containerRest
    }, children), root || document.body) : null;
}
const $c552f4c6f5978452$export$f2a0761442face5c = $c552f4c6f5978452$export$c5ba3739ffba980d((0, $a036e438091559f5$export$9d2e4856063e1a22), $c552f4c6f5978452$export$602eac185826482c);
function $c552f4c6f5978452$export$be92b6f5f03c0fe9({ children: children }) {
    return $gRqVZ.createElement($gRqVZ.Fragment, null, children);
}
const $c552f4c6f5978452$export$fa1081225b99a9f2 = $c552f4c6f5978452$export$c5ba3739ffba980d((0, $a036e438091559f5$export$62f3c66ae8dab8a3), $c552f4c6f5978452$export$be92b6f5f03c0fe9);
function $c552f4c6f5978452$var$cssPrefix(value) {
    return $c552f4c6f5978452$export$195c4126907dde97((0, $a036e438091559f5$export$5414719b40b8294f), value);
}
function $c552f4c6f5978452$export$4c260019440d418f({ toolbar: { buttons: buttons }, render: { buttonClose: buttonClose, iconClose: iconClose }, styles: styles }) {
    const { close: close, setToolbarWidth: setToolbarWidth } = $c552f4c6f5978452$export$e8c786024a2b0a79();
    const { setContainerRef: setContainerRef, containerRect: containerRect } = $c552f4c6f5978452$export$b1d85de58d38d09d();
    $c552f4c6f5978452$export$e5c5a5f917a5871c(()=>{
        setToolbarWidth(containerRect === null || containerRect === void 0 ? void 0 : containerRect.width);
    }, [
        setToolbarWidth,
        containerRect === null || containerRect === void 0 ? void 0 : containerRect.width
    ]);
    const renderCloseButton = ()=>{
        if (buttonClose) return buttonClose();
        return $gRqVZ.createElement($c552f4c6f5978452$export$c25acd513dcc8062, {
            key: (0, $a036e438091559f5$export$493a596486210a21),
            label: "Close",
            icon: $c552f4c6f5978452$export$cae179f078f4b4a4,
            renderIcon: iconClose,
            onClick: close
        });
    };
    return $gRqVZ.createElement("div", {
        ref: setContainerRef,
        style: styles.toolbar,
        className: $c552f4c6f5978452$export$1283875077dc8f0a($c552f4c6f5978452$var$cssPrefix())
    }, buttons === null || buttons === void 0 ? void 0 : buttons.map((button)=>button === (0, $a036e438091559f5$export$493a596486210a21) ? renderCloseButton() : button));
}
const $c552f4c6f5978452$export$d0a9743c06e42ce8 = $c552f4c6f5978452$export$c5ba3739ffba980d((0, $a036e438091559f5$export$5414719b40b8294f), $c552f4c6f5978452$export$4c260019440d418f);
function $c552f4c6f5978452$var$renderNode(node, props) {
    var _a;
    return $gRqVZ.createElement(node.module.component, {
        key: node.module.name,
        ...props
    }, (_a = node.children) === null || _a === void 0 ? void 0 : _a.map((child)=>$c552f4c6f5978452$var$renderNode(child, props)));
}
function $c552f4c6f5978452$var$mergeAnimation(defaultAnimation, animation = {}) {
    const { easing: defaultAnimationEasing, ...restDefaultAnimation } = defaultAnimation;
    const { easing: easing, ...restAnimation } = animation;
    return {
        easing: {
            ...defaultAnimationEasing,
            ...easing
        },
        ...restDefaultAnimation,
        ...restAnimation
    };
}
function $c552f4c6f5978452$export$7d2670a66155874b({ carousel: carousel, animation: animation, render: render, toolbar: toolbar, controller: controller, noScroll: noScroll, on: on, plugins: plugins, slides: slides, index: index, ...restProps }) {
    const { animation: defaultAnimation, carousel: defaultCarousel, render: defaultRender, toolbar: defaultToolbar, controller: defaultController, noScroll: defaultNoScroll, on: defaultOn, slides: defaultSlides, index: defaultIndex, plugins: defaultPlugins, ...restDefaultProps } = $c552f4c6f5978452$export$d626463445cef3e9;
    const { config: config, augmentation: augmentation } = $c552f4c6f5978452$export$bc996c07eb970c78([
        $c552f4c6f5978452$export$270e7ba5936d3c48($c552f4c6f5978452$export$f2a0761442face5c, [
            $c552f4c6f5978452$export$270e7ba5936d3c48($c552f4c6f5978452$export$7ded5f1cd4840ad, [
                $c552f4c6f5978452$export$270e7ba5936d3c48($c552f4c6f5978452$export$be59d34228c8ec8a, [
                    $c552f4c6f5978452$export$270e7ba5936d3c48($c552f4c6f5978452$export$9c087759a323a56c),
                    $c552f4c6f5978452$export$270e7ba5936d3c48($c552f4c6f5978452$export$d0a9743c06e42ce8),
                    $c552f4c6f5978452$export$270e7ba5936d3c48($c552f4c6f5978452$export$6c16e1ac15089858)
                ])
            ])
        ])
    ], plugins || defaultPlugins);
    const props = augmentation({
        animation: $c552f4c6f5978452$var$mergeAnimation(defaultAnimation, animation),
        carousel: {
            ...defaultCarousel,
            ...carousel
        },
        render: {
            ...defaultRender,
            ...render
        },
        toolbar: {
            ...defaultToolbar,
            ...toolbar
        },
        controller: {
            ...defaultController,
            ...controller
        },
        noScroll: {
            ...defaultNoScroll,
            ...noScroll
        },
        on: {
            ...defaultOn,
            ...on
        },
        ...restDefaultProps,
        ...restProps
    });
    if (!props.open) return null;
    return $gRqVZ.createElement($c552f4c6f5978452$export$7141a340a3dea601, {
        ...props
    }, $gRqVZ.createElement($c552f4c6f5978452$export$62d2e1d2e7609988, {
        slides: slides || defaultSlides,
        index: $c552f4c6f5978452$export$5f87784a266e50a4(index || defaultIndex)
    }, $gRqVZ.createElement($c552f4c6f5978452$export$9d9954f5885fa393, null, $gRqVZ.createElement($c552f4c6f5978452$export$686accdd53ac150f, null, $gRqVZ.createElement($c552f4c6f5978452$export$e41a845d3e53ea09, null, $c552f4c6f5978452$var$renderNode($c552f4c6f5978452$export$270e7ba5936d3c48($c552f4c6f5978452$export$fa1081225b99a9f2, config), props))))));
}







const $4798097dcc8bac9b$export$a6fe38fb357a1ec5 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	flex-wrap: wrap;
`;
const $4798097dcc8bac9b$export$6e0f22ba93f02904 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	height: 100%;
	width: 100%;
	background-size: cover;
	background-repeat: no-repeat;
	transition: all 0.5s;
	&:before {
		content: '';
		height: 100%;
		width: 100%;
		position: absolute;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.4);
	}
`;
const $4798097dcc8bac9b$export$b4ca9e05809bd186 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)($4798097dcc8bac9b$export$6e0f22ba93f02904)`
	&:before {
		background-color: rgba(0, 0, 0, 0);
	}
`;
const $4798097dcc8bac9b$export$266d69320a343fc1 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	text-align: center;
	margin: auto;
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	background-color: rgba(0, 0, 0, 0.3);
	user-select: none;
`;
const $4798097dcc8bac9b$export$61287401a9b6135 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	color: #ffffff !important;
	font-size: 150%;
	margin-bottom: 6px;
	padding-left: 12px;
	padding-right: 12px;
`;
const $4798097dcc8bac9b$export$c6756bfc15908808 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	color: #cccccc !important;
	font-size: 90%;
`;
const $4798097dcc8bac9b$export$245ec001d8ab6eb8 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: none;
	justify-content: space-between;
	height: 55px;
	width: 40px;
	position: absolute;
	top: 0;
	right: 0;
	padding-top: 15px;
	padding-right: 15px;
`;
const $4798097dcc8bac9b$export$a773913f57bf814a = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	flex-grow: 0;
	height: 200px;
	overflow: hidden;
	position: relative;
	cursor: pointer;

	&:hover ${$4798097dcc8bac9b$export$6e0f22ba93f02904} {
		transform: scale(1.1);
	}
	&:hover ${$4798097dcc8bac9b$export$245ec001d8ab6eb8} {
		display: flex;
	}
`;
const $4798097dcc8bac9b$export$395ce40f751434ec = $4798097dcc8bac9b$export$a773913f57bf814a;
const $4798097dcc8bac9b$export$7ad97355af757009 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)($4798097dcc8bac9b$export$a773913f57bf814a)`
	cursor: pointer;
`;
const $4798097dcc8bac9b$export$6ed0965c9443aaa6 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $3cf30fe56fd1629f$export$889aff59bd27773b))`
	width: 15px;
	height: 15px;
	color: #fff;
	vertical-align: top;
`;
const $4798097dcc8bac9b$export$bfadae053a633538 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $51c6ea681161bff5$export$99442c433de1441d))`
	width: 15px;
	height: 15px;
	color: #fff;
`;
const $4798097dcc8bac9b$export$34b846af2dd63598 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	justify-content: space-between;
`;





var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");

var $gRqVZ = parcelRequire("gRqVZ");

var $hYKvr = parcelRequire("hYKvr");

var $gRqVZ = parcelRequire("gRqVZ");
function $638831efd3fb3cf7$export$2f8294366bb2d67a() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (0, $gRqVZ.useMemo)(()=>(node)=>{
            refs.forEach((ref)=>ref(node));
        }, refs);
}
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const $638831efd3fb3cf7$export$71594e8a50f746f4 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
function $638831efd3fb3cf7$export$5a096129d439f843(element) {
    const elementString = Object.prototype.toString.call(element);
    return elementString === '[object Window]' || // In Electron context the Window object serializes to [object global]
    elementString === '[object global]';
}
function $638831efd3fb3cf7$export$8ee0fc9ee280b4ee(node) {
    return 'nodeType' in node;
}
function $638831efd3fb3cf7$export$38b2d434cce3ea22(target) {
    var _target$ownerDocument, _target$ownerDocument2;
    if (!target) return window;
    if ($638831efd3fb3cf7$export$5a096129d439f843(target)) return target;
    if (!$638831efd3fb3cf7$export$8ee0fc9ee280b4ee(target)) return window;
    return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function $638831efd3fb3cf7$export$62858bae88b53fd0(node) {
    const { Document: Document } = $638831efd3fb3cf7$export$38b2d434cce3ea22(node);
    return node instanceof Document;
}
function $638831efd3fb3cf7$export$1b3bfaa9684536aa(node) {
    if ($638831efd3fb3cf7$export$5a096129d439f843(node)) return false;
    return node instanceof $638831efd3fb3cf7$export$38b2d434cce3ea22(node).HTMLElement;
}
function $638831efd3fb3cf7$export$17eda790a720ec57(node) {
    return node instanceof $638831efd3fb3cf7$export$38b2d434cce3ea22(node).SVGElement;
}
function $638831efd3fb3cf7$export$b204af158042fbac(target) {
    if (!target) return document;
    if ($638831efd3fb3cf7$export$5a096129d439f843(target)) return target.document;
    if (!$638831efd3fb3cf7$export$8ee0fc9ee280b4ee(target)) return document;
    if ($638831efd3fb3cf7$export$62858bae88b53fd0(target)) return target;
    if ($638831efd3fb3cf7$export$1b3bfaa9684536aa(target) || $638831efd3fb3cf7$export$17eda790a720ec57(target)) return target.ownerDocument;
    return document;
}
/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */ const $638831efd3fb3cf7$export$700979bc83e7db82 = $638831efd3fb3cf7$export$71594e8a50f746f4 ? (0, $gRqVZ.useLayoutEffect) : (0, $gRqVZ.useEffect);
function $638831efd3fb3cf7$export$90fc3a17d93f704c(handler) {
    const handlerRef = (0, $gRqVZ.useRef)(handler);
    $638831efd3fb3cf7$export$700979bc83e7db82(()=>{
        handlerRef.current = handler;
    });
    return (0, $gRqVZ.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return handlerRef.current == null ? void 0 : handlerRef.current(...args);
    }, []);
}
function $638831efd3fb3cf7$export$f4b266cd2aae9cb1() {
    const intervalRef = (0, $gRqVZ.useRef)(null);
    const set = (0, $gRqVZ.useCallback)((listener, duration)=>{
        intervalRef.current = setInterval(listener, duration);
    }, []);
    const clear = (0, $gRqVZ.useCallback)(()=>{
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    return [
        set,
        clear
    ];
}
function $638831efd3fb3cf7$export$86c4283a11f23f95(value, dependencies) {
    if (dependencies === void 0) dependencies = [
        value
    ];
    const valueRef = (0, $gRqVZ.useRef)(value);
    $638831efd3fb3cf7$export$700979bc83e7db82(()=>{
        if (valueRef.current !== value) valueRef.current = value;
    }, dependencies);
    return valueRef;
}
function $638831efd3fb3cf7$export$b0d7b7f1fcd613d1(callback, dependencies) {
    const valueRef = (0, $gRqVZ.useRef)();
    return (0, $gRqVZ.useMemo)(()=>{
        const newValue = callback(valueRef.current);
        valueRef.current = newValue;
        return newValue;
    }, [
        ...dependencies
    ]);
}
function $638831efd3fb3cf7$export$bc23c270f170c912(onChange) {
    const onChangeHandler = $638831efd3fb3cf7$export$90fc3a17d93f704c(onChange);
    const node = (0, $gRqVZ.useRef)(null);
    const setNodeRef = (0, $gRqVZ.useCallback)((element)=>{
        if (element !== node.current) onChangeHandler == null || onChangeHandler(element, node.current);
        node.current = element;
    }, []);
    return [
        node,
        setNodeRef
    ];
}
function $638831efd3fb3cf7$export$5cae361ad82dce8b(value) {
    const ref = (0, $gRqVZ.useRef)();
    (0, $gRqVZ.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
let $638831efd3fb3cf7$var$ids = {};
function $638831efd3fb3cf7$export$c485849f2e393253(prefix, value) {
    return (0, $gRqVZ.useMemo)(()=>{
        if (value) return value;
        const id = $638831efd3fb3cf7$var$ids[prefix] == null ? 0 : $638831efd3fb3cf7$var$ids[prefix] + 1;
        $638831efd3fb3cf7$var$ids[prefix] = id;
        return prefix + "-" + id;
    }, [
        prefix,
        value
    ]);
}
function $638831efd3fb3cf7$var$createAdjustmentFn(modifier) {
    return function(object) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((accumulator, adjustment)=>{
            const entries = Object.entries(adjustment);
            for (const [key, valueAdjustment] of entries){
                const value = accumulator[key];
                if (value != null) accumulator[key] = value + modifier * valueAdjustment;
            }
            return accumulator;
        }, {
            ...object
        });
    };
}
const $638831efd3fb3cf7$export$e16d8520af44a096 = /*#__PURE__*/ $638831efd3fb3cf7$var$createAdjustmentFn(1);
const $638831efd3fb3cf7$export$4e2d2ead65e5f7e3 = /*#__PURE__*/ $638831efd3fb3cf7$var$createAdjustmentFn(-1);
function $638831efd3fb3cf7$export$d0e71af79cd586c6(event) {
    return 'clientX' in event && 'clientY' in event;
}
function $638831efd3fb3cf7$export$130b789831072f4c(event) {
    if (!event) return false;
    const { KeyboardEvent: KeyboardEvent } = $638831efd3fb3cf7$export$38b2d434cce3ea22(event.target);
    return KeyboardEvent && event instanceof KeyboardEvent;
}
function $638831efd3fb3cf7$export$c4dfce035d43d1e0(event) {
    if (!event) return false;
    const { TouchEvent: TouchEvent } = $638831efd3fb3cf7$export$38b2d434cce3ea22(event.target);
    return TouchEvent && event instanceof TouchEvent;
}
/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */ function $638831efd3fb3cf7$export$36195c8aa1517e04(event) {
    if ($638831efd3fb3cf7$export$c4dfce035d43d1e0(event)) {
        if (event.touches && event.touches.length) {
            const { clientX: x, clientY: y } = event.touches[0];
            return {
                x: x,
                y: y
            };
        } else if (event.changedTouches && event.changedTouches.length) {
            const { clientX: x, clientY: y } = event.changedTouches[0];
            return {
                x: x,
                y: y
            };
        }
    }
    if ($638831efd3fb3cf7$export$d0e71af79cd586c6(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    return null;
}
const $638831efd3fb3cf7$export$c4ffa16951855e28 = /*#__PURE__*/ Object.freeze({
    Translate: {
        toString (transform) {
            if (!transform) return;
            const { x: x, y: y } = transform;
            return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
        }
    },
    Scale: {
        toString (transform) {
            if (!transform) return;
            const { scaleX: scaleX, scaleY: scaleY } = transform;
            return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        }
    },
    Transform: {
        toString (transform) {
            if (!transform) return;
            return [
                $638831efd3fb3cf7$export$c4ffa16951855e28.Translate.toString(transform),
                $638831efd3fb3cf7$export$c4ffa16951855e28.Scale.toString(transform)
            ].join(' ');
        }
    },
    Transition: {
        toString (_ref) {
            let { property: property, duration: duration, easing: easing } = _ref;
            return property + " " + duration + "ms " + easing;
        }
    }
});
const $638831efd3fb3cf7$var$SELECTOR = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]';
function $638831efd3fb3cf7$export$44f71d798fd0a62b(element) {
    if (element.matches($638831efd3fb3cf7$var$SELECTOR)) return element;
    return element.querySelector($638831efd3fb3cf7$var$SELECTOR);
}



var $gRqVZ = parcelRequire("gRqVZ");
const $a34673c5f8233050$var$hiddenStyles = {
    display: 'none'
};
function $a34673c5f8233050$export$1496ac55023363a5(_ref) {
    let { id: id, value: value } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
        id: id,
        style: $a34673c5f8233050$var$hiddenStyles
    }, value);
}
function $a34673c5f8233050$export$ae99b902be98b17(_ref) {
    let { id: id, announcement: announcement, ariaLiveType: ariaLiveType = "assertive" } = _ref;
    // Hide element visually but keep it readable by screen readers
    const visuallyHidden = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: 1,
        height: 1,
        margin: -1,
        border: 0,
        padding: 0,
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(100%)',
        whiteSpace: 'nowrap'
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement("div", {
        id: id,
        style: visuallyHidden,
        role: "status",
        "aria-live": ariaLiveType,
        "aria-atomic": true
    }, announcement);
}
function $a34673c5f8233050$export$97d78af8d95ca8bd() {
    const [announcement, setAnnouncement] = (0, $gRqVZ.useState)('');
    const announce = (0, $gRqVZ.useCallback)((value)=>{
        if (value != null) setAnnouncement(value);
    }, []);
    return {
        announce: announce,
        announcement: announcement
    };
}


const $83696c5bbc79d2da$var$screenReaderInstructions = {
    draggable: `
    To pick up a draggable item, press the space bar.
    While dragging, use the arrow keys to move the item.
    Press space again to drop the item in its new position, or press escape to cancel.
  `
};
const $83696c5bbc79d2da$export$6acb64047911dd54 = {
    onDragStart (id) {
        return `Picked up draggable item ${id}.`;
    },
    onDragOver (id, overId) {
        if (overId) return `Draggable item ${id} was moved over droppable area ${overId}.`;
        return `Draggable item ${id} is no longer over a droppable area.`;
    },
    onDragEnd (id, overId) {
        if (overId) return `Draggable item ${id} was dropped over droppable area ${overId}`;
        return `Draggable item ${id} was dropped.`;
    },
    onDragCancel (id) {
        return `Dragging was cancelled. Draggable item ${id} was dropped.`;
    }
};
var $83696c5bbc79d2da$var$Action;
(function(Action) {
    Action["DragStart"] = "dragStart";
    Action["DragMove"] = "dragMove";
    Action["DragEnd"] = "dragEnd";
    Action["DragCancel"] = "dragCancel";
    Action["DragOver"] = "dragOver";
    Action["RegisterDroppable"] = "registerDroppable";
    Action["SetDroppableDisabled"] = "setDroppableDisabled";
    Action["UnregisterDroppable"] = "unregisterDroppable";
})($83696c5bbc79d2da$var$Action || ($83696c5bbc79d2da$var$Action = {}));
function $83696c5bbc79d2da$var$noop(..._args) {}
class $83696c5bbc79d2da$var$DroppableContainersMap extends Map {
    get(id) {
        var _super$get;
        return id != null ? (_super$get = super.get(id)) != null ? _super$get : undefined : undefined;
    }
    toArray() {
        return Array.from(this.values());
    }
    getEnabled() {
        return this.toArray().filter(({ disabled: disabled })=>!disabled);
    }
    getNodeFor(id) {
        var _this$get$node$curren, _this$get;
        return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : undefined;
    }
}
const $83696c5bbc79d2da$var$defaultPublicContext = {
    activatorEvent: null,
    active: null,
    activeNode: null,
    activeNodeRect: null,
    collisions: null,
    containerNodeRect: null,
    draggableNodes: {},
    droppableRects: /*#__PURE__*/ new Map(),
    droppableContainers: /*#__PURE__*/ new $83696c5bbc79d2da$var$DroppableContainersMap(),
    over: null,
    dragOverlay: {
        nodeRef: {
            current: null
        },
        rect: null,
        setRef: $83696c5bbc79d2da$var$noop
    },
    scrollableAncestors: [],
    scrollableAncestorRects: [],
    measureDroppableContainers: $83696c5bbc79d2da$var$noop,
    windowRect: null,
    measuringScheduled: false
};
const $83696c5bbc79d2da$var$defaultInternalContext = {
    activatorEvent: null,
    activators: [],
    active: null,
    activeNodeRect: null,
    ariaDescribedById: {
        draggable: ''
    },
    dispatch: $83696c5bbc79d2da$var$noop,
    draggableNodes: {},
    over: null,
    measureDroppableContainers: $83696c5bbc79d2da$var$noop
};
const $83696c5bbc79d2da$var$InternalContext = /*#__PURE__*/ (0, $gRqVZ.createContext)($83696c5bbc79d2da$var$defaultInternalContext);
const $83696c5bbc79d2da$var$PublicContext = /*#__PURE__*/ (0, $gRqVZ.createContext)($83696c5bbc79d2da$var$defaultPublicContext);
function $83696c5bbc79d2da$var$getInitialState() {
    return {
        draggable: {
            active: null,
            initialCoordinates: {
                x: 0,
                y: 0
            },
            nodes: {},
            translate: {
                x: 0,
                y: 0
            }
        },
        droppable: {
            containers: new $83696c5bbc79d2da$var$DroppableContainersMap()
        }
    };
}
function $83696c5bbc79d2da$var$reducer(state, action) {
    switch(action.type){
        case $83696c5bbc79d2da$var$Action.DragStart:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    initialCoordinates: action.initialCoordinates,
                    active: action.active
                }
            };
        case $83696c5bbc79d2da$var$Action.DragMove:
            if (!state.draggable.active) return state;
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    translate: {
                        x: action.coordinates.x - state.draggable.initialCoordinates.x,
                        y: action.coordinates.y - state.draggable.initialCoordinates.y
                    }
                }
            };
        case $83696c5bbc79d2da$var$Action.DragEnd:
        case $83696c5bbc79d2da$var$Action.DragCancel:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    active: null,
                    initialCoordinates: {
                        x: 0,
                        y: 0
                    },
                    translate: {
                        x: 0,
                        y: 0
                    }
                }
            };
        case $83696c5bbc79d2da$var$Action.RegisterDroppable:
            {
                const { element: element } = action;
                const { id: id } = element;
                const containers = new $83696c5bbc79d2da$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, element);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $83696c5bbc79d2da$var$Action.SetDroppableDisabled:
            {
                const { id: id, key: key, disabled: disabled } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $83696c5bbc79d2da$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, {
                    ...element,
                    disabled: disabled
                });
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $83696c5bbc79d2da$var$Action.UnregisterDroppable:
            {
                const { id: id, key: key } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $83696c5bbc79d2da$var$DroppableContainersMap(state.droppable.containers);
                containers.delete(id);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        default:
            return state;
    }
}
const $83696c5bbc79d2da$var$DndMonitorContext = /*#__PURE__*/ (0, $gRqVZ.createContext)({
    type: null,
    event: null
});
function $83696c5bbc79d2da$export$1182af90218a7b81({ onDragStart: onDragStart, onDragMove: onDragMove, onDragOver: onDragOver, onDragEnd: onDragEnd, onDragCancel: onDragCancel }) {
    const monitorState = (0, $gRqVZ.useContext)($83696c5bbc79d2da$var$DndMonitorContext);
    const previousMonitorState = (0, $gRqVZ.useRef)(monitorState);
    (0, $gRqVZ.useEffect)(()=>{
        if (monitorState !== previousMonitorState.current) {
            const { type: type, event: event } = monitorState;
            switch(type){
                case $83696c5bbc79d2da$var$Action.DragStart:
                    onDragStart == null || onDragStart(event);
                    break;
                case $83696c5bbc79d2da$var$Action.DragMove:
                    onDragMove == null || onDragMove(event);
                    break;
                case $83696c5bbc79d2da$var$Action.DragOver:
                    onDragOver == null || onDragOver(event);
                    break;
                case $83696c5bbc79d2da$var$Action.DragCancel:
                    onDragCancel == null || onDragCancel(event);
                    break;
                case $83696c5bbc79d2da$var$Action.DragEnd:
                    onDragEnd == null || onDragEnd(event);
                    break;
            }
            previousMonitorState.current = monitorState;
        }
    }, [
        monitorState,
        onDragStart,
        onDragMove,
        onDragOver,
        onDragEnd,
        onDragCancel
    ]);
}
function $83696c5bbc79d2da$var$Accessibility({ announcements: announcements = $83696c5bbc79d2da$export$6acb64047911dd54, hiddenTextDescribedById: hiddenTextDescribedById, screenReaderInstructions: screenReaderInstructions }) {
    const { announce: announce, announcement: announcement } = (0, $a34673c5f8233050$export$97d78af8d95ca8bd)();
    const liveRegionId = (0, $638831efd3fb3cf7$export$c485849f2e393253)(`DndLiveRegion`);
    const [mounted, setMounted] = (0, $gRqVZ.useState)(false);
    (0, $gRqVZ.useEffect)(()=>{
        setMounted(true);
    }, []);
    $83696c5bbc79d2da$export$1182af90218a7b81((0, $gRqVZ.useMemo)(()=>({
            onDragStart ({ active: active }) {
                announce(announcements.onDragStart(active.id));
            },
            onDragMove ({ active: active, over: over }) {
                if (announcements.onDragMove) announce(announcements.onDragMove(active.id, over == null ? void 0 : over.id));
            },
            onDragOver ({ active: active, over: over }) {
                announce(announcements.onDragOver(active.id, over == null ? void 0 : over.id));
            },
            onDragEnd ({ active: active, over: over }) {
                announce(announcements.onDragEnd(active.id, over == null ? void 0 : over.id));
            },
            onDragCancel ({ active: active }) {
                announce(announcements.onDragCancel(active.id));
            }
        }), [
        announce,
        announcements
    ]));
    return mounted ? (0, $hYKvr.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement((0, $a34673c5f8233050$export$1496ac55023363a5), {
        id: hiddenTextDescribedById,
        value: screenReaderInstructions.draggable
    }), (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement((0, $a34673c5f8233050$export$ae99b902be98b17), {
        id: liveRegionId,
        announcement: announcement
    })), document.body) : null;
}
const $83696c5bbc79d2da$export$597cbd7bbd10deb4 = /*#__PURE__*/ Object.freeze({
    x: 0,
    y: 0
});
/**
 * Returns the distance between two points
 */ function $83696c5bbc79d2da$var$distanceBetween(p1, p2) {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function $83696c5bbc79d2da$var$getRelativeTransformOrigin(event, rect) {
    const eventCoordinates = (0, $638831efd3fb3cf7$export$36195c8aa1517e04)(event);
    if (!eventCoordinates) return '0 0';
    const transformOrigin = {
        x: (eventCoordinates.x - rect.left) / rect.width * 100,
        y: (eventCoordinates.y - rect.top) / rect.height * 100
    };
    return `${transformOrigin.x}% ${transformOrigin.y}%`;
}
/**
 * Sort collisions from smallest to greatest value
 */ function $83696c5bbc79d2da$var$sortCollisionsAsc({ data: { value: a } }, { data: { value: b } }) {
    return a - b;
}
/**
 * Sort collisions from greatest to smallest value
 */ function $83696c5bbc79d2da$var$sortCollisionsDesc({ data: { value: a } }, { data: { value: b } }) {
    return b - a;
}
/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */ function $83696c5bbc79d2da$var$cornersOfRectangle({ left: left, top: top, height: height, width: width }) {
    return [
        {
            x: left,
            y: top
        },
        {
            x: left + width,
            y: top
        },
        {
            x: left,
            y: top + height
        },
        {
            x: left + width,
            y: top + height
        }
    ];
}
function $83696c5bbc79d2da$export$ef1beab6d7287295(collisions, property) {
    if (!collisions || collisions.length === 0) return null;
    const [firstCollision] = collisions;
    return property ? firstCollision[property] : firstCollision;
}
/**
 * Returns the coordinates of the center of a given ClientRect
 */ function $83696c5bbc79d2da$var$centerOfRectangle(rect, left = rect.left, top = rect.top) {
    return {
        x: left + rect.width * 0.5,
        y: top + rect.height * 0.5
    };
}
/**
 * Returns the closest rectangles from an array of rectangles to the center of a given
 * rectangle.
 */ const $83696c5bbc79d2da$export$c8e785ae6b74bab8 = ({ collisionRect: collisionRect, droppableContainers: droppableContainers })=>{
    const centerRect = $83696c5bbc79d2da$var$centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id, rect: { current: rect } } = droppableContainer;
        if (rect) {
            const distBetween = $83696c5bbc79d2da$var$distanceBetween($83696c5bbc79d2da$var$centerOfRectangle(rect), centerRect);
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: distBetween
                }
            });
        }
    }
    return collisions.sort($83696c5bbc79d2da$var$sortCollisionsAsc);
};
/**
 * Returns the closest rectangles from an array of rectangles to the corners of
 * another rectangle.
 */ const $83696c5bbc79d2da$export$c3a6c1c7122b31c9 = ({ collisionRect: collisionRect, droppableContainers: droppableContainers })=>{
    const corners = $83696c5bbc79d2da$var$cornersOfRectangle(collisionRect);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id, rect: { current: rect } } = droppableContainer;
        if (rect) {
            const rectCorners = $83696c5bbc79d2da$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner, index)=>{
                return accumulator + $83696c5bbc79d2da$var$distanceBetween(rectCorners[index], corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($83696c5bbc79d2da$var$sortCollisionsAsc);
};
/**
 * Returns the intersecting rectangle area between two rectangles
 */ function $83696c5bbc79d2da$var$getIntersectionRatio(entry, target) {
    const top = Math.max(target.top, entry.top);
    const left = Math.max(target.left, entry.left);
    const right = Math.min(target.left + target.width, entry.left + entry.width);
    const bottom = Math.min(target.top + target.height, entry.top + entry.height);
    const width = right - left;
    const height = bottom - top;
    if (left < right && top < bottom) {
        const targetArea = target.width * target.height;
        const entryArea = entry.width * entry.height;
        const intersectionArea = width * height;
        const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
        return Number(intersectionRatio.toFixed(4));
    } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)
    return 0;
}
/**
 * Returns the rectangles that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */ const $83696c5bbc79d2da$export$953346c40b5eb62a = ({ collisionRect: collisionRect, droppableContainers: droppableContainers })=>{
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id, rect: { current: rect } } = droppableContainer;
        if (rect) {
            const intersectionRatio = $83696c5bbc79d2da$var$getIntersectionRatio(rect, collisionRect);
            if (intersectionRatio > 0) collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: intersectionRatio
                }
            });
        }
    }
    return collisions.sort($83696c5bbc79d2da$var$sortCollisionsDesc);
};
/**
 * Check if a given point is contained within a bounding rectangle
 */ function $83696c5bbc79d2da$var$isPointWithinRect(point, rect) {
    const { top: top, left: left, bottom: bottom, right: right } = rect;
    return top <= point.y && point.y <= bottom && left <= point.x && point.x <= right;
}
/**
 * Returns the rectangles that the pointer is hovering over
 */ const $83696c5bbc79d2da$export$cd834c0ba378cb94 = ({ droppableContainers: droppableContainers, pointerCoordinates: pointerCoordinates })=>{
    if (!pointerCoordinates) return [];
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id, rect: { current: rect } } = droppableContainer;
        if (rect && $83696c5bbc79d2da$var$isPointWithinRect(pointerCoordinates, rect)) {
            /* There may be more than a single rectangle intersecting
       * with the pointer coordinates. In order to sort the
       * colliding rectangles, we measure the distance between
       * the pointer and the corners of the intersecting rectangle
       */ const corners = $83696c5bbc79d2da$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner)=>{
                return accumulator + $83696c5bbc79d2da$var$distanceBetween(pointerCoordinates, corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($83696c5bbc79d2da$var$sortCollisionsAsc);
};
function $83696c5bbc79d2da$var$adjustScale(transform, rect1, rect2) {
    return {
        ...transform,
        scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
        scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
    };
}
function $83696c5bbc79d2da$var$getRectDelta(rect1, rect2) {
    return rect1 && rect2 ? {
        x: rect1.left - rect2.left,
        y: rect1.top - rect2.top
    } : $83696c5bbc79d2da$export$597cbd7bbd10deb4;
}
function $83696c5bbc79d2da$var$createRectAdjustmentFn(modifier) {
    return function adjustClientRect(rect, ...adjustments) {
        return adjustments.reduce((acc, adjustment)=>({
                ...acc,
                top: acc.top + modifier * adjustment.y,
                bottom: acc.bottom + modifier * adjustment.y,
                left: acc.left + modifier * adjustment.x,
                right: acc.right + modifier * adjustment.x
            }), {
            ...rect
        });
    };
}
const $83696c5bbc79d2da$var$getAdjustedRect = /*#__PURE__*/ $83696c5bbc79d2da$var$createRectAdjustmentFn(1);
function $83696c5bbc79d2da$var$inverseTransform(rect, transform, transformOrigin) {
    let ta, sx, sy, dx, dy;
    if (transform.startsWith('matrix3d(')) {
        ta = transform.slice(9, -1).split(/, /);
        sx = +ta[0];
        sy = +ta[5];
        dx = +ta[12];
        dy = +ta[13];
    } else if (transform.startsWith('matrix(')) {
        ta = transform.slice(7, -1).split(/, /);
        sx = +ta[0];
        sy = +ta[3];
        dx = +ta[4];
        dy = +ta[5];
    } else return rect;
    const x = rect.left - dx - (1 - sx) * parseFloat(transformOrigin);
    const y = rect.top - dy - (1 - sy) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(' ') + 1));
    const w = sx ? rect.width / sx : rect.width;
    const h = sy ? rect.height / sy : rect.height;
    return {
        width: w,
        height: h,
        top: y,
        right: x + w,
        bottom: y + h,
        left: x
    };
}
const $83696c5bbc79d2da$var$defaultOptions = {
    ignoreTransform: false
};
/**
 * Returns the bounding client rect of an element relative to the viewport.
 */ function $83696c5bbc79d2da$export$b6aa1f30c53d7454(element, options = $83696c5bbc79d2da$var$defaultOptions) {
    let rect = element.getBoundingClientRect();
    if (options.ignoreTransform) {
        const { getComputedStyle: getComputedStyle } = (0, $638831efd3fb3cf7$export$38b2d434cce3ea22)(element);
        const { transform: transform, transformOrigin: transformOrigin } = getComputedStyle(element);
        if (transform) rect = $83696c5bbc79d2da$var$inverseTransform(rect, transform, transformOrigin);
    }
    const { top: top, left: left, width: width, height: height, bottom: bottom, right: right } = rect;
    return {
        top: top,
        left: left,
        width: width,
        height: height,
        bottom: bottom,
        right: right
    };
}
/**
 * Returns the bounding client rect of an element relative to the viewport.
 *
 * @remarks
 * The ClientRect returned by this method does not take into account transforms
 * applied to the element it measures.
 *
 */ function $83696c5bbc79d2da$var$getTransformAgnosticClientRect(element) {
    return $83696c5bbc79d2da$export$b6aa1f30c53d7454(element, {
        ignoreTransform: true
    });
}
function $83696c5bbc79d2da$var$getWindowClientRect(element) {
    const width = element.innerWidth;
    const height = element.innerHeight;
    return {
        top: 0,
        left: 0,
        right: width,
        bottom: height,
        width: width,
        height: height
    };
}
function $83696c5bbc79d2da$var$isFixed(node, computedStyle = (0, $638831efd3fb3cf7$export$38b2d434cce3ea22)(node).getComputedStyle(node)) {
    return computedStyle.position === 'fixed';
}
function $83696c5bbc79d2da$var$isScrollable(element, computedStyle = (0, $638831efd3fb3cf7$export$38b2d434cce3ea22)(element).getComputedStyle(element)) {
    const overflowRegex = /(auto|scroll|overlay)/;
    const properties = [
        'overflow',
        'overflowX',
        'overflowY'
    ];
    return properties.find((property)=>{
        const value = computedStyle[property];
        return typeof value === 'string' ? overflowRegex.test(value) : false;
    }) != null;
}
function $83696c5bbc79d2da$export$e4864aa91b5ed091(element) {
    const scrollParents = [];
    function findScrollableAncestors(node) {
        if (!node) return scrollParents;
        if ((0, $638831efd3fb3cf7$export$62858bae88b53fd0)(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
            scrollParents.push(node.scrollingElement);
            return scrollParents;
        }
        if (!(0, $638831efd3fb3cf7$export$1b3bfaa9684536aa)(node) || (0, $638831efd3fb3cf7$export$17eda790a720ec57)(node)) return scrollParents;
        if (scrollParents.includes(node)) return scrollParents;
        const { getComputedStyle: getComputedStyle } = (0, $638831efd3fb3cf7$export$38b2d434cce3ea22)(node);
        const computedStyle = getComputedStyle(node);
        if (node !== element) {
            if ($83696c5bbc79d2da$var$isScrollable(node, computedStyle)) scrollParents.push(node);
        }
        if ($83696c5bbc79d2da$var$isFixed(node, computedStyle)) return scrollParents;
        return findScrollableAncestors(node.parentNode);
    }
    if (!element) return scrollParents;
    return findScrollableAncestors(element);
}
function $83696c5bbc79d2da$var$getScrollableElement(element) {
    if (!(0, $638831efd3fb3cf7$export$71594e8a50f746f4) || !element) return null;
    if ((0, $638831efd3fb3cf7$export$5a096129d439f843)(element)) return element;
    if (!(0, $638831efd3fb3cf7$export$8ee0fc9ee280b4ee)(element)) return null;
    if ((0, $638831efd3fb3cf7$export$62858bae88b53fd0)(element) || element === (0, $638831efd3fb3cf7$export$b204af158042fbac)(element).scrollingElement) return window;
    if ((0, $638831efd3fb3cf7$export$1b3bfaa9684536aa)(element)) return element;
    return null;
}
function $83696c5bbc79d2da$var$getScrollXCoordinate(element) {
    if ((0, $638831efd3fb3cf7$export$5a096129d439f843)(element)) return element.scrollX;
    return element.scrollLeft;
}
function $83696c5bbc79d2da$var$getScrollYCoordinate(element) {
    if ((0, $638831efd3fb3cf7$export$5a096129d439f843)(element)) return element.scrollY;
    return element.scrollTop;
}
function $83696c5bbc79d2da$var$getScrollCoordinates(element) {
    return {
        x: $83696c5bbc79d2da$var$getScrollXCoordinate(element),
        y: $83696c5bbc79d2da$var$getScrollYCoordinate(element)
    };
}
var $83696c5bbc79d2da$var$Direction;
(function(Direction) {
    Direction[Direction["Forward"] = 1] = "Forward";
    Direction[Direction["Backward"] = -1] = "Backward";
})($83696c5bbc79d2da$var$Direction || ($83696c5bbc79d2da$var$Direction = {}));
function $83696c5bbc79d2da$var$getScrollPosition(scrollingContainer) {
    const minScroll = {
        x: 0,
        y: 0
    };
    const maxScroll = {
        x: scrollingContainer.scrollWidth - scrollingContainer.clientWidth,
        y: scrollingContainer.scrollHeight - scrollingContainer.clientHeight
    };
    const isTop = scrollingContainer.scrollTop <= minScroll.y;
    const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop: isTop,
        isLeft: isLeft,
        isBottom: isBottom,
        isRight: isRight,
        maxScroll: maxScroll,
        minScroll: minScroll
    };
}
function $83696c5bbc79d2da$var$isDocumentScrollingElement(element) {
    if (!(0, $638831efd3fb3cf7$export$71594e8a50f746f4) || !element) return false;
    return element === document.scrollingElement;
}
const $83696c5bbc79d2da$var$defaultThreshold = {
    x: 0.2,
    y: 0.2
};
function $83696c5bbc79d2da$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, { top: top, left: left, right: right, bottom: bottom }, acceleration = 10, thresholdPercentage = $83696c5bbc79d2da$var$defaultThreshold) {
    const { clientHeight: clientHeight, clientWidth: clientWidth } = scrollContainer;
    const finalScrollContainerRect = $83696c5bbc79d2da$var$isDocumentScrollingElement(scrollContainer) ? {
        top: 0,
        left: 0,
        right: clientWidth,
        bottom: clientHeight,
        width: clientWidth,
        height: clientHeight
    } : scrollContainerRect;
    const { isTop: isTop, isBottom: isBottom, isLeft: isLeft, isRight: isRight } = $83696c5bbc79d2da$var$getScrollPosition(scrollContainer);
    const direction = {
        x: 0,
        y: 0
    };
    const speed = {
        x: 0,
        y: 0
    };
    const threshold = {
        height: finalScrollContainerRect.height * thresholdPercentage.y,
        width: finalScrollContainerRect.width * thresholdPercentage.x
    };
    if (!isTop && top <= finalScrollContainerRect.top + threshold.height) {
        // Scroll Up
        direction.y = $83696c5bbc79d2da$var$Direction.Backward;
        speed.y = acceleration * Math.abs((finalScrollContainerRect.top + threshold.height - top) / threshold.height);
    } else if (!isBottom && bottom >= finalScrollContainerRect.bottom - threshold.height) {
        // Scroll Down
        direction.y = $83696c5bbc79d2da$var$Direction.Forward;
        speed.y = acceleration * Math.abs((finalScrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
    }
    if (!isRight && right >= finalScrollContainerRect.right - threshold.width) {
        // Scroll Right
        direction.x = $83696c5bbc79d2da$var$Direction.Forward;
        speed.x = acceleration * Math.abs((finalScrollContainerRect.right - threshold.width - right) / threshold.width);
    } else if (!isLeft && left <= finalScrollContainerRect.left + threshold.width) {
        // Scroll Left
        direction.x = $83696c5bbc79d2da$var$Direction.Backward;
        speed.x = acceleration * Math.abs((finalScrollContainerRect.left + threshold.width - left) / threshold.width);
    }
    return {
        direction: direction,
        speed: speed
    };
}
function $83696c5bbc79d2da$var$getScrollElementRect(element) {
    if (element === document.scrollingElement) {
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        return {
            top: 0,
            left: 0,
            right: innerWidth,
            bottom: innerHeight,
            width: innerWidth,
            height: innerHeight
        };
    }
    const { top: top, left: left, right: right, bottom: bottom } = element.getBoundingClientRect();
    return {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function $83696c5bbc79d2da$var$getScrollOffsets(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return (0, $638831efd3fb3cf7$export$e16d8520af44a096)(acc, $83696c5bbc79d2da$var$getScrollCoordinates(node));
    }, $83696c5bbc79d2da$export$597cbd7bbd10deb4);
}
function $83696c5bbc79d2da$var$getScrollXOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $83696c5bbc79d2da$var$getScrollXCoordinate(node);
    }, 0);
}
function $83696c5bbc79d2da$var$getScrollYOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $83696c5bbc79d2da$var$getScrollYCoordinate(node);
    }, 0);
}
const $83696c5bbc79d2da$var$properties = [
    [
        'x',
        [
            'left',
            'right'
        ],
        $83696c5bbc79d2da$var$getScrollXOffset
    ],
    [
        'y',
        [
            'top',
            'bottom'
        ],
        $83696c5bbc79d2da$var$getScrollYOffset
    ]
];
class $83696c5bbc79d2da$var$Rect {
    constructor(rect, element){
        this.rect = void 0;
        this.width = void 0;
        this.height = void 0;
        this.top = void 0;
        this.bottom = void 0;
        this.right = void 0;
        this.left = void 0;
        const scrollableAncestors = $83696c5bbc79d2da$export$e4864aa91b5ed091(element);
        const scrollOffsets = $83696c5bbc79d2da$var$getScrollOffsets(scrollableAncestors);
        this.rect = {
            ...rect
        };
        this.width = rect.width;
        this.height = rect.height;
        for (const [axis, keys, getScrollOffset] of $83696c5bbc79d2da$var$properties)for (const key of keys)Object.defineProperty(this, key, {
            get: ()=>{
                const currentOffsets = getScrollOffset(scrollableAncestors);
                const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
                return this.rect[key] + scrollOffsetsDeltla;
            },
            enumerable: true
        });
        Object.defineProperty(this, 'rect', {
            enumerable: false
        });
    }
}
var $83696c5bbc79d2da$export$eefe60e26f04c318;
(function(AutoScrollActivator) {
    AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
    AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})($83696c5bbc79d2da$export$eefe60e26f04c318 || ($83696c5bbc79d2da$export$eefe60e26f04c318 = {}));
var $83696c5bbc79d2da$export$f93aa492a37e1b0e;
(function(TraversalOrder) {
    TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
    TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})($83696c5bbc79d2da$export$f93aa492a37e1b0e || ($83696c5bbc79d2da$export$f93aa492a37e1b0e = {}));
function $83696c5bbc79d2da$var$useAutoScroller({ acceleration: acceleration, activator: activator = $83696c5bbc79d2da$export$eefe60e26f04c318.Pointer, canScroll: canScroll, draggingRect: draggingRect, enabled: enabled, interval: interval = 5, order: order = $83696c5bbc79d2da$export$f93aa492a37e1b0e.TreeOrder, pointerCoordinates: pointerCoordinates, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, threshold: threshold }) {
    const [setAutoScrollInterval, clearAutoScrollInterval] = (0, $638831efd3fb3cf7$export$f4b266cd2aae9cb1)();
    const scrollSpeed = (0, $gRqVZ.useRef)({
        x: 1,
        y: 1
    });
    const rect = (0, $gRqVZ.useMemo)(()=>{
        switch(activator){
            case $83696c5bbc79d2da$export$eefe60e26f04c318.Pointer:
                return pointerCoordinates ? {
                    top: pointerCoordinates.y,
                    bottom: pointerCoordinates.y,
                    left: pointerCoordinates.x,
                    right: pointerCoordinates.x
                } : null;
            case $83696c5bbc79d2da$export$eefe60e26f04c318.DraggableRect:
                return draggingRect;
        }
        return null;
    }, [
        activator,
        draggingRect,
        pointerCoordinates
    ]);
    const scrollDirection = (0, $gRqVZ.useRef)($83696c5bbc79d2da$export$597cbd7bbd10deb4);
    const scrollContainerRef = (0, $gRqVZ.useRef)(null);
    const autoScroll = (0, $gRqVZ.useCallback)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
        const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
        scrollContainer.scrollBy(scrollLeft, scrollTop);
    }, []);
    const sortedScrollableAncestors = (0, $gRqVZ.useMemo)(()=>order === $83696c5bbc79d2da$export$f93aa492a37e1b0e.TreeOrder ? [
            ...scrollableAncestors
        ].reverse() : scrollableAncestors, [
        order,
        scrollableAncestors
    ]);
    (0, $gRqVZ.useEffect)(()=>{
        if (!enabled || !scrollableAncestors.length || !rect) {
            clearAutoScrollInterval();
            return;
        }
        for (const scrollContainer of sortedScrollableAncestors){
            if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) continue;
            const index = scrollableAncestors.indexOf(scrollContainer);
            const scrollContainerRect = scrollableAncestorRects[index];
            if (!scrollContainerRect) continue;
            const { direction: direction, speed: speed } = $83696c5bbc79d2da$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);
            if (speed.x > 0 || speed.y > 0) {
                clearAutoScrollInterval();
                scrollContainerRef.current = scrollContainer;
                setAutoScrollInterval(autoScroll, interval);
                scrollSpeed.current = speed;
                scrollDirection.current = direction;
                return;
            }
        }
        scrollSpeed.current = {
            x: 0,
            y: 0
        };
        scrollDirection.current = {
            x: 0,
            y: 0
        };
        clearAutoScrollInterval();
    }, [
        acceleration,
        autoScroll,
        canScroll,
        clearAutoScrollInterval,
        enabled,
        interval,
        JSON.stringify(rect),
        setAutoScrollInterval,
        scrollableAncestors,
        sortedScrollableAncestors,
        scrollableAncestorRects,
        JSON.stringify(threshold)
    ]);
}
function $83696c5bbc79d2da$var$useCachedNode(draggableNodes, id) {
    const draggableNode = id !== null ? draggableNodes[id] : undefined;
    const node = draggableNode ? draggableNode.node.current : null;
    return (0, $638831efd3fb3cf7$export$b0d7b7f1fcd613d1)((cachedNode)=>{
        var _ref;
        if (id === null) return null;
         // In some cases, the draggable node can unmount while dragging
        // This is the case for virtualized lists. In those situations,
        // we fall back to the last known value for that node.
        return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
    }, [
        node,
        id
    ]);
}
function $83696c5bbc79d2da$var$useCombineActivators(sensors, getSyntheticHandler) {
    return (0, $gRqVZ.useMemo)(()=>sensors.reduce((accumulator, sensor)=>{
            const { sensor: Sensor } = sensor;
            const sensorActivators = Sensor.activators.map((activator)=>({
                    eventName: activator.eventName,
                    handler: getSyntheticHandler(activator.handler, sensor)
                }));
            return [
                ...accumulator,
                ...sensorActivators
            ];
        }, []), [
        sensors,
        getSyntheticHandler
    ]);
}
var $83696c5bbc79d2da$export$571c10ffffe014ab;
(function(MeasuringStrategy) {
    MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
    MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
    MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})($83696c5bbc79d2da$export$571c10ffffe014ab || ($83696c5bbc79d2da$export$571c10ffffe014ab = {}));
var $83696c5bbc79d2da$export$8e062c3160beefd5;
(function(MeasuringFrequency) {
    MeasuringFrequency["Optimized"] = "optimized";
})($83696c5bbc79d2da$export$8e062c3160beefd5 || ($83696c5bbc79d2da$export$8e062c3160beefd5 = {}));
const $83696c5bbc79d2da$var$defaultValue = /*#__PURE__*/ new Map();
const $83696c5bbc79d2da$var$defaultConfig = {
    measure: $83696c5bbc79d2da$var$getTransformAgnosticClientRect,
    strategy: $83696c5bbc79d2da$export$571c10ffffe014ab.WhileDragging,
    frequency: $83696c5bbc79d2da$export$8e062c3160beefd5.Optimized
};
function $83696c5bbc79d2da$var$useDroppableMeasuring(containers, { dragging: dragging, dependencies: dependencies, config: config }) {
    const [containerIdsScheduledForMeasurement, setContainerIdsScheduledForMeasurement] = (0, $gRqVZ.useState)(null);
    const measuringScheduled = containerIdsScheduledForMeasurement != null;
    const { frequency: frequency, measure: measure, strategy: strategy } = {
        ...$83696c5bbc79d2da$var$defaultConfig,
        ...config
    };
    const containersRef = (0, $gRqVZ.useRef)(containers);
    const measureDroppableContainers = (0, $gRqVZ.useCallback)((ids = [])=>setContainerIdsScheduledForMeasurement((value)=>value ? value.concat(ids) : ids), []);
    const timeoutId = (0, $gRqVZ.useRef)(null);
    const disabled = isDisabled();
    const droppableRects = (0, $638831efd3fb3cf7$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (disabled && !dragging) return $83696c5bbc79d2da$var$defaultValue;
        const ids = containerIdsScheduledForMeasurement;
        if (!previousValue || previousValue === $83696c5bbc79d2da$var$defaultValue || containersRef.current !== containers || ids != null) {
            const map = new Map();
            for (let container of containers){
                if (!container) continue;
                if (ids && ids.length > 0 && !ids.includes(container.id) && container.rect.current) {
                    // This container does not need to be re-measured
                    map.set(container.id, container.rect.current);
                    continue;
                }
                const node = container.node.current;
                const rect = node ? new $83696c5bbc79d2da$var$Rect(measure(node), node) : null;
                container.rect.current = rect;
                if (rect) map.set(container.id, rect);
            }
            return map;
        }
        return previousValue;
    }, [
        containers,
        containerIdsScheduledForMeasurement,
        dragging,
        disabled,
        measure
    ]);
    (0, $gRqVZ.useEffect)(()=>{
        containersRef.current = containers;
    }, [
        containers
    ]);
    (0, $gRqVZ.useEffect)(()=>{
        if (disabled) return;
        requestAnimationFrame(()=>measureDroppableContainers());
    }, [
        dragging,
        disabled
    ]);
    (0, $gRqVZ.useEffect)(()=>{
        if (measuringScheduled) setContainerIdsScheduledForMeasurement(null);
    }, [
        measuringScheduled
    ]);
    (0, $gRqVZ.useEffect)(()=>{
        if (disabled || typeof frequency !== 'number' || timeoutId.current !== null) return;
        timeoutId.current = setTimeout(()=>{
            measureDroppableContainers();
            timeoutId.current = null;
        }, frequency);
    }, [
        frequency,
        disabled,
        measureDroppableContainers,
        ...dependencies
    ]);
    return {
        droppableRects: droppableRects,
        measureDroppableContainers: measureDroppableContainers,
        measuringScheduled: measuringScheduled
    };
    function isDisabled() {
        switch(strategy){
            case $83696c5bbc79d2da$export$571c10ffffe014ab.Always:
                return false;
            case $83696c5bbc79d2da$export$571c10ffffe014ab.BeforeDragging:
                return dragging;
            default:
                return !dragging;
        }
    }
}
/**
 * Returns a new ResizeObserver instance bound to the `onResize` callback.
 * If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
 */ function $83696c5bbc79d2da$var$useResizeObserver({ onResize: onResize, disabled: disabled }) {
    const resizeObserver = (0, $gRqVZ.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.ResizeObserver === 'undefined') return undefined;
        const { ResizeObserver: ResizeObserver } = window;
        return new ResizeObserver(onResize);
    }, [
        disabled,
        onResize
    ]);
    (0, $gRqVZ.useEffect)(()=>{
        return ()=>resizeObserver == null ? void 0 : resizeObserver.disconnect();
    }, [
        resizeObserver
    ]);
    return resizeObserver;
}
function $83696c5bbc79d2da$var$useScrollOffsets(elements) {
    const [scrollCoordinates, setScrollCoordinates] = (0, $gRqVZ.useState)(null);
    const prevElements = (0, $gRqVZ.useRef)(elements); // To-do: Throttle the handleScroll callback
    const handleScroll = (0, $gRqVZ.useCallback)((event)=>{
        const scrollingElement = $83696c5bbc79d2da$var$getScrollableElement(event.target);
        if (!scrollingElement) return;
        setScrollCoordinates((scrollCoordinates)=>{
            if (!scrollCoordinates) return null;
            scrollCoordinates.set(scrollingElement, $83696c5bbc79d2da$var$getScrollCoordinates(scrollingElement));
            return new Map(scrollCoordinates);
        });
    }, []);
    (0, $gRqVZ.useEffect)(()=>{
        const previousElements = prevElements.current;
        if (elements !== previousElements) {
            cleanup(previousElements);
            const entries = elements.map((element)=>{
                const scrollableElement = $83696c5bbc79d2da$var$getScrollableElement(element);
                if (scrollableElement) {
                    scrollableElement.addEventListener('scroll', handleScroll, {
                        passive: true
                    });
                    return [
                        scrollableElement,
                        $83696c5bbc79d2da$var$getScrollCoordinates(scrollableElement)
                    ];
                }
                return null;
            }).filter((entry)=>entry != null);
            setScrollCoordinates(entries.length ? new Map(entries) : null);
            prevElements.current = elements;
        }
        return ()=>{
            cleanup(elements);
            cleanup(previousElements);
        };
        function cleanup(elements) {
            elements.forEach((element)=>{
                const scrollableElement = $83696c5bbc79d2da$var$getScrollableElement(element);
                scrollableElement == null || scrollableElement.removeEventListener('scroll', handleScroll);
            });
        }
    }, [
        handleScroll,
        elements
    ]);
    return (0, $gRqVZ.useMemo)(()=>{
        if (elements.length) return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates)=>(0, $638831efd3fb3cf7$export$e16d8520af44a096)(acc, coordinates), $83696c5bbc79d2da$export$597cbd7bbd10deb4) : $83696c5bbc79d2da$var$getScrollOffsets(elements);
        return $83696c5bbc79d2da$export$597cbd7bbd10deb4;
    }, [
        elements,
        scrollCoordinates
    ]);
}
const $83696c5bbc79d2da$var$defaultValue$1 = [];
function $83696c5bbc79d2da$var$useScrollableAncestors(node) {
    const previousNode = (0, $gRqVZ.useRef)(node);
    const ancestors = (0, $638831efd3fb3cf7$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!node) return $83696c5bbc79d2da$var$defaultValue$1;
        if (previousValue && node && previousNode.current && node.parentNode === previousNode.current.parentNode) return previousValue;
        return $83696c5bbc79d2da$export$e4864aa91b5ed091(node);
    }, [
        node
    ]);
    (0, $gRqVZ.useEffect)(()=>{
        previousNode.current = node;
    }, [
        node
    ]);
    return ancestors;
}
function $83696c5bbc79d2da$var$useSensorSetup(sensors) {
    (0, $gRqVZ.useEffect)(()=>{
        if (!(0, $638831efd3fb3cf7$export$71594e8a50f746f4)) return;
        const teardownFns = sensors.map(({ sensor: sensor })=>sensor.setup == null ? void 0 : sensor.setup());
        return ()=>{
            for (const teardown of teardownFns)teardown == null || teardown();
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map(({ sensor: sensor })=>sensor));
}
function $83696c5bbc79d2da$var$useSyntheticListeners(listeners, id) {
    return (0, $gRqVZ.useMemo)(()=>{
        return listeners.reduce((acc, { eventName: eventName, handler: handler })=>{
            acc[eventName] = (event)=>{
                handler(event, id);
            };
            return acc;
        }, {});
    }, [
        listeners,
        id
    ]);
}
const $83696c5bbc79d2da$var$useClientRect = /*#__PURE__*/ $83696c5bbc79d2da$var$createUseRectFn($83696c5bbc79d2da$var$getTransformAgnosticClientRect);
const $83696c5bbc79d2da$var$useClientRects = /*#__PURE__*/ $83696c5bbc79d2da$var$createUseRectsFn($83696c5bbc79d2da$var$getTransformAgnosticClientRect);
function $83696c5bbc79d2da$var$useRect(element, getRect, forceRecompute) {
    const previousElement = (0, $gRqVZ.useRef)(element);
    return (0, $638831efd3fb3cf7$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!element) return null;
        if (forceRecompute || !previousValue && element || element !== previousElement.current) {
            if ((0, $638831efd3fb3cf7$export$1b3bfaa9684536aa)(element) && element.parentNode == null) return null;
            return new $83696c5bbc79d2da$var$Rect(getRect(element), element);
        }
        return previousValue != null ? previousValue : null;
    }, [
        element,
        forceRecompute,
        getRect
    ]);
}
function $83696c5bbc79d2da$var$createUseRectFn(getRect) {
    return (element, forceRecompute)=>$83696c5bbc79d2da$var$useRect(element, getRect, forceRecompute);
}
function $83696c5bbc79d2da$var$createUseRectsFn(getRect) {
    const defaultValue = [];
    return function useRects(elements, forceRecompute) {
        const previousElements = (0, $gRqVZ.useRef)(elements);
        return (0, $638831efd3fb3cf7$export$b0d7b7f1fcd613d1)((previousValue)=>{
            if (!elements.length) return defaultValue;
            if (forceRecompute || !previousValue && elements.length || elements !== previousElements.current) return elements.map((element)=>new $83696c5bbc79d2da$var$Rect(getRect(element), element));
            return previousValue != null ? previousValue : defaultValue;
        }, [
            elements,
            forceRecompute
        ]);
    };
}
function $83696c5bbc79d2da$var$useWindowRect(element) {
    return (0, $gRqVZ.useMemo)(()=>element ? $83696c5bbc79d2da$var$getWindowClientRect(element) : null, [
        element
    ]);
}
function $83696c5bbc79d2da$var$getMeasurableNode(node) {
    if (!node) return null;
    if (node.children.length > 1) return node;
    const firstChild = node.children[0];
    return (0, $638831efd3fb3cf7$export$1b3bfaa9684536aa)(firstChild) ? firstChild : node;
}
function $83696c5bbc79d2da$var$useDragOverlayMeasuring({ measure: measure = $83696c5bbc79d2da$export$b6aa1f30c53d7454 }) {
    const [rect, setRect] = (0, $gRqVZ.useState)(null);
    const handleResize = (0, $gRqVZ.useCallback)((entries)=>{
        for (const { target: target } of entries)if ((0, $638831efd3fb3cf7$export$1b3bfaa9684536aa)(target)) {
            setRect((rect)=>{
                const newRect = measure(target);
                return rect ? {
                    ...rect,
                    width: newRect.width,
                    height: newRect.height
                } : newRect;
            });
            break;
        }
    }, [
        measure
    ]);
    const resizeObserver = $83696c5bbc79d2da$var$useResizeObserver({
        onResize: handleResize
    });
    const handleNodeChange = (0, $gRqVZ.useCallback)((element)=>{
        const node = $83696c5bbc79d2da$var$getMeasurableNode(element);
        resizeObserver == null || resizeObserver.disconnect();
        if (node) resizeObserver == null || resizeObserver.observe(node);
        setRect(node ? measure(node) : null);
    }, [
        measure,
        resizeObserver
    ]);
    const [nodeRef, setRef] = (0, $638831efd3fb3cf7$export$bc23c270f170c912)(handleNodeChange);
    return (0, $gRqVZ.useMemo)(()=>({
            nodeRef: nodeRef,
            rect: rect,
            setRef: setRef
        }), [
        rect,
        nodeRef,
        setRef
    ]);
}
function $83696c5bbc79d2da$export$cc72dd71f4ec69eb(sensor, options) {
    return (0, $gRqVZ.useMemo)(()=>({
            sensor: sensor,
            options: options != null ? options : {}
        }), [
        sensor,
        options
    ]);
}
function $83696c5bbc79d2da$export$19012f58216d597f(...sensors) {
    return (0, $gRqVZ.useMemo)(()=>[
            ...sensors
        ].filter((sensor)=>sensor != null), [
        ...sensors
    ]);
}
class $83696c5bbc79d2da$var$Listeners {
    constructor(target){
        this.target = void 0;
        this.listeners = [];
        this.removeAll = ()=>{
            this.listeners.forEach((listener)=>{
                var _this$target;
                return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
            });
        };
        this.target = target;
    }
    add(eventName, handler, options) {
        var _this$target2;
        (_this$target2 = this.target) == null || _this$target2.addEventListener(eventName, handler, options);
        this.listeners.push([
            eventName,
            handler,
            options
        ]);
    }
}
function $83696c5bbc79d2da$var$getEventListenerTarget(target) {
    // If the `event.target` element is removed from the document events will still be targeted
    // at it, and hence won't always bubble up to the window or document anymore.
    // If there is any risk of an element being removed while it is being dragged,
    // the best practice is to attach the event listeners directly to the target.
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
    const { EventTarget: EventTarget } = (0, $638831efd3fb3cf7$export$38b2d434cce3ea22)(target);
    return target instanceof EventTarget ? target : (0, $638831efd3fb3cf7$export$b204af158042fbac)(target);
}
function $83696c5bbc79d2da$var$hasExceededDistance(delta, measurement) {
    const dx = Math.abs(delta.x);
    const dy = Math.abs(delta.y);
    if (typeof measurement === 'number') return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
    if ('x' in measurement && 'y' in measurement) return dx > measurement.x && dy > measurement.y;
    if ('x' in measurement) return dx > measurement.x;
    if ('y' in measurement) return dy > measurement.y;
    return false;
}
var $83696c5bbc79d2da$var$EventName;
(function(EventName) {
    EventName["Click"] = "click";
    EventName["DragStart"] = "dragstart";
    EventName["Keydown"] = "keydown";
    EventName["ContextMenu"] = "contextmenu";
    EventName["Resize"] = "resize";
    EventName["SelectionChange"] = "selectionchange";
    EventName["VisibilityChange"] = "visibilitychange";
})($83696c5bbc79d2da$var$EventName || ($83696c5bbc79d2da$var$EventName = {}));
function $83696c5bbc79d2da$var$preventDefault(event) {
    event.preventDefault();
}
function $83696c5bbc79d2da$var$stopPropagation(event) {
    event.stopPropagation();
}
var $83696c5bbc79d2da$export$a8b1916dba3ae88b;
(function(KeyboardCode) {
    KeyboardCode["Space"] = "Space";
    KeyboardCode["Down"] = "ArrowDown";
    KeyboardCode["Right"] = "ArrowRight";
    KeyboardCode["Left"] = "ArrowLeft";
    KeyboardCode["Up"] = "ArrowUp";
    KeyboardCode["Esc"] = "Escape";
    KeyboardCode["Enter"] = "Enter";
})($83696c5bbc79d2da$export$a8b1916dba3ae88b || ($83696c5bbc79d2da$export$a8b1916dba3ae88b = {}));
const $83696c5bbc79d2da$var$defaultKeyboardCodes = {
    start: [
        $83696c5bbc79d2da$export$a8b1916dba3ae88b.Space,
        $83696c5bbc79d2da$export$a8b1916dba3ae88b.Enter
    ],
    cancel: [
        $83696c5bbc79d2da$export$a8b1916dba3ae88b.Esc
    ],
    end: [
        $83696c5bbc79d2da$export$a8b1916dba3ae88b.Space,
        $83696c5bbc79d2da$export$a8b1916dba3ae88b.Enter
    ]
};
const $83696c5bbc79d2da$var$defaultKeyboardCoordinateGetter = (event, { currentCoordinates: currentCoordinates })=>{
    switch(event.code){
        case $83696c5bbc79d2da$export$a8b1916dba3ae88b.Right:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x + 25
            };
        case $83696c5bbc79d2da$export$a8b1916dba3ae88b.Left:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x - 25
            };
        case $83696c5bbc79d2da$export$a8b1916dba3ae88b.Down:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y + 25
            };
        case $83696c5bbc79d2da$export$a8b1916dba3ae88b.Up:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y - 25
            };
    }
    return undefined;
};
class $83696c5bbc79d2da$export$44d67f2a438aeba9 {
    constructor(props){
        this.props = void 0;
        this.autoScrollEnabled = false;
        this.coordinates = $83696c5bbc79d2da$export$597cbd7bbd10deb4;
        this.listeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        const { event: { target: target } } = props;
        this.props = props;
        this.listeners = new $83696c5bbc79d2da$var$Listeners((0, $638831efd3fb3cf7$export$b204af158042fbac)(target));
        this.windowListeners = new $83696c5bbc79d2da$var$Listeners((0, $638831efd3fb3cf7$export$38b2d434cce3ea22)(target));
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.attach();
    }
    attach() {
        this.handleStart();
        this.windowListeners.add($83696c5bbc79d2da$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($83696c5bbc79d2da$var$EventName.VisibilityChange, this.handleCancel);
        setTimeout(()=>this.listeners.add($83696c5bbc79d2da$var$EventName.Keydown, this.handleKeyDown));
    }
    handleStart() {
        const { activeNode: activeNode, onStart: onStart } = this.props;
        if (!activeNode.node.current) throw new Error('Active draggable node is undefined');
        const activeNodeRect = $83696c5bbc79d2da$var$getTransformAgnosticClientRect(activeNode.node.current);
        const coordinates = {
            x: activeNodeRect.left,
            y: activeNodeRect.top
        };
        this.coordinates = coordinates;
        onStart(coordinates);
    }
    handleKeyDown(event) {
        if ((0, $638831efd3fb3cf7$export$130b789831072f4c)(event)) {
            const { coordinates: coordinates } = this;
            const { active: active, context: context, options: options } = this.props;
            const { keyboardCodes: keyboardCodes = $83696c5bbc79d2da$var$defaultKeyboardCodes, coordinateGetter: coordinateGetter = $83696c5bbc79d2da$var$defaultKeyboardCoordinateGetter, scrollBehavior: scrollBehavior = 'smooth' } = options;
            const { code: code } = event;
            if (keyboardCodes.end.includes(code)) {
                this.handleEnd(event);
                return;
            }
            if (keyboardCodes.cancel.includes(code)) {
                this.handleCancel(event);
                return;
            }
            const newCoordinates = coordinateGetter(event, {
                active: active,
                context: context.current,
                currentCoordinates: coordinates
            });
            if (newCoordinates) {
                const scrollDelta = {
                    x: 0,
                    y: 0
                };
                const { scrollableAncestors: scrollableAncestors } = context.current;
                for (const scrollContainer of scrollableAncestors){
                    const direction = event.code;
                    const coordinatesDelta = (0, $638831efd3fb3cf7$export$4e2d2ead65e5f7e3)(newCoordinates, coordinates);
                    const { isTop: isTop, isRight: isRight, isLeft: isLeft, isBottom: isBottom, maxScroll: maxScroll, minScroll: minScroll } = $83696c5bbc79d2da$var$getScrollPosition(scrollContainer);
                    const scrollElementRect = $83696c5bbc79d2da$var$getScrollElementRect(scrollContainer);
                    const clampedCoordinates = {
                        x: Math.min(direction === $83696c5bbc79d2da$export$a8b1916dba3ae88b.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === $83696c5bbc79d2da$export$a8b1916dba3ae88b.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
                        y: Math.min(direction === $83696c5bbc79d2da$export$a8b1916dba3ae88b.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === $83696c5bbc79d2da$export$a8b1916dba3ae88b.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
                    };
                    const canScrollX = direction === $83696c5bbc79d2da$export$a8b1916dba3ae88b.Right && !isRight || direction === $83696c5bbc79d2da$export$a8b1916dba3ae88b.Left && !isLeft;
                    const canScrollY = direction === $83696c5bbc79d2da$export$a8b1916dba3ae88b.Down && !isBottom || direction === $83696c5bbc79d2da$export$a8b1916dba3ae88b.Up && !isTop;
                    if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
                        const canFullyScrollToNewCoordinates = direction === $83696c5bbc79d2da$export$a8b1916dba3ae88b.Right && scrollContainer.scrollLeft + coordinatesDelta.x <= maxScroll.x || direction === $83696c5bbc79d2da$export$a8b1916dba3ae88b.Left && scrollContainer.scrollLeft + coordinatesDelta.x >= minScroll.x;
                        if (canFullyScrollToNewCoordinates) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollBy({
                                left: coordinatesDelta.x,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        scrollDelta.x = direction === $83696c5bbc79d2da$export$a8b1916dba3ae88b.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
                        scrollContainer.scrollBy({
                            left: -scrollDelta.x,
                            behavior: scrollBehavior
                        });
                        break;
                    } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
                        const canFullyScrollToNewCoordinates = direction === $83696c5bbc79d2da$export$a8b1916dba3ae88b.Down && scrollContainer.scrollTop + coordinatesDelta.y <= maxScroll.y || direction === $83696c5bbc79d2da$export$a8b1916dba3ae88b.Up && scrollContainer.scrollTop + coordinatesDelta.y >= minScroll.y;
                        if (canFullyScrollToNewCoordinates) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollBy({
                                top: coordinatesDelta.y,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        scrollDelta.y = direction === $83696c5bbc79d2da$export$a8b1916dba3ae88b.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
                        scrollContainer.scrollBy({
                            top: -scrollDelta.y,
                            behavior: scrollBehavior
                        });
                        break;
                    }
                }
                this.handleMove(event, (0, $638831efd3fb3cf7$export$e16d8520af44a096)(newCoordinates, scrollDelta));
            }
        }
    }
    handleMove(event, coordinates) {
        const { onMove: onMove } = this.props;
        event.preventDefault();
        onMove(coordinates);
        this.coordinates = coordinates;
    }
    handleEnd(event) {
        const { onEnd: onEnd } = this.props;
        event.preventDefault();
        this.detach();
        onEnd();
    }
    handleCancel(event) {
        const { onCancel: onCancel } = this.props;
        event.preventDefault();
        this.detach();
        onCancel();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll();
    }
}
$83696c5bbc79d2da$export$44d67f2a438aeba9.activators = [
    {
        eventName: 'onKeyDown',
        handler: (event, { keyboardCodes: keyboardCodes = $83696c5bbc79d2da$var$defaultKeyboardCodes, onActivation: onActivation })=>{
            const { code: code } = event.nativeEvent;
            if (keyboardCodes.start.includes(code)) {
                event.preventDefault();
                onActivation == null || onActivation({
                    event: event.nativeEvent
                });
                return true;
            }
            return false;
        }
    }
];
function $83696c5bbc79d2da$var$isDistanceConstraint(constraint) {
    return Boolean(constraint && 'distance' in constraint);
}
function $83696c5bbc79d2da$var$isDelayConstraint(constraint) {
    return Boolean(constraint && 'delay' in constraint);
}
class $83696c5bbc79d2da$var$AbstractPointerSensor {
    constructor(props, events, listenerTarget = $83696c5bbc79d2da$var$getEventListenerTarget(props.event.target)){
        var _getEventCoordinates;
        this.props = void 0;
        this.events = void 0;
        this.autoScrollEnabled = true;
        this.document = void 0;
        this.activated = false;
        this.initialCoordinates = void 0;
        this.timeoutId = null;
        this.listeners = void 0;
        this.documentListeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        this.events = events;
        const { event: event } = props;
        const { target: target } = event;
        this.props = props;
        this.events = events;
        this.document = (0, $638831efd3fb3cf7$export$b204af158042fbac)(target);
        this.documentListeners = new $83696c5bbc79d2da$var$Listeners(this.document);
        this.listeners = new $83696c5bbc79d2da$var$Listeners(listenerTarget);
        this.windowListeners = new $83696c5bbc79d2da$var$Listeners((0, $638831efd3fb3cf7$export$38b2d434cce3ea22)(target));
        this.initialCoordinates = (_getEventCoordinates = (0, $638831efd3fb3cf7$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates : $83696c5bbc79d2da$export$597cbd7bbd10deb4;
        this.handleStart = this.handleStart.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.removeTextSelection = this.removeTextSelection.bind(this);
        this.attach();
    }
    attach() {
        const { events: events, props: { options: { activationConstraint: activationConstraint } } } = this;
        this.listeners.add(events.move.name, this.handleMove, {
            passive: false
        });
        this.listeners.add(events.end.name, this.handleEnd);
        this.windowListeners.add($83696c5bbc79d2da$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($83696c5bbc79d2da$var$EventName.DragStart, $83696c5bbc79d2da$var$preventDefault);
        this.windowListeners.add($83696c5bbc79d2da$var$EventName.VisibilityChange, this.handleCancel);
        this.windowListeners.add($83696c5bbc79d2da$var$EventName.ContextMenu, $83696c5bbc79d2da$var$preventDefault);
        this.documentListeners.add($83696c5bbc79d2da$var$EventName.Keydown, this.handleKeydown);
        if (activationConstraint) {
            if ($83696c5bbc79d2da$var$isDistanceConstraint(activationConstraint)) return;
            if ($83696c5bbc79d2da$var$isDelayConstraint(activationConstraint)) {
                this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
                return;
            }
        }
        this.handleStart();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll(); // Wait until the next event loop before removing document listeners
        // This is necessary because we listen for `click` and `selection` events on the document
        setTimeout(this.documentListeners.removeAll, 50);
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
    handleStart() {
        const { initialCoordinates: initialCoordinates } = this;
        const { onStart: onStart } = this.props;
        if (initialCoordinates) {
            this.activated = true; // Stop propagation of click events once activation constraints are met
            this.documentListeners.add($83696c5bbc79d2da$var$EventName.Click, $83696c5bbc79d2da$var$stopPropagation, {
                capture: true
            }); // Remove any text selection from the document
            this.removeTextSelection(); // Prevent further text selection while dragging
            this.documentListeners.add($83696c5bbc79d2da$var$EventName.SelectionChange, this.removeTextSelection);
            onStart(initialCoordinates);
        }
    }
    handleMove(event) {
        var _getEventCoordinates2;
        const { activated: activated, initialCoordinates: initialCoordinates, props: props } = this;
        const { onMove: onMove, options: { activationConstraint: activationConstraint } } = props;
        if (!initialCoordinates) return;
        const coordinates = (_getEventCoordinates2 = (0, $638831efd3fb3cf7$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates2 : $83696c5bbc79d2da$export$597cbd7bbd10deb4;
        const delta = (0, $638831efd3fb3cf7$export$4e2d2ead65e5f7e3)(initialCoordinates, coordinates);
        if (!activated && activationConstraint) {
            // Constraint validation
            if ($83696c5bbc79d2da$var$isDelayConstraint(activationConstraint)) {
                if ($83696c5bbc79d2da$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                return;
            }
            if ($83696c5bbc79d2da$var$isDistanceConstraint(activationConstraint)) {
                if (activationConstraint.tolerance != null && $83696c5bbc79d2da$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                if ($83696c5bbc79d2da$var$hasExceededDistance(delta, activationConstraint.distance)) return this.handleStart();
                return;
            }
        }
        if (event.cancelable) event.preventDefault();
        onMove(coordinates);
    }
    handleEnd() {
        const { onEnd: onEnd } = this.props;
        this.detach();
        onEnd();
    }
    handleCancel() {
        const { onCancel: onCancel } = this.props;
        this.detach();
        onCancel();
    }
    handleKeydown(event) {
        if (event.code === $83696c5bbc79d2da$export$a8b1916dba3ae88b.Esc) this.handleCancel();
    }
    removeTextSelection() {
        var _this$document$getSel;
        (_this$document$getSel = this.document.getSelection()) == null || _this$document$getSel.removeAllRanges();
    }
}
const $83696c5bbc79d2da$var$events = {
    move: {
        name: 'pointermove'
    },
    end: {
        name: 'pointerup'
    }
};
class $83696c5bbc79d2da$export$b26af955418d6638 extends $83696c5bbc79d2da$var$AbstractPointerSensor {
    constructor(props){
        const { event: event } = props; // Pointer events stop firing if the target is unmounted while dragging
        // Therefore we attach listeners to the owner document instead
        const listenerTarget = (0, $638831efd3fb3cf7$export$b204af158042fbac)(event.target);
        super(props, $83696c5bbc79d2da$var$events, listenerTarget);
    }
}
$83696c5bbc79d2da$export$b26af955418d6638.activators = [
    {
        eventName: 'onPointerDown',
        handler: ({ nativeEvent: event }, { onActivation: onActivation })=>{
            if (!event.isPrimary || event.button !== 0) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $83696c5bbc79d2da$var$events$1 = {
    move: {
        name: 'mousemove'
    },
    end: {
        name: 'mouseup'
    }
};
var $83696c5bbc79d2da$var$MouseButton;
(function(MouseButton) {
    MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})($83696c5bbc79d2da$var$MouseButton || ($83696c5bbc79d2da$var$MouseButton = {}));
class $83696c5bbc79d2da$export$b28554b50bf7f273 extends $83696c5bbc79d2da$var$AbstractPointerSensor {
    constructor(props){
        super(props, $83696c5bbc79d2da$var$events$1, (0, $638831efd3fb3cf7$export$b204af158042fbac)(props.event.target));
    }
}
$83696c5bbc79d2da$export$b28554b50bf7f273.activators = [
    {
        eventName: 'onMouseDown',
        handler: ({ nativeEvent: event }, { onActivation: onActivation })=>{
            if (event.button === $83696c5bbc79d2da$var$MouseButton.RightClick) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $83696c5bbc79d2da$var$events$2 = {
    move: {
        name: 'touchmove'
    },
    end: {
        name: 'touchend'
    }
};
class $83696c5bbc79d2da$export$19b41baf2e1bcdc0 extends $83696c5bbc79d2da$var$AbstractPointerSensor {
    constructor(props){
        super(props, $83696c5bbc79d2da$var$events$2);
    }
    static setup() {
        // Adding a non-capture and non-passive `touchmove` listener in order
        // to force `event.preventDefault()` calls to work in dynamically added
        // touchmove event handlers. This is required for iOS Safari.
        window.addEventListener($83696c5bbc79d2da$var$events$2.move.name, noop, {
            capture: false,
            passive: false
        });
        return function teardown() {
            window.removeEventListener($83696c5bbc79d2da$var$events$2.move.name, noop);
        }; // We create a new handler because the teardown function of another sensor
        // could remove our event listener if we use a referentially equal listener.
        function noop() {}
    }
}
$83696c5bbc79d2da$export$19b41baf2e1bcdc0.activators = [
    {
        eventName: 'onTouchStart',
        handler: ({ nativeEvent: event }, { onActivation: onActivation })=>{
            const { touches: touches } = event;
            if (touches.length > 1) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
function $83696c5bbc79d2da$export$f1696300e8775372(modifiers, { transform: transform, ...args }) {
    return (modifiers == null ? void 0 : modifiers.length) ? modifiers.reduce((accumulator, modifier)=>{
        return modifier({
            transform: accumulator,
            ...args
        });
    }, transform) : transform;
}
const $83696c5bbc79d2da$var$defaultSensors = [
    {
        sensor: $83696c5bbc79d2da$export$b26af955418d6638,
        options: {}
    },
    {
        sensor: $83696c5bbc79d2da$export$44d67f2a438aeba9,
        options: {}
    }
];
const $83696c5bbc79d2da$var$defaultData = {
    current: {}
};
const $83696c5bbc79d2da$var$ActiveDraggableContext = /*#__PURE__*/ (0, $gRqVZ.createContext)({
    ...$83696c5bbc79d2da$export$597cbd7bbd10deb4,
    scaleX: 1,
    scaleY: 1
});
const $83696c5bbc79d2da$export$2d5c5ceac203fc1e = /*#__PURE__*/ (0, $gRqVZ.memo)(function DndContext({ id: id, autoScroll: autoScroll = true, announcements: announcements, children: children, sensors: sensors = $83696c5bbc79d2da$var$defaultSensors, collisionDetection: collisionDetection = $83696c5bbc79d2da$export$953346c40b5eb62a, measuring: measuring, modifiers: modifiers, screenReaderInstructions: screenReaderInstructions$1 = $83696c5bbc79d2da$var$screenReaderInstructions, ...props }) {
    var _measuring$draggable$, _measuring$draggable, _sensorContext$curren, _measuring$dragOverla, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
    const store = (0, $gRqVZ.useReducer)($83696c5bbc79d2da$var$reducer, undefined, $83696c5bbc79d2da$var$getInitialState);
    const [state, dispatch] = store;
    const [monitorState, setMonitorState] = (0, $gRqVZ.useState)(()=>({
            type: null,
            event: null
        }));
    const [isDragging, setIsDragging] = (0, $gRqVZ.useState)(false);
    const { draggable: { active: activeId, nodes: draggableNodes, translate: translate }, droppable: { containers: droppableContainers } } = state;
    const node = activeId ? draggableNodes[activeId] : null;
    const activeRects = (0, $gRqVZ.useRef)({
        initial: null,
        translated: null
    });
    const active = (0, $gRqVZ.useMemo)(()=>{
        var _node$data;
        return activeId != null ? {
            id: activeId,
            // It's possible for the active node to unmount while dragging
            data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : $83696c5bbc79d2da$var$defaultData,
            rect: activeRects
        } : null;
    }, [
        activeId,
        node
    ]);
    const activeRef = (0, $gRqVZ.useRef)(null);
    const [activeSensor, setActiveSensor] = (0, $gRqVZ.useState)(null);
    const [activatorEvent, setActivatorEvent] = (0, $gRqVZ.useState)(null);
    const latestProps = (0, $638831efd3fb3cf7$export$86c4283a11f23f95)(props, Object.values(props));
    const draggableDescribedById = (0, $638831efd3fb3cf7$export$c485849f2e393253)(`DndDescribedBy`, id);
    const enabledDroppableContainers = (0, $gRqVZ.useMemo)(()=>droppableContainers.getEnabled(), [
        droppableContainers
    ]);
    const { droppableRects: droppableRects, measureDroppableContainers: measureDroppableContainers, measuringScheduled: measuringScheduled } = $83696c5bbc79d2da$var$useDroppableMeasuring(enabledDroppableContainers, {
        dragging: isDragging,
        dependencies: [
            translate.x,
            translate.y
        ],
        config: measuring == null ? void 0 : measuring.droppable
    });
    const activeNode = $83696c5bbc79d2da$var$useCachedNode(draggableNodes, activeId);
    const activationCoordinates = activatorEvent ? (0, $638831efd3fb3cf7$export$36195c8aa1517e04)(activatorEvent) : null;
    const activeNodeRect = $83696c5bbc79d2da$var$useRect(activeNode, (_measuring$draggable$ = measuring == null ? void 0 : (_measuring$draggable = measuring.draggable) == null ? void 0 : _measuring$draggable.measure) != null ? _measuring$draggable$ : $83696c5bbc79d2da$var$getTransformAgnosticClientRect);
    const containerNodeRect = $83696c5bbc79d2da$var$useClientRect(activeNode ? activeNode.parentElement : null);
    const sensorContext = (0, $gRqVZ.useRef)({
        active: null,
        activeNode: activeNode,
        collisionRect: null,
        collisions: null,
        droppableRects: droppableRects,
        draggableNodes: draggableNodes,
        draggingNode: null,
        draggingNodeRect: null,
        droppableContainers: droppableContainers,
        over: null,
        scrollableAncestors: [],
        scrollAdjustedTranslate: null
    });
    const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
    const dragOverlay = $83696c5bbc79d2da$var$useDragOverlayMeasuring({
        measure: measuring == null ? void 0 : (_measuring$dragOverla = measuring.dragOverlay) == null ? void 0 : _measuring$dragOverla.measure
    }); // Use the rect of the drag overlay if it is mounted
    const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
    const draggingNodeRect = (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect;
    const initialActiveNodeRectRef = (0, $gRqVZ.useRef)(null);
    const initialActiveNodeRect = initialActiveNodeRectRef.current; // The delta between the previous and new position of the draggable node
    // is only relevant when there is no drag overlay
    const nodeRectDelta = draggingNodeRect === activeNodeRect ? $83696c5bbc79d2da$var$getRectDelta(activeNodeRect, initialActiveNodeRect) : $83696c5bbc79d2da$export$597cbd7bbd10deb4; // Get the window rect of the dragging node
    const windowRect = $83696c5bbc79d2da$var$useWindowRect(draggingNode ? draggingNode.ownerDocument.defaultView : null); // Get scrollable ancestors of the dragging node
    const scrollableAncestors = $83696c5bbc79d2da$var$useScrollableAncestors(activeId ? overNode != null ? overNode : draggingNode : null);
    const scrollableAncestorRects = $83696c5bbc79d2da$var$useClientRects(scrollableAncestors); // Apply modifiers
    const modifiedTranslate = $83696c5bbc79d2da$export$f1696300e8775372(modifiers, {
        transform: {
            x: translate.x - nodeRectDelta.x,
            y: translate.y - nodeRectDelta.y,
            scaleX: 1,
            scaleY: 1
        },
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: draggingNodeRect,
        over: sensorContext.current.over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        windowRect: windowRect
    });
    const pointerCoordinates = activationCoordinates ? (0, $638831efd3fb3cf7$export$e16d8520af44a096)(activationCoordinates, translate) : null;
    const scrollAdjustment = $83696c5bbc79d2da$var$useScrollOffsets(scrollableAncestors);
    const scrollAdjustedTranslate = (0, $638831efd3fb3cf7$export$e16d8520af44a096)(modifiedTranslate, scrollAdjustment);
    const collisionRect = draggingNodeRect ? $83696c5bbc79d2da$var$getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
    const collisions = active && collisionRect ? collisionDetection({
        active: active,
        collisionRect: collisionRect,
        droppableContainers: enabledDroppableContainers,
        pointerCoordinates: pointerCoordinates
    }) : null;
    const overId = $83696c5bbc79d2da$export$ef1beab6d7287295(collisions, 'id');
    const [over, setOver] = (0, $gRqVZ.useState)(null);
    const transform = $83696c5bbc79d2da$var$adjustScale(modifiedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
    const instantiateSensor = (0, $gRqVZ.useCallback)((event, { sensor: Sensor, options: options })=>{
        if (!activeRef.current) return;
        const activeNode = draggableNodes[activeRef.current];
        if (!activeNode) return;
        const sensorInstance = new Sensor({
            active: activeRef.current,
            activeNode: activeNode,
            event: event.nativeEvent,
            options: options,
            // Sensors need to be instantiated with refs for arguments that change over time
            // otherwise they are frozen in time with the stale arguments
            context: sensorContext,
            onStart (initialCoordinates) {
                const id = activeRef.current;
                if (!id) return;
                const node = draggableNodes[id];
                if (!node) return;
                const { onDragStart: onDragStart } = latestProps.current;
                const event = {
                    active: {
                        id: id,
                        data: node.data,
                        rect: activeRects
                    }
                };
                (0, $hYKvr.unstable_batchedUpdates)(()=>{
                    dispatch({
                        type: $83696c5bbc79d2da$var$Action.DragStart,
                        initialCoordinates: initialCoordinates,
                        active: id
                    });
                    setMonitorState({
                        type: $83696c5bbc79d2da$var$Action.DragStart,
                        event: event
                    });
                });
                onDragStart == null || onDragStart(event);
            },
            onMove (coordinates) {
                dispatch({
                    type: $83696c5bbc79d2da$var$Action.DragMove,
                    coordinates: coordinates
                });
            },
            onEnd: createHandler($83696c5bbc79d2da$var$Action.DragEnd),
            onCancel: createHandler($83696c5bbc79d2da$var$Action.DragCancel)
        });
        (0, $hYKvr.unstable_batchedUpdates)(()=>{
            setActiveSensor(sensorInstance);
            setActivatorEvent(event.nativeEvent);
        });
        function createHandler(type) {
            return async function handler() {
                const { active: active, collisions: collisions, over: over, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
                let event = null;
                if (active && scrollAdjustedTranslate) {
                    const { cancelDrop: cancelDrop } = latestProps.current;
                    event = {
                        active: active,
                        collisions: collisions,
                        delta: scrollAdjustedTranslate,
                        over: over
                    };
                    if (type === $83696c5bbc79d2da$var$Action.DragEnd && typeof cancelDrop === 'function') {
                        const shouldCancel = await Promise.resolve(cancelDrop(event));
                        if (shouldCancel) type = $83696c5bbc79d2da$var$Action.DragCancel;
                    }
                }
                activeRef.current = null;
                (0, $hYKvr.unstable_batchedUpdates)(()=>{
                    dispatch({
                        type: type
                    });
                    setOver(null);
                    setIsDragging(false);
                    setActiveSensor(null);
                    setActivatorEvent(null);
                    if (event) setMonitorState({
                        type: type,
                        event: event
                    });
                    if (event) {
                        const { onDragCancel: onDragCancel, onDragEnd: onDragEnd } = latestProps.current;
                        const handler = type === $83696c5bbc79d2da$var$Action.DragEnd ? onDragEnd : onDragCancel;
                        handler == null || handler(event);
                    }
                });
            };
        }
    }, [
        draggableNodes
    ]);
    const bindActivatorToSensorInstantiator = (0, $gRqVZ.useCallback)((handler, sensor)=>{
        return (event, active)=>{
            const nativeEvent = event.nativeEvent;
            if (activeRef.current !== null || // Event has already been captured
            nativeEvent.dndKit || nativeEvent.defaultPrevented) return;
            if (handler(event, sensor.options) === true) {
                nativeEvent.dndKit = {
                    capturedBy: sensor.sensor
                };
                activeRef.current = active;
                instantiateSensor(event, sensor);
            }
        };
    }, [
        instantiateSensor
    ]);
    const activators = $83696c5bbc79d2da$var$useCombineActivators(sensors, bindActivatorToSensorInstantiator);
    $83696c5bbc79d2da$var$useSensorSetup(sensors);
    (0, $gRqVZ.useEffect)(()=>{
        if (activeId != null) setIsDragging(true);
    }, [
        activeId
    ]);
    (0, $gRqVZ.useEffect)(()=>{
        if (!active) initialActiveNodeRectRef.current = null;
        if (active && activeNodeRect && !initialActiveNodeRectRef.current) initialActiveNodeRectRef.current = activeNodeRect;
    }, [
        activeNodeRect,
        active
    ]);
    (0, $gRqVZ.useEffect)(()=>{
        const { onDragMove: onDragMove } = latestProps.current;
        const { active: active, collisions: collisions, over: over } = sensorContext.current;
        if (!active) return;
        const event = {
            active: active,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        setMonitorState({
            type: $83696c5bbc79d2da$var$Action.DragMove,
            event: event
        });
        onDragMove == null || onDragMove(event);
    }, [
        scrollAdjustedTranslate.x,
        scrollAdjustedTranslate.y
    ]);
    (0, $gRqVZ.useEffect)(()=>{
        const { active: active, collisions: collisions, droppableContainers: droppableContainers, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
        if (!active || !activeRef.current || !scrollAdjustedTranslate) return;
        const { onDragOver: onDragOver } = latestProps.current;
        const overContainer = droppableContainers.get(overId);
        const over = overContainer && overContainer.rect.current ? {
            id: overContainer.id,
            rect: overContainer.rect.current,
            data: overContainer.data,
            disabled: overContainer.disabled
        } : null;
        const event = {
            active: active,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $hYKvr.unstable_batchedUpdates)(()=>{
            setOver(over);
            setMonitorState({
                type: $83696c5bbc79d2da$var$Action.DragOver,
                event: event
            });
            onDragOver == null || onDragOver(event);
        });
    }, [
        overId
    ]);
    (0, $638831efd3fb3cf7$export$700979bc83e7db82)(()=>{
        sensorContext.current = {
            active: active,
            activeNode: activeNode,
            collisionRect: collisionRect,
            collisions: collisions,
            droppableRects: droppableRects,
            draggableNodes: draggableNodes,
            draggingNode: draggingNode,
            draggingNodeRect: draggingNodeRect,
            droppableContainers: droppableContainers,
            over: over,
            scrollableAncestors: scrollableAncestors,
            scrollAdjustedTranslate: scrollAdjustedTranslate
        };
        activeRects.current = {
            initial: draggingNodeRect,
            translated: collisionRect
        };
    }, [
        active,
        activeNode,
        collisions,
        collisionRect,
        draggableNodes,
        draggingNode,
        draggingNodeRect,
        droppableRects,
        droppableContainers,
        over,
        scrollableAncestors,
        scrollAdjustedTranslate
    ]);
    $83696c5bbc79d2da$var$useAutoScroller({
        ...getAutoScrollerOptions(),
        draggingRect: collisionRect,
        pointerCoordinates: pointerCoordinates,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects
    });
    const publicContext = (0, $gRqVZ.useMemo)(()=>{
        const context = {
            active: active,
            activeNode: activeNode,
            activeNodeRect: activeNodeRect,
            activatorEvent: activatorEvent,
            collisions: collisions,
            containerNodeRect: containerNodeRect,
            dragOverlay: dragOverlay,
            draggableNodes: draggableNodes,
            droppableContainers: droppableContainers,
            droppableRects: droppableRects,
            over: over,
            measureDroppableContainers: measureDroppableContainers,
            scrollableAncestors: scrollableAncestors,
            scrollableAncestorRects: scrollableAncestorRects,
            measuringScheduled: measuringScheduled,
            windowRect: windowRect
        };
        return context;
    }, [
        active,
        activeNode,
        activeNodeRect,
        activatorEvent,
        collisions,
        containerNodeRect,
        dragOverlay,
        draggableNodes,
        droppableContainers,
        droppableRects,
        over,
        measureDroppableContainers,
        scrollableAncestors,
        scrollableAncestorRects,
        measuringScheduled,
        windowRect
    ]);
    const internalContext = (0, $gRqVZ.useMemo)(()=>{
        const context = {
            activatorEvent: activatorEvent,
            activators: activators,
            active: active,
            activeNodeRect: activeNodeRect,
            ariaDescribedById: {
                draggable: draggableDescribedById
            },
            dispatch: dispatch,
            draggableNodes: draggableNodes,
            over: over,
            measureDroppableContainers: measureDroppableContainers
        };
        return context;
    }, [
        activatorEvent,
        activators,
        active,
        activeNodeRect,
        dispatch,
        draggableDescribedById,
        draggableNodes,
        over,
        measureDroppableContainers
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($83696c5bbc79d2da$var$DndMonitorContext.Provider, {
        value: monitorState
    }, (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($83696c5bbc79d2da$var$InternalContext.Provider, {
        value: internalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($83696c5bbc79d2da$var$PublicContext.Provider, {
        value: publicContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($83696c5bbc79d2da$var$ActiveDraggableContext.Provider, {
        value: transform
    }, children))), (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($83696c5bbc79d2da$var$Accessibility, {
        announcements: announcements,
        hiddenTextDescribedById: draggableDescribedById,
        screenReaderInstructions: screenReaderInstructions$1
    }));
    function getAutoScrollerOptions() {
        const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
        const autoScrollGloballyDisabled = typeof autoScroll === 'object' ? autoScroll.enabled === false : autoScroll === false;
        const enabled = !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
        if (typeof autoScroll === 'object') return {
            ...autoScroll,
            enabled: enabled
        };
        return {
            enabled: enabled
        };
    }
});
const $83696c5bbc79d2da$var$NullContext = /*#__PURE__*/ (0, $gRqVZ.createContext)(null);
const $83696c5bbc79d2da$var$defaultRole = 'button';
const $83696c5bbc79d2da$var$ID_PREFIX = 'Droppable';
function $83696c5bbc79d2da$export$df30c81f5aa01ff7({ id: id, data: data, disabled: disabled = false, attributes: attributes }) {
    const key = (0, $638831efd3fb3cf7$export$c485849f2e393253)($83696c5bbc79d2da$var$ID_PREFIX);
    const { activators: activators, activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, ariaDescribedById: ariaDescribedById, draggableNodes: draggableNodes, over: over } = (0, $gRqVZ.useContext)($83696c5bbc79d2da$var$InternalContext);
    const { role: role = $83696c5bbc79d2da$var$defaultRole, roleDescription: roleDescription = 'draggable', tabIndex: tabIndex = 0 } = attributes != null ? attributes : {};
    const isDragging = (active == null ? void 0 : active.id) === id;
    const transform = (0, $gRqVZ.useContext)(isDragging ? $83696c5bbc79d2da$var$ActiveDraggableContext : $83696c5bbc79d2da$var$NullContext);
    const [node, setNodeRef] = (0, $638831efd3fb3cf7$export$bc23c270f170c912)();
    const listeners = $83696c5bbc79d2da$var$useSyntheticListeners(activators, id);
    const dataRef = (0, $638831efd3fb3cf7$export$86c4283a11f23f95)(data);
    (0, $638831efd3fb3cf7$export$700979bc83e7db82)(()=>{
        draggableNodes[id] = {
            id: id,
            key: key,
            node: node,
            data: dataRef
        };
        return ()=>{
            const node = draggableNodes[id];
            if (node && node.key === key) delete draggableNodes[id];
        };
    }, [
        draggableNodes,
        id
    ]);
    const memoizedAttributes = (0, $gRqVZ.useMemo)(()=>({
            role: role,
            tabIndex: tabIndex,
            'aria-pressed': isDragging && role === $83696c5bbc79d2da$var$defaultRole ? true : undefined,
            'aria-roledescription': roleDescription,
            'aria-describedby': ariaDescribedById.draggable
        }), [
        role,
        tabIndex,
        isDragging,
        roleDescription,
        ariaDescribedById.draggable
    ]);
    return {
        active: active,
        activatorEvent: activatorEvent,
        activeNodeRect: activeNodeRect,
        attributes: memoizedAttributes,
        isDragging: isDragging,
        listeners: disabled ? undefined : listeners,
        node: node,
        over: over,
        setNodeRef: setNodeRef,
        transform: transform
    };
}
function $83696c5bbc79d2da$export$4930f6bf413be70e() {
    return (0, $gRqVZ.useContext)($83696c5bbc79d2da$var$PublicContext);
}
const $83696c5bbc79d2da$var$ID_PREFIX$1 = 'Droppable';
const $83696c5bbc79d2da$var$defaultResizeObserverConfig = {
    timeout: 25
};
function $83696c5bbc79d2da$export$d74e5d67dc2b3176({ data: data, disabled: disabled = false, id: id, resizeObserverConfig: resizeObserverConfig }) {
    const key = (0, $638831efd3fb3cf7$export$c485849f2e393253)($83696c5bbc79d2da$var$ID_PREFIX$1);
    const { active: active, dispatch: dispatch, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $gRqVZ.useContext)($83696c5bbc79d2da$var$InternalContext);
    const resizeObserverConnected = (0, $gRqVZ.useRef)(false);
    const rect = (0, $gRqVZ.useRef)(null);
    const callbackId = (0, $gRqVZ.useRef)(null);
    const { disabled: resizeObserverDisabled, updateMeasurementsFor: updateMeasurementsFor, timeout: resizeObserverTimeout } = {
        ...$83696c5bbc79d2da$var$defaultResizeObserverConfig,
        ...resizeObserverConfig
    };
    const ids = (0, $638831efd3fb3cf7$export$86c4283a11f23f95)(updateMeasurementsFor != null ? updateMeasurementsFor : id);
    const handleResize = (0, $gRqVZ.useCallback)(()=>{
        if (!resizeObserverConnected.current) {
            // ResizeObserver invokes the `handleResize` callback as soon as `observe` is called,
            // assuming the element is rendered and displayed.
            resizeObserverConnected.current = true;
            return;
        }
        if (callbackId.current != null) clearTimeout(callbackId.current);
        callbackId.current = setTimeout(()=>{
            measureDroppableContainers(typeof ids.current === 'string' ? [
                ids.current
            ] : ids.current);
            callbackId.current = null;
        }, resizeObserverTimeout);
    }, [
        resizeObserverTimeout
    ]);
    const resizeObserver = $83696c5bbc79d2da$var$useResizeObserver({
        onResize: handleResize,
        disabled: resizeObserverDisabled || !active
    });
    const handleNodeChange = (0, $gRqVZ.useCallback)((newElement, previousElement)=>{
        if (!resizeObserver) return;
        if (previousElement) {
            resizeObserver.unobserve(previousElement);
            resizeObserverConnected.current = false;
        }
        if (newElement) resizeObserver.observe(newElement);
    }, [
        resizeObserver
    ]);
    const [nodeRef, setNodeRef] = (0, $638831efd3fb3cf7$export$bc23c270f170c912)(handleNodeChange);
    const dataRef = (0, $638831efd3fb3cf7$export$86c4283a11f23f95)(data);
    (0, $gRqVZ.useEffect)(()=>{
        if (!resizeObserver || !nodeRef.current) return;
        resizeObserver.disconnect();
        resizeObserverConnected.current = false;
        resizeObserver.observe(nodeRef.current);
    }, [
        nodeRef,
        resizeObserver
    ]);
    (0, $638831efd3fb3cf7$export$700979bc83e7db82)(()=>{
        dispatch({
            type: $83696c5bbc79d2da$var$Action.RegisterDroppable,
            element: {
                id: id,
                key: key,
                disabled: disabled,
                node: nodeRef,
                rect: rect,
                data: dataRef
            }
        });
        return ()=>dispatch({
                type: $83696c5bbc79d2da$var$Action.UnregisterDroppable,
                key: key,
                id: id
            });
    }, [
        id
    ]);
    (0, $gRqVZ.useEffect)(()=>{
        dispatch({
            type: $83696c5bbc79d2da$var$Action.SetDroppableDisabled,
            id: id,
            key: key,
            disabled: disabled
        });
    }, [
        disabled
    ]);
    return {
        active: active,
        rect: rect,
        isOver: (over == null ? void 0 : over.id) === id,
        node: nodeRef,
        over: over,
        setNodeRef: setNodeRef
    };
}
const $83696c5bbc79d2da$export$10f7ab1c653bb60e = {
    duration: 250,
    easing: 'ease',
    dragSourceOpacity: 0
};
function $83696c5bbc79d2da$var$useDropAnimation({ animate: animate, adjustScale: adjustScale, activeId: activeId, draggableNodes: draggableNodes, duration: duration, dragSourceOpacity: dragSourceOpacity, easing: easing, node: node, transform: transform }) {
    const [dropAnimationComplete, setDropAnimationComplete] = (0, $gRqVZ.useState)(false);
    (0, $638831efd3fb3cf7$export$700979bc83e7db82)(()=>{
        var _draggableNodes$activ;
        if (!animate || !activeId || !easing || !duration) {
            if (animate) setDropAnimationComplete(true);
            return;
        }
        const finalNode = (_draggableNodes$activ = draggableNodes[activeId]) == null ? void 0 : _draggableNodes$activ.node.current;
        if (transform && node && finalNode && finalNode.parentNode !== null) {
            const fromNode = $83696c5bbc79d2da$var$getMeasurableNode(node);
            if (fromNode) {
                const from = fromNode.getBoundingClientRect();
                const to = $83696c5bbc79d2da$var$getTransformAgnosticClientRect(finalNode);
                const delta = {
                    x: from.left - to.left,
                    y: from.top - to.top
                };
                if (Math.abs(delta.x) || Math.abs(delta.y)) {
                    const scaleDelta = {
                        scaleX: adjustScale ? to.width * transform.scaleX / from.width : 1,
                        scaleY: adjustScale ? to.height * transform.scaleY / from.height : 1
                    };
                    const finalTransform = (0, $638831efd3fb3cf7$export$c4ffa16951855e28).Transform.toString({
                        x: transform.x - delta.x,
                        y: transform.y - delta.y,
                        ...scaleDelta
                    });
                    const originalOpacity = finalNode.style.opacity;
                    if (dragSourceOpacity != null) finalNode.style.opacity = `${dragSourceOpacity}`;
                    const nodeAnimation = node.animate([
                        {
                            transform: (0, $638831efd3fb3cf7$export$c4ffa16951855e28).Transform.toString(transform)
                        },
                        {
                            transform: finalTransform
                        }
                    ], {
                        easing: easing,
                        duration: duration
                    });
                    nodeAnimation.onfinish = ()=>{
                        node.style.display = 'none';
                        setDropAnimationComplete(true);
                        if (finalNode && dragSourceOpacity != null) finalNode.style.opacity = originalOpacity;
                    };
                    return;
                }
            }
        }
        setDropAnimationComplete(true);
    }, [
        animate,
        activeId,
        adjustScale,
        draggableNodes,
        duration,
        easing,
        dragSourceOpacity,
        node,
        transform
    ]);
    (0, $638831efd3fb3cf7$export$700979bc83e7db82)(()=>{
        if (dropAnimationComplete) setDropAnimationComplete(false);
    }, [
        dropAnimationComplete
    ]);
    return dropAnimationComplete;
}
const $83696c5bbc79d2da$var$defaultTransform = {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1
};
const $83696c5bbc79d2da$var$defaultTransition = (activatorEvent)=>{
    const isKeyboardActivator = (0, $638831efd3fb3cf7$export$130b789831072f4c)(activatorEvent);
    return isKeyboardActivator ? 'transform 250ms ease' : undefined;
};
const $83696c5bbc79d2da$export$aca73479aa40659d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).memo(({ adjustScale: adjustScale = false, children: children, dropAnimation: dropAnimation = $83696c5bbc79d2da$export$10f7ab1c653bb60e, style: styleProp, transition: transition = $83696c5bbc79d2da$var$defaultTransition, modifiers: modifiers, wrapperElement: wrapperElement = 'div', className: className, zIndex: zIndex = 999 })=>{
    var _active$id, _attributesSnapshot$c;
    const { active: active, activeNodeRect: activeNodeRect, containerNodeRect: containerNodeRect, draggableNodes: draggableNodes, activatorEvent: activatorEvent, over: over, dragOverlay: dragOverlay, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, windowRect: windowRect } = $83696c5bbc79d2da$export$4930f6bf413be70e();
    const transform = (0, $gRqVZ.useContext)($83696c5bbc79d2da$var$ActiveDraggableContext);
    const modifiedTransform = $83696c5bbc79d2da$export$f1696300e8775372(modifiers, {
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: dragOverlay.rect,
        over: over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        transform: transform,
        windowRect: windowRect
    });
    const isDragging = active !== null;
    const finalTransform = adjustScale ? modifiedTransform : {
        ...modifiedTransform,
        scaleX: 1,
        scaleY: 1
    };
    const initialRect = (0, $638831efd3fb3cf7$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (isDragging) {
            if (previousValue) return previousValue;
            if (!activeNodeRect) return null;
            return {
                ...activeNodeRect
            };
        }
        return null;
    }, [
        isDragging,
        activeNodeRect
    ]);
    const style = initialRect ? {
        position: 'fixed',
        width: initialRect.width,
        height: initialRect.height,
        top: initialRect.top,
        left: initialRect.left,
        zIndex: zIndex,
        transform: (0, $638831efd3fb3cf7$export$c4ffa16951855e28).Transform.toString(finalTransform),
        touchAction: 'none',
        transformOrigin: adjustScale && activatorEvent ? $83696c5bbc79d2da$var$getRelativeTransformOrigin(activatorEvent, initialRect) : undefined,
        transition: typeof transition === 'function' ? transition(activatorEvent) : transition,
        ...styleProp
    } : undefined;
    const attributes = isDragging ? {
        style: style,
        children: children,
        className: className,
        transform: finalTransform
    } : undefined;
    const attributesSnapshot = (0, $gRqVZ.useRef)(attributes);
    const derivedAttributes = attributes != null ? attributes : attributesSnapshot.current;
    const { children: finalChildren, transform: _, ...otherAttributes } = derivedAttributes != null ? derivedAttributes : {};
    const prevActiveId = (0, $gRqVZ.useRef)((_active$id = active == null ? void 0 : active.id) != null ? _active$id : null);
    const dropAnimationComplete = $83696c5bbc79d2da$var$useDropAnimation({
        animate: Boolean(dropAnimation && prevActiveId.current && !active),
        adjustScale: adjustScale,
        activeId: prevActiveId.current,
        draggableNodes: draggableNodes,
        duration: dropAnimation == null ? void 0 : dropAnimation.duration,
        easing: dropAnimation == null ? void 0 : dropAnimation.easing,
        dragSourceOpacity: dropAnimation == null ? void 0 : dropAnimation.dragSourceOpacity,
        node: dragOverlay.nodeRef.current,
        transform: (_attributesSnapshot$c = attributesSnapshot.current) == null ? void 0 : _attributesSnapshot$c.transform
    });
    const shouldRender = Boolean(finalChildren && (children || dropAnimation && !dropAnimationComplete));
    (0, $gRqVZ.useEffect)(()=>{
        if ((active == null ? void 0 : active.id) !== prevActiveId.current) {
            var _active$id2;
            prevActiveId.current = (_active$id2 = active == null ? void 0 : active.id) != null ? _active$id2 : null;
        }
        if (active && attributesSnapshot.current !== attributes) attributesSnapshot.current = attributes;
    }, [
        active,
        attributes
    ]);
    (0, $gRqVZ.useEffect)(()=>{
        if (dropAnimationComplete) attributesSnapshot.current = undefined;
    }, [
        dropAnimationComplete
    ]);
    if (!shouldRender) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($83696c5bbc79d2da$var$InternalContext.Provider, {
        value: $83696c5bbc79d2da$var$defaultInternalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($83696c5bbc79d2da$var$ActiveDraggableContext.Provider, {
        value: $83696c5bbc79d2da$var$defaultTransform
    }, (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement(wrapperElement, {
        ...otherAttributes,
        ref: dragOverlay.setRef
    }, finalChildren)));
});



var $gRqVZ = parcelRequire("gRqVZ");


/**
 * Move an array item to a different position. Returns a new array with the item moved to the new position.
 */ function $34983f388f26cd06$export$5d49d615ad5ea2b0(array, from, to) {
    const newArray = array.slice();
    newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
    return newArray;
}
/**
 * Swap an array item to a different position. Returns a new array with the item swapped to the new position.
 */ function $34983f388f26cd06$export$5d3a3e794fd2dcef(array, from, to) {
    const newArray = array.slice();
    newArray[from] = array[to];
    newArray[to] = array[from];
    return newArray;
}
function $34983f388f26cd06$var$getSortedRects(items, rects) {
    return items.reduce((accumulator, id, index)=>{
        const rect = rects.get(id);
        if (rect) accumulator[index] = rect;
        return accumulator;
    }, Array(items.length));
}
function $34983f388f26cd06$var$isValidIndex(index) {
    return index !== null && index >= 0;
}
// To-do: We should be calculating scale transformation
const $34983f388f26cd06$var$defaultScale = {
    scaleX: 1,
    scaleY: 1
};
const $34983f388f26cd06$export$7a687825fa98548a = ({ rects: rects, activeNodeRect: fallbackActiveRect, activeIndex: activeIndex, overIndex: overIndex, index: index })=>{
    var _rects$activeIndex;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    const itemGap = $34983f388f26cd06$var$getItemGap(rects, index, activeIndex);
    if (index === activeIndex) {
        const newIndexRect = rects[overIndex];
        if (!newIndexRect) return null;
        return {
            x: activeIndex < overIndex ? newIndexRect.left + newIndexRect.width - (activeNodeRect.left + activeNodeRect.width) : newIndexRect.left - activeNodeRect.left,
            y: 0,
            ...$34983f388f26cd06$var$defaultScale
        };
    }
    if (index > activeIndex && index <= overIndex) return {
        x: -activeNodeRect.width - itemGap,
        y: 0,
        ...$34983f388f26cd06$var$defaultScale
    };
    if (index < activeIndex && index >= overIndex) return {
        x: activeNodeRect.width + itemGap,
        y: 0,
        ...$34983f388f26cd06$var$defaultScale
    };
    return {
        x: 0,
        y: 0,
        ...$34983f388f26cd06$var$defaultScale
    };
};
function $34983f388f26cd06$var$getItemGap(rects, index, activeIndex) {
    const currentRect = rects[index];
    const previousRect = rects[index - 1];
    const nextRect = rects[index + 1];
    if (!currentRect || !previousRect && !nextRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.left - (previousRect.left + previousRect.width) : nextRect.left - (currentRect.left + currentRect.width);
    return nextRect ? nextRect.left - (currentRect.left + currentRect.width) : currentRect.left - (previousRect.left + previousRect.width);
}
const $34983f388f26cd06$export$9377a9486e3fbbe1 = ({ rects: rects, activeIndex: activeIndex, overIndex: overIndex, index: index })=>{
    const newRects = $34983f388f26cd06$export$5d49d615ad5ea2b0(rects, overIndex, activeIndex);
    const oldRect = rects[index];
    const newRect = newRects[index];
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
const $34983f388f26cd06$export$8b26fb37076c162 = ({ activeIndex: activeIndex, index: index, rects: rects, overIndex: overIndex })=>{
    let oldRect;
    let newRect;
    if (index === activeIndex) {
        oldRect = rects[index];
        newRect = rects[overIndex];
    }
    if (index === overIndex) {
        oldRect = rects[index];
        newRect = rects[activeIndex];
    }
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
// To-do: We should be calculating scale transformation
const $34983f388f26cd06$var$defaultScale$1 = {
    scaleX: 1,
    scaleY: 1
};
const $34983f388f26cd06$export$fe2be640df2ffb9e = ({ activeIndex: activeIndex, activeNodeRect: fallbackActiveRect, index: index, rects: rects, overIndex: overIndex })=>{
    var _rects$activeIndex;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    if (index === activeIndex) {
        const overIndexRect = rects[overIndex];
        if (!overIndexRect) return null;
        return {
            x: 0,
            y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
            ...$34983f388f26cd06$var$defaultScale$1
        };
    }
    const itemGap = $34983f388f26cd06$var$getItemGap$1(rects, index, activeIndex);
    if (index > activeIndex && index <= overIndex) return {
        x: 0,
        y: -activeNodeRect.height - itemGap,
        ...$34983f388f26cd06$var$defaultScale$1
    };
    if (index < activeIndex && index >= overIndex) return {
        x: 0,
        y: activeNodeRect.height + itemGap,
        ...$34983f388f26cd06$var$defaultScale$1
    };
    return {
        x: 0,
        y: 0,
        ...$34983f388f26cd06$var$defaultScale$1
    };
};
function $34983f388f26cd06$var$getItemGap$1(clientRects, index, activeIndex) {
    const currentRect = clientRects[index];
    const previousRect = clientRects[index - 1];
    const nextRect = clientRects[index + 1];
    if (!currentRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
    return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
const $34983f388f26cd06$var$ID_PREFIX = 'Sortable';
const $34983f388f26cd06$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createContext({
    activeIndex: -1,
    containerId: $34983f388f26cd06$var$ID_PREFIX,
    disableTransforms: false,
    items: [],
    overIndex: -1,
    useDragOverlay: false,
    sortedRects: [],
    strategy: $34983f388f26cd06$export$9377a9486e3fbbe1
});
function $34983f388f26cd06$export$86155fde54f06e6a({ children: children, id: id, items: userDefinedItems, strategy: strategy = $34983f388f26cd06$export$9377a9486e3fbbe1 }) {
    const { active: active, dragOverlay: dragOverlay, droppableRects: droppableRects, over: over, measureDroppableContainers: measureDroppableContainers, measuringScheduled: measuringScheduled } = (0, $83696c5bbc79d2da$export$4930f6bf413be70e)();
    const containerId = (0, $638831efd3fb3cf7$export$c485849f2e393253)($34983f388f26cd06$var$ID_PREFIX, id);
    const useDragOverlay = Boolean(dragOverlay.rect !== null);
    const items = (0, $gRqVZ.useMemo)(()=>userDefinedItems.map((item)=>typeof item === 'string' ? item : item.id), [
        userDefinedItems
    ]);
    const isDragging = active != null;
    const activeIndex = active ? items.indexOf(active.id) : -1;
    const overIndex = over ? items.indexOf(over.id) : -1;
    const previousItemsRef = (0, $gRqVZ.useRef)(items);
    const itemsHaveChanged = !$34983f388f26cd06$var$isEqual(items, previousItemsRef.current);
    const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
    (0, $638831efd3fb3cf7$export$700979bc83e7db82)(()=>{
        if (itemsHaveChanged && isDragging && !measuringScheduled) measureDroppableContainers(items);
    }, [
        itemsHaveChanged,
        items,
        isDragging,
        measureDroppableContainers,
        measuringScheduled
    ]);
    (0, $gRqVZ.useEffect)(()=>{
        previousItemsRef.current = items;
    }, [
        items
    ]);
    const contextValue = (0, $gRqVZ.useMemo)(()=>({
            activeIndex: activeIndex,
            containerId: containerId,
            disableTransforms: disableTransforms,
            items: items,
            overIndex: overIndex,
            useDragOverlay: useDragOverlay,
            sortedRects: $34983f388f26cd06$var$getSortedRects(items, droppableRects),
            strategy: strategy
        }), [
        activeIndex,
        containerId,
        disableTransforms,
        items,
        overIndex,
        droppableRects,
        useDragOverlay,
        strategy
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createElement($34983f388f26cd06$var$Context.Provider, {
        value: contextValue
    }, children);
}
function $34983f388f26cd06$var$isEqual(arr1, arr2) {
    return arr1.join() === arr2.join();
}
const $34983f388f26cd06$export$e1ca29a833a61b5e = ({ id: id, items: items, activeIndex: activeIndex, overIndex: overIndex })=>$34983f388f26cd06$export$5d49d615ad5ea2b0(items, activeIndex, overIndex).indexOf(id);
const $34983f388f26cd06$export$633d85fd1dcf5e11 = ({ containerId: containerId, isSorting: isSorting, wasDragging: wasDragging, index: index, items: items, newIndex: newIndex, previousItems: previousItems, previousContainerId: previousContainerId, transition: transition })=>{
    if (!transition || !wasDragging) return false;
    if (previousItems !== items && index === newIndex) return false;
    if (isSorting) return true;
    return newIndex !== index && containerId === previousContainerId;
};
const $34983f388f26cd06$var$defaultTransition = {
    duration: 200,
    easing: 'ease'
};
const $34983f388f26cd06$var$transitionProperty = 'transform';
const $34983f388f26cd06$var$disabledTransition = /*#__PURE__*/ (0, $638831efd3fb3cf7$export$c4ffa16951855e28).Transition.toString({
    property: $34983f388f26cd06$var$transitionProperty,
    duration: 0,
    easing: 'linear'
});
const $34983f388f26cd06$var$defaultAttributes = {
    roleDescription: 'sortable'
};
/*
 * When the index of an item changes while sorting,
 * we need to temporarily disable the transforms
 */ function $34983f388f26cd06$var$useDerivedTransform({ disabled: disabled, index: index, node: node, rect: rect }) {
    const [derivedTransform, setDerivedtransform] = (0, $gRqVZ.useState)(null);
    const previousIndex = (0, $gRqVZ.useRef)(index);
    (0, $638831efd3fb3cf7$export$700979bc83e7db82)(()=>{
        if (!disabled && index !== previousIndex.current && node.current) {
            const initial = rect.current;
            if (initial) {
                const current = (0, $83696c5bbc79d2da$export$b6aa1f30c53d7454)(node.current, {
                    ignoreTransform: true
                });
                const delta = {
                    x: initial.left - current.left,
                    y: initial.top - current.top,
                    scaleX: initial.width / current.width,
                    scaleY: initial.height / current.height
                };
                if (delta.x || delta.y) setDerivedtransform(delta);
            }
        }
        if (index !== previousIndex.current) previousIndex.current = index;
    }, [
        disabled,
        index,
        node,
        rect
    ]);
    (0, $gRqVZ.useEffect)(()=>{
        if (derivedTransform) requestAnimationFrame(()=>{
            setDerivedtransform(null);
        });
    }, [
        derivedTransform
    ]);
    return derivedTransform;
}
function $34983f388f26cd06$export$4ebcb6201122185a({ animateLayoutChanges: animateLayoutChanges = $34983f388f26cd06$export$633d85fd1dcf5e11, attributes: userDefinedAttributes, disabled: disabled, data: customData, getNewIndex: getNewIndex = $34983f388f26cd06$export$e1ca29a833a61b5e, id: id, strategy: localStrategy, resizeObserverConfig: resizeObserverConfig, transition: transition = $34983f388f26cd06$var$defaultTransition }) {
    const { items: items, containerId: containerId, activeIndex: activeIndex, disableTransforms: disableTransforms, sortedRects: sortedRects, overIndex: overIndex, useDragOverlay: useDragOverlay, strategy: globalStrategy } = (0, $gRqVZ.useContext)($34983f388f26cd06$var$Context);
    const index = items.indexOf(id);
    const data = (0, $gRqVZ.useMemo)(()=>({
            sortable: {
                containerId: containerId,
                index: index,
                items: items
            },
            ...customData
        }), [
        containerId,
        customData,
        index,
        items
    ]);
    const itemsAfterCurrentSortable = (0, $gRqVZ.useMemo)(()=>items.slice(items.indexOf(id)), [
        items,
        id
    ]);
    const { rect: rect, node: node, isOver: isOver, setNodeRef: setDroppableNodeRef } = (0, $83696c5bbc79d2da$export$d74e5d67dc2b3176)({
        id: id,
        data: data,
        resizeObserverConfig: {
            updateMeasurementsFor: itemsAfterCurrentSortable,
            ...resizeObserverConfig
        }
    });
    const { active: active, activatorEvent: activatorEvent, activeNodeRect: activeNodeRect, attributes: attributes, setNodeRef: setDraggableNodeRef, listeners: listeners, isDragging: isDragging, over: over, transform: transform } = (0, $83696c5bbc79d2da$export$df30c81f5aa01ff7)({
        id: id,
        data: data,
        attributes: {
            ...$34983f388f26cd06$var$defaultAttributes,
            ...userDefinedAttributes
        },
        disabled: disabled
    });
    const setNodeRef = (0, $638831efd3fb3cf7$export$2f8294366bb2d67a)(setDroppableNodeRef, setDraggableNodeRef);
    const isSorting = Boolean(active);
    const displaceItem = isSorting && !disableTransforms && $34983f388f26cd06$var$isValidIndex(activeIndex) && $34983f388f26cd06$var$isValidIndex(overIndex);
    const shouldDisplaceDragSource = !useDragOverlay && isDragging;
    const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
    const strategy = localStrategy != null ? localStrategy : globalStrategy;
    const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
        rects: sortedRects,
        activeNodeRect: activeNodeRect,
        activeIndex: activeIndex,
        overIndex: overIndex,
        index: index
    }) : null;
    const newIndex = $34983f388f26cd06$var$isValidIndex(activeIndex) && $34983f388f26cd06$var$isValidIndex(overIndex) ? getNewIndex({
        id: id,
        items: items,
        activeIndex: activeIndex,
        overIndex: overIndex
    }) : index;
    const activeId = active == null ? void 0 : active.id;
    const previous = (0, $gRqVZ.useRef)({
        activeId: activeId,
        items: items,
        newIndex: newIndex,
        containerId: containerId
    });
    const itemsHaveChanged = items !== previous.current.items;
    const shouldAnimateLayoutChanges = animateLayoutChanges({
        active: active,
        containerId: containerId,
        isDragging: isDragging,
        isSorting: isSorting,
        id: id,
        index: index,
        items: items,
        newIndex: previous.current.newIndex,
        previousItems: previous.current.items,
        previousContainerId: previous.current.containerId,
        transition: transition,
        wasDragging: previous.current.activeId != null
    });
    const derivedTransform = $34983f388f26cd06$var$useDerivedTransform({
        disabled: !shouldAnimateLayoutChanges,
        index: index,
        node: node,
        rect: rect
    });
    (0, $gRqVZ.useEffect)(()=>{
        if (isSorting && previous.current.newIndex !== newIndex) previous.current.newIndex = newIndex;
        if (containerId !== previous.current.containerId) previous.current.containerId = containerId;
        if (items !== previous.current.items) previous.current.items = items;
        if (activeId !== previous.current.activeId) previous.current.activeId = activeId;
    }, [
        activeId,
        isSorting,
        newIndex,
        containerId,
        items
    ]);
    return {
        active: active,
        activeIndex: activeIndex,
        attributes: attributes,
        rect: rect,
        index: index,
        newIndex: newIndex,
        items: items,
        isOver: isOver,
        isSorting: isSorting,
        isDragging: isDragging,
        listeners: listeners,
        node: node,
        overIndex: overIndex,
        over: over,
        setNodeRef: setNodeRef,
        setDroppableNodeRef: setDroppableNodeRef,
        setDraggableNodeRef: setDraggableNodeRef,
        transform: derivedTransform != null ? derivedTransform : finalTransform,
        transition: getTransition()
    };
    function getTransition() {
        if (derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
        itemsHaveChanged && previous.current.newIndex === index) return $34983f388f26cd06$var$disabledTransition;
        if (shouldDisplaceDragSource && !(0, $638831efd3fb3cf7$export$130b789831072f4c)(activatorEvent) || !transition) return undefined;
        if (isSorting || shouldAnimateLayoutChanges) return (0, $638831efd3fb3cf7$export$c4ffa16951855e28).Transition.toString({
            ...transition,
            property: $34983f388f26cd06$var$transitionProperty
        });
        return undefined;
    }
}
const $34983f388f26cd06$var$directions = [
    (0, $83696c5bbc79d2da$export$a8b1916dba3ae88b).Down,
    (0, $83696c5bbc79d2da$export$a8b1916dba3ae88b).Right,
    (0, $83696c5bbc79d2da$export$a8b1916dba3ae88b).Up,
    (0, $83696c5bbc79d2da$export$a8b1916dba3ae88b).Left
];
const $34983f388f26cd06$export$a6f27ecf02eb3a67 = (event, { context: { active: active, droppableContainers: droppableContainers, collisionRect: collisionRect, scrollableAncestors: scrollableAncestors } })=>{
    if ($34983f388f26cd06$var$directions.includes(event.code)) {
        event.preventDefault();
        if (!active || !collisionRect) return;
        const filteredContainers = [];
        droppableContainers.getEnabled().forEach((entry)=>{
            if (!entry || (entry == null ? void 0 : entry.disabled)) return;
            const rect = entry == null ? void 0 : entry.rect.current;
            if (!rect) return;
            switch(event.code){
                case (0, $83696c5bbc79d2da$export$a8b1916dba3ae88b).Down:
                    if (collisionRect.top + collisionRect.height <= rect.top) filteredContainers.push(entry);
                    break;
                case (0, $83696c5bbc79d2da$export$a8b1916dba3ae88b).Up:
                    if (collisionRect.top >= rect.top + rect.height) filteredContainers.push(entry);
                    break;
                case (0, $83696c5bbc79d2da$export$a8b1916dba3ae88b).Left:
                    if (collisionRect.left >= rect.left + rect.width) filteredContainers.push(entry);
                    break;
                case (0, $83696c5bbc79d2da$export$a8b1916dba3ae88b).Right:
                    if (collisionRect.left + collisionRect.width <= rect.left) filteredContainers.push(entry);
                    break;
            }
        });
        const collisions = (0, $83696c5bbc79d2da$export$c3a6c1c7122b31c9)({
            active: active,
            collisionRect: collisionRect,
            droppableContainers: filteredContainers,
            pointerCoordinates: null
        });
        const closestId = (0, $83696c5bbc79d2da$export$ef1beab6d7287295)(collisions, 'id');
        if (closestId != null) {
            const newDroppable = droppableContainers.get(closestId);
            const newNode = newDroppable == null ? void 0 : newDroppable.node.current;
            const newRect = newDroppable == null ? void 0 : newDroppable.rect.current;
            if (newNode && newRect) {
                const newScrollAncestors = (0, $83696c5bbc79d2da$export$e4864aa91b5ed091)(newNode);
                const hasDifferentScrollAncestors = newScrollAncestors.some((element, index)=>scrollableAncestors[index] !== element);
                const offset = hasDifferentScrollAncestors ? {
                    x: 0,
                    y: 0
                } : {
                    x: collisionRect.width - newRect.width,
                    y: collisionRect.height - newRect.height
                };
                const newCoordinates = {
                    x: newRect.left - offset.x,
                    y: newRect.top - offset.y
                };
                return newCoordinates;
            }
        }
    }
    return undefined;
};




var $jIrNf = parcelRequire("jIrNf");

const $c15da4ea76286c97$var$SortableGridItem = ({ GridItemComponent: GridItemComponent, ...props })=>{
    const { isGalleryAdmin: isGalleryAdmin } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    const sortable = (0, $34983f388f26cd06$export$4ebcb6201122185a)({
        id: props.data.id,
        disabled: !isGalleryAdmin
    });
    const { attributes: attributes, listeners: listeners, setNodeRef: setNodeRef, transform: transform, transition: transition } = sortable;
    const style = {
        transform: (0, $638831efd3fb3cf7$export$c4ffa16951855e28).Transform.toString(transform),
        transition: transition
    };
    return /*#__PURE__*/ (0, $01ysi.jsx)(GridItemComponent, {
        ref: setNodeRef,
        style: style,
        ...props,
        ...attributes,
        ...listeners
    });
};
const $c15da4ea76286c97$export$e92d17a3b2a587bb = ({ GridItemComponent: GridItemComponent, reorderHook: reorderHook, reorderHookConfig: reorderHookConfig, reorderMutationVariables: reorderMutationVariables, initialItems: initialItems, gridColumns: gridColumns, onGridItemClick: onGridItemClick })=>{
    const { isGalleryAdmin: canEdit } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    const [items, setItems] = (0, $gRqVZ.useState)([]);
    const [activeId, setActiveId] = (0, $gRqVZ.useState)(null);
    const sensors = (0, $83696c5bbc79d2da$export$19012f58216d597f)((0, $83696c5bbc79d2da$export$cc72dd71f4ec69eb)((0, $83696c5bbc79d2da$export$b28554b50bf7f273), {
        activationConstraint: {
            distance: 10
        }
    }));
    const [reorderMutation] = reorderHook(reorderHookConfig);
    (0, $gRqVZ.useMemo)(()=>{
        if (!canEdit) return;
        if (!(initialItems?.length > 0) || !(items?.length > 0)) return;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).isEqual((0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).map(initialItems, 'id'), (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).map(items, 'id'))) reorderMutation({
            variables: {
                children: (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).map(items, 'id'),
                ...reorderMutationVariables
            }
        });
    }, [
        items
    ]);
    if (!initialItems) return null;
    if (initialItems?.length && !items.length || items.length > initialItems.length) {
        setItems(initialItems);
        return null;
    }
    if (!items.length) return null;
    function handleDragStart(event) {
        setActiveId(event.active.id);
    }
    function handleDragEnd(event) {
        const { active: active, over: over } = event;
        if (active.id !== over.id) setItems((items)=>{
            const itemIds = items.map((g)=>g.id);
            const oldIndex = itemIds.indexOf(active.id);
            const newIndex = itemIds.indexOf(over.id);
            return (0, $34983f388f26cd06$export$5d49d615ad5ea2b0)(items, oldIndex, newIndex);
        });
        setActiveId(null);
    }
    function handleDragCancel() {
        setActiveId(null);
    }
    let activeFullGalleryCard = null;
    if (activeId) {
        const activeIndex = items.findIndex((g)=>g.id == activeId);
        const activeItem = items[activeIndex];
        activeFullGalleryCard = /*#__PURE__*/ (0, $01ysi.jsx)(GridItemComponent, {
            data: activeItem
        });
    }
    return items.length > 0 && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $83696c5bbc79d2da$export$2d5c5ceac203fc1e), {
        sensors: sensors,
        collisionDetection: (0, $83696c5bbc79d2da$export$c8e785ae6b74bab8),
        onDragStart: handleDragStart,
        onDragEnd: handleDragEnd,
        onDragCancel: handleDragCancel,
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $34983f388f26cd06$export$86155fde54f06e6a), {
                items: items,
                strategy: (0, $34983f388f26cd06$export$9377a9486e3fbbe1),
                children: /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                    style: {
                        display: 'grid',
                        gridTemplateColumns: `repeat(${gridColumns}, 1fr)`,
                        gridGap: 10,
                        padding: 10
                    },
                    children: items.map((i, index)=>/*#__PURE__*/ (0, $01ysi.jsx)($c15da4ea76286c97$var$SortableGridItem, {
                            GridItemComponent: GridItemComponent,
                            data: i,
                            onClick: ()=>{
                                if (onGridItemClick) onGridItemClick(index);
                            }
                        }, i.id))
                })
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $83696c5bbc79d2da$export$aca73479aa40659d), {
                adjustScale: true,
                children: activeFullGalleryCard
            })
        ]
    });
};



var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");
const $499ce6b22b0e482d$var$VideoLightbox = ({ src: src, poster: poster, onClose: onClose, onPrev: onPrev, onNext: onNext, caption: caption })=>{
    (0, $gRqVZ.useEffect)(()=>{
        const handleKey = (e)=>{
            if (e.key === 'Escape') onClose();
            if (e.key === 'ArrowLeft' && onPrev) onPrev();
            if (e.key === 'ArrowRight' && onNext) onNext();
        };
        window.addEventListener('keydown', handleKey);
        return ()=>window.removeEventListener('keydown', handleKey);
    }, [
        onClose,
        onPrev,
        onNext
    ]);
    return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        onClick: onClose,
        style: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.85)',
            zIndex: 10000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
        },
        children: [
            /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                onClick: (e)=>e.stopPropagation(),
                style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '50px',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    justifyContent: 'space-between',
                    zIndex: 1
                },
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)("div", {}),
                    /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            paddingRight: '20px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)("a", {
                                href: src,
                                download: true,
                                onClick: (e)=>e.stopPropagation(),
                                style: {
                                    width: '40px',
                                    height: '35px',
                                    cursor: 'pointer',
                                    opacity: 0.7,
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PHBhdGggZD0iTTEwIDF2MTJtMCAwbC00LTRtNCA0bDQtNE0zIDE1djJoMTR2LTIiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=') no-repeat center"
                                },
                                onMouseEnter: (e)=>e.currentTarget.style.opacity = '1',
                                onMouseLeave: (e)=>e.currentTarget.style.opacity = '0.7'
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)("button", {
                                onClick: onClose,
                                style: {
                                    width: '40px',
                                    height: '35px',
                                    cursor: 'pointer',
                                    border: 'none',
                                    opacity: 0.7,
                                    backgroundColor: 'transparent',
                                    background: "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIj48cGF0aCBkPSJtIDEsMyAxLjI1LC0xLjI1IDcuNSw3LjUgNy41LC03LjUgMS4yNSwxLjI1IC03LjUsNy41IDcuNSw3LjUgLTEuMjUsMS4yNSAtNy41LC03LjUgLTcuNSw3LjUgLTEuMjUsLTEuMjUgNy41LC03LjUgLTcuNSwtNy41IHoiIGZpbGw9IiNGRkYiLz48L3N2Zz4=') no-repeat center"
                                },
                                onMouseEnter: (e)=>e.currentTarget.style.opacity = '1',
                                onMouseLeave: (e)=>e.currentTarget.style.opacity = '0.7'
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)("video", {
                onClick: (e)=>e.stopPropagation(),
                controls: true,
                autoPlay: true,
                playsInline: true,
                preload: "metadata",
                poster: poster,
                style: {
                    maxWidth: '90vw',
                    maxHeight: '80vh'
                },
                children: /*#__PURE__*/ (0, $01ysi.jsx)("source", {
                    src: src
                })
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                onClick: (e)=>e.stopPropagation(),
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    justifyContent: 'space-between'
                },
                children: /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                    style: {
                        padding: '10px 20px',
                        color: '#fff'
                    },
                    children: caption
                })
            }),
            onPrev && /*#__PURE__*/ (0, $01ysi.jsx)("button", {
                onClick: (e)=>{
                    e.stopPropagation();
                    onPrev();
                },
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: '20px',
                    padding: '40px 30px',
                    margin: 'auto',
                    height: '34px',
                    cursor: 'pointer',
                    border: 'none',
                    opacity: 0.7,
                    background: "rgba(0,0,0,0.2) url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjM0Ij48cGF0aCBkPSJtIDE5LDMgLTIsLTIgLTE2LDE2IDE2LDE2IDEsLTEgLTE1LC0xNSAxNSwtMTUgeiIgZmlsbD0iI0ZGRiIvPjwvc3ZnPg==') no-repeat center"
                },
                onMouseEnter: (e)=>e.currentTarget.style.opacity = '1',
                onMouseLeave: (e)=>e.currentTarget.style.opacity = '0.7'
            }),
            onNext && /*#__PURE__*/ (0, $01ysi.jsx)("button", {
                onClick: (e)=>{
                    e.stopPropagation();
                    onNext();
                },
                style: {
                    position: 'absolute',
                    right: 0,
                    top: 0,
                    bottom: 0,
                    width: '20px',
                    padding: '40px 30px',
                    margin: 'auto',
                    height: '34px',
                    cursor: 'pointer',
                    border: 'none',
                    opacity: 0.7,
                    background: "rgba(0,0,0,0.2) url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjM0Ij48cGF0aCBkPSJtIDEsMyAyLC0yIDE2LDE2IC0xNiwxNiAtMSwtMSAxNSwtMTUgLTE1LC0xNSB6IiBmaWxsPSIjRkZGIi8+PC9zdmc+') no-repeat center"
                },
                onMouseEnter: (e)=>e.currentTarget.style.opacity = '1',
                onMouseLeave: (e)=>e.currentTarget.style.opacity = '0.7'
            })
        ]
    });
};
var $499ce6b22b0e482d$export$2e2bcd8739ae039 = $499ce6b22b0e482d$var$VideoLightbox;


const $e74fd2833333a170$var$PhotoCard = /*#__PURE__*/ (0, $gRqVZ.forwardRef)(({ data: data, onClick: onClick, style: style, ...props }, ref)=>{
    const { isGalleryAdmin: canEdit } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    const [deletePhoto] = (0, $93486c083cb38a29$export$a0cb06c8b903595b)({
        refetchQueries: [
            'getGallery'
        ],
        awaitRefetchQueries: true
    });
    const inlineStyles = {
        height: 200,
        position: 'relative',
        ...style
    };
    const thumbnailUrl = data.image.publicUrl.replace('/original_', '/thumb_');
    return /*#__PURE__*/ (0, $01ysi.jsx)("div", {
        ref: ref,
        style: inlineStyles,
        ...props,
        children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4798097dcc8bac9b$export$7ad97355af757009), {
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $4798097dcc8bac9b$export$b4ca9e05809bd186), {
                    style: {
                        backgroundImage: `url(${thumbnailUrl})`
                    }
                }),
                canEdit && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4798097dcc8bac9b$export$245ec001d8ab6eb8), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $4798097dcc8bac9b$export$6ed0965c9443aaa6), {
                            onClick: ()=>console.log('edit')
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $4798097dcc8bac9b$export$bfadae053a633538), {
                            onClick: (ev)=>{
                                ev.stopPropagation();
                                if (confirm('Are you sure you want to delete this photo?')) deletePhoto({
                                    variables: {
                                        id: data.id
                                    }
                                });
                            }
                        })
                    ]
                })
            ]
        })
    });
});
function $e74fd2833333a170$var$GalleryView() {
    const { galleryId: galleryId } = (0, $372fcccf2bee01ac$export$99eaa27ddbbb95ef)();
    const { data: data, media: media } = (0, $8e914d5dfc637c4d$export$91a825dae171a9cd)(+galleryId);
    const [lightboxOpen, setLightboxOpen] = (0, $gRqVZ.useState)(false);
    const [mediaIndex, setMediaIndex] = (0, $gRqVZ.useState)(0);
    const openLightbox = (0, $gRqVZ.useCallback)((idx)=>{
        setMediaIndex(idx);
        setLightboxOpen(true);
    }, []);
    if (!data?.gallery?.title) return null;
    const pageTitle = `${data.gallery.title} (${(0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(data.gallery.date?.split('T')[0]).format('ll')})`;
    const hasVideo = media.length > 0 && media[0].type === 'video';
    // Photo-only offset: when video exists, photo grid click index maps to media index + 1
    const photoMediaOffset = hasVideo ? 1 : 0;
    const numMedia = media.length;
    const currentMedia = media[mediaIndex];
    const prevIndex = (mediaIndex + numMedia - 1) % numMedia;
    const nextIndex = (mediaIndex + 1) % numMedia;
    // Photo-only slide list for the image lightbox (videos are handled by VideoLightbox)
    const photoSlides = media.map((item, idx)=>({
            item: item,
            mediaIdx: idx
        })).filter(({ item: item })=>item.type === 'photo').map(({ item: item, mediaIdx: mediaIdx })=>({
            src: item.url,
            mediaIdx: mediaIdx
        }));
    const photoSlideIndex = photoSlides.findIndex((s)=>s.mediaIdx === mediaIndex);
    const numPhotos = photoSlides.length;
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $355796544c0c0b43$export$2e2bcd8739ae039), {
                parents: [
                    {
                        to: '/gallery',
                        title: 'All Albums'
                    }
                ],
                primaryColor: false,
                children: pageTitle
            }),
            hasVideo && media[0].type === 'video' && /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                style: {
                    marginBottom: '16px',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(5, 1fr)',
                    gridGap: 8,
                    padding: 8
                },
                children: /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                    onClick: ()=>openLightbox(0),
                    style: {
                        height: 200,
                        position: 'relative',
                        cursor: 'pointer',
                        overflow: 'hidden',
                        borderRadius: '4px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $4798097dcc8bac9b$export$b4ca9e05809bd186), {
                            style: {
                                backgroundImage: `url(${media[0].thumbnailUrl})`
                            }
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                            style: {
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'rgba(0,0,0,0.3)'
                            },
                            children: /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                                style: {
                                    width: 48,
                                    height: 48,
                                    borderRadius: '50%',
                                    backgroundColor: 'rgba(255,255,255,0.85)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                },
                                children: /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                                    style: {
                                        width: 0,
                                        height: 0,
                                        borderTop: '12px solid transparent',
                                        borderBottom: '12px solid transparent',
                                        borderLeft: '20px solid #333',
                                        marginLeft: '4px'
                                    }
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $c15da4ea76286c97$export$e92d17a3b2a587bb), {
                GridItemComponent: $e74fd2833333a170$var$PhotoCard,
                reorderHook: (0, $93486c083cb38a29$export$87a6aee51120b824),
                reorderHookConfig: {
                    refetchQueries: [
                        'getGallery'
                    ],
                    awaitRefetchQueries: true
                },
                reorderMutationVariables: {
                    id: +galleryId
                },
                initialItems: data?.gallery?.photos,
                gridColumns: 5,
                onGridItemClick: (index)=>{
                    openLightbox(index + photoMediaOffset);
                }
            }),
            lightboxOpen && currentMedia?.type === 'video' && /*#__PURE__*/ (0, $01ysi.jsx)((0, $499ce6b22b0e482d$export$2e2bcd8739ae039), {
                src: currentMedia.url,
                poster: currentMedia.thumbnailUrl,
                onClose: ()=>setLightboxOpen(false),
                onPrev: numMedia > 1 ? ()=>setMediaIndex(prevIndex) : undefined,
                onNext: numMedia > 1 ? ()=>setMediaIndex(nextIndex) : undefined,
                caption: `Video - 1 of ${numMedia}`
            }),
            lightboxOpen && currentMedia?.type === 'photo' && /*#__PURE__*/ (0, $01ysi.jsx)((0, $c552f4c6f5978452$export$7d2670a66155874b), {
                open: lightboxOpen,
                close: ()=>setLightboxOpen(false),
                index: photoSlideIndex,
                slides: photoSlides.map(({ src: src }, i)=>({
                        src: src,
                        description: `Image ${i + 1} of ${numPhotos}`
                    })),
                on: {
                    view: ({ index: index })=>{
                        const slide = photoSlides[index];
                        if (slide) setMediaIndex(slide.mediaIdx);
                    }
                }
            })
        ]
    });
}
var $e74fd2833333a170$export$2e2bcd8739ae039 = $e74fd2833333a170$var$GalleryView;



var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");

var $489wz = parcelRequire("489wz");






var $jIrNf = parcelRequire("jIrNf");






const $90146a108c487a8a$var$ToggleButton = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).button`
	flex: 1;
	border: none;
	border-radius: 3px;
	padding: 0.5rem 1rem;
	font-family: inherit;
	font-size: inherit;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	font-weight: 400;
	transition: all 0.2s ease;
	background: ${(props)=>props.$active ? props.theme.colors.primary : 'transparent'};
	color: ${(props)=>props.$active ? '#fff' : props.theme.colors.primaryTextColor};
	cursor: pointer;
	&:hover:not(:disabled) {
		background: ${(props)=>props.$active ? props.theme.colors.primaryDark : props.theme.colors.lightGray};
	}
	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;
const $90146a108c487a8a$var$processImageBase = location.host === 'localhost:1234' ? 'https://onenibbi-v2-backend.vercel.app/api/processImage?uploadId=' : 'https://onenibbi-v2-backend.vercel.app/api/processImage?uploadId=';
// Upload status types
const $90146a108c487a8a$var$UPLOAD_STATUS = {
    PENDING: 'pending',
    UPLOADING: 'uploading',
    PROCESSING: 'processing',
    SUCCESS: 'success',
    ERROR: 'error'
};
// Error component
const $90146a108c487a8a$var$ErrorMessage = ({ error: error, onRetry: onRetry, onDismiss: onDismiss })=>/*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        style: {
            padding: '8px 12px',
            backgroundColor: '#fee',
            border: '1px solid #fcc',
            borderRadius: '4px',
            marginBottom: '8px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                style: {
                    color: '#c00',
                    fontSize: '14px'
                },
                children: error
            }),
            /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                children: [
                    onRetry && /*#__PURE__*/ (0, $01ysi.jsx)("button", {
                        type: "button",
                        onClick: onRetry,
                        style: {
                            marginLeft: '8px',
                            padding: '4px 8px',
                            fontSize: '12px',
                            cursor: 'pointer'
                        },
                        children: "Retry"
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)("button", {
                        type: "button",
                        onClick: onDismiss,
                        style: {
                            marginLeft: '8px',
                            padding: '4px 8px',
                            fontSize: '12px',
                            cursor: 'pointer'
                        },
                        children: "Dismiss"
                    })
                ]
            })
        ]
    });
// Progress bar component
const $90146a108c487a8a$var$ProgressBar = ({ progress: progress, status: status })=>{
    const getStatusColor = ()=>{
        switch(status){
            case $90146a108c487a8a$var$UPLOAD_STATUS.ERROR:
                return '#dc3545';
            case $90146a108c487a8a$var$UPLOAD_STATUS.SUCCESS:
                return '#28a745';
            case $90146a108c487a8a$var$UPLOAD_STATUS.PROCESSING:
                return '#ffc107';
            default:
                return '#007bff';
        }
    };
    return /*#__PURE__*/ (0, $01ysi.jsx)("div", {
        style: {
            width: '100%',
            height: '4px',
            backgroundColor: '#e9ecef',
            borderRadius: '2px',
            overflow: 'hidden',
            marginTop: '4px'
        },
        children: /*#__PURE__*/ (0, $01ysi.jsx)("div", {
            style: {
                width: `${progress}%`,
                height: '100%',
                backgroundColor: getStatusColor(),
                transition: 'width 0.3s ease, background-color 0.3s ease'
            }
        })
    });
};
// Single file progress card
const $90146a108c487a8a$var$UploadProgressCard = ({ progress: progress })=>/*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        style: {
            padding: '8px',
            marginBottom: '8px',
            backgroundColor: '#f8f9fa',
            borderRadius: '4px',
            border: '1px solid #dee2e6'
        },
        children: [
            /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '4px'
                },
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                        style: {
                            fontSize: '14px',
                            fontWeight: '500'
                        },
                        children: progress.fileName
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                        style: {
                            fontSize: '12px',
                            color: progress.status === $90146a108c487a8a$var$UPLOAD_STATUS.ERROR ? '#dc3545' : '#6c757d'
                        },
                        children: progress.status === $90146a108c487a8a$var$UPLOAD_STATUS.ERROR ? 'Failed' : progress.status === $90146a108c487a8a$var$UPLOAD_STATUS.SUCCESS ? 'Complete' : progress.status === $90146a108c487a8a$var$UPLOAD_STATUS.PROCESSING ? 'Processing...' : progress.status === $90146a108c487a8a$var$UPLOAD_STATUS.UPLOADING ? 'Uploading...' : 'Pending'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)($90146a108c487a8a$var$ProgressBar, {
                progress: progress.progress,
                status: progress.status
            }),
            progress.error && /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                style: {
                    fontSize: '12px',
                    color: '#dc3545',
                    marginTop: '4px'
                },
                children: progress.error
            })
        ]
    });
// Upload status display component
const $90146a108c487a8a$var$UploadStatusDisplay = ({ uploads: uploads })=>{
    const totalFiles = Object.keys(uploads).length;
    const completedFiles = Object.values(uploads).filter((u)=>u.status === $90146a108c487a8a$var$UPLOAD_STATUS.SUCCESS).length;
    const errorFiles = Object.values(uploads).filter((u)=>u.status === $90146a108c487a8a$var$UPLOAD_STATUS.ERROR).length;
    const uploadingFiles = Object.values(uploads).filter((u)=>u.status === $90146a108c487a8a$var$UPLOAD_STATUS.UPLOADING || u.status === $90146a108c487a8a$var$UPLOAD_STATUS.PROCESSING).length;
    if (totalFiles === 0) return null;
    return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        style: {
            padding: '12px',
            backgroundColor: '#f8f9fa',
            borderRadius: '4px',
            marginBottom: '16px'
        },
        children: [
            /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                style: {
                    marginBottom: '8px',
                    fontWeight: 'bold'
                },
                children: [
                    "Upload Progress: ",
                    completedFiles,
                    "/",
                    totalFiles,
                    " files"
                ]
            }),
            uploadingFiles > 0 && /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                style: {
                    fontSize: '14px',
                    color: '#666'
                },
                children: [
                    "Uploading ",
                    uploadingFiles,
                    " file",
                    uploadingFiles > 1 ? 's' : '',
                    "..."
                ]
            }),
            errorFiles > 0 && /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                style: {
                    fontSize: '14px',
                    color: '#dc3545',
                    marginTop: '4px'
                },
                children: [
                    errorFiles,
                    " file",
                    errorFiles > 1 ? 's' : '',
                    " failed to upload"
                ]
            })
        ]
    });
};
function $90146a108c487a8a$var$GalleryForm() {
    const { galleryId: galleryId } = (0, $372fcccf2bee01ac$export$99eaa27ddbbb95ef)();
    const navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    const mutationConfig = {
        refetchQueries: [
            {
                query: (0, $93486c083cb38a29$export$bc912973c7913eac)
            },
            {
                query: (0, $93486c083cb38a29$export$232abb3e31c29db6),
                variables: {
                    id: +galleryId > 0 ? +galleryId : -1
                }
            }
        ],
        awaitRefetchQueries: true
    };
    const [updateGallery] = (0, $93486c083cb38a29$export$ff44cc8239f86a48)(mutationConfig);
    const [updateGalleryOrder] = (0, $93486c083cb38a29$export$87a6aee51120b824)(mutationConfig);
    const [createGallery] = (0, $93486c083cb38a29$export$8c35d5623b21c9f5)(mutationConfig);
    const [getGallery, { data: postUpdateGalleryData }] = (0, $93486c083cb38a29$export$4b2c274fad10cbb4)();
    const [uploading, setUploading] = (0, $gRqVZ.useState)(false);
    const [newPhotos, setNewPhotos] = (0, $gRqVZ.useState)({});
    const [uploadProgress, setUploadProgress] = (0, $gRqVZ.useState)({});
    const [uploadErrors, setUploadErrors] = (0, $gRqVZ.useState)([]);
    const { data: data, loading: loading } = (0, $8e914d5dfc637c4d$export$91a825dae171a9cd)(+galleryId, !galleryId);
    const [upload] = (0, $a2c6c12bc7500c5d$export$b20424b4610825c3)(true);
    const [addGalleryPhotos] = (0, $93486c083cb38a29$export$9e4a1835de3418b0)();
    const [removeGalleryPhoto] = (0, $93486c083cb38a29$export$a0cb06c8b903595b)(mutationConfig);
    // Media type selector (photos or video, mutually exclusive)
    const [mediaType, setMediaType] = (0, $gRqVZ.useState)('photos');
    // Video upload state
    const [videoUpload, setVideoUpload] = (0, $gRqVZ.useState)(null);
    const [videoThumbnailUpload, setVideoThumbnailUpload] = (0, $gRqVZ.useState)(null);
    const [videoUploading, setVideoUploading] = (0, $gRqVZ.useState)(false);
    const [thumbnailUploading, setThumbnailUploading] = (0, $gRqVZ.useState)(false);
    // Pre-fill video state from existing gallery data
    const galleryVideoUploadId = data?.gallery?.videoUpload?.id;
    const galleryVideoThumbnailId = data?.gallery?.videoThumbnail?.id;
    (0, $gRqVZ.useEffect)(()=>{
        if (data?.gallery) {
            const gallery = data.gallery;
            if (gallery.videoUpload && !videoUpload) {
                setVideoUpload({
                    uploadId: gallery.videoUpload.id,
                    publicUrl: gallery.videoUpload.publicUrl
                });
                setMediaType('video');
            }
            if (gallery.videoThumbnail && !videoThumbnailUpload) setVideoThumbnailUpload({
                uploadId: gallery.videoThumbnail.id,
                publicUrl: gallery.videoThumbnail.publicUrl
            });
        }
    }, [
        galleryVideoUploadId,
        galleryVideoThumbnailId
    ]);
    const { isGalleryAdmin: isGalleryAdmin } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    (0, $gRqVZ.useEffect)(()=>{
        if (!isGalleryAdmin) navigate('/gallery');
    }, [
        isGalleryAdmin
    ]);
    (0, $gRqVZ.useEffect)(()=>{
        const check = async ()=>{
            if (postUpdateGalleryData) {
                if (postUpdateGalleryData.gallery.children.length != postUpdateGalleryData.gallery.photos.length) await updateGalleryOrder({
                    variables: {
                        id: postUpdateGalleryData.gallery.id,
                        children: postUpdateGalleryData.gallery.photos.map((p)=>p.id)
                    }
                });
                navigate('/gallery');
            }
        };
        check();
    }, [
        postUpdateGalleryData
    ]);
    if (loading) return null;
    const prefillFormData = {
        title: data?.gallery?.title || '',
        date: data?.gallery?.date?.split('T')[0] || '',
        photos: data?.gallery?.photos || []
    };
    // Helper function to update upload progress
    const updateUploadProgress = (fileKey, updates)=>{
        setUploadProgress((prev)=>({
                ...prev,
                [fileKey]: {
                    ...prev[fileKey],
                    ...updates
                }
            }));
    };
    // Helper function to handle single file upload with retry capability
    const uploadSingleFile = async (file, fileKey, retryCount = 0)=>{
        const MAX_RETRIES = 1;
        try {
            // Update status to uploading
            updateUploadProgress(fileKey, {
                status: $90146a108c487a8a$var$UPLOAD_STATUS.UPLOADING,
                progress: 0,
                fileName: file.name,
                fileSize: file.size,
                error: null
            });
            // Simulate progress updates (you might need to modify the upload hook to support progress)
            const progressInterval = setInterval(()=>{
                setUploadProgress((prev)=>{
                    const current = prev[fileKey];
                    if (current && current.progress < 90 && current.status === $90146a108c487a8a$var$UPLOAD_STATUS.UPLOADING) return {
                        ...prev,
                        [fileKey]: {
                            ...current,
                            progress: current.progress + 10
                        }
                    };
                    return prev;
                });
            }, 200);
            // Upload file
            const uploadResult = await upload(file);
            clearInterval(progressInterval);
            // Update status to processing
            updateUploadProgress(fileKey, {
                status: $90146a108c487a8a$var$UPLOAD_STATUS.PROCESSING,
                progress: 95
            });
            // Process image
            // const processImageRequest = await fetch(processImageBase + uploadResult.uploadId)
            // if (!processImageRequest.ok) {
            // 	throw new Error(`Image processing failed: ${processImageRequest.statusText}`)
            // }
            // const processImageResult = await processImageRequest.json()
            // Update status to success
            updateUploadProgress(fileKey, {
                status: $90146a108c487a8a$var$UPLOAD_STATUS.SUCCESS,
                progress: 100
            });
            return {
                uploadId: uploadResult.uploadId,
                publicUrl: uploadResult.publicUrl
            };
        } catch (error) {
            console.error(`Upload failed for ${file.name}:`, error);
            if (retryCount < MAX_RETRIES) {
                // Retry upload
                updateUploadProgress(fileKey, {
                    status: $90146a108c487a8a$var$UPLOAD_STATUS.UPLOADING,
                    progress: 0,
                    error: `Retrying... (${retryCount + 1}/${MAX_RETRIES})`
                });
                // Wait before retry
                await new Promise((resolve)=>setTimeout(resolve, 1000 * (retryCount + 1)));
                return uploadSingleFile(file, fileKey, retryCount + 1);
            }
            // Update status to error
            updateUploadProgress(fileKey, {
                status: $90146a108c487a8a$var$UPLOAD_STATUS.ERROR,
                progress: 0,
                error: error.message || 'Upload failed'
            });
            throw error;
        }
    };
    // Handle file selection and upload
    const handleFileUpload = async (ev)=>{
        ev.persist();
        setUploading(true);
        setUploadErrors([]);
        const files = Array.from(ev.target.files);
        const newUploads = files.map((file)=>({
                file: file,
                key: `${file.name}:${file.size}`
            })).filter((fileEntry)=>!newPhotos[fileEntry.key]);
        // Initialize upload progress for all files
        const initialProgress = {};
        newUploads.forEach(({ key: key, file: file })=>{
            initialProgress[key] = {
                status: $90146a108c487a8a$var$UPLOAD_STATUS.PENDING,
                progress: 0,
                fileName: file.name,
                fileSize: file.size,
                error: null
            };
        });
        setUploadProgress((prev)=>({
                ...prev,
                ...initialProgress
            }));
        // Upload files concurrently with a limit
        const CONCURRENT_LIMIT = 3;
        const uploadResults = {};
        const errors = [];
        for(let i = 0; i < newUploads.length; i += CONCURRENT_LIMIT){
            const batch = newUploads.slice(i, i + CONCURRENT_LIMIT);
            const batchPromises = batch.map(async ({ file: file, key: key })=>{
                try {
                    const result = await uploadSingleFile(file, key);
                    uploadResults[key] = result;
                } catch (error) {
                    errors.push({
                        fileName: file.name,
                        error: error.message || 'Upload failed',
                        key: key
                    });
                }
            });
            await Promise.all(batchPromises);
        }
        // Update state with successful uploads
        if (Object.keys(uploadResults).length > 0) setNewPhotos((prev)=>({
                ...prev,
                ...uploadResults
            }));
        // Set errors if any
        if (errors.length > 0) setUploadErrors(errors);
        setUploading(false);
        ev.target.value = '';
    };
    // Retry failed upload
    const retryFailedUpload = async (fileKey)=>{
        const progressInfo = uploadProgress[fileKey];
        if (!progressInfo) return;
        // Create a file object from the stored info (you might need to store the actual file)
        // For now, this is a placeholder - you'd need to modify the initial upload to store files
        console.log('Retry functionality needs file reference implementation');
    };
    const handleVideoUpload = async (ev)=>{
        const file = ev.target.files?.[0];
        if (!file) return;
        const allowedVideoTypes = [
            'video/mp4',
            'video/quicktime'
        ];
        if (!allowedVideoTypes.includes(file.type)) {
            setUploadErrors((prev)=>[
                    ...prev,
                    {
                        error: 'Only MP4 and MOV videos are supported',
                        key: 'video-type'
                    }
                ]);
            ev.target.value = '';
            return;
        }
        if (file.size > 524288000) {
            setUploadErrors((prev)=>[
                    ...prev,
                    {
                        error: 'Video must be under 500MB',
                        key: 'video-size'
                    }
                ]);
            ev.target.value = '';
            return;
        }
        const fileKey = `video:${file.name}:${file.size}`;
        setVideoUploading(true);
        try {
            const result = await uploadSingleFile(file, fileKey);
            setVideoUpload({
                uploadId: result.uploadId,
                publicUrl: result.publicUrl
            });
        } catch (error) {
            setUploadErrors((prev)=>[
                    ...prev,
                    {
                        error: `Video upload failed: ${error.message}`,
                        key: 'video-upload'
                    }
                ]);
        }
        setVideoUploading(false);
        ev.target.value = '';
    };
    const handleThumbnailUpload = async (ev)=>{
        const file = ev.target.files?.[0];
        if (!file) return;
        const fileKey = `thumbnail:${file.name}:${file.size}`;
        setThumbnailUploading(true);
        try {
            const result = await uploadSingleFile(file, fileKey);
            setVideoThumbnailUpload({
                uploadId: result.uploadId,
                publicUrl: result.publicUrl
            });
        } catch (error) {
            setUploadErrors((prev)=>[
                    ...prev,
                    {
                        error: `Thumbnail upload failed: ${error.message}`,
                        key: 'thumb-upload'
                    }
                ]);
        }
        setThumbnailUploading(false);
        ev.target.value = '';
    };
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Formik), {
        initialValues: prefillFormData,
        onSubmit: async (values)=>{
            console.log('[VideoUpload] Form submit - videoUpload:', videoUpload, 'videoThumbnailUpload:', videoThumbnailUpload);
            const getDate = ()=>{
                if (values.date?.length === 0) return new Date().toISOString().substring(0, 10);
                else return values.date;
            };
            let newGalleryId = +galleryId;
            try {
                const submitVideoId = mediaType === 'video' ? videoUpload?.uploadId || null : null;
                const submitThumbnailId = mediaType === 'video' ? videoThumbnailUpload?.uploadId || null : null;
                const submitPhotos = mediaType === 'photos' ? Object.values(newPhotos) : [];
                if (galleryId) {
                    if (submitPhotos.length > 0) await addGalleryPhotos({
                        variables: {
                            objects: submitPhotos.map((newPhoto)=>({
                                    caption: '',
                                    galleryId: galleryId,
                                    imageUploadId: newPhoto.uploadId
                                }))
                        }
                    });
                    await updateGallery({
                        variables: {
                            id: +galleryId,
                            title: values.title,
                            date: getDate(),
                            videoUploadId: submitVideoId,
                            videoThumbnailUploadId: submitThumbnailId
                        }
                    });
                } else {
                    const result = await createGallery({
                        variables: {
                            title: values.title,
                            date: getDate(),
                            photos: {
                                data: submitPhotos.map((newPhoto)=>({
                                        caption: '',
                                        galleryId: galleryId,
                                        imageUploadId: newPhoto.uploadId
                                    }))
                            },
                            videoUploadId: submitVideoId,
                            videoThumbnailUploadId: submitThumbnailId
                        }
                    });
                    newGalleryId = result.data.insertGallery.id;
                }
                await getGallery({
                    variables: {
                        id: newGalleryId
                    }
                });
            } catch (error) {
                console.error('Failed to save gallery:', error);
                setUploadErrors([
                    {
                        error: 'Failed to save gallery. Please try again.',
                        key: 'gallery-save'
                    }
                ]);
            }
        },
        children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $489wz.Form), {
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                    name: "title",
                    type: "text",
                    label: "Title",
                    placeholder: "Gallery Title"
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                    name: "date",
                    type: "date",
                    label: "Date"
                }),
                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $2519c42fed6cedee$export$a4654c742baf9825), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $837a9440f933970f$export$2e2bcd8739ae039), {
                            children: "Media type"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                            style: {
                                display: 'flex',
                                borderRadius: '3px',
                                border: '1px solid #DEDEDE',
                                padding: '4px',
                                gap: '4px',
                                background: '#fff'
                            },
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsxs)($90146a108c487a8a$var$ToggleButton, {
                                    type: "button",
                                    $active: mediaType === 'photos',
                                    onClick: ()=>setMediaType('photos'),
                                    disabled: uploading || videoUploading || thumbnailUploading,
                                    children: [
                                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $6a14c6a918655516$export$3e431a229df88919), {
                                            style: {
                                                width: 16,
                                                height: 16
                                            }
                                        }),
                                        "Photos"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsxs)($90146a108c487a8a$var$ToggleButton, {
                                    type: "button",
                                    $active: mediaType === 'video',
                                    onClick: ()=>setMediaType('video'),
                                    disabled: uploading || videoUploading || thumbnailUploading,
                                    children: [
                                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $3da7744c6e165eb5$export$287f8fcc69caf433), {
                                            style: {
                                                width: 16,
                                                height: 16
                                            }
                                        }),
                                        "Video"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                uploadErrors.map((error, index)=>/*#__PURE__*/ (0, $01ysi.jsx)($90146a108c487a8a$var$ErrorMessage, {
                        error: `${error.fileName ? `${error.fileName}: ` : ''}${error.error}`,
                        onRetry: error.key && error.key !== 'gallery-save' ? ()=>retryFailedUpload(error.key) : null,
                        onDismiss: ()=>setUploadErrors((prev)=>prev.filter((_, i)=>i !== index))
                    }, error.key || index)),
                mediaType === 'video' && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                            name: "video",
                            type: "file",
                            label: "Video (MP4/MOV, max 500MB)",
                            buttonLabel: videoUpload ? 'Replace Video' : 'Upload Video',
                            disabled: videoUploading,
                            onChange: handleVideoUpload
                        }),
                        Object.entries(uploadProgress).filter(([key])=>key.startsWith('video:') || key.startsWith('thumbnail:')).map(([key, progress])=>/*#__PURE__*/ (0, $01ysi.jsx)($90146a108c487a8a$var$UploadProgressCard, {
                                progress: progress
                            }, key)),
                        videoUpload && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $837a9440f933970f$export$2e2bcd8739ae039), {
                                    children: "Video"
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                                    style: {
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(5, 1fr)',
                                        gridGap: 8,
                                        padding: 8,
                                        marginBottom: '16px'
                                    },
                                    children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4798097dcc8bac9b$export$7ad97355af757009), {
                                        style: {
                                            position: 'relative'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $4798097dcc8bac9b$export$b4ca9e05809bd186), {
                                                style: {
                                                    backgroundImage: videoThumbnailUpload ? `url(${videoThumbnailUpload.publicUrl})` : undefined,
                                                    backgroundColor: !videoThumbnailUpload ? '#e9ecef' : undefined,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                },
                                                children: !videoThumbnailUpload && /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                                                    style: {
                                                        color: '#6c757d',
                                                        fontSize: '12px',
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: '50%',
                                                        transform: 'translate(-50%, -50%)'
                                                    },
                                                    children: "No thumbnail"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                                                style: {
                                                    position: 'absolute',
                                                    top: '4px',
                                                    right: '4px',
                                                    backgroundColor: '#28a745',
                                                    color: 'white',
                                                    borderRadius: '50%',
                                                    width: '20px',
                                                    height: '20px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '12px',
                                                    zIndex: 3
                                                },
                                                children: "\u2713"
                                            }),
                                            /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                                                style: {
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    right: 0,
                                                    bottom: 0,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    pointerEvents: 'none'
                                                },
                                                children: /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                                                    style: {
                                                        width: 36,
                                                        height: 36,
                                                        borderRadius: '50%',
                                                        backgroundColor: 'rgba(0,0,0,0.5)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    },
                                                    children: /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                                                        style: {
                                                            width: 0,
                                                            height: 0,
                                                            borderTop: '8px solid transparent',
                                                            borderBottom: '8px solid transparent',
                                                            borderLeft: '14px solid #fff',
                                                            marginLeft: '3px'
                                                        }
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $4798097dcc8bac9b$export$245ec001d8ab6eb8), {
                                                children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $4798097dcc8bac9b$export$bfadae053a633538), {
                                                    onClick: ()=>{
                                                        if (confirm('Remove video from this gallery?')) {
                                                            setVideoUpload(null);
                                                            setVideoThumbnailUpload(null);
                                                        }
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                            name: "videoThumbnail",
                            type: "file",
                            label: videoThumbnailUpload ? 'Replace video thumbnail' : 'Video thumbnail (required)',
                            buttonLabel: videoThumbnailUpload ? 'Replace Thumbnail' : 'Upload Thumbnail',
                            disabled: thumbnailUploading,
                            onChange: handleThumbnailUpload
                        }),
                        videoThumbnailUpload && /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                            style: {
                                marginTop: '8px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $837a9440f933970f$export$2e2bcd8739ae039), {
                                    children: "Current thumbnail"
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)("img", {
                                    src: videoThumbnailUpload.publicUrl,
                                    alt: "Video thumbnail",
                                    style: {
                                        maxWidth: '200px',
                                        borderRadius: '3px',
                                        border: '1px solid #DEDEDE'
                                    }
                                })
                            ]
                        })
                    ]
                }),
                mediaType === 'photos' && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)($90146a108c487a8a$var$UploadStatusDisplay, {
                            uploads: Object.fromEntries(Object.entries(uploadProgress).filter(([key])=>!key.startsWith('video:') && !key.startsWith('thumbnail:')))
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                            name: "photo",
                            type: "file",
                            label: "Upload photo(s)",
                            multiple: true,
                            disabled: uploading,
                            onChange: handleFileUpload
                        }),
                        Object.entries(uploadProgress).filter(([key])=>!key.startsWith('video:') && !key.startsWith('thumbnail:')).length > 0 && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $837a9440f933970f$export$2e2bcd8739ae039), {
                                    children: "Upload Progress"
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                                    style: {
                                        marginBottom: '16px'
                                    },
                                    children: Object.entries(uploadProgress).filter(([key])=>!key.startsWith('video:') && !key.startsWith('thumbnail:')).map(([key, progress])=>/*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                                            style: {
                                                padding: '8px',
                                                marginBottom: '8px',
                                                backgroundColor: '#f8f9fa',
                                                borderRadius: '4px',
                                                border: '1px solid #dee2e6'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                                                    style: {
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        marginBottom: '4px'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                                                            style: {
                                                                fontSize: '14px',
                                                                fontWeight: '500'
                                                            },
                                                            children: progress.fileName
                                                        }),
                                                        /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                                                            style: {
                                                                fontSize: '12px',
                                                                color: progress.status === $90146a108c487a8a$var$UPLOAD_STATUS.ERROR ? '#dc3545' : '#6c757d'
                                                            },
                                                            children: progress.status === $90146a108c487a8a$var$UPLOAD_STATUS.ERROR ? 'Failed' : progress.status === $90146a108c487a8a$var$UPLOAD_STATUS.SUCCESS ? 'Complete' : progress.status === $90146a108c487a8a$var$UPLOAD_STATUS.PROCESSING ? 'Processing...' : progress.status === $90146a108c487a8a$var$UPLOAD_STATUS.UPLOADING ? 'Uploading...' : 'Pending'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $01ysi.jsx)($90146a108c487a8a$var$ProgressBar, {
                                                    progress: progress.progress,
                                                    status: progress.status
                                                }),
                                                progress.error && /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                                                    style: {
                                                        fontSize: '12px',
                                                        color: '#dc3545',
                                                        marginTop: '4px'
                                                    },
                                                    children: progress.error
                                                })
                                            ]
                                        }, key))
                                })
                            ]
                        }),
                        data?.gallery?.photos?.length > 0 && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $837a9440f933970f$export$2e2bcd8739ae039), {
                                    children: "Existing photo(s)"
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                                    style: {
                                        display: 'grid',
                                        gridTemplateColumns: `repeat(5, 1fr)`,
                                        gridGap: 8,
                                        padding: 8
                                    },
                                    children: data.gallery.photos.map((photo)=>/*#__PURE__*/ (0, $01ysi.jsxs)((0, $4798097dcc8bac9b$export$7ad97355af757009), {
                                            style: {
                                                position: 'relative'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $4798097dcc8bac9b$export$b4ca9e05809bd186), {
                                                    style: {
                                                        backgroundImage: `url(${photo.image?.publicUrl})`
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $4798097dcc8bac9b$export$245ec001d8ab6eb8), {
                                                    children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $4798097dcc8bac9b$export$bfadae053a633538), {
                                                        onClick: async ()=>{
                                                            if (confirm('Are you sure you want to delete this photo?')) await removeGalleryPhoto({
                                                                variables: {
                                                                    id: photo.id
                                                                }
                                                            });
                                                        }
                                                    })
                                                })
                                            ]
                                        }, photo.id))
                                })
                            ]
                        }),
                        Object.keys(newPhotos).length > 0 && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $837a9440f933970f$export$2e2bcd8739ae039), {
                                    children: "New photo(s)"
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                                    style: {
                                        display: 'grid',
                                        gridTemplateColumns: `repeat(5, 1fr)`,
                                        gridGap: 8,
                                        padding: 8
                                    },
                                    children: Object.entries(newPhotos).map(([pKey, p])=>{
                                        const progress = uploadProgress[pKey];
                                        return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4798097dcc8bac9b$export$7ad97355af757009), {
                                            style: {
                                                position: 'relative',
                                                opacity: progress?.status === $90146a108c487a8a$var$UPLOAD_STATUS.SUCCESS ? 1 : 0.8
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $4798097dcc8bac9b$export$b4ca9e05809bd186), {
                                                    style: {
                                                        backgroundImage: `url(${p.publicUrl})`
                                                    }
                                                }),
                                                progress?.status === $90146a108c487a8a$var$UPLOAD_STATUS.SUCCESS && /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                                                    style: {
                                                        position: 'absolute',
                                                        top: '4px',
                                                        right: '4px',
                                                        backgroundColor: '#28a745',
                                                        color: 'white',
                                                        borderRadius: '50%',
                                                        width: '20px',
                                                        height: '20px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontSize: '12px'
                                                    },
                                                    children: "\u2713"
                                                }),
                                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $4798097dcc8bac9b$export$245ec001d8ab6eb8), {
                                                    children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $4798097dcc8bac9b$export$bfadae053a633538), {
                                                        onClick: ()=>{
                                                            if (confirm('Are you sure you want to delete this photo?')) {
                                                                setNewPhotos((0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).omit(newPhotos, pKey));
                                                                setUploadProgress((0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).omit(uploadProgress, pKey));
                                                            }
                                                        }
                                                    })
                                                })
                                            ]
                                        }, p.uploadId);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                    type: "formButtons",
                    isLoading: uploading || videoUploading || thumbnailUploading,
                    onCancel: galleryId ? '../..' : '..'
                })
            ]
        })
    });
}
var $90146a108c487a8a$export$2e2bcd8739ae039 = $90146a108c487a8a$var$GalleryForm;







const $5f3c2bf5d3453f85$var$mutationConfig = {
    refetchQueries: [
        'galleriesGetAll'
    ],
    awaitRefetchQueries: true
};
const $5f3c2bf5d3453f85$var$FullGalleryCard = /*#__PURE__*/ (0, $gRqVZ.forwardRef)(({ style: style, ...props }, ref)=>{
    const inlineStyles = {
        height: 200,
        position: 'relative',
        ...style
    };
    const [disableGallery] = (0, $93486c083cb38a29$export$b89ea64d2a13b36d)($5f3c2bf5d3453f85$var$mutationConfig);
    const g = props.data;
    const { isGalleryAdmin: canEdit } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    const [showVideo, setShowVideo] = (0, $gRqVZ.useState)(false);
    const isVideo = !!g.videoUpload;
    const cardContent = /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $4798097dcc8bac9b$export$6e0f22ba93f02904), {
                style: {
                    backgroundImage: `url(${g.thumbUrl || g.videoThumbnail?.publicUrl || ''})`
                }
            }),
            isVideo && /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                style: {
                    position: 'absolute',
                    top: '8px',
                    left: '8px',
                    zIndex: 2,
                    backgroundColor: 'rgba(0,0,0,0.7)',
                    color: '#fff',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    fontSize: '11px',
                    fontWeight: 'bold',
                    letterSpacing: '0.5px'
                },
                children: "VIDEO"
            }),
            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4798097dcc8bac9b$export$266d69320a343fc1), {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $4798097dcc8bac9b$export$61287401a9b6135), {
                        children: g.title
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4798097dcc8bac9b$export$c6756bfc15908808), {
                        children: [
                            isVideo ? 'Video' : `${g.children.length} photos`,
                            g.date && ' on ' + (0, (/*@__PURE__*/$parcel$interopDefault($7de12bd144294bc3$exports)))(g.date.split('T')[0]).format('LL')
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        ref: ref,
        style: inlineStyles,
        ...props,
        children: [
            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4798097dcc8bac9b$export$395ce40f751434ec), {
                children: [
                    isVideo ? /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                        onClick: ()=>setShowVideo(true),
                        style: {
                            cursor: 'pointer',
                            height: '100%'
                        },
                        children: cardContent
                    }) : /*#__PURE__*/ (0, $01ysi.jsx)((0, $e3f57e4b1ea630bd$export$a6c7ac8248d6e38a), {
                        to: '/gallery/' + g.id,
                        children: cardContent
                    }, g.id),
                    canEdit && /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4798097dcc8bac9b$export$245ec001d8ab6eb8), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $e3f57e4b1ea630bd$export$a6c7ac8248d6e38a), {
                                to: `${g.id}/publish`,
                                children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $4798097dcc8bac9b$export$6ed0965c9443aaa6), {})
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)((0, $4798097dcc8bac9b$export$bfadae053a633538), {
                                onClick: ()=>{
                                    if (confirm('Are you sure you want to delete this album?')) disableGallery({
                                        variables: {
                                            id: g.id
                                        }
                                    });
                                }
                            })
                        ]
                    })
                ]
            }, g.id),
            showVideo && g.videoUpload && /*#__PURE__*/ (0, $01ysi.jsx)((0, $499ce6b22b0e482d$export$2e2bcd8739ae039), {
                src: g.videoUpload.publicUrl,
                poster: g.videoThumbnail?.publicUrl || '',
                onClose: ()=>setShowVideo(false),
                caption: g.title
            })
        ]
    });
});
function $5f3c2bf5d3453f85$var$GalleryList() {
    const { data: data } = (0, $8e914d5dfc637c4d$export$2729cbcf847987e9)();
    const { isGalleryAdmin: canEdit } = (0, $6e3a19da527b7fab$export$ff989fa3ff87b5af)();
    return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $01ysi.Fragment), {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4798097dcc8bac9b$export$34b846af2dd63598), {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $355796544c0c0b43$export$2e2bcd8739ae039), {
                        primaryColor: false,
                        children: "Albums"
                    }),
                    canEdit && /*#__PURE__*/ (0, $01ysi.jsx)((0, $e3f57e4b1ea630bd$export$a6c7ac8248d6e38a), {
                        to: "/gallery/publish",
                        children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $32c3454e141c39d9$export$2e2bcd8739ae039), {
                            $autoWidth: true,
                            mode: "secondary",
                            children: "Create New Gallery"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $c15da4ea76286c97$export$e92d17a3b2a587bb), {
                gridColumns: 3,
                GridItemComponent: $5f3c2bf5d3453f85$var$FullGalleryCard,
                reorderHook: (0, $93486c083cb38a29$export$b75fe83a2756d1c7),
                reorderHookConfig: $5f3c2bf5d3453f85$var$mutationConfig,
                initialItems: data?.galleries
            })
        ]
    });
}
function $5f3c2bf5d3453f85$var$GalleryRoute() {
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $372fcccf2bee01ac$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                    path: "/",
                    element: /*#__PURE__*/ (0, $01ysi.jsx)($5f3c2bf5d3453f85$var$GalleryList, {})
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                    path: "/publish",
                    element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $90146a108c487a8a$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                    path: "/:galleryId",
                    element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $e74fd2833333a170$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                    path: "/:galleryId/publish",
                    element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $90146a108c487a8a$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
}
var $5f3c2bf5d3453f85$export$2e2bcd8739ae039 = $5f3c2bf5d3453f85$var$GalleryRoute;



var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");




const $cf0dd335a9133e17$var$REFRESH_INTERVAL_MS = 30000;
const $cf0dd335a9133e17$var$JobSiteFrame = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	position: relative;
	width: 100%;
	aspect-ratio: 4 / 3;
	overflow: hidden;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}
`;
const $cf0dd335a9133e17$var$Caption = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	padding: 10px 20px;
	background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), transparent);
	color: #fff;
	font-weight: bold;
	font-size: 18px;
`;
function $cf0dd335a9133e17$var$JobSiteGallery() {
    const [ts, setTs] = (0, $gRqVZ.useState)(()=>Date.now());
    const { data: data } = (0, $93486c083cb38a29$export$3923358757a3967b)();
    (0, $gRqVZ.useEffect)(()=>{
        const id = setInterval(()=>setTs(Date.now()), $cf0dd335a9133e17$var$REFRESH_INTERVAL_MS);
        return ()=>clearInterval(id);
    }, []);
    const camera = data?.cameraEmbeds[0];
    if (!camera) return null;
    return /*#__PURE__*/ (0, $01ysi.jsxs)($cf0dd335a9133e17$var$JobSiteFrame, {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)("img", {
                src: `${camera.stillUrl}?ts=${ts}`,
                alt: camera.title
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)($cf0dd335a9133e17$var$Caption, {
                children: camera.title
            })
        ]
    });
}
function $cf0dd335a9133e17$var$JobsiteVideosRoute() {
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$3565eb3d00ca5a74), {
            children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                path: "/",
                element: /*#__PURE__*/ (0, $01ysi.jsx)($cf0dd335a9133e17$var$JobSiteGallery, {})
            })
        })
    });
}
var $cf0dd335a9133e17$export$2e2bcd8739ae039 = $cf0dd335a9133e17$var$JobsiteVideosRoute;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");












const $78bd24ed2ae981f2$export$e9d03fcc84d41d58 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	border: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	padding: 20px;
	margin-top: 20px;
	width: 260px;
	h3 {
		margin-bottom: 15px;
		font-weight: normal;
		font-size: 16px;
	}
`;
const $78bd24ed2ae981f2$export$754f42ddee2c4511 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $e3f57e4b1ea630bd$export$b0d92dbee9b5b60d))`
	display: block;
	border-bottom: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	color: ${({ theme: theme })=>theme.colors.primary};
	padding: 15px 0px;
	text-decoration: none;
	font-size: 14px;
	&:last-child {
		border-bottom: none;
	}
`;



const $49da022061afbf32$var$sidebarLinks = [
    {
        title: 'Create New Post',
        to: '/news/publish',
        adminOnly: true
    }
];
function $49da022061afbf32$var$NewsListRoute(props) {
    return /*#__PURE__*/ (0, $01ysi.jsx)("div", {
        children: props?.bulletins?.map((b)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $2ba354589c9f4590$export$2e2bcd8739ae039), {
                data: b
            }, b.id))
    });
}
function $49da022061afbf32$var$NewsDetailRoute(props) {
    const { bulletinId: bulletinId } = (0, $372fcccf2bee01ac$export$99eaa27ddbbb95ef)();
    const fromProps = props.bulletins?.find((b)=>b.id === +bulletinId);
    const { data: lookupData } = (0, $93486c083cb38a29$export$cd249570f68f791d)({
        variables: {
            id: +bulletinId
        },
        skip: !props.bulletins || !!fromProps
    });
    const bulletin = fromProps || (lookupData?.bulletins ?? []).find((b)=>b.id === +bulletinId);
    if (!bulletin) return null;
    return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $355796544c0c0b43$export$2e2bcd8739ae039), {
                parents: [
                    {
                        to: '/news',
                        title: 'News & Resources'
                    }
                ],
                primaryColor: false,
                children: bulletin.title
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)((0, $ae37069f12c6c62d$export$2e2bcd8739ae039), {
                bulletin: bulletin,
                commentsRefetch: "bulletins"
            })
        ]
    });
}
function $49da022061afbf32$var$NewsAndAnnouncements() {
    const { siteMeta: siteMeta } = (0, $6f7f49c0f054a62d$export$55c0e3cb4fbc46cf)();
    const departments = siteMeta.departments;
    const { data: data, loading: loading } = (0, $93486c083cb38a29$export$4d4ddd807f84394d)();
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $38e8ff2ff45ad7fb$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $f17ceecf287e1f86$export$2e2bcd8739ae039), {
                    links: $49da022061afbf32$var$sidebarLinks,
                    children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $78bd24ed2ae981f2$export$e9d03fcc84d41d58), {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)("h3", {
                                children: "Jump to Department Board"
                            }),
                            departments.map((d)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $78bd24ed2ae981f2$export$754f42ddee2c4511), {
                                    to: `/departments/${d.id}/news`,
                                    children: d.title
                                }, d.id))
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $372fcccf2bee01ac$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                            path: "/",
                            element: loading ? /*#__PURE__*/ (0, $01ysi.jsx)((0, $a5fc2fd641867f25$export$91fa629114bce97f), {}) : /*#__PURE__*/ (0, $01ysi.jsx)($49da022061afbf32$var$NewsListRoute, {
                                bulletins: data?.bulletins
                            })
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                            path: "/publish",
                            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $35b01a16b505efb7$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                            path: "/:bulletinId/*",
                            element: /*#__PURE__*/ (0, $01ysi.jsx)($49da022061afbf32$var$NewsDetailRoute, {
                                bulletins: data?.bulletins
                            })
                        })
                    ]
                })
            ]
        })
    });
}
var $49da022061afbf32$export$2e2bcd8739ae039 = $49da022061afbf32$var$NewsAndAnnouncements;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");




function $1d358cdcdd7e6197$var$ResourcesRoute() {
    const { data: data, loading: loading } = (0, $93486c083cb38a29$export$de72a3e3ea83f132)();
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
        children: loading ? /*#__PURE__*/ (0, $01ysi.jsx)((0, $a5fc2fd641867f25$export$91fa629114bce97f), {}) : /*#__PURE__*/ (0, $01ysi.jsx)((0, $1c3b3c5e1c4e70d7$export$2e2bcd8739ae039), {
            data: data?.resources ?? []
        })
    });
}
var $1d358cdcdd7e6197$export$2e2bcd8739ae039 = $1d358cdcdd7e6197$var$ResourcesRoute;



var $01ysi = parcelRequire("01ysi");


var $gRqVZ = parcelRequire("gRqVZ");

const $fcf5b0132d6341e1$var$theme = {
    space: [
        0,
        4,
        8,
        16,
        32,
        64,
        128,
        256,
        512
    ],
    colors: {
        primary: '#bd5f28',
        primaryDark: '#e4996e',
        primaryTextColor: '#222',
        lightestGray: '#868686',
        darkGray: '#EBEBEB',
        lightGray: '#F3F3F3',
        borderGray: '#DEDEDE',
        neonGreen: '#409F11',
        red: '#F62E2D',
        white: '#fff',
        royalBlue: '#1925B7',
        teal: '#069D88',
        mediumGray: '#ACACAC',
        lightestBackground: '#F6F6F6',
        mutedText: '#7F7F7F'
    },
    linkCardSize: {
        iconSize: {
            med: '20px',
            lg: '40px'
        }
    }
};
var $fcf5b0132d6341e1$export$2e2bcd8739ae039 = $fcf5b0132d6341e1$var$theme;





var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");


var $01ysi = parcelRequire("01ysi");




// Bolder/tighter than UserModal's CloseIcon (which is small and light-gray,
// reading as disconnected from the card here) — matches the mockup's clearly
// visible close button.
const $a39114e070a0a8df$var$CloseIcon = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $f0e7a4a36037df80$export$78acf4525d8a74c4))`
	width: 22px;
	height: 22px;
	color: ${(props)=>props.theme.colors.lightestGray};
	top: 22px;
	right: 22px;
	position: absolute;
	z-index: 1;
	&:hover {
		cursor: pointer;
		color: ${(props)=>props.theme.colors.primaryTextColor};
	}
`;
// Modal's own DialogContainer fills the viewport (position:fixed, 100%/100%);
// centering the card here with flex instead of magic top/left percentages
// keeps it centered and on-screen at any viewport size.
const $a39114e070a0a8df$var$CenteringLayer = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 100%;
	padding: 24px;
`;
// Same visual treatment as UserModal's PersonCardContainer, but sized with
// clamped relative units instead of a bare 450px (which overflowed narrow
// viewports) and height:auto instead of a fixed 250px (which cut off longer
// org-chart titles/contact rows).
const $a39114e070a0a8df$var$PersonCardContainer = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	position: relative;
	background-color: ${({ theme: theme })=>theme.colors.white};
	width: min(450px, 100%);
	box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
	border-radius: 3px;
	border: 1px solid ${({ theme: theme })=>theme.colors.borderGray};
	padding: 12px;
	color: ${({ theme: theme })=>theme.colors.primaryTextColor};

	/* PersonCard's own card is the visible keyline — full width so it sits an even
	   12px inside the modal edge, instead of its default 90% (off-centre here). */
	> div {
		box-sizing: border-box;
		width: 100%;
		margin-bottom: 0;
	}

	/* Larger photo than the shared 64px, per the design. */
	img {
		width: 120px;
		height: 120px;
	}

	/* Align the name's visible glyph top with the top of the photo. Flush boxes
	   leave the text low (half-leading plus the font's ascent), so it needs a
	   negative offset — measured by pixel-scanning the rendered text, since
	   font metrics measure to the ascender and overshoot by ~2px. */
	h1 {
		margin-top: -3px;
		text-align: left;
		line-height: 1.1;
	}
`;
const $a39114e070a0a8df$var$PersonDetailModal = ({ person: person, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $63e9a7af5676c306$export$2e2bcd8739ae039), {
        backgroundColor: "dark",
        children: /*#__PURE__*/ (0, $01ysi.jsx)($a39114e070a0a8df$var$CenteringLayer, {
            children: /*#__PURE__*/ (0, $01ysi.jsxs)($a39114e070a0a8df$var$PersonCardContainer, {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)($a39114e070a0a8df$var$CloseIcon, {
                        onClick: onClose
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $b7cf2e00be4cfa04$export$2e2bcd8739ae039), {
                        person: {
                            profilePhotoUrl: person.profilePhotoUrl,
                            firstName: person.firstName,
                            lastName: person.lastName,
                            jobTitle: person.jobTitle,
                            department: person.department,
                            jobsite: person.jobsite,
                            phoneExt: person.phoneExt,
                            phoneCell: person.phoneCell,
                            phoneDirect: person.phoneDirect,
                            email: person.email
                        },
                        fullWidth: true
                    })
                ]
            })
        })
    });
};
var $a39114e070a0a8df$export$2e2bcd8739ae039 = $a39114e070a0a8df$var$PersonDetailModal;


// ─── CONSTANTS ─────────────────────────────────────────────────────────────────
const $2b15f70c0ff60fbf$var$AVATAR_COLORS = [
    [
        '#2D3A4A',
        '#7EC8C8'
    ],
    [
        '#3B2D4A',
        '#C87EC8'
    ],
    [
        '#2D4A35',
        '#7EC88A'
    ],
    [
        '#4A3B2D',
        '#C8A87E'
    ],
    [
        '#2D3F4A',
        '#7EAAC8'
    ],
    [
        '#4A2D2D',
        '#C87E7E'
    ]
];
// ─── THEME ─────────────────────────────────────────────────────────────────────
function $2b15f70c0ff60fbf$var$getT(theme, accentColor) {
    const d = theme === 'dark';
    return {
        bg: d ? '#0B1220' : '#FFFFFF',
        header: d ? '#0D1526' : '#FFFFFF',
        headerBorder: d ? '#1A2435' : '#E8E8E8',
        cardBg: d ? '#16202E' : '#FFFFFF',
        cardBgAlt: d ? '#1E2634' : '#F8F8F8',
        cardBorder: d ? '#2A3548' : '#DEDEDE',
        text: d ? '#E8EAF0' : '#1A1A1A',
        textMuted: d ? '#5A7090' : '#888888',
        accent: accentColor,
        accentBg: d ? `${accentColor}15` : `${accentColor}10`,
        sectionMgr: d ? 'rgba(60,100,200,0.18)' : '#FFFFFF',
        sectionPeers: d ? 'rgba(40,180,100,0.14)' : '#FFFFFF',
        sectionReports: d ? 'rgba(160,80,220,0.14)' : '#F8F8F8',
        sectionBg: d ? (depth)=>depth % 2 === 0 ? '#121C2C' : '#0E1726' : // the deepest bands stay readable behind the black card text.
        (depth)=>{
            const v = Math.round(255 * (1 - 0.05 * Math.min(depth, 8))) // 255→…→153 (#999999)
            ;
            const h = v.toString(16).padStart(2, '0');
            return `#${h}${h}${h}`;
        },
        connMgr: d ? '#3A4560' : '#CCCCCC',
        connRpt: d ? '#2A4A3A' : '#CCCCCC',
        searchBg: d ? '#0F1A2A' : '#FFFFFF',
        sectionBorder: d ? 'none' : `1px solid #E8E8E8`
    };
}
// ─── DATA HELPERS ──────────────────────────────────────────────────────────────
function $2b15f70c0ff60fbf$var$buildIndex(nodes) {
    const idx = {};
    nodes.forEach((n)=>{
        idx[n.id] = n;
    });
    return idx;
}
function $2b15f70c0ff60fbf$var$getChildren(idx, pid) {
    return Object.values(idx).filter((n)=>n.managerId === pid);
}
function $2b15f70c0ff60fbf$var$getSiblings(idx, node) {
    if (!node) return [];
    return node.managerId == null ? Object.values(idx).filter((n)=>n.managerId == null && n.id !== node.id) : Object.values(idx).filter((n)=>n.managerId === node.managerId && n.id !== node.id);
}
// Chain of ancestors from the root (CEO) down to — but not including — nodeId.
function $2b15f70c0ff60fbf$var$getChainToRoot(idx, nodeId) {
    const chain = [];
    let cur = idx[nodeId];
    while(cur && cur.managerId != null){
        const parent = idx[cur.managerId];
        if (!parent) break;
        chain.unshift(parent);
        cur = parent;
    }
    return chain // [root, ..., directManager]
    ;
}
// ─── HOOKS ─────────────────────────────────────────────────────────────────────
function $2b15f70c0ff60fbf$var$useContainerWidth(ref) {
    const [w, setW] = (0, $gRqVZ.useState)(400);
    (0, $gRqVZ.useEffect)(()=>{
        if (!ref.current) return;
        const ro = new ResizeObserver((es)=>setW(es[0].contentRect.width));
        ro.observe(ref.current);
        setW(ref.current.getBoundingClientRect().width);
        return ()=>ro.disconnect();
    }, []);
    return w;
}
function $2b15f70c0ff60fbf$export$10d0c9e6fd61288b({ person: person, isMe: isMe, size: size, accentColor: accentColor }) {
    const [bg, fg] = $2b15f70c0ff60fbf$var$AVATAR_COLORS[person.id % $2b15f70c0ff60fbf$var$AVATAR_COLORS.length];
    return /*#__PURE__*/ (0, $01ysi.jsx)("div", {
        style: {
            width: size,
            height: size,
            borderRadius: 0,
            flexShrink: 0,
            background: isMe ? `linear-gradient(135deg, ${accentColor}, #F5813D)` : bg,
            color: isMe ? '#111' : fg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: Math.round(size * 0.28),
            fontFamily: "'Helvetica Neue',Helvetica,Arial,sans-serif",
            fontWeight: 600,
            boxShadow: isMe ? `0 0 0 2px ${accentColor},0 0 12px ${accentColor}55` : 'none',
            transition: 'all 0.2s'
        },
        children: person.avatar || person.name.slice(0, 2).toUpperCase()
    });
}
function $2b15f70c0ff60fbf$var$Card({ person: person, isMe: isMe, hasReports: hasReports, open: open, onToggle: onToggle, onSelectPerson: onSelectPerson, renderAvatar: renderAvatar, accentColor: accentColor, t: t, idx: idx }) {
    const subordinateCount = idx ? Object.values(idx).filter((n)=>n.managerId === person.id).length : 0;
    const bg = isMe ? t.accentBg : t.cardBg;
    const border = isMe ? t.accent : t.cardBorder;
    return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        "data-testid": "org-card",
        "data-node-id": person.id,
        "data-expanded": open,
        "data-is-me": isMe,
        "data-has-reports": hasReports,
        onClick: ()=>onSelectPerson(person),
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            // Fixed card height (independent of photo size and title line count) so
            // every card in a row is uniformly sized — previously the card's height
            // was implicit (derived from its content), which let 1-line-title cards
            // render shorter than 2-line-title cards. 88px comfortably fits the 56px
            // photo plus the horizontal padding below.
            height: 88,
            padding: '0 10px',
            borderRadius: 4,
            border: `1px solid ${border}`,
            background: bg,
            cursor: 'pointer',
            WebkitTapHighlightColor: 'transparent',
            userSelect: 'none',
            minWidth: 0,
            width: '100%',
            overflow: 'visible',
            position: 'relative'
        },
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                style: {
                    width: 56,
                    height: 56,
                    flexShrink: 0
                },
                children: renderAvatar ? renderAvatar({
                    person: person,
                    isMe: isMe,
                    size: 56
                }) : /*#__PURE__*/ (0, $01ysi.jsx)($2b15f70c0ff60fbf$export$10d0c9e6fd61288b, {
                    person: person,
                    isMe: isMe,
                    size: 56,
                    accentColor: accentColor
                })
            }),
            /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                style: {
                    minWidth: 0,
                    flex: 1
                },
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                        style: {
                            fontFamily: "'Helvetica Neue',Helvetica,Arial,sans-serif",
                            fontWeight: person.isYou ? 700 : 600,
                            fontSize: 13,
                            color: isMe ? t.accent : t.text,
                            overflow: 'hidden',
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 2,
                            overflowWrap: 'anywhere'
                        },
                        children: [
                            person.name,
                            person.isYou && /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                                style: {
                                    fontSize: 9,
                                    opacity: 0.5,
                                    fontWeight: 400,
                                    marginLeft: 4
                                },
                                children: "you"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                        style: {
                            fontFamily: "'Helvetica Neue',Helvetica,Arial,sans-serif",
                            fontSize: 11,
                            lineHeight: 1.3,
                            marginTop: 2,
                            color: t.textMuted,
                            // Reserve exactly two lines on every card so cards in a group are
                            // uniform height: short titles get a blank second line, long ones
                            // clamp to two lines with an ellipsis instead of growing the card.
                            height: '2.6em',
                            overflow: 'hidden',
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 2,
                            overflowWrap: 'anywhere'
                        },
                        children: person.title
                    })
                ]
            }),
            hasReports && /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                "data-testid": "expand-toggle",
                "data-node-id": person.id,
                "data-open": open,
                onClick: (e)=>{
                    e.stopPropagation();
                    onToggle?.();
                },
                style: {
                    position: 'absolute',
                    right: 12,
                    bottom: 0,
                    transform: 'translateY(50%)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 5,
                    background: isMe ? t.accent : t.cardBgAlt,
                    border: `1px solid ${isMe ? t.accent : t.cardBorder}`,
                    color: isMe ? '#FFFFFF' : t.text,
                    borderRadius: 99,
                    padding: '4px 12px',
                    fontFamily: "'Helvetica Neue',Helvetica,Arial,sans-serif",
                    fontSize: 12,
                    fontWeight: 600,
                    lineHeight: 1,
                    whiteSpace: 'nowrap',
                    cursor: 'pointer',
                    zIndex: 1,
                    boxShadow: '0 1px 3px rgba(0,0,0,0.18)',
                    transition: 'transform 0.12s, box-shadow 0.12s'
                },
                onMouseEnter: (e)=>{
                    e.currentTarget.style.transform = 'translateY(50%) scale(1.08)';
                    e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.25)';
                },
                onMouseLeave: (e)=>{
                    e.currentTarget.style.transform = 'translateY(50%)';
                    e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.18)';
                },
                children: [
                    subordinateCount,
                    ' ',
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $a84fe49467631aef$export$cb86d8fdcb9f94b5), {
                        size: 16,
                        style: {
                            display: 'block',
                            transform: open ? 'rotate(180deg)' : 'none'
                        }
                    })
                ]
            })
        ]
    });
}
function $2b15f70c0ff60fbf$var$Grid({ items: items, renderItem: renderItem }) {
    return /*#__PURE__*/ (0, $01ysi.jsx)("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
            columnGap: 8,
            rowGap: 18,
            minWidth: 0,
            alignItems: 'start'
        },
        children: items.map((item, i)=>/*#__PURE__*/ (0, $01ysi.jsx)("div", {
                style: {
                    minWidth: 0
                },
                children: renderItem(item, i)
            }, item.id ?? i))
    });
}
function $2b15f70c0ff60fbf$var$Section({ bg: bg, border: border, t: t, action: action, children: children }) {
    const showHeader = !!action;
    return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        style: {
            background: bg,
            borderRadius: 6,
            padding: '12px 10px',
            border: border || 'none',
            marginBottom: 8
        },
        children: [
            showHeader && /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    paddingBottom: 4,
                    marginTop: -9,
                    fontFamily: "'Helvetica Neue',Helvetica,Arial,sans-serif",
                    fontSize: 10,
                    color: t.textMuted,
                    letterSpacing: '0.06em',
                    textTransform: 'uppercase',
                    fontWeight: 600,
                    userSelect: 'none'
                },
                children: action && /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                    style: {
                        marginLeft: 'auto'
                    },
                    children: action
                })
            }),
            children
        ]
    });
}
// Small inline toggle for revealing a chain manager's peer group.
function $2b15f70c0ff60fbf$var$PeerToggle({ open: open, count: count, onClick: onClick, t: t, nodeId: nodeId }) {
    return /*#__PURE__*/ (0, $01ysi.jsxs)("button", {
        "data-testid": "peer-toggle",
        "data-node-id": nodeId,
        "data-open": open,
        "data-count": count,
        onClick: onClick,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            background: 'none',
            border: 'none',
            padding: 0,
            margin: 0,
            cursor: 'pointer',
            color: t.textMuted
        },
        children: [
            open ? /*#__PURE__*/ (0, $01ysi.jsx)((0, $780cee0797cae5da$export$c42ab4f9cd72fed3), {
                size: 20
            }) : /*#__PURE__*/ (0, $01ysi.jsx)((0, $36fb27ce642053a4$export$540b644af6247088), {
                size: 20
            }),
            count > 0 && /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                style: {
                    color: t.textMuted,
                    fontWeight: 700,
                    fontSize: 11
                },
                children: count
            })
        ]
    });
}
function $2b15f70c0ff60fbf$export$8929951f37b9096e({ nodes: nodes, rootId: rootId, columns: columns = 2, accentColor: accentColor = '#D4521A', theme: theme = 'light', renderCard: renderCard = null, renderAvatar: renderAvatar = null }) {
    const t = (0, $gRqVZ.useMemo)(()=>$2b15f70c0ff60fbf$var$getT(theme, accentColor), [
        theme,
        accentColor
    ]);
    const idx = (0, $gRqVZ.useMemo)(()=>$2b15f70c0ff60fbf$var$buildIndex(nodes), [
        nodes
    ]);
    // Root of the tree (CEO / managerId === null), unless a rootId is supplied.
    const treeRootId = (0, $gRqVZ.useMemo)(()=>{
        if (rootId != null && idx[rootId]) return rootId;
        const top = nodes.find((n)=>n.managerId == null);
        return top ? top.id : nodes[0]?.id;
    }, [
        rootId,
        idx,
        nodes
    ]);
    // "You" — the logged-in user, only when actually present in the data. Drives
    // the accent. Undefined when the current user isn't in the chart's dataset.
    const youId = (0, $gRqVZ.useMemo)(()=>nodes.find((n)=>n.isYou)?.id, [
        nodes
    ]);
    // "Me" — anchors the default open state. The logged-in user if they're in the
    // data, otherwise the tree root (CEO) so the view starts at the top rather
    // than centering on an arbitrary person.
    const meId = youId ?? treeRootId;
    // The upward chain: [root ... directManager] of me.
    const chain = (0, $gRqVZ.useMemo)(()=>$2b15f70c0ff60fbf$var$getChainToRoot(idx, meId), [
        idx,
        meId
    ]);
    // expanded: set of node ids whose DOWNWARD subtree is open.
    // Default: my direct reports are shown (I am expanded), and the whole upward
    // chain (my manager, their manager, ... CEO) is expanded so it flows down to me.
    const [expanded, setExpanded] = (0, $gRqVZ.useState)(()=>new Set([
            meId,
            ...chain.map((c)=>c.id)
        ]));
    // peerOpen: set of chain-member ids whose PEER GROUP is revealed. Default: none.
    const [peerOpen, setPeerOpen] = (0, $gRqVZ.useState)(()=>new Set());
    // Person shown in the detail modal on card click; null when no modal is open.
    const [selectedPerson, setSelectedPerson] = (0, $gRqVZ.useState)(null);
    const containerRef = (0, $gRqVZ.useRef)(null);
    const contentRef = (0, $gRqVZ.useRef)(null);
    const cw = $2b15f70c0ff60fbf$var$useContainerWidth(containerRef);
    const cols = cw >= 900 ? Math.max(columns, 4) : cw >= 600 ? Math.max(columns, 3) : columns;
    const toggleExpand = (0, $gRqVZ.useCallback)((id)=>{
        const me = idx[id];
        if (expanded.has(id)) {
            // Collapsing: clear this node AND its entire subtree from expanded/peerOpen,
            // so reopening later starts fresh — one layer, nothing pre-drilled below.
            const subtree = new Set();
            const gather = (pid)=>{
                subtree.add(pid);
                $2b15f70c0ff60fbf$var$getChildren(idx, pid).forEach((c)=>gather(c.id));
            };
            gather(id);
            setExpanded((prev)=>{
                const next = new Set(prev);
                subtree.forEach((s)=>next.delete(s));
                return next;
            });
            setPeerOpen((prev)=>{
                const next = new Set(prev);
                subtree.forEach((s)=>next.delete(s));
                return next;
            });
            return;
        }
        // Expanding: collapse any already-expanded sibling (same manager), so only
        // one member of a peer group is expanded at a time.
        setExpanded((prev)=>{
            const next = new Set(prev);
            if (me) Object.values(idx).forEach((n)=>{
                if (n.id !== id && n.managerId === me.managerId && next.has(n.id)) next.delete(n.id);
            });
            next.add(id);
            return next;
        });
    }, [
        idx,
        expanded
    ]);
    // Order a peer group so the expanded member (if any) sits last — its caret
    // then points down into the report group rendered directly below it.
    const expandedLast = (0, $gRqVZ.useCallback)((arr)=>{
        const open = arr.filter((p)=>expanded.has(p.id));
        const closed = arr.filter((p)=>!expanded.has(p.id));
        return [
            ...closed,
            ...open
        ];
    }, [
        expanded
    ]);
    const togglePeers = (0, $gRqVZ.useCallback)((id)=>{
        setPeerOpen((prev)=>{
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    }, []);
    function mkCard(person, opts = {}) {
        const { variant: variant = 'report', onToggle: onToggle } = opts;
        const hasReports = $2b15f70c0ff60fbf$var$getChildren(idx, person.id).length > 0;
        const open = expanded.has(person.id);
        // Accent only the real logged-in user; never the fallback anchor.
        const isMe = youId != null && person.id === youId;
        if (renderCard) return renderCard({
            person: person,
            isMe: isMe,
            variant: variant,
            hasReports: hasReports,
            open: open,
            onToggle: onToggle,
            t: t
        });
        return /*#__PURE__*/ (0, $01ysi.jsx)($2b15f70c0ff60fbf$var$Card, {
            person: person,
            isMe: isMe,
            variant: variant,
            hasReports: hasReports,
            open: open,
            onToggle: onToggle,
            onSelectPerson: setSelectedPerson,
            renderAvatar: renderAvatar,
            accentColor: accentColor,
            t: t,
            idx: idx
        });
    }
    // Render a row of report cards, expanded member last.
    function renderReportGrid(kids) {
        return /*#__PURE__*/ (0, $01ysi.jsx)($2b15f70c0ff60fbf$var$Grid, {
            items: expandedLast(kids),
            cols: cols,
            renderItem: (p)=>{
                const kidHasReports = $2b15f70c0ff60fbf$var$getChildren(idx, p.id).length > 0;
                return mkCard(p, {
                    variant: 'report',
                    onToggle: kidHasReports ? ()=>toggleExpand(p.id) : undefined
                });
            }
        });
    }
    const meNode = idx[meId];
    // Build the followed path of node ids from the root down to the deepest
    // expanded node. At each layer only one node is expanded (enforced by
    // toggleExpand), so the path is unambiguous. Default path = my chain to me,
    // then whatever I've expanded below. Expanding a peer of any node switches
    // the path to follow that peer instead.
    function buildFollowedPath() {
        // Find the topmost ancestor (root of the whole tree the focus belongs to).
        let top = meNode;
        while(top && top.managerId != null && idx[top.managerId])top = idx[top.managerId];
        const path = [];
        let cur = top ?? null;
        while(cur){
            path.push(cur.id);
            // descend to the expanded child of cur, if any
            const kids = $2b15f70c0ff60fbf$var$getChildren(idx, cur.id);
            const nextOpen = kids.find((k)=>expanded.has(k.id));
            cur = nextOpen || null;
        }
        return path // [rootId, ..., deepestExpandedId]
        ;
    }
    // Render one layer: the node (with its peer group if peers are toggled on for
    // it) as a Section, expanded member last. variant kept for renderCard context.
    function renderLayer(nodeId, pos) {
        const node = idx[nodeId];
        if (!node) return null;
        const peers = $2b15f70c0ff60fbf$var$getSiblings(idx, node);
        const peersShown = peerOpen.has(nodeId);
        const groupMembers = peersShown ? [
            node,
            ...peers
        ] : [
            node
        ];
        return /*#__PURE__*/ (0, $01ysi.jsx)("div", {
            children: /*#__PURE__*/ (0, $01ysi.jsx)($2b15f70c0ff60fbf$var$Section, {
                bg: t.sectionBg(pos),
                border: t.sectionBorder,
                t: t,
                action: peers.length > 0 ? /*#__PURE__*/ (0, $01ysi.jsx)($2b15f70c0ff60fbf$var$PeerToggle, {
                    open: peersShown,
                    count: peers.length,
                    label: "peers",
                    onClick: ()=>togglePeers(nodeId),
                    t: t,
                    nodeId: nodeId
                }) : undefined,
                children: /*#__PURE__*/ (0, $01ysi.jsx)($2b15f70c0ff60fbf$var$Grid, {
                    items: expandedLast(groupMembers),
                    cols: cols,
                    renderItem: (p)=>mkCard(p, {
                            variant: p.id === meId ? 'peer' : 'manager',
                            onToggle: $2b15f70c0ff60fbf$var$getChildren(idx, p.id).length > 0 ? ()=>toggleExpand(p.id) : undefined
                        })
                })
            })
        }, `layer-${nodeId}`);
    }
    // Render the report group directly below a node that has its subs expanded.
    function renderReportLayerFor(nodeId, pos) {
        const kids = $2b15f70c0ff60fbf$var$getChildren(idx, nodeId);
        if (kids.length === 0) return null;
        // The child (if any) that continues the followed path.
        const onPath = kids.filter((k)=>$2b15f70c0ff60fbf$var$getChildren(idx, k.id).length > 0 && expanded.has(k.id));
        const following = onPath.length > 0 // we've drilled through one child
        ;
        const peersShown = peerOpen.has(nodeId) // user asked to reveal siblings here
        ;
        // Default: if following a child, show only that child (single-line chain);
        // otherwise (leaf — no child expanded) show all reports. Revealing peers
        // shows every sibling regardless.
        const shownKids = following && !peersShown ? onPath : kids;
        // Offer the peers toggle only when there are hidden siblings to reveal.
        const canToggle = following && kids.length > onPath.length;
        return /*#__PURE__*/ (0, $01ysi.jsx)($2b15f70c0ff60fbf$var$Section, {
            bg: t.sectionBg(pos),
            border: t.sectionBorder,
            t: t,
            action: canToggle ? /*#__PURE__*/ (0, $01ysi.jsx)($2b15f70c0ff60fbf$var$PeerToggle, {
                open: peersShown,
                count: kids.length - onPath.length,
                label: "peers",
                onClick: ()=>togglePeers(nodeId),
                t: t,
                nodeId: nodeId
            }) : undefined,
            children: renderReportGrid(shownKids)
        }, `rpt-${nodeId}`);
    }
    // The full followed path, rendered top→down: the root's own group, then each
    // expanded node's reports group (which contains the next followed node).
    function renderFollowedPath() {
        const path = buildFollowedPath();
        const out = [];
        let pos = 0;
        // Root layer (the top node + its peers, though the true root rarely has any).
        out.push(renderLayer(path[0], pos++));
        // Walk down the path. A node's reports group renders only while every node
        // above it (and itself) is expanded. The moment we hit a collapsed node we
        // stop — everything "below" a collapsed node is, by definition, hidden.
        for (const nodeId of path){
            if (!expanded.has(nodeId)) break;
            if ($2b15f70c0ff60fbf$var$getChildren(idx, nodeId).length > 0) out.push(renderReportLayerFor(nodeId, pos++));
        }
        return out;
    }
    if (!meNode) return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        "data-testid": "org-chart-error",
        style: {
            color: 'red',
            padding: 20
        },
        children: [
            "Node not found: ",
            meId
        ]
    });
    return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
        ref: containerRef,
        style: {
            background: t.bg,
            fontFamily: "'Helvetica Neue',Helvetica,Arial,sans-serif",
            overflowX: 'hidden',
            position: 'relative'
        },
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)("style", {
                children: `
        .org-chart-content, .org-chart-content *, .org-chart-content *::before, .org-chart-content *::after { box-sizing: border-box; }
      `
            }),
            /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                ref: contentRef,
                className: "org-chart-content",
                style: {
                    overflowX: 'hidden',
                    padding: '12px 0'
                },
                children: [
                    renderFollowedPath(),
                    /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                        style: {
                            height: 32
                        }
                    })
                ]
            }),
            selectedPerson && /*#__PURE__*/ (0, $01ysi.jsx)((0, $a39114e070a0a8df$export$2e2bcd8739ae039), {
                person: selectedPerson,
                onClose: ()=>setSelectedPerson(null)
            })
        ]
    });
}
var $2b15f70c0ff60fbf$export$2e2bcd8739ae039 = $2b15f70c0ff60fbf$export$8929951f37b9096e;



var $01ysi = parcelRequire("01ysi");





const $b76b8f5033f3049e$export$df6a541d7dc3c0a3 = ()=>{
    const { loading: loading, data: data } = (0, $93486c083cb38a29$export$404deecb7906e6a8)();
    let resource;
    if (!loading && data?.resources?.length) resource = data.resources[0];
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $32c3454e141c39d9$export$2e2bcd8739ae039), {
        loading: loading,
        disabled: loading,
        mode: "outline",
        onClick: ()=>{
            // this should be an anchor tag, not a button
            // but i don't think we built that
            // ghetto yolo
            if (resource) window.open(resource.file.url, '_blank');
        },
        children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $5ce7c99cb8ebffb6$export$2e2bcd8739ae039), {
            direction: "row",
            alignItems: "center",
            spacing: 1,
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $f56fb9e0fe685cc1$export$1e9bbbacaf20997a), {
                    height: 24,
                    color: (0, $fcf5b0132d6341e1$export$2e2bcd8739ae039).colors.primary
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $3e4306c97c8d2a8d$export$2e2bcd8739ae039), {
                    children: "View as PDF"
                })
            ]
        })
    });
};


// Show the person's real photo, falling back to the chart's initials circle when
// they have none or the image fails to load. UserProfilePhoto isn't reused here
// because it falls back to a default silhouette rather than initials.
function $a5a28410614d0a31$var$OrgChartAvatar({ person: person, isMe: isMe, size: size }) {
    const [failed, setFailed] = (0, $gRqVZ.useState)(false);
    const src = person.photoUrl;
    if (!src || failed) return /*#__PURE__*/ (0, $01ysi.jsx)((0, $2b15f70c0ff60fbf$export$10d0c9e6fd61288b), {
        person: person,
        isMe: isMe,
        size: size,
        accentColor: (0, $fcf5b0132d6341e1$export$2e2bcd8739ae039).colors.primary
    });
    return /*#__PURE__*/ (0, $01ysi.jsx)("img", {
        src: src,
        width: size,
        height: size,
        onError: ()=>setFailed(true),
        style: {
            borderRadius: 0,
            objectFit: 'cover',
            flexShrink: 0,
            // Matches the accent ring Av draws for the signed-in user.
            boxShadow: isMe ? `0 0 0 2px ${(0, $fcf5b0132d6341e1$export$2e2bcd8739ae039).colors.primary},0 0 12px ${(0, $fcf5b0132d6341e1$export$2e2bcd8739ae039).colors.primary}55` : 'none'
        }
    });
}
function $a5a28410614d0a31$var$OrgChartRoute() {
    const { data: data, loading: loading, error: error } = (0, $93486c083cb38a29$export$2bd5ffe7a75ae513)();
    const { user: user } = (0, $f8298f6bd5fca48e$export$a609e16b0cfae3f1)();
    if (loading) return /*#__PURE__*/ (0, $01ysi.jsx)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
        children: "Loading..."
    });
    if (error) return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
        children: [
            "Error loading org chart: ",
            error.message
        ]
    });
    if (data?.users) {
        const ids = new Set(data.users.map((u)=>u.id));
        const nodes = data.users.map((u)=>({
                id: u.id,
                name: `${u.firstName} ${u.lastName}`,
                title: u.jobTitle,
                // Normalize supervisors that aren't in the fetched set to a root (null).
                managerId: u.supervisorId && ids.has(u.supervisorId) ? u.supervisorId : null,
                photoUrl: u.profilePhotoUrl || undefined,
                isYou: u.id === user?.id,
                // Carried through for PersonDetailModal (opened on card click).
                firstName: u.firstName,
                lastName: u.lastName,
                jobTitle: u.jobTitle,
                profilePhotoUrl: u.profilePhotoUrl,
                department: u.department,
                jobsite: u.jobsite,
                email: u.email,
                phoneCell: u.phoneCell,
                phoneDirect: u.phoneDirect,
                phoneExt: u.phoneExt
            }));
        // Drop root-level people who have no reports (board members, broken data) so
        // the chart anchors on the real operational top of org — matches the prior
        // route's `filteredOrgChartData` behavior.
        const hasReports = new Set(nodes.map((n)=>n.managerId));
        const chartNodes = nodes.filter((n)=>n.managerId != null || hasReports.has(n.id));
        // Anyone whose supervisor isn't in the fetched set becomes a root, so the data
        // is a forest, not a tree. OrgChartFollow renders a single lineage from one
        // root, so give each root its own chart — the prior route did the same by
        // mapping over `rootEmployees`. Passing the whole flat list to one chart would
        // silently hide every root but the first, along with everyone beneath it.
        const childrenOf = new Map();
        chartNodes.forEach((n)=>{
            if (n.managerId != null) childrenOf.set(n.managerId, [
                ...childrenOf.get(n.managerId) ?? [],
                n
            ]);
        });
        const subtreeOf = (root)=>{
            const out = [];
            const seen = new Set();
            const walk = (n)=>{
                // supervisor_id has no DB cycle constraint and is written by the ADP
                // sync, so guard the descent rather than recurse forever.
                if (seen.has(n.id)) return;
                seen.add(n.id);
                out.push(n);
                (childrenOf.get(n.id) ?? []).forEach(walk);
            };
            walk(root);
            return out;
        };
        const roots = chartNodes.filter((n)=>n.managerId == null);
        return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $3e4306c97c8d2a8d$export$2e2bcd8739ae039), {
                    sx: {
                        textAlign: 'right'
                    },
                    children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $b76b8f5033f3049e$export$df6a541d7dc3c0a3), {})
                }),
                roots.map((root)=>/*#__PURE__*/ (0, $01ysi.jsx)((0, $2b15f70c0ff60fbf$export$2e2bcd8739ae039), {
                        nodes: subtreeOf(root),
                        rootId: root.id,
                        accentColor: (0, $fcf5b0132d6341e1$export$2e2bcd8739ae039).colors.primary,
                        renderAvatar: $a5a28410614d0a31$var$OrgChartAvatar
                    }, root.id))
            ]
        });
    }
    return null;
}
var $a5a28410614d0a31$export$2e2bcd8739ae039 = $a5a28410614d0a31$var$OrgChartRoute;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");







var $489wz = parcelRequire("489wz");



var $jIrNf = parcelRequire("jIrNf");


const $5244e1896c2900f3$var$sidebarLinks = [
    {
        title: 'Users',
        to: '/admin/users'
    },
    {
        title: 'Job Sites',
        to: '/admin/jobsites',
        subLinks: [
            {
                title: 'Create New Job Site',
                to: '/admin/jobsites/new'
            }
        ]
    },
    {
        title: 'Pages',
        to: '/admin/pages'
    },
    {
        title: 'Departments',
        to: '/admin/departments',
        subLinks: [
            {
                title: 'Create New Department',
                to: '/admin/departments/new'
            }
        ]
    }
];
const $5244e1896c2900f3$var$jobsiteMutationParams = {
    awaitRefetchQueries: true,
    refetchQueries: [
        'jobsites'
    ]
};
const $5244e1896c2900f3$var$usersMutationParams = {
    awaitRefetchQueries: true,
    refetchQueries: [
        'usersGetAll'
    ]
};
const $5244e1896c2900f3$var$context = {
    useRole: 'SuperAdmin'
};
function $5244e1896c2900f3$var$JobsitePublish({ jobsites: jobsites }) {
    const location = (0, $372fcccf2bee01ac$export$45d76561a5302f2b)();
    const navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    const [createJobsite] = (0, $93486c083cb38a29$export$d44cc90afff5d3b2)($5244e1896c2900f3$var$jobsiteMutationParams);
    const [updateJobsite] = (0, $93486c083cb38a29$export$83310d2b73219242)($5244e1896c2900f3$var$jobsiteMutationParams);
    const existingId = +location.pathname.split('/').pop();
    const existing = existingId > 0 && jobsites.find((js)=>js.id === existingId);
    const { data: adConfigData } = (0, $93486c083cb38a29$export$ecb06dbd95d54e0c)({
        variables: {
            key: 'adJobsites'
        }
    });
    const missingJobsites = adConfigData ? (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).chain(JSON.parse(adConfigData.configByKey.value)).difference((0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).chain(jobsites).map('title').value()).orderBy().value() : [];
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Formik), {
        enableReinitialize: true,
        initialValues: {
            title: existing?.title || '',
            siteNumber: existing?.siteNumber || '',
            phone: existing?.phone || '',
            mainAddress: existing?.mainAddress || '',
            mainAddress2: existing?.mainAddress2 || '',
            mainAddressCity: existing?.mainAddressCity || '',
            mainAddressState: existing?.mainAddressState || '',
            mainAddressZip: existing?.mainAddressZip || '',
            officeAddress: existing?.officeAddress || '',
            officeAddress2: existing?.officeAddress2 || '',
            officeAddressCity: existing?.officeAddressCity || '',
            officeAddressState: existing?.officeAddressState || '',
            officeAddressZip: existing?.officeAddressZip || '',
            alt_names: existing?.alt_names || ''
        },
        onSubmit: async (values)=>{
            const variables = {
                ...values
            };
            for (const field of [
                'mainAddress2',
                'officeAddress',
                'officeAddress2',
                'officeAddressCity',
                'officeAddressState',
                'officeAddressZip'
            ])if (variables[field].length === 0) variables[field] = null;
            if (existing) await updateJobsite({
                context: $5244e1896c2900f3$var$context,
                variables: {
                    ...variables,
                    id: existing.id
                }
            });
            else await createJobsite({
                context: $5244e1896c2900f3$var$context,
                variables: variables
            });
            navigate('/admin/jobsites');
        },
        children: ({ setFieldValue: setFieldValue, values: values })=>{
            return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $489wz.Form), {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        className: "twothird",
                        name: "title",
                        type: "text",
                        label: "Site Name"
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        className: "third",
                        name: "siteNumber",
                        type: "text",
                        label: "Site Number",
                        onChange: (e)=>{
                            const nextVal = /^\d\d$/.test(e.target.value) ? `${e.target.value}-` : e.target.value;
                            setFieldValue('siteNumber', nextVal);
                        }
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        name: "phone",
                        type: "text",
                        label: "Phone Number",
                        onChange: (e)=>{
                            const digits = e.target.value.replace(/[^\d]/g, '');
                            const nextVal = digits.length === 3 ? `(${digits.substr(0, 3)}) ` : digits.length === 6 ? `(${digits.substr(0, 3)}) ${digits.substr(3, 3)}-` : digits.length === 10 ? `(${digits.substr(0, 3)}) ${digits.substr(3, 3)}-${digits.substr(6, 4)}` : e.target.value;
                            setFieldValue('phone', nextVal);
                        }
                    }),
                    !existing && missingJobsites.length > 0 && /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                        style: {
                            paddingTop: '1em',
                            fontSize: '90%'
                        },
                        children: [
                            "New job sites from AD:",
                            ' ',
                            missingJobsites.map((js, idx)=>/*#__PURE__*/ (0, $01ysi.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                                            style: {
                                                cursor: 'pointer',
                                                color: '#bd5f28'
                                            },
                                            onClick: ()=>setFieldValue('title', js),
                                            children: js
                                        }),
                                        idx != missingJobsites.length - 1 ? ', ' : ''
                                    ]
                                }, js))
                        ]
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$1ff3c3f08ae963c0), {}),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        className: "half",
                        name: "mainAddress",
                        type: "text",
                        label: "Job Site Address"
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        className: "half",
                        name: "mainAddress2",
                        type: "text",
                        label: "Job Site Address 2"
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        className: "half",
                        name: "mainAddressCity",
                        type: "text",
                        label: "City"
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        className: "quarter",
                        name: "mainAddressState",
                        type: "text",
                        label: "State"
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        className: "quarter",
                        name: "mainAddressZip",
                        type: "text",
                        label: "Zip"
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$1ff3c3f08ae963c0), {}),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        className: "half",
                        name: "officeAddress",
                        type: "text",
                        label: "Job Office Address"
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        className: "half",
                        name: "officeAddress2",
                        type: "text",
                        label: "Job Office Address 2"
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        className: "half",
                        name: "officeAddressCity",
                        type: "text",
                        label: "City"
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        className: "quarter",
                        name: "officeAddressState",
                        type: "text",
                        label: "State"
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        className: "quarter",
                        name: "officeAddressZip",
                        type: "text",
                        label: "Zip"
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        name: "alt_names",
                        type: "text",
                        label: "Matching office names"
                    }),
                    existing && missingJobsites.length > 0 && /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                        style: {
                            paddingTop: '1em',
                            fontSize: '90%'
                        },
                        children: [
                            "New job sites from AD:",
                            ' ',
                            missingJobsites.map((js, idx)=>/*#__PURE__*/ (0, $01ysi.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0, $01ysi.jsx)("span", {
                                            style: {
                                                cursor: 'pointer',
                                                color: '#bd5f28'
                                            },
                                            onClick: ()=>{
                                                const newAltNames = (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).chain((values.alt_names || '').split(';')).map((ejs)=>ejs.trim()).filter((ejs)=>ejs.length > 0).concat([
                                                    js
                                                ]).uniq().value().join('; ') + ';';
                                                setFieldValue('alt_names', newAltNames);
                                            },
                                            children: js
                                        }),
                                        idx != missingJobsites.length - 1 ? ', ' : ''
                                    ]
                                }, js))
                        ]
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        type: "formButtons",
                        submitLabel: `${existing ? 'Update' : 'Create'} Job Site`,
                        onCancel: "/admin/jobsites"
                    })
                ]
            });
        }
    });
}
function $5244e1896c2900f3$var$UsersPublish({ users: users }) {
    const location = (0, $372fcccf2bee01ac$export$45d76561a5302f2b)();
    const navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    const [upload] = (0, $a2c6c12bc7500c5d$export$b20424b4610825c3)();
    const [addUserRole] = (0, $93486c083cb38a29$export$f8b1b8fbf5b89d45)($5244e1896c2900f3$var$usersMutationParams);
    const [removeUserRole] = (0, $93486c083cb38a29$export$52639b1a58427e4e)($5244e1896c2900f3$var$usersMutationParams);
    const [updateProfilePic] = (0, $93486c083cb38a29$export$11678de5e6a25d7b)($5244e1896c2900f3$var$usersMutationParams);
    const userId = +location.pathname.split('/').pop();
    const user = users.find((u)=>u.id === userId);
    const roles = [
        'SuperAdmin',
        'Editor',
        'Gallery',
        'Crisis'
    ].map((role)=>({
            label: role,
            value: role
        }));
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Formik), {
        enableReinitialize: true,
        initialValues: {
            name: `${user.firstName || ''} ${user.lastName || ''}`,
            roles: user.roles.map((ur)=>roles.find((role)=>role.value === ur.role)),
            profileImage: null
        },
        onSubmit: async (values)=>{
            if (values.profileImage) {
                const { uploadId: uploadId } = await upload(values.profileImage.file);
                // todo: adjust hasura permissions
                await updateProfilePic({
                    variables: {
                        userId: user.id,
                        uploadId: uploadId
                    }
                });
            }
            const currentRoles = user.roles.map((ur)=>ur.role);
            const newRoles = values.roles.map((r)=>r.value);
            const addedRoles = (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).difference(newRoles, currentRoles);
            const removedRoles = (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).difference(currentRoles, newRoles);
            for (const addedRole of addedRoles)await addUserRole({
                context: $5244e1896c2900f3$var$context,
                variables: {
                    input: {
                        userId: user.id,
                        role: addedRole
                    }
                }
            });
            for (const removedRole of removedRoles)await removeUserRole({
                context: $5244e1896c2900f3$var$context,
                variables: {
                    userId: user.id,
                    role: removedRole
                }
            });
            navigate('/admin/users');
        },
        children: ()=>{
            return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $489wz.Form), {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        name: "name",
                        type: "text",
                        label: "Name",
                        disabled: true
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$1ff3c3f08ae963c0), {}),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        name: "profileImage",
                        label: "Profile Image",
                        type: "file",
                        image: {
                            aspect: 1,
                            existing: user.profilePhotoUrl
                        }
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$1ff3c3f08ae963c0), {}),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        name: "roles",
                        type: "select2",
                        label: "Roles",
                        options: roles,
                        isMulti: true
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        type: "formButtons",
                        submitLabel: "Update User",
                        onCancel: "/admin/users"
                    })
                ]
            });
        }
    });
}
function $5244e1896c2900f3$var$UsersList({ users: users }) {
    const fullNameByUserId = (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).chain(users).keyBy('id').mapValues((u)=>`${u.firstName || ''} ${u.lastName || ''}`).value();
    return /*#__PURE__*/ (0, $01ysi.jsx)("div", {
        children: /*#__PURE__*/ (0, $01ysi.jsxs)($77464f2f26b81980$export$54ec01a60f47d33d, {
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$e93312b7773dfcac, {
                    children: /*#__PURE__*/ (0, $01ysi.jsxs)($77464f2f26b81980$export$b59bdbef9ce70de2, {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$8b251419efc915eb, {
                                children: "Name"
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$8b251419efc915eb, {
                                children: "Job Title"
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$8b251419efc915eb, {
                                children: "Supervisor"
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$4d82ce4c37371892, {
                                children: "Roles"
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$d90409754c76221d, {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$4b2c32e08f77ff18, {
                    children: users.map((u)=>/*#__PURE__*/ (0, $01ysi.jsxs)($77464f2f26b81980$export$b59bdbef9ce70de2, {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)("td", {
                                    children: fullNameByUserId[u.id] || ''
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)("td", {
                                    children: u.jobTitle
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)("td", {
                                    children: fullNameByUserId[u.supervisorId] || ''
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)("td", {
                                    children: u.roles.map((ur)=>ur.role).join(', ')
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$b52183d5cfb26dc9, {
                                    children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $e3f57e4b1ea630bd$export$a6c7ac8248d6e38a), {
                                        to: `/admin/users/${u.id}`,
                                        children: /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$2ad141e9e3d81b82, {})
                                    })
                                })
                            ]
                        }, u.id))
                })
            ]
        })
    });
}
function $5244e1896c2900f3$var$PageList() {
    const pages = (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).orderBy((0, $6f7f49c0f054a62d$export$55c0e3cb4fbc46cf)().siteMeta.pages, 'title');
    return /*#__PURE__*/ (0, $01ysi.jsxs)($77464f2f26b81980$export$54ec01a60f47d33d, {
        children: [
            /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$e93312b7773dfcac, {
                children: /*#__PURE__*/ (0, $01ysi.jsxs)($77464f2f26b81980$export$b59bdbef9ce70de2, {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$8b251419efc915eb, {
                            children: "Name"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$d90409754c76221d, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$4b2c32e08f77ff18, {
                children: pages.map((p)=>/*#__PURE__*/ (0, $01ysi.jsxs)($77464f2f26b81980$export$b59bdbef9ce70de2, {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)("td", {
                                children: p.title
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$b52183d5cfb26dc9, {
                                children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $e3f57e4b1ea630bd$export$a6c7ac8248d6e38a), {
                                    to: `/admin/pages/${p.slug}`,
                                    children: /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$2ad141e9e3d81b82, {})
                                })
                            })
                        ]
                    }, p.slug))
            })
        ]
    });
}
function $5244e1896c2900f3$var$PagePublish() {
    const location = (0, $372fcccf2bee01ac$export$45d76561a5302f2b)();
    const pageSlug = location.pathname.split('/').pop();
    const page = (0, $6f7f49c0f054a62d$export$55c0e3cb4fbc46cf)().siteMeta.pages.find((p)=>p.slug === pageSlug);
    const navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    const [upload] = (0, $a2c6c12bc7500c5d$export$b20424b4610825c3)();
    const [updatePage] = (0, $93486c083cb38a29$export$aeb2a06afafa0c69)({
        awaitRefetchQueries: true,
        refetchQueries: [
            'siteMeta'
        ]
    });
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Formik), {
        enableReinitialize: true,
        initialValues: {
            mastheadImage: null,
            name: page.title
        },
        onSubmit: async (values)=>{
            if (values.mastheadImage) {
                const { uploadId: uploadId } = await upload(values.mastheadImage.file);
                await updatePage({
                    variables: {
                        slug: page.slug,
                        mastheadUploadId: uploadId
                    }
                });
            }
            navigate('/admin/pages');
        },
        children: ()=>{
            return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $489wz.Form), {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        name: "name",
                        type: "text",
                        label: "Name",
                        disabled: true
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$1ff3c3f08ae963c0), {}),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        name: "mastheadImage",
                        label: "Masthead Image",
                        type: "file",
                        image: {
                            aspect: 160 / 15,
                            existing: page.masthead.publicUrl
                        }
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                        type: "formButtons",
                        submitLabel: "Update Page",
                        onCancel: "/admin/pages"
                    })
                ]
            });
        }
    });
}
function $5244e1896c2900f3$var$JobsiteList({ jobsites: jobsites }) {
    const [deleteJobsite] = (0, $93486c083cb38a29$export$bf3b340cbc1be158)($5244e1896c2900f3$var$jobsiteMutationParams);
    return /*#__PURE__*/ (0, $01ysi.jsx)("div", {
        children: /*#__PURE__*/ (0, $01ysi.jsxs)($77464f2f26b81980$export$54ec01a60f47d33d, {
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$e93312b7773dfcac, {
                    children: /*#__PURE__*/ (0, $01ysi.jsxs)($77464f2f26b81980$export$b59bdbef9ce70de2, {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$8b251419efc915eb, {
                                children: "Site Number"
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$8b251419efc915eb, {
                                children: "Title"
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$8b251419efc915eb, {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$4b2c32e08f77ff18, {
                    children: jobsites.map((js)=>/*#__PURE__*/ (0, $01ysi.jsxs)($77464f2f26b81980$export$b59bdbef9ce70de2, {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)("td", {
                                    children: js.siteNumber
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)("td", {
                                    children: js.title
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsxs)($77464f2f26b81980$export$b52183d5cfb26dc9, {
                                    children: [
                                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $e3f57e4b1ea630bd$export$a6c7ac8248d6e38a), {
                                            to: `/admin/jobsites/${js.id}`,
                                            children: /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$2ad141e9e3d81b82, {})
                                        }),
                                        /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$1ae95d1a7411cb7b, {
                                            onClick: async ()=>{
                                                if (confirm('Are you sure you want to delete this job site?')) await deleteJobsite({
                                                    context: $5244e1896c2900f3$var$context,
                                                    variables: {
                                                        id: js.id
                                                    }
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        }, js.id))
                })
            ]
        })
    });
}
function $5244e1896c2900f3$var$DepartmentsAdminList({ users: users }) {
    const { departments: departments } = (0, $6f7f49c0f054a62d$export$55c0e3cb4fbc46cf)().siteMeta;
    const usersById = (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).keyBy(users, 'id');
    const getOwner = (userId)=>{
        const user = usersById[userId];
        if (user) return `${user.firstName} ${user.lastName}`;
        return '-';
    };
    return /*#__PURE__*/ (0, $01ysi.jsx)("div", {
        children: /*#__PURE__*/ (0, $01ysi.jsxs)($77464f2f26b81980$export$54ec01a60f47d33d, {
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$e93312b7773dfcac, {
                    children: /*#__PURE__*/ (0, $01ysi.jsxs)($77464f2f26b81980$export$b59bdbef9ce70de2, {
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$8b251419efc915eb, {
                                children: "Name"
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$8b251419efc915eb, {
                                children: "Owner"
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$d90409754c76221d, {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$4b2c32e08f77ff18, {
                    children: departments.map((d)=>/*#__PURE__*/ (0, $01ysi.jsxs)($77464f2f26b81980$export$b59bdbef9ce70de2, {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsx)("td", {
                                    children: d.title
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)("td", {
                                    children: getOwner(d.ownerId)
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$b52183d5cfb26dc9, {
                                    children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $e3f57e4b1ea630bd$export$a6c7ac8248d6e38a), {
                                        to: `/departments/${d.id}/edit`,
                                        children: /*#__PURE__*/ (0, $01ysi.jsx)($77464f2f26b81980$export$2ad141e9e3d81b82, {})
                                    })
                                })
                            ]
                        }, d.id))
                })
            ]
        })
    });
}
function $5244e1896c2900f3$var$DepartmentsAdminPublish({ users: users }) {
    const navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    const [createDepartment] = (0, $93486c083cb38a29$export$1018408e8180dc25)({
        awaitRefetchQueries: true,
        refetchQueries: [
            'siteMeta'
        ]
    });
    const userOptions = (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).chain(users).orderBy([
        'lastName',
        'firstName'
    ]).map((u)=>({
            label: `${u.lastName}, ${u.firstName}`,
            value: u.id.toString()
        })).value();
    return /*#__PURE__*/ (0, $01ysi.jsx)("div", {
        children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Formik), {
            enableReinitialize: true,
            initialValues: {
                title: '',
                ownerId: {
                    value: 0
                }
            },
            onSubmit: async (values)=>{
                const { id: id } = (await createDepartment({
                    context: $5244e1896c2900f3$var$context,
                    variables: {
                        title: values.title,
                        ownerId: +values.ownerId.value,
                        mastheadUploadId: 5365
                    }
                })).data.insertDepartment;
                navigate(`/departments/${id}/edit`);
            },
            children: ()=>{
                return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $489wz.Form), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                            name: "title",
                            type: "text",
                            label: "Title"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                            name: "ownerId",
                            type: "select2",
                            label: "Owner",
                            options: userOptions
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                            type: "formButtons",
                            submitLabel: "Create Department",
                            onCancel: "/admin/departments",
                            autoWidth: true
                        })
                    ]
                });
            }
        })
    });
}
function $5244e1896c2900f3$var$AdminRoute() {
    const jobsites = (0, $93486c083cb38a29$export$f64f3247eeaa58a9)().data?.jobsites;
    const users = (0, $93486c083cb38a29$export$db5004fb9b9627eb)().data?.users;
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $38e8ff2ff45ad7fb$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $f17ceecf287e1f86$export$2e2bcd8739ae039), {
                    links: $5244e1896c2900f3$var$sidebarLinks
                }),
                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $372fcccf2bee01ac$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                            path: "/",
                            element: /*#__PURE__*/ (0, $01ysi.jsx)("p", {
                                children: "Select a section from the navigation. "
                            })
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                            path: "/users/*",
                            element: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $372fcccf2bee01ac$export$3565eb3d00ca5a74), {
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                        path: "/",
                                        element: users && /*#__PURE__*/ (0, $01ysi.jsx)($5244e1896c2900f3$var$UsersList, {
                                            users: users
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                        path: "/*",
                                        element: users && /*#__PURE__*/ (0, $01ysi.jsx)($5244e1896c2900f3$var$UsersPublish, {
                                            users: users
                                        })
                                    })
                                ]
                            })
                        }),
                        ' ',
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                            path: "/jobsites/*",
                            element: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $372fcccf2bee01ac$export$3565eb3d00ca5a74), {
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                        path: "/",
                                        element: jobsites && /*#__PURE__*/ (0, $01ysi.jsx)($5244e1896c2900f3$var$JobsiteList, {
                                            jobsites: jobsites
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                        path: "/new",
                                        element: jobsites && /*#__PURE__*/ (0, $01ysi.jsx)($5244e1896c2900f3$var$JobsitePublish, {
                                            jobsites: jobsites
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                        path: "/*",
                                        element: jobsites && /*#__PURE__*/ (0, $01ysi.jsx)($5244e1896c2900f3$var$JobsitePublish, {
                                            jobsites: jobsites
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                            path: "/pages/*",
                            element: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $372fcccf2bee01ac$export$3565eb3d00ca5a74), {
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                        path: "/",
                                        element: /*#__PURE__*/ (0, $01ysi.jsx)($5244e1896c2900f3$var$PageList, {})
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                        path: "/*",
                                        element: /*#__PURE__*/ (0, $01ysi.jsx)($5244e1896c2900f3$var$PagePublish, {})
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                            path: "/departments/*",
                            element: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $372fcccf2bee01ac$export$3565eb3d00ca5a74), {
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                        path: "/",
                                        element: users && /*#__PURE__*/ (0, $01ysi.jsx)($5244e1896c2900f3$var$DepartmentsAdminList, {
                                            users: users
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                        path: "/new",
                                        element: users && /*#__PURE__*/ (0, $01ysi.jsx)($5244e1896c2900f3$var$DepartmentsAdminPublish, {
                                            users: users
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}
var $5244e1896c2900f3$export$2e2bcd8739ae039 = $5244e1896c2900f3$var$AdminRoute;



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");



var $489wz = parcelRequire("489wz");




var $489wz = parcelRequire("489wz");
const $3120ab62486ba8c8$export$9a29075fb75452c6 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).p`
	color: #666;
	margin: 0.5rem 0;
	font-size: 0.9rem;
	line-height: 1.6;

	&:last-child {
		margin-top: 1rem;
		font-weight: 500;
		color: #333;
	}
`;
const $3120ab62486ba8c8$export$5740cdd52697d95d = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	width: 90%;
	text-align: right;
	margin-top: 0.5rem;
	font-size: 0.9rem;
	color: ${(props)=>props.isOverLimit ? '#e21717' : '#666'};
	font-weight: ${(props)=>props.isOverLimit ? '600' : '400'};
`;
const $3120ab62486ba8c8$export$a5f05ba1cc88f865 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $489wz.Field))`
	width: 100%;
	min-height: 200px;
	padding: 0.75rem 1rem;
	background: #fff;
	border: 1px solid #d1d1d1;
	border-radius: 3px;
	font-size: 1rem;
	line-height: 1.5;
	resize: vertical;
	font-family: inherit;
	box-sizing: border-box;
	
	&:focus {
		outline: none;
		border-color: #bd5f28;
	}
	
	&::placeholder {
		color: #999;
	}
`;
const $3120ab62486ba8c8$export$f0d5cf01c1e890b1 = (0, $8999e1d77b7e12d9$export$f0f03736edb61697)`
	textarea[name="message"] {
		height: 200px !important;
		min-height: 200px !important;
		resize: vertical !important;
	}
`;
const $3120ab62486ba8c8$export$5ed629df631d8188 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	width: 90%;
	padding: 1rem 0;
	
	& > div {
		width: 100%;
	}
`;




function $b0d733c990b20501$var$CrisisNotificationsHome() {
    const [sendCrisisNotification] = (0, $93486c083cb38a29$export$308c2c378aa8b747)();
    const MAX_CHARACTERS = 1000;
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $a45e69cf1a9414fe$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $6e3a19da527b7fab$export$d56e283436f735f9), {
            role: "Crisis",
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $3120ab62486ba8c8$export$9a29075fb75452c6), {
                    children: "Only use in the case of crisis like fire or active shooter."
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $3120ab62486ba8c8$export$9a29075fb75452c6), {
                    children: "NOT TO BE USED for standard emergencies like utility strikes, injuries, or property damage unless catastrophic in nature."
                }),
                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $3120ab62486ba8c8$export$9a29075fb75452c6), {
                    children: [
                        "Please note: Text message are limited to ",
                        MAX_CHARACTERS,
                        " characters including spaces."
                    ]
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Formik), {
                    initialValues: {
                        message: ''
                    },
                    validate: (values)=>{
                        const errors = {};
                        if (!values.message) errors.message = 'Message is required';
                        else if (values.message.length > MAX_CHARACTERS) errors.message = `Message exceeds ${MAX_CHARACTERS} character limit (${values.message.length} characters)`;
                        return errors;
                    },
                    onSubmit: async (values, actions)=>{
                        try {
                            const result = await sendCrisisNotification({
                                variables: {
                                    title: 'Crisis Notification',
                                    text: values.message
                                }
                            });
                            if (result.data?.sendCrisisNotification?.success) {
                                alert('Crisis notification sent successfully!');
                                actions.resetForm();
                            } else throw new Error(result.data?.sendCrisisNotification?.message || 'Failed to send crisis notification');
                        } catch (error) {
                            console.error('Error sending crisis notification:', error);
                            alert(`Failed to send crisis notification: ${error instanceof Error ? error.message : 'Unknown error'}`);
                        } finally{
                            actions.setSubmitting(false);
                        }
                    },
                    children: ({ values: values, errors: errors, touched: touched, isValid: isValid, isSubmitting: isSubmitting })=>{
                        const isOverLimit = (values.message || '').length > MAX_CHARACTERS;
                        return /*#__PURE__*/ (0, $01ysi.jsxs)((0, $489wz.Form), {
                            children: [
                                /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                                    style: {
                                        width: '90%',
                                        paddingTop: '20px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $837a9440f933970f$export$2e2bcd8739ae039), {
                                            children: "Crisis Message"
                                        }),
                                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $3120ab62486ba8c8$export$a5f05ba1cc88f865), {
                                            name: "message",
                                            component: "textarea",
                                            placeholder: "Enter your crisis notification message..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $3120ab62486ba8c8$export$5740cdd52697d95d), {
                                    isOverLimit: isOverLimit,
                                    children: [
                                        (values.message || '').length,
                                        " / ",
                                        MAX_CHARACTERS,
                                        " characters"
                                    ]
                                }),
                                errors.message && touched.message && /*#__PURE__*/ (0, $01ysi.jsx)("div", {
                                    style: {
                                        color: '#e21717',
                                        marginTop: '0.5rem',
                                        fontSize: '0.9rem',
                                        width: '90%'
                                    },
                                    children: errors.message
                                }),
                                /*#__PURE__*/ (0, $01ysi.jsx)((0, $241e7cea7cf41e5a$export$2e2bcd8739ae039), {
                                    type: "formButtons",
                                    submitLabel: "Send",
                                    disabled: isOverLimit,
                                    isLoading: isSubmitting
                                })
                            ]
                        });
                    }
                })
            ]
        })
    });
}
function $b0d733c990b20501$var$CrisisNotificationsRoute() {
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$3565eb3d00ca5a74), {
        children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
            path: "/",
            element: /*#__PURE__*/ (0, $01ysi.jsx)($b0d733c990b20501$var$CrisisNotificationsHome, {})
        })
    });
}
var $b0d733c990b20501$export$2e2bcd8739ae039 = $b0d733c990b20501$var$CrisisNotificationsRoute;



var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");
var $566808ab82a672e4$exports = {};
$566808ab82a672e4$exports = $parcel$resolve("8Gfqa");


var $947452b0032889fc$exports = {};
'use strict';
var $f1093a887bbeb55c$exports = {};
'use strict';
var $b5a334a9661ff09e$exports = {};
'use strict';
var $3731c64e2a96f376$exports = {};
'use strict';
Object.defineProperty($3731c64e2a96f376$exports, "__esModule", {
    value: true
});
var $3731c64e2a96f376$var$warn = function warn(s) {
    console.warn('[react-gtm]', s);
};
$3731c64e2a96f376$exports.default = $3731c64e2a96f376$var$warn;


var $b5a334a9661ff09e$var$_warn2 = $b5a334a9661ff09e$var$_interopRequireDefault($3731c64e2a96f376$exports);
function $b5a334a9661ff09e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// https://developers.google.com/tag-manager/quickstart
var $b5a334a9661ff09e$var$Snippets = {
    tags: function tags(_ref) {
        var id = _ref.id, events = _ref.events, dataLayer = _ref.dataLayer, dataLayerName = _ref.dataLayerName, preview = _ref.preview, auth = _ref.auth;
        var gtm_auth = '&gtm_auth=' + auth;
        var gtm_preview = '&gtm_preview=' + preview;
        if (!id) (0, $b5a334a9661ff09e$var$_warn2.default)('GTM Id is required');
        var iframe = '\n      <iframe src="https://www.googletagmanager.com/ns.html?id=' + id + gtm_auth + gtm_preview + '&gtm_cookies_win=x"\n        height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>';
        var script = '\n      (function(w,d,s,l,i){w[l]=w[l]||[];\n        w[l].push({\'gtm.start\': new Date().getTime(),event:\'gtm.js\', ' + JSON.stringify(events).slice(1, -1) + '});\n        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';\n        j.async=true;j.src=\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl+\'' + gtm_auth + gtm_preview + '&gtm_cookies_win=x\';\n        f.parentNode.insertBefore(j,f);\n      })(window,document,\'script\',\'' + dataLayerName + '\',\'' + id + '\');';
        var dataLayerVar = this.dataLayer(dataLayer, dataLayerName);
        return {
            iframe: iframe,
            script: script,
            dataLayerVar: dataLayerVar
        };
    },
    dataLayer: function dataLayer(_dataLayer, dataLayerName) {
        return '\n      window.' + dataLayerName + ' = window.' + dataLayerName + ' || [];\n      window.' + dataLayerName + '.push(' + JSON.stringify(_dataLayer) + ')';
    }
};
$b5a334a9661ff09e$exports = $b5a334a9661ff09e$var$Snippets;


var $f1093a887bbeb55c$var$_Snippets2 = $f1093a887bbeb55c$var$_interopRequireDefault($b5a334a9661ff09e$exports);
function $f1093a887bbeb55c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f1093a887bbeb55c$var$TagManager = {
    dataScript: function dataScript(dataLayer) {
        var script = document.createElement('script');
        script.innerHTML = dataLayer;
        return script;
    },
    gtm: function gtm(args) {
        var snippets = $f1093a887bbeb55c$var$_Snippets2.default.tags(args);
        var noScript = function noScript() {
            var noscript = document.createElement('noscript');
            noscript.innerHTML = snippets.iframe;
            return noscript;
        };
        var script = function script() {
            var script = document.createElement('script');
            script.innerHTML = snippets.script;
            return script;
        };
        var dataScript = this.dataScript(snippets.dataLayerVar);
        return {
            noScript: noScript,
            script: script,
            dataScript: dataScript
        };
    },
    initialize: function initialize(_ref) {
        var gtmId = _ref.gtmId, _ref$events = _ref.events, events = _ref$events === undefined ? {} : _ref$events, dataLayer = _ref.dataLayer, _ref$dataLayerName = _ref.dataLayerName, dataLayerName = _ref$dataLayerName === undefined ? 'dataLayer' : _ref$dataLayerName, _ref$auth = _ref.auth, auth = _ref$auth === undefined ? '' : _ref$auth, _ref$preview = _ref.preview, preview = _ref$preview === undefined ? '' : _ref$preview;
        var gtm = this.gtm({
            id: gtmId,
            events: events,
            dataLayer: dataLayer || undefined,
            dataLayerName: dataLayerName,
            auth: auth,
            preview: preview
        });
        if (dataLayer) document.head.appendChild(gtm.dataScript);
        document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
        document.body.insertBefore(gtm.noScript(), document.body.childNodes[0]);
    },
    dataLayer: function dataLayer(_ref2) {
        var _dataLayer = _ref2.dataLayer, _ref2$dataLayerName = _ref2.dataLayerName, dataLayerName = _ref2$dataLayerName === undefined ? 'dataLayer' : _ref2$dataLayerName;
        if (window[dataLayerName]) return window[dataLayerName].push(_dataLayer);
        var snippets = $f1093a887bbeb55c$var$_Snippets2.default.dataLayer(_dataLayer, dataLayerName);
        var dataScript = this.dataScript(snippets);
        document.head.insertBefore(dataScript, document.head.childNodes[0]);
    }
};
$f1093a887bbeb55c$exports = $f1093a887bbeb55c$var$TagManager;


var $947452b0032889fc$var$_TagManager2 = $947452b0032889fc$var$_interopRequireDefault($f1093a887bbeb55c$exports);
function $947452b0032889fc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$947452b0032889fc$exports = $947452b0032889fc$var$_TagManager2.default;


const $45543d8653d576d2$var$ITHelp = ()=>{
    const [isOpen, setIsOpen] = (0, $gRqVZ.useState)(false);
    const [isScrolled, setIsScrolled] = (0, $gRqVZ.useState)(false);
    const onButtonClick = ()=>{
        const tagManagerArgs = {
            gtmId: 'GTM-W4B8NSHJ'
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($947452b0032889fc$exports))).initialize(tagManagerArgs);
        (0, (/*@__PURE__*/$parcel$interopDefault($947452b0032889fc$exports))).dataLayer({
            dataLayer: {
                event: 'it_help_button_click',
                category: 'IT Help',
                action: 'click',
                label: 'IT Help Button'
            }
        });
        window.open('https://ithelp.nibbi.com', '_blank');
    };
    const handleScroll = ()=>{
        if (window.scrollY > 300) setIsScrolled(true);
        else setIsScrolled(false);
    };
    (0, $gRqVZ.useEffect)(()=>{
        window.addEventListener('scroll', handleScroll);
        return ()=>window.removeEventListener('scroll', handleScroll);
    }, []);
    return /*#__PURE__*/ (0, $01ysi.jsx)("div", {
        style: {
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 1000
        },
        children: /*#__PURE__*/ (0, $01ysi.jsx)("button", {
            onClick: onButtonClick,
            className: "rounded-full shadow-lg",
            style: {
                backgroundColor: 'transparent',
                border: 'none'
            },
            children: /*#__PURE__*/ (0, $01ysi.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($566808ab82a672e4$exports))),
                alt: "IT Help",
                style: {
                    borderRadius: '50%'
                },
                width: 75,
                height: 75
            })
        })
    });
};
var $45543d8653d576d2$export$2e2bcd8739ae039 = $45543d8653d576d2$var$ITHelp;


const $6f7f49c0f054a62d$var$SiteContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).createContext(null);
function $6f7f49c0f054a62d$var$AppWrapper() {
    const { loading: loading, data: data } = (0, $93486c083cb38a29$export$67241447dc3e8d68)();
    const location = (0, $372fcccf2bee01ac$export$45d76561a5302f2b)();
    const { searchOpen: searchOpen } = (0, $2693f7ea46500e8f$export$bd221a7c56b93941)();
    const { resourceOpen: resourceOpen } = (0, $83c95e5072a5afa6$export$9f6abfd74295843b)();
    // eslint-disable-next-line prefer-const
    let currentParams;
    const routes = [
        {
            name: '',
            path: '*',
            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$444b3ab0cb9aec40), {
                to: "/home"
            })
        },
        {
            name: 'Home',
            hideTitle: true,
            hideHeader: true,
            path: '/home',
            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $cffdf4453f44ed2d$export$2e2bcd8739ae039), {})
        },
        {
            name: 'Users',
            path: '/users',
            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $839dd07d6fb046f9$export$2e2bcd8739ae039), {})
        },
        {
            name: 'News',
            path: '/news/*',
            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $49da022061afbf32$export$2e2bcd8739ae039), {})
        },
        {
            name: 'Resource Library',
            path: '/resources',
            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $1d358cdcdd7e6197$export$2e2bcd8739ae039), {})
        },
        {
            name: 'Company Directory',
            path: '/company-directory',
            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $2c406d71a571f9f0$export$2e2bcd8739ae039), {})
        },
        {
            name: 'Org Chart',
            path: '/org-chart',
            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $a5a28410614d0a31$export$2e2bcd8739ae039), {})
        },
        {
            name: 'Discussions',
            path: '/discussions/*',
            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $66c440d29c26d289$export$2e2bcd8739ae039), {})
        },
        {
            name: 'Gallery',
            path: '/gallery/*',
            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $5f3c2bf5d3453f85$export$2e2bcd8739ae039), {})
        },
        {
            name: 'Job Sites Gallery',
            get header () {
                return data.pages.find((page)=>page.slug === 'gallery')?.masthead?.publicUrl;
            },
            path: '/jobsite-videos/*',
            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $cf0dd335a9133e17$export$2e2bcd8739ae039), {})
        },
        {
            name: 'Calendar',
            path: '/calendar/*',
            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $6e352ea6786000e7$export$2e2bcd8739ae039), {})
        },
        {
            name: 'Feedback',
            path: '/feedback',
            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $7d3aa74f2569f1a7$export$e7b0ac011bb776c6), {})
        },
        {
            name: 'Etiquette',
            path: '/etiquette',
            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $7d3aa74f2569f1a7$export$e7b0ac011bb776c6), {})
        },
        {
            name: 'Admin',
            caseSensitive: false,
            path: '/admin/*',
            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $5244e1896c2900f3$export$2e2bcd8739ae039), {})
        },
        {
            name: 'Crisis Notifications',
            caseSensitive: false,
            path: '/crisis-notifications/*',
            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $b0d733c990b20501$export$2e2bcd8739ae039), {})
        },
        {
            get name () {
                return data.departments.find((department)=>department.id === +currentParams.departmentId)?.title;
            },
            get header () {
                return data.departments.find((department)=>department.id === +currentParams.departmentId)?.masthead?.publicUrl;
            },
            get hideTitle () {
                return !!data.departments.find((department)=>department.id === +currentParams.departmentId)?.logo;
            },
            caseSensitive: false,
            path: '/departments/:departmentId/*',
            element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $154dffb4cf685475$export$2e2bcd8739ae039), {})
        }
    ];
    const authRoutes = (0, $372fcccf2bee01ac$export$5d3fca4a98652595)(routes);
    if (loading || !data) return null;
    const match = (0, $80658610e38a69c8$export$2708184779ceb39d)(routes, location)[0] ?? {};
    const currentRoute = match.route;
    currentParams = match.params;
    const mastheadUrl = currentRoute.header ?? data.pages.find((page)=>page.slug === currentRoute.path.split('/')[1])?.masthead?.publicUrl;
    const siteContext = {
        siteMeta: {
            ...data,
            departments: (0, (/*@__PURE__*/$parcel$interopDefault($jIrNf))).orderBy(data.departments, 'title')
        }
    };
    return /*#__PURE__*/ (0, $01ysi.jsx)($6f7f49c0f054a62d$var$SiteContext.Provider, {
        value: siteContext,
        children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4eb583db17ee8a52$export$3dfe143f127ef20a), {
            children: [
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $e75f9f9569755185$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $9a1dd6fa292b0c8a$export$2e2bcd8739ae039), {}),
                !currentRoute.hideHeader && /*#__PURE__*/ (0, $01ysi.jsx)((0, $1cc0b2ae0e4c17ef$export$2e2bcd8739ae039), {
                    imageUrl: mastheadUrl,
                    title: currentRoute.name,
                    hideTitle: currentRoute.hideTitle ?? false
                }),
                /*#__PURE__*/ (0, $01ysi.jsxs)((0, $4eb583db17ee8a52$export$eb4ff40e34002c26), {
                    children: [
                        authRoutes,
                        searchOpen && /*#__PURE__*/ (0, $01ysi.jsx)((0, $f134475015c955ff$export$2e2bcd8739ae039), {}),
                        resourceOpen && /*#__PURE__*/ (0, $01ysi.jsx)((0, $83c95e5072a5afa6$export$2e2bcd8739ae039), {})
                    ]
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $1ead20da5b0b8ee0$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $01ysi.jsx)((0, $45543d8653d576d2$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
function $6f7f49c0f054a62d$export$55c0e3cb4fbc46cf() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gRqVZ))).useContext($6f7f49c0f054a62d$var$SiteContext);
}
var $6f7f49c0f054a62d$export$2e2bcd8739ae039 = $6f7f49c0f054a62d$var$AppWrapper;


function $558b1157e7a30192$var$Sandbox() {
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $6f7f49c0f054a62d$export$2e2bcd8739ae039), {});
}
var $558b1157e7a30192$export$2e2bcd8739ae039 = $558b1157e7a30192$var$Sandbox;





var $gRqVZ = parcelRequire("gRqVZ");


const $9c0ab08af26ed2fe$export$c16b04c8a9956446 = ({ client: client, children: children })=>{
    const ApolloContext = (0, $e1d3f667cb3a09be$export$a47505d961ee3a1)();
    const parentContext = $gRqVZ.useContext(ApolloContext);
    const context = $gRqVZ.useMemo(()=>{
        return {
            ...parentContext,
            client: client || parentContext.client
        };
    }, [
        parentContext,
        client
    ]);
    (0, $aa2d7231b5e28112$export$f5708dca728d7177)(context.client, 38);
    return $gRqVZ.createElement(ApolloContext.Provider, {
        value: context
    }, children);
};





function $6175481c6b9a1949$export$871de8747c9eaa88(project, thisArg) {
    return (0, $beab12e89343bf23$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $da8da925672b7eb3$export$b9e075132cc6937f)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}






const $cd2396bbf46089ba$export$a89c95c098ac2a58 = Object.freeze({});
function $cd2396bbf46089ba$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $d53ea9002ec4d7a4$export$4fcd777a40ccf407)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $324243985983b985$export$a84bdc57c5122798)))enterLeaveMap.set(kind, $cd2396bbf46089ba$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = {
                        ...node
                    };
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $d53ea9002ec4d7a4$export$8ee0fc9ee280b4ee)(node) || (0, $c4a46104edabf5e8$export$b6cb5906f04696c8)(false, `Invalid AST Node: ${(0, $db53774dc0ce903e$export$9dec5d1b3b6a130d)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $cd2396bbf46089ba$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $d53ea9002ec4d7a4$export$8ee0fc9ee280b4ee)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $cd2396bbf46089ba$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $324243985983b985$export$a84bdc57c5122798))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $cd2396bbf46089ba$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $cd2396bbf46089ba$export$a89c95c098ac2a58) skipping[i] = $cd2396bbf46089ba$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $cd2396bbf46089ba$export$a89c95c098ac2a58) skipping[i] = $cd2396bbf46089ba$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $cd2396bbf46089ba$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === 'object') // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === 'function') // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $cd2396bbf46089ba$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $cd2396bbf46089ba$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}


function $73b423ec85fb7119$export$2dafb573e282fe8d(names, root, all) {
    const nameSet = new Set(names);
    const uniqueCount = nameSet.size;
    (0, $cd2396bbf46089ba$export$bf638b60ea8b89b7)(root, {
        Directive (node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) return 0, $cd2396bbf46089ba$export$a89c95c098ac2a58;
        }
    });
    // If we found all the names, nameSet will be empty. If we only care about
    // finding some of them, the < condition is sufficient.
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}



class $af1ec4677379bc82$export$ac7bcc44740f06fb {
    isIncrementalResult(_) {
        return false;
    }
    prepareRequest(request) {
        (0, $aa2d7231b5e28112$export$f5708dca728d7177)(!(0, $73b423ec85fb7119$export$2dafb573e282fe8d)([
            "defer",
            "stream"
        ], request.query), 67);
        return request;
    }
    extractErrors() {}
    // This code path can never be reached, so we won't implement it.
    startRequest = undefined;
}




var $60bbc08227059bad$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();


function $c1a8806d0be82246$export$f0954fd7d5368655(x) {
    return x;
}


function $ef5fec74e7932a75$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $ef5fec74e7932a75$export$71f88a61afaa14d7(fns);
}
function $ef5fec74e7932a75$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $c1a8806d0be82246$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $23f68ab689e21470$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $23f68ab689e21470$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $fbf2224f7546e2e1$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $d729478010e38fd5$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $23f68ab689e21470$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $fbf2224f7546e2e1$export$94eeb6a328cab6c7)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $60bbc08227059bad$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $ef5fec74e7932a75$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $23f68ab689e21470$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $23f68ab689e21470$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $faa67ecdc3966937$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $23f68ab689e21470$var$isObserver(value) {
    return value && (0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(value.next) && (0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(value.error) && (0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(value.complete);
}
function $23f68ab689e21470$var$isSubscriber(value) {
    return value && value instanceof (0, $fbf2224f7546e2e1$export$60959659b2c22881) || $23f68ab689e21470$var$isObserver(value) && (0, $effe293b9da5735b$export$4f9221cbada3c4fc)(value);
}


var $31cce697e13f76b3$export$ccb33e29d92c9a58 = new (0, $23f68ab689e21470$export$77cea355fa80b5f4)(function(subscriber) {
    return subscriber.complete();
});
function $31cce697e13f76b3$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $31cce697e13f76b3$var$emptyScheduled(scheduler) : $31cce697e13f76b3$export$ccb33e29d92c9a58;
}
function $31cce697e13f76b3$var$emptyScheduled(scheduler) {
    return new (0, $23f68ab689e21470$export$77cea355fa80b5f4)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}


// Checks the document for errors and throws an exception if there is an error.




/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/ function $3ed2520e139df5b6$export$41bca9dc6871dd4e(doc, fallback) {
    return doc.definitions.find((definition)=>definition.kind === "OperationDefinition" && !!definition.name)?.name.value ?? fallback;
}




function $c1a63f9e5855cc0e$export$fc10aeed3a532e2a(fn, { max: max, makeCacheKey: makeCacheKey = (args)=>args }) {
    const keys = new (0, $3fafa7abbadfcc3d$export$73571c50d0f2507e)(true);
    const cache = new (0, $1abac2280838e114$export$8dbad6f439bb2331)(max);
    return (...args)=>{
        const cacheKey = keys.lookupArray(makeCacheKey(args));
        const cached = cache.get(cacheKey);
        if (cached) {
            if (cached.error) throw cached.error;
            return cached.result;
        }
        const entry = cache.set(cacheKey, {});
        try {
            return entry.result = fn(...args);
        } catch (error) {
            entry.error = error;
            throw error;
        }
    };
}


const $2a4ebb84b536625f$export$a7d0d8111d2386df = (0, $c1a63f9e5855cc0e$export$fc10aeed3a532e2a)((doc, expectedType)=>{
    (0, $aa2d7231b5e28112$export$f5708dca728d7177)(doc && doc.kind === "Document", 1);
    const operations = doc.definitions.filter((d)=>d.kind === "OperationDefinition");
    if (0, $e15192e15b3ad6c1$export$a866f231438cc228) {
        doc.definitions.forEach((definition)=>{
            if (definition.kind !== "OperationDefinition" && definition.kind !== "FragmentDefinition") throw (0, $aa2d7231b5e28112$export$3991762405098ea)(2, definition.kind);
        });
        (0, $aa2d7231b5e28112$export$f5708dca728d7177)(operations.length <= 1, 3, operations.length);
    }
    if (expectedType) (0, $aa2d7231b5e28112$export$f5708dca728d7177)(operations.length == 1 && operations[0].operation === expectedType, 4, expectedType, expectedType, operations[0].operation);
    (0, $cd2396bbf46089ba$export$bf638b60ea8b89b7)(doc, {
        Field (field, _, __, path) {
            if (field.alias && (field.alias.value === "__typename" || field.alias.value.startsWith("__ac_")) && field.alias.value !== field.name.value) {
                // not using `invariant` so path calculation only happens in error case
                let current = doc, fieldPath = [];
                for (const key of path){
                    current = current[key];
                    if (current.kind === (0, $324243985983b985$export$a84bdc57c5122798).FIELD) fieldPath.push(current.alias?.value || current.name.value);
                }
                fieldPath.splice(-1, 1, field.name.value);
                throw (0, $aa2d7231b5e28112$export$3991762405098ea)(5, field.alias.value, fieldPath.join("."), operations[0].operation, (0, $3ed2520e139df5b6$export$41bca9dc6871dd4e)(doc, "(anonymous)"));
            }
        }
    });
}, {
    max: (0, $9f7df0d640a1952d$export$f29926b23b28936b)["checkDocument"] || 2000 /* defaultCacheSizes["checkDocument"] */ 
});


function $bfe912ade316f216$export$7a5b1fa979d2c158(doc) {
    (0, $2a4ebb84b536625f$export$a7d0d8111d2386df)(doc);
    return doc.definitions.filter((definition)=>definition.kind === "OperationDefinition")[0];
}


function $9fb74f29897bbe0d$export$f29bedd62f56fcb2(request, { client: client }) {
    const operation = {
        query: request.query,
        variables: request.variables || {},
        extensions: request.extensions || {},
        operationName: (0, $3ed2520e139df5b6$export$41bca9dc6871dd4e)(request.query),
        operationType: (0, $bfe912ade316f216$export$7a5b1fa979d2c158)(request.query).operation
    };
    let context = {
        ...request.context
    };
    const setContext = (next)=>{
        if (typeof next === "function") context = {
            ...context,
            ...next(getContext())
        };
        else context = {
            ...context,
            ...next
        };
    };
    const getContext = ()=>Object.freeze({
            ...context
        });
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, "client", {
        enumerable: false,
        value: client
    });
    return operation;
}




class $44d61e2fd5c5ba8c$export$2fed3d61f740bc7f {
    /**
     * Creates a link that completes immediately and does not emit a result.
     *
     * @example
     *
     * ```ts
     * const link = ApolloLink.empty();
     * ```
     */ static empty() {
        return new $44d61e2fd5c5ba8c$export$2fed3d61f740bc7f(()=>(0, $31cce697e13f76b3$export$ccb33e29d92c9a58));
    }
    /**
     * Composes multiple links into a single composed link that executes each
     * provided link in serial order.
     *
     * @example
     *
     * ```ts
     * import { from, HttpLink, ApolloLink } from "@apollo/client";
     * import { RetryLink } from "@apollo/client/link/retry";
     * import MyAuthLink from "../auth";
     *
     * const link = ApolloLink.from([
     *   new RetryLink(),
     *   new MyAuthLink(),
     *   new HttpLink({ uri: "http://localhost:4000/graphql" }),
     * ]);
     * ```
     *
     * @param links - An array of `ApolloLink` instances or request handlers that
     * are executed in serial order.
     */ static from(links) {
        if (links.length === 0) return $44d61e2fd5c5ba8c$export$2fed3d61f740bc7f.empty();
        const [first, ...rest] = links;
        return first.concat(...rest);
    }
    /**
     * Creates a link that conditionally routes a request to different links.
     *
     * @example
     *
     * ```ts
     * import { ApolloLink, HttpLink } from "@apollo/client";
     *
     * const link = ApolloLink.split(
     *   (operation) => operation.getContext().version === 1,
     *   new HttpLink({ uri: "http://localhost:4000/v1/graphql" }),
     *   new HttpLink({ uri: "http://localhost:4000/v2/graphql" })
     * );
     * ```
     *
     * @param test - A predicate function that receives the current `operation`
     * and returns a boolean indicating which link to execute. Returning `true`
     * executes the `left` link. Returning `false` executes the `right` link.
     *
     * @param left - The link that executes when the `test` function returns
     * `true`.
     *
     * @param right - The link that executes when the `test` function returns
     * `false`. If the `right` link is not provided, the request is forwarded to
     * the next link in the chain.
     */ static split(test, left, right = new $44d61e2fd5c5ba8c$export$2fed3d61f740bc7f((op, forward)=>forward(op))) {
        const link = new $44d61e2fd5c5ba8c$export$2fed3d61f740bc7f((operation, forward)=>{
            const result = test(operation);
            if (0, $e15192e15b3ad6c1$export$a866f231438cc228) {
                if (typeof result !== "boolean") (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).warn(63, result);
            }
            return result ? left.request(operation, forward) : right.request(operation, forward);
        });
        return Object.assign(link, {
            left: left,
            right: right
        });
    }
    /**
     * Executes a GraphQL request against a link. The `execute` function begins
     * the request by calling the request handler of the link.
     *
     * @example
     *
     * ```ts
     * const observable = ApolloLink.execute(link, { query, variables }, { client });
     *
     * observable.subscribe({
     *   next(value) {
     *     console.log("Received", value);
     *   },
     *   error(error) {
     *     console.error("Oops got error", error);
     *   },
     *   complete() {
     *     console.log("Request complete");
     *   },
     * });
     * ```
     *
     * @param link - The `ApolloLink` instance to execute the request.
     *
     * @param request - The GraphQL request details, such as the `query` and
     * `variables`.
     *
     * @param context - The execution context for the request, such as the
     * `client` making the request.
     */ static execute(link, request, context) {
        return link.request((0, $9fb74f29897bbe0d$export$f29bedd62f56fcb2)(request, context), ()=>{
            if (0, $e15192e15b3ad6c1$export$a866f231438cc228) (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).warn(64);
            return 0, $31cce697e13f76b3$export$ccb33e29d92c9a58;
        });
    }
    /**
     * Combines multiple links into a single composed link.
     *
     * @example
     *
     * ```ts
     * const link = ApolloLink.concat(firstLink, secondLink, thirdLink);
     * ```
     *
     * @param links - The links to concatenate into a single link. Each link will
     * execute in serial order.
     *
     * @deprecated Use `ApolloLink.from` instead. `ApolloLink.concat` will be
     * removed in a future major version.
     */ static concat(...links) {
        return $44d61e2fd5c5ba8c$export$2fed3d61f740bc7f.from(links);
    }
    constructor(request){
        if (request) this.request = request;
    }
    /**
     * Concatenates a link that conditionally routes a request to different links.
     *
     * @example
     *
     * ```ts
     * import { ApolloLink, HttpLink } from "@apollo/client";
     *
     * const previousLink = new ApolloLink((operation, forward) => {
     *   // Handle the request
     *
     *   return forward(operation);
     * });
     *
     * const link = previousLink.split(
     *   (operation) => operation.getContext().version === 1,
     *   new HttpLink({ uri: "http://localhost:4000/v1/graphql" }),
     *   new HttpLink({ uri: "http://localhost:4000/v2/graphql" })
     * );
     * ```
     *
     * @param test - A predicate function that receives the current `operation`
     * and returns a boolean indicating which link to execute. Returning `true`
     * executes the `left` link. Returning `false` executes the `right` link.
     *
     * @param left - The link that executes when the `test` function returns
     * `true`.
     *
     * @param right - The link that executes when the `test` function returns
     * `false`. If the `right` link is not provided, the request is forwarded to
     * the next link in the chain.
     */ split(test, left, right) {
        return this.concat($44d61e2fd5c5ba8c$export$2fed3d61f740bc7f.split(test, left, right));
    }
    /**
     * Combines the link with other links into a single composed link.
     *
     * @example
     *
     * ```ts
     * import { ApolloLink, HttpLink } from "@apollo/client";
     *
     * const previousLink = new ApolloLink((operation, forward) => {
     *   // Handle the request
     *
     *   return forward(operation);
     * });
     *
     * const link = previousLink.concat(
     *   link1,
     *   link2,
     *   new HttpLink({ uri: "http://localhost:4000/graphql" })
     * );
     * ```
     */ concat(...links) {
        if (links.length === 0) return this;
        return links.reduce(this.combine.bind(this), this);
    }
    combine(left, right) {
        const link = new $44d61e2fd5c5ba8c$export$2fed3d61f740bc7f((operation, forward)=>{
            return left.request(operation, (op)=>right.request(op, forward));
        });
        return Object.assign(link, {
            left: left,
            right: right
        });
    }
    /**
     * Runs the request handler for the provided operation.
     *
     * > [!NOTE]
     * > This is called by the `ApolloLink.execute` function for you and should
     * > not be called directly. Prefer using `ApolloLink.execute` to make the
     * > request instead.
     */ request(operation, forward) {
        throw (0, $aa2d7231b5e28112$export$3991762405098ea)(65);
    }
    /**
    * @internal
    * Used to iterate through all links that are concatenations or `split` links.
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */ left;
    /**
    * @internal
    * Used to iterate through all links that are concatenations or `split` links.
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */ right;
}


const $0e5659e1b70da0ac$export$51396ec711da548b = (0, $44d61e2fd5c5ba8c$export$2fed3d61f740bc7f).execute;






// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let $5fdbf93429dbc742$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const $5fdbf93429dbc742$var$MISSING_VALUE = {};
let $5fdbf93429dbc742$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const $5fdbf93429dbc742$var$makeSlotClass = ()=>class Slot {
        constructor(){
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $5fdbf93429dbc742$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        hasValue() {
            for(let context = $5fdbf93429dbc742$var$currentContext; context; context = context.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === $5fdbf93429dbc742$var$MISSING_VALUE) break;
                if (context !== $5fdbf93429dbc742$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $5fdbf93429dbc742$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($5fdbf93429dbc742$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $5fdbf93429dbc742$var$currentContext.slots[this.id] = $5fdbf93429dbc742$var$MISSING_VALUE;
            return false;
        }
        getValue() {
            if (this.hasValue()) return $5fdbf93429dbc742$var$currentContext.slots[this.id];
        }
        withValue(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            const slots = {
                __proto__: null,
                [this.id]: value
            };
            const parent = $5fdbf93429dbc742$var$currentContext;
            $5fdbf93429dbc742$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $5fdbf93429dbc742$var$currentContext = parent;
            }
        }
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        static bind(callback) {
            const context = $5fdbf93429dbc742$var$currentContext;
            return function() {
                const saved = $5fdbf93429dbc742$var$currentContext;
                try {
                    $5fdbf93429dbc742$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $5fdbf93429dbc742$var$currentContext = saved;
                }
            };
        }
        // Immediately run a callback function without any captured context.
        static noContext(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($5fdbf93429dbc742$var$currentContext) {
                const saved = $5fdbf93429dbc742$var$currentContext;
                try {
                    $5fdbf93429dbc742$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $5fdbf93429dbc742$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        }
    };
function $5fdbf93429dbc742$var$maybe(fn) {
    try {
        return fn();
    } catch (ignored) {}
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const $5fdbf93429dbc742$var$globalKey = "@wry/context:Slot";
const $5fdbf93429dbc742$var$host = // Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
$5fdbf93429dbc742$var$maybe(()=>globalThis) || // Fall back to global, which works in Node.js and may be converted by some
// bundlers to the appropriate identifier (window, self, ...) depending on the
// bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
$5fdbf93429dbc742$var$maybe(()=>$parcel$global) || // Otherwise, use a dummy host that's local to this module. We used to fall
// back to using the Array constructor as a namespace, but that was flagged in
// https://github.com/benjamn/wryware/issues/347, and can be avoided.
Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const $5fdbf93429dbc742$var$globalHost = $5fdbf93429dbc742$var$host;
const $5fdbf93429dbc742$export$8c6ed5c666ac1360 = $5fdbf93429dbc742$var$globalHost[$5fdbf93429dbc742$var$globalKey] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[$5fdbf93429dbc742$var$globalKey] || function(Slot) {
    try {
        Object.defineProperty($5fdbf93429dbc742$var$globalHost, $5fdbf93429dbc742$var$globalKey, {
            value: Slot,
            enumerable: false,
            writable: false,
            // When it was possible for globalHost to be the Array constructor (a
            // legacy Slot dedup strategy), it was important for the property to be
            // configurable:true so it could be deleted. That does not seem to be as
            // important when globalHost is the global object, but I don't want to
            // cause similar problems again, and configurable:true seems safest.
            // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
            configurable: true
        });
    } finally{
        return Slot;
    }
}($5fdbf93429dbc742$var$makeSlotClass());


const { bind: $52373a21d9cd00c8$export$2385a24977818dd0, noContext: $52373a21d9cd00c8$export$9fa6f2e300a97f8 } = (0, $5fdbf93429dbc742$export$8c6ed5c666ac1360);
function $52373a21d9cd00c8$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($52373a21d9cd00c8$export$2385a24977818dd0(callback), delay);
}
function $52373a21d9cd00c8$export$d5d7536e965c82da(genFn) {
    return function() {
        const gen = genFn.apply(this, arguments);
        const boundNext = $52373a21d9cd00c8$export$2385a24977818dd0(gen.next);
        const boundThrow = $52373a21d9cd00c8$export$2385a24977818dd0(gen.throw);
        return new Promise((resolve, reject)=>{
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if ($52373a21d9cd00c8$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            const invokeNext = (value)=>invoke(boundNext, value);
            const invokeThrow = (error)=>invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function $52373a21d9cd00c8$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const $52373a21d9cd00c8$var$wrappedFibers = [];
function $52373a21d9cd00c8$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($52373a21d9cd00c8$var$wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method)=>{
            const fn = obj[method];
            obj[method] = function() {
                return $52373a21d9cd00c8$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $52373a21d9cd00c8$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}


const $f7b1b945496fd368$export$11fa9682b6ba79b1 = new (0, $5fdbf93429dbc742$export$8c6ed5c666ac1360)();
function $f7b1b945496fd368$export$d906efd39458576(fn) {
    return $f7b1b945496fd368$export$11fa9682b6ba79b1.withValue(void 0, fn);
}


const { hasOwnProperty: $79e1376ebe8e4ec3$export$5a15a386532a5ea4 } = Object.prototype;
const $79e1376ebe8e4ec3$export$1eb72f2488cedd93 = Array.from || function(set) {
    const array = [];
    set.forEach((item)=>array.push(item));
    return array;
};
function $79e1376ebe8e4ec3$export$50527b97338c0f71(entryOrDep) {
    const { unsubscribe: unsubscribe } = entryOrDep;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}


const $d6a8d25937b5e8a9$var$emptySetPool = [];
const $d6a8d25937b5e8a9$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $d6a8d25937b5e8a9$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $d6a8d25937b5e8a9$var$valueIs(a, b) {
    const len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $d6a8d25937b5e8a9$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $d6a8d25937b5e8a9$var$valueCopy(value) {
    return value.slice(0);
}
class $d6a8d25937b5e8a9$export$3bb977b3ba9d3b59 {
    constructor(fn){
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++$d6a8d25937b5e8a9$export$3bb977b3ba9d3b59.count;
    }
    peek() {
        if (this.value.length === 1 && !$d6a8d25937b5e8a9$var$mightBeDirty(this)) {
            $d6a8d25937b5e8a9$var$rememberParent(this);
            return this.value[0];
        }
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(args) {
        $d6a8d25937b5e8a9$var$assert(!this.recomputing, "already recomputing");
        $d6a8d25937b5e8a9$var$rememberParent(this);
        return $d6a8d25937b5e8a9$var$mightBeDirty(this) ? $d6a8d25937b5e8a9$var$reallyRecompute(this, args) : $d6a8d25937b5e8a9$var$valueGet(this.value);
    }
    setDirty() {
        if (this.dirty) return;
        this.dirty = true;
        $d6a8d25937b5e8a9$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        (0, $79e1376ebe8e4ec3$export$50527b97338c0f71)(this);
    }
    dispose() {
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        $d6a8d25937b5e8a9$var$forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        $d6a8d25937b5e8a9$var$eachParent(this, (parent, child)=>{
            parent.setDirty();
            $d6a8d25937b5e8a9$var$forgetChild(parent, this);
        });
    }
    forget() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    }
    dependOn(dep) {
        dep.add(this);
        if (!this.deps) this.deps = $d6a8d25937b5e8a9$var$emptySetPool.pop() || new Set();
        this.deps.add(dep);
    }
    forgetDeps() {
        if (this.deps) {
            (0, $79e1376ebe8e4ec3$export$1eb72f2488cedd93)(this.deps).forEach((dep)=>dep.delete(this));
            this.deps.clear();
            $d6a8d25937b5e8a9$var$emptySetPool.push(this.deps);
            this.deps = null;
        }
    }
}
$d6a8d25937b5e8a9$export$3bb977b3ba9d3b59.count = 0;
function $d6a8d25937b5e8a9$var$rememberParent(child) {
    const parent = (0, $f7b1b945496fd368$export$11fa9682b6ba79b1).getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($d6a8d25937b5e8a9$var$mightBeDirty(child)) $d6a8d25937b5e8a9$var$reportDirtyChild(parent, child);
        else $d6a8d25937b5e8a9$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $d6a8d25937b5e8a9$var$reallyRecompute(entry, args) {
    $d6a8d25937b5e8a9$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    (0, $f7b1b945496fd368$export$11fa9682b6ba79b1).withValue(entry, $d6a8d25937b5e8a9$var$recomputeNewValue, [
        entry,
        args
    ]);
    if ($d6a8d25937b5e8a9$var$maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $d6a8d25937b5e8a9$var$setClean(entry);
    return $d6a8d25937b5e8a9$var$valueGet(entry.value);
}
function $d6a8d25937b5e8a9$var$recomputeNewValue(entry, args) {
    entry.recomputing = true;
    const { normalizeResult: normalizeResult } = entry;
    let oldValueCopy;
    if (normalizeResult && entry.value.length === 1) oldValueCopy = $d6a8d25937b5e8a9$var$valueCopy(entry.value);
    // Make entry.value an empty array, representing an unknown value.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
        // If we have a viable oldValueCopy to compare with the (successfully
        // recomputed) new entry.value, and they are not already === identical, give
        // normalizeResult a chance to pick/choose/reuse parts of oldValueCopy[0]
        // and/or entry.value[0] to determine the final cached entry.value.
        if (normalizeResult && oldValueCopy && !$d6a8d25937b5e8a9$var$valueIs(oldValueCopy, entry.value)) try {
            entry.value[0] = normalizeResult(entry.value[0], oldValueCopy[0]);
        } catch (_a) {
        // If normalizeResult throws, just use the newer value, rather than
        // saving the exception as entry.value[1].
        }
    } catch (e) {
        // If entry.fn throws, entry.value will hold that exception.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $d6a8d25937b5e8a9$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $d6a8d25937b5e8a9$var$setClean(entry) {
    entry.dirty = false;
    if ($d6a8d25937b5e8a9$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $d6a8d25937b5e8a9$var$reportClean(entry);
}
function $d6a8d25937b5e8a9$var$reportDirty(child) {
    $d6a8d25937b5e8a9$var$eachParent(child, $d6a8d25937b5e8a9$var$reportDirtyChild);
}
function $d6a8d25937b5e8a9$var$reportClean(child) {
    $d6a8d25937b5e8a9$var$eachParent(child, $d6a8d25937b5e8a9$var$reportCleanChild);
}
function $d6a8d25937b5e8a9$var$eachParent(child, callback) {
    const parentCount = child.parents.size;
    if (parentCount) {
        const parents = (0, $79e1376ebe8e4ec3$export$1eb72f2488cedd93)(child.parents);
        for(let i = 0; i < parentCount; ++i)callback(parents[i], child);
    }
}
// Let a parent Entry know that one of its children may be dirty.
function $d6a8d25937b5e8a9$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $d6a8d25937b5e8a9$var$assert(parent.childValues.has(child));
    $d6a8d25937b5e8a9$var$assert($d6a8d25937b5e8a9$var$mightBeDirty(child));
    const parentWasClean = !$d6a8d25937b5e8a9$var$mightBeDirty(parent);
    if (!parent.dirtyChildren) parent.dirtyChildren = $d6a8d25937b5e8a9$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) $d6a8d25937b5e8a9$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $d6a8d25937b5e8a9$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $d6a8d25937b5e8a9$var$assert(parent.childValues.has(child));
    $d6a8d25937b5e8a9$var$assert(!$d6a8d25937b5e8a9$var$mightBeDirty(child));
    const childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $d6a8d25937b5e8a9$var$valueCopy(child.value));
    else if (!$d6a8d25937b5e8a9$var$valueIs(childValue, child.value)) parent.setDirty();
    $d6a8d25937b5e8a9$var$removeDirtyChild(parent, child);
    if ($d6a8d25937b5e8a9$var$mightBeDirty(parent)) return;
    $d6a8d25937b5e8a9$var$reportClean(parent);
}
function $d6a8d25937b5e8a9$var$removeDirtyChild(parent, child) {
    const dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($d6a8d25937b5e8a9$var$emptySetPool.length < $d6a8d25937b5e8a9$var$POOL_TARGET_SIZE) $d6a8d25937b5e8a9$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function $d6a8d25937b5e8a9$var$forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach((_value, child)=>{
        $d6a8d25937b5e8a9$var$forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $d6a8d25937b5e8a9$var$assert(parent.dirtyChildren === null);
}
function $d6a8d25937b5e8a9$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $d6a8d25937b5e8a9$var$removeDirtyChild(parent, child);
}
function $d6a8d25937b5e8a9$var$maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        (0, $79e1376ebe8e4ec3$export$50527b97338c0f71)(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}





const $cd2cbff575a42bcb$var$EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true
};
function $cd2cbff575a42bcb$export$c723b7eff9d8f870(options) {
    const depsByKey = new Map();
    const subscribe = options && options.subscribe;
    function depend(key) {
        const parent = (0, $f7b1b945496fd368$export$11fa9682b6ba79b1).getValue();
        if (parent) {
            let dep = depsByKey.get(key);
            if (!dep) depsByKey.set(key, dep = new Set);
            parent.dependOn(dep);
            if (typeof subscribe === "function") {
                (0, $79e1376ebe8e4ec3$export$50527b97338c0f71)(dep);
                dep.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        const dep = depsByKey.get(key);
        if (dep) {
            const m = entryMethodName && (0, $79e1376ebe8e4ec3$export$5a15a386532a5ea4).call($cd2cbff575a42bcb$var$EntryMethods, entryMethodName) ? entryMethodName : "setDirty";
            // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
            // because modifying a Set while iterating over it can cause elements in
            // the Set to be removed from the Set before they've been iterated over.
            (0, $79e1376ebe8e4ec3$export$1eb72f2488cedd93)(dep).forEach((entry)=>entry[m]());
            depsByKey.delete(key);
            (0, $79e1376ebe8e4ec3$export$50527b97338c0f71)(dep);
        }
    };
    return depend;
}


// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
let $f07187d601866eca$var$defaultKeyTrie;
function $f07187d601866eca$export$cd3144f8dd136006(...args) {
    const trie = $f07187d601866eca$var$defaultKeyTrie || ($f07187d601866eca$var$defaultKeyTrie = new (0, $3fafa7abbadfcc3d$export$73571c50d0f2507e)(typeof WeakMap === "function"));
    return trie.lookupArray(args);
}
const $f07187d601866eca$var$caches = new Set();
function $f07187d601866eca$export$4997ffc0176396a6(originalFunction, { max: max = Math.pow(2, 16), keyArgs: keyArgs, makeCacheKey: makeCacheKey = $f07187d601866eca$export$cd3144f8dd136006, normalizeResult: normalizeResult, subscribe: subscribe, cache: cacheOption = (0, $272455ec0e5fd782$export$d3a0331d2c286dc8) } = Object.create(null)) {
    const cache = typeof cacheOption === "function" ? new cacheOption(max, (entry)=>entry.dispose()) : cacheOption;
    const optimistic = function() {
        const key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        let entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new (0, $d6a8d25937b5e8a9$export$3bb977b3ba9d3b59)(originalFunction));
            entry.normalizeResult = normalizeResult;
            entry.subscribe = subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = ()=>cache.delete(key);
        }
        const value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $f07187d601866eca$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!(0, $f7b1b945496fd368$export$11fa9682b6ba79b1).hasValue()) {
            $f07187d601866eca$var$caches.forEach((cache)=>cache.clean());
            $f07187d601866eca$var$caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: ()=>cache.size,
        configurable: false,
        enumerable: false
    });
    Object.freeze(optimistic.options = {
        max: max,
        keyArgs: keyArgs,
        makeCacheKey: makeCacheKey,
        normalizeResult: normalizeResult,
        subscribe: subscribe,
        cache: cache
    });
    function dirtyKey(key) {
        const entry = key && cache.get(key);
        if (entry) entry.setDirty();
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        const entry = key && cache.get(key);
        if (entry) return entry.peek();
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return key ? cache.delete(key) : false;
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}





function $a9a623faa62cac2b$var$identity(document) {
    return document;
}
class $a9a623faa62cac2b$export$f887060e48e5dc1b {
    transform;
    cached;
    resultCache = new WeakSet();
    // This default implementation of getCacheKey can be overridden by providing
    // options.getCacheKey to the DocumentTransform constructor. In general, a
    // getCacheKey function may either return an array of keys (often including
    // the document) to be used as a cache key, or undefined to indicate the
    // transform for this document should not be cached.
    getCacheKey(document) {
        return [
            document
        ];
    }
    /**
     * Creates a DocumentTransform that returns the input document unchanged.
     *
     * @returns The input document
     */ static identity() {
        // No need to cache this transform since it just returns the document
        // unchanged. This should save a bit of memory that would otherwise be
        // needed to populate the `documentCache` of this transform.
        return new $a9a623faa62cac2b$export$f887060e48e5dc1b($a9a623faa62cac2b$var$identity, {
            cache: false
        });
    }
    /**
     * Creates a DocumentTransform that conditionally applies one of two transforms.
     *
     * @param predicate - Function that determines which transform to apply
     * @param left - Transform to apply when `predicate` returns `true`
     * @param right - Transform to apply when `predicate` returns `false`. If not provided, it defaults to `DocumentTransform.identity()`.
     * @returns A DocumentTransform that conditionally applies a document transform based on the predicate
     *
     * @example
     *
     * ```ts
     * import { isQueryOperation } from "@apollo/client/utilities";
     *
     * const conditionalTransform = DocumentTransform.split(
     *   (document) => isQueryOperation(document),
     *   queryTransform,
     *   mutationTransform
     * );
     * ```
     */ static split(predicate, left, right = $a9a623faa62cac2b$export$f887060e48e5dc1b.identity()) {
        return Object.assign(new $a9a623faa62cac2b$export$f887060e48e5dc1b((document)=>{
            const documentTransform = predicate(document) ? left : right;
            return documentTransform.transformDocument(document);
        }, // Reasonably assume both `left` and `right` transforms handle their own caching
        {
            cache: false
        }), {
            left: left,
            right: right
        });
    }
    constructor(transform, options = {}){
        this.transform = transform;
        if (options.getCacheKey) // Override default `getCacheKey` function, which returns [document].
        this.getCacheKey = options.getCacheKey;
        this.cached = options.cache !== false;
        this.resetCache();
    }
    /**
     * Resets the internal cache of this transform, if it is cached.
     */ resetCache() {
        if (this.cached) {
            const stableCacheKeys = new (0, $3fafa7abbadfcc3d$export$73571c50d0f2507e)();
            this.performWork = (0, $f07187d601866eca$export$4997ffc0176396a6)($a9a623faa62cac2b$export$f887060e48e5dc1b.prototype.performWork.bind(this), {
                makeCacheKey: (document)=>{
                    const cacheKeys = this.getCacheKey(document);
                    if (cacheKeys) {
                        (0, $aa2d7231b5e28112$export$f5708dca728d7177)(Array.isArray(cacheKeys), 20);
                        return stableCacheKeys.lookupArray(cacheKeys);
                    }
                },
                max: (0, $9f7df0d640a1952d$export$f29926b23b28936b)["documentTransform.cache"],
                cache: (0, $07bddf69ae669f38$export$87b462129af3b7d4)
            });
        }
    }
    performWork(document) {
        (0, $2a4ebb84b536625f$export$a7d0d8111d2386df)(document);
        return this.transform(document);
    }
    /**
     * Transforms a GraphQL document using the configured transform function.
     *
     * @remarks
     *
     * Note that `transformDocument` caches the transformed document. Calling
     * `transformDocument` again with the already-transformed document will
     * immediately return it.
     *
     * @param document - The GraphQL document to transform
     * @returns The transformed document
     *
     * @example
     *
     * ```ts
     * const document = gql`
     *   # ...
     * `;
     *
     * const documentTransform = new DocumentTransform(transformFn);
     * const transformedDocument = documentTransform.transformDocument(document);
     * ```
     */ transformDocument(document) {
        // If a user passes an already transformed result back to this function,
        // immediately return it.
        if (this.resultCache.has(document)) return document;
        const transformedDocument = this.performWork(document);
        this.resultCache.add(transformedDocument);
        return transformedDocument;
    }
    /**
     * Combines this document transform with another document transform. The
     * returned document transform first applies the current document transform,
     * then applies the other document transform.
     *
     * @param otherTransform - The transform to apply after this one
     * @returns A new DocumentTransform that applies both transforms in sequence
     *
     * @example
     *
     * ```ts
     * const combinedTransform = addTypenameTransform.concat(
     *   removeDirectivesTransform
     * );
     * ```
     */ concat(otherTransform) {
        return Object.assign(new $a9a623faa62cac2b$export$f887060e48e5dc1b((document)=>{
            return otherTransform.transformDocument(this.transformDocument(document));
        }, // Reasonably assume both transforms handle their own caching
        {
            cache: false
        }), {
            left: this,
            right: otherTransform
        });
    }
    /**
    * @internal
    * Used to iterate through all transforms that are concatenations or `split` links.
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */ left;
    /**
    * @internal
    * Used to iterate through all transforms that are concatenations or `split` links.
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */ right;
}




var $k8Bfo = parcelRequire("k8Bfo");

var $k8Bfo = parcelRequire("k8Bfo");



var $6ff112babe86e29b$export$f708eee25634bc80 = (0, $140b8b2dd929bf6a$export$128a15b65d1b6041)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});




var $1e1b2aa6dbd14b53$export$b6bbab5a9b109038 = function(_super) {
    (0, $k8Bfo.__extends)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $1e1b2aa6dbd14b53$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $6ff112babe86e29b$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $d729478010e38fd5$export$d974811edc77eafa)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $k8Bfo.__values)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $d729478010e38fd5$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $d729478010e38fd5$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $effe293b9da5735b$export$610f9c3ca1a38dd8;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $effe293b9da5735b$export$f55210826850c514)(function() {
            _this.currentObservers = null;
            (0, $a0e9eed99caff378$export$dae3f38077fc36c0)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $23f68ab689e21470$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $1e1b2aa6dbd14b53$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $23f68ab689e21470$export$77cea355fa80b5f4));
var $1e1b2aa6dbd14b53$export$155189cde295587d = function(_super) {
    (0, $k8Bfo.__extends)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $effe293b9da5735b$export$610f9c3ca1a38dd8);
    };
    return AnonymousSubject;
}($1e1b2aa6dbd14b53$export$b6bbab5a9b109038);



var $de3901f1c29f38e2$export$915d2682b0aa0991 = function(_super) {
    (0, $k8Bfo.__extends)(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) _bufferSize = Infinity;
        if (_windowTime === void 0) _windowTime = Infinity;
        if (_timestampProvider === void 0) _timestampProvider = (0, $09b6be3211b47876$export$c1895ea2d519a677);
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function(value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for(var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2)subscriber.next(copy[i]);
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function() {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for(var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2)last = i;
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}((0, $1e1b2aa6dbd14b53$export$b6bbab5a9b109038));



var $k8Bfo = parcelRequire("k8Bfo");

var $k8Bfo = parcelRequire("k8Bfo");
var $6f93464aed3d2a83$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
};



function $4464c308aa9d0310$export$4369c812aac99591(value) {
    return (0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(value === null || value === void 0 ? void 0 : value.then);
}





function $0483f24a40a43075$export$48c0cddbc99c45c2(input) {
    return (0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(input[0, $60bbc08227059bad$export$5ab46cbf6120b33a]);
}



function $c87f3a8de5099275$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}


function $33762d0816d658b0$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}


function $41433876a4a41594$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) return '@@iterator';
    return Symbol.iterator;
}
var $41433876a4a41594$export$6f58e2338da23f4d = $41433876a4a41594$export$aa9956be4ae4fe8();



function $e518f435213a3a41$export$9652023d9040757(input) {
    return (0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(input === null || input === void 0 ? void 0 : input[0, $41433876a4a41594$export$6f58e2338da23f4d]);
}



var $k8Bfo = parcelRequire("k8Bfo");

function $9b6233124fad1237$export$cf4785e597badab3(readableStream) {
    return (0, $k8Bfo.__asyncGenerator)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $k8Bfo.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $k8Bfo.__await)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $k8Bfo.__await)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $k8Bfo.__await)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $9b6233124fad1237$export$c088ffafdba7405f(obj) {
    return (0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}





function $455ad6624f19614d$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $23f68ab689e21470$export$77cea355fa80b5f4)) return input;
    if (input != null) {
        if ((0, $0483f24a40a43075$export$48c0cddbc99c45c2)(input)) return $455ad6624f19614d$export$aa3d41784b3267fa(input);
        if ((0, $6f93464aed3d2a83$export$1e2f57719e155213)(input)) return $455ad6624f19614d$export$4cb2acdbcda2c253(input);
        if ((0, $4464c308aa9d0310$export$4369c812aac99591)(input)) return $455ad6624f19614d$export$60f45028237c39d1(input);
        if ((0, $c87f3a8de5099275$export$edb10ab8dd75a915)(input)) return $455ad6624f19614d$export$e073fccf36d78cc1(input);
        if ((0, $e518f435213a3a41$export$9652023d9040757)(input)) return $455ad6624f19614d$export$dcccc29c315dd646(input);
        if ((0, $9b6233124fad1237$export$c088ffafdba7405f)(input)) return $455ad6624f19614d$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $33762d0816d658b0$export$7cbe71b9fa263484)(input);
}
function $455ad6624f19614d$export$aa3d41784b3267fa(obj) {
    return new (0, $23f68ab689e21470$export$77cea355fa80b5f4)(function(subscriber) {
        var obs = obj[0, $60bbc08227059bad$export$5ab46cbf6120b33a]();
        if ((0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function $455ad6624f19614d$export$4cb2acdbcda2c253(array) {
    return new (0, $23f68ab689e21470$export$77cea355fa80b5f4)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $455ad6624f19614d$export$60f45028237c39d1(promise) {
    return new (0, $23f68ab689e21470$export$77cea355fa80b5f4)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $fbfcee34922855d4$export$ebf645db02d3e99f));
    });
}
function $455ad6624f19614d$export$dcccc29c315dd646(iterable) {
    return new (0, $23f68ab689e21470$export$77cea355fa80b5f4)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $k8Bfo.__values)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $455ad6624f19614d$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $23f68ab689e21470$export$77cea355fa80b5f4)(function(subscriber) {
        $455ad6624f19614d$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $455ad6624f19614d$export$b2dcb11d46e7a4ad(readableStream) {
    return $455ad6624f19614d$export$e073fccf36d78cc1((0, $9b6233124fad1237$export$cf4785e597badab3)(readableStream));
}
function $455ad6624f19614d$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $k8Bfo.__awaiter)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $k8Bfo.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $k8Bfo.__asyncValues)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}





function $590f717384cd71b5$export$ed80d9de1d9df928(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new (0, $1e1b2aa6dbd14b53$export$b6bbab5a9b109038)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, $beab12e89343bf23$export$871731df685d7753)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = $590f717384cd71b5$var$handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, $fbf2224f7546e2e1$export$94eeb6a328cab6c7)({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = $590f717384cd71b5$var$handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = $590f717384cd71b5$var$handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, $455ad6624f19614d$export$6a9cfa3ebc765910)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function $590f717384cd71b5$var$handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, $fbf2224f7546e2e1$export$94eeb6a328cab6c7)({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return (0, $455ad6624f19614d$export$6a9cfa3ebc765910)(on.apply(void 0, (0, $k8Bfo.__spreadArray)([], (0, $k8Bfo.__read)(args)))).subscribe(onSubscriber);
}


function $2a32ac76ac1a6174$export$db61d692014e534e(configOrBufferSize, windowTime, scheduler) {
    var _a, _b, _c;
    var bufferSize;
    var refCount = false;
    if (configOrBufferSize && typeof configOrBufferSize === 'object') _a = configOrBufferSize.bufferSize, bufferSize = _a === void 0 ? Infinity : _a, _b = configOrBufferSize.windowTime, windowTime = _b === void 0 ? Infinity : _b, _c = configOrBufferSize.refCount, refCount = _c === void 0 ? false : _c, scheduler = configOrBufferSize.scheduler;
    else bufferSize = configOrBufferSize !== null && configOrBufferSize !== void 0 ? configOrBufferSize : Infinity;
    return (0, $590f717384cd71b5$export$ed80d9de1d9df928)({
        connector: function() {
            return new (0, $de3901f1c29f38e2$export$915d2682b0aa0991)(bufferSize, windowTime, scheduler);
        },
        resetOnError: true,
        resetOnComplete: false,
        resetOnRefCountZero: refCount
    });
}



function $85e8597b5615b1c6$var$mapObservableFragment(observable, mapFn) {
    let currentResult;
    let stableMappedResult;
    function toMapped(result) {
        if (result !== currentResult) {
            currentResult = result;
            stableMappedResult = mapFn(currentResult);
        }
        return stableMappedResult;
    }
    return Object.assign(observable.pipe((0, $6175481c6b9a1949$export$871de8747c9eaa88)(toMapped), (0, $2a32ac76ac1a6174$export$db61d692014e534e)({
        bufferSize: 1,
        refCount: true
    })), {
        getCurrentResult: ()=>toMapped(observable.getCurrentResult())
    });
}
const $85e8597b5615b1c6$export$17d87cebd0a0465a = (0, $c1a63f9e5855cc0e$export$fc10aeed3a532e2a)(function mapObservableFragmentMemoized(observable, /**
 * used together with `observable` as memoization key, `mapFn` is explicitly not used as memoization key
 */ _cacheKey, mapFn) {
    return $85e8597b5615b1c6$var$mapObservableFragment(observable, mapFn);
}, {
    max: 1,
    makeCacheKey: (args)=>args.slice(0, 2)
});


function $e3b29cddc6a2eb6b$export$9e00fc5e314cda67(document) {
    return (0, $cd2396bbf46089ba$export$bf638b60ea8b89b7)(document, {
        FragmentSpread (node) {
            if (!node.directives?.some(({ name: name })=>name.value === "unmask")) return null;
        }
    });
}









function $35e2765fba36ce76$export$3dede90624df3ba9(selector) {
    return (0, $beab12e89343bf23$export$871731df685d7753)(function(source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe((0, $da8da925672b7eb3$export$b9e075132cc6937f)(subscriber, undefined, undefined, function(err) {
            handledResult = (0, $455ad6624f19614d$export$6a9cfa3ebc765910)(selector(err, $35e2765fba36ce76$export$3dede90624df3ba9(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            } else syncUnsub = true;
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}







function $a0df1aa2e38f88b6$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $455ad6624f19614d$export$6a9cfa3ebc765910)(project(value, index++)).subscribe((0, $da8da925672b7eb3$export$b9e075132cc6937f)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $617f62038feacfbb$export$a2b7447487315232)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $da8da925672b7eb3$export$b9e075132cc6937f)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}



function $c0e80712e8b0e00e$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(resultSelector)) return $c0e80712e8b0e00e$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $6175481c6b9a1949$export$871de8747c9eaa88)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $455ad6624f19614d$export$6a9cfa3ebc765910)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === 'number') concurrent = resultSelector;
    return (0, $beab12e89343bf23$export$871731df685d7753)(function(source, subscriber) {
        return (0, $a0df1aa2e38f88b6$export$600918ebaa9e0a1b)(source, subscriber, project, concurrent);
    });
}



function $e839a6f8a394d2ce$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $c0e80712e8b0e00e$export$6b9f6c0d32c093f9)((0, $c1a8806d0be82246$export$f0954fd7d5368655), concurrent);
}


function $1e46ea4ab2d16ead$export$b314777ae20abca9() {
    return (0, $e839a6f8a394d2ce$export$18aef43295bbe906)(1);
}




function $87b0ea8f3c2dacce$export$187e35932e88c15c(value) {
    return value && (0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(value.schedule);
}


function $9581faeb264c8615$var$last(arr) {
    return arr[arr.length - 1];
}
function $9581faeb264c8615$export$9ae19b645239a61b(args) {
    return (0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)($9581faeb264c8615$var$last(args)) ? args.pop() : undefined;
}
function $9581faeb264c8615$export$29534b2f653ae592(args) {
    return (0, $87b0ea8f3c2dacce$export$187e35932e88c15c)($9581faeb264c8615$var$last(args)) ? args.pop() : undefined;
}
function $9581faeb264c8615$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $9581faeb264c8615$var$last(args) === 'number' ? args.pop() : defaultValue;
}





function $800b424d9e719252$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $beab12e89343bf23$export$871731df685d7753)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}


function $de5940dbebf8c90b$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $455ad6624f19614d$export$6a9cfa3ebc765910)(input).pipe((0, $800b424d9e719252$export$1eb44d8f5f64733b)(scheduler), (0, $cfb9afa60710a0f8$export$9007f49c319d1ac7)(scheduler));
}





function $8efc3301aca6a706$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $455ad6624f19614d$export$6a9cfa3ebc765910)(input).pipe((0, $800b424d9e719252$export$1eb44d8f5f64733b)(scheduler), (0, $cfb9afa60710a0f8$export$9007f49c319d1ac7)(scheduler));
}



function $a0a1067c4bcb9efe$export$b34673931371729a(input, scheduler) {
    return new (0, $23f68ab689e21470$export$77cea355fa80b5f4)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}






function $1e748a7199298ccb$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $23f68ab689e21470$export$77cea355fa80b5f4)(function(subscriber) {
        var iterator;
        (0, $617f62038feacfbb$export$a2b7447487315232)(subscriber, scheduler, function() {
            iterator = input[0, $41433876a4a41594$export$6f58e2338da23f4d]();
            (0, $617f62038feacfbb$export$a2b7447487315232)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}




function $7ae3b641e3c16fc7$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error('Iterable cannot be null');
    return new (0, $23f68ab689e21470$export$77cea355fa80b5f4)(function(subscriber) {
        (0, $617f62038feacfbb$export$a2b7447487315232)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $617f62038feacfbb$export$a2b7447487315232)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}











function $c40d20d3dbe104db$export$3385251aeecad28a(input, scheduler) {
    return (0, $7ae3b641e3c16fc7$export$7c7f0979b56a32f3)((0, $9b6233124fad1237$export$cf4785e597badab3)(input), scheduler);
}


function $80c8df291893de9a$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $0483f24a40a43075$export$48c0cddbc99c45c2)(input)) return (0, $de5940dbebf8c90b$export$ed8bd553a12b6a30)(input, scheduler);
        if ((0, $6f93464aed3d2a83$export$1e2f57719e155213)(input)) return (0, $a0a1067c4bcb9efe$export$b34673931371729a)(input, scheduler);
        if ((0, $4464c308aa9d0310$export$4369c812aac99591)(input)) return (0, $8efc3301aca6a706$export$fc9afd948577f0a8)(input, scheduler);
        if ((0, $c87f3a8de5099275$export$edb10ab8dd75a915)(input)) return (0, $7ae3b641e3c16fc7$export$7c7f0979b56a32f3)(input, scheduler);
        if ((0, $e518f435213a3a41$export$9652023d9040757)(input)) return (0, $1e748a7199298ccb$export$2b75c58ab9b5b766)(input, scheduler);
        if ((0, $9b6233124fad1237$export$c088ffafdba7405f)(input)) return (0, $c40d20d3dbe104db$export$3385251aeecad28a)(input, scheduler);
    }
    throw (0, $33762d0816d658b0$export$7cbe71b9fa263484)(input);
}



function $b728d3864a499415$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $80c8df291893de9a$export$49c44dfc2bb21d70)(input, scheduler) : (0, $455ad6624f19614d$export$6a9cfa3ebc765910)(input);
}


function $cc38c15a77ac39bb$export$ee1b3e54f0441b22() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, $1e46ea4ab2d16ead$export$b314777ae20abca9)()((0, $b728d3864a499415$export$6788812c4e6611e6)(args, (0, $9581faeb264c8615$export$29534b2f653ae592)(args)));
}


function $c62a4a145ab75d8d$export$578723aef62d92f5(callback) {
    return (0, $beab12e89343bf23$export$871731df685d7753)(function(source, subscriber) {
        try {
            source.subscribe(subscriber);
        } finally{
            subscriber.add(callback);
        }
    });
}


var $0e0f5f0ce96d4c74$export$78f6d1b1dbcda304 = (0, $140b8b2dd929bf6a$export$128a15b65d1b6041)(function(_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = 'EmptyError';
        this.message = 'no elements in sequence';
    };
});


function $01d747b2900d60bc$export$a175cc82f1f2275e(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function(resolve, reject) {
        var _hasValue = false;
        var _value;
        source.subscribe({
            next: function(value) {
                _value = value;
                _hasValue = true;
            },
            error: reject,
            complete: function() {
                if (_hasValue) resolve(_value);
                else if (hasConfig) resolve(config.defaultValue);
                else reject(new (0, $0e0f5f0ce96d4c74$export$78f6d1b1dbcda304)());
            }
        });
    });
}




function $fc97cbd9f73f00f0$export$ba255e9e49e00608() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $9581faeb264c8615$export$29534b2f653ae592)(args);
    return (0, $b728d3864a499415$export$6788812c4e6611e6)(args, scheduler);
}




function $22be27f2a763a155$export$8bf7aba4a9e09055(errorOrErrorFactory, scheduler) {
    var errorFactory = (0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(errorOrErrorFactory) ? errorOrErrorFactory : function() {
        return errorOrErrorFactory;
    };
    var init = function(subscriber) {
        return subscriber.error(errorFactory());
    };
    return new (0, $23f68ab689e21470$export$77cea355fa80b5f4)(scheduler ? function(subscriber) {
        return scheduler.schedule(init, 0, subscriber);
    } : init);
}



var $6b6bc1ef7482e0ae$export$f59c804e350a7a80;
(function(NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})($6b6bc1ef7482e0ae$export$f59c804e350a7a80 || ($6b6bc1ef7482e0ae$export$f59c804e350a7a80 = {}));
var $6b6bc1ef7482e0ae$export$14834abbfce3b8cd = function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    Notification.prototype.observe = function(observer) {
        return $6b6bc1ef7482e0ae$export$b7ed52a57c1cee9e(this, observer);
    };
    Notification.prototype.do = function(nextHandler, errorHandler, completeHandler) {
        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
        return kind === 'N' ? nextHandler === null || nextHandler === void 0 ? void 0 : nextHandler(value) : kind === 'E' ? errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(error) : completeHandler === null || completeHandler === void 0 ? void 0 : completeHandler();
    };
    Notification.prototype.accept = function(nextOrObserver, error, complete) {
        var _a;
        return (0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)((_a = nextOrObserver) === null || _a === void 0 ? void 0 : _a.next) ? this.observe(nextOrObserver) : this.do(nextOrObserver, error, complete);
    };
    Notification.prototype.toObservable = function() {
        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
        var result = kind === 'N' ? (0, $fc97cbd9f73f00f0$export$ba255e9e49e00608)(value) : kind === 'E' ? (0, $22be27f2a763a155$export$8bf7aba4a9e09055)(function() {
            return error;
        }) : kind === 'C' ? (0, $31cce697e13f76b3$export$ccb33e29d92c9a58) : 0;
        if (!result) throw new TypeError("Unexpected notification kind " + kind);
        return result;
    };
    Notification.createNext = function(value) {
        return new Notification('N', value);
    };
    Notification.createError = function(err) {
        return new Notification('E', undefined, err);
    };
    Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    return Notification;
}();
function $6b6bc1ef7482e0ae$export$b7ed52a57c1cee9e(notification, observer) {
    var _a, _b, _c;
    var _d = notification, kind = _d.kind, value = _d.value, error = _d.error;
    if (typeof kind !== 'string') throw new TypeError('Invalid notification, missing "kind"');
    kind === 'N' ? (_a = observer.next) === null || _a === void 0 || _a.call(observer, value) : kind === 'E' ? (_b = observer.error) === null || _b === void 0 || _b.call(observer, error) : (_c = observer.complete) === null || _c === void 0 || _c.call(observer);
}




function $76ba9b8f04580447$export$76dbd6ffd832405d() {
    return (0, $beab12e89343bf23$export$871731df685d7753)(function(source, subscriber) {
        source.subscribe((0, $da8da925672b7eb3$export$b9e075132cc6937f)(subscriber, function(value) {
            subscriber.next((0, $6b6bc1ef7482e0ae$export$14834abbfce3b8cd).createNext(value));
        }, function() {
            subscriber.next((0, $6b6bc1ef7482e0ae$export$14834abbfce3b8cd).createComplete());
            subscriber.complete();
        }, function(err) {
            subscriber.next((0, $6b6bc1ef7482e0ae$export$14834abbfce3b8cd).createError(err));
            subscriber.complete();
        }));
    });
}





function $074c390243aea0da$export$3f23594af5f37336(observerOrNext, error, complete) {
    var tapObserver = (0, $15c7bfd29ceeeb4c$export$f6e2535fb5126e54)(observerOrNext) || error || complete ? {
        next: observerOrNext,
        error: error,
        complete: complete
    } : observerOrNext;
    return tapObserver ? (0, $beab12e89343bf23$export$871731df685d7753)(function(source, subscriber) {
        var _a;
        (_a = tapObserver.subscribe) === null || _a === void 0 || _a.call(tapObserver);
        var isUnsub = true;
        source.subscribe((0, $da8da925672b7eb3$export$b9e075132cc6937f)(subscriber, function(value) {
            var _a;
            (_a = tapObserver.next) === null || _a === void 0 || _a.call(tapObserver, value);
            subscriber.next(value);
        }, function() {
            var _a;
            isUnsub = false;
            (_a = tapObserver.complete) === null || _a === void 0 || _a.call(tapObserver);
            subscriber.complete();
        }, function(err) {
            var _a;
            isUnsub = false;
            (_a = tapObserver.error) === null || _a === void 0 || _a.call(tapObserver, err);
            subscriber.error(err);
        }, function() {
            var _a, _b;
            if (isUnsub) (_a = tapObserver.unsubscribe) === null || _a === void 0 || _a.call(tapObserver);
            (_b = tapObserver.finalize) === null || _b === void 0 || _b.call(tapObserver);
        }));
    }) : (0, $c1a8806d0be82246$export$f0954fd7d5368655);
}



function $e43d6cbe4cd32846$export$e61b6fee0e5eed39(error, name) {
    return typeof error === "object" && error !== null && error[Symbol.for("apollo.error")] === name;
}
function $e43d6cbe4cd32846$export$96ff94e0adb1d772(error) {
    Object.defineProperty(error, Symbol.for("apollo.error"), {
        value: error.name,
        enumerable: false,
        writable: false,
        configurable: false
    });
}


function $47039b6dcaec9173$var$defaultFormatMessage(errors) {
    return errors// Handle non-spec-compliant servers: See #1185
    .filter((e)=>e).map((e)=>e.message || "Error message not found.").join("\n");
}
class $47039b6dcaec9173$export$c28d7b46cdb2b476 extends Error {
    /**
    * A method that determines whether an error is a `CombinedGraphQLErrors`
    * object. This method enables TypeScript to narrow the error type.
    * 
    * @example
    * 
    * ```ts
    * if (CombinedGraphQLErrors.is(error)) {
    *   // TypeScript now knows `error` is a `CombinedGraphQLErrors` object
    *   console.log(error.errors);
    * }
    * ```
    */ static is(error) {
        return (0, $e43d6cbe4cd32846$export$e61b6fee0e5eed39)(error, "CombinedGraphQLErrors");
    }
    /**
    * A function that formats the error message used for the error's `message`
    * property. Override this method to provide your own formatting.
    * 
    * @remarks
    * 
    * The `formatMessage` function is called by the `CombinedGraphQLErrors`
    * constructor to provide a formatted message as the `message` property of the
    * `CombinedGraphQLErrors` object. Follow the ["Providing a custom message
    * formatter"](https://www.apollographql.com/docs/react/api/errors/CombinedGraphQLErrors#providing-a-custom-message-formatter) guide to learn how to modify the message format.
    * 
    * @param errors - The array of GraphQL errors returned from the server in
    * the `errors` field of the response.
    * @param options - Additional context that could be useful when formatting
    * the message.
    */ static formatMessage = $47039b6dcaec9173$var$defaultFormatMessage;
    /**
    * The raw list of GraphQL errors returned by the `errors` field in the GraphQL response.
    */ errors;
    /**
    * Partial data returned in the `data` field of the GraphQL response.
    */ data;
    /**
    * Extensions returned by the `extensions` field in the GraphQL response.
    */ extensions;
    constructor(result, errors = result.errors || []){
        super($47039b6dcaec9173$export$c28d7b46cdb2b476.formatMessage(errors, {
            result: result,
            defaultFormatMessage: $47039b6dcaec9173$var$defaultFormatMessage
        }));
        this.errors = errors;
        this.data = result.data;
        this.extensions = result.extensions;
        this.name = "CombinedGraphQLErrors";
        (0, $e43d6cbe4cd32846$export$96ff94e0adb1d772)(this);
        Object.setPrototypeOf(this, $47039b6dcaec9173$export$c28d7b46cdb2b476.prototype);
    }
}


function $b3091290e5c54aca$var$defaultFormatMessage(errors) {
    return errors.map((e)=>e.message || "Error message not found.").join("\n");
}
class $b3091290e5c54aca$export$efe656d729cf89ca extends Error {
    /**
     * A method that determines whether an error is a `CombinedProtocolErrors`
     * object. This method enables TypeScript to narrow the error type.
     *
     * @example
     *
     * ```ts
     * if (CombinedProtocolErrors.is(error)) {
     *   // TypeScript now knows `error` is a CombinedProtocolErrors object
     *   console.log(error.errors);
     * }
     * ```
     */ static is(error) {
        return (0, $e43d6cbe4cd32846$export$e61b6fee0e5eed39)(error, "CombinedProtocolErrors");
    }
    /**
    * A function that formats the error message used for the error's `message`
    * property. Override this method to provide your own formatting.
    * 
    * @remarks
    * 
    * The `formatMessage` function is called by the `CombinedProtocolErrors`
    * constructor to provide a formatted message as the `message` property of the
    * `CombinedProtocolErrors` object. Follow the ["Providing a custom message
    * formatter"](https://www.apollographql.com/docs/react/api/errors/CombinedProtocolErrors#providing-a-custom-message-formatter) guide to learn how to modify the message format.
    * 
    * @param errors - The array of GraphQL errors returned from the server in the
    * `errors` field of the response.
    * @param options - Additional context that could be useful when formatting
    * the message.
    */ static formatMessage = $b3091290e5c54aca$var$defaultFormatMessage;
    /**
    * The raw list of errors returned by the top-level `errors` field in the
    * multipart HTTP subscription response.
    */ errors;
    constructor(protocolErrors){
        super($b3091290e5c54aca$export$efe656d729cf89ca.formatMessage(protocolErrors, {
            defaultFormatMessage: $b3091290e5c54aca$var$defaultFormatMessage
        }));
        this.name = "CombinedProtocolErrors";
        this.errors = protocolErrors;
        (0, $e43d6cbe4cd32846$export$96ff94e0adb1d772)(this);
        Object.setPrototypeOf(this, $b3091290e5c54aca$export$efe656d729cf89ca.prototype);
    }
}


function $39fa6e3f72b21e8a$export$7713bb8b33f5c3c9(error) {
    return error !== null && typeof error === "object" && typeof error.message === "string" && typeof error.name === "string" && (typeof error.stack === "string" || typeof error.stack === "undefined");
}



class $b4543246f46cd8ec$export$ce3dd09f702cbf6c extends Error {
    /**
     * A method that determines whether an error is an `UnconventionalError`
     * object. This method enables TypeScript to narrow the error type.
     *
     * @example
     *
     * ```ts
     * if (UnconventionalError.is(error)) {
     *   // TypeScript now knows `error` is a UnconventionalError object
     *   console.log("What caused this?", error.cause);
     * }
     * ```
     */ static is(error) {
        return (0, $e43d6cbe4cd32846$export$e61b6fee0e5eed39)(error, "UnconventionalError");
    }
    constructor(errorType){
        super("An error of unexpected shape occurred.", {
            cause: errorType
        });
        this.name = "UnconventionalError";
        (0, $e43d6cbe4cd32846$export$96ff94e0adb1d772)(this);
        Object.setPrototypeOf(this, $b4543246f46cd8ec$export$ce3dd09f702cbf6c.prototype);
    }
}



const $a3bc43cc34afd4db$var$registry = new WeakSet();
function $a3bc43cc34afd4db$export$1ef81dbee0dd241d(error) {
    $a3bc43cc34afd4db$var$registry.add(error);
}
const $a3bc43cc34afd4db$export$d0a452ab7a9d9f73 = {
    /**
     * A method that determines whether an error originated from the link chain.
     * `is` does not provide any type narrowing.
     *
     * @example
     *
     * ```ts
     * if (LinkError.is(error)) {
     *   // The error originated from the link chain
     *   console.log("Got network error:", error.message);
     * }
     * ```
     */ is: (error)=>$a3bc43cc34afd4db$var$registry.has(error)
};




class $0038b7d5404f1ede$export$ea52035eac03daf0 extends Error {
    /**
     * A method that determines whether an error is a `ServerError` object. This
     * method enables TypeScript to narrow the error type.
     *
     * @example
     *
     * ```ts
     * if (ServerError.is(error)) {
     *   // TypeScript now knows `error` is a ServerError object
     *   console.log(error.errors);
     * }
     * ```
     */ static is(error) {
        return (0, $e43d6cbe4cd32846$export$e61b6fee0e5eed39)(error, "ServerError");
    }
    /**
    * The raw [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response) object provided by the [Fetch API](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
    */ response;
    /**
    * The status code returned by the server in the response. This is provided as
    * a shortcut for `response.status`.
    */ statusCode;
    /**
    * The raw response body text.
    */ bodyText;
    constructor(message, options){
        super(message);
        this.name = "ServerError";
        this.response = options.response;
        this.statusCode = options.response.status;
        this.bodyText = options.bodyText;
        (0, $e43d6cbe4cd32846$export$96ff94e0adb1d772)(this);
        Object.setPrototypeOf(this, $0038b7d5404f1ede$export$ea52035eac03daf0.prototype);
    }
}



class $afdacda929502087$export$2b2913ac6c4db8e6 extends Error {
    /**
     * A method that determines whether an error is a `ServerParseError`
     * object. This method enables TypeScript to narrow the error type.
     *
     * @example
     *
     * ```ts
     * if (ServerParseError.is(error)) {
     *   // TypeScript now knows `error` is a ServerParseError object
     *   console.log(error.statusCode);
     * }
     * ```
     */ static is(error) {
        return (0, $e43d6cbe4cd32846$export$e61b6fee0e5eed39)(error, "ServerParseError");
    }
    /**
    * The raw [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response) object provided by the [Fetch API](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
    */ response;
    /**
    * The status code returned by the server in the response. This is provided
    * as a shortcut for `response.status`.
    */ statusCode;
    /**
    * The raw response body text.
    */ bodyText;
    constructor(originalParseError, options){
        super(originalParseError instanceof Error ? originalParseError.message : "Could not parse server response", {
            cause: originalParseError
        });
        this.name = "ServerParseError";
        this.response = options.response;
        this.statusCode = options.response.status;
        this.bodyText = options.bodyText;
        (0, $e43d6cbe4cd32846$export$96ff94e0adb1d772)(this);
        Object.setPrototypeOf(this, $afdacda929502087$export$2b2913ac6c4db8e6.prototype);
    }
}


const $f1a9d96edac5fab2$export$4995664c1b49842e = Symbol();
function $f1a9d96edac5fab2$export$345f95cc6b6b9b0b(result) {
    if ("extensions" in result) return (0, $b3091290e5c54aca$export$efe656d729cf89ca).is(result.extensions[$f1a9d96edac5fab2$export$4995664c1b49842e]);
    return false;
}
function $f1a9d96edac5fab2$export$9ca5882e11f8e4c6(error) {
    if ((0, $39fa6e3f72b21e8a$export$7713bb8b33f5c3c9)(error)) return error;
    if (typeof error === "string") return new Error(error, {
        cause: error
    });
    return new (0, $b4543246f46cd8ec$export$ce3dd09f702cbf6c)(error);
}





/**
* Utility function that takes a list of fragment definitions and makes a hash out of them
* that maps the name of the fragment to the fragment definition.
*
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/ function $af06dc884b782fca$export$193789b4c8246dd4(fragments = []) {
    const symTable = {};
    fragments.forEach((fragment)=>{
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}

/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/ function $499d29b3c6f5bfa6$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter((definition)=>definition.kind === "FragmentDefinition");
}





/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/ function $6a5b17c6ecfc0cd4$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}







const $912b590fa3da2f6f$export$2ddf8815a8abe8b = new (0, $5fdbf93429dbc742$export$8c6ed5c666ac1360)();
function $912b590fa3da2f6f$export$d6913ace4214003(fragment) {
    const directive = fragment.directives?.find(({ name: name })=>name.value === "unmask");
    if (!directive) return "mask";
    const modeArg = directive.arguments?.find(({ name: name })=>name.value === "mode");
    if (0, $e15192e15b3ad6c1$export$a866f231438cc228) {
        if (modeArg) {
            if (modeArg.value.kind === (0, $324243985983b985$export$a84bdc57c5122798).VARIABLE) (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).warn(44);
            else if (modeArg.value.kind !== (0, $324243985983b985$export$a84bdc57c5122798).STRING) (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).warn(45);
            else if (modeArg.value.value !== "migrate") (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).warn(46, modeArg.value.value);
        }
    }
    if (modeArg && "value" in modeArg.value && modeArg.value.value === "migrate") return "migrate";
    return "unmask";
}


function $cd9028680a630b5e$export$d4ee6fea56447c82(data, selectionSet, context) {
    return (0, $912b590fa3da2f6f$export$2ddf8815a8abe8b).withValue(true, ()=>{
        const masked = $cd9028680a630b5e$var$maskSelectionSet(data, selectionSet, context, false);
        if (Object.isFrozen(data)) (0, $4f666ffbf7bc8e40$export$7f9c177735b71f18)(masked);
        return masked;
    });
}
function $cd9028680a630b5e$var$getMutableTarget(data, mutableTargets) {
    if (mutableTargets.has(data)) return mutableTargets.get(data);
    const mutableTarget = Array.isArray(data) ? [] : {};
    mutableTargets.set(data, mutableTarget);
    return mutableTarget;
}
function $cd9028680a630b5e$var$maskSelectionSet(data, selectionSet, context, migration, path) {
    const { knownChanged: knownChanged } = context;
    const memo = $cd9028680a630b5e$var$getMutableTarget(data, context.mutableTargets);
    if (Array.isArray(data)) {
        for (const [index, item] of Array.from(data.entries())){
            if (item === null) {
                memo[index] = null;
                continue;
            }
            const masked = $cd9028680a630b5e$var$maskSelectionSet(item, selectionSet, context, migration, (0, $e15192e15b3ad6c1$export$a866f231438cc228) ? `${path || ""}[${index}]` : void 0);
            if (knownChanged.has(masked)) knownChanged.add(memo);
            memo[index] = masked;
        }
        return knownChanged.has(memo) ? memo : data;
    }
    for (const selection of selectionSet.selections){
        let value;
        // we later want to add accessor warnings to the final result
        // so we need a new object to add the accessor warning to
        if (migration) knownChanged.add(memo);
        if (selection.kind === (0, $324243985983b985$export$a84bdc57c5122798).FIELD) {
            const keyName = (0, $6a5b17c6ecfc0cd4$export$7d1ad22471852218)(selection);
            const childSelectionSet = selection.selectionSet;
            value = memo[keyName] || data[keyName];
            if (value === void 0) continue;
            if (childSelectionSet && value !== null) {
                const masked = $cd9028680a630b5e$var$maskSelectionSet(data[keyName], childSelectionSet, context, migration, (0, $e15192e15b3ad6c1$export$a866f231438cc228) ? `${path || ""}.${keyName}` : void 0);
                if (knownChanged.has(masked)) value = masked;
            }
            if (!(0, $e15192e15b3ad6c1$export$a866f231438cc228)) memo[keyName] = value;
            if (0, $e15192e15b3ad6c1$export$a866f231438cc228) {
                if (migration && keyName !== "__typename" && // either the field is not present in the memo object
                // or it has a `get` descriptor, not a `value` descriptor
                // => it is a warning accessor and we can overwrite it
                // with another accessor
                !Object.getOwnPropertyDescriptor(memo, keyName)?.value) Object.defineProperty(memo, keyName, $cd9028680a630b5e$var$getAccessorWarningDescriptor(keyName, value, path || "", context.operationName, context.operationType));
                else {
                    delete memo[keyName];
                    memo[keyName] = value;
                }
            }
        }
        if (selection.kind === (0, $324243985983b985$export$a84bdc57c5122798).INLINE_FRAGMENT && (!selection.typeCondition || context.cache.fragmentMatches(selection, data.__typename))) value = $cd9028680a630b5e$var$maskSelectionSet(data, selection.selectionSet, context, migration, path);
        if (selection.kind === (0, $324243985983b985$export$a84bdc57c5122798).FRAGMENT_SPREAD) {
            const fragmentName = selection.name.value;
            const fragment = context.fragmentMap[fragmentName] || (context.fragmentMap[fragmentName] = context.cache.lookupFragment(fragmentName));
            (0, $aa2d7231b5e28112$export$f5708dca728d7177)(fragment, 39, fragmentName);
            const mode = (0, $912b590fa3da2f6f$export$d6913ace4214003)(selection);
            if (mode !== "mask") value = $cd9028680a630b5e$var$maskSelectionSet(data, fragment.selectionSet, context, mode === "migrate", path);
        }
        if (knownChanged.has(value)) knownChanged.add(memo);
    }
    if ("__typename" in data && !("__typename" in memo)) memo.__typename = data.__typename;
    // This check prevents cases where masked fields may accidentally be
    // returned as part of this object when the fragment also selects
    // additional fields from the same child selection.
    if (Object.keys(memo).length !== Object.keys(data).length) knownChanged.add(memo);
    return knownChanged.has(memo) ? memo : data;
}
function $cd9028680a630b5e$var$getAccessorWarningDescriptor(fieldName, value, path, operationName, operationType) {
    let getValue = ()=>{
        if ((0, $912b590fa3da2f6f$export$2ddf8815a8abe8b).getValue()) return value;
        (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).warn(40, operationName ? `${operationType} '${operationName}'` : `anonymous ${operationType}`, `${path}.${fieldName}`.replace(/^\./, ""));
        getValue = ()=>value;
        return value;
    };
    return {
        get () {
            return getValue();
        },
        set (newValue) {
            getValue = ()=>newValue;
        },
        enumerable: true,
        configurable: true
    };
}


function $91cd43a9c338b9c0$export$adbebb59d1aeea97(data, document, cache, fragmentName) {
    const fragments = document.definitions.filter((node)=>node.kind === (0, $324243985983b985$export$a84bdc57c5122798).FRAGMENT_DEFINITION);
    if (typeof fragmentName === "undefined") {
        (0, $aa2d7231b5e28112$export$f5708dca728d7177)(fragments.length === 1, 41, fragments.length);
        fragmentName = fragments[0].name.value;
    }
    const fragment = fragments.find((fragment)=>fragment.name.value === fragmentName);
    (0, $aa2d7231b5e28112$export$f5708dca728d7177)(!!fragment, 42, fragmentName);
    if (data == null) // Maintain the original `null` or `undefined` value
    return data;
    if ((0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(data, {})) // Return early and skip the masking algorithm if we don't have any data
    // yet. This can happen when cache.diff returns an empty object which is
    // used from watchFragment.
    return data;
    return (0, $cd9028680a630b5e$export$d4ee6fea56447c82)(data, fragment.selectionSet, {
        operationType: "fragment",
        operationName: fragment.name.value,
        fragmentMap: (0, $af06dc884b782fca$export$193789b4c8246dd4)((0, $499d29b3c6f5bfa6$export$5320a7ba9466a3df)(document)),
        cache: cache,
        mutableTargets: new WeakMap(),
        knownChanged: new WeakSet()
    });
}




function $032a43dadd6a478b$export$74a61e4252a4a2ef(data, document, cache) {
    const definition = (0, $bfe912ade316f216$export$7a5b1fa979d2c158)(document);
    (0, $aa2d7231b5e28112$export$f5708dca728d7177)(definition, 43);
    if (data == null) // Maintain the original `null` or `undefined` value
    return data;
    return (0, $cd9028680a630b5e$export$d4ee6fea56447c82)(data, definition.selectionSet, {
        operationType: definition.operation,
        operationName: definition.name?.value,
        fragmentMap: (0, $af06dc884b782fca$export$193789b4c8246dd4)((0, $499d29b3c6f5bfa6$export$5320a7ba9466a3df)(document)),
        cache: cache,
        mutableTargets: new WeakMap(),
        knownChanged: new WeakSet()
    });
}


/**
 * Returns true if the network request is in ready or error state according to a given network
 * status.
 */ function $2143f5bfa0fc1fe2$export$427e8a52ef0f96e2(networkStatus) {
    return networkStatus === 7 || networkStatus === 8;
}


function $9311d187008787b8$export$37509604341a3464(networkStatus) {
    return !(0, $2143f5bfa0fc1fe2$export$427e8a52ef0f96e2)(networkStatus);
}


/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $f92a99ba8cb4dbd2$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($f92a99ba8cb4dbd2$var$escapedRegExp, $f92a99ba8cb4dbd2$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $f92a99ba8cb4dbd2$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $f92a99ba8cb4dbd2$var$escapedReplacer(str) {
    return $f92a99ba8cb4dbd2$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $f92a99ba8cb4dbd2$var$escapeSequences = [
    '\\u0000',
    '\\u0001',
    '\\u0002',
    '\\u0003',
    '\\u0004',
    '\\u0005',
    '\\u0006',
    '\\u0007',
    '\\b',
    '\\t',
    '\\n',
    '\\u000B',
    '\\f',
    '\\r',
    '\\u000E',
    '\\u000F',
    '\\u0010',
    '\\u0011',
    '\\u0012',
    '\\u0013',
    '\\u0014',
    '\\u0015',
    '\\u0016',
    '\\u0017',
    '\\u0018',
    '\\u0019',
    '\\u001A',
    '\\u001B',
    '\\u001C',
    '\\u001D',
    '\\u001E',
    '\\u001F',
    '',
    '',
    '\\"',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\\\',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\u007F',
    '\\u0080',
    '\\u0081',
    '\\u0082',
    '\\u0083',
    '\\u0084',
    '\\u0085',
    '\\u0086',
    '\\u0087',
    '\\u0088',
    '\\u0089',
    '\\u008A',
    '\\u008B',
    '\\u008C',
    '\\u008D',
    '\\u008E',
    '\\u008F',
    '\\u0090',
    '\\u0091',
    '\\u0092',
    '\\u0093',
    '\\u0094',
    '\\u0095',
    '\\u0096',
    '\\u0097',
    '\\u0098',
    '\\u0099',
    '\\u009A',
    '\\u009B',
    '\\u009C',
    '\\u009D',
    '\\u009E',
    '\\u009F'
];



function $05cc42f5e21e370d$export$c2d084dc44961371(ast) {
    return (0, $cd2396bbf46089ba$export$bf638b60ea8b89b7)(ast, $05cc42f5e21e370d$var$printDocASTReducer);
}
const $05cc42f5e21e370d$var$MAX_LINE_LENGTH = 80;
const $05cc42f5e21e370d$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>'$' + node.name
    },
    // Document
    Document: {
        leave: (node)=>$05cc42f5e21e370d$var$join(node.definitions, '\n\n')
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $05cc42f5e21e370d$var$hasMultilineItems(node.variableDefinitions) ? $05cc42f5e21e370d$var$wrap('(\n', $05cc42f5e21e370d$var$join(node.variableDefinitions, '\n'), '\n)') : $05cc42f5e21e370d$var$wrap('(', $05cc42f5e21e370d$var$join(node.variableDefinitions, ', '), ')');
            const prefix = $05cc42f5e21e370d$var$wrap('', node.description, '\n') + $05cc42f5e21e370d$var$join([
                node.operation,
                $05cc42f5e21e370d$var$join([
                    node.name,
                    varDefs
                ]),
                $05cc42f5e21e370d$var$join(node.directives, ' ')
            ], ' '); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives, description: description })=>$05cc42f5e21e370d$var$wrap('', description, '\n') + variable + ': ' + type + $05cc42f5e21e370d$var$wrap(' = ', defaultValue) + $05cc42f5e21e370d$var$wrap(' ', $05cc42f5e21e370d$var$join(directives, ' '))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$05cc42f5e21e370d$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $05cc42f5e21e370d$var$wrap('', alias, ': ') + name;
            let argsLine = prefix + $05cc42f5e21e370d$var$wrap('(', $05cc42f5e21e370d$var$join(args, ', '), ')');
            if (argsLine.length > $05cc42f5e21e370d$var$MAX_LINE_LENGTH) argsLine = prefix + $05cc42f5e21e370d$var$wrap('(\n', $05cc42f5e21e370d$var$indent($05cc42f5e21e370d$var$join(args, '\n')), '\n)');
            return $05cc42f5e21e370d$var$join([
                argsLine,
                $05cc42f5e21e370d$var$join(directives, ' '),
                selectionSet
            ], ' ');
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>'...' + name + $05cc42f5e21e370d$var$wrap(' ', $05cc42f5e21e370d$var$join(directives, ' '))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$05cc42f5e21e370d$var$join([
                '...',
                $05cc42f5e21e370d$var$wrap('on ', typeCondition),
                $05cc42f5e21e370d$var$join(directives, ' '),
                selectionSet
            ], ' ')
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet, description: description })=>$05cc42f5e21e370d$var$wrap('', description, '\n') + // Note: fragment variable definitions are experimental and may be changed
            // or removed in the future.
            `fragment ${name}${$05cc42f5e21e370d$var$wrap('(', $05cc42f5e21e370d$var$join(variableDefinitions, ', '), ')')} ` + `on ${typeCondition} ${$05cc42f5e21e370d$var$wrap('', $05cc42f5e21e370d$var$join(directives, ' '), ' ')}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $cd2de6e6313a6d9b$export$adb6ca997eeb1f45)(value) : (0, $f92a99ba8cb4dbd2$export$3cdec7cf614a0ecc)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? 'true' : 'false'
    },
    NullValue: {
        leave: ()=>'null'
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>'[' + $05cc42f5e21e370d$var$join(values, ', ') + ']'
    },
    ObjectValue: {
        leave: ({ fields: fields })=>'{' + $05cc42f5e21e370d$var$join(fields, ', ') + '}'
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>'@' + name + $05cc42f5e21e370d$var$wrap('(', $05cc42f5e21e370d$var$join(args, ', '), ')')
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>'[' + type + ']'
    },
    NonNullType: {
        leave: ({ type: type })=>type + '!'
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$05cc42f5e21e370d$var$wrap('', description, '\n') + $05cc42f5e21e370d$var$join([
                'schema',
                $05cc42f5e21e370d$var$join(directives, ' '),
                $05cc42f5e21e370d$var$block(operationTypes)
            ], ' ')
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ': ' + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$05cc42f5e21e370d$var$wrap('', description, '\n') + $05cc42f5e21e370d$var$join([
                'scalar',
                name,
                $05cc42f5e21e370d$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$05cc42f5e21e370d$var$wrap('', description, '\n') + $05cc42f5e21e370d$var$join([
                'type',
                name,
                $05cc42f5e21e370d$var$wrap('implements ', $05cc42f5e21e370d$var$join(interfaces, ' & ')),
                $05cc42f5e21e370d$var$join(directives, ' '),
                $05cc42f5e21e370d$var$block(fields)
            ], ' ')
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$05cc42f5e21e370d$var$wrap('', description, '\n') + name + ($05cc42f5e21e370d$var$hasMultilineItems(args) ? $05cc42f5e21e370d$var$wrap('(\n', $05cc42f5e21e370d$var$indent($05cc42f5e21e370d$var$join(args, '\n')), '\n)') : $05cc42f5e21e370d$var$wrap('(', $05cc42f5e21e370d$var$join(args, ', '), ')')) + ': ' + type + $05cc42f5e21e370d$var$wrap(' ', $05cc42f5e21e370d$var$join(directives, ' '))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$05cc42f5e21e370d$var$wrap('', description, '\n') + $05cc42f5e21e370d$var$join([
                name + ': ' + type,
                $05cc42f5e21e370d$var$wrap('= ', defaultValue),
                $05cc42f5e21e370d$var$join(directives, ' ')
            ], ' ')
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$05cc42f5e21e370d$var$wrap('', description, '\n') + $05cc42f5e21e370d$var$join([
                'interface',
                name,
                $05cc42f5e21e370d$var$wrap('implements ', $05cc42f5e21e370d$var$join(interfaces, ' & ')),
                $05cc42f5e21e370d$var$join(directives, ' '),
                $05cc42f5e21e370d$var$block(fields)
            ], ' ')
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$05cc42f5e21e370d$var$wrap('', description, '\n') + $05cc42f5e21e370d$var$join([
                'union',
                name,
                $05cc42f5e21e370d$var$join(directives, ' '),
                $05cc42f5e21e370d$var$wrap('= ', $05cc42f5e21e370d$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$05cc42f5e21e370d$var$wrap('', description, '\n') + $05cc42f5e21e370d$var$join([
                'enum',
                name,
                $05cc42f5e21e370d$var$join(directives, ' '),
                $05cc42f5e21e370d$var$block(values)
            ], ' ')
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$05cc42f5e21e370d$var$wrap('', description, '\n') + $05cc42f5e21e370d$var$join([
                name,
                $05cc42f5e21e370d$var$join(directives, ' ')
            ], ' ')
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$05cc42f5e21e370d$var$wrap('', description, '\n') + $05cc42f5e21e370d$var$join([
                'input',
                name,
                $05cc42f5e21e370d$var$join(directives, ' '),
                $05cc42f5e21e370d$var$block(fields)
            ], ' ')
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$05cc42f5e21e370d$var$wrap('', description, '\n') + 'directive @' + name + ($05cc42f5e21e370d$var$hasMultilineItems(args) ? $05cc42f5e21e370d$var$wrap('(\n', $05cc42f5e21e370d$var$indent($05cc42f5e21e370d$var$join(args, '\n')), '\n)') : $05cc42f5e21e370d$var$wrap('(', $05cc42f5e21e370d$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $05cc42f5e21e370d$var$join(locations, ' | ')
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$05cc42f5e21e370d$var$join([
                'extend schema',
                $05cc42f5e21e370d$var$join(directives, ' '),
                $05cc42f5e21e370d$var$block(operationTypes)
            ], ' ')
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$05cc42f5e21e370d$var$join([
                'extend scalar',
                name,
                $05cc42f5e21e370d$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$05cc42f5e21e370d$var$join([
                'extend type',
                name,
                $05cc42f5e21e370d$var$wrap('implements ', $05cc42f5e21e370d$var$join(interfaces, ' & ')),
                $05cc42f5e21e370d$var$join(directives, ' '),
                $05cc42f5e21e370d$var$block(fields)
            ], ' ')
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$05cc42f5e21e370d$var$join([
                'extend interface',
                name,
                $05cc42f5e21e370d$var$wrap('implements ', $05cc42f5e21e370d$var$join(interfaces, ' & ')),
                $05cc42f5e21e370d$var$join(directives, ' '),
                $05cc42f5e21e370d$var$block(fields)
            ], ' ')
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$05cc42f5e21e370d$var$join([
                'extend union',
                name,
                $05cc42f5e21e370d$var$join(directives, ' '),
                $05cc42f5e21e370d$var$wrap('= ', $05cc42f5e21e370d$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$05cc42f5e21e370d$var$join([
                'extend enum',
                name,
                $05cc42f5e21e370d$var$join(directives, ' '),
                $05cc42f5e21e370d$var$block(values)
            ], ' ')
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$05cc42f5e21e370d$var$join([
                'extend input',
                name,
                $05cc42f5e21e370d$var$join(directives, ' '),
                $05cc42f5e21e370d$var$block(fields)
            ], ' ')
    },
    // Schema Coordinates
    TypeCoordinate: {
        leave: ({ name: name })=>name
    },
    MemberCoordinate: {
        leave: ({ name: name, memberName: memberName })=>$05cc42f5e21e370d$var$join([
                name,
                $05cc42f5e21e370d$var$wrap('.', memberName)
            ])
    },
    ArgumentCoordinate: {
        leave: ({ name: name, fieldName: fieldName, argumentName: argumentName })=>$05cc42f5e21e370d$var$join([
                name,
                $05cc42f5e21e370d$var$wrap('.', fieldName),
                $05cc42f5e21e370d$var$wrap('(', argumentName, ':)')
            ])
    },
    DirectiveCoordinate: {
        leave: ({ name: name })=>$05cc42f5e21e370d$var$join([
                '@',
                name
            ])
    },
    DirectiveArgumentCoordinate: {
        leave: ({ name: name, argumentName: argumentName })=>$05cc42f5e21e370d$var$join([
                '@',
                name,
                $05cc42f5e21e370d$var$wrap('(', argumentName, ':)')
            ])
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $05cc42f5e21e370d$var$join(maybeArray, separator = '') {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $05cc42f5e21e370d$var$block(array) {
    return $05cc42f5e21e370d$var$wrap('{\n', $05cc42f5e21e370d$var$indent($05cc42f5e21e370d$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $05cc42f5e21e370d$var$wrap(start, maybeString, end = '') {
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $05cc42f5e21e370d$var$indent(str) {
    return $05cc42f5e21e370d$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $05cc42f5e21e370d$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes('\n'))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}





let $a6091649f6831c1e$var$printCache;
const $a6091649f6831c1e$export$c2d084dc44961371 = Object.assign((ast)=>{
    let result = $a6091649f6831c1e$var$printCache.get(ast);
    if (!result) {
        result = (0, $05cc42f5e21e370d$export$c2d084dc44961371)(ast);
        $a6091649f6831c1e$var$printCache.set(ast, result);
    }
    return result;
}, {
    reset () {
        $a6091649f6831c1e$var$printCache = new (0, $1abac2280838e114$export$8dbad6f439bb2331)((0, $9f7df0d640a1952d$export$f29926b23b28936b).print || 2000 /* defaultCacheSizes.print */ );
    }
});
$a6091649f6831c1e$export$c2d084dc44961371.reset();
if (0, $e15192e15b3ad6c1$export$a866f231438cc228) (0, $0b54944ffd705e51$export$a8fcd406d9e37621)("print", ()=>$a6091649f6831c1e$var$printCache ? $a6091649f6831c1e$var$printCache.size : 0);




function $4b985f1bcf049783$export$a04c6c6965dd4709(fn, makeContext = ()=>undefined) {
    return (source)=>new (0, $23f68ab689e21470$export$77cea355fa80b5f4)((subscriber)=>{
            let context = makeContext();
            return source.subscribe({
                next (value) {
                    let result;
                    try {
                        result = fn(value, context);
                    } catch (e) {
                        subscriber.error(e);
                    }
                    if (result === undefined) return;
                    subscriber.next(result);
                },
                error (err) {
                    subscriber.error(err);
                },
                complete () {
                    subscriber.complete();
                }
            });
        });
}



function $cf7c3ff17e2ece79$export$a1dab82d368d6525(argObj, name, value, variables) {
    if (value.kind === (0, $324243985983b985$export$a84bdc57c5122798).INT || value.kind === (0, $324243985983b985$export$a84bdc57c5122798).FLOAT) argObj[name.value] = Number(value.value);
    else if (value.kind === (0, $324243985983b985$export$a84bdc57c5122798).BOOLEAN || value.kind === (0, $324243985983b985$export$a84bdc57c5122798).STRING) argObj[name.value] = value.value;
    else if (value.kind === (0, $324243985983b985$export$a84bdc57c5122798).OBJECT) {
        const nestedArgObj = {};
        value.fields.map((obj)=>$cf7c3ff17e2ece79$export$a1dab82d368d6525(nestedArgObj, obj.name, obj.value, variables));
        argObj[name.value] = nestedArgObj;
    } else if (value.kind === (0, $324243985983b985$export$a84bdc57c5122798).VARIABLE) {
        const variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if (value.kind === (0, $324243985983b985$export$a84bdc57c5122798).LIST) argObj[name.value] = value.values.map((listValue)=>{
        const nestedArgArrayObj = {};
        $cf7c3ff17e2ece79$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if (value.kind === (0, $324243985983b985$export$a84bdc57c5122798).ENUM) argObj[name.value] = value.value;
    else if (value.kind === (0, $324243985983b985$export$a84bdc57c5122798).NULL) argObj[name.value] = null;
    else throw (0, $aa2d7231b5e28112$export$3991762405098ea)(19, name.value, value.kind);
}


function $ff81cbd493b54cb0$export$84c19026e616569e(definition) {
    const defaultValues = {};
    const defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach((def)=>{
        if (def.defaultValue) (0, $cf7c3ff17e2ece79$export$a1dab82d368d6525)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}

/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/ function $c31535aa3b39d468$export$b4df399e879e53ab(result) {
    return !!result.errors?.length;
}


function $21c28b2e5e0aa2b8$export$e2838dcad1841001(document) {
    let forceResolvers = false;
    (0, $cd2396bbf46089ba$export$bf638b60ea8b89b7)(document, {
        Directive: {
            enter (node) {
                if (node.name.value === "client" && node.arguments) {
                    forceResolvers = node.arguments.some((arg)=>arg.name.value === "always" && arg.value.kind === "BooleanValue" && arg.value.value === true);
                    if (forceResolvers) return 0, $cd2396bbf46089ba$export$a89c95c098ac2a58;
                }
            }
        }
    });
    return forceResolvers;
}


function $aba99c557ad5aa19$export$540432d49fcec6c9(value) {
    return (0, $e79cca4a6323426e$export$417207af72fad9c9)(value) && value.kind === "Document" && Array.isArray(value.definitions);
}






function $0d31b63b7d259842$export$772111caef41b3f5(doc) {
    (0, $aa2d7231b5e28112$export$f5708dca728d7177)(doc.kind === "Document", 6);
    (0, $aa2d7231b5e28112$export$f5708dca728d7177)(doc.definitions.length <= 1, 7);
    const fragmentDef = doc.definitions[0];
    (0, $aa2d7231b5e28112$export$f5708dca728d7177)(fragmentDef.kind === "FragmentDefinition", 8);
    return fragmentDef;
}




/**
* A version of Array.isArray that works better with readonly arrays.
*
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/ const $120a6dcb47daaf45$export$43bee75e5e14138e = Array.isArray;


/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/ function $19bcd21ff0d8bcb3$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}


function $71a932e945cf8578$export$e5ae0530da5fe96c(directives, doc) {
    (0, $2a4ebb84b536625f$export$a7d0d8111d2386df)(doc);
    // Passing empty strings to makeInUseGetterFunction means we handle anonymous
    // operations as if their names were "". Anonymous fragment definitions are
    // not supposed to be possible, but the same default naming strategy seems
    // appropriate for that case as well.
    const getInUseByOperationName = $71a932e945cf8578$var$makeInUseGetterFunction("");
    const getInUseByFragmentName = $71a932e945cf8578$var$makeInUseGetterFunction("");
    const getInUse = (ancestors)=>{
        for(let p = 0, ancestor; p < ancestors.length && (ancestor = ancestors[p]); ++p){
            if ((0, $120a6dcb47daaf45$export$43bee75e5e14138e)(ancestor)) continue;
            if (ancestor.kind === (0, $324243985983b985$export$a84bdc57c5122798).OPERATION_DEFINITION) // If an operation is anonymous, we use the empty string as its key.
            return getInUseByOperationName(ancestor.name && ancestor.name.value);
            if (ancestor.kind === (0, $324243985983b985$export$a84bdc57c5122798).FRAGMENT_DEFINITION) return getInUseByFragmentName(ancestor.name.value);
        }
        (0, $aa2d7231b5e28112$export$f5708dca728d7177).error(14);
        return null;
    };
    let operationCount = 0;
    for(let i = doc.definitions.length - 1; i >= 0; --i)if (doc.definitions[i].kind === (0, $324243985983b985$export$a84bdc57c5122798).OPERATION_DEFINITION) ++operationCount;
    const directiveMatcher = $71a932e945cf8578$var$getDirectiveMatcher(directives);
    const shouldRemoveField = (nodeDirectives)=>(0, $19bcd21ff0d8bcb3$export$d307f5934e447d0e)(nodeDirectives) && nodeDirectives.map(directiveMatcher).some((config)=>config && config.remove);
    const originalFragmentDefsByPath = new Map();
    // Any time the first traversal of the document below makes a change like
    // removing a fragment (by returning null), this variable should be set to
    // true. Once it becomes true, it should never be set to false again. If this
    // variable remains false throughout the traversal, then we can return the
    // original doc immediately without any modifications.
    let firstVisitMadeChanges = false;
    const fieldOrInlineFragmentVisitor = {
        enter (node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        }
    };
    const docWithoutDirectiveSubtrees = (0, $cd2396bbf46089ba$export$bf638b60ea8b89b7)(doc, {
        // These two AST node types share the same implementation, defined above.
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter () {
                // VariableDefinition nodes do not count as variables in use, though
                // they do contain Variable nodes that might be visited below. To avoid
                // counting variable declarations as usages, we skip visiting the
                // contents of this VariableDefinition node by returning false.
                return false;
            }
        },
        Variable: {
            enter (node, _key, _parent, _path, ancestors) {
                const inUse = getInUse(ancestors);
                if (inUse) inUse.variables.add(node.name.value);
            }
        },
        FragmentSpread: {
            enter (node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                const inUse = getInUse(ancestors);
                if (inUse) inUse.fragmentSpreads.add(node.name.value);
            // We might like to remove this FragmentSpread by returning null here if
            // the corresponding FragmentDefinition node is also going to be removed
            // by the logic below, but we can't control the relative order of those
            // events, so we have to postpone the removal of dangling FragmentSpread
            // nodes until after the current visit of the document has finished.
            }
        },
        FragmentDefinition: {
            enter (node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave (node, _key, _parent, path) {
                const originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) // If the FragmentNode received by this leave function is identical to
                // the one received by the corresponding enter function (above), then
                // the visitor must not have made any changes within this
                // FragmentDefinition node. This fragment definition may still be
                // removed if there are no ...spread references to it, but it won't be
                // removed just because it has only a __typename field.
                return node;
                if (// This logic applies only if the document contains one or more
                // operations, since removing all fragments from a document containing
                // only fragments makes the document useless.
                operationCount > 0 && node.selectionSet.selections.every((selection)=>selection.kind === (0, $324243985983b985$export$a84bdc57c5122798).FIELD && selection.name.value === "__typename")) {
                    // This is a somewhat opinionated choice: if a FragmentDefinition ends
                    // up having no fields other than __typename, we remove the whole
                    // fragment definition, and later prune ...spread references to it.
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        },
        Directive: {
            leave (node) {
                // If a matching directive is found, remove the directive itself. Note
                // that this does not remove the target (field, argument, etc) of the
                // directive, but only the directive itself.
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        }
    });
    if (!firstVisitMadeChanges) // If our first pass did not change anything about the document, then there
    // is no cleanup we need to do, and we can return the original doc.
    return doc;
    // Utility for making sure inUse.transitiveVars is recursively populated.
    // Because this logic assumes inUse.fragmentSpreads has been completely
    // populated and inUse.removed has been set if appropriate,
    // populateTransitiveVars must be called after that information has been
    // collected by the first traversal of the document.
    const populateTransitiveVars = (inUse)=>{
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) inUse.fragmentSpreads.forEach((childFragmentName)=>{
                populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach((varName)=>{
                    inUse.transitiveVars.add(varName);
                });
            });
        }
        return inUse;
    };
    // Since we've been keeping track of fragment spreads used by particular
    // operations and fragment definitions, we now need to compute the set of all
    // spreads used (transitively) by any operations in the document.
    const allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach((def)=>{
        if (def.kind === (0, $324243985983b985$export$a84bdc57c5122798).OPERATION_DEFINITION) populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach((childFragmentName)=>{
            allFragmentNamesUsed.add(childFragmentName);
        });
        else if (def.kind === (0, $324243985983b985$export$a84bdc57c5122798).FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
        // definitions count as usages of their own fragment names. This heuristic
        // prevents accidentally removing all fragment definitions from the
        // document just because it contains no operations that use the fragments.
        operationCount === 0 && !getInUseByFragmentName(def.name.value).removed) allFragmentNamesUsed.add(def.name.value);
    });
    // Now that we have added all fragment spreads used by operations to the
    // allFragmentNamesUsed set, we can complete the set by transitively adding
    // all fragment spreads used by those fragments, and so on.
    allFragmentNamesUsed.forEach((fragmentName)=>{
        // Once all the childFragmentName strings added here have been seen already,
        // the top-level allFragmentNamesUsed.forEach loop will terminate.
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach((childFragmentName)=>{
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    const fragmentWillBeRemoved = (fragmentName)=>!!// A fragment definition will be removed if there are no spreads that refer
        // to it, or the fragment was explicitly removed because it had no fields
        // other than __typename.
        (!allFragmentNamesUsed.has(fragmentName) || getInUseByFragmentName(fragmentName).removed);
    const enterVisitor = {
        enter (node) {
            if (fragmentWillBeRemoved(node.name.value)) return null;
        }
    };
    return $71a932e945cf8578$var$nullIfDocIsEmpty((0, $cd2396bbf46089ba$export$bf638b60ea8b89b7)(docWithoutDirectiveSubtrees, {
        // If the fragment is going to be removed, then leaving any dangling
        // FragmentSpread nodes with the same name would be a mistake.
        FragmentSpread: enterVisitor,
        // This is where the fragment definition is actually removed.
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave (node) {
                // Upon leaving each operation in the depth-first AST traversal, prune
                // any variables that are declared by the operation but unused within.
                if (node.variableDefinitions) {
                    const usedVariableNames = populateTransitiveVars(// If an operation is anonymous, we use the empty string as its key.
                    getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    // According to the GraphQL spec, all variables declared by an
                    // operation must either be used by that operation or used by some
                    // fragment included transitively into that operation:
                    // https://spec.graphql.org/draft/#sec-All-Variables-Used
                    //
                    // To stay on the right side of this validation rule, if/when we
                    // remove the last $var references from an operation or its fragments,
                    // we must also remove the corresponding $var declaration from the
                    // enclosing operation. This pruning applies only to operations and
                    // not fragment definitions, at the moment. Fragments may be able to
                    // declare variables eventually, but today they can only consume them.
                    if (usedVariableNames.size < node.variableDefinitions.length) return {
                        ...node,
                        variableDefinitions: node.variableDefinitions.filter((varDef)=>usedVariableNames.has(varDef.variable.name.value))
                    };
                }
            }
        }
    }));
}
function $71a932e945cf8578$var$makeInUseGetterFunction(defaultKey) {
    const map = new Map();
    return function inUseGetterFunction(key = defaultKey) {
        let inUse = map.get(key);
        if (!inUse) map.set(key, inUse = {
            // Variable and fragment spread names used directly within this
            // operation or fragment definition, as identified by key. These sets
            // will be populated during the first traversal of the document in
            // removeDirectivesFromDocument below.
            variables: new Set(),
            fragmentSpreads: new Set()
        });
        return inUse;
    };
}
function $71a932e945cf8578$var$getDirectiveMatcher(configs) {
    const names = new Map();
    const tests = new Map();
    configs.forEach((directive)=>{
        if (directive) {
            if (directive.name) names.set(directive.name, directive);
            else if (directive.test) tests.set(directive.test, directive);
        }
    });
    return (directive)=>{
        let config = names.get(directive.name.value);
        if (!config && tests.size) tests.forEach((testConfig, test)=>{
            if (test(directive)) config = testConfig;
        });
        return config;
    };
}
function $71a932e945cf8578$var$isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every((selection)=>selection.kind === (0, $324243985983b985$export$a84bdc57c5122798).FRAGMENT_SPREAD && $71a932e945cf8578$var$isEmpty(fragmentMap[selection.name.value], fragmentMap));
}
function $71a932e945cf8578$var$nullIfDocIsEmpty(doc) {
    return $71a932e945cf8578$var$isEmpty((0, $bfe912ade316f216$export$7a5b1fa979d2c158)(doc) || (0, $0d31b63b7d259842$export$772111caef41b3f5)(doc), (0, $af06dc884b782fca$export$193789b4c8246dd4)((0, $499d29b3c6f5bfa6$export$5320a7ba9466a3df)(doc))) ? null : doc;
}

/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/ function $7df42a60a8344f21$export$de3acc9431f1695e(value) {
    const result = {
        data: value.data
    };
    if (value.error) result.error = value.error;
    return result;
}






var $k8Bfo = parcelRequire("k8Bfo");

var $158ebd49b399cbad$export$cc3d42e6b2b9cf8b = function(_super) {
    (0, $k8Bfo.__extends)(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, $1e1b2aa6dbd14b53$export$b6bbab5a9b109038));








function $67d5fb3547f9891c$export$f80bdb85f299186(selection, fragmentMap) {
    switch(selection.kind){
        case "InlineFragment":
            return selection;
        case "FragmentSpread":
            {
                const fragmentName = selection.name.value;
                if (typeof fragmentMap === "function") return fragmentMap(fragmentName);
                const fragment = fragmentMap && fragmentMap[fragmentName];
                (0, $aa2d7231b5e28112$export$f5708dca728d7177)(fragment, 9, fragmentName);
                return fragment || null;
            }
        default:
            return null;
    }
}




function $a0943c6fbd138d63$export$f431198736b7f96d(queryDoc) {
    (0, $2a4ebb84b536625f$export$a7d0d8111d2386df)(queryDoc);
    let fragmentDefinition;
    for (let definition of queryDoc.definitions){
        if (definition.kind === "OperationDefinition") return definition;
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) // we do this because we want to allow multiple fragment definitions
        // to precede an operation definition.
        fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw (0, $aa2d7231b5e28112$export$3991762405098ea)(12);
}


/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/ function $e5a2402b798644a7$export$fb56ad75dd311c12(selection) {
    return selection.kind === "Field";
}




function $873800698121f009$export$3dc388a5f013b4a5({ directives: directives }, variables) {
    if (!directives || !directives.length) return true;
    return $873800698121f009$var$getInclusionDirectives(directives).every(({ directive: directive, ifArgument: ifArgument })=>{
        let evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue = variables && variables[ifArgument.value.name.value];
            (0, $aa2d7231b5e28112$export$f5708dca728d7177)(evaledValue !== void 0, 15, directive.name.value);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function $873800698121f009$var$isInclusionDirective({ name: { value: value } }) {
    return value === "skip" || value === "include";
}
function $873800698121f009$var$getInclusionDirectives(directives) {
    const result = [];
    if (directives && directives.length) directives.forEach((directive)=>{
        if (!$873800698121f009$var$isInclusionDirective(directive)) return;
        const directiveArguments = directive.arguments;
        const directiveName = directive.name.value;
        (0, $aa2d7231b5e28112$export$f5708dca728d7177)(directiveArguments && directiveArguments.length === 1, 16, directiveName);
        const ifArgument = directiveArguments[0];
        (0, $aa2d7231b5e28112$export$f5708dca728d7177)(ifArgument.name && ifArgument.name.value === "if", 17, directiveName);
        const ifValue = ifArgument.value;
        // means it has to be a variable value if this is a valid @skip or @include directive
        (0, $aa2d7231b5e28112$export$f5708dca728d7177)(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 18, directiveName);
        result.push({
            directive: directive,
            ifArgument: ifArgument
        });
    });
    return result;
}


function $6b68336fdc3e0e6c$export$5e40714c5ad44445(query, { data: aData, ...aRest }, { data: bData, ...bRest }, variables) {
    return (0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(aRest, bRest) && $6b68336fdc3e0e6c$var$equalBySelectionSet((0, $a0943c6fbd138d63$export$f431198736b7f96d)(query).selectionSet, aData, bData, {
        fragmentMap: (0, $af06dc884b782fca$export$193789b4c8246dd4)((0, $499d29b3c6f5bfa6$export$5320a7ba9466a3df)(query)),
        variables: variables
    });
}
function $6b68336fdc3e0e6c$var$equalBySelectionSet(selectionSet, aResult, bResult, context) {
    if (aResult === bResult) return true;
    const seenSelections = new Set();
    // Returning true from this Array.prototype.every callback function skips the
    // current field/subtree. Returning false aborts the entire traversal
    // immediately, causing equalBySelectionSet to return false.
    return selectionSet.selections.every((selection)=>{
        // Avoid re-processing the same selection at the same level of recursion, in
        // case the same field gets included via multiple indirect fragment spreads.
        if (seenSelections.has(selection)) return true;
        seenSelections.add(selection);
        // Ignore @skip(if: true) and @include(if: false) fields.
        if (!(0, $873800698121f009$export$3dc388a5f013b4a5)(selection, context.variables)) return true;
        // If the field or (named) fragment spread has a @nonreactive directive on
        // it, we don't care if it's different, so we pretend it's the same.
        if ($6b68336fdc3e0e6c$var$selectionHasNonreactiveDirective(selection)) return true;
        if ((0, $e5a2402b798644a7$export$fb56ad75dd311c12)(selection)) {
            const resultKey = (0, $6a5b17c6ecfc0cd4$export$7d1ad22471852218)(selection);
            const aResultChild = aResult && aResult[resultKey];
            const bResultChild = bResult && bResult[resultKey];
            const childSelectionSet = selection.selectionSet;
            if (!childSelectionSet) // These are scalar values, so we can compare them with deep equal
            // without redoing the main recursive work.
            return (0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(aResultChild, bResultChild);
            const aChildIsArray = Array.isArray(aResultChild);
            const bChildIsArray = Array.isArray(bResultChild);
            if (aChildIsArray !== bChildIsArray) return false;
            if (aChildIsArray && bChildIsArray) {
                const length = aResultChild.length;
                if (bResultChild.length !== length) return false;
                for(let i = 0; i < length; ++i){
                    if (!$6b68336fdc3e0e6c$var$equalBySelectionSet(childSelectionSet, aResultChild[i], bResultChild[i], context)) return false;
                }
                return true;
            }
            return $6b68336fdc3e0e6c$var$equalBySelectionSet(childSelectionSet, aResultChild, bResultChild, context);
        } else {
            const fragment = (0, $67d5fb3547f9891c$export$f80bdb85f299186)(selection, context.fragmentMap);
            if (fragment) {
                // The fragment might === selection if it's an inline fragment, but
                // could be !== if it's a named fragment ...spread.
                if ($6b68336fdc3e0e6c$var$selectionHasNonreactiveDirective(fragment)) return true;
                return $6b68336fdc3e0e6c$var$equalBySelectionSet(fragment.selectionSet, // Notice that we reuse the same aResult and bResult values here,
                // since the fragment ...spread does not specify a field name, but
                // consists of multiple fields (within the fragment's selection set)
                // that should be applied to the current result value(s).
                aResult, bResult, context);
            }
        }
    });
}
function $6b68336fdc3e0e6c$var$selectionHasNonreactiveDirective(selection) {
    return !!selection.directives && selection.directives.some($6b68336fdc3e0e6c$var$directiveIsNonreactive);
}
function $6b68336fdc3e0e6c$var$directiveIsNonreactive(dir) {
    return dir.name.value === "nonreactive";
}



function $dc8fea04cb0035e1$export$d96b2213c1b9d3a9(doc) {
    const queryDef = (0, $bfe912ade316f216$export$7a5b1fa979d2c158)(doc);
    (0, $aa2d7231b5e28112$export$f5708dca728d7177)(queryDef && queryDef.operation === "query", 13);
    return queryDef;
}




const { assign: $1724141f75044c6b$var$assign, hasOwnProperty: $1724141f75044c6b$var$hasOwnProperty } = Object;
const $1724141f75044c6b$var$uninitialized = {
    loading: true,
    networkStatus: (0, $28ed6ef232a84776$export$bd096ddbd246c79c).loading,
    data: undefined,
    dataState: "empty",
    partial: true
};
const $1724141f75044c6b$var$empty = {
    loading: false,
    networkStatus: (0, $28ed6ef232a84776$export$bd096ddbd246c79c).ready,
    data: undefined,
    dataState: "empty",
    partial: true
};
class $1724141f75044c6b$export$6c1b56eac59c9584 {
    options;
    queryName;
    variablesUnknown = false;
    /**
    * @internal will be read and written from `QueryInfo`
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */ _lastWrite;
    // The `query` computed property will always reflect the document transformed
    // by the last run query. `this.options.query` will always reflect the raw
    // untransformed query to ensure document transforms with runtime conditionals
    // are run on the original document.
    get query() {
        return this.lastQuery;
    }
    /**
     * An object containing the variables that were provided for the query.
     */ get variables() {
        return this.options.variables;
    }
    unsubscribeFromCache;
    input;
    subject;
    isTornDown;
    queryManager;
    subscriptions = new Set();
    /**
     * If an `ObservableQuery` is created with a `network-only` fetch policy,
     * it should actually start receiving cache updates, but not before it has
     * received the first result from the network.
     */ waitForNetworkResult;
    lastQuery;
    linkSubscription;
    pollingInfo;
    get networkStatus() {
        return this.subject.getValue().result.networkStatus;
    }
    get cache() {
        return this.queryManager.cache;
    }
    constructor({ queryManager: queryManager, options: options, transformedQuery: transformedQuery = queryManager.transform(options.query) }){
        this.queryManager = queryManager;
        // active state
        this.waitForNetworkResult = options.fetchPolicy === "network-only";
        this.isTornDown = false;
        this.subscribeToMore = this.subscribeToMore.bind(this);
        this.maskResult = this.maskResult.bind(this);
        const { watchQuery: { fetchPolicy: defaultFetchPolicy = "cache-first" } = {} } = queryManager.defaultOptions;
        const { fetchPolicy: fetchPolicy = defaultFetchPolicy, initialFetchPolicy: // Make sure we don't store "standby" as the initialFetchPolicy.
        initialFetchPolicy = fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy } = options;
        if (options[0, $16b2c739aa564ddd$export$868b9638ff105835]) {
            (0, $aa2d7231b5e28112$export$f5708dca728d7177)(fetchPolicy === "standby", 80);
            this.variablesUnknown = true;
        }
        this.lastQuery = transformedQuery;
        this.options = {
            ...options,
            initialFetchPolicy: // Remember the initial options.fetchPolicy so we can revert back to this
            // policy when variables change. This information can also be specified
            // (or overridden) by providing options.initialFetchPolicy explicitly.
            initialFetchPolicy,
            fetchPolicy: // This ensures this.options.fetchPolicy always has a string value, in
            // case options.fetchPolicy was not provided.
            fetchPolicy,
            variables: this.getVariablesWithDefaults(options.variables)
        };
        this.initializeObservablesQueue();
        this["@@observable"] = ()=>this;
        if (Symbol.observable) this[Symbol.observable] = ()=>this;
        const opDef = (0, $bfe912ade316f216$export$7a5b1fa979d2c158)(this.query);
        this.queryName = opDef && opDef.name && opDef.name.value;
    }
    initializeObservablesQueue() {
        this.subject = new (0, $158ebd49b399cbad$export$cc3d42e6b2b9cf8b)({
            query: this.query,
            variables: this.variables,
            result: $1724141f75044c6b$var$uninitialized,
            meta: {}
        });
        const observable = this.subject.pipe((0, $074c390243aea0da$export$3f23594af5f37336)({
            subscribe: ()=>{
                if (!this.subject.observed) {
                    this.reobserve();
                    // TODO: See if we can rework updatePolling to better handle this.
                    // reobserve calls updatePolling but this `subscribe` callback is
                    // called before the subject is subscribed to so `updatePolling`
                    // can't accurately detect if there is an active subscription.
                    // Calling it again here ensures that it can detect if it can poll
                    setTimeout(()=>this.updatePolling());
                }
            },
            unsubscribe: ()=>{
                if (!this.subject.observed) this.tearDownQuery();
            }
        }), (0, $4b985f1bcf049783$export$a04c6c6965dd4709)(({ query: query, variables: variables, result: current, meta: meta }, context)=>{
            const { shouldEmit: shouldEmit } = meta;
            if (current === $1724141f75044c6b$var$uninitialized) {
                // reset internal state after `ObservableQuery.reset()`
                context.previous = undefined;
                context.previousVariables = undefined;
            }
            if (this.options.fetchPolicy === "standby" || shouldEmit === 2 /* EmitBehavior.never */ ) return;
            if (shouldEmit === 1 /* EmitBehavior.force */ ) return emit();
            const { previous: previous, previousVariables: previousVariables } = context;
            if (previous) {
                const documentInfo = this.queryManager.getDocumentInfo(query);
                const dataMasking = this.queryManager.dataMasking;
                const maskedQuery = dataMasking ? documentInfo.nonReactiveQuery : query;
                const resultIsEqual = dataMasking || documentInfo.hasNonreactiveDirective ? (0, $6b68336fdc3e0e6c$export$5e40714c5ad44445)(maskedQuery, previous, current, variables) : (0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(previous, current);
                if (resultIsEqual && (0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(previousVariables, variables)) return;
            }
            if (shouldEmit === 3 /* EmitBehavior.networkStatusChange */  && (!this.options.notifyOnNetworkStatusChange || (0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(previous, current))) return;
            return emit();
            function emit() {
                context.previous = current;
                context.previousVariables = variables;
                return current;
            }
        }, ()=>({})));
        this.pipe = observable.pipe.bind(observable);
        this.subscribe = observable.subscribe.bind(observable);
        this.input = new (0, $1e1b2aa6dbd14b53$export$b6bbab5a9b109038)();
        // we want to feed many streams into `this.subject`, but none of them should
        // be able to close `this.input`
        this.input.complete = ()=>{};
        this.input.pipe(this.operator).subscribe(this.subject);
    }
    // We can't use Observable['subscribe'] here as the type as it conflicts with
    // the ability to infer T from Subscribable<T>. This limits the surface area
    // to the non-deprecated signature which works properly with type inference.
    /**
     * Subscribes to the `ObservableQuery`.
     * @param observerOrNext - Either an RxJS `Observer` with some or all callback methods,
     * or the `next` handler that is called for each value emitted from the subscribed Observable.
     * @returns A subscription reference to the registered handlers.
     */ subscribe;
    /**
     * Used to stitch together functional operators into a chain.
     *
     * @example
     *
     * ```ts
     * import { filter, map } from 'rxjs';
     *
     * observableQuery
     *   .pipe(
     *     filter(...),
     *     map(...),
     *   )
     *   .subscribe(x => console.log(x));
     * ```
     *
     * @returns The Observable result of all the operators having been called
     * in the order they were passed in.
     */ pipe;
    [Symbol.observable];
    ["@@observable"];
    /**
    * @internal
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */ getCacheDiff({ optimistic: optimistic = true } = {}) {
        return this.cache.diff({
            query: this.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: optimistic
        });
    }
    getInitialResult(initialFetchPolicy) {
        let fetchPolicy = initialFetchPolicy || this.options.fetchPolicy;
        if (this.queryManager.prioritizeCacheValues && (fetchPolicy === "network-only" || fetchPolicy === "cache-and-network")) fetchPolicy = "cache-first";
        const cacheResult = ()=>{
            const diff = this.getCacheDiff();
            // TODO: queryInfo.getDiff should handle this since cache.diff returns a
            // null when returnPartialData is false
            const data = this.options.returnPartialData || diff.complete ? diff.result ?? undefined : undefined;
            return this.maskResult({
                data: data,
                dataState: diff.complete ? "complete" : data === undefined ? "empty" : "partial",
                loading: !diff.complete,
                networkStatus: diff.complete ? (0, $28ed6ef232a84776$export$bd096ddbd246c79c).ready : (0, $28ed6ef232a84776$export$bd096ddbd246c79c).loading,
                partial: !diff.complete
            });
        };
        switch(fetchPolicy){
            case "cache-only":
                return {
                    ...cacheResult(),
                    loading: false,
                    networkStatus: (0, $28ed6ef232a84776$export$bd096ddbd246c79c).ready
                };
            case "cache-first":
                return cacheResult();
            case "cache-and-network":
                return {
                    ...cacheResult(),
                    loading: true,
                    networkStatus: (0, $28ed6ef232a84776$export$bd096ddbd246c79c).loading
                };
            case "standby":
                return $1724141f75044c6b$var$empty;
            default:
                return $1724141f75044c6b$var$uninitialized;
        }
    }
    resubscribeCache() {
        const { variables: variables, fetchPolicy: fetchPolicy } = this.options;
        const query = this.query;
        const shouldUnsubscribe = fetchPolicy === "standby" || fetchPolicy === "no-cache" || this.waitForNetworkResult;
        const shouldResubscribe = !$1724141f75044c6b$var$isEqualQuery({
            query: query,
            variables: variables
        }, this.unsubscribeFromCache) && !this.waitForNetworkResult;
        if (shouldUnsubscribe || shouldResubscribe) this.unsubscribeFromCache?.();
        if (shouldUnsubscribe || !shouldResubscribe) return;
        const watch = {
            query: query,
            variables: variables,
            optimistic: true,
            watcher: this,
            callback: (diff)=>{
                const info = this.queryManager.getDocumentInfo(query);
                if (info.hasClientExports || info.hasForcedResolvers) // If this is not set to something different than `diff`, we will
                // not be notified about future cache changes with an equal `diff`.
                // That would be the case if we are working with client-only fields
                // that are forced or with `exports` fields that might change, causing
                // local resolvers to return a new result.
                // This is based on an implementation detail of `InMemoryCache`, which
                // is not optimal - but the only alternative to this would be to
                // resubscribe to the cache asynchonouly, which would bear the risk of
                // missing further synchronous updates.
                watch.lastDiff = undefined;
                if (watch.lastOwnDiff === diff) // skip cache updates that were caused by our own writes
                return;
                const { result: previousResult } = this.subject.getValue();
                if (!diff.complete && // If we are trying to deliver an incomplete cache result, we avoid
                // reporting it if the query has errored, otherwise we let the broadcast try
                // and repair the partial result by refetching the query. This check avoids
                // a situation where a query that errors and another succeeds with
                // overlapping data does not report the partial data result to the errored
                // query.
                //
                // See https://github.com/apollographql/apollo-client/issues/11400 for more
                // information on this issue.
                (previousResult.error || // Prevent to schedule a notify directly after the `ObservableQuery`
                // has been `reset` (which will set the `previousResult` to `uninitialized` or `empty`)
                // as in those cases, `resetCache` will manually call `refetch` with more intentional timing.
                previousResult === $1724141f75044c6b$var$uninitialized || previousResult === $1724141f75044c6b$var$empty)) return;
                if (!(0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(previousResult.data, diff.result)) this.scheduleNotify();
            }
        };
        const cancelWatch = this.cache.watch(watch);
        this.unsubscribeFromCache = Object.assign(()=>{
            this.unsubscribeFromCache = undefined;
            cancelWatch();
        }, {
            query: query,
            variables: variables
        });
    }
    stableLastResult;
    getCurrentResult() {
        const { result: current } = this.subject.getValue();
        let value = // if the `current` result is in an error state, we will always return that
        // error state, even if we have no observers
        current.networkStatus === (0, $28ed6ef232a84776$export$bd096ddbd246c79c).error || // if we have observers, we are watching the cache and
        // this.subject.getValue() will always be up to date
        this.hasObservers() || // if we are using a `no-cache` fetch policy in which case this
        // `ObservableQuery` cannot have been updated from the outside - in
        // that case, we prefer to keep the current value
        this.options.fetchPolicy === "no-cache" ? current : this.getInitialResult();
        if (value === $1724141f75044c6b$var$uninitialized) value = this.getInitialResult();
        if (!(0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(this.stableLastResult, value)) this.stableLastResult = value;
        return this.stableLastResult;
    }
    /**
     * Update the variables of this observable query, and fetch the new results.
     * This method should be preferred over `setVariables` in most use cases.
     *
     * Returns a `ResultPromise` with an additional `.retain()` method. Calling
     * `.retain()` keeps the network operation running even if the `ObservableQuery`
     * no longer requires the result.
     *
     * Note: `refetch()` guarantees that a value will be emitted from the
     * observable, even if the result is deep equal to the previous value.
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ refetch(variables) {
        const { fetchPolicy: fetchPolicy } = this.options;
        const reobserveOptions = {
            // Always disable polling for refetches.
            pollInterval: 0
        };
        // Unless the provided fetchPolicy always consults the network
        // (no-cache, network-only, or cache-and-network), override it with
        // network-only to force the refetch for this fetchQuery call.
        if (fetchPolicy === "no-cache") reobserveOptions.fetchPolicy = "no-cache";
        else reobserveOptions.fetchPolicy = "network-only";
        if ((0, $e15192e15b3ad6c1$export$a866f231438cc228) && variables && $1724141f75044c6b$var$hasOwnProperty.call(variables, "variables")) {
            const queryDef = (0, $dc8fea04cb0035e1$export$d96b2213c1b9d3a9)(this.query);
            const vars = queryDef.variableDefinitions;
            if (!vars || !vars.some((v)=>v.variable.name.value === "variables")) (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).warn(81, variables, queryDef.name?.value || queryDef);
        }
        if (variables && !(0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(this.variables, variables)) // Update the existing options with new variables
        reobserveOptions.variables = this.options.variables = this.getVariablesWithDefaults({
            ...this.variables,
            ...variables
        });
        this._lastWrite = undefined;
        return this._reobserve(reobserveOptions, {
            newNetworkStatus: (0, $28ed6ef232a84776$export$bd096ddbd246c79c).refetch
        });
    }
    fetchMore({ query: query, variables: variables, context: context, errorPolicy: errorPolicy, updateQuery: updateQuery }) {
        (0, $aa2d7231b5e28112$export$f5708dca728d7177)(this.options.fetchPolicy !== "cache-only", 82, (0, $3ed2520e139df5b6$export$41bca9dc6871dd4e)(this.query, "(anonymous)"));
        const combinedOptions = {
            ...(0, $8e62f7547d3f557e$export$8e16b83750b44988)(this.options, {
                errorPolicy: "none"
            }, {
                query: query,
                context: context,
                errorPolicy: errorPolicy
            }),
            variables: query ? variables : {
                ...this.variables,
                ...variables
            },
            // The fetchMore request goes immediately to the network and does
            // not automatically write its result to the cache (hence no-cache
            // instead of network-only), because we allow the caller of
            // fetchMore to provide an updateQuery callback that determines how
            // the data gets written to the cache.
            fetchPolicy: "no-cache",
            notifyOnNetworkStatusChange: this.options.notifyOnNetworkStatusChange
        };
        combinedOptions.query = this.transformDocument(combinedOptions.query);
        // If a temporary query is passed to `fetchMore`, we don't want to store
        // it as the last query result since it may be an optimized query for
        // pagination. We will however run the transforms on the original document
        // as well as the document passed in `fetchMoreOptions` to ensure the cache
        // uses the most up-to-date document which may rely on runtime conditionals.
        this.lastQuery = query ? this.transformDocument(this.options.query) : combinedOptions.query;
        let wasUpdated = false;
        const isCached = this.options.fetchPolicy !== "no-cache";
        if (!isCached) (0, $aa2d7231b5e28112$export$f5708dca728d7177)(updateQuery, 83);
        const { finalize: finalize, pushNotification: pushNotification } = this.pushOperation((0, $28ed6ef232a84776$export$bd096ddbd246c79c).fetchMore);
        pushNotification({
            source: "newNetworkStatus",
            kind: "N",
            value: {}
        }, {
            shouldEmit: 3 /* EmitBehavior.networkStatusChange */ 
        });
        const { promise: promise, operator: operator } = $1724141f75044c6b$var$getTrackingOperatorPromise();
        const { observable: observable } = this.queryManager.fetchObservableWithInfo(combinedOptions, {
            networkStatus: (0, $28ed6ef232a84776$export$bd096ddbd246c79c).fetchMore,
            exposeExtensions: true
        });
        const subscription = observable.pipe(operator, (0, $1ed725e1b173ea41$export$3dea766d36a8935f)((notification)=>notification.kind === "N" && notification.source === "network")).subscribe({
            next: (notification)=>{
                wasUpdated = false;
                const fetchMoreResult = notification.value;
                const extensions = fetchMoreResult[0, $16b2c739aa564ddd$export$bcc403bd3c6120cd];
                if ((0, $2143f5bfa0fc1fe2$export$427e8a52ef0f96e2)(notification.value.networkStatus)) finalize();
                if (isCached) {
                    // Separately getting a diff here before the batch - `onWatchUpdated` might be
                    // called with an `undefined` `lastDiff` on the watcher if the cache was just subscribed to.
                    const lastDiff = this.getCacheDiff();
                    // Performing this cache update inside a cache.batch transaction ensures
                    // any affected cache.watch watchers are notified at most once about any
                    // updates. Most watchers will be using the QueryInfo class, which
                    // responds to notifications by calling reobserveCacheFirst to deliver
                    // fetchMore cache results back to this ObservableQuery.
                    this.cache.batch({
                        update: (cache)=>{
                            if (updateQuery) cache.updateQuery({
                                query: this.query,
                                variables: this.variables,
                                returnPartialData: true,
                                optimistic: false,
                                extensions: extensions
                            }, (previous)=>updateQuery(previous, {
                                    fetchMoreResult: fetchMoreResult.data,
                                    variables: combinedOptions.variables
                                }));
                            else // If we're using a field policy instead of updateQuery, the only
                            // thing we need to do is write the new data to the cache using
                            // combinedOptions.variables (instead of this.variables, which is
                            // what this.updateQuery uses, because it works by abusing the
                            // original field value, keyed by the original variables).
                            cache.writeQuery({
                                query: combinedOptions.query,
                                variables: combinedOptions.variables,
                                data: fetchMoreResult.data,
                                extensions: extensions
                            });
                        },
                        onWatchUpdated: (watch, diff)=>{
                            if (watch.watcher === this && !(0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(diff.result, lastDiff.result)) {
                                wasUpdated = true;
                                const lastResult = this.getCurrentResult();
                                // Let the cache watch from resubscribeCache handle the final
                                // result
                                if ((0, $9311d187008787b8$export$37509604341a3464)(fetchMoreResult.networkStatus)) pushNotification({
                                    kind: "N",
                                    source: "network",
                                    value: {
                                        ...lastResult,
                                        networkStatus: fetchMoreResult.networkStatus === (0, $28ed6ef232a84776$export$bd096ddbd246c79c).error ? (0, $28ed6ef232a84776$export$bd096ddbd246c79c).ready : fetchMoreResult.networkStatus,
                                        // will be overwritten anyways, just here for types sake
                                        loading: false,
                                        data: diff.result,
                                        dataState: fetchMoreResult.dataState === "streaming" ? "streaming" : "complete"
                                    }
                                });
                            }
                        }
                    });
                } else {
                    // There is a possibility `lastResult` may not be set when
                    // `fetchMore` is called which would cause this to crash. This should
                    // only happen if we haven't previously reported a result. We don't
                    // quite know what the right behavior should be here since this block
                    // of code runs after the fetch result has executed on the network.
                    // We plan to let it crash in the meantime.
                    //
                    // If we get bug reports due to the `data` property access on
                    // undefined, this should give us a real-world scenario that we can
                    // use to test against and determine the right behavior. If we do end
                    // up changing this behavior, this may require, for example, an
                    // adjustment to the types on `updateQuery` since that function
                    // expects that the first argument always contains previous result
                    // data, but not `undefined`.
                    const lastResult = this.getCurrentResult();
                    const data = updateQuery(lastResult.data, {
                        fetchMoreResult: fetchMoreResult.data,
                        variables: combinedOptions.variables
                    });
                    pushNotification({
                        kind: "N",
                        value: {
                            ...lastResult,
                            networkStatus: (0, $28ed6ef232a84776$export$bd096ddbd246c79c).ready,
                            // will be overwritten anyways, just here for types sake
                            loading: false,
                            data: data,
                            dataState: lastResult.dataState === "streaming" ? "streaming" : "complete"
                        },
                        source: "network"
                    });
                }
            }
        });
        return (0, $eec24d8374c011ae$export$7ff41c6e01127226)(promise.then((result)=>(0, $7df42a60a8344f21$export$de3acc9431f1695e)(this.maskResult(result))).finally(()=>{
            subscription.unsubscribe();
            finalize();
            if (isCached && !wasUpdated) {
                const lastResult = this.getCurrentResult();
                if (lastResult.dataState === "streaming") pushNotification({
                    kind: "N",
                    source: "network",
                    value: {
                        ...lastResult,
                        dataState: "complete",
                        networkStatus: (0, $28ed6ef232a84776$export$bd096ddbd246c79c).ready
                    }
                });
                else pushNotification({
                    kind: "N",
                    source: "newNetworkStatus",
                    value: {}
                }, {
                    shouldEmit: 1 /* EmitBehavior.force */ 
                });
            }
        }));
    }
    // XXX the subscription variables are separate from the query variables.
    // if you want to update subscription variables, right now you have to do that separately,
    // and you can only do it by stopping the subscription and then subscribing again with new variables.
    /**
     * A function that enables you to execute a [subscription](https://www.apollographql.com/docs/react/data/subscriptions/), usually to subscribe to specific fields that were included in the query.
     *
     * This function returns _another_ function that you can call to terminate the subscription.
     */ subscribeToMore(options) {
        const subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context
        }).subscribe({
            next: (subscriptionData)=>{
                const { updateQuery: updateQuery, onError: onError } = options;
                const { error: error } = subscriptionData;
                if (error) {
                    if (onError) onError(error);
                    else (0, $aa2d7231b5e28112$export$f5708dca728d7177).error(84, error);
                    return;
                }
                if (updateQuery) this.updateQuery((previous, updateOptions)=>updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        ...updateOptions
                    }));
            }
        });
        this.subscriptions.add(subscription);
        return ()=>{
            if (this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    }
    /**
    * @internal
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */ applyOptions(newOptions) {
        const mergedOptions = (0, $8e62f7547d3f557e$export$8e16b83750b44988)(this.options, newOptions || {});
        $1724141f75044c6b$var$assign(this.options, mergedOptions);
        this.updatePolling();
    }
    /**
     * Update the variables of this observable query, and fetch the new results
     * if they've changed. Most users should prefer `refetch` instead of
     * `setVariables` in order to to be properly notified of results even when
     * they come from the cache.
     *
     * Note: `setVariables()` guarantees that a value will be emitted from the
     * observable, even if the result is deeply equal to the previous value.
     *
     * Note: the promise will resolve with the last emitted result
     * when either the variables match the current variables or there
     * are no subscribers to the query.
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ async setVariables(variables) {
        variables = this.getVariablesWithDefaults(variables);
        if ((0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(this.variables, variables)) // If we have no observers, then we don't actually want to make a network
        // request. As soon as someone observes the query, the request will kick
        // off. For now, we just store any changes. (See #1077)
        return (0, $7df42a60a8344f21$export$de3acc9431f1695e)(this.getCurrentResult());
        this.options.variables = variables;
        // See comment above
        if (!this.hasObservers()) return (0, $7df42a60a8344f21$export$de3acc9431f1695e)(this.getCurrentResult());
        return this._reobserve({
            // Reset options.fetchPolicy to its original value.
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables
        }, {
            newNetworkStatus: (0, $28ed6ef232a84776$export$bd096ddbd246c79c).setVariables
        });
    }
    /**
     * A function that enables you to update the query's cached result without executing a followup GraphQL operation.
     *
     * See [using updateQuery and updateFragment](https://www.apollographql.com/docs/react/caching/cache-interaction/#using-updatequery-and-updatefragment) for additional information.
     */ updateQuery(mapFn) {
        const { queryManager: queryManager } = this;
        const { result: result, complete: complete } = this.getCacheDiff({
            optimistic: false
        });
        const newResult = mapFn(result, {
            variables: this.variables,
            complete: !!complete,
            previousData: result
        });
        if (newResult) {
            this.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables
            });
            queryManager.broadcastQueries();
        }
    }
    /**
     * A function that instructs the query to begin re-executing at a specified interval (in milliseconds).
     */ startPolling(pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    }
    /**
     * A function that instructs the query to stop polling after a previous call to `startPolling`.
     */ stopPolling() {
        this.options.pollInterval = 0;
        this.updatePolling();
    }
    // Update options.fetchPolicy according to options.nextFetchPolicy.
    applyNextFetchPolicy(reason, // It's possible to use this method to apply options.nextFetchPolicy to
    // options.fetchPolicy even if options !== this.options, though that happens
    // most often when the options are temporary, used for only one request and
    // then thrown away, so nextFetchPolicy may not end up mattering.
    options) {
        if (options.nextFetchPolicy) {
            const { fetchPolicy: fetchPolicy = "cache-first", initialFetchPolicy: initialFetchPolicy = fetchPolicy } = options;
            if (fetchPolicy === "standby") ;
            else if (typeof options.nextFetchPolicy === "function") // When someone chooses "cache-and-network" or "network-only" as their
            // initial FetchPolicy, they often do not want future cache updates to
            // trigger unconditional network requests, which is what repeatedly
            // applying the "cache-and-network" or "network-only" policies would
            // seem to imply. Instead, when the cache reports an update after the
            // initial network request, it may be desirable for subsequent network
            // requests to be triggered only if the cache result is incomplete. To
            // that end, the options.nextFetchPolicy option provides an easy way to
            // update options.fetchPolicy after the initial network request, without
            // having to call observableQuery.reobserve.
            options.fetchPolicy = options.nextFetchPolicy.call(options, fetchPolicy, {
                reason: reason,
                options: options,
                observable: this,
                initialFetchPolicy: initialFetchPolicy
            });
            else if (reason === "variables-changed") options.fetchPolicy = initialFetchPolicy;
            else options.fetchPolicy = options.nextFetchPolicy;
        }
        return options.fetchPolicy;
    }
    fetch(options, networkStatus, fetchQuery, operator) {
        // TODO Make sure we update the networkStatus (and infer fetchVariables)
        // before actually committing to the fetch.
        const initialFetchPolicy = this.options.fetchPolicy;
        options.context ??= {};
        let synchronouslyEmitted = false;
        const onCacheHit = ()=>{
            synchronouslyEmitted = true;
        };
        const fetchQueryOperator = // hook with `subscribe` and we care for "directly before and after subscription"
        (source)=>new (0, $23f68ab689e21470$export$77cea355fa80b5f4)((subscriber)=>{
                try {
                    return source.subscribe({
                        next (value) {
                            synchronouslyEmitted = true;
                            subscriber.next(value);
                        },
                        error: (error)=>subscriber.error(error),
                        complete: ()=>subscriber.complete()
                    });
                } finally{
                    if (!synchronouslyEmitted) {
                        operation.override = networkStatus;
                        this.input.next({
                            kind: "N",
                            source: "newNetworkStatus",
                            value: {
                                resetError: true
                            },
                            query: query,
                            variables: variables,
                            meta: {
                                shouldEmit: 3 /* EmitBehavior.networkStatusChange */ ,
                                /*
                             * The moment this notification is emitted, `nextFetchPolicy`
                             * might already have switched from a `network-only` to a
                             * `cache-something` policy, so we want to ensure that the
                             * loading state emit doesn't accidentally read from the cache
                             * in those cases.
                             */ fetchPolicy: initialFetchPolicy
                            }
                        });
                    }
                }
            });
        let { observable: observable, fromLink: fromLink } = this.queryManager.fetchObservableWithInfo(options, {
            networkStatus: networkStatus,
            query: fetchQuery,
            onCacheHit: onCacheHit,
            fetchQueryOperator: fetchQueryOperator,
            observableQuery: this
        });
        // track query and variables from the start of the operation
        const { query: query, variables: variables } = this;
        const operation = {
            abort: ()=>{
                subscription.unsubscribe();
            },
            query: query,
            variables: variables
        };
        this.activeOperations.add(operation);
        let forceFirstValueEmit = networkStatus == (0, $28ed6ef232a84776$export$bd096ddbd246c79c).refetch || networkStatus == (0, $28ed6ef232a84776$export$bd096ddbd246c79c).setVariables;
        observable = observable.pipe(operator, (0, $590f717384cd71b5$export$ed80d9de1d9df928)());
        const subscription = observable.pipe((0, $074c390243aea0da$export$3f23594af5f37336)({
            next: (notification)=>{
                if (notification.source === "newNetworkStatus" || notification.kind === "N" && notification.value.loading) operation.override = networkStatus;
                else delete operation.override;
            },
            finalize: ()=>this.activeOperations.delete(operation)
        })).subscribe({
            next: (value)=>{
                const meta = {};
                if (forceFirstValueEmit && value.kind === "N" && "loading" in value.value && !value.value.loading) {
                    forceFirstValueEmit = false;
                    meta.shouldEmit = 1 /* EmitBehavior.force */ ;
                }
                this.input.next({
                    ...value,
                    query: query,
                    variables: variables,
                    meta: meta
                });
            }
        });
        return {
            fromLink: fromLink,
            subscription: subscription,
            observable: observable
        };
    }
    // Turns polling on or off based on this.options.pollInterval.
    didWarnCacheOnlyPolling = false;
    updatePolling() {
        // Avoid polling in SSR mode
        if (this.queryManager.ssrMode) return;
        const { pollingInfo: pollingInfo, options: { fetchPolicy: fetchPolicy, pollInterval: pollInterval } } = this;
        const shouldCancelPolling = ()=>{
            const { options: options } = this;
            return !options.pollInterval || !this.hasObservers() || options.fetchPolicy === "cache-only" || options.fetchPolicy === "standby";
        };
        if (shouldCancelPolling()) {
            if (0, $e15192e15b3ad6c1$export$a866f231438cc228) {
                if (!this.didWarnCacheOnlyPolling && pollInterval && fetchPolicy === "cache-only") {
                    (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).warn(85, (0, $3ed2520e139df5b6$export$41bca9dc6871dd4e)(this.query, "(anonymous)"));
                    this.didWarnCacheOnlyPolling = true;
                }
            }
            this.cancelPolling();
            return;
        }
        if (pollingInfo?.interval === pollInterval) return;
        const info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        const maybeFetch = ()=>{
            // defense against options changing after the setTimeout changes in case
            // the call site forgets to call cancelPolling
            if (shouldCancelPolling()) return this.cancelPolling();
            if (this.pollingInfo) {
                if (!(0, $9311d187008787b8$export$37509604341a3464)(this.networkStatus) && !this.options.skipPollAttempt?.()) this._reobserve({
                    // Most fetchPolicy options don't make sense to use in a polling context, as
                    // users wouldn't want to be polling the cache directly. However, network-only and
                    // no-cache are both useful for when the user wants to control whether or not the
                    // polled results are written to the cache.
                    fetchPolicy: this.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
                }, {
                    newNetworkStatus: (0, $28ed6ef232a84776$export$bd096ddbd246c79c).poll
                }).then(poll, poll);
                else poll();
            }
        };
        const poll = ()=>{
            const info = this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    }
    // This differs from stopPolling in that it does not set pollInterval to 0
    cancelPolling() {
        if (this.pollingInfo) {
            clearTimeout(this.pollingInfo.timeout);
            delete this.pollingInfo;
        }
    }
    /**
     * Reevaluate the query, optionally against new options. New options will be
     * merged with the current options when given.
     *
     * Note: `variables` can be reset back to their defaults (typically empty) by calling `reobserve` with
     * `variables: undefined`.
     */ reobserve(newOptions) {
        return this._reobserve(newOptions);
    }
    _reobserve(newOptions, internalOptions) {
        this.isTornDown = false;
        let { newNetworkStatus: newNetworkStatus } = internalOptions || {};
        this.queryManager.obsQueries.add(this);
        const useDisposableObservable = // Refetching uses a disposable Observable to allow refetches using different
        // options, without permanently altering the options of the
        // original ObservableQuery.
        newNetworkStatus === (0, $28ed6ef232a84776$export$bd096ddbd246c79c).refetch || // Polling uses a disposable Observable so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        newNetworkStatus === (0, $28ed6ef232a84776$export$bd096ddbd246c79c).poll;
        // Save the old variables, since Object.assign may modify them below.
        const oldVariables = this.variables;
        const oldFetchPolicy = this.options.fetchPolicy;
        const mergedOptions = (0, $8e62f7547d3f557e$export$8e16b83750b44988)(this.options, newOptions || {});
        // This request will hit the network, so even if there are no variables,
        // we now know that's intentional. (see #12996)
        // Even if that happens only once, we want `variablesUnknown` to stay false permanently.
        this.variablesUnknown &&= mergedOptions.fetchPolicy === "standby";
        const options = useDisposableObservable ? // Disposable Observable fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        mergedOptions : $1724141f75044c6b$var$assign(this.options, mergedOptions);
        // Don't update options.query with the transformed query to avoid
        // overwriting this.options.query when we aren't using a disposable concast.
        // We want to ensure we can re-run the custom document transforms the next
        // time a request is made against the original query.
        const query = this.transformDocument(options.query);
        this.lastQuery = query;
        // Reevaluate variables to allow resetting variables with variables: undefined,
        // otherwise `compact` will ignore the `variables` key in `newOptions`. We
        // do this after we run the query transform to ensure we get default
        // variables from the transformed query.
        //
        // Note: updating options.variables may mutate this.options.variables
        // in the case of a non-disposable query. This is intentional.
        if (newOptions && "variables" in newOptions) options.variables = this.getVariablesWithDefaults(newOptions.variables);
        if (!useDisposableObservable) {
            // We can skip calling updatePolling if we're not changing this.options.
            this.updatePolling();
            // Reset options.fetchPolicy to its original value when variables change,
            // unless a new fetchPolicy was provided by newOptions.
            if (newOptions && newOptions.variables && !(0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(newOptions.variables, oldVariables) && // Don't mess with the fetchPolicy if it's currently "standby".
            options.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
            // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
            (options.fetchPolicy === oldFetchPolicy || // A `nextFetchPolicy` function has even higher priority, though,
            // so in that case `applyNextFetchPolicy` must be called.
            typeof options.nextFetchPolicy === "function")) {
                // This might mutate options.fetchPolicy
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) newNetworkStatus = (0, $28ed6ef232a84776$export$bd096ddbd246c79c).setVariables;
            }
        }
        const oldNetworkStatus = this.networkStatus;
        if (!newNetworkStatus) {
            newNetworkStatus = (0, $28ed6ef232a84776$export$bd096ddbd246c79c).loading;
            if (oldNetworkStatus !== (0, $28ed6ef232a84776$export$bd096ddbd246c79c).loading && newOptions?.variables && !(0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(newOptions.variables, oldVariables)) newNetworkStatus = (0, $28ed6ef232a84776$export$bd096ddbd246c79c).setVariables;
            // QueryManager does not emit any values for standby fetch policies so we
            // want ensure that the networkStatus remains ready.
            if (options.fetchPolicy === "standby") newNetworkStatus = (0, $28ed6ef232a84776$export$bd096ddbd246c79c).ready;
        }
        if (options.fetchPolicy === "standby") this.cancelPolling();
        this.resubscribeCache();
        const { promise: promise, operator: promiseOperator } = $1724141f75044c6b$var$getTrackingOperatorPromise(// This default value should only be used when using a `fetchPolicy` of
        // `standby` since that fetch policy completes without emitting a
        // result. Since we are converting this to a QueryResult type, we
        // omit the extra fields from ApolloQueryResult in the default value.
        options.fetchPolicy === "standby" ? {
            data: undefined
        } : undefined);
        const { subscription: subscription, observable: observable, fromLink: fromLink } = this.fetch(options, newNetworkStatus, query, promiseOperator);
        if (!useDisposableObservable && (fromLink || !this.linkSubscription)) {
            if (this.linkSubscription) this.linkSubscription.unsubscribe();
            this.linkSubscription = subscription;
        }
        const ret = Object.assign((0, $eec24d8374c011ae$export$7ff41c6e01127226)(promise.then((result)=>(0, $7df42a60a8344f21$export$de3acc9431f1695e)(this.maskResult(result))).finally(()=>{
            if (!this.hasObservers() && this.activeOperations.size === 0) // If `reobserve` was called on a query without any observers,
            // the teardown logic would never be called, so we need to
            // call it here to ensure the query is properly torn down.
            this.tearDownQuery();
        })), {
            retain: ()=>{
                const subscription = observable.subscribe({});
                const unsubscribe = ()=>subscription.unsubscribe();
                promise.then(unsubscribe, unsubscribe);
                return ret;
            }
        });
        return ret;
    }
    hasObservers() {
        return this.subject.observed;
    }
    /**
     * Tears down the `ObservableQuery` and stops all active operations by sending a `complete` notification.
     */ stop() {
        this.subject.complete();
        this.initializeObservablesQueue();
        this.tearDownQuery();
    }
    tearDownQuery() {
        if (this.isTornDown) return;
        this.resetNotifications();
        this.unsubscribeFromCache?.();
        if (this.linkSubscription) {
            this.linkSubscription.unsubscribe();
            delete this.linkSubscription;
        }
        this.stopPolling();
        // stop all active GraphQL subscriptions
        this.subscriptions.forEach((sub)=>sub.unsubscribe());
        this.subscriptions.clear();
        this.queryManager.obsQueries.delete(this);
        this.isTornDown = true;
        this.abortActiveOperations();
        this._lastWrite = undefined;
    }
    transformDocument(document) {
        return this.queryManager.transform(document);
    }
    maskResult(result) {
        const masked = this.queryManager.maskOperation({
            document: this.query,
            data: result.data,
            fetchPolicy: this.options.fetchPolicy,
            cause: this
        });
        // Maintain object identity as much as possible
        return masked === result.data ? result : {
            ...result,
            data: masked
        };
    }
    dirty = false;
    notifyTimeout;
    /**
    * @internal
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */ resetNotifications() {
        if (this.notifyTimeout) {
            clearTimeout(this.notifyTimeout);
            this.notifyTimeout = void 0;
        }
        this.dirty = false;
    }
    /**
    * @internal
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */ scheduleNotify() {
        if (this.dirty) return;
        this.dirty = true;
        if (!this.notifyTimeout) this.notifyTimeout = setTimeout(()=>this.notify(true), 0);
    }
    /**
    * @internal
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */ notify(scheduled = false) {
        if (!scheduled) {
            // For queries with client exports or forced resolvers, we don't want to
            // synchronously reobserve the cache on broadcast,
            // but actually wait for the `scheduleNotify` timeout triggered by the
            // `cache.watch` callback from `resubscribeCache`.
            const info = this.queryManager.getDocumentInfo(this.query);
            if (info.hasClientExports || info.hasForcedResolvers) return;
        }
        const { dirty: dirty } = this;
        this.resetNotifications();
        if (dirty && (this.options.fetchPolicy === "cache-only" || this.options.fetchPolicy === "cache-and-network" || !this.activeOperations.size)) {
            const diff = this.getCacheDiff();
            if (// `fromOptimisticTransaction` is not available through the `cache.diff`
            // code path, so we need to check it this way
            (0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(diff.result, this.getCacheDiff({
                optimistic: false
            }).result)) //If this diff did not come from an optimistic transaction
            // make the ObservableQuery "reobserve" the latest data
            // using a temporary fetch policy of "cache-first", so complete cache
            // results have a chance to be delivered without triggering additional
            // network requests, even when options.fetchPolicy is "network-only"
            // or "cache-and-network". All other fetch policies are preserved by
            // this method, and are handled by calling oq.reobserve(). If this
            // reobservation is spurious, distinctUntilChanged still has a
            // chance to catch it before delivery to ObservableQuery subscribers.
            this.reobserveCacheFirst();
            else // If this diff came from an optimistic transaction, deliver the
            // current cache data to the ObservableQuery, but don't perform a
            // reobservation, since oq.reobserveCacheFirst might make a network
            // request, and we never want to trigger network requests in the
            // middle of optimistic updates.
            this.input.next({
                kind: "N",
                value: {
                    data: diff.result,
                    dataState: diff.complete ? "complete" : diff.result ? "partial" : "empty",
                    networkStatus: (0, $28ed6ef232a84776$export$bd096ddbd246c79c).ready,
                    loading: false,
                    error: undefined,
                    partial: !diff.complete
                },
                source: "cache",
                query: this.query,
                variables: this.variables,
                meta: {}
            });
        }
    }
    activeOperations = new Set();
    pushOperation(networkStatus) {
        let aborted = false;
        // track query and variables from the start of the operation
        const { query: query, variables: variables } = this;
        const finalize = ()=>{
            this.activeOperations.delete(operation);
        };
        const operation = {
            override: networkStatus,
            abort: ()=>{
                aborted = true;
                finalize();
            },
            query: query,
            variables: variables
        };
        this.activeOperations.add(operation);
        return {
            finalize: finalize,
            pushNotification: (notification, additionalMeta)=>{
                if (!aborted) this.input.next({
                    ...notification,
                    query: query,
                    variables: variables,
                    meta: {
                        ...additionalMeta
                    }
                });
            }
        };
    }
    calculateNetworkStatus(baseNetworkStatus) {
        if (baseNetworkStatus === (0, $28ed6ef232a84776$export$bd096ddbd246c79c).streaming) return baseNetworkStatus;
        // in the future, this could be more complex logic, e.g. "refetch" and
        // "fetchMore" having priority over "polling" or "loading" network statuses
        // as for now we just take the "latest" operation that is still active,
        // as that lines up best with previous behavior[]
        const operation = Array.from(this.activeOperations.values()).reverse().find((operation)=>$1724141f75044c6b$var$isEqualQuery(operation, this) && operation.override !== undefined);
        return operation?.override ?? baseNetworkStatus;
    }
    abortActiveOperations() {
        this.activeOperations.forEach((operation)=>operation.abort());
    }
    /**
    * @internal
    * Called from `clearStore`.
    *
    * - resets the query to its initial state
    * - cancels all active operations and their subscriptions
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */ reset() {
        // exception for cache-only queries - we reset them into a "ready" state
        // as we won't trigger a refetch for them
        const resetToEmpty = this.options.fetchPolicy === "cache-only";
        this.setResult(resetToEmpty ? $1724141f75044c6b$var$empty : $1724141f75044c6b$var$uninitialized, {
            shouldEmit: resetToEmpty ? 1 /* EmitBehavior.force */  : 2 /* EmitBehavior.never */ 
        });
        this.abortActiveOperations();
    }
    /**
    * @internal
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */ setResult(result, additionalMeta) {
        this.input.next({
            source: "setResult",
            kind: "N",
            value: result,
            query: this.query,
            variables: this.variables,
            meta: {
                ...additionalMeta
            }
        });
    }
    operator = (0, $4b985f1bcf049783$export$a04c6c6965dd4709)((notification)=>{
        const { query: query, variables: variables, meta: meta } = notification;
        if (notification.source === "setResult") return {
            query: query,
            variables: variables,
            result: notification.value,
            meta: meta
        };
        if (notification.kind === "C" || !$1724141f75044c6b$var$isEqualQuery(notification, this)) return;
        let result;
        const previous = this.subject.getValue();
        if (notification.source === "cache") {
            result = notification.value;
            if (result.networkStatus === (0, $28ed6ef232a84776$export$bd096ddbd246c79c).ready && result.partial && (!this.options.returnPartialData || previous.result.networkStatus === (0, $28ed6ef232a84776$export$bd096ddbd246c79c).error) && this.options.fetchPolicy !== "cache-only") return;
        } else if (notification.source === "network") {
            if (this.waitForNetworkResult) {
                this.waitForNetworkResult = false;
                this.resubscribeCache();
            }
            result = notification.kind === "E" ? {
                ...$1724141f75044c6b$var$isEqualQuery(previous, notification) ? previous.result : {
                    data: undefined,
                    dataState: "empty",
                    partial: true
                },
                error: notification.error,
                networkStatus: (0, $28ed6ef232a84776$export$bd096ddbd246c79c).error,
                loading: false
            } : notification.value;
            if (notification.kind === "E" && result.dataState === "streaming") result.dataState = "complete";
            if (result.error) meta.shouldEmit = 1 /* EmitBehavior.force */ ;
        } else if (notification.source === "newNetworkStatus") {
            const baseResult = $1724141f75044c6b$var$isEqualQuery(previous, notification) ? previous.result : this.getInitialResult(meta.fetchPolicy);
            const { resetError: resetError } = notification.value;
            const error = resetError ? undefined : baseResult.error;
            const networkStatus = error ? (0, $28ed6ef232a84776$export$bd096ddbd246c79c).error : (0, $28ed6ef232a84776$export$bd096ddbd246c79c).ready;
            result = {
                ...baseResult,
                error: error,
                networkStatus: networkStatus
            };
        }
        // every code path until here should have either returned or set a result,
        // but typescript needs a little help
        (0, $aa2d7231b5e28112$export$f5708dca728d7177)(result);
        // normalize result shape
        if (!result.error) delete result.error;
        result.networkStatus = this.calculateNetworkStatus(result.networkStatus);
        result.loading = (0, $9311d187008787b8$export$37509604341a3464)(result.networkStatus);
        result = this.maskResult(result);
        return {
            query: query,
            variables: variables,
            result: result,
            meta: meta
        };
    });
    // Reobserve with fetchPolicy effectively set to "cache-first", triggering
    // delivery of any new data from the cache, possibly falling back to the network
    // if any cache data are missing. This allows _complete_ cache results to be
    // delivered without also kicking off unnecessary network requests when
    // this.options.fetchPolicy is "cache-and-network" or "network-only". When
    // this.options.fetchPolicy is any other policy ("cache-first", "cache-only",
    // "standby", or "no-cache"), we call this.reobserve() as usual.
    reobserveCacheFirst() {
        const { fetchPolicy: fetchPolicy, nextFetchPolicy: nextFetchPolicy } = this.options;
        if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") this.reobserve({
            fetchPolicy: "cache-first",
            // Use a temporary nextFetchPolicy function that replaces itself with the
            // previous nextFetchPolicy value and returns the original fetchPolicy.
            nextFetchPolicy (currentFetchPolicy, context) {
                // Replace this nextFetchPolicy function in the options object with the
                // original this.options.nextFetchPolicy value.
                this.nextFetchPolicy = nextFetchPolicy;
                // If the original nextFetchPolicy value was a function, give it a
                // chance to decide what happens here.
                if (typeof this.nextFetchPolicy === "function") return this.nextFetchPolicy(currentFetchPolicy, context);
                // Otherwise go back to the original this.options.fetchPolicy.
                return fetchPolicy;
            }
        });
        else this.reobserve();
    }
    getVariablesWithDefaults(variables) {
        return this.queryManager.getVariables(this.query, variables);
    }
}
function $1724141f75044c6b$export$b7e1973aacac3ae7(missing) {
    if ((0, $e15192e15b3ad6c1$export$a866f231438cc228) && missing) (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).debug(86, missing);
}
function $1724141f75044c6b$var$isEqualQuery(a, b) {
    return !!(a && b && a.query === b.query && (0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(a.variables, b.variables));
}
function $1724141f75044c6b$var$getTrackingOperatorPromise(defaultValue) {
    let lastValue = defaultValue, resolve, reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    const operator = (0, $074c390243aea0da$export$3f23594af5f37336)({
        next (value) {
            if (value.kind === "E") return reject(value.error);
            if (value.kind === "N" && value.source !== "newNetworkStatus" && !value.value.loading) lastValue = value.value;
        },
        finalize: ()=>{
            if (lastValue) resolve(lastValue);
            else {
                const message = "The operation was aborted.";
                const name = "AbortError";
                reject(typeof DOMException !== "undefined" ? new DOMException(message, name) : Object.assign(new Error(message), {
                    name: name
                }));
            }
        }
    });
    return {
        promise: promise,
        operator: operator
    };
}





const $ceb95b2ee67b0239$var$IGNORE = {};
const $ceb95b2ee67b0239$var$destructiveMethodCounts = new WeakMap();
function $ceb95b2ee67b0239$var$wrapDestructiveCacheMethod(cache, methodName) {
    const original = cache[methodName];
    if (typeof original === "function") // @ts-expect-error this is just too generic to be typed correctly
    cache[methodName] = function() {
        $ceb95b2ee67b0239$var$destructiveMethodCounts.set(cache, // The %1e15 allows the count to wrap around to 0 safely every
        // quadrillion evictions, so there's no risk of overflow. To be
        // clear, this is more of a pedantic principle than something
        // that matters in any conceivable practical scenario.
        ($ceb95b2ee67b0239$var$destructiveMethodCounts.get(cache) + 1) % 1e15);
        // @ts-expect-error this is just too generic to be typed correctly
        return original.apply(this, arguments);
    };
}
const $ceb95b2ee67b0239$var$queryInfoIds = new WeakMap();
class $ceb95b2ee67b0239$export$79a6120a39c90b6a {
    // TODO remove soon - this should be able to be handled by cancelling old operations before starting new ones
    lastRequestId = 1;
    cache;
    queryManager;
    id;
    observableQuery;
    incremental;
    constructor(queryManager, observableQuery){
        const cache = this.cache = queryManager.cache;
        const id = ($ceb95b2ee67b0239$var$queryInfoIds.get(queryManager) || 0) + 1;
        $ceb95b2ee67b0239$var$queryInfoIds.set(queryManager, id);
        this.id = id + "";
        this.observableQuery = observableQuery;
        this.queryManager = queryManager;
        // Track how often cache.evict is called, since we want eviction to
        // override the feud-stopping logic in the markQueryResult method, by
        // causing shouldWrite to return true. Wrapping the cache.evict method
        // is a bit of a hack, but it saves us from having to make eviction
        // counting an official part of the ApolloCache API.
        if (!$ceb95b2ee67b0239$var$destructiveMethodCounts.has(cache)) {
            $ceb95b2ee67b0239$var$destructiveMethodCounts.set(cache, 0);
            $ceb95b2ee67b0239$var$wrapDestructiveCacheMethod(cache, "evict");
            $ceb95b2ee67b0239$var$wrapDestructiveCacheMethod(cache, "modify");
            $ceb95b2ee67b0239$var$wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    /**
    * @internal
    * For feud-preventing behaviour, `lastWrite` should be shared by all `QueryInfo` instances of an `ObservableQuery`.
    * In the case of a standalone `QueryInfo`, we will keep a local version.
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */ _lastWrite;
    get lastWrite() {
        return (this.observableQuery || this)._lastWrite;
    }
    set lastWrite(value) {
        (this.observableQuery || this)._lastWrite = value;
    }
    resetLastWrite() {
        this.lastWrite = void 0;
    }
    shouldWrite(result, variables) {
        const { lastWrite: lastWrite } = this;
        return !(lastWrite && // If cache.evict has been called since the last time we wrote this
        // data into the cache, there's a chance writing this result into
        // the cache will repair what was evicted.
        lastWrite.dmCount === $ceb95b2ee67b0239$var$destructiveMethodCounts.get(this.cache) && (0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(variables, lastWrite.variables) && (0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(result.data, lastWrite.result.data) && // We have to compare these values because its possible the final chunk
        // emitted in the incremental result is just `hasNext: false`. This
        // ensures we trigger a cache write when we get `isLastChunk: true`.
        result.extensions?.[0, $16b2c739aa564ddd$export$e49e8c01e90ecf85] === lastWrite.result.extensions?.[0, $16b2c739aa564ddd$export$e49e8c01e90ecf85]);
    }
    get hasNext() {
        return this.incremental ? this.incremental.hasNext : false;
    }
    maybeHandleIncrementalResult(cacheData, incoming, query) {
        const { incrementalHandler: incrementalHandler } = this.queryManager;
        if (incrementalHandler.isIncrementalResult(incoming)) {
            this.incremental ||= incrementalHandler.startRequest({
                query: query
            });
            return this.incremental.handle(cacheData, incoming);
        }
        return incoming;
    }
    markQueryResult(incoming, { document: query, variables: variables, errorPolicy: errorPolicy, cacheWriteBehavior: cacheWriteBehavior }) {
        const diffOptions = {
            query: query,
            variables: variables,
            returnPartialData: true,
            optimistic: true
        };
        // Cancel the pending notify timeout (if it exists) to prevent extraneous network
        // requests. To allow future notify timeouts, diff and dirty are reset as well.
        this.observableQuery?.["resetNotifications"]();
        const skipCache = cacheWriteBehavior === 0 /* CacheWriteBehavior.FORBID */ ;
        const lastDiff = skipCache ? undefined : this.cache.diff(diffOptions);
        let result = this.maybeHandleIncrementalResult(lastDiff?.result, incoming, query);
        if (skipCache) return result;
        if ($ceb95b2ee67b0239$var$shouldWriteResult(result, errorPolicy)) // Using a transaction here so we have a chance to read the result
        // back from the cache before the watch callback fires as a result
        // of writeQuery, so we can store the new diff quietly and ignore
        // it when we receive it redundantly from the watch callback.
        this.cache.batch({
            onWatchUpdated: (// all additional options on ObservableQuery.CacheWatchOptions are
            // optional so we can use the type here
            watch, diff)=>{
                if (watch.watcher === this.observableQuery) // see comment on `lastOwnDiff` for explanation
                watch.lastOwnDiff = diff;
            },
            update: (cache)=>{
                if (this.shouldWrite(result, variables)) {
                    cache.writeQuery({
                        query: query,
                        data: result.data,
                        variables: variables,
                        overwrite: cacheWriteBehavior === 1 /* CacheWriteBehavior.OVERWRITE */ ,
                        extensions: result.extensions
                    });
                    this.lastWrite = {
                        result: result,
                        variables: variables,
                        dmCount: $ceb95b2ee67b0239$var$destructiveMethodCounts.get(this.cache)
                    };
                } else // If result is the same as the last result we received from
                // the network (and the variables match too), avoid writing
                // result into the cache again. The wisdom of skipping this
                // cache write is far from obvious, since any cache write
                // could be the one that puts the cache back into a desired
                // state, fixing corruption or missing data. However, if we
                // always write every network result into the cache, we enable
                // feuds between queries competing to update the same data in
                // incompatible ways, which can lead to an endless cycle of
                // cache broadcasts and useless network requests. As with any
                // feud, eventually one side must step back from the brink,
                // letting the other side(s) have the last word(s). There may
                // be other points where we could break this cycle, such as
                // silencing the broadcast for cache.writeQuery (not a good
                // idea, since it just delays the feud a bit) or somehow
                // avoiding the network request that just happened (also bad,
                // because the server could return useful new data). All
                // options considered, skipping this cache write seems to be
                // the least damaging place to break the cycle, because it
                // reflects the intuition that we recently wrote this exact
                // result into the cache, so the cache *should* already/still
                // contain this data. If some other query has clobbered that
                // data in the meantime, that's too bad, but there will be no
                // winners if every query blindly reverts to its own version
                // of the data. This approach also gives the network a chance
                // to return new data, which will be written into the cache as
                // usual, notifying only those queries that are directly
                // affected by the cache updates, as usual. In the future, an
                // even more sophisticated cache could perhaps prevent or
                // mitigate the clobbering somehow, but that would make this
                // particular cache write even less important, and thus
                // skipping it would be even safer than it is today.
                if (lastDiff && lastDiff.complete) {
                    // Reuse data from the last good (complete) diff that we
                    // received, when possible.
                    result = {
                        ...result,
                        data: lastDiff.result
                    };
                    return;
                }
                const diff = cache.diff(diffOptions);
                // If we're allowed to write to the cache, and we can read a
                // complete result from the cache, update result.data to be the
                // result from the cache, rather than the raw network result.
                // Set without setDiff to avoid triggering a notify call, since
                // we have other ways of notifying for this result.
                if (diff.complete) result = {
                    ...result,
                    data: diff.result
                };
            }
        });
        else this.lastWrite = void 0;
        return result;
    }
    markMutationResult(incoming, mutation, cache = this.cache) {
        const cacheWrites = [];
        const skipCache = mutation.cacheWriteBehavior === 0 /* CacheWriteBehavior.FORBID */ ;
        let result = this.maybeHandleIncrementalResult(skipCache ? undefined : cache.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.queryManager.getDocumentInfo(mutation.document).asQuery,
            variables: mutation.variables,
            optimistic: false,
            returnPartialData: true
        }).result, incoming, mutation.document);
        if (mutation.errorPolicy === "ignore") result = {
            ...result,
            errors: []
        };
        if ((0, $c31535aa3b39d468$export$b4df399e879e53ab)(result) && mutation.errorPolicy === "none") return Promise.resolve(result);
        const getResultWithDataState = ()=>({
                ...result,
                dataState: this.hasNext ? "streaming" : "complete"
            });
        if (!skipCache && $ceb95b2ee67b0239$var$shouldWriteResult(result, mutation.errorPolicy)) {
            cacheWrites.push({
                result: result.data,
                dataId: "ROOT_MUTATION",
                query: mutation.document,
                variables: mutation.variables,
                extensions: result.extensions
            });
            const { updateQueries: updateQueries } = mutation;
            if (updateQueries) this.queryManager.getObservableQueries("all").forEach((observableQuery)=>{
                const queryName = observableQuery && observableQuery.queryName;
                if (!queryName || !Object.hasOwnProperty.call(updateQueries, queryName)) return;
                const updater = updateQueries[queryName];
                const { query: document, variables: variables } = observableQuery;
                // Read the current query result from the store.
                const { result: currentQueryResult, complete: complete } = observableQuery.getCacheDiff({
                    optimistic: false
                });
                if (complete && currentQueryResult) {
                    // Run our reducer using the current query result and the mutation result.
                    const nextQueryResult = updater(currentQueryResult, {
                        mutationResult: getResultWithDataState(),
                        queryName: document && (0, $3ed2520e139df5b6$export$41bca9dc6871dd4e)(document) || void 0,
                        queryVariables: variables
                    });
                    // Write the modified result back into the store if we got a new result.
                    if (nextQueryResult) cacheWrites.push({
                        result: nextQueryResult,
                        dataId: "ROOT_QUERY",
                        query: document,
                        variables: variables
                    });
                }
            });
        }
        let refetchQueries = mutation.refetchQueries;
        if (typeof refetchQueries === "function") refetchQueries = refetchQueries(getResultWithDataState());
        if (cacheWrites.length > 0 || (refetchQueries || "").length > 0 || mutation.update || mutation.onQueryUpdated || mutation.removeOptimistic) {
            const results = [];
            this.queryManager.refetchQueries({
                updateCache: (cache)=>{
                    if (!skipCache) cacheWrites.forEach((write)=>cache.write(write));
                    // If the mutation has some writes associated with it then we need to
                    // apply those writes to the store by running this reducer again with
                    // a write action.
                    const { update: update } = mutation;
                    // Determine whether result is a SingleExecutionResult,
                    // or the final ExecutionPatchResult.
                    if (update) {
                        if (!skipCache) {
                            // Re-read the ROOT_MUTATION data we just wrote into the cache
                            // (the first cache.write call in the cacheWrites.forEach loop
                            // above), so field read functions have a chance to run for
                            // fields within mutation result objects.
                            const diff = cache.diff({
                                id: "ROOT_MUTATION",
                                // The cache complains if passed a mutation where it expects a
                                // query, so we transform mutations and subscriptions to queries
                                // (only once, thanks to this.transformCache).
                                query: this.queryManager.getDocumentInfo(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true
                            });
                            if (diff.complete) result = {
                                ...result,
                                data: diff.result
                            };
                        }
                        // If we've received the whole response, call the update function.
                        if (!this.hasNext) update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables
                        });
                    }
                    // TODO Do this with cache.evict({ id: 'ROOT_MUTATION' }) but make it
                    // shallow to allow rolling back optimistic evictions.
                    if (!skipCache && !mutation.keepRootFields && !this.hasNext) cache.modify({
                        id: "ROOT_MUTATION",
                        fields (value, { fieldName: fieldName, DELETE: DELETE }) {
                            return fieldName === "__typename" ? value : DELETE;
                        }
                    });
                },
                include: refetchQueries,
                // Write the final mutation.result to the root layer of the cache.
                optimistic: false,
                // Remove the corresponding optimistic layer at the same time as we
                // write the final non-optimistic result.
                removeOptimistic: mutation.removeOptimistic,
                // Let the caller of client.mutate optionally determine the refetching
                // behavior for watched queries after the mutation.update function runs.
                // If no onQueryUpdated function was provided for this mutation, pass
                // null instead of undefined to disable the default refetching behavior.
                onQueryUpdated: mutation.onQueryUpdated || null
            }).forEach((result)=>results.push(result));
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) // Returning a promise here makes the mutation await that promise, so we
            // include results in that promise's work if awaitRefetchQueries or an
            // onQueryUpdated function was specified.
            return Promise.all(results).then(()=>result);
        }
        return Promise.resolve(result);
    }
    markMutationOptimistic(optimisticResponse, mutation) {
        const data = typeof optimisticResponse === "function" ? optimisticResponse(mutation.variables, {
            IGNORE: $ceb95b2ee67b0239$var$IGNORE
        }) : optimisticResponse;
        if (data === $ceb95b2ee67b0239$var$IGNORE) return false;
        this.cache.recordOptimisticTransaction((cache)=>{
            try {
                this.markMutationResult({
                    data: data
                }, mutation, cache);
            } catch (error) {
                (0, $aa2d7231b5e28112$export$f5708dca728d7177).error(error);
            }
        }, this.id);
        return true;
    }
    markSubscriptionResult(result, { document: document, variables: variables, errorPolicy: errorPolicy, cacheWriteBehavior: cacheWriteBehavior }) {
        if (cacheWriteBehavior !== 0 /* CacheWriteBehavior.FORBID */ ) {
            if ($ceb95b2ee67b0239$var$shouldWriteResult(result, errorPolicy)) this.cache.write({
                query: document,
                result: result.data,
                dataId: "ROOT_SUBSCRIPTION",
                variables: variables,
                extensions: result.extensions
            });
            this.queryManager.broadcastQueries();
        }
    }
}
function $ceb95b2ee67b0239$var$shouldWriteResult(result, errorPolicy = "none") {
    const ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    let writeWithErrors = !(0, $c31535aa3b39d468$export$b4df399e879e53ab)(result);
    if (!writeWithErrors && ignoreErrors && result.data) writeWithErrors = true;
    return writeWithErrors;
}


class $27ad2f533f1621c5$export$b986383a50b53ea4 {
    defaultOptions;
    client;
    /**
     * The options that were passed to the ApolloClient constructor.
     */ clientOptions;
    assumeImmutableResults;
    documentTransform;
    ssrMode;
    defaultContext;
    dataMasking;
    incrementalHandler;
    localState;
    queryDeduplication;
    /**
     * Whether to prioritize cache values over network results when
     * `fetchObservableWithInfo` is called.
     * This will essentially turn a `"network-only"` or `"cache-and-network"`
     * fetchPolicy into a `"cache-first"` fetchPolicy, but without influencing
     * the `fetchPolicy` of the `ObservableQuery`.
     *
     * This can e.g. be used to prioritize the cache during the first render after
     * SSR.
     */ prioritizeCacheValues = false;
    onBroadcast;
    mutationStore;
    /**
     * All ObservableQueries that currently have at least one subscriber.
     */ obsQueries = new Set();
    // Maps from queryInfo.id strings to Promise rejection functions for
    // currently active queries and fetches.
    // Use protected instead of private field so
    // @apollo/experimental-nextjs-app-support can access type info.
    fetchCancelFns = new Map();
    constructor(options){
        const defaultDocumentTransform = new (0, $a9a623faa62cac2b$export$f887060e48e5dc1b)((document)=>this.cache.transformDocument(document), // Allow the apollo cache to manage its own transform caches
        {
            cache: false
        });
        this.client = options.client;
        this.defaultOptions = options.defaultOptions;
        this.queryDeduplication = options.queryDeduplication;
        this.clientOptions = options.clientOptions;
        this.ssrMode = options.ssrMode;
        this.assumeImmutableResults = options.assumeImmutableResults;
        this.dataMasking = options.dataMasking;
        this.localState = options.localState;
        this.incrementalHandler = options.incrementalHandler;
        const documentTransform = options.documentTransform;
        this.documentTransform = documentTransform ? defaultDocumentTransform.concat(documentTransform)// The custom document transform may add new fragment spreads or new
        // field selections, so we want to give the cache a chance to run
        // again. For example, the InMemoryCache adds __typename to field
        // selections and fragments from the fragment registry.
        .concat(defaultDocumentTransform) : defaultDocumentTransform;
        this.defaultContext = options.defaultContext || {};
        if (this.onBroadcast = options.onBroadcast) this.mutationStore = {};
    }
    get link() {
        return this.client.link;
    }
    get cache() {
        return this.client.cache;
    }
    /**
     * Call this method to terminate any active query processes, making it safe
     * to dispose of this QueryManager instance.
     */ stop() {
        this.obsQueries.forEach((oq)=>oq.stop());
        this.cancelPendingFetches((0, $aa2d7231b5e28112$export$3991762405098ea)(87));
    }
    cancelPendingFetches(error) {
        this.fetchCancelFns.forEach((cancel)=>cancel(error));
        this.fetchCancelFns.clear();
    }
    async mutate({ mutation: mutation, variables: variables, optimisticResponse: optimisticResponse, updateQueries: updateQueries, refetchQueries: refetchQueries = [], awaitRefetchQueries: awaitRefetchQueries = false, update: updateWithProxyFn, onQueryUpdated: onQueryUpdated, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy, keepRootFields: keepRootFields, context: context }) {
        const queryInfo = new (0, $ceb95b2ee67b0239$export$79a6120a39c90b6a)(this);
        mutation = this.cache.transformForLink(this.transform(mutation));
        const { hasClientExports: hasClientExports } = this.getDocumentInfo(mutation);
        variables = this.getVariables(mutation, variables);
        if (hasClientExports) {
            if (0, $e15192e15b3ad6c1$export$a866f231438cc228) (0, $aa2d7231b5e28112$export$f5708dca728d7177)(this.localState, 88, (0, $3ed2520e139df5b6$export$41bca9dc6871dd4e)(mutation, "(anonymous)"));
            variables = await this.localState.getExportedVariables({
                client: this.client,
                document: mutation,
                variables: variables,
                context: context
            });
        }
        const mutationStoreValue = this.mutationStore && (this.mutationStore[queryInfo.id] = {
            mutation: mutation,
            variables: variables,
            loading: true,
            error: null
        });
        const isOptimistic = optimisticResponse && queryInfo.markMutationOptimistic(optimisticResponse, {
            document: mutation,
            variables: variables,
            cacheWriteBehavior: fetchPolicy === "no-cache" ? 0 /* CacheWriteBehavior.FORBID */  : 2 /* CacheWriteBehavior.MERGE */ ,
            errorPolicy: errorPolicy,
            context: context,
            updateQueries: updateQueries,
            update: updateWithProxyFn,
            keepRootFields: keepRootFields
        });
        this.broadcastQueries();
        return new Promise((resolve, reject)=>{
            const cause = {};
            return this.getObservableFromLink(mutation, {
                ...context,
                optimisticResponse: isOptimistic ? optimisticResponse : void 0
            }, variables, fetchPolicy, {}, false).observable.pipe($27ad2f533f1621c5$var$validateDidEmitValue(), (0, $c0e80712e8b0e00e$export$6b9f6c0d32c093f9)((result)=>{
                const storeResult = {
                    ...result
                };
                return (0, $b728d3864a499415$export$6788812c4e6611e6)(queryInfo.markMutationResult(storeResult, {
                    document: mutation,
                    variables: variables,
                    cacheWriteBehavior: fetchPolicy === "no-cache" ? 0 /* CacheWriteBehavior.FORBID */  : 2 /* CacheWriteBehavior.MERGE */ ,
                    errorPolicy: errorPolicy,
                    context: context,
                    update: updateWithProxyFn,
                    updateQueries: updateQueries,
                    awaitRefetchQueries: awaitRefetchQueries,
                    refetchQueries: refetchQueries,
                    removeOptimistic: isOptimistic ? queryInfo.id : void 0,
                    onQueryUpdated: onQueryUpdated,
                    keepRootFields: keepRootFields
                }));
            })).pipe((0, $6175481c6b9a1949$export$871de8747c9eaa88)((storeResult)=>{
                const hasErrors = (0, $c31535aa3b39d468$export$b4df399e879e53ab)(storeResult);
                if (hasErrors && errorPolicy === "none") throw new (0, $47039b6dcaec9173$export$c28d7b46cdb2b476)($27ad2f533f1621c5$var$removeStreamDetailsFromExtensions(storeResult));
                if (mutationStoreValue) {
                    mutationStoreValue.loading = false;
                    mutationStoreValue.error = null;
                }
                return storeResult;
            })).subscribe({
                next: (storeResult)=>{
                    this.broadcastQueries();
                    // Since mutations might receive multiple payloads from the
                    // ApolloLink chain (e.g. when used with @defer),
                    // we resolve with a SingleExecutionResult or after the final
                    // ExecutionPatchResult has arrived and we have assembled the
                    // multipart response into a single result.
                    if (!queryInfo.hasNext) {
                        const result = {
                            data: this.maskOperation({
                                document: mutation,
                                data: storeResult.data,
                                fetchPolicy: fetchPolicy,
                                cause: cause
                            })
                        };
                        if ((0, $c31535aa3b39d468$export$b4df399e879e53ab)(storeResult)) result.error = new (0, $47039b6dcaec9173$export$c28d7b46cdb2b476)(storeResult);
                        if (Object.keys(storeResult.extensions || {}).length) result.extensions = storeResult.extensions;
                        resolve(result);
                    }
                },
                error: (error)=>{
                    if (mutationStoreValue) {
                        mutationStoreValue.loading = false;
                        mutationStoreValue.error = error;
                    }
                    if (isOptimistic) this.cache.removeOptimistic(queryInfo.id);
                    this.broadcastQueries();
                    if (errorPolicy === "ignore") return resolve({
                        data: undefined
                    });
                    if (errorPolicy === "all") return resolve({
                        data: undefined,
                        error: error
                    });
                    reject(error);
                }
            });
        });
    }
    fetchQuery(options, networkStatus) {
        (0, $2a4ebb84b536625f$export$a7d0d8111d2386df)(options.query, (0, $d53ea9002ec4d7a4$export$f58c50edb4aef9d4).QUERY);
        // do the rest asynchronously to keep the same rejection timing as
        // checks further in `.mutate`
        return (async ()=>(0, $01d747b2900d60bc$export$a175cc82f1f2275e)(this.fetchObservableWithInfo(options, {
                networkStatus: networkStatus
            }).observable.pipe((0, $4b985f1bcf049783$export$a04c6c6965dd4709)((value)=>{
                switch(value.kind){
                    case "E":
                        throw value.error;
                    case "N":
                        if (value.source !== "newNetworkStatus") return (0, $7df42a60a8344f21$export$de3acc9431f1695e)(value.value);
                }
            })), {
                // This default is needed when a `standby` fetch policy is used to avoid
                // an EmptyError from rejecting this promise.
                defaultValue: {
                    data: undefined
                }
            }))();
    }
    transform(document) {
        return this.documentTransform.transformDocument(document);
    }
    transformCache = new (0, $1abac2280838e114$export$8dbad6f439bb2331)((0, $9f7df0d640a1952d$export$f29926b23b28936b)["queryManager.getDocumentInfo"] || 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ );
    getDocumentInfo(document) {
        const { transformCache: transformCache } = this;
        if (!transformCache.has(document)) {
            const operationDefinition = (0, $bfe912ade316f216$export$7a5b1fa979d2c158)(document);
            const cacheEntry = {
                // TODO These three calls (hasClientExports, shouldForceResolvers, and
                // usesNonreactiveDirective) are performing independent full traversals
                // of the transformed document. We should consider merging these
                // traversals into a single pass in the future, though the work is
                // cached after the first time.
                hasClientExports: (0, $73b423ec85fb7119$export$2dafb573e282fe8d)([
                    "client",
                    "export"
                ], document, true),
                hasForcedResolvers: (0, $21c28b2e5e0aa2b8$export$e2838dcad1841001)(document),
                hasNonreactiveDirective: (0, $73b423ec85fb7119$export$2dafb573e282fe8d)([
                    "nonreactive"
                ], document),
                hasIncrementalDirective: (0, $73b423ec85fb7119$export$2dafb573e282fe8d)([
                    "defer"
                ], document),
                nonReactiveQuery: $27ad2f533f1621c5$var$addNonReactiveToNamedFragments(document),
                clientQuery: (0, $73b423ec85fb7119$export$2dafb573e282fe8d)([
                    "client"
                ], document) ? document : null,
                serverQuery: (0, $71a932e945cf8578$export$e5ae0530da5fe96c)([
                    {
                        name: "client",
                        remove: true
                    },
                    {
                        name: "connection"
                    },
                    {
                        name: "nonreactive"
                    },
                    {
                        name: "unmask"
                    }
                ], document),
                operationType: operationDefinition?.operation,
                defaultVars: (0, $ff81cbd493b54cb0$export$84c19026e616569e)(operationDefinition),
                // Transform any mutation or subscription operations to query operations
                // so we can read/write them from/to the cache.
                asQuery: {
                    ...document,
                    definitions: document.definitions.map((def)=>{
                        if (def.kind === "OperationDefinition" && def.operation !== "query") return {
                            ...def,
                            operation: "query"
                        };
                        return def;
                    })
                }
            };
            transformCache.set(document, cacheEntry);
        }
        const entry = transformCache.get(document);
        if (entry.violation) throw entry.violation;
        return entry;
    }
    getVariables(document, variables) {
        const defaultVars = this.getDocumentInfo(document).defaultVars;
        const varsWithDefaults = Object.entries(variables ?? {}).map(([key, value])=>[
                key,
                value === undefined ? defaultVars[key] : value
            ]);
        return {
            ...defaultVars,
            ...Object.fromEntries(varsWithDefaults)
        };
    }
    watchQuery(options) {
        (0, $2a4ebb84b536625f$export$a7d0d8111d2386df)(options.query, (0, $d53ea9002ec4d7a4$export$f58c50edb4aef9d4).QUERY);
        const query = this.transform(options.query);
        // assign variable default values if supplied
        // NOTE: We don't modify options.query here with the transformed query to
        // ensure observable.options.query is set to the raw untransformed query.
        options = {
            ...options,
            variables: this.getVariables(query, options.variables)
        };
        if (typeof options.notifyOnNetworkStatusChange === "undefined") options.notifyOnNetworkStatusChange = true;
        const observable = new (0, $1724141f75044c6b$export$6c1b56eac59c9584)({
            queryManager: this,
            options: options,
            transformedQuery: query
        });
        return observable;
    }
    query(options) {
        const query = this.transform(options.query);
        return this.fetchQuery({
            ...options,
            query: query
        }).then((value)=>({
                ...value,
                data: this.maskOperation({
                    document: query,
                    data: value?.data,
                    fetchPolicy: options.fetchPolicy
                })
            }));
    }
    requestIdCounter = 1;
    generateRequestId() {
        return this.requestIdCounter++;
    }
    clearStore(options = {
        discardWatches: true
    }) {
        // Before we have sent the reset action to the store, we can no longer
        // rely on the results returned by in-flight requests since these may
        // depend on values that previously existed in the data portion of the
        // store. So, we cancel the promises and observers that we have issued
        // so far and not yet resolved (in the case of queries).
        this.cancelPendingFetches((0, $aa2d7231b5e28112$export$3991762405098ea)(89));
        this.obsQueries.forEach((observableQuery)=>{
            // Set loading to true so listeners don't trigger unless they want
            // results with partial data.
            observableQuery.reset();
        });
        if (this.mutationStore) this.mutationStore = {};
        // begin removing data from the store
        return this.cache.reset(options);
    }
    getObservableQueries(include = "active") {
        const queries = new Set();
        const queryNames = new Map();
        const queryNamesAndQueryStrings = new Map();
        const legacyQueryOptions = new Set();
        if (Array.isArray(include)) include.forEach((desc)=>{
            if (typeof desc === "string") {
                queryNames.set(desc, desc);
                queryNamesAndQueryStrings.set(desc, false);
            } else if ((0, $aba99c557ad5aa19$export$540432d49fcec6c9)(desc)) {
                const queryString = (0, $a6091649f6831c1e$export$c2d084dc44961371)(this.transform(desc));
                queryNames.set(queryString, (0, $3ed2520e139df5b6$export$41bca9dc6871dd4e)(desc));
                queryNamesAndQueryStrings.set(queryString, false);
            } else if ((0, $e79cca4a6323426e$export$417207af72fad9c9)(desc) && desc.query) legacyQueryOptions.add(desc);
        });
        this.obsQueries.forEach((oq)=>{
            const document = (0, $a6091649f6831c1e$export$c2d084dc44961371)(this.transform(oq.options.query));
            if (include === "all") {
                queries.add(oq);
                return;
            }
            const { queryName: queryName, options: { fetchPolicy: fetchPolicy } } = oq;
            if (include === "active" && fetchPolicy === "standby") return;
            if (include === "active" || queryName && queryNamesAndQueryStrings.has(queryName) || document && queryNamesAndQueryStrings.has(document)) {
                queries.add(oq);
                if (queryName) queryNamesAndQueryStrings.set(queryName, true);
                if (document) queryNamesAndQueryStrings.set(document, true);
            }
        });
        if (legacyQueryOptions.size) legacyQueryOptions.forEach((options)=>{
            const oq = new (0, $1724141f75044c6b$export$6c1b56eac59c9584)({
                queryManager: this,
                options: {
                    ...(0, $7e1dfc8c7a435d55$export$235b7fc70b9fc359)(this.defaultOptions.watchQuery, options),
                    fetchPolicy: "network-only"
                }
            });
            queries.add(oq);
        });
        if ((0, $e15192e15b3ad6c1$export$a866f231438cc228) && queryNamesAndQueryStrings.size) queryNamesAndQueryStrings.forEach((included, nameOrQueryString)=>{
            if (!included) {
                const queryName = queryNames.get(nameOrQueryString);
                if (queryName) (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).warn(90, queryName);
                else (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).warn(91);
            }
        });
        return queries;
    }
    refetchObservableQueries(includeStandby = false) {
        const observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach((observableQuery)=>{
            const { fetchPolicy: fetchPolicy } = observableQuery.options;
            if ((includeStandby || fetchPolicy !== "standby") && fetchPolicy !== "cache-only") observableQueryPromises.push(observableQuery.refetch());
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    }
    startGraphQLSubscription(options) {
        let { query: query, variables: variables } = options;
        const { fetchPolicy: fetchPolicy = "cache-first", errorPolicy: errorPolicy = "none", context: context = {}, extensions: extensions = {} } = options;
        (0, $2a4ebb84b536625f$export$a7d0d8111d2386df)(query, (0, $d53ea9002ec4d7a4$export$f58c50edb4aef9d4).SUBSCRIPTION);
        query = this.transform(query);
        variables = this.getVariables(query, variables);
        let restart;
        if (0, $e15192e15b3ad6c1$export$a866f231438cc228) (0, $aa2d7231b5e28112$export$f5708dca728d7177)(!this.getDocumentInfo(query).hasClientExports || this.localState, 92, (0, $3ed2520e139df5b6$export$41bca9dc6871dd4e)(query, "(anonymous)"));
        const observable = (this.getDocumentInfo(query).hasClientExports ? (0, $b728d3864a499415$export$6788812c4e6611e6)(this.localState.getExportedVariables({
            client: this.client,
            document: query,
            variables: variables,
            context: context
        })) : (0, $fc97cbd9f73f00f0$export$ba255e9e49e00608)(variables)).pipe((0, $c0e80712e8b0e00e$export$6b9f6c0d32c093f9)((variables)=>{
            const { observable: observable, restart: res } = this.getObservableFromLink(query, context, variables, fetchPolicy, extensions);
            const queryInfo = new (0, $ceb95b2ee67b0239$export$79a6120a39c90b6a)(this);
            restart = res;
            return observable.pipe((0, $6175481c6b9a1949$export$871de8747c9eaa88)((rawResult)=>{
                queryInfo.markSubscriptionResult(rawResult, {
                    document: query,
                    variables: variables,
                    errorPolicy: errorPolicy,
                    cacheWriteBehavior: fetchPolicy === "no-cache" ? 0 /* CacheWriteBehavior.FORBID */  : 2 /* CacheWriteBehavior.MERGE */ 
                });
                const result = {
                    data: rawResult.data ?? undefined
                };
                if ((0, $c31535aa3b39d468$export$b4df399e879e53ab)(rawResult)) result.error = new (0, $47039b6dcaec9173$export$c28d7b46cdb2b476)(rawResult);
                else if ((0, $f1a9d96edac5fab2$export$345f95cc6b6b9b0b)(rawResult)) {
                    result.error = rawResult.extensions[0, $f1a9d96edac5fab2$export$4995664c1b49842e];
                    // Don't emit protocol errors added by HttpLink
                    delete rawResult.extensions[0, $f1a9d96edac5fab2$export$4995664c1b49842e];
                }
                if (rawResult.extensions && Object.keys(rawResult.extensions).length) result.extensions = rawResult.extensions;
                if (result.error && errorPolicy === "none") result.data = undefined;
                if (errorPolicy === "ignore") delete result.error;
                return result;
            }), (0, $35e2765fba36ce76$export$3dede90624df3ba9)((error)=>{
                if (errorPolicy === "ignore") return (0, $fc97cbd9f73f00f0$export$ba255e9e49e00608)({
                    data: undefined
                });
                return (0, $fc97cbd9f73f00f0$export$ba255e9e49e00608)({
                    data: undefined,
                    error: error
                });
            }), (0, $1ed725e1b173ea41$export$3dea766d36a8935f)((result)=>!!(result.data || result.error)));
        }));
        return Object.assign(observable, {
            restart: ()=>restart?.()
        });
    }
    broadcastQueries() {
        if (this.onBroadcast) this.onBroadcast();
        this.obsQueries.forEach((observableQuery)=>observableQuery.notify());
    }
    // Use protected instead of private field so
    // @apollo/experimental-nextjs-app-support can access type info.
    inFlightLinkObservables = new (0, $3fafa7abbadfcc3d$export$73571c50d0f2507e)(false);
    getObservableFromLink(query, context, variables, fetchPolicy, extensions, // Prefer context.queryDeduplication if specified.
    deduplication = context?.queryDeduplication ?? this.queryDeduplication) {
        let entry = {};
        const { serverQuery: serverQuery, clientQuery: clientQuery, operationType: operationType, hasIncrementalDirective: hasIncrementalDirective } = this.getDocumentInfo(query);
        const operationName = (0, $3ed2520e139df5b6$export$41bca9dc6871dd4e)(query);
        const executeContext = {
            client: this.client
        };
        if (serverQuery) {
            const { inFlightLinkObservables: inFlightLinkObservables, link: link } = this;
            try {
                const operation = this.incrementalHandler.prepareRequest({
                    query: serverQuery,
                    variables: variables,
                    context: {
                        ...this.defaultContext,
                        ...context,
                        queryDeduplication: deduplication
                    },
                    extensions: extensions
                });
                context = operation.context;
                function withRestart(source) {
                    return new (0, $23f68ab689e21470$export$77cea355fa80b5f4)((observer)=>{
                        function subscribe() {
                            return source.subscribe({
                                next: observer.next.bind(observer),
                                complete: observer.complete.bind(observer),
                                error: observer.error.bind(observer)
                            });
                        }
                        let subscription = subscribe();
                        entry.restart ||= ()=>{
                            subscription.unsubscribe();
                            subscription = subscribe();
                        };
                        return ()=>{
                            subscription.unsubscribe();
                            entry.restart = undefined;
                        };
                    });
                }
                if (deduplication) {
                    const printedServerQuery = (0, $a6091649f6831c1e$export$c2d084dc44961371)(serverQuery);
                    const varJson = (0, $a82bc0d00c91b19f$export$88a0ad9b6f961b51)(variables);
                    entry = inFlightLinkObservables.lookup(printedServerQuery, varJson);
                    if (!entry.observable) entry.observable = (0, $0e5659e1b70da0ac$export$51396ec711da548b)(link, operation, executeContext).pipe(withRestart, (0, $c62a4a145ab75d8d$export$578723aef62d92f5)(()=>{
                        if (inFlightLinkObservables.peek(printedServerQuery, varJson) === entry) inFlightLinkObservables.remove(printedServerQuery, varJson);
                    }), // We don't want to replay the last emitted value for
                    // subscriptions and instead opt to wait to receive updates until
                    // the subscription emits new values.
                    operationType === (0, $d53ea9002ec4d7a4$export$f58c50edb4aef9d4).SUBSCRIPTION ? (0, $590f717384cd71b5$export$ed80d9de1d9df928)() : (0, $2a32ac76ac1a6174$export$db61d692014e534e)({
                        refCount: true
                    }));
                } else entry.observable = (0, $0e5659e1b70da0ac$export$51396ec711da548b)(link, operation, executeContext).pipe(withRestart);
            } catch (error) {
                entry.observable = (0, $22be27f2a763a155$export$8bf7aba4a9e09055)(()=>error);
            }
        } else entry.observable = (0, $fc97cbd9f73f00f0$export$ba255e9e49e00608)({
            data: {}
        });
        if (clientQuery) {
            const { operation: operation } = (0, $bfe912ade316f216$export$7a5b1fa979d2c158)(query);
            if (0, $e15192e15b3ad6c1$export$a866f231438cc228) (0, $aa2d7231b5e28112$export$f5708dca728d7177)(this.localState, 93, operation[0].toUpperCase() + operation.slice(1), operationName ?? "(anonymous)");
            (0, $aa2d7231b5e28112$export$f5708dca728d7177)(!hasIncrementalDirective, 94, operation[0].toUpperCase() + operation.slice(1), operationName ?? "(anonymous)");
            entry.observable = entry.observable.pipe((0, $c0e80712e8b0e00e$export$6b9f6c0d32c093f9)((result)=>{
                return (0, $b728d3864a499415$export$6788812c4e6611e6)(this.localState.execute({
                    client: this.client,
                    document: clientQuery,
                    remoteResult: result,
                    context: context,
                    variables: variables,
                    fetchPolicy: fetchPolicy
                }));
            }));
        }
        return {
            restart: ()=>entry.restart?.(),
            observable: entry.observable.pipe((0, $35e2765fba36ce76$export$3dede90624df3ba9)((error)=>{
                error = (0, $f1a9d96edac5fab2$export$9ca5882e11f8e4c6)(error);
                (0, $a3bc43cc34afd4db$export$1ef81dbee0dd241d)(error);
                throw error;
            }))
        };
    }
    getResultsFromLink(options, { queryInfo: queryInfo, cacheWriteBehavior: cacheWriteBehavior, observableQuery: observableQuery, exposeExtensions: exposeExtensions }) {
        const requestId = queryInfo.lastRequestId = this.generateRequestId();
        const { errorPolicy: errorPolicy } = options;
        // Performing transformForLink here gives this.cache a chance to fill in
        // missing fragment definitions (for example) before sending this document
        // through the link chain.
        const linkDocument = this.cache.transformForLink(options.query);
        return this.getObservableFromLink(linkDocument, options.context, options.variables, options.fetchPolicy).observable.pipe((0, $6175481c6b9a1949$export$871de8747c9eaa88)((incoming)=>{
            // Use linkDocument rather than queryInfo.document so the
            // operation/fragments used to write the result are the same as the
            // ones used to obtain it from the link.
            const result = queryInfo.markQueryResult(incoming, {
                ...options,
                document: linkDocument,
                cacheWriteBehavior: cacheWriteBehavior
            });
            const hasErrors = (0, $c31535aa3b39d468$export$b4df399e879e53ab)(result);
            if (hasErrors && errorPolicy === "none") {
                queryInfo.resetLastWrite();
                observableQuery?.["resetNotifications"]();
                throw new (0, $47039b6dcaec9173$export$c28d7b46cdb2b476)($27ad2f533f1621c5$var$removeStreamDetailsFromExtensions(result));
            }
            const aqr = {
                data: result.data,
                ...queryInfo.hasNext ? {
                    loading: true,
                    networkStatus: (0, $28ed6ef232a84776$export$bd096ddbd246c79c).streaming,
                    dataState: "streaming",
                    partial: true
                } : {
                    dataState: result.data ? "complete" : "empty",
                    loading: false,
                    networkStatus: (0, $28ed6ef232a84776$export$bd096ddbd246c79c).ready,
                    partial: !result.data
                }
            };
            if (exposeExtensions && "extensions" in result) aqr[0, $16b2c739aa564ddd$export$bcc403bd3c6120cd] = result.extensions;
            // In the case we start multiple network requests simultaneously, we
            // want to ensure we properly set `data` if we're reporting on an old
            // result which will not be caught by the conditional above that ends up
            // throwing the markError result.
            if (hasErrors) {
                if (errorPolicy === "none") {
                    aqr.data = void 0;
                    aqr.dataState = "empty";
                }
                if (errorPolicy !== "ignore") {
                    aqr.error = new (0, $47039b6dcaec9173$export$c28d7b46cdb2b476)($27ad2f533f1621c5$var$removeStreamDetailsFromExtensions(result));
                    if (aqr.dataState !== "streaming") aqr.networkStatus = (0, $28ed6ef232a84776$export$bd096ddbd246c79c).error;
                }
            }
            return aqr;
        }), (0, $35e2765fba36ce76$export$3dede90624df3ba9)((error)=>{
            // Avoid storing errors from older interrupted queries.
            if (requestId >= queryInfo.lastRequestId && errorPolicy === "none") {
                queryInfo.resetLastWrite();
                observableQuery?.["resetNotifications"]();
                throw error;
            }
            const aqr = {
                data: undefined,
                dataState: "empty",
                loading: false,
                networkStatus: (0, $28ed6ef232a84776$export$bd096ddbd246c79c).ready,
                partial: true
            };
            if (errorPolicy !== "ignore") {
                aqr.error = error;
                aqr.networkStatus = (0, $28ed6ef232a84776$export$bd096ddbd246c79c).error;
            }
            return (0, $fc97cbd9f73f00f0$export$ba255e9e49e00608)(aqr);
        }));
    }
    fetchObservableWithInfo(options, { networkStatus: // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus = (0, $28ed6ef232a84776$export$bd096ddbd246c79c).loading, query: query = options.query, fetchQueryOperator: fetchQueryOperator = (x)=>x, onCacheHit: onCacheHit = ()=>{}, observableQuery: observableQuery, exposeExtensions: exposeExtensions }) {
        const variables = this.getVariables(query, options.variables);
        let { fetchPolicy: fetchPolicy = "cache-first", errorPolicy: errorPolicy = "none", returnPartialData: returnPartialData = false, notifyOnNetworkStatusChange: notifyOnNetworkStatusChange = true, context: context = {} } = options;
        if (this.prioritizeCacheValues && (fetchPolicy === "network-only" || fetchPolicy === "cache-and-network")) fetchPolicy = "cache-first";
        const normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context
        });
        const queryInfo = new (0, $ceb95b2ee67b0239$export$79a6120a39c90b6a)(this, observableQuery);
        const fromVariables = (variables)=>{
            // Since normalized is always a fresh copy of options, it's safe to
            // modify its properties here, rather than creating yet another new
            // WatchQueryOptions object.
            normalized.variables = variables;
            const cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 /* CacheWriteBehavior.FORBID */  : networkStatus === (0, $28ed6ef232a84776$export$bd096ddbd246c79c).refetch && normalized.refetchWritePolicy !== "merge" ? 1 /* CacheWriteBehavior.OVERWRITE */  : 2 /* CacheWriteBehavior.MERGE */ ;
            const observableWithInfo = this.fetchQueryByPolicy(normalized, {
                queryInfo: queryInfo,
                cacheWriteBehavior: cacheWriteBehavior,
                onCacheHit: onCacheHit,
                observableQuery: observableQuery,
                exposeExtensions: exposeExtensions
            });
            observableWithInfo.observable = observableWithInfo.observable.pipe(fetchQueryOperator);
            if (// If we're in standby, postpone advancing options.fetchPolicy using
            // applyNextFetchPolicy.
            normalized.fetchPolicy !== "standby") observableQuery?.["applyNextFetchPolicy"]("after-fetch", options);
            return observableWithInfo;
        };
        // This cancel function needs to be set before the concast is created,
        // in case concast creation synchronously cancels the request.
        const cleanupCancelFn = ()=>{
            this.fetchCancelFns.delete(queryInfo.id);
        };
        this.fetchCancelFns.set(queryInfo.id, (error)=>{
            fetchCancelSubject.next({
                kind: "E",
                error: error,
                source: "network"
            });
        });
        const fetchCancelSubject = new (0, $1e1b2aa6dbd14b53$export$b6bbab5a9b109038)();
        let observable, containsDataFromLink;
        // If the query has @export(as: ...) directives, then we need to
        // process those directives asynchronously. When there are no
        // @export directives (the common case), we deliberately avoid
        // wrapping the result of this.fetchQueryByPolicy in a Promise,
        // since the timing of result delivery is (unfortunately) important
        // for backwards compatibility. TODO This code could be simpler if
        // we deprecated and removed LocalState.
        if (this.getDocumentInfo(normalized.query).hasClientExports) {
            if (0, $e15192e15b3ad6c1$export$a866f231438cc228) (0, $aa2d7231b5e28112$export$f5708dca728d7177)(this.localState, 95, (0, $3ed2520e139df5b6$export$41bca9dc6871dd4e)(normalized.query, "(anonymous)"));
            observable = (0, $b728d3864a499415$export$6788812c4e6611e6)(this.localState.getExportedVariables({
                client: this.client,
                document: normalized.query,
                variables: normalized.variables,
                context: normalized.context
            })).pipe((0, $c0e80712e8b0e00e$export$6b9f6c0d32c093f9)((variables)=>fromVariables(variables).observable));
            // there is just no way we can synchronously get the *right* value here,
            // so we will assume `true`, which is the behaviour before the bug fix in
            // #10597. This means that bug is not fixed in that case, and is probably
            // un-fixable with reasonable effort for the edge case of @export as
            // directives.
            containsDataFromLink = true;
        } else {
            const sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            observable = sourcesWithInfo.observable;
        }
        return {
            // Merge `observable` with `fetchCancelSubject`, in a way that completing or
            // erroring either of them will complete the merged obserable.
            observable: new (0, $23f68ab689e21470$export$77cea355fa80b5f4)((observer)=>{
                observer.add(cleanupCancelFn);
                observable.subscribe(observer);
                fetchCancelSubject.subscribe(observer);
            }).pipe((0, $590f717384cd71b5$export$ed80d9de1d9df928)()),
            fromLink: containsDataFromLink
        };
    }
    refetchQueries({ updateCache: updateCache, include: include, optimistic: optimistic = false, removeOptimistic: removeOptimistic = optimistic ? (0, $7bc48cc8dd979395$export$d0c8ec0fe1b18b70)("refetchQueries") : void 0, onQueryUpdated: onQueryUpdated }) {
        const includedQueriesByOq = new Map();
        if (include) this.getObservableQueries(include).forEach((oq)=>{
            if (oq.options.fetchPolicy === "cache-only" || oq["variablesUnknown"]) return;
            const current = oq.getCurrentResult();
            includedQueriesByOq.set(oq, {
                oq: oq,
                lastDiff: {
                    result: current?.data,
                    complete: !current?.partial
                }
            });
        });
        const results = new Map();
        if (updateCache) {
            const handled = new Set();
            this.cache.batch({
                update: updateCache,
                // Since you can perform any combination of cache reads and/or writes in
                // the cache.batch update function, its optimistic option can be either
                // a boolean or a string, representing three distinct modes of
                // operation:
                //
                // * false: read/write only the root layer
                // * true: read/write the topmost layer
                // * string: read/write a fresh optimistic layer with that ID string
                //
                // When typeof optimistic === "string", a new optimistic layer will be
                // temporarily created within cache.batch with that string as its ID. If
                // we then pass that same string as the removeOptimistic option, we can
                // make cache.batch immediately remove the optimistic layer after
                // running the updateCache function, triggering only one broadcast.
                //
                // However, the refetchQueries method accepts only true or false for its
                // optimistic option (not string). We interpret true to mean a temporary
                // optimistic layer should be created, to allow efficiently rolling back
                // the effect of the updateCache function, which involves passing a
                // string instead of true as the optimistic option to cache.batch, when
                // refetchQueries receives optimistic: true.
                //
                // In other words, we are deliberately not supporting the use case of
                // writing to an *existing* optimistic layer (using the refetchQueries
                // updateCache function), since that would potentially interfere with
                // other optimistic updates in progress. Instead, you can read/write
                // only the root layer by passing optimistic: false to refetchQueries,
                // or you can read/write a brand new optimistic layer that will be
                // automatically removed by passing optimistic: true.
                optimistic: optimistic && removeOptimistic || false,
                removeOptimistic: // The removeOptimistic option can also be provided by itself, even if
                // optimistic === false, to remove some previously-added optimistic
                // layer safely and efficiently, like we do in markMutationResult.
                //
                // If an explicit removeOptimistic string is provided with optimistic:
                // true, the removeOptimistic string will determine the ID of the
                // temporary optimistic layer, in case that ever matters.
                removeOptimistic,
                onWatchUpdated (watch, diff, lastDiff) {
                    const oq = watch.watcher;
                    if (oq instanceof (0, $1724141f75044c6b$export$6c1b56eac59c9584) && !handled.has(oq)) {
                        handled.add(oq);
                        if (onQueryUpdated) {
                            // Since we're about to handle this query now, remove it from
                            // includedQueriesById, in case it was added earlier because of
                            // options.include.
                            includedQueriesByOq.delete(oq);
                            let result = onQueryUpdated(oq, diff, lastDiff);
                            if (result === true) // The onQueryUpdated function requested the default refetching
                            // behavior by returning true.
                            result = oq.refetch().retain();
                            // Record the result in the results Map, as long as onQueryUpdated
                            // did not return false to skip/ignore this result.
                            if (result !== false) results.set(oq, result);
                            // Allow the default cache broadcast to happen, except when
                            // onQueryUpdated returns false.
                            return result;
                        }
                        if (onQueryUpdated !== null && oq.options.fetchPolicy !== "cache-only") // If we don't have an onQueryUpdated function, and onQueryUpdated
                        // was not disabled by passing null, make sure this query is
                        // "included" like any other options.include-specified query.
                        includedQueriesByOq.set(oq, {
                            oq: oq,
                            lastDiff: lastDiff,
                            diff: diff
                        });
                    }
                }
            });
        }
        if (includedQueriesByOq.size) includedQueriesByOq.forEach(({ oq: oq, lastDiff: lastDiff, diff: diff })=>{
            let result;
            // If onQueryUpdated is provided, we want to use it for all included
            // queries, even the QueryOptions ones.
            if (onQueryUpdated) {
                if (!diff) diff = oq.getCacheDiff();
                result = onQueryUpdated(oq, diff, lastDiff);
            }
            // Otherwise, we fall back to refetching.
            if (!onQueryUpdated || result === true) result = oq.refetch().retain();
            if (result !== false) results.set(oq, result);
        });
        if (removeOptimistic) // In case no updateCache callback was provided (so cache.batch was not
        // called above, and thus did not already remove the optimistic layer),
        // remove it here. Since this is a no-op when the layer has already been
        // removed, we do it even if we called cache.batch above, since it's
        // possible this.cache is an instance of some ApolloCache subclass other
        // than InMemoryCache, and does not fully support the removeOptimistic
        // option for cache.batch.
        this.cache.removeOptimistic(removeOptimistic);
        return results;
    }
    noCacheWarningsByCause = new WeakSet();
    maskOperation(options) {
        const { document: document, data: data } = options;
        if (0, $e15192e15b3ad6c1$export$a866f231438cc228) {
            const { fetchPolicy: fetchPolicy, cause: cause = {} } = options;
            const operationType = (0, $bfe912ade316f216$export$7a5b1fa979d2c158)(document)?.operation;
            if (this.dataMasking && fetchPolicy === "no-cache" && !$27ad2f533f1621c5$var$isFullyUnmaskedOperation(document) && !this.noCacheWarningsByCause.has(cause)) {
                this.noCacheWarningsByCause.add(cause);
                (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).warn(96, (0, $3ed2520e139df5b6$export$41bca9dc6871dd4e)(document, `Unnamed ${operationType ?? "operation"}`));
            }
        }
        return this.dataMasking ? (0, $032a43dadd6a478b$export$74a61e4252a4a2ef)(data, document, this.cache) : data;
    }
    maskFragment(options) {
        const { data: data, fragment: fragment, fragmentName: fragmentName } = options;
        return this.dataMasking ? (0, $91cd43a9c338b9c0$export$adbebb59d1aeea97)(data, fragment, this.cache, fragmentName) : data;
    }
    fetchQueryByPolicy({ query: query, variables: variables, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy, returnPartialData: returnPartialData, context: context }, { cacheWriteBehavior: cacheWriteBehavior, onCacheHit: onCacheHit, queryInfo: queryInfo, observableQuery: observableQuery, exposeExtensions: exposeExtensions }) {
        const readCache = ()=>this.cache.diff({
                query: query,
                variables: variables,
                returnPartialData: true,
                optimistic: true
            });
        const resultsFromCache = (diff, networkStatus)=>{
            const data = diff.result;
            if ((0, $e15192e15b3ad6c1$export$a866f231438cc228) && !returnPartialData && data !== null) (0, $1724141f75044c6b$export$b7e1973aacac3ae7)(diff.missing);
            const toResult = (data)=>{
                // TODO: Eventually we should move this handling into
                // queryInfo.getDiff() directly. Since getDiff is updated to return null
                // on returnPartialData: false, we should take advantage of that instead
                // of having to patch it elsewhere.
                if (!diff.complete && !returnPartialData) data = undefined;
                return {
                    // TODO: Handle partial data
                    data: data,
                    dataState: diff.complete ? "complete" : data ? "partial" : "empty",
                    loading: (0, $9311d187008787b8$export$37509604341a3464)(networkStatus),
                    networkStatus: networkStatus,
                    partial: !diff.complete
                };
            };
            const fromData = (data)=>{
                return (0, $fc97cbd9f73f00f0$export$ba255e9e49e00608)({
                    kind: "N",
                    value: toResult(data),
                    source: "cache"
                });
            };
            if (// Don't attempt to run forced resolvers if we have incomplete cache
            // data and partial isn't allowed since this result would get set to
            // `undefined` anyways in `toResult`.
            (diff.complete || returnPartialData) && this.getDocumentInfo(query).hasForcedResolvers) {
                if (0, $e15192e15b3ad6c1$export$a866f231438cc228) (0, $aa2d7231b5e28112$export$f5708dca728d7177)(this.localState, 97, (0, $3ed2520e139df5b6$export$41bca9dc6871dd4e)(query, "(anonymous)"));
                onCacheHit();
                return (0, $b728d3864a499415$export$6788812c4e6611e6)(this.localState.execute({
                    client: this.client,
                    document: query,
                    remoteResult: data ? {
                        data: data
                    } : undefined,
                    context: context,
                    variables: variables,
                    onlyRunForcedResolvers: true,
                    returnPartialData: true,
                    fetchPolicy: fetchPolicy
                }).then((resolved)=>({
                        kind: "N",
                        value: toResult(resolved.data || void 0),
                        source: "cache"
                    })));
            }
            // Resolves https://github.com/apollographql/apollo-client/issues/10317.
            // If errorPolicy is 'none' and notifyOnNetworkStatusChange is true,
            // data was incorrectly returned from the cache on refetch:
            // if diff.missing exists, we should not return cache data.
            if (errorPolicy === "none" && networkStatus === (0, $28ed6ef232a84776$export$bd096ddbd246c79c).refetch && diff.missing) return fromData(void 0);
            return fromData(data || undefined);
        };
        const resultsFromLink = ()=>this.getResultsFromLink({
                query: query,
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy
            }, {
                cacheWriteBehavior: cacheWriteBehavior,
                queryInfo: queryInfo,
                observableQuery: observableQuery,
                exposeExtensions: exposeExtensions
            }).pipe($27ad2f533f1621c5$var$validateDidEmitValue(), (0, $76ba9b8f04580447$export$76dbd6ffd832405d)(), (0, $6175481c6b9a1949$export$871de8747c9eaa88)((result)=>({
                    ...result,
                    source: "network"
                })));
        switch(fetchPolicy){
            default:
            case "cache-first":
                {
                    const diff = readCache();
                    if (diff.complete) return {
                        fromLink: false,
                        observable: resultsFromCache(diff, (0, $28ed6ef232a84776$export$bd096ddbd246c79c).ready)
                    };
                    if (returnPartialData) return {
                        fromLink: true,
                        observable: (0, $cc38c15a77ac39bb$export$ee1b3e54f0441b22)(resultsFromCache(diff, (0, $28ed6ef232a84776$export$bd096ddbd246c79c).loading), resultsFromLink())
                    };
                    return {
                        fromLink: true,
                        observable: resultsFromLink()
                    };
                }
            case "cache-and-network":
                {
                    const diff = readCache();
                    if (diff.complete || returnPartialData) return {
                        fromLink: true,
                        observable: (0, $cc38c15a77ac39bb$export$ee1b3e54f0441b22)(resultsFromCache(diff, (0, $28ed6ef232a84776$export$bd096ddbd246c79c).loading), resultsFromLink())
                    };
                    return {
                        fromLink: true,
                        observable: resultsFromLink()
                    };
                }
            case "cache-only":
                return {
                    fromLink: false,
                    observable: (0, $cc38c15a77ac39bb$export$ee1b3e54f0441b22)(resultsFromCache(readCache(), (0, $28ed6ef232a84776$export$bd096ddbd246c79c).ready))
                };
            case "network-only":
                return {
                    fromLink: true,
                    observable: resultsFromLink()
                };
            case "no-cache":
                return {
                    fromLink: true,
                    observable: resultsFromLink()
                };
            case "standby":
                return {
                    fromLink: false,
                    observable: (0, $31cce697e13f76b3$export$ccb33e29d92c9a58)
                };
        }
    }
}
function $27ad2f533f1621c5$var$validateDidEmitValue() {
    let didEmitValue = false;
    return (0, $074c390243aea0da$export$3f23594af5f37336)({
        next () {
            didEmitValue = true;
        },
        complete () {
            (0, $aa2d7231b5e28112$export$f5708dca728d7177)(didEmitValue, 98);
        }
    });
}
function $27ad2f533f1621c5$var$isFullyUnmaskedOperation(document) {
    let isUnmasked = true;
    (0, $cd2396bbf46089ba$export$bf638b60ea8b89b7)(document, {
        FragmentSpread: (node)=>{
            isUnmasked = !!node.directives && node.directives.some((directive)=>directive.name.value === "unmask");
            if (!isUnmasked) return 0, $cd2396bbf46089ba$export$a89c95c098ac2a58;
        }
    });
    return isUnmasked;
}
function $27ad2f533f1621c5$var$addNonReactiveToNamedFragments(document) {
    return (0, $cd2396bbf46089ba$export$bf638b60ea8b89b7)(document, {
        FragmentSpread: (node)=>{
            // Do not add `@nonreactive` if the fragment is marked with `@unmask`
            // since we want to react to changes in this fragment.
            if (node.directives?.some((directive)=>directive.name.value === "unmask")) return;
            return {
                ...node,
                directives: [
                    ...node.directives || [],
                    {
                        kind: (0, $324243985983b985$export$a84bdc57c5122798).DIRECTIVE,
                        name: {
                            kind: (0, $324243985983b985$export$a84bdc57c5122798).NAME,
                            value: "nonreactive"
                        }
                    }
                ]
            };
        }
    });
}
function $27ad2f533f1621c5$var$removeStreamDetailsFromExtensions(original) {
    if (original.extensions?.[0, $16b2c739aa564ddd$export$e49e8c01e90ecf85] == null) return original;
    const { extensions: { [(0, $16b2c739aa564ddd$export$e49e8c01e90ecf85)]: _, ...extensions }, ...result } = original;
    if (Object.keys(extensions).length > 0) result.extensions = extensions;
    return result;
}


let $02d2383b4a0acb65$var$hasSuggestedDevtools = false;
class $02d2383b4a0acb65$export$13f5a5f0f1dbab88 {
    link;
    cache;
    /**
     * @deprecated `disableNetworkFetches` has been renamed to `prioritizeCacheValues`.
     */ disableNetworkFetches;
    set prioritizeCacheValues(value) {
        this.queryManager.prioritizeCacheValues = value;
    }
    /**
     * Whether to prioritize cache values over network results when `query` or `watchQuery` is called.
     * This will essentially turn a `"network-only"` or `"cache-and-network"` fetchPolicy into a `"cache-first"` fetchPolicy,
     * but without influencing the `fetchPolicy` of the created `ObservableQuery` long-term.
     *
     * This can e.g. be used to prioritize the cache during the first render after SSR.
     */ get prioritizeCacheValues() {
        return this.queryManager.prioritizeCacheValues;
    }
    version;
    queryDeduplication;
    defaultOptions;
    devtoolsConfig;
    queryManager;
    devToolsHookCb;
    resetStoreCallbacks = [];
    clearStoreCallbacks = [];
    /**
     * Constructs an instance of `ApolloClient`.
     *
     * @example
     *
     * ```js
     * import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";
     *
     * const cache = new InMemoryCache();
     * const link = new HttpLink({ uri: "http://localhost:4000/" });
     *
     * const client = new ApolloClient({
     *   // Provide required constructor fields
     *   cache: cache,
     *   link: link,
     *
     *   // Provide some optional constructor fields
     *   clientAwareness: {
     *     name: "react-web-client",
     *     version: "1.3",
     *   },
     *   queryDeduplication: false,
     * });
     * ```
     */ constructor(options){
        if (0, $e15192e15b3ad6c1$export$a866f231438cc228) {
            (0, $aa2d7231b5e28112$export$f5708dca728d7177)(options.cache, 68);
            (0, $aa2d7231b5e28112$export$f5708dca728d7177)(options.link, 69);
        }
        const { cache: cache, documentTransform: documentTransform, ssrMode: ssrMode = false, ssrForceFetchDelay: ssrForceFetchDelay = 0, queryDeduplication: queryDeduplication = true, defaultOptions: defaultOptions, defaultContext: defaultContext, assumeImmutableResults: assumeImmutableResults = cache.assumeImmutableResults, localState: localState, devtools: devtools, dataMasking: dataMasking, link: link, incrementalHandler: incrementalHandler = new (0, $af1ec4677379bc82$export$ac7bcc44740f06fb)(), experiments: experiments = [] } = options;
        this.link = link;
        this.cache = cache;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.devtoolsConfig = {
            ...devtools,
            enabled: devtools?.enabled ?? (0, $e15192e15b3ad6c1$export$a866f231438cc228)
        };
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.watchFragment = this.watchFragment.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.refetchObservableQueries = this.refetchObservableQueries.bind(this);
        this.version = (0, $10d1d4b25cee1a9f$export$83d89fbfd8236492);
        this.queryManager = new (0, $27ad2f533f1621c5$export$b986383a50b53ea4)({
            client: this,
            defaultOptions: this.defaultOptions,
            defaultContext: defaultContext,
            documentTransform: documentTransform,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            dataMasking: !!dataMasking,
            clientOptions: options,
            incrementalHandler: incrementalHandler,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: this.devtoolsConfig.enabled ? ()=>{
                if (this.devToolsHookCb) this.devToolsHookCb();
            } : void 0,
            localState: localState
        });
        this.prioritizeCacheValues = ssrMode || ssrForceFetchDelay > 0;
        if (ssrForceFetchDelay) setTimeout(()=>{
            this.prioritizeCacheValues = false;
        }, ssrForceFetchDelay);
        if (this.devtoolsConfig.enabled) this.connectToDevTools();
        experiments.forEach((experiment)=>experiment.call(this, options));
    }
    connectToDevTools() {
        if (typeof window === "undefined") return;
        const windowWithDevTools = window;
        const devtoolsSymbol = Symbol.for("apollo.devtools");
        (windowWithDevTools[devtoolsSymbol] = windowWithDevTools[devtoolsSymbol] || []).push(this);
        windowWithDevTools.__APOLLO_CLIENT__ = this;
        /**
         * Suggest installing the devtools for developers who don't have them
         */ if (!$02d2383b4a0acb65$var$hasSuggestedDevtools && (0, $e15192e15b3ad6c1$export$a866f231438cc228)) {
            $02d2383b4a0acb65$var$hasSuggestedDevtools = true;
            if (window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol)) setTimeout(()=>{
                if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                    const nav = window.navigator;
                    const ua = nav && nav.userAgent;
                    let url;
                    if (typeof ua === "string") {
                        if (ua.indexOf("Chrome/") > -1) url = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                        else if (ua.indexOf("Firefox/") > -1) url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                    }
                    if (url) (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).log("Download the Apollo DevTools for a better development experience: %s", url);
                }
            }, 10000);
        }
    }
    /**
     * The `DocumentTransform` used to modify GraphQL documents before a request
     * is made. If a custom `DocumentTransform` is not provided, this will be the
     * default document transform.
     */ get documentTransform() {
        return this.queryManager.documentTransform;
    }
    /**
     * The configured `LocalState` instance used to enable the use of `@client`
     * fields.
     */ get localState() {
        return this.queryManager.localState;
    }
    set localState(localState) {
        this.queryManager.localState = localState;
    }
    /**
     * Call this method to terminate any active client processes, making it safe
     * to dispose of this `ApolloClient` instance.
     *
     * This method performs aggressive cleanup to prevent memory leaks:
     *
     * - Unsubscribes all active `ObservableQuery` instances by emitting a `completed` event
     * - Rejects all currently running queries with "QueryManager stopped while query was in flight"
     * - Removes all queryRefs from the suspense cache
     */ stop() {
        this.queryManager.stop();
    }
    /**
     * This watches the cache store of the query according to the options specified and
     * returns an `ObservableQuery`. We can subscribe to this `ObservableQuery` and
     * receive updated results through an observer when the cache store changes.
     *
     * Note that this method is not an implementation of GraphQL subscriptions. Rather,
     * it uses Apollo's store in order to reactively deliver updates to your query results.
     *
     * For example, suppose you call watchQuery on a GraphQL query that fetches a person's
     * first and last name and this person has a particular object identifier, provided by
     * `cache.identify`. Later, a different query fetches that same person's
     * first and last name and the first name has now changed. Then, any observers associated
     * with the results of the first query will be updated with a new result object.
     *
     * Note that if the cache does not change, the subscriber will _not_ be notified.
     *
     * See [here](https://medium.com/apollo-stack/the-concepts-of-graphql-bc68bd819be3#.3mb0cbcmc) for
     * a description of store reactivity.
     */ watchQuery(options) {
        if (this.defaultOptions.watchQuery) options = (0, $7e1dfc8c7a435d55$export$235b7fc70b9fc359)(this.defaultOptions.watchQuery, options);
        return this.queryManager.watchQuery(options);
    }
    /**
     * This resolves a single query according to the options specified and
     * returns a `Promise` which is either resolved with the resulting data
     * or rejected with an error.
     *
     * @param options - An object of type `QueryOptions` that allows us to
     * describe how this query should be treated e.g. whether it should hit the
     * server at all or just resolve from the cache, etc.
     */ query(options) {
        if (this.defaultOptions.query) options = (0, $7e1dfc8c7a435d55$export$235b7fc70b9fc359)(this.defaultOptions.query, options);
        if (0, $e15192e15b3ad6c1$export$a866f231438cc228) {
            (0, $aa2d7231b5e28112$export$f5708dca728d7177)(options.fetchPolicy !== "cache-and-network", 70);
            (0, $aa2d7231b5e28112$export$f5708dca728d7177)(options.fetchPolicy !== "standby", 71);
            (0, $aa2d7231b5e28112$export$f5708dca728d7177)(options.query, 72);
            (0, $aa2d7231b5e28112$export$f5708dca728d7177)(options.query.kind === "Document", 73);
            (0, $aa2d7231b5e28112$export$f5708dca728d7177)(!options.returnPartialData, 74);
            (0, $aa2d7231b5e28112$export$f5708dca728d7177)(!options.pollInterval, 75);
            (0, $aa2d7231b5e28112$export$f5708dca728d7177)(!options.notifyOnNetworkStatusChange, 76);
        }
        return this.queryManager.query(options);
    }
    /**
     * This resolves a single mutation according to the options specified and returns a
     * Promise which is either resolved with the resulting data or rejected with an
     * error. In some cases both `data` and `errors` might be undefined, for example
     * when `errorPolicy` is set to `'ignore'`.
     *
     * It takes options as an object with the following keys and values:
     */ mutate(options) {
        const optionsWithDefaults = (0, $7e1dfc8c7a435d55$export$235b7fc70b9fc359)((0, $8e62f7547d3f557e$export$8e16b83750b44988)({
            fetchPolicy: "network-only",
            errorPolicy: "none"
        }, this.defaultOptions.mutate), options);
        if (0, $e15192e15b3ad6c1$export$a866f231438cc228) {
            (0, $aa2d7231b5e28112$export$f5708dca728d7177)(optionsWithDefaults.mutation, 77);
            (0, $aa2d7231b5e28112$export$f5708dca728d7177)(optionsWithDefaults.fetchPolicy === "network-only" || optionsWithDefaults.fetchPolicy === "no-cache", 78);
        }
        (0, $2a4ebb84b536625f$export$a7d0d8111d2386df)(optionsWithDefaults.mutation, (0, $d53ea9002ec4d7a4$export$f58c50edb4aef9d4).MUTATION);
        return this.queryManager.mutate(optionsWithDefaults);
    }
    /**
     * This subscribes to a graphql subscription according to the options specified and returns an
     * `Observable` which either emits received data or an error.
     */ subscribe(options) {
        const cause = {};
        const observable = this.queryManager.startGraphQLSubscription(options);
        const mapped = observable.pipe((0, $6175481c6b9a1949$export$871de8747c9eaa88)((result)=>({
                ...result,
                data: this.queryManager.maskOperation({
                    document: options.query,
                    data: result.data,
                    fetchPolicy: options.fetchPolicy,
                    cause: cause
                })
            })));
        return Object.assign(mapped, {
            restart: observable.restart
        });
    }
    readQuery(options, optimistic = false) {
        return this.cache.readQuery({
            ...options,
            query: this.transform(options.query)
        }, optimistic);
    }
    watchFragment(options) {
        const dataMasking = this.queryManager.dataMasking;
        const observable = this.cache.watchFragment({
            ...options,
            fragment: this.transform(options.fragment, dataMasking)
        });
        if (0, $e15192e15b3ad6c1$export$a866f231438cc228) return (0, $85e8597b5615b1c6$export$17d87cebd0a0465a)(observable, Symbol.for("apollo.transform.dev.mask"), (result)=>({
                ...result,
                // The transform will remove fragment spreads from the fragment
                // document when dataMasking is enabled. The `mask` function
                // remains to apply warnings to fragments marked as
                // `@unmask(mode: "migrate")`. Since these warnings are only applied
                // in dev, we can skip the masking algorithm entirely for production.
                data: this.queryManager.maskFragment({
                    ...options,
                    data: result.data
                })
            }));
        return observable;
    }
    readFragment(options, optimistic = false) {
        return this.cache.readFragment({
            ...options,
            fragment: this.transform(options.fragment)
        }, optimistic);
    }
    /**
     * Writes some data in the shape of the provided GraphQL query directly to
     * the store. This method will start at the root query. To start at a
     * specific id returned by `cache.identify` then use `writeFragment`.
     */ writeQuery(options) {
        const ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    }
    /**
     * Writes some data in the shape of the provided GraphQL fragment directly to
     * the store. This method will write to a GraphQL fragment from any arbitrary
     * id that is currently cached, unlike `writeQuery` which will only write
     * from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are writing. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     */ writeFragment(options) {
        const ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    }
    __actionHookForDevTools(cb) {
        this.devToolsHookCb = cb;
    }
    __requestRaw(request) {
        return (0, $0e5659e1b70da0ac$export$51396ec711da548b)(this.link, request, {
            client: this
        });
    }
    /**
     * Resets your entire store by clearing out your cache and then re-executing
     * all of your active queries. This makes it so that you may guarantee that
     * there is no data left in your store from a time before you called this
     * method.
     *
     * `resetStore()` is useful when your user just logged out. You’ve removed the
     * user session, and you now want to make sure that any references to data you
     * might have fetched while the user session was active is gone.
     *
     * It is important to remember that `resetStore()` _will_ refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ resetStore() {
        return Promise.resolve().then(()=>this.queryManager.clearStore({
                discardWatches: false
            })).then(()=>Promise.all(this.resetStoreCallbacks.map((fn)=>fn()))).then(()=>this.refetchObservableQueries());
    }
    /**
     * Remove all data from the store. Unlike `resetStore`, `clearStore` will
     * not refetch any active queries.
     */ clearStore() {
        return Promise.resolve().then(()=>this.queryManager.clearStore({
                discardWatches: true
            })).then(()=>Promise.all(this.clearStoreCallbacks.map((fn)=>fn())));
    }
    /**
     * Allows callbacks to be registered that are executed when the store is
     * reset. `onResetStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ onResetStore(cb) {
        this.resetStoreCallbacks.push(cb);
        return ()=>{
            this.resetStoreCallbacks = this.resetStoreCallbacks.filter((c)=>c !== cb);
        };
    }
    /**
     * Allows callbacks to be registered that are executed when the store is
     * cleared. `onClearStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ onClearStore(cb) {
        this.clearStoreCallbacks.push(cb);
        return ()=>{
            this.clearStoreCallbacks = this.clearStoreCallbacks.filter((c)=>c !== cb);
        };
    }
    /**
     * Refetches all of your active queries.
     *
     * `reFetchObservableQueries()` is useful if you want to bring the client back to proper state in case of a network outage
     *
     * It is important to remember that `reFetchObservableQueries()` _will_ refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     * Takes optional parameter `includeStandby` which will include queries in standby-mode when refetching.
     *
     * Note: `cache-only` queries are not refetched by this function.
     *
     * @deprecated Please use `refetchObservableQueries` instead.
     */ reFetchObservableQueries;
    /**
     * Refetches all of your active queries.
     *
     * `refetchObservableQueries()` is useful if you want to bring the client back to proper state in case of a network outage
     *
     * It is important to remember that `refetchObservableQueries()` _will_ refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     * Takes optional parameter `includeStandby` which will include queries in standby-mode when refetching.
     *
     * Note: `cache-only` queries are not refetched by this function.
     */ refetchObservableQueries(includeStandby) {
        return this.queryManager.refetchObservableQueries(includeStandby);
    }
    /**
     * Refetches specified active queries. Similar to "refetchObservableQueries()" but with a specific list of queries.
     *
     * `refetchQueries()` is useful for use cases to imperatively refresh a selection of queries.
     *
     * It is important to remember that `refetchQueries()` _will_ refetch specified active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ refetchQueries(options) {
        const map = this.queryManager.refetchQueries(options);
        const queries = [];
        const results = [];
        map.forEach((result, obsQuery)=>{
            queries.push(obsQuery);
            results.push(result);
        });
        const result = Promise.all(results);
        // In case you need the raw results immediately, without awaiting
        // Promise.all(results):
        result.queries = queries;
        result.results = results;
        // If you decide to ignore the result Promise because you're using
        // result.queries and result.results instead, you shouldn't have to worry
        // about preventing uncaught rejections for the Promise.all result.
        result.catch((error)=>{
            (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).debug(79, error);
        });
        return result;
    }
    /**
     * Get all currently active `ObservableQuery` objects, in a `Set`.
     *
     * An "active" query is one that has observers and a `fetchPolicy` other than
     * "standby" or "cache-only".
     *
     * You can include all `ObservableQuery` objects (including the inactive ones)
     * by passing "all" instead of "active", or you can include just a subset of
     * active queries by passing an array of query names or DocumentNode objects.
     *
     * Note: This method only returns queries that have active subscribers. Queries
     * without subscribers are not tracked by the client.
     */ getObservableQueries(include = "active") {
        return this.queryManager.getObservableQueries(include);
    }
    /**
     * Exposes the cache's complete state, in a serializable format for later restoration.
     *
     * @remarks
     *
     * This can be useful for debugging in order to inspect the full state of the
     * cache.
     *
     * @param optimistic - Determines whether the result contains data from the
     * optimistic layer
     */ extract(optimistic) {
        return this.cache.extract(optimistic);
    }
    /**
     * Replaces existing state in the cache (if any) with the values expressed by
     * `serializedState`.
     *
     * Called when hydrating a cache (server side rendering, or offline storage),
     * and also (potentially) during hot reloads.
     */ restore(serializedState) {
        return this.cache.restore(serializedState);
    }
    /**
     * Define a new ApolloLink (or link chain) that Apollo Client will use.
     */ setLink(newLink) {
        this.link = newLink;
    }
    get defaultContext() {
        return this.queryManager.defaultContext;
    }
    maskedFragmentTransform = new (0, $a9a623faa62cac2b$export$f887060e48e5dc1b)((0, $e3b29cddc6a2eb6b$export$9e00fc5e314cda67));
    transform(document, dataMasking = false) {
        const transformed = this.queryManager.transform(document);
        return dataMasking ? this.maskedFragmentTransform.transformDocument(transformed) : transformed;
    }
}
if (0, $e15192e15b3ad6c1$export$a866f231438cc228) $02d2383b4a0acb65$export$13f5a5f0f1dbab88.prototype.getMemoryInternals = (0, $0b54944ffd705e51$export$dfdba94ce46d2ea5);


const $264c73136f36a4a1$export$6788812c4e6611e6 = (0, $44d61e2fd5c5ba8c$export$2fed3d61f740bc7f).from;




class $aae0259a2137e5cf$export$1583604d11424b51 extends (0, $44d61e2fd5c5ba8c$export$2fed3d61f740bc7f) {
    constructor(options = {}){
        super((operation, forward)=>{
            const client = operation.client;
            const clientOptions = client["queryManager"].clientOptions;
            const context = operation.getContext();
            {
                const { name: name, version: version, transport: transport = "headers" } = (0, $8e62f7547d3f557e$export$8e16b83750b44988)({}, clientOptions.clientAwareness, options.clientAwareness, context.clientAwareness);
                if (transport === "headers") operation.setContext(({ headers: headers })=>{
                    return {
                        headers: (0, $8e62f7547d3f557e$export$8e16b83750b44988)(// setting these first so that they can be overridden by user-provided headers
                        {
                            "apollographql-client-name": name,
                            "apollographql-client-version": version
                        }, headers)
                    };
                });
            }
            {
                const { transport: transport = "extensions" } = (0, $8e62f7547d3f557e$export$8e16b83750b44988)({}, clientOptions.enhancedClientAwareness, options.enhancedClientAwareness);
                if (transport === "extensions") operation.extensions = (0, $8e62f7547d3f557e$export$8e16b83750b44988)(// setting these first so that it can be overridden by user-provided extensions
                {
                    clientLibrary: {
                        name: "@apollo/client",
                        version: client.version
                    }
                }, operation.extensions);
                if (transport === "headers") operation.setContext(({ headers: headers })=>{
                    return {
                        headers: (0, $8e62f7547d3f557e$export$8e16b83750b44988)(// setting these first so that they can be overridden by user-provided headers
                        {
                            "apollographql-library-name": "@apollo/client",
                            "apollographql-library-version": client.version
                        }, headers)
                    };
                });
            }
            return forward(operation);
        });
    }
}





function $1f46ca07a302d23b$export$de246493ae27fe3f(variables, query) {
    const result = {
        ...variables
    };
    const unusedNames = new Set(Object.keys(variables));
    (0, $cd2396bbf46089ba$export$bf638b60ea8b89b7)(query, {
        Variable (node, _key, parent) {
            // A variable type definition at the top level of a query is not
            // enough to silence server-side errors about the variable being
            // unused, so variable definitions do not count as usage.
            // https://spec.graphql.org/draft/#sec-All-Variables-Used
            if (parent && parent.kind !== "VariableDefinition") unusedNames.delete(node.name.value);
        }
    });
    unusedNames.forEach((name)=>{
        delete result[name];
    });
    return result;
}



function $b367dcb95e9dde26$var$isOperation(document, operation) {
    return (0, $bfe912ade316f216$export$7a5b1fa979d2c158)(document)?.operation === operation;
}
function $b367dcb95e9dde26$export$1e3245727d2452cb(document) {
    return $b367dcb95e9dde26$var$isOperation(document, "mutation");
}
function $b367dcb95e9dde26$export$c6b59427cec373c0(document) {
    return $b367dcb95e9dde26$var$isOperation(document, "query");
}
function $b367dcb95e9dde26$export$2ca64ee07a3c6511(document) {
    return $b367dcb95e9dde26$var$isOperation(document, "subscription");
}






const $449b95f01a76a455$export$8423f0cd3773115e = (fetcher)=>{
    (0, $aa2d7231b5e28112$export$f5708dca728d7177)(fetcher || typeof fetch !== "undefined", 61);
};





const { hasOwnProperty: $c8da0723e7899e10$var$hasOwnProperty } = Object.prototype;
/**
 * This function detects an Apollo payload result before it is transformed
 * into a FetchResult via HttpLink; it cannot detect an ApolloPayloadResult
 * once it leaves the link chain.
 */ function $c8da0723e7899e10$var$isApolloPayloadResult(value) {
    return (0, $e79cca4a6323426e$export$417207af72fad9c9)(value) && "payload" in value;
}
async function* $c8da0723e7899e10$var$consumeMultipartBody(response) {
    const decoder = new TextDecoder("utf-8");
    const contentType = response.headers?.get("content-type");
    // parse boundary value and ignore any subsequent name/value pairs after ;
    // https://www.rfc-editor.org/rfc/rfc9110.html#name-parameters
    // e.g. multipart/mixed;boundary="graphql";deferSpec=20220824
    // if no boundary is specified, default to -
    const match = contentType?.match(/*
      ;\s*boundary=                # Match the boundary parameter
      (?:                          # either
        '([^']*)'                  # a string starting with ' doesn't contain ', ends with '
        |                          # or
        "([^"]*)"                  # a string starting with " doesn't contain ", ends with "
        |                          # or
        ([^"'].*?)                 # a string that doesn't start with ' or ", parsed non-greedily
        )                          # end of the group
      \s*                          # optional whitespace
      (?:;|$)                        # match a semicolon or end of string
    */ /;\s*boundary=(?:'([^']+)'|"([^"]+)"|([^"'].+?))\s*(?:;|$)/i);
    const boundary = "\r\n--" + (match ? match[1] ?? match[2] ?? match[3] ?? "-" : "-");
    let buffer = "";
    (0, $aa2d7231b5e28112$export$f5708dca728d7177)(response.body && typeof response.body.getReader === "function", 62);
    const stream = response.body;
    const reader = stream.getReader();
    let done = false;
    let encounteredBoundary = false;
    let value;
    // check to see if we received the final boundary, which is a normal boundary followed by "--"
    // as described in https://www.rfc-editor.org/rfc/rfc2046#section-5.1.1
    const passedFinalBoundary = ()=>encounteredBoundary && buffer[0] == "-" && buffer[1] == "-";
    try {
        while(!done){
            ({ value: value, done: done } = await reader.read());
            const chunk = typeof value === "string" ? value : decoder.decode(value);
            const searchFrom = buffer.length - boundary.length + 1;
            buffer += chunk;
            let bi = buffer.indexOf(boundary, searchFrom);
            while(bi > -1 && !passedFinalBoundary()){
                encounteredBoundary = true;
                let message;
                [message, buffer] = [
                    buffer.slice(0, bi),
                    buffer.slice(bi + boundary.length)
                ];
                const i = message.indexOf("\r\n\r\n");
                const headers = $c8da0723e7899e10$var$parseHeaders(message.slice(0, i));
                const contentType = headers["content-type"];
                if (contentType && contentType.toLowerCase().indexOf("application/json") === -1) throw new Error("Unsupported patch content type: application/json is required.");
                // nb: Technically you'd want to slice off the beginning "\r\n" but since
                // this is going to be `JSON.parse`d there is no need.
                const body = message.slice(i);
                if (body) yield body;
                bi = buffer.indexOf(boundary);
            }
            if (passedFinalBoundary()) return;
        }
        throw new Error("premature end of multipart body");
    } finally{
        reader.cancel();
    }
}
async function $c8da0723e7899e10$export$ccb60864026baf09(response, nextValue) {
    for await (const body of $c8da0723e7899e10$var$consumeMultipartBody(response)){
        const result = $c8da0723e7899e10$var$parseJsonEncoding(response, body);
        if (Object.keys(result).length == 0) continue;
        if ($c8da0723e7899e10$var$isApolloPayloadResult(result)) {
            if (Object.keys(result).length === 1 && result.payload === null) return;
            let next = {
                ...result.payload
            };
            if ("errors" in result) next.extensions = {
                ...next.extensions,
                [(0, $f1a9d96edac5fab2$export$4995664c1b49842e)]: new (0, $b3091290e5c54aca$export$efe656d729cf89ca)(result.errors ?? [])
            };
            nextValue(next);
        } else nextValue(result);
    }
}
function $c8da0723e7899e10$var$parseHeaders(headerText) {
    const headersInit = {};
    headerText.split("\n").forEach((line)=>{
        const i = line.indexOf(":");
        if (i > -1) {
            // normalize headers to lowercase
            const name = line.slice(0, i).trim().toLowerCase();
            const value = line.slice(i + 1).trim();
            headersInit[name] = value;
        }
    });
    return headersInit;
}
function $c8da0723e7899e10$var$parseJsonEncoding(response, bodyText) {
    if (response.status >= 300) throw new (0, $0038b7d5404f1ede$export$ea52035eac03daf0)(`Response not successful: Received status code ${response.status}`, {
        response: response,
        bodyText: bodyText
    });
    try {
        return JSON.parse(bodyText);
    } catch (err) {
        throw new (0, $afdacda929502087$export$2b2913ac6c4db8e6)(err, {
            response: response,
            bodyText: bodyText
        });
    }
}
function $c8da0723e7899e10$var$parseGraphQLResponseJsonEncoding(response, bodyText) {
    try {
        return JSON.parse(bodyText);
    } catch (err) {
        throw new (0, $afdacda929502087$export$2b2913ac6c4db8e6)(err, {
            response: response,
            bodyText: bodyText
        });
    }
}
function $c8da0723e7899e10$var$parseResponse(response, bodyText) {
    const contentType = response.headers.get("content-type");
    if (contentType?.includes("application/graphql-response+json")) return $c8da0723e7899e10$var$parseGraphQLResponseJsonEncoding(response, bodyText);
    return $c8da0723e7899e10$var$parseJsonEncoding(response, bodyText);
}
function $c8da0723e7899e10$export$d4051215bea0639f(operations) {
    return (response)=>response.text().then((bodyText)=>{
            const result = $c8da0723e7899e10$var$parseResponse(response, bodyText);
            if (!Array.isArray(result) && !$c8da0723e7899e10$var$hasOwnProperty.call(result, "data") && !$c8da0723e7899e10$var$hasOwnProperty.call(result, "errors")) throw new (0, $0038b7d5404f1ede$export$ea52035eac03daf0)(`Server response was malformed for query '${Array.isArray(operations) ? operations.map((op)=>op.operationName) : operations.operationName}'.`, {
                response: response,
                bodyText: bodyText
            });
            return result;
        });
}


// For GET operations, returns the given URI rewritten with parameters, or a
// parse error.
function $091f8644855cd0f7$export$fb82bb094b6f76b5(chosenURI, body) {
    // Implement the standard HTTP GET serialization, plus 'extensions'. Note
    // the extra level of JSON serialization!
    const queryParams = [];
    const addQueryParam = (key, value)=>{
        queryParams.push(`${key}=${encodeURIComponent(value)}`);
    };
    if ("query" in body) addQueryParam("query", body.query);
    if (body.operationName) addQueryParam("operationName", body.operationName);
    if (body.variables) {
        let serializedVariables;
        try {
            serializedVariables = JSON.stringify(body.variables);
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        let serializedExtensions;
        try {
            serializedExtensions = JSON.stringify(body.extensions);
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    // Reconstruct the URI with added query params.
    // XXX This assumes that the URI is well-formed and that it doesn't
    //     already contain any of these query params. We could instead use the
    //     URL API and take a polyfill (whatwg-url@6) for older browsers that
    //     don't support URLSearchParams. Note that some browsers (and
    //     versions of whatwg-url) support URL but not URLSearchParams!
    let fragment = "", preFragment = chosenURI;
    const fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    const queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    const newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return {
        newURI: newURI
    };
}



const $8a2cb9b12e04d570$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: true,
    preserveHeaderCase: false
};
const $8a2cb9b12e04d570$var$defaultHeaders = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: "application/graphql-response+json,application/json;q=0.9",
    // The content-type header describes the type of the body of the request, and
    // so it typically only is sent with requests that actually have bodies. One
    // could imagine that Apollo Client would remove this header when constructing
    // a GET request (which has no body), but we historically have not done that.
    // This means that browsers will preflight all Apollo Client requests (even
    // GET requests). Apollo Server's CSRF prevention feature (introduced in
    // AS3.7) takes advantage of this fact and does not block requests with this
    // header. If you want to drop this header from GET requests, then you should
    // probably replace it with a `apollo-require-preflight` header, or servers
    // with CSRF prevention enabled might block your GET request. See
    // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
    // for more details.
    "content-type": "application/json"
};
const $8a2cb9b12e04d570$var$defaultOptions = {
    method: "POST"
};
const $8a2cb9b12e04d570$export$dd86f00dc866e75d = {
    http: $8a2cb9b12e04d570$var$defaultHttpOptions,
    headers: $8a2cb9b12e04d570$var$defaultHeaders,
    options: $8a2cb9b12e04d570$var$defaultOptions
};
const $8a2cb9b12e04d570$export$e88934976ca4fd65 = (ast, printer)=>printer(ast);
function $8a2cb9b12e04d570$export$a00ebfd5f1eebfb1(operation, fallbackConfig, ...configs) {
    configs.unshift(fallbackConfig);
    return $8a2cb9b12e04d570$export$12d90ccf75844275(operation, $8a2cb9b12e04d570$export$e88934976ca4fd65, ...configs);
}
function $8a2cb9b12e04d570$export$12d90ccf75844275(operation, printer, ...configs) {
    let options = {};
    let http = {};
    configs.forEach((config)=>{
        options = {
            ...options,
            ...config.options,
            headers: {
                ...options.headers,
                ...config.headers
            }
        };
        if (config.credentials) options.credentials = config.credentials;
        options.headers.accept = (config.http?.accept || []).concat(options.headers.accept).join(",");
        http = {
            ...http,
            ...config.http
        };
    });
    options.headers = $8a2cb9b12e04d570$var$removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    //The body depends on the http options
    const { operationName: operationName, extensions: extensions, variables: variables, query: query } = operation;
    const body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions && Object.keys(extensions || {}).length) body.extensions = extensions;
    // not sending the query (i.e persisted queries)
    if (http.includeQuery) body.query = printer(query, (0, $a6091649f6831c1e$export$c2d084dc44961371));
    return {
        options: options,
        body: body
    };
}
// Remove potential duplicate header names, preserving last (by insertion order).
// This is done to prevent unintentionally duplicating a header instead of
// overwriting it (See #8447 and #8449).
function $8a2cb9b12e04d570$var$removeDuplicateHeaders(headers, preserveHeaderCase) {
    // If we're not preserving the case, just remove duplicates w/ normalization.
    if (!preserveHeaderCase) {
        const normalizedHeaders = {};
        Object.keys(Object(headers)).forEach((name)=>{
            normalizedHeaders[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders;
    }
    // If we are preserving the case, remove duplicates w/ normalization,
    // preserving the original name.
    // This allows for non-http-spec-compliant servers that expect intentionally
    // capitalized header names (See #6741).
    const headerData = {};
    Object.keys(Object(headers)).forEach((name)=>{
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name]
        };
    });
    const normalizedHeaders = {};
    Object.keys(headerData).forEach((name)=>{
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}


const $4decd88cc7b1095a$export$63ccc2571850f81a = (operation, fallbackURI)=>{
    const context = operation.getContext();
    const contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === "function") return fallbackURI(operation);
    else return fallbackURI || "/graphql";
};


const $fd2d624cba8060f2$var$backupFetch = (0, $480dec63d9529d01$export$f8b8b9ce72e9ccbf)(()=>fetch);
function $fd2d624cba8060f2$var$noop() {}
class $fd2d624cba8060f2$export$cd40e1cb4684a450 extends (0, $44d61e2fd5c5ba8c$export$2fed3d61f740bc7f) {
    constructor(options = {}){
        let { uri: uri = "/graphql", // use default global fetch if nothing passed in
        fetch: preferredFetch, print: print = (0, $8a2cb9b12e04d570$export$e88934976ca4fd65), includeExtensions: includeExtensions, preserveHeaderCase: preserveHeaderCase, useGETForQueries: useGETForQueries, includeUnusedVariables: includeUnusedVariables = false, ...requestOptions } = options;
        if (0, $e15192e15b3ad6c1$export$a866f231438cc228) // Make sure at least one of preferredFetch, window.fetch, or backupFetch is
        // defined, so requests won't fail at runtime.
        (0, $449b95f01a76a455$export$8423f0cd3773115e)(preferredFetch || $fd2d624cba8060f2$var$backupFetch);
        const linkConfig = {
            http: (0, $8e62f7547d3f557e$export$8e16b83750b44988)({
                includeExtensions: includeExtensions,
                preserveHeaderCase: preserveHeaderCase
            }),
            options: requestOptions.fetchOptions,
            credentials: requestOptions.credentials,
            headers: requestOptions.headers
        };
        super((operation)=>{
            let chosenURI = (0, $4decd88cc7b1095a$export$63ccc2571850f81a)(operation, uri);
            const context = operation.getContext();
            const http = {
                ...context.http
            };
            if ((0, $b367dcb95e9dde26$export$2ca64ee07a3c6511)(operation.query)) http.accept = [
                "multipart/mixed;boundary=graphql;subscriptionSpec=1.0",
                ...http.accept || []
            ];
            const contextConfig = {
                http: http,
                options: context.fetchOptions,
                credentials: context.credentials,
                headers: context.headers
            };
            //uses fallback, link, and then context to build options
            const { options: options, body: body } = (0, $8a2cb9b12e04d570$export$12d90ccf75844275)(operation, print, (0, $8a2cb9b12e04d570$export$dd86f00dc866e75d), linkConfig, contextConfig);
            if (body.variables && !includeUnusedVariables) body.variables = (0, $1f46ca07a302d23b$export$de246493ae27fe3f)(body.variables, operation.query);
            let controller = new AbortController();
            let cleanupController = ()=>{
                controller = undefined;
            };
            if (options.signal) {
                const externalSignal = options.signal;
                // in an ideal world we could use `AbortSignal.any` here, but
                // React Native uses https://github.com/mysticatea/abort-controller as
                // a polyfill for `AbortController`, and it does not support `AbortSignal.any`.
                const listener = ()=>{
                    controller?.abort(externalSignal.reason);
                };
                externalSignal.addEventListener("abort", listener, {
                    once: true
                });
                cleanupController = ()=>{
                    controller?.signal.removeEventListener("abort", cleanupController);
                    controller = undefined;
                    // on cleanup, we need to stop listening to `options.signal` to avoid memory leaks
                    externalSignal.removeEventListener("abort", listener);
                    cleanupController = $fd2d624cba8060f2$var$noop;
                };
                // react native also does not support the addEventListener `signal` option
                // so we have to simulate that ourself
                controller.signal.addEventListener("abort", cleanupController, {
                    once: true
                });
            }
            options.signal = controller.signal;
            if (useGETForQueries && !(0, $b367dcb95e9dde26$export$1e3245727d2452cb)(operation.query)) options.method = "GET";
            return new (0, $23f68ab689e21470$export$77cea355fa80b5f4)((observer)=>{
                if (options.method === "GET") {
                    const { newURI: newURI, parseError: parseError } = (0, $091f8644855cd0f7$export$fb82bb094b6f76b5)(chosenURI, body);
                    if (parseError) throw parseError;
                    chosenURI = newURI;
                } else options.body = JSON.stringify(body);
                // Prefer linkOptions.fetch (preferredFetch) if provided, and otherwise
                // fall back to the *current* global window.fetch function (see issue
                // #7832), or (if all else fails) the backupFetch function we saved when
                // this module was first evaluated. This last option protects against the
                // removal of window.fetch, which is unlikely but not impossible.
                const currentFetch = preferredFetch || (0, $480dec63d9529d01$export$f8b8b9ce72e9ccbf)(()=>fetch) || $fd2d624cba8060f2$var$backupFetch;
                const observerNext = observer.next.bind(observer);
                currentFetch(chosenURI, options).then((response)=>{
                    operation.setContext({
                        response: response
                    });
                    const ctype = response.headers?.get("content-type");
                    if (ctype !== null && /^multipart\/mixed/i.test(ctype)) return (0, $c8da0723e7899e10$export$ccb60864026baf09)(response, observerNext);
                    else return (0, $c8da0723e7899e10$export$d4051215bea0639f)(operation)(response).then(observerNext);
                }).then(()=>{
                    cleanupController();
                    observer.complete();
                }).catch((err)=>{
                    cleanupController();
                    observer.error(err);
                });
                return ()=>{
                    // XXX support canceling this request
                    // https://developers.google.com/web/updates/2017/09/abortable-fetch
                    if (controller) controller.abort();
                };
            });
        });
    }
}


class $3a0c2b1ddd554e2f$export$f4bbf1aec241cc1 extends (0, $44d61e2fd5c5ba8c$export$2fed3d61f740bc7f) {
    constructor(options = {}){
        const { left: left, right: right, request: request } = (0, $44d61e2fd5c5ba8c$export$2fed3d61f740bc7f).from([
            new (0, $aae0259a2137e5cf$export$1583604d11424b51)(options),
            new (0, $fd2d624cba8060f2$export$cd40e1cb4684a450)(options)
        ]);
        super(request);
        Object.assign(this, {
            left: left,
            right: right
        });
    }
}
const $3a0c2b1ddd554e2f$export$95180a16573d6675 = (options = {})=>new $3a0c2b1ddd554e2f$export$f4bbf1aec241cc1(options);




const $9d96340bd04b5f33$var$TYPENAME_FIELD = {
    kind: (0, $324243985983b985$export$a84bdc57c5122798).FIELD,
    name: {
        kind: (0, $324243985983b985$export$a84bdc57c5122798).NAME,
        value: "__typename"
    }
};
const $9d96340bd04b5f33$export$43b332f87950a467 = Object.assign(function(doc) {
    return (0, $cd2396bbf46089ba$export$bf638b60ea8b89b7)(doc, {
        SelectionSet: {
            enter (node, _key, parent) {
                // Don't add __typename to OperationDefinitions.
                if (parent && parent.kind === (0, $324243985983b985$export$a84bdc57c5122798).OPERATION_DEFINITION) return;
                // No changes if no selections.
                const { selections: selections } = node;
                if (!selections) return;
                // If selections already have a __typename, or are part of an
                // introspection query, do nothing.
                const skip = selections.some((selection)=>{
                    return selection.kind === (0, $324243985983b985$export$a84bdc57c5122798).FIELD && (selection.name.value === "__typename" || selection.name.value.lastIndexOf("__", 0) === 0);
                });
                if (skip) return;
                // If this SelectionSet is @export-ed as an input variable, it should
                // not have a __typename field (see issue #4691).
                const field = parent;
                if (field.kind === (0, $324243985983b985$export$a84bdc57c5122798).FIELD && field.directives && field.directives.some((d)=>d.name.value === "export")) return;
                // Create and return a new SelectionSet with a __typename Field.
                return {
                    ...node,
                    selections: [
                        ...selections,
                        $9d96340bd04b5f33$var$TYPENAME_FIELD
                    ]
                };
            }
        }
    });
}, {
    added (field) {
        return field === $9d96340bd04b5f33$var$TYPENAME_FIELD;
    }
});

/**
 * Determines if a given object is a reference object.
 *
 * @param obj - The object to check if its a reference object
 *
 * @example
 *
 * ```ts
 * import { isReference } from "@apollo/client/utilities";
 *
 * isReference({ __ref: "User:1" }); // true
 * isReference({ __typename: "User", id: 1 }); // false
 * ```
 */ function $7014c795296fa5ac$export$fa99cac1c0883c47(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}












function $8b8afd58f50c55d9$export$779c5fb865a0172e(comparator, keySelector) {
    if (keySelector === void 0) keySelector = (0, $c1a8806d0be82246$export$f0954fd7d5368655);
    comparator = comparator !== null && comparator !== void 0 ? comparator : $8b8afd58f50c55d9$var$defaultCompare;
    return (0, $beab12e89343bf23$export$871731df685d7753)(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe((0, $da8da925672b7eb3$export$b9e075132cc6937f)(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function $8b8afd58f50c55d9$var$defaultCompare(a, b) {
    return a === b;
}




var $da8ec979ab61d742$export$8d6b71a2b178fc32 = new (0, $34d801dcaad6bbe2$export$4114a3ec92faa3c6)((0, $36f9373025161954$export$b5369ffd7cb2211b));
var $da8ec979ab61d742$export$12af436354f1a4f7 = $da8ec979ab61d742$export$8d6b71a2b178fc32;



function $ba1807eaf827eee4$export$c03bb0116ee09d4b(value) {
    return value instanceof Date && !isNaN(value);
}


function $347ab9b35506caa5$export$9dc4ecf953986f04(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    if (scheduler === void 0) scheduler = (0, $da8ec979ab61d742$export$12af436354f1a4f7);
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if ((0, $87b0ea8f3c2dacce$export$187e35932e88c15c)(intervalOrScheduler)) scheduler = intervalOrScheduler;
        else intervalDuration = intervalOrScheduler;
    }
    return new (0, $23f68ab689e21470$export$77cea355fa80b5f4)(function(subscriber) {
        var due = (0, $ba1807eaf827eee4$export$c03bb0116ee09d4b)(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) due = 0;
        var n = 0;
        return scheduler.schedule(function() {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) this.schedule(undefined, intervalDuration);
                else subscriber.complete();
            }
        }, due);
    });
}





function $1f95eb38021c2b23$export$5e772a3f6a698b12(...prebound) {
    return (0, $f07187d601866eca$export$cd3144f8dd136006).bind(null, ...prebound);
}


function $d5d0860c39cb6fe5$export$f219ae4213b3d311(observables) {
    if (observables.length === 0) return 0, $31cce697e13f76b3$export$ccb33e29d92c9a58;
    return new (0, $23f68ab689e21470$export$77cea355fa80b5f4)((observer)=>{
        const { length: length } = observables;
        // Keeps track of current values for each observable
        const values = new Array(length);
        // Used to batch an update each item in the array that share an observable
        // so that they can be emitted together.
        const indexesByObservable = new Map();
        observables.forEach((source, idx)=>{
            if (!indexesByObservable.has(source)) indexesByObservable.set(source, new Set());
            indexesByObservable.get(source).add(idx);
        });
        // Track the number of active subscriptions so we know when to complete this
        // observable
        let active = indexesByObservable.size;
        // Track how many observables are left to emit their first value
        let remainingFirstValues = indexesByObservable.size;
        let currentBatch;
        // Subscribe to each unique observable instead of the raw source array of
        // observables since we want at most 1-subscription per unique observable.
        // This ensures an update can write to multiple indexes before emitting the
        // result.
        indexesByObservable.forEach((indexes, source)=>{
            let hasFirstValue = false;
            const subscription = source.subscribe({
                next: (value)=>{
                    indexes.forEach((idx)=>values[idx] = value);
                    if (!hasFirstValue) {
                        hasFirstValue = true;
                        remainingFirstValues--;
                    }
                    if (!remainingFirstValues) {
                        currentBatch ||= new Set(observables.filter((obs)=>obs.dirty));
                        currentBatch.delete(source);
                        if (!currentBatch.size) {
                            observer.next(values.slice());
                            currentBatch = undefined;
                        }
                    }
                },
                complete: ()=>{
                    active--;
                    if (!active) observer.complete();
                },
                error: observer.error.bind(observer)
            });
            observer.add(subscription);
        });
    });
}


function $477c0ce8f159f13a$export$abbf37c7cf644e41(document, fragmentName) {
    let actualFragmentName = fragmentName;
    // Build an array of all our fragment definitions that will be used for
    // validations. We also do some validations on the other definitions in the
    // document while building this list.
    const fragments = [];
    document.definitions.forEach((definition)=>{
        // Throw an error if we encounter an operation definition because we will
        // define our own operation definition later on.
        if (definition.kind === "OperationDefinition") throw (0, $aa2d7231b5e28112$export$3991762405098ea)(10, definition.operation, definition.name ? ` named '${definition.name.value}'` : "");
        // Add our definition to the fragments array if it is a fragment
        // definition.
        if (definition.kind === "FragmentDefinition") fragments.push(definition);
    });
    // If the user did not give us a fragment name then let us try to get a
    // name from a single fragment in the definition.
    if (typeof actualFragmentName === "undefined") {
        (0, $aa2d7231b5e28112$export$f5708dca728d7177)(fragments.length === 1, 11, fragments.length);
        actualFragmentName = fragments[0].name.value;
    }
    // Generate a query document with an operation that simply spreads the
    // fragment inside of it.
    const query = {
        ...document,
        definitions: [
            {
                kind: "OperationDefinition",
                // OperationTypeNode is an enum
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            },
            ...document.definitions
        ]
    };
    return query;
}



class $9bbc598d12210779$export$5fc74f25506aa9c {
    assumeImmutableResults = false;
    // Function used to lookup a fragment when a fragment definition is not part
    // of the GraphQL document. This is useful for caches, such as InMemoryCache,
    // that register fragments ahead of time so they can be referenced by name.
    lookupFragment(fragmentName) {
        return null;
    }
    // Transactional API
    /**
     * Executes multiple cache operations as a single batch, ensuring that
     * watchers are only notified once after all operations complete. This is
     * useful for improving performance when making multiple cache updates, as it
     * prevents unnecessary re-renders or query refetches between individual
     * operations.
     *
     * The `batch` method supports both optimistic and non-optimistic updates, and
     * provides fine-grained control over which cache layer receives the updates
     * and when watchers are notified.
     *
     * For usage instructions, see [Interacting with cached data: `cache.batch`](https://www.apollographql.com/docs/react/caching/cache-interaction#using-cachebatch).
     *
     * @example
     *
     * ```js
     * cache.batch({
     *   update(cache) {
     *     cache.writeQuery({
     *       query: GET_TODOS,
     *       data: { todos: updatedTodos },
     *     });
     *     cache.evict({ id: "Todo:123" });
     *   },
     * });
     * ```
     *
     * @example
     *
     * ```js
     * // Optimistic update with a custom layer ID
     * cache.batch({
     *   optimistic: "add-todo-optimistic",
     *   update(cache) {
     *     cache.modify({
     *       fields: {
     *         todos(existing = []) {
     *           return [...existing, newTodoRef];
     *         },
     *       },
     *     });
     *   },
     * });
     * ```
     *
     * @returns The return value of the `update` function.
     */ batch(options) {
        const optimisticId = typeof options.optimistic === "string" ? options.optimistic : options.optimistic === false ? null : void 0;
        let updateResult;
        this.performTransaction(()=>updateResult = options.update(this), optimisticId);
        return updateResult;
    }
    recordOptimisticTransaction(transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    }
    // Optional API
    // Called once per input document, allowing the cache to make static changes
    // to the query, such as adding __typename fields.
    transformDocument(document) {
        return document;
    }
    // Called before each ApolloLink request, allowing the cache to make dynamic
    // changes to the query, such as filling in missing fragment definitions.
    transformForLink(document) {
        return document;
    }
    identify(object) {
        return;
    }
    gc() {
        return [];
    }
    modify(options) {
        return false;
    }
    readQuery(options, optimistic = !!options.optimistic) {
        return this.read({
            ...options,
            rootId: options.id || "ROOT_QUERY",
            optimistic: optimistic
        });
    }
    fragmentWatches = new (0, $3fafa7abbadfcc3d$export$73571c50d0f2507e)(true);
    /**
    * Watches the cache store of the fragment according to the options specified
    * and returns an `Observable`. We can subscribe to this
    * `Observable` and receive updated results through an
    * observer when the cache store changes.
    * 
    * You must pass in a GraphQL document with a single fragment or a document
    * with multiple fragments that represent what you are reading. If you pass
    * in a document with multiple fragments then you must also specify a
    * `fragmentName`.
    * 
    * @since 3.10.0
    * @param options - An object of type `WatchFragmentOptions` that allows
    * the cache to identify the fragment and optionally specify whether to react
    * to optimistic updates.
    */ watchFragment(options) {
        const { fragment: fragment, fragmentName: fragmentName, from: from } = options;
        const query = this.getFragmentDoc(fragment, fragmentName);
        const fromArray = Array.isArray(from) ? from : [
            from
        ];
        const ids = fromArray.map((value)=>{
            // While our TypeScript types do not allow for `undefined` as a valid
            // `from`, its possible `useFragment` gives us an `undefined` since it
            // calls` cache.identify` and provides that value to `from`. We are
            // adding this fix here however to ensure those using plain JavaScript
            // and using `cache.identify` themselves will avoid seeing the obscure
            // warning.
            const id = value == null ? value : this.toCacheId(value);
            if (0, $e15192e15b3ad6c1$export$a866f231438cc228) {
                const actualFragmentName = fragmentName || (0, $0d31b63b7d259842$export$772111caef41b3f5)(fragment).name.value;
                if (id === undefined) (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).warn(113, actualFragmentName);
            }
            return id;
        });
        if (!Array.isArray(from)) {
            const observable = this.watchSingleFragment(ids[0], query, options);
            // Unfortunately we forgot to allow for `null` on watchFragment in 4.0
            // when `from` is a single record. As such, we need to fallback to {}
            // when diff.result is null to maintain backwards compatibility. We
            // should plan to change this in v5. We do however support `null` if
            // `from` is explicitly `null`.
            //
            // NOTE: Using `from` with an array will maintain `null` properly
            // without the need for a similar fallback since watchFragment with
            // arrays is new functionality in v4.1.
            return from === null ? observable : (0, $85e8597b5615b1c6$export$17d87cebd0a0465a)(observable, Symbol.for("apollo.transform.individualResult"), (result)=>({
                    ...result,
                    data: result.data ?? {}
                }));
        }
        let currentResult;
        function toResult(results) {
            const result = results.reduce((memo, result, idx)=>{
                memo.data.push(result.data);
                memo.complete &&= result.complete;
                memo.dataState = memo.complete ? "complete" : "partial";
                if (result.missing) {
                    memo.missing ||= {};
                    memo.missing[idx] = result.missing;
                }
                return memo;
            }, {
                data: [],
                dataState: "complete",
                complete: true
            });
            if (!(0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(currentResult, result)) currentResult = result;
            return currentResult;
        }
        if (ids.length === 0) return $9bbc598d12210779$var$emptyArrayObservable;
        let subscribed = false;
        const observables = ids.map((id)=>this.watchSingleFragment(id, query, options));
        const observable = (0, $d5d0860c39cb6fe5$export$f219ae4213b3d311)(observables).pipe((0, $6175481c6b9a1949$export$871de8747c9eaa88)(toResult), (0, $074c390243aea0da$export$3f23594af5f37336)({
            subscribe: ()=>subscribed = true,
            unsubscribe: ()=>subscribed = false
        }), (0, $2a32ac76ac1a6174$export$db61d692014e534e)({
            bufferSize: 1,
            refCount: true
        }));
        return Object.assign(observable, {
            getCurrentResult: ()=>{
                if (subscribed && currentResult) return currentResult;
                const results = observables.map((observable)=>observable.getCurrentResult());
                return toResult(results);
            }
        });
    }
    /**
     * Can be overridden by subclasses to delay calling the provided callback
     * until after all broadcasts have been completed - e.g. in a cache scenario
     * where many watchers are notified in parallel.
     */ onAfterBroadcast = (cb)=>cb();
    watchSingleFragment(id, fragmentQuery, options) {
        if (id === null) return $9bbc598d12210779$var$nullObservable;
        const { optimistic: optimistic = true, variables: variables } = options;
        const cacheKey = [
            fragmentQuery,
            (0, $a82bc0d00c91b19f$export$88a0ad9b6f961b51)({
                id: id,
                optimistic: optimistic,
                variables: variables
            })
        ];
        const cacheEntry = this.fragmentWatches.lookupArray(cacheKey);
        if (!cacheEntry.observable) {
            let subscribed = false;
            let currentResult;
            function getNewestResult(diff) {
                const data = diff.result;
                if (!currentResult || !(0, $6b68336fdc3e0e6c$export$5e40714c5ad44445)(fragmentQuery, {
                    data: currentResult.data
                }, {
                    data: data
                }, options.variables)) {
                    currentResult = {
                        data: data,
                        dataState: diff.complete ? "complete" : "partial",
                        complete: diff.complete
                    };
                    if (diff.missing) currentResult.missing = diff.missing.missing;
                }
                return currentResult;
            }
            const observable = new (0, $23f68ab689e21470$export$77cea355fa80b5f4)((observer)=>{
                subscribed = true;
                const cleanup = this.watch({
                    variables: variables,
                    returnPartialData: true,
                    id: id,
                    query: fragmentQuery,
                    optimistic: optimistic,
                    immediate: true,
                    callback: (diff)=>{
                        observable.dirty = true;
                        this.onAfterBroadcast(()=>{
                            observer.next(getNewestResult(diff));
                            observable.dirty = false;
                        });
                    }
                });
                return ()=>{
                    subscribed = false;
                    cleanup();
                    this.fragmentWatches.removeArray(cacheKey);
                };
            }).pipe((0, $8b8afd58f50c55d9$export$779c5fb865a0172e)(), (0, $590f717384cd71b5$export$ed80d9de1d9df928)({
                connector: ()=>new (0, $de3901f1c29f38e2$export$915d2682b0aa0991)(1),
                // debounce so a synchronous unsubscribe+resubscribe doesn't tear down the watch and create a new one
                resetOnRefCountZero: ()=>(0, $347ab9b35506caa5$export$9dc4ecf953986f04)(0)
            }));
            cacheEntry.observable = Object.assign(observable, {
                dirty: false,
                getCurrentResult: ()=>{
                    if (subscribed && currentResult) return currentResult;
                    return getNewestResult(this.diff({
                        id: id,
                        query: fragmentQuery,
                        returnPartialData: true,
                        optimistic: optimistic,
                        variables: variables
                    }));
                }
            });
        }
        return cacheEntry.observable;
    }
    // Make sure we compute the same (===) fragment query document every
    // time we receive the same fragment in readFragment.
    getFragmentDoc = (0, $f07187d601866eca$export$4997ffc0176396a6)((0, $477c0ce8f159f13a$export$abbf37c7cf644e41), {
        max: (0, $9f7df0d640a1952d$export$f29926b23b28936b)["cache.fragmentQueryDocuments"] || 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
        cache: (0, $07bddf69ae669f38$export$87b462129af3b7d4),
        makeCacheKey: (0, $1f95eb38021c2b23$export$5e772a3f6a698b12)(this)
    });
    readFragment(options, optimistic = !!options.optimistic) {
        const id = options.from !== undefined ? this.toCacheId(options.from) : options.id;
        return this.read({
            ...options,
            query: this.getFragmentDoc(options.fragment, options.fragmentName),
            rootId: id,
            optimistic: optimistic
        });
    }
    writeQuery({ id: id, data: data, ...options }) {
        return this.write(Object.assign(options, {
            dataId: id || "ROOT_QUERY",
            result: data
        }));
    }
    writeFragment({ data: data, fragment: fragment, fragmentName: fragmentName, ...options }) {
        const id = options.from !== undefined ? this.toCacheId(options.from) : options.id;
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data
        }));
    }
    updateQuery(options, update) {
        return this.batch({
            update (cache) {
                const value = cache.readQuery(options);
                const data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeQuery({
                    ...options,
                    data: data
                });
                return data;
            }
        });
    }
    updateFragment(options, update) {
        return this.batch({
            update (cache) {
                const value = cache.readFragment(options);
                const data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeFragment({
                    ...options,
                    data: data
                });
                return data;
            }
        });
    }
    toCacheId(from) {
        return typeof from === "string" ? from : this.identify(from);
    }
}
if (0, $e15192e15b3ad6c1$export$a866f231438cc228) $9bbc598d12210779$export$5fc74f25506aa9c.prototype.getMemoryInternals = (0, $0b54944ffd705e51$export$e7ed438e82606689);
const $9bbc598d12210779$var$nullResult = Object.freeze({
    data: null,
    dataState: "complete",
    complete: true
});
const $9bbc598d12210779$var$nullObservable = Object.assign(new (0, $23f68ab689e21470$export$77cea355fa80b5f4)((observer)=>{
    observer.next($9bbc598d12210779$var$nullResult);
}), {
    dirty: false,
    getCurrentResult: ()=>$9bbc598d12210779$var$nullResult
});
const $9bbc598d12210779$var$emptyArrayResult = Object.freeze({
    data: [],
    dataState: "complete",
    complete: true
});
const $9bbc598d12210779$var$emptyArrayObservable = Object.assign(new (0, $23f68ab689e21470$export$77cea355fa80b5f4)((observer)=>{
    observer.next($9bbc598d12210779$var$emptyArrayResult);
}), {
    getCurrentResult: ()=>$9bbc598d12210779$var$emptyArrayResult
});








const { hasOwnProperty: $4db7004dd586db75$var$hasOwnProperty } = Object.prototype;
const $4db7004dd586db75$var$defaultReconciler = function(target, source, property) {
    return this.merge(target[property], source[property]);
};
const $4db7004dd586db75$var$objForKey = (key)=>{
    return isNaN(+key) ? {} : [];
};
class $4db7004dd586db75$export$509e11c221f576c0 {
    options;
    reconciler;
    constructor(options = {}){
        this.options = options;
        this.reconciler = options.reconciler || $4db7004dd586db75$var$defaultReconciler;
    }
    merge(target, source, mergeOptions = {}) {
        const atPath = mergeOptions.atPath;
        if (atPath?.length) {
            const [head, ...tail] = atPath;
            if (target === undefined) target = $4db7004dd586db75$var$objForKey(head);
            let nestedTarget = target[head];
            if (nestedTarget === undefined && tail.length) nestedTarget = $4db7004dd586db75$var$objForKey(tail[0]);
            const nestedSource = this.merge(nestedTarget, source, {
                ...mergeOptions,
                atPath: tail
            });
            if (nestedTarget !== nestedSource) {
                target = this.shallowCopyForMerge(target);
                target[head] = nestedSource;
            }
            return target;
        }
        if (Array.isArray(target) && Array.isArray(source) && this.options.arrayMerge === "truncate" && target.length > source.length) {
            target = target.slice(0, source.length);
            this.pastCopies.add(target);
        }
        if ((0, $e79cca4a6323426e$export$417207af72fad9c9)(source) && (0, $e79cca4a6323426e$export$417207af72fad9c9)(target)) {
            Object.keys(source).forEach((sourceKey)=>{
                if ($4db7004dd586db75$var$hasOwnProperty.call(target, sourceKey)) {
                    const targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        const result = this.reconciler(target, source, sourceKey);
                        // A well-implemented reconciler may return targetValue to indicate
                        // the merge changed nothing about the structure of the target.
                        if (result !== targetValue) {
                            target = this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                } else {
                    // If there is no collision, the target can safely share memory with
                    // the source, and the recursion can terminate here.
                    target = this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        // If source (or target) is not an object, let source replace target.
        return source;
    }
    isObject = (0, $e79cca4a6323426e$export$417207af72fad9c9);
    pastCopies = new Set();
    shallowCopyForMerge(value) {
        if ((0, $e79cca4a6323426e$export$417207af72fad9c9)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) value = value.slice(0);
                else value = {
                    __proto__: Object.getPrototypeOf(value),
                    ...value
                };
                this.pastCopies.add(value);
            }
        }
        return value;
    }
}

/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/ function $6e3cddf834991569$export$634ae0e932e9be99(id) {
    return {
        __ref: String(id)
    };
}





const { hasOwnProperty: $1c7a634c9225e137$export$b5a638e9b3fff9f3 } = Object.prototype;
function $1c7a634c9225e137$export$bd03c5a9c99d6bce({ __typename: __typename, id: id, _id: _id }, context) {
    if (typeof __typename === "string") {
        if (context) context.keyObject = id != null ? {
            id: id
        } : _id != null ? {
            _id: _id
        } : void 0;
        // If there is no object.id, fall back to object._id.
        if (id == null && _id != null) id = _id;
        if (id != null) return `${__typename}:${typeof id === "number" || typeof id === "string" ? id : JSON.stringify(id)}`;
    }
}
const $1c7a634c9225e137$var$defaultConfig = {
    dataIdFromObject: $1c7a634c9225e137$export$bd03c5a9c99d6bce,
    resultCaching: true
};
function $1c7a634c9225e137$export$fa542f9ee3f7f4e2(config) {
    return (0, $8e62f7547d3f557e$export$8e16b83750b44988)($1c7a634c9225e137$var$defaultConfig, config);
}
function $1c7a634c9225e137$export$fdef206c83ff2c09(store, objectOrReference) {
    return (0, $7014c795296fa5ac$export$fa99cac1c0883c47)(objectOrReference) ? store.get(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}
const $1c7a634c9225e137$export$6ed54d4784f1ce28 = /^[_a-z][_0-9a-z]*/i;
function $1c7a634c9225e137$export$37874422037b6029(storeFieldName) {
    const match = storeFieldName.match($1c7a634c9225e137$export$6ed54d4784f1ce28);
    return match ? match[0] : storeFieldName;
}
function $1c7a634c9225e137$export$60bd1cbb09c1a4a2(selectionSet, result, variables) {
    if ((0, $e79cca4a6323426e$export$417207af72fad9c9)(result)) return (0, $120a6dcb47daaf45$export$43bee75e5e14138e)(result) ? result.every((item)=>$1c7a634c9225e137$export$60bd1cbb09c1a4a2(selectionSet, item, variables)) : selectionSet.selections.every((field)=>{
        if ((0, $e5a2402b798644a7$export$fb56ad75dd311c12)(field) && (0, $873800698121f009$export$3dc388a5f013b4a5)(field, variables)) {
            const key = (0, $6a5b17c6ecfc0cd4$export$7d1ad22471852218)(field);
            return $1c7a634c9225e137$export$b5a638e9b3fff9f3.call(result, key) && (!field.selectionSet || $1c7a634c9225e137$export$60bd1cbb09c1a4a2(field.selectionSet, result[key], variables));
        }
        // If the selection has been skipped with @skip(true) or
        // @include(false), it should not count against the matching. If
        // the selection is not a field, it must be a fragment (inline or
        // named). We will determine if selectionSetMatchesResult for that
        // fragment when we get to it, so for now we return true.
        return true;
    });
    return false;
}
function $1c7a634c9225e137$export$4f39afca21bd938e(value) {
    return (0, $e79cca4a6323426e$export$417207af72fad9c9)(value) && !(0, $7014c795296fa5ac$export$fa99cac1c0883c47)(value) && !(0, $120a6dcb47daaf45$export$43bee75e5e14138e)(value);
}
function $1c7a634c9225e137$export$b874a818f7a2fa6d() {
    return new (0, $4db7004dd586db75$export$509e11c221f576c0)();
}
function $1c7a634c9225e137$export$3a33c00f0ae4a480(document, fragments) {
    // FragmentMap consisting only of fragments defined directly in document, not
    // including other fragments registered in the FragmentRegistry.
    const fragmentMap = (0, $af06dc884b782fca$export$193789b4c8246dd4)((0, $499d29b3c6f5bfa6$export$5320a7ba9466a3df)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment (name) {
            let def = fragmentMap[name];
            if (!def && fragments) def = fragments.lookup(name);
            return def || null;
        }
    };
}


const $2fbe0640bbab32b5$var$DELETE = {};
const $2fbe0640bbab32b5$var$delModifier = ()=>$2fbe0640bbab32b5$var$DELETE;
const $2fbe0640bbab32b5$var$INVALIDATE = {};
class $2fbe0640bbab32b5$export$cb507f57054c7321 {
    policies;
    group;
    data = {};
    constructor(policies, group){
        this.policies = policies;
        this.group = group;
    }
    // Although the EntityStore class is abstract, it contains concrete
    // implementations of the various NormalizedCache interface methods that
    // are inherited by the Root and Layer subclasses.
    toObject() {
        return {
            ...this.data
        };
    }
    has(dataId) {
        return this.lookup(dataId, true) !== void 0;
    }
    get(dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if ((0, $1c7a634c9225e137$export$b5a638e9b3fff9f3).call(this.data, dataId)) {
            const storeObject = this.data[dataId];
            if (storeObject && (0, $1c7a634c9225e137$export$b5a638e9b3fff9f3).call(storeObject, fieldName)) return storeObject[fieldName];
        }
        if (fieldName === "__typename" && (0, $1c7a634c9225e137$export$b5a638e9b3fff9f3).call(this.policies.rootTypenamesById, dataId)) return this.policies.rootTypenamesById[dataId];
        if (this instanceof $2fbe0640bbab32b5$var$Layer) return this.parent.get(dataId, fieldName);
    }
    lookup(dataId, dependOnExistence) {
        // The has method (above) calls lookup with dependOnExistence = true, so
        // that it can later be invalidated when we add or remove a StoreObject for
        // this dataId. Any consumer who cares about the contents of the StoreObject
        // should not rely on this dependency, since the contents could change
        // without the object being added or removed.
        if (dependOnExistence) this.group.depend(dataId, "__exists");
        if ((0, $1c7a634c9225e137$export$b5a638e9b3fff9f3).call(this.data, dataId)) return this.data[dataId];
        if (this instanceof $2fbe0640bbab32b5$var$Layer) return this.parent.lookup(dataId, dependOnExistence);
        if (this.policies.rootTypenamesById[dataId]) return {};
    }
    merge(older, newer) {
        let dataId;
        // Convert unexpected references to ID strings.
        if ((0, $7014c795296fa5ac$export$fa99cac1c0883c47)(older)) older = older.__ref;
        if ((0, $7014c795296fa5ac$export$fa99cac1c0883c47)(newer)) newer = newer.__ref;
        const existing = typeof older === "string" ? this.lookup(dataId = older) : older;
        const incoming = typeof newer === "string" ? this.lookup(dataId = newer) : newer;
        // If newer was a string ID, but that ID was not defined in this store,
        // then there are no fields to be merged, so we're done.
        if (!incoming) return;
        (0, $aa2d7231b5e28112$export$f5708dca728d7177)(typeof dataId === "string", 99);
        const merged = new (0, $4db7004dd586db75$export$509e11c221f576c0)({
            reconciler: $2fbe0640bbab32b5$var$storeObjectReconciler
        }).merge(existing, incoming);
        // Even if merged === existing, existing may have come from a lower
        // layer, so we always need to set this.data[dataId] on this level.
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                const fieldsToDirty = {};
                // If we added a new StoreObject where there was previously none, dirty
                // anything that depended on the existence of this dataId, such as the
                // EntityStore#has method.
                if (!existing) fieldsToDirty.__exists = 1;
                // Now invalidate dependents who called getFieldValue for any fields
                // that are changing as a result of this merge.
                Object.keys(incoming).forEach((storeFieldName)=>{
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        // Always dirty the full storeFieldName, which may include
                        // serialized arguments following the fieldName prefix.
                        fieldsToDirty[storeFieldName] = 1;
                        // Also dirty fieldNameFromStoreName(storeFieldName) if it's
                        // different from storeFieldName and this field does not have
                        // keyArgs configured, because that means the cache can't make
                        // any assumptions about how field values with the same field
                        // name but different arguments might be interrelated, so it
                        // must err on the side of invalidating all field values that
                        // share the same short fieldName, regardless of arguments.
                        const fieldName = (0, $1c7a634c9225e137$export$37874422037b6029)(storeFieldName);
                        if (fieldName !== storeFieldName && !this.policies.hasKeyArgs(merged.__typename, fieldName)) fieldsToDirty[fieldName] = 1;
                        // If merged[storeFieldName] has become undefined, and this is the
                        // Root layer, actually delete the property from the merged object,
                        // which is guaranteed to have been created fresh in this method.
                        if (merged[storeFieldName] === void 0 && !(this instanceof $2fbe0640bbab32b5$var$Layer)) delete merged[storeFieldName];
                    }
                });
                if (fieldsToDirty.__typename && !(existing && existing.__typename) && // Since we return default root __typename strings
                // automatically from store.get, we don't need to dirty the
                // ROOT_QUERY.__typename field if merged.__typename is equal
                // to the default string (usually "Query").
                this.policies.rootTypenamesById[dataId] === merged.__typename) delete fieldsToDirty.__typename;
                Object.keys(fieldsToDirty).forEach((fieldName)=>this.group.dirty(dataId, fieldName));
            }
        }
    }
    modify(dataId, fields, exact) {
        const storeObject = this.lookup(dataId);
        if (storeObject) {
            const changedFields = {};
            let needToMerge = false;
            let allDeleted = true;
            const sharedDetails = {
                DELETE: $2fbe0640bbab32b5$var$DELETE,
                INVALIDATE: $2fbe0640bbab32b5$var$INVALIDATE,
                isReference: $7014c795296fa5ac$export$fa99cac1c0883c47,
                toReference: this.toReference,
                canRead: this.canRead,
                readField: (fieldNameOrOptions, from)=>this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                        fieldName: fieldNameOrOptions,
                        from: from || (0, $6e3cddf834991569$export$634ae0e932e9be99)(dataId)
                    } : fieldNameOrOptions, {
                        store: this
                    })
            };
            Object.keys(storeObject).forEach((storeFieldName)=>{
                const fieldName = (0, $1c7a634c9225e137$export$37874422037b6029)(storeFieldName);
                let fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0) return;
                const modify = typeof fields === "function" ? fields : fields[storeFieldName] || (exact ? undefined : fields[fieldName]);
                if (modify) {
                    let newValue = modify === $2fbe0640bbab32b5$var$delModifier ? $2fbe0640bbab32b5$var$DELETE : modify((0, $4f666ffbf7bc8e40$export$7f9c177735b71f18)(fieldValue), {
                        ...sharedDetails,
                        fieldName: fieldName,
                        storeFieldName: storeFieldName,
                        storage: this.getStorage(dataId, storeFieldName)
                    });
                    if (newValue === $2fbe0640bbab32b5$var$INVALIDATE) this.group.dirty(dataId, storeFieldName);
                    else {
                        if (newValue === $2fbe0640bbab32b5$var$DELETE) newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields[storeFieldName] = newValue;
                            needToMerge = true;
                            fieldValue = newValue;
                            if (0, $e15192e15b3ad6c1$export$a866f231438cc228) {
                                const checkReference = (ref)=>{
                                    if (this.lookup(ref.__ref) === undefined) {
                                        (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).warn(100, ref);
                                        return true;
                                    }
                                };
                                if ((0, $7014c795296fa5ac$export$fa99cac1c0883c47)(newValue)) checkReference(newValue);
                                else if (Array.isArray(newValue)) {
                                    // Warn about writing "mixed" arrays of Reference and non-Reference objects
                                    let seenReference = false;
                                    let someNonReference;
                                    for (const value of newValue){
                                        if ((0, $7014c795296fa5ac$export$fa99cac1c0883c47)(value)) {
                                            seenReference = true;
                                            if (checkReference(value)) break;
                                        } else // Do not warn on primitive values, since those could never be represented
                                        // by a reference. This is a valid (albeit uncommon) use case.
                                        if (typeof value === "object" && !!value) {
                                            const [id] = this.policies.identify(value);
                                            // check if object could even be referenced, otherwise we are not interested in it for this warning
                                            if (id) someNonReference = value;
                                        }
                                        if (seenReference && someNonReference !== undefined) {
                                            (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).warn(101, someNonReference);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (fieldValue !== void 0) allDeleted = false;
            });
            if (needToMerge) {
                this.merge(dataId, changedFields);
                if (allDeleted) {
                    if (this instanceof $2fbe0640bbab32b5$var$Layer) this.data[dataId] = void 0;
                    else delete this.data[dataId];
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    }
    // If called with only one argument, removes the entire entity
    // identified by dataId. If called with a fieldName as well, removes all
    // fields of that entity whose names match fieldName according to the
    // fieldNameFromStoreName helper function. If called with a fieldName
    // and variables, removes all fields of that entity whose names match fieldName
    // and whose arguments when cached exactly match the variables passed.
    delete(dataId, fieldName, args) {
        const storeObject = this.lookup(dataId);
        if (storeObject) {
            const typename = this.getFieldValue(storeObject, "__typename");
            const storeFieldName = fieldName && args ? this.policies.getStoreFieldName({
                typename: typename,
                fieldName: fieldName,
                args: args
            }) : fieldName;
            return this.modify(dataId, storeFieldName ? {
                [storeFieldName]: $2fbe0640bbab32b5$var$delModifier
            } : $2fbe0640bbab32b5$var$delModifier, !!args);
        }
        return false;
    }
    evict(options, limit) {
        let evicted = false;
        if (options.id) {
            if ((0, $1c7a634c9225e137$export$b5a638e9b3fff9f3).call(this.data, options.id)) evicted = this.delete(options.id, options.fieldName, options.args);
            if (this instanceof $2fbe0640bbab32b5$var$Layer && this !== limit) evicted = this.parent.evict(options, limit) || evicted;
            // Always invalidate the field to trigger rereading of watched
            // queries, even if no cache data was modified by the eviction,
            // because queries may depend on computed fields with custom read
            // functions, whose values are not stored in the EntityStore.
            if (options.fieldName || evicted) this.group.dirty(options.id, options.fieldName || "__exists");
        }
        return evicted;
    }
    clear() {
        this.replace(null);
    }
    extract() {
        const obj = this.toObject();
        const extraRootIds = [];
        this.getRootIdSet().forEach((id)=>{
            if (!(0, $1c7a634c9225e137$export$b5a638e9b3fff9f3).call(this.policies.rootTypenamesById, id)) extraRootIds.push(id);
        });
        if (extraRootIds.length) obj.__META = {
            extraRootIds: extraRootIds.sort()
        };
        return obj;
    }
    replace(newData) {
        Object.keys(this.data).forEach((dataId)=>{
            if (!(newData && (0, $1c7a634c9225e137$export$b5a638e9b3fff9f3).call(newData, dataId))) this.delete(dataId);
        });
        if (newData) {
            const { __META: __META, ...rest } = newData;
            Object.keys(rest).forEach((dataId)=>{
                this.merge(dataId, rest[dataId]);
            });
            if (__META) __META.extraRootIds.forEach(this.retain, this);
        }
    }
    // Maps root entity IDs to the number of times they have been retained, minus
    // the number of times they have been released. Retained entities keep other
    // entities they reference (even indirectly) from being garbage collected.
    rootIds = {};
    retain(rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    }
    release(rootId) {
        if (this.rootIds[rootId] > 0) {
            const count = --this.rootIds[rootId];
            if (!count) delete this.rootIds[rootId];
            return count;
        }
        return 0;
    }
    // Return a Set<string> of all the ID strings that have been retained by
    // this layer/root *and* any layers/roots beneath it.
    getRootIdSet(ids = new Set()) {
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof $2fbe0640bbab32b5$var$Layer) this.parent.getRootIdSet(ids);
        else // Official singleton IDs like ROOT_QUERY and ROOT_MUTATION are
        // always considered roots for garbage collection, regardless of
        // their retainment counts in this.rootIds.
        Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        return ids;
    }
    // The goal of garbage collection is to remove IDs from the Root layer of the
    // store that are no longer reachable starting from any IDs that have been
    // explicitly retained (see retain and release, above). Returns an array of
    // dataId strings that were removed from the store.
    gc() {
        const ids = this.getRootIdSet();
        const snapshot = this.toObject();
        ids.forEach((id)=>{
            if ((0, $1c7a634c9225e137$export$b5a638e9b3fff9f3).call(snapshot, id)) {
                // Because we are iterating over an ECMAScript Set, the IDs we add here
                // will be visited in later iterations of the forEach loop only if they
                // were not previously contained by the Set.
                Object.keys(this.findChildRefIds(id)).forEach(ids.add, ids);
                // By removing IDs from the snapshot object here, we protect them from
                // getting removed from the root store layer below.
                delete snapshot[id];
            }
        });
        const idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            let root = this;
            while(root instanceof $2fbe0640bbab32b5$var$Layer)root = root.parent;
            idsToRemove.forEach((id)=>root.delete(id));
        }
        return idsToRemove;
    }
    // Lazily tracks { __ref: <dataId> } strings contained by this.data[dataId].
    refs = {};
    findChildRefIds(dataId) {
        if (!(0, $1c7a634c9225e137$export$b5a638e9b3fff9f3).call(this.refs, dataId)) {
            const found = this.refs[dataId] = {};
            const root = this.data[dataId];
            if (!root) return found;
            const workSet = new Set([
                root
            ]);
            // Within the store, only arrays and objects can contain child entity
            // references, so we can prune the traversal using this predicate:
            workSet.forEach((obj)=>{
                if ((0, $7014c795296fa5ac$export$fa99cac1c0883c47)(obj)) found[obj.__ref] = true;
                if ((0, $e79cca4a6323426e$export$417207af72fad9c9)(obj)) Object.keys(obj).forEach((key)=>{
                    const child = obj[key];
                    // No need to add primitive values to the workSet, since they cannot
                    // contain reference objects.
                    if ((0, $e79cca4a6323426e$export$417207af72fad9c9)(child)) workSet.add(child);
                });
            });
        }
        return this.refs[dataId];
    }
    makeCacheKey() {
        return this.group.keyMaker.lookupArray(arguments);
    }
    // Bound function that can be passed around to provide easy access to fields
    // of Reference objects as well as ordinary objects.
    getFieldValue = (objectOrReference, storeFieldName)=>(0, $4f666ffbf7bc8e40$export$7f9c177735b71f18)((0, $7014c795296fa5ac$export$fa99cac1c0883c47)(objectOrReference) ? this.get(objectOrReference.__ref, storeFieldName) : objectOrReference && objectOrReference[storeFieldName]);
    // Returns true for non-normalized StoreObjects and non-dangling
    // References, indicating that readField(name, objOrRef) has a chance of
    // working. Useful for filtering out dangling references from lists.
    canRead = (objOrRef)=>{
        return (0, $7014c795296fa5ac$export$fa99cac1c0883c47)(objOrRef) ? this.has(objOrRef.__ref) : typeof objOrRef === "object";
    };
    // Bound function that converts an id or an object with a __typename and
    // primary key fields to a Reference object. If called with a Reference object,
    // that same Reference object is returned. Pass true for mergeIntoStore to persist
    // an object into the store.
    toReference = (objOrIdOrRef, mergeIntoStore)=>{
        if (typeof objOrIdOrRef === "string") return (0, $6e3cddf834991569$export$634ae0e932e9be99)(objOrIdOrRef);
        if ((0, $7014c795296fa5ac$export$fa99cac1c0883c47)(objOrIdOrRef)) return objOrIdOrRef;
        const [id] = this.policies.identify(objOrIdOrRef);
        if (id) {
            const ref = (0, $6e3cddf834991569$export$634ae0e932e9be99)(id);
            if (mergeIntoStore) this.merge(id, objOrIdOrRef);
            return ref;
        }
    };
    get supportsResultCaching() {
        return this.group.caching;
    }
}
// A single CacheGroup represents a set of one or more EntityStore objects,
// typically the Root store in a CacheGroup by itself, and all active Layer
// stores in a group together. A single EntityStore object belongs to only
// one CacheGroup, store.group. The CacheGroup is responsible for tracking
// dependencies, so store.group is helpful for generating unique keys for
// cached results that need to be invalidated when/if those dependencies
// change. If we used the EntityStore objects themselves as cache keys (that
// is, store rather than store.group), the cache would become unnecessarily
// fragmented by all the different Layer objects. Instead, the CacheGroup
// approach allows all optimistic Layer objects in the same linked list to
// belong to one CacheGroup, with the non-optimistic Root object belonging
// to another CacheGroup, allowing resultCaching dependencies to be tracked
// separately for optimistic and non-optimistic entity data.
class $2fbe0640bbab32b5$var$CacheGroup {
    caching;
    parent;
    d = null;
    // Used by the EntityStore#makeCacheKey method to compute cache keys
    // specific to this CacheGroup.
    keyMaker;
    constructor(caching, parent = null){
        this.caching = caching;
        this.parent = parent;
        this.resetCaching();
    }
    resetCaching() {
        this.d = this.caching ? (0, $cd2cbff575a42bcb$export$c723b7eff9d8f870)() : null;
        this.keyMaker = new (0, $3fafa7abbadfcc3d$export$73571c50d0f2507e)();
    }
    depend(dataId, storeFieldName) {
        if (this.d) {
            this.d($2fbe0640bbab32b5$var$makeDepKey(dataId, storeFieldName));
            const fieldName = (0, $1c7a634c9225e137$export$37874422037b6029)(storeFieldName);
            if (fieldName !== storeFieldName) // Fields with arguments that contribute extra identifying
            // information to the fieldName (thus forming the storeFieldName)
            // depend not only on the full storeFieldName but also on the
            // short fieldName, so the field can be invalidated using either
            // level of specificity.
            this.d($2fbe0640bbab32b5$var$makeDepKey(dataId, fieldName));
            if (this.parent) this.parent.depend(dataId, storeFieldName);
        }
    }
    dirty(dataId, storeFieldName) {
        if (this.d) this.d.dirty($2fbe0640bbab32b5$var$makeDepKey(dataId, storeFieldName), // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        storeFieldName === "__exists" ? "forget" : "setDirty");
    }
}
function $2fbe0640bbab32b5$var$makeDepKey(dataId, storeFieldName) {
    // Since field names cannot have '#' characters in them, this method
    // of joining the field name and the ID should be unambiguous, and much
    // cheaper than JSON.stringify([dataId, fieldName]).
    return storeFieldName + "#" + dataId;
}
function $2fbe0640bbab32b5$export$f8068a30967ddc18(store, entityId) {
    if ($2fbe0640bbab32b5$export$488c0743feab3d61(store)) // We use this pseudo-field __exists elsewhere in the EntityStore code to
    // represent changes in the existence of the entity object identified by
    // entityId. This dependency gets reliably dirtied whenever an object with
    // this ID is deleted (or newly created) within this group, so any result
    // cache entries (for example, StoreReader#executeSelectionSet results) that
    // depend on __exists for this entityId will get dirtied as well, leading to
    // the eventual recomputation (instead of reuse) of those result objects the
    // next time someone reads them from the cache.
    store.group.depend(entityId, "__exists");
}
class $2fbe0640bbab32b5$var$Root extends $2fbe0640bbab32b5$export$cb507f57054c7321 {
    constructor({ policies: policies, resultCaching: resultCaching = true, seed: seed }){
        super(policies, new $2fbe0640bbab32b5$var$CacheGroup(resultCaching));
        if (seed) this.replace(seed);
    }
    stump = new $2fbe0640bbab32b5$var$Stump(this);
    addLayer(layerId, replay) {
        // Adding an optimistic Layer on top of the Root actually adds the Layer
        // on top of the Stump, so the Stump always comes between the Root and
        // any Layer objects that we've added.
        return this.stump.addLayer(layerId, replay);
    }
    removeLayer() {
        // Never remove the root layer.
        return this;
    }
    storageTrie = new (0, $3fafa7abbadfcc3d$export$73571c50d0f2507e)();
    getStorage() {
        return this.storageTrie.lookupArray(arguments);
    }
}
$2fbe0640bbab32b5$export$cb507f57054c7321.Root = $2fbe0640bbab32b5$var$Root;
// Not exported, since all Layer instances are created by the addLayer method
// of the EntityStore.Root class.
class $2fbe0640bbab32b5$var$Layer extends $2fbe0640bbab32b5$export$cb507f57054c7321 {
    id;
    parent;
    replay;
    group;
    constructor(id, parent, replay, group){
        super(parent.policies, group);
        this.id = id;
        this.parent = parent;
        this.replay = replay;
        this.group = group;
        replay(this);
    }
    addLayer(layerId, replay) {
        return new $2fbe0640bbab32b5$var$Layer(layerId, this, replay, this.group);
    }
    removeLayer(layerId) {
        // Remove all instances of the given id, not just the first one.
        const parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) // Dirty every ID we're removing. Technically we might be able to avoid
            // dirtying fields that have values in higher layers, but we don't have
            // easy access to higher layers here, and we're about to recreate those
            // layers anyway (see parent.addLayer below).
            Object.keys(this.data).forEach((dataId)=>{
                const ownStoreObject = this.data[dataId];
                const parentStoreObject = parent["lookup"](dataId);
                if (!parentStoreObject) // The StoreObject identified by dataId was defined in this layer
                // but will be undefined in the parent layer, so we can delete the
                // whole entity using this.delete(dataId). Since we're about to
                // throw this layer away, the only goal of this deletion is to dirty
                // the removed fields.
                this.delete(dataId);
                else if (!ownStoreObject) {
                    // This layer had an entry for dataId but it was undefined, which
                    // means the entity was deleted in this layer, and it's about to
                    // become undeleted when we remove this layer, so we need to dirty
                    // all fields that are about to be reexposed.
                    this.group.dirty(dataId, "__exists");
                    Object.keys(parentStoreObject).forEach((storeFieldName)=>{
                        this.group.dirty(dataId, storeFieldName);
                    });
                } else if (ownStoreObject !== parentStoreObject) // If ownStoreObject is not exactly the same as parentStoreObject,
                // dirty any fields whose values will change as a result of this
                // removal.
                Object.keys(ownStoreObject).forEach((storeFieldName)=>{
                    if (!(0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) this.group.dirty(dataId, storeFieldName);
                });
            });
            return parent;
        }
        // No changes are necessary if the parent chain remains identical.
        if (parent === this.parent) return this;
        // Recreate this layer on top of the new parent.
        return parent.addLayer(this.id, this.replay);
    }
    toObject() {
        return {
            ...this.parent.toObject(),
            ...this.data
        };
    }
    findChildRefIds(dataId) {
        const fromParent = this.parent.findChildRefIds(dataId);
        return (0, $1c7a634c9225e137$export$b5a638e9b3fff9f3).call(this.data, dataId) ? {
            ...fromParent,
            ...super.findChildRefIds(dataId)
        } : fromParent;
    }
    getStorage(...args) {
        let p = this.parent;
        while(p.parent)p = p.parent;
        return p.getStorage(...args);
    }
}
// Represents a Layer permanently installed just above the Root, which allows
// reading optimistically (and registering optimistic dependencies) even when
// no optimistic layers are currently active. The stump.group CacheGroup object
// is shared by any/all Layer objects added on top of the Stump.
class $2fbe0640bbab32b5$var$Stump extends $2fbe0640bbab32b5$var$Layer {
    constructor(root){
        super("EntityStore.Stump", root, ()=>{}, new $2fbe0640bbab32b5$var$CacheGroup(root.group.caching, root.group));
    }
    removeLayer() {
        // Never remove the Stump layer.
        return this;
    }
    merge(older, newer) {
        // We never want to write any data into the Stump, so we forward any merge
        // calls to the Root instead. Another option here would be to throw an
        // exception, but the toReference(object, true) function can sometimes
        // trigger Stump writes (which used to be Root writes, before the Stump
        // concept was introduced).
        return this.parent.merge(older, newer);
    }
}
function $2fbe0640bbab32b5$var$storeObjectReconciler(existingObject, incomingObject, property) {
    const existingValue = existingObject[property];
    const incomingValue = incomingObject[property];
    // Wherever there is a key collision, prefer the incoming value, unless
    // it is deeply equal to the existing value. It's worth checking deep
    // equality here (even though blindly returning incoming would be
    // logically correct) because preserving the referential identity of
    // existing data can prevent needless rereading and rerendering.
    return (0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function $2fbe0640bbab32b5$export$488c0743feab3d61(store) {
    // When result caching is disabled, store.depend will be null.
    return !!(store && store.supportsResultCaching);
}








function $88b116cb2fe37bba$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        const argObj = {};
        field.arguments.forEach(({ name: name, value: value })=>(0, $cf7c3ff17e2ece79$export$a1dab82d368d6525)(argObj, name, value, variables));
        return argObj;
    }
    return null;
}


const $0f36311b122331c2$var$KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive",
    "stream"
];
// Default stable JSON.stringify implementation used by getStoreKeyName. Can be
// updated/replaced with something better by calling
// getStoreKeyName.setStringify(newStringifyFunction).
let $0f36311b122331c2$var$storeKeyNameStringify = (0, $a82bc0d00c91b19f$export$88a0ad9b6f961b51);
const $0f36311b122331c2$export$3cdb6c178b88cabe = Object.assign(function(fieldName, args, directives) {
    if (args && directives && directives["connection"] && directives["connection"]["key"]) {
        if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
            const filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
            filterKeys.sort();
            const filteredArgs = {};
            filterKeys.forEach((key)=>{
                filteredArgs[key] = args[key];
            });
            const stringifiedArgs = $0f36311b122331c2$var$storeKeyNameStringify(filteredArgs);
            if (stringifiedArgs !== "{}") return `${directives["connection"]["key"]}(${stringifiedArgs})`;
        }
        return directives["connection"]["key"];
    }
    let completeFieldName = fieldName;
    if (args) {
        // We can't use `JSON.stringify` here since it's non-deterministic,
        // and can lead to different store key names being created even though
        // the `args` object used during creation has the same properties/values.
        const stringifiedArgs = $0f36311b122331c2$var$storeKeyNameStringify(args);
        if (stringifiedArgs !== "{}") completeFieldName += `(${stringifiedArgs})`;
    }
    if (directives) Object.keys(directives).forEach((key)=>{
        if ($0f36311b122331c2$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += `@${key}(${$0f36311b122331c2$var$storeKeyNameStringify(directives[key])})`;
        else completeFieldName += `@${key}`;
    });
    return completeFieldName;
}, {
    setStringify (s) {
        const previous = $0f36311b122331c2$var$storeKeyNameStringify;
        $0f36311b122331c2$var$storeKeyNameStringify = s;
        return previous;
    }
});



function $75f69697c414d3c6$export$54be8689c65f3b56(field, variables) {
    let directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach((directive)=>{
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(({ name: name, value: value })=>(0, $cf7c3ff17e2ece79$export$a1dab82d368d6525)(directivesObj[directive.name.value], name, value, variables));
        });
    }
    let argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(({ name: name, value: value })=>(0, $cf7c3ff17e2ece79$export$a1dab82d368d6525)(argObj, name, value, variables));
    }
    return (0, $0f36311b122331c2$export$3cdb6c178b88cabe)(field.name.value, argObj, directivesObj);
}







// Mapping from JSON-encoded KeySpecifier strings to associated information.
const $a384f593c626bb7a$var$specifierInfoCache = {};
function $a384f593c626bb7a$var$lookupSpecifierInfo(spec) {
    // It's safe to encode KeySpecifier arrays with JSON.stringify, since they're
    // just arrays of strings or nested KeySpecifier arrays, and the order of the
    // array elements is important (and suitably preserved by JSON.stringify).
    const cacheKey = JSON.stringify(spec);
    return $a384f593c626bb7a$var$specifierInfoCache[cacheKey] || ($a384f593c626bb7a$var$specifierInfoCache[cacheKey] = {});
}
function $a384f593c626bb7a$export$f1953a0407594d2c(specifier) {
    const info = $a384f593c626bb7a$var$lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = (object, context)=>{
        const extract = (from, key)=>context.readField(key, from);
        const keyObject = context.keyObject = $a384f593c626bb7a$export$2db31da99613c21f(specifier, (schemaKeyPath)=>{
            let extracted = $a384f593c626bb7a$export$e8f64f7a025887d3(context.storeObject, schemaKeyPath, // Using context.readField to extract paths from context.storeObject
            // allows the extraction to see through Reference objects and respect
            // custom read functions.
            extract);
            if (extracted === void 0 && object !== context.storeObject && (0, $1c7a634c9225e137$export$b5a638e9b3fff9f3).call(object, schemaKeyPath[0])) // If context.storeObject fails to provide a value for the requested
            // path, fall back to the raw result object, if it has a top-level key
            // matching the first key in the path (schemaKeyPath[0]). This allows
            // key fields included in the written data to be saved in the cache
            // even if they are not selected explicitly in context.selectionSet.
            // Not being mentioned by context.selectionSet is convenient here,
            // since it means these extra fields cannot be affected by field
            // aliasing, which is why we can use extractKey instead of
            // context.readField for this extraction.
            extracted = $a384f593c626bb7a$export$e8f64f7a025887d3(object, schemaKeyPath, $a384f593c626bb7a$var$extractKey);
            (0, $aa2d7231b5e28112$export$f5708dca728d7177)(extracted !== void 0, 102, schemaKeyPath.join("."), object);
            return extracted;
        });
        return `${context.typename}:${JSON.stringify(keyObject)}`;
    });
}
function $a384f593c626bb7a$export$550737ee0cc371ac(specifier) {
    const info = $a384f593c626bb7a$var$lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = (args, { field: field, variables: variables, fieldName: fieldName })=>{
        const collected = $a384f593c626bb7a$export$2db31da99613c21f(specifier, (keyPath)=>{
            const firstKey = keyPath[0];
            const firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0, $19bcd21ff0d8bcb3$export$d307f5934e447d0e)(field.directives)) {
                    const directiveName = firstKey.slice(1);
                    // If the directive appears multiple times, only the first
                    // occurrence's arguments will be used. TODO Allow repetition?
                    // TODO Cache this work somehow, a la aliasMap?
                    const d = field.directives.find((d)=>d.name.value === directiveName);
                    // Fortunately argumentsObjectFromField works for DirectiveNode!
                    const directiveArgs = d && (0, $88b116cb2fe37bba$export$3f5a60fb6a781b4f)(d, variables);
                    // For directives without arguments (d defined, but directiveArgs ===
                    // null), the presence or absence of the directive still counts as
                    // part of the field key, so we return null in those cases. If no
                    // directive with this name was found for this field (d undefined and
                    // thus directiveArgs undefined), we return undefined, which causes
                    // this value to be omitted from the key object returned by
                    // collectSpecifierPaths.
                    return directiveArgs && $a384f593c626bb7a$export$e8f64f7a025887d3(directiveArgs, // If keyPath.length === 1, this code calls extractKeyPath with an
                    // empty path, which works because it uses directiveArgs as the
                    // extracted value.
                    keyPath.slice(1));
                }
                // If the key started with @ but there was no corresponding directive,
                // we want to omit this value from the key object, not fall through to
                // treating @whatever as a normal argument name.
                return;
            }
            if (firstChar === "$") {
                const variableName = firstKey.slice(1);
                if (variables && (0, $1c7a634c9225e137$export$b5a638e9b3fff9f3).call(variables, variableName)) {
                    const varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return $a384f593c626bb7a$export$e8f64f7a025887d3(variables, varKeyPath);
                }
                // If the key started with $ but there was no corresponding variable, we
                // want to omit this value from the key object, not fall through to
                // treating $whatever as a normal argument name.
                return;
            }
            if (args) return $a384f593c626bb7a$export$e8f64f7a025887d3(args, keyPath);
        });
        const suffix = JSON.stringify(collected);
        // If no arguments were passed to this field, and it didn't have any other
        // field key contributions from directives or variables, hide the empty
        // :{} suffix from the field key. However, a field passed no arguments can
        // still end up with a non-empty :{...} suffix if its key configuration
        // refers to directives or variables.
        if (args || suffix !== "{}") fieldName += ":" + suffix;
        return fieldName;
    });
}
function $a384f593c626bb7a$export$2db31da99613c21f(specifier, extractor) {
    // For each path specified by specifier, invoke the extractor, and repeatedly
    // merge the results together, with appropriate ancestor context.
    const merger = new (0, $4db7004dd586db75$export$509e11c221f576c0)();
    return $a384f593c626bb7a$export$eca459f173e85801(specifier).reduce((collected, path)=>{
        let toMerge = extractor(path);
        if (toMerge !== void 0) {
            // This path is not expected to contain array indexes, so the toMerge
            // reconstruction will not contain arrays. TODO Fix this?
            for(let i = path.length - 1; i >= 0; --i)toMerge = {
                [path[i]]: toMerge
            };
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, {});
}
function $a384f593c626bb7a$export$eca459f173e85801(spec) {
    const info = $a384f593c626bb7a$var$lookupSpecifierInfo(spec);
    if (!info.paths) {
        const paths = info.paths = [];
        const currentPath = [];
        spec.forEach((s, i)=>{
            if ((0, $120a6dcb47daaf45$export$43bee75e5e14138e)(s)) {
                $a384f593c626bb7a$export$eca459f173e85801(s).forEach((p)=>paths.push(currentPath.concat(p)));
                currentPath.length = 0;
            } else {
                currentPath.push(s);
                if (!(0, $120a6dcb47daaf45$export$43bee75e5e14138e)(spec[i + 1])) {
                    paths.push(currentPath.slice(0));
                    currentPath.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function $a384f593c626bb7a$var$extractKey(object, key) {
    return object[key];
}
function $a384f593c626bb7a$export$e8f64f7a025887d3(object, path, extract) {
    // For each key in path, extract the corresponding child property from obj,
    // flattening arrays if encountered (uncommon for keyFields and keyArgs, but
    // possible). The final result of path.reduce is normalized so unexpected leaf
    // objects have their keys safely sorted. That final result is difficult to
    // type as anything other than any. You're welcome to try to improve the
    // return type, but keep in mind extractKeyPath is not a public function
    // (exported only for testing), so the effort may not be worthwhile unless the
    // limited set of actual callers (see above) pass arguments that TypeScript
    // can statically type. If we know only that path is some array of strings
    // (and not, say, a specific tuple of statically known strings), any (or
    // possibly unknown) is the honest answer.
    extract = extract || $a384f593c626bb7a$var$extractKey;
    return $a384f593c626bb7a$var$normalize(path.reduce(function reducer(obj, key) {
        return (0, $120a6dcb47daaf45$export$43bee75e5e14138e)(obj) ? obj.map((child)=>reducer(child, key)) : obj && extract(obj, key);
    }, object));
}
function $a384f593c626bb7a$var$normalize(value) {
    // Usually the extracted value will be a scalar value, since most primary
    // key fields are scalar, but just in case we get an object or an array, we
    // need to do some normalization of the order of (nested) keys.
    if ((0, $e79cca4a6323426e$export$417207af72fad9c9)(value)) {
        if ((0, $120a6dcb47daaf45$export$43bee75e5e14138e)(value)) return value.map($a384f593c626bb7a$var$normalize);
        return $a384f593c626bb7a$export$2db31da99613c21f(Object.keys(value).sort(), (path)=>$a384f593c626bb7a$export$e8f64f7a025887d3(value, path));
    }
    return value;
}



const $f236ebb39974113b$export$ac9723609f5c76c2 = new (0, $5fdbf93429dbc742$export$8c6ed5c666ac1360)();
const $f236ebb39974113b$var$cacheInfoMap = new WeakMap();
function $f236ebb39974113b$var$getCacheInfo(cache) {
    let info = $f236ebb39974113b$var$cacheInfoMap.get(cache);
    if (!info) $f236ebb39974113b$var$cacheInfoMap.set(cache, info = {
        vars: new Set(),
        dep: (0, $cd2cbff575a42bcb$export$c723b7eff9d8f870)()
    });
    return info;
}
function $f236ebb39974113b$export$cbe12faed7725318(cache) {
    $f236ebb39974113b$var$getCacheInfo(cache).vars.forEach((rv)=>rv.forgetCache(cache));
}
function $f236ebb39974113b$export$f342bdd61b3e9412(cache) {
    $f236ebb39974113b$var$getCacheInfo(cache).vars.forEach((rv)=>rv.attachCache(cache));
}
function $f236ebb39974113b$export$5345c8ac69b4a9db(value) {
    const caches = new Set();
    const listeners = new Set();
    const rv = function(newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach((cache)=>{
                    // Invalidate any fields with custom read functions that
                    // consumed this variable, so query results involving those
                    // fields will be recomputed the next time we read them.
                    $f236ebb39974113b$var$getCacheInfo(cache).dep.dirty(rv);
                    // Broadcast changes to any caches that have previously read
                    // from this variable.
                    $f236ebb39974113b$var$broadcast(cache);
                });
                // Finally, notify any listeners added via rv.onNextChange.
                const oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach((listener)=>listener(value));
            }
        } else {
            // When reading from the variable, obtain the current cache from
            // context via cacheSlot. This isn't entirely foolproof, but it's
            // the same system that powers varDep.
            const cache = $f236ebb39974113b$export$ac9723609f5c76c2.getValue();
            if (cache) {
                attach(cache);
                $f236ebb39974113b$var$getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = (listener)=>{
        listeners.add(listener);
        return ()=>{
            listeners.delete(listener);
        };
    };
    const attach = rv.attachCache = (cache)=>{
        caches.add(cache);
        $f236ebb39974113b$var$getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = (cache)=>caches.delete(cache);
    return rv;
}
function $f236ebb39974113b$var$broadcast(cache) {
    if (cache.broadcastWatches) cache.broadcastWatches();
}


function $c6d6f437fd3dfe55$var$argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args : spec.field ? (0, $88b116cb2fe37bba$export$3f5a60fb6a781b4f)(spec.field, spec.variables) : null;
}
const $c6d6f437fd3dfe55$var$nullKeyFieldsFn = ()=>void 0;
const $c6d6f437fd3dfe55$var$simpleKeyArgsFn = (_args, context)=>context.fieldName;
// These merge functions can be selected by specifying merge:true or
// merge:false in a field policy.
const $c6d6f437fd3dfe55$var$mergeTrueFn = (existing, incoming, { mergeObjects: mergeObjects })=>mergeObjects(existing, incoming);
const $c6d6f437fd3dfe55$var$mergeFalseFn = (_, incoming)=>incoming;
const $c6d6f437fd3dfe55$export$c1694d4c18746e93 = (existing, incoming, { streamFieldInfo: streamFieldInfo, existingData: existingData })=>{
    if (!existing && !existingData) return incoming;
    const results = [];
    const previous = existing ?? existingData;
    const length = streamFieldInfo?.isLastChunk ? incoming.length : Math.max(previous.length, incoming.length);
    for(let i = 0; i < length; i++)results[i] = incoming[i] === undefined ? previous[i] : incoming[i];
    return results;
};
class $c6d6f437fd3dfe55$export$e9859ad90648930b {
    config;
    typePolicies = {};
    toBeAdded = {};
    // Map from subtype names to sets of supertype names. Note that this
    // representation inverts the structure of possibleTypes (whose keys are
    // supertypes and whose values are arrays of subtypes) because it tends
    // to be much more efficient to search upwards than downwards.
    supertypeMap = new Map();
    // Any fuzzy subtypes specified by possibleTypes will be converted to
    // RegExp objects and recorded here. Every key of this map can also be
    // found in supertypeMap. In many cases this Map will be empty, which
    // means no fuzzy subtype checking will happen in fragmentMatches.
    fuzzySubtypes = new Map();
    cache;
    rootIdsByTypename = {};
    rootTypenamesById = {};
    usingPossibleTypes = false;
    constructor(config){
        this.config = config;
        this.config = {
            dataIdFromObject: (0, $1c7a634c9225e137$export$bd03c5a9c99d6bce),
            ...config
        };
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) this.addPossibleTypes(config.possibleTypes);
        if (config.typePolicies) this.addTypePolicies(config.typePolicies);
    }
    identify(object, partialContext) {
        const policies = this;
        const typename = partialContext && (partialContext.typename || partialContext.storeObject?.__typename) || object.__typename;
        // It should be possible to write root Query fields with writeFragment,
        // using { __typename: "Query", ... } as the data, but it does not make
        // sense to allow the same identification behavior for the Mutation and
        // Subscription types, since application code should never be writing
        // directly to (or reading directly from) those root objects.
        if (typename === this.rootTypenamesById.ROOT_QUERY) return [
            "ROOT_QUERY"
        ];
        // Default context.storeObject to object if not otherwise provided.
        const storeObject = partialContext && partialContext.storeObject || object;
        const context = {
            ...partialContext,
            typename: typename,
            storeObject: storeObject,
            readField: partialContext && partialContext.readField || ((...args)=>{
                const options = $c6d6f437fd3dfe55$export$1ad7a877581bdf2e(args, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables
                });
            })
        };
        let id;
        const policy = typename && this.getTypePolicy(typename);
        let keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        (0, $912b590fa3da2f6f$export$2ddf8815a8abe8b).withValue(true, ()=>{
            while(keyFn){
                const specifierOrId = keyFn({
                    ...object,
                    ...storeObject
                }, context);
                if ((0, $120a6dcb47daaf45$export$43bee75e5e14138e)(specifierOrId)) keyFn = (0, $a384f593c626bb7a$export$f1953a0407594d2c)(specifierOrId);
                else {
                    id = specifierOrId;
                    break;
                }
            }
        });
        id = id ? String(id) : void 0;
        return context.keyObject ? [
            id,
            context.keyObject
        ] : [
            id
        ];
    }
    addTypePolicies(typePolicies) {
        Object.keys(typePolicies).forEach((typename)=>{
            const { queryType: queryType, mutationType: mutationType, subscriptionType: subscriptionType, ...incoming } = typePolicies[typename];
            // Though {query,mutation,subscription}Type configurations are rare,
            // it's important to call setRootTypename as early as possible,
            // since these configurations should apply consistently for the
            // entire lifetime of the cache. Also, since only one __typename can
            // qualify as one of these root types, these three properties cannot
            // be inherited, unlike the rest of the incoming properties. That
            // restriction is convenient, because the purpose of this.toBeAdded
            // is to delay the processing of type/field policies until the first
            // time they're used, allowing policies to be added in any order as
            // long as all relevant policies (including policies for supertypes)
            // have been added by the time a given policy is used for the first
            // time. In other words, since inheritance doesn't matter for these
            // properties, there's also no need to delay their processing using
            // the this.toBeAdded queue.
            if (queryType) this.setRootTypename("Query", typename);
            if (mutationType) this.setRootTypename("Mutation", typename);
            if (subscriptionType) this.setRootTypename("Subscription", typename);
            if ((0, $1c7a634c9225e137$export$b5a638e9b3fff9f3).call(this.toBeAdded, typename)) this.toBeAdded[typename].push(incoming);
            else this.toBeAdded[typename] = [
                incoming
            ];
        });
    }
    updateTypePolicy(typename, incoming, existingFieldPolicies) {
        const existing = this.getTypePolicy(typename);
        const { keyFields: keyFields, fields: fields } = incoming;
        function setMerge(existing, merge) {
            existing.merge = typeof merge === "function" ? merge : merge === true ? $c6d6f437fd3dfe55$var$mergeTrueFn : merge === false ? $c6d6f437fd3dfe55$var$mergeFalseFn : existing.merge;
        }
        // Type policies can define merge functions, as an alternative to
        // using field policies to merge child objects.
        setMerge(existing, incoming.merge);
        existing.keyFn = // Pass false to disable normalization for this typename.
        keyFields === false ? $c6d6f437fd3dfe55$var$nullKeyFieldsFn : (0, $120a6dcb47daaf45$export$43bee75e5e14138e)(keyFields) ? (0, $a384f593c626bb7a$export$f1953a0407594d2c)(keyFields) : typeof keyFields === "function" ? keyFields : existing.keyFn;
        if (fields) Object.keys(fields).forEach((fieldName)=>{
            let existing = existingFieldPolicies[fieldName];
            // Field policy inheritance is atomic/shallow: you can't inherit a
            // field policy and then override just its read function, since read
            // and merge functions often need to cooperate, so changing only one
            // of them would be a recipe for inconsistency.
            // So here we avoid merging an inherited field policy with an updated one.
            if (!existing || existing?.typename !== typename) existing = existingFieldPolicies[fieldName] = {
                typename: typename
            };
            const incoming = fields[fieldName];
            if (typeof incoming === "function") existing.read = incoming;
            else {
                const { keyArgs: keyArgs, read: read, merge: merge } = incoming;
                existing.keyFn = // Pass false to disable argument-based differentiation of
                // field identities.
                keyArgs === false ? $c6d6f437fd3dfe55$var$simpleKeyArgsFn : (0, $120a6dcb47daaf45$export$43bee75e5e14138e)(keyArgs) ? (0, $a384f593c626bb7a$export$550737ee0cc371ac)(keyArgs) : typeof keyArgs === "function" ? keyArgs : existing.keyFn;
                if (typeof read === "function") existing.read = read;
                setMerge(existing, merge);
            }
            if (existing.read && existing.merge) // If we have both a read and a merge function, assume
            // keyArgs:false, because read and merge together can take
            // responsibility for interpreting arguments in and out. This
            // default assumption can always be overridden by specifying
            // keyArgs explicitly in the FieldPolicy.
            existing.keyFn = existing.keyFn || $c6d6f437fd3dfe55$var$simpleKeyArgsFn;
        });
    }
    setRootTypename(which, typename = which) {
        const rootId = "ROOT_" + which.toUpperCase();
        const old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            (0, $aa2d7231b5e28112$export$f5708dca728d7177)(!old || old === which, 103, which);
            // First, delete any old __typename associated with this rootId from
            // rootIdsByTypename.
            if (old) delete this.rootIdsByTypename[old];
            // Now make this the only __typename that maps to this rootId.
            this.rootIdsByTypename[typename] = rootId;
            // Finally, update the __typename associated with this rootId.
            this.rootTypenamesById[rootId] = typename;
        }
    }
    addPossibleTypes(possibleTypes) {
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach((supertype)=>{
            // Make sure all types have an entry in this.supertypeMap, even if
            // their supertype set is empty, so we can return false immediately
            // from policies.fragmentMatches for unknown supertypes.
            this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach((subtype)=>{
                this.getSupertypeSet(subtype, true).add(supertype);
                const match = subtype.match((0, $1c7a634c9225e137$export$6ed54d4784f1ce28));
                if (!match || match[0] !== subtype) // TODO Don't interpret just any invalid typename as a RegExp.
                this.fuzzySubtypes.set(subtype, new RegExp(subtype));
            });
        });
    }
    getTypePolicy(typename) {
        if (!(0, $1c7a634c9225e137$export$b5a638e9b3fff9f3).call(this.typePolicies, typename)) {
            const policy = this.typePolicies[typename] = {};
            policy.fields = {};
            // When the TypePolicy for typename is first accessed, instead of
            // starting with an empty policy object, inherit any properties or
            // fields from the type policies of the supertypes of typename.
            //
            // Any properties or fields defined explicitly within the TypePolicy
            // for typename will take precedence, and if there are multiple
            // supertypes, the properties of policies whose types were added
            // later via addPossibleTypes will take precedence over those of
            // earlier supertypes. TODO Perhaps we should warn about these
            // conflicts in development, and recommend defining the property
            // explicitly in the subtype policy?
            //
            // Field policy inheritance is atomic/shallow: you can't inherit a
            // field policy and then override just its read function, since read
            // and merge functions often need to cooperate, so changing only one
            // of them would be a recipe for inconsistency.
            //
            // Once the TypePolicy for typename has been accessed, its properties can
            // still be updated directly using addTypePolicies, but future changes to
            // inherited supertype policies will not be reflected in this subtype
            // policy, because this code runs at most once per typename.
            let supertypes = this.supertypeMap.get(typename);
            if (!supertypes && this.fuzzySubtypes.size) {
                // To make the inheritance logic work for unknown typename strings that
                // may have fuzzy supertypes, we give this typename an empty supertype
                // set and then populate it with any fuzzy supertypes that match.
                supertypes = this.getSupertypeSet(typename, true);
                // This only works for typenames that are directly matched by a fuzzy
                // supertype. What if there is an intermediate chain of supertypes?
                // While possible, that situation can only be solved effectively by
                // specifying the intermediate relationships via possibleTypes, manually
                // and in a non-fuzzy way.
                this.fuzzySubtypes.forEach((regExp, fuzzy)=>{
                    if (regExp.test(typename)) {
                        // The fuzzy parameter is just the original string version of regExp
                        // (not a valid __typename string), but we can look up the
                        // associated supertype(s) in this.supertypeMap.
                        const fuzzySupertypes = this.supertypeMap.get(fuzzy);
                        if (fuzzySupertypes) fuzzySupertypes.forEach((supertype)=>supertypes.add(supertype));
                    }
                });
            }
            if (supertypes && supertypes.size) supertypes.forEach((supertype)=>{
                const { fields: fields, ...rest } = this.getTypePolicy(supertype);
                Object.assign(policy, rest);
                Object.assign(policy.fields, fields);
            });
        }
        const inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) // Merge the pending policies into this.typePolicies, in the order they
        // were originally passed to addTypePolicy.
        inbox.splice(0).forEach((policy)=>{
            this.updateTypePolicy(typename, policy, this.typePolicies[typename].fields);
        });
        return this.typePolicies[typename];
    }
    getFieldPolicy(typename, fieldName) {
        if (typename) return this.getTypePolicy(typename).fields[fieldName];
    }
    getSupertypeSet(subtype, createIfMissing) {
        let supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) this.supertypeMap.set(subtype, supertypeSet = new Set());
        return supertypeSet;
    }
    fragmentMatches(fragment, typename, result, variables) {
        if (!fragment.typeCondition) return true;
        // If the fragment has a type condition but the object we're matching
        // against does not have a __typename, the fragment cannot match.
        if (!typename) return false;
        const supertype = fragment.typeCondition.name.value;
        // Common case: fragment type condition and __typename are the same.
        if (typename === supertype) return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            const typenameSupertypeSet = this.getSupertypeSet(typename, true);
            const workQueue = [
                typenameSupertypeSet
            ];
            const maybeEnqueue = (subtype)=>{
                const supertypeSet = this.getSupertypeSet(subtype, false);
                if (supertypeSet && supertypeSet.size && workQueue.indexOf(supertypeSet) < 0) workQueue.push(supertypeSet);
            };
            // We need to check fuzzy subtypes only if we encountered fuzzy
            // subtype strings in addPossibleTypes, and only while writing to
            // the cache, since that's when selectionSetMatchesResult gives a
            // strong signal of fragment matching. The StoreReader class calls
            // policies.fragmentMatches without passing a result object, so
            // needToCheckFuzzySubtypes is always false while reading.
            let needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            let checkingFuzzySubtypes = false;
            // It's important to keep evaluating workQueue.length each time through
            // the loop, because the queue can grow while we're iterating over it.
            for(let i = 0; i < workQueue.length; ++i){
                const supertypeSet = workQueue[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).warn(104, typename, supertype);
                        // Record positive results for faster future lookup.
                        // Unfortunately, we cannot safely cache negative results,
                        // because new possibleTypes data could always be added to the
                        // Policies class.
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue);
                if (needToCheckFuzzySubtypes && // Start checking fuzzy subtypes only after exhausting all
                // non-fuzzy subtypes (after the final iteration of the loop).
                i === workQueue.length - 1 && // We could wait to compare fragment.selectionSet to result
                // after we verify the supertype, but this check is often less
                // expensive than that search, and we will have to do the
                // comparison anyway whenever we find a potential match.
                (0, $1c7a634c9225e137$export$60bd1cbb09c1a4a2)(fragment.selectionSet, result, variables)) {
                    // We don't always need to check fuzzy subtypes (if no result
                    // was provided, or !this.fuzzySubtypes.size), but, when we do,
                    // we only want to check them once.
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    // If we find any fuzzy subtypes that match typename, extend the
                    // workQueue to search through the supertypes of those fuzzy
                    // subtypes. Otherwise the for-loop will terminate and we'll
                    // return false below.
                    this.fuzzySubtypes.forEach((regExp, fuzzyString)=>{
                        const match = typename.match(regExp);
                        if (match && match[0] === typename) maybeEnqueue(fuzzyString);
                    });
                }
            }
        }
        return false;
    }
    hasKeyArgs(typename, fieldName) {
        const policy = this.getFieldPolicy(typename, fieldName);
        return !!(policy && policy.keyFn);
    }
    getStoreFieldName(fieldSpec) {
        const { typename: typename, fieldName: fieldName } = fieldSpec;
        const policy = this.getFieldPolicy(typename, fieldName);
        let storeFieldName;
        let keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            const context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables
            };
            const args = $c6d6f437fd3dfe55$var$argsFromFieldSpecifier(fieldSpec);
            while(keyFn){
                const specifierOrString = keyFn(args, context);
                if ((0, $120a6dcb47daaf45$export$43bee75e5e14138e)(specifierOrString)) keyFn = (0, $a384f593c626bb7a$export$550737ee0cc371ac)(specifierOrString);
                else {
                    // If the custom keyFn returns a falsy value, fall back to
                    // fieldName instead.
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) storeFieldName = fieldSpec.field ? (0, $75f69697c414d3c6$export$54be8689c65f3b56)(fieldSpec.field, fieldSpec.variables) : (0, $0f36311b122331c2$export$3cdb6c178b88cabe)(fieldName, $c6d6f437fd3dfe55$var$argsFromFieldSpecifier(fieldSpec));
        // Returning false from a keyArgs function is like configuring
        // keyArgs: false, but more dynamic.
        if (storeFieldName === false) return fieldName;
        // Make sure custom field names start with the actual field.name.value
        // of the field, so we can always figure out which properties of a
        // StoreObject correspond to which original field names.
        return fieldName === (0, $1c7a634c9225e137$export$37874422037b6029)(storeFieldName) ? storeFieldName : fieldName + ":" + storeFieldName;
    }
    readField(options, context) {
        const objectOrReference = options.from;
        if (!objectOrReference) return;
        const nameOrField = options.field || options.fieldName;
        if (!nameOrField) return;
        if (options.typename === void 0) {
            const typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename) options.typename = typename;
        }
        const storeFieldName = this.getStoreFieldName(options);
        const fieldName = (0, $1c7a634c9225e137$export$37874422037b6029)(storeFieldName);
        const existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        const policy = this.getFieldPolicy(options.typename, fieldName);
        const read = policy && policy.read;
        if (read) {
            const readOptions = $c6d6f437fd3dfe55$var$makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0, $7014c795296fa5ac$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref : objectOrReference, storeFieldName));
            // Call read(existing, readOptions) with cacheSlot holding this.cache.
            return (0, $f236ebb39974113b$export$ac9723609f5c76c2).withValue(this.cache, read, [
                existing,
                readOptions
            ]);
        }
        return existing;
    }
    getReadFunction(typename, fieldName) {
        const policy = this.getFieldPolicy(typename, fieldName);
        return policy && policy.read;
    }
    getMergeFunction(parentTypename, fieldName, childTypename) {
        let policy = this.getFieldPolicy(parentTypename, fieldName);
        let merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    }
    runMergeFunction(existing, incoming, { field: field, typename: typename, merge: merge, path: path }, context, storage) {
        // Preserve the value in case `context.overwrite` is set.
        const existingData = existing;
        if (merge === $c6d6f437fd3dfe55$var$mergeTrueFn) // Instead of going to the trouble of creating a full
        // FieldFunctionOptions object and calling mergeTrueFn, we can
        // simply call mergeObjects, as mergeTrueFn would.
        return $c6d6f437fd3dfe55$var$makeMergeObjectsFunction(context.store)(existing, incoming);
        if (merge === $c6d6f437fd3dfe55$var$mergeFalseFn) // Likewise for mergeFalseFn, whose implementation is even simpler.
        return incoming;
        // If cache.writeQuery or cache.writeFragment was called with
        // options.overwrite set to true, we still call merge functions, but
        // the existing data is always undefined, so the merge function will
        // not attempt to combine the incoming data with the existing data.
        if (context.overwrite) existing = void 0;
        const streamInfo = context.extensions?.[0, $16b2c739aa564ddd$export$e49e8c01e90ecf85]?.deref()?.peekArray(path);
        if (streamInfo) {
            const { current: current, previous: previous } = streamInfo;
            if (previous && (0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(previous.incoming, incoming) && (0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(previous.streamFieldInfo, current)) return previous.result;
        }
        const result = merge(existing, incoming, $c6d6f437fd3dfe55$var$makeMergeFieldFunctionOptions(this, // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0, {
            typename: typename,
            fieldName: field.name.value,
            field: field,
            variables: context.variables,
            path: path
        }, context, storage || {}, existingData));
        if (streamInfo) streamInfo.previous = {
            incoming: incoming,
            streamFieldInfo: streamInfo.current,
            result: result
        };
        return result;
    }
}
function $c6d6f437fd3dfe55$var$makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    const storeFieldName = policies.getStoreFieldName(fieldSpec);
    const fieldName = (0, $1c7a634c9225e137$export$37874422037b6029)(storeFieldName);
    const variables = fieldSpec.variables || context.variables;
    const { toReference: toReference, canRead: canRead } = context.store;
    return {
        args: $c6d6f437fd3dfe55$var$argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: $7014c795296fa5ac$export$fa99cac1c0883c47,
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField (...args) {
            return policies.readField($c6d6f437fd3dfe55$export$1ad7a877581bdf2e(args, objectOrReference, variables), context);
        },
        mergeObjects: $c6d6f437fd3dfe55$var$makeMergeObjectsFunction(context.store)
    };
}
function $c6d6f437fd3dfe55$var$makeMergeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage, existingData) {
    const options = {
        ...$c6d6f437fd3dfe55$var$makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage),
        extensions: context.extensions,
        existingData: existingData
    };
    const extensions = context.extensions;
    if (extensions && (0, $16b2c739aa564ddd$export$e49e8c01e90ecf85) in extensions) {
        const { [(0, $16b2c739aa564ddd$export$e49e8c01e90ecf85)]: streamInfo, ...otherExtensions } = extensions;
        const streamFieldInfo = streamInfo?.deref()?.peekArray(fieldSpec.path);
        if (streamFieldInfo) options.streamFieldInfo = streamFieldInfo.current;
        // If the only key in `extensions` was the stream details key, we didn't
        // receive any remote extensions, so we reset extensions back to undefined
        options.extensions = Object.keys(otherExtensions).length === 0 ? undefined : otherExtensions;
    }
    return options;
}
function $c6d6f437fd3dfe55$export$1ad7a877581bdf2e(readFieldArgs, objectOrReference, variables) {
    const { 0: fieldNameOrOptions, 1: from, length: argc } = readFieldArgs;
    let options;
    if (typeof fieldNameOrOptions === "string") options = {
        fieldName: fieldNameOrOptions,
        // Default to objectOrReference only when no second argument was
        // passed for the from parameter, not when undefined is explicitly
        // passed as the second argument.
        from: argc > 1 ? from : objectOrReference
    };
    else {
        options = {
            ...fieldNameOrOptions
        };
        // Default to objectOrReference only when fieldNameOrOptions.from is
        // actually omitted, rather than just undefined.
        if (!(0, $1c7a634c9225e137$export$b5a638e9b3fff9f3).call(options, "from")) options.from = objectOrReference;
    }
    if ((0, $e15192e15b3ad6c1$export$a866f231438cc228) && options.from === void 0) (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).warn(105, (0, $c038a06252f02d7b$export$f341b4883239463f)(Array.from(readFieldArgs)));
    if (void 0 === options.variables) options.variables = variables;
    return options;
}
function $c6d6f437fd3dfe55$var$makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0, $120a6dcb47daaf45$export$43bee75e5e14138e)(existing) || (0, $120a6dcb47daaf45$export$43bee75e5e14138e)(incoming)) throw (0, $aa2d7231b5e28112$export$3991762405098ea)(106);
        // These dynamic checks are necessary because the parameters of a
        // custom merge function can easily have the any type, so the type
        // system cannot always enforce the StoreObject | Reference parameter
        // types of options.mergeObjects.
        if ((0, $e79cca4a6323426e$export$417207af72fad9c9)(existing) && (0, $e79cca4a6323426e$export$417207af72fad9c9)(incoming)) {
            const eType = store.getFieldValue(existing, "__typename");
            const iType = store.getFieldValue(incoming, "__typename");
            const typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) return incoming;
            if ((0, $7014c795296fa5ac$export$fa99cac1c0883c47)(existing) && (0, $1c7a634c9225e137$export$4f39afca21bd938e)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // existing.__ref, preferring/overwriting any fields contributed by the
                // newer incoming StoreObject.
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if ((0, $1c7a634c9225e137$export$4f39afca21bd938e)(existing) && (0, $7014c795296fa5ac$export$fa99cac1c0883c47)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // incoming.__ref, taking fields from the older existing object only if
                // those fields are not already present in the newer StoreObject
                // identified by incoming.__ref.
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if ((0, $1c7a634c9225e137$export$4f39afca21bd938e)(existing) && (0, $1c7a634c9225e137$export$4f39afca21bd938e)(incoming)) return {
                ...existing,
                ...incoming
            };
        }
        return incoming;
    };
}








function $7a71fbfaf5af1115$export$160070228be94b08(sources) {
    let target = sources[0] || {};
    const count = sources.length;
    if (count > 1) {
        const merger = new (0, $4db7004dd586db75$export$509e11c221f576c0)();
        for(let i = 1; i < count; ++i)target = merger.merge(target, sources[i]);
    }
    return target;
}



class $cc788fdf4194120c$export$257c68286583b0f9 extends Error {
    message;
    path;
    query;
    variables;
    constructor(message, path, query, variables){
        // 'Error' breaks prototype chain here
        super(message);
        this.message = message;
        this.path = path;
        this.query = query;
        this.variables = variables;
        this.name = "MissingFieldError";
        if (Array.isArray(this.path)) {
            this.missing = this.message;
            for(let i = this.path.length - 1; i >= 0; --i)this.missing = {
                [this.path[i]]: this.missing
            };
        } else this.missing = this.path;
        // We're not using `Object.setPrototypeOf` here as it isn't fully supported
        // on Android (see issue #3236).
        this.__proto__ = $cc788fdf4194120c$export$257c68286583b0f9.prototype;
    }
    missing;
}




function $1c117b3c7b8d06c5$var$execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context
    ];
}
class $1c117b3c7b8d06c5$export$628ef07ba8965f12 {
    // cached version of executeSelectionSet
    executeSelectionSet;
    // cached version of executeSubSelectedArray
    executeSubSelectedArray;
    config;
    knownResults = new WeakMap();
    constructor(config){
        this.config = config;
        // memoized functions in this class will be "garbage-collected"
        // by recreating the whole `StoreReader` in
        // `InMemoryCache.resetResultsCache`
        // (triggered from `InMemoryCache.gc` with `resetResultCache: true`)
        this.executeSelectionSet = (0, $f07187d601866eca$export$4997ffc0176396a6)((options)=>{
            const peekArgs = $1c117b3c7b8d06c5$var$execSelectionSetKeyArgs(options);
            const other = this.executeSelectionSet.peek(...peekArgs);
            if (other) // If we previously read this result with canonization enabled, we can
            // return that canonized result as-is.
            return other;
            (0, $2fbe0640bbab32b5$export$f8068a30967ddc18)(options.context.store, options.enclosingRef.__ref);
            // Finally, if we didn't find any useful previous results, run the real
            // execSelectionSetImpl method with the given options.
            return this.execSelectionSetImpl(options);
        }, {
            max: (0, $9f7df0d640a1952d$export$f29926b23b28936b)["inMemoryCache.executeSelectionSet"] || 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
            keyArgs: $1c117b3c7b8d06c5$var$execSelectionSetKeyArgs,
            // Note that the parameters of makeCacheKey are determined by the
            // array returned by keyArgs.
            makeCacheKey (selectionSet, parent, context) {
                if ((0, $2fbe0640bbab32b5$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(selectionSet, (0, $7014c795296fa5ac$export$fa99cac1c0883c47)(parent) ? parent.__ref : parent, context.varString);
            }
        });
        this.executeSubSelectedArray = (0, $f07187d601866eca$export$4997ffc0176396a6)((options)=>{
            (0, $2fbe0640bbab32b5$export$f8068a30967ddc18)(options.context.store, options.enclosingRef.__ref);
            return this.execSubSelectedArrayImpl(options);
        }, {
            max: (0, $9f7df0d640a1952d$export$f29926b23b28936b)["inMemoryCache.executeSubSelectedArray"] || 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ ,
            makeCacheKey ({ field: field, array: array, context: context }) {
                if ((0, $2fbe0640bbab32b5$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(field, array, context.varString);
            }
        });
    }
    /**
     * Given a store and a query, return as much of the result as possible and
     * identify if any data was missing from the store.
     */ diffQueryAgainstStore({ store: store, query: query, rootId: rootId = "ROOT_QUERY", variables: variables, returnPartialData: returnPartialData = true }) {
        const policies = this.config.cache.policies;
        variables = {
            ...(0, $ff81cbd493b54cb0$export$84c19026e616569e)((0, $dc8fea04cb0035e1$export$d96b2213c1b9d3a9)(query)),
            ...variables
        };
        const rootRef = (0, $6e3cddf834991569$export$634ae0e932e9be99)(rootId);
        const execResult = this.executeSelectionSet({
            selectionSet: (0, $a0943c6fbd138d63$export$f431198736b7f96d)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: {
                store: store,
                query: query,
                policies: policies,
                variables: variables,
                varString: (0, $a82bc0d00c91b19f$export$88a0ad9b6f961b51)(variables),
                ...(0, $1c7a634c9225e137$export$3a33c00f0ae4a480)(query, this.config.fragments)
            }
        });
        let missing;
        if (execResult.missing) missing = new (0, $cc788fdf4194120c$export$257c68286583b0f9)($1c117b3c7b8d06c5$var$firstMissing(execResult.missing), execResult.missing, query, variables);
        const complete = !missing;
        const { result: result } = execResult;
        return {
            result: complete ? result : returnPartialData ? Object.keys(result).length === 0 ? null : result : null,
            complete: complete,
            missing: missing
        };
    }
    isFresh(result, parent, selectionSet, context) {
        if ((0, $2fbe0640bbab32b5$export$488c0743feab3d61)(context.store) && this.knownResults.get(result) === selectionSet) {
            const latest = this.executeSelectionSet.peek(selectionSet, parent, context);
            if (latest && result === latest.result) return true;
        }
        return false;
    }
    // Uncached version of executeSelectionSet.
    execSelectionSetImpl({ selectionSet: selectionSet, objectOrReference: objectOrReference, enclosingRef: enclosingRef, context: context }) {
        if ((0, $7014c795296fa5ac$export$fa99cac1c0883c47)(objectOrReference) && !context.policies.rootTypenamesById[objectOrReference.__ref] && !context.store.has(objectOrReference.__ref)) return {
            result: {},
            missing: `Dangling reference to missing ${objectOrReference.__ref} object`
        };
        const { variables: variables, policies: policies, store: store } = context;
        const typename = store.getFieldValue(objectOrReference, "__typename");
        const objectsToMerge = [];
        let missing;
        const missingMerger = new (0, $4db7004dd586db75$export$509e11c221f576c0)();
        if (typeof typename === "string" && !policies.rootIdsByTypename[typename]) // Ensure we always include a default value for the __typename
        // field, if we have one. Note that this field can be overridden by other
        // merged objects.
        objectsToMerge.push({
            __typename: typename
        });
        function handleMissing(result, resultName) {
            if (result.missing) missing = missingMerger.merge(missing, {
                [resultName]: result.missing
            });
            return result.result;
        }
        const workSet = new Set(selectionSet.selections);
        workSet.forEach((selection)=>{
            // Omit fields with directives @skip(if: <truthy value>) or
            // @include(if: <falsy value>).
            if (!(0, $873800698121f009$export$3dc388a5f013b4a5)(selection, variables)) return;
            if ((0, $e5a2402b798644a7$export$fb56ad75dd311c12)(selection)) {
                let fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference
                }, context);
                const resultName = (0, $6a5b17c6ecfc0cd4$export$7d1ad22471852218)(selection);
                if (fieldValue === void 0) {
                    if (!(0, $9d96340bd04b5f33$export$43b332f87950a467).added(selection)) missing = missingMerger.merge(missing, {
                        [resultName]: `Can't find field '${selection.name.value}' on ${(0, $7014c795296fa5ac$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref + " object" : "object " + JSON.stringify(objectOrReference, null, 2)}`
                    });
                } else if ((0, $120a6dcb47daaf45$export$43bee75e5e14138e)(fieldValue)) {
                    if (fieldValue.length > 0) fieldValue = handleMissing(this.executeSubSelectedArray({
                        field: selection,
                        array: fieldValue,
                        enclosingRef: enclosingRef,
                        context: context
                    }), resultName);
                } else if (!selection.selectionSet) ;
                else if (fieldValue != null) // In this case, because we know the field has a selection set,
                // it must be trying to query a GraphQLObjectType, which is why
                // fieldValue must be != null.
                fieldValue = handleMissing(this.executeSelectionSet({
                    selectionSet: selection.selectionSet,
                    objectOrReference: fieldValue,
                    enclosingRef: (0, $7014c795296fa5ac$export$fa99cac1c0883c47)(fieldValue) ? fieldValue : enclosingRef,
                    context: context
                }), resultName);
                if (fieldValue !== void 0) objectsToMerge.push({
                    [resultName]: fieldValue
                });
            } else {
                const fragment = (0, $67d5fb3547f9891c$export$f80bdb85f299186)(selection, context.lookupFragment);
                if (!fragment && selection.kind === (0, $324243985983b985$export$a84bdc57c5122798).FRAGMENT_SPREAD) throw (0, $aa2d7231b5e28112$export$3991762405098ea)(107, selection.name.value);
                if (fragment && policies.fragmentMatches(fragment, typename)) fragment.selectionSet.selections.forEach(workSet.add, workSet);
            }
        });
        const result = (0, $7a71fbfaf5af1115$export$160070228be94b08)(objectsToMerge);
        const finalResult = {
            result: result,
            missing: missing
        };
        const frozen = (0, $4f666ffbf7bc8e40$export$7f9c177735b71f18)(finalResult);
        // Store this result with its selection set so that we can quickly
        // recognize it again in the StoreReader#isFresh method.
        if (frozen.result) this.knownResults.set(frozen.result, selectionSet);
        return frozen;
    }
    // Uncached version of executeSubSelectedArray.
    execSubSelectedArrayImpl({ field: field, array: array, enclosingRef: enclosingRef, context: context }) {
        let missing;
        let missingMerger = new (0, $4db7004dd586db75$export$509e11c221f576c0)();
        function handleMissing(childResult, i) {
            if (childResult.missing) missing = missingMerger.merge(missing, {
                [i]: childResult.missing
            });
            return childResult.result;
        }
        if (field.selectionSet) array = array.filter((item)=>item === undefined || context.store.canRead(item));
        array = array.map((item, i)=>{
            // null value in array
            if (item === null) return null;
            // This is a nested array, recurse
            if ((0, $120a6dcb47daaf45$export$43bee75e5e14138e)(item)) return handleMissing(this.executeSubSelectedArray({
                field: field,
                array: item,
                enclosingRef: enclosingRef,
                context: context
            }), i);
            // This is an object, run the selection set on it
            if (field.selectionSet) return handleMissing(this.executeSelectionSet({
                selectionSet: field.selectionSet,
                objectOrReference: item,
                enclosingRef: (0, $7014c795296fa5ac$export$fa99cac1c0883c47)(item) ? item : enclosingRef,
                context: context
            }), i);
            if (0, $e15192e15b3ad6c1$export$a866f231438cc228) $1c117b3c7b8d06c5$var$assertSelectionSetForIdValue(context.store, field, item);
            return item;
        });
        return {
            result: array,
            missing: missing
        };
    }
}
function $1c117b3c7b8d06c5$var$firstMissing(tree) {
    try {
        JSON.stringify(tree, (_, value)=>{
            if (typeof value === "string") throw value;
            return value;
        });
    } catch (result) {
        return result;
    }
}
function $1c117b3c7b8d06c5$var$assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        const workSet = new Set([
            fieldValue
        ]);
        workSet.forEach((value)=>{
            if ((0, $e79cca4a6323426e$export$417207af72fad9c9)(value)) {
                (0, $aa2d7231b5e28112$export$f5708dca728d7177)(!(0, $7014c795296fa5ac$export$fa99cac1c0883c47)(value), 108, (0, $1c7a634c9225e137$export$fdef206c83ff2c09)(store, value), field.name.value);
                Object.values(value).forEach(workSet.add, workSet);
            }
        });
    }
}







const { toString: $28992b276e3124e7$var$toString } = Object.prototype;
function $28992b276e3124e7$export$629a2bd3f5a49ecc(value) {
    return $28992b276e3124e7$var$__cloneDeep(value);
}
function $28992b276e3124e7$var$__cloneDeep(val, seen) {
    switch($28992b276e3124e7$var$toString.call(val)){
        case "[object Array]":
            {
                seen = seen || new Map();
                if (seen.has(val)) return seen.get(val);
                const copy = val.slice(0);
                seen.set(val, copy);
                copy.forEach(function(child, i) {
                    copy[i] = $28992b276e3124e7$var$__cloneDeep(child, seen);
                });
                return copy;
            }
        case "[object Object]":
            {
                seen = seen || new Map();
                if (seen.has(val)) return seen.get(val);
                // High fidelity polyfills of Object.create and Object.getPrototypeOf are
                // possible in all JS environments, so we will assume they exist/work.
                const copy = Object.create(Object.getPrototypeOf(val));
                seen.set(val, copy);
                Object.keys(val).forEach((key)=>{
                    copy[key] = $28992b276e3124e7$var$__cloneDeep(val[key], seen);
                });
                return copy;
            }
        default:
            return val;
    }
}





// Since there are only four possible combinations of context.clientOnly and
// context.deferred values, we should need at most four "flavors" of any given
// WriteContext. To avoid creating multiple copies of the same context, we cache
// the contexts in the context.flavors Map (shared by all flavors) according to
// their clientOnly and deferred values (always in that order).
function $6277fd95b1e2489a$var$getContextFlavor(context, clientOnly, deferred) {
    const key = `${clientOnly}${deferred}`;
    let flavored = context.flavors.get(key);
    if (!flavored) context.flavors.set(key, flavored = context.clientOnly === clientOnly && context.deferred === deferred ? context : {
        ...context,
        clientOnly: clientOnly,
        deferred: deferred
    });
    return flavored;
}
class $6277fd95b1e2489a$export$eb8361c5d132fb8f {
    cache;
    reader;
    fragments;
    constructor(cache, reader, fragments){
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    writeToStore(store, { query: query, result: result, dataId: dataId, variables: variables, overwrite: overwrite, extensions: extensions }) {
        const operationDefinition = (0, $bfe912ade316f216$export$7a5b1fa979d2c158)(query);
        const merger = (0, $1c7a634c9225e137$export$b874a818f7a2fa6d)();
        variables = {
            ...(0, $ff81cbd493b54cb0$export$84c19026e616569e)(operationDefinition),
            ...variables
        };
        const context = {
            store: store,
            written: {},
            merge (existing, incoming) {
                return merger.merge(existing, incoming);
            },
            variables: variables,
            varString: (0, $a82bc0d00c91b19f$export$88a0ad9b6f961b51)(variables),
            ...(0, $1c7a634c9225e137$export$3a33c00f0ae4a480)(query, this.fragments),
            overwrite: !!overwrite,
            incomingById: new Map(),
            clientOnly: false,
            deferred: false,
            flavors: new Map(),
            extensions: extensions
        };
        const ref = this.processSelectionSet({
            result: result || {},
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: {
                map: new Map()
            },
            context: context,
            path: []
        });
        if (!(0, $7014c795296fa5ac$export$fa99cac1c0883c47)(ref)) throw (0, $aa2d7231b5e28112$export$3991762405098ea)(109, result);
        // So far, the store has not been modified, so now it's time to process
        // context.incomingById and merge those incoming fields into context.store.
        context.incomingById.forEach(({ storeObject: storeObject, mergeTree: mergeTree, fieldNodeSet: fieldNodeSet }, dataId)=>{
            const entityRef = (0, $6e3cddf834991569$export$634ae0e932e9be99)(dataId);
            if (mergeTree && mergeTree.map.size) {
                const applied = this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0, $7014c795296fa5ac$export$fa99cac1c0883c47)(applied)) // Assume References returned by applyMerges have already been merged
                // into the store. See makeMergeObjectsFunction in policies.ts for an
                // example of how this can happen.
                return;
                // Otherwise, applyMerges returned a StoreObject, whose fields we should
                // merge into the store (see store.merge statement below).
                storeObject = applied;
            }
            if ((0, $e15192e15b3ad6c1$export$a866f231438cc228) && !context.overwrite) {
                const fieldsWithSelectionSets = {};
                fieldNodeSet.forEach((field)=>{
                    if (field.selectionSet) fieldsWithSelectionSets[field.name.value] = true;
                });
                const hasSelectionSet = (storeFieldName)=>fieldsWithSelectionSets[(0, $1c7a634c9225e137$export$37874422037b6029)(storeFieldName)] === true;
                const hasMergeFunction = (storeFieldName)=>{
                    const childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach((storeFieldName)=>{
                    // If a merge function was defined for this field, trust that it
                    // did the right thing about (not) clobbering data. If the field
                    // has no selection set, it's a scalar field, so it doesn't need
                    // a merge function (even if it's an object, like JSON data).
                    if (hasSelectionSet(storeFieldName) && !hasMergeFunction(storeFieldName)) $6277fd95b1e2489a$var$warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                });
            }
            store.merge(dataId, storeObject);
        });
        // Any IDs written explicitly to the cache will be retained as
        // reachable root IDs for garbage collection purposes. Although this
        // logic includes root IDs like ROOT_QUERY and ROOT_MUTATION, their
        // retainment counts are effectively ignored because cache.gc() always
        // includes them in its root ID set.
        store.retain(ref.__ref);
        return ref;
    }
    processSelectionSet({ dataId: dataId, result: result, selectionSet: selectionSet, context: context, mergeTree: // This object allows processSelectionSet to report useful information
    // to its callers without explicitly returning that information.
    mergeTree, path: currentPath }) {
        const { policies: policies } = this.cache;
        // This variable will be repeatedly updated using context.merge to
        // accumulate all fields that need to be written into the store.
        let incoming = {};
        // If typename was not passed in, infer it. Note that typename is
        // always passed in for tricky-to-infer cases such as "Query" for
        // ROOT_QUERY.
        const typename = dataId && policies.rootTypenamesById[dataId] || $6277fd95b1e2489a$var$getTypenameFromResult(result, selectionSet, context.fragmentMap) || dataId && context.store.get(dataId, "__typename");
        if ("string" === typeof typename) incoming.__typename = typename;
        // This readField function will be passed as context.readField in the
        // KeyFieldsContext object created within policies.identify (called below).
        // In addition to reading from the existing context.store (thanks to the
        // policies.readField(options, context) line at the very bottom), this
        // version of readField can read from Reference objects that are currently
        // pending in context.incomingById, which is important whenever keyFields
        // need to be extracted from a child object that processSelectionSet has
        // turned into a Reference.
        const readField = (...args)=>{
            const options = (0, $c6d6f437fd3dfe55$export$1ad7a877581bdf2e)(args, incoming, context.variables);
            if ((0, $7014c795296fa5ac$export$fa99cac1c0883c47)(options.from)) {
                const info = context.incomingById.get(options.from.__ref);
                if (info) {
                    const result = policies.readField({
                        ...options,
                        from: info.storeObject
                    }, context);
                    if (result !== void 0) return result;
                }
            }
            return policies.readField(options, context);
        };
        const fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        context, typename).forEach((context, field)=>{
            const resultFieldKey = (0, $6a5b17c6ecfc0cd4$export$7d1ad22471852218)(field);
            const value = result[resultFieldKey];
            const path = [
                ...currentPath,
                field.name.value
            ];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                const storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables
                });
                const childTree = $6277fd95b1e2489a$var$getChildMergeTree(mergeTree, storeFieldName);
                let incomingValue = this.processFieldValue(value, field, // Reset context.clientOnly and context.deferred to their default
                // values before processing nested selection sets.
                field.selectionSet ? $6277fd95b1e2489a$var$getContextFlavor(context, false, false) : context, childTree, path);
                // To determine if this field holds a child object with a merge function
                // defined in its type policy (see PR #7070), we need to figure out the
                // child object's __typename.
                let childTypename;
                // The field's value can be an object that has a __typename only if the
                // field has a selection set. Otherwise incomingValue is scalar.
                if (field.selectionSet && ((0, $7014c795296fa5ac$export$fa99cac1c0883c47)(incomingValue) || (0, $1c7a634c9225e137$export$4f39afca21bd938e)(incomingValue))) childTypename = readField("__typename", incomingValue);
                const merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) childTree.info = {
                    field: // TODO Check compatibility against any existing childTree.field?
                    field,
                    typename: typename,
                    merge: merge,
                    path: path
                };
                else if ((0, $73b423ec85fb7119$export$2dafb573e282fe8d)([
                    "stream"
                ], field) && Array.isArray(incomingValue) && context.extensions?.[0, $16b2c739aa564ddd$export$e49e8c01e90ecf85]) childTree.info = {
                    field: field,
                    typename: typename,
                    merge: (0, $c6d6f437fd3dfe55$export$c1694d4c18746e93),
                    path: path
                };
                else $6277fd95b1e2489a$var$maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                incoming = context.merge(incoming, {
                    [storeFieldName]: incomingValue
                });
            } else if ((0, $e15192e15b3ad6c1$export$a866f231438cc228) && !context.clientOnly && !context.deferred && !(0, $9d96340bd04b5f33$export$43b332f87950a467).added(field) && // If the field has a read function, it may be a synthetic field or
            // provide a default value, so its absence from the written data should
            // not be cause for alarm.
            !policies.getReadFunction(typename, field.name.value)) (0, $aa2d7231b5e28112$export$f5708dca728d7177).error(110, (0, $6a5b17c6ecfc0cd4$export$7d1ad22471852218)(field), result);
        });
        // Identify the result object, even if dataId was already provided,
        // since we always need keyObject below.
        try {
            const [id, keyObject] = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField
            });
            // If dataId was not provided, fall back to the id just generated by
            // policies.identify.
            dataId = dataId || id;
            // Write any key fields that were used during identification, even if
            // they were not mentioned in the original query.
            if (keyObject) // TODO Reverse the order of the arguments?
            incoming = context.merge(incoming, keyObject);
        } catch (e) {
            // If dataId was provided, tolerate failure of policies.identify.
            if (!dataId) throw e;
        }
        if ("string" === typeof dataId) {
            const dataRef = (0, $6e3cddf834991569$export$634ae0e932e9be99)(dataId);
            // Avoid processing the same entity object using the same selection
            // set more than once. We use an array instead of a Set since most
            // entity IDs will be written using only one selection set, so the
            // size of this array is likely to be very small, meaning indexOf is
            // likely to be faster than Set.prototype.has.
            const sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0) return dataRef;
            sets.push(selectionSet);
            // If we're about to write a result object into the store, but we
            // happen to know that the exact same (===) result object would be
            // returned if we were to reread the result with the same inputs,
            // then we can skip the rest of the processSelectionSet work for
            // this object, and immediately return a Reference to it.
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) return dataRef;
            const previous = context.incomingById.get(dataId);
            if (previous) {
                previous.storeObject = context.merge(previous.storeObject, incoming);
                previous.mergeTree = $6277fd95b1e2489a$var$mergeMergeTrees(previous.mergeTree, mergeTree);
                fieldNodeSet.forEach((field)=>previous.fieldNodeSet.add(field));
            } else context.incomingById.set(dataId, {
                storeObject: incoming,
                // Save a reference to mergeTree only if it is not empty, because
                // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
                // reused for entirely different parts of the result tree.
                mergeTree: $6277fd95b1e2489a$var$mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                fieldNodeSet: fieldNodeSet
            });
            return dataRef;
        }
        return incoming;
    }
    processFieldValue(value, field, context, mergeTree, path) {
        if (!field.selectionSet || value === null) // In development, we need to clone scalar values so that they can be
        // safely frozen with maybeDeepFreeze in readFromStore.ts. In production,
        // it's cheaper to store the scalar values directly in the cache.
        return (0, $e15192e15b3ad6c1$export$a866f231438cc228) ? (0, $28992b276e3124e7$export$629a2bd3f5a49ecc)(value) : value;
        if ((0, $120a6dcb47daaf45$export$43bee75e5e14138e)(value)) return value.map((item, i)=>{
            const value = this.processFieldValue(item, field, context, $6277fd95b1e2489a$var$getChildMergeTree(mergeTree, i), [
                ...path,
                i
            ]);
            $6277fd95b1e2489a$var$maybeRecycleChildMergeTree(mergeTree, i);
            return value;
        });
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree,
            path: path
        });
    }
    // Implements https://spec.graphql.org/draft/#sec-Field-Collection, but with
    // some additions for tracking @client and @defer directives.
    flattenFields(selectionSet, result, context, typename = $6277fd95b1e2489a$var$getTypenameFromResult(result, selectionSet, context.fragmentMap)) {
        const fieldMap = new Map();
        const { policies: policies } = this.cache;
        const limitingTrie = new (0, $3fafa7abbadfcc3d$export$73571c50d0f2507e)(false); // No need for WeakMap, since limitingTrie does not escape.
        (function flatten(selectionSet, inheritedContext) {
            const visitedNode = limitingTrie.lookup(selectionSet, // Because we take inheritedClientOnly and inheritedDeferred into
            // consideration here (in addition to selectionSet), it's possible for
            // the same selection set to be flattened more than once, if it appears
            // in the query with different @client and/or @directive configurations.
            inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited) return;
            visitedNode.visited = true;
            selectionSet.selections.forEach((selection)=>{
                if (!(0, $873800698121f009$export$3dc388a5f013b4a5)(selection, context.variables)) return;
                let { clientOnly: clientOnly, deferred: deferred } = inheritedContext;
                if (// Since the presence of @client or @defer on this field can only
                // cause clientOnly or deferred to become true, we can skip the
                // forEach loop if both clientOnly and deferred are already true.
                !(clientOnly && deferred) && (0, $19bcd21ff0d8bcb3$export$d307f5934e447d0e)(selection.directives)) selection.directives.forEach((dir)=>{
                    const name = dir.name.value;
                    if (name === "client") clientOnly = true;
                    if (name === "defer") {
                        const args = (0, $88b116cb2fe37bba$export$3f5a60fb6a781b4f)(dir, context.variables);
                        // The @defer directive takes an optional args.if boolean
                        // argument, similar to @include(if: boolean). Note that
                        // @defer(if: false) does not make context.deferred false, but
                        // instead behaves as if there was no @defer directive.
                        if (!args || args.if !== false) deferred = true;
                    // TODO In the future, we may want to record args.label using
                    // context.deferred, if a label is specified.
                    }
                });
                if ((0, $e5a2402b798644a7$export$fb56ad75dd311c12)(selection)) {
                    const existing = fieldMap.get(selection);
                    if (existing) {
                        // If this field has been visited along another recursive path
                        // before, the final context should have clientOnly or deferred set
                        // to true only if *all* paths have the directive (hence the &&).
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, $6277fd95b1e2489a$var$getContextFlavor(context, clientOnly, deferred));
                } else {
                    const fragment = (0, $67d5fb3547f9891c$export$f80bdb85f299186)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === (0, $324243985983b985$export$a84bdc57c5122798).FRAGMENT_SPREAD) throw (0, $aa2d7231b5e28112$export$3991762405098ea)(111, selection.name.value);
                    if (fragment && policies.fragmentMatches(fragment, typename, result, context.variables)) flatten(fragment.selectionSet, $6277fd95b1e2489a$var$getContextFlavor(context, clientOnly, deferred));
                }
            });
        })(selectionSet, context);
        return fieldMap;
    }
    applyMerges(mergeTree, existing, incoming, context, getStorageArgs) {
        if (mergeTree.map.size && !(0, $7014c795296fa5ac$export$fa99cac1c0883c47)(incoming)) {
            const e = // Items in the same position in different arrays are not
            // necessarily related to each other, so when incoming is an array
            // we process its elements as if there was no existing data.
            !(0, $120a6dcb47daaf45$export$43bee75e5e14138e)(incoming) && // Likewise, existing must be either a Reference or a StoreObject
            // in order for its fields to be safe to merge with the fields of
            // the incoming object.
            ((0, $7014c795296fa5ac$export$fa99cac1c0883c47)(existing) || (0, $1c7a634c9225e137$export$4f39afca21bd938e)(existing)) ? existing : void 0;
            // This narrowing is implied by mergeTree.map.size > 0 and
            // !isReference(incoming), though TypeScript understandably cannot
            // hope to infer this type.
            const i = incoming;
            // The options.storage objects provided to read and merge functions
            // are derived from the identity of the parent object plus a
            // sequence of storeFieldName strings/numbers identifying the nested
            // field name path of each field value to be merged.
            if (e && !getStorageArgs) getStorageArgs = [
                (0, $7014c795296fa5ac$export$fa99cac1c0883c47)(e) ? e.__ref : e
            ];
            // It's possible that applying merge functions to this subtree will
            // not change the incoming data, so this variable tracks the fields
            // that did change, so we can create a new incoming object when (and
            // only when) at least one incoming field has changed. We use a Map
            // to preserve the type of numeric keys.
            let changedFields;
            const getValue = (from, name)=>{
                return (0, $120a6dcb47daaf45$export$43bee75e5e14138e)(from) ? typeof name === "number" ? from[name] : void 0 : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach((childTree, storeFieldName)=>{
                const eVal = getValue(e, storeFieldName);
                const iVal = getValue(i, storeFieldName);
                // If we have no incoming data, leave any existing data untouched.
                if (void 0 === iVal) return;
                if (getStorageArgs) getStorageArgs.push(storeFieldName);
                const aVal = this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields = changedFields || new Map();
                    changedFields.set(storeFieldName, aVal);
                }
                if (getStorageArgs) (0, $aa2d7231b5e28112$export$f5708dca728d7177)(getStorageArgs.pop() === storeFieldName);
            });
            if (changedFields) {
                // Shallow clone i so we can add changed fields to it.
                incoming = (0, $120a6dcb47daaf45$export$43bee75e5e14138e)(i) ? i.slice(0) : {
                    ...i
                };
                changedFields.forEach((value, name)=>{
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && context.store.getStorage(...getStorageArgs));
        return incoming;
    }
}
const $6277fd95b1e2489a$var$emptyMergeTreePool = [];
function $6277fd95b1e2489a$var$getChildMergeTree({ map: map }, name) {
    if (!map.has(name)) map.set(name, $6277fd95b1e2489a$var$emptyMergeTreePool.pop() || {
        map: new Map()
    });
    return map.get(name);
}
function $6277fd95b1e2489a$var$mergeMergeTrees(left, right) {
    if (left === right || !right || $6277fd95b1e2489a$var$mergeTreeIsEmpty(right)) return left;
    if (!left || $6277fd95b1e2489a$var$mergeTreeIsEmpty(left)) return right;
    const info = left.info && right.info ? {
        ...left.info,
        ...right.info
    } : left.info || right.info;
    const needToMergeMaps = left.map.size && right.map.size;
    const map = needToMergeMaps ? new Map() : left.map.size ? left.map : right.map;
    const merged = {
        info: info,
        map: map
    };
    if (needToMergeMaps) {
        const remainingRightKeys = new Set(right.map.keys());
        left.map.forEach((leftTree, key)=>{
            merged.map.set(key, $6277fd95b1e2489a$var$mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys.delete(key);
        });
        remainingRightKeys.forEach((key)=>{
            merged.map.set(key, $6277fd95b1e2489a$var$mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function $6277fd95b1e2489a$var$mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function $6277fd95b1e2489a$var$maybeRecycleChildMergeTree({ map: map }, name) {
    const childTree = map.get(name);
    if (childTree && $6277fd95b1e2489a$var$mergeTreeIsEmpty(childTree)) {
        $6277fd95b1e2489a$var$emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
const $6277fd95b1e2489a$var$warnings = new Set();
// Note that this function is unused in production, and thus should be
// pruned by any well-configured minifier.
function $6277fd95b1e2489a$var$warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    const getChild = (objOrRef)=>{
        const child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    const existing = getChild(existingRef);
    if (!existing) return;
    const incoming = getChild(incomingObj);
    if (!incoming) return;
    // It's always safe to replace a reference, since it refers to data
    // safely stored elsewhere.
    if ((0, $7014c795296fa5ac$export$fa99cac1c0883c47)(existing)) return;
    // If the values are structurally equivalent, we do not need to worry
    // about incoming replacing existing.
    if ((0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(existing, incoming)) return;
    // If we're replacing every key of the existing object, then the
    // existing data would be overwritten even if the objects were
    // normalized, so warning would not be helpful here.
    if (Object.keys(existing).every((key)=>store.getFieldValue(incoming, key) !== void 0)) return;
    const parentType = store.getFieldValue(existingRef, "__typename") || store.getFieldValue(incomingObj, "__typename");
    const fieldName = (0, $1c7a634c9225e137$export$37874422037b6029)(storeFieldName);
    const typeDotName = `${parentType}.${fieldName}`;
    // Avoid warning more than once for the same type and field name.
    if ($6277fd95b1e2489a$var$warnings.has(typeDotName)) return;
    $6277fd95b1e2489a$var$warnings.add(typeDotName);
    const childTypenames = [];
    // Arrays do not have __typename fields, and always need a custom merge
    // function, even if their elements are normalized entities.
    if (!(0, $120a6dcb47daaf45$export$43bee75e5e14138e)(existing) && !(0, $120a6dcb47daaf45$export$43bee75e5e14138e)(incoming)) [
        existing,
        incoming
    ].forEach((child)=>{
        const typename = store.getFieldValue(child, "__typename");
        if (typeof typename === "string" && !childTypenames.includes(typename)) childTypenames.push(typename);
    });
    (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).warn(112, fieldName, parentType, childTypenames.length ? "either ensure all objects of type " + childTypenames.join(" and ") + " have an ID or a custom merge function, or " : "", typeDotName, Array.isArray(existing) ? [
        ...existing
    ] : {
        ...existing
    }, Array.isArray(incoming) ? [
        ...incoming
    ] : {
        ...incoming
    });
}
function $6277fd95b1e2489a$var$getTypenameFromResult(result, selectionSet, fragmentMap) {
    let fragments;
    for (const selection of selectionSet.selections){
        if ((0, $e5a2402b798644a7$export$fb56ad75dd311c12)(selection)) {
            if (selection.name.value === "__typename") return result[(0, $6a5b17c6ecfc0cd4$export$7d1ad22471852218)(selection)];
        } else if (fragments) fragments.push(selection);
        else fragments = [
            selection
        ];
    }
    if (typeof result.__typename === "string") return result.__typename;
    if (fragments) for (const selection of fragments){
        const typename = $6277fd95b1e2489a$var$getTypenameFromResult(result, (0, $67d5fb3547f9891c$export$f80bdb85f299186)(selection, fragmentMap).selectionSet, fragmentMap);
        if (typeof typename === "string") return typename;
    }
}


class $03b004873a461f17$export$467265324939f47f extends (0, $9bbc598d12210779$export$5fc74f25506aa9c) {
    data;
    optimisticData;
    config;
    watches = new Set();
    storeReader;
    storeWriter;
    addTypenameTransform = new (0, $a9a623faa62cac2b$export$f887060e48e5dc1b)((0, $9d96340bd04b5f33$export$43b332f87950a467));
    maybeBroadcastWatch;
    // Override the default value, since InMemoryCache result objects are frozen
    // in development and expected to remain logically immutable in production.
    assumeImmutableResults = true;
    // Dynamically imported code can augment existing typePolicies or
    // possibleTypes by calling cache.policies.addTypePolicies or
    // cache.policies.addPossibletypes.
    policies;
    makeVar = (0, $f236ebb39974113b$export$5345c8ac69b4a9db);
    constructor(config = {}){
        super();
        this.config = (0, $1c7a634c9225e137$export$fa542f9ee3f7f4e2)(config);
        this.policies = new (0, $c6d6f437fd3dfe55$export$e9859ad90648930b)({
            cache: this,
            dataIdFromObject: this.config.dataIdFromObject,
            possibleTypes: this.config.possibleTypes,
            typePolicies: this.config.typePolicies
        });
        this.init();
    }
    init() {
        // Passing { resultCaching: false } in the InMemoryCache constructor options
        // will completely disable dependency tracking, which will improve memory
        // usage but worsen the performance of repeated reads.
        const rootStore = this.data = new (0, $2fbe0640bbab32b5$export$cb507f57054c7321).Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching
        });
        // When no optimistic writes are currently active, cache.optimisticData ===
        // cache.data, so there are no additional layers on top of the actual data.
        // When an optimistic update happens, this.optimisticData will become a
        // linked list of EntityStore Layer objects that terminates with the
        // original this.data cache object.
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    }
    resetResultCache() {
        const { fragments: fragments } = this.config;
        this.addTypenameTransform.resetCache();
        fragments?.resetCaches();
        // The StoreWriter is mostly stateless and so doesn't really need to be
        // reset, but it does need to have its writer.storeReader reference updated,
        // so it's simpler to update this.storeWriter as well.
        this.storeWriter = new (0, $6277fd95b1e2489a$export$eb8361c5d132fb8f)(this, this.storeReader = new (0, $1c117b3c7b8d06c5$export$628ef07ba8965f12)({
            cache: this,
            fragments: fragments
        }), fragments);
        this.maybeBroadcastWatch = (0, $f07187d601866eca$export$4997ffc0176396a6)((c, options)=>{
            return this.broadcastWatch(c, options);
        }, {
            max: (0, $9f7df0d640a1952d$export$f29926b23b28936b)["inMemoryCache.maybeBroadcastWatch"] || 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
            makeCacheKey: (c)=>{
                // Return a cache key (thus enabling result caching) only if we're
                // currently using a data store that can track cache dependencies.
                const store = c.optimistic ? this.optimisticData : this.data;
                if ((0, $2fbe0640bbab32b5$export$488c0743feab3d61)(store)) {
                    const { optimistic: optimistic, id: id, variables: variables } = c;
                    return store.makeCacheKey(c.query, // Different watches can have the same query, optimistic
                    // status, rootId, and variables, but if their callbacks are
                    // different, the (identical) result needs to be delivered to
                    // each distinct callback. The easiest way to achieve that
                    // separation is to include c.callback in the cache key for
                    // maybeBroadcastWatch calls. See issue #5733.
                    c.callback, (0, $a82bc0d00c91b19f$export$88a0ad9b6f961b51)({
                        optimistic: optimistic,
                        id: id,
                        variables: variables
                    }));
                }
            }
        });
        // Since we have thrown away all the cached functions that depend on the
        // CacheGroup dependencies maintained by EntityStore, we should also reset
        // all CacheGroup dependency information.
        new Set([
            this.data.group,
            this.optimisticData.group
        ]).forEach((group)=>group.resetCaching());
    }
    restore(data) {
        this.init();
        // Since calling this.init() discards/replaces the entire StoreReader, along
        // with the result caches it maintains, this.data.replace(data) won't have
        // to bother deleting the old data.
        if (data) this.data.replace(data);
        return this;
    }
    extract(optimistic = false) {
        return (optimistic ? this.optimisticData : this.data).extract();
    }
    read(options) {
        const { returnPartialData: // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        returnPartialData = false } = options;
        return this.storeReader.diffQueryAgainstStore({
            ...options,
            store: options.optimistic ? this.optimisticData : this.data,
            config: this.config,
            returnPartialData: returnPartialData
        }).result;
    }
    write(options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    }
    modify(options) {
        if ((0, $1c7a634c9225e137$export$b5a638e9b3fff9f3).call(options, "id") && !options.id) // To my knowledge, TypeScript does not currently provide a way to
        // enforce that an optional property?:type must *not* be undefined
        // when present. That ability would be useful here, because we want
        // options.id to default to ROOT_QUERY only when no options.id was
        // provided. If the caller attempts to pass options.id with a
        // falsy/undefined value (perhaps because cache.identify failed), we
        // should not assume the goal was to modify the ROOT_QUERY object.
        // We could throw, but it seems natural to return false to indicate
        // that nothing was modified.
        return false;
        const store = options.optimistic // Defaults to false.
         ? this.optimisticData : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields, false);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    }
    diff(options) {
        return this.storeReader.diffQueryAgainstStore({
            ...options,
            store: options.optimistic ? this.optimisticData : this.data,
            rootId: options.id || "ROOT_QUERY",
            config: this.config
        });
    }
    watch(watch) {
        if (!this.watches.size) // In case we previously called forgetCache(this) because
        // this.watches became empty (see below), reattach this cache to any
        // reactive variables on which it previously depended. It might seem
        // paradoxical that we're able to recall something we supposedly
        // forgot, but the point of calling forgetCache(this) is to silence
        // useless broadcasts while this.watches is empty, and to allow the
        // cache to be garbage collected. If, however, we manage to call
        // recallCache(this) here, this cache object must not have been
        // garbage collected yet, and should resume receiving updates from
        // reactive variables, now that it has a watcher to notify.
        (0, $f236ebb39974113b$export$f342bdd61b3e9412)(this);
        this.watches.add(watch);
        if (watch.immediate) this.maybeBroadcastWatch(watch);
        return ()=>{
            // Once we remove the last watch from this.watches, cache.broadcastWatches
            // no longer does anything, so we preemptively tell the reactive variable
            // system to exclude this cache from future broadcasts.
            if (this.watches.delete(watch) && !this.watches.size) (0, $f236ebb39974113b$export$cbe12faed7725318)(this);
            // Remove this watch from the LRU cache managed by the
            // maybeBroadcastWatch OptimisticWrapperFunction, to prevent memory
            // leaks involving the closure of watch.callback.
            this.maybeBroadcastWatch.forget(watch);
        };
    }
    gc(options) {
        (0, $a82bc0d00c91b19f$export$88a0ad9b6f961b51).reset();
        (0, $a6091649f6831c1e$export$c2d084dc44961371).reset();
        const ids = this.optimisticData.gc();
        if (options && !this.txCount && options.resetResultCache) this.resetResultCache();
        return ids;
    }
    // Call this method to ensure the given root ID remains in the cache after
    // garbage collection, along with its transitive child entities. Note that
    // the cache automatically retains all directly written entities. By default,
    // the retainment persists after optimistic updates are removed. Pass true
    // for the optimistic argument if you would prefer for the retainment to be
    // discarded when the top-most optimistic layer is removed. Returns the
    // resulting (non-negative) retainment count.
    retain(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    }
    // Call this method to undo the effect of the retain method, above. Once the
    // retainment count falls to zero, the given ID will no longer be preserved
    // during garbage collection, though it may still be preserved by other safe
    // entities that refer to it. Returns the resulting (non-negative) retainment
    // count, in case that's useful.
    release(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    }
    // Returns the canonical ID for a given StoreObject, obeying typePolicies
    // and keyFields (and dataIdFromObject, if you still use that). At minimum,
    // the object must contain a __typename and any primary key fields required
    // to identify entities of that type. If you pass a query result object, be
    // sure that none of the primary key fields have been renamed by aliasing.
    // If you pass a Reference object, its __ref ID string will be returned.
    identify(object) {
        if ((0, $7014c795296fa5ac$export$fa99cac1c0883c47)(object)) return object.__ref;
        try {
            return this.policies.identify(object)[0];
        } catch (e) {
            (0, $e15192e15b3ad6c1$export$a866f231438cc228) && (0, $aa2d7231b5e28112$export$f5708dca728d7177).warn(e);
        }
    }
    evict(options) {
        if (!options.id) {
            if ((0, $1c7a634c9225e137$export$b5a638e9b3fff9f3).call(options, "id")) // See comment in modify method about why we return false when
            // options.id exists but is falsy/undefined.
            return false;
            options = {
                ...options,
                id: "ROOT_QUERY"
            };
        }
        try {
            // It's unlikely that the eviction will end up invoking any other
            // cache update operations while it's running, but {in,de}crementing
            // this.txCount still seems like a good idea, for uniformity with
            // the other update methods.
            ++this.txCount;
            // Pass this.data as a limit on the depth of the eviction, so evictions
            // during optimistic updates (when this.data is temporarily set equal to
            // this.optimisticData) do not escape their optimistic Layer.
            return this.optimisticData.evict(options, this.data);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    }
    reset(options) {
        this.init();
        (0, $a82bc0d00c91b19f$export$88a0ad9b6f961b51).reset();
        if (options && options.discardWatches) {
            // Similar to what happens in the unsubscribe function returned by
            // cache.watch, applied to all current watches.
            this.watches.forEach((watch)=>this.maybeBroadcastWatch.forget(watch));
            this.watches.clear();
            (0, $f236ebb39974113b$export$cbe12faed7725318)(this);
        } else // Calling this.init() above unblocks all maybeBroadcastWatch caching, so
        // this.broadcastWatches() triggers a broadcast to every current watcher
        // (letting them know their data is now missing). This default behavior is
        // convenient because it means the watches do not have to be manually
        // reestablished after resetting the cache. To prevent this broadcast and
        // cancel all watches, pass true for options.discardWatches.
        this.broadcastWatches();
        return Promise.resolve();
    }
    removeOptimistic(idToRemove) {
        const newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    }
    txCount = 0;
    /**
    * Executes multiple cache operations as a single batch, ensuring that
    * watchers are only notified once after all operations complete. This is
    * useful for improving performance when making multiple cache updates, as it
    * prevents unnecessary re-renders or query refetches between individual
    * operations.
    * 
    * The `batch` method supports both optimistic and non-optimistic updates, and
    * provides fine-grained control over which cache layer receives the updates
    * and when watchers are notified.
    * 
    * For usage instructions, see [Interacting with cached data: `cache.batch`](https://www.apollographql.com/docs/react/caching/cache-interaction#using-cachebatch).
    * 
    * @example
    * 
    * ```js
    * cache.batch({
    *   update(cache) {
    *     cache.writeQuery({
    *       query: GET_TODOS,
    *       data: { todos: updatedTodos },
    *     });
    *     cache.evict({ id: "Todo:123" });
    *   },
    * });
    * ```
    * 
    * @example
    * 
    * ```js
    * // Optimistic update with a custom layer ID
    * cache.batch({
    *   optimistic: "add-todo-optimistic",
    *   update(cache) {
    *     cache.modify({
    *       fields: {
    *         todos(existing = []) {
    *           return [...existing, newTodoRef];
    *         },
    *       },
    *     });
    *   },
    * });
    * ```
    * 
    * @returns The return value of the `update` function.
    */ batch(options) {
        const { update: update, optimistic: optimistic = true, removeOptimistic: removeOptimistic, onWatchUpdated: onWatchUpdated } = options;
        let updateResult;
        const perform = (layer)=>{
            const { data: data, optimisticData: optimisticData } = this;
            ++this.txCount;
            if (layer) this.data = this.optimisticData = layer;
            try {
                return updateResult = update(this);
            } finally{
                --this.txCount;
                this.data = data;
                this.optimisticData = optimisticData;
            }
        };
        const alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) // If an options.onWatchUpdated callback is provided, we want to call it
        // with only the Cache.WatchOptions objects affected by options.update,
        // but there might be dirty watchers already waiting to be broadcast that
        // have nothing to do with the update. To prevent including those watchers
        // in the post-update broadcast, we perform this initial broadcast to
        // collect the dirty watchers, so we can re-dirty them later, after the
        // post-update broadcast, allowing them to receive their pending
        // broadcasts the next time broadcastWatches is called, just as they would
        // if we never called cache.batch.
        this.broadcastWatches({
            ...options,
            onWatchUpdated (watch) {
                alreadyDirty.add(watch);
                return false;
            }
        });
        if (typeof optimistic === "string") // Note that there can be multiple layers with the same optimistic ID.
        // When removeOptimistic(id) is called for that id, all matching layers
        // will be removed, and the remaining layers will be reapplied.
        this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        else if (optimistic === false) // Ensure both this.data and this.optimisticData refer to the root
        // (non-optimistic) layer of the cache during the update. Note that
        // this.data could be a Layer if we are currently executing an optimistic
        // update function, but otherwise will always be an EntityStore.Root
        // instance.
        perform(this.data);
        else // Otherwise, leave this.data and this.optimisticData unchanged and run
        // the update with broadcast batching.
        perform();
        if (typeof removeOptimistic === "string") this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        // Note: if this.txCount > 0, then alreadyDirty.size === 0, so this code
        // takes the else branch and calls this.broadcastWatches(options), which
        // does nothing when this.txCount > 0.
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches({
                ...options,
                onWatchUpdated (watch, diff) {
                    const result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) // Since onWatchUpdated did not return false, this diff is
                    // about to be broadcast to watch.callback, so we don't need
                    // to re-dirty it with the other alreadyDirty watches below.
                    alreadyDirty.delete(watch);
                    return result;
                }
            });
            // Silently re-dirty any watches that were already dirty before the update
            // was performed, and were not broadcast just now.
            if (alreadyDirty.size) alreadyDirty.forEach((watch)=>this.maybeBroadcastWatch.dirty(watch));
        } else // If alreadyDirty is empty or we don't have an onWatchUpdated
        // function, we don't need to go to the trouble of wrapping
        // options.onWatchUpdated.
        this.broadcastWatches(options);
        return updateResult;
    }
    performTransaction(update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || optimisticId !== null
        });
    }
    transformDocument(document) {
        return this.addTypenameTransform.transformDocument(this.addFragmentsToDocument(document));
    }
    fragmentMatches(fragment, typename) {
        return this.policies.fragmentMatches(fragment, typename);
    }
    lookupFragment(fragmentName) {
        return this.config.fragments?.lookup(fragmentName) || null;
    }
    resolvesClientField(typename, fieldName) {
        return !!this.policies.getReadFunction(typename, fieldName);
    }
    broadcastWatches(options) {
        if (!this.txCount) {
            const prevOnAfter = this.onAfterBroadcast;
            const callbacks = new Set();
            this.onAfterBroadcast = (cb)=>{
                callbacks.add(cb);
            };
            try {
                this.watches.forEach((c)=>this.maybeBroadcastWatch(c, options));
                callbacks.forEach((cb)=>cb());
            } finally{
                this.onAfterBroadcast = prevOnAfter;
            }
        }
    }
    addFragmentsToDocument(document) {
        const { fragments: fragments } = this.config;
        return fragments ? fragments.transform(document) : document;
    }
    // This method is wrapped by maybeBroadcastWatch, which is called by
    // broadcastWatches, so that we compute and broadcast results only when
    // the data that would be broadcast might have changed. It would be
    // simpler to check for changes after recomputing a result but before
    // broadcasting it, but this wrapping approach allows us to skip both
    // the recomputation and the broadcast, in most cases.
    broadcastWatch(c, options) {
        const { lastDiff: lastDiff } = c;
        // Both WatchOptions and DiffOptions extend ReadOptions, and DiffOptions
        // currently requires no additional properties, so we can use c (a
        // WatchOptions object) as DiffOptions, without having to allocate a new
        // object, and without having to enumerate the relevant properties (query,
        // variables, etc.) explicitly. There will be some additional properties
        // (lastDiff, callback, etc.), but cache.diff ignores them.
        const diff = this.diff(c);
        if (options) {
            if (c.optimistic && typeof options.optimistic === "string") diff.fromOptimisticTransaction = true;
            if (options.onWatchUpdated && options.onWatchUpdated.call(this, c, diff, lastDiff) === false) // Returning false from the onWatchUpdated callback will prevent
            // calling c.callback(diff) for this watcher.
            return;
        }
        if (!lastDiff || !(0, $f6c3c7d1e328abb5$export$411ce8e5a71e3069)(lastDiff.result, diff.result)) c.callback(c.lastDiff = diff, lastDiff);
    }
}
if (0, $e15192e15b3ad6c1$export$a866f231438cc228) $03b004873a461f17$export$467265324939f47f.prototype.getMemoryInternals = (0, $0b54944ffd705e51$export$e95a5a2210e62466);





function $6bbe612f07515c94$export$2288787135a8f66e(errorHandler) {
    return new $6bbe612f07515c94$export$d2c8415987899609(errorHandler);
}
class $6bbe612f07515c94$export$d2c8415987899609 extends (0, $44d61e2fd5c5ba8c$export$2fed3d61f740bc7f) {
    constructor(errorHandler){
        super((operation, forward)=>{
            return new (0, $23f68ab689e21470$export$77cea355fa80b5f4)((observer)=>{
                let sub;
                let retriedSub;
                let retriedResult;
                try {
                    sub = forward(operation).subscribe({
                        next: (result)=>{
                            const handler = operation.client["queryManager"].incrementalHandler;
                            const errors = handler.isIncrementalResult(result) ? handler.extractErrors(result) : result.errors;
                            if (errors) retriedResult = errorHandler({
                                error: new (0, $47039b6dcaec9173$export$c28d7b46cdb2b476)(result, errors),
                                result: result,
                                operation: operation,
                                forward: forward
                            });
                            else if ((0, $f1a9d96edac5fab2$export$345f95cc6b6b9b0b)(result)) retriedResult = errorHandler({
                                error: result.extensions[0, $f1a9d96edac5fab2$export$4995664c1b49842e],
                                result: result,
                                operation: operation,
                                forward: forward
                            });
                            retriedSub = retriedResult?.subscribe(observer);
                            if (!retriedSub) observer.next(result);
                        },
                        error: (error)=>{
                            retriedResult = errorHandler({
                                operation: operation,
                                error: (0, $f1a9d96edac5fab2$export$9ca5882e11f8e4c6)(error),
                                forward: forward
                            });
                            retriedSub = retriedResult?.subscribe(observer);
                            if (!retriedSub) observer.error(error);
                        },
                        complete: ()=>{
                            // disable the previous sub from calling complete on observable
                            // if retry is in flight.
                            if (!retriedResult) observer.complete();
                        }
                    });
                } catch (e) {
                    errorHandler({
                        error: (0, $f1a9d96edac5fab2$export$9ca5882e11f8e4c6)(e),
                        operation: operation,
                        forward: forward
                    });
                    observer.error(e);
                }
                return ()=>{
                    if (sub) sub.unsubscribe();
                    if (retriedSub) retriedSub.unsubscribe();
                };
            });
        });
    }
}


const $ca4d76c580089ed3$var$httpLink = new (0, $3a0c2b1ddd554e2f$export$f4bbf1aec241cc1)({
    uri: "https://nibbi-prod.hasura.app/v1/graphql"
});
const $ca4d76c580089ed3$var$authMiddleware = new (0, $44d61e2fd5c5ba8c$export$2fed3d61f740bc7f)((operation, forward)=>{
    const context = operation.getContext();
    const roleHeaders = context.useRole ? {
        'x-hasura-role': context.useRole
    } : {};
    operation.setContext(({ headers: headers = {} })=>{
        const accessToken = localStorage.getItem('accessToken');
        return {
            headers: {
                ...headers,
                ...accessToken ? {
                    Authorization: `Bearer ${accessToken}`
                } : {},
                ...roleHeaders
            }
        };
    });
    return forward(operation);
});
const $ca4d76c580089ed3$var$errorLink = (0, $6bbe612f07515c94$export$2288787135a8f66e)(({ graphQLErrors: graphQLErrors })=>{
    if (graphQLErrors?.some((error)=>error?.extensions?.code === 'invalid-jwt')) window.dispatchEvent(new Event('invalid-jwt'));
});
const $ca4d76c580089ed3$var$client = new (0, $02d2383b4a0acb65$export$13f5a5f0f1dbab88)({
    cache: new (0, $03b004873a461f17$export$467265324939f47f)(),
    link: (0, $264c73136f36a4a1$export$6788812c4e6611e6)([
        $ca4d76c580089ed3$var$errorLink,
        $ca4d76c580089ed3$var$authMiddleware,
        $ca4d76c580089ed3$var$httpLink
    ])
});
var $ca4d76c580089ed3$export$2e2bcd8739ae039 = $ca4d76c580089ed3$var$client;






var $01ysi = parcelRequire("01ysi");

var $1kZhP = parcelRequire("1kZhP");
var $if2ZQ = parcelRequire("if2ZQ");

var $2UY5J = parcelRequire("2UY5J");
parcelRequire("gRqVZ");


var $if2ZQ = parcelRequire("if2ZQ");

var $gRqVZ = parcelRequire("gRqVZ");


var $if2ZQ = parcelRequire("if2ZQ");

var $gRqVZ = parcelRequire("gRqVZ");



var $gRqVZ = parcelRequire("gRqVZ");
const $f0a704a0e88d435b$var$ThemeContext = /*#__PURE__*/ $gRqVZ.createContext(null);
var $f0a704a0e88d435b$export$2e2bcd8739ae039 = $f0a704a0e88d435b$var$ThemeContext;



var $gRqVZ = parcelRequire("gRqVZ");

function $6ba13778ab8e6b66$export$2e2bcd8739ae039() {
    const theme = $gRqVZ.useContext((0, $f0a704a0e88d435b$export$2e2bcd8739ae039));
    return theme;
}


const $2dd076a44d6d3aba$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $2dd076a44d6d3aba$export$2e2bcd8739ae039 = $2dd076a44d6d3aba$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



var $01ysi = parcelRequire("01ysi");
function $64772b529f88c6c4$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $if2ZQ.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $64772b529f88c6c4$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $6ba13778ab8e6b66$export$2e2bcd8739ae039)();
    const theme = $gRqVZ.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $64772b529f88c6c4$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $2dd076a44d6d3aba$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $f0a704a0e88d435b$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $64772b529f88c6c4$export$2e2bcd8739ae039 = $64772b529f88c6c4$var$ThemeProvider;



parcelRequire("50JbI");
var $8DRs0 = parcelRequire("8DRs0");


var $if2ZQ = parcelRequire("if2ZQ");

var $2UY5J = parcelRequire("2UY5J");

var $gRqVZ = parcelRequire("gRqVZ");


var $01ysi = parcelRequire("01ysi");
const $2d8fdd64905b1198$var$_excluded = [
    "value"
];
const $2d8fdd64905b1198$var$RtlContext = /*#__PURE__*/ $gRqVZ.createContext();
function $2d8fdd64905b1198$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $2UY5J.default)(_ref, $2d8fdd64905b1198$var$_excluded);
    return /*#__PURE__*/ (0, $01ysi.jsx)($2d8fdd64905b1198$var$RtlContext.Provider, (0, $if2ZQ.default)({
        value: value != null ? value : true
    }, props));
}
const $2d8fdd64905b1198$export$b2dd014b6c321cb = ()=>{
    const value = $gRqVZ.useContext($2d8fdd64905b1198$var$RtlContext);
    return value != null ? value : false;
};
var $2d8fdd64905b1198$export$2e2bcd8739ae039 = $2d8fdd64905b1198$var$RtlProvider;



var $3youE = parcelRequire("3youE");
parcelRequire("gRqVZ");

var $gRqVZ = parcelRequire("gRqVZ");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $1fb60913b630eb41$var$useEnhancedEffect = typeof window !== 'undefined' ? $gRqVZ.useLayoutEffect : $gRqVZ.useEffect;
var $1fb60913b630eb41$export$2e2bcd8739ae039 = $1fb60913b630eb41$var$useEnhancedEffect;



var $gRqVZ = parcelRequire("gRqVZ");
'use client';
let $04c50e0e55291475$var$globalId = 0;
function $04c50e0e55291475$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $gRqVZ.useState(idOverride);
    const id = idOverride || defaultId;
    $gRqVZ.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $04c50e0e55291475$var$globalId += 1;
            setDefaultId(`mui-${$04c50e0e55291475$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $04c50e0e55291475$var$maybeReactUseId = $gRqVZ['useId'.toString()];
function $04c50e0e55291475$export$2e2bcd8739ae039(idOverride) {
    if ($04c50e0e55291475$var$maybeReactUseId !== undefined) {
        const reactId = $04c50e0e55291475$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $04c50e0e55291475$var$useGlobalId(idOverride);
}


parcelRequire("gRqVZ");


var $4dd7z = parcelRequire("4dd7z");
var $15iRw = parcelRequire("15iRw");


var $01ysi = parcelRequire("01ysi");
'use client';
function $e26f3ece546d5a91$var$wrapGlobalLayer(styles) {
    const serialized = (0, $15iRw.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $e26f3ece546d5a91$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $914e35017106b4cb$export$2e2bcd8739ae039)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $e26f3ece546d5a91$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $e26f3ece546d5a91$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $e26f3ece546d5a91$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $4dd7z.default), {
        styles: globalStyles
    });
}
var $e26f3ece546d5a91$export$2e2bcd8739ae039 = $e26f3ece546d5a91$var$GlobalStyles;




var $01ysi = parcelRequire("01ysi");
'use client';
function $e39ba7ba2c5e5610$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $fa316fe2f4d999c7$export$2e2bcd8739ae039)();
    const id = (0, $04c50e0e55291475$export$2e2bcd8739ae039)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $1fb60913b630eb41$export$2e2bcd8739ae039)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            var _firstChild$hasAttrib;
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && (_firstChild$hasAttrib = firstChild.hasAttribute) != null && _firstChild$hasAttrib.call(firstChild, 'data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else {
            var _head$querySelector;
            (_head$querySelector = head.querySelector(`style[data-mui-layer-order="${id}"]`)) == null || _head$querySelector.remove();
        }
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $e26f3ece546d5a91$export$2e2bcd8739ae039), {
        styles: layerOrder
    });
}



var $01ysi = parcelRequire("01ysi");
'use client';
const $67256911b9a493a1$var$EMPTY_THEME = {};
function $67256911b9a493a1$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $gRqVZ.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $if2ZQ.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $if2ZQ.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $if2ZQ.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $67256911b9a493a1$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $fa316fe2f4d999c7$export$2e2bcd8739ae039)($67256911b9a493a1$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $6ba13778ab8e6b66$export$2e2bcd8739ae039)() || $67256911b9a493a1$var$EMPTY_THEME;
    const engineTheme = $67256911b9a493a1$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $67256911b9a493a1$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === 'rtl';
    const layerOrder = (0, $e39ba7ba2c5e5610$export$2e2bcd8739ae039)(engineTheme);
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $64772b529f88c6c4$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $8DRs0.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $2d8fdd64905b1198$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $3youE.default), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $67256911b9a493a1$export$2e2bcd8739ae039 = $67256911b9a493a1$var$ThemeProvider;



var $1WdmB = parcelRequire("1WdmB");

var $01ysi = parcelRequire("01ysi");
'use client';
const $983a51b80ddb3acf$var$_excluded = [
    "theme"
];
function $983a51b80ddb3acf$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $2UY5J.default)(_ref, $983a51b80ddb3acf$var$_excluded);
    const scopedTheme = themeInput[0, $1WdmB.default];
    let finalTheme = scopedTheme || themeInput;
    if (typeof themeInput !== 'function') {
        if (scopedTheme && !scopedTheme.vars) finalTheme = (0, $if2ZQ.default)({}, scopedTheme, {
            vars: null
        });
        else if (themeInput && !themeInput.vars) finalTheme = (0, $if2ZQ.default)({}, themeInput, {
            vars: null
        });
    }
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $67256911b9a493a1$export$2e2bcd8739ae039), (0, $if2ZQ.default)({}, props, {
        themeId: scopedTheme ? (0, $1WdmB.default) : undefined,
        theme: finalTheme
    }));
}


const $8c17cac81986aadf$var$theme = (0, $1kZhP.default)({
    palette: {
        primary: {
            main: '#bd5f28'
        }
    },
    typography: {
        fontFamily: `-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"`
    },
    components: {
        MuiLink: {
            defaultProps: {
                underline: 'none'
            }
        },
        MuiSvgIcon: {
            defaultProps: {
                color: 'primary'
            }
        }
    }
});
function $8c17cac81986aadf$var$MuiBaseTheme(props) {
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $983a51b80ddb3acf$export$2e2bcd8739ae039), {
        theme: $8c17cac81986aadf$var$theme,
        ...props
    });
}
var $8c17cac81986aadf$export$2e2bcd8739ae039 = $8c17cac81986aadf$var$MuiBaseTheme;



var $gRqVZ = parcelRequire("gRqVZ");

function $d62a924bbfb54cc0$var$GAPageView() {
    const { pathname: pathname } = (0, $372fcccf2bee01ac$export$45d76561a5302f2b)();
    (0, $gRqVZ.useEffect)(()=>{
        const w = window;
        if (w.ga) {
            w.ga('set', 'page', pathname);
            w.ga('send', 'pageview');
        }
    }, [
        pathname
    ]);
    return null;
}
var $d62a924bbfb54cc0$export$2e2bcd8739ae039 = $d62a924bbfb54cc0$var$GAPageView;




var $01ysi = parcelRequire("01ysi");

var $gRqVZ = parcelRequire("gRqVZ");

var $489wz = parcelRequire("489wz");
var $6687f9591dc1a5f1$exports = {};
// THIS FILE IS GENERATED - DO NOT EDIT!
/*!mobile-detect v1.4.5 2021-03-13*/ /*global module:false, define:false*/ /*jshint latedef:false*/ /*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/ (function(define1, undefined) {
    define1(function() {
        'use strict';
        var impl = {};
        impl.mobileDetectRules = {
            "phones": {
                "iPhone": "\\biPhone\\b|\\biPod\\b",
                "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+|\\b(BBA100|BBB100|BBD100|BBE100|BBF100|STH100)\\b-[0-9]+",
                "Pixel": "; \\bPixel\\b",
                "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m|Android [0-9.]+; Pixel",
                "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 5X|Nexus 6",
                "Dell": "Dell[;]? (Streak|Aero|Venue|Venue Pro|Flash|Smoke|Mini 3iX)|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
                "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b|XT1068|XT1092|XT1052",
                "Samsung": "\\bSamsung\\b|SM-G950F|SM-G955F|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C|SM-A310F|GT-I9190|SM-J500FN|SM-G903F|SM-J330F|SM-G610F|SM-G981B|SM-G892A|SM-A530F",
                "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323|M257)|LM-G710",
                "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533|SOV34|601SO|F8332",
                "Asus": "Asus.*Galaxy|PadFone.*Mobile",
                "Xiaomi": "^(?!.*\\bx11\\b).*xiaomi.*$|POCOPHONE F1|MI 8|Redmi Note 9S|Redmi Note 5A Prime|N2G47H|M2001J2G|M2001J2I|M1805E10A|M2004J11G|M1902F1G|M2002J9G|M2004J19G|M2003J6A1G",
                "NokiaLumia": "Lumia [0-9]{3,4}",
                "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
                "Palm": "PalmSource|Palm",
                "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
                "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
                "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
                "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
                "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
                "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
                "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
                "Alcatel": "Alcatel",
                "Nintendo": "Nintendo (3DS|Switch)",
                "Amoi": "Amoi",
                "INQ": "INQ",
                "OnePlus": "ONEPLUS",
                "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
            },
            "tablets": {
                "iPad": "iPad|iPad.*Mobile",
                "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
                "GoogleTablet": "Android.*Pixel C",
                "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-T116BU|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y?|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587|SM-P350|SM-P555M|SM-P355M|SM-T113NU|SM-T815Y|SM-T585|SM-T285|SM-T825|SM-W708|SM-T835|SM-T830|SM-T837V|SM-T720|SM-T510|SM-T387V|SM-P610|SM-T290|SM-T515|SM-T590|SM-T595|SM-T725|SM-T817P|SM-P585N0|SM-T395|SM-T295|SM-T865|SM-P610N|SM-P615|SM-T970|SM-T380|SM-T5950|SM-T905|SM-T231|SM-T500|SM-T860",
                "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk\/[0-9.]+ like Chrome\/[0-9.]+ (?!Mobile)",
                "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
                "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
                "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z|\\bP027\\b|\\bP024\\b|\\bP00C\\b",
                "BlackBerryTablet": "PlayBook|RIM Tablet",
                "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
                "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
                "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
                "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30|A3-A40",
                "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
                "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
                "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
                "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
                "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-850M|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)|TB-X103F|TB-X304X|TB-X304F|TB-X304L|TB-X505F|TB-X505L|TB-X505X|TB-X605F|TB-X605L|TB-8703F|TB-8703X|TB-8703N|TB-8704N|TB-8704F|TB-8704X|TB-8704V|TB-7304F|TB-7304I|TB-7304X|Tab2A7-10F|Tab2A7-20F|TB2-X30L|YT3-X50L|YT3-X50F|YT3-X50M|YT-X705F|YT-X703F|YT-X703L|YT-X705L|YT-X705X|TB2-X30F|TB2-X30L|TB2-X30M|A2107A-F|A2107A-H|TB3-730F|TB3-730M|TB3-730X|TB-7504F|TB-7504X|TB-X704F|TB-X104F|TB3-X70F|TB-X705F|TB-8504F|TB3-X70L|TB3-710F|TB-X704L",
                "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
                "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
                "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
                "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
                "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
                "IRUTablet": "M702pro",
                "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
                "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
                "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
                "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
                "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
                "NokiaLumiaTablet": "Lumia 2520",
                "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP641|SGP612|SOT31|SGP771|SGP611|SGP612|SGP712",
                "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
                "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
                "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
                "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
                "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
                "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
                "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
                "FlyTablet": "IQ310|Fly Vision",
                "bqTablet": "Android.*(bq)?.*\\b(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris ([E|M]10|M8))\\b|Maxwell.*Lite|Maxwell.*Plus",
                "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim|M2-A01L|BAH-L09|BAH-W09|AGS-L09|CMR-AL19",
                "NecTablet": "\\bN-06D|\\bN-08D",
                "PantechTablet": "Pantech.*P4100",
                "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
                "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
                "ZyncTablet": "z1000|Z99 2G|z930|z990|z909|Z919|z900",
                "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
                "NabiTablet": "Android.*\\bNabi",
                "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
                "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
                "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
                "PlaystationTablet": "Playstation.*(Portable|Vita)",
                "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
                "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
                "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
                "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
                "GalapadTablet": "Android [0-9.]+; [a-z-]+; \\bG1\\b",
                "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
                "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
                "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
                "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
                "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
                "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
                "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
                "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
                "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)|Qualcore 1027",
                "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
                "DPSTablet": "DPS Dream 9|DPS Dual 7",
                "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
                "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
                "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
                "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
                "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
                "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
                "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
                "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
                "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
                "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497|VFD 1400",
                "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
                "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
                "iMobileTablet": "i-mobile i-note",
                "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
                "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
                "AMPETablet": "Android.* A78 ",
                "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
                "TecnoTablet": "TECNO P9|TECNO DP8D",
                "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
                "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
                "FX2Tablet": "FX2 PAD7|FX2 PAD10",
                "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
                "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
                "VerizonTablet": "QTAQZ3|QTAIR7|QTAQTZ3|QTASUN1|QTASUN2|QTAXIA1",
                "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
                "CaptivaTablet": "CAPTIVA PAD",
                "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
                "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
                "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+|V10 \\b4G\\b",
                "JaytechTablet": "TPC-PA762",
                "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
                "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
                "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
                "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
                "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
                "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
                "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
                "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
                "MediacomTablet": "M-MPI10C3G|M-SP10EG|M-SP10EGP|M-SP10HXAH|M-SP7HXAH|M-SP10HXBH|M-SP8HXAH|M-SP8MXA",
                "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
                "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
                "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
                "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
                "UbislateTablet": "UbiSlate[\\s]?7C",
                "PocketBookTablet": "Pocketbook",
                "KocasoTablet": "\\b(TB-1207)\\b",
                "HisenseTablet": "\\b(F5281|E2371)\\b",
                "Hudl": "Hudl HT7S3|Hudl 2",
                "TelstraTablet": "T-Hub2",
                "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b|\\bQTAQZ3\\b|WVT101|TM1088|KT107"
            },
            "oss": {
                "AndroidOS": "Android",
                "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
                "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
                "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
                "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Windows Mobile|Windows Phone [0-9.]+|WCE;",
                "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
                "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia",
                "iPadOS": "CPU OS 13",
                "SailfishOS": "Sailfish",
                "MeeGoOS": "MeeGo",
                "MaemoOS": "Maemo",
                "JavaOS": "J2ME\/|\\bMIDP\\b|\\bCLDC\\b",
                "webOS": "webOS|hpwOS",
                "badaOS": "\\bBada\\b",
                "BREWOS": "BREW"
            },
            "uas": {
                "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?",
                "Dolfin": "\\bDolfin\\b",
                "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR\/[0-9.]+$|Coast\/[0-9.]+",
                "Skyfire": "Skyfire",
                "Edge": "\\bEdgiOS\\b|Mobile Safari\/[.0-9]* Edge",
                "IE": "IEMobile|MSIEMobile",
                "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
                "Bolt": "bolt",
                "TeaShark": "teashark",
                "Blazer": "Blazer",
                "Safari": "Version((?!\\bEdgiOS\\b).)*Mobile.*Safari|Safari.*Mobile|MobileSafari",
                "WeChat": "\\bMicroMessenger\\b",
                "UCBrowser": "UC.*Browser|UCWEB",
                "baiduboxapp": "baiduboxapp",
                "baidubrowser": "baidubrowser",
                "DiigoBrowser": "DiigoBrowser",
                "Mercury": "\\bMercury\\b",
                "ObigoBrowser": "Obigo",
                "NetFront": "NF-Browser",
                "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
                "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
            },
            "props": {
                "Mobile": "Mobile\/[VER]",
                "Build": "Build\/[VER]",
                "Version": "Version\/[VER]",
                "VendorID": "VendorID\/[VER]",
                "iPad": "iPad.*CPU[a-z ]+[VER]",
                "iPhone": "iPhone.*CPU[a-z ]+[VER]",
                "iPod": "iPod.*CPU[a-z ]+[VER]",
                "Kindle": "Kindle\/[VER]",
                "Chrome": [
                    "Chrome\/[VER]",
                    "CriOS\/[VER]",
                    "CrMo\/[VER]"
                ],
                "Coast": [
                    "Coast\/[VER]"
                ],
                "Dolfin": "Dolfin\/[VER]",
                "Firefox": [
                    "Firefox\/[VER]",
                    "FxiOS\/[VER]"
                ],
                "Fennec": "Fennec\/[VER]",
                "Edge": "Edge\/[VER]",
                "IE": [
                    "IEMobile\/[VER];",
                    "IEMobile [VER]",
                    "MSIE [VER];",
                    "Trident\/[0-9.]+;.*rv:[VER]"
                ],
                "NetFront": "NetFront\/[VER]",
                "NokiaBrowser": "NokiaBrowser\/[VER]",
                "Opera": [
                    " OPR\/[VER]",
                    "Opera Mini\/[VER]",
                    "Version\/[VER]"
                ],
                "Opera Mini": "Opera Mini\/[VER]",
                "Opera Mobi": "Version\/[VER]",
                "UCBrowser": [
                    "UCWEB[VER]",
                    "UC.*Browser\/[VER]"
                ],
                "MQQBrowser": "MQQBrowser\/[VER]",
                "MicroMessenger": "MicroMessenger\/[VER]",
                "baiduboxapp": "baiduboxapp\/[VER]",
                "baidubrowser": "baidubrowser\/[VER]",
                "SamsungBrowser": "SamsungBrowser\/[VER]",
                "Iron": "Iron\/[VER]",
                "Safari": [
                    "Version\/[VER]",
                    "Safari\/[VER]"
                ],
                "Skyfire": "Skyfire\/[VER]",
                "Tizen": "Tizen\/[VER]",
                "Webkit": "webkit[ \/][VER]",
                "PaleMoon": "PaleMoon\/[VER]",
                "SailfishBrowser": "SailfishBrowser\/[VER]",
                "Gecko": "Gecko\/[VER]",
                "Trident": "Trident\/[VER]",
                "Presto": "Presto\/[VER]",
                "Goanna": "Goanna\/[VER]",
                "iOS": " \\bi?OS\\b [VER][ ;]{1}",
                "Android": "Android [VER]",
                "Sailfish": "Sailfish [VER]",
                "BlackBerry": [
                    "BlackBerry[\\w]+\/[VER]",
                    "BlackBerry.*Version\/[VER]",
                    "Version\/[VER]"
                ],
                "BREW": "BREW [VER]",
                "Java": "Java\/[VER]",
                "Windows Phone OS": [
                    "Windows Phone OS [VER]",
                    "Windows Phone [VER]"
                ],
                "Windows Phone": "Windows Phone [VER]",
                "Windows CE": "Windows CE\/[VER]",
                "Windows NT": "Windows NT [VER]",
                "Symbian": [
                    "SymbianOS\/[VER]",
                    "Symbian\/[VER]"
                ],
                "webOS": [
                    "webOS\/[VER]",
                    "hpwOS\/[VER];"
                ]
            },
            "utils": {
                "Bot": "Googlebot|facebookexternalhit|Google-AMPHTML|s~amp-validator|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom|contentkingapp|AspiegelBot",
                "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker\/M1A1-R2D2",
                "DesktopMode": "WPDesktop",
                "TV": "SonyDTV|HbbTV",
                "WebKit": "(webkit)[ \/]([\\w.]+)",
                "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|Nintendo Switch|PLAYSTATION|Xbox)\\b",
                "Watch": "SM-V700"
            }
        };
        // following patterns come from http://detectmobilebrowsers.com/
        impl.detectMobileBrowsers = {
            fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
            shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
            tabletPattern: /android|ipad|playbook|silk/i
        };
        var hasOwnProp = Object.prototype.hasOwnProperty, isArray;
        impl.FALLBACK_PHONE = 'UnknownPhone';
        impl.FALLBACK_TABLET = 'UnknownTablet';
        impl.FALLBACK_MOBILE = 'UnknownMobile';
        isArray = 'isArray' in Array ? Array.isArray : function(value) {
            return Object.prototype.toString.call(value) === '[object Array]';
        };
        function equalIC(a, b) {
            return a != null && b != null && a.toLowerCase() === b.toLowerCase();
        }
        function containsIC(array, value) {
            var valueLC, i, len = array.length;
            if (!len || !value) return false;
            valueLC = value.toLowerCase();
            for(i = 0; i < len; ++i){
                if (valueLC === array[i].toLowerCase()) return true;
            }
            return false;
        }
        function convertPropsToRegExp(object) {
            for(var key in object)if (hasOwnProp.call(object, key)) object[key] = new RegExp(object[key], 'i');
        }
        function prepareUserAgent(userAgent) {
            return (userAgent || '').substr(0, 500); // mitigate vulnerable to ReDoS
        }
        (function init() {
            var key, values, value, i, len, verPos, mobileDetectRules = impl.mobileDetectRules;
            for(key in mobileDetectRules.props)if (hasOwnProp.call(mobileDetectRules.props, key)) {
                values = mobileDetectRules.props[key];
                if (!isArray(values)) values = [
                    values
                ];
                len = values.length;
                for(i = 0; i < len; ++i){
                    value = values[i];
                    verPos = value.indexOf('[VER]');
                    if (verPos >= 0) value = value.substring(0, verPos) + '([\\w._\\+]+)' + value.substring(verPos + 5);
                    values[i] = new RegExp(value, 'i');
                }
                mobileDetectRules.props[key] = values;
            }
            convertPropsToRegExp(mobileDetectRules.oss);
            convertPropsToRegExp(mobileDetectRules.phones);
            convertPropsToRegExp(mobileDetectRules.tablets);
            convertPropsToRegExp(mobileDetectRules.uas);
            convertPropsToRegExp(mobileDetectRules.utils);
            // copy some patterns to oss0 which are tested first (see issue#15)
            mobileDetectRules.oss0 = {
                WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
                WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
            };
        })();
        /**
     * Test userAgent string against a set of rules and find the first matched key.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
     * @private
     */ impl.findMatch = function(rules, userAgent) {
            for(var key in rules)if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) return key;
            }
            return null;
        };
        /**
     * Test userAgent string against a set of rules and return an array of matched keys.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
     * @private
     */ impl.findMatches = function(rules, userAgent) {
            var result = [];
            for(var key in rules){
                if (hasOwnProp.call(rules, key)) {
                    if (rules[key].test(userAgent)) result.push(key);
                }
            }
            return result;
        };
        /**
     * Check the version of the given property in the User-Agent.
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {String} version or <tt>null</tt> if version not found
     * @private
     */ impl.getVersionStr = function(propertyName, userAgent) {
            var props = impl.mobileDetectRules.props, patterns, i, len, match;
            if (hasOwnProp.call(props, propertyName)) {
                patterns = props[propertyName];
                len = patterns.length;
                for(i = 0; i < len; ++i){
                    match = patterns[i].exec(userAgent);
                    if (match !== null) return match[1];
                }
            }
            return null;
        };
        /**
     * Check the version of the given property in the User-Agent.
     * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {Number} version or <tt>NaN</tt> if version not found
     * @private
     */ impl.getVersion = function(propertyName, userAgent) {
            var version = impl.getVersionStr(propertyName, userAgent);
            return version ? impl.prepareVersionNo(version) : NaN;
        };
        /**
     * Prepare the version number.
     *
     * @param {String} version
     * @return {Number} the version number as a floating number
     * @private
     */ impl.prepareVersionNo = function(version) {
            var numbers;
            numbers = version.split(/[a-z._ \/\-]/i);
            if (numbers.length === 1) version = numbers[0];
            if (numbers.length > 1) {
                version = numbers[0] + '.';
                numbers.shift();
                version += numbers.join('');
            }
            return Number(version);
        };
        impl.isMobileFallback = function(userAgent) {
            return impl.detectMobileBrowsers.fullPattern.test(userAgent) || impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0, 4));
        };
        impl.isTabletFallback = function(userAgent) {
            return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
        };
        impl.prepareDetectionCache = function(cache, userAgent, maxPhoneWidth) {
            if (cache.mobile !== undefined) return;
            var phone, tablet, phoneSized;
            // first check for stronger tablet rules, then phone (see issue#5)
            tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
            if (tablet) {
                cache.mobile = cache.tablet = tablet;
                cache.phone = null;
                return; // unambiguously identified as tablet
            }
            phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
            if (phone) {
                cache.mobile = cache.phone = phone;
                cache.tablet = null;
                return; // unambiguously identified as phone
            }
            // our rules haven't found a match -> try more general fallback rules
            if (impl.isMobileFallback(userAgent)) {
                phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
                if (phoneSized === undefined) {
                    cache.mobile = impl.FALLBACK_MOBILE;
                    cache.tablet = cache.phone = null;
                } else if (phoneSized) {
                    cache.mobile = cache.phone = impl.FALLBACK_PHONE;
                    cache.tablet = null;
                } else {
                    cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
                    cache.phone = null;
                }
            } else if (impl.isTabletFallback(userAgent)) {
                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
                cache.phone = null;
            } else // not mobile at all!
            cache.mobile = cache.tablet = cache.phone = null;
        };
        // t is a reference to a MobileDetect instance
        impl.mobileGrade = function(t) {
            // impl note:
            // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
            // When changes are made in Mobile_Detect.php, copy this method and replace:
            //     $this-> / t.
            //     self::MOBILE_GRADE_(.) / '$1'
            //     , self::VERSION_TYPE_FLOAT / (nothing)
            //     isIOS() / os('iOS')
            //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
            var $isMobile = t.mobile() !== null;
            if (// Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
            t.os('iOS') && t.version('iPad') >= 4.3 || t.os('iOS') && t.version('iPhone') >= 3.1 || t.os('iOS') && t.version('iPod') >= 3.1 || // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
            t.version('Android') > 2.1 && t.is('Webkit') || // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
            t.version('Windows Phone OS') >= 7.0 || // Blackberry 7 - Tested on BlackBerry Torch 9810
            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
            t.is('BlackBerry') && t.version('BlackBerry') >= 6.0 || // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
            t.match('Playbook.*Tablet') || // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
            t.version('webOS') >= 1.4 && t.match('Palm|Pre|Pixi') || // Palm WebOS 3.0  - Tested on HP TouchPad
            t.match('hp.*TouchPad') || // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
            t.is('Firefox') && t.version('Firefox') >= 12 || // Chrome for Android - Tested on Android 4.0, 4.1 device
            t.is('Chrome') && t.is('AndroidOS') && t.version('Android') >= 4.0 || // Skyfire 4.1 - Tested on Android 2.3 device
            t.is('Skyfire') && t.version('Skyfire') >= 4.1 && t.is('AndroidOS') && t.version('Android') >= 2.3 || // Opera Mobile 11.5-12: Tested on Android 2.3
            t.is('Opera') && t.version('Opera Mobi') > 11 && t.is('AndroidOS') || // Meego 1.2 - Tested on Nokia 950 and N9
            t.is('MeeGoOS') || // Tizen (pre-release) - Tested on early hardware
            t.is('Tizen') || // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
            // @todo: more tests here!
            t.is('Dolfin') && t.version('Bada') >= 2.0 || // UC Browser - Tested on Android 2.3 device
            (t.is('UC Browser') || t.is('Dolfin')) && t.version('Android') >= 2.3 || // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
            t.match('Kindle Fire') || t.is('Kindle') && t.version('Kindle') >= 3.0 || // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
            t.is('AndroidOS') && t.is('NookTablet') || // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
            t.version('Chrome') >= 11 && !$isMobile || // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
            t.version('Safari') >= 5.0 && !$isMobile || // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
            t.version('Firefox') >= 4.0 && !$isMobile || // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
            t.version('MSIE') >= 7.0 && !$isMobile || // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
            // @reference: http://my.opera.com/community/openweb/idopera/
            t.version('Opera') >= 10 && !$isMobile) return 'A';
            if (t.os('iOS') && t.version('iPad') < 4.3 || t.os('iOS') && t.version('iPhone') < 3.1 || t.os('iOS') && t.version('iPod') < 3.1 || // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
            t.is('Blackberry') && t.version('BlackBerry') >= 5 && t.version('BlackBerry') < 6 || //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
            t.version('Opera Mini') >= 5.0 && t.version('Opera Mini') <= 6.5 && (t.version('Android') >= 2.3 || t.is('iOS')) || // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
            t.match('NokiaN8|NokiaC7|N97.*Series60|Symbian/3') || // @todo: report this (tested on Nokia N71)
            t.version('Opera Mobi') >= 11 && t.is('SymbianOS')) return 'B';
            if (// Blackberry 4.x - Tested on the Curve 8330
            t.version('BlackBerry') < 5.0 || // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
            t.match('MSIEMobile|Windows CE.*Mobile') || t.version('Windows Mobile') <= 5.2) return 'C';
            //All older smartphone platforms and featurephones - Any device that doesn't support media queries
            //will receive the basic, C grade experience.
            return 'C';
        };
        impl.detectOS = function(ua) {
            return impl.findMatch(impl.mobileDetectRules.oss0, ua) || impl.findMatch(impl.mobileDetectRules.oss, ua);
        };
        impl.getDeviceSmallerSide = function() {
            return window.screen.width < window.screen.height ? window.screen.width : window.screen.height;
        };
        /**
     * Constructor for MobileDetect object.
     * <br>
     * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
     * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
     *     <strong>Find information how to download and install:</strong>
     *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
     * </div>
     *
     * @example <pre>
     *     var md = new MobileDetect(window.navigator.userAgent);
     *     if (md.mobile()) {
     *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
     *     }
     * </pre>
     *
     * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
     * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
     *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
     *        as phone.
     *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
     *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
     *        for Android</a>.<br>
     *        If you provide a value < 0, then this "fuzzy" check is disabled.
     * @constructor
     * @global
     */ function MobileDetect(userAgent, maxPhoneWidth) {
            this.ua = prepareUserAgent(userAgent);
            this._cache = {};
            //600dp is typical 7" tablet minimum width
            this.maxPhoneWidth = maxPhoneWidth || 600;
        }
        MobileDetect.prototype = {
            constructor: MobileDetect,
            /**
         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
         * <br>
         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
         * <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
         * @function MobileDetect#mobile
         */ mobile: function() {
                impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
                return this._cache.mobile;
            },
            /**
         * Returns the detected phone type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPhone, BlackBerry, Pixel, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
         * Xiaomi, NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile,
         * SimValley, Wolfgang, Alcatel, Nintendo, Amoi, INQ, OnePlus, GenericPhone</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
         * @function MobileDetect#phone
         */ phone: function() {
                impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
                return this._cache.phone;
            },
            /**
         * Returns the detected tablet type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPad, NexusTablet, GoogleTablet, SamsungTablet, Kindle, SurfaceTablet,
         * HPTablet, AsusTablet, BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet,
         * AcerTablet, ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet,
         * LenovoTablet, DellTablet, YarvikTablet, MedionTablet, ArnovaTablet,
         * IntensoTablet, IRUTablet, MegafonTablet, EbodaTablet, AllViewTablet,
         * ArchosTablet, AinolTablet, NokiaLumiaTablet, SonyTablet, PhilipsTablet,
         * CubeTablet, CobyTablet, MIDTablet, MSITablet, SMiTTablet, RockChipTablet,
         * FlyTablet, bqTablet, HuaweiTablet, NecTablet, PantechTablet, BronchoTablet,
         * VersusTablet, ZyncTablet, PositivoTablet, NabiTablet, KoboTablet, DanewTablet,
         * TexetTablet, PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
         * VerizonTablet, OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet,
         * OndaTablet, JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet,
         * LavaTablet, AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MediacomTablet,
         * MiTablet, NibiruTablet, NexoTablet, LeaderTablet, UbislateTablet,
         * PocketBookTablet, KocasoTablet, HisenseTablet, Hudl, TelstraTablet,
         * GenericTablet</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
         * @function MobileDetect#tablet
         */ tablet: function() {
                impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
                return this._cache.tablet;
            },
            /**
         * Returns the (first) detected user-agent string or <tt>null</tt>.
         * <br>
         * The returned user-agent is one of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {String} the key for the detected user-agent or <tt>null</tt>
         * @function MobileDetect#userAgent
         */ userAgent: function() {
                if (this._cache.userAgent === undefined) this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
                return this._cache.userAgent;
            },
            /**
         * Returns all detected user-agent strings.
         * <br>
         * The array is empty or contains one or more of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
         * @function MobileDetect#userAgents
         */ userAgents: function() {
                if (this._cache.userAgents === undefined) this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
                return this._cache.userAgents;
            },
            /**
         * Returns the detected operating system string or <tt>null</tt>.
         * <br>
         * The operating system is one of following keys:<br>
         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
         * iOS, iPadOS, SailfishOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
         *
         * @returns {String} the key for the detected operating system.
         * @function MobileDetect#os
         */ os: function() {
                if (this._cache.os === undefined) this._cache.os = impl.detectOS(this.ua);
                return this._cache.os;
            },
            /**
         * Get the version (as Number) of the given property in the User-Agent.
         * <br>
         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon,
         * SailfishBrowser, Gecko, Trident, Presto, Goanna, iOS, Android, Sailfish,
         * BlackBerry, BREW, Java, Windows Phone OS, Windows Phone, Windows CE, Windows
         * NT, Symbian, webOS</tt><br>
         *
         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
         *          Be careful when comparing this value with '==' operator!
         * @function MobileDetect#version
         */ version: function(key) {
                return impl.getVersion(key, this.ua);
            },
            /**
         * Get the version (as String) of the given property in the User-Agent.
         * <br>
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon,
         * SailfishBrowser, Gecko, Trident, Presto, Goanna, iOS, Android, Sailfish,
         * BlackBerry, BREW, Java, Windows Phone OS, Windows Phone, Windows CE, Windows
         * NT, Symbian, webOS</tt><br>
         *
         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
         *
         * @function MobileDetect#versionStr
         */ versionStr: function(key) {
                return impl.getVersionStr(key, this.ua);
            },
            /**
         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
         *
         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
         *        tablet family.<br>
         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
         *        Additionally you have following keys:<br>
         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
         *
         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
         * @function MobileDetect#is
         */ is: function(key) {
                return containsIC(this.userAgents(), key) || equalIC(key, this.os()) || equalIC(key, this.phone()) || equalIC(key, this.tablet()) || containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
            },
            /**
         * Do a quick test against navigator::userAgent.
         *
         * @param {String|RegExp} pattern the pattern, either as String or RegExp
         *                        (a string will be converted to a case-insensitive RegExp).
         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
         * @function MobileDetect#match
         */ match: function(pattern) {
                if (!(pattern instanceof RegExp)) pattern = new RegExp(pattern, 'i');
                return pattern.test(this.ua);
            },
            /**
         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
         * <br>
         * Obviously this method makes sense in browser environments only (not for Node.js)!
         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
         *          Will always return <code>undefined</code> server-side.
         */ isPhoneSized: function(maxPhoneWidth) {
                return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
            },
            /**
         * Returns the mobile grade ('A', 'B', 'C').
         *
         * @returns {String} one of the mobile grades ('A', 'B', 'C').
         * @function MobileDetect#mobileGrade
         */ mobileGrade: function() {
                if (this._cache.grade === undefined) this._cache.grade = impl.mobileGrade(this);
                return this._cache.grade;
            }
        };
        // environment-dependent
        if (typeof window !== 'undefined' && window.screen) MobileDetect.isPhoneSized = function(maxPhoneWidth) {
            return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
        };
        else MobileDetect.isPhoneSized = function() {};
        // should not be replaced by a completely new object - just overwrite existing methods
        MobileDetect._impl = impl;
        MobileDetect.version = '1.4.5 2021-03-13';
        return MobileDetect;
    }); // end of call of define()
})(function(undefined) {
    if ($6687f9591dc1a5f1$exports) return function(factory) {
        $6687f9591dc1a5f1$exports = factory();
    };
    else if (typeof define === 'function' && define.amd) return define;
    else if (typeof window !== 'undefined') return function(factory) {
        window.MobileDetect = factory();
    };
    else // please file a bug if you get this error!
    throw new Error('unknown environment');
}());






var $e61b2b9165ba5589$exports = {};
$e61b2b9165ba5589$exports = $parcel$resolve("kd7Cu");


var $35f75c214ecb4a3f$exports = {};
$35f75c214ecb4a3f$exports = $parcel$resolve("cDiAF");



var $01ysi = parcelRequire("01ysi");
parcelRequire("gRqVZ");
function $c7570fcc18b6cc50$var$AppleLogo() {
    return /*#__PURE__*/ (0, $01ysi.jsx)("svg", {
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 284.3 95",
        enableBackground: "new 0 0 284.3 95",
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0, $01ysi.jsxs)("g", {
            id: "XMLID_206_",
            children: [
                /*#__PURE__*/ (0, $01ysi.jsxs)("g", {
                    id: "XMLID_267_",
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_271_",
                            fill: "#030202",
                            d: "M284.3,20.1c0-0.7,0-1.5,0-2.2c-0.1-1.6-0.1-3.2-0.4-4.8c-0.3-1.6-0.7-3.1-1.5-4.5    c-0.7-1.4-1.7-2.7-2.8-3.9c-1.1-1.1-2.4-2.1-3.8-2.8c-1.5-0.7-2.9-1.2-4.5-1.5c-1.6-0.3-3.2-0.4-4.8-0.4c-0.7,0-1.5,0-2.2,0    c-0.9,0-1.7,0-2.6,0h-239c-0.9,0-1.7,0-2.6,0c-0.7,0-1.4,0-2.2,0c-1.6,0-3.2,0.1-4.8,0.4C11.5,0.7,10,1.2,8.6,1.9    C7.2,2.7,5.9,3.6,4.7,4.7C3.6,5.9,2.7,7.2,1.9,8.6c-0.7,1.4-1.2,2.9-1.5,4.5c-0.3,1.6-0.4,3.2-0.4,4.8c0,0.7,0,1.5,0,2.2    c0,0.9,0,1.7,0,2.6v49.7c0,0.9,0,1.7,0,2.6c0,0.7,0,1.5,0,2.2c0,1.6,0.1,3.2,0.4,4.8c0.3,1.6,0.7,3.1,1.5,4.5    c0.7,1.4,1.7,2.7,2.8,3.8c1.1,1.1,2.4,2.1,3.8,2.8c1.4,0.7,2.9,1.2,4.5,1.5c1.6,0.3,3.2,0.4,4.8,0.4c0.7,0,1.5,0,2.2,0    c0.9,0,1.7,0,2.6,0h239c0.9,0,1.7,0,2.6,0c0.7,0,1.5,0,2.2,0c1.6,0,3.2-0.1,4.8-0.4c1.6-0.3,3.1-0.8,4.5-1.5    c1.4-0.7,2.7-1.7,3.8-2.8c1.1-1.1,2.1-2.4,2.8-3.8c0.7-1.4,1.2-2.9,1.5-4.5c0.3-1.6,0.4-3.2,0.4-4.8c0-0.7,0-1.5,0-2.2    c0-0.9,0-1.7,0-2.6V22.7C284.3,21.8,284.3,20.9,284.3,20.1z"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_268_",
                            fill: "#909295",
                            d: "M261.6,2l2.6,0c0.6,0,1.2,0,1.8,0l0.4,0c1.2,0,2.9,0.1,4.5,0.4c1.4,0.3,2.7,0.7,4,1.3    c1.2,0.6,2.4,1.5,3.4,2.4c1,1,1.8,2.1,2.4,3.3c0.6,1.2,1,2.5,1.3,4c0.3,1.5,0.4,3,0.4,4.4c0,0.7,0,1.4,0,2.2c0,0.8,0,1.7,0,2.6    v49.7c0,0.9,0,1.7,0,2.6c0,0.7,0,1.4,0,2.1c-0.1,1.5-0.1,3-0.4,4.5c-0.2,1.4-0.7,2.7-1.3,4c-0.7,1.3-1.5,2.4-2.5,3.4    c-1,1-2.1,1.8-3.3,2.4c-1.2,0.6-2.5,1-4,1.3c-1.5,0.3-3.1,0.4-4.4,0.4c-0.7,0-1.4,0-2.2,0c-0.9,0-1.7,0-2.6,0h-239    c-0.9,0-1.7,0-2.6,0c-0.7,0-1.4,0-2.1,0c-1.3,0-2.9-0.1-4.5-0.4c-1.5-0.3-2.8-0.7-4-1.3c-1.2-0.6-2.4-1.4-3.4-2.5    c-1-1-1.8-2.1-2.4-3.3c-0.6-1.2-1-2.5-1.3-4C2.1,80,2,78.4,2,77.1c0-0.5,0-1,0-1.5L2,75v-2.6V22.7l0-2.6l0-0.7c0-0.5,0-1,0-1.5    c0-1.2,0.1-2.9,0.4-4.5c0.3-1.5,0.7-2.8,1.3-4c0.6-1.3,1.5-2.4,2.4-3.4c1-1,2.1-1.8,3.3-2.4c1.2-0.6,2.5-1.1,4-1.3    C15.1,2.1,16.7,2,17.9,2l0.5,0c0.6,0,1.1,0,1.7,0l2.6,0H261.6 M261.6,0h-239c-0.9,0-1.7,0-2.6,0c-0.7,0-1.4,0-2.2,0    c-1.6,0-3.2,0.1-4.8,0.4C11.5,0.7,10,1.2,8.6,1.9C7.2,2.7,5.9,3.6,4.7,4.7C3.6,5.9,2.7,7.2,1.9,8.6c-0.7,1.4-1.2,2.9-1.5,4.5    c-0.3,1.6-0.4,3.2-0.4,4.8c0,0.7,0,1.5,0,2.2c0,0.9,0,1.7,0,2.6v49.7c0,0.9,0,1.7,0,2.6c0,0.7,0,1.5,0,2.2c0,1.6,0.1,3.2,0.4,4.8    c0.3,1.6,0.7,3.1,1.5,4.5c0.7,1.4,1.7,2.7,2.8,3.8c1.1,1.1,2.4,2.1,3.8,2.8c1.4,0.7,2.9,1.2,4.5,1.5c1.6,0.3,3.2,0.4,4.8,0.4    c0.7,0,1.5,0,2.2,0c0.9,0,1.7,0,2.6,0h239c0.9,0,1.7,0,2.6,0c0.7,0,1.5,0,2.2,0c1.6,0,3.2-0.1,4.8-0.4c1.6-0.3,3.1-0.8,4.5-1.5    c1.4-0.7,2.7-1.7,3.8-2.8c1.1-1.1,2.1-2.4,2.8-3.8c0.7-1.4,1.2-2.9,1.5-4.5c0.3-1.6,0.4-3.2,0.4-4.8c0-0.7,0-1.5,0-2.2    c0-0.9,0-1.7,0-2.6V22.7c0-0.9,0-1.7,0-2.6c0-0.7,0-1.5,0-2.2c-0.1-1.6-0.1-3.2-0.4-4.8c-0.3-1.6-0.7-3.1-1.5-4.5    c-0.7-1.4-1.7-2.7-2.8-3.9c-1.1-1.1-2.4-2.1-3.8-2.8c-1.5-0.7-2.9-1.2-4.5-1.5c-1.6-0.3-3.2-0.4-4.8-0.4c-0.7,0-1.5,0-2.2,0    C263.4,0,262.5,0,261.6,0L261.6,0z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $01ysi.jsxs)("g", {
                    id: "XMLID_233_",
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_264_",
                            fill: "#FFFFFF",
                            d: "M89.9,20.7c4.2,0,6.7,2.6,6.7,7c0,4.5-2.4,7.1-6.7,7.1h-5.1V20.7H89.9z M86.9,32.9h2.7    c3,0,4.7-1.8,4.7-5.1c0-3.2-1.7-5.1-4.7-5.1h-2.7V32.9z"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_261_",
                            fill: "#FFFFFF",
                            d: "M99,29.6c0-3.4,1.9-5.6,5-5.6c3.1,0,5,2.1,5,5.6c0,3.5-1.9,5.6-5,5.6    C100.9,35.1,99,33,99,29.6z M106.9,29.6c0-2.3-1-3.7-2.9-3.7c-1.8,0-2.9,1.4-2.9,3.7c0,2.3,1,3.7,2.9,3.7    C105.9,33.2,106.9,31.9,106.9,29.6z"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_259_",
                            fill: "#FFFFFF",
                            d: "M122.5,34.9h-2.2l-2.2-7.9H118l-2.2,7.9h-2.2l-3-10.7h2.1l1.9,8.2h0.2l2.2-8.2h2l2.2,8.2    h0.2l1.9-8.2h2.1L122.5,34.9z"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_257_",
                            fill: "#FFFFFF",
                            d: "M127.9,24.2h2v1.7h0.2c0.5-1.2,1.6-1.9,3.2-1.9c2.4,0,3.7,1.4,3.7,4v6.9h-2.1v-6.4    c0-1.7-0.7-2.6-2.3-2.6c-1.6,0-2.6,1-2.6,2.7v6.3h-2.1V24.2z"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_255_",
                            fill: "#FFFFFF",
                            d: "M140.4,20h2.1v14.9h-2.1V20z"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_252_",
                            fill: "#FFFFFF",
                            d: "M145.4,29.6c0-3.4,1.9-5.6,5-5.6c3.1,0,5,2.1,5,5.6c0,3.5-1.9,5.6-5,5.6    C147.3,35.1,145.4,33,145.4,29.6z M153.4,29.6c0-2.3-1-3.7-2.9-3.7c-1.8,0-2.9,1.4-2.9,3.7c0,2.3,1,3.7,2.9,3.7    C152.3,33.2,153.4,31.9,153.4,29.6z"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_249_",
                            fill: "#FFFFFF",
                            d: "M157.7,31.9c0-1.9,1.4-3,4-3.2l2.9-0.2v-0.9c0-1.1-0.7-1.8-2.2-1.8c-1.2,0-2,0.4-2.2,1.2    h-2c0.2-1.8,1.9-3,4.4-3c2.7,0,4.2,1.3,4.2,3.6v7.3h-2v-1.5h-0.2c-0.6,1.1-1.8,1.7-3.2,1.7C159.2,35.1,157.7,33.8,157.7,31.9z    M164.6,31v-0.9l-2.6,0.2c-1.5,0.1-2.1,0.6-2.1,1.5c0,1,0.8,1.5,2,1.5C163.4,33.3,164.6,32.3,164.6,31z"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_246_",
                            fill: "#FFFFFF",
                            d: "M169.5,29.6c0-3.4,1.7-5.5,4.4-5.5c1.5,0,2.7,0.7,3.3,1.9h0.2V20h2.1v14.9h-2v-1.7h-0.2    c-0.6,1.2-1.9,1.9-3.4,1.9C171.2,35.1,169.5,33,169.5,29.6z M171.7,29.6c0,2.3,1.1,3.6,2.9,3.6c1.8,0,2.9-1.4,2.9-3.6    c0-2.2-1.1-3.6-2.9-3.6C172.8,25.9,171.7,27.3,171.7,29.6z"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_243_",
                            fill: "#FFFFFF",
                            d: "M188.2,29.6c0-3.4,1.9-5.6,5-5.6c3.1,0,5,2.1,5,5.6c0,3.5-1.9,5.6-5,5.6    C190.1,35.1,188.2,33,188.2,29.6z M196.1,29.6c0-2.3-1-3.7-2.9-3.7c-1.8,0-2.9,1.4-2.9,3.7c0,2.3,1,3.7,2.9,3.7    C195.1,33.2,196.1,31.9,196.1,29.6z"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_241_",
                            fill: "#FFFFFF",
                            d: "M201.1,24.2h2v1.7h0.2c0.5-1.2,1.6-1.9,3.2-1.9c2.4,0,3.7,1.4,3.7,4v6.9h-2.1v-6.4    c0-1.7-0.7-2.6-2.3-2.6c-1.6,0-2.6,1-2.6,2.7v6.3h-2.1V24.2z"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_239_",
                            fill: "#FFFFFF",
                            d: "M222.2,21.6v2.7h2.3V26h-2.3v5.5c0,1.1,0.5,1.6,1.5,1.6c0.3,0,0.5,0,0.8,0v1.8    c-0.3,0.1-0.7,0.1-1.2,0.1c-2.3,0-3.3-0.8-3.3-2.9v-6h-1.7v-1.8h1.7v-2.7H222.2z"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_237_",
                            fill: "#FFFFFF",
                            d: "M227.4,20h2.1v5.9h0.2c0.5-1.2,1.7-1.9,3.3-1.9c2.3,0,3.7,1.4,3.7,4v6.9h-2.1v-6.4    c0-1.7-0.8-2.6-2.3-2.6c-1.7,0-2.7,1.1-2.7,2.7v6.2h-2.1V20z"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_234_",
                            fill: "#FFFFFF",
                            d: "M248.9,32c-0.5,1.9-2.2,3.1-4.6,3.1c-3.1,0-4.9-2.1-4.9-5.5c0-3.4,1.9-5.6,4.9-5.6    c3,0,4.8,2,4.8,5.4v0.7h-7.6v0.1c0.1,1.9,1.2,3.1,2.8,3.1c1.3,0,2.2-0.5,2.5-1.3H248.9z M241.5,28.6h5.4c0-1.7-1.1-2.8-2.6-2.8    S241.6,26.9,241.5,28.6z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $01ysi.jsx)("g", {
                    id: "XMLID_229_",
                    children: /*#__PURE__*/ (0, $01ysi.jsxs)("g", {
                        id: "XMLID_230_",
                        children: [
                            /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                                id: "XMLID_232_",
                                fill: "#FFFFFF",
                                d: "M58.8,48.2c-0.1-6.5,5.4-9.7,5.6-9.9c-3.1-4.5-7.8-5.1-9.5-5.1c-4-0.4-7.9,2.4-9.9,2.4     c-2.1,0-5.2-2.3-8.6-2.3c-4.3,0.1-8.4,2.6-10.6,6.5c-4.6,8-1.2,19.6,3.2,26.1c2.2,3.1,4.8,6.7,8.1,6.5c3.3-0.1,4.5-2.1,8.5-2.1     c3.9,0,5.1,2.1,8.5,2c3.5-0.1,5.8-3.2,7.9-6.3c2.5-3.6,3.6-7.2,3.6-7.3C65.7,58.7,58.9,56.1,58.8,48.2z"
                            }),
                            /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                                id: "XMLID_231_",
                                fill: "#FFFFFF",
                                d: "M52.4,29c1.8-2.2,3-5.2,2.6-8.3c-2.6,0.1-5.8,1.8-7.6,3.9c-1.6,1.9-3.1,5-2.7,8     C47.5,32.9,50.5,31.2,52.4,29z"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $01ysi.jsxs)("g", {
                    id: "XMLID_207_",
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_226_",
                            fill: "#FFFFFF",
                            d: "M100.5,64.5H89.2l-2.7,8h-4.8l10.7-29.5h4.9L108,72.4h-4.8L100.5,64.5z M90.4,60.8h8.9    l-4.4-12.9h-0.1L90.4,60.8z"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_223_",
                            fill: "#FFFFFF",
                            d: "M131,61.7c0,6.7-3.6,11-9,11c-3.1,0-5.5-1.4-6.8-3.8h-0.1v10.7h-4.4V50.9h4.3v3.6h0.1    c1.2-2.3,3.8-3.8,6.8-3.8C127.4,50.7,131,55,131,61.7z M126.5,61.7c0-4.4-2.3-7.2-5.7-7.2c-3.4,0-5.6,2.9-5.6,7.2    c0,4.3,2.3,7.2,5.6,7.2C124.3,68.9,126.5,66.1,126.5,61.7z"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_220_",
                            fill: "#FFFFFF",
                            d: "M154.7,61.7c0,6.7-3.6,11-9,11c-3.1,0-5.5-1.4-6.8-3.8h-0.1v10.7h-4.4V50.9h4.3v3.6h0.1    c1.2-2.3,3.8-3.8,6.8-3.8C151.1,50.7,154.7,55,154.7,61.7z M150.2,61.7c0-4.4-2.3-7.2-5.7-7.2c-3.4,0-5.6,2.9-5.6,7.2    c0,4.3,2.3,7.2,5.6,7.2C147.9,68.9,150.2,66.1,150.2,61.7z"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_218_",
                            fill: "#FFFFFF",
                            d: "M170.4,64.2c0.3,2.9,3.2,4.8,7.1,4.8c3.7,0,6.4-1.9,6.4-4.6c0-2.3-1.6-3.7-5.4-4.6    l-3.8-0.9c-5.4-1.3-7.9-3.8-7.9-8c0-5.1,4.4-8.6,10.7-8.6c6.2,0,10.5,3.5,10.7,8.6h-4.5c-0.3-2.9-2.7-4.7-6.3-4.7s-6,1.8-6,4.4    c0,2.1,1.6,3.3,5.4,4.3l3.3,0.8c6.1,1.4,8.6,3.9,8.6,8.2c0,5.5-4.4,9-11.4,9c-6.5,0-11-3.4-11.2-8.7H170.4z"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_216_",
                            fill: "#FFFFFF",
                            d: "M198,45.8v5.1h4.1v3.5H198v11.9c0,1.8,0.8,2.7,2.6,2.7c0.5,0,1.2-0.1,1.5-0.1v3.5    c-0.5,0.1-1.5,0.2-2.5,0.2c-4.4,0-6.1-1.6-6.1-5.8V54.4h-3.1v-3.5h3.1v-5.1H198z"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_213_",
                            fill: "#FFFFFF",
                            d: "M204.5,61.7c0-6.8,4-11,10.2-11c6.2,0,10.2,4.3,10.2,11c0,6.8-3.9,11-10.2,11    C208.4,72.7,204.5,68.5,204.5,61.7z M220.4,61.7c0-4.6-2.1-7.4-5.7-7.4c-3.6,0-5.7,2.8-5.7,7.4c0,4.7,2.1,7.4,5.7,7.4    C218.2,69.1,220.4,66.4,220.4,61.7z"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_211_",
                            fill: "#FFFFFF",
                            d: "M228.5,50.9h4.2v3.7h0.1c0.7-2.4,2.6-3.9,5.2-3.9c0.6,0,1.2,0.1,1.5,0.2V55    c-0.3-0.1-1.1-0.3-2-0.3c-2.8,0-4.6,1.9-4.6,4.9v12.8h-4.4V50.9z"
                        }),
                        /*#__PURE__*/ (0, $01ysi.jsx)("path", {
                            id: "XMLID_208_",
                            fill: "#FFFFFF",
                            d: "M259.9,66.1c-0.6,3.9-4.4,6.6-9.3,6.6c-6.3,0-10.1-4.2-10.1-10.9c0-6.7,3.9-11.1,10-11.1    c6,0,9.7,4.1,9.7,10.6v1.5h-15.2v0.3c0,3.7,2.3,6.1,5.8,6.1c2.5,0,4.4-1.2,5-3H259.9z M244.9,59.7h10.8c-0.1-3.3-2.2-5.5-5.3-5.5    C247.4,54.3,245.2,56.5,244.9,59.7z"
                        })
                    ]
                })
            ]
        })
    });
}
var $c7570fcc18b6cc50$export$2e2bcd8739ae039 = $c7570fcc18b6cc50$var$AppleLogo;




const $31258bcb9a3d514c$export$668799e4797757a8 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	background-size: cover;
	background-position: center;
	height: 100vh;
`;
const $31258bcb9a3d514c$export$bcb16ee9b04073d6 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	background: white;
	max-width: 375px;
	margin: 0 auto;
	padding: 30px;
	box-shadow: 0px 5px 5px rgb(0 0 0 / 10%);
	border-radius: 3px;
`;
const $31258bcb9a3d514c$export$fa419c1301da19e7 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	width: 50%;
	height: 50%;
	overflow: auto;
	margin: auto;
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
`;
const $31258bcb9a3d514c$export$a4654c742baf9825 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	width: 90%;
	padding-top: 20px;
	&:last-of-type {
		padding-bottom: 30px;
	}
`;
const $31258bcb9a3d514c$export$441f75c3d478b44b = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).img`
	display: block;
	margin: 0 auto;
	padding-top: 15px;
	padding-bottom: 25px;
`;
const $31258bcb9a3d514c$export$d0e9074fe417a1a0 = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039)((0, $32c3454e141c39d9$export$2e2bcd8739ae039))`
	width: 100%;
`;
const $31258bcb9a3d514c$export$b8e9cd941e8016ac = (0, $8999e1d77b7e12d9$export$2e2bcd8739ae039).div`
	color: ${(props)=>props.theme.colors.red};
`;


function $644c113d176115bd$var$SignInRoute() {
    const client = (0, $b86ffbc6c4f7be29$export$eb9a56e7a29e494)();
    const [idToken, setIdToken] = (0, $gRqVZ.useState)(window.__ID_TOKEN);
    const [promptNextLogin] = (0, $gRqVZ.useState)(localStorage.__promptNextLogin);
    const [authenticateUser] = (0, $93486c083cb38a29$export$b6f0d9793b6d1b9f)({
        onCompleted () {
            client.clearStore();
        }
    });
    if (localStorage.__promptNextLogin) delete localStorage.__promptNextLogin;
    const [getIosRedemptionCode, { data: iosRedemptionCodeData, loading: iosRedemptionCodeLoading }] = (0, $93486c083cb38a29$export$5aa87c875db9fb46)();
    const { setAccessToken: setAccessToken } = (0, $f8298f6bd5fca48e$export$a609e16b0cfae3f1)();
    const navigate = (0, $372fcccf2bee01ac$export$9770f232ac06a008)();
    const { data: mastheadData } = (0, $93486c083cb38a29$export$27db48495116d434)();
    (0, $gRqVZ.useEffect)(()=>{
        if (!idToken) return;
        delete window.__ID_TOKEN;
        setIdToken(null);
        authenticateUser({
            variables: {
                username: '_MS_TOKEN',
                password: idToken
            }
        }).then(({ data: data })=>{
            if (data.authenticateUser.accessToken) {
                setAccessToken(data.authenticateUser.accessToken);
                navigate('/home');
            }
        });
    }, []);
    const md = new (0, (/*@__PURE__*/$parcel$interopDefault($6687f9591dc1a5f1$exports)))(window.navigator.userAgent);
    const isiOS = md.os() === 'iOS';
    const isAndroid = md.os() === 'AndroidOS';
    if (iosRedemptionCodeData?.iosRedemptionCode?.url) window.location.href = iosRedemptionCodeData.iosRedemptionCode.url;
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $31258bcb9a3d514c$export$668799e4797757a8), {
        style: {
            backgroundImage: `url(${mastheadData?.signinPage.masthead.publicUrl})`
        },
        children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $31258bcb9a3d514c$export$fa419c1301da19e7), {
            children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $31258bcb9a3d514c$export$bcb16ee9b04073d6), {
                children: [
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $31258bcb9a3d514c$export$441f75c3d478b44b), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e61b2b9165ba5589$exports)))
                    }),
                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Formik), {
                        children: ()=>{
                            if (isiOS) return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                                style: {
                                    padding: '3rem',
                                    cursor: 'pointer',
                                    fontSize: '200%'
                                },
                                onClick: async ()=>{
                                    if (iosRedemptionCodeLoading) return;
                                    getIosRedemptionCode();
                                },
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)("p", {
                                        children: "Tap here to download the app:"
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $c7570fcc18b6cc50$export$2e2bcd8739ae039), {})
                                ]
                            });
                            if (isAndroid) return /*#__PURE__*/ (0, $01ysi.jsxs)("div", {
                                style: {
                                    padding: '3rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)("p", {
                                        children: "Tap here to download the app:"
                                    }),
                                    /*#__PURE__*/ (0, $01ysi.jsx)("a", {
                                        href: "https://play.google.com/store/apps/details?id=com.onenibbi.app",
                                        children: /*#__PURE__*/ (0, $01ysi.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($35f75c214ecb4a3f$exports)))
                                        })
                                    })
                                ]
                            });
                            return /*#__PURE__*/ (0, $01ysi.jsx)((0, $489wz.Form), {
                                children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $31258bcb9a3d514c$export$d0e9074fe417a1a0), {
                                    type: "button",
                                    onClick: ()=>{
                                        const nonce = (Math.random() + 1).toString(36).substring(2) + (Math.random() + 1).toString(36).substring(2);
                                        location.href = "https://login.microsoftonline.com/5c99c30a-e366-4543-b7b8-5c75fee2faae/oauth2/v2.0/authorize?client_id=5595bc06-d9d2-40b5-9bcf-88143a0fd55d&response_type=id_token&redirect_uri=" + window.location.origin + '&response_mode=fragment' + '&scope=openid%20email' + `&nonce=${nonce}` + (promptNextLogin ? '&prompt=select_account' : '');
                                    },
                                    style: {
                                        marginTop: '2rem'
                                    },
                                    loading: idToken,
                                    disabled: idToken,
                                    children: "Login"
                                })
                            });
                        }
                    })
                ]
            })
        })
    });
}
var $644c113d176115bd$export$2e2bcd8739ae039 = $644c113d176115bd$var$SignInRoute;


try {
    if (location.hash) {
        const hash = new URLSearchParams(location.hash.slice(1));
        const idToken = hash.get('id_token');
        if (idToken.length > 0) window.__ID_TOKEN = idToken;
    }
} catch (err) {}
const $9ecef34159e8ff4c$var$breakpoints = {
    small: 'screen and (max-width: 767px)',
    medium: 'screen and (min-width: 768px) and (max-width: 959px)',
    large: 'screen and (min-width: 960px)'
};
const $9ecef34159e8ff4c$var$App = ()=>{
    const tagManagerArgs = {
        gtmId: 'GTM-W4B8NSHJ'
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($947452b0032889fc$exports))).initialize(tagManagerArgs);
    return /*#__PURE__*/ (0, $01ysi.jsx)((0, $9c0ab08af26ed2fe$export$c16b04c8a9956446), {
        client: (0, $ca4d76c580089ed3$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $b7f2bb4232df9024$export$af5f2e06b272a59f), {
            children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $8c17cac81986aadf$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $8999e1d77b7e12d9$export$d8964aec282183a3), {
                    theme: (0, $fcf5b0132d6341e1$export$2e2bcd8739ae039),
                    children: [
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $0b5632181df8e81c$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $01ysi.jsx)((0, $152b72f1e80df695$export$2e2bcd8739ae039).Provider, {
                            config: $9ecef34159e8ff4c$var$breakpoints,
                            children: /*#__PURE__*/ (0, $01ysi.jsxs)((0, $e3f57e4b1ea630bd$export$9ba4e89fdfa1fc54), {
                                children: [
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $d62a924bbfb54cc0$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $aed2108b74da4cc9$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $f8298f6bd5fca48e$export$2e2bcd8739ae039), {
                                        children: ({ isLoading: isLoading, user: user })=>{
                                            if (isLoading) return /*#__PURE__*/ (0, $01ysi.jsx)((0, $8d13d13871606beb$export$2e2bcd8739ae039), {});
                                            return user ? /*#__PURE__*/ (0, $01ysi.jsx)((0, $2693f7ea46500e8f$export$a14e94a710e3b3ab), {
                                                children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $83c95e5072a5afa6$export$2ed61928bd1aa480), {
                                                    children: /*#__PURE__*/ (0, $01ysi.jsx)((0, $6f7f49c0f054a62d$export$2e2bcd8739ae039), {})
                                                })
                                            }) : /*#__PURE__*/ (0, $01ysi.jsxs)((0, $372fcccf2bee01ac$export$3565eb3d00ca5a74), {
                                                children: [
                                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                                        path: "*",
                                                        element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$444b3ab0cb9aec40), {
                                                            to: "/sign-in"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                                        path: "/sign-in",
                                                        element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $644c113d176115bd$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $01ysi.jsx)((0, $372fcccf2bee01ac$export$e7b0ac011bb776c6), {
                                                        path: "/sandbox",
                                                        element: /*#__PURE__*/ (0, $01ysi.jsx)((0, $558b1157e7a30192$export$2e2bcd8739ae039), {})
                                                    })
                                                ]
                                            });
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
(0, $66e8bd72b116f830$exports.createRoot)(document.getElementById('root')).render(/*#__PURE__*/ (0, $01ysi.jsx)($9ecef34159e8ff4c$var$App, {}));


//# sourceMappingURL=web.228ceb34.js.map
